import {
  __commonJS,
  __export,
  __toESM
} from "./chunk-U67V476Y.js";

// ../node_modules/@frogcat/ttl2jsonld/ttl2jsonld.js
var require_ttl2jsonld = __commonJS({
  "../node_modules/@frogcat/ttl2jsonld/ttl2jsonld.js"(exports, module3) {
    (function(root, factory) {
      if (typeof define === "function" && define.amd) {
        define([], factory);
      } else if (typeof module3 === "object" && module3.exports) {
        module3.exports = factory();
      } else {
        root.ttl2jsonld = factory();
      }
    })(exports, function() {
      "use strict";
      function peg$subclass(child2, parent4) {
        function ctor() {
          this.constructor = child2;
        }
        ctor.prototype = parent4.prototype;
        child2.prototype = new ctor();
      }
      function peg$SyntaxError(message4, expected, found, location7) {
        this.message = message4;
        this.expected = expected;
        this.found = found;
        this.location = location7;
        this.name = "SyntaxError";
        if (typeof Error.captureStackTrace === "function") {
          Error.captureStackTrace(this, peg$SyntaxError);
        }
      }
      peg$subclass(peg$SyntaxError, Error);
      peg$SyntaxError.buildMessage = function(expected, found) {
        var DESCRIBE_EXPECTATION_FNS = {
          literal: function(expectation) {
            return '"' + literalEscape(expectation.text) + '"';
          },
          "class": function(expectation) {
            var escapedParts = "", i;
            for (i = 0; i < expectation.parts.length; i++) {
              escapedParts += expectation.parts[i] instanceof Array ? classEscape(expectation.parts[i][0]) + "-" + classEscape(expectation.parts[i][1]) : classEscape(expectation.parts[i]);
            }
            return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
          },
          any: function(expectation) {
            return "any character";
          },
          end: function(expectation) {
            return "end of input";
          },
          other: function(expectation) {
            return expectation.description;
          }
        };
        function hex(ch) {
          return ch.charCodeAt(0).toString(16).toUpperCase();
        }
        function literalEscape(s) {
          return s.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
            return "\\x0" + hex(ch);
          }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
            return "\\x" + hex(ch);
          });
        }
        function classEscape(s) {
          return s.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
            return "\\x0" + hex(ch);
          }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
            return "\\x" + hex(ch);
          });
        }
        function describeExpectation(expectation) {
          return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
        }
        function describeExpected(expected2) {
          var descriptions = new Array(expected2.length), i, j;
          for (i = 0; i < expected2.length; i++) {
            descriptions[i] = describeExpectation(expected2[i]);
          }
          descriptions.sort();
          if (descriptions.length > 0) {
            for (i = 1, j = 1; i < descriptions.length; i++) {
              if (descriptions[i - 1] !== descriptions[i]) {
                descriptions[j] = descriptions[i];
                j++;
              }
            }
            descriptions.length = j;
          }
          switch (descriptions.length) {
            case 1:
              return descriptions[0];
            case 2:
              return descriptions[0] + " or " + descriptions[1];
            default:
              return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
          }
        }
        function describeFound(found2) {
          return found2 ? '"' + literalEscape(found2) + '"' : "end of input";
        }
        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
      };
      function peg$parse(input2, options) {
        options = options !== void 0 ? options : {};
        var peg$FAILED = {}, peg$startRuleFunctions = { turtleDoc: peg$parseturtleDoc }, peg$startRuleFunction = peg$parseturtleDoc, peg$c0 = function(statements) {
          var jsonld = context4.toJSON();
          jsonld["@graph"] = [];
          statements.filter((a) => Array.isArray(a)).forEach((a) => {
            a.forEach((b) => {
              jsonld["@graph"].push(b);
            });
          });
          if (jsonld["@graph"].length === 1) {
            Object.assign(jsonld, jsonld["@graph"][0]);
            delete jsonld["@graph"];
          }
          return jsonld;
        }, peg$c1 = "\uFEFF", peg$c2 = peg$literalExpectation("\uFEFF", false), peg$c3 = ".", peg$c4 = peg$literalExpectation(".", false), peg$c5 = function(a) {
          return a;
        }, peg$c6 = "#", peg$c7 = peg$literalExpectation("#", false), peg$c8 = /^[^\n]/, peg$c9 = peg$classExpectation(["\n"], true, false), peg$c10 = "\n", peg$c11 = peg$literalExpectation("\n", false), peg$c12 = function(a) {
          return a.join("");
        }, peg$c13 = "@prefix", peg$c14 = peg$literalExpectation("@prefix", false), peg$c15 = function(a, b) {
          context4.addPrefix(a === "" ? "0" : a, b);
          return {};
        }, peg$c16 = "@base", peg$c17 = peg$literalExpectation("@base", false), peg$c18 = function(a) {
          context4.addBase(a);
          return {};
        }, peg$c19 = /^[Bb]/, peg$c20 = peg$classExpectation(["B", "b"], false, false), peg$c21 = /^[Aa]/, peg$c22 = peg$classExpectation(["A", "a"], false, false), peg$c23 = /^[Ss]/, peg$c24 = peg$classExpectation(["S", "s"], false, false), peg$c25 = /^[Ee]/, peg$c26 = peg$classExpectation(["E", "e"], false, false), peg$c27 = /^[Pp]/, peg$c28 = peg$classExpectation(["P", "p"], false, false), peg$c29 = /^[Rr]/, peg$c30 = peg$classExpectation(["R", "r"], false, false), peg$c31 = /^[Ff]/, peg$c32 = peg$classExpectation(["F", "f"], false, false), peg$c33 = /^[Ii]/, peg$c34 = peg$classExpectation(["I", "i"], false, false), peg$c35 = /^[Xx]/, peg$c36 = peg$classExpectation(["X", "x"], false, false), peg$c37 = function(s, p) {
          var x = {};
          if (typeof s === "string" && s !== "[]") x["@id"] = s;
          else if (typeof s === "object") Object.assign(x, s);
          if (p) Object.assign(x, p);
          return [x];
        }, peg$c38 = function(s, p) {
          var x = {};
          if (s) Object.assign(x, s);
          if (p) Object.assign(x, p);
          return [x];
        }, peg$c39 = ";", peg$c40 = peg$literalExpectation(";", false), peg$c41 = function(a, b, e, f) {
          var x = {};
          x[e] = f;
          return x;
        }, peg$c42 = function(a, b, d) {
          return d;
        }, peg$c43 = function(a, b, c) {
          var x = {};
          c.unshift(createObject(a, b));
          c.forEach((t) => {
            if (!t) return;
            Object.keys(t).forEach((key3) => {
              t[key3].forEach((val) => {
                if (key3 === "@type" && val["@id"] !== void 0) val = val["@id"];
                if (x[key3] === void 0) x[key3] = val;
                else if (Array.isArray(x[key3])) x[key3].push(val);
                else x[key3] = [x[key3], val];
              });
            });
          });
          return x;
        }, peg$c44 = ",", peg$c45 = peg$literalExpectation(",", false), peg$c46 = function(a, c) {
          return c;
        }, peg$c47 = function(a, b) {
          b.unshift(a);
          return b;
        }, peg$c48 = "a", peg$c49 = peg$literalExpectation("a", false), peg$c50 = function() {
          return "@type";
        }, peg$c51 = function(a) {
          return expandList(a, true);
        }, peg$c52 = function(a) {
          return expandList(a, false);
        }, peg$c53 = function(a) {
          return a === "[]" ? {} : { "@id": a };
        }, peg$c54 = function(a) {
          return { "@id": a };
        }, peg$c55 = "[", peg$c56 = peg$literalExpectation("[", false), peg$c57 = "]", peg$c58 = peg$literalExpectation("]", false), peg$c59 = "(", peg$c60 = peg$literalExpectation("(", false), peg$c61 = ")", peg$c62 = peg$literalExpectation(")", false), peg$c63 = function(a) {
          return { "@list": a };
        }, peg$c64 = function(a, b) {
          return { "@value": a, "@language": b };
        }, peg$c65 = "^^", peg$c66 = peg$literalExpectation("^^", false), peg$c67 = function(a, b) {
          if (b === "http://www.w3.org/2001/XMLSchema#boolean" && a === "true") return true;
          if (b === "http://www.w3.org/2001/XMLSchema#boolean" && a === "false") return false;
          if (b === "http://www.w3.org/2001/XMLSchema#integer") return parseInt(a);
          if (b === "http://www.w3.org/2001/XMLSchema#double") return parseFloat(a);
          const uri6 = context4.resolve(b, true);
          if (uri6) {
            const prefix3 = b.split(":")[0];
            if (uri6 === "http://www.w3.org/2001/XMLSchema#boolean" && a === "true") {
              context4.decrement(prefix3);
              return true;
            }
            if (uri6 === "http://www.w3.org/2001/XMLSchema#boolean" && a === "false") {
              context4.decrement(prefix3);
              return false;
            }
            if (uri6 === "http://www.w3.org/2001/XMLSchema#integer") {
              context4.decrement(prefix3);
              return parseInt(a);
            }
            if (uri6 === "http://www.w3.org/2001/XMLSchema#double") {
              context4.decrement(prefix3);
              return parseFloat(a);
            }
          }
          return { "@value": a, "@type": b };
        }, peg$c68 = "true", peg$c69 = peg$literalExpectation("true", false), peg$c70 = function() {
          return true;
        }, peg$c71 = "false", peg$c72 = peg$literalExpectation("false", false), peg$c73 = function() {
          return false;
        }, peg$c74 = function(a) {
          return a + ":";
        }, peg$c75 = "<", peg$c76 = peg$literalExpectation("<", false), peg$c77 = /^[^\0- <>"{}|\^`\\]/, peg$c78 = peg$classExpectation([["\0", " "], "<", ">", '"', "{", "}", "|", "^", "`", "\\"], true, false), peg$c79 = ">", peg$c80 = peg$literalExpectation(">", false), peg$c81 = function(a) {
          const decoded = a.map((s) => {
            if (65536 <= s.codePointAt(0) && s.codePointAt(0) <= 983039) return "a";
            if (s.length === 1) return s;
            if (s.length === 6) return String.fromCharCode("0x" + s.substring(2));
            if (s.length === 10) return String.fromCodePoint("0x" + s.substring(2));
            return s;
          }).join("");
          if (decoded.match(/^[^\u0000-\u0020<>"{}|^`\\]*$/)) {
            var join2 = a.join("");
            try {
              return context4.resolve(join2);
            } catch (e) {
              error4("Invalid IRIREF " + join2);
            }
          } else error4("Invalid IRIREF " + a.join("") + " / " + decoded);
        }, peg$c82 = ":", peg$c83 = peg$literalExpectation(":", false), peg$c84 = function(a) {
          a = a || "0";
          if (context4.hasPrefix(a) === false)
            error4("undefined prefix " + a);
          return a;
        }, peg$c85 = function(a) {
          return a || "";
        }, peg$c86 = function(a, b) {
          context4.increment(a);
          return context4.resolve(a + ":" + b);
        }, peg$c87 = "_:", peg$c88 = peg$literalExpectation("_:", false), peg$c89 = /^[0-9]/, peg$c90 = peg$classExpectation([["0", "9"]], false, false), peg$c91 = "@", peg$c92 = peg$literalExpectation("@", false), peg$c93 = /^[a-zA-Z]/, peg$c94 = peg$classExpectation([["a", "z"], ["A", "Z"]], false, false), peg$c95 = "-", peg$c96 = peg$literalExpectation("-", false), peg$c97 = /^[a-zA-Z0-9]/, peg$c98 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"]], false, false), peg$c99 = function(a, s) {
          return "-" + s.join("");
        }, peg$c100 = function(a, b) {
          return a.join("") + b.join("");
        }, peg$c101 = /^[+\-]/, peg$c102 = peg$classExpectation(["+", "-"], false, false), peg$c103 = function(a) {
          if (a.match(/^[0+][0-9]+$/))
            return {
              "@value": a,
              "@type": "http://www.w3.org/2001/XMLSchema#integer"
            };
          return parseInt(a);
        }, peg$c104 = function(a) {
          return {
            "@value": a,
            "@type": "http://www.w3.org/2001/XMLSchema#decimal"
          };
        }, peg$c105 = function(a) {
          return {
            "@value": a,
            "@type": "http://www.w3.org/2001/XMLSchema#double"
          };
        }, peg$c106 = /^[eE]/, peg$c107 = peg$classExpectation(["e", "E"], false, false), peg$c108 = '"', peg$c109 = peg$literalExpectation('"', false), peg$c110 = /^[^"\\\n\r]/, peg$c111 = peg$classExpectation(['"', "\\", "\n", "\r"], true, false), peg$c112 = "'", peg$c113 = peg$literalExpectation("'", false), peg$c114 = /^[^'\\\n\r]/, peg$c115 = peg$classExpectation(["'", "\\", "\n", "\r"], true, false), peg$c116 = "'''", peg$c117 = peg$literalExpectation("'''", false), peg$c118 = /^[^'\\]/, peg$c119 = peg$classExpectation(["'", "\\"], true, false), peg$c120 = "''", peg$c121 = peg$literalExpectation("''", false), peg$c122 = function(head, a) {
          return "''" + a.join("");
        }, peg$c123 = function(head, a) {
          return "'" + a.join("");
        }, peg$c124 = function(head, body) {
          return head.join("") + body.join("");
        }, peg$c125 = '"""', peg$c126 = peg$literalExpectation('"""', false), peg$c127 = /^[^"\\]/, peg$c128 = peg$classExpectation(['"', "\\"], true, false), peg$c129 = '""', peg$c130 = peg$literalExpectation('""', false), peg$c131 = function(head, a) {
          return '""' + a.join("");
        }, peg$c132 = function(head, a) {
          return '"' + a.join("");
        }, peg$c133 = "\\U", peg$c134 = peg$literalExpectation("\\U", false), peg$c135 = function(hex) {
          return String.fromCodePoint(parseInt(hex.join(""), 16));
        }, peg$c136 = "\\u", peg$c137 = peg$literalExpectation("\\u", false), peg$c138 = function(hex) {
          return String.fromCharCode(parseInt(hex.join(""), 16));
        }, peg$c139 = "\\t", peg$c140 = peg$literalExpectation("\\t", false), peg$c141 = function() {
          return "	";
        }, peg$c142 = "\\b", peg$c143 = peg$literalExpectation("\\b", false), peg$c144 = function() {
          return "\b";
        }, peg$c145 = "\\n", peg$c146 = peg$literalExpectation("\\n", false), peg$c147 = function() {
          return "\n";
        }, peg$c148 = "\\r", peg$c149 = peg$literalExpectation("\\r", false), peg$c150 = function() {
          return "\r";
        }, peg$c151 = "\\f", peg$c152 = peg$literalExpectation("\\f", false), peg$c153 = function() {
          return "\f";
        }, peg$c154 = '\\"', peg$c155 = peg$literalExpectation('\\"', false), peg$c156 = function() {
          return '"';
        }, peg$c157 = "\\'", peg$c158 = peg$literalExpectation("\\'", false), peg$c159 = function() {
          return "'";
        }, peg$c160 = "\\\\", peg$c161 = peg$literalExpectation("\\\\", false), peg$c162 = function() {
          return "\\";
        }, peg$c163 = /^[ \t\r\n]/, peg$c164 = peg$classExpectation([" ", "	", "\r", "\n"], false, false), peg$c165 = function() {
          return "[]";
        }, peg$c166 = /^[\uD800-\uDBFF]/, peg$c167 = peg$classExpectation([["\uD800", "\uDBFF"]], false, false), peg$c168 = /^[\uDC00-\uDFFF]/, peg$c169 = peg$classExpectation([["\uDC00", "\uDFFF"]], false, false), peg$c170 = function(a, b) {
          return a + b;
        }, peg$c171 = /^[A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/, peg$c172 = peg$classExpectation([["A", "Z"], ["a", "z"], ["\xC0", "\xD6"], ["\xD8", "\xF6"], ["\xF8", "\u02FF"], ["\u0370", "\u037D"], ["\u037F", "\u1FFF"], ["\u200C", "\u200D"], ["\u2070", "\u218F"], ["\u2C00", "\u2FEF"], ["\u3001", "\uD7FF"], ["\uF900", "\uFDCF"], ["\uFDF0", "\uFFFD"]], false, false), peg$c173 = "_", peg$c174 = peg$literalExpectation("_", false), peg$c175 = "\xB7", peg$c176 = peg$literalExpectation("\xB7", false), peg$c177 = /^[\u0300-\u036F]/, peg$c178 = peg$classExpectation([["\u0300", "\u036F"]], false, false), peg$c179 = /^[\u203F-\u2040]/, peg$c180 = peg$classExpectation([["\u203F", "\u2040"]], false, false), peg$c181 = function(head, body, a, b) {
          return a.join("") + b.join("");
        }, peg$c182 = function(head, body, tail) {
          return head + body.join("") + tail.join("");
        }, peg$c183 = "%", peg$c184 = peg$literalExpectation("%", false), peg$c185 = /^[0-9A-Fa-f]/, peg$c186 = peg$classExpectation([["0", "9"], ["A", "F"], ["a", "f"]], false, false), peg$c187 = "\\", peg$c188 = peg$literalExpectation("\\", false), peg$c189 = /^[_~.!$&'()*+,;=\/?#@%\-]/, peg$c190 = peg$classExpectation(["_", "~", ".", "!", "$", "&", "'", "(", ")", "*", "+", ",", ";", "=", "/", "?", "#", "@", "%", "-"], false, false), peg$currPos = 0, peg$savedPos = 0, peg$posDetailsCache = [{ line: 1, column: 1 }], peg$maxFailPos = 0, peg$maxFailExpected = [], peg$silentFails = 0, peg$result;
        if ("startRule" in options) {
          if (!(options.startRule in peg$startRuleFunctions)) {
            throw new Error(`Can't start parsing from rule "` + options.startRule + '".');
          }
          peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
        }
        function text4() {
          return input2.substring(peg$savedPos, peg$currPos);
        }
        function location7() {
          return peg$computeLocation(peg$savedPos, peg$currPos);
        }
        function expected(description12, location8) {
          location8 = location8 !== void 0 ? location8 : peg$computeLocation(peg$savedPos, peg$currPos);
          throw peg$buildStructuredError(
            [peg$otherExpectation(description12)],
            input2.substring(peg$savedPos, peg$currPos),
            location8
          );
        }
        function error4(message4, location8) {
          location8 = location8 !== void 0 ? location8 : peg$computeLocation(peg$savedPos, peg$currPos);
          throw peg$buildSimpleError(message4, location8);
        }
        function peg$literalExpectation(text5, ignoreCase) {
          return { type: "literal", text: text5, ignoreCase };
        }
        function peg$classExpectation(parts, inverted, ignoreCase) {
          return { type: "class", parts, inverted, ignoreCase };
        }
        function peg$anyExpectation() {
          return { type: "any" };
        }
        function peg$endExpectation() {
          return { type: "end" };
        }
        function peg$otherExpectation(description12) {
          return { type: "other", description: description12 };
        }
        function peg$computePosDetails(pos) {
          var details2 = peg$posDetailsCache[pos], p;
          if (details2) {
            return details2;
          } else {
            p = pos - 1;
            while (!peg$posDetailsCache[p]) {
              p--;
            }
            details2 = peg$posDetailsCache[p];
            details2 = {
              line: details2.line,
              column: details2.column
            };
            while (p < pos) {
              if (input2.charCodeAt(p) === 10) {
                details2.line++;
                details2.column = 1;
              } else {
                details2.column++;
              }
              p++;
            }
            peg$posDetailsCache[pos] = details2;
            return details2;
          }
        }
        function peg$computeLocation(startPos, endPos) {
          var startPosDetails = peg$computePosDetails(startPos), endPosDetails = peg$computePosDetails(endPos);
          return {
            start: {
              offset: startPos,
              line: startPosDetails.line,
              column: startPosDetails.column
            },
            end: {
              offset: endPos,
              line: endPosDetails.line,
              column: endPosDetails.column
            }
          };
        }
        function peg$fail(expected2) {
          if (peg$currPos < peg$maxFailPos) {
            return;
          }
          if (peg$currPos > peg$maxFailPos) {
            peg$maxFailPos = peg$currPos;
            peg$maxFailExpected = [];
          }
          peg$maxFailExpected.push(expected2);
        }
        function peg$buildSimpleError(message4, location8) {
          return new peg$SyntaxError(message4, null, null, location8);
        }
        function peg$buildStructuredError(expected2, found, location8) {
          return new peg$SyntaxError(
            peg$SyntaxError.buildMessage(expected2, found),
            expected2,
            found,
            location8
          );
        }
        function peg$parseturtleDoc() {
          var s0, s1, s2, s3, s4;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseBOM();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseBOM();
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsestatement();
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parsestatement();
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$parseIGNORE();
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$parseIGNORE();
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c0(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseBOM() {
          var s0;
          if (input2.charCodeAt(peg$currPos) === 65279) {
            s0 = peg$c1;
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c2);
            }
          }
          return s0;
        }
        function peg$parsestatement() {
          var s0, s1, s2, s3;
          s0 = peg$parsedirective();
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsetriples();
            if (s1 !== peg$FAILED) {
              s2 = [];
              s3 = peg$parseIGNORE();
              while (s3 !== peg$FAILED) {
                s2.push(s3);
                s3 = peg$parseIGNORE();
              }
              if (s2 !== peg$FAILED) {
                if (input2.charCodeAt(peg$currPos) === 46) {
                  s3 = peg$c3;
                  peg$currPos++;
                } else {
                  s3 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c4);
                  }
                }
                if (s3 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c5(s1);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
          return s0;
        }
        function peg$parseCOMMENT() {
          var s0, s1, s2, s3;
          s0 = peg$currPos;
          if (input2.charCodeAt(peg$currPos) === 35) {
            s1 = peg$c6;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c7);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            if (peg$c8.test(input2.charAt(peg$currPos))) {
              s3 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c9);
              }
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              if (peg$c8.test(input2.charAt(peg$currPos))) {
                s3 = input2.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c9);
                }
              }
            }
            if (s2 !== peg$FAILED) {
              if (input2.charCodeAt(peg$currPos) === 10) {
                s3 = peg$c10;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c11);
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c12(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseIGNORE() {
          var s0;
          s0 = peg$parseWS();
          if (s0 === peg$FAILED) {
            s0 = peg$parseCOMMENT();
          }
          return s0;
        }
        function peg$parsedirective() {
          var s0;
          s0 = peg$parseprefixID();
          if (s0 === peg$FAILED) {
            s0 = peg$parsebase();
            if (s0 === peg$FAILED) {
              s0 = peg$parsesparqlPrefix();
              if (s0 === peg$FAILED) {
                s0 = peg$parsesparqlBase();
              }
            }
          }
          return s0;
        }
        function peg$parseprefixID() {
          var s0, s1, s2, s3, s4, s5, s6, s7, s8;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            if (input2.substr(peg$currPos, 7) === peg$c13) {
              s2 = peg$c13;
              peg$currPos += 7;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c14);
              }
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$parseIGNORE();
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$parseIGNORE();
              }
              if (s3 !== peg$FAILED) {
                s4 = peg$parsePNAME_NS_NO_CHECK();
                if (s4 !== peg$FAILED) {
                  s5 = [];
                  s6 = peg$parseIGNORE();
                  while (s6 !== peg$FAILED) {
                    s5.push(s6);
                    s6 = peg$parseIGNORE();
                  }
                  if (s5 !== peg$FAILED) {
                    s6 = peg$parseIRIREF();
                    if (s6 !== peg$FAILED) {
                      s7 = [];
                      s8 = peg$parseIGNORE();
                      while (s8 !== peg$FAILED) {
                        s7.push(s8);
                        s8 = peg$parseIGNORE();
                      }
                      if (s7 !== peg$FAILED) {
                        if (input2.charCodeAt(peg$currPos) === 46) {
                          s8 = peg$c3;
                          peg$currPos++;
                        } else {
                          s8 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c4);
                          }
                        }
                        if (s8 !== peg$FAILED) {
                          peg$savedPos = s0;
                          s1 = peg$c15(s4, s6);
                          s0 = s1;
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsebase() {
          var s0, s1, s2, s3, s4, s5, s6;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            if (input2.substr(peg$currPos, 5) === peg$c16) {
              s2 = peg$c16;
              peg$currPos += 5;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c17);
              }
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$parseIGNORE();
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$parseIGNORE();
              }
              if (s3 !== peg$FAILED) {
                s4 = peg$parseIRIREF();
                if (s4 !== peg$FAILED) {
                  s5 = [];
                  s6 = peg$parseIGNORE();
                  while (s6 !== peg$FAILED) {
                    s5.push(s6);
                    s6 = peg$parseIGNORE();
                  }
                  if (s5 !== peg$FAILED) {
                    if (input2.charCodeAt(peg$currPos) === 46) {
                      s6 = peg$c3;
                      peg$currPos++;
                    } else {
                      s6 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c4);
                      }
                    }
                    if (s6 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c18(s4);
                      s0 = s1;
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsesparqlBase() {
          var s0, s1, s2, s3, s4, s5, s6, s7;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            if (peg$c19.test(input2.charAt(peg$currPos))) {
              s2 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c20);
              }
            }
            if (s2 !== peg$FAILED) {
              if (peg$c21.test(input2.charAt(peg$currPos))) {
                s3 = input2.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c22);
                }
              }
              if (s3 !== peg$FAILED) {
                if (peg$c23.test(input2.charAt(peg$currPos))) {
                  s4 = input2.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s4 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c24);
                  }
                }
                if (s4 !== peg$FAILED) {
                  if (peg$c25.test(input2.charAt(peg$currPos))) {
                    s5 = input2.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c26);
                    }
                  }
                  if (s5 !== peg$FAILED) {
                    s6 = [];
                    s7 = peg$parseIGNORE();
                    while (s7 !== peg$FAILED) {
                      s6.push(s7);
                      s7 = peg$parseIGNORE();
                    }
                    if (s6 !== peg$FAILED) {
                      s7 = peg$parseIRIREF();
                      if (s7 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c18(s7);
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsesparqlPrefix() {
          var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10, s11;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            if (peg$c27.test(input2.charAt(peg$currPos))) {
              s2 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c28);
              }
            }
            if (s2 !== peg$FAILED) {
              if (peg$c29.test(input2.charAt(peg$currPos))) {
                s3 = input2.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c30);
                }
              }
              if (s3 !== peg$FAILED) {
                if (peg$c25.test(input2.charAt(peg$currPos))) {
                  s4 = input2.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s4 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c26);
                  }
                }
                if (s4 !== peg$FAILED) {
                  if (peg$c31.test(input2.charAt(peg$currPos))) {
                    s5 = input2.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c32);
                    }
                  }
                  if (s5 !== peg$FAILED) {
                    if (peg$c33.test(input2.charAt(peg$currPos))) {
                      s6 = input2.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s6 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c34);
                      }
                    }
                    if (s6 !== peg$FAILED) {
                      if (peg$c35.test(input2.charAt(peg$currPos))) {
                        s7 = input2.charAt(peg$currPos);
                        peg$currPos++;
                      } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c36);
                        }
                      }
                      if (s7 !== peg$FAILED) {
                        s8 = [];
                        s9 = peg$parseIGNORE();
                        while (s9 !== peg$FAILED) {
                          s8.push(s9);
                          s9 = peg$parseIGNORE();
                        }
                        if (s8 !== peg$FAILED) {
                          s9 = peg$parsePNAME_NS_NO_CHECK();
                          if (s9 !== peg$FAILED) {
                            s10 = [];
                            s11 = peg$parseIGNORE();
                            while (s11 !== peg$FAILED) {
                              s10.push(s11);
                              s11 = peg$parseIGNORE();
                            }
                            if (s10 !== peg$FAILED) {
                              s11 = peg$parseIRIREF();
                              if (s11 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c15(s9, s11);
                                s0 = s1;
                              } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                              }
                            } else {
                              peg$currPos = s0;
                              s0 = peg$FAILED;
                            }
                          } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s0;
                          s0 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsetriples() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = peg$parsesubject();
          if (s1 !== peg$FAILED) {
            s2 = peg$parsepredicateObjectList();
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c37(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parseblankNodePropertyList();
            if (s1 !== peg$FAILED) {
              s2 = peg$parsepredicateObjectList();
              if (s2 === peg$FAILED) {
                s2 = null;
              }
              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c38(s1, s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
          return s0;
        }
        function peg$parsepredicateObjectList() {
          var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
          s0 = peg$currPos;
          s1 = peg$parseverb();
          if (s1 !== peg$FAILED) {
            s2 = peg$parseobjectList();
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$currPos;
              s5 = [];
              s6 = peg$parseIGNORE();
              while (s6 !== peg$FAILED) {
                s5.push(s6);
                s6 = peg$parseIGNORE();
              }
              if (s5 !== peg$FAILED) {
                if (input2.charCodeAt(peg$currPos) === 59) {
                  s6 = peg$c39;
                  peg$currPos++;
                } else {
                  s6 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c40);
                  }
                }
                if (s6 !== peg$FAILED) {
                  s7 = peg$currPos;
                  s8 = peg$parseverb();
                  if (s8 !== peg$FAILED) {
                    s9 = peg$parseobjectList();
                    if (s9 !== peg$FAILED) {
                      peg$savedPos = s7;
                      s8 = peg$c41(s1, s2, s8, s9);
                      s7 = s8;
                    } else {
                      peg$currPos = s7;
                      s7 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s7;
                    s7 = peg$FAILED;
                  }
                  if (s7 === peg$FAILED) {
                    s7 = null;
                  }
                  if (s7 !== peg$FAILED) {
                    peg$savedPos = s4;
                    s5 = peg$c42(s1, s2, s7);
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$currPos;
                s5 = [];
                s6 = peg$parseIGNORE();
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$parseIGNORE();
                }
                if (s5 !== peg$FAILED) {
                  if (input2.charCodeAt(peg$currPos) === 59) {
                    s6 = peg$c39;
                    peg$currPos++;
                  } else {
                    s6 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c40);
                    }
                  }
                  if (s6 !== peg$FAILED) {
                    s7 = peg$currPos;
                    s8 = peg$parseverb();
                    if (s8 !== peg$FAILED) {
                      s9 = peg$parseobjectList();
                      if (s9 !== peg$FAILED) {
                        peg$savedPos = s7;
                        s8 = peg$c41(s1, s2, s8, s9);
                        s7 = s8;
                      } else {
                        peg$currPos = s7;
                        s7 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s7;
                      s7 = peg$FAILED;
                    }
                    if (s7 === peg$FAILED) {
                      s7 = null;
                    }
                    if (s7 !== peg$FAILED) {
                      peg$savedPos = s4;
                      s5 = peg$c42(s1, s2, s7);
                      s4 = s5;
                    } else {
                      peg$currPos = s4;
                      s4 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c43(s1, s2, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseobjectList() {
          var s0, s1, s2, s3, s4, s5, s6;
          s0 = peg$currPos;
          s1 = peg$parseobject();
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$currPos;
            s4 = [];
            s5 = peg$parseIGNORE();
            while (s5 !== peg$FAILED) {
              s4.push(s5);
              s5 = peg$parseIGNORE();
            }
            if (s4 !== peg$FAILED) {
              if (input2.charCodeAt(peg$currPos) === 44) {
                s5 = peg$c44;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c45);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = peg$parseobject();
                if (s6 !== peg$FAILED) {
                  peg$savedPos = s3;
                  s4 = peg$c46(s1, s6);
                  s3 = s4;
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$currPos;
              s4 = [];
              s5 = peg$parseIGNORE();
              while (s5 !== peg$FAILED) {
                s4.push(s5);
                s5 = peg$parseIGNORE();
              }
              if (s4 !== peg$FAILED) {
                if (input2.charCodeAt(peg$currPos) === 44) {
                  s5 = peg$c44;
                  peg$currPos++;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c45);
                  }
                }
                if (s5 !== peg$FAILED) {
                  s6 = peg$parseobject();
                  if (s6 !== peg$FAILED) {
                    peg$savedPos = s3;
                    s4 = peg$c46(s1, s6);
                    s3 = s4;
                  } else {
                    peg$currPos = s3;
                    s3 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s3;
                  s3 = peg$FAILED;
                }
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c47(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseverb() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = peg$parsepredicate();
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c5(s1);
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while (s2 !== peg$FAILED) {
              s1.push(s2);
              s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
              if (input2.charCodeAt(peg$currPos) === 97) {
                s2 = peg$c48;
                peg$currPos++;
              } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c49);
                }
              }
              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c50();
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
          return s0;
        }
        function peg$parsesubject() {
          var s0, s1;
          s0 = peg$currPos;
          s1 = peg$parsecollection();
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c51(s1);
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$parseBlankNode();
            if (s0 === peg$FAILED) {
              s0 = peg$parseiri();
            }
          }
          return s0;
        }
        function peg$parsepredicate() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseiri();
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c5(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseobject() {
          var s0, s1;
          s0 = peg$parseliteral();
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsecollection();
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c52(s1);
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = peg$parseBlankNode();
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c53(s1);
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                s1 = peg$parseblankNodePropertyList();
                if (s1 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c5(s1);
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;
                  s1 = peg$parseiri();
                  if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c54(s1);
                  }
                  s0 = s1;
                }
              }
            }
          }
          return s0;
        }
        function peg$parseliteral() {
          var s0;
          s0 = peg$parseRDFLiteral();
          if (s0 === peg$FAILED) {
            s0 = peg$parseNumericLiteral();
            if (s0 === peg$FAILED) {
              s0 = peg$parseBooleanLiteral();
            }
          }
          return s0;
        }
        function peg$parseblankNodePropertyList() {
          var s0, s1, s2, s3, s4, s5;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            if (input2.charCodeAt(peg$currPos) === 91) {
              s2 = peg$c55;
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c56);
              }
            }
            if (s2 !== peg$FAILED) {
              s3 = peg$parsepredicateObjectList();
              if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parseIGNORE();
                while (s5 !== peg$FAILED) {
                  s4.push(s5);
                  s5 = peg$parseIGNORE();
                }
                if (s4 !== peg$FAILED) {
                  if (input2.charCodeAt(peg$currPos) === 93) {
                    s5 = peg$c57;
                    peg$currPos++;
                  } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c58);
                    }
                  }
                  if (s5 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c5(s3);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsecollection() {
          var s0, s1, s2, s3, s4, s5;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            if (input2.charCodeAt(peg$currPos) === 40) {
              s2 = peg$c59;
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c60);
              }
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$parseobject();
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$parseobject();
              }
              if (s3 !== peg$FAILED) {
                s4 = [];
                s5 = peg$parseIGNORE();
                while (s5 !== peg$FAILED) {
                  s4.push(s5);
                  s5 = peg$parseIGNORE();
                }
                if (s4 !== peg$FAILED) {
                  if (input2.charCodeAt(peg$currPos) === 41) {
                    s5 = peg$c61;
                    peg$currPos++;
                  } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c62);
                    }
                  }
                  if (s5 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c63(s3);
                    s0 = s1;
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseNumericLiteral() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseDOUBLE();
            if (s2 === peg$FAILED) {
              s2 = peg$parseDECIMAL();
              if (s2 === peg$FAILED) {
                s2 = peg$parseINTEGER();
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c5(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseRDFLiteral() {
          var s0, s1, s2, s3, s4, s5, s6;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseString();
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$parseIGNORE();
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$parseIGNORE();
              }
              if (s3 !== peg$FAILED) {
                s4 = peg$parseLANGTAG();
                if (s4 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c64(s2, s4);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while (s2 !== peg$FAILED) {
              s1.push(s2);
              s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
              s2 = peg$parseString();
              if (s2 !== peg$FAILED) {
                s3 = [];
                s4 = peg$parseIGNORE();
                while (s4 !== peg$FAILED) {
                  s3.push(s4);
                  s4 = peg$parseIGNORE();
                }
                if (s3 !== peg$FAILED) {
                  if (input2.substr(peg$currPos, 2) === peg$c65) {
                    s4 = peg$c65;
                    peg$currPos += 2;
                  } else {
                    s4 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c66);
                    }
                  }
                  if (s4 !== peg$FAILED) {
                    s5 = [];
                    s6 = peg$parseIGNORE();
                    while (s6 !== peg$FAILED) {
                      s5.push(s6);
                      s6 = peg$parseIGNORE();
                    }
                    if (s5 !== peg$FAILED) {
                      s6 = peg$parseiri();
                      if (s6 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c67(s2, s6);
                        s0 = s1;
                      } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s0;
                      s0 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s0;
                    s0 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              s1 = [];
              s2 = peg$parseIGNORE();
              while (s2 !== peg$FAILED) {
                s1.push(s2);
                s2 = peg$parseIGNORE();
              }
              if (s1 !== peg$FAILED) {
                s2 = peg$parseString();
                if (s2 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c5(s2);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            }
          }
          return s0;
        }
        function peg$parseBooleanLiteral() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            if (input2.substr(peg$currPos, 4) === peg$c68) {
              s2 = peg$c68;
              peg$currPos += 4;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c69);
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c70();
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while (s2 !== peg$FAILED) {
              s1.push(s2);
              s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
              if (input2.substr(peg$currPos, 5) === peg$c71) {
                s2 = peg$c71;
                peg$currPos += 5;
              } else {
                s2 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c72);
                }
              }
              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c73();
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
          return s0;
        }
        function peg$parseString() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseSTRING_LITERAL_LONG_SINGLE_QUOTE();
            if (s2 === peg$FAILED) {
              s2 = peg$parseSTRING_LITERAL_LONG_QUOTE();
              if (s2 === peg$FAILED) {
                s2 = peg$parseSTRING_LITERAL_SINGLE_QUOTE();
                if (s2 === peg$FAILED) {
                  s2 = peg$parseSTRING_LITERAL_QUOTE();
                }
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c5(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseiri() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseIRIREF();
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c5(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while (s2 !== peg$FAILED) {
              s1.push(s2);
              s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
              s2 = peg$parsePrefixedName();
              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c5(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
          return s0;
        }
        function peg$parsePrefixedName() {
          var s0, s1;
          s0 = peg$parsePNAME_LN();
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = peg$parsePNAME_NS();
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c74(s1);
            }
            s0 = s1;
          }
          return s0;
        }
        function peg$parseBlankNode() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = [];
          s2 = peg$parseIGNORE();
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = peg$parseIGNORE();
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseBLANK_NODE_LABEL();
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c5(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            s1 = [];
            s2 = peg$parseIGNORE();
            while (s2 !== peg$FAILED) {
              s1.push(s2);
              s2 = peg$parseIGNORE();
            }
            if (s1 !== peg$FAILED) {
              s2 = peg$parseANON();
              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c5(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
          return s0;
        }
        function peg$parseIRIREF() {
          var s0, s1, s2, s3;
          s0 = peg$currPos;
          if (input2.charCodeAt(peg$currPos) === 60) {
            s1 = peg$c75;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c76);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            if (peg$c77.test(input2.charAt(peg$currPos))) {
              s3 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c78);
              }
            }
            if (s3 === peg$FAILED) {
              s3 = peg$parseUCHAR();
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              if (peg$c77.test(input2.charAt(peg$currPos))) {
                s3 = input2.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c78);
                }
              }
              if (s3 === peg$FAILED) {
                s3 = peg$parseUCHAR();
              }
            }
            if (s2 !== peg$FAILED) {
              if (input2.charCodeAt(peg$currPos) === 62) {
                s3 = peg$c79;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c80);
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c81(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsePNAME_NS() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = peg$parsePN_PREFIX();
          if (s1 === peg$FAILED) {
            s1 = null;
          }
          if (s1 !== peg$FAILED) {
            if (input2.charCodeAt(peg$currPos) === 58) {
              s2 = peg$c82;
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c83);
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c84(s1);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsePNAME_NS_NO_CHECK() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = peg$parsePN_PREFIX();
          if (s1 === peg$FAILED) {
            s1 = null;
          }
          if (s1 !== peg$FAILED) {
            if (input2.charCodeAt(peg$currPos) === 58) {
              s2 = peg$c82;
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c83);
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c85(s1);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsePNAME_LN() {
          var s0, s1, s2;
          s0 = peg$currPos;
          s1 = peg$parsePNAME_NS();
          if (s1 !== peg$FAILED) {
            s2 = peg$parsePN_LOCAL();
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c86(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseBLANK_NODE_LABEL() {
          var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9;
          s0 = peg$currPos;
          s1 = peg$currPos;
          if (input2.substr(peg$currPos, 2) === peg$c87) {
            s2 = peg$c87;
            peg$currPos += 2;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c88);
            }
          }
          if (s2 !== peg$FAILED) {
            s3 = peg$parsePN_CHARS_U();
            if (s3 === peg$FAILED) {
              if (peg$c89.test(input2.charAt(peg$currPos))) {
                s3 = input2.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c90);
                }
              }
            }
            if (s3 !== peg$FAILED) {
              s4 = [];
              s5 = peg$parsePN_CHARS();
              while (s5 !== peg$FAILED) {
                s4.push(s5);
                s5 = peg$parsePN_CHARS();
              }
              if (s4 !== peg$FAILED) {
                s5 = [];
                s6 = peg$currPos;
                s7 = [];
                if (input2.charCodeAt(peg$currPos) === 46) {
                  s8 = peg$c3;
                  peg$currPos++;
                } else {
                  s8 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c4);
                  }
                }
                if (s8 !== peg$FAILED) {
                  while (s8 !== peg$FAILED) {
                    s7.push(s8);
                    if (input2.charCodeAt(peg$currPos) === 46) {
                      s8 = peg$c3;
                      peg$currPos++;
                    } else {
                      s8 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c4);
                      }
                    }
                  }
                } else {
                  s7 = peg$FAILED;
                }
                if (s7 !== peg$FAILED) {
                  s8 = [];
                  s9 = peg$parsePN_CHARS();
                  if (s9 !== peg$FAILED) {
                    while (s9 !== peg$FAILED) {
                      s8.push(s9);
                      s9 = peg$parsePN_CHARS();
                    }
                  } else {
                    s8 = peg$FAILED;
                  }
                  if (s8 !== peg$FAILED) {
                    s7 = [s7, s8];
                    s6 = s7;
                  } else {
                    peg$currPos = s6;
                    s6 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s6;
                  s6 = peg$FAILED;
                }
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  s6 = peg$currPos;
                  s7 = [];
                  if (input2.charCodeAt(peg$currPos) === 46) {
                    s8 = peg$c3;
                    peg$currPos++;
                  } else {
                    s8 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c4);
                    }
                  }
                  if (s8 !== peg$FAILED) {
                    while (s8 !== peg$FAILED) {
                      s7.push(s8);
                      if (input2.charCodeAt(peg$currPos) === 46) {
                        s8 = peg$c3;
                        peg$currPos++;
                      } else {
                        s8 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c4);
                        }
                      }
                    }
                  } else {
                    s7 = peg$FAILED;
                  }
                  if (s7 !== peg$FAILED) {
                    s8 = [];
                    s9 = peg$parsePN_CHARS();
                    if (s9 !== peg$FAILED) {
                      while (s9 !== peg$FAILED) {
                        s8.push(s9);
                        s9 = peg$parsePN_CHARS();
                      }
                    } else {
                      s8 = peg$FAILED;
                    }
                    if (s8 !== peg$FAILED) {
                      s7 = [s7, s8];
                      s6 = s7;
                    } else {
                      peg$currPos = s6;
                      s6 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s6;
                    s6 = peg$FAILED;
                  }
                }
                if (s5 !== peg$FAILED) {
                  s2 = [s2, s3, s4, s5];
                  s1 = s2;
                } else {
                  peg$currPos = s1;
                  s1 = peg$FAILED;
                }
              } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
              }
            } else {
              peg$currPos = s1;
              s1 = peg$FAILED;
            }
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
          if (s1 !== peg$FAILED) {
            s0 = input2.substring(s0, peg$currPos);
          } else {
            s0 = s1;
          }
          return s0;
        }
        function peg$parseLANGTAG() {
          var s0, s1, s2, s3, s4, s5, s6, s7;
          s0 = peg$currPos;
          if (input2.charCodeAt(peg$currPos) === 64) {
            s1 = peg$c91;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c92);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            if (peg$c93.test(input2.charAt(peg$currPos))) {
              s3 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c94);
              }
            }
            if (s3 !== peg$FAILED) {
              while (s3 !== peg$FAILED) {
                s2.push(s3);
                if (peg$c93.test(input2.charAt(peg$currPos))) {
                  s3 = input2.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s3 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c94);
                  }
                }
              }
            } else {
              s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$currPos;
              if (input2.charCodeAt(peg$currPos) === 45) {
                s5 = peg$c95;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c96);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = [];
                if (peg$c97.test(input2.charAt(peg$currPos))) {
                  s7 = input2.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c98);
                  }
                }
                if (s7 !== peg$FAILED) {
                  while (s7 !== peg$FAILED) {
                    s6.push(s7);
                    if (peg$c97.test(input2.charAt(peg$currPos))) {
                      s7 = input2.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c98);
                      }
                    }
                  }
                } else {
                  s6 = peg$FAILED;
                }
                if (s6 !== peg$FAILED) {
                  peg$savedPos = s4;
                  s5 = peg$c99(s2, s6);
                  s4 = s5;
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$currPos;
                if (input2.charCodeAt(peg$currPos) === 45) {
                  s5 = peg$c95;
                  peg$currPos++;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c96);
                  }
                }
                if (s5 !== peg$FAILED) {
                  s6 = [];
                  if (peg$c97.test(input2.charAt(peg$currPos))) {
                    s7 = input2.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c98);
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    while (s7 !== peg$FAILED) {
                      s6.push(s7);
                      if (peg$c97.test(input2.charAt(peg$currPos))) {
                        s7 = input2.charAt(peg$currPos);
                        peg$currPos++;
                      } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c98);
                        }
                      }
                    }
                  } else {
                    s6 = peg$FAILED;
                  }
                  if (s6 !== peg$FAILED) {
                    peg$savedPos = s4;
                    s5 = peg$c99(s2, s6);
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c100(s2, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseINTEGER() {
          var s0, s1, s2, s3, s4, s5;
          s0 = peg$currPos;
          s1 = peg$currPos;
          s2 = peg$currPos;
          if (peg$c101.test(input2.charAt(peg$currPos))) {
            s3 = input2.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c102);
            }
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            s4 = [];
            if (peg$c89.test(input2.charAt(peg$currPos))) {
              s5 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c90);
              }
            }
            if (s5 !== peg$FAILED) {
              while (s5 !== peg$FAILED) {
                s4.push(s5);
                if (peg$c89.test(input2.charAt(peg$currPos))) {
                  s5 = input2.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c90);
                  }
                }
              }
            } else {
              s4 = peg$FAILED;
            }
            if (s4 !== peg$FAILED) {
              s3 = [s3, s4];
              s2 = s3;
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
          if (s2 !== peg$FAILED) {
            s1 = input2.substring(s1, peg$currPos);
          } else {
            s1 = s2;
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c103(s1);
          }
          s0 = s1;
          return s0;
        }
        function peg$parseDECIMAL() {
          var s0, s1, s2, s3, s4, s5, s6, s7;
          s0 = peg$currPos;
          s1 = peg$currPos;
          s2 = peg$currPos;
          if (peg$c101.test(input2.charAt(peg$currPos))) {
            s3 = input2.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c102);
            }
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            s4 = [];
            if (peg$c89.test(input2.charAt(peg$currPos))) {
              s5 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s5 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c90);
              }
            }
            while (s5 !== peg$FAILED) {
              s4.push(s5);
              if (peg$c89.test(input2.charAt(peg$currPos))) {
                s5 = input2.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c90);
                }
              }
            }
            if (s4 !== peg$FAILED) {
              if (input2.charCodeAt(peg$currPos) === 46) {
                s5 = peg$c3;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c4);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = [];
                if (peg$c89.test(input2.charAt(peg$currPos))) {
                  s7 = input2.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c90);
                  }
                }
                if (s7 !== peg$FAILED) {
                  while (s7 !== peg$FAILED) {
                    s6.push(s7);
                    if (peg$c89.test(input2.charAt(peg$currPos))) {
                      s7 = input2.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c90);
                      }
                    }
                  }
                } else {
                  s6 = peg$FAILED;
                }
                if (s6 !== peg$FAILED) {
                  s3 = [s3, s4, s5, s6];
                  s2 = s3;
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
          if (s2 !== peg$FAILED) {
            s1 = input2.substring(s1, peg$currPos);
          } else {
            s1 = s2;
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c104(s1);
          }
          s0 = s1;
          return s0;
        }
        function peg$parseDOUBLE() {
          var s0, s1, s2, s3, s4, s5, s6, s7, s8;
          s0 = peg$currPos;
          s1 = peg$currPos;
          s2 = peg$currPos;
          if (peg$c101.test(input2.charAt(peg$currPos))) {
            s3 = input2.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c102);
            }
          }
          if (s3 === peg$FAILED) {
            s3 = null;
          }
          if (s3 !== peg$FAILED) {
            s4 = peg$currPos;
            s5 = [];
            if (peg$c89.test(input2.charAt(peg$currPos))) {
              s6 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s6 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c90);
              }
            }
            if (s6 !== peg$FAILED) {
              while (s6 !== peg$FAILED) {
                s5.push(s6);
                if (peg$c89.test(input2.charAt(peg$currPos))) {
                  s6 = input2.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s6 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c90);
                  }
                }
              }
            } else {
              s5 = peg$FAILED;
            }
            if (s5 !== peg$FAILED) {
              if (input2.charCodeAt(peg$currPos) === 46) {
                s6 = peg$c3;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c4);
                }
              }
              if (s6 !== peg$FAILED) {
                s7 = [];
                if (peg$c89.test(input2.charAt(peg$currPos))) {
                  s8 = input2.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s8 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c90);
                  }
                }
                while (s8 !== peg$FAILED) {
                  s7.push(s8);
                  if (peg$c89.test(input2.charAt(peg$currPos))) {
                    s8 = input2.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s8 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c90);
                    }
                  }
                }
                if (s7 !== peg$FAILED) {
                  s8 = peg$parseEXPONENT();
                  if (s8 !== peg$FAILED) {
                    s5 = [s5, s6, s7, s8];
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
            if (s4 === peg$FAILED) {
              s4 = peg$currPos;
              if (input2.charCodeAt(peg$currPos) === 46) {
                s5 = peg$c3;
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c4);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = [];
                if (peg$c89.test(input2.charAt(peg$currPos))) {
                  s7 = input2.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c90);
                  }
                }
                if (s7 !== peg$FAILED) {
                  while (s7 !== peg$FAILED) {
                    s6.push(s7);
                    if (peg$c89.test(input2.charAt(peg$currPos))) {
                      s7 = input2.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c90);
                      }
                    }
                  }
                } else {
                  s6 = peg$FAILED;
                }
                if (s6 !== peg$FAILED) {
                  s7 = peg$parseEXPONENT();
                  if (s7 !== peg$FAILED) {
                    s5 = [s5, s6, s7];
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
              if (s4 === peg$FAILED) {
                s4 = peg$currPos;
                s5 = [];
                if (peg$c89.test(input2.charAt(peg$currPos))) {
                  s6 = input2.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s6 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c90);
                  }
                }
                if (s6 !== peg$FAILED) {
                  while (s6 !== peg$FAILED) {
                    s5.push(s6);
                    if (peg$c89.test(input2.charAt(peg$currPos))) {
                      s6 = input2.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s6 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c90);
                      }
                    }
                  }
                } else {
                  s5 = peg$FAILED;
                }
                if (s5 !== peg$FAILED) {
                  s6 = peg$parseEXPONENT();
                  if (s6 !== peg$FAILED) {
                    s5 = [s5, s6];
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              }
            }
            if (s4 !== peg$FAILED) {
              s3 = [s3, s4];
              s2 = s3;
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
          } else {
            peg$currPos = s2;
            s2 = peg$FAILED;
          }
          if (s2 !== peg$FAILED) {
            s1 = input2.substring(s1, peg$currPos);
          } else {
            s1 = s2;
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c105(s1);
          }
          s0 = s1;
          return s0;
        }
        function peg$parseEXPONENT() {
          var s0, s1, s2, s3, s4, s5;
          s0 = peg$currPos;
          s1 = peg$currPos;
          if (peg$c106.test(input2.charAt(peg$currPos))) {
            s2 = input2.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c107);
            }
          }
          if (s2 !== peg$FAILED) {
            if (peg$c101.test(input2.charAt(peg$currPos))) {
              s3 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c102);
              }
            }
            if (s3 === peg$FAILED) {
              s3 = null;
            }
            if (s3 !== peg$FAILED) {
              s4 = [];
              if (peg$c89.test(input2.charAt(peg$currPos))) {
                s5 = input2.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c90);
                }
              }
              if (s5 !== peg$FAILED) {
                while (s5 !== peg$FAILED) {
                  s4.push(s5);
                  if (peg$c89.test(input2.charAt(peg$currPos))) {
                    s5 = input2.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c90);
                    }
                  }
                }
              } else {
                s4 = peg$FAILED;
              }
              if (s4 !== peg$FAILED) {
                s2 = [s2, s3, s4];
                s1 = s2;
              } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
              }
            } else {
              peg$currPos = s1;
              s1 = peg$FAILED;
            }
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
          if (s1 !== peg$FAILED) {
            s0 = input2.substring(s0, peg$currPos);
          } else {
            s0 = s1;
          }
          return s0;
        }
        function peg$parseSTRING_LITERAL_QUOTE() {
          var s0, s1, s2, s3;
          s0 = peg$currPos;
          if (input2.charCodeAt(peg$currPos) === 34) {
            s1 = peg$c108;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c109);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            if (peg$c110.test(input2.charAt(peg$currPos))) {
              s3 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c111);
              }
            }
            if (s3 === peg$FAILED) {
              s3 = peg$parseECHAR();
              if (s3 === peg$FAILED) {
                s3 = peg$parseUCHAR();
              }
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              if (peg$c110.test(input2.charAt(peg$currPos))) {
                s3 = input2.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c111);
                }
              }
              if (s3 === peg$FAILED) {
                s3 = peg$parseECHAR();
                if (s3 === peg$FAILED) {
                  s3 = peg$parseUCHAR();
                }
              }
            }
            if (s2 !== peg$FAILED) {
              if (input2.charCodeAt(peg$currPos) === 34) {
                s3 = peg$c108;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c109);
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c12(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseSTRING_LITERAL_SINGLE_QUOTE() {
          var s0, s1, s2, s3;
          s0 = peg$currPos;
          if (input2.charCodeAt(peg$currPos) === 39) {
            s1 = peg$c112;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c113);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            if (peg$c114.test(input2.charAt(peg$currPos))) {
              s3 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c115);
              }
            }
            if (s3 === peg$FAILED) {
              s3 = peg$parseECHAR();
              if (s3 === peg$FAILED) {
                s3 = peg$parseUCHAR();
              }
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              if (peg$c114.test(input2.charAt(peg$currPos))) {
                s3 = input2.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c115);
                }
              }
              if (s3 === peg$FAILED) {
                s3 = peg$parseECHAR();
                if (s3 === peg$FAILED) {
                  s3 = peg$parseUCHAR();
                }
              }
            }
            if (s2 !== peg$FAILED) {
              if (input2.charCodeAt(peg$currPos) === 39) {
                s3 = peg$c112;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c113);
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c12(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseSTRING_LITERAL_LONG_SINGLE_QUOTE() {
          var s0, s1, s2, s3, s4, s5, s6, s7;
          s0 = peg$currPos;
          if (input2.substr(peg$currPos, 3) === peg$c116) {
            s1 = peg$c116;
            peg$currPos += 3;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c117);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            if (peg$c118.test(input2.charAt(peg$currPos))) {
              s3 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c119);
              }
            }
            if (s3 === peg$FAILED) {
              s3 = peg$parseECHAR();
              if (s3 === peg$FAILED) {
                s3 = peg$parseUCHAR();
              }
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              if (peg$c118.test(input2.charAt(peg$currPos))) {
                s3 = input2.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c119);
                }
              }
              if (s3 === peg$FAILED) {
                s3 = peg$parseECHAR();
                if (s3 === peg$FAILED) {
                  s3 = peg$parseUCHAR();
                }
              }
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$currPos;
              if (input2.substr(peg$currPos, 2) === peg$c120) {
                s5 = peg$c120;
                peg$currPos += 2;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c121);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = [];
                if (peg$c118.test(input2.charAt(peg$currPos))) {
                  s7 = input2.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c119);
                  }
                }
                if (s7 === peg$FAILED) {
                  s7 = peg$parseECHAR();
                  if (s7 === peg$FAILED) {
                    s7 = peg$parseUCHAR();
                  }
                }
                if (s7 !== peg$FAILED) {
                  while (s7 !== peg$FAILED) {
                    s6.push(s7);
                    if (peg$c118.test(input2.charAt(peg$currPos))) {
                      s7 = input2.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c119);
                      }
                    }
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseECHAR();
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseUCHAR();
                      }
                    }
                  }
                } else {
                  s6 = peg$FAILED;
                }
                if (s6 !== peg$FAILED) {
                  peg$savedPos = s4;
                  s5 = peg$c122(s2, s6);
                  s4 = s5;
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
              if (s4 === peg$FAILED) {
                s4 = peg$currPos;
                if (input2.charCodeAt(peg$currPos) === 39) {
                  s5 = peg$c112;
                  peg$currPos++;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c113);
                  }
                }
                if (s5 !== peg$FAILED) {
                  s6 = [];
                  if (peg$c118.test(input2.charAt(peg$currPos))) {
                    s7 = input2.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c119);
                    }
                  }
                  if (s7 === peg$FAILED) {
                    s7 = peg$parseECHAR();
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseUCHAR();
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    while (s7 !== peg$FAILED) {
                      s6.push(s7);
                      if (peg$c118.test(input2.charAt(peg$currPos))) {
                        s7 = input2.charAt(peg$currPos);
                        peg$currPos++;
                      } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c119);
                        }
                      }
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseECHAR();
                        if (s7 === peg$FAILED) {
                          s7 = peg$parseUCHAR();
                        }
                      }
                    }
                  } else {
                    s6 = peg$FAILED;
                  }
                  if (s6 !== peg$FAILED) {
                    peg$savedPos = s4;
                    s5 = peg$c123(s2, s6);
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              }
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$currPos;
                if (input2.substr(peg$currPos, 2) === peg$c120) {
                  s5 = peg$c120;
                  peg$currPos += 2;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c121);
                  }
                }
                if (s5 !== peg$FAILED) {
                  s6 = [];
                  if (peg$c118.test(input2.charAt(peg$currPos))) {
                    s7 = input2.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c119);
                    }
                  }
                  if (s7 === peg$FAILED) {
                    s7 = peg$parseECHAR();
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseUCHAR();
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    while (s7 !== peg$FAILED) {
                      s6.push(s7);
                      if (peg$c118.test(input2.charAt(peg$currPos))) {
                        s7 = input2.charAt(peg$currPos);
                        peg$currPos++;
                      } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c119);
                        }
                      }
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseECHAR();
                        if (s7 === peg$FAILED) {
                          s7 = peg$parseUCHAR();
                        }
                      }
                    }
                  } else {
                    s6 = peg$FAILED;
                  }
                  if (s6 !== peg$FAILED) {
                    peg$savedPos = s4;
                    s5 = peg$c122(s2, s6);
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
                if (s4 === peg$FAILED) {
                  s4 = peg$currPos;
                  if (input2.charCodeAt(peg$currPos) === 39) {
                    s5 = peg$c112;
                    peg$currPos++;
                  } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c113);
                    }
                  }
                  if (s5 !== peg$FAILED) {
                    s6 = [];
                    if (peg$c118.test(input2.charAt(peg$currPos))) {
                      s7 = input2.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c119);
                      }
                    }
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseECHAR();
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseUCHAR();
                      }
                    }
                    if (s7 !== peg$FAILED) {
                      while (s7 !== peg$FAILED) {
                        s6.push(s7);
                        if (peg$c118.test(input2.charAt(peg$currPos))) {
                          s7 = input2.charAt(peg$currPos);
                          peg$currPos++;
                        } else {
                          s7 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c119);
                          }
                        }
                        if (s7 === peg$FAILED) {
                          s7 = peg$parseECHAR();
                          if (s7 === peg$FAILED) {
                            s7 = peg$parseUCHAR();
                          }
                        }
                      }
                    } else {
                      s6 = peg$FAILED;
                    }
                    if (s6 !== peg$FAILED) {
                      peg$savedPos = s4;
                      s5 = peg$c123(s2, s6);
                      s4 = s5;
                    } else {
                      peg$currPos = s4;
                      s4 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                }
              }
              if (s3 !== peg$FAILED) {
                if (input2.substr(peg$currPos, 3) === peg$c116) {
                  s4 = peg$c116;
                  peg$currPos += 3;
                } else {
                  s4 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c117);
                  }
                }
                if (s4 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c124(s2, s3);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseSTRING_LITERAL_LONG_QUOTE() {
          var s0, s1, s2, s3, s4, s5, s6, s7;
          s0 = peg$currPos;
          if (input2.substr(peg$currPos, 3) === peg$c125) {
            s1 = peg$c125;
            peg$currPos += 3;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c126);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            if (peg$c127.test(input2.charAt(peg$currPos))) {
              s3 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c128);
              }
            }
            if (s3 === peg$FAILED) {
              s3 = peg$parseECHAR();
              if (s3 === peg$FAILED) {
                s3 = peg$parseUCHAR();
              }
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              if (peg$c127.test(input2.charAt(peg$currPos))) {
                s3 = input2.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c128);
                }
              }
              if (s3 === peg$FAILED) {
                s3 = peg$parseECHAR();
                if (s3 === peg$FAILED) {
                  s3 = peg$parseUCHAR();
                }
              }
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$currPos;
              if (input2.substr(peg$currPos, 2) === peg$c129) {
                s5 = peg$c129;
                peg$currPos += 2;
              } else {
                s5 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c130);
                }
              }
              if (s5 !== peg$FAILED) {
                s6 = [];
                if (peg$c127.test(input2.charAt(peg$currPos))) {
                  s7 = input2.charAt(peg$currPos);
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c128);
                  }
                }
                if (s7 === peg$FAILED) {
                  s7 = peg$parseECHAR();
                  if (s7 === peg$FAILED) {
                    s7 = peg$parseUCHAR();
                  }
                }
                if (s7 !== peg$FAILED) {
                  while (s7 !== peg$FAILED) {
                    s6.push(s7);
                    if (peg$c127.test(input2.charAt(peg$currPos))) {
                      s7 = input2.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c128);
                      }
                    }
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseECHAR();
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseUCHAR();
                      }
                    }
                  }
                } else {
                  s6 = peg$FAILED;
                }
                if (s6 !== peg$FAILED) {
                  peg$savedPos = s4;
                  s5 = peg$c131(s2, s6);
                  s4 = s5;
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
              if (s4 === peg$FAILED) {
                s4 = peg$currPos;
                if (input2.charCodeAt(peg$currPos) === 34) {
                  s5 = peg$c108;
                  peg$currPos++;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c109);
                  }
                }
                if (s5 !== peg$FAILED) {
                  s6 = [];
                  if (peg$c127.test(input2.charAt(peg$currPos))) {
                    s7 = input2.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c128);
                    }
                  }
                  if (s7 === peg$FAILED) {
                    s7 = peg$parseECHAR();
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseUCHAR();
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    while (s7 !== peg$FAILED) {
                      s6.push(s7);
                      if (peg$c127.test(input2.charAt(peg$currPos))) {
                        s7 = input2.charAt(peg$currPos);
                        peg$currPos++;
                      } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c128);
                        }
                      }
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseECHAR();
                        if (s7 === peg$FAILED) {
                          s7 = peg$parseUCHAR();
                        }
                      }
                    }
                  } else {
                    s6 = peg$FAILED;
                  }
                  if (s6 !== peg$FAILED) {
                    peg$savedPos = s4;
                    s5 = peg$c132(s2, s6);
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              }
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$currPos;
                if (input2.substr(peg$currPos, 2) === peg$c129) {
                  s5 = peg$c129;
                  peg$currPos += 2;
                } else {
                  s5 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c130);
                  }
                }
                if (s5 !== peg$FAILED) {
                  s6 = [];
                  if (peg$c127.test(input2.charAt(peg$currPos))) {
                    s7 = input2.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c128);
                    }
                  }
                  if (s7 === peg$FAILED) {
                    s7 = peg$parseECHAR();
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseUCHAR();
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    while (s7 !== peg$FAILED) {
                      s6.push(s7);
                      if (peg$c127.test(input2.charAt(peg$currPos))) {
                        s7 = input2.charAt(peg$currPos);
                        peg$currPos++;
                      } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c128);
                        }
                      }
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseECHAR();
                        if (s7 === peg$FAILED) {
                          s7 = peg$parseUCHAR();
                        }
                      }
                    }
                  } else {
                    s6 = peg$FAILED;
                  }
                  if (s6 !== peg$FAILED) {
                    peg$savedPos = s4;
                    s5 = peg$c131(s2, s6);
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
                if (s4 === peg$FAILED) {
                  s4 = peg$currPos;
                  if (input2.charCodeAt(peg$currPos) === 34) {
                    s5 = peg$c108;
                    peg$currPos++;
                  } else {
                    s5 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c109);
                    }
                  }
                  if (s5 !== peg$FAILED) {
                    s6 = [];
                    if (peg$c127.test(input2.charAt(peg$currPos))) {
                      s7 = input2.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c128);
                      }
                    }
                    if (s7 === peg$FAILED) {
                      s7 = peg$parseECHAR();
                      if (s7 === peg$FAILED) {
                        s7 = peg$parseUCHAR();
                      }
                    }
                    if (s7 !== peg$FAILED) {
                      while (s7 !== peg$FAILED) {
                        s6.push(s7);
                        if (peg$c127.test(input2.charAt(peg$currPos))) {
                          s7 = input2.charAt(peg$currPos);
                          peg$currPos++;
                        } else {
                          s7 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c128);
                          }
                        }
                        if (s7 === peg$FAILED) {
                          s7 = peg$parseECHAR();
                          if (s7 === peg$FAILED) {
                            s7 = peg$parseUCHAR();
                          }
                        }
                      }
                    } else {
                      s6 = peg$FAILED;
                    }
                    if (s6 !== peg$FAILED) {
                      peg$savedPos = s4;
                      s5 = peg$c132(s2, s6);
                      s4 = s5;
                    } else {
                      peg$currPos = s4;
                      s4 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                }
              }
              if (s3 !== peg$FAILED) {
                if (input2.substr(peg$currPos, 3) === peg$c125) {
                  s4 = peg$c125;
                  peg$currPos += 3;
                } else {
                  s4 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c126);
                  }
                }
                if (s4 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c124(s2, s3);
                  s0 = s1;
                } else {
                  peg$currPos = s0;
                  s0 = peg$FAILED;
                }
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parseUCHAR() {
          var s0, s1, s2, s3, s4, s5, s6, s7, s8, s9, s10;
          s0 = peg$currPos;
          if (input2.substr(peg$currPos, 2) === peg$c133) {
            s1 = peg$c133;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c134);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$currPos;
            s3 = peg$parseHEX();
            if (s3 !== peg$FAILED) {
              s4 = peg$parseHEX();
              if (s4 !== peg$FAILED) {
                s5 = peg$parseHEX();
                if (s5 !== peg$FAILED) {
                  s6 = peg$parseHEX();
                  if (s6 !== peg$FAILED) {
                    s7 = peg$parseHEX();
                    if (s7 !== peg$FAILED) {
                      s8 = peg$parseHEX();
                      if (s8 !== peg$FAILED) {
                        s9 = peg$parseHEX();
                        if (s9 !== peg$FAILED) {
                          s10 = peg$parseHEX();
                          if (s10 !== peg$FAILED) {
                            s3 = [s3, s4, s5, s6, s7, s8, s9, s10];
                            s2 = s3;
                          } else {
                            peg$currPos = s2;
                            s2 = peg$FAILED;
                          }
                        } else {
                          peg$currPos = s2;
                          s2 = peg$FAILED;
                        }
                      } else {
                        peg$currPos = s2;
                        s2 = peg$FAILED;
                      }
                    } else {
                      peg$currPos = s2;
                      s2 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            } else {
              peg$currPos = s2;
              s2 = peg$FAILED;
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c135(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input2.substr(peg$currPos, 2) === peg$c136) {
              s1 = peg$c136;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c137);
              }
            }
            if (s1 !== peg$FAILED) {
              s2 = peg$currPos;
              s3 = peg$parseHEX();
              if (s3 !== peg$FAILED) {
                s4 = peg$parseHEX();
                if (s4 !== peg$FAILED) {
                  s5 = peg$parseHEX();
                  if (s5 !== peg$FAILED) {
                    s6 = peg$parseHEX();
                    if (s6 !== peg$FAILED) {
                      s3 = [s3, s4, s5, s6];
                      s2 = s3;
                    } else {
                      peg$currPos = s2;
                      s2 = peg$FAILED;
                    }
                  } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
              if (s2 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c138(s2);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          }
          return s0;
        }
        function peg$parseECHAR() {
          var s0, s1;
          s0 = peg$currPos;
          if (input2.substr(peg$currPos, 2) === peg$c139) {
            s1 = peg$c139;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c140);
            }
          }
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$c141();
          }
          s0 = s1;
          if (s0 === peg$FAILED) {
            s0 = peg$currPos;
            if (input2.substr(peg$currPos, 2) === peg$c142) {
              s1 = peg$c142;
              peg$currPos += 2;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c143);
              }
            }
            if (s1 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c144();
            }
            s0 = s1;
            if (s0 === peg$FAILED) {
              s0 = peg$currPos;
              if (input2.substr(peg$currPos, 2) === peg$c145) {
                s1 = peg$c145;
                peg$currPos += 2;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c146);
                }
              }
              if (s1 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c147();
              }
              s0 = s1;
              if (s0 === peg$FAILED) {
                s0 = peg$currPos;
                if (input2.substr(peg$currPos, 2) === peg$c148) {
                  s1 = peg$c148;
                  peg$currPos += 2;
                } else {
                  s1 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c149);
                  }
                }
                if (s1 !== peg$FAILED) {
                  peg$savedPos = s0;
                  s1 = peg$c150();
                }
                s0 = s1;
                if (s0 === peg$FAILED) {
                  s0 = peg$currPos;
                  if (input2.substr(peg$currPos, 2) === peg$c151) {
                    s1 = peg$c151;
                    peg$currPos += 2;
                  } else {
                    s1 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c152);
                    }
                  }
                  if (s1 !== peg$FAILED) {
                    peg$savedPos = s0;
                    s1 = peg$c153();
                  }
                  s0 = s1;
                  if (s0 === peg$FAILED) {
                    s0 = peg$currPos;
                    if (input2.substr(peg$currPos, 2) === peg$c154) {
                      s1 = peg$c154;
                      peg$currPos += 2;
                    } else {
                      s1 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c155);
                      }
                    }
                    if (s1 !== peg$FAILED) {
                      peg$savedPos = s0;
                      s1 = peg$c156();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                      s0 = peg$currPos;
                      if (input2.substr(peg$currPos, 2) === peg$c157) {
                        s1 = peg$c157;
                        peg$currPos += 2;
                      } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c158);
                        }
                      }
                      if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c159();
                      }
                      s0 = s1;
                      if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input2.substr(peg$currPos, 2) === peg$c160) {
                          s1 = peg$c160;
                          peg$currPos += 2;
                        } else {
                          s1 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c161);
                          }
                        }
                        if (s1 !== peg$FAILED) {
                          peg$savedPos = s0;
                          s1 = peg$c162();
                        }
                        s0 = s1;
                      }
                    }
                  }
                }
              }
            }
          }
          return s0;
        }
        function peg$parseWS() {
          var s0;
          if (peg$c163.test(input2.charAt(peg$currPos))) {
            s0 = input2.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c164);
            }
          }
          return s0;
        }
        function peg$parseANON() {
          var s0, s1, s2, s3;
          s0 = peg$currPos;
          if (input2.charCodeAt(peg$currPos) === 91) {
            s1 = peg$c55;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c56);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parseIGNORE();
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parseIGNORE();
            }
            if (s2 !== peg$FAILED) {
              if (input2.charCodeAt(peg$currPos) === 93) {
                s3 = peg$c57;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c58);
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c165();
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsePN_CHARS_BASE() {
          var s0, s1, s2;
          s0 = peg$currPos;
          if (peg$c166.test(input2.charAt(peg$currPos))) {
            s1 = input2.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c167);
            }
          }
          if (s1 !== peg$FAILED) {
            if (peg$c168.test(input2.charAt(peg$currPos))) {
              s2 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c169);
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c170(s1, s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          if (s0 === peg$FAILED) {
            if (peg$c171.test(input2.charAt(peg$currPos))) {
              s0 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s0 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c172);
              }
            }
          }
          return s0;
        }
        function peg$parsePN_CHARS_U() {
          var s0;
          s0 = peg$parsePN_CHARS_BASE();
          if (s0 === peg$FAILED) {
            if (input2.charCodeAt(peg$currPos) === 95) {
              s0 = peg$c173;
              peg$currPos++;
            } else {
              s0 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c174);
              }
            }
          }
          return s0;
        }
        function peg$parsePN_CHARS() {
          var s0;
          s0 = peg$parsePN_CHARS_U();
          if (s0 === peg$FAILED) {
            if (input2.charCodeAt(peg$currPos) === 45) {
              s0 = peg$c95;
              peg$currPos++;
            } else {
              s0 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c96);
              }
            }
            if (s0 === peg$FAILED) {
              if (peg$c89.test(input2.charAt(peg$currPos))) {
                s0 = input2.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s0 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c90);
                }
              }
              if (s0 === peg$FAILED) {
                if (input2.charCodeAt(peg$currPos) === 183) {
                  s0 = peg$c175;
                  peg$currPos++;
                } else {
                  s0 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c176);
                  }
                }
                if (s0 === peg$FAILED) {
                  if (peg$c177.test(input2.charAt(peg$currPos))) {
                    s0 = input2.charAt(peg$currPos);
                    peg$currPos++;
                  } else {
                    s0 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c178);
                    }
                  }
                  if (s0 === peg$FAILED) {
                    if (peg$c179.test(input2.charAt(peg$currPos))) {
                      s0 = input2.charAt(peg$currPos);
                      peg$currPos++;
                    } else {
                      s0 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c180);
                      }
                    }
                  }
                }
              }
            }
          }
          return s0;
        }
        function peg$parsePN_PREFIX() {
          var s0, s1, s2, s3, s4, s5, s6, s7, s8;
          s0 = peg$currPos;
          s1 = peg$currPos;
          s2 = peg$parsePN_CHARS_BASE();
          if (s2 !== peg$FAILED) {
            s3 = [];
            s4 = peg$parsePN_CHARS();
            while (s4 !== peg$FAILED) {
              s3.push(s4);
              s4 = peg$parsePN_CHARS();
            }
            if (s3 !== peg$FAILED) {
              s4 = [];
              s5 = peg$currPos;
              s6 = [];
              if (input2.charCodeAt(peg$currPos) === 46) {
                s7 = peg$c3;
                peg$currPos++;
              } else {
                s7 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c4);
                }
              }
              if (s7 !== peg$FAILED) {
                while (s7 !== peg$FAILED) {
                  s6.push(s7);
                  if (input2.charCodeAt(peg$currPos) === 46) {
                    s7 = peg$c3;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c4);
                    }
                  }
                }
              } else {
                s6 = peg$FAILED;
              }
              if (s6 !== peg$FAILED) {
                s7 = [];
                s8 = peg$parsePN_CHARS();
                if (s8 !== peg$FAILED) {
                  while (s8 !== peg$FAILED) {
                    s7.push(s8);
                    s8 = peg$parsePN_CHARS();
                  }
                } else {
                  s7 = peg$FAILED;
                }
                if (s7 !== peg$FAILED) {
                  s6 = [s6, s7];
                  s5 = s6;
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              } else {
                peg$currPos = s5;
                s5 = peg$FAILED;
              }
              while (s5 !== peg$FAILED) {
                s4.push(s5);
                s5 = peg$currPos;
                s6 = [];
                if (input2.charCodeAt(peg$currPos) === 46) {
                  s7 = peg$c3;
                  peg$currPos++;
                } else {
                  s7 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c4);
                  }
                }
                if (s7 !== peg$FAILED) {
                  while (s7 !== peg$FAILED) {
                    s6.push(s7);
                    if (input2.charCodeAt(peg$currPos) === 46) {
                      s7 = peg$c3;
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c4);
                      }
                    }
                  }
                } else {
                  s6 = peg$FAILED;
                }
                if (s6 !== peg$FAILED) {
                  s7 = [];
                  s8 = peg$parsePN_CHARS();
                  if (s8 !== peg$FAILED) {
                    while (s8 !== peg$FAILED) {
                      s7.push(s8);
                      s8 = peg$parsePN_CHARS();
                    }
                  } else {
                    s7 = peg$FAILED;
                  }
                  if (s7 !== peg$FAILED) {
                    s6 = [s6, s7];
                    s5 = s6;
                  } else {
                    peg$currPos = s5;
                    s5 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s5;
                  s5 = peg$FAILED;
                }
              }
              if (s4 !== peg$FAILED) {
                s2 = [s2, s3, s4];
                s1 = s2;
              } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
              }
            } else {
              peg$currPos = s1;
              s1 = peg$FAILED;
            }
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
          if (s1 !== peg$FAILED) {
            s0 = input2.substring(s0, peg$currPos);
          } else {
            s0 = s1;
          }
          return s0;
        }
        function peg$parsePN_LOCAL() {
          var s0, s1, s2, s3, s4, s5, s6, s7;
          s0 = peg$currPos;
          s1 = peg$parsePN_CHARS_U();
          if (s1 === peg$FAILED) {
            if (input2.charCodeAt(peg$currPos) === 58) {
              s1 = peg$c82;
              peg$currPos++;
            } else {
              s1 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c83);
              }
            }
            if (s1 === peg$FAILED) {
              if (peg$c89.test(input2.charAt(peg$currPos))) {
                s1 = input2.charAt(peg$currPos);
                peg$currPos++;
              } else {
                s1 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c90);
                }
              }
              if (s1 === peg$FAILED) {
                s1 = peg$parsePLX();
              }
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parsePN_CHARS();
            if (s3 === peg$FAILED) {
              if (input2.charCodeAt(peg$currPos) === 58) {
                s3 = peg$c82;
                peg$currPos++;
              } else {
                s3 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c83);
                }
              }
              if (s3 === peg$FAILED) {
                s3 = peg$parsePLX();
              }
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parsePN_CHARS();
              if (s3 === peg$FAILED) {
                if (input2.charCodeAt(peg$currPos) === 58) {
                  s3 = peg$c82;
                  peg$currPos++;
                } else {
                  s3 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c83);
                  }
                }
                if (s3 === peg$FAILED) {
                  s3 = peg$parsePLX();
                }
              }
            }
            if (s2 !== peg$FAILED) {
              s3 = [];
              s4 = peg$currPos;
              s5 = [];
              if (input2.charCodeAt(peg$currPos) === 46) {
                s6 = peg$c3;
                peg$currPos++;
              } else {
                s6 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$c4);
                }
              }
              if (s6 !== peg$FAILED) {
                while (s6 !== peg$FAILED) {
                  s5.push(s6);
                  if (input2.charCodeAt(peg$currPos) === 46) {
                    s6 = peg$c3;
                    peg$currPos++;
                  } else {
                    s6 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c4);
                    }
                  }
                }
              } else {
                s5 = peg$FAILED;
              }
              if (s5 !== peg$FAILED) {
                s6 = [];
                s7 = peg$parsePN_CHARS();
                if (s7 === peg$FAILED) {
                  if (input2.charCodeAt(peg$currPos) === 58) {
                    s7 = peg$c82;
                    peg$currPos++;
                  } else {
                    s7 = peg$FAILED;
                    if (peg$silentFails === 0) {
                      peg$fail(peg$c83);
                    }
                  }
                  if (s7 === peg$FAILED) {
                    s7 = peg$parsePLX();
                  }
                }
                if (s7 !== peg$FAILED) {
                  while (s7 !== peg$FAILED) {
                    s6.push(s7);
                    s7 = peg$parsePN_CHARS();
                    if (s7 === peg$FAILED) {
                      if (input2.charCodeAt(peg$currPos) === 58) {
                        s7 = peg$c82;
                        peg$currPos++;
                      } else {
                        s7 = peg$FAILED;
                        if (peg$silentFails === 0) {
                          peg$fail(peg$c83);
                        }
                      }
                      if (s7 === peg$FAILED) {
                        s7 = peg$parsePLX();
                      }
                    }
                  }
                } else {
                  s6 = peg$FAILED;
                }
                if (s6 !== peg$FAILED) {
                  peg$savedPos = s4;
                  s5 = peg$c181(s1, s2, s5, s6);
                  s4 = s5;
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              } else {
                peg$currPos = s4;
                s4 = peg$FAILED;
              }
              while (s4 !== peg$FAILED) {
                s3.push(s4);
                s4 = peg$currPos;
                s5 = [];
                if (input2.charCodeAt(peg$currPos) === 46) {
                  s6 = peg$c3;
                  peg$currPos++;
                } else {
                  s6 = peg$FAILED;
                  if (peg$silentFails === 0) {
                    peg$fail(peg$c4);
                  }
                }
                if (s6 !== peg$FAILED) {
                  while (s6 !== peg$FAILED) {
                    s5.push(s6);
                    if (input2.charCodeAt(peg$currPos) === 46) {
                      s6 = peg$c3;
                      peg$currPos++;
                    } else {
                      s6 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c4);
                      }
                    }
                  }
                } else {
                  s5 = peg$FAILED;
                }
                if (s5 !== peg$FAILED) {
                  s6 = [];
                  s7 = peg$parsePN_CHARS();
                  if (s7 === peg$FAILED) {
                    if (input2.charCodeAt(peg$currPos) === 58) {
                      s7 = peg$c82;
                      peg$currPos++;
                    } else {
                      s7 = peg$FAILED;
                      if (peg$silentFails === 0) {
                        peg$fail(peg$c83);
                      }
                    }
                    if (s7 === peg$FAILED) {
                      s7 = peg$parsePLX();
                    }
                  }
                  if (s7 !== peg$FAILED) {
                    while (s7 !== peg$FAILED) {
                      s6.push(s7);
                      s7 = peg$parsePN_CHARS();
                      if (s7 === peg$FAILED) {
                        if (input2.charCodeAt(peg$currPos) === 58) {
                          s7 = peg$c82;
                          peg$currPos++;
                        } else {
                          s7 = peg$FAILED;
                          if (peg$silentFails === 0) {
                            peg$fail(peg$c83);
                          }
                        }
                        if (s7 === peg$FAILED) {
                          s7 = peg$parsePLX();
                        }
                      }
                    }
                  } else {
                    s6 = peg$FAILED;
                  }
                  if (s6 !== peg$FAILED) {
                    peg$savedPos = s4;
                    s5 = peg$c181(s1, s2, s5, s6);
                    s4 = s5;
                  } else {
                    peg$currPos = s4;
                    s4 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s4;
                  s4 = peg$FAILED;
                }
              }
              if (s3 !== peg$FAILED) {
                peg$savedPos = s0;
                s1 = peg$c182(s1, s2, s3);
                s0 = s1;
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        function peg$parsePLX() {
          var s0;
          s0 = peg$parsePERCENT();
          if (s0 === peg$FAILED) {
            s0 = peg$parsePN_LOCAL_ESC();
          }
          return s0;
        }
        function peg$parsePERCENT() {
          var s0, s1, s2, s3, s4;
          s0 = peg$currPos;
          s1 = peg$currPos;
          if (input2.charCodeAt(peg$currPos) === 37) {
            s2 = peg$c183;
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c184);
            }
          }
          if (s2 !== peg$FAILED) {
            s3 = peg$parseHEX();
            if (s3 !== peg$FAILED) {
              s4 = peg$parseHEX();
              if (s4 !== peg$FAILED) {
                s2 = [s2, s3, s4];
                s1 = s2;
              } else {
                peg$currPos = s1;
                s1 = peg$FAILED;
              }
            } else {
              peg$currPos = s1;
              s1 = peg$FAILED;
            }
          } else {
            peg$currPos = s1;
            s1 = peg$FAILED;
          }
          if (s1 !== peg$FAILED) {
            s0 = input2.substring(s0, peg$currPos);
          } else {
            s0 = s1;
          }
          return s0;
        }
        function peg$parseHEX() {
          var s0;
          if (peg$c185.test(input2.charAt(peg$currPos))) {
            s0 = input2.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s0 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c186);
            }
          }
          return s0;
        }
        function peg$parsePN_LOCAL_ESC() {
          var s0, s1, s2;
          s0 = peg$currPos;
          if (input2.charCodeAt(peg$currPos) === 92) {
            s1 = peg$c187;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$c188);
            }
          }
          if (s1 !== peg$FAILED) {
            if (peg$c189.test(input2.charAt(peg$currPos))) {
              s2 = input2.charAt(peg$currPos);
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$c190);
              }
            }
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s1 = peg$c5(s2);
              s0 = s1;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
          return s0;
        }
        var isIRI = function(a) {
          return a.match(/^[a-z](.*?):(.+?)/g);
        };
        function createObject(property4, value8) {
          var a = {};
          a[property4] = value8;
          return a;
        }
        var context4 = {
          base: [],
          data: {},
          addBase: function(uri6) {
            if (context4.base.length === 0) {
              context4.base.push(uri6);
              return;
            }
            const last4 = context4.base[context4.base.length - 1];
            if (last4 !== uri6) context4.base.push(new URL(uri6, last4).toString());
          },
          addPrefix: function(prefix3, uri6) {
            const list = context4.data[prefix3];
            if (list === void 0) {
              context4.data[prefix3] = [{ uri: uri6, count: 0 }];
            } else if (list[list.length - 1].uri !== uri6) {
              list.push({ uri: uri6, count: 0 });
            }
          },
          hasPrefix: function(prefix3) {
            return this.data[prefix3] !== void 0;
          },
          resolve: function(pname, force) {
            const prefix3 = Object.keys(context4.data).find((key3) => pname.indexOf(key3 + ":") === 0);
            if (prefix3 !== void 0) {
              const list = context4.data[prefix3];
              if (list.length === 1 && force !== true && isIRI(list[0].uri)) return pname;
              const uri6 = list[list.length - 1].uri;
              return pname.replace(prefix3 + ":", uri6);
            } else {
              var base2 = context4.base.length === 0 ? options.baseIRI : context4.base[context4.base.length - 1];
              if (!base2 || pname.match(/^(http:|https:|urn:|file:)/)) return pname;
              if (pname.indexOf("//") === 0 && base2) return base2.split("//")[0] + pname;
              return new URL(pname, base2).toString();
            }
          },
          increment: function(prefix3) {
            const list = context4.data[prefix3];
            if (list !== void 0) list[list.length - 1].count++;
          },
          decrement: function(prefix3) {
            const list = context4.data[prefix3];
            if (list !== void 0) list[list.length - 1].count--;
          },
          toJSON: function() {
            const root = {};
            if (context4.base.length > 0) {
              if (root["@context"] === void 0) root["@context"] = {};
              root["@context"]["@base"] = context4.base[0];
            }
            Object.keys(context4.data).forEach((key3) => {
              const head = context4.data[key3][0];
              if (head.uri === "http://www.w3.org/2001/XMLSchema#" && head.count < 1) return;
              if (!isIRI(head.uri)) return;
              if (root["@context"] === void 0) root["@context"] = {};
              root["@context"][key3] = head.uri;
            });
            return root;
          }
        };
        function expandList(container2, force) {
          if (container2["@list"] === void 0) return container2;
          if (!force && !container2["@list"].find((x) => x["@list"] !== void 0)) return container2;
          if (container2["@list"].length === 0)
            return { "@id": "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil" };
          var root = {};
          var focus3 = null;
          container2["@list"].forEach((b) => {
            if (focus3 === null) focus3 = root;
            else {
              focus3["http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"] = {};
              focus3 = focus3["http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"];
            }
            focus3["http://www.w3.org/1999/02/22-rdf-syntax-ns#first"] = expandList(b, true);
            focus3["http://www.w3.org/1999/02/22-rdf-syntax-ns#rest"] = {
              "@id": "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
            };
          });
          return root;
        }
        peg$result = peg$startRuleFunction();
        if (peg$result !== peg$FAILED && peg$currPos === input2.length) {
          return peg$result;
        } else {
          if (peg$result !== peg$FAILED && peg$currPos < input2.length) {
            peg$fail(peg$endExpectation());
          }
          throw peg$buildStructuredError(
            peg$maxFailExpected,
            peg$maxFailPos < input2.length ? input2.charAt(peg$maxFailPos) : null,
            peg$maxFailPos < input2.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
          );
        }
      }
      return {
        SyntaxError: peg$SyntaxError,
        parse: peg$parse
      };
    });
  }
});

// ../node_modules/solid-namespace/index.js
var require_solid_namespace = __commonJS({
  "../node_modules/solid-namespace/index.js"(exports, module3) {
    var aliases = {
      acl: "http://www.w3.org/ns/auth/acl#",
      arg: "http://www.w3.org/ns/pim/arg#",
      as: "https://www.w3.org/ns/activitystreams#",
      bookmark: "http://www.w3.org/2002/01/bookmark#",
      cal: "http://www.w3.org/2002/12/cal/ical#",
      cco: "http://www.ontologyrepository.com/CommonCoreOntologies/",
      cert: "http://www.w3.org/ns/auth/cert#",
      contact: "http://www.w3.org/2000/10/swap/pim/contact#",
      dc: "http://purl.org/dc/elements/1.1/",
      dct: "http://purl.org/dc/terms/",
      doap: "http://usefulinc.com/ns/doap#",
      foaf: "http://xmlns.com/foaf/0.1/",
      geo: "http://www.w3.org/2003/01/geo/wgs84_pos#",
      gpx: "http://www.w3.org/ns/pim/gpx#",
      gr: "http://purl.org/goodrelations/v1#",
      http: "http://www.w3.org/2007/ont/http#",
      httph: "http://www.w3.org/2007/ont/httph#",
      icalTZ: "http://www.w3.org/2002/12/cal/icaltzd#",
      // Beware: not cal:
      ldp: "http://www.w3.org/ns/ldp#",
      link: "http://www.w3.org/2007/ont/link#",
      log: "http://www.w3.org/2000/10/swap/log#",
      meeting: "http://www.w3.org/ns/pim/meeting#",
      mo: "http://purl.org/ontology/mo/",
      org: "http://www.w3.org/ns/org#",
      owl: "http://www.w3.org/2002/07/owl#",
      pad: "http://www.w3.org/ns/pim/pad#",
      patch: "http://www.w3.org/ns/pim/patch#",
      prov: "http://www.w3.org/ns/prov#",
      pto: "http://www.productontology.org/id/",
      qu: "http://www.w3.org/2000/10/swap/pim/qif#",
      trip: "http://www.w3.org/ns/pim/trip#",
      rdf: "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
      rdfs: "http://www.w3.org/2000/01/rdf-schema#",
      rss: "http://purl.org/rss/1.0/",
      sched: "http://www.w3.org/ns/pim/schedule#",
      schema: "http://schema.org/",
      // @@ beware confusion with documents no 303
      sioc: "http://rdfs.org/sioc/ns#",
      skos: "http://www.w3.org/2004/02/skos/core#",
      solid: "http://www.w3.org/ns/solid/terms#",
      space: "http://www.w3.org/ns/pim/space#",
      stat: "http://www.w3.org/ns/posix/stat#",
      tab: "http://www.w3.org/2007/ont/link#",
      tabont: "http://www.w3.org/2007/ont/link#",
      ui: "http://www.w3.org/ns/ui#",
      vann: "http://purl.org/vocab/vann/",
      vcard: "http://www.w3.org/2006/vcard/ns#",
      wf: "http://www.w3.org/2005/01/wf/flow#",
      xsd: "http://www.w3.org/2001/XMLSchema#"
    };
    function vocab(rdf5 = { namedNode: (u) => u }) {
      const namespaces = {};
      for (const alias2 in aliases) {
        const expansion2 = aliases[alias2];
        namespaces[alias2] = function(localName = "") {
          return rdf5.namedNode(expansion2 + localName);
        };
      }
      ;
      return namespaces;
    }
    module3.exports = vocab;
  }
});

// node_modules/@xmldom/xmldom/lib/conventions.js
var require_conventions = __commonJS({
  "node_modules/@xmldom/xmldom/lib/conventions.js"(exports) {
    "use strict";
    function find(list, predicate4, ac) {
      if (ac === void 0) {
        ac = Array.prototype;
      }
      if (list && typeof ac.find === "function") {
        return ac.find.call(list, predicate4);
      }
      for (var i = 0; i < list.length; i++) {
        if (hasOwn(list, i)) {
          var item4 = list[i];
          if (predicate4.call(void 0, item4, i, list)) {
            return item4;
          }
        }
      }
    }
    function freeze(object8, oc) {
      if (oc === void 0) {
        oc = Object;
      }
      if (oc && typeof oc.getOwnPropertyDescriptors === "function") {
        object8 = oc.create(null, oc.getOwnPropertyDescriptors(object8));
      }
      return oc && typeof oc.freeze === "function" ? oc.freeze(object8) : object8;
    }
    function hasOwn(object8, key3) {
      return Object.prototype.hasOwnProperty.call(object8, key3);
    }
    function assign(target6, source10) {
      if (target6 === null || typeof target6 !== "object") {
        throw new TypeError("target is not an object");
      }
      for (var key3 in source10) {
        if (hasOwn(source10, key3)) {
          target6[key3] = source10[key3];
        }
      }
      return target6;
    }
    var HTML_BOOLEAN_ATTRIBUTES = freeze({
      allowfullscreen: true,
      async: true,
      autofocus: true,
      autoplay: true,
      checked: true,
      controls: true,
      default: true,
      defer: true,
      disabled: true,
      formnovalidate: true,
      hidden: true,
      ismap: true,
      itemscope: true,
      loop: true,
      multiple: true,
      muted: true,
      nomodule: true,
      novalidate: true,
      open: true,
      playsinline: true,
      readonly: true,
      required: true,
      reversed: true,
      selected: true
    });
    function isHTMLBooleanAttribute(name9) {
      return hasOwn(HTML_BOOLEAN_ATTRIBUTES, name9.toLowerCase());
    }
    var HTML_VOID_ELEMENTS = freeze({
      area: true,
      base: true,
      br: true,
      col: true,
      embed: true,
      hr: true,
      img: true,
      input: true,
      link: true,
      meta: true,
      param: true,
      source: true,
      track: true,
      wbr: true
    });
    function isHTMLVoidElement(tagName) {
      return hasOwn(HTML_VOID_ELEMENTS, tagName.toLowerCase());
    }
    var HTML_RAW_TEXT_ELEMENTS = freeze({
      script: false,
      style: false,
      textarea: true,
      title: true
    });
    function isHTMLRawTextElement(tagName) {
      var key3 = tagName.toLowerCase();
      return hasOwn(HTML_RAW_TEXT_ELEMENTS, key3) && !HTML_RAW_TEXT_ELEMENTS[key3];
    }
    function isHTMLEscapableRawTextElement(tagName) {
      var key3 = tagName.toLowerCase();
      return hasOwn(HTML_RAW_TEXT_ELEMENTS, key3) && HTML_RAW_TEXT_ELEMENTS[key3];
    }
    function isHTMLMimeType(mimeType2) {
      return mimeType2 === MIME_TYPE.HTML;
    }
    function hasDefaultHTMLNamespace(mimeType2) {
      return isHTMLMimeType(mimeType2) || mimeType2 === MIME_TYPE.XML_XHTML_APPLICATION;
    }
    var MIME_TYPE = freeze({
      /**
       * `text/html`, the only mime type that triggers treating an XML document as HTML.
       *
       * @see https://www.iana.org/assignments/media-types/text/html IANA MimeType registration
       * @see https://en.wikipedia.org/wiki/HTML Wikipedia
       * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString MDN
       * @see https://html.spec.whatwg.org/multipage/dynamic-markup-insertion.html#dom-domparser-parsefromstring
       *      WHATWG HTML Spec
       */
      HTML: "text/html",
      /**
       * `application/xml`, the standard mime type for XML documents.
       *
       * @see https://www.iana.org/assignments/media-types/application/xml IANA MimeType
       *      registration
       * @see https://tools.ietf.org/html/rfc7303#section-9.1 RFC 7303
       * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
       */
      XML_APPLICATION: "application/xml",
      /**
       * `text/xml`, an alias for `application/xml`.
       *
       * @see https://tools.ietf.org/html/rfc7303#section-9.2 RFC 7303
       * @see https://www.iana.org/assignments/media-types/text/xml IANA MimeType registration
       * @see https://en.wikipedia.org/wiki/XML_and_MIME Wikipedia
       */
      XML_TEXT: "text/xml",
      /**
       * `application/xhtml+xml`, indicates an XML document that has the default HTML namespace,
       * but is parsed as an XML document.
       *
       * @see https://www.iana.org/assignments/media-types/application/xhtml+xml IANA MimeType
       *      registration
       * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument WHATWG DOM Spec
       * @see https://en.wikipedia.org/wiki/XHTML Wikipedia
       */
      XML_XHTML_APPLICATION: "application/xhtml+xml",
      /**
       * `image/svg+xml`,
       *
       * @see https://www.iana.org/assignments/media-types/image/svg+xml IANA MimeType registration
       * @see https://www.w3.org/TR/SVG11/ W3C SVG 1.1
       * @see https://en.wikipedia.org/wiki/Scalable_Vector_Graphics Wikipedia
       */
      XML_SVG_IMAGE: "image/svg+xml"
    });
    var _MIME_TYPES = Object.keys(MIME_TYPE).map(function(key3) {
      return MIME_TYPE[key3];
    });
    function isValidMimeType(mimeType2) {
      return _MIME_TYPES.indexOf(mimeType2) > -1;
    }
    var NAMESPACE = freeze({
      /**
       * The XHTML namespace.
       *
       * @see http://www.w3.org/1999/xhtml
       */
      HTML: "http://www.w3.org/1999/xhtml",
      /**
       * The SVG namespace.
       *
       * @see http://www.w3.org/2000/svg
       */
      SVG: "http://www.w3.org/2000/svg",
      /**
       * The `xml:` namespace.
       *
       * @see http://www.w3.org/XML/1998/namespace
       */
      XML: "http://www.w3.org/XML/1998/namespace",
      /**
       * The `xmlns:` namespace.
       *
       * @see https://www.w3.org/2000/xmlns/
       */
      XMLNS: "http://www.w3.org/2000/xmlns/"
    });
    exports.assign = assign;
    exports.find = find;
    exports.freeze = freeze;
    exports.HTML_BOOLEAN_ATTRIBUTES = HTML_BOOLEAN_ATTRIBUTES;
    exports.HTML_RAW_TEXT_ELEMENTS = HTML_RAW_TEXT_ELEMENTS;
    exports.HTML_VOID_ELEMENTS = HTML_VOID_ELEMENTS;
    exports.hasDefaultHTMLNamespace = hasDefaultHTMLNamespace;
    exports.hasOwn = hasOwn;
    exports.isHTMLBooleanAttribute = isHTMLBooleanAttribute;
    exports.isHTMLRawTextElement = isHTMLRawTextElement;
    exports.isHTMLEscapableRawTextElement = isHTMLEscapableRawTextElement;
    exports.isHTMLMimeType = isHTMLMimeType;
    exports.isHTMLVoidElement = isHTMLVoidElement;
    exports.isValidMimeType = isValidMimeType;
    exports.MIME_TYPE = MIME_TYPE;
    exports.NAMESPACE = NAMESPACE;
  }
});

// node_modules/@xmldom/xmldom/lib/errors.js
var require_errors = __commonJS({
  "node_modules/@xmldom/xmldom/lib/errors.js"(exports) {
    "use strict";
    var conventions = require_conventions();
    function extendError(constructor, writableName) {
      constructor.prototype = Object.create(Error.prototype, {
        constructor: { value: constructor },
        name: { value: constructor.name, enumerable: true, writable: writableName }
      });
    }
    var DOMExceptionName = conventions.freeze({
      /**
       * the default value as defined by the spec
       */
      Error: "Error",
      /**
       * @deprecated
       * Use RangeError instead.
       */
      IndexSizeError: "IndexSizeError",
      /**
       * @deprecated
       * Just to match the related static code, not part of the spec.
       */
      DomstringSizeError: "DomstringSizeError",
      HierarchyRequestError: "HierarchyRequestError",
      WrongDocumentError: "WrongDocumentError",
      InvalidCharacterError: "InvalidCharacterError",
      /**
       * @deprecated
       * Just to match the related static code, not part of the spec.
       */
      NoDataAllowedError: "NoDataAllowedError",
      NoModificationAllowedError: "NoModificationAllowedError",
      NotFoundError: "NotFoundError",
      NotSupportedError: "NotSupportedError",
      InUseAttributeError: "InUseAttributeError",
      InvalidStateError: "InvalidStateError",
      SyntaxError: "SyntaxError",
      InvalidModificationError: "InvalidModificationError",
      NamespaceError: "NamespaceError",
      /**
       * @deprecated
       * Use TypeError for invalid arguments,
       * "NotSupportedError" DOMException for unsupported operations,
       * and "NotAllowedError" DOMException for denied requests instead.
       */
      InvalidAccessError: "InvalidAccessError",
      /**
       * @deprecated
       * Just to match the related static code, not part of the spec.
       */
      ValidationError: "ValidationError",
      /**
       * @deprecated
       * Use TypeError instead.
       */
      TypeMismatchError: "TypeMismatchError",
      SecurityError: "SecurityError",
      NetworkError: "NetworkError",
      AbortError: "AbortError",
      /**
       * @deprecated
       * Just to match the related static code, not part of the spec.
       */
      URLMismatchError: "URLMismatchError",
      QuotaExceededError: "QuotaExceededError",
      TimeoutError: "TimeoutError",
      InvalidNodeTypeError: "InvalidNodeTypeError",
      DataCloneError: "DataCloneError",
      EncodingError: "EncodingError",
      NotReadableError: "NotReadableError",
      UnknownError: "UnknownError",
      ConstraintError: "ConstraintError",
      DataError: "DataError",
      TransactionInactiveError: "TransactionInactiveError",
      ReadOnlyError: "ReadOnlyError",
      VersionError: "VersionError",
      OperationError: "OperationError",
      NotAllowedError: "NotAllowedError",
      OptOutError: "OptOutError"
    });
    var DOMExceptionNames = Object.keys(DOMExceptionName);
    function isValidDomExceptionCode(value8) {
      return typeof value8 === "number" && value8 >= 1 && value8 <= 25;
    }
    function endsWithError(value8) {
      return typeof value8 === "string" && value8.substring(value8.length - DOMExceptionName.Error.length) === DOMExceptionName.Error;
    }
    function DOMException(messageOrCode, nameOrMessage) {
      if (isValidDomExceptionCode(messageOrCode)) {
        this.name = DOMExceptionNames[messageOrCode];
        this.message = nameOrMessage || "";
      } else {
        this.message = messageOrCode;
        this.name = endsWithError(nameOrMessage) ? nameOrMessage : DOMExceptionName.Error;
      }
      if (Error.captureStackTrace) Error.captureStackTrace(this, DOMException);
    }
    extendError(DOMException, true);
    Object.defineProperties(DOMException.prototype, {
      code: {
        enumerable: true,
        get: function() {
          var code5 = DOMExceptionNames.indexOf(this.name);
          if (isValidDomExceptionCode(code5)) return code5;
          return 0;
        }
      }
    });
    var ExceptionCode = {
      INDEX_SIZE_ERR: 1,
      DOMSTRING_SIZE_ERR: 2,
      HIERARCHY_REQUEST_ERR: 3,
      WRONG_DOCUMENT_ERR: 4,
      INVALID_CHARACTER_ERR: 5,
      NO_DATA_ALLOWED_ERR: 6,
      NO_MODIFICATION_ALLOWED_ERR: 7,
      NOT_FOUND_ERR: 8,
      NOT_SUPPORTED_ERR: 9,
      INUSE_ATTRIBUTE_ERR: 10,
      INVALID_STATE_ERR: 11,
      SYNTAX_ERR: 12,
      INVALID_MODIFICATION_ERR: 13,
      NAMESPACE_ERR: 14,
      INVALID_ACCESS_ERR: 15,
      VALIDATION_ERR: 16,
      TYPE_MISMATCH_ERR: 17,
      SECURITY_ERR: 18,
      NETWORK_ERR: 19,
      ABORT_ERR: 20,
      URL_MISMATCH_ERR: 21,
      QUOTA_EXCEEDED_ERR: 22,
      TIMEOUT_ERR: 23,
      INVALID_NODE_TYPE_ERR: 24,
      DATA_CLONE_ERR: 25
    };
    var entries = Object.entries(ExceptionCode);
    for (i = 0; i < entries.length; i++) {
      key3 = entries[i][0];
      DOMException[key3] = entries[i][1];
    }
    var key3;
    var i;
    function ParseError(message4, locator) {
      this.message = message4;
      this.locator = locator;
      if (Error.captureStackTrace) Error.captureStackTrace(this, ParseError);
    }
    extendError(ParseError);
    exports.DOMException = DOMException;
    exports.DOMExceptionName = DOMExceptionName;
    exports.ExceptionCode = ExceptionCode;
    exports.ParseError = ParseError;
  }
});

// node_modules/@xmldom/xmldom/lib/grammar.js
var require_grammar = __commonJS({
  "node_modules/@xmldom/xmldom/lib/grammar.js"(exports) {
    "use strict";
    function detectUnicodeSupport(RegExpImpl) {
      try {
        if (typeof RegExpImpl !== "function") {
          RegExpImpl = RegExp;
        }
        var match = new RegExpImpl("\u{1D306}", "u").exec("\u{1D306}");
        return !!match && match[0].length === 2;
      } catch (error4) {
      }
      return false;
    }
    var UNICODE_SUPPORT = detectUnicodeSupport();
    function chars(regexp) {
      if (regexp.source[0] !== "[") {
        throw new Error(regexp + " can not be used with chars");
      }
      return regexp.source.slice(1, regexp.source.lastIndexOf("]"));
    }
    function chars_without(regexp, search3) {
      if (regexp.source[0] !== "[") {
        throw new Error("/" + regexp.source + "/ can not be used with chars_without");
      }
      if (!search3 || typeof search3 !== "string") {
        throw new Error(JSON.stringify(search3) + " is not a valid search");
      }
      if (regexp.source.indexOf(search3) === -1) {
        throw new Error('"' + search3 + '" is not is /' + regexp.source + "/");
      }
      if (search3 === "-" && regexp.source.indexOf(search3) !== 1) {
        throw new Error('"' + search3 + '" is not at the first postion of /' + regexp.source + "/");
      }
      return new RegExp(regexp.source.replace(search3, ""), UNICODE_SUPPORT ? "u" : "");
    }
    function reg(args) {
      var self2 = this;
      return new RegExp(
        Array.prototype.slice.call(arguments).map(function(part3) {
          var isStr = typeof part3 === "string";
          if (isStr && self2 === void 0 && part3 === "|") {
            throw new Error("use regg instead of reg to wrap expressions with `|`!");
          }
          return isStr ? part3 : part3.source;
        }).join(""),
        UNICODE_SUPPORT ? "mu" : "m"
      );
    }
    function regg(args) {
      if (arguments.length === 0) {
        throw new Error("no parameters provided");
      }
      return reg.apply(regg, ["(?:"].concat(Array.prototype.slice.call(arguments), [")"]));
    }
    var UNICODE_REPLACEMENT_CHARACTER = "\uFFFD";
    var Char = /[-\x09\x0A\x0D\x20-\x2C\x2E-\uD7FF\uE000-\uFFFD]/;
    if (UNICODE_SUPPORT) {
      Char = reg("[", chars(Char), "\\u{10000}-\\u{10FFFF}", "]");
    }
    var InvalidChar = new RegExp("[^" + chars(Char) + "]", UNICODE_SUPPORT ? "u" : "");
    var _SChar = /[\x20\x09\x0D\x0A]/;
    var SChar_s = chars(_SChar);
    var S = reg(_SChar, "+");
    var S_OPT = reg(_SChar, "*");
    var NameStartChar = /[:_a-zA-Z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD]/;
    if (UNICODE_SUPPORT) {
      NameStartChar = reg("[", chars(NameStartChar), "\\u{10000}-\\u{10FFFF}", "]");
    }
    var NameStartChar_s = chars(NameStartChar);
    var NameChar = reg("[", NameStartChar_s, chars(/[-.0-9\xB7]/), chars(/[\u0300-\u036F\u203F-\u2040]/), "]");
    var Name3 = reg(NameStartChar, NameChar, "*");
    var Nmtoken = reg(NameChar, "+");
    var EntityRef = reg("&", Name3, ";");
    var CharRef = regg(/&#[0-9]+;|&#x[0-9a-fA-F]+;/);
    var Reference2 = regg(EntityRef, "|", CharRef);
    var PEReference = reg("%", Name3, ";");
    var EntityValue = regg(
      reg('"', regg(/[^%&"]/, "|", PEReference, "|", Reference2), "*", '"'),
      "|",
      reg("'", regg(/[^%&']/, "|", PEReference, "|", Reference2), "*", "'")
    );
    var AttValue = regg('"', regg(/[^<&"]/, "|", Reference2), "*", '"', "|", "'", regg(/[^<&']/, "|", Reference2), "*", "'");
    var NCNameStartChar = chars_without(NameStartChar, ":");
    var NCNameChar = chars_without(NameChar, ":");
    var NCName2 = reg(NCNameStartChar, NCNameChar, "*");
    var QName2 = reg(NCName2, regg(":", NCName2), "?");
    var QName_exact = reg("^", QName2, "$");
    var QName_group = reg("(", QName2, ")");
    var SystemLiteral = regg(/"[^"]*"|'[^']*'/);
    var PI = reg(/^<\?/, "(", Name3, ")", regg(S, "(", Char, "*?)"), "?", /\?>/);
    var PubidChar = /[\x20\x0D\x0Aa-zA-Z0-9-'()+,./:=?;!*#@$_%]/;
    var PubidLiteral = regg('"', PubidChar, '*"', "|", "'", chars_without(PubidChar, "'"), "*'");
    var COMMENT_START = "<!--";
    var COMMENT_END = "-->";
    var Comment3 = reg(COMMENT_START, regg(chars_without(Char, "-"), "|", reg("-", chars_without(Char, "-"))), "*", COMMENT_END);
    var PCDATA = "#PCDATA";
    var Mixed = regg(
      reg(/\(/, S_OPT, PCDATA, regg(S_OPT, /\|/, S_OPT, QName2), "*", S_OPT, /\)\*/),
      "|",
      reg(/\(/, S_OPT, PCDATA, S_OPT, /\)/)
    );
    var _children_quantity = /[?*+]?/;
    var children3 = reg(
      /\([^>]+\)/,
      _children_quantity
      /*regg(choice, '|', seq), _children_quantity*/
    );
    var contentspec = regg("EMPTY", "|", "ANY", "|", Mixed, "|", children3);
    var ELEMENTDECL_START = "<!ELEMENT";
    var elementdecl = reg(ELEMENTDECL_START, S, regg(QName2, "|", PEReference), S, regg(contentspec, "|", PEReference), S_OPT, ">");
    var NotationType = reg("NOTATION", S, /\(/, S_OPT, Name3, regg(S_OPT, /\|/, S_OPT, Name3), "*", S_OPT, /\)/);
    var Enumeration3 = reg(/\(/, S_OPT, Nmtoken, regg(S_OPT, /\|/, S_OPT, Nmtoken), "*", S_OPT, /\)/);
    var EnumeratedType = regg(NotationType, "|", Enumeration3);
    var AttType = regg(/CDATA|ID|IDREF|IDREFS|ENTITY|ENTITIES|NMTOKEN|NMTOKENS/, "|", EnumeratedType);
    var DefaultDecl = regg(/#REQUIRED|#IMPLIED/, "|", regg(regg("#FIXED", S), "?", AttValue));
    var AttDef = regg(S, Name3, S, AttType, S, DefaultDecl);
    var ATTLIST_DECL_START = "<!ATTLIST";
    var AttlistDecl = reg(ATTLIST_DECL_START, S, Name3, AttDef, "*", S_OPT, ">");
    var ABOUT_LEGACY_COMPAT = "about:legacy-compat";
    var ABOUT_LEGACY_COMPAT_SystemLiteral = regg('"' + ABOUT_LEGACY_COMPAT + '"', "|", "'" + ABOUT_LEGACY_COMPAT + "'");
    var SYSTEM = "SYSTEM";
    var PUBLIC = "PUBLIC";
    var ExternalID = regg(regg(SYSTEM, S, SystemLiteral), "|", regg(PUBLIC, S, PubidLiteral, S, SystemLiteral));
    var ExternalID_match = reg(
      "^",
      regg(
        regg(SYSTEM, S, "(?<SystemLiteralOnly>", SystemLiteral, ")"),
        "|",
        regg(PUBLIC, S, "(?<PubidLiteral>", PubidLiteral, ")", S, "(?<SystemLiteral>", SystemLiteral, ")")
      )
    );
    var PubidLiteral_match = reg("^", PubidLiteral, "$");
    var SystemLiteral_match = reg("^", SystemLiteral, "$");
    var NDataDecl = regg(S, "NDATA", S, Name3);
    var EntityDef = regg(EntityValue, "|", regg(ExternalID, NDataDecl, "?"));
    var ENTITY_DECL_START = "<!ENTITY";
    var GEDecl = reg(ENTITY_DECL_START, S, Name3, S, EntityDef, S_OPT, ">");
    var PEDef = regg(EntityValue, "|", ExternalID);
    var PEDecl = reg(ENTITY_DECL_START, S, "%", S, Name3, S, PEDef, S_OPT, ">");
    var EntityDecl = regg(GEDecl, "|", PEDecl);
    var PublicID = reg(PUBLIC, S, PubidLiteral);
    var NotationDecl = reg("<!NOTATION", S, Name3, S, regg(ExternalID, "|", PublicID), S_OPT, ">");
    var Eq = reg(S_OPT, "=", S_OPT);
    var VersionNum = /1[.]\d+/;
    var VersionInfo = reg(S, "version", Eq, regg("'", VersionNum, "'", "|", '"', VersionNum, '"'));
    var EncName = /[A-Za-z][-A-Za-z0-9._]*/;
    var EncodingDecl = regg(S, "encoding", Eq, regg('"', EncName, '"', "|", "'", EncName, "'"));
    var SDDecl = regg(S, "standalone", Eq, regg("'", regg("yes", "|", "no"), "'", "|", '"', regg("yes", "|", "no"), '"'));
    var XMLDecl = reg(/^<\?xml/, VersionInfo, EncodingDecl, "?", SDDecl, "?", S_OPT, /\?>/);
    var DOCTYPE_DECL_START = "<!DOCTYPE";
    var CDATA_START = "<![CDATA[";
    var CDATA_END = "]]>";
    var CDStart = /<!\[CDATA\[/;
    var CDEnd = /\]\]>/;
    var CData = reg(Char, "*?", CDEnd);
    var CDSect = reg(CDStart, CData);
    exports.chars = chars;
    exports.chars_without = chars_without;
    exports.detectUnicodeSupport = detectUnicodeSupport;
    exports.reg = reg;
    exports.regg = regg;
    exports.ABOUT_LEGACY_COMPAT = ABOUT_LEGACY_COMPAT;
    exports.ABOUT_LEGACY_COMPAT_SystemLiteral = ABOUT_LEGACY_COMPAT_SystemLiteral;
    exports.AttlistDecl = AttlistDecl;
    exports.CDATA_START = CDATA_START;
    exports.CDATA_END = CDATA_END;
    exports.CDSect = CDSect;
    exports.Char = Char;
    exports.Comment = Comment3;
    exports.COMMENT_START = COMMENT_START;
    exports.COMMENT_END = COMMENT_END;
    exports.DOCTYPE_DECL_START = DOCTYPE_DECL_START;
    exports.elementdecl = elementdecl;
    exports.EntityDecl = EntityDecl;
    exports.EntityValue = EntityValue;
    exports.ExternalID = ExternalID;
    exports.ExternalID_match = ExternalID_match;
    exports.Name = Name3;
    exports.NotationDecl = NotationDecl;
    exports.Reference = Reference2;
    exports.PEReference = PEReference;
    exports.PI = PI;
    exports.PUBLIC = PUBLIC;
    exports.PubidLiteral = PubidLiteral;
    exports.PubidLiteral_match = PubidLiteral_match;
    exports.QName = QName2;
    exports.QName_exact = QName_exact;
    exports.QName_group = QName_group;
    exports.S = S;
    exports.SChar_s = SChar_s;
    exports.S_OPT = S_OPT;
    exports.SYSTEM = SYSTEM;
    exports.SystemLiteral = SystemLiteral;
    exports.SystemLiteral_match = SystemLiteral_match;
    exports.InvalidChar = InvalidChar;
    exports.UNICODE_REPLACEMENT_CHARACTER = UNICODE_REPLACEMENT_CHARACTER;
    exports.UNICODE_SUPPORT = UNICODE_SUPPORT;
    exports.XMLDecl = XMLDecl;
  }
});

// node_modules/@xmldom/xmldom/lib/dom.js
var require_dom = __commonJS({
  "node_modules/@xmldom/xmldom/lib/dom.js"(exports) {
    "use strict";
    var conventions = require_conventions();
    var find = conventions.find;
    var hasDefaultHTMLNamespace = conventions.hasDefaultHTMLNamespace;
    var hasOwn = conventions.hasOwn;
    var isHTMLMimeType = conventions.isHTMLMimeType;
    var isHTMLRawTextElement = conventions.isHTMLRawTextElement;
    var isHTMLVoidElement = conventions.isHTMLVoidElement;
    var MIME_TYPE = conventions.MIME_TYPE;
    var NAMESPACE = conventions.NAMESPACE;
    var PDC = /* @__PURE__ */ Symbol();
    var errors = require_errors();
    var DOMException = errors.DOMException;
    var DOMExceptionName = errors.DOMExceptionName;
    var g = require_grammar();
    function checkSymbol(symbol) {
      if (symbol !== PDC) {
        throw new TypeError("Illegal constructor");
      }
    }
    function notEmptyString(input2) {
      return input2 !== "";
    }
    function splitOnASCIIWhitespace(input2) {
      return input2 ? input2.split(/[\t\n\f\r ]+/).filter(notEmptyString) : [];
    }
    function orderedSetReducer(current3, element2) {
      if (!hasOwn(current3, element2)) {
        current3[element2] = true;
      }
      return current3;
    }
    function toOrderedSet(input2) {
      if (!input2) return [];
      var list = splitOnASCIIWhitespace(input2);
      return Object.keys(list.reduce(orderedSetReducer, {}));
    }
    function arrayIncludes(list) {
      return function(element2) {
        return list && list.indexOf(element2) !== -1;
      };
    }
    function validateQualifiedName(qualifiedName) {
      if (!g.QName_exact.test(qualifiedName)) {
        throw new DOMException(DOMException.INVALID_CHARACTER_ERR, 'invalid character in qualified name "' + qualifiedName + '"');
      }
    }
    function validateAndExtract(namespace2, qualifiedName) {
      validateQualifiedName(qualifiedName);
      namespace2 = namespace2 || null;
      var prefix3 = null;
      var localName = qualifiedName;
      if (qualifiedName.indexOf(":") >= 0) {
        var splitResult = qualifiedName.split(":");
        prefix3 = splitResult[0];
        localName = splitResult[1];
      }
      if (prefix3 !== null && namespace2 === null) {
        throw new DOMException(DOMException.NAMESPACE_ERR, "prefix is non-null and namespace is null");
      }
      if (prefix3 === "xml" && namespace2 !== conventions.NAMESPACE.XML) {
        throw new DOMException(DOMException.NAMESPACE_ERR, 'prefix is "xml" and namespace is not the XML namespace');
      }
      if ((prefix3 === "xmlns" || qualifiedName === "xmlns") && namespace2 !== conventions.NAMESPACE.XMLNS) {
        throw new DOMException(
          DOMException.NAMESPACE_ERR,
          'either qualifiedName or prefix is "xmlns" and namespace is not the XMLNS namespace'
        );
      }
      if (namespace2 === conventions.NAMESPACE.XMLNS && prefix3 !== "xmlns" && qualifiedName !== "xmlns") {
        throw new DOMException(
          DOMException.NAMESPACE_ERR,
          'namespace is the XMLNS namespace and neither qualifiedName nor prefix is "xmlns"'
        );
      }
      return [namespace2, prefix3, localName];
    }
    function copy(src, dest) {
      for (var p in src) {
        if (hasOwn(src, p)) {
          dest[p] = src[p];
        }
      }
    }
    function _extends2(Class7, Super) {
      var pt = Class7.prototype;
      if (!(pt instanceof Super)) {
        let t = function() {
        };
        t.prototype = Super.prototype;
        t = new t();
        copy(pt, t);
        Class7.prototype = pt = t;
      }
      if (pt.constructor != Class7) {
        if (typeof Class7 != "function") {
          console.error("unknown Class:" + Class7);
        }
        pt.constructor = Class7;
      }
    }
    var NodeType = {};
    var ELEMENT_NODE = NodeType.ELEMENT_NODE = 1;
    var ATTRIBUTE_NODE = NodeType.ATTRIBUTE_NODE = 2;
    var TEXT_NODE = NodeType.TEXT_NODE = 3;
    var CDATA_SECTION_NODE = NodeType.CDATA_SECTION_NODE = 4;
    var ENTITY_REFERENCE_NODE = NodeType.ENTITY_REFERENCE_NODE = 5;
    var ENTITY_NODE = NodeType.ENTITY_NODE = 6;
    var PROCESSING_INSTRUCTION_NODE = NodeType.PROCESSING_INSTRUCTION_NODE = 7;
    var COMMENT_NODE = NodeType.COMMENT_NODE = 8;
    var DOCUMENT_NODE = NodeType.DOCUMENT_NODE = 9;
    var DOCUMENT_TYPE_NODE = NodeType.DOCUMENT_TYPE_NODE = 10;
    var DOCUMENT_FRAGMENT_NODE = NodeType.DOCUMENT_FRAGMENT_NODE = 11;
    var NOTATION_NODE = NodeType.NOTATION_NODE = 12;
    var DocumentPosition = conventions.freeze({
      DOCUMENT_POSITION_DISCONNECTED: 1,
      DOCUMENT_POSITION_PRECEDING: 2,
      DOCUMENT_POSITION_FOLLOWING: 4,
      DOCUMENT_POSITION_CONTAINS: 8,
      DOCUMENT_POSITION_CONTAINED_BY: 16,
      DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC: 32
    });
    function commonAncestor(a, b) {
      if (b.length < a.length) return commonAncestor(b, a);
      var c = null;
      for (var n3 in a) {
        if (a[n3] !== b[n3]) return c;
        c = a[n3];
      }
      return c;
    }
    function docGUID(doc) {
      if (!doc.guid) doc.guid = Math.random();
      return doc.guid;
    }
    function NodeList() {
    }
    NodeList.prototype = {
      /**
       * The number of nodes in the list. The range of valid child node indices is 0 to length-1
       * inclusive.
       *
       * @type {number}
       */
      length: 0,
      /**
       * Returns the item at `index`. If index is greater than or equal to the number of nodes in
       * the list, this returns null.
       *
       * @param index
       * Unsigned long Index into the collection.
       * @returns {Node | null}
       * The node at position `index` in the NodeList,
       * or null if that is not a valid index.
       */
      item: function(index2) {
        return index2 >= 0 && index2 < this.length ? this[index2] : null;
      },
      /**
       * Returns a string representation of the NodeList.
       *
       * Accepts the same `options` object as `XMLSerializer.prototype.serializeToString`
       * (`requireWellFormed`, `splitCDATASections`, `nodeFilter`). Passing a function is treated as
       * a legacy `nodeFilter` for backward compatibility.
       *
       * @param {Object | function} [options]
       * @param {boolean} [options.requireWellFormed=false]
       * @param {boolean} [options.splitCDATASections=true]
       * @param {function} [options.nodeFilter]
       * @returns {string}
       */
      toString: function(options) {
        var opts;
        if (typeof options === "function") {
          opts = { requireWellFormed: false, splitCDATASections: true, nodeFilter: options };
        } else if (!!options) {
          opts = {
            requireWellFormed: !!options.requireWellFormed,
            splitCDATASections: options.splitCDATASections !== false,
            nodeFilter: options.nodeFilter || null
          };
        } else {
          opts = { requireWellFormed: false, splitCDATASections: true, nodeFilter: null };
        }
        for (var buf = [], i = 0; i < this.length; i++) {
          serializeToString(this[i], buf, null, opts);
        }
        return buf.join("");
      },
      /**
       * Filters the NodeList based on a predicate.
       *
       * @param {function(Node): boolean} predicate
       * - A predicate function to filter the NodeList.
       * @returns {Node[]}
       * An array of nodes that satisfy the predicate.
       * @private
       */
      filter: function(predicate4) {
        return Array.prototype.filter.call(this, predicate4);
      },
      /**
       * Returns the first index at which a given node can be found in the NodeList, or -1 if it is
       * not present.
       *
       * @param {Node} item
       * - The Node item to locate in the NodeList.
       * @returns {number}
       * The first index of the node in the NodeList; -1 if not found.
       * @private
       */
      indexOf: function(item4) {
        return Array.prototype.indexOf.call(this, item4);
      }
    };
    NodeList.prototype[Symbol.iterator] = function() {
      var me = this;
      var index2 = 0;
      return {
        next: function() {
          if (index2 < me.length) {
            return {
              value: me[index2++],
              done: false
            };
          } else {
            return {
              done: true
            };
          }
        },
        return: function() {
          return {
            done: true
          };
        }
      };
    };
    function LiveNodeList(node3, refresh) {
      this._node = node3;
      this._refresh = refresh;
      _updateLiveList(this);
    }
    function _updateLiveList(list) {
      var inc = list._node._inc || list._node.ownerDocument._inc;
      if (list._inc !== inc) {
        var ls = list._refresh(list._node);
        __set__(list, "length", ls.length);
        if (!list.$$length || ls.length < list.$$length) {
          for (var i = ls.length; i in list; i++) {
            if (hasOwn(list, i)) {
              delete list[i];
            }
          }
        }
        copy(ls, list);
        list._inc = inc;
      }
    }
    LiveNodeList.prototype.item = function(i) {
      _updateLiveList(this);
      return this[i] || null;
    };
    _extends2(LiveNodeList, NodeList);
    function NamedNodeMap() {
    }
    function _findNodeIndex(list, node3) {
      var i = 0;
      while (i < list.length) {
        if (list[i] === node3) {
          return i;
        }
        i++;
      }
    }
    function _addNamedNode(el, list, newAttr, oldAttr) {
      if (oldAttr) {
        list[_findNodeIndex(list, oldAttr)] = newAttr;
      } else {
        list[list.length] = newAttr;
        list.length++;
      }
      if (el) {
        newAttr.ownerElement = el;
        var doc = el.ownerDocument;
        if (doc) {
          oldAttr && _onRemoveAttribute(doc, el, oldAttr);
          _onAddAttribute(doc, el, newAttr);
        }
      }
    }
    function _removeNamedNode(el, list, attr) {
      var i = _findNodeIndex(list, attr);
      if (i >= 0) {
        var lastIndex = list.length - 1;
        while (i <= lastIndex) {
          list[i] = list[++i];
        }
        list.length = lastIndex;
        if (el) {
          var doc = el.ownerDocument;
          if (doc) {
            _onRemoveAttribute(doc, el, attr);
          }
          attr.ownerElement = null;
        }
      }
    }
    NamedNodeMap.prototype = {
      length: 0,
      item: NodeList.prototype.item,
      /**
       * Get an attribute by name. Note: Name is in lower case in case of HTML namespace and
       * document.
       *
       * @param {string} localName
       * The local name of the attribute.
       * @returns {Attr | null}
       * The attribute with the given local name, or null if no such attribute exists.
       * @see https://dom.spec.whatwg.org/#concept-element-attributes-get-by-name
       */
      getNamedItem: function(localName) {
        if (this._ownerElement && this._ownerElement._isInHTMLDocumentAndNamespace()) {
          localName = localName.toLowerCase();
        }
        var i = 0;
        while (i < this.length) {
          var attr = this[i];
          if (attr.nodeName === localName) {
            return attr;
          }
          i++;
        }
        return null;
      },
      /**
       * Set an attribute.
       *
       * @param {Attr} attr
       * The attribute to set.
       * @returns {Attr | null}
       * The old attribute with the same local name and namespace URI as the new one, or null if no
       * such attribute exists.
       * @throws {DOMException}
       * With code:
       * - {@link INUSE_ATTRIBUTE_ERR} - If the attribute is already an attribute of another
       * element.
       * @see https://dom.spec.whatwg.org/#concept-element-attributes-set
       */
      setNamedItem: function(attr) {
        var el = attr.ownerElement;
        if (el && el !== this._ownerElement) {
          throw new DOMException(DOMException.INUSE_ATTRIBUTE_ERR);
        }
        var oldAttr = this.getNamedItemNS(attr.namespaceURI, attr.localName);
        if (oldAttr === attr) {
          return attr;
        }
        _addNamedNode(this._ownerElement, this, attr, oldAttr);
        return oldAttr;
      },
      /**
       * Set an attribute, replacing an existing attribute with the same local name and namespace
       * URI if one exists.
       *
       * @param {Attr} attr
       * The attribute to set.
       * @returns {Attr | null}
       * The old attribute with the same local name and namespace URI as the new one, or null if no
       * such attribute exists.
       * @throws {DOMException}
       * Throws a DOMException with the name "InUseAttributeError" if the attribute is already an
       * attribute of another element.
       * @see https://dom.spec.whatwg.org/#concept-element-attributes-set
       */
      setNamedItemNS: function(attr) {
        return this.setNamedItem(attr);
      },
      /**
       * Removes an attribute specified by the local name.
       *
       * @param {string} localName
       * The local name of the attribute to be removed.
       * @returns {Attr}
       * The attribute node that was removed.
       * @throws {DOMException}
       * With code:
       * - {@link DOMException.NOT_FOUND_ERR} if no attribute with the given name is found.
       * @see https://dom.spec.whatwg.org/#dom-namednodemap-removenameditem
       * @see https://dom.spec.whatwg.org/#concept-element-attributes-remove-by-name
       */
      removeNamedItem: function(localName) {
        var attr = this.getNamedItem(localName);
        if (!attr) {
          throw new DOMException(DOMException.NOT_FOUND_ERR, localName);
        }
        _removeNamedNode(this._ownerElement, this, attr);
        return attr;
      },
      /**
       * Removes an attribute specified by the namespace and local name.
       *
       * @param {string | null} namespaceURI
       * The namespace URI of the attribute to be removed.
       * @param {string} localName
       * The local name of the attribute to be removed.
       * @returns {Attr}
       * The attribute node that was removed.
       * @throws {DOMException}
       * With code:
       * - {@link DOMException.NOT_FOUND_ERR} if no attribute with the given namespace URI and local
       * name is found.
       * @see https://dom.spec.whatwg.org/#dom-namednodemap-removenameditemns
       * @see https://dom.spec.whatwg.org/#concept-element-attributes-remove-by-namespace
       */
      removeNamedItemNS: function(namespaceURI, localName) {
        var attr = this.getNamedItemNS(namespaceURI, localName);
        if (!attr) {
          throw new DOMException(DOMException.NOT_FOUND_ERR, namespaceURI ? namespaceURI + " : " + localName : localName);
        }
        _removeNamedNode(this._ownerElement, this, attr);
        return attr;
      },
      /**
       * Get an attribute by namespace and local name.
       *
       * @param {string | null} namespaceURI
       * The namespace URI of the attribute.
       * @param {string} localName
       * The local name of the attribute.
       * @returns {Attr | null}
       * The attribute with the given namespace URI and local name, or null if no such attribute
       * exists.
       * @see https://dom.spec.whatwg.org/#concept-element-attributes-get-by-namespace
       */
      getNamedItemNS: function(namespaceURI, localName) {
        if (!namespaceURI) {
          namespaceURI = null;
        }
        var i = 0;
        while (i < this.length) {
          var node3 = this[i];
          if (node3.localName === localName && node3.namespaceURI === namespaceURI) {
            return node3;
          }
          i++;
        }
        return null;
      }
    };
    NamedNodeMap.prototype[Symbol.iterator] = function() {
      var me = this;
      var index2 = 0;
      return {
        next: function() {
          if (index2 < me.length) {
            return {
              value: me[index2++],
              done: false
            };
          } else {
            return {
              done: true
            };
          }
        },
        return: function() {
          return {
            done: true
          };
        }
      };
    };
    function DOMImplementation() {
    }
    DOMImplementation.prototype = {
      /**
       * Test if the DOM implementation implements a specific feature and version, as specified in
       * {@link https://www.w3.org/TR/DOM-Level-3-Core/core.html#DOMFeatures DOM Features}.
       *
       * The DOMImplementation.hasFeature() method returns a Boolean flag indicating if a given
       * feature is supported. The different implementations fairly diverged in what kind of
       * features were reported. The latest version of the spec settled to force this method to
       * always return true, where the functionality was accurate and in use.
       *
       * @deprecated
       * It is deprecated and modern browsers return true in all cases.
       * @function DOMImplementation#hasFeature
       * @param {string} feature
       * The name of the feature to test.
       * @param {string} [version]
       * This is the version number of the feature to test.
       * @returns {boolean}
       * Always returns true.
       * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/hasFeature MDN
       * @see https://www.w3.org/TR/REC-DOM-Level-1/level-one-core.html#ID-5CED94D7 DOM Level 1 Core
       * @see https://dom.spec.whatwg.org/#dom-domimplementation-hasfeature DOM Living Standard
       * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-5CED94D7 DOM Level 3 Core
       */
      hasFeature: function(feature2, version6) {
        return true;
      },
      /**
       * Creates a DOM Document object of the specified type with its document element. Note that
       * based on the {@link DocumentType}
       * given to create the document, the implementation may instantiate specialized
       * {@link Document} objects that support additional features than the "Core", such as "HTML"
       * {@link https://www.w3.org/TR/DOM-Level-3-Core/references.html#DOM2HTML DOM Level 2 HTML}.
       * On the other hand, setting the {@link DocumentType} after the document was created makes
       * this very unlikely to happen. Alternatively, specialized {@link Document} creation methods,
       * such as createHTMLDocument
       * {@link https://www.w3.org/TR/DOM-Level-3-Core/references.html#DOM2HTML DOM Level 2 HTML},
       * can be used to obtain specific types of {@link Document} objects.
       *
       * __It behaves slightly different from the description in the living standard__:
       * - There is no interface/class `XMLDocument`, it returns a `Document`
       * instance (with it's `type` set to `'xml'`).
       * - `encoding`, `mode`, `origin`, `url` fields are currently not declared.
       *
       * @function DOMImplementation.createDocument
       * @param {string | null} namespaceURI
       * The
       * {@link https://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-namespaceURI namespace URI}
       * of the document element to create or null.
       * @param {string | null} qualifiedName
       * The
       * {@link https://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-qualifiedname qualified name}
       * of the document element to be created or null.
       * @param {DocumentType | null} [doctype=null]
       * The type of document to be created or null. When doctype is not null, its
       * {@link Node#ownerDocument} attribute is set to the document being created. Default is
       * `null`
       * @returns {Document}
       * A new {@link Document} object with its document element. If the NamespaceURI,
       * qualifiedName, and doctype are null, the returned {@link Document} is empty with no
       * document element.
       * @throws {DOMException}
       * With code:
       *
       * - `INVALID_CHARACTER_ERR`: Raised if the specified qualified name is not an XML name
       * according to {@link https://www.w3.org/TR/DOM-Level-3-Core/references.html#XML XML 1.0}.
       * - `NAMESPACE_ERR`: Raised if the qualifiedName is malformed, if the qualifiedName has a
       * prefix and the namespaceURI is null, or if the qualifiedName is null and the namespaceURI
       * is different from null, or if the qualifiedName has a prefix that is "xml" and the
       * namespaceURI is different from "{@link http://www.w3.org/XML/1998/namespace}"
       * {@link https://www.w3.org/TR/DOM-Level-3-Core/references.html#Namespaces XML Namespaces},
       * or if the DOM implementation does not support the "XML" feature but a non-null namespace
       * URI was provided, since namespaces were defined by XML.
       * - `WRONG_DOCUMENT_ERR`: Raised if doctype has already been used with a different document
       * or was created from a different implementation.
       * - `NOT_SUPPORTED_ERR`: May be raised if the implementation does not support the feature
       * "XML" and the language exposed through the Document does not support XML Namespaces (such
       * as {@link https://www.w3.org/TR/DOM-Level-3-Core/references.html#HTML40 HTML 4.01}).
       * @since DOM Level 2.
       * @see {@link #createHTMLDocument}
       * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocument MDN
       * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocument DOM Living Standard
       * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Level-2-Core-DOM-createDocument DOM
       *      Level 3 Core
       * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocument DOM
       *      Level 2 Core (initial)
       */
      createDocument: function(namespaceURI, qualifiedName, doctype) {
        var contentType4 = MIME_TYPE.XML_APPLICATION;
        if (namespaceURI === NAMESPACE.HTML) {
          contentType4 = MIME_TYPE.XML_XHTML_APPLICATION;
        } else if (namespaceURI === NAMESPACE.SVG) {
          contentType4 = MIME_TYPE.XML_SVG_IMAGE;
        }
        var doc = new Document6(PDC, { contentType: contentType4 });
        doc.implementation = this;
        doc.childNodes = new NodeList();
        doc.doctype = doctype || null;
        if (doctype) {
          doc.appendChild(doctype);
        }
        if (qualifiedName) {
          var root = doc.createElementNS(namespaceURI, qualifiedName);
          doc.appendChild(root);
        }
        return doc;
      },
      /**
       * Creates an empty DocumentType node. Entity declarations and notations are not made
       * available. Entity reference expansions and default attribute additions do not occur.
       *
       * **This behavior is slightly different from the one in the specs**:
       * - `encoding`, `mode`, `origin`, `url` fields are currently not declared.
       * - `publicId` and `systemId` contain the raw data including any possible quotes,
       *   so they can always be serialized back to the original value
       * - `internalSubset` contains the raw string between `[` and `]` if present,
       *   but is not parsed or validated in any form.
       *
       * @function DOMImplementation#createDocumentType
       * @param {string} qualifiedName
       * The {@link https://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-qualifiedname qualified
       * name} of the document type to be created.
       * @param {string} [publicId]
       * The external subset public identifier. Stored verbatim including surrounding quotes.
       * When serialized with `requireWellFormed: true`, the serializer throws `InvalidStateError`
       * if the value is non-empty and does not match the XML `PubidLiteral` production
       * (W3C DOM Parsing §3.2.1.3; XML 1.0 production [12]). Creation-time validation is not
       * enforced — deferred to a future breaking release.
       * @param {string} [systemId]
       * The external subset system identifier. Stored verbatim including surrounding quotes.
       * When serialized with `requireWellFormed: true`, the serializer throws `InvalidStateError`
       * if the value is non-empty and does not match the XML `SystemLiteral` production
       * (W3C DOM Parsing §3.2.1.3; XML 1.0 production [11]). Creation-time validation is not
       * enforced — deferred to a future breaking release.
       * @param {string} [internalSubset]
       * The internal subset or an empty string if it is not present. Stored verbatim.
       * When serialized with `requireWellFormed: true`, the serializer throws `InvalidStateError`
       * if the value contains `"]>"`. Creation-time validation is not enforced.
       * @returns {DocumentType}
       * A new {@link DocumentType} node with {@link Node#ownerDocument} set to null.
       * @throws {DOMException}
       * With code:
       *
       * - `INVALID_CHARACTER_ERR`: Raised if the specified qualified name is not an XML name
       * according to {@link https://www.w3.org/TR/DOM-Level-3-Core/references.html#XML XML 1.0}.
       * - `NAMESPACE_ERR`: Raised if the qualifiedName is malformed.
       * - `NOT_SUPPORTED_ERR`: May be raised if the implementation does not support the feature
       * "XML" and the language exposed through the Document does not support XML Namespaces (such
       * as {@link https://www.w3.org/TR/DOM-Level-3-Core/references.html#HTML40 HTML 4.01}).
       * @since DOM Level 2.
       * @see https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation/createDocumentType
       *      MDN
       * @see https://dom.spec.whatwg.org/#dom-domimplementation-createdocumenttype DOM Living
       *      Standard
       * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Level-3-Core-DOM-createDocType DOM
       *      Level 3 Core
       * @see https://www.w3.org/TR/DOM-Level-2-Core/core.html#Level-2-Core-DOM-createDocType DOM
       *      Level 2 Core
       * @see https://github.com/xmldom/xmldom/blob/master/CHANGELOG.md#050
       * @see https://www.w3.org/TR/DOM-Level-2-Core/#core-ID-Core-DocType-internalSubset
       * @prettierignore
       */
      createDocumentType: function(qualifiedName, publicId, systemId, internalSubset) {
        validateQualifiedName(qualifiedName);
        var node3 = new DocumentType(PDC);
        node3.name = qualifiedName;
        node3.nodeName = qualifiedName;
        node3.publicId = publicId || "";
        node3.systemId = systemId || "";
        node3.internalSubset = internalSubset || "";
        node3.childNodes = new NodeList();
        return node3;
      },
      /**
       * Returns an HTML document, that might already have a basic DOM structure.
       *
       * __It behaves slightly different from the description in the living standard__:
       * - If the first argument is `false` no initial nodes are added (steps 3-7 in the specs are
       * omitted)
       * - `encoding`, `mode`, `origin`, `url` fields are currently not declared.
       *
       * @param {string | false} [title]
       * A string containing the title to give the new HTML document.
       * @returns {Document}
       * The HTML document.
       * @since WHATWG Living Standard.
       * @see {@link #createDocument}
       * @see https://dom.spec.whatwg.org/#dom-domimplementation-createhtmldocument
       * @see https://dom.spec.whatwg.org/#html-document
       */
      createHTMLDocument: function(title10) {
        var doc = new Document6(PDC, { contentType: MIME_TYPE.HTML });
        doc.implementation = this;
        doc.childNodes = new NodeList();
        if (title10 !== false) {
          doc.doctype = this.createDocumentType("html");
          doc.doctype.ownerDocument = doc;
          doc.appendChild(doc.doctype);
          var htmlNode = doc.createElement("html");
          doc.appendChild(htmlNode);
          var headNode = doc.createElement("head");
          htmlNode.appendChild(headNode);
          if (typeof title10 === "string") {
            var titleNode = doc.createElement("title");
            titleNode.appendChild(doc.createTextNode(title10));
            headNode.appendChild(titleNode);
          }
          htmlNode.appendChild(doc.createElement("body"));
        }
        return doc;
      }
    };
    function Node3(symbol) {
      checkSymbol(symbol);
    }
    Node3.prototype = {
      /**
       * The first child of this node.
       *
       * @type {Node | null}
       */
      firstChild: null,
      /**
       * The last child of this node.
       *
       * @type {Node | null}
       */
      lastChild: null,
      /**
       * The previous sibling of this node.
       *
       * @type {Node | null}
       */
      previousSibling: null,
      /**
       * The next sibling of this node.
       *
       * @type {Node | null}
       */
      nextSibling: null,
      /**
       * The parent node of this node.
       *
       * @type {Node | null}
       */
      parentNode: null,
      /**
       * The parent element of this node.
       *
       * @type {Element | null}
       */
      get parentElement() {
        return this.parentNode && this.parentNode.nodeType === this.ELEMENT_NODE ? this.parentNode : null;
      },
      /**
       * The child nodes of this node.
       *
       * @type {NodeList}
       */
      childNodes: null,
      /**
       * The document object associated with this node.
       *
       * @type {Document | null}
       */
      ownerDocument: null,
      /**
       * The value of this node.
       *
       * @type {string | null}
       */
      nodeValue: null,
      /**
       * The namespace URI of this node.
       *
       * @type {string | null}
       */
      namespaceURI: null,
      /**
       * The prefix of the namespace for this node.
       *
       * @type {string | null}
       */
      prefix: null,
      /**
       * The local part of the qualified name of this node.
       *
       * @type {string | null}
       */
      localName: null,
      /**
       * The baseURI is currently always `about:blank`,
       * since that's what happens when you create a document from scratch.
       *
       * @type {'about:blank'}
       */
      baseURI: "about:blank",
      /**
       * Is true if this node is part of a document.
       *
       * @type {boolean}
       */
      get isConnected() {
        var rootNode = this.getRootNode();
        return rootNode && rootNode.nodeType === rootNode.DOCUMENT_NODE;
      },
      /**
       * Checks whether `other` is an inclusive descendant of this node.
       *
       * @param {Node | null | undefined} other
       * The node to check.
       * @returns {boolean}
       * True if `other` is an inclusive descendant of this node; false otherwise.
       * @see https://dom.spec.whatwg.org/#dom-node-contains
       */
      contains: function(other2) {
        if (!other2) return false;
        var parent4 = other2;
        do {
          if (this === parent4) return true;
          parent4 = parent4.parentNode;
        } while (parent4);
        return false;
      },
      /**
       * @typedef GetRootNodeOptions
       * @property {boolean} [composed=false]
       */
      /**
       * Searches for the root node of this node.
       *
       * **This behavior is slightly different from the in the specs**:
       * - ignores `options.composed`, since `ShadowRoot`s are unsupported, always returns root.
       *
       * @param {GetRootNodeOptions} [options]
       * @returns {Node}
       * Root node.
       * @see https://dom.spec.whatwg.org/#dom-node-getrootnode
       * @see https://dom.spec.whatwg.org/#concept-shadow-including-root
       */
      getRootNode: function(options) {
        var parent4 = this;
        do {
          if (!parent4.parentNode) {
            return parent4;
          }
          parent4 = parent4.parentNode;
        } while (parent4);
      },
      /**
       * Checks whether the given node is equal to this node.
       *
       * Two nodes are equal when they have the same type, defining characteristics (for the type),
       * and the same childNodes. The comparison is iterative to avoid stack overflows on
       * deeply-nested trees. Attribute nodes of each Element pair are also pushed onto the stack
       * and compared the same way.
       *
       * @param {Node} [otherNode]
       * @returns {boolean}
       * @see https://dom.spec.whatwg.org/#concept-node-equals
       * @see ../docs/walk-dom.md.
       */
      isEqualNode: function(otherNode) {
        if (!otherNode) return false;
        var stack = [{ node: this, other: otherNode }];
        while (stack.length > 0) {
          var pair = stack.pop();
          var node3 = pair.node;
          var other2 = pair.other;
          if (node3.nodeType !== other2.nodeType) return false;
          switch (node3.nodeType) {
            case node3.DOCUMENT_TYPE_NODE:
              if (node3.name !== other2.name) return false;
              if (node3.publicId !== other2.publicId) return false;
              if (node3.systemId !== other2.systemId) return false;
              break;
            case node3.ELEMENT_NODE:
              if (node3.namespaceURI !== other2.namespaceURI) return false;
              if (node3.prefix !== other2.prefix) return false;
              if (node3.localName !== other2.localName) return false;
              if (node3.attributes.length !== other2.attributes.length) return false;
              for (var i = 0; i < node3.attributes.length; i++) {
                var attr = node3.attributes.item(i);
                var otherAttr = other2.getAttributeNodeNS(attr.namespaceURI, attr.localName);
                if (!otherAttr) return false;
                stack.push({ node: attr, other: otherAttr });
              }
              break;
            case node3.ATTRIBUTE_NODE:
              if (node3.namespaceURI !== other2.namespaceURI) return false;
              if (node3.localName !== other2.localName) return false;
              if (node3.value !== other2.value) return false;
              break;
            case node3.PROCESSING_INSTRUCTION_NODE:
              if (node3.target !== other2.target || node3.data !== other2.data) return false;
              break;
            case node3.TEXT_NODE:
            case node3.CDATA_SECTION_NODE:
            case node3.COMMENT_NODE:
              if (node3.data !== other2.data) return false;
              break;
          }
          if (node3.childNodes.length !== other2.childNodes.length) return false;
          for (var i = node3.childNodes.length - 1; i >= 0; i--) {
            stack.push({ node: node3.childNodes[i], other: other2.childNodes[i] });
          }
        }
        return true;
      },
      /**
       * Checks whether or not the given node is this node.
       *
       * @param {Node} [otherNode]
       */
      isSameNode: function(otherNode) {
        return this === otherNode;
      },
      /**
       * Inserts a node before a reference node as a child of this node.
       *
       * @param {Node} newChild
       * The new child node to be inserted.
       * @param {Node | null} refChild
       * The reference node before which newChild will be inserted.
       * @returns {Node}
       * The new child node successfully inserted.
       * @throws {DOMException}
       * Throws a DOMException if inserting the node would result in a DOM tree that is not
       * well-formed, or if `child` is provided but is not a child of `parent`.
       * See {@link _insertBefore} for more details.
       * @since Modified in DOM L2
       */
      insertBefore: function(newChild, refChild) {
        return _insertBefore(this, newChild, refChild);
      },
      /**
       * Replaces an old child node with a new child node within this node.
       *
       * @param {Node} newChild
       * The new node that is to replace the old node.
       * If it already exists in the DOM, it is removed from its original position.
       * @param {Node} oldChild
       * The existing child node to be replaced.
       * @returns {Node}
       * Returns the replaced child node.
       * @throws {DOMException}
       * Throws a DOMException if replacing the node would result in a DOM tree that is not
       * well-formed, or if `oldChild` is not a child of `this`.
       * This can also occur if the pre-replacement validity assertion fails.
       * See {@link _insertBefore}, {@link Node.removeChild}, and
       * {@link assertPreReplacementValidityInDocument} for more details.
       * @see https://dom.spec.whatwg.org/#concept-node-replace
       */
      replaceChild: function(newChild, oldChild) {
        _insertBefore(this, newChild, oldChild, assertPreReplacementValidityInDocument);
        if (oldChild) {
          this.removeChild(oldChild);
        }
      },
      /**
       * Removes an existing child node from this node.
       *
       * @param {Node} oldChild
       * The child node to be removed.
       * @returns {Node}
       * Returns the removed child node.
       * @throws {DOMException}
       * Throws a DOMException if `oldChild` is not a child of `this`.
       * See {@link _removeChild} for more details.
       */
      removeChild: function(oldChild) {
        return _removeChild(this, oldChild);
      },
      /**
       * Appends a child node to this node.
       *
       * @param {Node} newChild
       * The child node to be appended to this node.
       * If it already exists in the DOM, it is removed from its original position.
       * @returns {Node}
       * Returns the appended child node.
       * @throws {DOMException}
       * Throws a DOMException if appending the node would result in a DOM tree that is not
       * well-formed, or if `newChild` is not a valid Node.
       * See {@link insertBefore} for more details.
       */
      appendChild: function(newChild) {
        return this.insertBefore(newChild, null);
      },
      /**
       * Determines whether this node has any child nodes.
       *
       * @returns {boolean}
       * Returns true if this node has any child nodes, and false otherwise.
       */
      hasChildNodes: function() {
        return this.firstChild != null;
      },
      /**
       * Creates a copy of the calling node.
       *
       * @param {boolean} deep
       * If true, the contents of the node are recursively copied.
       * If false, only the node itself (and its attributes, if it is an element) are copied.
       * @returns {Node}
       * Returns the newly created copy of the node.
       * @throws {DOMException}
       * May throw a DOMException if operations within {@link Element#setAttributeNode} or
       * {@link Node#appendChild} (which are potentially invoked in this method) do not meet their
       * specific constraints.
       * @see {@link cloneNode}
       */
      cloneNode: function(deep) {
        return cloneNode(this.ownerDocument || this, this, deep);
      },
      /**
       * Puts the specified node and all of its subtree into a "normalized" form. In a normalized
       * subtree, no text nodes in the subtree are empty and there are no adjacent text nodes.
       *
       * Specifically, this method merges any adjacent text nodes (i.e., nodes for which `nodeType`
       * is `TEXT_NODE`) into a single node with the combined data. It also removes any empty text
       * nodes.
       *
       * This method iterativly traverses all child nodes to normalize all descendent nodes within
       * the subtree.
       *
       * @throws {DOMException}
       * May throw a DOMException if operations within removeChild or appendData (which are
       * potentially invoked in this method) do not meet their specific constraints.
       * @since Modified in DOM Level 2
       * @see {@link Node.removeChild}
       * @see {@link CharacterData.appendData}
       * @see ../docs/walk-dom.md.
       */
      normalize: function() {
        walkDOM(this, null, {
          enter: function(node3) {
            var child2 = node3.firstChild;
            while (child2) {
              var next4 = child2.nextSibling;
              if (next4 !== null && next4.nodeType === TEXT_NODE && child2.nodeType === TEXT_NODE) {
                node3.removeChild(next4);
                child2.appendData(next4.data);
              } else {
                child2 = next4;
              }
            }
            return true;
          }
        });
      },
      /**
       * Checks whether the DOM implementation implements a specific feature and its version.
       *
       * @deprecated
       * Since `DOMImplementation.hasFeature` is deprecated and always returns true.
       * @param {string} feature
       * The package name of the feature to test. This is the same name that can be passed to the
       * method `hasFeature` on `DOMImplementation`.
       * @param {string} version
       * This is the version number of the package name to test.
       * @returns {boolean}
       * Returns true in all cases in the current implementation.
       * @since Introduced in DOM Level 2
       * @see {@link DOMImplementation.hasFeature}
       */
      isSupported: function(feature2, version6) {
        return this.ownerDocument.implementation.hasFeature(feature2, version6);
      },
      /**
       * Look up the prefix associated to the given namespace URI, starting from this node.
       * **The default namespace declarations are ignored by this method.**
       * See Namespace Prefix Lookup for details on the algorithm used by this method.
       *
       * **This behavior is different from the in the specs**:
       * - no node type specific handling
       * - uses the internal attribute _nsMap for resolving namespaces that is updated when changing attributes
       *
       * @param {string | null} namespaceURI
       * The namespace URI for which to find the associated prefix.
       * @returns {string | null}
       * The associated prefix, if found; otherwise, null.
       * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespacePrefix
       * @see https://www.w3.org/TR/DOM-Level-3-Core/namespaces-algorithms.html#lookupNamespacePrefixAlgo
       * @see https://dom.spec.whatwg.org/#dom-node-lookupprefix
       * @see https://github.com/xmldom/xmldom/issues/322
       * @prettierignore
       */
      lookupPrefix: function(namespaceURI) {
        var el = this;
        while (el) {
          var map5 = el._nsMap;
          if (map5) {
            for (var n3 in map5) {
              if (hasOwn(map5, n3) && map5[n3] === namespaceURI) {
                return n3;
              }
            }
          }
          el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
      },
      /**
       * This function is used to look up the namespace URI associated with the given prefix,
       * starting from this node.
       *
       * **This behavior is different from the in the specs**:
       * - no node type specific handling
       * - uses the internal attribute _nsMap for resolving namespaces that is updated when changing attributes
       *
       * @param {string | null} prefix
       * The prefix for which to find the associated namespace URI.
       * @returns {string | null}
       * The associated namespace URI, if found; otherwise, null.
       * @since DOM Level 3
       * @see https://dom.spec.whatwg.org/#dom-node-lookupnamespaceuri
       * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-lookupNamespaceURI
       * @prettierignore
       */
      lookupNamespaceURI: function(prefix3) {
        var el = this;
        while (el) {
          var map5 = el._nsMap;
          if (map5) {
            if (hasOwn(map5, prefix3)) {
              return map5[prefix3];
            }
          }
          el = el.nodeType == ATTRIBUTE_NODE ? el.ownerDocument : el.parentNode;
        }
        return null;
      },
      /**
       * Determines whether the given namespace URI is the default namespace.
       *
       * The function works by looking up the prefix associated with the given namespace URI. If no
       * prefix is found (i.e., the namespace URI is not registered in the namespace map of this
       * node or any of its ancestors), it returns `true`, implying the namespace URI is considered
       * the default.
       *
       * **This behavior is different from the in the specs**:
       * - no node type specific handling
       * - uses the internal attribute _nsMap for resolving namespaces that is updated when changing attributes
       *
       * @param {string | null} namespaceURI
       * The namespace URI to be checked.
       * @returns {boolean}
       * Returns true if the given namespace URI is the default namespace, false otherwise.
       * @since DOM Level 3
       * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#Node3-isDefaultNamespace
       * @see https://dom.spec.whatwg.org/#dom-node-isdefaultnamespace
       * @prettierignore
       */
      isDefaultNamespace: function(namespaceURI) {
        var prefix3 = this.lookupPrefix(namespaceURI);
        return prefix3 == null;
      },
      /**
       * Compares the reference node with a node with regard to their position in the document and
       * according to the document order.
       *
       * @param {Node} other
       * The node to compare the reference node to.
       * @returns {number}
       * Returns how the node is positioned relatively to the reference node according to the
       * bitmask. 0 if reference node and given node are the same.
       * @since DOM Level 3
       * @see https://www.w3.org/TR/2004/REC-DOM-Level-3-Core-20040407/core.html#Node3-compare
       * @see https://dom.spec.whatwg.org/#dom-node-comparedocumentposition
       */
      compareDocumentPosition: function(other2) {
        if (this === other2) return 0;
        var node1 = other2;
        var node22 = this;
        var attr1 = null;
        var attr2 = null;
        if (node1 instanceof Attr) {
          attr1 = node1;
          node1 = attr1.ownerElement;
        }
        if (node22 instanceof Attr) {
          attr2 = node22;
          node22 = attr2.ownerElement;
          if (attr1 && node1 && node22 === node1) {
            for (var i = 0, attr; attr = node22.attributes[i]; i++) {
              if (attr === attr1)
                return DocumentPosition.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC + DocumentPosition.DOCUMENT_POSITION_PRECEDING;
              if (attr === attr2)
                return DocumentPosition.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC + DocumentPosition.DOCUMENT_POSITION_FOLLOWING;
            }
          }
        }
        if (!node1 || !node22 || node22.ownerDocument !== node1.ownerDocument) {
          return DocumentPosition.DOCUMENT_POSITION_DISCONNECTED + DocumentPosition.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC + (docGUID(node22.ownerDocument) > docGUID(node1.ownerDocument) ? DocumentPosition.DOCUMENT_POSITION_FOLLOWING : DocumentPosition.DOCUMENT_POSITION_PRECEDING);
        }
        if (attr2 && node1 === node22) {
          return DocumentPosition.DOCUMENT_POSITION_CONTAINS + DocumentPosition.DOCUMENT_POSITION_PRECEDING;
        }
        if (attr1 && node1 === node22) {
          return DocumentPosition.DOCUMENT_POSITION_CONTAINED_BY + DocumentPosition.DOCUMENT_POSITION_FOLLOWING;
        }
        var chain1 = [];
        var ancestor1 = node1.parentNode;
        while (ancestor1) {
          if (!attr2 && ancestor1 === node22) {
            return DocumentPosition.DOCUMENT_POSITION_CONTAINED_BY + DocumentPosition.DOCUMENT_POSITION_FOLLOWING;
          }
          chain1.push(ancestor1);
          ancestor1 = ancestor1.parentNode;
        }
        chain1.reverse();
        var chain2 = [];
        var ancestor2 = node22.parentNode;
        while (ancestor2) {
          if (!attr1 && ancestor2 === node1) {
            return DocumentPosition.DOCUMENT_POSITION_CONTAINS + DocumentPosition.DOCUMENT_POSITION_PRECEDING;
          }
          chain2.push(ancestor2);
          ancestor2 = ancestor2.parentNode;
        }
        chain2.reverse();
        var ca = commonAncestor(chain1, chain2);
        for (var n3 in ca.childNodes) {
          var child2 = ca.childNodes[n3];
          if (child2 === node22) return DocumentPosition.DOCUMENT_POSITION_FOLLOWING;
          if (child2 === node1) return DocumentPosition.DOCUMENT_POSITION_PRECEDING;
          if (chain2.indexOf(child2) >= 0) return DocumentPosition.DOCUMENT_POSITION_FOLLOWING;
          if (chain1.indexOf(child2) >= 0) return DocumentPosition.DOCUMENT_POSITION_PRECEDING;
        }
        return 0;
      }
    };
    function _xmlEncoder(c) {
      return c == "<" && "&lt;" || c == ">" && "&gt;" || c == "&" && "&amp;" || c == '"' && "&quot;" || "&#" + c.charCodeAt() + ";";
    }
    copy(NodeType, Node3);
    copy(NodeType, Node3.prototype);
    copy(DocumentPosition, Node3);
    copy(DocumentPosition, Node3.prototype);
    function _visitNode(node3, callback) {
      walkDOM(node3, null, {
        enter: function(n3) {
          return callback(n3) ? walkDOM.STOP : true;
        }
      });
    }
    function walkDOM(node3, context4, callbacks) {
      var stack = [{ node: node3, context: context4, phase: walkDOM.ENTER }];
      while (stack.length > 0) {
        var frame = stack.pop();
        if (frame.phase === walkDOM.ENTER) {
          var childContext = callbacks.enter(frame.node, frame.context);
          if (childContext === walkDOM.STOP) {
            return walkDOM.STOP;
          }
          stack.push({ node: frame.node, context: childContext, phase: walkDOM.EXIT });
          if (childContext === null || childContext === void 0) {
            continue;
          }
          var child2 = frame.node.lastChild;
          while (child2) {
            stack.push({ node: child2, context: childContext, phase: walkDOM.ENTER });
            child2 = child2.previousSibling;
          }
        } else {
          if (callbacks.exit) {
            callbacks.exit(frame.node, frame.context);
          }
        }
      }
    }
    walkDOM.STOP = /* @__PURE__ */ Symbol("walkDOM.STOP");
    walkDOM.ENTER = 0;
    walkDOM.EXIT = 1;
    function Document6(symbol, options) {
      checkSymbol(symbol);
      var opt = options || {};
      this.ownerDocument = this;
      this.contentType = opt.contentType || MIME_TYPE.XML_APPLICATION;
      this.type = isHTMLMimeType(this.contentType) ? "html" : "xml";
    }
    function _onAddAttribute(doc, el, newAttr) {
      doc && doc._inc++;
      var ns3 = newAttr.namespaceURI;
      if (ns3 === NAMESPACE.XMLNS) {
        el._nsMap[newAttr.prefix ? newAttr.localName : ""] = newAttr.value;
      }
    }
    function _onRemoveAttribute(doc, el, newAttr, remove) {
      doc && doc._inc++;
      var ns3 = newAttr.namespaceURI;
      if (ns3 === NAMESPACE.XMLNS) {
        delete el._nsMap[newAttr.prefix ? newAttr.localName : ""];
      }
    }
    function _onUpdateChild(doc, parent4, newChild) {
      if (doc && doc._inc) {
        doc._inc++;
        var childNodes = parent4.childNodes;
        if (newChild && !newChild.nextSibling) {
          childNodes[childNodes.length++] = newChild;
        } else {
          var child2 = parent4.firstChild;
          var i = 0;
          while (child2) {
            childNodes[i++] = child2;
            child2 = child2.nextSibling;
          }
          childNodes.length = i;
          delete childNodes[childNodes.length];
        }
      }
    }
    function _removeChild(parentNode, child2) {
      if (parentNode !== child2.parentNode) {
        throw new DOMException(DOMException.NOT_FOUND_ERR, "child's parent is not parent");
      }
      var oldPreviousSibling = child2.previousSibling;
      var oldNextSibling = child2.nextSibling;
      if (oldPreviousSibling) {
        oldPreviousSibling.nextSibling = oldNextSibling;
      } else {
        parentNode.firstChild = oldNextSibling;
      }
      if (oldNextSibling) {
        oldNextSibling.previousSibling = oldPreviousSibling;
      } else {
        parentNode.lastChild = oldPreviousSibling;
      }
      _onUpdateChild(parentNode.ownerDocument, parentNode);
      child2.parentNode = null;
      child2.previousSibling = null;
      child2.nextSibling = null;
      return child2;
    }
    function hasValidParentNodeType(node3) {
      return node3 && (node3.nodeType === Node3.DOCUMENT_NODE || node3.nodeType === Node3.DOCUMENT_FRAGMENT_NODE || node3.nodeType === Node3.ELEMENT_NODE);
    }
    function hasInsertableNodeType(node3) {
      return node3 && (node3.nodeType === Node3.CDATA_SECTION_NODE || node3.nodeType === Node3.COMMENT_NODE || node3.nodeType === Node3.DOCUMENT_FRAGMENT_NODE || node3.nodeType === Node3.DOCUMENT_TYPE_NODE || node3.nodeType === Node3.ELEMENT_NODE || node3.nodeType === Node3.PROCESSING_INSTRUCTION_NODE || node3.nodeType === Node3.TEXT_NODE);
    }
    function isDocTypeNode(node3) {
      return node3 && node3.nodeType === Node3.DOCUMENT_TYPE_NODE;
    }
    function isElementNode(node3) {
      return node3 && node3.nodeType === Node3.ELEMENT_NODE;
    }
    function isTextNode(node3) {
      return node3 && node3.nodeType === Node3.TEXT_NODE;
    }
    function isElementInsertionPossible(doc, child2) {
      var parentChildNodes = doc.childNodes || [];
      if (find(parentChildNodes, isElementNode) || isDocTypeNode(child2)) {
        return false;
      }
      var docTypeNode = find(parentChildNodes, isDocTypeNode);
      return !(child2 && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child2));
    }
    function isElementReplacementPossible(doc, child2) {
      var parentChildNodes = doc.childNodes || [];
      function hasElementChildThatIsNotChild(node3) {
        return isElementNode(node3) && node3 !== child2;
      }
      if (find(parentChildNodes, hasElementChildThatIsNotChild)) {
        return false;
      }
      var docTypeNode = find(parentChildNodes, isDocTypeNode);
      return !(child2 && docTypeNode && parentChildNodes.indexOf(docTypeNode) > parentChildNodes.indexOf(child2));
    }
    function assertPreInsertionValidity1to5(parent4, node3, child2) {
      if (!hasValidParentNodeType(parent4)) {
        throw new DOMException(DOMException.HIERARCHY_REQUEST_ERR, "Unexpected parent node type " + parent4.nodeType);
      }
      if (child2 && child2.parentNode !== parent4) {
        throw new DOMException(DOMException.NOT_FOUND_ERR, "child not in parent");
      }
      if (
        // 4. If `node` is not a DocumentFragment, DocumentType, Element, or CharacterData node, then throw a "HierarchyRequestError" DOMException.
        !hasInsertableNodeType(node3) || // 5. If either `node` is a Text node and `parent` is a document,
        // the sax parser currently adds top level text nodes, this will be fixed in 0.9.0
        // || (node.nodeType === Node.TEXT_NODE && parent.nodeType === Node.DOCUMENT_NODE)
        // or `node` is a doctype and `parent` is not a document, then throw a "HierarchyRequestError" DOMException.
        isDocTypeNode(node3) && parent4.nodeType !== Node3.DOCUMENT_NODE
      ) {
        throw new DOMException(
          DOMException.HIERARCHY_REQUEST_ERR,
          "Unexpected node type " + node3.nodeType + " for parent node type " + parent4.nodeType
        );
      }
    }
    function assertPreInsertionValidityInDocument(parent4, node3, child2) {
      var parentChildNodes = parent4.childNodes || [];
      var nodeChildNodes = node3.childNodes || [];
      if (node3.nodeType === Node3.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter(isElementNode);
        if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
          throw new DOMException(DOMException.HIERARCHY_REQUEST_ERR, "More than one element or text in fragment");
        }
        if (nodeChildElements.length === 1 && !isElementInsertionPossible(parent4, child2)) {
          throw new DOMException(DOMException.HIERARCHY_REQUEST_ERR, "Element in fragment can not be inserted before doctype");
        }
      }
      if (isElementNode(node3)) {
        if (!isElementInsertionPossible(parent4, child2)) {
          throw new DOMException(DOMException.HIERARCHY_REQUEST_ERR, "Only one element can be added and only after doctype");
        }
      }
      if (isDocTypeNode(node3)) {
        if (find(parentChildNodes, isDocTypeNode)) {
          throw new DOMException(DOMException.HIERARCHY_REQUEST_ERR, "Only one doctype is allowed");
        }
        var parentElementChild = find(parentChildNodes, isElementNode);
        if (child2 && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child2)) {
          throw new DOMException(DOMException.HIERARCHY_REQUEST_ERR, "Doctype can only be inserted before an element");
        }
        if (!child2 && parentElementChild) {
          throw new DOMException(DOMException.HIERARCHY_REQUEST_ERR, "Doctype can not be appended since element is present");
        }
      }
    }
    function assertPreReplacementValidityInDocument(parent4, node3, child2) {
      var parentChildNodes = parent4.childNodes || [];
      var nodeChildNodes = node3.childNodes || [];
      if (node3.nodeType === Node3.DOCUMENT_FRAGMENT_NODE) {
        var nodeChildElements = nodeChildNodes.filter(isElementNode);
        if (nodeChildElements.length > 1 || find(nodeChildNodes, isTextNode)) {
          throw new DOMException(DOMException.HIERARCHY_REQUEST_ERR, "More than one element or text in fragment");
        }
        if (nodeChildElements.length === 1 && !isElementReplacementPossible(parent4, child2)) {
          throw new DOMException(DOMException.HIERARCHY_REQUEST_ERR, "Element in fragment can not be inserted before doctype");
        }
      }
      if (isElementNode(node3)) {
        if (!isElementReplacementPossible(parent4, child2)) {
          throw new DOMException(DOMException.HIERARCHY_REQUEST_ERR, "Only one element can be added and only after doctype");
        }
      }
      if (isDocTypeNode(node3)) {
        let hasDoctypeChildThatIsNotChild = function(node4) {
          return isDocTypeNode(node4) && node4 !== child2;
        };
        if (find(parentChildNodes, hasDoctypeChildThatIsNotChild)) {
          throw new DOMException(DOMException.HIERARCHY_REQUEST_ERR, "Only one doctype is allowed");
        }
        var parentElementChild = find(parentChildNodes, isElementNode);
        if (child2 && parentChildNodes.indexOf(parentElementChild) < parentChildNodes.indexOf(child2)) {
          throw new DOMException(DOMException.HIERARCHY_REQUEST_ERR, "Doctype can only be inserted before an element");
        }
      }
    }
    function _insertBefore(parent4, node3, child2, _inDocumentAssertion) {
      assertPreInsertionValidity1to5(parent4, node3, child2);
      if (parent4.nodeType === Node3.DOCUMENT_NODE) {
        (_inDocumentAssertion || assertPreInsertionValidityInDocument)(parent4, node3, child2);
      }
      var cp = node3.parentNode;
      if (cp) {
        cp.removeChild(node3);
      }
      if (node3.nodeType === DOCUMENT_FRAGMENT_NODE) {
        var newFirst = node3.firstChild;
        if (newFirst == null) {
          return node3;
        }
        var newLast = node3.lastChild;
      } else {
        newFirst = newLast = node3;
      }
      var pre = child2 ? child2.previousSibling : parent4.lastChild;
      newFirst.previousSibling = pre;
      newLast.nextSibling = child2;
      if (pre) {
        pre.nextSibling = newFirst;
      } else {
        parent4.firstChild = newFirst;
      }
      if (child2 == null) {
        parent4.lastChild = newLast;
      } else {
        child2.previousSibling = newLast;
      }
      do {
        newFirst.parentNode = parent4;
      } while (newFirst !== newLast && (newFirst = newFirst.nextSibling));
      _onUpdateChild(parent4.ownerDocument || parent4, parent4, node3);
      if (node3.nodeType == DOCUMENT_FRAGMENT_NODE) {
        node3.firstChild = node3.lastChild = null;
      }
      return node3;
    }
    Document6.prototype = {
      /**
       * The implementation that created this document.
       *
       * @type DOMImplementation
       * @readonly
       */
      implementation: null,
      nodeName: "#document",
      nodeType: DOCUMENT_NODE,
      /**
       * The DocumentType node of the document.
       *
       * @type DocumentType
       * @readonly
       */
      doctype: null,
      documentElement: null,
      _inc: 1,
      insertBefore: function(newChild, refChild) {
        if (newChild.nodeType === DOCUMENT_FRAGMENT_NODE) {
          var child2 = newChild.firstChild;
          while (child2) {
            var next4 = child2.nextSibling;
            this.insertBefore(child2, refChild);
            child2 = next4;
          }
          return newChild;
        }
        _insertBefore(this, newChild, refChild);
        newChild.ownerDocument = this;
        if (this.documentElement === null && newChild.nodeType === ELEMENT_NODE) {
          this.documentElement = newChild;
        }
        return newChild;
      },
      removeChild: function(oldChild) {
        var removed = _removeChild(this, oldChild);
        if (removed === this.documentElement) {
          this.documentElement = null;
        }
        return removed;
      },
      replaceChild: function(newChild, oldChild) {
        _insertBefore(this, newChild, oldChild, assertPreReplacementValidityInDocument);
        newChild.ownerDocument = this;
        if (oldChild) {
          this.removeChild(oldChild);
        }
        if (isElementNode(newChild)) {
          this.documentElement = newChild;
        }
      },
      /**
       * Imports a node from another document into this document, creating a new copy owned by this
       * document. The source node and its subtree are not modified.
       *
       * @param {Node} importedNode
       * The node to import.
       * @param {boolean} deep
       * If true, the contents of the node are recursively imported.
       * If false, only the node itself (and its attributes, if it is an element) are imported.
       * @returns {Node}
       * Returns the newly created import of the node.
       * @see {@link importNode}
       * @see {@link https://dom.spec.whatwg.org/#dom-document-importnode}
       */
      importNode: function(importedNode, deep) {
        return importNode(this, importedNode, deep);
      },
      // Introduced in DOM Level 2:
      getElementById: function(id4) {
        var rtv = null;
        _visitNode(this.documentElement, function(node3) {
          if (node3.nodeType == ELEMENT_NODE) {
            if (node3.getAttribute("id") == id4) {
              rtv = node3;
              return true;
            }
          }
        });
        return rtv;
      },
      /**
       * Creates a new `Element` that is owned by this `Document`.
       * In HTML Documents `localName` is the lower cased `tagName`,
       * otherwise no transformation is being applied.
       * When `contentType` implies the HTML namespace, it will be set as `namespaceURI`.
       *
       * __This implementation differs from the specification:__ - The provided name is not checked
       * against the `Name` production,
       * so no related error will be thrown.
       * - There is no interface `HTMLElement`, it is always an `Element`.
       * - There is no support for a second argument to indicate using custom elements.
       *
       * @param {string} tagName
       * @returns {Element}
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/createElement
       * @see https://dom.spec.whatwg.org/#dom-document-createelement
       * @see https://dom.spec.whatwg.org/#concept-create-element
       */
      createElement: function(tagName) {
        var node3 = new Element2(PDC);
        node3.ownerDocument = this;
        if (this.type === "html") {
          tagName = tagName.toLowerCase();
        }
        if (hasDefaultHTMLNamespace(this.contentType)) {
          node3.namespaceURI = NAMESPACE.HTML;
        }
        node3.nodeName = tagName;
        node3.tagName = tagName;
        node3.localName = tagName;
        node3.childNodes = new NodeList();
        var attrs = node3.attributes = new NamedNodeMap();
        attrs._ownerElement = node3;
        return node3;
      },
      /**
       * @returns {DocumentFragment}
       */
      createDocumentFragment: function() {
        var node3 = new DocumentFragment(PDC);
        node3.ownerDocument = this;
        node3.childNodes = new NodeList();
        return node3;
      },
      /**
       * @param {string} data
       * @returns {Text}
       */
      createTextNode: function(data4) {
        var node3 = new Text4(PDC);
        node3.ownerDocument = this;
        node3.childNodes = new NodeList();
        node3.appendData(data4);
        return node3;
      },
      /**
       * @param {string} data
       * @returns {Comment}
       * @see https://dom.spec.whatwg.org/#dom-document-createcomment
       * @see https://www.w3.org/TR/xml/#NT-Comment XML 1.0 production [15]
       * @see https://www.w3.org/TR/DOM-Parsing/#dfn-concept-serialize-xml §3.2.1.3
       *
       *      Note: no validation is performed at creation time. When the resulting document is
       *      serialized with `requireWellFormed: true`, the serializer throws `InvalidStateError`
       *      if the comment data contains `--` anywhere, ends with `-`, or contains characters
       *      outside the XML Char production (W3C DOM Parsing §3.2.1.3). Without that option the
       *      data is emitted verbatim.
       */
      createComment: function(data4) {
        var node3 = new Comment3(PDC);
        node3.ownerDocument = this;
        node3.childNodes = new NodeList();
        node3.appendData(data4);
        return node3;
      },
      /**
       * Returns a new CDATASection node whose data is `data`.
       *
       * __This implementation differs from the specification:__ - calling this method on an HTML
       * document does not throw `NotSupportedError`.
       *
       * @param {string} data
       * @returns {CDATASection}
       * @throws {DOMException}
       * With code `INVALID_CHARACTER_ERR` if `data` contains `"]]>"`.
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/createCDATASection
       * @see https://dom.spec.whatwg.org/#dom-document-createcdatasection
       */
      createCDATASection: function(data4) {
        if (data4.indexOf("]]>") !== -1) {
          throw new DOMException(DOMException.INVALID_CHARACTER_ERR, 'data contains "]]>"');
        }
        var node3 = new CDATASection(PDC);
        node3.ownerDocument = this;
        node3.childNodes = new NodeList();
        node3.appendData(data4);
        return node3;
      },
      /**
       * Returns a ProcessingInstruction node whose target is target and data is data.
       *
       * __This behavior is slightly different from the in the specs__:
       * - it does not do any input validation on the arguments and doesn't throw
       * "InvalidCharacterError".
       *
       * Note: When the resulting document is serialized with `requireWellFormed: true`, the
       * serializer throws `InvalidStateError` if `.target` contains `:` or is an ASCII
       * case-insensitive match for `"xml"`, or if `.data` contains `?>` or characters outside the
       * XML Char production (W3C DOM Parsing §3.2.1.7). Without that option the data is emitted
       * verbatim.
       *
       * @param {string} target
       * @param {string} data
       * @returns {ProcessingInstruction}
       * @see https://developer.mozilla.org/docs/Web/API/Document/createProcessingInstruction
       * @see https://dom.spec.whatwg.org/#dom-document-createprocessinginstruction
       * @see https://www.w3.org/TR/DOM-Parsing/#dfn-concept-serialize-xml §3.2.1.7
       */
      createProcessingInstruction: function(target6, data4) {
        var node3 = new ProcessingInstruction(PDC);
        node3.ownerDocument = this;
        node3.childNodes = new NodeList();
        node3.nodeName = node3.target = target6;
        node3.nodeValue = node3.data = data4;
        return node3;
      },
      /**
       * Creates an `Attr` node that is owned by this document.
       * In HTML Documents `localName` is the lower cased `name`,
       * otherwise no transformation is being applied.
       *
       * __This implementation differs from the specification:__ - The provided name is not checked
       * against the `Name` production,
       * so no related error will be thrown.
       *
       * @param {string} name
       * @returns {Attr}
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/createAttribute
       * @see https://dom.spec.whatwg.org/#dom-document-createattribute
       */
      createAttribute: function(name9) {
        if (!g.QName_exact.test(name9)) {
          throw new DOMException(DOMException.INVALID_CHARACTER_ERR, 'invalid character in name "' + name9 + '"');
        }
        if (this.type === "html") {
          name9 = name9.toLowerCase();
        }
        return this._createAttribute(name9);
      },
      _createAttribute: function(name9) {
        var node3 = new Attr(PDC);
        node3.ownerDocument = this;
        node3.childNodes = new NodeList();
        node3.name = name9;
        node3.nodeName = name9;
        node3.localName = name9;
        node3.specified = true;
        return node3;
      },
      /**
       * Creates an EntityReference object.
       * The current implementation does not fill the `childNodes` with those of the corresponding
       * `Entity`
       *
       * @deprecated
       * In DOM Level 4.
       * @param {string} name
       * The name of the entity to reference. No namespace well-formedness checks are performed.
       * @returns {EntityReference}
       * @throws {DOMException}
       * With code `INVALID_CHARACTER_ERR` when `name` is not valid.
       * @throws {DOMException}
       * with code `NOT_SUPPORTED_ERR` when the document is of type `html`
       * @see https://www.w3.org/TR/DOM-Level-3-Core/core.html#ID-392B75AE
       */
      createEntityReference: function(name9) {
        if (!g.Name.test(name9)) {
          throw new DOMException(DOMException.INVALID_CHARACTER_ERR, 'not a valid xml name "' + name9 + '"');
        }
        if (this.type === "html") {
          throw new DOMException("document is an html document", DOMExceptionName.NotSupportedError);
        }
        var node3 = new EntityReference(PDC);
        node3.ownerDocument = this;
        node3.childNodes = new NodeList();
        node3.nodeName = name9;
        return node3;
      },
      // Introduced in DOM Level 2:
      /**
       * @param {string} namespaceURI
       * @param {string} qualifiedName
       * @returns {Element}
       */
      createElementNS: function(namespaceURI, qualifiedName) {
        var validated2 = validateAndExtract(namespaceURI, qualifiedName);
        var node3 = new Element2(PDC);
        var attrs = node3.attributes = new NamedNodeMap();
        node3.childNodes = new NodeList();
        node3.ownerDocument = this;
        node3.nodeName = qualifiedName;
        node3.tagName = qualifiedName;
        node3.namespaceURI = validated2[0];
        node3.prefix = validated2[1];
        node3.localName = validated2[2];
        attrs._ownerElement = node3;
        return node3;
      },
      // Introduced in DOM Level 2:
      /**
       * @param {string} namespaceURI
       * @param {string} qualifiedName
       * @returns {Attr}
       */
      createAttributeNS: function(namespaceURI, qualifiedName) {
        var validated2 = validateAndExtract(namespaceURI, qualifiedName);
        var node3 = new Attr(PDC);
        node3.ownerDocument = this;
        node3.childNodes = new NodeList();
        node3.nodeName = qualifiedName;
        node3.name = qualifiedName;
        node3.specified = true;
        node3.namespaceURI = validated2[0];
        node3.prefix = validated2[1];
        node3.localName = validated2[2];
        return node3;
      }
    };
    _extends2(Document6, Node3);
    function Element2(symbol) {
      checkSymbol(symbol);
      this._nsMap = /* @__PURE__ */ Object.create(null);
    }
    Element2.prototype = {
      nodeType: ELEMENT_NODE,
      /**
       * The attributes of this element.
       *
       * @type {NamedNodeMap | null}
       */
      attributes: null,
      getQualifiedName: function() {
        return this.prefix ? this.prefix + ":" + this.localName : this.localName;
      },
      _isInHTMLDocumentAndNamespace: function() {
        return this.ownerDocument.type === "html" && this.namespaceURI === NAMESPACE.HTML;
      },
      /**
       * Implementaton of Level2 Core function hasAttributes.
       *
       * @returns {boolean}
       * True if attribute list is not empty.
       * @see https://www.w3.org/TR/DOM-Level-2-Core/#core-ID-NodeHasAttrs
       */
      hasAttributes: function() {
        return !!(this.attributes && this.attributes.length);
      },
      hasAttribute: function(name9) {
        return !!this.getAttributeNode(name9);
      },
      /**
       * Returns element’s first attribute whose qualified name is `name`, and `null`
       * if there is no such attribute.
       *
       * @param {string} name
       * @returns {string | null}
       */
      getAttribute: function(name9) {
        var attr = this.getAttributeNode(name9);
        return attr ? attr.value : null;
      },
      getAttributeNode: function(name9) {
        if (this._isInHTMLDocumentAndNamespace()) {
          name9 = name9.toLowerCase();
        }
        return this.attributes.getNamedItem(name9);
      },
      /**
       * Sets the value of element’s first attribute whose qualified name is qualifiedName to value.
       *
       * @param {string} name
       * @param {string} value
       */
      setAttribute: function(name9, value8) {
        if (this._isInHTMLDocumentAndNamespace()) {
          name9 = name9.toLowerCase();
        }
        var attr = this.getAttributeNode(name9);
        if (attr) {
          attr.value = attr.nodeValue = "" + value8;
        } else {
          attr = this.ownerDocument._createAttribute(name9);
          attr.value = attr.nodeValue = "" + value8;
          this.setAttributeNode(attr);
        }
      },
      removeAttribute: function(name9) {
        var attr = this.getAttributeNode(name9);
        attr && this.removeAttributeNode(attr);
      },
      setAttributeNode: function(newAttr) {
        return this.attributes.setNamedItem(newAttr);
      },
      setAttributeNodeNS: function(newAttr) {
        return this.attributes.setNamedItemNS(newAttr);
      },
      removeAttributeNode: function(oldAttr) {
        return this.attributes.removeNamedItem(oldAttr.nodeName);
      },
      //get real attribute name,and remove it by removeAttributeNode
      removeAttributeNS: function(namespaceURI, localName) {
        var old = this.getAttributeNodeNS(namespaceURI, localName);
        old && this.removeAttributeNode(old);
      },
      hasAttributeNS: function(namespaceURI, localName) {
        return this.getAttributeNodeNS(namespaceURI, localName) != null;
      },
      /**
       * Returns element’s attribute whose namespace is `namespaceURI` and local name is
       * `localName`,
       * or `null` if there is no such attribute.
       *
       * @param {string} namespaceURI
       * @param {string} localName
       * @returns {string | null}
       */
      getAttributeNS: function(namespaceURI, localName) {
        var attr = this.getAttributeNodeNS(namespaceURI, localName);
        return attr ? attr.value : null;
      },
      /**
       * Sets the value of element’s attribute whose namespace is `namespaceURI` and local name is
       * `localName` to value.
       *
       * @param {string} namespaceURI
       * @param {string} qualifiedName
       * @param {string} value
       * @see https://dom.spec.whatwg.org/#dom-element-setattributens
       */
      setAttributeNS: function(namespaceURI, qualifiedName, value8) {
        var validated2 = validateAndExtract(namespaceURI, qualifiedName);
        var localName = validated2[2];
        var attr = this.getAttributeNodeNS(namespaceURI, localName);
        if (attr) {
          attr.value = attr.nodeValue = "" + value8;
        } else {
          attr = this.ownerDocument.createAttributeNS(namespaceURI, qualifiedName);
          attr.value = attr.nodeValue = "" + value8;
          this.setAttributeNode(attr);
        }
      },
      getAttributeNodeNS: function(namespaceURI, localName) {
        return this.attributes.getNamedItemNS(namespaceURI, localName);
      },
      /**
       * Returns a LiveNodeList of all child elements which have **all** of the given class name(s).
       *
       * Returns an empty list if `classNames` is an empty string or only contains HTML white space
       * characters.
       *
       * Warning: This returns a live LiveNodeList.
       * Changes in the DOM will reflect in the array as the changes occur.
       * If an element selected by this array no longer qualifies for the selector,
       * it will automatically be removed. Be aware of this for iteration purposes.
       *
       * @param {string} classNames
       * Is a string representing the class name(s) to match; multiple class names are separated by
       * (ASCII-)whitespace.
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/getElementsByClassName
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/getElementsByClassName
       * @see https://dom.spec.whatwg.org/#concept-getelementsbyclassname
       */
      getElementsByClassName: function(classNames) {
        var classNamesSet = toOrderedSet(classNames);
        return new LiveNodeList(this, function(base2) {
          var ls = [];
          if (classNamesSet.length > 0) {
            _visitNode(base2, function(node3) {
              if (node3 !== base2 && node3.nodeType === ELEMENT_NODE) {
                var nodeClassNames = node3.getAttribute("class");
                if (nodeClassNames) {
                  var matches = classNames === nodeClassNames;
                  if (!matches) {
                    var nodeClassNamesSet = toOrderedSet(nodeClassNames);
                    matches = classNamesSet.every(arrayIncludes(nodeClassNamesSet));
                  }
                  if (matches) {
                    ls.push(node3);
                  }
                }
              }
            });
          }
          return ls;
        });
      },
      /**
       * Returns a LiveNodeList of elements with the given qualifiedName.
       * Searching for all descendants can be done by passing `*` as `qualifiedName`.
       *
       * All descendants of the specified element are searched, but not the element itself.
       * The returned list is live, which means it updates itself with the DOM tree automatically.
       * Therefore, there is no need to call `Element.getElementsByTagName()`
       * with the same element and arguments repeatedly if the DOM changes in between calls.
       *
       * When called on an HTML element in an HTML document,
       * `getElementsByTagName` lower-cases the argument before searching for it.
       * This is undesirable when trying to match camel-cased SVG elements (such as
       * `<linearGradient>`) in an HTML document.
       * Instead, use `Element.getElementsByTagNameNS()`,
       * which preserves the capitalization of the tag name.
       *
       * `Element.getElementsByTagName` is similar to `Document.getElementsByTagName()`,
       * except that it only searches for elements that are descendants of the specified element.
       *
       * @param {string} qualifiedName
       * @returns {LiveNodeList}
       * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/getElementsByTagName
       * @see https://dom.spec.whatwg.org/#concept-getelementsbytagname
       */
      getElementsByTagName: function(qualifiedName) {
        var isHTMLDocument = (this.nodeType === DOCUMENT_NODE ? this : this.ownerDocument).type === "html";
        var lowerQualifiedName = qualifiedName.toLowerCase();
        return new LiveNodeList(this, function(base2) {
          var ls = [];
          _visitNode(base2, function(node3) {
            if (node3 === base2 || node3.nodeType !== ELEMENT_NODE) {
              return;
            }
            if (qualifiedName === "*") {
              ls.push(node3);
            } else {
              var nodeQualifiedName = node3.getQualifiedName();
              var matchingQName = isHTMLDocument && node3.namespaceURI === NAMESPACE.HTML ? lowerQualifiedName : qualifiedName;
              if (nodeQualifiedName === matchingQName) {
                ls.push(node3);
              }
            }
          });
          return ls;
        });
      },
      getElementsByTagNameNS: function(namespaceURI, localName) {
        return new LiveNodeList(this, function(base2) {
          var ls = [];
          _visitNode(base2, function(node3) {
            if (node3 !== base2 && node3.nodeType === ELEMENT_NODE && (namespaceURI === "*" || node3.namespaceURI === namespaceURI) && (localName === "*" || node3.localName == localName)) {
              ls.push(node3);
            }
          });
          return ls;
        });
      }
    };
    Document6.prototype.getElementsByClassName = Element2.prototype.getElementsByClassName;
    Document6.prototype.getElementsByTagName = Element2.prototype.getElementsByTagName;
    Document6.prototype.getElementsByTagNameNS = Element2.prototype.getElementsByTagNameNS;
    _extends2(Element2, Node3);
    function Attr(symbol) {
      checkSymbol(symbol);
      this.namespaceURI = null;
      this.prefix = null;
      this.ownerElement = null;
    }
    Attr.prototype.nodeType = ATTRIBUTE_NODE;
    _extends2(Attr, Node3);
    function CharacterData(symbol) {
      checkSymbol(symbol);
    }
    CharacterData.prototype = {
      data: "",
      substringData: function(offset3, count2) {
        return this.data.substring(offset3, offset3 + count2);
      },
      appendData: function(text4) {
        text4 = this.data + text4;
        this.nodeValue = this.data = text4;
        this.length = text4.length;
      },
      insertData: function(offset3, text4) {
        this.replaceData(offset3, 0, text4);
      },
      deleteData: function(offset3, count2) {
        this.replaceData(offset3, count2, "");
      },
      replaceData: function(offset3, count2, text4) {
        var start3 = this.data.substring(0, offset3);
        var end2 = this.data.substring(offset3 + count2);
        text4 = start3 + text4 + end2;
        this.nodeValue = this.data = text4;
        this.length = text4.length;
      }
    };
    _extends2(CharacterData, Node3);
    function Text4(symbol) {
      checkSymbol(symbol);
    }
    Text4.prototype = {
      nodeName: "#text",
      nodeType: TEXT_NODE,
      splitText: function(offset3) {
        var text4 = this.data;
        var newText = text4.substring(offset3);
        text4 = text4.substring(0, offset3);
        this.data = this.nodeValue = text4;
        this.length = text4.length;
        var newNode = this.ownerDocument.createTextNode(newText);
        if (this.parentNode) {
          this.parentNode.insertBefore(newNode, this.nextSibling);
        }
        return newNode;
      }
    };
    _extends2(Text4, CharacterData);
    function Comment3(symbol) {
      checkSymbol(symbol);
    }
    Comment3.prototype = {
      nodeName: "#comment",
      nodeType: COMMENT_NODE
    };
    _extends2(Comment3, CharacterData);
    function CDATASection(symbol) {
      checkSymbol(symbol);
    }
    CDATASection.prototype = {
      nodeName: "#cdata-section",
      nodeType: CDATA_SECTION_NODE
    };
    _extends2(CDATASection, Text4);
    function DocumentType(symbol) {
      checkSymbol(symbol);
    }
    DocumentType.prototype.nodeType = DOCUMENT_TYPE_NODE;
    _extends2(DocumentType, Node3);
    function Notation(symbol) {
      checkSymbol(symbol);
    }
    Notation.prototype.nodeType = NOTATION_NODE;
    _extends2(Notation, Node3);
    function Entity2(symbol) {
      checkSymbol(symbol);
    }
    Entity2.prototype.nodeType = ENTITY_NODE;
    _extends2(Entity2, Node3);
    function EntityReference(symbol) {
      checkSymbol(symbol);
    }
    EntityReference.prototype.nodeType = ENTITY_REFERENCE_NODE;
    _extends2(EntityReference, Node3);
    function DocumentFragment(symbol) {
      checkSymbol(symbol);
    }
    DocumentFragment.prototype.nodeName = "#document-fragment";
    DocumentFragment.prototype.nodeType = DOCUMENT_FRAGMENT_NODE;
    _extends2(DocumentFragment, Node3);
    function ProcessingInstruction(symbol) {
      checkSymbol(symbol);
    }
    ProcessingInstruction.prototype.nodeType = PROCESSING_INSTRUCTION_NODE;
    _extends2(ProcessingInstruction, CharacterData);
    function XMLSerializer() {
    }
    XMLSerializer.prototype.serializeToString = function(node3, options) {
      return nodeSerializeToString.call(node3, options);
    };
    Node3.prototype.toString = nodeSerializeToString;
    function nodeSerializeToString(options) {
      var opts;
      if (typeof options === "function") {
        opts = { requireWellFormed: false, splitCDATASections: true, nodeFilter: options };
      } else if (options != null) {
        opts = {
          requireWellFormed: !!options.requireWellFormed,
          splitCDATASections: options.splitCDATASections !== false,
          nodeFilter: options.nodeFilter || null
        };
      } else {
        opts = { requireWellFormed: false, splitCDATASections: true, nodeFilter: null };
      }
      var buf = [];
      var refNode = this.nodeType === DOCUMENT_NODE && this.documentElement || this;
      var prefix3 = refNode.prefix;
      var uri6 = refNode.namespaceURI;
      if (uri6 && prefix3 == null) {
        var prefix3 = refNode.lookupPrefix(uri6);
        if (prefix3 == null) {
          var visibleNamespaces = [
            { namespace: uri6, prefix: null }
            //{namespace:uri,prefix:''}
          ];
        }
      }
      serializeToString(this, buf, visibleNamespaces, opts);
      return buf.join("");
    }
    function needNamespaceDefine(node3, isHTML, visibleNamespaces) {
      var prefix3 = node3.prefix || "";
      var uri6 = node3.namespaceURI;
      if (!uri6) {
        return false;
      }
      if (prefix3 === "xml" && uri6 === NAMESPACE.XML || uri6 === NAMESPACE.XMLNS) {
        return false;
      }
      var i = visibleNamespaces.length;
      while (i--) {
        var ns3 = visibleNamespaces[i];
        if (ns3.prefix === prefix3) {
          return ns3.namespace !== uri6;
        }
      }
      return true;
    }
    function addSerializedAttribute(buf, qualifiedName, value8) {
      buf.push(" ", qualifiedName, '="', value8.replace(/[<>&"\t\n\r]/g, _xmlEncoder), '"');
    }
    function serializeToString(node3, buf, visibleNamespaces, opts) {
      if (!visibleNamespaces) {
        visibleNamespaces = [];
      }
      var nodeFilter = opts.nodeFilter;
      var requireWellFormed = opts.requireWellFormed;
      var splitCDATASections = opts.splitCDATASections;
      var doc = node3.nodeType === DOCUMENT_NODE ? node3 : node3.ownerDocument;
      var isHTML = doc.type === "html";
      walkDOM(
        node3,
        { ns: visibleNamespaces },
        {
          enter: function(n3, ctx) {
            var namespaces = ctx.ns;
            if (nodeFilter) {
              n3 = nodeFilter(n3);
              if (n3) {
                if (typeof n3 == "string") {
                  buf.push(n3);
                  return null;
                }
              } else {
                return null;
              }
            }
            switch (n3.nodeType) {
              case ELEMENT_NODE:
                var attrs = n3.attributes;
                var len = attrs.length;
                var nodeName = n3.tagName;
                var prefixedNodeName = nodeName;
                if (!isHTML && !n3.prefix && n3.namespaceURI) {
                  var defaultNS;
                  for (var ai = 0; ai < attrs.length; ai++) {
                    if (attrs.item(ai).name === "xmlns") {
                      defaultNS = attrs.item(ai).value;
                      break;
                    }
                  }
                  if (!defaultNS) {
                    for (var nsi = namespaces.length - 1; nsi >= 0; nsi--) {
                      var nsEntry = namespaces[nsi];
                      if (nsEntry.prefix === "" && nsEntry.namespace === n3.namespaceURI) {
                        defaultNS = nsEntry.namespace;
                        break;
                      }
                    }
                  }
                  if (defaultNS !== n3.namespaceURI) {
                    for (var nsi = namespaces.length - 1; nsi >= 0; nsi--) {
                      var nsEntry = namespaces[nsi];
                      if (nsEntry.namespace === n3.namespaceURI) {
                        if (nsEntry.prefix) {
                          prefixedNodeName = nsEntry.prefix + ":" + nodeName;
                        }
                        break;
                      }
                    }
                  }
                }
                buf.push("<", prefixedNodeName);
                var childNamespaces = namespaces.slice();
                for (var i = 0; i < len; i++) {
                  var attr = attrs.item(i);
                  if (attr.prefix == "xmlns") {
                    childNamespaces.push({
                      prefix: attr.localName,
                      namespace: attr.value
                    });
                  } else if (attr.nodeName == "xmlns") {
                    childNamespaces.push({ prefix: "", namespace: attr.value });
                  }
                }
                for (var i = 0; i < len; i++) {
                  var attr = attrs.item(i);
                  if (needNamespaceDefine(attr, isHTML, childNamespaces)) {
                    var attrPrefix = attr.prefix || "";
                    var uri6 = attr.namespaceURI;
                    addSerializedAttribute(buf, attrPrefix ? "xmlns:" + attrPrefix : "xmlns", uri6);
                    childNamespaces.push({ prefix: attrPrefix, namespace: uri6 });
                  }
                  var filteredAttr = nodeFilter ? nodeFilter(attr) : attr;
                  if (filteredAttr) {
                    if (typeof filteredAttr === "string") {
                      buf.push(filteredAttr);
                    } else {
                      addSerializedAttribute(buf, filteredAttr.name, filteredAttr.value);
                    }
                  }
                }
                if (nodeName === prefixedNodeName && needNamespaceDefine(n3, isHTML, childNamespaces)) {
                  var nodePrefix = n3.prefix || "";
                  var uri6 = n3.namespaceURI;
                  addSerializedAttribute(buf, nodePrefix ? "xmlns:" + nodePrefix : "xmlns", uri6);
                  childNamespaces.push({ prefix: nodePrefix, namespace: uri6 });
                }
                var canCloseTag = !n3.firstChild;
                if (canCloseTag && (isHTML || n3.namespaceURI === NAMESPACE.HTML)) {
                  canCloseTag = isHTMLVoidElement(nodeName);
                }
                if (canCloseTag) {
                  buf.push("/>");
                  return null;
                }
                buf.push(">");
                if (isHTML && isHTMLRawTextElement(nodeName)) {
                  var child2 = n3.firstChild;
                  while (child2) {
                    if (child2.data) {
                      buf.push(child2.data);
                    } else {
                      serializeToString(child2, buf, childNamespaces.slice(), opts);
                    }
                    child2 = child2.nextSibling;
                  }
                  buf.push("</", prefixedNodeName, ">");
                  return null;
                }
                return { ns: childNamespaces, tag: prefixedNodeName };
              case DOCUMENT_NODE:
              case DOCUMENT_FRAGMENT_NODE:
                if (requireWellFormed && n3.nodeType === DOCUMENT_NODE && n3.documentElement == null) {
                  throw new DOMException("The Document has no documentElement", DOMExceptionName.InvalidStateError);
                }
                return { ns: namespaces };
              case ATTRIBUTE_NODE:
                addSerializedAttribute(buf, n3.name, n3.value);
                return null;
              case TEXT_NODE:
                if (requireWellFormed && g.InvalidChar.test(n3.data)) {
                  throw new DOMException(
                    "The Text node data contains characters outside the XML Char production",
                    DOMExceptionName.InvalidStateError
                  );
                }
                buf.push(n3.data.replace(/[<&>]/g, _xmlEncoder));
                return null;
              case CDATA_SECTION_NODE:
                if (requireWellFormed && n3.data.indexOf("]]>") !== -1) {
                  throw new DOMException('The CDATASection data contains "]]>"', DOMExceptionName.InvalidStateError);
                }
                if (splitCDATASections) {
                  buf.push(g.CDATA_START, n3.data.replace(/]]>/g, "]]]]><![CDATA[>"), g.CDATA_END);
                } else {
                  buf.push(g.CDATA_START, n3.data, g.CDATA_END);
                }
                return null;
              case COMMENT_NODE:
                if (requireWellFormed) {
                  if (g.InvalidChar.test(n3.data)) {
                    throw new DOMException(
                      "The comment node data contains characters outside the XML Char production",
                      DOMExceptionName.InvalidStateError
                    );
                  }
                  if (n3.data.indexOf("--") !== -1 || n3.data[n3.data.length - 1] === "-") {
                    throw new DOMException(
                      'The comment node data contains "--" or ends with "-"',
                      DOMExceptionName.InvalidStateError
                    );
                  }
                }
                buf.push(g.COMMENT_START, n3.data, g.COMMENT_END);
                return null;
              case DOCUMENT_TYPE_NODE:
                var pubid = n3.publicId;
                var sysid = n3.systemId;
                if (requireWellFormed) {
                  if (pubid && !g.PubidLiteral_match.test(pubid)) {
                    throw new DOMException("DocumentType publicId is not a valid PubidLiteral", DOMExceptionName.InvalidStateError);
                  }
                  if (sysid && sysid !== "." && !g.SystemLiteral_match.test(sysid)) {
                    throw new DOMException("DocumentType systemId is not a valid SystemLiteral", DOMExceptionName.InvalidStateError);
                  }
                  if (n3.internalSubset && n3.internalSubset.indexOf("]>") !== -1) {
                    throw new DOMException('DocumentType internalSubset contains "]>"', DOMExceptionName.InvalidStateError);
                  }
                }
                buf.push(g.DOCTYPE_DECL_START, " ", n3.name);
                if (pubid) {
                  buf.push(" ", g.PUBLIC, " ", pubid);
                  if (sysid && sysid !== ".") {
                    buf.push(" ", sysid);
                  }
                } else if (sysid && sysid !== ".") {
                  buf.push(" ", g.SYSTEM, " ", sysid);
                }
                if (n3.internalSubset) {
                  buf.push(" [", n3.internalSubset, "]");
                }
                buf.push(">");
                return null;
              case PROCESSING_INSTRUCTION_NODE:
                if (requireWellFormed) {
                  if (n3.target.indexOf(":") !== -1 || n3.target.toLowerCase() === "xml") {
                    throw new DOMException("The ProcessingInstruction target is not well-formed", DOMExceptionName.InvalidStateError);
                  }
                  if (g.InvalidChar.test(n3.data)) {
                    throw new DOMException(
                      "The ProcessingInstruction data contains characters outside the XML Char production",
                      DOMExceptionName.InvalidStateError
                    );
                  }
                  if (n3.data.indexOf("?>") !== -1) {
                    throw new DOMException('The ProcessingInstruction data contains "?>"', DOMExceptionName.InvalidStateError);
                  }
                }
                buf.push("<?", n3.target, " ", n3.data, "?>");
                return null;
              case ENTITY_REFERENCE_NODE:
                buf.push("&", n3.nodeName, ";");
                return null;
              //case ENTITY_NODE:
              //case NOTATION_NODE:
              default:
                buf.push("??", n3.nodeName);
                return null;
            }
          },
          exit: function(n3, childCtx) {
            if (childCtx && childCtx.tag) {
              buf.push("</", childCtx.tag, ">");
            }
          }
        }
      );
    }
    function importNode(doc, node3, deep) {
      var destRoot;
      walkDOM(node3, null, {
        enter: function(srcNode, destParent) {
          var destNode = srcNode.cloneNode(false);
          destNode.ownerDocument = doc;
          destNode.parentNode = null;
          if (destParent === null) {
            destRoot = destNode;
          } else {
            destParent.appendChild(destNode);
          }
          var shouldDeep = srcNode.nodeType === ATTRIBUTE_NODE || deep;
          return shouldDeep ? destNode : null;
        }
      });
      return destRoot;
    }
    function cloneNode(doc, node3, deep) {
      var destRoot;
      walkDOM(node3, null, {
        enter: function(srcNode, destParent) {
          var destNode = new srcNode.constructor(PDC);
          for (var n3 in srcNode) {
            if (hasOwn(srcNode, n3)) {
              var v2 = srcNode[n3];
              if (typeof v2 != "object") {
                if (v2 != destNode[n3]) {
                  destNode[n3] = v2;
                }
              }
            }
          }
          if (srcNode.childNodes) {
            destNode.childNodes = new NodeList();
          }
          destNode.ownerDocument = doc;
          var shouldDeep = deep;
          switch (destNode.nodeType) {
            case ELEMENT_NODE:
              var attrs = srcNode.attributes;
              var attrs2 = destNode.attributes = new NamedNodeMap();
              var len = attrs.length;
              attrs2._ownerElement = destNode;
              for (var i = 0; i < len; i++) {
                destNode.setAttributeNode(cloneNode(doc, attrs.item(i), true));
              }
              break;
            case ATTRIBUTE_NODE:
              shouldDeep = true;
          }
          if (destParent !== null) {
            destParent.appendChild(destNode);
          } else {
            destRoot = destNode;
          }
          return shouldDeep ? destNode : null;
        }
      });
      return destRoot;
    }
    function __set__(object8, key3, value8) {
      object8[key3] = value8;
    }
    function childrenRefresh(node3) {
      var ls = [];
      var child2 = node3.firstChild;
      while (child2) {
        if (child2.nodeType === ELEMENT_NODE) {
          ls.push(child2);
        }
        child2 = child2.nextSibling;
      }
      return ls;
    }
    try {
      if (Object.defineProperty) {
        Object.defineProperty(LiveNodeList.prototype, "length", {
          get: function() {
            _updateLiveList(this);
            return this.$$length;
          }
        });
        Object.defineProperty(Node3.prototype, "textContent", {
          get: function() {
            if (this.nodeType === ELEMENT_NODE || this.nodeType === DOCUMENT_FRAGMENT_NODE) {
              var buf = [];
              walkDOM(this, null, {
                enter: function(n3) {
                  if (n3.nodeType === ELEMENT_NODE || n3.nodeType === DOCUMENT_FRAGMENT_NODE) {
                    return true;
                  }
                  if (n3.nodeType === PROCESSING_INSTRUCTION_NODE || n3.nodeType === COMMENT_NODE) {
                    return null;
                  }
                  buf.push(n3.nodeValue);
                }
              });
              return buf.join("");
            }
            return this.nodeValue;
          },
          set: function(data4) {
            switch (this.nodeType) {
              case ELEMENT_NODE:
              case DOCUMENT_FRAGMENT_NODE:
                while (this.firstChild) {
                  this.removeChild(this.firstChild);
                }
                if (data4 || String(data4)) {
                  this.appendChild(this.ownerDocument.createTextNode(data4));
                }
                break;
              default:
                this.data = data4;
                this.value = data4;
                this.nodeValue = data4;
            }
          }
        });
        Object.defineProperty(Element2.prototype, "children", {
          get: function() {
            return new LiveNodeList(this, childrenRefresh);
          }
        });
        Object.defineProperty(Document6.prototype, "children", {
          get: function() {
            return new LiveNodeList(this, childrenRefresh);
          }
        });
        Object.defineProperty(DocumentFragment.prototype, "children", {
          get: function() {
            return new LiveNodeList(this, childrenRefresh);
          }
        });
        __set__ = function(object8, key3, value8) {
          object8["$$" + key3] = value8;
        };
      }
    } catch (e) {
    }
    exports._updateLiveList = _updateLiveList;
    exports.Attr = Attr;
    exports.CDATASection = CDATASection;
    exports.CharacterData = CharacterData;
    exports.Comment = Comment3;
    exports.Document = Document6;
    exports.DocumentFragment = DocumentFragment;
    exports.DocumentType = DocumentType;
    exports.DOMImplementation = DOMImplementation;
    exports.Element = Element2;
    exports.Entity = Entity2;
    exports.EntityReference = EntityReference;
    exports.LiveNodeList = LiveNodeList;
    exports.NamedNodeMap = NamedNodeMap;
    exports.Node = Node3;
    exports.NodeList = NodeList;
    exports.Notation = Notation;
    exports.Text = Text4;
    exports.ProcessingInstruction = ProcessingInstruction;
    exports.walkDOM = walkDOM;
    exports.XMLSerializer = XMLSerializer;
  }
});

// node_modules/@xmldom/xmldom/lib/entities.js
var require_entities = __commonJS({
  "node_modules/@xmldom/xmldom/lib/entities.js"(exports) {
    "use strict";
    var freeze = require_conventions().freeze;
    exports.XML_ENTITIES = freeze({
      amp: "&",
      apos: "'",
      gt: ">",
      lt: "<",
      quot: '"'
    });
    exports.HTML_ENTITIES = freeze({
      Aacute: "\xC1",
      aacute: "\xE1",
      Abreve: "\u0102",
      abreve: "\u0103",
      ac: "\u223E",
      acd: "\u223F",
      acE: "\u223E\u0333",
      Acirc: "\xC2",
      acirc: "\xE2",
      acute: "\xB4",
      Acy: "\u0410",
      acy: "\u0430",
      AElig: "\xC6",
      aelig: "\xE6",
      af: "\u2061",
      Afr: "\u{1D504}",
      afr: "\u{1D51E}",
      Agrave: "\xC0",
      agrave: "\xE0",
      alefsym: "\u2135",
      aleph: "\u2135",
      Alpha: "\u0391",
      alpha: "\u03B1",
      Amacr: "\u0100",
      amacr: "\u0101",
      amalg: "\u2A3F",
      AMP: "&",
      amp: "&",
      And: "\u2A53",
      and: "\u2227",
      andand: "\u2A55",
      andd: "\u2A5C",
      andslope: "\u2A58",
      andv: "\u2A5A",
      ang: "\u2220",
      ange: "\u29A4",
      angle: "\u2220",
      angmsd: "\u2221",
      angmsdaa: "\u29A8",
      angmsdab: "\u29A9",
      angmsdac: "\u29AA",
      angmsdad: "\u29AB",
      angmsdae: "\u29AC",
      angmsdaf: "\u29AD",
      angmsdag: "\u29AE",
      angmsdah: "\u29AF",
      angrt: "\u221F",
      angrtvb: "\u22BE",
      angrtvbd: "\u299D",
      angsph: "\u2222",
      angst: "\xC5",
      angzarr: "\u237C",
      Aogon: "\u0104",
      aogon: "\u0105",
      Aopf: "\u{1D538}",
      aopf: "\u{1D552}",
      ap: "\u2248",
      apacir: "\u2A6F",
      apE: "\u2A70",
      ape: "\u224A",
      apid: "\u224B",
      apos: "'",
      ApplyFunction: "\u2061",
      approx: "\u2248",
      approxeq: "\u224A",
      Aring: "\xC5",
      aring: "\xE5",
      Ascr: "\u{1D49C}",
      ascr: "\u{1D4B6}",
      Assign: "\u2254",
      ast: "*",
      asymp: "\u2248",
      asympeq: "\u224D",
      Atilde: "\xC3",
      atilde: "\xE3",
      Auml: "\xC4",
      auml: "\xE4",
      awconint: "\u2233",
      awint: "\u2A11",
      backcong: "\u224C",
      backepsilon: "\u03F6",
      backprime: "\u2035",
      backsim: "\u223D",
      backsimeq: "\u22CD",
      Backslash: "\u2216",
      Barv: "\u2AE7",
      barvee: "\u22BD",
      Barwed: "\u2306",
      barwed: "\u2305",
      barwedge: "\u2305",
      bbrk: "\u23B5",
      bbrktbrk: "\u23B6",
      bcong: "\u224C",
      Bcy: "\u0411",
      bcy: "\u0431",
      bdquo: "\u201E",
      becaus: "\u2235",
      Because: "\u2235",
      because: "\u2235",
      bemptyv: "\u29B0",
      bepsi: "\u03F6",
      bernou: "\u212C",
      Bernoullis: "\u212C",
      Beta: "\u0392",
      beta: "\u03B2",
      beth: "\u2136",
      between: "\u226C",
      Bfr: "\u{1D505}",
      bfr: "\u{1D51F}",
      bigcap: "\u22C2",
      bigcirc: "\u25EF",
      bigcup: "\u22C3",
      bigodot: "\u2A00",
      bigoplus: "\u2A01",
      bigotimes: "\u2A02",
      bigsqcup: "\u2A06",
      bigstar: "\u2605",
      bigtriangledown: "\u25BD",
      bigtriangleup: "\u25B3",
      biguplus: "\u2A04",
      bigvee: "\u22C1",
      bigwedge: "\u22C0",
      bkarow: "\u290D",
      blacklozenge: "\u29EB",
      blacksquare: "\u25AA",
      blacktriangle: "\u25B4",
      blacktriangledown: "\u25BE",
      blacktriangleleft: "\u25C2",
      blacktriangleright: "\u25B8",
      blank: "\u2423",
      blk12: "\u2592",
      blk14: "\u2591",
      blk34: "\u2593",
      block: "\u2588",
      bne: "=\u20E5",
      bnequiv: "\u2261\u20E5",
      bNot: "\u2AED",
      bnot: "\u2310",
      Bopf: "\u{1D539}",
      bopf: "\u{1D553}",
      bot: "\u22A5",
      bottom: "\u22A5",
      bowtie: "\u22C8",
      boxbox: "\u29C9",
      boxDL: "\u2557",
      boxDl: "\u2556",
      boxdL: "\u2555",
      boxdl: "\u2510",
      boxDR: "\u2554",
      boxDr: "\u2553",
      boxdR: "\u2552",
      boxdr: "\u250C",
      boxH: "\u2550",
      boxh: "\u2500",
      boxHD: "\u2566",
      boxHd: "\u2564",
      boxhD: "\u2565",
      boxhd: "\u252C",
      boxHU: "\u2569",
      boxHu: "\u2567",
      boxhU: "\u2568",
      boxhu: "\u2534",
      boxminus: "\u229F",
      boxplus: "\u229E",
      boxtimes: "\u22A0",
      boxUL: "\u255D",
      boxUl: "\u255C",
      boxuL: "\u255B",
      boxul: "\u2518",
      boxUR: "\u255A",
      boxUr: "\u2559",
      boxuR: "\u2558",
      boxur: "\u2514",
      boxV: "\u2551",
      boxv: "\u2502",
      boxVH: "\u256C",
      boxVh: "\u256B",
      boxvH: "\u256A",
      boxvh: "\u253C",
      boxVL: "\u2563",
      boxVl: "\u2562",
      boxvL: "\u2561",
      boxvl: "\u2524",
      boxVR: "\u2560",
      boxVr: "\u255F",
      boxvR: "\u255E",
      boxvr: "\u251C",
      bprime: "\u2035",
      Breve: "\u02D8",
      breve: "\u02D8",
      brvbar: "\xA6",
      Bscr: "\u212C",
      bscr: "\u{1D4B7}",
      bsemi: "\u204F",
      bsim: "\u223D",
      bsime: "\u22CD",
      bsol: "\\",
      bsolb: "\u29C5",
      bsolhsub: "\u27C8",
      bull: "\u2022",
      bullet: "\u2022",
      bump: "\u224E",
      bumpE: "\u2AAE",
      bumpe: "\u224F",
      Bumpeq: "\u224E",
      bumpeq: "\u224F",
      Cacute: "\u0106",
      cacute: "\u0107",
      Cap: "\u22D2",
      cap: "\u2229",
      capand: "\u2A44",
      capbrcup: "\u2A49",
      capcap: "\u2A4B",
      capcup: "\u2A47",
      capdot: "\u2A40",
      CapitalDifferentialD: "\u2145",
      caps: "\u2229\uFE00",
      caret: "\u2041",
      caron: "\u02C7",
      Cayleys: "\u212D",
      ccaps: "\u2A4D",
      Ccaron: "\u010C",
      ccaron: "\u010D",
      Ccedil: "\xC7",
      ccedil: "\xE7",
      Ccirc: "\u0108",
      ccirc: "\u0109",
      Cconint: "\u2230",
      ccups: "\u2A4C",
      ccupssm: "\u2A50",
      Cdot: "\u010A",
      cdot: "\u010B",
      cedil: "\xB8",
      Cedilla: "\xB8",
      cemptyv: "\u29B2",
      cent: "\xA2",
      CenterDot: "\xB7",
      centerdot: "\xB7",
      Cfr: "\u212D",
      cfr: "\u{1D520}",
      CHcy: "\u0427",
      chcy: "\u0447",
      check: "\u2713",
      checkmark: "\u2713",
      Chi: "\u03A7",
      chi: "\u03C7",
      cir: "\u25CB",
      circ: "\u02C6",
      circeq: "\u2257",
      circlearrowleft: "\u21BA",
      circlearrowright: "\u21BB",
      circledast: "\u229B",
      circledcirc: "\u229A",
      circleddash: "\u229D",
      CircleDot: "\u2299",
      circledR: "\xAE",
      circledS: "\u24C8",
      CircleMinus: "\u2296",
      CirclePlus: "\u2295",
      CircleTimes: "\u2297",
      cirE: "\u29C3",
      cire: "\u2257",
      cirfnint: "\u2A10",
      cirmid: "\u2AEF",
      cirscir: "\u29C2",
      ClockwiseContourIntegral: "\u2232",
      CloseCurlyDoubleQuote: "\u201D",
      CloseCurlyQuote: "\u2019",
      clubs: "\u2663",
      clubsuit: "\u2663",
      Colon: "\u2237",
      colon: ":",
      Colone: "\u2A74",
      colone: "\u2254",
      coloneq: "\u2254",
      comma: ",",
      commat: "@",
      comp: "\u2201",
      compfn: "\u2218",
      complement: "\u2201",
      complexes: "\u2102",
      cong: "\u2245",
      congdot: "\u2A6D",
      Congruent: "\u2261",
      Conint: "\u222F",
      conint: "\u222E",
      ContourIntegral: "\u222E",
      Copf: "\u2102",
      copf: "\u{1D554}",
      coprod: "\u2210",
      Coproduct: "\u2210",
      COPY: "\xA9",
      copy: "\xA9",
      copysr: "\u2117",
      CounterClockwiseContourIntegral: "\u2233",
      crarr: "\u21B5",
      Cross: "\u2A2F",
      cross: "\u2717",
      Cscr: "\u{1D49E}",
      cscr: "\u{1D4B8}",
      csub: "\u2ACF",
      csube: "\u2AD1",
      csup: "\u2AD0",
      csupe: "\u2AD2",
      ctdot: "\u22EF",
      cudarrl: "\u2938",
      cudarrr: "\u2935",
      cuepr: "\u22DE",
      cuesc: "\u22DF",
      cularr: "\u21B6",
      cularrp: "\u293D",
      Cup: "\u22D3",
      cup: "\u222A",
      cupbrcap: "\u2A48",
      CupCap: "\u224D",
      cupcap: "\u2A46",
      cupcup: "\u2A4A",
      cupdot: "\u228D",
      cupor: "\u2A45",
      cups: "\u222A\uFE00",
      curarr: "\u21B7",
      curarrm: "\u293C",
      curlyeqprec: "\u22DE",
      curlyeqsucc: "\u22DF",
      curlyvee: "\u22CE",
      curlywedge: "\u22CF",
      curren: "\xA4",
      curvearrowleft: "\u21B6",
      curvearrowright: "\u21B7",
      cuvee: "\u22CE",
      cuwed: "\u22CF",
      cwconint: "\u2232",
      cwint: "\u2231",
      cylcty: "\u232D",
      Dagger: "\u2021",
      dagger: "\u2020",
      daleth: "\u2138",
      Darr: "\u21A1",
      dArr: "\u21D3",
      darr: "\u2193",
      dash: "\u2010",
      Dashv: "\u2AE4",
      dashv: "\u22A3",
      dbkarow: "\u290F",
      dblac: "\u02DD",
      Dcaron: "\u010E",
      dcaron: "\u010F",
      Dcy: "\u0414",
      dcy: "\u0434",
      DD: "\u2145",
      dd: "\u2146",
      ddagger: "\u2021",
      ddarr: "\u21CA",
      DDotrahd: "\u2911",
      ddotseq: "\u2A77",
      deg: "\xB0",
      Del: "\u2207",
      Delta: "\u0394",
      delta: "\u03B4",
      demptyv: "\u29B1",
      dfisht: "\u297F",
      Dfr: "\u{1D507}",
      dfr: "\u{1D521}",
      dHar: "\u2965",
      dharl: "\u21C3",
      dharr: "\u21C2",
      DiacriticalAcute: "\xB4",
      DiacriticalDot: "\u02D9",
      DiacriticalDoubleAcute: "\u02DD",
      DiacriticalGrave: "`",
      DiacriticalTilde: "\u02DC",
      diam: "\u22C4",
      Diamond: "\u22C4",
      diamond: "\u22C4",
      diamondsuit: "\u2666",
      diams: "\u2666",
      die: "\xA8",
      DifferentialD: "\u2146",
      digamma: "\u03DD",
      disin: "\u22F2",
      div: "\xF7",
      divide: "\xF7",
      divideontimes: "\u22C7",
      divonx: "\u22C7",
      DJcy: "\u0402",
      djcy: "\u0452",
      dlcorn: "\u231E",
      dlcrop: "\u230D",
      dollar: "$",
      Dopf: "\u{1D53B}",
      dopf: "\u{1D555}",
      Dot: "\xA8",
      dot: "\u02D9",
      DotDot: "\u20DC",
      doteq: "\u2250",
      doteqdot: "\u2251",
      DotEqual: "\u2250",
      dotminus: "\u2238",
      dotplus: "\u2214",
      dotsquare: "\u22A1",
      doublebarwedge: "\u2306",
      DoubleContourIntegral: "\u222F",
      DoubleDot: "\xA8",
      DoubleDownArrow: "\u21D3",
      DoubleLeftArrow: "\u21D0",
      DoubleLeftRightArrow: "\u21D4",
      DoubleLeftTee: "\u2AE4",
      DoubleLongLeftArrow: "\u27F8",
      DoubleLongLeftRightArrow: "\u27FA",
      DoubleLongRightArrow: "\u27F9",
      DoubleRightArrow: "\u21D2",
      DoubleRightTee: "\u22A8",
      DoubleUpArrow: "\u21D1",
      DoubleUpDownArrow: "\u21D5",
      DoubleVerticalBar: "\u2225",
      DownArrow: "\u2193",
      Downarrow: "\u21D3",
      downarrow: "\u2193",
      DownArrowBar: "\u2913",
      DownArrowUpArrow: "\u21F5",
      DownBreve: "\u0311",
      downdownarrows: "\u21CA",
      downharpoonleft: "\u21C3",
      downharpoonright: "\u21C2",
      DownLeftRightVector: "\u2950",
      DownLeftTeeVector: "\u295E",
      DownLeftVector: "\u21BD",
      DownLeftVectorBar: "\u2956",
      DownRightTeeVector: "\u295F",
      DownRightVector: "\u21C1",
      DownRightVectorBar: "\u2957",
      DownTee: "\u22A4",
      DownTeeArrow: "\u21A7",
      drbkarow: "\u2910",
      drcorn: "\u231F",
      drcrop: "\u230C",
      Dscr: "\u{1D49F}",
      dscr: "\u{1D4B9}",
      DScy: "\u0405",
      dscy: "\u0455",
      dsol: "\u29F6",
      Dstrok: "\u0110",
      dstrok: "\u0111",
      dtdot: "\u22F1",
      dtri: "\u25BF",
      dtrif: "\u25BE",
      duarr: "\u21F5",
      duhar: "\u296F",
      dwangle: "\u29A6",
      DZcy: "\u040F",
      dzcy: "\u045F",
      dzigrarr: "\u27FF",
      Eacute: "\xC9",
      eacute: "\xE9",
      easter: "\u2A6E",
      Ecaron: "\u011A",
      ecaron: "\u011B",
      ecir: "\u2256",
      Ecirc: "\xCA",
      ecirc: "\xEA",
      ecolon: "\u2255",
      Ecy: "\u042D",
      ecy: "\u044D",
      eDDot: "\u2A77",
      Edot: "\u0116",
      eDot: "\u2251",
      edot: "\u0117",
      ee: "\u2147",
      efDot: "\u2252",
      Efr: "\u{1D508}",
      efr: "\u{1D522}",
      eg: "\u2A9A",
      Egrave: "\xC8",
      egrave: "\xE8",
      egs: "\u2A96",
      egsdot: "\u2A98",
      el: "\u2A99",
      Element: "\u2208",
      elinters: "\u23E7",
      ell: "\u2113",
      els: "\u2A95",
      elsdot: "\u2A97",
      Emacr: "\u0112",
      emacr: "\u0113",
      empty: "\u2205",
      emptyset: "\u2205",
      EmptySmallSquare: "\u25FB",
      emptyv: "\u2205",
      EmptyVerySmallSquare: "\u25AB",
      emsp: "\u2003",
      emsp13: "\u2004",
      emsp14: "\u2005",
      ENG: "\u014A",
      eng: "\u014B",
      ensp: "\u2002",
      Eogon: "\u0118",
      eogon: "\u0119",
      Eopf: "\u{1D53C}",
      eopf: "\u{1D556}",
      epar: "\u22D5",
      eparsl: "\u29E3",
      eplus: "\u2A71",
      epsi: "\u03B5",
      Epsilon: "\u0395",
      epsilon: "\u03B5",
      epsiv: "\u03F5",
      eqcirc: "\u2256",
      eqcolon: "\u2255",
      eqsim: "\u2242",
      eqslantgtr: "\u2A96",
      eqslantless: "\u2A95",
      Equal: "\u2A75",
      equals: "=",
      EqualTilde: "\u2242",
      equest: "\u225F",
      Equilibrium: "\u21CC",
      equiv: "\u2261",
      equivDD: "\u2A78",
      eqvparsl: "\u29E5",
      erarr: "\u2971",
      erDot: "\u2253",
      Escr: "\u2130",
      escr: "\u212F",
      esdot: "\u2250",
      Esim: "\u2A73",
      esim: "\u2242",
      Eta: "\u0397",
      eta: "\u03B7",
      ETH: "\xD0",
      eth: "\xF0",
      Euml: "\xCB",
      euml: "\xEB",
      euro: "\u20AC",
      excl: "!",
      exist: "\u2203",
      Exists: "\u2203",
      expectation: "\u2130",
      ExponentialE: "\u2147",
      exponentiale: "\u2147",
      fallingdotseq: "\u2252",
      Fcy: "\u0424",
      fcy: "\u0444",
      female: "\u2640",
      ffilig: "\uFB03",
      fflig: "\uFB00",
      ffllig: "\uFB04",
      Ffr: "\u{1D509}",
      ffr: "\u{1D523}",
      filig: "\uFB01",
      FilledSmallSquare: "\u25FC",
      FilledVerySmallSquare: "\u25AA",
      fjlig: "fj",
      flat: "\u266D",
      fllig: "\uFB02",
      fltns: "\u25B1",
      fnof: "\u0192",
      Fopf: "\u{1D53D}",
      fopf: "\u{1D557}",
      ForAll: "\u2200",
      forall: "\u2200",
      fork: "\u22D4",
      forkv: "\u2AD9",
      Fouriertrf: "\u2131",
      fpartint: "\u2A0D",
      frac12: "\xBD",
      frac13: "\u2153",
      frac14: "\xBC",
      frac15: "\u2155",
      frac16: "\u2159",
      frac18: "\u215B",
      frac23: "\u2154",
      frac25: "\u2156",
      frac34: "\xBE",
      frac35: "\u2157",
      frac38: "\u215C",
      frac45: "\u2158",
      frac56: "\u215A",
      frac58: "\u215D",
      frac78: "\u215E",
      frasl: "\u2044",
      frown: "\u2322",
      Fscr: "\u2131",
      fscr: "\u{1D4BB}",
      gacute: "\u01F5",
      Gamma: "\u0393",
      gamma: "\u03B3",
      Gammad: "\u03DC",
      gammad: "\u03DD",
      gap: "\u2A86",
      Gbreve: "\u011E",
      gbreve: "\u011F",
      Gcedil: "\u0122",
      Gcirc: "\u011C",
      gcirc: "\u011D",
      Gcy: "\u0413",
      gcy: "\u0433",
      Gdot: "\u0120",
      gdot: "\u0121",
      gE: "\u2267",
      ge: "\u2265",
      gEl: "\u2A8C",
      gel: "\u22DB",
      geq: "\u2265",
      geqq: "\u2267",
      geqslant: "\u2A7E",
      ges: "\u2A7E",
      gescc: "\u2AA9",
      gesdot: "\u2A80",
      gesdoto: "\u2A82",
      gesdotol: "\u2A84",
      gesl: "\u22DB\uFE00",
      gesles: "\u2A94",
      Gfr: "\u{1D50A}",
      gfr: "\u{1D524}",
      Gg: "\u22D9",
      gg: "\u226B",
      ggg: "\u22D9",
      gimel: "\u2137",
      GJcy: "\u0403",
      gjcy: "\u0453",
      gl: "\u2277",
      gla: "\u2AA5",
      glE: "\u2A92",
      glj: "\u2AA4",
      gnap: "\u2A8A",
      gnapprox: "\u2A8A",
      gnE: "\u2269",
      gne: "\u2A88",
      gneq: "\u2A88",
      gneqq: "\u2269",
      gnsim: "\u22E7",
      Gopf: "\u{1D53E}",
      gopf: "\u{1D558}",
      grave: "`",
      GreaterEqual: "\u2265",
      GreaterEqualLess: "\u22DB",
      GreaterFullEqual: "\u2267",
      GreaterGreater: "\u2AA2",
      GreaterLess: "\u2277",
      GreaterSlantEqual: "\u2A7E",
      GreaterTilde: "\u2273",
      Gscr: "\u{1D4A2}",
      gscr: "\u210A",
      gsim: "\u2273",
      gsime: "\u2A8E",
      gsiml: "\u2A90",
      Gt: "\u226B",
      GT: ">",
      gt: ">",
      gtcc: "\u2AA7",
      gtcir: "\u2A7A",
      gtdot: "\u22D7",
      gtlPar: "\u2995",
      gtquest: "\u2A7C",
      gtrapprox: "\u2A86",
      gtrarr: "\u2978",
      gtrdot: "\u22D7",
      gtreqless: "\u22DB",
      gtreqqless: "\u2A8C",
      gtrless: "\u2277",
      gtrsim: "\u2273",
      gvertneqq: "\u2269\uFE00",
      gvnE: "\u2269\uFE00",
      Hacek: "\u02C7",
      hairsp: "\u200A",
      half: "\xBD",
      hamilt: "\u210B",
      HARDcy: "\u042A",
      hardcy: "\u044A",
      hArr: "\u21D4",
      harr: "\u2194",
      harrcir: "\u2948",
      harrw: "\u21AD",
      Hat: "^",
      hbar: "\u210F",
      Hcirc: "\u0124",
      hcirc: "\u0125",
      hearts: "\u2665",
      heartsuit: "\u2665",
      hellip: "\u2026",
      hercon: "\u22B9",
      Hfr: "\u210C",
      hfr: "\u{1D525}",
      HilbertSpace: "\u210B",
      hksearow: "\u2925",
      hkswarow: "\u2926",
      hoarr: "\u21FF",
      homtht: "\u223B",
      hookleftarrow: "\u21A9",
      hookrightarrow: "\u21AA",
      Hopf: "\u210D",
      hopf: "\u{1D559}",
      horbar: "\u2015",
      HorizontalLine: "\u2500",
      Hscr: "\u210B",
      hscr: "\u{1D4BD}",
      hslash: "\u210F",
      Hstrok: "\u0126",
      hstrok: "\u0127",
      HumpDownHump: "\u224E",
      HumpEqual: "\u224F",
      hybull: "\u2043",
      hyphen: "\u2010",
      Iacute: "\xCD",
      iacute: "\xED",
      ic: "\u2063",
      Icirc: "\xCE",
      icirc: "\xEE",
      Icy: "\u0418",
      icy: "\u0438",
      Idot: "\u0130",
      IEcy: "\u0415",
      iecy: "\u0435",
      iexcl: "\xA1",
      iff: "\u21D4",
      Ifr: "\u2111",
      ifr: "\u{1D526}",
      Igrave: "\xCC",
      igrave: "\xEC",
      ii: "\u2148",
      iiiint: "\u2A0C",
      iiint: "\u222D",
      iinfin: "\u29DC",
      iiota: "\u2129",
      IJlig: "\u0132",
      ijlig: "\u0133",
      Im: "\u2111",
      Imacr: "\u012A",
      imacr: "\u012B",
      image: "\u2111",
      ImaginaryI: "\u2148",
      imagline: "\u2110",
      imagpart: "\u2111",
      imath: "\u0131",
      imof: "\u22B7",
      imped: "\u01B5",
      Implies: "\u21D2",
      in: "\u2208",
      incare: "\u2105",
      infin: "\u221E",
      infintie: "\u29DD",
      inodot: "\u0131",
      Int: "\u222C",
      int: "\u222B",
      intcal: "\u22BA",
      integers: "\u2124",
      Integral: "\u222B",
      intercal: "\u22BA",
      Intersection: "\u22C2",
      intlarhk: "\u2A17",
      intprod: "\u2A3C",
      InvisibleComma: "\u2063",
      InvisibleTimes: "\u2062",
      IOcy: "\u0401",
      iocy: "\u0451",
      Iogon: "\u012E",
      iogon: "\u012F",
      Iopf: "\u{1D540}",
      iopf: "\u{1D55A}",
      Iota: "\u0399",
      iota: "\u03B9",
      iprod: "\u2A3C",
      iquest: "\xBF",
      Iscr: "\u2110",
      iscr: "\u{1D4BE}",
      isin: "\u2208",
      isindot: "\u22F5",
      isinE: "\u22F9",
      isins: "\u22F4",
      isinsv: "\u22F3",
      isinv: "\u2208",
      it: "\u2062",
      Itilde: "\u0128",
      itilde: "\u0129",
      Iukcy: "\u0406",
      iukcy: "\u0456",
      Iuml: "\xCF",
      iuml: "\xEF",
      Jcirc: "\u0134",
      jcirc: "\u0135",
      Jcy: "\u0419",
      jcy: "\u0439",
      Jfr: "\u{1D50D}",
      jfr: "\u{1D527}",
      jmath: "\u0237",
      Jopf: "\u{1D541}",
      jopf: "\u{1D55B}",
      Jscr: "\u{1D4A5}",
      jscr: "\u{1D4BF}",
      Jsercy: "\u0408",
      jsercy: "\u0458",
      Jukcy: "\u0404",
      jukcy: "\u0454",
      Kappa: "\u039A",
      kappa: "\u03BA",
      kappav: "\u03F0",
      Kcedil: "\u0136",
      kcedil: "\u0137",
      Kcy: "\u041A",
      kcy: "\u043A",
      Kfr: "\u{1D50E}",
      kfr: "\u{1D528}",
      kgreen: "\u0138",
      KHcy: "\u0425",
      khcy: "\u0445",
      KJcy: "\u040C",
      kjcy: "\u045C",
      Kopf: "\u{1D542}",
      kopf: "\u{1D55C}",
      Kscr: "\u{1D4A6}",
      kscr: "\u{1D4C0}",
      lAarr: "\u21DA",
      Lacute: "\u0139",
      lacute: "\u013A",
      laemptyv: "\u29B4",
      lagran: "\u2112",
      Lambda: "\u039B",
      lambda: "\u03BB",
      Lang: "\u27EA",
      lang: "\u27E8",
      langd: "\u2991",
      langle: "\u27E8",
      lap: "\u2A85",
      Laplacetrf: "\u2112",
      laquo: "\xAB",
      Larr: "\u219E",
      lArr: "\u21D0",
      larr: "\u2190",
      larrb: "\u21E4",
      larrbfs: "\u291F",
      larrfs: "\u291D",
      larrhk: "\u21A9",
      larrlp: "\u21AB",
      larrpl: "\u2939",
      larrsim: "\u2973",
      larrtl: "\u21A2",
      lat: "\u2AAB",
      lAtail: "\u291B",
      latail: "\u2919",
      late: "\u2AAD",
      lates: "\u2AAD\uFE00",
      lBarr: "\u290E",
      lbarr: "\u290C",
      lbbrk: "\u2772",
      lbrace: "{",
      lbrack: "[",
      lbrke: "\u298B",
      lbrksld: "\u298F",
      lbrkslu: "\u298D",
      Lcaron: "\u013D",
      lcaron: "\u013E",
      Lcedil: "\u013B",
      lcedil: "\u013C",
      lceil: "\u2308",
      lcub: "{",
      Lcy: "\u041B",
      lcy: "\u043B",
      ldca: "\u2936",
      ldquo: "\u201C",
      ldquor: "\u201E",
      ldrdhar: "\u2967",
      ldrushar: "\u294B",
      ldsh: "\u21B2",
      lE: "\u2266",
      le: "\u2264",
      LeftAngleBracket: "\u27E8",
      LeftArrow: "\u2190",
      Leftarrow: "\u21D0",
      leftarrow: "\u2190",
      LeftArrowBar: "\u21E4",
      LeftArrowRightArrow: "\u21C6",
      leftarrowtail: "\u21A2",
      LeftCeiling: "\u2308",
      LeftDoubleBracket: "\u27E6",
      LeftDownTeeVector: "\u2961",
      LeftDownVector: "\u21C3",
      LeftDownVectorBar: "\u2959",
      LeftFloor: "\u230A",
      leftharpoondown: "\u21BD",
      leftharpoonup: "\u21BC",
      leftleftarrows: "\u21C7",
      LeftRightArrow: "\u2194",
      Leftrightarrow: "\u21D4",
      leftrightarrow: "\u2194",
      leftrightarrows: "\u21C6",
      leftrightharpoons: "\u21CB",
      leftrightsquigarrow: "\u21AD",
      LeftRightVector: "\u294E",
      LeftTee: "\u22A3",
      LeftTeeArrow: "\u21A4",
      LeftTeeVector: "\u295A",
      leftthreetimes: "\u22CB",
      LeftTriangle: "\u22B2",
      LeftTriangleBar: "\u29CF",
      LeftTriangleEqual: "\u22B4",
      LeftUpDownVector: "\u2951",
      LeftUpTeeVector: "\u2960",
      LeftUpVector: "\u21BF",
      LeftUpVectorBar: "\u2958",
      LeftVector: "\u21BC",
      LeftVectorBar: "\u2952",
      lEg: "\u2A8B",
      leg: "\u22DA",
      leq: "\u2264",
      leqq: "\u2266",
      leqslant: "\u2A7D",
      les: "\u2A7D",
      lescc: "\u2AA8",
      lesdot: "\u2A7F",
      lesdoto: "\u2A81",
      lesdotor: "\u2A83",
      lesg: "\u22DA\uFE00",
      lesges: "\u2A93",
      lessapprox: "\u2A85",
      lessdot: "\u22D6",
      lesseqgtr: "\u22DA",
      lesseqqgtr: "\u2A8B",
      LessEqualGreater: "\u22DA",
      LessFullEqual: "\u2266",
      LessGreater: "\u2276",
      lessgtr: "\u2276",
      LessLess: "\u2AA1",
      lesssim: "\u2272",
      LessSlantEqual: "\u2A7D",
      LessTilde: "\u2272",
      lfisht: "\u297C",
      lfloor: "\u230A",
      Lfr: "\u{1D50F}",
      lfr: "\u{1D529}",
      lg: "\u2276",
      lgE: "\u2A91",
      lHar: "\u2962",
      lhard: "\u21BD",
      lharu: "\u21BC",
      lharul: "\u296A",
      lhblk: "\u2584",
      LJcy: "\u0409",
      ljcy: "\u0459",
      Ll: "\u22D8",
      ll: "\u226A",
      llarr: "\u21C7",
      llcorner: "\u231E",
      Lleftarrow: "\u21DA",
      llhard: "\u296B",
      lltri: "\u25FA",
      Lmidot: "\u013F",
      lmidot: "\u0140",
      lmoust: "\u23B0",
      lmoustache: "\u23B0",
      lnap: "\u2A89",
      lnapprox: "\u2A89",
      lnE: "\u2268",
      lne: "\u2A87",
      lneq: "\u2A87",
      lneqq: "\u2268",
      lnsim: "\u22E6",
      loang: "\u27EC",
      loarr: "\u21FD",
      lobrk: "\u27E6",
      LongLeftArrow: "\u27F5",
      Longleftarrow: "\u27F8",
      longleftarrow: "\u27F5",
      LongLeftRightArrow: "\u27F7",
      Longleftrightarrow: "\u27FA",
      longleftrightarrow: "\u27F7",
      longmapsto: "\u27FC",
      LongRightArrow: "\u27F6",
      Longrightarrow: "\u27F9",
      longrightarrow: "\u27F6",
      looparrowleft: "\u21AB",
      looparrowright: "\u21AC",
      lopar: "\u2985",
      Lopf: "\u{1D543}",
      lopf: "\u{1D55D}",
      loplus: "\u2A2D",
      lotimes: "\u2A34",
      lowast: "\u2217",
      lowbar: "_",
      LowerLeftArrow: "\u2199",
      LowerRightArrow: "\u2198",
      loz: "\u25CA",
      lozenge: "\u25CA",
      lozf: "\u29EB",
      lpar: "(",
      lparlt: "\u2993",
      lrarr: "\u21C6",
      lrcorner: "\u231F",
      lrhar: "\u21CB",
      lrhard: "\u296D",
      lrm: "\u200E",
      lrtri: "\u22BF",
      lsaquo: "\u2039",
      Lscr: "\u2112",
      lscr: "\u{1D4C1}",
      Lsh: "\u21B0",
      lsh: "\u21B0",
      lsim: "\u2272",
      lsime: "\u2A8D",
      lsimg: "\u2A8F",
      lsqb: "[",
      lsquo: "\u2018",
      lsquor: "\u201A",
      Lstrok: "\u0141",
      lstrok: "\u0142",
      Lt: "\u226A",
      LT: "<",
      lt: "<",
      ltcc: "\u2AA6",
      ltcir: "\u2A79",
      ltdot: "\u22D6",
      lthree: "\u22CB",
      ltimes: "\u22C9",
      ltlarr: "\u2976",
      ltquest: "\u2A7B",
      ltri: "\u25C3",
      ltrie: "\u22B4",
      ltrif: "\u25C2",
      ltrPar: "\u2996",
      lurdshar: "\u294A",
      luruhar: "\u2966",
      lvertneqq: "\u2268\uFE00",
      lvnE: "\u2268\uFE00",
      macr: "\xAF",
      male: "\u2642",
      malt: "\u2720",
      maltese: "\u2720",
      Map: "\u2905",
      map: "\u21A6",
      mapsto: "\u21A6",
      mapstodown: "\u21A7",
      mapstoleft: "\u21A4",
      mapstoup: "\u21A5",
      marker: "\u25AE",
      mcomma: "\u2A29",
      Mcy: "\u041C",
      mcy: "\u043C",
      mdash: "\u2014",
      mDDot: "\u223A",
      measuredangle: "\u2221",
      MediumSpace: "\u205F",
      Mellintrf: "\u2133",
      Mfr: "\u{1D510}",
      mfr: "\u{1D52A}",
      mho: "\u2127",
      micro: "\xB5",
      mid: "\u2223",
      midast: "*",
      midcir: "\u2AF0",
      middot: "\xB7",
      minus: "\u2212",
      minusb: "\u229F",
      minusd: "\u2238",
      minusdu: "\u2A2A",
      MinusPlus: "\u2213",
      mlcp: "\u2ADB",
      mldr: "\u2026",
      mnplus: "\u2213",
      models: "\u22A7",
      Mopf: "\u{1D544}",
      mopf: "\u{1D55E}",
      mp: "\u2213",
      Mscr: "\u2133",
      mscr: "\u{1D4C2}",
      mstpos: "\u223E",
      Mu: "\u039C",
      mu: "\u03BC",
      multimap: "\u22B8",
      mumap: "\u22B8",
      nabla: "\u2207",
      Nacute: "\u0143",
      nacute: "\u0144",
      nang: "\u2220\u20D2",
      nap: "\u2249",
      napE: "\u2A70\u0338",
      napid: "\u224B\u0338",
      napos: "\u0149",
      napprox: "\u2249",
      natur: "\u266E",
      natural: "\u266E",
      naturals: "\u2115",
      nbsp: "\xA0",
      nbump: "\u224E\u0338",
      nbumpe: "\u224F\u0338",
      ncap: "\u2A43",
      Ncaron: "\u0147",
      ncaron: "\u0148",
      Ncedil: "\u0145",
      ncedil: "\u0146",
      ncong: "\u2247",
      ncongdot: "\u2A6D\u0338",
      ncup: "\u2A42",
      Ncy: "\u041D",
      ncy: "\u043D",
      ndash: "\u2013",
      ne: "\u2260",
      nearhk: "\u2924",
      neArr: "\u21D7",
      nearr: "\u2197",
      nearrow: "\u2197",
      nedot: "\u2250\u0338",
      NegativeMediumSpace: "\u200B",
      NegativeThickSpace: "\u200B",
      NegativeThinSpace: "\u200B",
      NegativeVeryThinSpace: "\u200B",
      nequiv: "\u2262",
      nesear: "\u2928",
      nesim: "\u2242\u0338",
      NestedGreaterGreater: "\u226B",
      NestedLessLess: "\u226A",
      NewLine: "\n",
      nexist: "\u2204",
      nexists: "\u2204",
      Nfr: "\u{1D511}",
      nfr: "\u{1D52B}",
      ngE: "\u2267\u0338",
      nge: "\u2271",
      ngeq: "\u2271",
      ngeqq: "\u2267\u0338",
      ngeqslant: "\u2A7E\u0338",
      nges: "\u2A7E\u0338",
      nGg: "\u22D9\u0338",
      ngsim: "\u2275",
      nGt: "\u226B\u20D2",
      ngt: "\u226F",
      ngtr: "\u226F",
      nGtv: "\u226B\u0338",
      nhArr: "\u21CE",
      nharr: "\u21AE",
      nhpar: "\u2AF2",
      ni: "\u220B",
      nis: "\u22FC",
      nisd: "\u22FA",
      niv: "\u220B",
      NJcy: "\u040A",
      njcy: "\u045A",
      nlArr: "\u21CD",
      nlarr: "\u219A",
      nldr: "\u2025",
      nlE: "\u2266\u0338",
      nle: "\u2270",
      nLeftarrow: "\u21CD",
      nleftarrow: "\u219A",
      nLeftrightarrow: "\u21CE",
      nleftrightarrow: "\u21AE",
      nleq: "\u2270",
      nleqq: "\u2266\u0338",
      nleqslant: "\u2A7D\u0338",
      nles: "\u2A7D\u0338",
      nless: "\u226E",
      nLl: "\u22D8\u0338",
      nlsim: "\u2274",
      nLt: "\u226A\u20D2",
      nlt: "\u226E",
      nltri: "\u22EA",
      nltrie: "\u22EC",
      nLtv: "\u226A\u0338",
      nmid: "\u2224",
      NoBreak: "\u2060",
      NonBreakingSpace: "\xA0",
      Nopf: "\u2115",
      nopf: "\u{1D55F}",
      Not: "\u2AEC",
      not: "\xAC",
      NotCongruent: "\u2262",
      NotCupCap: "\u226D",
      NotDoubleVerticalBar: "\u2226",
      NotElement: "\u2209",
      NotEqual: "\u2260",
      NotEqualTilde: "\u2242\u0338",
      NotExists: "\u2204",
      NotGreater: "\u226F",
      NotGreaterEqual: "\u2271",
      NotGreaterFullEqual: "\u2267\u0338",
      NotGreaterGreater: "\u226B\u0338",
      NotGreaterLess: "\u2279",
      NotGreaterSlantEqual: "\u2A7E\u0338",
      NotGreaterTilde: "\u2275",
      NotHumpDownHump: "\u224E\u0338",
      NotHumpEqual: "\u224F\u0338",
      notin: "\u2209",
      notindot: "\u22F5\u0338",
      notinE: "\u22F9\u0338",
      notinva: "\u2209",
      notinvb: "\u22F7",
      notinvc: "\u22F6",
      NotLeftTriangle: "\u22EA",
      NotLeftTriangleBar: "\u29CF\u0338",
      NotLeftTriangleEqual: "\u22EC",
      NotLess: "\u226E",
      NotLessEqual: "\u2270",
      NotLessGreater: "\u2278",
      NotLessLess: "\u226A\u0338",
      NotLessSlantEqual: "\u2A7D\u0338",
      NotLessTilde: "\u2274",
      NotNestedGreaterGreater: "\u2AA2\u0338",
      NotNestedLessLess: "\u2AA1\u0338",
      notni: "\u220C",
      notniva: "\u220C",
      notnivb: "\u22FE",
      notnivc: "\u22FD",
      NotPrecedes: "\u2280",
      NotPrecedesEqual: "\u2AAF\u0338",
      NotPrecedesSlantEqual: "\u22E0",
      NotReverseElement: "\u220C",
      NotRightTriangle: "\u22EB",
      NotRightTriangleBar: "\u29D0\u0338",
      NotRightTriangleEqual: "\u22ED",
      NotSquareSubset: "\u228F\u0338",
      NotSquareSubsetEqual: "\u22E2",
      NotSquareSuperset: "\u2290\u0338",
      NotSquareSupersetEqual: "\u22E3",
      NotSubset: "\u2282\u20D2",
      NotSubsetEqual: "\u2288",
      NotSucceeds: "\u2281",
      NotSucceedsEqual: "\u2AB0\u0338",
      NotSucceedsSlantEqual: "\u22E1",
      NotSucceedsTilde: "\u227F\u0338",
      NotSuperset: "\u2283\u20D2",
      NotSupersetEqual: "\u2289",
      NotTilde: "\u2241",
      NotTildeEqual: "\u2244",
      NotTildeFullEqual: "\u2247",
      NotTildeTilde: "\u2249",
      NotVerticalBar: "\u2224",
      npar: "\u2226",
      nparallel: "\u2226",
      nparsl: "\u2AFD\u20E5",
      npart: "\u2202\u0338",
      npolint: "\u2A14",
      npr: "\u2280",
      nprcue: "\u22E0",
      npre: "\u2AAF\u0338",
      nprec: "\u2280",
      npreceq: "\u2AAF\u0338",
      nrArr: "\u21CF",
      nrarr: "\u219B",
      nrarrc: "\u2933\u0338",
      nrarrw: "\u219D\u0338",
      nRightarrow: "\u21CF",
      nrightarrow: "\u219B",
      nrtri: "\u22EB",
      nrtrie: "\u22ED",
      nsc: "\u2281",
      nsccue: "\u22E1",
      nsce: "\u2AB0\u0338",
      Nscr: "\u{1D4A9}",
      nscr: "\u{1D4C3}",
      nshortmid: "\u2224",
      nshortparallel: "\u2226",
      nsim: "\u2241",
      nsime: "\u2244",
      nsimeq: "\u2244",
      nsmid: "\u2224",
      nspar: "\u2226",
      nsqsube: "\u22E2",
      nsqsupe: "\u22E3",
      nsub: "\u2284",
      nsubE: "\u2AC5\u0338",
      nsube: "\u2288",
      nsubset: "\u2282\u20D2",
      nsubseteq: "\u2288",
      nsubseteqq: "\u2AC5\u0338",
      nsucc: "\u2281",
      nsucceq: "\u2AB0\u0338",
      nsup: "\u2285",
      nsupE: "\u2AC6\u0338",
      nsupe: "\u2289",
      nsupset: "\u2283\u20D2",
      nsupseteq: "\u2289",
      nsupseteqq: "\u2AC6\u0338",
      ntgl: "\u2279",
      Ntilde: "\xD1",
      ntilde: "\xF1",
      ntlg: "\u2278",
      ntriangleleft: "\u22EA",
      ntrianglelefteq: "\u22EC",
      ntriangleright: "\u22EB",
      ntrianglerighteq: "\u22ED",
      Nu: "\u039D",
      nu: "\u03BD",
      num: "#",
      numero: "\u2116",
      numsp: "\u2007",
      nvap: "\u224D\u20D2",
      nVDash: "\u22AF",
      nVdash: "\u22AE",
      nvDash: "\u22AD",
      nvdash: "\u22AC",
      nvge: "\u2265\u20D2",
      nvgt: ">\u20D2",
      nvHarr: "\u2904",
      nvinfin: "\u29DE",
      nvlArr: "\u2902",
      nvle: "\u2264\u20D2",
      nvlt: "<\u20D2",
      nvltrie: "\u22B4\u20D2",
      nvrArr: "\u2903",
      nvrtrie: "\u22B5\u20D2",
      nvsim: "\u223C\u20D2",
      nwarhk: "\u2923",
      nwArr: "\u21D6",
      nwarr: "\u2196",
      nwarrow: "\u2196",
      nwnear: "\u2927",
      Oacute: "\xD3",
      oacute: "\xF3",
      oast: "\u229B",
      ocir: "\u229A",
      Ocirc: "\xD4",
      ocirc: "\xF4",
      Ocy: "\u041E",
      ocy: "\u043E",
      odash: "\u229D",
      Odblac: "\u0150",
      odblac: "\u0151",
      odiv: "\u2A38",
      odot: "\u2299",
      odsold: "\u29BC",
      OElig: "\u0152",
      oelig: "\u0153",
      ofcir: "\u29BF",
      Ofr: "\u{1D512}",
      ofr: "\u{1D52C}",
      ogon: "\u02DB",
      Ograve: "\xD2",
      ograve: "\xF2",
      ogt: "\u29C1",
      ohbar: "\u29B5",
      ohm: "\u03A9",
      oint: "\u222E",
      olarr: "\u21BA",
      olcir: "\u29BE",
      olcross: "\u29BB",
      oline: "\u203E",
      olt: "\u29C0",
      Omacr: "\u014C",
      omacr: "\u014D",
      Omega: "\u03A9",
      omega: "\u03C9",
      Omicron: "\u039F",
      omicron: "\u03BF",
      omid: "\u29B6",
      ominus: "\u2296",
      Oopf: "\u{1D546}",
      oopf: "\u{1D560}",
      opar: "\u29B7",
      OpenCurlyDoubleQuote: "\u201C",
      OpenCurlyQuote: "\u2018",
      operp: "\u29B9",
      oplus: "\u2295",
      Or: "\u2A54",
      or: "\u2228",
      orarr: "\u21BB",
      ord: "\u2A5D",
      order: "\u2134",
      orderof: "\u2134",
      ordf: "\xAA",
      ordm: "\xBA",
      origof: "\u22B6",
      oror: "\u2A56",
      orslope: "\u2A57",
      orv: "\u2A5B",
      oS: "\u24C8",
      Oscr: "\u{1D4AA}",
      oscr: "\u2134",
      Oslash: "\xD8",
      oslash: "\xF8",
      osol: "\u2298",
      Otilde: "\xD5",
      otilde: "\xF5",
      Otimes: "\u2A37",
      otimes: "\u2297",
      otimesas: "\u2A36",
      Ouml: "\xD6",
      ouml: "\xF6",
      ovbar: "\u233D",
      OverBar: "\u203E",
      OverBrace: "\u23DE",
      OverBracket: "\u23B4",
      OverParenthesis: "\u23DC",
      par: "\u2225",
      para: "\xB6",
      parallel: "\u2225",
      parsim: "\u2AF3",
      parsl: "\u2AFD",
      part: "\u2202",
      PartialD: "\u2202",
      Pcy: "\u041F",
      pcy: "\u043F",
      percnt: "%",
      period: ".",
      permil: "\u2030",
      perp: "\u22A5",
      pertenk: "\u2031",
      Pfr: "\u{1D513}",
      pfr: "\u{1D52D}",
      Phi: "\u03A6",
      phi: "\u03C6",
      phiv: "\u03D5",
      phmmat: "\u2133",
      phone: "\u260E",
      Pi: "\u03A0",
      pi: "\u03C0",
      pitchfork: "\u22D4",
      piv: "\u03D6",
      planck: "\u210F",
      planckh: "\u210E",
      plankv: "\u210F",
      plus: "+",
      plusacir: "\u2A23",
      plusb: "\u229E",
      pluscir: "\u2A22",
      plusdo: "\u2214",
      plusdu: "\u2A25",
      pluse: "\u2A72",
      PlusMinus: "\xB1",
      plusmn: "\xB1",
      plussim: "\u2A26",
      plustwo: "\u2A27",
      pm: "\xB1",
      Poincareplane: "\u210C",
      pointint: "\u2A15",
      Popf: "\u2119",
      popf: "\u{1D561}",
      pound: "\xA3",
      Pr: "\u2ABB",
      pr: "\u227A",
      prap: "\u2AB7",
      prcue: "\u227C",
      prE: "\u2AB3",
      pre: "\u2AAF",
      prec: "\u227A",
      precapprox: "\u2AB7",
      preccurlyeq: "\u227C",
      Precedes: "\u227A",
      PrecedesEqual: "\u2AAF",
      PrecedesSlantEqual: "\u227C",
      PrecedesTilde: "\u227E",
      preceq: "\u2AAF",
      precnapprox: "\u2AB9",
      precneqq: "\u2AB5",
      precnsim: "\u22E8",
      precsim: "\u227E",
      Prime: "\u2033",
      prime: "\u2032",
      primes: "\u2119",
      prnap: "\u2AB9",
      prnE: "\u2AB5",
      prnsim: "\u22E8",
      prod: "\u220F",
      Product: "\u220F",
      profalar: "\u232E",
      profline: "\u2312",
      profsurf: "\u2313",
      prop: "\u221D",
      Proportion: "\u2237",
      Proportional: "\u221D",
      propto: "\u221D",
      prsim: "\u227E",
      prurel: "\u22B0",
      Pscr: "\u{1D4AB}",
      pscr: "\u{1D4C5}",
      Psi: "\u03A8",
      psi: "\u03C8",
      puncsp: "\u2008",
      Qfr: "\u{1D514}",
      qfr: "\u{1D52E}",
      qint: "\u2A0C",
      Qopf: "\u211A",
      qopf: "\u{1D562}",
      qprime: "\u2057",
      Qscr: "\u{1D4AC}",
      qscr: "\u{1D4C6}",
      quaternions: "\u210D",
      quatint: "\u2A16",
      quest: "?",
      questeq: "\u225F",
      QUOT: '"',
      quot: '"',
      rAarr: "\u21DB",
      race: "\u223D\u0331",
      Racute: "\u0154",
      racute: "\u0155",
      radic: "\u221A",
      raemptyv: "\u29B3",
      Rang: "\u27EB",
      rang: "\u27E9",
      rangd: "\u2992",
      range: "\u29A5",
      rangle: "\u27E9",
      raquo: "\xBB",
      Rarr: "\u21A0",
      rArr: "\u21D2",
      rarr: "\u2192",
      rarrap: "\u2975",
      rarrb: "\u21E5",
      rarrbfs: "\u2920",
      rarrc: "\u2933",
      rarrfs: "\u291E",
      rarrhk: "\u21AA",
      rarrlp: "\u21AC",
      rarrpl: "\u2945",
      rarrsim: "\u2974",
      Rarrtl: "\u2916",
      rarrtl: "\u21A3",
      rarrw: "\u219D",
      rAtail: "\u291C",
      ratail: "\u291A",
      ratio: "\u2236",
      rationals: "\u211A",
      RBarr: "\u2910",
      rBarr: "\u290F",
      rbarr: "\u290D",
      rbbrk: "\u2773",
      rbrace: "}",
      rbrack: "]",
      rbrke: "\u298C",
      rbrksld: "\u298E",
      rbrkslu: "\u2990",
      Rcaron: "\u0158",
      rcaron: "\u0159",
      Rcedil: "\u0156",
      rcedil: "\u0157",
      rceil: "\u2309",
      rcub: "}",
      Rcy: "\u0420",
      rcy: "\u0440",
      rdca: "\u2937",
      rdldhar: "\u2969",
      rdquo: "\u201D",
      rdquor: "\u201D",
      rdsh: "\u21B3",
      Re: "\u211C",
      real: "\u211C",
      realine: "\u211B",
      realpart: "\u211C",
      reals: "\u211D",
      rect: "\u25AD",
      REG: "\xAE",
      reg: "\xAE",
      ReverseElement: "\u220B",
      ReverseEquilibrium: "\u21CB",
      ReverseUpEquilibrium: "\u296F",
      rfisht: "\u297D",
      rfloor: "\u230B",
      Rfr: "\u211C",
      rfr: "\u{1D52F}",
      rHar: "\u2964",
      rhard: "\u21C1",
      rharu: "\u21C0",
      rharul: "\u296C",
      Rho: "\u03A1",
      rho: "\u03C1",
      rhov: "\u03F1",
      RightAngleBracket: "\u27E9",
      RightArrow: "\u2192",
      Rightarrow: "\u21D2",
      rightarrow: "\u2192",
      RightArrowBar: "\u21E5",
      RightArrowLeftArrow: "\u21C4",
      rightarrowtail: "\u21A3",
      RightCeiling: "\u2309",
      RightDoubleBracket: "\u27E7",
      RightDownTeeVector: "\u295D",
      RightDownVector: "\u21C2",
      RightDownVectorBar: "\u2955",
      RightFloor: "\u230B",
      rightharpoondown: "\u21C1",
      rightharpoonup: "\u21C0",
      rightleftarrows: "\u21C4",
      rightleftharpoons: "\u21CC",
      rightrightarrows: "\u21C9",
      rightsquigarrow: "\u219D",
      RightTee: "\u22A2",
      RightTeeArrow: "\u21A6",
      RightTeeVector: "\u295B",
      rightthreetimes: "\u22CC",
      RightTriangle: "\u22B3",
      RightTriangleBar: "\u29D0",
      RightTriangleEqual: "\u22B5",
      RightUpDownVector: "\u294F",
      RightUpTeeVector: "\u295C",
      RightUpVector: "\u21BE",
      RightUpVectorBar: "\u2954",
      RightVector: "\u21C0",
      RightVectorBar: "\u2953",
      ring: "\u02DA",
      risingdotseq: "\u2253",
      rlarr: "\u21C4",
      rlhar: "\u21CC",
      rlm: "\u200F",
      rmoust: "\u23B1",
      rmoustache: "\u23B1",
      rnmid: "\u2AEE",
      roang: "\u27ED",
      roarr: "\u21FE",
      robrk: "\u27E7",
      ropar: "\u2986",
      Ropf: "\u211D",
      ropf: "\u{1D563}",
      roplus: "\u2A2E",
      rotimes: "\u2A35",
      RoundImplies: "\u2970",
      rpar: ")",
      rpargt: "\u2994",
      rppolint: "\u2A12",
      rrarr: "\u21C9",
      Rrightarrow: "\u21DB",
      rsaquo: "\u203A",
      Rscr: "\u211B",
      rscr: "\u{1D4C7}",
      Rsh: "\u21B1",
      rsh: "\u21B1",
      rsqb: "]",
      rsquo: "\u2019",
      rsquor: "\u2019",
      rthree: "\u22CC",
      rtimes: "\u22CA",
      rtri: "\u25B9",
      rtrie: "\u22B5",
      rtrif: "\u25B8",
      rtriltri: "\u29CE",
      RuleDelayed: "\u29F4",
      ruluhar: "\u2968",
      rx: "\u211E",
      Sacute: "\u015A",
      sacute: "\u015B",
      sbquo: "\u201A",
      Sc: "\u2ABC",
      sc: "\u227B",
      scap: "\u2AB8",
      Scaron: "\u0160",
      scaron: "\u0161",
      sccue: "\u227D",
      scE: "\u2AB4",
      sce: "\u2AB0",
      Scedil: "\u015E",
      scedil: "\u015F",
      Scirc: "\u015C",
      scirc: "\u015D",
      scnap: "\u2ABA",
      scnE: "\u2AB6",
      scnsim: "\u22E9",
      scpolint: "\u2A13",
      scsim: "\u227F",
      Scy: "\u0421",
      scy: "\u0441",
      sdot: "\u22C5",
      sdotb: "\u22A1",
      sdote: "\u2A66",
      searhk: "\u2925",
      seArr: "\u21D8",
      searr: "\u2198",
      searrow: "\u2198",
      sect: "\xA7",
      semi: ";",
      seswar: "\u2929",
      setminus: "\u2216",
      setmn: "\u2216",
      sext: "\u2736",
      Sfr: "\u{1D516}",
      sfr: "\u{1D530}",
      sfrown: "\u2322",
      sharp: "\u266F",
      SHCHcy: "\u0429",
      shchcy: "\u0449",
      SHcy: "\u0428",
      shcy: "\u0448",
      ShortDownArrow: "\u2193",
      ShortLeftArrow: "\u2190",
      shortmid: "\u2223",
      shortparallel: "\u2225",
      ShortRightArrow: "\u2192",
      ShortUpArrow: "\u2191",
      shy: "\xAD",
      Sigma: "\u03A3",
      sigma: "\u03C3",
      sigmaf: "\u03C2",
      sigmav: "\u03C2",
      sim: "\u223C",
      simdot: "\u2A6A",
      sime: "\u2243",
      simeq: "\u2243",
      simg: "\u2A9E",
      simgE: "\u2AA0",
      siml: "\u2A9D",
      simlE: "\u2A9F",
      simne: "\u2246",
      simplus: "\u2A24",
      simrarr: "\u2972",
      slarr: "\u2190",
      SmallCircle: "\u2218",
      smallsetminus: "\u2216",
      smashp: "\u2A33",
      smeparsl: "\u29E4",
      smid: "\u2223",
      smile: "\u2323",
      smt: "\u2AAA",
      smte: "\u2AAC",
      smtes: "\u2AAC\uFE00",
      SOFTcy: "\u042C",
      softcy: "\u044C",
      sol: "/",
      solb: "\u29C4",
      solbar: "\u233F",
      Sopf: "\u{1D54A}",
      sopf: "\u{1D564}",
      spades: "\u2660",
      spadesuit: "\u2660",
      spar: "\u2225",
      sqcap: "\u2293",
      sqcaps: "\u2293\uFE00",
      sqcup: "\u2294",
      sqcups: "\u2294\uFE00",
      Sqrt: "\u221A",
      sqsub: "\u228F",
      sqsube: "\u2291",
      sqsubset: "\u228F",
      sqsubseteq: "\u2291",
      sqsup: "\u2290",
      sqsupe: "\u2292",
      sqsupset: "\u2290",
      sqsupseteq: "\u2292",
      squ: "\u25A1",
      Square: "\u25A1",
      square: "\u25A1",
      SquareIntersection: "\u2293",
      SquareSubset: "\u228F",
      SquareSubsetEqual: "\u2291",
      SquareSuperset: "\u2290",
      SquareSupersetEqual: "\u2292",
      SquareUnion: "\u2294",
      squarf: "\u25AA",
      squf: "\u25AA",
      srarr: "\u2192",
      Sscr: "\u{1D4AE}",
      sscr: "\u{1D4C8}",
      ssetmn: "\u2216",
      ssmile: "\u2323",
      sstarf: "\u22C6",
      Star: "\u22C6",
      star: "\u2606",
      starf: "\u2605",
      straightepsilon: "\u03F5",
      straightphi: "\u03D5",
      strns: "\xAF",
      Sub: "\u22D0",
      sub: "\u2282",
      subdot: "\u2ABD",
      subE: "\u2AC5",
      sube: "\u2286",
      subedot: "\u2AC3",
      submult: "\u2AC1",
      subnE: "\u2ACB",
      subne: "\u228A",
      subplus: "\u2ABF",
      subrarr: "\u2979",
      Subset: "\u22D0",
      subset: "\u2282",
      subseteq: "\u2286",
      subseteqq: "\u2AC5",
      SubsetEqual: "\u2286",
      subsetneq: "\u228A",
      subsetneqq: "\u2ACB",
      subsim: "\u2AC7",
      subsub: "\u2AD5",
      subsup: "\u2AD3",
      succ: "\u227B",
      succapprox: "\u2AB8",
      succcurlyeq: "\u227D",
      Succeeds: "\u227B",
      SucceedsEqual: "\u2AB0",
      SucceedsSlantEqual: "\u227D",
      SucceedsTilde: "\u227F",
      succeq: "\u2AB0",
      succnapprox: "\u2ABA",
      succneqq: "\u2AB6",
      succnsim: "\u22E9",
      succsim: "\u227F",
      SuchThat: "\u220B",
      Sum: "\u2211",
      sum: "\u2211",
      sung: "\u266A",
      Sup: "\u22D1",
      sup: "\u2283",
      sup1: "\xB9",
      sup2: "\xB2",
      sup3: "\xB3",
      supdot: "\u2ABE",
      supdsub: "\u2AD8",
      supE: "\u2AC6",
      supe: "\u2287",
      supedot: "\u2AC4",
      Superset: "\u2283",
      SupersetEqual: "\u2287",
      suphsol: "\u27C9",
      suphsub: "\u2AD7",
      suplarr: "\u297B",
      supmult: "\u2AC2",
      supnE: "\u2ACC",
      supne: "\u228B",
      supplus: "\u2AC0",
      Supset: "\u22D1",
      supset: "\u2283",
      supseteq: "\u2287",
      supseteqq: "\u2AC6",
      supsetneq: "\u228B",
      supsetneqq: "\u2ACC",
      supsim: "\u2AC8",
      supsub: "\u2AD4",
      supsup: "\u2AD6",
      swarhk: "\u2926",
      swArr: "\u21D9",
      swarr: "\u2199",
      swarrow: "\u2199",
      swnwar: "\u292A",
      szlig: "\xDF",
      Tab: "	",
      target: "\u2316",
      Tau: "\u03A4",
      tau: "\u03C4",
      tbrk: "\u23B4",
      Tcaron: "\u0164",
      tcaron: "\u0165",
      Tcedil: "\u0162",
      tcedil: "\u0163",
      Tcy: "\u0422",
      tcy: "\u0442",
      tdot: "\u20DB",
      telrec: "\u2315",
      Tfr: "\u{1D517}",
      tfr: "\u{1D531}",
      there4: "\u2234",
      Therefore: "\u2234",
      therefore: "\u2234",
      Theta: "\u0398",
      theta: "\u03B8",
      thetasym: "\u03D1",
      thetav: "\u03D1",
      thickapprox: "\u2248",
      thicksim: "\u223C",
      ThickSpace: "\u205F\u200A",
      thinsp: "\u2009",
      ThinSpace: "\u2009",
      thkap: "\u2248",
      thksim: "\u223C",
      THORN: "\xDE",
      thorn: "\xFE",
      Tilde: "\u223C",
      tilde: "\u02DC",
      TildeEqual: "\u2243",
      TildeFullEqual: "\u2245",
      TildeTilde: "\u2248",
      times: "\xD7",
      timesb: "\u22A0",
      timesbar: "\u2A31",
      timesd: "\u2A30",
      tint: "\u222D",
      toea: "\u2928",
      top: "\u22A4",
      topbot: "\u2336",
      topcir: "\u2AF1",
      Topf: "\u{1D54B}",
      topf: "\u{1D565}",
      topfork: "\u2ADA",
      tosa: "\u2929",
      tprime: "\u2034",
      TRADE: "\u2122",
      trade: "\u2122",
      triangle: "\u25B5",
      triangledown: "\u25BF",
      triangleleft: "\u25C3",
      trianglelefteq: "\u22B4",
      triangleq: "\u225C",
      triangleright: "\u25B9",
      trianglerighteq: "\u22B5",
      tridot: "\u25EC",
      trie: "\u225C",
      triminus: "\u2A3A",
      TripleDot: "\u20DB",
      triplus: "\u2A39",
      trisb: "\u29CD",
      tritime: "\u2A3B",
      trpezium: "\u23E2",
      Tscr: "\u{1D4AF}",
      tscr: "\u{1D4C9}",
      TScy: "\u0426",
      tscy: "\u0446",
      TSHcy: "\u040B",
      tshcy: "\u045B",
      Tstrok: "\u0166",
      tstrok: "\u0167",
      twixt: "\u226C",
      twoheadleftarrow: "\u219E",
      twoheadrightarrow: "\u21A0",
      Uacute: "\xDA",
      uacute: "\xFA",
      Uarr: "\u219F",
      uArr: "\u21D1",
      uarr: "\u2191",
      Uarrocir: "\u2949",
      Ubrcy: "\u040E",
      ubrcy: "\u045E",
      Ubreve: "\u016C",
      ubreve: "\u016D",
      Ucirc: "\xDB",
      ucirc: "\xFB",
      Ucy: "\u0423",
      ucy: "\u0443",
      udarr: "\u21C5",
      Udblac: "\u0170",
      udblac: "\u0171",
      udhar: "\u296E",
      ufisht: "\u297E",
      Ufr: "\u{1D518}",
      ufr: "\u{1D532}",
      Ugrave: "\xD9",
      ugrave: "\xF9",
      uHar: "\u2963",
      uharl: "\u21BF",
      uharr: "\u21BE",
      uhblk: "\u2580",
      ulcorn: "\u231C",
      ulcorner: "\u231C",
      ulcrop: "\u230F",
      ultri: "\u25F8",
      Umacr: "\u016A",
      umacr: "\u016B",
      uml: "\xA8",
      UnderBar: "_",
      UnderBrace: "\u23DF",
      UnderBracket: "\u23B5",
      UnderParenthesis: "\u23DD",
      Union: "\u22C3",
      UnionPlus: "\u228E",
      Uogon: "\u0172",
      uogon: "\u0173",
      Uopf: "\u{1D54C}",
      uopf: "\u{1D566}",
      UpArrow: "\u2191",
      Uparrow: "\u21D1",
      uparrow: "\u2191",
      UpArrowBar: "\u2912",
      UpArrowDownArrow: "\u21C5",
      UpDownArrow: "\u2195",
      Updownarrow: "\u21D5",
      updownarrow: "\u2195",
      UpEquilibrium: "\u296E",
      upharpoonleft: "\u21BF",
      upharpoonright: "\u21BE",
      uplus: "\u228E",
      UpperLeftArrow: "\u2196",
      UpperRightArrow: "\u2197",
      Upsi: "\u03D2",
      upsi: "\u03C5",
      upsih: "\u03D2",
      Upsilon: "\u03A5",
      upsilon: "\u03C5",
      UpTee: "\u22A5",
      UpTeeArrow: "\u21A5",
      upuparrows: "\u21C8",
      urcorn: "\u231D",
      urcorner: "\u231D",
      urcrop: "\u230E",
      Uring: "\u016E",
      uring: "\u016F",
      urtri: "\u25F9",
      Uscr: "\u{1D4B0}",
      uscr: "\u{1D4CA}",
      utdot: "\u22F0",
      Utilde: "\u0168",
      utilde: "\u0169",
      utri: "\u25B5",
      utrif: "\u25B4",
      uuarr: "\u21C8",
      Uuml: "\xDC",
      uuml: "\xFC",
      uwangle: "\u29A7",
      vangrt: "\u299C",
      varepsilon: "\u03F5",
      varkappa: "\u03F0",
      varnothing: "\u2205",
      varphi: "\u03D5",
      varpi: "\u03D6",
      varpropto: "\u221D",
      vArr: "\u21D5",
      varr: "\u2195",
      varrho: "\u03F1",
      varsigma: "\u03C2",
      varsubsetneq: "\u228A\uFE00",
      varsubsetneqq: "\u2ACB\uFE00",
      varsupsetneq: "\u228B\uFE00",
      varsupsetneqq: "\u2ACC\uFE00",
      vartheta: "\u03D1",
      vartriangleleft: "\u22B2",
      vartriangleright: "\u22B3",
      Vbar: "\u2AEB",
      vBar: "\u2AE8",
      vBarv: "\u2AE9",
      Vcy: "\u0412",
      vcy: "\u0432",
      VDash: "\u22AB",
      Vdash: "\u22A9",
      vDash: "\u22A8",
      vdash: "\u22A2",
      Vdashl: "\u2AE6",
      Vee: "\u22C1",
      vee: "\u2228",
      veebar: "\u22BB",
      veeeq: "\u225A",
      vellip: "\u22EE",
      Verbar: "\u2016",
      verbar: "|",
      Vert: "\u2016",
      vert: "|",
      VerticalBar: "\u2223",
      VerticalLine: "|",
      VerticalSeparator: "\u2758",
      VerticalTilde: "\u2240",
      VeryThinSpace: "\u200A",
      Vfr: "\u{1D519}",
      vfr: "\u{1D533}",
      vltri: "\u22B2",
      vnsub: "\u2282\u20D2",
      vnsup: "\u2283\u20D2",
      Vopf: "\u{1D54D}",
      vopf: "\u{1D567}",
      vprop: "\u221D",
      vrtri: "\u22B3",
      Vscr: "\u{1D4B1}",
      vscr: "\u{1D4CB}",
      vsubnE: "\u2ACB\uFE00",
      vsubne: "\u228A\uFE00",
      vsupnE: "\u2ACC\uFE00",
      vsupne: "\u228B\uFE00",
      Vvdash: "\u22AA",
      vzigzag: "\u299A",
      Wcirc: "\u0174",
      wcirc: "\u0175",
      wedbar: "\u2A5F",
      Wedge: "\u22C0",
      wedge: "\u2227",
      wedgeq: "\u2259",
      weierp: "\u2118",
      Wfr: "\u{1D51A}",
      wfr: "\u{1D534}",
      Wopf: "\u{1D54E}",
      wopf: "\u{1D568}",
      wp: "\u2118",
      wr: "\u2240",
      wreath: "\u2240",
      Wscr: "\u{1D4B2}",
      wscr: "\u{1D4CC}",
      xcap: "\u22C2",
      xcirc: "\u25EF",
      xcup: "\u22C3",
      xdtri: "\u25BD",
      Xfr: "\u{1D51B}",
      xfr: "\u{1D535}",
      xhArr: "\u27FA",
      xharr: "\u27F7",
      Xi: "\u039E",
      xi: "\u03BE",
      xlArr: "\u27F8",
      xlarr: "\u27F5",
      xmap: "\u27FC",
      xnis: "\u22FB",
      xodot: "\u2A00",
      Xopf: "\u{1D54F}",
      xopf: "\u{1D569}",
      xoplus: "\u2A01",
      xotime: "\u2A02",
      xrArr: "\u27F9",
      xrarr: "\u27F6",
      Xscr: "\u{1D4B3}",
      xscr: "\u{1D4CD}",
      xsqcup: "\u2A06",
      xuplus: "\u2A04",
      xutri: "\u25B3",
      xvee: "\u22C1",
      xwedge: "\u22C0",
      Yacute: "\xDD",
      yacute: "\xFD",
      YAcy: "\u042F",
      yacy: "\u044F",
      Ycirc: "\u0176",
      ycirc: "\u0177",
      Ycy: "\u042B",
      ycy: "\u044B",
      yen: "\xA5",
      Yfr: "\u{1D51C}",
      yfr: "\u{1D536}",
      YIcy: "\u0407",
      yicy: "\u0457",
      Yopf: "\u{1D550}",
      yopf: "\u{1D56A}",
      Yscr: "\u{1D4B4}",
      yscr: "\u{1D4CE}",
      YUcy: "\u042E",
      yucy: "\u044E",
      Yuml: "\u0178",
      yuml: "\xFF",
      Zacute: "\u0179",
      zacute: "\u017A",
      Zcaron: "\u017D",
      zcaron: "\u017E",
      Zcy: "\u0417",
      zcy: "\u0437",
      Zdot: "\u017B",
      zdot: "\u017C",
      zeetrf: "\u2128",
      ZeroWidthSpace: "\u200B",
      Zeta: "\u0396",
      zeta: "\u03B6",
      Zfr: "\u2128",
      zfr: "\u{1D537}",
      ZHcy: "\u0416",
      zhcy: "\u0436",
      zigrarr: "\u21DD",
      Zopf: "\u2124",
      zopf: "\u{1D56B}",
      Zscr: "\u{1D4B5}",
      zscr: "\u{1D4CF}",
      zwj: "\u200D",
      zwnj: "\u200C"
    });
    exports.entityMap = exports.HTML_ENTITIES;
  }
});

// node_modules/@xmldom/xmldom/lib/sax.js
var require_sax = __commonJS({
  "node_modules/@xmldom/xmldom/lib/sax.js"(exports) {
    "use strict";
    var conventions = require_conventions();
    var g = require_grammar();
    var errors = require_errors();
    var isHTMLEscapableRawTextElement = conventions.isHTMLEscapableRawTextElement;
    var isHTMLMimeType = conventions.isHTMLMimeType;
    var isHTMLRawTextElement = conventions.isHTMLRawTextElement;
    var hasOwn = conventions.hasOwn;
    var NAMESPACE = conventions.NAMESPACE;
    var ParseError = errors.ParseError;
    var DOMException = errors.DOMException;
    var S_TAG = 0;
    var S_ATTR = 1;
    var S_ATTR_SPACE = 2;
    var S_EQ = 3;
    var S_ATTR_NOQUOT_VALUE = 4;
    var S_ATTR_END = 5;
    var S_TAG_SPACE = 6;
    var S_TAG_CLOSE = 7;
    function XMLReader() {
    }
    XMLReader.prototype = {
      parse: function(source10, defaultNSMap, entityMap) {
        var domBuilder = this.domBuilder;
        domBuilder.startDocument();
        _copy(defaultNSMap, defaultNSMap = /* @__PURE__ */ Object.create(null));
        parse3(source10, defaultNSMap, entityMap, domBuilder, this.errorHandler);
        domBuilder.endDocument();
      }
    };
    var ENTITY_REG = /&#?\w+;?/g;
    function parse3(source10, defaultNSMapCopy, entityMap, domBuilder, errorHandler) {
      var isHTML = isHTMLMimeType(domBuilder.mimeType);
      if (source10.indexOf(g.UNICODE_REPLACEMENT_CHARACTER) >= 0) {
        errorHandler.warning("Unicode replacement character detected, source encoding issues?");
      }
      function fixedFromCharCode(code5) {
        if (code5 > 65535) {
          code5 -= 65536;
          var surrogate1 = 55296 + (code5 >> 10), surrogate2 = 56320 + (code5 & 1023);
          return String.fromCharCode(surrogate1, surrogate2);
        } else {
          return String.fromCharCode(code5);
        }
      }
      function entityReplacer(a2) {
        var complete2 = a2[a2.length - 1] === ";" ? a2 : a2 + ";";
        if (!isHTML && complete2 !== a2) {
          errorHandler.error("EntityRef: expecting ;");
          return a2;
        }
        var match = g.Reference.exec(complete2);
        if (!match || match[0].length !== complete2.length) {
          errorHandler.error("entity not matching Reference production: " + a2);
          return a2;
        }
        var k = complete2.slice(1, -1);
        if (hasOwn(entityMap, k)) {
          return entityMap[k];
        } else if (k.charAt(0) === "#") {
          return fixedFromCharCode(parseInt(k.substring(1).replace("x", "0x")));
        } else {
          errorHandler.error("entity not found:" + a2);
          return a2;
        }
      }
      function appendText(end3) {
        if (end3 > start3) {
          var xt = source10.substring(start3, end3).replace(ENTITY_REG, entityReplacer);
          locator && position4(start3);
          domBuilder.characters(xt, 0, end3 - start3);
          start3 = end3;
        }
      }
      var lineStart = 0;
      var lineEnd = 0;
      var linePattern = /\r\n?|\n|$/g;
      var locator = domBuilder.locator;
      function position4(p, m) {
        while (p >= lineEnd && (m = linePattern.exec(source10))) {
          lineStart = lineEnd;
          lineEnd = m.index + m[0].length;
          locator.lineNumber++;
        }
        locator.columnNumber = p - lineStart + 1;
      }
      var parseStack = [{ currentNSMap: defaultNSMapCopy }];
      var unclosedTags = [];
      var start3 = 0;
      while (true) {
        try {
          var tagStart = source10.indexOf("<", start3);
          if (tagStart < 0) {
            if (!isHTML && unclosedTags.length > 0) {
              return errorHandler.fatalError("unclosed xml tag(s): " + unclosedTags.join(", "));
            }
            if (!source10.substring(start3).match(/^\s*$/)) {
              var doc = domBuilder.doc;
              var text4 = doc.createTextNode(source10.substring(start3));
              if (doc.documentElement) {
                return errorHandler.error("Extra content at the end of the document");
              }
              doc.appendChild(text4);
              domBuilder.currentElement = text4;
            }
            return;
          }
          if (tagStart > start3) {
            var fromSource = source10.substring(start3, tagStart);
            if (!isHTML && unclosedTags.length === 0) {
              fromSource = fromSource.replace(new RegExp(g.S_OPT.source, "g"), "");
              fromSource && errorHandler.error("Unexpected content outside root element: '" + fromSource + "'");
            }
            appendText(tagStart);
          }
          switch (source10.charAt(tagStart + 1)) {
            case "/":
              var end2 = source10.indexOf(">", tagStart + 2);
              var tagNameRaw = source10.substring(tagStart + 2, end2 > 0 ? end2 : void 0);
              if (!tagNameRaw) {
                return errorHandler.fatalError("end tag name missing");
              }
              var tagNameMatch = end2 > 0 && g.reg("^", g.QName_group, g.S_OPT, "$").exec(tagNameRaw);
              if (!tagNameMatch) {
                return errorHandler.fatalError('end tag name contains invalid characters: "' + tagNameRaw + '"');
              }
              if (!domBuilder.currentElement && !domBuilder.doc.documentElement) {
                return;
              }
              var currentTagName = unclosedTags[unclosedTags.length - 1] || domBuilder.currentElement.tagName || domBuilder.doc.documentElement.tagName || "";
              if (currentTagName !== tagNameMatch[1]) {
                var tagNameLower = tagNameMatch[1].toLowerCase();
                if (!isHTML || currentTagName.toLowerCase() !== tagNameLower) {
                  return errorHandler.fatalError('Opening and ending tag mismatch: "' + currentTagName + '" != "' + tagNameRaw + '"');
                }
              }
              var config2 = parseStack.pop();
              unclosedTags.pop();
              var localNSMap = config2.localNSMap;
              domBuilder.endElement(config2.uri, config2.localName, currentTagName);
              if (localNSMap) {
                for (var prefix3 in localNSMap) {
                  if (hasOwn(localNSMap, prefix3)) {
                    domBuilder.endPrefixMapping(prefix3);
                  }
                }
              }
              end2++;
              break;
            // end element
            case "?":
              locator && position4(tagStart);
              end2 = parseProcessingInstruction(source10, tagStart, domBuilder, errorHandler);
              break;
            case "!":
              locator && position4(tagStart);
              end2 = parseDoctypeCommentOrCData(source10, tagStart, domBuilder, errorHandler, isHTML);
              break;
            default:
              locator && position4(tagStart);
              var el = new ElementAttributes();
              var currentNSMap = parseStack[parseStack.length - 1].currentNSMap;
              var end2 = parseElementStartPart(source10, tagStart, el, currentNSMap, entityReplacer, errorHandler, isHTML);
              var len = el.length;
              if (!el.closed) {
                if (isHTML && conventions.isHTMLVoidElement(el.tagName)) {
                  el.closed = true;
                } else {
                  unclosedTags.push(el.tagName);
                }
              }
              if (locator && len) {
                var locator2 = copyLocator(locator, {});
                for (var i = 0; i < len; i++) {
                  var a = el[i];
                  position4(a.offset);
                  a.locator = copyLocator(locator, {});
                }
                domBuilder.locator = locator2;
                if (appendElement(el, domBuilder, currentNSMap)) {
                  parseStack.push(el);
                }
                domBuilder.locator = locator;
              } else {
                if (appendElement(el, domBuilder, currentNSMap)) {
                  parseStack.push(el);
                }
              }
              if (isHTML && !el.closed) {
                end2 = parseHtmlSpecialContent(source10, end2, el.tagName, entityReplacer, domBuilder);
              } else {
                end2++;
              }
          }
        } catch (e) {
          if (e instanceof ParseError) {
            throw e;
          } else if (e instanceof DOMException) {
            throw new ParseError(e.name + ": " + e.message, domBuilder.locator, e);
          }
          errorHandler.error("element parse error: " + e);
          end2 = -1;
        }
        if (end2 > start3) {
          start3 = end2;
        } else {
          appendText(Math.max(tagStart, start3) + 1);
        }
      }
    }
    function copyLocator(f, t) {
      t.lineNumber = f.lineNumber;
      t.columnNumber = f.columnNumber;
      return t;
    }
    function parseElementStartPart(source10, start3, el, currentNSMap, entityReplacer, errorHandler, isHTML) {
      function addAttribute(qname, value9, startIndex2) {
        if (hasOwn(el.attributeNames, qname)) {
          return errorHandler.fatalError("Attribute " + qname + " redefined");
        }
        if (!isHTML && value9.indexOf("<") >= 0) {
          return errorHandler.fatalError("Unescaped '<' not allowed in attributes values");
        }
        el.addValue(
          qname,
          // @see https://www.w3.org/TR/xml/#AVNormalize
          // since the xmldom sax parser does not "interpret" DTD the following is not implemented:
          // - recursive replacement of (DTD) entity references
          // - trimming and collapsing multiple spaces into a single one for attributes that are not of type CDATA
          value9.replace(/[\t\n\r]/g, " ").replace(ENTITY_REG, entityReplacer),
          startIndex2
        );
      }
      var attrName;
      var value8;
      var p = ++start3;
      var s = S_TAG;
      while (true) {
        var c = source10.charAt(p);
        switch (c) {
          case "=":
            if (s === S_ATTR) {
              attrName = source10.slice(start3, p);
              s = S_EQ;
            } else if (s === S_ATTR_SPACE) {
              s = S_EQ;
            } else {
              throw new Error("attribute equal must after attrName");
            }
            break;
          case "'":
          case '"':
            if (s === S_EQ || s === S_ATTR) {
              if (s === S_ATTR) {
                errorHandler.warning('attribute value must after "="');
                attrName = source10.slice(start3, p);
              }
              start3 = p + 1;
              p = source10.indexOf(c, start3);
              if (p > 0) {
                value8 = source10.slice(start3, p);
                addAttribute(attrName, value8, start3 - 1);
                s = S_ATTR_END;
              } else {
                throw new Error("attribute value no end '" + c + "' match");
              }
            } else if (s == S_ATTR_NOQUOT_VALUE) {
              value8 = source10.slice(start3, p);
              addAttribute(attrName, value8, start3);
              errorHandler.warning('attribute "' + attrName + '" missed start quot(' + c + ")!!");
              start3 = p + 1;
              s = S_ATTR_END;
            } else {
              throw new Error('attribute value must after "="');
            }
            break;
          case "/":
            switch (s) {
              case S_TAG:
                el.setTagName(source10.slice(start3, p));
              case S_ATTR_END:
              case S_TAG_SPACE:
              case S_TAG_CLOSE:
                s = S_TAG_CLOSE;
                el.closed = true;
              case S_ATTR_NOQUOT_VALUE:
              case S_ATTR:
                break;
              case S_ATTR_SPACE:
                el.closed = true;
                break;
              //case S_EQ:
              default:
                throw new Error("attribute invalid close char('/')");
            }
            break;
          case "":
            errorHandler.error("unexpected end of input");
            if (s == S_TAG) {
              el.setTagName(source10.slice(start3, p));
            }
            return p;
          case ">":
            switch (s) {
              case S_TAG:
                el.setTagName(source10.slice(start3, p));
              case S_ATTR_END:
              case S_TAG_SPACE:
              case S_TAG_CLOSE:
                break;
              //normal
              case S_ATTR_NOQUOT_VALUE:
              //Compatible state
              case S_ATTR:
                value8 = source10.slice(start3, p);
                if (value8.slice(-1) === "/") {
                  el.closed = true;
                  value8 = value8.slice(0, -1);
                }
              case S_ATTR_SPACE:
                if (s === S_ATTR_SPACE) {
                  value8 = attrName;
                }
                if (s == S_ATTR_NOQUOT_VALUE) {
                  errorHandler.warning('attribute "' + value8 + '" missed quot(")!');
                  addAttribute(attrName, value8, start3);
                } else {
                  if (!isHTML) {
                    errorHandler.warning('attribute "' + value8 + '" missed value!! "' + value8 + '" instead!!');
                  }
                  addAttribute(value8, value8, start3);
                }
                break;
              case S_EQ:
                if (!isHTML) {
                  return errorHandler.fatalError(`AttValue: ' or " expected`);
                }
            }
            return p;
          /*xml space '\x20' | #x9 | #xD | #xA; */
          case "\x80":
            c = " ";
          default:
            if (c <= " ") {
              switch (s) {
                case S_TAG:
                  el.setTagName(source10.slice(start3, p));
                  s = S_TAG_SPACE;
                  break;
                case S_ATTR:
                  attrName = source10.slice(start3, p);
                  s = S_ATTR_SPACE;
                  break;
                case S_ATTR_NOQUOT_VALUE:
                  var value8 = source10.slice(start3, p);
                  errorHandler.warning('attribute "' + value8 + '" missed quot(")!!');
                  addAttribute(attrName, value8, start3);
                case S_ATTR_END:
                  s = S_TAG_SPACE;
                  break;
              }
            } else {
              switch (s) {
                //case S_TAG:void();break;
                //case S_ATTR:void();break;
                //case S_ATTR_NOQUOT_VALUE:void();break;
                case S_ATTR_SPACE:
                  if (!isHTML) {
                    errorHandler.warning('attribute "' + attrName + '" missed value!! "' + attrName + '" instead2!!');
                  }
                  addAttribute(attrName, attrName, start3);
                  start3 = p;
                  s = S_ATTR;
                  break;
                case S_ATTR_END:
                  errorHandler.warning('attribute space is required"' + attrName + '"!!');
                case S_TAG_SPACE:
                  s = S_ATTR;
                  start3 = p;
                  break;
                case S_EQ:
                  s = S_ATTR_NOQUOT_VALUE;
                  start3 = p;
                  break;
                case S_TAG_CLOSE:
                  throw new Error("elements closed character '/' and '>' must be connected to");
              }
            }
        }
        p++;
      }
    }
    function appendElement(el, domBuilder, currentNSMap) {
      var tagName = el.tagName;
      var localNSMap = null;
      var i = el.length;
      while (i--) {
        var a = el[i];
        var qName = a.qName;
        var value8 = a.value;
        var nsp = qName.indexOf(":");
        if (nsp > 0) {
          var prefix3 = a.prefix = qName.slice(0, nsp);
          var localName = qName.slice(nsp + 1);
          var nsPrefix = prefix3 === "xmlns" && localName;
        } else {
          localName = qName;
          prefix3 = null;
          nsPrefix = qName === "xmlns" && "";
        }
        a.localName = localName;
        if (nsPrefix !== false) {
          if (localNSMap == null) {
            localNSMap = /* @__PURE__ */ Object.create(null);
            _copy(currentNSMap, currentNSMap = /* @__PURE__ */ Object.create(null));
          }
          currentNSMap[nsPrefix] = localNSMap[nsPrefix] = value8;
          a.uri = NAMESPACE.XMLNS;
          domBuilder.startPrefixMapping(nsPrefix, value8);
        }
      }
      var i = el.length;
      while (i--) {
        a = el[i];
        if (a.prefix) {
          if (a.prefix === "xml") {
            a.uri = NAMESPACE.XML;
          }
          if (a.prefix !== "xmlns") {
            a.uri = currentNSMap[a.prefix];
          }
        }
      }
      var nsp = tagName.indexOf(":");
      if (nsp > 0) {
        prefix3 = el.prefix = tagName.slice(0, nsp);
        localName = el.localName = tagName.slice(nsp + 1);
      } else {
        prefix3 = null;
        localName = el.localName = tagName;
      }
      var ns3 = el.uri = currentNSMap[prefix3 || ""];
      domBuilder.startElement(ns3, localName, tagName, el);
      if (el.closed) {
        domBuilder.endElement(ns3, localName, tagName);
        if (localNSMap) {
          for (prefix3 in localNSMap) {
            if (hasOwn(localNSMap, prefix3)) {
              domBuilder.endPrefixMapping(prefix3);
            }
          }
        }
      } else {
        el.currentNSMap = currentNSMap;
        el.localNSMap = localNSMap;
        return true;
      }
    }
    function parseHtmlSpecialContent(source10, elStartEnd, tagName, entityReplacer, domBuilder) {
      var isEscapableRaw = isHTMLEscapableRawTextElement(tagName);
      if (isEscapableRaw || isHTMLRawTextElement(tagName)) {
        var elEndStart = source10.indexOf("</" + tagName + ">", elStartEnd);
        var text4 = source10.substring(elStartEnd + 1, elEndStart);
        if (isEscapableRaw) {
          text4 = text4.replace(ENTITY_REG, entityReplacer);
        }
        domBuilder.characters(text4, 0, text4.length);
        return elEndStart;
      }
      return elStartEnd + 1;
    }
    function _copy(source10, target6) {
      for (var n3 in source10) {
        if (hasOwn(source10, n3)) {
          target6[n3] = source10[n3];
        }
      }
    }
    function parseUtils(source10, start3) {
      var index2 = start3;
      function char(n3) {
        n3 = n3 || 0;
        return source10.charAt(index2 + n3);
      }
      function skip(n3) {
        n3 = n3 || 1;
        index2 += n3;
      }
      function skipBlanks() {
        var blanks = 0;
        while (index2 < source10.length) {
          var c = char();
          if (c !== " " && c !== "\n" && c !== "	" && c !== "\r") {
            return blanks;
          }
          blanks++;
          skip();
        }
        return -1;
      }
      function substringFromIndex() {
        return source10.substring(index2);
      }
      function substringStartsWith(text4) {
        return source10.substring(index2, index2 + text4.length) === text4;
      }
      function substringStartsWithCaseInsensitive(text4) {
        return source10.substring(index2, index2 + text4.length).toUpperCase() === text4.toUpperCase();
      }
      function getMatch(args) {
        var expr = g.reg("^", args);
        var match = expr.exec(substringFromIndex());
        if (match) {
          skip(match[0].length);
          return match[0];
        }
        return null;
      }
      return {
        char,
        getIndex: function() {
          return index2;
        },
        getMatch,
        getSource: function() {
          return source10;
        },
        skip,
        skipBlanks,
        substringFromIndex,
        substringStartsWith,
        substringStartsWithCaseInsensitive
      };
    }
    function parseDoctypeInternalSubset(p, errorHandler) {
      function parsePI(p2, errorHandler2) {
        var match = g.PI.exec(p2.substringFromIndex());
        if (!match) {
          return errorHandler2.fatalError("processing instruction is not well-formed at position " + p2.getIndex());
        }
        if (match[1].toLowerCase() === "xml") {
          return errorHandler2.fatalError(
            "xml declaration is only allowed at the start of the document, but found at position " + p2.getIndex()
          );
        }
        p2.skip(match[0].length);
        return match[0];
      }
      var source10 = p.getSource();
      if (p.char() === "[") {
        p.skip(1);
        var intSubsetStart = p.getIndex();
        while (p.getIndex() < source10.length) {
          p.skipBlanks();
          if (p.char() === "]") {
            var internalSubset = source10.substring(intSubsetStart, p.getIndex());
            p.skip(1);
            return internalSubset;
          }
          var current3 = null;
          if (p.char() === "<" && p.char(1) === "!") {
            switch (p.char(2)) {
              case "E":
                if (p.char(3) === "L") {
                  current3 = p.getMatch(g.elementdecl);
                } else if (p.char(3) === "N") {
                  current3 = p.getMatch(g.EntityDecl);
                }
                break;
              case "A":
                current3 = p.getMatch(g.AttlistDecl);
                break;
              case "N":
                current3 = p.getMatch(g.NotationDecl);
                break;
              case "-":
                current3 = p.getMatch(g.Comment);
                break;
            }
          } else if (p.char() === "<" && p.char(1) === "?") {
            current3 = parsePI(p, errorHandler);
          } else if (p.char() === "%") {
            current3 = p.getMatch(g.PEReference);
          } else {
            return errorHandler.fatalError("Error detected in Markup declaration");
          }
          if (!current3) {
            return errorHandler.fatalError("Error in internal subset at position " + p.getIndex());
          }
        }
        return errorHandler.fatalError("doctype internal subset is not well-formed, missing ]");
      }
    }
    function parseDoctypeCommentOrCData(source10, start3, domBuilder, errorHandler, isHTML) {
      var p = parseUtils(source10, start3);
      switch (isHTML ? p.char(2).toUpperCase() : p.char(2)) {
        case "-":
          var comment6 = p.getMatch(g.Comment);
          if (comment6) {
            domBuilder.comment(comment6, g.COMMENT_START.length, comment6.length - g.COMMENT_START.length - g.COMMENT_END.length);
            return p.getIndex();
          } else {
            return errorHandler.fatalError("comment is not well-formed at position " + p.getIndex());
          }
        case "[":
          var cdata = p.getMatch(g.CDSect);
          if (cdata) {
            if (!isHTML && !domBuilder.currentElement) {
              return errorHandler.fatalError("CDATA outside of element");
            }
            domBuilder.startCDATA();
            domBuilder.characters(cdata, g.CDATA_START.length, cdata.length - g.CDATA_START.length - g.CDATA_END.length);
            domBuilder.endCDATA();
            return p.getIndex();
          } else {
            return errorHandler.fatalError("Invalid CDATA starting at position " + start3);
          }
        case "D": {
          if (domBuilder.doc && domBuilder.doc.documentElement) {
            return errorHandler.fatalError("Doctype not allowed inside or after documentElement at position " + p.getIndex());
          }
          if (isHTML ? !p.substringStartsWithCaseInsensitive(g.DOCTYPE_DECL_START) : !p.substringStartsWith(g.DOCTYPE_DECL_START)) {
            return errorHandler.fatalError("Expected " + g.DOCTYPE_DECL_START + " at position " + p.getIndex());
          }
          p.skip(g.DOCTYPE_DECL_START.length);
          if (p.skipBlanks() < 1) {
            return errorHandler.fatalError("Expected whitespace after " + g.DOCTYPE_DECL_START + " at position " + p.getIndex());
          }
          var doctype = {
            name: void 0,
            publicId: void 0,
            systemId: void 0,
            internalSubset: void 0
          };
          doctype.name = p.getMatch(g.Name);
          if (!doctype.name)
            return errorHandler.fatalError("doctype name missing or contains unexpected characters at position " + p.getIndex());
          if (isHTML && doctype.name.toLowerCase() !== "html") {
            errorHandler.warning("Unexpected DOCTYPE in HTML document at position " + p.getIndex());
          }
          p.skipBlanks();
          if (p.substringStartsWith(g.PUBLIC) || p.substringStartsWith(g.SYSTEM)) {
            var match = g.ExternalID_match.exec(p.substringFromIndex());
            if (!match) {
              return errorHandler.fatalError("doctype external id is not well-formed at position " + p.getIndex());
            }
            if (match.groups.SystemLiteralOnly !== void 0) {
              doctype.systemId = match.groups.SystemLiteralOnly;
            } else {
              doctype.systemId = match.groups.SystemLiteral;
              doctype.publicId = match.groups.PubidLiteral;
            }
            p.skip(match[0].length);
          } else if (isHTML && p.substringStartsWithCaseInsensitive(g.SYSTEM)) {
            p.skip(g.SYSTEM.length);
            if (p.skipBlanks() < 1) {
              return errorHandler.fatalError("Expected whitespace after " + g.SYSTEM + " at position " + p.getIndex());
            }
            doctype.systemId = p.getMatch(g.ABOUT_LEGACY_COMPAT_SystemLiteral);
            if (!doctype.systemId) {
              return errorHandler.fatalError(
                "Expected " + g.ABOUT_LEGACY_COMPAT + " in single or double quotes after " + g.SYSTEM + " at position " + p.getIndex()
              );
            }
          }
          if (isHTML && doctype.systemId && !g.ABOUT_LEGACY_COMPAT_SystemLiteral.test(doctype.systemId)) {
            errorHandler.warning("Unexpected doctype.systemId in HTML document at position " + p.getIndex());
          }
          if (!isHTML) {
            p.skipBlanks();
            doctype.internalSubset = parseDoctypeInternalSubset(p, errorHandler);
          }
          p.skipBlanks();
          if (p.char() !== ">") {
            return errorHandler.fatalError("doctype not terminated with > at position " + p.getIndex());
          }
          p.skip(1);
          domBuilder.startDTD(doctype.name, doctype.publicId, doctype.systemId, doctype.internalSubset);
          domBuilder.endDTD();
          return p.getIndex();
        }
        default:
          return errorHandler.fatalError('Not well-formed XML starting with "<!" at position ' + start3);
      }
    }
    function parseProcessingInstruction(source10, start3, domBuilder, errorHandler) {
      var match = source10.substring(start3).match(g.PI);
      if (!match) {
        return errorHandler.fatalError("Invalid processing instruction starting at position " + start3);
      }
      if (match[1].toLowerCase() === "xml") {
        if (start3 > 0) {
          return errorHandler.fatalError(
            "processing instruction at position " + start3 + " is an xml declaration which is only at the start of the document"
          );
        }
        if (!g.XMLDecl.test(source10.substring(start3))) {
          return errorHandler.fatalError("xml declaration is not well-formed");
        }
      }
      domBuilder.processingInstruction(match[1], match[2]);
      return start3 + match[0].length;
    }
    function ElementAttributes() {
      this.attributeNames = /* @__PURE__ */ Object.create(null);
    }
    ElementAttributes.prototype = {
      setTagName: function(tagName) {
        if (!g.QName_exact.test(tagName)) {
          throw new Error("invalid tagName:" + tagName);
        }
        this.tagName = tagName;
      },
      addValue: function(qName, value8, offset3) {
        if (!g.QName_exact.test(qName)) {
          throw new Error("invalid attribute:" + qName);
        }
        this.attributeNames[qName] = this.length;
        this[this.length++] = { qName, value: value8, offset: offset3 };
      },
      length: 0,
      getLocalName: function(i) {
        return this[i].localName;
      },
      getLocator: function(i) {
        return this[i].locator;
      },
      getQName: function(i) {
        return this[i].qName;
      },
      getURI: function(i) {
        return this[i].uri;
      },
      getValue: function(i) {
        return this[i].value;
      }
      //	,getIndex:function(uri, localName)){
      //		if(localName){
      //
      //		}else{
      //			var qName = uri
      //		}
      //	},
      //	getValue:function(){return this.getValue(this.getIndex.apply(this,arguments))},
      //	getType:function(uri,localName){}
      //	getType:function(i){},
    };
    exports.XMLReader = XMLReader;
    exports.parseUtils = parseUtils;
    exports.parseDoctypeCommentOrCData = parseDoctypeCommentOrCData;
  }
});

// node_modules/@xmldom/xmldom/lib/dom-parser.js
var require_dom_parser = __commonJS({
  "node_modules/@xmldom/xmldom/lib/dom-parser.js"(exports) {
    "use strict";
    var conventions = require_conventions();
    var dom = require_dom();
    var errors = require_errors();
    var entities = require_entities();
    var sax = require_sax();
    var DOMImplementation = dom.DOMImplementation;
    var hasDefaultHTMLNamespace = conventions.hasDefaultHTMLNamespace;
    var isHTMLMimeType = conventions.isHTMLMimeType;
    var isValidMimeType = conventions.isValidMimeType;
    var MIME_TYPE = conventions.MIME_TYPE;
    var NAMESPACE = conventions.NAMESPACE;
    var ParseError = errors.ParseError;
    var XMLReader = sax.XMLReader;
    function normalizeLineEndings(input2) {
      return input2.replace(/\r[\n\u0085]/g, "\n").replace(/[\r\u0085\u2028\u2029]/g, "\n");
    }
    function DOMParser2(options) {
      options = options || {};
      if (options.locator === void 0) {
        options.locator = true;
      }
      this.assign = options.assign || conventions.assign;
      this.domHandler = options.domHandler || DOMHandler;
      this.onError = options.onError || options.errorHandler;
      if (options.errorHandler && typeof options.errorHandler !== "function") {
        throw new TypeError("errorHandler object is no longer supported, switch to onError!");
      } else if (options.errorHandler) {
        options.errorHandler("warning", "The `errorHandler` option has been deprecated, use `onError` instead!", this);
      }
      this.normalizeLineEndings = options.normalizeLineEndings || normalizeLineEndings;
      this.locator = !!options.locator;
      this.xmlns = this.assign(/* @__PURE__ */ Object.create(null), options.xmlns);
    }
    DOMParser2.prototype.parseFromString = function(source10, mimeType2) {
      if (!isValidMimeType(mimeType2)) {
        throw new TypeError('DOMParser.parseFromString: the provided mimeType "' + mimeType2 + '" is not valid.');
      }
      var defaultNSMap = this.assign(/* @__PURE__ */ Object.create(null), this.xmlns);
      var entityMap = entities.XML_ENTITIES;
      var defaultNamespace = defaultNSMap[""] || null;
      if (hasDefaultHTMLNamespace(mimeType2)) {
        entityMap = entities.HTML_ENTITIES;
        defaultNamespace = NAMESPACE.HTML;
      } else if (mimeType2 === MIME_TYPE.XML_SVG_IMAGE) {
        defaultNamespace = NAMESPACE.SVG;
      }
      defaultNSMap[""] = defaultNamespace;
      defaultNSMap.xml = defaultNSMap.xml || NAMESPACE.XML;
      var domBuilder = new this.domHandler({
        mimeType: mimeType2,
        defaultNamespace,
        onError: this.onError
      });
      var locator = this.locator ? {} : void 0;
      if (this.locator) {
        domBuilder.setDocumentLocator(locator);
      }
      var sax2 = new XMLReader();
      sax2.errorHandler = domBuilder;
      sax2.domBuilder = domBuilder;
      var isXml = !conventions.isHTMLMimeType(mimeType2);
      if (isXml && typeof source10 !== "string") {
        sax2.errorHandler.fatalError("source is not a string");
      }
      sax2.parse(this.normalizeLineEndings(String(source10)), defaultNSMap, entityMap);
      if (!domBuilder.doc.documentElement) {
        sax2.errorHandler.fatalError("missing root element");
      }
      return domBuilder.doc;
    };
    function DOMHandler(options) {
      var opt = options || {};
      this.mimeType = opt.mimeType || MIME_TYPE.XML_APPLICATION;
      this.defaultNamespace = opt.defaultNamespace || null;
      this.cdata = false;
      this.currentElement = void 0;
      this.doc = void 0;
      this.locator = void 0;
      this.onError = opt.onError;
    }
    function position4(locator, node3) {
      node3.lineNumber = locator.lineNumber;
      node3.columnNumber = locator.columnNumber;
    }
    DOMHandler.prototype = {
      /**
       * Either creates an XML or an HTML document and stores it under `this.doc`.
       * If it is an XML document, `this.defaultNamespace` is used to create it,
       * and it will not contain any `childNodes`.
       * If it is an HTML document, it will be created without any `childNodes`.
       *
       * @see http://www.saxproject.org/apidoc/org/xml/sax/ContentHandler.html
       */
      startDocument: function() {
        var impl = new DOMImplementation();
        this.doc = isHTMLMimeType(this.mimeType) ? impl.createHTMLDocument(false) : impl.createDocument(this.defaultNamespace, "");
      },
      startElement: function(namespaceURI, localName, qName, attrs) {
        var doc = this.doc;
        var el = doc.createElementNS(namespaceURI, qName || localName);
        var len = attrs.length;
        appendElement(this, el);
        this.currentElement = el;
        this.locator && position4(this.locator, el);
        for (var i = 0; i < len; i++) {
          var namespaceURI = attrs.getURI(i);
          var value8 = attrs.getValue(i);
          var qName = attrs.getQName(i);
          var attr = doc.createAttributeNS(namespaceURI, qName);
          this.locator && position4(attrs.getLocator(i), attr);
          attr.value = attr.nodeValue = value8;
          el.setAttributeNode(attr);
        }
      },
      endElement: function(namespaceURI, localName, qName) {
        this.currentElement = this.currentElement.parentNode;
      },
      startPrefixMapping: function(prefix3, uri6) {
      },
      endPrefixMapping: function(prefix3) {
      },
      processingInstruction: function(target6, data4) {
        var ins = this.doc.createProcessingInstruction(target6, data4);
        this.locator && position4(this.locator, ins);
        appendElement(this, ins);
      },
      ignorableWhitespace: function(ch, start3, length3) {
      },
      characters: function(chars, start3, length3) {
        chars = _toString.apply(this, arguments);
        if (chars) {
          if (this.cdata) {
            var charNode = this.doc.createCDATASection(chars);
          } else {
            var charNode = this.doc.createTextNode(chars);
          }
          if (this.currentElement) {
            this.currentElement.appendChild(charNode);
          } else if (/^\s*$/.test(chars)) {
            this.doc.appendChild(charNode);
          }
          this.locator && position4(this.locator, charNode);
        }
      },
      skippedEntity: function(name9) {
      },
      endDocument: function() {
        this.doc.normalize();
      },
      /**
       * Stores the locator to be able to set the `columnNumber` and `lineNumber`
       * on the created DOM nodes.
       *
       * @param {Locator} locator
       */
      setDocumentLocator: function(locator) {
        if (locator) {
          locator.lineNumber = 0;
        }
        this.locator = locator;
      },
      //LexicalHandler
      comment: function(chars, start3, length3) {
        chars = _toString.apply(this, arguments);
        var comm = this.doc.createComment(chars);
        this.locator && position4(this.locator, comm);
        appendElement(this, comm);
      },
      startCDATA: function() {
        this.cdata = true;
      },
      endCDATA: function() {
        this.cdata = false;
      },
      startDTD: function(name9, publicId, systemId, internalSubset) {
        var impl = this.doc.implementation;
        if (impl && impl.createDocumentType) {
          var dt = impl.createDocumentType(name9, publicId, systemId, internalSubset);
          this.locator && position4(this.locator, dt);
          appendElement(this, dt);
          this.doc.doctype = dt;
        }
      },
      reportError: function(level2, message4) {
        if (typeof this.onError === "function") {
          try {
            this.onError(level2, message4, this);
          } catch (e) {
            throw new ParseError("Reporting " + level2 + ' "' + message4 + '" caused ' + e, this.locator);
          }
        } else {
          console.error("[xmldom " + level2 + "]	" + message4, _locator(this.locator));
        }
      },
      /**
       * @see http://www.saxproject.org/apidoc/org/xml/sax/ErrorHandler.html
       */
      warning: function(message4) {
        this.reportError("warning", message4);
      },
      error: function(message4) {
        this.reportError("error", message4);
      },
      /**
       * This function reports a fatal error and throws a ParseError.
       *
       * @param {string} message
       * - The message to be used for reporting and throwing the error.
       * @returns {never}
       * This function always throws an error and never returns a value.
       * @throws {ParseError}
       * Always throws a ParseError with the provided message.
       */
      fatalError: function(message4) {
        this.reportError("fatalError", message4);
        throw new ParseError(message4, this.locator);
      }
    };
    function _locator(l) {
      if (l) {
        return "\n@#[line:" + l.lineNumber + ",col:" + l.columnNumber + "]";
      }
    }
    function _toString(chars, start3, length3) {
      if (typeof chars == "string") {
        return chars.substr(start3, length3);
      } else {
        if (chars.length >= start3 + length3 || start3) {
          return new java.lang.String(chars, start3, length3) + "";
        }
        return chars;
      }
    }
    "endDTD,startEntity,endEntity,attributeDecl,elementDecl,externalEntityDecl,internalEntityDecl,resolveEntity,getExternalSubset,notationDecl,unparsedEntityDecl".replace(
      /\w+/g,
      function(key3) {
        DOMHandler.prototype[key3] = function() {
          return null;
        };
      }
    );
    function appendElement(handler, node3) {
      if (!handler.currentElement) {
        handler.doc.appendChild(node3);
      } else {
        handler.currentElement.appendChild(node3);
      }
    }
    function onErrorStopParsing(level2) {
      if (level2 === "error") throw "onErrorStopParsing";
    }
    function onWarningStopParsing() {
      throw "onWarningStopParsing";
    }
    exports.__DOMHandler = DOMHandler;
    exports.DOMParser = DOMParser2;
    exports.normalizeLineEndings = normalizeLineEndings;
    exports.onErrorStopParsing = onErrorStopParsing;
    exports.onWarningStopParsing = onWarningStopParsing;
  }
});

// node_modules/@xmldom/xmldom/lib/index.js
var require_lib = __commonJS({
  "node_modules/@xmldom/xmldom/lib/index.js"(exports) {
    "use strict";
    var conventions = require_conventions();
    exports.assign = conventions.assign;
    exports.hasDefaultHTMLNamespace = conventions.hasDefaultHTMLNamespace;
    exports.isHTMLMimeType = conventions.isHTMLMimeType;
    exports.isValidMimeType = conventions.isValidMimeType;
    exports.MIME_TYPE = conventions.MIME_TYPE;
    exports.NAMESPACE = conventions.NAMESPACE;
    var errors = require_errors();
    exports.DOMException = errors.DOMException;
    exports.DOMExceptionName = errors.DOMExceptionName;
    exports.ExceptionCode = errors.ExceptionCode;
    exports.ParseError = errors.ParseError;
    var dom = require_dom();
    exports.Attr = dom.Attr;
    exports.CDATASection = dom.CDATASection;
    exports.CharacterData = dom.CharacterData;
    exports.Comment = dom.Comment;
    exports.Document = dom.Document;
    exports.DocumentFragment = dom.DocumentFragment;
    exports.DocumentType = dom.DocumentType;
    exports.DOMImplementation = dom.DOMImplementation;
    exports.Element = dom.Element;
    exports.Entity = dom.Entity;
    exports.EntityReference = dom.EntityReference;
    exports.LiveNodeList = dom.LiveNodeList;
    exports.NamedNodeMap = dom.NamedNodeMap;
    exports.Node = dom.Node;
    exports.NodeList = dom.NodeList;
    exports.Notation = dom.Notation;
    exports.ProcessingInstruction = dom.ProcessingInstruction;
    exports.Text = dom.Text;
    exports.XMLSerializer = dom.XMLSerializer;
    var domParser = require_dom_parser();
    exports.DOMParser = domParser.DOMParser;
    exports.normalizeLineEndings = domParser.normalizeLineEndings;
    exports.onErrorStopParsing = domParser.onErrorStopParsing;
    exports.onWarningStopParsing = domParser.onWarningStopParsing;
  }
});

// ../node_modules/base64-js/index.js
var require_base64_js = __commonJS({
  "../node_modules/base64-js/index.js"(exports) {
    "use strict";
    exports.byteLength = byteLength;
    exports.toByteArray = toByteArray;
    exports.fromByteArray = fromByteArray;
    var lookup = [];
    var revLookup = [];
    var Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
    var code5 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    for (i = 0, len = code5.length; i < len; ++i) {
      lookup[i] = code5[i];
      revLookup[code5.charCodeAt(i)] = i;
    }
    var i;
    var len;
    revLookup["-".charCodeAt(0)] = 62;
    revLookup["_".charCodeAt(0)] = 63;
    function getLens(b64) {
      var len2 = b64.length;
      if (len2 % 4 > 0) {
        throw new Error("Invalid string. Length must be a multiple of 4");
      }
      var validLen = b64.indexOf("=");
      if (validLen === -1) validLen = len2;
      var placeHoldersLen = validLen === len2 ? 0 : 4 - validLen % 4;
      return [validLen, placeHoldersLen];
    }
    function byteLength(b64) {
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function _byteLength(b64, validLen, placeHoldersLen) {
      return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
    }
    function toByteArray(b64) {
      var tmp;
      var lens = getLens(b64);
      var validLen = lens[0];
      var placeHoldersLen = lens[1];
      var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
      var curByte = 0;
      var len2 = placeHoldersLen > 0 ? validLen - 4 : validLen;
      var i2;
      for (i2 = 0; i2 < len2; i2 += 4) {
        tmp = revLookup[b64.charCodeAt(i2)] << 18 | revLookup[b64.charCodeAt(i2 + 1)] << 12 | revLookup[b64.charCodeAt(i2 + 2)] << 6 | revLookup[b64.charCodeAt(i2 + 3)];
        arr[curByte++] = tmp >> 16 & 255;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i2)] << 2 | revLookup[b64.charCodeAt(i2 + 1)] >> 4;
        arr[curByte++] = tmp & 255;
      }
      if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i2)] << 10 | revLookup[b64.charCodeAt(i2 + 1)] << 4 | revLookup[b64.charCodeAt(i2 + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 255;
        arr[curByte++] = tmp & 255;
      }
      return arr;
    }
    function tripletToBase64(num) {
      return lookup[num >> 18 & 63] + lookup[num >> 12 & 63] + lookup[num >> 6 & 63] + lookup[num & 63];
    }
    function encodeChunk(uint8, start3, end2) {
      var tmp;
      var output2 = [];
      for (var i2 = start3; i2 < end2; i2 += 3) {
        tmp = (uint8[i2] << 16 & 16711680) + (uint8[i2 + 1] << 8 & 65280) + (uint8[i2 + 2] & 255);
        output2.push(tripletToBase64(tmp));
      }
      return output2.join("");
    }
    function fromByteArray(uint8) {
      var tmp;
      var len2 = uint8.length;
      var extraBytes = len2 % 3;
      var parts = [];
      var maxChunkLength = 16383;
      for (var i2 = 0, len22 = len2 - extraBytes; i2 < len22; i2 += maxChunkLength) {
        parts.push(encodeChunk(uint8, i2, i2 + maxChunkLength > len22 ? len22 : i2 + maxChunkLength));
      }
      if (extraBytes === 1) {
        tmp = uint8[len2 - 1];
        parts.push(
          lookup[tmp >> 2] + lookup[tmp << 4 & 63] + "=="
        );
      } else if (extraBytes === 2) {
        tmp = (uint8[len2 - 2] << 8) + uint8[len2 - 1];
        parts.push(
          lookup[tmp >> 10] + lookup[tmp >> 4 & 63] + lookup[tmp << 2 & 63] + "="
        );
      }
      return parts.join("");
    }
  }
});

// ../node_modules/ieee754/index.js
var require_ieee754 = __commonJS({
  "../node_modules/ieee754/index.js"(exports) {
    exports.read = function(buffer, offset3, isLE, mLen, nBytes) {
      var e, m;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var nBits = -7;
      var i = isLE ? nBytes - 1 : 0;
      var d = isLE ? -1 : 1;
      var s = buffer[offset3 + i];
      i += d;
      e = s & (1 << -nBits) - 1;
      s >>= -nBits;
      nBits += eLen;
      for (; nBits > 0; e = e * 256 + buffer[offset3 + i], i += d, nBits -= 8) {
      }
      m = e & (1 << -nBits) - 1;
      e >>= -nBits;
      nBits += mLen;
      for (; nBits > 0; m = m * 256 + buffer[offset3 + i], i += d, nBits -= 8) {
      }
      if (e === 0) {
        e = 1 - eBias;
      } else if (e === eMax) {
        return m ? NaN : (s ? -1 : 1) * Infinity;
      } else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
      }
      return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
    };
    exports.write = function(buffer, value8, offset3, isLE, mLen, nBytes) {
      var e, m, c;
      var eLen = nBytes * 8 - mLen - 1;
      var eMax = (1 << eLen) - 1;
      var eBias = eMax >> 1;
      var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
      var i = isLE ? 0 : nBytes - 1;
      var d = isLE ? 1 : -1;
      var s = value8 < 0 || value8 === 0 && 1 / value8 < 0 ? 1 : 0;
      value8 = Math.abs(value8);
      if (isNaN(value8) || value8 === Infinity) {
        m = isNaN(value8) ? 1 : 0;
        e = eMax;
      } else {
        e = Math.floor(Math.log(value8) / Math.LN2);
        if (value8 * (c = Math.pow(2, -e)) < 1) {
          e--;
          c *= 2;
        }
        if (e + eBias >= 1) {
          value8 += rt / c;
        } else {
          value8 += rt * Math.pow(2, 1 - eBias);
        }
        if (value8 * c >= 2) {
          e++;
          c /= 2;
        }
        if (e + eBias >= eMax) {
          m = 0;
          e = eMax;
        } else if (e + eBias >= 1) {
          m = (value8 * c - 1) * Math.pow(2, mLen);
          e = e + eBias;
        } else {
          m = value8 * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
          e = 0;
        }
      }
      for (; mLen >= 8; buffer[offset3 + i] = m & 255, i += d, m /= 256, mLen -= 8) {
      }
      e = e << mLen | m;
      eLen += mLen;
      for (; eLen > 0; buffer[offset3 + i] = e & 255, i += d, e /= 256, eLen -= 8) {
      }
      buffer[offset3 + i - d] |= s * 128;
    };
  }
});

// ../node_modules/buffer/index.js
var require_buffer = __commonJS({
  "../node_modules/buffer/index.js"(exports) {
    "use strict";
    var base64 = require_base64_js();
    var ieee754 = require_ieee754();
    var customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" ? Symbol["for"]("nodejs.util.inspect.custom") : null;
    exports.Buffer = Buffer2;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    var K_MAX_LENGTH = 2147483647;
    exports.kMaxLength = K_MAX_LENGTH;
    Buffer2.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer2.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") {
      console.error(
        "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
      );
    }
    function typedArraySupport() {
      try {
        const arr = new Uint8Array(1);
        const proto = { foo: function() {
          return 42;
        } };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
      } catch (e) {
        return false;
      }
    }
    Object.defineProperty(Buffer2.prototype, "parent", {
      enumerable: true,
      get: function() {
        if (!Buffer2.isBuffer(this)) return void 0;
        return this.buffer;
      }
    });
    Object.defineProperty(Buffer2.prototype, "offset", {
      enumerable: true,
      get: function() {
        if (!Buffer2.isBuffer(this)) return void 0;
        return this.byteOffset;
      }
    });
    function createBuffer(length3) {
      if (length3 > K_MAX_LENGTH) {
        throw new RangeError('The value "' + length3 + '" is invalid for option "size"');
      }
      const buf = new Uint8Array(length3);
      Object.setPrototypeOf(buf, Buffer2.prototype);
      return buf;
    }
    function Buffer2(arg2, encodingOrOffset, length3) {
      if (typeof arg2 === "number") {
        if (typeof encodingOrOffset === "string") {
          throw new TypeError(
            'The "string" argument must be of type string. Received type number'
          );
        }
        return allocUnsafe(arg2);
      }
      return from2(arg2, encodingOrOffset, length3);
    }
    Buffer2.poolSize = 8192;
    function from2(value8, encodingOrOffset, length3) {
      if (typeof value8 === "string") {
        return fromString(value8, encodingOrOffset);
      }
      if (ArrayBuffer.isView(value8)) {
        return fromArrayView(value8);
      }
      if (value8 == null) {
        throw new TypeError(
          "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value8
        );
      }
      if (isInstance(value8, ArrayBuffer) || value8 && isInstance(value8.buffer, ArrayBuffer)) {
        return fromArrayBuffer(value8, encodingOrOffset, length3);
      }
      if (typeof SharedArrayBuffer !== "undefined" && (isInstance(value8, SharedArrayBuffer) || value8 && isInstance(value8.buffer, SharedArrayBuffer))) {
        return fromArrayBuffer(value8, encodingOrOffset, length3);
      }
      if (typeof value8 === "number") {
        throw new TypeError(
          'The "value" argument must not be of type number. Received type number'
        );
      }
      const valueOf = value8.valueOf && value8.valueOf();
      if (valueOf != null && valueOf !== value8) {
        return Buffer2.from(valueOf, encodingOrOffset, length3);
      }
      const b = fromObject(value8);
      if (b) return b;
      if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value8[Symbol.toPrimitive] === "function") {
        return Buffer2.from(value8[Symbol.toPrimitive]("string"), encodingOrOffset, length3);
      }
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value8
      );
    }
    Buffer2.from = function(value8, encodingOrOffset, length3) {
      return from2(value8, encodingOrOffset, length3);
    };
    Object.setPrototypeOf(Buffer2.prototype, Uint8Array.prototype);
    Object.setPrototypeOf(Buffer2, Uint8Array);
    function assertSize(size4) {
      if (typeof size4 !== "number") {
        throw new TypeError('"size" argument must be of type number');
      } else if (size4 < 0) {
        throw new RangeError('The value "' + size4 + '" is invalid for option "size"');
      }
    }
    function alloc(size4, fill, encoding3) {
      assertSize(size4);
      if (size4 <= 0) {
        return createBuffer(size4);
      }
      if (fill !== void 0) {
        return typeof encoding3 === "string" ? createBuffer(size4).fill(fill, encoding3) : createBuffer(size4).fill(fill);
      }
      return createBuffer(size4);
    }
    Buffer2.alloc = function(size4, fill, encoding3) {
      return alloc(size4, fill, encoding3);
    };
    function allocUnsafe(size4) {
      assertSize(size4);
      return createBuffer(size4 < 0 ? 0 : checked(size4) | 0);
    }
    Buffer2.allocUnsafe = function(size4) {
      return allocUnsafe(size4);
    };
    Buffer2.allocUnsafeSlow = function(size4) {
      return allocUnsafe(size4);
    };
    function fromString(string3, encoding3) {
      if (typeof encoding3 !== "string" || encoding3 === "") {
        encoding3 = "utf8";
      }
      if (!Buffer2.isEncoding(encoding3)) {
        throw new TypeError("Unknown encoding: " + encoding3);
      }
      const length3 = byteLength(string3, encoding3) | 0;
      let buf = createBuffer(length3);
      const actual2 = buf.write(string3, encoding3);
      if (actual2 !== length3) {
        buf = buf.slice(0, actual2);
      }
      return buf;
    }
    function fromArrayLike2(array) {
      const length3 = array.length < 0 ? 0 : checked(array.length) | 0;
      const buf = createBuffer(length3);
      for (let i = 0; i < length3; i += 1) {
        buf[i] = array[i] & 255;
      }
      return buf;
    }
    function fromArrayView(arrayView) {
      if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
      }
      return fromArrayLike2(arrayView);
    }
    function fromArrayBuffer(array, byteOffset, length3) {
      if (byteOffset < 0 || array.byteLength < byteOffset) {
        throw new RangeError('"offset" is outside of buffer bounds');
      }
      if (array.byteLength < byteOffset + (length3 || 0)) {
        throw new RangeError('"length" is outside of buffer bounds');
      }
      let buf;
      if (byteOffset === void 0 && length3 === void 0) {
        buf = new Uint8Array(array);
      } else if (length3 === void 0) {
        buf = new Uint8Array(array, byteOffset);
      } else {
        buf = new Uint8Array(array, byteOffset, length3);
      }
      Object.setPrototypeOf(buf, Buffer2.prototype);
      return buf;
    }
    function fromObject(obj) {
      if (Buffer2.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) {
          return buf;
        }
        obj.copy(buf, 0, 0, len);
        return buf;
      }
      if (obj.length !== void 0) {
        if (typeof obj.length !== "number" || numberIsNaN(obj.length)) {
          return createBuffer(0);
        }
        return fromArrayLike2(obj);
      }
      if (obj.type === "Buffer" && Array.isArray(obj.data)) {
        return fromArrayLike2(obj.data);
      }
    }
    function checked(length3) {
      if (length3 >= K_MAX_LENGTH) {
        throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + " bytes");
      }
      return length3 | 0;
    }
    function SlowBuffer(length3) {
      if (+length3 != length3) {
        length3 = 0;
      }
      return Buffer2.alloc(+length3);
    }
    Buffer2.isBuffer = function isBuffer(b) {
      return b != null && b._isBuffer === true && b !== Buffer2.prototype;
    };
    Buffer2.compare = function compare(a, b) {
      if (isInstance(a, Uint8Array)) a = Buffer2.from(a, a.offset, a.byteLength);
      if (isInstance(b, Uint8Array)) b = Buffer2.from(b, b.offset, b.byteLength);
      if (!Buffer2.isBuffer(a) || !Buffer2.isBuffer(b)) {
        throw new TypeError(
          'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
        );
      }
      if (a === b) return 0;
      let x = a.length;
      let y = b.length;
      for (let i = 0, len = Math.min(x, y); i < len; ++i) {
        if (a[i] !== b[i]) {
          x = a[i];
          y = b[i];
          break;
        }
      }
      if (x < y) return -1;
      if (y < x) return 1;
      return 0;
    };
    Buffer2.isEncoding = function isEncoding(encoding3) {
      switch (String(encoding3).toLowerCase()) {
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return true;
        default:
          return false;
      }
    };
    Buffer2.concat = function concat2(list, length3) {
      if (!Array.isArray(list)) {
        throw new TypeError('"list" argument must be an Array of Buffers');
      }
      if (list.length === 0) {
        return Buffer2.alloc(0);
      }
      let i;
      if (length3 === void 0) {
        length3 = 0;
        for (i = 0; i < list.length; ++i) {
          length3 += list[i].length;
        }
      }
      const buffer = Buffer2.allocUnsafe(length3);
      let pos = 0;
      for (i = 0; i < list.length; ++i) {
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
          if (pos + buf.length > buffer.length) {
            if (!Buffer2.isBuffer(buf)) buf = Buffer2.from(buf);
            buf.copy(buffer, pos);
          } else {
            Uint8Array.prototype.set.call(
              buffer,
              buf,
              pos
            );
          }
        } else if (!Buffer2.isBuffer(buf)) {
          throw new TypeError('"list" argument must be an Array of Buffers');
        } else {
          buf.copy(buffer, pos);
        }
        pos += buf.length;
      }
      return buffer;
    };
    function byteLength(string3, encoding3) {
      if (Buffer2.isBuffer(string3)) {
        return string3.length;
      }
      if (ArrayBuffer.isView(string3) || isInstance(string3, ArrayBuffer)) {
        return string3.byteLength;
      }
      if (typeof string3 !== "string") {
        throw new TypeError(
          'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string3
        );
      }
      const len = string3.length;
      const mustMatch = arguments.length > 2 && arguments[2] === true;
      if (!mustMatch && len === 0) return 0;
      let loweredCase = false;
      for (; ; ) {
        switch (encoding3) {
          case "ascii":
          case "latin1":
          case "binary":
            return len;
          case "utf8":
          case "utf-8":
            return utf8ToBytes(string3).length;
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return len * 2;
          case "hex":
            return len >>> 1;
          case "base64":
            return base64ToBytes(string3).length;
          default:
            if (loweredCase) {
              return mustMatch ? -1 : utf8ToBytes(string3).length;
            }
            encoding3 = ("" + encoding3).toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer2.byteLength = byteLength;
    function slowToString(encoding3, start3, end2) {
      let loweredCase = false;
      if (start3 === void 0 || start3 < 0) {
        start3 = 0;
      }
      if (start3 > this.length) {
        return "";
      }
      if (end2 === void 0 || end2 > this.length) {
        end2 = this.length;
      }
      if (end2 <= 0) {
        return "";
      }
      end2 >>>= 0;
      start3 >>>= 0;
      if (end2 <= start3) {
        return "";
      }
      if (!encoding3) encoding3 = "utf8";
      while (true) {
        switch (encoding3) {
          case "hex":
            return hexSlice(this, start3, end2);
          case "utf8":
          case "utf-8":
            return utf8Slice(this, start3, end2);
          case "ascii":
            return asciiSlice(this, start3, end2);
          case "latin1":
          case "binary":
            return latin1Slice(this, start3, end2);
          case "base64":
            return base64Slice(this, start3, end2);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return utf16leSlice(this, start3, end2);
          default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding3);
            encoding3 = (encoding3 + "").toLowerCase();
            loweredCase = true;
        }
      }
    }
    Buffer2.prototype._isBuffer = true;
    function swap(b, n3, m) {
      const i = b[n3];
      b[n3] = b[m];
      b[m] = i;
    }
    Buffer2.prototype.swap16 = function swap16() {
      const len = this.length;
      if (len % 2 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 16-bits");
      }
      for (let i = 0; i < len; i += 2) {
        swap(this, i, i + 1);
      }
      return this;
    };
    Buffer2.prototype.swap32 = function swap32() {
      const len = this.length;
      if (len % 4 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 32-bits");
      }
      for (let i = 0; i < len; i += 4) {
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
      }
      return this;
    };
    Buffer2.prototype.swap64 = function swap64() {
      const len = this.length;
      if (len % 8 !== 0) {
        throw new RangeError("Buffer size must be a multiple of 64-bits");
      }
      for (let i = 0; i < len; i += 8) {
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
      }
      return this;
    };
    Buffer2.prototype.toString = function toString() {
      const length3 = this.length;
      if (length3 === 0) return "";
      if (arguments.length === 0) return utf8Slice(this, 0, length3);
      return slowToString.apply(this, arguments);
    };
    Buffer2.prototype.toLocaleString = Buffer2.prototype.toString;
    Buffer2.prototype.equals = function equals2(b) {
      if (!Buffer2.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
      if (this === b) return true;
      return Buffer2.compare(this, b) === 0;
    };
    Buffer2.prototype.inspect = function inspect() {
      let str = "";
      const max3 = exports.INSPECT_MAX_BYTES;
      str = this.toString("hex", 0, max3).replace(/(.{2})/g, "$1 ").trim();
      if (this.length > max3) str += " ... ";
      return "<Buffer " + str + ">";
    };
    if (customInspectSymbol) {
      Buffer2.prototype[customInspectSymbol] = Buffer2.prototype.inspect;
    }
    Buffer2.prototype.compare = function compare(target6, start3, end2, thisStart, thisEnd) {
      if (isInstance(target6, Uint8Array)) {
        target6 = Buffer2.from(target6, target6.offset, target6.byteLength);
      }
      if (!Buffer2.isBuffer(target6)) {
        throw new TypeError(
          'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target6
        );
      }
      if (start3 === void 0) {
        start3 = 0;
      }
      if (end2 === void 0) {
        end2 = target6 ? target6.length : 0;
      }
      if (thisStart === void 0) {
        thisStart = 0;
      }
      if (thisEnd === void 0) {
        thisEnd = this.length;
      }
      if (start3 < 0 || end2 > target6.length || thisStart < 0 || thisEnd > this.length) {
        throw new RangeError("out of range index");
      }
      if (thisStart >= thisEnd && start3 >= end2) {
        return 0;
      }
      if (thisStart >= thisEnd) {
        return -1;
      }
      if (start3 >= end2) {
        return 1;
      }
      start3 >>>= 0;
      end2 >>>= 0;
      thisStart >>>= 0;
      thisEnd >>>= 0;
      if (this === target6) return 0;
      let x = thisEnd - thisStart;
      let y = end2 - start3;
      const len = Math.min(x, y);
      const thisCopy = this.slice(thisStart, thisEnd);
      const targetCopy = target6.slice(start3, end2);
      for (let i = 0; i < len; ++i) {
        if (thisCopy[i] !== targetCopy[i]) {
          x = thisCopy[i];
          y = targetCopy[i];
          break;
        }
      }
      if (x < y) return -1;
      if (y < x) return 1;
      return 0;
    };
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding3, dir) {
      if (buffer.length === 0) return -1;
      if (typeof byteOffset === "string") {
        encoding3 = byteOffset;
        byteOffset = 0;
      } else if (byteOffset > 2147483647) {
        byteOffset = 2147483647;
      } else if (byteOffset < -2147483648) {
        byteOffset = -2147483648;
      }
      byteOffset = +byteOffset;
      if (numberIsNaN(byteOffset)) {
        byteOffset = dir ? 0 : buffer.length - 1;
      }
      if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
      if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
      } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
      }
      if (typeof val === "string") {
        val = Buffer2.from(val, encoding3);
      }
      if (Buffer2.isBuffer(val)) {
        if (val.length === 0) {
          return -1;
        }
        return arrayIndexOf(buffer, val, byteOffset, encoding3, dir);
      } else if (typeof val === "number") {
        val = val & 255;
        if (typeof Uint8Array.prototype.indexOf === "function") {
          if (dir) {
            return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
          } else {
            return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
          }
        }
        return arrayIndexOf(buffer, [val], byteOffset, encoding3, dir);
      }
      throw new TypeError("val must be string, number or Buffer");
    }
    function arrayIndexOf(arr, val, byteOffset, encoding3, dir) {
      let indexSize = 1;
      let arrLength = arr.length;
      let valLength = val.length;
      if (encoding3 !== void 0) {
        encoding3 = String(encoding3).toLowerCase();
        if (encoding3 === "ucs2" || encoding3 === "ucs-2" || encoding3 === "utf16le" || encoding3 === "utf-16le") {
          if (arr.length < 2 || val.length < 2) {
            return -1;
          }
          indexSize = 2;
          arrLength /= 2;
          valLength /= 2;
          byteOffset /= 2;
        }
      }
      function read2(buf, i2) {
        if (indexSize === 1) {
          return buf[i2];
        } else {
          return buf.readUInt16BE(i2 * indexSize);
        }
      }
      let i;
      if (dir) {
        let foundIndex = -1;
        for (i = byteOffset; i < arrLength; i++) {
          if (read2(arr, i) === read2(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
          } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
          }
        }
      } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for (i = byteOffset; i >= 0; i--) {
          let found = true;
          for (let j = 0; j < valLength; j++) {
            if (read2(arr, i + j) !== read2(val, j)) {
              found = false;
              break;
            }
          }
          if (found) return i;
        }
      }
      return -1;
    }
    Buffer2.prototype.includes = function includes2(val, byteOffset, encoding3) {
      return this.indexOf(val, byteOffset, encoding3) !== -1;
    };
    Buffer2.prototype.indexOf = function indexOf(val, byteOffset, encoding3) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding3, true);
    };
    Buffer2.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding3) {
      return bidirectionalIndexOf(this, val, byteOffset, encoding3, false);
    };
    function hexWrite(buf, string3, offset3, length3) {
      offset3 = Number(offset3) || 0;
      const remaining = buf.length - offset3;
      if (!length3) {
        length3 = remaining;
      } else {
        length3 = Number(length3);
        if (length3 > remaining) {
          length3 = remaining;
        }
      }
      const strLen = string3.length;
      if (length3 > strLen / 2) {
        length3 = strLen / 2;
      }
      let i;
      for (i = 0; i < length3; ++i) {
        const parsed = parseInt(string3.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset3 + i] = parsed;
      }
      return i;
    }
    function utf8Write(buf, string3, offset3, length3) {
      return blitBuffer(utf8ToBytes(string3, buf.length - offset3), buf, offset3, length3);
    }
    function asciiWrite(buf, string3, offset3, length3) {
      return blitBuffer(asciiToBytes(string3), buf, offset3, length3);
    }
    function base64Write(buf, string3, offset3, length3) {
      return blitBuffer(base64ToBytes(string3), buf, offset3, length3);
    }
    function ucs2Write(buf, string3, offset3, length3) {
      return blitBuffer(utf16leToBytes(string3, buf.length - offset3), buf, offset3, length3);
    }
    Buffer2.prototype.write = function write(string3, offset3, length3, encoding3) {
      if (offset3 === void 0) {
        encoding3 = "utf8";
        length3 = this.length;
        offset3 = 0;
      } else if (length3 === void 0 && typeof offset3 === "string") {
        encoding3 = offset3;
        length3 = this.length;
        offset3 = 0;
      } else if (isFinite(offset3)) {
        offset3 = offset3 >>> 0;
        if (isFinite(length3)) {
          length3 = length3 >>> 0;
          if (encoding3 === void 0) encoding3 = "utf8";
        } else {
          encoding3 = length3;
          length3 = void 0;
        }
      } else {
        throw new Error(
          "Buffer.write(string, encoding, offset[, length]) is no longer supported"
        );
      }
      const remaining = this.length - offset3;
      if (length3 === void 0 || length3 > remaining) length3 = remaining;
      if (string3.length > 0 && (length3 < 0 || offset3 < 0) || offset3 > this.length) {
        throw new RangeError("Attempt to write outside buffer bounds");
      }
      if (!encoding3) encoding3 = "utf8";
      let loweredCase = false;
      for (; ; ) {
        switch (encoding3) {
          case "hex":
            return hexWrite(this, string3, offset3, length3);
          case "utf8":
          case "utf-8":
            return utf8Write(this, string3, offset3, length3);
          case "ascii":
          case "latin1":
          case "binary":
            return asciiWrite(this, string3, offset3, length3);
          case "base64":
            return base64Write(this, string3, offset3, length3);
          case "ucs2":
          case "ucs-2":
          case "utf16le":
          case "utf-16le":
            return ucs2Write(this, string3, offset3, length3);
          default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding3);
            encoding3 = ("" + encoding3).toLowerCase();
            loweredCase = true;
        }
      }
    };
    Buffer2.prototype.toJSON = function toJSON() {
      return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
      };
    };
    function base64Slice(buf, start3, end2) {
      if (start3 === 0 && end2 === buf.length) {
        return base64.fromByteArray(buf);
      } else {
        return base64.fromByteArray(buf.slice(start3, end2));
      }
    }
    function utf8Slice(buf, start3, end2) {
      end2 = Math.min(buf.length, end2);
      const res = [];
      let i = start3;
      while (i < end2) {
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 239 ? 4 : firstByte > 223 ? 3 : firstByte > 191 ? 2 : 1;
        if (i + bytesPerSequence <= end2) {
          let secondByte, thirdByte, fourthByte, tempCodePoint;
          switch (bytesPerSequence) {
            case 1:
              if (firstByte < 128) {
                codePoint = firstByte;
              }
              break;
            case 2:
              secondByte = buf[i + 1];
              if ((secondByte & 192) === 128) {
                tempCodePoint = (firstByte & 31) << 6 | secondByte & 63;
                if (tempCodePoint > 127) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 3:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 12 | (secondByte & 63) << 6 | thirdByte & 63;
                if (tempCodePoint > 2047 && (tempCodePoint < 55296 || tempCodePoint > 57343)) {
                  codePoint = tempCodePoint;
                }
              }
              break;
            case 4:
              secondByte = buf[i + 1];
              thirdByte = buf[i + 2];
              fourthByte = buf[i + 3];
              if ((secondByte & 192) === 128 && (thirdByte & 192) === 128 && (fourthByte & 192) === 128) {
                tempCodePoint = (firstByte & 15) << 18 | (secondByte & 63) << 12 | (thirdByte & 63) << 6 | fourthByte & 63;
                if (tempCodePoint > 65535 && tempCodePoint < 1114112) {
                  codePoint = tempCodePoint;
                }
              }
          }
        }
        if (codePoint === null) {
          codePoint = 65533;
          bytesPerSequence = 1;
        } else if (codePoint > 65535) {
          codePoint -= 65536;
          res.push(codePoint >>> 10 & 1023 | 55296);
          codePoint = 56320 | codePoint & 1023;
        }
        res.push(codePoint);
        i += bytesPerSequence;
      }
      return decodeCodePointsArray(res);
    }
    var MAX_ARGUMENTS_LENGTH = 4096;
    function decodeCodePointsArray(codePoints) {
      const len = codePoints.length;
      if (len <= MAX_ARGUMENTS_LENGTH) {
        return String.fromCharCode.apply(String, codePoints);
      }
      let res = "";
      let i = 0;
      while (i < len) {
        res += String.fromCharCode.apply(
          String,
          codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
        );
      }
      return res;
    }
    function asciiSlice(buf, start3, end2) {
      let ret = "";
      end2 = Math.min(buf.length, end2);
      for (let i = start3; i < end2; ++i) {
        ret += String.fromCharCode(buf[i] & 127);
      }
      return ret;
    }
    function latin1Slice(buf, start3, end2) {
      let ret = "";
      end2 = Math.min(buf.length, end2);
      for (let i = start3; i < end2; ++i) {
        ret += String.fromCharCode(buf[i]);
      }
      return ret;
    }
    function hexSlice(buf, start3, end2) {
      const len = buf.length;
      if (!start3 || start3 < 0) start3 = 0;
      if (!end2 || end2 < 0 || end2 > len) end2 = len;
      let out = "";
      for (let i = start3; i < end2; ++i) {
        out += hexSliceLookupTable[buf[i]];
      }
      return out;
    }
    function utf16leSlice(buf, start3, end2) {
      const bytes = buf.slice(start3, end2);
      let res = "";
      for (let i = 0; i < bytes.length - 1; i += 2) {
        res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
      }
      return res;
    }
    Buffer2.prototype.slice = function slice(start3, end2) {
      const len = this.length;
      start3 = ~~start3;
      end2 = end2 === void 0 ? len : ~~end2;
      if (start3 < 0) {
        start3 += len;
        if (start3 < 0) start3 = 0;
      } else if (start3 > len) {
        start3 = len;
      }
      if (end2 < 0) {
        end2 += len;
        if (end2 < 0) end2 = 0;
      } else if (end2 > len) {
        end2 = len;
      }
      if (end2 < start3) end2 = start3;
      const newBuf = this.subarray(start3, end2);
      Object.setPrototypeOf(newBuf, Buffer2.prototype);
      return newBuf;
    };
    function checkOffset(offset3, ext, length3) {
      if (offset3 % 1 !== 0 || offset3 < 0) throw new RangeError("offset is not uint");
      if (offset3 + ext > length3) throw new RangeError("Trying to access beyond buffer length");
    }
    Buffer2.prototype.readUintLE = Buffer2.prototype.readUIntLE = function readUIntLE(offset3, byteLength2, noAssert) {
      offset3 = offset3 >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) checkOffset(offset3, byteLength2, this.length);
      let val = this[offset3];
      let mul = 1;
      let i = 0;
      while (++i < byteLength2 && (mul *= 256)) {
        val += this[offset3 + i] * mul;
      }
      return val;
    };
    Buffer2.prototype.readUintBE = Buffer2.prototype.readUIntBE = function readUIntBE(offset3, byteLength2, noAssert) {
      offset3 = offset3 >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        checkOffset(offset3, byteLength2, this.length);
      }
      let val = this[offset3 + --byteLength2];
      let mul = 1;
      while (byteLength2 > 0 && (mul *= 256)) {
        val += this[offset3 + --byteLength2] * mul;
      }
      return val;
    };
    Buffer2.prototype.readUint8 = Buffer2.prototype.readUInt8 = function readUInt8(offset3, noAssert) {
      offset3 = offset3 >>> 0;
      if (!noAssert) checkOffset(offset3, 1, this.length);
      return this[offset3];
    };
    Buffer2.prototype.readUint16LE = Buffer2.prototype.readUInt16LE = function readUInt16LE(offset3, noAssert) {
      offset3 = offset3 >>> 0;
      if (!noAssert) checkOffset(offset3, 2, this.length);
      return this[offset3] | this[offset3 + 1] << 8;
    };
    Buffer2.prototype.readUint16BE = Buffer2.prototype.readUInt16BE = function readUInt16BE(offset3, noAssert) {
      offset3 = offset3 >>> 0;
      if (!noAssert) checkOffset(offset3, 2, this.length);
      return this[offset3] << 8 | this[offset3 + 1];
    };
    Buffer2.prototype.readUint32LE = Buffer2.prototype.readUInt32LE = function readUInt32LE(offset3, noAssert) {
      offset3 = offset3 >>> 0;
      if (!noAssert) checkOffset(offset3, 4, this.length);
      return (this[offset3] | this[offset3 + 1] << 8 | this[offset3 + 2] << 16) + this[offset3 + 3] * 16777216;
    };
    Buffer2.prototype.readUint32BE = Buffer2.prototype.readUInt32BE = function readUInt32BE(offset3, noAssert) {
      offset3 = offset3 >>> 0;
      if (!noAssert) checkOffset(offset3, 4, this.length);
      return this[offset3] * 16777216 + (this[offset3 + 1] << 16 | this[offset3 + 2] << 8 | this[offset3 + 3]);
    };
    Buffer2.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset3) {
      offset3 = offset3 >>> 0;
      validateNumber(offset3, "offset");
      const first4 = this[offset3];
      const last4 = this[offset3 + 7];
      if (first4 === void 0 || last4 === void 0) {
        boundsError(offset3, this.length - 8);
      }
      const lo = first4 + this[++offset3] * 2 ** 8 + this[++offset3] * 2 ** 16 + this[++offset3] * 2 ** 24;
      const hi = this[++offset3] + this[++offset3] * 2 ** 8 + this[++offset3] * 2 ** 16 + last4 * 2 ** 24;
      return BigInt(lo) + (BigInt(hi) << BigInt(32));
    });
    Buffer2.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset3) {
      offset3 = offset3 >>> 0;
      validateNumber(offset3, "offset");
      const first4 = this[offset3];
      const last4 = this[offset3 + 7];
      if (first4 === void 0 || last4 === void 0) {
        boundsError(offset3, this.length - 8);
      }
      const hi = first4 * 2 ** 24 + this[++offset3] * 2 ** 16 + this[++offset3] * 2 ** 8 + this[++offset3];
      const lo = this[++offset3] * 2 ** 24 + this[++offset3] * 2 ** 16 + this[++offset3] * 2 ** 8 + last4;
      return (BigInt(hi) << BigInt(32)) + BigInt(lo);
    });
    Buffer2.prototype.readIntLE = function readIntLE(offset3, byteLength2, noAssert) {
      offset3 = offset3 >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) checkOffset(offset3, byteLength2, this.length);
      let val = this[offset3];
      let mul = 1;
      let i = 0;
      while (++i < byteLength2 && (mul *= 256)) {
        val += this[offset3 + i] * mul;
      }
      mul *= 128;
      if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
      return val;
    };
    Buffer2.prototype.readIntBE = function readIntBE(offset3, byteLength2, noAssert) {
      offset3 = offset3 >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) checkOffset(offset3, byteLength2, this.length);
      let i = byteLength2;
      let mul = 1;
      let val = this[offset3 + --i];
      while (i > 0 && (mul *= 256)) {
        val += this[offset3 + --i] * mul;
      }
      mul *= 128;
      if (val >= mul) val -= Math.pow(2, 8 * byteLength2);
      return val;
    };
    Buffer2.prototype.readInt8 = function readInt8(offset3, noAssert) {
      offset3 = offset3 >>> 0;
      if (!noAssert) checkOffset(offset3, 1, this.length);
      if (!(this[offset3] & 128)) return this[offset3];
      return (255 - this[offset3] + 1) * -1;
    };
    Buffer2.prototype.readInt16LE = function readInt16LE(offset3, noAssert) {
      offset3 = offset3 >>> 0;
      if (!noAssert) checkOffset(offset3, 2, this.length);
      const val = this[offset3] | this[offset3 + 1] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer2.prototype.readInt16BE = function readInt16BE(offset3, noAssert) {
      offset3 = offset3 >>> 0;
      if (!noAssert) checkOffset(offset3, 2, this.length);
      const val = this[offset3 + 1] | this[offset3] << 8;
      return val & 32768 ? val | 4294901760 : val;
    };
    Buffer2.prototype.readInt32LE = function readInt32LE(offset3, noAssert) {
      offset3 = offset3 >>> 0;
      if (!noAssert) checkOffset(offset3, 4, this.length);
      return this[offset3] | this[offset3 + 1] << 8 | this[offset3 + 2] << 16 | this[offset3 + 3] << 24;
    };
    Buffer2.prototype.readInt32BE = function readInt32BE(offset3, noAssert) {
      offset3 = offset3 >>> 0;
      if (!noAssert) checkOffset(offset3, 4, this.length);
      return this[offset3] << 24 | this[offset3 + 1] << 16 | this[offset3 + 2] << 8 | this[offset3 + 3];
    };
    Buffer2.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset3) {
      offset3 = offset3 >>> 0;
      validateNumber(offset3, "offset");
      const first4 = this[offset3];
      const last4 = this[offset3 + 7];
      if (first4 === void 0 || last4 === void 0) {
        boundsError(offset3, this.length - 8);
      }
      const val = this[offset3 + 4] + this[offset3 + 5] * 2 ** 8 + this[offset3 + 6] * 2 ** 16 + (last4 << 24);
      return (BigInt(val) << BigInt(32)) + BigInt(first4 + this[++offset3] * 2 ** 8 + this[++offset3] * 2 ** 16 + this[++offset3] * 2 ** 24);
    });
    Buffer2.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset3) {
      offset3 = offset3 >>> 0;
      validateNumber(offset3, "offset");
      const first4 = this[offset3];
      const last4 = this[offset3 + 7];
      if (first4 === void 0 || last4 === void 0) {
        boundsError(offset3, this.length - 8);
      }
      const val = (first4 << 24) + // Overflow
      this[++offset3] * 2 ** 16 + this[++offset3] * 2 ** 8 + this[++offset3];
      return (BigInt(val) << BigInt(32)) + BigInt(this[++offset3] * 2 ** 24 + this[++offset3] * 2 ** 16 + this[++offset3] * 2 ** 8 + last4);
    });
    Buffer2.prototype.readFloatLE = function readFloatLE(offset3, noAssert) {
      offset3 = offset3 >>> 0;
      if (!noAssert) checkOffset(offset3, 4, this.length);
      return ieee754.read(this, offset3, true, 23, 4);
    };
    Buffer2.prototype.readFloatBE = function readFloatBE(offset3, noAssert) {
      offset3 = offset3 >>> 0;
      if (!noAssert) checkOffset(offset3, 4, this.length);
      return ieee754.read(this, offset3, false, 23, 4);
    };
    Buffer2.prototype.readDoubleLE = function readDoubleLE(offset3, noAssert) {
      offset3 = offset3 >>> 0;
      if (!noAssert) checkOffset(offset3, 8, this.length);
      return ieee754.read(this, offset3, true, 52, 8);
    };
    Buffer2.prototype.readDoubleBE = function readDoubleBE(offset3, noAssert) {
      offset3 = offset3 >>> 0;
      if (!noAssert) checkOffset(offset3, 8, this.length);
      return ieee754.read(this, offset3, false, 52, 8);
    };
    function checkInt(buf, value8, offset3, ext, max3, min3) {
      if (!Buffer2.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
      if (value8 > max3 || value8 < min3) throw new RangeError('"value" argument is out of bounds');
      if (offset3 + ext > buf.length) throw new RangeError("Index out of range");
    }
    Buffer2.prototype.writeUintLE = Buffer2.prototype.writeUIntLE = function writeUIntLE(value8, offset3, byteLength2, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
        checkInt(this, value8, offset3, byteLength2, maxBytes, 0);
      }
      let mul = 1;
      let i = 0;
      this[offset3] = value8 & 255;
      while (++i < byteLength2 && (mul *= 256)) {
        this[offset3 + i] = value8 / mul & 255;
      }
      return offset3 + byteLength2;
    };
    Buffer2.prototype.writeUintBE = Buffer2.prototype.writeUIntBE = function writeUIntBE(value8, offset3, byteLength2, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      byteLength2 = byteLength2 >>> 0;
      if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength2) - 1;
        checkInt(this, value8, offset3, byteLength2, maxBytes, 0);
      }
      let i = byteLength2 - 1;
      let mul = 1;
      this[offset3 + i] = value8 & 255;
      while (--i >= 0 && (mul *= 256)) {
        this[offset3 + i] = value8 / mul & 255;
      }
      return offset3 + byteLength2;
    };
    Buffer2.prototype.writeUint8 = Buffer2.prototype.writeUInt8 = function writeUInt8(value8, offset3, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      if (!noAssert) checkInt(this, value8, offset3, 1, 255, 0);
      this[offset3] = value8 & 255;
      return offset3 + 1;
    };
    Buffer2.prototype.writeUint16LE = Buffer2.prototype.writeUInt16LE = function writeUInt16LE(value8, offset3, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      if (!noAssert) checkInt(this, value8, offset3, 2, 65535, 0);
      this[offset3] = value8 & 255;
      this[offset3 + 1] = value8 >>> 8;
      return offset3 + 2;
    };
    Buffer2.prototype.writeUint16BE = Buffer2.prototype.writeUInt16BE = function writeUInt16BE(value8, offset3, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      if (!noAssert) checkInt(this, value8, offset3, 2, 65535, 0);
      this[offset3] = value8 >>> 8;
      this[offset3 + 1] = value8 & 255;
      return offset3 + 2;
    };
    Buffer2.prototype.writeUint32LE = Buffer2.prototype.writeUInt32LE = function writeUInt32LE(value8, offset3, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      if (!noAssert) checkInt(this, value8, offset3, 4, 4294967295, 0);
      this[offset3 + 3] = value8 >>> 24;
      this[offset3 + 2] = value8 >>> 16;
      this[offset3 + 1] = value8 >>> 8;
      this[offset3] = value8 & 255;
      return offset3 + 4;
    };
    Buffer2.prototype.writeUint32BE = Buffer2.prototype.writeUInt32BE = function writeUInt32BE(value8, offset3, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      if (!noAssert) checkInt(this, value8, offset3, 4, 4294967295, 0);
      this[offset3] = value8 >>> 24;
      this[offset3 + 1] = value8 >>> 16;
      this[offset3 + 2] = value8 >>> 8;
      this[offset3 + 3] = value8 & 255;
      return offset3 + 4;
    };
    function wrtBigUInt64LE(buf, value8, offset3, min3, max3) {
      checkIntBI(value8, min3, max3, buf, offset3, 7);
      let lo = Number(value8 & BigInt(4294967295));
      buf[offset3++] = lo;
      lo = lo >> 8;
      buf[offset3++] = lo;
      lo = lo >> 8;
      buf[offset3++] = lo;
      lo = lo >> 8;
      buf[offset3++] = lo;
      let hi = Number(value8 >> BigInt(32) & BigInt(4294967295));
      buf[offset3++] = hi;
      hi = hi >> 8;
      buf[offset3++] = hi;
      hi = hi >> 8;
      buf[offset3++] = hi;
      hi = hi >> 8;
      buf[offset3++] = hi;
      return offset3;
    }
    function wrtBigUInt64BE(buf, value8, offset3, min3, max3) {
      checkIntBI(value8, min3, max3, buf, offset3, 7);
      let lo = Number(value8 & BigInt(4294967295));
      buf[offset3 + 7] = lo;
      lo = lo >> 8;
      buf[offset3 + 6] = lo;
      lo = lo >> 8;
      buf[offset3 + 5] = lo;
      lo = lo >> 8;
      buf[offset3 + 4] = lo;
      let hi = Number(value8 >> BigInt(32) & BigInt(4294967295));
      buf[offset3 + 3] = hi;
      hi = hi >> 8;
      buf[offset3 + 2] = hi;
      hi = hi >> 8;
      buf[offset3 + 1] = hi;
      hi = hi >> 8;
      buf[offset3] = hi;
      return offset3 + 8;
    }
    Buffer2.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value8, offset3 = 0) {
      return wrtBigUInt64LE(this, value8, offset3, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer2.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value8, offset3 = 0) {
      return wrtBigUInt64BE(this, value8, offset3, BigInt(0), BigInt("0xffffffffffffffff"));
    });
    Buffer2.prototype.writeIntLE = function writeIntLE(value8, offset3, byteLength2, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      if (!noAssert) {
        const limit3 = Math.pow(2, 8 * byteLength2 - 1);
        checkInt(this, value8, offset3, byteLength2, limit3 - 1, -limit3);
      }
      let i = 0;
      let mul = 1;
      let sub = 0;
      this[offset3] = value8 & 255;
      while (++i < byteLength2 && (mul *= 256)) {
        if (value8 < 0 && sub === 0 && this[offset3 + i - 1] !== 0) {
          sub = 1;
        }
        this[offset3 + i] = (value8 / mul >> 0) - sub & 255;
      }
      return offset3 + byteLength2;
    };
    Buffer2.prototype.writeIntBE = function writeIntBE(value8, offset3, byteLength2, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      if (!noAssert) {
        const limit3 = Math.pow(2, 8 * byteLength2 - 1);
        checkInt(this, value8, offset3, byteLength2, limit3 - 1, -limit3);
      }
      let i = byteLength2 - 1;
      let mul = 1;
      let sub = 0;
      this[offset3 + i] = value8 & 255;
      while (--i >= 0 && (mul *= 256)) {
        if (value8 < 0 && sub === 0 && this[offset3 + i + 1] !== 0) {
          sub = 1;
        }
        this[offset3 + i] = (value8 / mul >> 0) - sub & 255;
      }
      return offset3 + byteLength2;
    };
    Buffer2.prototype.writeInt8 = function writeInt8(value8, offset3, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      if (!noAssert) checkInt(this, value8, offset3, 1, 127, -128);
      if (value8 < 0) value8 = 255 + value8 + 1;
      this[offset3] = value8 & 255;
      return offset3 + 1;
    };
    Buffer2.prototype.writeInt16LE = function writeInt16LE(value8, offset3, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      if (!noAssert) checkInt(this, value8, offset3, 2, 32767, -32768);
      this[offset3] = value8 & 255;
      this[offset3 + 1] = value8 >>> 8;
      return offset3 + 2;
    };
    Buffer2.prototype.writeInt16BE = function writeInt16BE(value8, offset3, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      if (!noAssert) checkInt(this, value8, offset3, 2, 32767, -32768);
      this[offset3] = value8 >>> 8;
      this[offset3 + 1] = value8 & 255;
      return offset3 + 2;
    };
    Buffer2.prototype.writeInt32LE = function writeInt32LE(value8, offset3, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      if (!noAssert) checkInt(this, value8, offset3, 4, 2147483647, -2147483648);
      this[offset3] = value8 & 255;
      this[offset3 + 1] = value8 >>> 8;
      this[offset3 + 2] = value8 >>> 16;
      this[offset3 + 3] = value8 >>> 24;
      return offset3 + 4;
    };
    Buffer2.prototype.writeInt32BE = function writeInt32BE(value8, offset3, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      if (!noAssert) checkInt(this, value8, offset3, 4, 2147483647, -2147483648);
      if (value8 < 0) value8 = 4294967295 + value8 + 1;
      this[offset3] = value8 >>> 24;
      this[offset3 + 1] = value8 >>> 16;
      this[offset3 + 2] = value8 >>> 8;
      this[offset3 + 3] = value8 & 255;
      return offset3 + 4;
    };
    Buffer2.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value8, offset3 = 0) {
      return wrtBigUInt64LE(this, value8, offset3, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    Buffer2.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value8, offset3 = 0) {
      return wrtBigUInt64BE(this, value8, offset3, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
    });
    function checkIEEE754(buf, value8, offset3, ext, max3, min3) {
      if (offset3 + ext > buf.length) throw new RangeError("Index out of range");
      if (offset3 < 0) throw new RangeError("Index out of range");
    }
    function writeFloat(buf, value8, offset3, littleEndian, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value8, offset3, 4, 34028234663852886e22, -34028234663852886e22);
      }
      ieee754.write(buf, value8, offset3, littleEndian, 23, 4);
      return offset3 + 4;
    }
    Buffer2.prototype.writeFloatLE = function writeFloatLE(value8, offset3, noAssert) {
      return writeFloat(this, value8, offset3, true, noAssert);
    };
    Buffer2.prototype.writeFloatBE = function writeFloatBE(value8, offset3, noAssert) {
      return writeFloat(this, value8, offset3, false, noAssert);
    };
    function writeDouble(buf, value8, offset3, littleEndian, noAssert) {
      value8 = +value8;
      offset3 = offset3 >>> 0;
      if (!noAssert) {
        checkIEEE754(buf, value8, offset3, 8, 17976931348623157e292, -17976931348623157e292);
      }
      ieee754.write(buf, value8, offset3, littleEndian, 52, 8);
      return offset3 + 8;
    }
    Buffer2.prototype.writeDoubleLE = function writeDoubleLE(value8, offset3, noAssert) {
      return writeDouble(this, value8, offset3, true, noAssert);
    };
    Buffer2.prototype.writeDoubleBE = function writeDoubleBE(value8, offset3, noAssert) {
      return writeDouble(this, value8, offset3, false, noAssert);
    };
    Buffer2.prototype.copy = function copy(target6, targetStart, start3, end2) {
      if (!Buffer2.isBuffer(target6)) throw new TypeError("argument should be a Buffer");
      if (!start3) start3 = 0;
      if (!end2 && end2 !== 0) end2 = this.length;
      if (targetStart >= target6.length) targetStart = target6.length;
      if (!targetStart) targetStart = 0;
      if (end2 > 0 && end2 < start3) end2 = start3;
      if (end2 === start3) return 0;
      if (target6.length === 0 || this.length === 0) return 0;
      if (targetStart < 0) {
        throw new RangeError("targetStart out of bounds");
      }
      if (start3 < 0 || start3 >= this.length) throw new RangeError("Index out of range");
      if (end2 < 0) throw new RangeError("sourceEnd out of bounds");
      if (end2 > this.length) end2 = this.length;
      if (target6.length - targetStart < end2 - start3) {
        end2 = target6.length - targetStart + start3;
      }
      const len = end2 - start3;
      if (this === target6 && typeof Uint8Array.prototype.copyWithin === "function") {
        this.copyWithin(targetStart, start3, end2);
      } else {
        Uint8Array.prototype.set.call(
          target6,
          this.subarray(start3, end2),
          targetStart
        );
      }
      return len;
    };
    Buffer2.prototype.fill = function fill(val, start3, end2, encoding3) {
      if (typeof val === "string") {
        if (typeof start3 === "string") {
          encoding3 = start3;
          start3 = 0;
          end2 = this.length;
        } else if (typeof end2 === "string") {
          encoding3 = end2;
          end2 = this.length;
        }
        if (encoding3 !== void 0 && typeof encoding3 !== "string") {
          throw new TypeError("encoding must be a string");
        }
        if (typeof encoding3 === "string" && !Buffer2.isEncoding(encoding3)) {
          throw new TypeError("Unknown encoding: " + encoding3);
        }
        if (val.length === 1) {
          const code5 = val.charCodeAt(0);
          if (encoding3 === "utf8" && code5 < 128 || encoding3 === "latin1") {
            val = code5;
          }
        }
      } else if (typeof val === "number") {
        val = val & 255;
      } else if (typeof val === "boolean") {
        val = Number(val);
      }
      if (start3 < 0 || this.length < start3 || this.length < end2) {
        throw new RangeError("Out of range index");
      }
      if (end2 <= start3) {
        return this;
      }
      start3 = start3 >>> 0;
      end2 = end2 === void 0 ? this.length : end2 >>> 0;
      if (!val) val = 0;
      let i;
      if (typeof val === "number") {
        for (i = start3; i < end2; ++i) {
          this[i] = val;
        }
      } else {
        const bytes = Buffer2.isBuffer(val) ? val : Buffer2.from(val, encoding3);
        const len = bytes.length;
        if (len === 0) {
          throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        }
        for (i = 0; i < end2 - start3; ++i) {
          this[i + start3] = bytes[i % len];
        }
      }
      return this;
    };
    var errors = {};
    function E(sym, getMessage, Base2) {
      errors[sym] = class NodeError extends Base2 {
        constructor() {
          super();
          Object.defineProperty(this, "message", {
            value: getMessage.apply(this, arguments),
            writable: true,
            configurable: true
          });
          this.name = `${this.name} [${sym}]`;
          this.stack;
          delete this.name;
        }
        get code() {
          return sym;
        }
        set code(value8) {
          Object.defineProperty(this, "code", {
            configurable: true,
            enumerable: true,
            value: value8,
            writable: true
          });
        }
        toString() {
          return `${this.name} [${sym}]: ${this.message}`;
        }
      };
    }
    E(
      "ERR_BUFFER_OUT_OF_BOUNDS",
      function(name9) {
        if (name9) {
          return `${name9} is outside of buffer bounds`;
        }
        return "Attempt to access memory outside buffer bounds";
      },
      RangeError
    );
    E(
      "ERR_INVALID_ARG_TYPE",
      function(name9, actual2) {
        return `The "${name9}" argument must be of type number. Received type ${typeof actual2}`;
      },
      TypeError
    );
    E(
      "ERR_OUT_OF_RANGE",
      function(str, range3, input2) {
        let msg = `The value of "${str}" is out of range.`;
        let received2 = input2;
        if (Number.isInteger(input2) && Math.abs(input2) > 2 ** 32) {
          received2 = addNumericalSeparator(String(input2));
        } else if (typeof input2 === "bigint") {
          received2 = String(input2);
          if (input2 > BigInt(2) ** BigInt(32) || input2 < -(BigInt(2) ** BigInt(32))) {
            received2 = addNumericalSeparator(received2);
          }
          received2 += "n";
        }
        msg += ` It must be ${range3}. Received ${received2}`;
        return msg;
      },
      RangeError
    );
    function addNumericalSeparator(val) {
      let res = "";
      let i = val.length;
      const start3 = val[0] === "-" ? 1 : 0;
      for (; i >= start3 + 4; i -= 3) {
        res = `_${val.slice(i - 3, i)}${res}`;
      }
      return `${val.slice(0, i)}${res}`;
    }
    function checkBounds(buf, offset3, byteLength2) {
      validateNumber(offset3, "offset");
      if (buf[offset3] === void 0 || buf[offset3 + byteLength2] === void 0) {
        boundsError(offset3, buf.length - (byteLength2 + 1));
      }
    }
    function checkIntBI(value8, min3, max3, buf, offset3, byteLength2) {
      if (value8 > max3 || value8 < min3) {
        const n3 = typeof min3 === "bigint" ? "n" : "";
        let range3;
        if (byteLength2 > 3) {
          if (min3 === 0 || min3 === BigInt(0)) {
            range3 = `>= 0${n3} and < 2${n3} ** ${(byteLength2 + 1) * 8}${n3}`;
          } else {
            range3 = `>= -(2${n3} ** ${(byteLength2 + 1) * 8 - 1}${n3}) and < 2 ** ${(byteLength2 + 1) * 8 - 1}${n3}`;
          }
        } else {
          range3 = `>= ${min3}${n3} and <= ${max3}${n3}`;
        }
        throw new errors.ERR_OUT_OF_RANGE("value", range3, value8);
      }
      checkBounds(buf, offset3, byteLength2);
    }
    function validateNumber(value8, name9) {
      if (typeof value8 !== "number") {
        throw new errors.ERR_INVALID_ARG_TYPE(name9, "number", value8);
      }
    }
    function boundsError(value8, length3, type5) {
      if (Math.floor(value8) !== value8) {
        validateNumber(value8, type5);
        throw new errors.ERR_OUT_OF_RANGE(type5 || "offset", "an integer", value8);
      }
      if (length3 < 0) {
        throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
      }
      throw new errors.ERR_OUT_OF_RANGE(
        type5 || "offset",
        `>= ${type5 ? 1 : 0} and <= ${length3}`,
        value8
      );
    }
    var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
      str = str.split("=")[0];
      str = str.trim().replace(INVALID_BASE64_RE, "");
      if (str.length < 2) return "";
      while (str.length % 4 !== 0) {
        str = str + "=";
      }
      return str;
    }
    function utf8ToBytes(string3, units2) {
      units2 = units2 || Infinity;
      let codePoint;
      const length3 = string3.length;
      let leadSurrogate = null;
      const bytes = [];
      for (let i = 0; i < length3; ++i) {
        codePoint = string3.charCodeAt(i);
        if (codePoint > 55295 && codePoint < 57344) {
          if (!leadSurrogate) {
            if (codePoint > 56319) {
              if ((units2 -= 3) > -1) bytes.push(239, 191, 189);
              continue;
            } else if (i + 1 === length3) {
              if ((units2 -= 3) > -1) bytes.push(239, 191, 189);
              continue;
            }
            leadSurrogate = codePoint;
            continue;
          }
          if (codePoint < 56320) {
            if ((units2 -= 3) > -1) bytes.push(239, 191, 189);
            leadSurrogate = codePoint;
            continue;
          }
          codePoint = (leadSurrogate - 55296 << 10 | codePoint - 56320) + 65536;
        } else if (leadSurrogate) {
          if ((units2 -= 3) > -1) bytes.push(239, 191, 189);
        }
        leadSurrogate = null;
        if (codePoint < 128) {
          if ((units2 -= 1) < 0) break;
          bytes.push(codePoint);
        } else if (codePoint < 2048) {
          if ((units2 -= 2) < 0) break;
          bytes.push(
            codePoint >> 6 | 192,
            codePoint & 63 | 128
          );
        } else if (codePoint < 65536) {
          if ((units2 -= 3) < 0) break;
          bytes.push(
            codePoint >> 12 | 224,
            codePoint >> 6 & 63 | 128,
            codePoint & 63 | 128
          );
        } else if (codePoint < 1114112) {
          if ((units2 -= 4) < 0) break;
          bytes.push(
            codePoint >> 18 | 240,
            codePoint >> 12 & 63 | 128,
            codePoint >> 6 & 63 | 128,
            codePoint & 63 | 128
          );
        } else {
          throw new Error("Invalid code point");
        }
      }
      return bytes;
    }
    function asciiToBytes(str) {
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        byteArray.push(str.charCodeAt(i) & 255);
      }
      return byteArray;
    }
    function utf16leToBytes(str, units2) {
      let c, hi, lo;
      const byteArray = [];
      for (let i = 0; i < str.length; ++i) {
        if ((units2 -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
      }
      return byteArray;
    }
    function base64ToBytes(str) {
      return base64.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset3, length3) {
      let i;
      for (i = 0; i < length3; ++i) {
        if (i + offset3 >= dst.length || i >= src.length) break;
        dst[i + offset3] = src[i];
      }
      return i;
    }
    function isInstance(obj, type5) {
      return obj instanceof type5 || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type5.name;
    }
    function numberIsNaN(obj) {
      return obj !== obj;
    }
    var hexSliceLookupTable = (function() {
      const alphabet = "0123456789abcdef";
      const table = new Array(256);
      for (let i = 0; i < 16; ++i) {
        const i16 = i * 16;
        for (let j = 0; j < 16; ++j) {
          table[i16 + j] = alphabet[i] + alphabet[j];
        }
      }
      return table;
    })();
    function defineBigIntMethod(fn2) {
      return typeof BigInt === "undefined" ? BufferBigIntNotDefined : fn2;
    }
    function BufferBigIntNotDefined() {
      throw new Error("BigInt not supported");
    }
  }
});

// ../node_modules/cross-fetch/dist/browser-ponyfill.js
var require_browser_ponyfill = __commonJS({
  "../node_modules/cross-fetch/dist/browser-ponyfill.js"(exports, module3) {
    var __global__ = typeof globalThis !== "undefined" && globalThis || typeof self !== "undefined" && self || typeof global !== "undefined" && global;
    var __globalThis__ = (function() {
      function F() {
        this.fetch = false;
        this.DOMException = __global__.DOMException;
      }
      F.prototype = __global__;
      return new F();
    })();
    (function(globalThis2) {
      var irrelevant = (function(exports2) {
        var g = typeof globalThis2 !== "undefined" && globalThis2 || typeof self !== "undefined" && self || // eslint-disable-next-line no-undef
        typeof global !== "undefined" && global || {};
        var support2 = {
          searchParams: "URLSearchParams" in g,
          iterable: "Symbol" in g && "iterator" in Symbol,
          blob: "FileReader" in g && "Blob" in g && (function() {
            try {
              new Blob();
              return true;
            } catch (e) {
              return false;
            }
          })(),
          formData: "FormData" in g,
          arrayBuffer: "ArrayBuffer" in g
        };
        function isDataView(obj) {
          return obj && DataView.prototype.isPrototypeOf(obj);
        }
        if (support2.arrayBuffer) {
          var viewClasses = [
            "[object Int8Array]",
            "[object Uint8Array]",
            "[object Uint8ClampedArray]",
            "[object Int16Array]",
            "[object Uint16Array]",
            "[object Int32Array]",
            "[object Uint32Array]",
            "[object Float32Array]",
            "[object Float64Array]"
          ];
          var isArrayBufferView = ArrayBuffer.isView || function(obj) {
            return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1;
          };
        }
        function normalizeName(name9) {
          if (typeof name9 !== "string") {
            name9 = String(name9);
          }
          if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name9) || name9 === "") {
            throw new TypeError('Invalid character in header field name: "' + name9 + '"');
          }
          return name9.toLowerCase();
        }
        function normalizeValue(value8) {
          if (typeof value8 !== "string") {
            value8 = String(value8);
          }
          return value8;
        }
        function iteratorFor(items2) {
          var iterator2 = {
            next: function() {
              var value8 = items2.shift();
              return { done: value8 === void 0, value: value8 };
            }
          };
          if (support2.iterable) {
            iterator2[Symbol.iterator] = function() {
              return iterator2;
            };
          }
          return iterator2;
        }
        function Headers2(headers) {
          this.map = {};
          if (headers instanceof Headers2) {
            headers.forEach(function(value8, name9) {
              this.append(name9, value8);
            }, this);
          } else if (Array.isArray(headers)) {
            headers.forEach(function(header2) {
              if (header2.length != 2) {
                throw new TypeError("Headers constructor: expected name/value pair to be length 2, found" + header2.length);
              }
              this.append(header2[0], header2[1]);
            }, this);
          } else if (headers) {
            Object.getOwnPropertyNames(headers).forEach(function(name9) {
              this.append(name9, headers[name9]);
            }, this);
          }
        }
        Headers2.prototype.append = function(name9, value8) {
          name9 = normalizeName(name9);
          value8 = normalizeValue(value8);
          var oldValue = this.map[name9];
          this.map[name9] = oldValue ? oldValue + ", " + value8 : value8;
        };
        Headers2.prototype["delete"] = function(name9) {
          delete this.map[normalizeName(name9)];
        };
        Headers2.prototype.get = function(name9) {
          name9 = normalizeName(name9);
          return this.has(name9) ? this.map[name9] : null;
        };
        Headers2.prototype.has = function(name9) {
          return this.map.hasOwnProperty(normalizeName(name9));
        };
        Headers2.prototype.set = function(name9, value8) {
          this.map[normalizeName(name9)] = normalizeValue(value8);
        };
        Headers2.prototype.forEach = function(callback, thisArg) {
          for (var name9 in this.map) {
            if (this.map.hasOwnProperty(name9)) {
              callback.call(thisArg, this.map[name9], name9, this);
            }
          }
        };
        Headers2.prototype.keys = function() {
          var items2 = [];
          this.forEach(function(value8, name9) {
            items2.push(name9);
          });
          return iteratorFor(items2);
        };
        Headers2.prototype.values = function() {
          var items2 = [];
          this.forEach(function(value8) {
            items2.push(value8);
          });
          return iteratorFor(items2);
        };
        Headers2.prototype.entries = function() {
          var items2 = [];
          this.forEach(function(value8, name9) {
            items2.push([name9, value8]);
          });
          return iteratorFor(items2);
        };
        if (support2.iterable) {
          Headers2.prototype[Symbol.iterator] = Headers2.prototype.entries;
        }
        function consumed(body) {
          if (body._noBody) return;
          if (body.bodyUsed) {
            return Promise.reject(new TypeError("Already read"));
          }
          body.bodyUsed = true;
        }
        function fileReaderReady(reader) {
          return new Promise(function(resolve, reject) {
            reader.onload = function() {
              resolve(reader.result);
            };
            reader.onerror = function() {
              reject(reader.error);
            };
          });
        }
        function readBlobAsArrayBuffer(blob) {
          var reader = new FileReader();
          var promise = fileReaderReady(reader);
          reader.readAsArrayBuffer(blob);
          return promise;
        }
        function readBlobAsText(blob) {
          var reader = new FileReader();
          var promise = fileReaderReady(reader);
          var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type);
          var encoding3 = match ? match[1] : "utf-8";
          reader.readAsText(blob, encoding3);
          return promise;
        }
        function readArrayBufferAsText(buf) {
          var view2 = new Uint8Array(buf);
          var chars = new Array(view2.length);
          for (var i = 0; i < view2.length; i++) {
            chars[i] = String.fromCharCode(view2[i]);
          }
          return chars.join("");
        }
        function bufferClone(buf) {
          if (buf.slice) {
            return buf.slice(0);
          } else {
            var view2 = new Uint8Array(buf.byteLength);
            view2.set(new Uint8Array(buf));
            return view2.buffer;
          }
        }
        function Body() {
          this.bodyUsed = false;
          this._initBody = function(body) {
            this.bodyUsed = this.bodyUsed;
            this._bodyInit = body;
            if (!body) {
              this._noBody = true;
              this._bodyText = "";
            } else if (typeof body === "string") {
              this._bodyText = body;
            } else if (support2.blob && Blob.prototype.isPrototypeOf(body)) {
              this._bodyBlob = body;
            } else if (support2.formData && FormData.prototype.isPrototypeOf(body)) {
              this._bodyFormData = body;
            } else if (support2.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
              this._bodyText = body.toString();
            } else if (support2.arrayBuffer && support2.blob && isDataView(body)) {
              this._bodyArrayBuffer = bufferClone(body.buffer);
              this._bodyInit = new Blob([this._bodyArrayBuffer]);
            } else if (support2.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
              this._bodyArrayBuffer = bufferClone(body);
            } else {
              this._bodyText = body = Object.prototype.toString.call(body);
            }
            if (!this.headers.get("content-type")) {
              if (typeof body === "string") {
                this.headers.set("content-type", "text/plain;charset=UTF-8");
              } else if (this._bodyBlob && this._bodyBlob.type) {
                this.headers.set("content-type", this._bodyBlob.type);
              } else if (support2.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
                this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8");
              }
            }
          };
          if (support2.blob) {
            this.blob = function() {
              var rejected = consumed(this);
              if (rejected) {
                return rejected;
              }
              if (this._bodyBlob) {
                return Promise.resolve(this._bodyBlob);
              } else if (this._bodyArrayBuffer) {
                return Promise.resolve(new Blob([this._bodyArrayBuffer]));
              } else if (this._bodyFormData) {
                throw new Error("could not read FormData body as blob");
              } else {
                return Promise.resolve(new Blob([this._bodyText]));
              }
            };
          }
          this.arrayBuffer = function() {
            if (this._bodyArrayBuffer) {
              var isConsumed = consumed(this);
              if (isConsumed) {
                return isConsumed;
              } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
                return Promise.resolve(
                  this._bodyArrayBuffer.buffer.slice(
                    this._bodyArrayBuffer.byteOffset,
                    this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
                  )
                );
              } else {
                return Promise.resolve(this._bodyArrayBuffer);
              }
            } else if (support2.blob) {
              return this.blob().then(readBlobAsArrayBuffer);
            } else {
              throw new Error("could not read as ArrayBuffer");
            }
          };
          this.text = function() {
            var rejected = consumed(this);
            if (rejected) {
              return rejected;
            }
            if (this._bodyBlob) {
              return readBlobAsText(this._bodyBlob);
            } else if (this._bodyArrayBuffer) {
              return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
            } else if (this._bodyFormData) {
              throw new Error("could not read FormData body as text");
            } else {
              return Promise.resolve(this._bodyText);
            }
          };
          if (support2.formData) {
            this.formData = function() {
              return this.text().then(decode);
            };
          }
          this.json = function() {
            return this.text().then(JSON.parse);
          };
          return this;
        }
        var methods = ["CONNECT", "DELETE", "GET", "HEAD", "OPTIONS", "PATCH", "POST", "PUT", "TRACE"];
        function normalizeMethod(method5) {
          var upcased = method5.toUpperCase();
          return methods.indexOf(upcased) > -1 ? upcased : method5;
        }
        function Request(input2, options) {
          if (!(this instanceof Request)) {
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          }
          options = options || {};
          var body = options.body;
          if (input2 instanceof Request) {
            if (input2.bodyUsed) {
              throw new TypeError("Already read");
            }
            this.url = input2.url;
            this.credentials = input2.credentials;
            if (!options.headers) {
              this.headers = new Headers2(input2.headers);
            }
            this.method = input2.method;
            this.mode = input2.mode;
            this.signal = input2.signal;
            if (!body && input2._bodyInit != null) {
              body = input2._bodyInit;
              input2.bodyUsed = true;
            }
          } else {
            this.url = String(input2);
          }
          this.credentials = options.credentials || this.credentials || "same-origin";
          if (options.headers || !this.headers) {
            this.headers = new Headers2(options.headers);
          }
          this.method = normalizeMethod(options.method || this.method || "GET");
          this.mode = options.mode || this.mode || null;
          this.signal = options.signal || this.signal || (function() {
            if ("AbortController" in g) {
              var ctrl = new AbortController();
              return ctrl.signal;
            }
          })();
          this.referrer = null;
          if ((this.method === "GET" || this.method === "HEAD") && body) {
            throw new TypeError("Body not allowed for GET or HEAD requests");
          }
          this._initBody(body);
          if (this.method === "GET" || this.method === "HEAD") {
            if (options.cache === "no-store" || options.cache === "no-cache") {
              var reParamSearch = /([?&])_=[^&]*/;
              if (reParamSearch.test(this.url)) {
                this.url = this.url.replace(reParamSearch, "$1_=" + (/* @__PURE__ */ new Date()).getTime());
              } else {
                var reQueryString = /\?/;
                this.url += (reQueryString.test(this.url) ? "&" : "?") + "_=" + (/* @__PURE__ */ new Date()).getTime();
              }
            }
          }
        }
        Request.prototype.clone = function() {
          return new Request(this, { body: this._bodyInit });
        };
        function decode(body) {
          var form2 = new FormData();
          body.trim().split("&").forEach(function(bytes) {
            if (bytes) {
              var split = bytes.split("=");
              var name9 = split.shift().replace(/\+/g, " ");
              var value8 = split.join("=").replace(/\+/g, " ");
              form2.append(decodeURIComponent(name9), decodeURIComponent(value8));
            }
          });
          return form2;
        }
        function parseHeaders(rawHeaders) {
          var headers = new Headers2();
          var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, " ");
          preProcessedHeaders.split("\r").map(function(header2) {
            return header2.indexOf("\n") === 0 ? header2.substr(1, header2.length) : header2;
          }).forEach(function(line4) {
            var parts = line4.split(":");
            var key3 = parts.shift().trim();
            if (key3) {
              var value8 = parts.join(":").trim();
              try {
                headers.append(key3, value8);
              } catch (error4) {
                console.warn("Response " + error4.message);
              }
            }
          });
          return headers;
        }
        Body.call(Request.prototype);
        function Response5(bodyInit, options) {
          if (!(this instanceof Response5)) {
            throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.');
          }
          if (!options) {
            options = {};
          }
          this.type = "default";
          this.status = options.status === void 0 ? 200 : options.status;
          if (this.status < 200 || this.status > 599) {
            throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].");
          }
          this.ok = this.status >= 200 && this.status < 300;
          this.statusText = options.statusText === void 0 ? "" : "" + options.statusText;
          this.headers = new Headers2(options.headers);
          this.url = options.url || "";
          this._initBody(bodyInit);
        }
        Body.call(Response5.prototype);
        Response5.prototype.clone = function() {
          return new Response5(this._bodyInit, {
            status: this.status,
            statusText: this.statusText,
            headers: new Headers2(this.headers),
            url: this.url
          });
        };
        Response5.error = function() {
          var response6 = new Response5(null, { status: 200, statusText: "" });
          response6.ok = false;
          response6.status = 0;
          response6.type = "error";
          return response6;
        };
        var redirectStatuses = [301, 302, 303, 307, 308];
        Response5.redirect = function(url7, status10) {
          if (redirectStatuses.indexOf(status10) === -1) {
            throw new RangeError("Invalid status code");
          }
          return new Response5(null, { status: status10, headers: { location: url7 } });
        };
        exports2.DOMException = g.DOMException;
        try {
          new exports2.DOMException();
        } catch (err2) {
          exports2.DOMException = function(message4, name9) {
            this.message = message4;
            this.name = name9;
            var error4 = Error(message4);
            this.stack = error4.stack;
          };
          exports2.DOMException.prototype = Object.create(Error.prototype);
          exports2.DOMException.prototype.constructor = exports2.DOMException;
        }
        function fetch(input2, init) {
          return new Promise(function(resolve, reject) {
            var request2 = new Request(input2, init);
            if (request2.signal && request2.signal.aborted) {
              return reject(new exports2.DOMException("Aborted", "AbortError"));
            }
            var xhr = new XMLHttpRequest();
            function abortXhr() {
              xhr.abort();
            }
            xhr.onload = function() {
              var options = {
                statusText: xhr.statusText,
                headers: parseHeaders(xhr.getAllResponseHeaders() || "")
              };
              if (request2.url.indexOf("file://") === 0 && (xhr.status < 200 || xhr.status > 599)) {
                options.status = 200;
              } else {
                options.status = xhr.status;
              }
              options.url = "responseURL" in xhr ? xhr.responseURL : options.headers.get("X-Request-URL");
              var body = "response" in xhr ? xhr.response : xhr.responseText;
              setTimeout(function() {
                resolve(new Response5(body, options));
              }, 0);
            };
            xhr.onerror = function() {
              setTimeout(function() {
                reject(new TypeError("Network request failed"));
              }, 0);
            };
            xhr.ontimeout = function() {
              setTimeout(function() {
                reject(new TypeError("Network request timed out"));
              }, 0);
            };
            xhr.onabort = function() {
              setTimeout(function() {
                reject(new exports2.DOMException("Aborted", "AbortError"));
              }, 0);
            };
            function fixUrl(url7) {
              try {
                return url7 === "" && g.location.href ? g.location.href : url7;
              } catch (e) {
                return url7;
              }
            }
            xhr.open(request2.method, fixUrl(request2.url), true);
            if (request2.credentials === "include") {
              xhr.withCredentials = true;
            } else if (request2.credentials === "omit") {
              xhr.withCredentials = false;
            }
            if ("responseType" in xhr) {
              if (support2.blob) {
                xhr.responseType = "blob";
              } else if (support2.arrayBuffer) {
                xhr.responseType = "arraybuffer";
              }
            }
            if (init && typeof init.headers === "object" && !(init.headers instanceof Headers2 || g.Headers && init.headers instanceof g.Headers)) {
              var names = [];
              Object.getOwnPropertyNames(init.headers).forEach(function(name9) {
                names.push(normalizeName(name9));
                xhr.setRequestHeader(name9, normalizeValue(init.headers[name9]));
              });
              request2.headers.forEach(function(value8, name9) {
                if (names.indexOf(name9) === -1) {
                  xhr.setRequestHeader(name9, value8);
                }
              });
            } else {
              request2.headers.forEach(function(value8, name9) {
                xhr.setRequestHeader(name9, value8);
              });
            }
            if (request2.signal) {
              request2.signal.addEventListener("abort", abortXhr);
              xhr.onreadystatechange = function() {
                if (xhr.readyState === 4) {
                  request2.signal.removeEventListener("abort", abortXhr);
                }
              };
            }
            xhr.send(typeof request2._bodyInit === "undefined" ? null : request2._bodyInit);
          });
        }
        fetch.polyfill = true;
        if (!g.fetch) {
          g.fetch = fetch;
          g.Headers = Headers2;
          g.Request = Request;
          g.Response = Response5;
        }
        exports2.Headers = Headers2;
        exports2.Request = Request;
        exports2.Response = Response5;
        exports2.fetch = fetch;
        return exports2;
      })({});
    })(__globalThis__);
    __globalThis__.fetch.ponyfill = true;
    delete __globalThis__.fetch.polyfill;
    var ctx = __global__.fetch ? __global__ : __globalThis__;
    exports = ctx.fetch;
    exports.default = ctx.fetch;
    exports.fetch = ctx.fetch;
    exports.Headers = ctx.Headers;
    exports.Request = ctx.Request;
    exports.Response = ctx.Response;
    module3.exports = exports;
  }
});

// ../node_modules/lunr/lunr.js
var require_lunr = __commonJS({
  "../node_modules/lunr/lunr.js"(exports, module3) {
    (function() {
      var lunr2 = function(config2) {
        var builder = new lunr2.Builder();
        builder.pipeline.add(
          lunr2.trimmer,
          lunr2.stopWordFilter,
          lunr2.stemmer
        );
        builder.searchPipeline.add(
          lunr2.stemmer
        );
        config2.call(builder, builder);
        return builder.build();
      };
      lunr2.version = "2.3.9";
      lunr2.utils = {};
      lunr2.utils.warn = /* @__PURE__ */ (function(global3) {
        return function(message4) {
          if (global3.console && console.warn) {
            console.warn(message4);
          }
        };
      })(this);
      lunr2.utils.asString = function(obj) {
        if (obj === void 0 || obj === null) {
          return "";
        } else {
          return obj.toString();
        }
      };
      lunr2.utils.clone = function(obj) {
        if (obj === null || obj === void 0) {
          return obj;
        }
        var clone = /* @__PURE__ */ Object.create(null), keys = Object.keys(obj);
        for (var i = 0; i < keys.length; i++) {
          var key3 = keys[i], val = obj[key3];
          if (Array.isArray(val)) {
            clone[key3] = val.slice();
            continue;
          }
          if (typeof val === "string" || typeof val === "number" || typeof val === "boolean") {
            clone[key3] = val;
            continue;
          }
          throw new TypeError("clone is not deep and does not support nested objects");
        }
        return clone;
      };
      lunr2.FieldRef = function(docRef, fieldName, stringValue) {
        this.docRef = docRef;
        this.fieldName = fieldName;
        this._stringValue = stringValue;
      };
      lunr2.FieldRef.joiner = "/";
      lunr2.FieldRef.fromString = function(s) {
        var n3 = s.indexOf(lunr2.FieldRef.joiner);
        if (n3 === -1) {
          throw "malformed field ref string";
        }
        var fieldRef = s.slice(0, n3), docRef = s.slice(n3 + 1);
        return new lunr2.FieldRef(docRef, fieldRef, s);
      };
      lunr2.FieldRef.prototype.toString = function() {
        if (this._stringValue == void 0) {
          this._stringValue = this.fieldName + lunr2.FieldRef.joiner + this.docRef;
        }
        return this._stringValue;
      };
      lunr2.Set = function(elements) {
        this.elements = /* @__PURE__ */ Object.create(null);
        if (elements) {
          this.length = elements.length;
          for (var i = 0; i < this.length; i++) {
            this.elements[elements[i]] = true;
          }
        } else {
          this.length = 0;
        }
      };
      lunr2.Set.complete = {
        intersect: function(other2) {
          return other2;
        },
        union: function() {
          return this;
        },
        contains: function() {
          return true;
        }
      };
      lunr2.Set.empty = {
        intersect: function() {
          return this;
        },
        union: function(other2) {
          return other2;
        },
        contains: function() {
          return false;
        }
      };
      lunr2.Set.prototype.contains = function(object8) {
        return !!this.elements[object8];
      };
      lunr2.Set.prototype.intersect = function(other2) {
        var a, b, elements, intersection2 = [];
        if (other2 === lunr2.Set.complete) {
          return this;
        }
        if (other2 === lunr2.Set.empty) {
          return other2;
        }
        if (this.length < other2.length) {
          a = this;
          b = other2;
        } else {
          a = other2;
          b = this;
        }
        elements = Object.keys(a.elements);
        for (var i = 0; i < elements.length; i++) {
          var element2 = elements[i];
          if (element2 in b.elements) {
            intersection2.push(element2);
          }
        }
        return new lunr2.Set(intersection2);
      };
      lunr2.Set.prototype.union = function(other2) {
        if (other2 === lunr2.Set.complete) {
          return lunr2.Set.complete;
        }
        if (other2 === lunr2.Set.empty) {
          return this;
        }
        return new lunr2.Set(Object.keys(this.elements).concat(Object.keys(other2.elements)));
      };
      lunr2.idf = function(posting, documentCount) {
        var documentsWithTerm = 0;
        for (var fieldName in posting) {
          if (fieldName == "_index") continue;
          documentsWithTerm += Object.keys(posting[fieldName]).length;
        }
        var x = (documentCount - documentsWithTerm + 0.5) / (documentsWithTerm + 0.5);
        return Math.log(1 + Math.abs(x));
      };
      lunr2.Token = function(str, metadata2) {
        this.str = str || "";
        this.metadata = metadata2 || {};
      };
      lunr2.Token.prototype.toString = function() {
        return this.str;
      };
      lunr2.Token.prototype.update = function(fn2) {
        this.str = fn2(this.str, this.metadata);
        return this;
      };
      lunr2.Token.prototype.clone = function(fn2) {
        fn2 = fn2 || function(s) {
          return s;
        };
        return new lunr2.Token(fn2(this.str, this.metadata), this.metadata);
      };
      lunr2.tokenizer = function(obj, metadata2) {
        if (obj == null || obj == void 0) {
          return [];
        }
        if (Array.isArray(obj)) {
          return obj.map(function(t) {
            return new lunr2.Token(
              lunr2.utils.asString(t).toLowerCase(),
              lunr2.utils.clone(metadata2)
            );
          });
        }
        var str = obj.toString().toLowerCase(), len = str.length, tokens = [];
        for (var sliceEnd = 0, sliceStart = 0; sliceEnd <= len; sliceEnd++) {
          var char = str.charAt(sliceEnd), sliceLength = sliceEnd - sliceStart;
          if (char.match(lunr2.tokenizer.separator) || sliceEnd == len) {
            if (sliceLength > 0) {
              var tokenMetadata = lunr2.utils.clone(metadata2) || {};
              tokenMetadata["position"] = [sliceStart, sliceLength];
              tokenMetadata["index"] = tokens.length;
              tokens.push(
                new lunr2.Token(
                  str.slice(sliceStart, sliceEnd),
                  tokenMetadata
                )
              );
            }
            sliceStart = sliceEnd + 1;
          }
        }
        return tokens;
      };
      lunr2.tokenizer.separator = /[\s\-]+/;
      lunr2.Pipeline = function() {
        this._stack = [];
      };
      lunr2.Pipeline.registeredFunctions = /* @__PURE__ */ Object.create(null);
      lunr2.Pipeline.registerFunction = function(fn2, label4) {
        if (label4 in this.registeredFunctions) {
          lunr2.utils.warn("Overwriting existing registered function: " + label4);
        }
        fn2.label = label4;
        lunr2.Pipeline.registeredFunctions[fn2.label] = fn2;
      };
      lunr2.Pipeline.warnIfFunctionNotRegistered = function(fn2) {
        var isRegistered = fn2.label && fn2.label in this.registeredFunctions;
        if (!isRegistered) {
          lunr2.utils.warn("Function is not registered with pipeline. This may cause problems when serialising the index.\n", fn2);
        }
      };
      lunr2.Pipeline.load = function(serialised) {
        var pipeline = new lunr2.Pipeline();
        serialised.forEach(function(fnName) {
          var fn2 = lunr2.Pipeline.registeredFunctions[fnName];
          if (fn2) {
            pipeline.add(fn2);
          } else {
            throw new Error("Cannot load unregistered function: " + fnName);
          }
        });
        return pipeline;
      };
      lunr2.Pipeline.prototype.add = function() {
        var fns = Array.prototype.slice.call(arguments);
        fns.forEach(function(fn2) {
          lunr2.Pipeline.warnIfFunctionNotRegistered(fn2);
          this._stack.push(fn2);
        }, this);
      };
      lunr2.Pipeline.prototype.after = function(existingFn, newFn) {
        lunr2.Pipeline.warnIfFunctionNotRegistered(newFn);
        var pos = this._stack.indexOf(existingFn);
        if (pos == -1) {
          throw new Error("Cannot find existingFn");
        }
        pos = pos + 1;
        this._stack.splice(pos, 0, newFn);
      };
      lunr2.Pipeline.prototype.before = function(existingFn, newFn) {
        lunr2.Pipeline.warnIfFunctionNotRegistered(newFn);
        var pos = this._stack.indexOf(existingFn);
        if (pos == -1) {
          throw new Error("Cannot find existingFn");
        }
        this._stack.splice(pos, 0, newFn);
      };
      lunr2.Pipeline.prototype.remove = function(fn2) {
        var pos = this._stack.indexOf(fn2);
        if (pos == -1) {
          return;
        }
        this._stack.splice(pos, 1);
      };
      lunr2.Pipeline.prototype.run = function(tokens) {
        var stackLength = this._stack.length;
        for (var i = 0; i < stackLength; i++) {
          var fn2 = this._stack[i];
          var memo = [];
          for (var j = 0; j < tokens.length; j++) {
            var result6 = fn2(tokens[j], j, tokens);
            if (result6 === null || result6 === void 0 || result6 === "") continue;
            if (Array.isArray(result6)) {
              for (var k = 0; k < result6.length; k++) {
                memo.push(result6[k]);
              }
            } else {
              memo.push(result6);
            }
          }
          tokens = memo;
        }
        return tokens;
      };
      lunr2.Pipeline.prototype.runString = function(str, metadata2) {
        var token2 = new lunr2.Token(str, metadata2);
        return this.run([token2]).map(function(t) {
          return t.toString();
        });
      };
      lunr2.Pipeline.prototype.reset = function() {
        this._stack = [];
      };
      lunr2.Pipeline.prototype.toJSON = function() {
        return this._stack.map(function(fn2) {
          lunr2.Pipeline.warnIfFunctionNotRegistered(fn2);
          return fn2.label;
        });
      };
      lunr2.Vector = function(elements) {
        this._magnitude = 0;
        this.elements = elements || [];
      };
      lunr2.Vector.prototype.positionForIndex = function(index2) {
        if (this.elements.length == 0) {
          return 0;
        }
        var start3 = 0, end2 = this.elements.length / 2, sliceLength = end2 - start3, pivotPoint = Math.floor(sliceLength / 2), pivotIndex = this.elements[pivotPoint * 2];
        while (sliceLength > 1) {
          if (pivotIndex < index2) {
            start3 = pivotPoint;
          }
          if (pivotIndex > index2) {
            end2 = pivotPoint;
          }
          if (pivotIndex == index2) {
            break;
          }
          sliceLength = end2 - start3;
          pivotPoint = start3 + Math.floor(sliceLength / 2);
          pivotIndex = this.elements[pivotPoint * 2];
        }
        if (pivotIndex == index2) {
          return pivotPoint * 2;
        }
        if (pivotIndex > index2) {
          return pivotPoint * 2;
        }
        if (pivotIndex < index2) {
          return (pivotPoint + 1) * 2;
        }
      };
      lunr2.Vector.prototype.insert = function(insertIdx, val) {
        this.upsert(insertIdx, val, function() {
          throw "duplicate index";
        });
      };
      lunr2.Vector.prototype.upsert = function(insertIdx, val, fn2) {
        this._magnitude = 0;
        var position4 = this.positionForIndex(insertIdx);
        if (this.elements[position4] == insertIdx) {
          this.elements[position4 + 1] = fn2(this.elements[position4 + 1], val);
        } else {
          this.elements.splice(position4, 0, insertIdx, val);
        }
      };
      lunr2.Vector.prototype.magnitude = function() {
        if (this._magnitude) return this._magnitude;
        var sumOfSquares = 0, elementsLength = this.elements.length;
        for (var i = 1; i < elementsLength; i += 2) {
          var val = this.elements[i];
          sumOfSquares += val * val;
        }
        return this._magnitude = Math.sqrt(sumOfSquares);
      };
      lunr2.Vector.prototype.dot = function(otherVector) {
        var dotProduct = 0, a = this.elements, b = otherVector.elements, aLen = a.length, bLen = b.length, aVal = 0, bVal = 0, i = 0, j = 0;
        while (i < aLen && j < bLen) {
          aVal = a[i], bVal = b[j];
          if (aVal < bVal) {
            i += 2;
          } else if (aVal > bVal) {
            j += 2;
          } else if (aVal == bVal) {
            dotProduct += a[i + 1] * b[j + 1];
            i += 2;
            j += 2;
          }
        }
        return dotProduct;
      };
      lunr2.Vector.prototype.similarity = function(otherVector) {
        return this.dot(otherVector) / this.magnitude() || 0;
      };
      lunr2.Vector.prototype.toArray = function() {
        var output2 = new Array(this.elements.length / 2);
        for (var i = 1, j = 0; i < this.elements.length; i += 2, j++) {
          output2[j] = this.elements[i];
        }
        return output2;
      };
      lunr2.Vector.prototype.toJSON = function() {
        return this.elements;
      };
      lunr2.stemmer = (function() {
        var step2list = {
          "ational": "ate",
          "tional": "tion",
          "enci": "ence",
          "anci": "ance",
          "izer": "ize",
          "bli": "ble",
          "alli": "al",
          "entli": "ent",
          "eli": "e",
          "ousli": "ous",
          "ization": "ize",
          "ation": "ate",
          "ator": "ate",
          "alism": "al",
          "iveness": "ive",
          "fulness": "ful",
          "ousness": "ous",
          "aliti": "al",
          "iviti": "ive",
          "biliti": "ble",
          "logi": "log"
        }, step3list = {
          "icate": "ic",
          "ative": "",
          "alize": "al",
          "iciti": "ic",
          "ical": "ic",
          "ful": "",
          "ness": ""
        }, c = "[^aeiou]", v2 = "[aeiouy]", C = c + "[^aeiouy]*", V = v2 + "[aeiou]*", mgr0 = "^(" + C + ")?" + V + C, meq1 = "^(" + C + ")?" + V + C + "(" + V + ")?$", mgr1 = "^(" + C + ")?" + V + C + V + C, s_v = "^(" + C + ")?" + v2;
        var re_mgr0 = new RegExp(mgr0);
        var re_mgr1 = new RegExp(mgr1);
        var re_meq1 = new RegExp(meq1);
        var re_s_v = new RegExp(s_v);
        var re_1a = /^(.+?)(ss|i)es$/;
        var re2_1a = /^(.+?)([^s])s$/;
        var re_1b = /^(.+?)eed$/;
        var re2_1b = /^(.+?)(ed|ing)$/;
        var re_1b_2 = /.$/;
        var re2_1b_2 = /(at|bl|iz)$/;
        var re3_1b_2 = new RegExp("([^aeiouylsz])\\1$");
        var re4_1b_2 = new RegExp("^" + C + v2 + "[^aeiouwxy]$");
        var re_1c = /^(.+?[^aeiou])y$/;
        var re_2 = /^(.+?)(ational|tional|enci|anci|izer|bli|alli|entli|eli|ousli|ization|ation|ator|alism|iveness|fulness|ousness|aliti|iviti|biliti|logi)$/;
        var re_3 = /^(.+?)(icate|ative|alize|iciti|ical|ful|ness)$/;
        var re_4 = /^(.+?)(al|ance|ence|er|ic|able|ible|ant|ement|ment|ent|ou|ism|ate|iti|ous|ive|ize)$/;
        var re2_4 = /^(.+?)(s|t)(ion)$/;
        var re_5 = /^(.+?)e$/;
        var re_5_1 = /ll$/;
        var re3_5 = new RegExp("^" + C + v2 + "[^aeiouwxy]$");
        var porterStemmer = function porterStemmer2(w) {
          var stem2, suffix2, firstch, re, re2, re3, re4;
          if (w.length < 3) {
            return w;
          }
          firstch = w.substr(0, 1);
          if (firstch == "y") {
            w = firstch.toUpperCase() + w.substr(1);
          }
          re = re_1a;
          re2 = re2_1a;
          if (re.test(w)) {
            w = w.replace(re, "$1$2");
          } else if (re2.test(w)) {
            w = w.replace(re2, "$1$2");
          }
          re = re_1b;
          re2 = re2_1b;
          if (re.test(w)) {
            var fp = re.exec(w);
            re = re_mgr0;
            if (re.test(fp[1])) {
              re = re_1b_2;
              w = w.replace(re, "");
            }
          } else if (re2.test(w)) {
            var fp = re2.exec(w);
            stem2 = fp[1];
            re2 = re_s_v;
            if (re2.test(stem2)) {
              w = stem2;
              re2 = re2_1b_2;
              re3 = re3_1b_2;
              re4 = re4_1b_2;
              if (re2.test(w)) {
                w = w + "e";
              } else if (re3.test(w)) {
                re = re_1b_2;
                w = w.replace(re, "");
              } else if (re4.test(w)) {
                w = w + "e";
              }
            }
          }
          re = re_1c;
          if (re.test(w)) {
            var fp = re.exec(w);
            stem2 = fp[1];
            w = stem2 + "i";
          }
          re = re_2;
          if (re.test(w)) {
            var fp = re.exec(w);
            stem2 = fp[1];
            suffix2 = fp[2];
            re = re_mgr0;
            if (re.test(stem2)) {
              w = stem2 + step2list[suffix2];
            }
          }
          re = re_3;
          if (re.test(w)) {
            var fp = re.exec(w);
            stem2 = fp[1];
            suffix2 = fp[2];
            re = re_mgr0;
            if (re.test(stem2)) {
              w = stem2 + step3list[suffix2];
            }
          }
          re = re_4;
          re2 = re2_4;
          if (re.test(w)) {
            var fp = re.exec(w);
            stem2 = fp[1];
            re = re_mgr1;
            if (re.test(stem2)) {
              w = stem2;
            }
          } else if (re2.test(w)) {
            var fp = re2.exec(w);
            stem2 = fp[1] + fp[2];
            re2 = re_mgr1;
            if (re2.test(stem2)) {
              w = stem2;
            }
          }
          re = re_5;
          if (re.test(w)) {
            var fp = re.exec(w);
            stem2 = fp[1];
            re = re_mgr1;
            re2 = re_meq1;
            re3 = re3_5;
            if (re.test(stem2) || re2.test(stem2) && !re3.test(stem2)) {
              w = stem2;
            }
          }
          re = re_5_1;
          re2 = re_mgr1;
          if (re.test(w) && re2.test(w)) {
            re = re_1b_2;
            w = w.replace(re, "");
          }
          if (firstch == "y") {
            w = firstch.toLowerCase() + w.substr(1);
          }
          return w;
        };
        return function(token2) {
          return token2.update(porterStemmer);
        };
      })();
      lunr2.Pipeline.registerFunction(lunr2.stemmer, "stemmer");
      lunr2.generateStopWordFilter = function(stopWords) {
        var words = stopWords.reduce(function(memo, stopWord) {
          memo[stopWord] = stopWord;
          return memo;
        }, {});
        return function(token2) {
          if (token2 && words[token2.toString()] !== token2.toString()) return token2;
        };
      };
      lunr2.stopWordFilter = lunr2.generateStopWordFilter([
        "a",
        "able",
        "about",
        "across",
        "after",
        "all",
        "almost",
        "also",
        "am",
        "among",
        "an",
        "and",
        "any",
        "are",
        "as",
        "at",
        "be",
        "because",
        "been",
        "but",
        "by",
        "can",
        "cannot",
        "could",
        "dear",
        "did",
        "do",
        "does",
        "either",
        "else",
        "ever",
        "every",
        "for",
        "from",
        "get",
        "got",
        "had",
        "has",
        "have",
        "he",
        "her",
        "hers",
        "him",
        "his",
        "how",
        "however",
        "i",
        "if",
        "in",
        "into",
        "is",
        "it",
        "its",
        "just",
        "least",
        "let",
        "like",
        "likely",
        "may",
        "me",
        "might",
        "most",
        "must",
        "my",
        "neither",
        "no",
        "nor",
        "not",
        "of",
        "off",
        "often",
        "on",
        "only",
        "or",
        "other",
        "our",
        "own",
        "rather",
        "said",
        "say",
        "says",
        "she",
        "should",
        "since",
        "so",
        "some",
        "than",
        "that",
        "the",
        "their",
        "them",
        "then",
        "there",
        "these",
        "they",
        "this",
        "tis",
        "to",
        "too",
        "twas",
        "us",
        "wants",
        "was",
        "we",
        "were",
        "what",
        "when",
        "where",
        "which",
        "while",
        "who",
        "whom",
        "why",
        "will",
        "with",
        "would",
        "yet",
        "you",
        "your"
      ]);
      lunr2.Pipeline.registerFunction(lunr2.stopWordFilter, "stopWordFilter");
      lunr2.trimmer = function(token2) {
        return token2.update(function(s) {
          return s.replace(/^\W+/, "").replace(/\W+$/, "");
        });
      };
      lunr2.Pipeline.registerFunction(lunr2.trimmer, "trimmer");
      lunr2.TokenSet = function() {
        this.final = false;
        this.edges = {};
        this.id = lunr2.TokenSet._nextId;
        lunr2.TokenSet._nextId += 1;
      };
      lunr2.TokenSet._nextId = 1;
      lunr2.TokenSet.fromArray = function(arr) {
        var builder = new lunr2.TokenSet.Builder();
        for (var i = 0, len = arr.length; i < len; i++) {
          builder.insert(arr[i]);
        }
        builder.finish();
        return builder.root;
      };
      lunr2.TokenSet.fromClause = function(clause) {
        if ("editDistance" in clause) {
          return lunr2.TokenSet.fromFuzzyString(clause.term, clause.editDistance);
        } else {
          return lunr2.TokenSet.fromString(clause.term);
        }
      };
      lunr2.TokenSet.fromFuzzyString = function(str, editDistance) {
        var root = new lunr2.TokenSet();
        var stack = [{
          node: root,
          editsRemaining: editDistance,
          str
        }];
        while (stack.length) {
          var frame = stack.pop();
          if (frame.str.length > 0) {
            var char = frame.str.charAt(0), noEditNode;
            if (char in frame.node.edges) {
              noEditNode = frame.node.edges[char];
            } else {
              noEditNode = new lunr2.TokenSet();
              frame.node.edges[char] = noEditNode;
            }
            if (frame.str.length == 1) {
              noEditNode.final = true;
            }
            stack.push({
              node: noEditNode,
              editsRemaining: frame.editsRemaining,
              str: frame.str.slice(1)
            });
          }
          if (frame.editsRemaining == 0) {
            continue;
          }
          if ("*" in frame.node.edges) {
            var insertionNode = frame.node.edges["*"];
          } else {
            var insertionNode = new lunr2.TokenSet();
            frame.node.edges["*"] = insertionNode;
          }
          if (frame.str.length == 0) {
            insertionNode.final = true;
          }
          stack.push({
            node: insertionNode,
            editsRemaining: frame.editsRemaining - 1,
            str: frame.str
          });
          if (frame.str.length > 1) {
            stack.push({
              node: frame.node,
              editsRemaining: frame.editsRemaining - 1,
              str: frame.str.slice(1)
            });
          }
          if (frame.str.length == 1) {
            frame.node.final = true;
          }
          if (frame.str.length >= 1) {
            if ("*" in frame.node.edges) {
              var substitutionNode = frame.node.edges["*"];
            } else {
              var substitutionNode = new lunr2.TokenSet();
              frame.node.edges["*"] = substitutionNode;
            }
            if (frame.str.length == 1) {
              substitutionNode.final = true;
            }
            stack.push({
              node: substitutionNode,
              editsRemaining: frame.editsRemaining - 1,
              str: frame.str.slice(1)
            });
          }
          if (frame.str.length > 1) {
            var charA = frame.str.charAt(0), charB = frame.str.charAt(1), transposeNode;
            if (charB in frame.node.edges) {
              transposeNode = frame.node.edges[charB];
            } else {
              transposeNode = new lunr2.TokenSet();
              frame.node.edges[charB] = transposeNode;
            }
            if (frame.str.length == 1) {
              transposeNode.final = true;
            }
            stack.push({
              node: transposeNode,
              editsRemaining: frame.editsRemaining - 1,
              str: charA + frame.str.slice(2)
            });
          }
        }
        return root;
      };
      lunr2.TokenSet.fromString = function(str) {
        var node3 = new lunr2.TokenSet(), root = node3;
        for (var i = 0, len = str.length; i < len; i++) {
          var char = str[i], final2 = i == len - 1;
          if (char == "*") {
            node3.edges[char] = node3;
            node3.final = final2;
          } else {
            var next4 = new lunr2.TokenSet();
            next4.final = final2;
            node3.edges[char] = next4;
            node3 = next4;
          }
        }
        return root;
      };
      lunr2.TokenSet.prototype.toArray = function() {
        var words = [];
        var stack = [{
          prefix: "",
          node: this
        }];
        while (stack.length) {
          var frame = stack.pop(), edges = Object.keys(frame.node.edges), len = edges.length;
          if (frame.node.final) {
            frame.prefix.charAt(0);
            words.push(frame.prefix);
          }
          for (var i = 0; i < len; i++) {
            var edge = edges[i];
            stack.push({
              prefix: frame.prefix.concat(edge),
              node: frame.node.edges[edge]
            });
          }
        }
        return words;
      };
      lunr2.TokenSet.prototype.toString = function() {
        if (this._str) {
          return this._str;
        }
        var str = this.final ? "1" : "0", labels = Object.keys(this.edges).sort(), len = labels.length;
        for (var i = 0; i < len; i++) {
          var label4 = labels[i], node3 = this.edges[label4];
          str = str + label4 + node3.id;
        }
        return str;
      };
      lunr2.TokenSet.prototype.intersect = function(b) {
        var output2 = new lunr2.TokenSet(), frame = void 0;
        var stack = [{
          qNode: b,
          output: output2,
          node: this
        }];
        while (stack.length) {
          frame = stack.pop();
          var qEdges = Object.keys(frame.qNode.edges), qLen = qEdges.length, nEdges = Object.keys(frame.node.edges), nLen = nEdges.length;
          for (var q = 0; q < qLen; q++) {
            var qEdge = qEdges[q];
            for (var n3 = 0; n3 < nLen; n3++) {
              var nEdge = nEdges[n3];
              if (nEdge == qEdge || qEdge == "*") {
                var node3 = frame.node.edges[nEdge], qNode = frame.qNode.edges[qEdge], final2 = node3.final && qNode.final, next4 = void 0;
                if (nEdge in frame.output.edges) {
                  next4 = frame.output.edges[nEdge];
                  next4.final = next4.final || final2;
                } else {
                  next4 = new lunr2.TokenSet();
                  next4.final = final2;
                  frame.output.edges[nEdge] = next4;
                }
                stack.push({
                  qNode,
                  output: next4,
                  node: node3
                });
              }
            }
          }
        }
        return output2;
      };
      lunr2.TokenSet.Builder = function() {
        this.previousWord = "";
        this.root = new lunr2.TokenSet();
        this.uncheckedNodes = [];
        this.minimizedNodes = {};
      };
      lunr2.TokenSet.Builder.prototype.insert = function(word) {
        var node3, commonPrefix = 0;
        if (word < this.previousWord) {
          throw new Error("Out of order word insertion");
        }
        for (var i = 0; i < word.length && i < this.previousWord.length; i++) {
          if (word[i] != this.previousWord[i]) break;
          commonPrefix++;
        }
        this.minimize(commonPrefix);
        if (this.uncheckedNodes.length == 0) {
          node3 = this.root;
        } else {
          node3 = this.uncheckedNodes[this.uncheckedNodes.length - 1].child;
        }
        for (var i = commonPrefix; i < word.length; i++) {
          var nextNode = new lunr2.TokenSet(), char = word[i];
          node3.edges[char] = nextNode;
          this.uncheckedNodes.push({
            parent: node3,
            char,
            child: nextNode
          });
          node3 = nextNode;
        }
        node3.final = true;
        this.previousWord = word;
      };
      lunr2.TokenSet.Builder.prototype.finish = function() {
        this.minimize(0);
      };
      lunr2.TokenSet.Builder.prototype.minimize = function(downTo) {
        for (var i = this.uncheckedNodes.length - 1; i >= downTo; i--) {
          var node3 = this.uncheckedNodes[i], childKey = node3.child.toString();
          if (childKey in this.minimizedNodes) {
            node3.parent.edges[node3.char] = this.minimizedNodes[childKey];
          } else {
            node3.child._str = childKey;
            this.minimizedNodes[childKey] = node3.child;
          }
          this.uncheckedNodes.pop();
        }
      };
      lunr2.Index = function(attrs) {
        this.invertedIndex = attrs.invertedIndex;
        this.fieldVectors = attrs.fieldVectors;
        this.tokenSet = attrs.tokenSet;
        this.fields = attrs.fields;
        this.pipeline = attrs.pipeline;
      };
      lunr2.Index.prototype.search = function(queryString) {
        return this.query(function(query4) {
          var parser = new lunr2.QueryParser(queryString, query4);
          parser.parse();
        });
      };
      lunr2.Index.prototype.query = function(fn2) {
        var query4 = new lunr2.Query(this.fields), matchingFields = /* @__PURE__ */ Object.create(null), queryVectors = /* @__PURE__ */ Object.create(null), termFieldCache = /* @__PURE__ */ Object.create(null), requiredMatches = /* @__PURE__ */ Object.create(null), prohibitedMatches = /* @__PURE__ */ Object.create(null);
        for (var i = 0; i < this.fields.length; i++) {
          queryVectors[this.fields[i]] = new lunr2.Vector();
        }
        fn2.call(query4, query4);
        for (var i = 0; i < query4.clauses.length; i++) {
          var clause = query4.clauses[i], terms = null, clauseMatches = lunr2.Set.empty;
          if (clause.usePipeline) {
            terms = this.pipeline.runString(clause.term, {
              fields: clause.fields
            });
          } else {
            terms = [clause.term];
          }
          for (var m = 0; m < terms.length; m++) {
            var term3 = terms[m];
            clause.term = term3;
            var termTokenSet = lunr2.TokenSet.fromClause(clause), expandedTerms = this.tokenSet.intersect(termTokenSet).toArray();
            if (expandedTerms.length === 0 && clause.presence === lunr2.Query.presence.REQUIRED) {
              for (var k = 0; k < clause.fields.length; k++) {
                var field2 = clause.fields[k];
                requiredMatches[field2] = lunr2.Set.empty;
              }
              break;
            }
            for (var j = 0; j < expandedTerms.length; j++) {
              var expandedTerm = expandedTerms[j], posting = this.invertedIndex[expandedTerm], termIndex = posting._index;
              for (var k = 0; k < clause.fields.length; k++) {
                var field2 = clause.fields[k], fieldPosting = posting[field2], matchingDocumentRefs = Object.keys(fieldPosting), termField = expandedTerm + "/" + field2, matchingDocumentsSet = new lunr2.Set(matchingDocumentRefs);
                if (clause.presence == lunr2.Query.presence.REQUIRED) {
                  clauseMatches = clauseMatches.union(matchingDocumentsSet);
                  if (requiredMatches[field2] === void 0) {
                    requiredMatches[field2] = lunr2.Set.complete;
                  }
                }
                if (clause.presence == lunr2.Query.presence.PROHIBITED) {
                  if (prohibitedMatches[field2] === void 0) {
                    prohibitedMatches[field2] = lunr2.Set.empty;
                  }
                  prohibitedMatches[field2] = prohibitedMatches[field2].union(matchingDocumentsSet);
                  continue;
                }
                queryVectors[field2].upsert(termIndex, clause.boost, function(a, b) {
                  return a + b;
                });
                if (termFieldCache[termField]) {
                  continue;
                }
                for (var l = 0; l < matchingDocumentRefs.length; l++) {
                  var matchingDocumentRef = matchingDocumentRefs[l], matchingFieldRef = new lunr2.FieldRef(matchingDocumentRef, field2), metadata2 = fieldPosting[matchingDocumentRef], fieldMatch;
                  if ((fieldMatch = matchingFields[matchingFieldRef]) === void 0) {
                    matchingFields[matchingFieldRef] = new lunr2.MatchData(expandedTerm, field2, metadata2);
                  } else {
                    fieldMatch.add(expandedTerm, field2, metadata2);
                  }
                }
                termFieldCache[termField] = true;
              }
            }
          }
          if (clause.presence === lunr2.Query.presence.REQUIRED) {
            for (var k = 0; k < clause.fields.length; k++) {
              var field2 = clause.fields[k];
              requiredMatches[field2] = requiredMatches[field2].intersect(clauseMatches);
            }
          }
        }
        var allRequiredMatches = lunr2.Set.complete, allProhibitedMatches = lunr2.Set.empty;
        for (var i = 0; i < this.fields.length; i++) {
          var field2 = this.fields[i];
          if (requiredMatches[field2]) {
            allRequiredMatches = allRequiredMatches.intersect(requiredMatches[field2]);
          }
          if (prohibitedMatches[field2]) {
            allProhibitedMatches = allProhibitedMatches.union(prohibitedMatches[field2]);
          }
        }
        var matchingFieldRefs = Object.keys(matchingFields), results = [], matches = /* @__PURE__ */ Object.create(null);
        if (query4.isNegated()) {
          matchingFieldRefs = Object.keys(this.fieldVectors);
          for (var i = 0; i < matchingFieldRefs.length; i++) {
            var matchingFieldRef = matchingFieldRefs[i];
            var fieldRef = lunr2.FieldRef.fromString(matchingFieldRef);
            matchingFields[matchingFieldRef] = new lunr2.MatchData();
          }
        }
        for (var i = 0; i < matchingFieldRefs.length; i++) {
          var fieldRef = lunr2.FieldRef.fromString(matchingFieldRefs[i]), docRef = fieldRef.docRef;
          if (!allRequiredMatches.contains(docRef)) {
            continue;
          }
          if (allProhibitedMatches.contains(docRef)) {
            continue;
          }
          var fieldVector = this.fieldVectors[fieldRef], score2 = queryVectors[fieldRef.fieldName].similarity(fieldVector), docMatch;
          if ((docMatch = matches[docRef]) !== void 0) {
            docMatch.score += score2;
            docMatch.matchData.combine(matchingFields[fieldRef]);
          } else {
            var match = {
              ref: docRef,
              score: score2,
              matchData: matchingFields[fieldRef]
            };
            matches[docRef] = match;
            results.push(match);
          }
        }
        return results.sort(function(a, b) {
          return b.score - a.score;
        });
      };
      lunr2.Index.prototype.toJSON = function() {
        var invertedIndex = Object.keys(this.invertedIndex).sort().map(function(term3) {
          return [term3, this.invertedIndex[term3]];
        }, this);
        var fieldVectors = Object.keys(this.fieldVectors).map(function(ref) {
          return [ref, this.fieldVectors[ref].toJSON()];
        }, this);
        return {
          version: lunr2.version,
          fields: this.fields,
          fieldVectors,
          invertedIndex,
          pipeline: this.pipeline.toJSON()
        };
      };
      lunr2.Index.load = function(serializedIndex) {
        var attrs = {}, fieldVectors = {}, serializedVectors = serializedIndex.fieldVectors, invertedIndex = /* @__PURE__ */ Object.create(null), serializedInvertedIndex = serializedIndex.invertedIndex, tokenSetBuilder = new lunr2.TokenSet.Builder(), pipeline = lunr2.Pipeline.load(serializedIndex.pipeline);
        if (serializedIndex.version != lunr2.version) {
          lunr2.utils.warn("Version mismatch when loading serialised index. Current version of lunr '" + lunr2.version + "' does not match serialized index '" + serializedIndex.version + "'");
        }
        for (var i = 0; i < serializedVectors.length; i++) {
          var tuple = serializedVectors[i], ref = tuple[0], elements = tuple[1];
          fieldVectors[ref] = new lunr2.Vector(elements);
        }
        for (var i = 0; i < serializedInvertedIndex.length; i++) {
          var tuple = serializedInvertedIndex[i], term3 = tuple[0], posting = tuple[1];
          tokenSetBuilder.insert(term3);
          invertedIndex[term3] = posting;
        }
        tokenSetBuilder.finish();
        attrs.fields = serializedIndex.fields;
        attrs.fieldVectors = fieldVectors;
        attrs.invertedIndex = invertedIndex;
        attrs.tokenSet = tokenSetBuilder.root;
        attrs.pipeline = pipeline;
        return new lunr2.Index(attrs);
      };
      lunr2.Builder = function() {
        this._ref = "id";
        this._fields = /* @__PURE__ */ Object.create(null);
        this._documents = /* @__PURE__ */ Object.create(null);
        this.invertedIndex = /* @__PURE__ */ Object.create(null);
        this.fieldTermFrequencies = {};
        this.fieldLengths = {};
        this.tokenizer = lunr2.tokenizer;
        this.pipeline = new lunr2.Pipeline();
        this.searchPipeline = new lunr2.Pipeline();
        this.documentCount = 0;
        this._b = 0.75;
        this._k1 = 1.2;
        this.termIndex = 0;
        this.metadataWhitelist = [];
      };
      lunr2.Builder.prototype.ref = function(ref) {
        this._ref = ref;
      };
      lunr2.Builder.prototype.field = function(fieldName, attributes) {
        if (/\//.test(fieldName)) {
          throw new RangeError("Field '" + fieldName + "' contains illegal character '/'");
        }
        this._fields[fieldName] = attributes || {};
      };
      lunr2.Builder.prototype.b = function(number2) {
        if (number2 < 0) {
          this._b = 0;
        } else if (number2 > 1) {
          this._b = 1;
        } else {
          this._b = number2;
        }
      };
      lunr2.Builder.prototype.k1 = function(number2) {
        this._k1 = number2;
      };
      lunr2.Builder.prototype.add = function(doc, attributes) {
        var docRef = doc[this._ref], fields = Object.keys(this._fields);
        this._documents[docRef] = attributes || {};
        this.documentCount += 1;
        for (var i = 0; i < fields.length; i++) {
          var fieldName = fields[i], extractor = this._fields[fieldName].extractor, field2 = extractor ? extractor(doc) : doc[fieldName], tokens = this.tokenizer(field2, {
            fields: [fieldName]
          }), terms = this.pipeline.run(tokens), fieldRef = new lunr2.FieldRef(docRef, fieldName), fieldTerms = /* @__PURE__ */ Object.create(null);
          this.fieldTermFrequencies[fieldRef] = fieldTerms;
          this.fieldLengths[fieldRef] = 0;
          this.fieldLengths[fieldRef] += terms.length;
          for (var j = 0; j < terms.length; j++) {
            var term3 = terms[j];
            if (fieldTerms[term3] == void 0) {
              fieldTerms[term3] = 0;
            }
            fieldTerms[term3] += 1;
            if (this.invertedIndex[term3] == void 0) {
              var posting = /* @__PURE__ */ Object.create(null);
              posting["_index"] = this.termIndex;
              this.termIndex += 1;
              for (var k = 0; k < fields.length; k++) {
                posting[fields[k]] = /* @__PURE__ */ Object.create(null);
              }
              this.invertedIndex[term3] = posting;
            }
            if (this.invertedIndex[term3][fieldName][docRef] == void 0) {
              this.invertedIndex[term3][fieldName][docRef] = /* @__PURE__ */ Object.create(null);
            }
            for (var l = 0; l < this.metadataWhitelist.length; l++) {
              var metadataKey = this.metadataWhitelist[l], metadata2 = term3.metadata[metadataKey];
              if (this.invertedIndex[term3][fieldName][docRef][metadataKey] == void 0) {
                this.invertedIndex[term3][fieldName][docRef][metadataKey] = [];
              }
              this.invertedIndex[term3][fieldName][docRef][metadataKey].push(metadata2);
            }
          }
        }
      };
      lunr2.Builder.prototype.calculateAverageFieldLengths = function() {
        var fieldRefs = Object.keys(this.fieldLengths), numberOfFields = fieldRefs.length, accumulator = {}, documentsWithField = {};
        for (var i = 0; i < numberOfFields; i++) {
          var fieldRef = lunr2.FieldRef.fromString(fieldRefs[i]), field2 = fieldRef.fieldName;
          documentsWithField[field2] || (documentsWithField[field2] = 0);
          documentsWithField[field2] += 1;
          accumulator[field2] || (accumulator[field2] = 0);
          accumulator[field2] += this.fieldLengths[fieldRef];
        }
        var fields = Object.keys(this._fields);
        for (var i = 0; i < fields.length; i++) {
          var fieldName = fields[i];
          accumulator[fieldName] = accumulator[fieldName] / documentsWithField[fieldName];
        }
        this.averageFieldLength = accumulator;
      };
      lunr2.Builder.prototype.createFieldVectors = function() {
        var fieldVectors = {}, fieldRefs = Object.keys(this.fieldTermFrequencies), fieldRefsLength = fieldRefs.length, termIdfCache = /* @__PURE__ */ Object.create(null);
        for (var i = 0; i < fieldRefsLength; i++) {
          var fieldRef = lunr2.FieldRef.fromString(fieldRefs[i]), fieldName = fieldRef.fieldName, fieldLength = this.fieldLengths[fieldRef], fieldVector = new lunr2.Vector(), termFrequencies = this.fieldTermFrequencies[fieldRef], terms = Object.keys(termFrequencies), termsLength = terms.length;
          var fieldBoost = this._fields[fieldName].boost || 1, docBoost = this._documents[fieldRef.docRef].boost || 1;
          for (var j = 0; j < termsLength; j++) {
            var term3 = terms[j], tf = termFrequencies[term3], termIndex = this.invertedIndex[term3]._index, idf, score2, scoreWithPrecision;
            if (termIdfCache[term3] === void 0) {
              idf = lunr2.idf(this.invertedIndex[term3], this.documentCount);
              termIdfCache[term3] = idf;
            } else {
              idf = termIdfCache[term3];
            }
            score2 = idf * ((this._k1 + 1) * tf) / (this._k1 * (1 - this._b + this._b * (fieldLength / this.averageFieldLength[fieldName])) + tf);
            score2 *= fieldBoost;
            score2 *= docBoost;
            scoreWithPrecision = Math.round(score2 * 1e3) / 1e3;
            fieldVector.insert(termIndex, scoreWithPrecision);
          }
          fieldVectors[fieldRef] = fieldVector;
        }
        this.fieldVectors = fieldVectors;
      };
      lunr2.Builder.prototype.createTokenSet = function() {
        this.tokenSet = lunr2.TokenSet.fromArray(
          Object.keys(this.invertedIndex).sort()
        );
      };
      lunr2.Builder.prototype.build = function() {
        this.calculateAverageFieldLengths();
        this.createFieldVectors();
        this.createTokenSet();
        return new lunr2.Index({
          invertedIndex: this.invertedIndex,
          fieldVectors: this.fieldVectors,
          tokenSet: this.tokenSet,
          fields: Object.keys(this._fields),
          pipeline: this.searchPipeline
        });
      };
      lunr2.Builder.prototype.use = function(fn2) {
        var args = Array.prototype.slice.call(arguments, 1);
        args.unshift(this);
        fn2.apply(this, args);
      };
      lunr2.MatchData = function(term3, field2, metadata2) {
        var clonedMetadata = /* @__PURE__ */ Object.create(null), metadataKeys = Object.keys(metadata2 || {});
        for (var i = 0; i < metadataKeys.length; i++) {
          var key3 = metadataKeys[i];
          clonedMetadata[key3] = metadata2[key3].slice();
        }
        this.metadata = /* @__PURE__ */ Object.create(null);
        if (term3 !== void 0) {
          this.metadata[term3] = /* @__PURE__ */ Object.create(null);
          this.metadata[term3][field2] = clonedMetadata;
        }
      };
      lunr2.MatchData.prototype.combine = function(otherMatchData) {
        var terms = Object.keys(otherMatchData.metadata);
        for (var i = 0; i < terms.length; i++) {
          var term3 = terms[i], fields = Object.keys(otherMatchData.metadata[term3]);
          if (this.metadata[term3] == void 0) {
            this.metadata[term3] = /* @__PURE__ */ Object.create(null);
          }
          for (var j = 0; j < fields.length; j++) {
            var field2 = fields[j], keys = Object.keys(otherMatchData.metadata[term3][field2]);
            if (this.metadata[term3][field2] == void 0) {
              this.metadata[term3][field2] = /* @__PURE__ */ Object.create(null);
            }
            for (var k = 0; k < keys.length; k++) {
              var key3 = keys[k];
              if (this.metadata[term3][field2][key3] == void 0) {
                this.metadata[term3][field2][key3] = otherMatchData.metadata[term3][field2][key3];
              } else {
                this.metadata[term3][field2][key3] = this.metadata[term3][field2][key3].concat(otherMatchData.metadata[term3][field2][key3]);
              }
            }
          }
        }
      };
      lunr2.MatchData.prototype.add = function(term3, field2, metadata2) {
        if (!(term3 in this.metadata)) {
          this.metadata[term3] = /* @__PURE__ */ Object.create(null);
          this.metadata[term3][field2] = metadata2;
          return;
        }
        if (!(field2 in this.metadata[term3])) {
          this.metadata[term3][field2] = metadata2;
          return;
        }
        var metadataKeys = Object.keys(metadata2);
        for (var i = 0; i < metadataKeys.length; i++) {
          var key3 = metadataKeys[i];
          if (key3 in this.metadata[term3][field2]) {
            this.metadata[term3][field2][key3] = this.metadata[term3][field2][key3].concat(metadata2[key3]);
          } else {
            this.metadata[term3][field2][key3] = metadata2[key3];
          }
        }
      };
      lunr2.Query = function(allFields) {
        this.clauses = [];
        this.allFields = allFields;
      };
      lunr2.Query.wildcard = new String("*");
      lunr2.Query.wildcard.NONE = 0;
      lunr2.Query.wildcard.LEADING = 1;
      lunr2.Query.wildcard.TRAILING = 2;
      lunr2.Query.presence = {
        /**
         * Term's presence in a document is optional, this is the default value.
         */
        OPTIONAL: 1,
        /**
         * Term's presence in a document is required, documents that do not contain
         * this term will not be returned.
         */
        REQUIRED: 2,
        /**
         * Term's presence in a document is prohibited, documents that do contain
         * this term will not be returned.
         */
        PROHIBITED: 3
      };
      lunr2.Query.prototype.clause = function(clause) {
        if (!("fields" in clause)) {
          clause.fields = this.allFields;
        }
        if (!("boost" in clause)) {
          clause.boost = 1;
        }
        if (!("usePipeline" in clause)) {
          clause.usePipeline = true;
        }
        if (!("wildcard" in clause)) {
          clause.wildcard = lunr2.Query.wildcard.NONE;
        }
        if (clause.wildcard & lunr2.Query.wildcard.LEADING && clause.term.charAt(0) != lunr2.Query.wildcard) {
          clause.term = "*" + clause.term;
        }
        if (clause.wildcard & lunr2.Query.wildcard.TRAILING && clause.term.slice(-1) != lunr2.Query.wildcard) {
          clause.term = "" + clause.term + "*";
        }
        if (!("presence" in clause)) {
          clause.presence = lunr2.Query.presence.OPTIONAL;
        }
        this.clauses.push(clause);
        return this;
      };
      lunr2.Query.prototype.isNegated = function() {
        for (var i = 0; i < this.clauses.length; i++) {
          if (this.clauses[i].presence != lunr2.Query.presence.PROHIBITED) {
            return false;
          }
        }
        return true;
      };
      lunr2.Query.prototype.term = function(term3, options) {
        if (Array.isArray(term3)) {
          term3.forEach(function(t) {
            this.term(t, lunr2.utils.clone(options));
          }, this);
          return this;
        }
        var clause = options || {};
        clause.term = term3.toString();
        this.clause(clause);
        return this;
      };
      lunr2.QueryParseError = function(message4, start3, end2) {
        this.name = "QueryParseError";
        this.message = message4;
        this.start = start3;
        this.end = end2;
      };
      lunr2.QueryParseError.prototype = new Error();
      lunr2.QueryLexer = function(str) {
        this.lexemes = [];
        this.str = str;
        this.length = str.length;
        this.pos = 0;
        this.start = 0;
        this.escapeCharPositions = [];
      };
      lunr2.QueryLexer.prototype.run = function() {
        var state2 = lunr2.QueryLexer.lexText;
        while (state2) {
          state2 = state2(this);
        }
      };
      lunr2.QueryLexer.prototype.sliceString = function() {
        var subSlices = [], sliceStart = this.start, sliceEnd = this.pos;
        for (var i = 0; i < this.escapeCharPositions.length; i++) {
          sliceEnd = this.escapeCharPositions[i];
          subSlices.push(this.str.slice(sliceStart, sliceEnd));
          sliceStart = sliceEnd + 1;
        }
        subSlices.push(this.str.slice(sliceStart, this.pos));
        this.escapeCharPositions.length = 0;
        return subSlices.join("");
      };
      lunr2.QueryLexer.prototype.emit = function(type5) {
        this.lexemes.push({
          type: type5,
          str: this.sliceString(),
          start: this.start,
          end: this.pos
        });
        this.start = this.pos;
      };
      lunr2.QueryLexer.prototype.escapeCharacter = function() {
        this.escapeCharPositions.push(this.pos - 1);
        this.pos += 1;
      };
      lunr2.QueryLexer.prototype.next = function() {
        if (this.pos >= this.length) {
          return lunr2.QueryLexer.EOS;
        }
        var char = this.str.charAt(this.pos);
        this.pos += 1;
        return char;
      };
      lunr2.QueryLexer.prototype.width = function() {
        return this.pos - this.start;
      };
      lunr2.QueryLexer.prototype.ignore = function() {
        if (this.start == this.pos) {
          this.pos += 1;
        }
        this.start = this.pos;
      };
      lunr2.QueryLexer.prototype.backup = function() {
        this.pos -= 1;
      };
      lunr2.QueryLexer.prototype.acceptDigitRun = function() {
        var char, charCode;
        do {
          char = this.next();
          charCode = char.charCodeAt(0);
        } while (charCode > 47 && charCode < 58);
        if (char != lunr2.QueryLexer.EOS) {
          this.backup();
        }
      };
      lunr2.QueryLexer.prototype.more = function() {
        return this.pos < this.length;
      };
      lunr2.QueryLexer.EOS = "EOS";
      lunr2.QueryLexer.FIELD = "FIELD";
      lunr2.QueryLexer.TERM = "TERM";
      lunr2.QueryLexer.EDIT_DISTANCE = "EDIT_DISTANCE";
      lunr2.QueryLexer.BOOST = "BOOST";
      lunr2.QueryLexer.PRESENCE = "PRESENCE";
      lunr2.QueryLexer.lexField = function(lexer) {
        lexer.backup();
        lexer.emit(lunr2.QueryLexer.FIELD);
        lexer.ignore();
        return lunr2.QueryLexer.lexText;
      };
      lunr2.QueryLexer.lexTerm = function(lexer) {
        if (lexer.width() > 1) {
          lexer.backup();
          lexer.emit(lunr2.QueryLexer.TERM);
        }
        lexer.ignore();
        if (lexer.more()) {
          return lunr2.QueryLexer.lexText;
        }
      };
      lunr2.QueryLexer.lexEditDistance = function(lexer) {
        lexer.ignore();
        lexer.acceptDigitRun();
        lexer.emit(lunr2.QueryLexer.EDIT_DISTANCE);
        return lunr2.QueryLexer.lexText;
      };
      lunr2.QueryLexer.lexBoost = function(lexer) {
        lexer.ignore();
        lexer.acceptDigitRun();
        lexer.emit(lunr2.QueryLexer.BOOST);
        return lunr2.QueryLexer.lexText;
      };
      lunr2.QueryLexer.lexEOS = function(lexer) {
        if (lexer.width() > 0) {
          lexer.emit(lunr2.QueryLexer.TERM);
        }
      };
      lunr2.QueryLexer.termSeparator = lunr2.tokenizer.separator;
      lunr2.QueryLexer.lexText = function(lexer) {
        while (true) {
          var char = lexer.next();
          if (char == lunr2.QueryLexer.EOS) {
            return lunr2.QueryLexer.lexEOS;
          }
          if (char.charCodeAt(0) == 92) {
            lexer.escapeCharacter();
            continue;
          }
          if (char == ":") {
            return lunr2.QueryLexer.lexField;
          }
          if (char == "~") {
            lexer.backup();
            if (lexer.width() > 0) {
              lexer.emit(lunr2.QueryLexer.TERM);
            }
            return lunr2.QueryLexer.lexEditDistance;
          }
          if (char == "^") {
            lexer.backup();
            if (lexer.width() > 0) {
              lexer.emit(lunr2.QueryLexer.TERM);
            }
            return lunr2.QueryLexer.lexBoost;
          }
          if (char == "+" && lexer.width() === 1) {
            lexer.emit(lunr2.QueryLexer.PRESENCE);
            return lunr2.QueryLexer.lexText;
          }
          if (char == "-" && lexer.width() === 1) {
            lexer.emit(lunr2.QueryLexer.PRESENCE);
            return lunr2.QueryLexer.lexText;
          }
          if (char.match(lunr2.QueryLexer.termSeparator)) {
            return lunr2.QueryLexer.lexTerm;
          }
        }
      };
      lunr2.QueryParser = function(str, query4) {
        this.lexer = new lunr2.QueryLexer(str);
        this.query = query4;
        this.currentClause = {};
        this.lexemeIdx = 0;
      };
      lunr2.QueryParser.prototype.parse = function() {
        this.lexer.run();
        this.lexemes = this.lexer.lexemes;
        var state2 = lunr2.QueryParser.parseClause;
        while (state2) {
          state2 = state2(this);
        }
        return this.query;
      };
      lunr2.QueryParser.prototype.peekLexeme = function() {
        return this.lexemes[this.lexemeIdx];
      };
      lunr2.QueryParser.prototype.consumeLexeme = function() {
        var lexeme = this.peekLexeme();
        this.lexemeIdx += 1;
        return lexeme;
      };
      lunr2.QueryParser.prototype.nextClause = function() {
        var completedClause = this.currentClause;
        this.query.clause(completedClause);
        this.currentClause = {};
      };
      lunr2.QueryParser.parseClause = function(parser) {
        var lexeme = parser.peekLexeme();
        if (lexeme == void 0) {
          return;
        }
        switch (lexeme.type) {
          case lunr2.QueryLexer.PRESENCE:
            return lunr2.QueryParser.parsePresence;
          case lunr2.QueryLexer.FIELD:
            return lunr2.QueryParser.parseField;
          case lunr2.QueryLexer.TERM:
            return lunr2.QueryParser.parseTerm;
          default:
            var errorMessage = "expected either a field or a term, found " + lexeme.type;
            if (lexeme.str.length >= 1) {
              errorMessage += " with value '" + lexeme.str + "'";
            }
            throw new lunr2.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
      };
      lunr2.QueryParser.parsePresence = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == void 0) {
          return;
        }
        switch (lexeme.str) {
          case "-":
            parser.currentClause.presence = lunr2.Query.presence.PROHIBITED;
            break;
          case "+":
            parser.currentClause.presence = lunr2.Query.presence.REQUIRED;
            break;
          default:
            var errorMessage = "unrecognised presence operator'" + lexeme.str + "'";
            throw new lunr2.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == void 0) {
          var errorMessage = "expecting term or field, found nothing";
          throw new lunr2.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        switch (nextLexeme.type) {
          case lunr2.QueryLexer.FIELD:
            return lunr2.QueryParser.parseField;
          case lunr2.QueryLexer.TERM:
            return lunr2.QueryParser.parseTerm;
          default:
            var errorMessage = "expecting term or field, found '" + nextLexeme.type + "'";
            throw new lunr2.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
      };
      lunr2.QueryParser.parseField = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == void 0) {
          return;
        }
        if (parser.query.allFields.indexOf(lexeme.str) == -1) {
          var possibleFields = parser.query.allFields.map(function(f) {
            return "'" + f + "'";
          }).join(", "), errorMessage = "unrecognised field '" + lexeme.str + "', possible fields: " + possibleFields;
          throw new lunr2.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        parser.currentClause.fields = [lexeme.str];
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == void 0) {
          var errorMessage = "expecting term, found nothing";
          throw new lunr2.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        switch (nextLexeme.type) {
          case lunr2.QueryLexer.TERM:
            return lunr2.QueryParser.parseTerm;
          default:
            var errorMessage = "expecting term, found '" + nextLexeme.type + "'";
            throw new lunr2.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
      };
      lunr2.QueryParser.parseTerm = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == void 0) {
          return;
        }
        parser.currentClause.term = lexeme.str.toLowerCase();
        if (lexeme.str.indexOf("*") != -1) {
          parser.currentClause.usePipeline = false;
        }
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == void 0) {
          parser.nextClause();
          return;
        }
        switch (nextLexeme.type) {
          case lunr2.QueryLexer.TERM:
            parser.nextClause();
            return lunr2.QueryParser.parseTerm;
          case lunr2.QueryLexer.FIELD:
            parser.nextClause();
            return lunr2.QueryParser.parseField;
          case lunr2.QueryLexer.EDIT_DISTANCE:
            return lunr2.QueryParser.parseEditDistance;
          case lunr2.QueryLexer.BOOST:
            return lunr2.QueryParser.parseBoost;
          case lunr2.QueryLexer.PRESENCE:
            parser.nextClause();
            return lunr2.QueryParser.parsePresence;
          default:
            var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
            throw new lunr2.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
      };
      lunr2.QueryParser.parseEditDistance = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == void 0) {
          return;
        }
        var editDistance = parseInt(lexeme.str, 10);
        if (isNaN(editDistance)) {
          var errorMessage = "edit distance must be numeric";
          throw new lunr2.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        parser.currentClause.editDistance = editDistance;
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == void 0) {
          parser.nextClause();
          return;
        }
        switch (nextLexeme.type) {
          case lunr2.QueryLexer.TERM:
            parser.nextClause();
            return lunr2.QueryParser.parseTerm;
          case lunr2.QueryLexer.FIELD:
            parser.nextClause();
            return lunr2.QueryParser.parseField;
          case lunr2.QueryLexer.EDIT_DISTANCE:
            return lunr2.QueryParser.parseEditDistance;
          case lunr2.QueryLexer.BOOST:
            return lunr2.QueryParser.parseBoost;
          case lunr2.QueryLexer.PRESENCE:
            parser.nextClause();
            return lunr2.QueryParser.parsePresence;
          default:
            var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
            throw new lunr2.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
      };
      lunr2.QueryParser.parseBoost = function(parser) {
        var lexeme = parser.consumeLexeme();
        if (lexeme == void 0) {
          return;
        }
        var boost = parseInt(lexeme.str, 10);
        if (isNaN(boost)) {
          var errorMessage = "boost must be numeric";
          throw new lunr2.QueryParseError(errorMessage, lexeme.start, lexeme.end);
        }
        parser.currentClause.boost = boost;
        var nextLexeme = parser.peekLexeme();
        if (nextLexeme == void 0) {
          parser.nextClause();
          return;
        }
        switch (nextLexeme.type) {
          case lunr2.QueryLexer.TERM:
            parser.nextClause();
            return lunr2.QueryParser.parseTerm;
          case lunr2.QueryLexer.FIELD:
            parser.nextClause();
            return lunr2.QueryParser.parseField;
          case lunr2.QueryLexer.EDIT_DISTANCE:
            return lunr2.QueryParser.parseEditDistance;
          case lunr2.QueryLexer.BOOST:
            return lunr2.QueryParser.parseBoost;
          case lunr2.QueryLexer.PRESENCE:
            parser.nextClause();
            return lunr2.QueryParser.parsePresence;
          default:
            var errorMessage = "Unexpected lexeme type '" + nextLexeme.type + "'";
            throw new lunr2.QueryParseError(errorMessage, nextLexeme.start, nextLexeme.end);
        }
      };
      (function(root, factory) {
        if (typeof define === "function" && define.amd) {
          define(factory);
        } else if (typeof exports === "object") {
          module3.exports = factory();
        } else {
          root.lunr = factory();
        }
      })(this, function() {
        return lunr2;
      });
    })();
  }
});

// ../node_modules/short-unique-id/dist/short-unique-id.js
var require_short_unique_id = __commonJS({
  "../node_modules/short-unique-id/dist/short-unique-id.js"(exports, module3) {
    "use strict";
    var ShortUniqueId2 = (() => {
      var __defProp = Object.defineProperty;
      var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
      var __getOwnPropNames = Object.getOwnPropertyNames;
      var __getOwnPropSymbols = Object.getOwnPropertySymbols;
      var __hasOwnProp = Object.prototype.hasOwnProperty;
      var __propIsEnum = Object.prototype.propertyIsEnumerable;
      var __defNormalProp = (obj, key3, value8) => key3 in obj ? __defProp(obj, key3, { enumerable: true, configurable: true, writable: true, value: value8 }) : obj[key3] = value8;
      var __spreadValues = (a, b) => {
        for (var prop in b || (b = {}))
          if (__hasOwnProp.call(b, prop))
            __defNormalProp(a, prop, b[prop]);
        if (__getOwnPropSymbols)
          for (var prop of __getOwnPropSymbols(b)) {
            if (__propIsEnum.call(b, prop))
              __defNormalProp(a, prop, b[prop]);
          }
        return a;
      };
      var __export2 = (target6, all) => {
        for (var name9 in all)
          __defProp(target6, name9, { get: all[name9], enumerable: true });
      };
      var __copyProps = (to2, from2, except, desc) => {
        if (from2 && typeof from2 === "object" || typeof from2 === "function") {
          for (let key3 of __getOwnPropNames(from2))
            if (!__hasOwnProp.call(to2, key3) && key3 !== except)
              __defProp(to2, key3, { get: () => from2[key3], enumerable: !(desc = __getOwnPropDesc(from2, key3)) || desc.enumerable });
        }
        return to2;
      };
      var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
      var __publicField = (obj, key3, value8) => {
        __defNormalProp(obj, typeof key3 !== "symbol" ? key3 + "" : key3, value8);
        return value8;
      };
      var src_exports = {};
      __export2(src_exports, {
        DEFAULT_OPTIONS: () => DEFAULT_OPTIONS,
        DEFAULT_UUID_LENGTH: () => DEFAULT_UUID_LENGTH,
        default: () => ShortUniqueId3
      });
      var version6 = "5.2.0";
      var DEFAULT_UUID_LENGTH = 6;
      var DEFAULT_OPTIONS = {
        dictionary: "alphanum",
        shuffle: true,
        debug: false,
        length: DEFAULT_UUID_LENGTH,
        counter: 0
      };
      var _ShortUniqueId = class _ShortUniqueId {
        constructor(argOptions = {}) {
          __publicField(this, "counter");
          __publicField(this, "debug");
          __publicField(this, "dict");
          __publicField(this, "version");
          __publicField(this, "dictIndex", 0);
          __publicField(this, "dictRange", []);
          __publicField(this, "lowerBound", 0);
          __publicField(this, "upperBound", 0);
          __publicField(this, "dictLength", 0);
          __publicField(this, "uuidLength");
          __publicField(this, "_digit_first_ascii", 48);
          __publicField(this, "_digit_last_ascii", 58);
          __publicField(this, "_alpha_lower_first_ascii", 97);
          __publicField(this, "_alpha_lower_last_ascii", 123);
          __publicField(this, "_hex_last_ascii", 103);
          __publicField(this, "_alpha_upper_first_ascii", 65);
          __publicField(this, "_alpha_upper_last_ascii", 91);
          __publicField(this, "_number_dict_ranges", {
            digits: [this._digit_first_ascii, this._digit_last_ascii]
          });
          __publicField(this, "_alpha_dict_ranges", {
            lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii],
            upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
          });
          __publicField(this, "_alpha_lower_dict_ranges", {
            lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii]
          });
          __publicField(this, "_alpha_upper_dict_ranges", {
            upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
          });
          __publicField(this, "_alphanum_dict_ranges", {
            digits: [this._digit_first_ascii, this._digit_last_ascii],
            lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii],
            upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
          });
          __publicField(this, "_alphanum_lower_dict_ranges", {
            digits: [this._digit_first_ascii, this._digit_last_ascii],
            lowerCase: [this._alpha_lower_first_ascii, this._alpha_lower_last_ascii]
          });
          __publicField(this, "_alphanum_upper_dict_ranges", {
            digits: [this._digit_first_ascii, this._digit_last_ascii],
            upperCase: [this._alpha_upper_first_ascii, this._alpha_upper_last_ascii]
          });
          __publicField(this, "_hex_dict_ranges", {
            decDigits: [this._digit_first_ascii, this._digit_last_ascii],
            alphaDigits: [this._alpha_lower_first_ascii, this._hex_last_ascii]
          });
          __publicField(this, "_dict_ranges", {
            _number_dict_ranges: this._number_dict_ranges,
            _alpha_dict_ranges: this._alpha_dict_ranges,
            _alpha_lower_dict_ranges: this._alpha_lower_dict_ranges,
            _alpha_upper_dict_ranges: this._alpha_upper_dict_ranges,
            _alphanum_dict_ranges: this._alphanum_dict_ranges,
            _alphanum_lower_dict_ranges: this._alphanum_lower_dict_ranges,
            _alphanum_upper_dict_ranges: this._alphanum_upper_dict_ranges,
            _hex_dict_ranges: this._hex_dict_ranges
          });
          __publicField(this, "log", (...args) => {
            const finalArgs = [...args];
            finalArgs[0] = `[short-unique-id] ${args[0]}`;
            if (this.debug === true) {
              if (typeof console !== "undefined" && console !== null) {
                return console.log(...finalArgs);
              }
            }
          });
          __publicField(this, "_normalizeDictionary", (dictionary3, shuffle2) => {
            let finalDict;
            if (dictionary3 && Array.isArray(dictionary3) && dictionary3.length > 1) {
              finalDict = dictionary3;
            } else {
              finalDict = [];
              let i;
              this.dictIndex = i = 0;
              const rangesName = `_${dictionary3}_dict_ranges`;
              const ranges = this._dict_ranges[rangesName];
              Object.keys(ranges).forEach((rangeType) => {
                const rangeTypeKey = rangeType;
                this.dictRange = ranges[rangeTypeKey];
                this.lowerBound = this.dictRange[0];
                this.upperBound = this.dictRange[1];
                for (this.dictIndex = i = this.lowerBound; this.lowerBound <= this.upperBound ? i < this.upperBound : i > this.upperBound; this.dictIndex = this.lowerBound <= this.upperBound ? i += 1 : i -= 1) {
                  finalDict.push(String.fromCharCode(this.dictIndex));
                }
              });
            }
            if (shuffle2) {
              const PROBABILITY = 0.5;
              finalDict = finalDict.sort(() => Math.random() - PROBABILITY);
            }
            return finalDict;
          });
          __publicField(this, "setDictionary", (dictionary3, shuffle2) => {
            this.dict = this._normalizeDictionary(dictionary3, shuffle2);
            this.dictLength = this.dict.length;
            this.setCounter(0);
          });
          __publicField(this, "seq", () => {
            return this.sequentialUUID();
          });
          __publicField(this, "sequentialUUID", () => {
            let counterDiv;
            let counterRem;
            let id4 = "";
            counterDiv = this.counter;
            do {
              counterRem = counterDiv % this.dictLength;
              counterDiv = Math.trunc(counterDiv / this.dictLength);
              id4 += this.dict[counterRem];
            } while (counterDiv !== 0);
            this.counter += 1;
            return id4;
          });
          __publicField(this, "rnd", (uuidLength = this.uuidLength || DEFAULT_UUID_LENGTH) => {
            return this.randomUUID(uuidLength);
          });
          __publicField(this, "randomUUID", (uuidLength = this.uuidLength || DEFAULT_UUID_LENGTH) => {
            let id4;
            let randomPartIdx;
            let j;
            if (uuidLength === null || typeof uuidLength === "undefined" || uuidLength < 1) {
              throw new Error("Invalid UUID Length Provided");
            }
            const isPositive = uuidLength >= 0;
            id4 = "";
            for (j = 0; j < uuidLength; j += 1) {
              randomPartIdx = parseInt(
                (Math.random() * this.dictLength).toFixed(0),
                10
              ) % this.dictLength;
              id4 += this.dict[randomPartIdx];
            }
            return id4;
          });
          __publicField(this, "fmt", (format4, date6) => {
            return this.formattedUUID(format4, date6);
          });
          __publicField(this, "formattedUUID", (format4, date6) => {
            const fnMap = {
              "$r": this.randomUUID,
              "$s": this.sequentialUUID,
              "$t": this.stamp
            };
            const result6 = format4.replace(
              /\$[rs]\d{0,}|\$t0|\$t[1-9]\d{1,}/g,
              (m) => {
                const fn2 = m.slice(0, 2);
                const len = parseInt(m.slice(2), 10);
                if (fn2 === "$s") {
                  return fnMap[fn2]().padStart(len, "0");
                }
                if (fn2 === "$t" && date6) {
                  return fnMap[fn2](len, date6);
                }
                return fnMap[fn2](len);
              }
            );
            return result6;
          });
          __publicField(this, "availableUUIDs", (uuidLength = this.uuidLength) => {
            return parseFloat(
              Math.pow([...new Set(this.dict)].length, uuidLength).toFixed(0)
            );
          });
          __publicField(this, "approxMaxBeforeCollision", (rounds = this.availableUUIDs(this.uuidLength)) => {
            return parseFloat(
              Math.sqrt(Math.PI / 2 * rounds).toFixed(20)
            );
          });
          __publicField(this, "collisionProbability", (rounds = this.availableUUIDs(this.uuidLength), uuidLength = this.uuidLength) => {
            return parseFloat(
              (this.approxMaxBeforeCollision(rounds) / this.availableUUIDs(uuidLength)).toFixed(20)
            );
          });
          __publicField(this, "uniqueness", (rounds = this.availableUUIDs(this.uuidLength)) => {
            const score2 = parseFloat(
              (1 - this.approxMaxBeforeCollision(rounds) / rounds).toFixed(20)
            );
            return score2 > 1 ? 1 : score2 < 0 ? 0 : score2;
          });
          __publicField(this, "getVersion", () => {
            return this.version;
          });
          __publicField(this, "stamp", (finalLength, date6) => {
            const hexStamp = Math.floor(+(date6 || /* @__PURE__ */ new Date()) / 1e3).toString(16);
            if (typeof finalLength === "number" && finalLength === 0) {
              return hexStamp;
            }
            if (typeof finalLength !== "number" || finalLength < 10) {
              throw new Error(
                [
                  "Param finalLength must be a number greater than or equal to 10,",
                  "or 0 if you want the raw hexadecimal timestamp"
                ].join("\n")
              );
            }
            const idLength = finalLength - 9;
            const rndIdx = Math.round(Math.random() * (idLength > 15 ? 15 : idLength));
            const id4 = this.randomUUID(idLength);
            return `${id4.substring(0, rndIdx)}${hexStamp}${id4.substring(rndIdx)}${rndIdx.toString(16)}`;
          });
          __publicField(this, "parseStamp", (suid, format4) => {
            if (format4 && !/t0|t[1-9]\d{1,}/.test(format4)) {
              throw new Error("Cannot extract date from a formated UUID with no timestamp in the format");
            }
            const stamp = format4 ? format4.replace(
              /\$[rs]\d{0,}|\$t0|\$t[1-9]\d{1,}/g,
              (m) => {
                const fnMap = {
                  "$r": (len2) => [...Array(len2)].map(() => "r").join(""),
                  "$s": (len2) => [...Array(len2)].map(() => "s").join(""),
                  "$t": (len2) => [...Array(len2)].map(() => "t").join("")
                };
                const fn2 = m.slice(0, 2);
                const len = parseInt(m.slice(2), 10);
                return fnMap[fn2](len);
              }
            ).replace(
              /^(.*?)(t{8,})(.*)$/g,
              (_m, p1, p2) => {
                return suid.substring(p1.length, p1.length + p2.length);
              }
            ) : suid;
            if (stamp.length === 8) {
              return new Date(parseInt(stamp, 16) * 1e3);
            }
            if (stamp.length < 10) {
              throw new Error("Stamp length invalid");
            }
            const rndIdx = parseInt(stamp.substring(stamp.length - 1), 16);
            return new Date(parseInt(stamp.substring(rndIdx, rndIdx + 8), 16) * 1e3);
          });
          __publicField(this, "setCounter", (counter2) => {
            this.counter = counter2;
          });
          __publicField(this, "validate", (uid4, dictionary3) => {
            const finalDictionary = dictionary3 ? this._normalizeDictionary(dictionary3) : this.dict;
            return uid4.split("").every((c) => finalDictionary.includes(c));
          });
          const options = __spreadValues(__spreadValues({}, DEFAULT_OPTIONS), argOptions);
          this.counter = 0;
          this.debug = false;
          this.dict = [];
          this.version = version6;
          const {
            dictionary: dictionary2,
            shuffle,
            length: length3,
            counter
          } = options;
          this.uuidLength = length3;
          this.setDictionary(dictionary2, shuffle);
          this.setCounter(counter);
          this.debug = options.debug;
          this.log(this.dict);
          this.log(
            `Generator instantiated with Dictionary Size ${this.dictLength} and counter set to ${this.counter}`
          );
          this.log = this.log.bind(this);
          this.setDictionary = this.setDictionary.bind(this);
          this.setCounter = this.setCounter.bind(this);
          this.seq = this.seq.bind(this);
          this.sequentialUUID = this.sequentialUUID.bind(this);
          this.rnd = this.rnd.bind(this);
          this.randomUUID = this.randomUUID.bind(this);
          this.fmt = this.fmt.bind(this);
          this.formattedUUID = this.formattedUUID.bind(this);
          this.availableUUIDs = this.availableUUIDs.bind(this);
          this.approxMaxBeforeCollision = this.approxMaxBeforeCollision.bind(this);
          this.collisionProbability = this.collisionProbability.bind(this);
          this.uniqueness = this.uniqueness.bind(this);
          this.getVersion = this.getVersion.bind(this);
          this.stamp = this.stamp.bind(this);
          this.parseStamp = this.parseStamp.bind(this);
          return this;
        }
      };
      __publicField(_ShortUniqueId, "default", _ShortUniqueId);
      var ShortUniqueId3 = _ShortUniqueId;
      return __toCommonJS(src_exports);
    })();
    "undefined" != typeof module3 && (module3.exports = ShortUniqueId2.default), "undefined" != typeof window && (ShortUniqueId2 = ShortUniqueId2.default);
  }
});

// node_modules/rdflib/lib/tf-types.js
var require_tf_types = __commonJS({
  "node_modules/rdflib/lib/tf-types.js"(exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", {
      value: true
    });
  }
});

// ../node_modules/slugify/slugify.js
var require_slugify = __commonJS({
  "../node_modules/slugify/slugify.js"(exports, module3) {
    (function(name9, root, factory) {
      if (typeof exports === "object") {
        module3.exports = factory();
        module3.exports["default"] = factory();
      } else if (typeof define === "function" && define.amd) {
        define(factory);
      } else {
        root[name9] = factory();
      }
    })("slugify", exports, function() {
      var charMap = JSON.parse(`{"$":"dollar","%":"percent","&":"and","<":"less",">":"greater","|":"or","\xA2":"cent","\xA3":"pound","\xA4":"currency","\xA5":"yen","\xA9":"(c)","\xAA":"a","\xAE":"(r)","\xBA":"o","\xC0":"A","\xC1":"A","\xC2":"A","\xC3":"A","\xC4":"A","\xC5":"A","\xC6":"AE","\xC7":"C","\xC8":"E","\xC9":"E","\xCA":"E","\xCB":"E","\xCC":"I","\xCD":"I","\xCE":"I","\xCF":"I","\xD0":"D","\xD1":"N","\xD2":"O","\xD3":"O","\xD4":"O","\xD5":"O","\xD6":"O","\xD8":"O","\xD9":"U","\xDA":"U","\xDB":"U","\xDC":"U","\xDD":"Y","\xDE":"TH","\xDF":"ss","\xE0":"a","\xE1":"a","\xE2":"a","\xE3":"a","\xE4":"a","\xE5":"a","\xE6":"ae","\xE7":"c","\xE8":"e","\xE9":"e","\xEA":"e","\xEB":"e","\xEC":"i","\xED":"i","\xEE":"i","\xEF":"i","\xF0":"d","\xF1":"n","\xF2":"o","\xF3":"o","\xF4":"o","\xF5":"o","\xF6":"o","\xF8":"o","\xF9":"u","\xFA":"u","\xFB":"u","\xFC":"u","\xFD":"y","\xFE":"th","\xFF":"y","\u0100":"A","\u0101":"a","\u0102":"A","\u0103":"a","\u0104":"A","\u0105":"a","\u0106":"C","\u0107":"c","\u010C":"C","\u010D":"c","\u010E":"D","\u010F":"d","\u0110":"DJ","\u0111":"dj","\u0112":"E","\u0113":"e","\u0116":"E","\u0117":"e","\u0118":"e","\u0119":"e","\u011A":"E","\u011B":"e","\u011E":"G","\u011F":"g","\u0122":"G","\u0123":"g","\u0128":"I","\u0129":"i","\u012A":"i","\u012B":"i","\u012E":"I","\u012F":"i","\u0130":"I","\u0131":"i","\u0136":"k","\u0137":"k","\u013B":"L","\u013C":"l","\u013D":"L","\u013E":"l","\u0141":"L","\u0142":"l","\u0143":"N","\u0144":"n","\u0145":"N","\u0146":"n","\u0147":"N","\u0148":"n","\u014C":"O","\u014D":"o","\u0150":"O","\u0151":"o","\u0152":"OE","\u0153":"oe","\u0154":"R","\u0155":"r","\u0158":"R","\u0159":"r","\u015A":"S","\u015B":"s","\u015E":"S","\u015F":"s","\u0160":"S","\u0161":"s","\u0162":"T","\u0163":"t","\u0164":"T","\u0165":"t","\u0168":"U","\u0169":"u","\u016A":"u","\u016B":"u","\u016E":"U","\u016F":"u","\u0170":"U","\u0171":"u","\u0172":"U","\u0173":"u","\u0174":"W","\u0175":"w","\u0176":"Y","\u0177":"y","\u0178":"Y","\u0179":"Z","\u017A":"z","\u017B":"Z","\u017C":"z","\u017D":"Z","\u017E":"z","\u018F":"E","\u0192":"f","\u01A0":"O","\u01A1":"o","\u01AF":"U","\u01B0":"u","\u01C8":"LJ","\u01C9":"lj","\u01CB":"NJ","\u01CC":"nj","\u0218":"S","\u0219":"s","\u021A":"T","\u021B":"t","\u0259":"e","\u02DA":"o","\u0386":"A","\u0388":"E","\u0389":"H","\u038A":"I","\u038C":"O","\u038E":"Y","\u038F":"W","\u0390":"i","\u0391":"A","\u0392":"B","\u0393":"G","\u0394":"D","\u0395":"E","\u0396":"Z","\u0397":"H","\u0398":"8","\u0399":"I","\u039A":"K","\u039B":"L","\u039C":"M","\u039D":"N","\u039E":"3","\u039F":"O","\u03A0":"P","\u03A1":"R","\u03A3":"S","\u03A4":"T","\u03A5":"Y","\u03A6":"F","\u03A7":"X","\u03A8":"PS","\u03A9":"W","\u03AA":"I","\u03AB":"Y","\u03AC":"a","\u03AD":"e","\u03AE":"h","\u03AF":"i","\u03B0":"y","\u03B1":"a","\u03B2":"b","\u03B3":"g","\u03B4":"d","\u03B5":"e","\u03B6":"z","\u03B7":"h","\u03B8":"8","\u03B9":"i","\u03BA":"k","\u03BB":"l","\u03BC":"m","\u03BD":"n","\u03BE":"3","\u03BF":"o","\u03C0":"p","\u03C1":"r","\u03C2":"s","\u03C3":"s","\u03C4":"t","\u03C5":"y","\u03C6":"f","\u03C7":"x","\u03C8":"ps","\u03C9":"w","\u03CA":"i","\u03CB":"y","\u03CC":"o","\u03CD":"y","\u03CE":"w","\u0401":"Yo","\u0402":"DJ","\u0404":"Ye","\u0406":"I","\u0407":"Yi","\u0408":"J","\u0409":"LJ","\u040A":"NJ","\u040B":"C","\u040F":"DZ","\u0410":"A","\u0411":"B","\u0412":"V","\u0413":"G","\u0414":"D","\u0415":"E","\u0416":"Zh","\u0417":"Z","\u0418":"I","\u0419":"J","\u041A":"K","\u041B":"L","\u041C":"M","\u041D":"N","\u041E":"O","\u041F":"P","\u0420":"R","\u0421":"S","\u0422":"T","\u0423":"U","\u0424":"F","\u0425":"H","\u0426":"C","\u0427":"Ch","\u0428":"Sh","\u0429":"Sh","\u042A":"U","\u042B":"Y","\u042C":"","\u042D":"E","\u042E":"Yu","\u042F":"Ya","\u0430":"a","\u0431":"b","\u0432":"v","\u0433":"g","\u0434":"d","\u0435":"e","\u0436":"zh","\u0437":"z","\u0438":"i","\u0439":"j","\u043A":"k","\u043B":"l","\u043C":"m","\u043D":"n","\u043E":"o","\u043F":"p","\u0440":"r","\u0441":"s","\u0442":"t","\u0443":"u","\u0444":"f","\u0445":"h","\u0446":"c","\u0447":"ch","\u0448":"sh","\u0449":"sh","\u044A":"u","\u044B":"y","\u044C":"","\u044D":"e","\u044E":"yu","\u044F":"ya","\u0451":"yo","\u0452":"dj","\u0454":"ye","\u0456":"i","\u0457":"yi","\u0458":"j","\u0459":"lj","\u045A":"nj","\u045B":"c","\u045D":"u","\u045F":"dz","\u0490":"G","\u0491":"g","\u0492":"GH","\u0493":"gh","\u049A":"KH","\u049B":"kh","\u04A2":"NG","\u04A3":"ng","\u04AE":"UE","\u04AF":"ue","\u04B0":"U","\u04B1":"u","\u04BA":"H","\u04BB":"h","\u04D8":"AE","\u04D9":"ae","\u04E8":"OE","\u04E9":"oe","\u0531":"A","\u0532":"B","\u0533":"G","\u0534":"D","\u0535":"E","\u0536":"Z","\u0537":"E'","\u0538":"Y'","\u0539":"T'","\u053A":"JH","\u053B":"I","\u053C":"L","\u053D":"X","\u053E":"C'","\u053F":"K","\u0540":"H","\u0541":"D'","\u0542":"GH","\u0543":"TW","\u0544":"M","\u0545":"Y","\u0546":"N","\u0547":"SH","\u0549":"CH","\u054A":"P","\u054B":"J","\u054C":"R'","\u054D":"S","\u054E":"V","\u054F":"T","\u0550":"R","\u0551":"C","\u0553":"P'","\u0554":"Q'","\u0555":"O''","\u0556":"F","\u0587":"EV","\u0621":"a","\u0622":"aa","\u0623":"a","\u0624":"u","\u0625":"i","\u0626":"e","\u0627":"a","\u0628":"b","\u0629":"h","\u062A":"t","\u062B":"th","\u062C":"j","\u062D":"h","\u062E":"kh","\u062F":"d","\u0630":"th","\u0631":"r","\u0632":"z","\u0633":"s","\u0634":"sh","\u0635":"s","\u0636":"dh","\u0637":"t","\u0638":"z","\u0639":"a","\u063A":"gh","\u0641":"f","\u0642":"q","\u0643":"k","\u0644":"l","\u0645":"m","\u0646":"n","\u0647":"h","\u0648":"w","\u0649":"a","\u064A":"y","\u064B":"an","\u064C":"on","\u064D":"en","\u064E":"a","\u064F":"u","\u0650":"e","\u0652":"","\u0660":"0","\u0661":"1","\u0662":"2","\u0663":"3","\u0664":"4","\u0665":"5","\u0666":"6","\u0667":"7","\u0668":"8","\u0669":"9","\u067E":"p","\u0686":"ch","\u0698":"zh","\u06A9":"k","\u06AF":"g","\u06CC":"y","\u06F0":"0","\u06F1":"1","\u06F2":"2","\u06F3":"3","\u06F4":"4","\u06F5":"5","\u06F6":"6","\u06F7":"7","\u06F8":"8","\u06F9":"9","\u0E3F":"baht","\u10D0":"a","\u10D1":"b","\u10D2":"g","\u10D3":"d","\u10D4":"e","\u10D5":"v","\u10D6":"z","\u10D7":"t","\u10D8":"i","\u10D9":"k","\u10DA":"l","\u10DB":"m","\u10DC":"n","\u10DD":"o","\u10DE":"p","\u10DF":"zh","\u10E0":"r","\u10E1":"s","\u10E2":"t","\u10E3":"u","\u10E4":"f","\u10E5":"k","\u10E6":"gh","\u10E7":"q","\u10E8":"sh","\u10E9":"ch","\u10EA":"ts","\u10EB":"dz","\u10EC":"ts","\u10ED":"ch","\u10EE":"kh","\u10EF":"j","\u10F0":"h","\u1E62":"S","\u1E63":"s","\u1E80":"W","\u1E81":"w","\u1E82":"W","\u1E83":"w","\u1E84":"W","\u1E85":"w","\u1E9E":"SS","\u1EA0":"A","\u1EA1":"a","\u1EA2":"A","\u1EA3":"a","\u1EA4":"A","\u1EA5":"a","\u1EA6":"A","\u1EA7":"a","\u1EA8":"A","\u1EA9":"a","\u1EAA":"A","\u1EAB":"a","\u1EAC":"A","\u1EAD":"a","\u1EAE":"A","\u1EAF":"a","\u1EB0":"A","\u1EB1":"a","\u1EB2":"A","\u1EB3":"a","\u1EB4":"A","\u1EB5":"a","\u1EB6":"A","\u1EB7":"a","\u1EB8":"E","\u1EB9":"e","\u1EBA":"E","\u1EBB":"e","\u1EBC":"E","\u1EBD":"e","\u1EBE":"E","\u1EBF":"e","\u1EC0":"E","\u1EC1":"e","\u1EC2":"E","\u1EC3":"e","\u1EC4":"E","\u1EC5":"e","\u1EC6":"E","\u1EC7":"e","\u1EC8":"I","\u1EC9":"i","\u1ECA":"I","\u1ECB":"i","\u1ECC":"O","\u1ECD":"o","\u1ECE":"O","\u1ECF":"o","\u1ED0":"O","\u1ED1":"o","\u1ED2":"O","\u1ED3":"o","\u1ED4":"O","\u1ED5":"o","\u1ED6":"O","\u1ED7":"o","\u1ED8":"O","\u1ED9":"o","\u1EDA":"O","\u1EDB":"o","\u1EDC":"O","\u1EDD":"o","\u1EDE":"O","\u1EDF":"o","\u1EE0":"O","\u1EE1":"o","\u1EE2":"O","\u1EE3":"o","\u1EE4":"U","\u1EE5":"u","\u1EE6":"U","\u1EE7":"u","\u1EE8":"U","\u1EE9":"u","\u1EEA":"U","\u1EEB":"u","\u1EEC":"U","\u1EED":"u","\u1EEE":"U","\u1EEF":"u","\u1EF0":"U","\u1EF1":"u","\u1EF2":"Y","\u1EF3":"y","\u1EF4":"Y","\u1EF5":"y","\u1EF6":"Y","\u1EF7":"y","\u1EF8":"Y","\u1EF9":"y","\u2013":"-","\u2018":"'","\u2019":"'","\u201C":"\\"","\u201D":"\\"","\u201E":"\\"","\u2020":"+","\u2022":"*","\u2026":"...","\u20A0":"ecu","\u20A2":"cruzeiro","\u20A3":"french franc","\u20A4":"lira","\u20A5":"mill","\u20A6":"naira","\u20A7":"peseta","\u20A8":"rupee","\u20A9":"won","\u20AA":"new shequel","\u20AB":"dong","\u20AC":"euro","\u20AD":"kip","\u20AE":"tugrik","\u20AF":"drachma","\u20B0":"penny","\u20B1":"peso","\u20B2":"guarani","\u20B3":"austral","\u20B4":"hryvnia","\u20B5":"cedi","\u20B8":"kazakhstani tenge","\u20B9":"indian rupee","\u20BA":"turkish lira","\u20BD":"russian ruble","\u20BF":"bitcoin","\u2120":"sm","\u2122":"tm","\u2202":"d","\u2206":"delta","\u2211":"sum","\u221E":"infinity","\u2665":"love","\u5143":"yuan","\u5186":"yen","\uFDFC":"rial","\uFEF5":"laa","\uFEF7":"laa","\uFEF9":"lai","\uFEFB":"la"}`);
      var locales = JSON.parse('{"bg":{"\u0419":"Y","\u0426":"Ts","\u0429":"Sht","\u042A":"A","\u042C":"Y","\u0439":"y","\u0446":"ts","\u0449":"sht","\u044A":"a","\u044C":"y"},"de":{"\xC4":"AE","\xE4":"ae","\xD6":"OE","\xF6":"oe","\xDC":"UE","\xFC":"ue","\xDF":"ss","%":"prozent","&":"und","|":"oder","\u2211":"summe","\u221E":"unendlich","\u2665":"liebe"},"es":{"%":"por ciento","&":"y","<":"menor que",">":"mayor que","|":"o","\xA2":"centavos","\xA3":"libras","\xA4":"moneda","\u20A3":"francos","\u2211":"suma","\u221E":"infinito","\u2665":"amor"},"fr":{"%":"pourcent","&":"et","<":"plus petit",">":"plus grand","|":"ou","\xA2":"centime","\xA3":"livre","\xA4":"devise","\u20A3":"franc","\u2211":"somme","\u221E":"infini","\u2665":"amour"},"pt":{"%":"porcento","&":"e","<":"menor",">":"maior","|":"ou","\xA2":"centavo","\u2211":"soma","\xA3":"libra","\u221E":"infinito","\u2665":"amor"},"uk":{"\u0418":"Y","\u0438":"y","\u0419":"Y","\u0439":"y","\u0426":"Ts","\u0446":"ts","\u0425":"Kh","\u0445":"kh","\u0429":"Shch","\u0449":"shch","\u0413":"H","\u0433":"h"},"vi":{"\u0110":"D","\u0111":"d"},"da":{"\xD8":"OE","\xF8":"oe","\xC5":"AA","\xE5":"aa","%":"procent","&":"og","|":"eller","$":"dollar","<":"mindre end",">":"st\xF8rre end"},"nb":{"&":"og","\xC5":"AA","\xC6":"AE","\xD8":"OE","\xE5":"aa","\xE6":"ae","\xF8":"oe"},"it":{"&":"e"},"nl":{"&":"en"},"sv":{"&":"och","\xC5":"AA","\xC4":"AE","\xD6":"OE","\xE5":"aa","\xE4":"ae","\xF6":"oe"}}');
      function replace(string3, options) {
        if (typeof string3 !== "string") {
          throw new Error("slugify: string argument expected");
        }
        options = typeof options === "string" ? { replacement: options } : options || {};
        var locale = locales[options.locale] || {};
        var replacement = options.replacement === void 0 ? "-" : options.replacement;
        var trim = options.trim === void 0 ? true : options.trim;
        var slug = string3.normalize().split("").reduce(function(result6, ch) {
          var appendChar = locale[ch];
          if (appendChar === void 0) appendChar = charMap[ch];
          if (appendChar === void 0) appendChar = ch;
          if (appendChar === replacement) appendChar = " ";
          return result6 + appendChar.replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]+/g, "");
        }, "");
        if (options.strict) {
          slug = slug.replace(/[^A-Za-z0-9\s]/g, "");
        }
        if (trim) {
          slug = slug.trim();
        }
        slug = slug.replace(/\s+/g, replacement);
        if (options.lower) {
          slug = slug.toLowerCase();
        }
        return slug;
      }
      replace.extend = function(customMap) {
        Object.assign(charMap, customMap);
      };
      return replace;
    });
  }
});

// ../node_modules/tslib/tslib.es6.mjs
var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2) if (Object.prototype.hasOwnProperty.call(b2, p)) d2[p] = b2[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
    throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
function __awaiter(thisArg, _arguments, P, generator3) {
  function adopt(value8) {
    return value8 instanceof P ? value8 : new P(function(resolve) {
      resolve(value8);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value8) {
      try {
        step4(generator3.next(value8));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value8) {
      try {
        step4(generator3["throw"](value8));
      } catch (e) {
        reject(e);
      }
    }
    function step4(result6) {
      result6.done ? resolve(result6.value) : adopt(result6.value).then(fulfilled, rejected);
    }
    step4((generator3 = generator3.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1) throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb2(0), g["throw"] = verb2(1), g["return"] = verb2(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb2(n3) {
    return function(v2) {
      return step4([n3, v2]);
    };
  }
  function step4(op2) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op2[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op2[0] & 2 ? y["return"] : op2[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op2[1])).done) return t;
      if (y = 0, t) op2 = [op2[0] & 2, t.value];
      switch (op2[0]) {
        case 0:
        case 1:
          t = op2;
          break;
        case 4:
          _.label++;
          return { value: op2[1], done: false };
        case 5:
          _.label++;
          y = op2[1];
          op2 = [0];
          continue;
        case 7:
          op2 = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op2[0] === 6 || op2[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op2[0] === 3 && (!t || op2[1] > t[0] && op2[1] < t[3])) {
            _.label = op2[1];
            break;
          }
          if (op2[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op2;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op2);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op2 = body.call(thisArg, _);
    } catch (e) {
      op2 = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op2[0] & 5) throw op2[1];
    return { value: op2[0] ? op2[1] : void 0, done: true };
  }
}
function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function() {
      if (o && i >= o.length) o = void 0;
      return { value: o && o[i++], done: !o };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n3) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
    while ((n3 === void 0 || n3-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error4) {
    e = { error: error4 };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
}
function __spreadArray(to2, from2, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from2.length, ar; i < l; i++) {
    if (ar || !(i in from2)) {
      if (!ar) ar = Array.prototype.slice.call(from2, 0, i);
      ar[i] = from2[i];
    }
  }
  return to2.concat(ar || Array.prototype.slice.call(from2));
}
function __await(v2) {
  return this instanceof __await ? (this.v = v2, this) : new __await(v2);
}
function __asyncGenerator(thisArg, _arguments, generator3) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator3.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb2("next"), verb2("throw"), verb2("return", awaitReturn), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function awaitReturn(f) {
    return function(v2) {
      return Promise.resolve(v2).then(f, reject);
    };
  }
  function verb2(n3, f) {
    if (g[n3]) {
      i[n3] = function(v2) {
        return new Promise(function(a, b) {
          q.push([n3, v2, a, b]) > 1 || resume(n3, v2);
        });
      };
      if (f) i[n3] = f(i[n3]);
    }
  }
  function resume(n3, v2) {
    try {
      step4(g[n3](v2));
    } catch (e) {
      settle(q[0][3], e);
    }
  }
  function step4(r) {
    r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }
  function fulfill(value8) {
    resume("next", value8);
  }
  function reject(value8) {
    resume("throw", value8);
  }
  function settle(f, v2) {
    if (f(v2), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
}
function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb2("next"), verb2("throw"), verb2("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i);
  function verb2(n3) {
    i[n3] = o[n3] && function(v2) {
      return new Promise(function(resolve, reject) {
        v2 = o[n3](v2), settle(resolve, reject, v2.done, v2.value);
      });
    };
  }
  function settle(resolve, reject, d, v2) {
    Promise.resolve(v2).then(function(v3) {
      resolve({ value: v3, done: d });
    }, reject);
  }
}

// ../node_modules/rxjs/dist/esm5/internal/util/isFunction.js
function isFunction(value8) {
  return typeof value8 === "function";
}

// ../node_modules/rxjs/dist/esm5/internal/util/createErrorClass.js
function createErrorClass(createImpl) {
  var _super = function(instance3) {
    Error.call(instance3);
    instance3.stack = new Error().stack;
  };
  var ctorFunc = createImpl(_super);
  ctorFunc.prototype = Object.create(Error.prototype);
  ctorFunc.prototype.constructor = ctorFunc;
  return ctorFunc;
}

// ../node_modules/rxjs/dist/esm5/internal/util/UnsubscriptionError.js
var UnsubscriptionError = createErrorClass(function(_super) {
  return function UnsubscriptionErrorImpl(errors) {
    _super(this);
    this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err2, i) {
      return i + 1 + ") " + err2.toString();
    }).join("\n  ") : "";
    this.name = "UnsubscriptionError";
    this.errors = errors;
  };
});

// ../node_modules/rxjs/dist/esm5/internal/util/arrRemove.js
function arrRemove(arr, item4) {
  if (arr) {
    var index2 = arr.indexOf(item4);
    0 <= index2 && arr.splice(index2, 1);
  }
}

// ../node_modules/rxjs/dist/esm5/internal/Subscription.js
var Subscription = (function() {
  function Subscription3(initialTeardown) {
    this.initialTeardown = initialTeardown;
    this.closed = false;
    this._parentage = null;
    this._finalizers = null;
  }
  Subscription3.prototype.unsubscribe = function() {
    var e_1, _a, e_2, _b;
    var errors;
    if (!this.closed) {
      this.closed = true;
      var _parentage = this._parentage;
      if (_parentage) {
        this._parentage = null;
        if (Array.isArray(_parentage)) {
          try {
            for (var _parentage_1 = __values(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()) {
              var parent_1 = _parentage_1_1.value;
              parent_1.remove(this);
            }
          } catch (e_1_1) {
            e_1 = { error: e_1_1 };
          } finally {
            try {
              if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
            } finally {
              if (e_1) throw e_1.error;
            }
          }
        } else {
          _parentage.remove(this);
        }
      }
      var initialFinalizer = this.initialTeardown;
      if (isFunction(initialFinalizer)) {
        try {
          initialFinalizer();
        } catch (e) {
          errors = e instanceof UnsubscriptionError ? e.errors : [e];
        }
      }
      var _finalizers = this._finalizers;
      if (_finalizers) {
        this._finalizers = null;
        try {
          for (var _finalizers_1 = __values(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()) {
            var finalizer = _finalizers_1_1.value;
            try {
              execFinalizer(finalizer);
            } catch (err2) {
              errors = errors !== null && errors !== void 0 ? errors : [];
              if (err2 instanceof UnsubscriptionError) {
                errors = __spreadArray(__spreadArray([], __read(errors)), __read(err2.errors));
              } else {
                errors.push(err2);
              }
            }
          }
        } catch (e_2_1) {
          e_2 = { error: e_2_1 };
        } finally {
          try {
            if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
          } finally {
            if (e_2) throw e_2.error;
          }
        }
      }
      if (errors) {
        throw new UnsubscriptionError(errors);
      }
    }
  };
  Subscription3.prototype.add = function(teardown2) {
    var _a;
    if (teardown2 && teardown2 !== this) {
      if (this.closed) {
        execFinalizer(teardown2);
      } else {
        if (teardown2 instanceof Subscription3) {
          if (teardown2.closed || teardown2._hasParent(this)) {
            return;
          }
          teardown2._addParent(this);
        }
        (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown2);
      }
    }
  };
  Subscription3.prototype._hasParent = function(parent4) {
    var _parentage = this._parentage;
    return _parentage === parent4 || Array.isArray(_parentage) && _parentage.includes(parent4);
  };
  Subscription3.prototype._addParent = function(parent4) {
    var _parentage = this._parentage;
    this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent4), _parentage) : _parentage ? [_parentage, parent4] : parent4;
  };
  Subscription3.prototype._removeParent = function(parent4) {
    var _parentage = this._parentage;
    if (_parentage === parent4) {
      this._parentage = null;
    } else if (Array.isArray(_parentage)) {
      arrRemove(_parentage, parent4);
    }
  };
  Subscription3.prototype.remove = function(teardown2) {
    var _finalizers = this._finalizers;
    _finalizers && arrRemove(_finalizers, teardown2);
    if (teardown2 instanceof Subscription3) {
      teardown2._removeParent(this);
    }
  };
  Subscription3.EMPTY = (function() {
    var empty = new Subscription3();
    empty.closed = true;
    return empty;
  })();
  return Subscription3;
})();
var EMPTY_SUBSCRIPTION = Subscription.EMPTY;
function isSubscription(value8) {
  return value8 instanceof Subscription || value8 && "closed" in value8 && isFunction(value8.remove) && isFunction(value8.add) && isFunction(value8.unsubscribe);
}
function execFinalizer(finalizer) {
  if (isFunction(finalizer)) {
    finalizer();
  } else {
    finalizer.unsubscribe();
  }
}

// ../node_modules/rxjs/dist/esm5/internal/config.js
var config = {
  onUnhandledError: null,
  onStoppedNotification: null,
  Promise: void 0,
  useDeprecatedSynchronousErrorHandling: false,
  useDeprecatedNextContext: false
};

// ../node_modules/rxjs/dist/esm5/internal/scheduler/timeoutProvider.js
var timeoutProvider = {
  setTimeout: function(handler, timeout2) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      args[_i - 2] = arguments[_i];
    }
    var delegate = timeoutProvider.delegate;
    if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) {
      return delegate.setTimeout.apply(delegate, __spreadArray([handler, timeout2], __read(args)));
    }
    return setTimeout.apply(void 0, __spreadArray([handler, timeout2], __read(args)));
  },
  clearTimeout: function(handle) {
    var delegate = timeoutProvider.delegate;
    return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
  },
  delegate: void 0
};

// ../node_modules/rxjs/dist/esm5/internal/util/reportUnhandledError.js
function reportUnhandledError(err2) {
  timeoutProvider.setTimeout(function() {
    var onUnhandledError = config.onUnhandledError;
    if (onUnhandledError) {
      onUnhandledError(err2);
    } else {
      throw err2;
    }
  });
}

// ../node_modules/rxjs/dist/esm5/internal/util/noop.js
function noop() {
}

// ../node_modules/rxjs/dist/esm5/internal/NotificationFactories.js
var COMPLETE_NOTIFICATION = (function() {
  return createNotification("C", void 0, void 0);
})();
function errorNotification(error4) {
  return createNotification("E", void 0, error4);
}
function nextNotification(value8) {
  return createNotification("N", value8, void 0);
}
function createNotification(kind2, value8, error4) {
  return {
    kind: kind2,
    value: value8,
    error: error4
  };
}

// ../node_modules/rxjs/dist/esm5/internal/util/errorContext.js
var context = null;
function errorContext(cb) {
  if (config.useDeprecatedSynchronousErrorHandling) {
    var isRoot = !context;
    if (isRoot) {
      context = { errorThrown: false, error: null };
    }
    cb();
    if (isRoot) {
      var _a = context, errorThrown = _a.errorThrown, error4 = _a.error;
      context = null;
      if (errorThrown) {
        throw error4;
      }
    }
  } else {
    cb();
  }
}
function captureError(err2) {
  if (config.useDeprecatedSynchronousErrorHandling && context) {
    context.errorThrown = true;
    context.error = err2;
  }
}

// ../node_modules/rxjs/dist/esm5/internal/Subscriber.js
var Subscriber = (function(_super) {
  __extends(Subscriber2, _super);
  function Subscriber2(destination2) {
    var _this = _super.call(this) || this;
    _this.isStopped = false;
    if (destination2) {
      _this.destination = destination2;
      if (isSubscription(destination2)) {
        destination2.add(_this);
      }
    } else {
      _this.destination = EMPTY_OBSERVER;
    }
    return _this;
  }
  Subscriber2.create = function(next4, error4, complete2) {
    return new SafeSubscriber(next4, error4, complete2);
  };
  Subscriber2.prototype.next = function(value8) {
    if (this.isStopped) {
      handleStoppedNotification(nextNotification(value8), this);
    } else {
      this._next(value8);
    }
  };
  Subscriber2.prototype.error = function(err2) {
    if (this.isStopped) {
      handleStoppedNotification(errorNotification(err2), this);
    } else {
      this.isStopped = true;
      this._error(err2);
    }
  };
  Subscriber2.prototype.complete = function() {
    if (this.isStopped) {
      handleStoppedNotification(COMPLETE_NOTIFICATION, this);
    } else {
      this.isStopped = true;
      this._complete();
    }
  };
  Subscriber2.prototype.unsubscribe = function() {
    if (!this.closed) {
      this.isStopped = true;
      _super.prototype.unsubscribe.call(this);
      this.destination = null;
    }
  };
  Subscriber2.prototype._next = function(value8) {
    this.destination.next(value8);
  };
  Subscriber2.prototype._error = function(err2) {
    try {
      this.destination.error(err2);
    } finally {
      this.unsubscribe();
    }
  };
  Subscriber2.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  };
  return Subscriber2;
})(Subscription);
var _bind = Function.prototype.bind;
function bind(fn2, thisArg) {
  return _bind.call(fn2, thisArg);
}
var ConsumerObserver = (function() {
  function ConsumerObserver2(partialObserver) {
    this.partialObserver = partialObserver;
  }
  ConsumerObserver2.prototype.next = function(value8) {
    var partialObserver = this.partialObserver;
    if (partialObserver.next) {
      try {
        partialObserver.next(value8);
      } catch (error4) {
        handleUnhandledError(error4);
      }
    }
  };
  ConsumerObserver2.prototype.error = function(err2) {
    var partialObserver = this.partialObserver;
    if (partialObserver.error) {
      try {
        partialObserver.error(err2);
      } catch (error4) {
        handleUnhandledError(error4);
      }
    } else {
      handleUnhandledError(err2);
    }
  };
  ConsumerObserver2.prototype.complete = function() {
    var partialObserver = this.partialObserver;
    if (partialObserver.complete) {
      try {
        partialObserver.complete();
      } catch (error4) {
        handleUnhandledError(error4);
      }
    }
  };
  return ConsumerObserver2;
})();
var SafeSubscriber = (function(_super) {
  __extends(SafeSubscriber2, _super);
  function SafeSubscriber2(observerOrNext, error4, complete2) {
    var _this = _super.call(this) || this;
    var partialObserver;
    if (isFunction(observerOrNext) || !observerOrNext) {
      partialObserver = {
        next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : void 0,
        error: error4 !== null && error4 !== void 0 ? error4 : void 0,
        complete: complete2 !== null && complete2 !== void 0 ? complete2 : void 0
      };
    } else {
      var context_1;
      if (_this && config.useDeprecatedNextContext) {
        context_1 = Object.create(observerOrNext);
        context_1.unsubscribe = function() {
          return _this.unsubscribe();
        };
        partialObserver = {
          next: observerOrNext.next && bind(observerOrNext.next, context_1),
          error: observerOrNext.error && bind(observerOrNext.error, context_1),
          complete: observerOrNext.complete && bind(observerOrNext.complete, context_1)
        };
      } else {
        partialObserver = observerOrNext;
      }
    }
    _this.destination = new ConsumerObserver(partialObserver);
    return _this;
  }
  return SafeSubscriber2;
})(Subscriber);
function handleUnhandledError(error4) {
  if (config.useDeprecatedSynchronousErrorHandling) {
    captureError(error4);
  } else {
    reportUnhandledError(error4);
  }
}
function defaultErrorHandler(err2) {
  throw err2;
}
function handleStoppedNotification(notification2, subscriber3) {
  var onStoppedNotification = config.onStoppedNotification;
  onStoppedNotification && timeoutProvider.setTimeout(function() {
    return onStoppedNotification(notification2, subscriber3);
  });
}
var EMPTY_OBSERVER = {
  closed: true,
  next: noop,
  error: defaultErrorHandler,
  complete: noop
};

// ../node_modules/rxjs/dist/esm5/internal/symbol/observable.js
var observable = (function() {
  return typeof Symbol === "function" && Symbol.observable || "@@observable";
})();

// ../node_modules/rxjs/dist/esm5/internal/util/identity.js
function identity(x) {
  return x;
}

// ../node_modules/rxjs/dist/esm5/internal/util/pipe.js
function pipeFromArray(fns) {
  if (fns.length === 0) {
    return identity;
  }
  if (fns.length === 1) {
    return fns[0];
  }
  return function piped(input2) {
    return fns.reduce(function(prev2, fn2) {
      return fn2(prev2);
    }, input2);
  };
}

// ../node_modules/rxjs/dist/esm5/internal/Observable.js
var Observable = (function() {
  function Observable5(subscribe) {
    if (subscribe) {
      this._subscribe = subscribe;
    }
  }
  Observable5.prototype.lift = function(operator2) {
    var observable2 = new Observable5();
    observable2.source = this;
    observable2.operator = operator2;
    return observable2;
  };
  Observable5.prototype.subscribe = function(observerOrNext, error4, complete2) {
    var _this = this;
    var subscriber3 = isSubscriber(observerOrNext) ? observerOrNext : new SafeSubscriber(observerOrNext, error4, complete2);
    errorContext(function() {
      var _a = _this, operator2 = _a.operator, source10 = _a.source;
      subscriber3.add(operator2 ? operator2.call(subscriber3, source10) : source10 ? _this._subscribe(subscriber3) : _this._trySubscribe(subscriber3));
    });
    return subscriber3;
  };
  Observable5.prototype._trySubscribe = function(sink) {
    try {
      return this._subscribe(sink);
    } catch (err2) {
      sink.error(err2);
    }
  };
  Observable5.prototype.forEach = function(next4, promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function(resolve, reject) {
      var subscriber3 = new SafeSubscriber({
        next: function(value8) {
          try {
            next4(value8);
          } catch (err2) {
            reject(err2);
            subscriber3.unsubscribe();
          }
        },
        error: reject,
        complete: resolve
      });
      _this.subscribe(subscriber3);
    });
  };
  Observable5.prototype._subscribe = function(subscriber3) {
    var _a;
    return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber3);
  };
  Observable5.prototype[observable] = function() {
    return this;
  };
  Observable5.prototype.pipe = function() {
    var operations = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      operations[_i] = arguments[_i];
    }
    return pipeFromArray(operations)(this);
  };
  Observable5.prototype.toPromise = function(promiseCtor) {
    var _this = this;
    promiseCtor = getPromiseCtor(promiseCtor);
    return new promiseCtor(function(resolve, reject) {
      var value8;
      _this.subscribe(function(x) {
        return value8 = x;
      }, function(err2) {
        return reject(err2);
      }, function() {
        return resolve(value8);
      });
    });
  };
  Observable5.create = function(subscribe) {
    return new Observable5(subscribe);
  };
  return Observable5;
})();
function getPromiseCtor(promiseCtor) {
  var _a;
  return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : config.Promise) !== null && _a !== void 0 ? _a : Promise;
}
function isObserver(value8) {
  return value8 && isFunction(value8.next) && isFunction(value8.error) && isFunction(value8.complete);
}
function isSubscriber(value8) {
  return value8 && value8 instanceof Subscriber || isObserver(value8) && isSubscription(value8);
}

// ../node_modules/rxjs/dist/esm5/internal/util/lift.js
function hasLift(source10) {
  return isFunction(source10 === null || source10 === void 0 ? void 0 : source10.lift);
}
function operate(init) {
  return function(source10) {
    if (hasLift(source10)) {
      return source10.lift(function(liftedSource) {
        try {
          return init(liftedSource, this);
        } catch (err2) {
          this.error(err2);
        }
      });
    }
    throw new TypeError("Unable to lift unknown Observable type");
  };
}

// ../node_modules/rxjs/dist/esm5/internal/operators/OperatorSubscriber.js
function createOperatorSubscriber(destination2, onNext, onComplete, onError, onFinalize) {
  return new OperatorSubscriber(destination2, onNext, onComplete, onError, onFinalize);
}
var OperatorSubscriber = (function(_super) {
  __extends(OperatorSubscriber2, _super);
  function OperatorSubscriber2(destination2, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
    var _this = _super.call(this, destination2) || this;
    _this.onFinalize = onFinalize;
    _this.shouldUnsubscribe = shouldUnsubscribe;
    _this._next = onNext ? function(value8) {
      try {
        onNext(value8);
      } catch (err2) {
        destination2.error(err2);
      }
    } : _super.prototype._next;
    _this._error = onError ? function(err2) {
      try {
        onError(err2);
      } catch (err3) {
        destination2.error(err3);
      } finally {
        this.unsubscribe();
      }
    } : _super.prototype._error;
    _this._complete = onComplete ? function() {
      try {
        onComplete();
      } catch (err2) {
        destination2.error(err2);
      } finally {
        this.unsubscribe();
      }
    } : _super.prototype._complete;
    return _this;
  }
  OperatorSubscriber2.prototype.unsubscribe = function() {
    var _a;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var closed_1 = this.closed;
      _super.prototype.unsubscribe.call(this);
      !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 ? void 0 : _a.call(this));
    }
  };
  return OperatorSubscriber2;
})(Subscriber);

// ../node_modules/rxjs/dist/esm5/internal/util/ObjectUnsubscribedError.js
var ObjectUnsubscribedError = createErrorClass(function(_super) {
  return function ObjectUnsubscribedErrorImpl() {
    _super(this);
    this.name = "ObjectUnsubscribedError";
    this.message = "object unsubscribed";
  };
});

// ../node_modules/rxjs/dist/esm5/internal/Subject.js
var Subject = (function(_super) {
  __extends(Subject2, _super);
  function Subject2() {
    var _this = _super.call(this) || this;
    _this.closed = false;
    _this.currentObservers = null;
    _this.observers = [];
    _this.isStopped = false;
    _this.hasError = false;
    _this.thrownError = null;
    return _this;
  }
  Subject2.prototype.lift = function(operator2) {
    var subject8 = new AnonymousSubject(this, this);
    subject8.operator = operator2;
    return subject8;
  };
  Subject2.prototype._throwIfClosed = function() {
    if (this.closed) {
      throw new ObjectUnsubscribedError();
    }
  };
  Subject2.prototype.next = function(value8) {
    var _this = this;
    errorContext(function() {
      var e_1, _a;
      _this._throwIfClosed();
      if (!_this.isStopped) {
        if (!_this.currentObservers) {
          _this.currentObservers = Array.from(_this.observers);
        }
        try {
          for (var _b = __values(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()) {
            var observer2 = _c.value;
            observer2.next(value8);
          }
        } catch (e_1_1) {
          e_1 = { error: e_1_1 };
        } finally {
          try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
          } finally {
            if (e_1) throw e_1.error;
          }
        }
      }
    });
  };
  Subject2.prototype.error = function(err2) {
    var _this = this;
    errorContext(function() {
      _this._throwIfClosed();
      if (!_this.isStopped) {
        _this.hasError = _this.isStopped = true;
        _this.thrownError = err2;
        var observers = _this.observers;
        while (observers.length) {
          observers.shift().error(err2);
        }
      }
    });
  };
  Subject2.prototype.complete = function() {
    var _this = this;
    errorContext(function() {
      _this._throwIfClosed();
      if (!_this.isStopped) {
        _this.isStopped = true;
        var observers = _this.observers;
        while (observers.length) {
          observers.shift().complete();
        }
      }
    });
  };
  Subject2.prototype.unsubscribe = function() {
    this.isStopped = this.closed = true;
    this.observers = this.currentObservers = null;
  };
  Object.defineProperty(Subject2.prototype, "observed", {
    get: function() {
      var _a;
      return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
    },
    enumerable: false,
    configurable: true
  });
  Subject2.prototype._trySubscribe = function(subscriber3) {
    this._throwIfClosed();
    return _super.prototype._trySubscribe.call(this, subscriber3);
  };
  Subject2.prototype._subscribe = function(subscriber3) {
    this._throwIfClosed();
    this._checkFinalizedStatuses(subscriber3);
    return this._innerSubscribe(subscriber3);
  };
  Subject2.prototype._innerSubscribe = function(subscriber3) {
    var _this = this;
    var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
    if (hasError || isStopped) {
      return EMPTY_SUBSCRIPTION;
    }
    this.currentObservers = null;
    observers.push(subscriber3);
    return new Subscription(function() {
      _this.currentObservers = null;
      arrRemove(observers, subscriber3);
    });
  };
  Subject2.prototype._checkFinalizedStatuses = function(subscriber3) {
    var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
    if (hasError) {
      subscriber3.error(thrownError);
    } else if (isStopped) {
      subscriber3.complete();
    }
  };
  Subject2.prototype.asObservable = function() {
    var observable2 = new Observable();
    observable2.source = this;
    return observable2;
  };
  Subject2.create = function(destination2, source10) {
    return new AnonymousSubject(destination2, source10);
  };
  return Subject2;
})(Observable);
var AnonymousSubject = (function(_super) {
  __extends(AnonymousSubject2, _super);
  function AnonymousSubject2(destination2, source10) {
    var _this = _super.call(this) || this;
    _this.destination = destination2;
    _this.source = source10;
    return _this;
  }
  AnonymousSubject2.prototype.next = function(value8) {
    var _a, _b;
    (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 ? void 0 : _b.call(_a, value8);
  };
  AnonymousSubject2.prototype.error = function(err2) {
    var _a, _b;
    (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.call(_a, err2);
  };
  AnonymousSubject2.prototype.complete = function() {
    var _a, _b;
    (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 ? void 0 : _b.call(_a);
  };
  AnonymousSubject2.prototype._subscribe = function(subscriber3) {
    var _a, _b;
    return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber3)) !== null && _b !== void 0 ? _b : EMPTY_SUBSCRIPTION;
  };
  return AnonymousSubject2;
})(Subject);

// ../node_modules/rxjs/dist/esm5/internal/BehaviorSubject.js
var BehaviorSubject = (function(_super) {
  __extends(BehaviorSubject3, _super);
  function BehaviorSubject3(_value2) {
    var _this = _super.call(this) || this;
    _this._value = _value2;
    return _this;
  }
  Object.defineProperty(BehaviorSubject3.prototype, "value", {
    get: function() {
      return this.getValue();
    },
    enumerable: false,
    configurable: true
  });
  BehaviorSubject3.prototype._subscribe = function(subscriber3) {
    var subscription2 = _super.prototype._subscribe.call(this, subscriber3);
    !subscription2.closed && subscriber3.next(this._value);
    return subscription2;
  };
  BehaviorSubject3.prototype.getValue = function() {
    var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value2 = _a._value;
    if (hasError) {
      throw thrownError;
    }
    this._throwIfClosed();
    return _value2;
  };
  BehaviorSubject3.prototype.next = function(value8) {
    _super.prototype.next.call(this, this._value = value8);
  };
  return BehaviorSubject3;
})(Subject);

// ../node_modules/rxjs/dist/esm5/internal/scheduler/dateTimestampProvider.js
var dateTimestampProvider = {
  now: function() {
    return (dateTimestampProvider.delegate || Date).now();
  },
  delegate: void 0
};

// ../node_modules/rxjs/dist/esm5/internal/scheduler/Action.js
var Action = (function(_super) {
  __extends(Action5, _super);
  function Action5(scheduler, work) {
    return _super.call(this) || this;
  }
  Action5.prototype.schedule = function(state2, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    return this;
  };
  return Action5;
})(Subscription);

// ../node_modules/rxjs/dist/esm5/internal/scheduler/intervalProvider.js
var intervalProvider = {
  setInterval: function(handler, timeout2) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
      args[_i - 2] = arguments[_i];
    }
    var delegate = intervalProvider.delegate;
    if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) {
      return delegate.setInterval.apply(delegate, __spreadArray([handler, timeout2], __read(args)));
    }
    return setInterval.apply(void 0, __spreadArray([handler, timeout2], __read(args)));
  },
  clearInterval: function(handle) {
    var delegate = intervalProvider.delegate;
    return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
  },
  delegate: void 0
};

// ../node_modules/rxjs/dist/esm5/internal/scheduler/AsyncAction.js
var AsyncAction = (function(_super) {
  __extends(AsyncAction2, _super);
  function AsyncAction2(scheduler, work) {
    var _this = _super.call(this, scheduler, work) || this;
    _this.scheduler = scheduler;
    _this.work = work;
    _this.pending = false;
    return _this;
  }
  AsyncAction2.prototype.schedule = function(state2, delay) {
    var _a;
    if (delay === void 0) {
      delay = 0;
    }
    if (this.closed) {
      return this;
    }
    this.state = state2;
    var id4 = this.id;
    var scheduler = this.scheduler;
    if (id4 != null) {
      this.id = this.recycleAsyncId(scheduler, id4, delay);
    }
    this.pending = true;
    this.delay = delay;
    this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
    return this;
  };
  AsyncAction2.prototype.requestAsyncId = function(scheduler, _id2, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    return intervalProvider.setInterval(scheduler.flush.bind(scheduler, this), delay);
  };
  AsyncAction2.prototype.recycleAsyncId = function(_scheduler, id4, delay) {
    if (delay === void 0) {
      delay = 0;
    }
    if (delay != null && this.delay === delay && this.pending === false) {
      return id4;
    }
    if (id4 != null) {
      intervalProvider.clearInterval(id4);
    }
    return void 0;
  };
  AsyncAction2.prototype.execute = function(state2, delay) {
    if (this.closed) {
      return new Error("executing a cancelled action");
    }
    this.pending = false;
    var error4 = this._execute(state2, delay);
    if (error4) {
      return error4;
    } else if (this.pending === false && this.id != null) {
      this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    }
  };
  AsyncAction2.prototype._execute = function(state2, _delay) {
    var errored = false;
    var errorValue;
    try {
      this.work(state2);
    } catch (e) {
      errored = true;
      errorValue = e ? e : new Error("Scheduled action threw falsy error");
    }
    if (errored) {
      this.unsubscribe();
      return errorValue;
    }
  };
  AsyncAction2.prototype.unsubscribe = function() {
    if (!this.closed) {
      var _a = this, id4 = _a.id, scheduler = _a.scheduler;
      var actions = scheduler.actions;
      this.work = this.state = this.scheduler = null;
      this.pending = false;
      arrRemove(actions, this);
      if (id4 != null) {
        this.id = this.recycleAsyncId(scheduler, id4, null);
      }
      this.delay = null;
      _super.prototype.unsubscribe.call(this);
    }
  };
  return AsyncAction2;
})(Action);

// ../node_modules/rxjs/dist/esm5/internal/Scheduler.js
var Scheduler = (function() {
  function Scheduler2(schedulerActionCtor, now) {
    if (now === void 0) {
      now = Scheduler2.now;
    }
    this.schedulerActionCtor = schedulerActionCtor;
    this.now = now;
  }
  Scheduler2.prototype.schedule = function(work, delay, state2) {
    if (delay === void 0) {
      delay = 0;
    }
    return new this.schedulerActionCtor(this, work).schedule(state2, delay);
  };
  Scheduler2.now = dateTimestampProvider.now;
  return Scheduler2;
})();

// ../node_modules/rxjs/dist/esm5/internal/scheduler/AsyncScheduler.js
var AsyncScheduler = (function(_super) {
  __extends(AsyncScheduler2, _super);
  function AsyncScheduler2(SchedulerAction, now) {
    if (now === void 0) {
      now = Scheduler.now;
    }
    var _this = _super.call(this, SchedulerAction, now) || this;
    _this.actions = [];
    _this._active = false;
    return _this;
  }
  AsyncScheduler2.prototype.flush = function(action3) {
    var actions = this.actions;
    if (this._active) {
      actions.push(action3);
      return;
    }
    var error4;
    this._active = true;
    do {
      if (error4 = action3.execute(action3.state, action3.delay)) {
        break;
      }
    } while (action3 = actions.shift());
    this._active = false;
    if (error4) {
      while (action3 = actions.shift()) {
        action3.unsubscribe();
      }
      throw error4;
    }
  };
  return AsyncScheduler2;
})(Scheduler);

// ../node_modules/rxjs/dist/esm5/internal/scheduler/async.js
var asyncScheduler = new AsyncScheduler(AsyncAction);

// ../node_modules/rxjs/dist/esm5/internal/observable/empty.js
var EMPTY = new Observable(function(subscriber3) {
  return subscriber3.complete();
});

// ../node_modules/rxjs/dist/esm5/internal/util/isScheduler.js
function isScheduler(value8) {
  return value8 && isFunction(value8.schedule);
}

// ../node_modules/rxjs/dist/esm5/internal/util/args.js
function last(arr) {
  return arr[arr.length - 1];
}
function popScheduler(args) {
  return isScheduler(last(args)) ? args.pop() : void 0;
}
function popNumber(args, defaultValue5) {
  return typeof last(args) === "number" ? args.pop() : defaultValue5;
}

// ../node_modules/rxjs/dist/esm5/internal/util/isArrayLike.js
var isArrayLike = (function(x) {
  return x && typeof x.length === "number" && typeof x !== "function";
});

// ../node_modules/rxjs/dist/esm5/internal/util/isPromise.js
function isPromise(value8) {
  return isFunction(value8 === null || value8 === void 0 ? void 0 : value8.then);
}

// ../node_modules/rxjs/dist/esm5/internal/util/isInteropObservable.js
function isInteropObservable(input2) {
  return isFunction(input2[observable]);
}

// ../node_modules/rxjs/dist/esm5/internal/util/isAsyncIterable.js
function isAsyncIterable(obj) {
  return Symbol.asyncIterator && isFunction(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}

// ../node_modules/rxjs/dist/esm5/internal/util/throwUnobservableError.js
function createInvalidObservableTypeError(input2) {
  return new TypeError("You provided " + (input2 !== null && typeof input2 === "object" ? "an invalid object" : "'" + input2 + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}

// ../node_modules/rxjs/dist/esm5/internal/symbol/iterator.js
function getSymbolIterator() {
  if (typeof Symbol !== "function" || !Symbol.iterator) {
    return "@@iterator";
  }
  return Symbol.iterator;
}
var iterator = getSymbolIterator();

// ../node_modules/rxjs/dist/esm5/internal/util/isIterable.js
function isIterable(input2) {
  return isFunction(input2 === null || input2 === void 0 ? void 0 : input2[iterator]);
}

// ../node_modules/rxjs/dist/esm5/internal/util/isReadableStreamLike.js
function readableStreamLikeToAsyncGenerator(readableStream) {
  return __asyncGenerator(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
    var reader, _a, value8, done;
    return __generator(this, function(_b) {
      switch (_b.label) {
        case 0:
          reader = readableStream.getReader();
          _b.label = 1;
        case 1:
          _b.trys.push([1, , 9, 10]);
          _b.label = 2;
        case 2:
          if (false) return [3, 8];
          return [4, __await(reader.read())];
        case 3:
          _a = _b.sent(), value8 = _a.value, done = _a.done;
          if (!done) return [3, 5];
          return [4, __await(void 0)];
        case 4:
          return [2, _b.sent()];
        case 5:
          return [4, __await(value8)];
        case 6:
          return [4, _b.sent()];
        case 7:
          _b.sent();
          return [3, 2];
        case 8:
          return [3, 10];
        case 9:
          reader.releaseLock();
          return [7];
        case 10:
          return [2];
      }
    });
  });
}
function isReadableStreamLike(obj) {
  return isFunction(obj === null || obj === void 0 ? void 0 : obj.getReader);
}

// ../node_modules/rxjs/dist/esm5/internal/observable/innerFrom.js
function innerFrom(input2) {
  if (input2 instanceof Observable) {
    return input2;
  }
  if (input2 != null) {
    if (isInteropObservable(input2)) {
      return fromInteropObservable(input2);
    }
    if (isArrayLike(input2)) {
      return fromArrayLike(input2);
    }
    if (isPromise(input2)) {
      return fromPromise(input2);
    }
    if (isAsyncIterable(input2)) {
      return fromAsyncIterable(input2);
    }
    if (isIterable(input2)) {
      return fromIterable(input2);
    }
    if (isReadableStreamLike(input2)) {
      return fromReadableStreamLike(input2);
    }
  }
  throw createInvalidObservableTypeError(input2);
}
function fromInteropObservable(obj) {
  return new Observable(function(subscriber3) {
    var obs = obj[observable]();
    if (isFunction(obs.subscribe)) {
      return obs.subscribe(subscriber3);
    }
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function fromArrayLike(array) {
  return new Observable(function(subscriber3) {
    for (var i = 0; i < array.length && !subscriber3.closed; i++) {
      subscriber3.next(array[i]);
    }
    subscriber3.complete();
  });
}
function fromPromise(promise) {
  return new Observable(function(subscriber3) {
    promise.then(function(value8) {
      if (!subscriber3.closed) {
        subscriber3.next(value8);
        subscriber3.complete();
      }
    }, function(err2) {
      return subscriber3.error(err2);
    }).then(null, reportUnhandledError);
  });
}
function fromIterable(iterable) {
  return new Observable(function(subscriber3) {
    var e_1, _a;
    try {
      for (var iterable_1 = __values(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()) {
        var value8 = iterable_1_1.value;
        subscriber3.next(value8);
        if (subscriber3.closed) {
          return;
        }
      }
    } catch (e_1_1) {
      e_1 = { error: e_1_1 };
    } finally {
      try {
        if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
      } finally {
        if (e_1) throw e_1.error;
      }
    }
    subscriber3.complete();
  });
}
function fromAsyncIterable(asyncIterable) {
  return new Observable(function(subscriber3) {
    process(asyncIterable, subscriber3).catch(function(err2) {
      return subscriber3.error(err2);
    });
  });
}
function fromReadableStreamLike(readableStream) {
  return fromAsyncIterable(readableStreamLikeToAsyncGenerator(readableStream));
}
function process(asyncIterable, subscriber3) {
  var asyncIterable_1, asyncIterable_1_1;
  var e_2, _a;
  return __awaiter(this, void 0, void 0, function() {
    var value8, e_2_1;
    return __generator(this, function(_b) {
      switch (_b.label) {
        case 0:
          _b.trys.push([0, 5, 6, 11]);
          asyncIterable_1 = __asyncValues(asyncIterable);
          _b.label = 1;
        case 1:
          return [4, asyncIterable_1.next()];
        case 2:
          if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [3, 4];
          value8 = asyncIterable_1_1.value;
          subscriber3.next(value8);
          if (subscriber3.closed) {
            return [2];
          }
          _b.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          e_2_1 = _b.sent();
          e_2 = { error: e_2_1 };
          return [3, 11];
        case 6:
          _b.trys.push([6, , 9, 10]);
          if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [3, 8];
          return [4, _a.call(asyncIterable_1)];
        case 7:
          _b.sent();
          _b.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (e_2) throw e_2.error;
          return [7];
        case 10:
          return [7];
        case 11:
          subscriber3.complete();
          return [2];
      }
    });
  });
}

// ../node_modules/rxjs/dist/esm5/internal/util/executeSchedule.js
function executeSchedule(parentSubscription, scheduler, work, delay, repeat3) {
  if (delay === void 0) {
    delay = 0;
  }
  if (repeat3 === void 0) {
    repeat3 = false;
  }
  var scheduleSubscription = scheduler.schedule(function() {
    work();
    if (repeat3) {
      parentSubscription.add(this.schedule(null, delay));
    } else {
      this.unsubscribe();
    }
  }, delay);
  parentSubscription.add(scheduleSubscription);
  if (!repeat3) {
    return scheduleSubscription;
  }
}

// ../node_modules/rxjs/dist/esm5/internal/operators/observeOn.js
function observeOn(scheduler, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return operate(function(source10, subscriber3) {
    source10.subscribe(createOperatorSubscriber(subscriber3, function(value8) {
      return executeSchedule(subscriber3, scheduler, function() {
        return subscriber3.next(value8);
      }, delay);
    }, function() {
      return executeSchedule(subscriber3, scheduler, function() {
        return subscriber3.complete();
      }, delay);
    }, function(err2) {
      return executeSchedule(subscriber3, scheduler, function() {
        return subscriber3.error(err2);
      }, delay);
    }));
  });
}

// ../node_modules/rxjs/dist/esm5/internal/operators/subscribeOn.js
function subscribeOn(scheduler, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return operate(function(source10, subscriber3) {
    subscriber3.add(scheduler.schedule(function() {
      return source10.subscribe(subscriber3);
    }, delay));
  });
}

// ../node_modules/rxjs/dist/esm5/internal/scheduled/scheduleObservable.js
function scheduleObservable(input2, scheduler) {
  return innerFrom(input2).pipe(subscribeOn(scheduler), observeOn(scheduler));
}

// ../node_modules/rxjs/dist/esm5/internal/scheduled/schedulePromise.js
function schedulePromise(input2, scheduler) {
  return innerFrom(input2).pipe(subscribeOn(scheduler), observeOn(scheduler));
}

// ../node_modules/rxjs/dist/esm5/internal/scheduled/scheduleArray.js
function scheduleArray(input2, scheduler) {
  return new Observable(function(subscriber3) {
    var i = 0;
    return scheduler.schedule(function() {
      if (i === input2.length) {
        subscriber3.complete();
      } else {
        subscriber3.next(input2[i++]);
        if (!subscriber3.closed) {
          this.schedule();
        }
      }
    });
  });
}

// ../node_modules/rxjs/dist/esm5/internal/scheduled/scheduleIterable.js
function scheduleIterable(input2, scheduler) {
  return new Observable(function(subscriber3) {
    var iterator2;
    executeSchedule(subscriber3, scheduler, function() {
      iterator2 = input2[iterator]();
      executeSchedule(subscriber3, scheduler, function() {
        var _a;
        var value8;
        var done;
        try {
          _a = iterator2.next(), value8 = _a.value, done = _a.done;
        } catch (err2) {
          subscriber3.error(err2);
          return;
        }
        if (done) {
          subscriber3.complete();
        } else {
          subscriber3.next(value8);
        }
      }, 0, true);
    });
    return function() {
      return isFunction(iterator2 === null || iterator2 === void 0 ? void 0 : iterator2.return) && iterator2.return();
    };
  });
}

// ../node_modules/rxjs/dist/esm5/internal/scheduled/scheduleAsyncIterable.js
function scheduleAsyncIterable(input2, scheduler) {
  if (!input2) {
    throw new Error("Iterable cannot be null");
  }
  return new Observable(function(subscriber3) {
    executeSchedule(subscriber3, scheduler, function() {
      var iterator2 = input2[Symbol.asyncIterator]();
      executeSchedule(subscriber3, scheduler, function() {
        iterator2.next().then(function(result6) {
          if (result6.done) {
            subscriber3.complete();
          } else {
            subscriber3.next(result6.value);
          }
        });
      }, 0, true);
    });
  });
}

// ../node_modules/rxjs/dist/esm5/internal/scheduled/scheduleReadableStreamLike.js
function scheduleReadableStreamLike(input2, scheduler) {
  return scheduleAsyncIterable(readableStreamLikeToAsyncGenerator(input2), scheduler);
}

// ../node_modules/rxjs/dist/esm5/internal/scheduled/scheduled.js
function scheduled(input2, scheduler) {
  if (input2 != null) {
    if (isInteropObservable(input2)) {
      return scheduleObservable(input2, scheduler);
    }
    if (isArrayLike(input2)) {
      return scheduleArray(input2, scheduler);
    }
    if (isPromise(input2)) {
      return schedulePromise(input2, scheduler);
    }
    if (isAsyncIterable(input2)) {
      return scheduleAsyncIterable(input2, scheduler);
    }
    if (isIterable(input2)) {
      return scheduleIterable(input2, scheduler);
    }
    if (isReadableStreamLike(input2)) {
      return scheduleReadableStreamLike(input2, scheduler);
    }
  }
  throw createInvalidObservableTypeError(input2);
}

// ../node_modules/rxjs/dist/esm5/internal/observable/from.js
function from(input2, scheduler) {
  return scheduler ? scheduled(input2, scheduler) : innerFrom(input2);
}

// ../node_modules/rxjs/dist/esm5/internal/operators/map.js
function map(project, thisArg) {
  return operate(function(source10, subscriber3) {
    var index2 = 0;
    source10.subscribe(createOperatorSubscriber(subscriber3, function(value8) {
      subscriber3.next(project.call(thisArg, value8, index2++));
    }));
  });
}

// ../node_modules/rxjs/dist/esm5/internal/operators/mergeInternals.js
function mergeInternals(source10, subscriber3, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
  var buffer = [];
  var active2 = 0;
  var index2 = 0;
  var isComplete = false;
  var checkComplete = function() {
    if (isComplete && !buffer.length && !active2) {
      subscriber3.complete();
    }
  };
  var outerNext = function(value8) {
    return active2 < concurrent ? doInnerSub(value8) : buffer.push(value8);
  };
  var doInnerSub = function(value8) {
    expand && subscriber3.next(value8);
    active2++;
    var innerComplete = false;
    innerFrom(project(value8, index2++)).subscribe(createOperatorSubscriber(subscriber3, function(innerValue) {
      onBeforeNext === null || onBeforeNext === void 0 ? void 0 : onBeforeNext(innerValue);
      if (expand) {
        outerNext(innerValue);
      } else {
        subscriber3.next(innerValue);
      }
    }, function() {
      innerComplete = true;
    }, void 0, function() {
      if (innerComplete) {
        try {
          active2--;
          var _loop_1 = function() {
            var bufferedValue = buffer.shift();
            if (innerSubScheduler) {
              executeSchedule(subscriber3, innerSubScheduler, function() {
                return doInnerSub(bufferedValue);
              });
            } else {
              doInnerSub(bufferedValue);
            }
          };
          while (buffer.length && active2 < concurrent) {
            _loop_1();
          }
          checkComplete();
        } catch (err2) {
          subscriber3.error(err2);
        }
      }
    }));
  };
  source10.subscribe(createOperatorSubscriber(subscriber3, outerNext, function() {
    isComplete = true;
    checkComplete();
  }));
  return function() {
    additionalFinalizer === null || additionalFinalizer === void 0 ? void 0 : additionalFinalizer();
  };
}

// ../node_modules/rxjs/dist/esm5/internal/operators/mergeMap.js
function mergeMap(project, resultSelector, concurrent) {
  if (concurrent === void 0) {
    concurrent = Infinity;
  }
  if (isFunction(resultSelector)) {
    return mergeMap(function(a, i) {
      return map(function(b, ii) {
        return resultSelector(a, b, i, ii);
      })(innerFrom(project(a, i)));
    }, concurrent);
  } else if (typeof resultSelector === "number") {
    concurrent = resultSelector;
  }
  return operate(function(source10, subscriber3) {
    return mergeInternals(source10, subscriber3, project, concurrent);
  });
}

// ../node_modules/rxjs/dist/esm5/internal/operators/mergeAll.js
function mergeAll(concurrent) {
  if (concurrent === void 0) {
    concurrent = Infinity;
  }
  return mergeMap(identity, concurrent);
}

// ../node_modules/rxjs/dist/esm5/internal/operators/concatAll.js
function concatAll() {
  return mergeAll(1);
}

// ../node_modules/rxjs/dist/esm5/internal/observable/concat.js
function concat() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  return concatAll()(from(args, popScheduler(args)));
}

// ../node_modules/rxjs/dist/esm5/internal/observable/merge.js
function merge() {
  var args = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }
  var scheduler = popScheduler(args);
  var concurrent = popNumber(args, Infinity);
  var sources = args;
  return !sources.length ? EMPTY : sources.length === 1 ? innerFrom(sources[0]) : mergeAll(concurrent)(from(sources, scheduler));
}

// ../node_modules/rxjs/dist/esm5/internal/operators/filter.js
function filter(predicate4, thisArg) {
  return operate(function(source10, subscriber3) {
    var index2 = 0;
    source10.subscribe(createOperatorSubscriber(subscriber3, function(value8) {
      return predicate4.call(thisArg, value8, index2++) && subscriber3.next(value8);
    }));
  });
}

// ../node_modules/rxjs/dist/esm5/internal/operators/debounceTime.js
function debounceTime(dueTime, scheduler) {
  if (scheduler === void 0) {
    scheduler = asyncScheduler;
  }
  return operate(function(source10, subscriber3) {
    var activeTask = null;
    var lastValue = null;
    var lastTime = null;
    var emit = function() {
      if (activeTask) {
        activeTask.unsubscribe();
        activeTask = null;
        var value8 = lastValue;
        lastValue = null;
        subscriber3.next(value8);
      }
    };
    function emitWhenIdle() {
      var targetTime = lastTime + dueTime;
      var now = scheduler.now();
      if (now < targetTime) {
        activeTask = this.schedule(void 0, targetTime - now);
        subscriber3.add(activeTask);
        return;
      }
      emit();
    }
    source10.subscribe(createOperatorSubscriber(subscriber3, function(value8) {
      lastValue = value8;
      lastTime = scheduler.now();
      if (!activeTask) {
        activeTask = scheduler.schedule(emitWhenIdle, dueTime);
        subscriber3.add(activeTask);
      }
    }, function() {
      emit();
      subscriber3.complete();
    }, void 0, function() {
      lastValue = activeTask = null;
    }));
  });
}

// ../node_modules/rxjs/dist/esm5/internal/operators/take.js
function take(count2) {
  return count2 <= 0 ? function() {
    return EMPTY;
  } : operate(function(source10, subscriber3) {
    var seen = 0;
    source10.subscribe(createOperatorSubscriber(subscriber3, function(value8) {
      if (++seen <= count2) {
        subscriber3.next(value8);
        if (count2 <= seen) {
          subscriber3.complete();
        }
      }
    }));
  });
}

// ../node_modules/rxjs/dist/esm5/internal/operators/distinctUntilChanged.js
function distinctUntilChanged(comparator2, keySelector) {
  if (keySelector === void 0) {
    keySelector = identity;
  }
  comparator2 = comparator2 !== null && comparator2 !== void 0 ? comparator2 : defaultCompare;
  return operate(function(source10, subscriber3) {
    var previousKey;
    var first4 = true;
    source10.subscribe(createOperatorSubscriber(subscriber3, function(value8) {
      var currentKey = keySelector(value8);
      if (first4 || !comparator2(previousKey, currentKey)) {
        first4 = false;
        previousKey = currentKey;
        subscriber3.next(value8);
      }
    }));
  });
}
function defaultCompare(a, b) {
  return a === b;
}

// ../node_modules/rxjs/dist/esm5/internal/operators/startWith.js
function startWith() {
  var values2 = [];
  for (var _i = 0; _i < arguments.length; _i++) {
    values2[_i] = arguments[_i];
  }
  var scheduler = popScheduler(values2);
  return operate(function(source10, subscriber3) {
    (scheduler ? concat(values2, source10, scheduler) : concat(values2, source10)).subscribe(subscriber3);
  });
}

// ../node_modules/rxjs/dist/esm5/internal/operators/switchMap.js
function switchMap(project, resultSelector) {
  return operate(function(source10, subscriber3) {
    var innerSubscriber = null;
    var index2 = 0;
    var isComplete = false;
    var checkComplete = function() {
      return isComplete && !innerSubscriber && subscriber3.complete();
    };
    source10.subscribe(createOperatorSubscriber(subscriber3, function(value8) {
      innerSubscriber === null || innerSubscriber === void 0 ? void 0 : innerSubscriber.unsubscribe();
      var innerIndex = 0;
      var outerIndex = index2++;
      innerFrom(project(value8, outerIndex)).subscribe(innerSubscriber = createOperatorSubscriber(subscriber3, function(innerValue) {
        return subscriber3.next(resultSelector ? resultSelector(value8, innerValue, outerIndex, innerIndex++) : innerValue);
      }, function() {
        innerSubscriber = null;
        checkComplete();
      }));
    }, function() {
      isComplete = true;
      checkComplete();
    }));
  });
}

// ../node_modules/rxjs/dist/esm5/internal/operators/tap.js
function tap(observerOrNext, error4, complete2) {
  var tapObserver = isFunction(observerOrNext) || error4 || complete2 ? { next: observerOrNext, error: error4, complete: complete2 } : observerOrNext;
  return tapObserver ? operate(function(source10, subscriber3) {
    var _a;
    (_a = tapObserver.subscribe) === null || _a === void 0 ? void 0 : _a.call(tapObserver);
    var isUnsub = true;
    source10.subscribe(createOperatorSubscriber(subscriber3, function(value8) {
      var _a2;
      (_a2 = tapObserver.next) === null || _a2 === void 0 ? void 0 : _a2.call(tapObserver, value8);
      subscriber3.next(value8);
    }, function() {
      var _a2;
      isUnsub = false;
      (_a2 = tapObserver.complete) === null || _a2 === void 0 ? void 0 : _a2.call(tapObserver);
      subscriber3.complete();
    }, function(err2) {
      var _a2;
      isUnsub = false;
      (_a2 = tapObserver.error) === null || _a2 === void 0 ? void 0 : _a2.call(tapObserver, err2);
      subscriber3.error(err2);
    }, function() {
      var _a2, _b;
      if (isUnsub) {
        (_a2 = tapObserver.unsubscribe) === null || _a2 === void 0 ? void 0 : _a2.call(tapObserver);
      }
      (_b = tapObserver.finalize) === null || _b === void 0 ? void 0 : _b.call(tapObserver);
    }));
  }) : identity;
}

// src/files/BinaryFile.ts
var BinaryFile = class {
  constructor(url7, data4) {
    this.url = url7;
    this.data = data4;
  }
  blob() {
    return this.data;
  }
};

// src/files/BrokenFile.ts
var BrokenFile = class {
  constructor(url7, status10) {
    this.url = url7;
    this.status = status10;
  }
  toString() {
    return `${this.status.toString()} - ${this.url}`;
  }
  blob() {
    return null;
  }
};

// src/files/HttpStatus.ts
var HttpStatus = class {
  constructor(code5, text4) {
    this.code = code5;
    this.text = text4;
  }
  toString() {
    return this.text ? `${this.code} - ${this.text}` : this.code.toString();
  }
};

// src/problems/index.ts
function httpProblem(title10, response6) {
  return {
    type: "http",
    title: title10,
    status: response6.status,
    detail: `The server responded with ${response6.status} ${response6.statusText}`
  };
}
function networkProblem(title10, cause3) {
  return {
    type: "network",
    title: title10,
    detail: `The server could not be reached: ${cause3.message}`
  };
}

// ../node_modules/neverthrow/dist/index.es.js
var defaultErrorConfig = {
  withStackTrace: false
};
var createNeverThrowError = (message4, result6, config2 = defaultErrorConfig) => {
  const data4 = result6.isOk() ? { type: "Ok", value: result6.value } : { type: "Err", value: result6.error };
  const maybeStack = config2.withStackTrace ? new Error().stack : void 0;
  return {
    data: data4,
    message: message4,
    stack: maybeStack
  };
};
function __awaiter2(thisArg, _arguments, P, generator3) {
  function adopt(value8) {
    return value8 instanceof P ? value8 : new P(function(resolve) {
      resolve(value8);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value8) {
      try {
        step4(generator3.next(value8));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value8) {
      try {
        step4(generator3["throw"](value8));
      } catch (e) {
        reject(e);
      }
    }
    function step4(result6) {
      result6.done ? resolve(result6.value) : adopt(result6.value).then(fulfilled, rejected);
    }
    step4((generator3 = generator3.apply(thisArg, _arguments || [])).next());
  });
}
function __values2(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function() {
      if (o && i >= o.length) o = void 0;
      return { value: o && o[i++], done: !o };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __await2(v2) {
  return this instanceof __await2 ? (this.v = v2, this) : new __await2(v2);
}
function __asyncGenerator2(thisArg, _arguments, generator3) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator3.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb2("next"), verb2("throw"), verb2("return", awaitReturn), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function awaitReturn(f) {
    return function(v2) {
      return Promise.resolve(v2).then(f, reject);
    };
  }
  function verb2(n3, f) {
    if (g[n3]) {
      i[n3] = function(v2) {
        return new Promise(function(a, b) {
          q.push([n3, v2, a, b]) > 1 || resume(n3, v2);
        });
      };
      if (f) i[n3] = f(i[n3]);
    }
  }
  function resume(n3, v2) {
    try {
      step4(g[n3](v2));
    } catch (e) {
      settle(q[0][3], e);
    }
  }
  function step4(r) {
    r.value instanceof __await2 ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
  }
  function fulfill(value8) {
    resume("next", value8);
  }
  function reject(value8) {
    resume("throw", value8);
  }
  function settle(f, v2) {
    if (f(v2), q.shift(), q.length) resume(q[0][0], q[0][1]);
  }
}
function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb2("next"), verb2("throw", function(e) {
    throw e;
  }), verb2("return"), i[Symbol.iterator] = function() {
    return this;
  }, i;
  function verb2(n3, f) {
    i[n3] = o[n3] ? function(v2) {
      return (p = !p) ? { value: __await2(o[n3](v2)), done: false } : f ? f(v2) : v2;
    } : f;
  }
}
function __asyncValues2(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values2 === "function" ? __values2(o) : o[Symbol.iterator](), i = {}, verb2("next"), verb2("throw"), verb2("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i);
  function verb2(n3) {
    i[n3] = o[n3] && function(v2) {
      return new Promise(function(resolve, reject) {
        v2 = o[n3](v2), settle(resolve, reject, v2.done, v2.value);
      });
    };
  }
  function settle(resolve, reject, d, v2) {
    Promise.resolve(v2).then(function(v3) {
      resolve({ value: v3, done: d });
    }, reject);
  }
}
var ResultAsync = class _ResultAsync {
  constructor(res) {
    this._promise = res;
  }
  static fromSafePromise(promise) {
    const newPromise = promise.then((value8) => new Ok(value8));
    return new _ResultAsync(newPromise);
  }
  static fromPromise(promise, errorFn) {
    const newPromise = promise.then((value8) => new Ok(value8)).catch((e) => new Err(errorFn(e)));
    return new _ResultAsync(newPromise);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static fromThrowable(fn2, errorFn) {
    return (...args) => {
      return new _ResultAsync((() => __awaiter2(this, void 0, void 0, function* () {
        try {
          return new Ok(yield fn2(...args));
        } catch (error4) {
          return new Err(errorFn ? errorFn(error4) : error4);
        }
      }))());
    };
  }
  static combine(asyncResultList) {
    return combineResultAsyncList(asyncResultList);
  }
  static combineWithAllErrors(asyncResultList) {
    return combineResultAsyncListWithAllErrors(asyncResultList);
  }
  map(f) {
    return new _ResultAsync(this._promise.then((res) => __awaiter2(this, void 0, void 0, function* () {
      if (res.isErr()) {
        return new Err(res.error);
      }
      return new Ok(yield f(res.value));
    })));
  }
  andThrough(f) {
    return new _ResultAsync(this._promise.then((res) => __awaiter2(this, void 0, void 0, function* () {
      if (res.isErr()) {
        return new Err(res.error);
      }
      const newRes = yield f(res.value);
      if (newRes.isErr()) {
        return new Err(newRes.error);
      }
      return new Ok(res.value);
    })));
  }
  andTee(f) {
    return new _ResultAsync(this._promise.then((res) => __awaiter2(this, void 0, void 0, function* () {
      if (res.isErr()) {
        return new Err(res.error);
      }
      try {
        yield f(res.value);
      } catch (e) {
      }
      return new Ok(res.value);
    })));
  }
  orTee(f) {
    return new _ResultAsync(this._promise.then((res) => __awaiter2(this, void 0, void 0, function* () {
      if (res.isOk()) {
        return new Ok(res.value);
      }
      try {
        yield f(res.error);
      } catch (e) {
      }
      return new Err(res.error);
    })));
  }
  mapErr(f) {
    return new _ResultAsync(this._promise.then((res) => __awaiter2(this, void 0, void 0, function* () {
      if (res.isOk()) {
        return new Ok(res.value);
      }
      return new Err(yield f(res.error));
    })));
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  andThen(f) {
    return new _ResultAsync(this._promise.then((res) => {
      if (res.isErr()) {
        return new Err(res.error);
      }
      const newValue = f(res.value);
      return newValue instanceof _ResultAsync ? newValue._promise : newValue;
    }));
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  orElse(f) {
    return new _ResultAsync(this._promise.then((res) => __awaiter2(this, void 0, void 0, function* () {
      if (res.isErr()) {
        return f(res.error);
      }
      return new Ok(res.value);
    })));
  }
  match(ok2, _err) {
    return this._promise.then((res) => res.match(ok2, _err));
  }
  unwrapOr(t) {
    return this._promise.then((res) => res.unwrapOr(t));
  }
  /**
   * @deprecated will be removed in 9.0.0.
   *
   * You can use `safeTry` without this method.
   * @example
   * ```typescript
   * safeTry(async function* () {
   *   const okValue = yield* yourResult
   * })
   * ```
   * Emulates Rust's `?` operator in `safeTry`'s body. See also `safeTry`.
   */
  safeUnwrap() {
    return __asyncGenerator2(this, arguments, function* safeUnwrap_1() {
      return yield __await2(yield __await2(yield* __asyncDelegator(__asyncValues2(yield __await2(this._promise.then((res) => res.safeUnwrap()))))));
    });
  }
  // Makes ResultAsync implement PromiseLike<Result>
  then(successCallback, failureCallback) {
    return this._promise.then(successCallback, failureCallback);
  }
  [Symbol.asyncIterator]() {
    return __asyncGenerator2(this, arguments, function* _a() {
      const result6 = yield __await2(this._promise);
      if (result6.isErr()) {
        yield yield __await2(errAsync(result6.error));
      }
      return yield __await2(result6.value);
    });
  }
};
function errAsync(err2) {
  return new ResultAsync(Promise.resolve(new Err(err2)));
}
var fromPromise2 = ResultAsync.fromPromise;
var fromSafePromise = ResultAsync.fromSafePromise;
var fromAsyncThrowable = ResultAsync.fromThrowable;
var combineResultList = (resultList) => {
  let acc = ok([]);
  for (const result6 of resultList) {
    if (result6.isErr()) {
      acc = err(result6.error);
      break;
    } else {
      acc.map((list) => list.push(result6.value));
    }
  }
  return acc;
};
var combineResultAsyncList = (asyncResultList) => ResultAsync.fromSafePromise(Promise.all(asyncResultList)).andThen(combineResultList);
var combineResultListWithAllErrors = (resultList) => {
  let acc = ok([]);
  for (const result6 of resultList) {
    if (result6.isErr() && acc.isErr()) {
      acc.error.push(result6.error);
    } else if (result6.isErr() && acc.isOk()) {
      acc = err([result6.error]);
    } else if (result6.isOk() && acc.isOk()) {
      acc.value.push(result6.value);
    }
  }
  return acc;
};
var combineResultAsyncListWithAllErrors = (asyncResultList) => ResultAsync.fromSafePromise(Promise.all(asyncResultList)).andThen(combineResultListWithAllErrors);
var Result;
(function(Result2) {
  function fromThrowable2(fn2, errorFn) {
    return (...args) => {
      try {
        const result6 = fn2(...args);
        return ok(result6);
      } catch (e) {
        return err(errorFn ? errorFn(e) : e);
      }
    };
  }
  Result2.fromThrowable = fromThrowable2;
  function combine(resultList) {
    return combineResultList(resultList);
  }
  Result2.combine = combine;
  function combineWithAllErrors(resultList) {
    return combineResultListWithAllErrors(resultList);
  }
  Result2.combineWithAllErrors = combineWithAllErrors;
})(Result || (Result = {}));
function ok(value8) {
  return new Ok(value8);
}
function err(err2) {
  return new Err(err2);
}
var Ok = class {
  constructor(value8) {
    this.value = value8;
  }
  isOk() {
    return true;
  }
  isErr() {
    return !this.isOk();
  }
  map(f) {
    return ok(f(this.value));
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  mapErr(_f) {
    return ok(this.value);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  andThen(f) {
    return f(this.value);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  andThrough(f) {
    return f(this.value).map((_value2) => this.value);
  }
  andTee(f) {
    try {
      f(this.value);
    } catch (e) {
    }
    return ok(this.value);
  }
  orTee(_f) {
    return ok(this.value);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  orElse(_f) {
    return ok(this.value);
  }
  asyncAndThen(f) {
    return f(this.value);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  asyncAndThrough(f) {
    return f(this.value).map(() => this.value);
  }
  asyncMap(f) {
    return ResultAsync.fromSafePromise(f(this.value));
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  unwrapOr(_v) {
    return this.value;
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  match(ok2, _err) {
    return ok2(this.value);
  }
  safeUnwrap() {
    const value8 = this.value;
    return (function* () {
      return value8;
    })();
  }
  _unsafeUnwrap(_) {
    return this.value;
  }
  _unsafeUnwrapErr(config2) {
    throw createNeverThrowError("Called `_unsafeUnwrapErr` on an Ok", this, config2);
  }
  // eslint-disable-next-line @typescript-eslint/no-this-alias, require-yield
  *[Symbol.iterator]() {
    return this.value;
  }
};
var Err = class {
  constructor(error4) {
    this.error = error4;
  }
  isOk() {
    return false;
  }
  isErr() {
    return !this.isOk();
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  map(_f) {
    return err(this.error);
  }
  mapErr(f) {
    return err(f(this.error));
  }
  andThrough(_f) {
    return err(this.error);
  }
  andTee(_f) {
    return err(this.error);
  }
  orTee(f) {
    try {
      f(this.error);
    } catch (e) {
    }
    return err(this.error);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  andThen(_f) {
    return err(this.error);
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  orElse(f) {
    return f(this.error);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  asyncAndThen(_f) {
    return errAsync(this.error);
  }
  asyncAndThrough(_f) {
    return errAsync(this.error);
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  asyncMap(_f) {
    return errAsync(this.error);
  }
  unwrapOr(v2) {
    return v2;
  }
  match(_ok, err2) {
    return err2(this.error);
  }
  safeUnwrap() {
    const error4 = this.error;
    return (function* () {
      yield err(error4);
      throw new Error("Do not use this generator out of `safeTry`");
    })();
  }
  _unsafeUnwrap(config2) {
    throw createNeverThrowError("Called `_unsafeUnwrap` on an Err", this, config2);
  }
  _unsafeUnwrapErr(_) {
    return this.error;
  }
  *[Symbol.iterator]() {
    const self2 = this;
    yield self2;
    return self2;
  }
};
var fromThrowable = Result.fromThrowable;

// ../node_modules/mime/dist/types/standard.js
var types = {
  "application/andrew-inset": ["ez"],
  "application/appinstaller": ["appinstaller"],
  "application/applixware": ["aw"],
  "application/appx": ["appx"],
  "application/appxbundle": ["appxbundle"],
  "application/atom+xml": ["atom"],
  "application/atomcat+xml": ["atomcat"],
  "application/atomdeleted+xml": ["atomdeleted"],
  "application/atomsvc+xml": ["atomsvc"],
  "application/atsc-dwd+xml": ["dwd"],
  "application/atsc-held+xml": ["held"],
  "application/atsc-rsat+xml": ["rsat"],
  "application/automationml-aml+xml": ["aml"],
  "application/automationml-amlx+zip": ["amlx"],
  "application/bdoc": ["bdoc"],
  "application/calendar+xml": ["xcs"],
  "application/ccxml+xml": ["ccxml"],
  "application/cdfx+xml": ["cdfx"],
  "application/cdmi-capability": ["cdmia"],
  "application/cdmi-container": ["cdmic"],
  "application/cdmi-domain": ["cdmid"],
  "application/cdmi-object": ["cdmio"],
  "application/cdmi-queue": ["cdmiq"],
  "application/cpl+xml": ["cpl"],
  "application/cu-seeme": ["cu"],
  "application/cwl": ["cwl"],
  "application/dash+xml": ["mpd"],
  "application/dash-patch+xml": ["mpp"],
  "application/davmount+xml": ["davmount"],
  "application/dicom": ["dcm"],
  "application/docbook+xml": ["dbk"],
  "application/dssc+der": ["dssc"],
  "application/dssc+xml": ["xdssc"],
  "application/ecmascript": ["ecma"],
  "application/emma+xml": ["emma"],
  "application/emotionml+xml": ["emotionml"],
  "application/epub+zip": ["epub"],
  "application/exi": ["exi"],
  "application/express": ["exp"],
  "application/fdf": ["fdf"],
  "application/fdt+xml": ["fdt"],
  "application/font-tdpfr": ["pfr"],
  "application/geo+json": ["geojson"],
  "application/gml+xml": ["gml"],
  "application/gpx+xml": ["gpx"],
  "application/gxf": ["gxf"],
  "application/gzip": ["gz"],
  "application/hjson": ["hjson"],
  "application/hyperstudio": ["stk"],
  "application/inkml+xml": ["ink", "inkml"],
  "application/ipfix": ["ipfix"],
  "application/its+xml": ["its"],
  "application/java-archive": ["jar", "war", "ear"],
  "application/java-serialized-object": ["ser"],
  "application/java-vm": ["class"],
  "application/javascript": ["*js"],
  "application/json": ["json", "map"],
  "application/json5": ["json5"],
  "application/jsonml+json": ["jsonml"],
  "application/ld+json": ["jsonld"],
  "application/lgr+xml": ["lgr"],
  "application/lost+xml": ["lostxml"],
  "application/mac-binhex40": ["hqx"],
  "application/mac-compactpro": ["cpt"],
  "application/mads+xml": ["mads"],
  "application/manifest+json": ["webmanifest"],
  "application/marc": ["mrc"],
  "application/marcxml+xml": ["mrcx"],
  "application/mathematica": ["ma", "nb", "mb"],
  "application/mathml+xml": ["mathml"],
  "application/mbox": ["mbox"],
  "application/media-policy-dataset+xml": ["mpf"],
  "application/mediaservercontrol+xml": ["mscml"],
  "application/metalink+xml": ["metalink"],
  "application/metalink4+xml": ["meta4"],
  "application/mets+xml": ["mets"],
  "application/mmt-aei+xml": ["maei"],
  "application/mmt-usd+xml": ["musd"],
  "application/mods+xml": ["mods"],
  "application/mp21": ["m21", "mp21"],
  "application/mp4": ["*mp4", "*mpg4", "mp4s", "m4p"],
  "application/msix": ["msix"],
  "application/msixbundle": ["msixbundle"],
  "application/msword": ["doc", "dot"],
  "application/mxf": ["mxf"],
  "application/n-quads": ["nq"],
  "application/n-triples": ["nt"],
  "application/node": ["cjs"],
  "application/octet-stream": [
    "bin",
    "dms",
    "lrf",
    "mar",
    "so",
    "dist",
    "distz",
    "pkg",
    "bpk",
    "dump",
    "elc",
    "deploy",
    "exe",
    "dll",
    "deb",
    "dmg",
    "iso",
    "img",
    "msi",
    "msp",
    "msm",
    "buffer"
  ],
  "application/oda": ["oda"],
  "application/oebps-package+xml": ["opf"],
  "application/ogg": ["ogx"],
  "application/omdoc+xml": ["omdoc"],
  "application/onenote": [
    "onetoc",
    "onetoc2",
    "onetmp",
    "onepkg",
    "one",
    "onea"
  ],
  "application/oxps": ["oxps"],
  "application/p2p-overlay+xml": ["relo"],
  "application/patch-ops-error+xml": ["xer"],
  "application/pdf": ["pdf"],
  "application/pgp-encrypted": ["pgp"],
  "application/pgp-keys": ["asc"],
  "application/pgp-signature": ["sig", "*asc"],
  "application/pics-rules": ["prf"],
  "application/pkcs10": ["p10"],
  "application/pkcs7-mime": ["p7m", "p7c"],
  "application/pkcs7-signature": ["p7s"],
  "application/pkcs8": ["p8"],
  "application/pkix-attr-cert": ["ac"],
  "application/pkix-cert": ["cer"],
  "application/pkix-crl": ["crl"],
  "application/pkix-pkipath": ["pkipath"],
  "application/pkixcmp": ["pki"],
  "application/pls+xml": ["pls"],
  "application/postscript": ["ai", "eps", "ps"],
  "application/provenance+xml": ["provx"],
  "application/pskc+xml": ["pskcxml"],
  "application/raml+yaml": ["raml"],
  "application/rdf+xml": ["rdf", "owl"],
  "application/reginfo+xml": ["rif"],
  "application/relax-ng-compact-syntax": ["rnc"],
  "application/resource-lists+xml": ["rl"],
  "application/resource-lists-diff+xml": ["rld"],
  "application/rls-services+xml": ["rs"],
  "application/route-apd+xml": ["rapd"],
  "application/route-s-tsid+xml": ["sls"],
  "application/route-usd+xml": ["rusd"],
  "application/rpki-ghostbusters": ["gbr"],
  "application/rpki-manifest": ["mft"],
  "application/rpki-roa": ["roa"],
  "application/rsd+xml": ["rsd"],
  "application/rss+xml": ["rss"],
  "application/rtf": ["rtf"],
  "application/sbml+xml": ["sbml"],
  "application/scvp-cv-request": ["scq"],
  "application/scvp-cv-response": ["scs"],
  "application/scvp-vp-request": ["spq"],
  "application/scvp-vp-response": ["spp"],
  "application/sdp": ["sdp"],
  "application/senml+xml": ["senmlx"],
  "application/sensml+xml": ["sensmlx"],
  "application/set-payment-initiation": ["setpay"],
  "application/set-registration-initiation": ["setreg"],
  "application/shf+xml": ["shf"],
  "application/sieve": ["siv", "sieve"],
  "application/smil+xml": ["smi", "smil"],
  "application/sparql-query": ["rq"],
  "application/sparql-results+xml": ["srx"],
  "application/sql": ["sql"],
  "application/srgs": ["gram"],
  "application/srgs+xml": ["grxml"],
  "application/sru+xml": ["sru"],
  "application/ssdl+xml": ["ssdl"],
  "application/ssml+xml": ["ssml"],
  "application/swid+xml": ["swidtag"],
  "application/tei+xml": ["tei", "teicorpus"],
  "application/thraud+xml": ["tfi"],
  "application/timestamped-data": ["tsd"],
  "application/toml": ["toml"],
  "application/trig": ["trig"],
  "application/ttml+xml": ["ttml"],
  "application/ubjson": ["ubj"],
  "application/urc-ressheet+xml": ["rsheet"],
  "application/urc-targetdesc+xml": ["td"],
  "application/voicexml+xml": ["vxml"],
  "application/wasm": ["wasm"],
  "application/watcherinfo+xml": ["wif"],
  "application/widget": ["wgt"],
  "application/winhlp": ["hlp"],
  "application/wsdl+xml": ["wsdl"],
  "application/wspolicy+xml": ["wspolicy"],
  "application/xaml+xml": ["xaml"],
  "application/xcap-att+xml": ["xav"],
  "application/xcap-caps+xml": ["xca"],
  "application/xcap-diff+xml": ["xdf"],
  "application/xcap-el+xml": ["xel"],
  "application/xcap-ns+xml": ["xns"],
  "application/xenc+xml": ["xenc"],
  "application/xfdf": ["xfdf"],
  "application/xhtml+xml": ["xhtml", "xht"],
  "application/xliff+xml": ["xlf"],
  "application/xml": ["xml", "xsl", "xsd", "rng"],
  "application/xml-dtd": ["dtd"],
  "application/xop+xml": ["xop"],
  "application/xproc+xml": ["xpl"],
  "application/xslt+xml": ["*xsl", "xslt"],
  "application/xspf+xml": ["xspf"],
  "application/xv+xml": ["mxml", "xhvml", "xvml", "xvm"],
  "application/yang": ["yang"],
  "application/yin+xml": ["yin"],
  "application/zip": ["zip"],
  "application/zip+dotlottie": ["lottie"],
  "audio/3gpp": ["*3gpp"],
  "audio/aac": ["adts", "aac"],
  "audio/adpcm": ["adp"],
  "audio/amr": ["amr"],
  "audio/basic": ["au", "snd"],
  "audio/midi": ["mid", "midi", "kar", "rmi"],
  "audio/mobile-xmf": ["mxmf"],
  "audio/mp3": ["*mp3"],
  "audio/mp4": ["m4a", "mp4a", "m4b"],
  "audio/mpeg": ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"],
  "audio/ogg": ["oga", "ogg", "spx", "opus"],
  "audio/s3m": ["s3m"],
  "audio/silk": ["sil"],
  "audio/wav": ["wav"],
  "audio/wave": ["*wav"],
  "audio/webm": ["weba"],
  "audio/xm": ["xm"],
  "font/collection": ["ttc"],
  "font/otf": ["otf"],
  "font/ttf": ["ttf"],
  "font/woff": ["woff"],
  "font/woff2": ["woff2"],
  "image/aces": ["exr"],
  "image/apng": ["apng"],
  "image/avci": ["avci"],
  "image/avcs": ["avcs"],
  "image/avif": ["avif"],
  "image/bmp": ["bmp", "dib"],
  "image/cgm": ["cgm"],
  "image/dicom-rle": ["drle"],
  "image/dpx": ["dpx"],
  "image/emf": ["emf"],
  "image/fits": ["fits"],
  "image/g3fax": ["g3"],
  "image/gif": ["gif"],
  "image/heic": ["heic"],
  "image/heic-sequence": ["heics"],
  "image/heif": ["heif"],
  "image/heif-sequence": ["heifs"],
  "image/hej2k": ["hej2"],
  "image/ief": ["ief"],
  "image/jaii": ["jaii"],
  "image/jais": ["jais"],
  "image/jls": ["jls"],
  "image/jp2": ["jp2", "jpg2"],
  "image/jpeg": ["jpg", "jpeg", "jpe"],
  "image/jph": ["jph"],
  "image/jphc": ["jhc"],
  "image/jpm": ["jpm", "jpgm"],
  "image/jpx": ["jpx", "jpf"],
  "image/jxl": ["jxl"],
  "image/jxr": ["jxr"],
  "image/jxra": ["jxra"],
  "image/jxrs": ["jxrs"],
  "image/jxs": ["jxs"],
  "image/jxsc": ["jxsc"],
  "image/jxsi": ["jxsi"],
  "image/jxss": ["jxss"],
  "image/ktx": ["ktx"],
  "image/ktx2": ["ktx2"],
  "image/pjpeg": ["jfif"],
  "image/png": ["png"],
  "image/sgi": ["sgi"],
  "image/svg+xml": ["svg", "svgz"],
  "image/t38": ["t38"],
  "image/tiff": ["tif", "tiff"],
  "image/tiff-fx": ["tfx"],
  "image/webp": ["webp"],
  "image/wmf": ["wmf"],
  "message/disposition-notification": ["disposition-notification"],
  "message/global": ["u8msg"],
  "message/global-delivery-status": ["u8dsn"],
  "message/global-disposition-notification": ["u8mdn"],
  "message/global-headers": ["u8hdr"],
  "message/rfc822": ["eml", "mime", "mht", "mhtml"],
  "model/3mf": ["3mf"],
  "model/gltf+json": ["gltf"],
  "model/gltf-binary": ["glb"],
  "model/iges": ["igs", "iges"],
  "model/jt": ["jt"],
  "model/mesh": ["msh", "mesh", "silo"],
  "model/mtl": ["mtl"],
  "model/obj": ["obj"],
  "model/prc": ["prc"],
  "model/step": ["step", "stp", "stpnc", "p21", "210"],
  "model/step+xml": ["stpx"],
  "model/step+zip": ["stpz"],
  "model/step-xml+zip": ["stpxz"],
  "model/stl": ["stl"],
  "model/u3d": ["u3d"],
  "model/vrml": ["wrl", "vrml"],
  "model/x3d+binary": ["*x3db", "x3dbz"],
  "model/x3d+fastinfoset": ["x3db"],
  "model/x3d+vrml": ["*x3dv", "x3dvz"],
  "model/x3d+xml": ["x3d", "x3dz"],
  "model/x3d-vrml": ["x3dv"],
  "text/cache-manifest": ["appcache", "manifest"],
  "text/calendar": ["ics", "ifb"],
  "text/coffeescript": ["coffee", "litcoffee"],
  "text/css": ["css"],
  "text/csv": ["csv"],
  "text/html": ["html", "htm", "shtml"],
  "text/jade": ["jade"],
  "text/javascript": ["js", "mjs"],
  "text/jsx": ["jsx"],
  "text/less": ["less"],
  "text/markdown": ["md", "markdown"],
  "text/mathml": ["mml"],
  "text/mdx": ["mdx"],
  "text/n3": ["n3"],
  "text/plain": ["txt", "text", "conf", "def", "list", "log", "in", "ini"],
  "text/richtext": ["rtx"],
  "text/rtf": ["*rtf"],
  "text/sgml": ["sgml", "sgm"],
  "text/shex": ["shex"],
  "text/slim": ["slim", "slm"],
  "text/spdx": ["spdx"],
  "text/stylus": ["stylus", "styl"],
  "text/tab-separated-values": ["tsv"],
  "text/troff": ["t", "tr", "roff", "man", "me", "ms"],
  "text/turtle": ["ttl"],
  "text/uri-list": ["uri", "uris", "urls"],
  "text/vcard": ["vcard"],
  "text/vtt": ["vtt"],
  "text/wgsl": ["wgsl"],
  "text/xml": ["*xml"],
  "text/yaml": ["yaml", "yml"],
  "video/3gpp": ["3gp", "3gpp"],
  "video/3gpp2": ["3g2"],
  "video/h261": ["h261"],
  "video/h263": ["h263"],
  "video/h264": ["h264"],
  "video/iso.segment": ["m4s"],
  "video/jpeg": ["jpgv"],
  "video/jpm": ["*jpm", "*jpgm"],
  "video/mj2": ["mj2", "mjp2"],
  "video/mp2t": ["ts", "m2t", "m2ts", "mts"],
  "video/mp4": ["mp4", "mp4v", "mpg4"],
  "video/mpeg": ["mpeg", "mpg", "mpe", "m1v", "m2v"],
  "video/ogg": ["ogv"],
  "video/quicktime": ["qt", "mov"],
  "video/webm": ["webm"]
};
Object.freeze(types);
var standard_default = types;

// ../node_modules/mime/dist/src/Mime.js
var __classPrivateFieldGet = function(receiver2, state2, kind2, f) {
  if (kind2 === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state2 === "function" ? receiver2 !== state2 || !f : !state2.has(receiver2)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind2 === "m" ? f : kind2 === "a" ? f.call(receiver2) : f ? f.value : state2.get(receiver2);
};
var _Mime_extensionToType;
var _Mime_typeToExtension;
var _Mime_typeToExtensions;
var Mime = class {
  constructor(...args) {
    _Mime_extensionToType.set(this, /* @__PURE__ */ new Map());
    _Mime_typeToExtension.set(this, /* @__PURE__ */ new Map());
    _Mime_typeToExtensions.set(this, /* @__PURE__ */ new Map());
    for (const arg2 of args) {
      this.define(arg2);
    }
  }
  define(typeMap, force = false) {
    for (let [type5, extensions] of Object.entries(typeMap)) {
      type5 = type5.toLowerCase();
      extensions = extensions.map((ext) => ext.toLowerCase());
      if (!__classPrivateFieldGet(this, _Mime_typeToExtensions, "f").has(type5)) {
        __classPrivateFieldGet(this, _Mime_typeToExtensions, "f").set(type5, /* @__PURE__ */ new Set());
      }
      const allExtensions = __classPrivateFieldGet(this, _Mime_typeToExtensions, "f").get(type5);
      let first4 = true;
      for (let extension3 of extensions) {
        const starred = extension3.startsWith("*");
        extension3 = starred ? extension3.slice(1) : extension3;
        allExtensions?.add(extension3);
        if (first4) {
          __classPrivateFieldGet(this, _Mime_typeToExtension, "f").set(type5, extension3);
        }
        first4 = false;
        if (starred)
          continue;
        const currentType = __classPrivateFieldGet(this, _Mime_extensionToType, "f").get(extension3);
        if (currentType && currentType != type5 && !force) {
          throw new Error(`"${type5} -> ${extension3}" conflicts with "${currentType} -> ${extension3}". Pass \`force=true\` to override this definition.`);
        }
        __classPrivateFieldGet(this, _Mime_extensionToType, "f").set(extension3, type5);
      }
    }
    return this;
  }
  getType(path3) {
    if (typeof path3 !== "string")
      return null;
    const last4 = path3.replace(/^.*[/\\]/s, "").toLowerCase();
    const ext = last4.replace(/^.*\./s, "").toLowerCase();
    const hasPath = last4.length < path3.length;
    const hasDot = ext.length < last4.length - 1;
    if (!hasDot && hasPath)
      return null;
    return __classPrivateFieldGet(this, _Mime_extensionToType, "f").get(ext) ?? null;
  }
  getExtension(type5) {
    if (typeof type5 !== "string")
      return null;
    type5 = type5?.split?.(";")[0];
    return (type5 && __classPrivateFieldGet(this, _Mime_typeToExtension, "f").get(type5.trim().toLowerCase())) ?? null;
  }
  getAllExtensions(type5) {
    if (typeof type5 !== "string")
      return null;
    return __classPrivateFieldGet(this, _Mime_typeToExtensions, "f").get(type5.toLowerCase()) ?? null;
  }
  _freeze() {
    this.define = () => {
      throw new Error("define() not allowed for built-in Mime objects. See https://github.com/broofa/mime/blob/main/README.md#custom-mime-instances");
    };
    Object.freeze(this);
    for (const extensions of __classPrivateFieldGet(this, _Mime_typeToExtensions, "f").values()) {
      Object.freeze(extensions);
    }
    return this;
  }
  _getTestState() {
    return {
      types: __classPrivateFieldGet(this, _Mime_extensionToType, "f"),
      extensions: __classPrivateFieldGet(this, _Mime_typeToExtension, "f")
    };
  }
};
_Mime_extensionToType = /* @__PURE__ */ new WeakMap(), _Mime_typeToExtension = /* @__PURE__ */ new WeakMap(), _Mime_typeToExtensions = /* @__PURE__ */ new WeakMap();
var Mime_default = Mime;

// ../node_modules/mime/dist/src/index_lite.js
var index_lite_default = new Mime_default(standard_default)._freeze();

// src/files/FileFetcher.ts
var FileFetcher = class {
  constructor(session4) {
    this.session = session4;
  }
  /**
   * Fetch the contents of the given file
   * @param {string} url - URL identifying the file
   * @returns {Promise<SolidFile>} An object representing the fetched file
   */
  async fetchFile(url7) {
    const response6 = await this.session.authenticatedFetch(url7);
    if (response6.ok) {
      const blob = await response6.blob();
      return new BinaryFile(url7, blob);
    } else {
      return new BrokenFile(
        url7,
        new HttpStatus(response6.status, response6.statusText)
      );
    }
  }
  /**
   * Updates the contents of a file (overrides old content with the given one)
   * @param file - The file to update
   * @param newContent - The content to put into the file, overriding all existing
   * @returns {Promise<Response>} The HTTP response
   */
  async putFile(file2, newContent) {
    return await this.session.authenticatedFetch(file2.url, {
      method: "PUT",
      headers: {
        "Content-Type": file2.blob()?.type ?? "text/plain"
      },
      body: newContent
    });
  }
  createNewFile(container2, name9) {
    const isFile = name9 instanceof File;
    const fileName = isFile ? name9.name : name9;
    const encodedName = encodeURIComponent(fileName);
    const url7 = container2.uri + encodedName;
    const contentTypeHeader = isFile ? name9.type : index_lite_default.getType(encodedName) ?? "text/turtle";
    const body = isFile ? name9 : void 0;
    return ResultAsync.fromPromise(
      this.session.authenticatedFetch(url7, {
        method: "PUT",
        headers: {
          "Content-Type": contentTypeHeader,
          "If-None-Match": "*"
        },
        body
      }),
      (e) => networkProblem("The file could not be created", e)
    ).andThen(
      (response6) => response6.ok ? ok({
        url: url7,
        name: fileName,
        contentType: contentTypeHeader
      }) : err(httpProblem("The file could not be created", response6))
    );
  }
  createNewFolder(container2, name9) {
    const encodedName = encodeURIComponent(name9);
    const url7 = container2.uri + encodedName + "/";
    return ResultAsync.fromPromise(
      this.session.authenticatedFetch(url7, {
        method: "PUT"
      }),
      (e) => networkProblem("The folder could not be created", e)
    ).andThen(
      (response6) => response6.ok ? ok({
        url: url7,
        name: name9
      }) : err(httpProblem("The folder could not be created", response6))
    );
  }
};

// ../node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}

// ../node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

// ../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

// ../node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: true,
    configurable: true,
    writable: true
  }) : e[r] = t, e;
}

// node_modules/rdflib/esm/class-order.js
var ClassOrder = {
  "Literal": 1,
  "Collection": 3,
  "Graph": 4,
  "NamedNode": 5,
  "BlankNode": 6,
  "Variable": 7
};
var class_order_default = ClassOrder;

// node_modules/rdflib/esm/node-internal.js
var Node2 = class {
  constructor(value8) {
    _defineProperty(this, "termType", void 0);
    _defineProperty(this, "classOrder", void 0);
    _defineProperty(this, "value", void 0);
    this.value = value8;
  }
  /**
   * Creates the substituted node for this one, according to the specified bindings
   * @param bindings - Bindings of identifiers to nodes
   */
  substitute(bindings) {
    return this;
  }
  /**
   * Compares this node with another
   * @see {equals} to check if two nodes are equal
   * @param other - The other node
   */
  compareTerm(other2) {
    if (this.classOrder < other2.classOrder) {
      return -1;
    }
    if (this.classOrder > other2.classOrder) {
      return 1;
    }
    if (this.value < other2.value) {
      return -1;
    }
    if (this.value > other2.value) {
      return 1;
    }
    return 0;
  }
  /**
   * Compares whether the two nodes are equal
   * @param other The other node
   */
  equals(other2) {
    if (!other2) {
      return false;
    }
    return this.termType === other2.termType && this.value === other2.value;
  }
  /**
   * Creates a hash for this node
   * @deprecated use {rdfFactory.id} instead if possible
   */
  hashString() {
    return this.toCanonical();
  }
  /**
   * Compares whether this node is the same as the other one
   * @param other - Another node
   */
  sameTerm(other2) {
    return this.equals(other2);
  }
  /**
   * Creates a canonical string representation of this node
   */
  toCanonical() {
    return this.toNT();
  }
  /**
   * Creates a n-triples string representation of this node
   */
  toNT() {
    return this.toString();
  }
  /**
   * Creates a n-quads string representation of this node
   */
  toNQ() {
    return this.toNT();
  }
  /**
   * Creates a string representation of this node
   */
  toString() {
    throw new Error("Node.toString() is abstract - see the subclasses instead");
  }
};
_defineProperty(Node2, "fromValue", void 0);
_defineProperty(Node2, "toJS", void 0);

// node_modules/rdflib/esm/types.js
var NamedNodeTermType = "NamedNode";
var BlankNodeTermType = "BlankNode";
var LiteralTermType = "Literal";
var VariableTermType = "Variable";
var DefaultGraphTermType = "DefaultGraph";
var CollectionTermType = "Collection";
var EmptyTermType = "Empty";
var GraphTermType = "Graph";
var HTMLContentType = "text/html";
var JSONLDContentType = "application/ld+json";
var N3ContentType = "text/n3";
var N3LegacyContentType = "application/n3";
var NQuadsAltContentType = "application/nquads";
var NQuadsContentType = "application/n-quads";
var NTriplesContentType = "application/n-triples";
var RDFXMLContentType = "application/rdf+xml";
var SPARQLUpdateContentType = "application/sparql-update";
var SPARQLUpdateSingleMatchContentType = "application/sparql-update-single-match";
var TurtleContentType = "text/turtle";
var TurtleLegacyContentType = "application/x-turtle";
var XHTMLContentType = "application/xhtml+xml";

// node_modules/rdflib/esm/blank-node.js
var BlankNode = class _BlankNode extends Node2 {
  static getId(id4) {
    if (id4) {
      if (typeof id4 !== "string") {
        throw new Error("Bad id argument to new blank node: " + id4);
      }
      if (id4.includes("#")) {
        let fragments = id4.split("#");
        return fragments[fragments.length - 1];
      }
      return id4;
    }
    return "n" + _BlankNode.nextId++;
  }
  /**
   * Initializes this node
   * @param [id] The identifier for the blank node
   */
  constructor(id4) {
    super(_BlankNode.getId(id4));
    _defineProperty(this, "termType", BlankNodeTermType);
    _defineProperty(this, "classOrder", class_order_default.BlankNode);
    _defineProperty(this, "isBlank", 1);
    _defineProperty(this, "isVar", 1);
  }
  /**
   * The identifier for the blank node
   */
  get id() {
    return this.value;
  }
  set id(value8) {
    this.value = value8;
  }
  compareTerm(other2) {
    if (this.classOrder < other2.classOrder) {
      return -1;
    }
    if (this.classOrder > other2.classOrder) {
      return 1;
    }
    if (this.id < other2.id) {
      return -1;
    }
    if (this.id > other2.id) {
      return 1;
    }
    return 0;
  }
  /**
   * Gets a copy of this blank node in the specified formula
   * @param formula The formula
   */
  copy(formula2) {
    var bnodeNew = new _BlankNode();
    formula2.copyTo(this, bnodeNew);
    return bnodeNew;
  }
  toCanonical() {
    return _BlankNode.NTAnonymousNodePrefix + this.value;
  }
  toString() {
    return _BlankNode.NTAnonymousNodePrefix + this.id;
  }
};
_defineProperty(BlankNode, "nextId", 0);
_defineProperty(BlankNode, "NTAnonymousNodePrefix", "_:");

// node_modules/rdflib/esm/utils/termValue.js
function termValue(node3) {
  if (typeof node3 === "string") {
    return node3;
  }
  return node3.value;
}

// node_modules/rdflib/esm/utils/terms.js
function isStatement(obj) {
  return typeof obj === "object" && obj !== null && "subject" in obj;
}
function isStore(obj) {
  return typeof obj === "object" && obj !== null && "statements" in obj;
}
function isCollection(obj) {
  return isTerm(obj) && obj.termType === CollectionTermType;
}
function isRDFlibObject(obj) {
  return obj && Object.prototype.hasOwnProperty.call(obj, "termType") && (obj.termType === NamedNodeTermType || obj.termType === VariableTermType || obj.termType === BlankNodeTermType || obj.termType === CollectionTermType || obj.termType === LiteralTermType || obj.termType === GraphTermType);
}
function isRDFlibSubject(obj) {
  return obj && Object.prototype.hasOwnProperty.call(obj, "termType") && (obj.termType === NamedNodeTermType || obj.termType === VariableTermType || obj.termType === BlankNodeTermType || obj.termType === CollectionTermType || obj.termType === LiteralTermType || obj.termType === GraphTermType);
}
function isRDFlibPredicate(obj) {
  return isTerm(obj) && (obj.termType === NamedNodeTermType || obj.termType === BlankNodeTermType || obj.termType === VariableTermType);
}
function isVariable(obj) {
  return isTerm(obj) && obj.termType === VariableTermType;
}
function isTerm(obj) {
  return typeof obj === "object" && obj !== null && "termType" in obj;
}
function isLiteral(value8) {
  return value8.termType === LiteralTermType;
}
function isQuad(obj) {
  return typeof obj === "object" && obj !== null && "subject" in obj && "predicate" in obj && "object" in obj;
}
function isNamedNode(obj) {
  return isTerm(obj) && obj.termType === "NamedNode";
}
function isBlankNode(obj) {
  return isTerm(obj) && "termType" in obj && obj.termType === "BlankNode";
}
function isGraph(obj) {
  return isTerm(obj) && (obj.termType === NamedNodeTermType || obj.termType === VariableTermType || obj.termType === BlankNodeTermType || obj.termType === DefaultGraphTermType);
}

// node_modules/rdflib/esm/named-node.js
var NamedNode = class _NamedNode extends Node2 {
  /**
   * Create a named (IRI) RDF Node
   * @constructor
   * @param iri - The IRI for this node
   */
  constructor(iri) {
    super(termValue(iri));
    _defineProperty(this, "termType", NamedNodeTermType);
    _defineProperty(this, "classOrder", class_order_default.NamedNode);
    if (!this.value) {
      throw new Error("Missing IRI for NamedNode");
    }
    if (!this.value.includes(":")) {
      throw new Error('NamedNode IRI "' + iri + '" must be absolute.');
    }
    if (this.value.includes(" ")) {
      var message4 = 'Error: NamedNode IRI "' + iri + '" must not contain unencoded spaces.';
      throw new Error(message4);
    }
  }
  /**
   * Returns an $rdf node for the containing directory, ending in slash.
   */
  dir() {
    var str = this.value.split("#")[0];
    var p = str.slice(0, -1).lastIndexOf("/");
    var q = str.indexOf("//");
    if (q >= 0 && p < q + 2 || p < 0) return null;
    return new _NamedNode(str.slice(0, p + 1));
  }
  /**
   * Returns an NN for the whole web site, ending in slash.
   * Contrast with the "origin" which does NOT have a trailing slash
   */
  site() {
    var str = this.value.split("#")[0];
    var p = str.indexOf("//");
    if (p < 0) throw new Error("This URI does not have a web site part (origin)");
    var q = str.indexOf("/", p + 2);
    if (q < 0) {
      return new _NamedNode(str.slice(0) + "/");
    } else {
      return new _NamedNode(str.slice(0, q + 1));
    }
  }
  /**
   * Creates the fetchable named node for the document.
   * Removes everything from the # anchor tag.
   */
  doc() {
    if (this.value.indexOf("#") < 0) {
      return this;
    } else {
      return new _NamedNode(this.value.split("#")[0]);
    }
  }
  /**
   * Returns the URI including <brackets>
   */
  toString() {
    return "<" + this.value + ">";
  }
  /** The local identifier with the document */
  id() {
    return this.value.split("#")[1];
  }
  /** Alias for value, favored by Tim */
  get uri() {
    return this.value;
  }
  set uri(uri6) {
    this.value = uri6;
  }
  /**
   * Creates a named node from the specified input value
   * @param value - An input value
   */
  static fromValue(value8) {
    if (typeof value8 === "undefined" || value8 === null) {
      return value8;
    }
    if (isTerm(value8)) {
      return value8;
    }
    return new _NamedNode(value8);
  }
};

// node_modules/rdflib/esm/xsd-internal.js
var xsd_internal_default = {
  boolean: new NamedNode("http://www.w3.org/2001/XMLSchema#boolean"),
  dateTime: new NamedNode("http://www.w3.org/2001/XMLSchema#dateTime"),
  decimal: new NamedNode("http://www.w3.org/2001/XMLSchema#decimal"),
  double: new NamedNode("http://www.w3.org/2001/XMLSchema#double"),
  integer: new NamedNode("http://www.w3.org/2001/XMLSchema#integer"),
  langString: new NamedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString"),
  string: new NamedNode("http://www.w3.org/2001/XMLSchema#string")
};

// node_modules/rdflib/esm/literal.js
var Literal = class _Literal extends Node2 {
  /**
   * Initializes a literal
   * @param value - The literal's lexical value
   * @param language - The language for the literal. Defaults to ''.
   * @param datatype - The literal's datatype as a named node. Defaults to xsd:string.
   */
  constructor(value8, language9, datatype3) {
    super(value8);
    _defineProperty(this, "termType", LiteralTermType);
    _defineProperty(this, "classOrder", class_order_default.Literal);
    _defineProperty(this, "datatype", xsd_internal_default.string);
    _defineProperty(this, "isVar", 0);
    _defineProperty(this, "language", "");
    if (language9) {
      this.language = language9;
      this.datatype = xsd_internal_default.langString;
    } else if (datatype3) {
      this.datatype = NamedNode.fromValue(datatype3);
    } else {
      this.datatype = xsd_internal_default.string;
    }
  }
  /**
   * Gets a copy of this literal
   */
  copy() {
    return new _Literal(this.value, this.lang, this.datatype);
  }
  /**
   * Gets whether two literals are the same
   * @param other The other statement
   */
  equals(other2) {
    if (!other2) {
      return false;
    }
    return this.termType === other2.termType && this.value === other2.value && this.language === other2.language && (!this.datatype && !other2.datatype || this.datatype && this.datatype.equals(other2.datatype));
  }
  /**
   * The language for the literal
   * @deprecated use {language} instead
   */
  get lang() {
    return this.language;
  }
  set lang(language9) {
    this.language = language9 || "";
  }
  toNT() {
    return _Literal.toNT(this);
  }
  /** Serializes a literal to an N-Triples string */
  static toNT(literal4) {
    if (typeof literal4.value === "number") {
      return "" + literal4.value;
    } else if (typeof literal4.value !== "string") {
      throw new Error("Value of RDF literal is not string or number: " + literal4.value);
    }
    var str = literal4.value;
    str = str.replace(/\\/g, "\\\\");
    str = str.replace(/\"/g, '\\"');
    str = str.replace(/\n/g, "\\n");
    str = str.replace(/\r/g, "\\r");
    str = '"' + str + '"';
    if (literal4.language) {
      str += "@" + literal4.language;
    } else if (!literal4.datatype.equals(xsd_internal_default.string)) {
      str += "^^" + literal4.datatype.toCanonical();
    }
    return str;
  }
  toString() {
    return "" + this.value;
  }
  /**
   * Builds a literal node from a boolean value
   * @param value - The value
   */
  static fromBoolean(value8) {
    let strValue = value8 ? "1" : "0";
    return new _Literal(strValue, null, xsd_internal_default.boolean);
  }
  /**
   * Builds a literal node from a date value
   * @param value The value
   */
  static fromDate(value8) {
    if (!(value8 instanceof Date)) {
      throw new TypeError("Invalid argument to Literal.fromDate()");
    }
    let d2 = function(x) {
      return ("" + (100 + x)).slice(1, 3);
    };
    let date6 = "" + value8.getUTCFullYear() + "-" + d2(value8.getUTCMonth() + 1) + "-" + d2(value8.getUTCDate()) + "T" + d2(value8.getUTCHours()) + ":" + d2(value8.getUTCMinutes()) + ":" + d2(value8.getUTCSeconds()) + "Z";
    return new _Literal(date6, null, xsd_internal_default.dateTime);
  }
  /**
   * Builds a literal node from a number value
   * @param value - The value
   */
  static fromNumber(value8) {
    if (typeof value8 !== "number") {
      throw new TypeError("Invalid argument to Literal.fromNumber()");
    }
    let datatype3;
    const strValue = value8.toString();
    if (strValue.indexOf("e") < 0 && Math.abs(value8) <= Number.MAX_SAFE_INTEGER) {
      datatype3 = Number.isInteger(value8) ? xsd_internal_default.integer : xsd_internal_default.decimal;
    } else {
      datatype3 = xsd_internal_default.double;
    }
    return new _Literal(strValue, null, datatype3);
  }
  /**
   * Builds a literal node from an input value
   * @param value - The input value
   */
  static fromValue(value8) {
    if (isLiteral(value8)) {
      return value8;
    }
    switch (typeof value8) {
      case "object":
        if (value8 instanceof Date) {
          return _Literal.fromDate(value8);
        }
      case "boolean":
        return _Literal.fromBoolean(value8);
      case "number":
        return _Literal.fromNumber(value8);
      case "string":
        return new _Literal(value8);
    }
    throw new Error("Can't make literal from " + value8 + " of type " + typeof value8);
  }
};

// node_modules/rdflib/esm/collection.js
function fromValue(value8) {
  if (typeof value8 === "undefined" || value8 === null) {
    return value8;
  }
  if (isTerm(value8)) {
    return value8;
  }
  if (Array.isArray(value8)) {
    return new Collection(value8);
  }
  return Literal.fromValue(value8);
}
var Collection = class _Collection extends Node2 {
  constructor(initial2) {
    super((BlankNode.nextId++).toString());
    _defineProperty(this, "termType", CollectionTermType);
    _defineProperty(this, "classOrder", class_order_default.Collection);
    _defineProperty(this, "closed", false);
    _defineProperty(this, "compareTerm", BlankNode.prototype.compareTerm);
    _defineProperty(this, "elements", []);
    _defineProperty(this, "isVar", 0);
    if (initial2 && initial2.length > 0) {
      initial2.forEach((element2) => {
        this.elements.push(fromValue(element2));
      });
    }
  }
  get id() {
    return this.value;
  }
  set id(value8) {
    this.value = value8;
  }
  /**
   * Appends an element to this collection
   * @param element - The new element
   */
  append(element2) {
    return this.elements.push(element2);
  }
  /**
   * Closes this collection
   */
  close() {
    this.closed = true;
    return this.closed;
  }
  /**
   * Removes the first element from the collection (and return it)
   */
  shift() {
    return this.elements.shift();
  }
  /**
   * Creates a new Collection with the substituting bindings applied
   * @param bindings - The bindings to substitute
   */
  substitute(bindings) {
    const elementsCopy = this.elements.map((ea) => ea.substitute(bindings));
    return new _Collection(elementsCopy);
  }
  toNT() {
    return _Collection.toNT(this);
  }
  static toNT(collection5) {
    return BlankNode.NTAnonymousNodePrefix + collection5.id;
  }
  /**
   * Serializes the collection to a string.
   * Surrounded by (parentheses) and separated by spaces.
   */
  toString() {
    return "(" + this.elements.join(" ") + ")";
  }
  /**
   * Prepends the specified element to the collection's front
   * @param element - The element to prepend
   */
  unshift(element2) {
    return this.elements.unshift(element2);
  }
};
_defineProperty(Collection, "termType", CollectionTermType);

// node_modules/rdflib/esm/utils/default-graph-uri.js
var defaultGraphURI = "chrome:theSession";
var defaultGraphNode = new NamedNode(defaultGraphURI);

// node_modules/rdflib/esm/default-graph.js
var DefaultGraph = class extends Node2 {
  constructor() {
    super("");
    _defineProperty(this, "value", "");
    _defineProperty(this, "termType", DefaultGraphTermType);
    _defineProperty(this, "uri", defaultGraphURI);
  }
  toCanonical() {
    return this.value;
  }
  toString() {
    return "DefaultGraph";
  }
};
function isDefaultGraph(object8) {
  return !!object8 && object8.termType === DefaultGraphTermType;
}

// node_modules/rdflib/esm/statement.js
var defaultGraph = new DefaultGraph();
var Statement = class _Statement {
  /**
   * Construct a new statement
   *
   * @param subject - The subject of the triple.  What the fact is about
   * @param predicate - The relationship which is asserted between the subject and object
   * @param object - The thing or data value which is asserted to be related to the subject
   * @param {NamedNode} graph - The document where the triple is or was or will be stored on the web.
   *
   * The graph param is a named node of the document in which the triple when it is stored
   *  on the web. It exists because when you have read data from various places in the web,
   *  the “graph” tells you _why_ you have the triple. (At the moment, it is just the
   *  document, in future it could be an inference step)
   *
   * When you do UpdateManager.update() then the graph’s of all the statements must be the same,
   *  and give the document you are patching. In future, we may have a more
   *  powerful update() which can update more than one document.
   */
  constructor(subject8, predicate4, object8, graph3) {
    _defineProperty(this, "subject", void 0);
    _defineProperty(this, "predicate", void 0);
    _defineProperty(this, "object", void 0);
    _defineProperty(this, "graph", void 0);
    this.subject = Node2.fromValue(subject8);
    this.predicate = Node2.fromValue(predicate4);
    this.object = Node2.fromValue(object8);
    this.graph = graph3 == void 0 ? defaultGraph : Node2.fromValue(graph3);
  }
  /** Alias for graph, favored by Tim */
  get why() {
    return this.graph;
  }
  set why(g) {
    this.graph = g;
  }
  /**
   * Checks whether two statements are the same
   * @param other - The other statement
   */
  equals(other2) {
    return other2.subject.equals(this.subject) && other2.predicate.equals(this.predicate) && other2.object.equals(this.object) && other2.graph.equals(this.graph);
  }
  /**
   * Creates a statement with the bindings substituted
   * @param bindings The bindings
   */
  substitute(bindings) {
    const y = new _Statement(this.subject.substitute(bindings), this.predicate.substitute(bindings), this.object.substitute(bindings), isDefaultGraph(this.graph) ? this.graph : this.graph.substitute(bindings));
    return y;
  }
  /** Creates a canonical string representation of this statement. */
  toCanonical() {
    let terms = [this.subject.toCanonical(), this.predicate.toCanonical(), this.object.toCanonical()];
    if (this.graph && this.graph.termType !== DefaultGraphTermType) {
      terms.push(this.graph.toCanonical());
    }
    return terms.join(" ") + " .";
  }
  /** Creates a n-triples string representation of this statement */
  toNT() {
    return [this.subject.toNT(), this.predicate.toNT(), this.object.toNT()].join(" ") + " .";
  }
  /** Creates a n-quads string representation of this statement */
  toNQ() {
    return [this.subject.toNT(), this.predicate.toNT(), this.object.toNT(), isDefaultGraph(this.graph) ? "" : this.graph.toNT()].join(" ") + " .";
  }
  /** Creates a string representation of this statement */
  toString() {
    return this.toNT();
  }
};

// node_modules/rdflib/esm/uri.js
var uri_exports = {};
__export(uri_exports, {
  docpart: () => docpart,
  document: () => document2,
  hostpart: () => hostpart,
  join: () => join,
  protocol: () => protocol,
  refTo: () => refTo
});
var alert = alert || console.log;
function docpart(uri6) {
  var i;
  i = uri6.indexOf("#");
  if (i < 0) {
    return uri6;
  } else {
    return uri6.slice(0, i);
  }
}
function document2(x) {
  return new NamedNode(docpart(x));
}
function hostpart(u) {
  var m = /[^\/]*\/\/([^\/]*)\//.exec(u);
  if (m) {
    return m[1];
  } else {
    return "";
  }
}
function join(given2, base2) {
  var baseColon, baseScheme, baseSingle;
  var colon, lastSlash, path3;
  var baseHash = base2.indexOf("#");
  if (baseHash > 0) {
    base2 = base2.slice(0, baseHash);
  }
  if (given2.length === 0) {
    return base2;
  }
  if (given2.indexOf("#") === 0) {
    return base2 + given2;
  }
  colon = given2.indexOf(":");
  if (colon >= 0) {
    return given2;
  }
  baseColon = base2.indexOf(":");
  if (base2.length === 0) {
    return given2;
  }
  if (baseColon < 0) {
    alert("Invalid base: " + base2 + " in join with given: " + given2);
    return given2;
  }
  baseScheme = base2.slice(0, +baseColon + 1 || 9e9);
  if (given2.indexOf("//") === 0) {
    return baseScheme + given2;
  }
  if (base2.indexOf("//", baseColon) === baseColon + 1) {
    baseSingle = base2.indexOf("/", baseColon + 3);
    if (baseSingle < 0) {
      if (base2.length - baseColon - 3 > 0) {
        return base2 + "/" + given2;
      } else {
        return baseScheme + given2;
      }
    }
  } else {
    baseSingle = base2.indexOf("/", baseColon + 1);
    if (baseSingle < 0) {
      if (base2.length - baseColon - 1 > 0) {
        return base2 + "/" + given2;
      } else {
        return baseScheme + given2;
      }
    }
  }
  if (given2.indexOf("/") === 0) {
    return base2.slice(0, baseSingle) + given2;
  }
  path3 = base2.slice(baseSingle);
  lastSlash = path3.lastIndexOf("/");
  if (lastSlash < 0) {
    return baseScheme + given2;
  }
  if (lastSlash >= 0 && lastSlash < path3.length - 1) {
    path3 = path3.slice(0, +lastSlash + 1 || 9e9);
  }
  path3 += given2;
  while (path3.match(/[^\/]*\/\.\.\//)) {
    path3 = path3.replace(/[^\/]*\/\.\.\//, "");
  }
  path3 = path3.replace(/\.\//g, "");
  path3 = path3.replace(/\/\.$/, "/");
  return base2.slice(0, baseSingle) + path3;
}
function protocol(uri6) {
  const i = uri6.indexOf(":");
  if (i < 0) {
    return null;
  } else {
    return uri6.slice(0, i);
  }
}
function refTo(base2, uri6) {
  var c, i, k, l, len, len1, n3, o, p, q, ref, ref1, s;
  var commonHost = new RegExp("^[-_a-zA-Z0-9.]+:(//[^/]*)?/[^/]*$");
  if (!base2) {
    return uri6;
  }
  if (base2 === uri6) {
    return "";
  }
  for (i = o = 0, len = uri6.length; o < len; i = ++o) {
    const c2 = uri6[i];
    if (c2 !== base2[i]) {
      break;
    }
  }
  if (base2.slice(0, i).match(commonHost)) {
    k = uri6.indexOf("//");
    if (k < 0) {
      k = -2;
    }
    l = uri6.indexOf("/", k + 2);
    if (uri6[l + 1] !== "/" && base2[l + 1] !== "/" && uri6.slice(0, l) === base2.slice(0, l)) {
      return uri6.slice(l);
    }
  }
  if (uri6[i] === "#" && base2.length === i) {
    return uri6.slice(i);
  }
  while (i > 0 && uri6[i - 1] !== "/") {
    i--;
  }
  if (i < 3) {
    return uri6;
  }
  if (base2.indexOf("//", i - 2) > 0 || uri6.indexOf("//", i - 2) > 0) {
    return uri6;
  }
  if (base2.indexOf(":", i) > 0) {
    return uri6;
  }
  n3 = 0;
  ref = base2.slice(i);
  for (p = 0, len1 = ref.length; p < len1; p++) {
    c = ref[p];
    if (c === "/") {
      n3++;
    }
  }
  if (n3 === 0 && i < uri6.length && uri6[i] === "#") {
    return "./" + uri6.slice(i);
  }
  if (n3 === 0 && i === uri6.length) {
    return "./";
  }
  s = "";
  if (n3 > 0) {
    for (q = 1, ref1 = n3; ref1 >= 1 ? q <= ref1 : q >= ref1; ref1 >= 1 ? ++q : --q) {
      s += "../";
    }
  }
  return s + uri6.slice(i);
}

// node_modules/rdflib/esm/variable.js
var Variable = class _Variable extends Node2 {
  /**
   * Initializes this variable
   * @param name The variable's name
   */
  constructor(name9 = "") {
    super(name9);
    _defineProperty(this, "termType", VariableTermType);
    _defineProperty(this, "base", "varid:");
    _defineProperty(this, "classOrder", class_order_default.Variable);
    _defineProperty(this, "isVar", 1);
    _defineProperty(this, "uri", void 0);
    this.base = "varid:";
    this.uri = join(name9, this.base);
  }
  equals(other2) {
    if (!other2) {
      return false;
    }
    return this.termType === other2.termType && this.value === other2.value;
  }
  hashString() {
    return this.toString();
  }
  substitute(bindings) {
    var ref;
    return (ref = bindings[this.toNT()]) != null ? ref : this;
  }
  toString() {
    return _Variable.toString(this);
  }
  static toString(variable5) {
    if (variable5.uri.slice(0, variable5.base.length) === variable5.base) {
      return `?${variable5.uri.slice(variable5.base.length)}`;
    }
    return `?${variable5.uri}`;
  }
};

// node_modules/rdflib/esm/factories/factory-types.js
var Feature = /* @__PURE__ */ (function(Feature2) {
  Feature2["collections"] = "COLLECTIONS";
  Feature2["defaultGraphType"] = "DEFAULT_GRAPH_TYPE";
  Feature2["equalsMethod"] = "EQUALS_METHOD";
  Feature2["id"] = "ID";
  Feature2["identity"] = "IDENTITY";
  Feature2["reversibleId"] = "REVERSIBLE_ID";
  Feature2["variableType"] = "VARIABLE_TYPE";
  return Feature2;
})({});

// node_modules/rdflib/esm/factories/canonical-data-factory.js
var defaultGraph2 = new DefaultGraph();
var CanonicalDataFactory = {
  supports: {
    [Feature.collections]: false,
    [Feature.defaultGraphType]: false,
    [Feature.equalsMethod]: true,
    [Feature.identity]: false,
    [Feature.id]: true,
    [Feature.reversibleId]: false,
    [Feature.variableType]: true
  },
  /**
   * Creates a new blank node
   * @param value - The blank node's identifier
   */
  blankNode(value8) {
    return new BlankNode(value8);
  },
  defaultGraph: () => defaultGraph2,
  /**
   * Compares to (rdf) objects for equality.
   */
  equals(a, b) {
    if (a === b || !a || !b) {
      return true;
    }
    if (isQuad(a) || isQuad(b)) {
      if (isQuad(a) && isQuad(b)) {
        return this.equals(a.subject, b.subject) && this.equals(a.predicate, b.predicate) && this.equals(a.object, b.object) && this.equals(a.graph, b.graph);
      }
      return false;
    }
    if (isTerm(a) && isTerm(b)) {
      return this.id(a) === this.id(b);
    }
    return false;
  },
  /**
   * Generates a uniquely identifiably *idempotent* string for the given {term}.
   *
   * Equivalent to [[Term.hashString]]
   *
   * @example Use this to associate data with a term in an object
   *   { obj[id(term)] = "myData" }
   */
  id(term3) {
    if (!term3) {
      return "undefined";
    }
    if (isQuad(term3)) {
      return this.quadToNQ(term3);
    }
    switch (term3.termType) {
      case DefaultGraphTermType:
        return "defaultGraph";
      case CollectionTermType:
        return Collection.toNT(term3);
      case VariableTermType:
        return Variable.toString(term3);
      default:
        const nq = this.termToNQ(term3);
        if (nq) {
          return nq;
        }
        throw new Error(`Can't id term with type '${term3.termType}'`);
    }
  },
  isQuad(obj) {
    return obj instanceof Statement;
  },
  /**
   * Creates a new literal node. Does some JS literal parsing for ease of use.
   * @param value - The lexical value
   * @param languageOrDatatype - Either the language or the datatype
   */
  literal(value8, languageOrDatatype) {
    if (typeof value8 !== "string" && !languageOrDatatype) {
      return Literal.fromValue(value8);
    }
    const strValue = typeof value8 === "string" ? value8 : "" + value8;
    if (typeof languageOrDatatype === "string") {
      if (languageOrDatatype.indexOf(":") === -1) {
        return new Literal(strValue, languageOrDatatype);
      } else {
        return new Literal(strValue, null, this.namedNode(languageOrDatatype));
      }
    } else {
      return new Literal(strValue, null, languageOrDatatype);
    }
  },
  /**
   * Creates a new named node
   * @param value - The new named node
   */
  namedNode(value8) {
    return new NamedNode(value8);
  },
  /**
   * Creates a new statement
   * @param subject - The subject
   * @param predicate - The predicate
   * @param object - The object
   * @param graph - The containing graph
   */
  quad(subject8, predicate4, object8, graph3) {
    return new Statement(subject8, predicate4, object8, graph3 || defaultGraph2);
  },
  /**
   * Creates a new statement
   * @param subject - The subject
   * @param predicate - The predicate
   * @param object - The object
   * @param graph - The containing graph
   */
  triple(subject8, predicate4, object8, graph3) {
    return this.quad(subject8, predicate4, object8, graph3);
  },
  quadToNQ(q) {
    return `${this.termToNQ(q.subject)} ${this.termToNQ(q.predicate)} ${this.termToNQ(q.object)} ${this.termToNQ(q.graph)} .`;
  },
  /** Stringify a {term} to n-quads serialization. */
  termToNQ(term3) {
    switch (term3.termType) {
      case BlankNodeTermType:
        return "_:" + term3.value;
      case DefaultGraphTermType:
        return "";
      case EmptyTermType:
        return "<http://www.w3.org/1999/02/22-rdf-syntax-ns#nil>";
      case LiteralTermType:
        return Literal.toNT(term3);
      case GraphTermType:
      case NamedNodeTermType:
        return "<" + term3.value + ">";
      case CollectionTermType:
        return "(" + term3.elements.map((t) => this.termToNQ(t)).join(" ") + ")";
      default:
        throw new Error(`Can't serialize nonstandard term type (was '${term3.termType}')`);
    }
  },
  /** Convert an rdf object (term or quad) to n-quads serialization. */
  toNQ(term3) {
    if (this.isQuad(term3)) {
      return this.quadToNQ(term3);
    }
    return this.termToNQ(term3);
  },
  /**
   * Creates a new variable
   * @param name - The name for the variable
   */
  variable(name9) {
    return new Variable(name9);
  }
};
var canonical_data_factory_default = CanonicalDataFactory;

// node_modules/rdflib/esm/log.js
var log = {
  debug(x) {
  },
  warn(x) {
  },
  info(x) {
  },
  error(x) {
  },
  success(x) {
  },
  msg(x) {
  }
};
var log_default = log;

// node_modules/rdflib/esm/namespace.js
function Namespace(nsuri, factory) {
  const dataFactory = factory || {
    namedNode: (value8) => new NamedNode(value8)
  };
  return function(ln) {
    return dataFactory.namedNode(nsuri + (ln || ""));
  };
}

// node_modules/rdflib/esm/serializer.js
var ttl2jsonld = __toESM(require_ttl2jsonld());
var import_solid_namespace = __toESM(require_solid_namespace());

// node_modules/rdflib/esm/utils-js.js
var import_xmldom = __toESM(require_lib());
function mediaTypeClass(mediaType2) {
  mediaType2 = mediaType2.split(";")[0].trim();
  return new NamedNode("http://www.w3.org/ns/iana/media-types/" + mediaType2 + "#Resource");
}
function callbackify(obj, callbacks) {
  obj.callbacks = {};
  for (var x = callbacks.length - 1; x >= 0; x--) {
    obj.callbacks[callbacks[x]] = [];
  }
  obj.addHook = function(hook) {
    if (!obj.callbacks[hook]) {
      obj.callbacks[hook] = [];
    }
  };
  obj.addCallback = function(hook, func) {
    obj.callbacks[hook].push(func);
  };
  obj.removeCallback = function(hook, funcName) {
    for (var i = 0; i < obj.callbacks[hook].length; i++) {
      if (obj.callbacks[hook][i].name === funcName) {
        obj.callbacks[hook].splice(i, 1);
        return true;
      }
    }
    return false;
  };
  obj.insertCallback = function(hook, func) {
    obj.callbacks[hook].unshift(func);
  };
  obj.fireCallbacks = function fireCallbacks(hook, args) {
    var newCallbacks = [];
    var replaceCallbacks = [];
    var len = obj.callbacks[hook].length;
    var x2;
    let callback;
    for (x2 = len - 1; x2 >= 0; x2--) {
      callback = obj.callbacks[hook][x2];
      if (callback && callback.apply(obj, args)) {
        newCallbacks.push(callback);
      }
    }
    for (x2 = newCallbacks.length - 1; x2 >= 0; x2--) {
      replaceCallbacks.push(newCallbacks[x2]);
    }
    for (x2 = len; x2 < obj.callbacks[hook].length; x2++) {
      replaceCallbacks.push(obj.callbacks[hook][x2]);
    }
    obj.callbacks[hook] = replaceCallbacks;
  };
}
function domToString(node3, options) {
  options = options || {};
  var selfClosing = [];
  if (options && options.selfClosing) {
    options.selfClosing.split(" ").forEach(function(n3) {
      selfClosing[n3] = true;
    });
  }
  var skipAttributes = [];
  if (options && options.skipAttributes) {
    options.skipAttributes.split(" ").forEach(function(n3) {
      skipAttributes[n3] = true;
    });
  }
  return dumpNode(node3, options, selfClosing, skipAttributes);
}
function dumpNode(node3, options, selfClosing, skipAttributes) {
  var i;
  var out = "";
  var noEsc = [false];
  if (typeof node3.nodeType === "undefined") return out;
  if (node3.nodeType === 1) {
    if (node3.hasAttribute("class") && options && options.classWithChildText && node3.matches(options.classWithChildText.class)) {
      out += node3.querySelector(options.classWithChildText.element).textContent;
    } else if (!(options && options.skipNodeWithClass && node3.matches("." + options.skipNodeWithClass))) {
      var ename = node3.nodeName.toLowerCase();
      out += "<" + ename;
      var attrList = [];
      for (i = node3.attributes.length - 1; i >= 0; i--) {
        var atn = node3.attributes[i];
        if (skipAttributes && skipAttributes.length > 0 && skipAttributes[atn.name]) continue;
        if (/^\d+$/.test(atn.name)) continue;
        if (atn.name === "class" && options && options.replaceClassItemWith && atn.value.split(" ").indexOf(options.replaceClassItemWith.source) > -1) {
          var re = new RegExp(options.replaceClassItemWith.source, "g");
          atn.value = atn.value.replace(re, options.replaceClassItemWith.target).trim();
        }
        if (!(atn.name === "class" && options && options.skipClassWithValue && options.skipClassWithValue === atn.value)) {
          attrList.push(atn.name + "='" + atn.value.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/'/g, "&quot;") + "'");
        }
      }
      if (attrList.length > 0) {
        if (options && options.sortAttributes) {
          attrList.sort(function(a, b) {
            return a.toLowerCase().localeCompare(b.toLowerCase());
          });
        }
        out += " " + attrList.join(" ");
      }
      if (selfClosing && selfClosing.ename) {
        out += " />";
      } else {
        out += ">";
        out += ename === "html" ? "\n  " : "";
        noEsc.push(ename === "style" || ename === "script");
        for (i = 0; i < node3.childNodes.length; i++) out += dumpNode(node3.childNodes[i]);
        noEsc.pop();
        out += ename === "body" ? "</" + ename + ">\n" : "</" + ename + ">";
      }
    }
  } else if (node3.nodeType === 8) {
    out += "<!--" + node3.nodeValue + "-->";
  } else if (node3.nodeType === 3 || node3.nodeType === 4) {
    var nl = node3.nodeValue.replace(/\n+$/, "");
    out += noEsc[noEsc.length - 1] ? nl : nl.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
  } else {
    console.log("Warning; Cannot handle serialising nodes of type: " + node3.nodeType);
    console.log(node3);
  }
  return out;
}
function heavyCompare(x, y, g, uriMap) {
  var nonBlank = function(x2) {
    return x2.termType === "BlankNode" ? null : x2;
  };
  var signature2 = function(x2) {
    var lis = g.statementsMatching(x2).map(function(st2) {
      return "" + nonBlank(st2.subject) + " " + nonBlank(st2.predicate) + " " + nonBlank(st2.object);
    }).concat(g.statementsMatching(void 0, void 0, x2).map(function(st2) {
      return "" + nonBlank(st2.subject) + " " + nonBlank(st2.predicate) + " " + nonBlank(st2.object);
    }));
    lis.sort();
    return lis.join("\n");
  };
  const comparison = Object.prototype.hasOwnProperty.call(g, "compareTerms") ? g.compareTerms(x, y) : x.compareTerm(y);
  if (x.termType === "BlankNode" && y.termType === "BlankNode") {
    if (comparison === 0) return 0;
    if (signature2(x) > signature2(y)) return 1;
    if (signature2(x) < signature2(y)) return -1;
    return comparison;
  } else {
    if (uriMap && x.uri && y.uri) {
      return (uriMap[x.uri] || x.uri).localeCompare(uriMap[y.uri] || y.uri);
    }
    return comparison;
  }
}
function heavyCompareSPO(x, y, g, uriMap) {
  return heavyCompare(x.subject, y.subject, g, uriMap) || heavyCompare(x.predicate, y.predicate, g, uriMap) || heavyCompare(x.object, y.object, g, uriMap);
}
function parseXML(str, options) {
  var dparser;
  options = options || {};
  if (typeof module !== "undefined" && module && module.exports) {
    var dom = new import_xmldom.DOMParser().parseFromString(str, options.contentType || "application/xhtml+xml");
    return dom;
  } else {
    if (typeof window !== "undefined" && window.DOMParser) {
      dparser = new window.DOMParser();
    } else {
      dparser = new import_xmldom.DOMParser();
    }
  }
  return dparser.parseFromString(str, "application/xml");
}
function RDFArrayRemove(a, x) {
  for (var i = 0; i < a.length; i++) {
    if (a[i].subject.equals(x.subject) && a[i].predicate.equals(x.predicate) && a[i].object.equals(x.object) && a[i].why.equals(x.why)) {
      a.splice(i, 1);
      return;
    }
  }
  throw new Error("RDFArrayRemove: Array did not contain " + x + " " + x.why);
}
function stackString(e) {
  var str = "" + e + "\n";
  if (!e.stack) {
    return str + "No stack available.\n";
  }
  var lines = e.stack.toString().split("\n");
  var toprint = [];
  for (var i = 0; i < lines.length; i++) {
    var line4 = lines[i];
    if (line4.indexOf("ecmaunit.js") > -1) {
      break;
    }
    if (line4.charAt(0) == "(") {
      line4 = "function" + line4;
    }
    var chunks = line4.split("@");
    toprint.push(chunks);
  }
  for (var i = 0; i < toprint.length; i++) {
    str += "  " + toprint[i][1] + "\n    " + toprint[i][0];
  }
  return str;
}

// node_modules/rdflib/esm/xsd.js
function createXSD(localFactory = canonical_data_factory_default) {
  return {
    boolean: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#boolean"),
    dateTime: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#dateTime"),
    decimal: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#decimal"),
    double: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#double"),
    integer: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#integer"),
    langString: localFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#langString"),
    string: localFactory.namedNode("http://www.w3.org/2001/XMLSchema#string")
  };
}
var defaultXSD = createXSD(canonical_data_factory_default);

// node_modules/rdflib/esm/serializer.js
function createSerializer(store) {
  return new Serializer(store);
}
var Serializer = class _Serializer {
  constructor(store) {
    _defineProperty(this, "_notQNameChars", "	\r\n !\"#$%&'()*,+/;<=>?@[\\]^`{|}~");
    _defineProperty(this, "_notNameChars", this._notQNameChars + ":");
    _defineProperty(this, "validPrefix", new RegExp(/^[a-zA-Z][a-zA-Z0-9]*$/));
    _defineProperty(this, "forbidden1", new RegExp(/[\\"\b\f\r\v\t\n\u0080-\uffff]/gm));
    _defineProperty(this, "forbidden3", new RegExp(/[\\"\b\f\r\v\u0080-\uffff]/gm));
    this.flags = "";
    this.base = null;
    this.prefixes = [];
    this.namespaces = [];
    const nsKeys = Object.keys((0, import_solid_namespace.default)());
    for (const i in nsKeys) {
      const uri6 = (0, import_solid_namespace.default)()[nsKeys[i]]("");
      const prefix3 = nsKeys[i];
      this.prefixes[uri6] = prefix3;
      this.namespaces[prefix3] = uri6;
    }
    this.suggestPrefix("rdf", "http://www.w3.org/1999/02/22-rdf-syntax-ns#");
    this.suggestPrefix("xml", "reserved:reservedForFutureUse");
    this.namespacesUsed = [];
    this.keywords = ["a"];
    this.prefixchars = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
    this.incoming = null;
    this.formulas = [];
    this.store = store;
    this.rdfFactory = store.rdfFactory || canonical_data_factory_default;
    this.xsd = createXSD(this.rdfFactory);
  }
  setBase(base2) {
    this.base = base2;
    return this;
  }
  /**
   * Set serializer behavior flags. Letters can be combined with spaces.
   * Examples: 'si', 'deinprstux', 'si dr', 'o'.
   * Notable flags:
   *  - 'o': do not abbreviate to a prefixed name when the local part contains a dot
   */
  setFlags(flags3) {
    this.flags = flags3 || "";
    return this;
  }
  toStr(x) {
    var s = x.toNT();
    if (x.termType === "Graph") {
      this.formulas[s] = x;
    }
    return s;
  }
  fromStr(s) {
    if (s[0] === "{") {
      var x = this.formulas[s];
      if (!x) console.log("No formula object for " + s);
      return x;
    }
    return this.store.fromNT(s);
  }
  /**
   * Defines a set of [prefix, namespace] pairs to be used by this Serializer instance.
   * Overrides previous prefixes if any
   * @param namespaces
   * @return {Serializer}
   */
  setNamespaces(namespaces) {
    for (var px in namespaces) {
      this.setPrefix(px, namespaces[px]);
    }
    return this;
  }
  /**
   * Defines a namespace prefix, overriding any existing prefix for that URI
   * @param prefix
   * @param uri
   */
  setPrefix(prefix3, uri6) {
    if (prefix3.slice(0, 7) === "default") return;
    if (prefix3.slice(0, 2) === "ns") return;
    if (!prefix3 || !uri6) return;
    for (let existingNs in this.prefixes) {
      if (this.prefixes[existingNs] == prefix3) delete this.prefixes[existingNs];
    }
    this.prefixes[uri6] = prefix3;
    this.namespaces[prefix3] = uri6;
  }
  /* Accumulate Namespaces
  **
  ** These are only hints.  If two overlap, only one gets used
  ** There is therefore no guarantee in general.
  */
  suggestPrefix(prefix3, uri6) {
    if (prefix3.slice(0, 7) === "default") return;
    if (prefix3.slice(0, 2) === "ns") return;
    if (!prefix3 || !uri6) return;
    if (prefix3 in this.namespaces || uri6 in this.prefixes) return;
    this.prefixes[uri6] = prefix3;
    this.namespaces[prefix3] = uri6;
  }
  // Takes a namespace -> prefix map
  suggestNamespaces(namespaces) {
    for (var px in namespaces) {
      this.suggestPrefix(px, namespaces[px]);
    }
    return this;
  }
  checkIntegrity() {
    var p, ns3;
    for (p in this.namespaces) {
      if (this.prefixes[this.namespaces[p]] !== p) {
        throw new Error("Serializer integity error 1: " + p + ", " + this.namespaces[p] + ", " + this.prefixes[this.namespaces[p]] + "!");
      }
    }
    for (ns3 in this.prefixes) {
      if (this.namespaces[this.prefixes[ns3]] !== ns3) {
        throw new Error("Serializer integity error 2: " + ns3 + ", " + this.prefixs[ns3] + ", " + this.namespaces[this.prefixes[ns3]] + "!");
      }
    }
  }
  // Make up an unused prefix for a random namespace
  makeUpPrefix(uri6) {
    var p = uri6;
    function canUseMethod(pp) {
      if (!this.validPrefix.test(pp)) return false;
      if (pp === "ns") return false;
      if (pp in this.namespaces) return false;
      this.prefixes[uri6] = pp;
      this.namespaces[pp] = uri6;
      return pp;
    }
    var canUse = canUseMethod.bind(this);
    if ("#/".indexOf(p[p.length - 1]) >= 0) p = p.slice(0, -1);
    var slash = p.lastIndexOf("/");
    if (slash >= 0) p = p.slice(slash + 1);
    var i = 0;
    while (i < p.length) {
      if (this.prefixchars.indexOf(p[i]) >= 0) {
        i++;
      } else {
        break;
      }
    }
    p = p.slice(0, i);
    if (p.length < 6 && canUse(p)) return p;
    if (canUse(p.slice(0, 3))) return p.slice(0, 3);
    if (canUse(p.slice(0, 2))) return p.slice(0, 2);
    if (canUse(p.slice(0, 4))) return p.slice(0, 4);
    if (canUse(p.slice(0, 1))) return p.slice(0, 1);
    if (canUse(p.slice(0, 5))) return p.slice(0, 5);
    if (!this.validPrefix.test(p)) {
      p = "n";
    }
    for (var j = 0; ; j++) if (canUse(p.slice(0, 3) + j)) return p.slice(0, 3) + j;
  }
  rootSubjects(sts) {
    var incoming = {};
    var subjects2 = {};
    var allBnodes = {};
    for (var i = 0; i < sts.length; i++) {
      var st2 = sts[i];
      var checkMentions = function(x) {
        if (!incoming.hasOwnProperty(x)) incoming[x] = [];
        incoming[x].push(st2.subject);
      };
      var st22 = [st2.subject, st2.predicate, st2.object];
      st22.map(function(y2) {
        if (y2.termType === "BlankNode") {
          allBnodes[y2.toNT()] = true;
        } else if (y2.termType === "Collection") {
          y2.elements.forEach(function(z) {
            checkMentions(z);
          });
        }
      });
      checkMentions(sts[i].object);
      var ss = subjects2[this.toStr(st2.subject)];
      if (!ss) ss = [];
      ss.push(st2);
      subjects2[this.toStr(st2.subject)] = ss;
    }
    var roots = [];
    for (var xNT in subjects2) {
      if (!subjects2.hasOwnProperty(xNT)) continue;
      var y = this.fromStr(xNT);
      if (y.termType !== "BlankNode" || !incoming[y] || incoming[y].length !== 1) {
        roots.push(y);
        continue;
      }
    }
    this.incoming = incoming;
    var rootsHash = {};
    for (var k = 0; k < roots.length; k++) {
      rootsHash[roots[k].toNT()] = true;
    }
    return {
      "roots": roots,
      "subjects": subjects2,
      "rootsHash": rootsHash,
      "incoming": incoming
    };
  }
  // //////////////////////////////////////////////////////
  toN3(f) {
    return this.statementsToN3(f.statements);
  }
  // Validate if a string is a valid PN_LOCAL per Turtle 1.1 spec
  // Allows dots inside the local name but not as trailing character
  // Also allows empty local names (for URIs ending in / or #)
  isValidPNLocal(local) {
    if (local.length === 0) return true;
    if (local[local.length - 1] === ".") return false;
    for (var i = 0; i < local.length; i++) {
      var ch = local[i];
      if (ch === ".") continue;
      if (this._notNameChars.indexOf(ch) >= 0) {
        return false;
      }
    }
    return true;
  }
  explicitURI(uri6) {
    if (this.flags.indexOf("r") < 0 && this.base) {
      uri6 = refTo(this.base, uri6);
    } else if (this.flags.indexOf("u") >= 0) {
      uri6 = backslashUify(uri6);
    } else {
      uri6 = hexify(decodeURI(uri6));
    }
    return "<" + uri6 + ">";
  }
  statementsToNTriples(sts) {
    var sorted = sts.slice();
    sorted.sort();
    var str = "";
    var rdfns = "http://www.w3.org/1999/02/22-rdf-syntax-ns#";
    var self2 = this;
    var kb = this.store;
    var factory = this.rdfFactory;
    var termToNT = function(x) {
      if (x.termType !== "Collection") {
        return self2.atomicTermToN3(x);
      }
      var list = x.elements;
      var rest3 = kb.sym(rdfns + "nill");
      for (var i2 = list.length - 1; i2 >= 0; i2--) {
        var bnode = factory.blankNode();
        str += termToNT(bnode) + " " + termToNT(kb.sym(rdfns + "first")) + " " + termToNT(list[i2]) + ".\n";
        str += termToNT(bnode) + " " + termToNT(kb.sym(rdfns + "rest")) + " " + termToNT(rest3) + ".\n";
        rest3 = bnode;
      }
      return self2.atomicTermToN3(rest3);
    };
    for (var i = 0; i < sorted.length; i++) {
      var st2 = sorted[i];
      var s = "";
      s += termToNT(st2.subject) + " ";
      s += termToNT(st2.predicate) + " ";
      s += termToNT(st2.object) + " ";
      if (this.flags.indexOf("q") >= 0) {
        s += termToNT(st2.why) + " ";
      }
      s += ".\n";
      str += s;
    }
    return str;
  }
  statementsToN3(sts) {
    var indent = 4;
    var width5 = 80;
    var kb = this.store;
    var uriMap = {
      "http://www.w3.org/1999/02/22-rdf-syntax-ns#type": "aaa:00"
    };
    var SPO = function(x, y) {
      return heavyCompareSPO(x, y, kb, uriMap);
    };
    sts.sort(SPO);
    if (this.base && !this.defaultNamespace) {
      this.defaultNamespace = this.base + "#";
    }
    var predMap = {};
    if (this.flags.indexOf("s") < 0) {
      predMap["http://www.w3.org/2002/07/owl#sameAs"] = "=";
    }
    if (this.flags.indexOf("t") < 0) {
      predMap["http://www.w3.org/1999/02/22-rdf-syntax-ns#type"] = "a";
    }
    if (this.flags.indexOf("i") < 0) {
      predMap["http://www.w3.org/2000/10/swap/log#implies"] = "=>";
    }
    var spaces = function(n3) {
      var s = "";
      for (var i = 0; i < n3; i++) s += " ";
      return s;
    };
    var treeToLine = function(tree2) {
      var str = "";
      for (var i = 0; i < tree2.length; i++) {
        var branch3 = tree2[i];
        var s2 = typeof branch3 === "string" ? branch3 : treeToLine(branch3);
        if (i !== 0) {
          var ch = str.slice(-1) || " ";
          if (s2 === "," || s2 === ";") {
          } else if (s2 === "." && !"0123456789.:".includes(ch)) {
          } else {
            str += " ";
          }
        }
        str += s2;
      }
      return str;
    };
    var treeToString = function(tree2, level2) {
      var str = "";
      var lastLength = 1e5;
      if (level2 === void 0) level2 = -1;
      for (var i = 0; i < tree2.length; i++) {
        var branch3 = tree2[i];
        if (typeof branch3 !== "string") {
          var substr = treeToString(branch3, level2 + 1);
          if (substr.length < 10 * (width5 - indent * level2) && substr.indexOf('"""') < 0) {
            var line4 = treeToLine(branch3);
            if (line4.length < width5 - indent * level2) {
              branch3 = line4;
              substr = "";
            }
          }
          if (substr) lastLength = 1e4;
          str += substr;
        }
        if (typeof branch3 === "string") {
          if (branch3.length === 1 && str.slice(-1) === "\n") {
            if (",.;".indexOf(branch3) >= 0) {
              str = str.slice(0, -1);
              if (branch3 == "." && "0123456789.:".includes(str.charAt(str.length - 1))) {
                str += " ";
                lastLength += 1;
              }
              str += branch3 + "\n";
              lastLength += 1;
              continue;
            }
          }
          if (lastLength < indent * level2 + 4 || // if new line not necessary
          lastLength + branch3.length + 1 < width5 && ";.".indexOf(str[str.length - 2]) < 0) {
            str = str.slice(0, -1) + " " + branch3 + "\n";
            lastLength += branch3.length + 1;
          } else {
            let line5 = spaces(indent * level2) + branch3;
            str += line5 + "\n";
            lastLength = line5.length;
            if (level2 < 0) {
              str += "\n";
              lastLength = 1e5;
            }
          }
        }
      }
      return str;
    };
    function statementListToTreeMethod(statements) {
      var stats = this.rootSubjects(statements);
      var roots = stats.roots;
      var results = [];
      for (var i = 0; i < roots.length; i++) {
        var root = roots[i];
        results.push(subjectTree(root, stats));
      }
      return results;
    }
    var statementListToTree = statementListToTreeMethod.bind(this);
    function subjectTree(subject8, stats) {
      if (subject8.termType === "BlankNode" && !stats.incoming[subject8]) {
        return objectTree(subject8, stats, true).concat(["."]);
      }
      return [termToN3(subject8, stats)].concat([propertyTree(subject8, stats)]).concat(["."]);
    }
    function propertyTreeMethod(subject8, stats) {
      var results = [];
      var lastPred = null;
      var sts2 = stats.subjects[this.toStr(subject8)] || [];
      if (typeof sts2 === "undefined") {
        throw new Error("Cant find statements for " + subject8);
      }
      var objects = [];
      for (var i = 0; i < sts2.length; i++) {
        var st2 = sts2[i];
        if (st2.predicate.uri === lastPred) {
          objects.push(",");
        } else {
          if (lastPred) {
            results = results.concat([objects]).concat([";"]);
            objects = [];
          }
          results.push(predMap[st2.predicate.uri] ? predMap[st2.predicate.uri] : termToN3(st2.predicate, stats));
        }
        lastPred = st2.predicate.uri;
        objects.push(objectTree(st2.object, stats));
      }
      results = results.concat([objects]);
      return results;
    }
    var propertyTree = propertyTreeMethod.bind(this);
    function objectTreeMethod(obj, stats, force) {
      if (obj.termType === "BlankNode" && (force || stats.rootsHash[obj.toNT()] === void 0)) {
        if (stats.subjects[this.toStr(obj)]) {
          return ["[", propertyTree(obj, stats), "]"];
        } else {
          return "[]";
        }
      }
      return termToN3(obj, stats);
    }
    var objectTree = objectTreeMethod.bind(this);
    function termToN3Method(expr, stats) {
      var i, res;
      switch (expr.termType) {
        case "Graph":
          res = ["{"];
          res = res.concat(statementListToTree(expr.statements));
          return res.concat(["}"]);
        case "Collection":
          res = ["("];
          for (i = 0; i < expr.elements.length; i++) {
            res.push([objectTree(expr.elements[i], stats)]);
          }
          res.push(")");
          return res;
        default:
          return this.atomicTermToN3(expr);
      }
    }
    _Serializer.prototype.termToN3 = termToN3;
    var termToN3 = termToN3Method.bind(this);
    function prefixDirectivesMethod() {
      var str = "";
      if (this.flags.indexOf("d") < 0 && this.defaultNamespace) {
        str += "@prefix : " + this.explicitURI(this.defaultNamespace) + ".\n";
      }
      for (var ns3 in this.prefixes) {
        if (!this.prefixes.hasOwnProperty(ns3)) continue;
        if (!this.namespacesUsed[ns3]) continue;
        str += "@prefix " + this.prefixes[ns3] + ": " + this.explicitURI(ns3) + ".\n";
      }
      return str + "\n";
    }
    var prefixDirectives = prefixDirectivesMethod.bind(this);
    var tree = statementListToTree(sts);
    return prefixDirectives() + treeToString(tree);
  }
  // //////////////////////////////////////////// Atomic Terms
  //  Deal with term level things and nesting with no bnode structure
  atomicTermToN3(expr, stats) {
    switch (expr.termType) {
      case "BlankNode":
      case "Variable":
        return expr.toNT();
      case "Literal":
        var val = expr.value;
        if (typeof val !== "string") {
          throw new TypeError("Value of RDF literal node must be a string");
        }
        if (expr.datatype && this.flags.indexOf("x") < 0) {
          switch (expr.datatype.uri) {
            case "http://www.w3.org/2001/XMLSchema#integer":
              return val;
            case "http://www.w3.org/2001/XMLSchema#decimal":
              if (val.indexOf(".") < 0) val += ".0";
              return val;
            case "http://www.w3.org/2001/XMLSchema#double": {
              const eNotation = val.toLowerCase().indexOf("e") > 0;
              if (val.indexOf(".") < 0 && !eNotation) val += ".0";
              if (!eNotation) val += "e0";
              return val;
            }
            case "http://www.w3.org/2001/XMLSchema#boolean":
              return expr.value === "1" ? "true" : "false";
          }
        }
        var str = this.stringToN3(expr.value, this.flags);
        if (expr.language) {
          str += "@" + expr.language;
        } else if (!expr.datatype.equals(this.xsd.string)) {
          str += "^^" + this.atomicTermToN3(expr.datatype, stats);
        }
        return str;
      case "NamedNode":
        return this.symbolToN3(expr);
      case "DefaultGraph":
        return "";
      default:
        throw new Error("Internal: atomicTermToN3 cannot handle " + expr + " of termType: " + expr.termType);
    }
  }
  stringToN3(str, flags3) {
    if (!flags3) flags3 = "e";
    var res = "";
    var i, j, k;
    var delim;
    var forbidden;
    if (str.length > 20 && // Long enough to make sense
    str.slice(-1) !== '"' && // corner case'
    flags3.indexOf("n") < 0 && // Force single line
    (str.indexOf("\n") > 0 || str.indexOf('"') > 0)) {
      delim = '"""';
      forbidden = this.forbidden3;
    } else {
      delim = '"';
      forbidden = this.forbidden1;
    }
    for (i = 0; i < str.length; ) {
      forbidden.lastIndex = 0;
      var m = forbidden.exec(str.slice(i));
      if (m == null) break;
      j = i + forbidden.lastIndex - 1;
      res += str.slice(i, j);
      var ch = str[j];
      if (ch === '"' && delim === '"""' && str.slice(j, j + 3) !== '"""') {
        res += ch;
      } else {
        k = '\b\f\r	\v\n\\"'.indexOf(ch);
        if (k >= 0) {
          res += "\\" + 'bfrtvn\\"'[k];
        } else {
          if (flags3.indexOf("e") >= 0) {
            res += "\\u" + ("000" + ch.charCodeAt(0).toString(16).toLowerCase()).slice(-4);
          } else {
            res += ch;
          }
        }
      }
      i = j + 1;
    }
    return delim + res + str.slice(i) + delim;
  }
  //  A single symbol, either in  <> or namespace notation
  symbolToN3(x) {
    var uri6 = x.uri;
    var j = uri6.indexOf("#");
    if (j < 0 && this.flags.indexOf("/") < 0) {
      j = uri6.lastIndexOf("/");
    }
    if (j >= 0 && this.flags.indexOf("p") < 0 && // Can split at namespace but only if http[s]: URI or file: or ws[s] (why not others?)
    (uri6.indexOf("http") === 0 || uri6.indexOf("ws") === 0 || uri6.indexOf("file") === 0)) {
      var localid = uri6.slice(j + 1);
      var namesp = uri6.slice(0, j + 1);
      var minNamespaceLength = uri6.indexOf("://") + 4;
      var baseDir = this.base ? this.base.slice(0, Math.max(this.base.lastIndexOf("/"), this.base.lastIndexOf("#")) + 1) : null;
      var namespaceIsBaseDir = baseDir && namesp === baseDir;
      var forbidDotLocal = this.flags.indexOf("o") >= 0 && localid.indexOf(".") >= 0;
      var canSplit = !namespaceIsBaseDir && !forbidDotLocal && namesp.length > minNamespaceLength && this.isValidPNLocal(localid);
      if (canSplit) {
        if (this.defaultNamespace && this.defaultNamespace === namesp && this.flags.indexOf("d") < 0) {
          if (this.flags.indexOf("k") >= 0 && this.keyords.indexOf(localid) < 0) {
            return localid;
          }
          return ":" + localid;
        }
        var prefix3 = this.prefixes[namesp];
        if (!prefix3) prefix3 = this.makeUpPrefix(namesp);
        if (prefix3) {
          this.namespacesUsed[namesp] = true;
          return prefix3 + ":" + localid;
        }
      }
    }
    return this.explicitURI(uri6);
  }
  // /////////////////////////// Quad store serialization
  // @para. write  - a function taking a single string to be output
  //
  writeStore(write) {
    var kb = this.store;
    var fetcher2 = kb.fetcher;
    var session4 = fetcher2 && fetcher2.appNode;
    var sources = this.store.index[3];
    for (var s in sources) {
      var source10 = kb.fromNT(s);
      if (session4 && source10.equals(session4)) continue;
      write("\n" + this.atomicTermToN3(source10) + " " + this.atomicTermToN3(kb.sym("http://www.w3.org/2000/10/swap/log#semantics")) + " { " + this.statementsToN3(kb.statementsMatching(void 0, void 0, void 0, source10)) + " }.\n");
    }
    kb.statementsMatching(void 0, kb.sym("http://www.w3.org/2007/ont/link#requestedURI")).map(function(st2) {
      write("\n<" + st2.object.value + "> log:metadata {\n");
      var sts = kb.statementsMatching(void 0, void 0, void 0, st2.subject);
      write(this.statementsToN3(this.statementsToN3(sts)));
      write("}.\n");
    });
    var metaSources = [];
    if (session4) metaSources.push(session4);
    var metadata2 = [];
    metaSources.map(function(source11) {
      metadata2 = metadata2.concat(kb.statementsMatching(void 0, void 0, void 0, source11));
    });
    write(this.statementsToN3(metadata2));
  }
  // ////////////////////////////////////////////// XML serialization
  statementsToXML(sts) {
    var indent = 4;
    var width5 = 80;
    var namespaceCounts = [];
    namespaceCounts["http://www.w3.org/1999/02/22-rdf-syntax-ns#"] = true;
    var liPrefix = "http://www.w3.org/1999/02/22-rdf-syntax-ns#_";
    var spaces = function(n3) {
      var s = "";
      for (var i = 0; i < n3; i++) s += " ";
      return s;
    };
    var XMLtreeToLine = function(tree3) {
      var str2 = "";
      for (var i = 0; i < tree3.length; i++) {
        var branch3 = tree3[i];
        var s2 = typeof branch3 === "string" ? branch3 : XMLtreeToLine(branch3);
        str2 += s2;
      }
      return str2;
    };
    var XMLtreeToString = function(tree3, level2) {
      var str2 = "";
      var line4;
      var lastLength = 1e5;
      if (!level2) level2 = 0;
      for (var i = 0; i < tree3.length; i++) {
        var branch3 = tree3[i];
        if (typeof branch3 !== "string") {
          var substr = XMLtreeToString(branch3, level2 + 1);
          if (substr.length < 10 * (width5 - indent * level2) && substr.indexOf('"""') < 0) {
            line4 = XMLtreeToLine(branch3);
            if (line4.length < width5 - indent * level2) {
              branch3 = "   " + line4;
              substr = "";
            }
          }
          if (substr) lastLength = 1e4;
          str2 += substr;
        }
        if (typeof branch3 === "string") {
          if (lastLength < indent * level2 + 4) {
            str2 = str2.slice(0, -1) + " " + branch3 + "\n";
            lastLength += branch3.length + 1;
          } else {
            line4 = spaces(indent * level2) + branch3;
            str2 += line4 + "\n";
            lastLength = line4.length;
          }
        } else {
        }
      }
      return str2;
    };
    function statementListToXMLTreeMethod(statements) {
      this.suggestPrefix("rdf", "http://www.w3.org/1999/02/22-rdf-syntax-ns#");
      var stats = this.rootSubjects(statements);
      var roots = stats.roots;
      var results = [];
      for (var i = 0; i < roots.length; i++) {
        var root = roots[i];
        results.push(subjectXMLTree(root, stats));
      }
      return results;
    }
    var statementListToXMLTree = statementListToXMLTreeMethod.bind(this);
    function escapeForXML(str2) {
      if (typeof str2 === "undefined") return "@@@undefined@@@@";
      return str2.replace(/[&<"]/g, function(m) {
        switch (m[0]) {
          case "&":
            return "&amp;";
          case "<":
            return "&lt;";
          case '"':
            return "&quot;";
        }
      });
    }
    function relURIMethod(term3) {
      return escapeForXML(this.base ? uri_exports.refTo(this.base, term3.uri) : term3.uri);
    }
    var relURI = relURIMethod.bind(this);
    function subjectXMLTreeMethod(subject8, stats) {
      var results = [];
      var type5, t, st2, pred;
      var sts2 = stats.subjects[this.toStr(subject8)];
      if (typeof sts2 === "undefined") {
        return propertyXMLTree(subject8, stats);
      }
      sts2.sort(function(a, b) {
        var ap = a.predicate.uri;
        var bp = b.predicate.uri;
        if (ap.substring(0, liPrefix.length) === liPrefix || bp.substring(0, liPrefix.length) === liPrefix) {
          return ap.localeCompare(bp);
        }
        var as2 = ap.substring(liPrefix.length);
        var bs = bp.substring(liPrefix.length);
        var an = parseInt(as2, 10);
        var bn = parseInt(bs, 10);
        if (isNaN(an) || isNaN(bn) || an !== as2 || bn !== bs) {
          return ap.localeCompare(bp);
        }
        return an - bn;
      });
      for (var i = 0; i < sts2.length; i++) {
        st2 = sts2[i];
        if (st2.predicate.uri === "http://www.w3.org/1999/02/22-rdf-syntax-ns#type" && !type5 && st2.object.termType === "NamedNode") {
          type5 = st2.object;
          continue;
        }
        pred = st2.predicate;
        if (pred.uri.substr(0, liPrefix.length) === liPrefix) {
          var number2 = pred.uri.substr(liPrefix.length);
          var intNumber = parseInt(number2, 10);
          if (number2 === intNumber.toString()) {
            pred = this.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#li");
          }
        }
        t = qname(pred);
        switch (st2.object.termType) {
          case "BlankNode":
            if (stats.incoming[st2.object].length === 1) {
              results = results.concat(["<" + t + ' rdf:parseType="Resource">', subjectXMLTree(st2.object, stats), "</" + t + ">"]);
            } else {
              results = results.concat(["<" + t + ' rdf:nodeID="' + st2.object.toNT().slice(2) + '"/>']);
            }
            break;
          case "NamedNode":
            results = results.concat(["<" + t + ' rdf:resource="' + relURI(st2.object) + '"/>']);
            break;
          case "Literal":
            results = results.concat(["<" + t + (st2.object.language ? ' xml:lang="' + st2.object.language + '"' : st2.object.datatype.equals(this.xsd.string) ? "" : ' rdf:datatype="' + escapeForXML(st2.object.datatype.uri) + '"') + ">" + escapeForXML(st2.object.value) + "</" + t + ">"]);
            break;
          case "Collection":
            results = results.concat(["<" + t + ' rdf:parseType="Collection">', collectionXMLTree(st2.object, stats), "</" + t + ">"]);
            break;
          default:
            throw new Error("Can't serialize object of type " + st2.object.termType + " into XML");
        }
      }
      var tag3 = type5 ? qname(type5) : "rdf:Description";
      var attrs = "";
      if (subject8.termType === "BlankNode") {
        if (!stats.incoming[subject8] || stats.incoming[subject8].length !== 1) {
          attrs = ' rdf:nodeID="' + subject8.toNT().slice(2) + '"';
        }
      } else {
        attrs = ' rdf:about="' + relURI(subject8) + '"';
      }
      return ["<" + tag3 + attrs + ">"].concat([results]).concat(["</" + tag3 + ">"]);
    }
    var subjectXMLTree = subjectXMLTreeMethod.bind(this);
    function collectionXMLTree(subject8, stats) {
      var res = [];
      for (var i = 0; i < subject8.elements.length; i++) {
        res.push(subjectXMLTree(subject8.elements[i], stats));
      }
      return res;
    }
    function propertyXMLTreeMethod(subject8, stats) {
      var results = [];
      var sts2 = stats.subjects[this.toStr(subject8)];
      if (!sts2) return results;
      sts2.sort();
      for (var i = 0; i < sts2.length; i++) {
        var st2 = sts2[i];
        switch (st2.object.termType) {
          case "BlankNode":
            if (stats.rootsHash[st2.object.toNT()]) {
              results = results.concat(["<" + qname(st2.predicate) + ' rdf:nodeID="' + st2.object.toNT().slice(2) + '">', "</" + qname(st2.predicate) + ">"]);
            } else {
              results = results.concat(["<" + qname(st2.predicate) + ' rdf:parseType="Resource">', propertyXMLTree(st2.object, stats), "</" + qname(st2.predicate) + ">"]);
            }
            break;
          case "NamedNode":
            results = results.concat(["<" + qname(st2.predicate) + ' rdf:resource="' + relURI(st2.object) + '"/>']);
            break;
          case "Literal":
            results = results.concat(["<" + qname(st2.predicate) + (st2.object.language ? ' xml:lang="' + st2.object.language + '"' : st2.object.datatype.equals(this.xsd.string) ? "" : ' rdf:datatype="' + escapeForXML(st2.object.datatype.value) + '"') + ">" + escapeForXML(st2.object.value) + "</" + qname(st2.predicate) + ">"]);
            break;
          case "Collection":
            results = results.concat(["<" + qname(st2.predicate) + ' rdf:parseType="Collection">', collectionXMLTree(st2.object, stats), "</" + qname(st2.predicate) + ">"]);
            break;
          default:
            throw new Error("Can't serialize object of type " + st2.object.termType + " into XML");
        }
      }
      return results;
    }
    var propertyXMLTree = propertyXMLTreeMethod.bind(this);
    function qnameMethod(term3) {
      var uri6 = term3.uri;
      var j = uri6.indexOf("#");
      if (j < 0 && this.flags.indexOf("/") < 0) {
        j = uri6.lastIndexOf("/");
      }
      if (j < 0) throw new Error("Cannot make qname out of <" + uri6 + ">");
      for (var k = j + 1; k < uri6.length; k++) {
        if (this._notNameChars.indexOf(uri6[k]) >= 0) {
          throw new Error('Invalid character "' + uri6[k] + '" cannot be in XML qname for URI: ' + uri6);
        }
      }
      var localid = uri6.slice(j + 1);
      var namesp = uri6.slice(0, j + 1);
      if (this.defaultNamespace && this.defaultNamespace === namesp && this.flags.indexOf("d") < 0) {
        return localid;
      }
      var prefix3 = this.prefixes[namesp];
      if (!prefix3) prefix3 = this.makeUpPrefix(namesp);
      namespaceCounts[namesp] = true;
      return prefix3 + ":" + localid;
    }
    var qname = qnameMethod.bind(this);
    var tree = statementListToXMLTree(sts);
    var str = "<rdf:RDF";
    if (this.defaultNamespace) {
      str += ' xmlns="' + escapeForXML(this.defaultNamespace) + '"';
    }
    for (var ns3 in namespaceCounts) {
      if (!namespaceCounts.hasOwnProperty(ns3)) continue;
      var ns22 = this.base && this.flags.includes("z") ? uri_exports.refTo(this.base, ns3) : ns3;
      str += "\n xmlns:" + this.prefixes[ns3] + '="' + escapeForXML(ns22) + '"';
    }
    str += ">";
    var tree2 = [str, tree, "</rdf:RDF>"];
    return XMLtreeToString(tree2, -1);
  }
  // End @@ body
  statementsToJsonld(sts) {
    const turtleDoc = this.statementsToN3(sts);
    const jsonldObj = ttl2jsonld.parse(turtleDoc);
    return JSON.stringify(jsonldObj, null, 2);
  }
};
function hexify(str) {
  return encodeURI(str);
}
function backslashUify(str) {
  var res = "";
  var k;
  for (var i = 0; i < str.length; i++) {
    k = str.charCodeAt(i);
    if (k > 65535) {
      res += "\\U" + ("00000000" + k.toString(16)).slice(-8);
    } else if (k > 126) {
      res += "\\u" + ("0000" + k.toString(16)).slice(-4);
    } else {
      res += str[i];
    }
  }
  return res;
}

// node_modules/rdflib/esm/serialize.js
function serialize(target6, kb, base2, contentType4, callback, options) {
  base2 = base2 || target6?.value;
  const opts = options || {};
  contentType4 = contentType4 || TurtleContentType;
  var documentString = void 0;
  try {
    var sz = createSerializer(kb);
    if (opts.flags) sz.setFlags(opts.flags);
    var newSts = kb.statementsMatching(void 0, void 0, void 0, target6);
    if ("namespaces" in kb) {
      sz.suggestNamespaces(kb.namespaces);
    }
    if (opts.namespaces) {
      sz.setNamespaces(opts.namespaces);
    }
    sz.setBase(base2);
    switch (contentType4) {
      case RDFXMLContentType:
        documentString = sz.statementsToXML(newSts);
        return executeCallback(null, documentString);
      case N3ContentType:
      case N3LegacyContentType:
        documentString = sz.statementsToN3(newSts);
        return executeCallback(null, documentString);
      case TurtleContentType:
      case TurtleLegacyContentType:
        sz.setFlags("si" + (opts.flags ? " " + opts.flags : ""));
        documentString = sz.statementsToN3(newSts);
        return executeCallback(null, documentString);
      case NTriplesContentType:
        sz.setFlags("deinprstux");
        documentString = sz.statementsToNTriples(newSts);
        return executeCallback(null, documentString);
      case JSONLDContentType:
        sz.setFlags("si dr" + (opts.flags ? " " + opts.flags : ""));
        documentString = sz.statementsToJsonld(newSts);
        return executeCallback(null, documentString);
      case NQuadsContentType:
      case NQuadsAltContentType:
        sz.setFlags("deinprstux q");
        documentString = sz.statementsToNTriples(newSts);
        return executeCallback(null, documentString);
      default:
        throw new Error("Serialize: Content-type " + contentType4 + " not supported for data write.");
    }
  } catch (err2) {
    if (callback) {
      return callback(err2, void 0);
    }
    throw err2;
  }
  function executeCallback(err2, result6) {
    if (callback) {
      callback(err2, result6);
      return;
    } else {
      return result6;
    }
  }
}

// node_modules/rdflib/esm/utils.js
var appliedFactoryMethods = ["blankNode", "defaultGraph", "literal", "namedNode", "quad", "variable", "supports"];
var rdf = {
  first: "http://www.w3.org/1999/02/22-rdf-syntax-ns#first",
  rest: "http://www.w3.org/1999/02/22-rdf-syntax-ns#rest",
  nil: "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
};
function arrayToStatements(rdfFactory, subject8, data4) {
  const statements = [];
  data4.reduce((id4, _listObj, i, listData) => {
    statements.push(rdfFactory.quad(id4, rdfFactory.namedNode(rdf.first), listData[i]));
    let nextNode;
    if (i < listData.length - 1) {
      nextNode = rdfFactory.blankNode();
      statements.push(rdfFactory.quad(id4, rdfFactory.namedNode(rdf.rest), nextNode));
    } else {
      statements.push(rdfFactory.quad(id4, rdfFactory.namedNode(rdf.rest), rdfFactory.namedNode(rdf.nil)));
    }
    return nextNode;
  }, subject8);
  return statements;
}
function ArrayIndexOf(arr, item4, i = 0) {
  var length3 = arr.length;
  if (i < 0) i = length3 + i;
  for (; i < length3; i++) {
    if (arr[i] === item4) {
      return i;
    }
  }
  return -1;
}

// node_modules/rdflib/esm/formula.js
var Formula = class _Formula extends Node2 {
  /**
   * Initializes this formula
   * @constructor
   * @param statements - Initial array of statements
   * @param constraints - initial array of constraints
   * @param initBindings - initial bindings used in Query
   * @param optional - optional
   * @param opts
   * @param opts.rdfFactory - The rdf factory that should be used by the store
  */
  constructor(statements = [], constraints2 = [], initBindings = [], optional2 = [], opts = {}) {
    super("");
    this.statements = statements;
    this.constraints = constraints2;
    this.initBindings = initBindings;
    this.optional = optional2;
    _defineProperty(this, "termType", GraphTermType);
    _defineProperty(this, "classOrder", class_order_default.Graph);
    _defineProperty(this, "fetcher", void 0);
    _defineProperty(this, "isVar", 0);
    _defineProperty(this, "ns", Namespace);
    _defineProperty(this, "rdfFactory", void 0);
    this.rdfFactory = opts && opts.rdfFactory || canonical_data_factory_default;
    for (const factoryMethod of appliedFactoryMethods) {
      this[factoryMethod] = (...args) => this.rdfFactory[factoryMethod](...args);
    }
  }
  /** Add a statement from its parts
   * @param subject - the first part of the statement
   * @param predicate - the second part of the statement
   * @param object - the third part of the statement
   * @param graph - the last part of the statement
   */
  add(subject8, predicate4, object8, graph3) {
    if (arguments.length === 1) {
      subject8.forEach((st2) => this.add(st2.subject, st2.predicate, st2.object, st2.graph));
    }
    return this.statements.push(this.rdfFactory.quad(subject8, predicate4, object8, graph3));
  }
  /** Add a statment object
   * @param {Statement} statement - An existing constructed statement to add
   */
  addStatement(statement2) {
    return this.add(statement2);
  }
  /**
   * Shortcut for adding blankNodes
   * @param [id]
   */
  bnode(id4) {
    return this.rdfFactory.blankNode(id4);
  }
  /**
   * Adds all the statements to this formula
   * @param statements - A collection of statements
   */
  addAll(statements) {
    statements.forEach((quad3) => {
      this.add(quad3.subject, quad3.predicate, quad3.object, quad3.graph);
    });
  }
  /** Follow link from one node, using one wildcard, looking for one
  *
  * For example, any(me, knows, null, profile)  - a person I know accoring to my profile .
  * any(me, knows, null, null)  - a person I know accoring to anything in store .
  * any(null, knows, me, null)  - a person who know me accoring to anything in store .
  *
  * @param s - A node to search for as subject, or if null, a wildcard
  * @param p - A node to search for as predicate, or if null, a wildcard
  * @param o - A node to search for as object, or if null, a wildcard
  * @param g - A node to search for as graph, or if null, a wildcard
  * @returns A node which match the wildcard position, or null
  */
  any(s, p, o, g) {
    const st2 = this.anyStatementMatching(s, p, o, g);
    if (st2 == null) {
      return null;
    } else if (s == null) {
      return st2.subject;
    } else if (p == null) {
      return st2.predicate;
    } else if (o == null) {
      return st2.object;
    }
    return null;
  }
  /**
   * Gets the value of a node that matches the specified pattern
   * @param s The subject
   * @param p The predicate
   * @param o The object
   * @param g The graph that contains the statement
   */
  anyValue(s, p, o, g) {
    const y = this.any(s, p, o, g);
    return y ? y.value : void 0;
  }
  /**
   * Gets the first JavaScript object equivalent to a node based on the specified pattern
   * @param s The subject
   * @param p The predicate
   * @param o The object
   * @param g The graph that contains the statement
   */
  anyJS(s, p, o, g) {
    const y = this.any(s, p, o, g);
    return y ? Node2.toJS(y) : void 0;
  }
  /**
   * Gets the first statement that matches the specified pattern
   */
  anyStatementMatching(s, p, o, g) {
    let x = this.statementsMatching(s, p, o, g, true);
    if (!x || x.length === 0) {
      return void 0;
    }
    return x[0];
  }
  /**
   * Returns a unique index-safe identifier for the given term.
   *
   * Falls back to the rdflib hashString implementation if the given factory doesn't support id.
   */
  id(term3) {
    return this.rdfFactory.id(term3);
  }
  /**
   * Search the Store
   * This is really a teaching method as to do this properly you would use IndexedFormula
   *
   * @param s - A node to search for as subject, or if null, a wildcard
   * @param p - A node to search for as predicate, or if null, a wildcard
   * @param o - A node to search for as object, or if null, a wildcard
   * @param g - A node to search for as graph, or if null, a wildcard
   * @param justOne - flag - stop when found one rather than get all of them?
   * @returns {Array<Node>} - An array of nodes which match the wildcard position
   */
  statementsMatching(s, p, o, g, justOne) {
    const sts = this.statements.filter((st2) => (!s || s.equals(st2.subject)) && (!p || p.equals(st2.predicate)) && (!o || o.equals(st2.object)) && (!g || g.equals(st2.graph)));
    if (justOne) {
      return sts.length === 0 ? [] : [sts[0]];
    }
    return sts;
  }
  /**
   * Finds the types in the list which have no *stored* subtypes
   * These are a set of classes which provide by themselves complete
   * information -- the other classes are redundant for those who
   * know the class DAG.
   * @param types A map of the types
   */
  bottomTypeURIs(types2) {
    let bots;
    let bottom;
    let elt;
    let i;
    let len;
    let ref;
    let subs;
    let v2;
    bots = [];
    for (let k in types2) {
      if (!types2.hasOwnProperty(k)) continue;
      v2 = types2[k];
      subs = this.each(void 0, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), this.rdfFactory.namedNode(k));
      bottom = true;
      i = 0;
      for (len = subs.length; i < len; i++) {
        elt = subs[i];
        ref = elt.uri;
        if (ref in types2) {
          bottom = false;
          break;
        }
      }
      if (bottom) {
        bots[k] = v2;
      }
    }
    return bots;
  }
  /** Creates a new collection */
  collection() {
    return new Collection();
  }
  /** Follow links from one node, using one wildcard.
  *
  * For example, each(me, knows, null, profile)  - people I know accoring to my profile .
  * each(me, knows, null, null)  - people I know accoring to anything in store .
  * each(null, knows, me, null)  - people who know me accoring to anything in store .
  *
  * @param s - A node to search for as subject, or if null, a wildcard
  * @param p - A node to search for as predicate, or if null, a wildcard
  * @param o - A node to search for as object, or if null, a wildcard
  * @param g - A node to search for as graph, or if null, a wildcard
  * @returns {Array<Node>} - An array of nodes which match the wildcard position
  */
  each(s, p, o, g) {
    const results = [];
    let sts = this.statementsMatching(s, p, o, g, false);
    if (s == null) {
      for (let i = 0, len = sts.length; i < len; i++) {
        results.push(sts[i].subject);
      }
    } else if (p == null) {
      for (let l = 0, len1 = sts.length; l < len1; l++) {
        results.push(sts[l].predicate);
      }
    } else if (o == null) {
      for (let m = 0, len2 = sts.length; m < len2; m++) {
        results.push(sts[m].object);
      }
    } else if (g == null) {
      for (let q = 0, len3 = sts.length; q < len3; q++) {
        results.push(new NamedNode(sts[q].graph.value));
      }
    }
    return results;
  }
  /**
   * Test whether this formula is equals to {other}
   * @param other - The other formula
   */
  equals(other2) {
    if (!other2) {
      return false;
    }
    return this.hashString() === other2.hashString();
  }
  /**
   * For thisClass or any subclass, anything which has it is its type
   * or is the object of something which has the type as its range, or subject
   * of something which has the type as its domain
   * We don't bother doing subproperty (yet?)as it doesn't seeem to be used
   * much.
   * Get all the Classes of which we can RDFS-infer the subject is a member
   * @return a hash of URIs
   */
  findMembersNT(thisClass) {
    let len2;
    let len4;
    let m;
    let members4;
    let pred;
    let ref;
    let ref1;
    let ref2;
    let ref3;
    let ref4;
    let ref5;
    let seeds;
    let st2;
    let u;
    seeds = {};
    seeds[thisClass.toNT()] = true;
    members4 = {};
    ref = this.transitiveClosure(seeds, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), true);
    for (let t in ref) {
      if (!ref.hasOwnProperty(t)) continue;
      ref1 = this.statementsMatching(void 0, this.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"), this.fromNT(t));
      for (let i = 0, len = ref1.length; i < len; i++) {
        st2 = ref1[i];
        members4[st2.subject.toNT()] = st2;
      }
      ref2 = this.each(void 0, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#domain"), this.fromNT(t));
      for (let l = 0, len1 = ref2.length; l < len1; l++) {
        pred = ref2[l];
        ref3 = this.statementsMatching(void 0, pred);
        for (m = 0, len2 = ref3.length; m < len2; m++) {
          st2 = ref3[m];
          members4[st2.subject.toNT()] = st2;
        }
      }
      ref4 = this.each(void 0, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#range"), this.fromNT(t));
      for (let q = 0, len3 = ref4.length; q < len3; q++) {
        pred = ref4[q];
        ref5 = this.statementsMatching(void 0, pred);
        for (u = 0, len4 = ref5.length; u < len4; u++) {
          st2 = ref5[u];
          members4[st2.object.toNT()] = st2;
        }
      }
    }
    return members4;
  }
  /**
   * For thisClass or any subclass, anything which has it is its type
   * or is the object of something which has the type as its range, or subject
   * of something which has the type as its domain
   * We don't bother doing subproperty (yet?)as it doesn't seeem to be used
   * much.
   * Get all the Classes of which we can RDFS-infer the subject is a member
   * @param subject - A named node
   */
  findMemberURIs(subject8) {
    return this.NTtoURI(this.findMembersNT(subject8));
  }
  /**
   * Get all the Classes of which we can RDFS-infer the subject is a superclass
   * Returns a hash table where key is NT of type and value is statement why we
   * think so.
   * Does NOT return terms, returns URI strings.
   * We use NT representations in this version because they handle blank nodes.
   */
  findSubClassesNT(subject8) {
    let types2 = {};
    types2[subject8.toNT()] = true;
    return this.transitiveClosure(types2, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), true);
  }
  /**
   * Get all the Classes of which we can RDFS-infer the subject is a subclass
   * @param {RDFlibNamedNode} subject - The thing whose classes are to be found
   * @returns a hash table where key is NT of type and value is statement why we
   * think so.
   * Does NOT return terms, returns URI strings.
   * We use NT representations in this version because they handle blank nodes.
   */
  findSuperClassesNT(subject8) {
    let types2 = {};
    types2[subject8.toNT()] = true;
    return this.transitiveClosure(types2, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), false);
  }
  /**
   * Get all the Classes of which we can RDFS-infer the subject is a member
   * todo: This will loop is there is a class subclass loop (Sublass loops are
   * not illegal)
   * @param {RDFlibNamedNode} subject - The thing whose classes are to be found
   * @returns a hash table where key is NT of type and value is statement why we think so.
   * Does NOT return terms, returns URI strings.
   * We use NT representations in this version because they handle blank nodes.
   */
  findTypesNT(subject8) {
    let domain4;
    let range3;
    let rdftype;
    let ref;
    let ref1;
    let ref2;
    let ref3;
    let st2;
    let types2;
    rdftype = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
    types2 = [];
    ref = this.statementsMatching(subject8, void 0, void 0);
    for (let i = 0, len = ref.length; i < len; i++) {
      st2 = ref[i];
      if (st2.predicate.uri === rdftype) {
        types2[st2.object.toNT()] = st2;
      } else {
        ref1 = this.each(st2.predicate, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#domain"));
        for (let l = 0, len1 = ref1.length; l < len1; l++) {
          range3 = ref1[l];
          types2[range3.toNT()] = st2;
        }
      }
    }
    ref2 = this.statementsMatching(void 0, void 0, subject8);
    for (let m = 0, len2 = ref2.length; m < len2; m++) {
      st2 = ref2[m];
      ref3 = this.each(st2.predicate, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#range"));
      for (let q = 0, len3 = ref3.length; q < len3; q++) {
        domain4 = ref3[q];
        types2[domain4.toNT()] = st2;
      }
    }
    return this.transitiveClosure(types2, this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"), false);
  }
  /**
   * Get all the Classes of which we can RDFS-infer the subject is a member
   * todo: This will loop is there is a class subclass loop (Sublass loops are
   * not illegal)
   * Returns a hash table where key is NT of type and value is statement why we
   * think so.
   * Does NOT return terms, returns URI strings.
   * We use NT representations in this version because they handle blank nodes.
   * @param subject - A subject node
   */
  findTypeURIs(subject8) {
    return this.NTtoURI(this.findTypesNT(subject8));
  }
  /** Trace statements which connect directly, or through bnodes
   *
   * @param subject - The node to start looking for statments
   * @param doc - The document to be searched, or null to search all documents
   * @returns an array of statements, duplicate statements are suppresssed.
   */
  connectedStatements(subject8, doc, excludePredicateURIs) {
    excludePredicateURIs = excludePredicateURIs || [];
    let todo2 = [subject8];
    let done = {};
    let doneArcs = {};
    let result6 = [];
    let self2 = this;
    let follow = function(x) {
      let queue = function(x2) {
        if (x2.termType === "BlankNode" && !done[x2.value]) {
          done[x2.value] = true;
          todo2.push(x2);
        }
      };
      let sts = self2.statementsMatching(null, null, x, doc).concat(self2.statementsMatching(x, null, null, doc));
      sts = sts.filter(function(st2) {
        if (excludePredicateURIs[st2.predicate.value]) return false;
        let hash2 = st2.toNT();
        if (doneArcs[hash2]) return false;
        doneArcs[hash2] = true;
        return true;
      });
      sts.forEach(function(st2) {
        queue(st2.subject);
        queue(st2.object);
      });
      result6 = result6.concat(sts);
    };
    while (todo2.length) {
      follow(todo2.shift());
    }
    return result6;
  }
  /**
   * Creates a new empty formula
   *
   * @param _features - Not applicable, but necessary for typing to pass
   */
  formula(_features) {
    return new _Formula();
  }
  /**
   * Transforms an NTriples string format into a Node.
   * The blank node bit should not be used on program-external values; designed
   * for internal work such as storing a blank node id in an HTML attribute.
   * This will only parse the strings generated by the various toNT() methods.
   */
  fromNT(str) {
    let dt, k, lang;
    switch (str[0]) {
      case "<":
        return this.sym(str.slice(1, -1));
      case '"':
        lang = void 0;
        dt = void 0;
        k = str.lastIndexOf('"');
        if (k < str.length - 1) {
          if (str[k + 1] === "@") {
            lang = str.slice(k + 2);
          } else if (str.slice(k + 1, k + 3) === "^^") {
            dt = this.fromNT(str.slice(k + 3));
          } else {
            throw new Error("Can't convert string from NT: " + str);
          }
        }
        str = str.slice(1, k);
        str = str.replace(/\\"/g, '"');
        str = str.replace(/\\n/g, "\n");
        str = str.replace(/\\\\/g, "\\");
        return this.rdfFactory.literal(str, lang || dt);
      case "_":
        return this.rdfFactory.blankNode(str.slice(2));
      case "?":
        return new Variable(str.slice(1));
    }
    throw new Error("Can't convert from NT: " + str);
  }
  /** Returns true if this formula holds the specified statement(s) */
  holds(s, p, o, g) {
    let i;
    if (arguments.length === 1) {
      if (!s) {
        return true;
      }
      if (s instanceof Array) {
        for (i = 0; i < s.length; i++) {
          if (!this.holds(s[i])) {
            return false;
          }
        }
        return true;
      } else if (isStatement(s)) {
        return this.holds(s.subject, s.predicate, s.object, s.graph);
      } else if (s.statements) {
        return this.holds(s.statements);
      }
    }
    let st2 = this.anyStatementMatching(s, p, o, g);
    return st2 != null;
  }
  /**
   * Returns true if this formula holds the specified {statement}
   */
  holdsStatement(statement2) {
    return this.holds(statement2.subject, statement2.predicate, statement2.object, statement2.graph);
  }
  /**
   * Used by the n3parser to generate list elements
   * @param values - The values of the collection
   * @param context - The store
   * @return {BlankNode|Collection} - The term for the statement
   */
  list(values2, context4) {
    if (context4.rdfFactory.supports["COLLECTIONS"]) {
      const collection5 = context4.rdfFactory.collection();
      values2.forEach(function(val) {
        collection5.append(val);
      });
      return collection5;
    } else {
      const node3 = context4.rdfFactory.blankNode();
      const statements = arrayToStatements(context4.rdfFactory, node3, values2);
      context4.addAll(statements);
      return node3;
    }
  }
  /**
   * Transform a collection of NTriple URIs into their URI strings
   * @param t - Some iterable collection of NTriple URI strings
   * @return A collection of the URIs as strings
   * todo: explain why it is important to go through NT
   */
  NTtoURI(t) {
    let k, v2;
    let uris = {};
    for (k in t) {
      if (!t.hasOwnProperty(k)) continue;
      v2 = t[k];
      if (k[0] === "<") {
        uris[k.slice(1, -1)] = v2;
      }
    }
    return uris;
  }
  /**
   * Serializes this formula
   * @param base - The base string
   * @param contentType - The content type of the syntax to use
   * @param provenance - The provenance URI
   * @param options  - options to pass to the serializer, as defined in serialize method
   */
  serialize(base2, contentType4, provenance2, options) {
    return serialize(provenance2, this, base2, contentType4, void 0, options);
  }
  /**
   * Creates a new formula with the substituting bindings applied
   * @param bindings - The bindings to substitute
   */
  substitute(bindings) {
    let statementsCopy = this.statements.map(function(ea) {
      return ea.substitute(bindings);
    });
    const y = new _Formula();
    y.addAll(statementsCopy);
    return y;
  }
  sym(uri6, name9) {
    if (name9) {
      throw new Error("This feature (kb.sym with 2 args) is removed. Do not assume prefix mappings.");
    }
    return this.rdfFactory.namedNode(uri6);
  }
  /**
   * Gets the node matching the specified pattern. Throws when no match could be made.
   * @param s - The subject
   * @param p - The predicate
   * @param o - The object
   * @param g - The graph that contains the statement
   */
  the(s, p, o, g) {
    let x = this.any(s, p, o, g);
    if (x == null) {
      log_default.error("No value found for the() {" + s + " " + p + " " + o + "}.");
    }
    return x;
  }
  /**
   * RDFS Inference
   * These are hand-written implementations of a backward-chaining reasoner
   * over the RDFS axioms.
   * @param seeds - A hash of NTs of classes to start with
   * @param predicate - The property to trace though
   * @param inverse - Trace inverse direction
   */
  transitiveClosure(seeds, predicate4, inverse3) {
    let elt, i, len, s, sups, t;
    let agenda2 = {};
    Object.assign(agenda2, seeds);
    let done = {};
    while (true) {
      t = (function() {
        for (let p in agenda2) {
          if (!agenda2.hasOwnProperty(p)) continue;
          return p;
        }
      })();
      if (t == null) {
        return done;
      }
      sups = inverse3 ? this.each(void 0, predicate4, this.fromNT(t)) : this.each(this.fromNT(t), predicate4);
      for (i = 0, len = sups.length; i < len; i++) {
        elt = sups[i];
        s = elt.toNT();
        if (s in done) {
          continue;
        }
        if (s in agenda2) {
          continue;
        }
        agenda2[s] = agenda2[t];
      }
      done[t] = agenda2[t];
      delete agenda2[t];
    }
  }
  /**
   * Finds the types in the list which have no *stored* supertypes
   * We exclude the universal class, owl:Things and rdf:Resource, as it is
   * information-free.
   * @param types - The types
   */
  topTypeURIs(types2) {
    let i;
    let j;
    let k;
    let len;
    let n3;
    let ref;
    let tops;
    let v2;
    tops = [];
    for (k in types2) {
      if (!types2.hasOwnProperty(k)) continue;
      v2 = types2[k];
      n3 = 0;
      ref = this.each(this.rdfFactory.namedNode(k), this.rdfFactory.namedNode("http://www.w3.org/2000/01/rdf-schema#subClassOf"));
      for (i = 0, len = ref.length; i < len; i++) {
        j = ref[i];
        if (j.uri !== "http://www.w3.org/2000/01/rdf-schema#Resource") {
          n3++;
          break;
        }
      }
      if (!n3) {
        tops[k] = v2;
      }
    }
    if (tops["http://www.w3.org/2000/01/rdf-schema#Resource"]) {
      delete tops["http://www.w3.org/2000/01/rdf-schema#Resource"];
    }
    if (tops["http://www.w3.org/2002/07/owl#Thing"]) {
      delete tops["http://www.w3.org/2002/07/owl#Thing"];
    }
    return tops;
  }
  /**
   * Serializes this formula to a string
   */
  toString() {
    return "{" + this.statements.join("\n") + "}";
  }
  /**
   * Gets a new variable
   * @param name - The variable's name
   */
  variable(name9) {
    return new Variable(name9);
  }
  /**
   * Gets the number of statements in this formula that matches the specified pattern
   * @param s - The subject
   * @param p - The predicate
   * @param o - The object
   * @param g - The graph that contains the statement
   */
  whether(s, p, o, g) {
    return this.statementsMatching(s, p, o, g, false).length;
  }
};

// node_modules/rdflib/esm/node.js
Node2.fromValue = fromValue;
var node_default = Node2;
var ns = {
  xsd: Namespace("http://www.w3.org/2001/XMLSchema#")
};
Node2.toJS = function(term3) {
  if (isCollection(term3)) {
    return term3.elements.map(Node2.toJS);
  }
  if (!isLiteral(term3)) return term3;
  if (term3.datatype.equals(ns.xsd("boolean"))) {
    return term3.value === "1" || term3.value === "true";
  }
  if (term3.datatype.equals(ns.xsd("dateTime")) || term3.datatype.equals(ns.xsd("date"))) {
    return new Date(term3.value);
  }
  if (term3.datatype.equals(ns.xsd("integer")) || term3.datatype.equals(ns.xsd("float")) || term3.datatype.equals(ns.xsd("decimal"))) {
    return Number(term3.value);
  }
  return term3.value;
};

// node_modules/rdflib/esm/query.js
var Query = class {
  constructor(name9, id4) {
    this.pat = new IndexedFormula();
    this.vars = [];
    this.name = name9;
    this.id = id4;
  }
};
function indexedFormulaQuery(myQuery, callback, fetcher2, onDone) {
  function bindingDebug(b) {
    var str = "";
    var v2;
    for (v2 in b) {
      if (b.hasOwnProperty(v2)) {
        str += "    " + v2 + " -> " + b[v2];
      }
    }
    return str;
  }
  function bindingsDebug(nbs) {
    var str = "Bindings: ";
    var i;
    var n3 = nbs.length;
    for (i = 0; i < n3; i++) {
      str += bindingDebug(nbs[i][0]) + ";\n	";
    }
    return str;
  }
  function unifyTerm(self2, other2, bindings, formula2) {
    var actual2 = bindings[self2];
    if (actual2 === void 0) {
      if (self2.isVar) {
        var b = [];
        b[self2] = other2;
        return [[b, null]];
      }
      actual2 = self2;
    }
    if (!actual2.complexType) {
      if (formula2.redirections[actual2]) {
        actual2 = formula2.redirections[actual2];
      }
      if (formula2.redirections[other2]) {
        other2 = formula2.redirections[other2];
      }
      if (actual2.equals(other2) || actual2.uri && actual2.uri === defaultGraphURI) {
        return [[[], null]];
      }
      return [];
    }
    if (self2 instanceof Array) {
      if (!(other2 instanceof Array)) {
        return [];
      }
      return unifyContents(self2, other2, bindings);
    }
    throw new Error("query.js: oops - code not written yet");
  }
  function unifyContents(self2, other2, bindings, formula2) {
    var nbs2;
    if (self2.length !== other2.length) {
      return [];
    }
    if (!self2.length) {
      return [[[], null]];
    }
    var nbs = unifyTerm(self2[0], other2[0], bindings, formula2);
    if (nbs.length === 0) {
      return nbs;
    }
    var res = [];
    var i;
    var n3 = nbs.length;
    var nb;
    var j;
    var m;
    var v2;
    var nb2;
    var bindings2;
    for (i = 0; i < n3; i++) {
      nb = nbs[i][0];
      bindings2 = [];
      for (v2 in nb) {
        if (nb.hasOwnProperty(v2)) {
          bindings2[v2] = nb[v2];
        }
      }
      for (v2 in bindings) {
        if (bindings.hasOwnProperty(v2)) {
          bindings2[v2] = bindings[v2];
        }
      }
      nbs2 = unifyContents(self2.slice(1), other2.slice(1), bindings2, formula2);
      m = nbs2.length;
      for (j = 0; j < m; j++) {
        nb2 = nbs2[j][0];
        for (v2 in nb) {
          if (nb.hasOwnProperty(v2)) {
            nb2[v2] = nb[v2];
          }
        }
        res.push([nb2, null]);
      }
    }
    return res;
  }
  function bind2(x, binding2) {
    var y = binding2[x];
    if (y === void 0) {
      return x;
    }
    return y;
  }
  function union2(a, b) {
    var c = {};
    var x;
    for (x in a) {
      if (a.hasOwnProperty(x)) {
        c[x] = a[x];
      }
    }
    for (x in b) {
      if (b.hasOwnProperty(x)) {
        c[x] = b[x];
      }
    }
    return c;
  }
  function OptionalBranchJunction(originalCallback, trunkBindings) {
    this.trunkBindings = trunkBindings;
    this.originalCallback = originalCallback;
    this.branches = [];
    return this;
  }
  OptionalBranchJunction.prototype.checkAllDone = function() {
    var i;
    for (i = 0; i < this.branches.length; i++) {
      if (!this.branches[i].done) {
        return;
      }
    }
    log_default.debug("OPTIONAL BIDNINGS ALL DONE:");
    this.doCallBacks(this.branches.length - 1, this.trunkBindings);
  };
  OptionalBranchJunction.prototype.doCallBacks = function(b, bindings) {
    var j;
    if (b < 0) {
      return this.originalCallback(bindings);
    }
    for (j = 0; j < this.branches[b].results.length; j++) {
      this.doCallBacks(b - 1, union2(bindings, this.branches[b].results[j]));
    }
  };
  function MandatoryBranch(callback2, onDone2) {
    this.count = 0;
    this.success = false;
    this.done = false;
    this.callback = callback2;
    this.onDone = onDone2;
    return this;
  }
  MandatoryBranch.prototype.reportMatch = function(bindings) {
    this.callback(bindings);
    this.success = true;
  };
  MandatoryBranch.prototype.reportDone = function() {
    this.done = true;
    log_default.info("Mandatory query branch finished.***");
    if (this.onDone !== void 0) {
      this.onDone();
    }
  };
  var OptionalBranch = function(junction) {
    this.count = 0;
    this.done = false;
    this.results = [];
    this.junction = junction;
    junction.branches.push(this);
    return this;
  };
  OptionalBranch.prototype.reportMatch = function(bindings) {
    this.results.push(bindings);
  };
  OptionalBranch.prototype.reportDone = function() {
    log_default.debug("Optional branch finished - results.length = " + this.results.length);
    if (this.results.length === 0) {
      this.results.push({});
      log_default.debug("Optional branch FAILED - that's OK.");
    }
    this.done = true;
    this.junction.checkAllDone();
  };
  function prepare(f2, item4, bindings) {
    var terms, termIndex, i, ind;
    item4.nvars = 0;
    item4.index = null;
    terms = [item4.subject, item4.predicate, item4.object, item4.why];
    ind = [f2.subjectIndex, f2.predicateIndex, f2.objectIndex, f2.whyIndex];
    for (i = 0; i < 4; i++) {
      let t = terms[i];
      if (t.uri && t.uri === defaultGraphURI) {
      } else if (t.isVar && !(bindings[t] !== void 0)) {
        item4.nvars++;
      } else {
        t = bind2(terms[i], bindings);
        if (f2.redirections[f2.id(t)]) {
          t = f2.redirections[f2.id(t)];
        }
        termIndex = ind[i][f2.id(t)];
        if (!termIndex) {
          item4.index = [];
          return false;
        }
        if (item4.index === null || item4.index.length > termIndex.length) {
          item4.index = termIndex;
        }
      }
    }
    if (item4.index === null) {
      item4.index = f2.statements;
    }
    return true;
  }
  function easiestQuery(self2, other2) {
    if (self2.nvars !== other2.nvars) {
      return self2.nvars - other2.nvars;
    }
    return self2.index.length - other2.index.length;
  }
  var matchIndex = 0;
  var match = function(f2, g, bindingsSoFar, level2, fetcher3, localCallback, branch3) {
    log_default.debug("Match begins, Branch count now: " + branch3.count + " for " + branch3.pattern_debug);
    var pattern7 = g.statements;
    if (pattern7.length === 0) {
      log_default.debug("FOUND MATCH WITH BINDINGS:" + bindingDebug(bindingsSoFar));
      if (g.optional.length === 0) {
        branch3.reportMatch(bindingsSoFar);
      } else {
        log_default.debug("OPTIONAL: " + g.optional);
        var junction = new OptionalBranchJunction(callback, bindingsSoFar);
        var br = [];
        var b;
        for (b = 0; b < g.optional.length; b++) {
          br[b] = new OptionalBranch(junction);
          br[b].pattern_debug = g.optional[b];
        }
        for (b = 0; b < g.optional.length; b++) {
          br[b].count = br[b].count + 1;
          match(f2, g.optional[b], bindingsSoFar, "", fetcher3, callback, br[b]);
        }
      }
      branch3.count--;
      log_default.debug("Match ends -- success , Branch count now: " + branch3.count + " for " + branch3.pattern_debug);
      return;
    }
    var item4;
    var i;
    var n3 = pattern7.length;
    if (fetcher3) {
      var id4 = "match" + matchIndex++;
      var fetchResource = function(requestedTerm, id5) {
        var docuri = requestedTerm.uri.split("#")[0];
        fetcher3.nowOrWhenFetched(docuri, void 0, function(ok2, body, xhr) {
          if (!ok2) {
            console.log("Error following link to <" + requestedTerm.uri + "> in query: " + body);
          }
          match(
            f2,
            g,
            bindingsSoFar,
            level2,
            fetcher3,
            // match not match2 to look up any others necessary.
            localCallback,
            branch3
          );
        });
      };
      for (i = 0; i < n3; i++) {
        item4 = pattern7[i];
        if (bindingsSoFar[item4.subject] !== void 0 && bindingsSoFar[item4.subject].uri && fetcher3 && fetcher3.getState(docpart(bindingsSoFar[item4.subject].uri)) === "unrequested") {
          fetchResource(bindingsSoFar[item4.subject], id4);
          return;
        }
        if (bindingsSoFar[item4.object] !== void 0 && bindingsSoFar[item4.object].uri && fetcher3 && fetcher3.getState(docpart(bindingsSoFar[item4.object].uri)) === "unrequested") {
          fetchResource(bindingsSoFar[item4.object], id4);
          return;
        }
      }
    }
    match2(f2, g, bindingsSoFar, level2, fetcher3, localCallback, branch3);
  };
  var constraintsSatisfied = function(bindings, constraints2) {
    var res = true;
    var x;
    var test2;
    for (x in bindings) {
      if (bindings.hasOwnProperty(x)) {
        if (constraints2[x]) {
          test2 = constraints2[x].test;
          if (test2 && !test2(bindings[x])) {
            res = false;
          }
        }
      }
    }
    return res;
  };
  var match2 = function(f2, g, bindingsSoFar, level2, fetcher3, callback2, branch3) {
    var pattern7 = g.statements;
    var n3 = pattern7.length;
    var i;
    var k;
    var nk;
    var v2;
    var bindings2;
    var newBindings1;
    var item4;
    for (i = 0; i < n3; i++) {
      item4 = pattern7[i];
      prepare(f2, item4, bindingsSoFar);
    }
    pattern7.sort(easiestQuery);
    item4 = pattern7[0];
    var rest3 = f2.formula();
    rest3.optional = g.optional;
    rest3.constraints = g.constraints;
    rest3.statements = pattern7.slice(1);
    log_default.debug(level2 + "match2 searching " + item4.index.length + " for " + item4 + "; bindings so far=" + bindingDebug(bindingsSoFar));
    var c;
    var nc = item4.index.length;
    var nbs1;
    var st2;
    var onward = 0;
    for (c = 0; c < nc; c++) {
      st2 = item4.index[c];
      nbs1 = unifyContents([item4.subject, item4.predicate, item4.object, item4.why], [st2.subject, st2.predicate, st2.object, st2.why], bindingsSoFar, f2);
      log_default.info(level2 + " From first: " + nbs1.length + ": " + bindingsDebug(nbs1));
      nk = nbs1.length;
      for (k = 0; k < nk; k++) {
        bindings2 = [];
        newBindings1 = nbs1[k][0];
        if (!constraintsSatisfied(newBindings1, g.constraints)) {
          log_default.debug("Branch count CS: " + branch3.count);
        } else {
          for (v2 in newBindings1) {
            if (newBindings1.hasOwnProperty(v2)) {
              bindings2[v2] = newBindings1[v2];
            }
          }
          for (v2 in bindingsSoFar) {
            if (bindingsSoFar.hasOwnProperty(v2)) {
              bindings2[v2] = bindingsSoFar[v2];
            }
          }
          branch3.count++;
          onward++;
          match(f2, rest3, bindings2, level2 + "  ", fetcher3, callback2, branch3);
        }
      }
    }
    branch3.count--;
    if (onward === 0) {
      log_default.debug("Match2 fails completely on " + item4);
    }
    log_default.debug("Match2 ends, Branch count: " + branch3.count + " for " + branch3.pattern_debug);
    if (branch3.count === 0) {
      log_default.debug("Branch finished.");
      branch3.reportDone();
    }
  };
  var f = this;
  log_default.debug("Query on " + this.statements.length);
  var trunck = new MandatoryBranch(callback, onDone);
  trunck.count++;
  if (myQuery.sync) {
    match(f, myQuery.pat, myQuery.pat.initBindings, "", fetcher2, callback, trunck);
  } else {
    setTimeout(function() {
      match(f, myQuery.pat, myQuery.pat.initBindings, "", fetcher2, callback, trunck);
    }, 0);
  }
}

// node_modules/rdflib/esm/store.js
var owlNamespaceURI = "http://www.w3.org/2002/07/owl#";
function handleFP(formula2, subj, pred, obj) {
  var o1 = formula2.any(subj, pred, void 0);
  if (!o1) {
    return false;
  }
  formula2.equate(o1, obj);
  return true;
}
function handleIFP(formula2, subj, pred, obj) {
  var s1 = formula2.any(void 0, pred, obj);
  if (!s1) {
    return false;
  }
  formula2.equate(s1, subj);
  return true;
}
function handleRDFType(formula2, subj, pred, obj, why) {
  if (formula2.typeCallback) {
    formula2.typeCallback(formula2, obj, why);
  }
  var x = formula2.classActions[formula2.id(obj)];
  var done = false;
  if (x) {
    for (var i = 0; i < x.length; i++) {
      done = done || x[i](formula2, subj, pred, obj, why);
    }
  }
  return done;
}
var IndexedFormula = class _IndexedFormula extends Formula {
  /**
   * Creates a new formula
   * @param features - What sort of automatic processing to do? Array of string
   * @param features.sameAs - Smush together A and B nodes whenever { A sameAs B }
   * @param opts
   * @param [opts.rdfFactory] - The data factory that should be used by the store
   * @param [opts.rdfArrayRemove] - Function which removes statements from the store
   * @param [opts.dataCallback] - Callback when a statement is added to the store, will not trigger when adding duplicates
   */
  constructor(features, opts = {}) {
    super(void 0, void 0, void 0, void 0, opts);
    _defineProperty(this, "updater", void 0);
    _defineProperty(this, "namespaces", void 0);
    _defineProperty(this, "classActions", void 0);
    _defineProperty(this, "propertyActions", void 0);
    _defineProperty(this, "redirections", void 0);
    _defineProperty(this, "aliases", void 0);
    _defineProperty(this, "HTTPRedirects", void 0);
    _defineProperty(this, "subjectIndex", void 0);
    _defineProperty(this, "predicateIndex", void 0);
    _defineProperty(this, "objectIndex", void 0);
    _defineProperty(this, "whyIndex", void 0);
    _defineProperty(this, "index", void 0);
    _defineProperty(this, "features", void 0);
    _defineProperty(this, "_universalVariables", void 0);
    _defineProperty(this, "_existentialVariables", void 0);
    _defineProperty(this, "rdfArrayRemove", void 0);
    _defineProperty(this, "dataCallbacks", []);
    _defineProperty(this, "dataRemovalCallbacks", []);
    this.propertyActions = {};
    this.classActions = {};
    this.redirections = [];
    this.aliases = [];
    this.HTTPRedirects = [];
    this.subjectIndex = [];
    this.predicateIndex = [];
    this.objectIndex = [];
    this.whyIndex = [];
    this.index = [this.subjectIndex, this.predicateIndex, this.objectIndex, this.whyIndex];
    this.namespaces = {};
    this.features = features || [
      // By default, devs do not expect these features.
      // See https://github.com/linkeddata/rdflib.js/issues/458
      //      'sameAs',
      //      'InverseFunctionalProperty',
      //      'FunctionalProperty',
    ];
    this.rdfArrayRemove = opts.rdfArrayRemove || RDFArrayRemove;
    if (opts.dataCallback) {
      this.dataCallbacks = [opts.dataCallback];
    }
    if (opts.dataRemovalCallback) {
      this.dataRemovalCallbacks = [opts.dataRemovalCallback];
    }
    this.initPropertyActions(this.features);
  }
  /**
   * Gets the URI of the default graph
   */
  static get defaultGraphURI() {
    return defaultGraphURI;
  }
  /**
   * Gets this graph with the bindings substituted
   * @param bindings The bindings
   */
  substitute(bindings) {
    var statementsCopy = this.statements.map(function(ea) {
      return ea.substitute(bindings);
    });
    var y = new _IndexedFormula();
    y.add(statementsCopy);
    return y;
  }
  /**
   * Add a callback which will be triggered after a statement has been added to the store.
   * @param cb
   */
  addDataCallback(cb) {
    this.dataCallbacks.push(cb);
  }
  addDataRemovalCallback(cb) {
    this.dataRemovalCallbacks.push(cb);
  }
  /**
   * Apply a set of statements to be deleted and to be inserted
   *
   * @param patch - The set of statements to be deleted and to be inserted
   * @param target - The name of the document to patch
   * @param patchCallback - Callback to be called when patching is complete
   */
  applyPatch(patch, target6, patchCallback) {
    var targetKB = this;
    var ds;
    var binding2 = null;
    function doPatch(onDonePatch) {
      if (patch["delete"]) {
        ds = patch["delete"];
        if (binding2) ds = ds.substitute(binding2);
        ds = ds.statements;
        var bad = [];
        var ds2 = ds.map(function(st2) {
          var sts = targetKB.statementsMatching(st2.subject, st2.predicate, st2.object, target6);
          if (sts.length === 0) {
            bad.push(st2);
            return null;
          } else {
            return sts[0];
          }
        });
        if (bad.length) {
          return patchCallback("Could not find to delete: " + bad.join("\n or "));
        }
        ds2.map(function(st2) {
          targetKB.remove(st2);
        });
      }
      if (patch["insert"]) {
        ds = patch["insert"];
        if (binding2) ds = ds.substitute(binding2);
        ds = ds.statements;
        ds.map(function(st2) {
          st2.graph = target6;
          targetKB.add(st2.subject, st2.predicate, st2.object, st2.graph);
        });
      }
      onDonePatch();
    }
    if (patch.where) {
      var query4 = new Query("patch");
      query4.pat = patch.where;
      query4.pat.statements.map(function(st2) {
        st2.graph = new NamedNode(target6.value);
      });
      query4.sync = true;
      var bindingsFound = [];
      targetKB.query(query4, function onBinding(binding3) {
        bindingsFound.push(binding3);
      }, targetKB.fetcher, function onDone() {
        if (bindingsFound.length === 0) {
          return patchCallback("No match found to be patched:" + patch.where);
        }
        if (bindingsFound.length > 1) {
          return patchCallback("Patch ambiguous. No patch done.");
        }
        binding2 = bindingsFound[0];
        doPatch(patchCallback);
      });
    } else {
      doPatch(patchCallback);
    }
  }
  /**
   * N3 allows for declaring blank nodes, this function enables that support
   *
   * @param x The blank node to be declared, supported in N3
   */
  declareExistential(x) {
    if (!this._existentialVariables) this._existentialVariables = [];
    this._existentialVariables.push(x);
    return x;
  }
  /**
   * @param features
   */
  initPropertyActions(features) {
    this.propertyActions[this.rdfFactory.id(this.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"))] = [handleRDFType];
    if (ArrayIndexOf(features, "sameAs") >= 0) {
      this.propertyActions[this.rdfFactory.id(this.rdfFactory.namedNode(`${owlNamespaceURI}sameAs`))] = [function(formula2, subj, pred, obj, why) {
        formula2.equate(subj, obj);
        return true;
      }];
    }
    if (ArrayIndexOf(features, "InverseFunctionalProperty") >= 0) {
      this.classActions[this.rdfFactory.id(this.rdfFactory.namedNode(`${owlNamespaceURI}InverseFunctionalProperty`))] = [function(formula2, subj, pred, obj, addFn) {
        return formula2.newPropertyAction(subj, handleIFP);
      }];
    }
    if (ArrayIndexOf(features, "FunctionalProperty") >= 0) {
      this.classActions[this.rdfFactory.id(this.rdfFactory.namedNode(`${owlNamespaceURI}FunctionalProperty`))] = [function(formula2, subj, proj, obj, addFn) {
        return formula2.newPropertyAction(subj, handleFP);
      }];
    }
  }
  /** @deprecated Use {add} instead */
  addStatement(st2) {
    this.add(st2.subject, st2.predicate, st2.object, st2.graph);
    return this.statements.length;
  }
  /**
   * Adds a triple (quad) to the store.
   *
   * @param subj - The thing about which the fact a relationship is asserted.
   *        Also accepts a statement or an array of Statements.
   * @param pred - The relationship which is asserted
   * @param obj - The object of the relationship, e.g. another thing or a value. If passed a string, this will become a literal.
   * @param why - The document in which the triple (S,P,O) was or will be stored on the web
   * @returns The statement added to the store, or the store
   */
  add(subj, pred, obj, why) {
    var i;
    if (arguments.length === 1) {
      if (subj instanceof Array) {
        for (i = 0; i < subj.length; i++) {
          this.add(subj[i]);
        }
      } else if (isQuad(subj)) {
        this.add(subj.subject, subj.predicate, subj.object, subj.graph);
      } else if (isStore(subj)) {
        this.add(subj.statements);
      }
      return this;
    }
    var actions;
    var st2;
    if (!why) {
      why = this.fetcher ? this.fetcher.appNode : this.rdfFactory.defaultGraph();
    }
    if (typeof subj == "string") {
      subj = this.rdfFactory.namedNode(subj);
    }
    pred = node_default.fromValue(pred);
    const objNode = node_default.fromValue(obj);
    why = node_default.fromValue(why);
    if (!isRDFlibSubject(subj)) {
      throw new Error("Subject is not a subject type");
    }
    if (!isRDFlibPredicate(pred)) {
      throw new Error(`Predicate ${pred} is not a predicate type`);
    }
    if (!isRDFlibObject(objNode)) {
      throw new Error(`Object ${objNode} is not an object type`);
    }
    if (!isGraph(why)) {
      throw new Error("Why is not a graph type");
    }
    if (this.predicateCallback) {
      this.predicateCallback(this, pred, why);
    }
    var predHash = this.id(this.canon(pred));
    actions = this.propertyActions[predHash];
    var done = false;
    if (actions) {
      for (i = 0; i < actions.length; i++) {
        done = done || actions[i](this, subj, pred, objNode, why);
      }
    }
    if (this.holds(subj, pred, objNode, why)) {
      return null;
    }
    var hash2 = [this.id(this.canon(subj)), predHash, this.id(this.canon(objNode)), this.id(this.canon(why))];
    st2 = this.rdfFactory.quad(subj, pred, objNode, why);
    for (i = 0; i < 4; i++) {
      var ix = this.index[i];
      var h = hash2[i];
      if (!ix[h]) {
        ix[h] = [];
      }
      ix[h].push(st2);
    }
    this.statements.push(st2);
    for (const callback of this.dataCallbacks) {
      callback(st2);
    }
    return st2;
  }
  /**
   * Returns the symbol with canonical URI as smushed
   * @param term - An RDF node
   */
  canon(term3) {
    if (!term3) {
      return term3;
    }
    const y = this.redirections[this.id(term3)];
    if (y) {
      return y;
    }
    switch (term3.termType) {
      case BlankNodeTermType:
        return new BlankNode(term3.value);
      case CollectionTermType:
        return term3;
      // non-RDF/JS type, should just need to cast
      case DefaultGraphTermType:
        return new DefaultGraph();
      case EmptyTermType:
        return term3;
      case GraphTermType:
        return term3;
      case LiteralTermType:
        return new Literal(term3.value, term3.language, term3.datatype);
      case NamedNodeTermType:
        return new NamedNode(term3.value);
      case VariableTermType:
        return new Variable(term3.value);
      default:
        throw new Error(`Term Type not recognized for canonization: ${term3.termType}`);
    }
  }
  /**
   * Checks this formula for consistency
   */
  check() {
    this.checkStatementList(this.statements);
    for (var p = 0; p < 4; p++) {
      var ix = this.index[p];
      for (var key3 in ix) {
        if (ix.hasOwnProperty(key3)) {
          this.checkStatementList(ix[key3], p);
        }
      }
    }
  }
  /**
   * Checks a list of statements for consistency
   * @param sts - The list of statements to check
   * @param from - An index with the array ['subject', 'predicate', 'object', 'why']
   */
  checkStatementList(sts, from2) {
    if (from2 === void 0) {
      from2 = 0;
    }
    var names = ["subject", "predicate", "object", "why"];
    var origin4 = " found in " + names[from2] + " index.";
    var st2;
    for (var j = 0; j < sts.length; j++) {
      st2 = sts[j];
      var term3 = [st2.subject, st2.predicate, st2.object, st2.graph];
      var arrayContains = function(a, x) {
        for (var i = 0; i < a.length; i++) {
          if (a[i].subject.equals(x.subject) && a[i].predicate.equals(x.predicate) && a[i].object.equals(x.object) && a[i].why.equals(x.graph)) {
            return true;
          }
        }
      };
      for (var p = 0; p < 4; p++) {
        var c = this.canon(term3[p]);
        var h = this.id(c);
        if (!this.index[p][h]) {
        } else {
          if (!arrayContains(this.index[p][h], st2)) {
          }
        }
      }
      if (!arrayContains(this.statements, st2)) {
        throw new Error("Statement list does not statement " + st2 + "@" + st2.graph + origin4);
      }
    }
  }
  /**
   * Closes this formula (and return it)
   */
  close() {
    return this;
  }
  compareTerms(u1, u2) {
    if (Object.prototype.hasOwnProperty.call(u1, "compareTerm")) {
      return u1.compareTerm(u2);
    }
    if (class_order_default[u1.termType] < class_order_default[u2.termType]) {
      return -1;
    }
    if (class_order_default[u1.termType] > class_order_default[u2.termType]) {
      return 1;
    }
    if (u1.value < u2.value) {
      return -1;
    }
    if (u1.value > u2.value) {
      return 1;
    }
    return 0;
  }
  /**
   * replaces @template with @target and add appropriate triples
   * removes no triples by default and is a one-direction replication
   * @param template node to copy
   * @param target node to copy to
   * @param flags Whether or not to do a two-directional copy and/or delete triples
   */
  copyTo(template3, target6, flags3) {
    if (!flags3) flags3 = [];
    var statList = this.statementsMatching(template3);
    if (ArrayIndexOf(flags3, "two-direction") !== -1) {
      statList.concat(this.statementsMatching(void 0, void 0, template3));
    }
    for (var i = 0; i < statList.length; i++) {
      var st2 = statList[i];
      switch (st2.object.termType) {
        case "NamedNode":
          this.add(target6, st2.predicate, st2.object);
          break;
        case "Literal":
        case "BlankNode":
        // @ts-ignore Collections can appear here
        case "Collection":
          this.add(target6, st2.predicate, st2.object.copy(this));
      }
      if (ArrayIndexOf(flags3, "delete") !== -1) {
        this.remove(st2);
      }
    }
  }
  /**
   * Simplify graph in store when we realize two identifiers are equivalent
   * We replace the bigger with the smaller.
   * @param u1in The first node
   * @param u2in The second node
   */
  equate(u1in, u2in) {
    const u1 = this.canon(u1in);
    const u2 = this.canon(u2in);
    var d = this.compareTerms(u1, u2);
    if (!d) {
      return true;
    }
    if (d < 0) {
      return this.replaceWith(u2, u1);
    } else {
      return this.replaceWith(u1, u2);
    }
  }
  /**
   * Creates a new empty indexed formula
   * Only applicable for IndexedFormula, but TypeScript won't allow a subclass to override a property
   * @param features The list of features
   */
  formula(features) {
    return new _IndexedFormula(features);
  }
  /**
   * Returns the number of statements contained in this IndexedFormula.
   * (Getter proxy to this.statements).
   * Usage:
   *    ```
   *    var kb = rdf.graph()
   *    kb.length  // -> 0
   *    ```
   * @returns {Number}
   */
  get length() {
    return this.statements.length;
  }
  /**
   * Returns any quads matching the given arguments.
   * Standard RDFJS spec method for Source objects, implemented as an
   * alias to `statementsMatching()`
   * @param subject The subject
   * @param predicate The predicate
   * @param object The object
   * @param graph The graph that contains the statement
   */
  match(subject8, predicate4, object8, graph3) {
    return this.statementsMatching(node_default.fromValue(subject8), node_default.fromValue(predicate4), node_default.fromValue(object8), node_default.fromValue(graph3));
  }
  /**
   * Find out whether a given URI is used as symbol in the formula
   * @param uri The URI to look for
   */
  mentionsURI(uri6) {
    var hash2 = "<" + uri6 + ">";
    return !!this.subjectIndex[hash2] || !!this.objectIndex[hash2] || !!this.predicateIndex[hash2];
  }
  /**
   * Existentials are BNodes - something exists without naming
   * @param uri An URI
   */
  newExistential(uri6) {
    if (!uri6) return this.bnode();
    var x = this.sym(uri6);
    return this.declareExistential(x);
  }
  /**
   * Adds a new property action
   * @param pred the predicate that the function should be triggered on
   * @param action the function that should trigger
   */
  newPropertyAction(pred, action3) {
    var hash2 = this.id(pred);
    if (!this.propertyActions[hash2]) {
      this.propertyActions[hash2] = [];
    }
    this.propertyActions[hash2].push(action3);
    var toBeFixed = this.statementsMatching(void 0, pred, void 0);
    var done = false;
    for (var i = 0; i < toBeFixed.length; i++) {
      done = done || action3(this, toBeFixed[i].subject, pred, toBeFixed[i].object);
    }
    return done;
  }
  /**
   * Creates a new universal node
   * Universals are Variables
   * @param uri An URI
   */
  newUniversal(uri6) {
    var x = this.sym(uri6);
    if (!this._universalVariables) this._universalVariables = [];
    this._universalVariables.push(x);
    return x;
  }
  // convenience function used by N3 parser
  variable(name9) {
    return new Variable(name9);
  }
  /**
   * Find an unused id for a file being edited: return a symbol
   * (Note: Slow iff a lot of them -- could be O(log(k)) )
   * @param doc A document named node
   */
  nextSymbol(doc) {
    for (var i = 0; ; i++) {
      var uri6 = doc.value + "#n" + i;
      if (!this.mentionsURI(uri6)) return this.sym(uri6);
    }
  }
  /**
   * Query this store asynchronously, return bindings in callback
   *
   * @param myQuery The query to be run
   * @param callback Function to call when bindings
   * @param Fetcher | null  If you want the query to do link following
   * @param onDone OBSOLETE - do not use this // @@ Why not ?? Called when query complete
   */
  query(myQuery, callback, fetcher2, onDone) {
    return indexedFormulaQuery.call(this, myQuery, callback, fetcher2, onDone);
  }
  /**
   * Query this store synchronously and return bindings
   *
   * @param myQuery The query to be run
   */
  querySync(myQuery) {
    var results = [];
    function saveBinginds(bindings) {
      results.push(bindings);
    }
    function onDone() {
      done = true;
    }
    var done = false;
    myQuery.sync = true;
    indexedFormulaQuery.call(this, myQuery, saveBinginds, null, onDone);
    if (!done) {
      throw new Error("Sync query should have called done function");
    }
    return results;
  }
  /**
   * Removes one or multiple statement(s) from this formula
   * @param st - A Statement or array of Statements to remove
   */
  remove(st2) {
    if (st2 instanceof Array) {
      for (var i = 0; i < st2.length; i++) {
        this.remove(st2[i]);
      }
      return this;
    }
    if (isStore(st2)) {
      return this.remove(st2.statements);
    }
    var sts = this.statementsMatching(st2.subject, st2.predicate, st2.object, st2.graph);
    if (!sts.length) {
      throw new Error("Statement to be removed is not on store: " + st2);
    }
    this.removeStatement(sts[0]);
    return this;
  }
  /**
   * Removes all statements in a doc, along with the related metadata including request/response/status
   * @param doc - The document / graph
   */
  removeDocument(doc) {
    this.removeMetadata(doc);
    var sts = this.statementsMatching(void 0, void 0, void 0, doc).slice();
    for (var i = 0; i < sts.length; i++) {
      this.removeStatement(sts[i]);
    }
    this.removeMatches(doc, null, null);
    return this;
  }
  removeMetadata(doc) {
    const meta2 = this.sym("chrome://TheCurrentSession");
    const linkNamespaceURI = "http://www.w3.org/2007/ont/link#";
    const requests = this.statementsMatching(void 0, this.sym(`${linkNamespaceURI}requestedURI`), this.rdfFactory.literal(doc.value), meta2).map((st2) => st2.subject);
    for (var r = 0; r < requests.length; r++) {
      const request2 = requests[r];
      if (request2 != void 0) {
        let sts;
        const status10 = this.any(request2, this.sym(`${linkNamespaceURI}status`), null, meta2);
        if (status10 != void 0) {
          sts = this.statementsMatching(status10, this.sym(`${linkNamespaceURI}status`), null, meta2).slice();
          for (var i = 0; i < sts.length; i++) {
            this.removeStatement(sts[i]);
          }
        }
        const response6 = this.any(request2, this.sym(`${linkNamespaceURI}response`), null, meta2);
        if (response6 != void 0) {
          sts = this.statementsMatching(response6, null, null, meta2).slice();
          for (var i = 0; i < sts.length; i++) {
            this.removeStatement(sts[i]);
          }
        }
        sts = this.statementsMatching(request2, null, null, meta2).slice();
        for (var i = 0; i < sts.length; i++) {
          this.removeStatement(sts[i]);
        }
      }
    }
    this.removeMatches(this.sym(doc.value), null, null, meta2);
    return this;
  }
  /**
   * Remove all statements matching args (within limit) *
   * @param subj The subject
   * @param pred The predicate
   * @param obj The object
   * @param why The graph that contains the statement
   * @param limit The number of statements to remove
   */
  removeMany(subj, pred, obj, why, limit3) {
    var sts = this.statementsMatching(subj, pred, obj, why, false);
    var statements = [];
    for (var i = 0; i < sts.length; i++) statements.push(sts[i]);
    if (limit3) statements = statements.slice(0, limit3);
    for (i = 0; i < statements.length; i++) this.remove(statements[i]);
  }
  /**
   * Remove all matching statements
   * @param subject The subject
   * @param predicate The predicate
   * @param object The object
   * @param graph The graph that contains the statement
   */
  removeMatches(subject8, predicate4, object8, graph3) {
    this.removeMany(subject8, predicate4, object8, graph3);
    return this;
  }
  /**
   * Remove a particular statement object from the store
   *
   * @param st - a statement which is already in the store and indexed.
   *        Make sure you only use this for these.
   *        Otherwise, you should use remove() above.
   */
  removeStatement(st2) {
    var term3 = [st2.subject, st2.predicate, st2.object, st2.graph];
    for (var p = 0; p < 4; p++) {
      var c = this.canon(term3[p]);
      var h = this.id(c);
      if (!this.index[p][h]) {
      } else {
        this.rdfArrayRemove(this.index[p][h], st2);
      }
    }
    this.rdfArrayRemove(this.statements, st2);
    for (const callback of this.dataRemovalCallbacks) {
      callback(st2);
    }
    return this;
  }
  /**
   * Removes statements
   * @param sts The statements to remove
   */
  removeStatements(sts) {
    for (var i = 0; i < sts.length; i++) {
      this.remove(sts[i]);
    }
    return this;
  }
  /**
   * Replace big with small, obsoleted with obsoleting.
   */
  replaceWith(big, small) {
    var oldhash = this.id(big);
    var newhash = this.id(small);
    var moveIndex = function(ix) {
      var oldlist = ix[oldhash];
      if (!oldlist) {
        return;
      }
      var newlist = ix[newhash];
      if (!newlist) {
        ix[newhash] = oldlist;
      } else {
        ix[newhash] = oldlist.concat(newlist);
      }
      delete ix[oldhash];
    };
    for (var i = 0; i < 4; i++) {
      moveIndex(this.index[i]);
    }
    this.redirections[oldhash] = small;
    if (big.value) {
      if (!this.aliases[newhash]) {
        this.aliases[newhash] = [];
      }
      this.aliases[newhash].push(big);
      if (this.aliases[oldhash]) {
        for (i = 0; i < this.aliases[oldhash].length; i++) {
          this.redirections[this.id(this.aliases[oldhash][i])] = small;
          this.aliases[newhash].push(this.aliases[oldhash][i]);
        }
      }
      this.add(small, this.sym("http://www.w3.org/2007/ont/link#uri"), big);
      if (this.fetcher) {
        this.fetcher.nowKnownAs(big, small);
      }
    }
    moveIndex(this.classActions);
    moveIndex(this.propertyActions);
    return true;
  }
  /**
   * Return all equivalent URIs by which this is known
   * @param x A named node
   */
  allAliases(x) {
    var a = this.aliases[this.id(this.canon(x))] || [];
    a.push(this.canon(x));
    return a;
  }
  /**
   * Compare by canonical URI as smushed
   * @param x A named node
   * @param y Another named node
   */
  sameThings(x, y) {
    if (x.equals(y)) {
      return true;
    }
    var x1 = this.canon(x);
    if (!x1) return false;
    var y1 = this.canon(y);
    if (!y1) return false;
    return x1.value === y1.value;
  }
  setPrefixForURI(prefix3, nsuri) {
    if (prefix3 === "tab" && this.namespaces["tab"]) {
      return;
    }
    if (prefix3.slice(0, 2) === "ns" || prefix3.slice(0, 7) === "default") {
      return;
    }
    for (let existingPrefix in this.namespaces) {
      if (this.namespaces[existingPrefix] == nsuri) delete this.namespaces[existingPrefix];
    }
    this.namespaces[prefix3] = nsuri;
  }
  /** Search the Store
   *
   * ALL CONVENIENCE LOOKUP FUNCTIONS RELY ON THIS!
   * @param subj - A node to search for as subject, or if null, a wildcard
   * @param pred - A node to search for as predicate, or if null, a wildcard
   * @param obj - A node to search for as object, or if null, a wildcard
   * @param why - A node to search for as graph, or if null, a wildcard
   * @param justOne - flag - stop when found one rather than get all of them?
   * @returns An array of nodes which match the wildcard position
   */
  statementsMatching(subj, pred, obj, why, justOne) {
    var pat = [subj, pred, obj, why];
    var pattern7 = [];
    var hash2 = [];
    var wild = [];
    var given2 = [];
    var p;
    var list;
    for (p = 0; p < 4; p++) {
      pattern7[p] = this.canon(node_default.fromValue(pat[p]));
      if (!pattern7[p]) {
        wild.push(p);
      } else {
        given2.push(p);
        hash2[p] = this.id(pattern7[p]);
      }
    }
    if (given2.length === 0) {
      return this.statements;
    }
    if (given2.length === 1) {
      p = given2[0];
      list = this.index[p][hash2[p]];
      if (list && justOne) {
        if (list.length > 1) {
          list = list.slice(0, 1);
        }
      }
      list = list || [];
      return list;
    }
    var best = 1e10;
    var iBest;
    var i;
    for (i = 0; i < given2.length; i++) {
      p = given2[i];
      list = this.index[p][hash2[p]];
      if (!list) {
        return [];
      }
      if (list.length < best) {
        best = list.length;
        iBest = i;
      }
    }
    var pBest = given2[iBest];
    var possibles = this.index[pBest][hash2[pBest]];
    var check2 = given2.slice(0, iBest).concat(given2.slice(iBest + 1));
    var results = [];
    var parts = ["subject", "predicate", "object", "why"];
    for (var j = 0; j < possibles.length; j++) {
      var st2 = possibles[j];
      for (i = 0; i < check2.length; i++) {
        p = check2[i];
        if (!this.canon(st2[parts[p]]).equals(pattern7[p])) {
          st2 = null;
          break;
        }
      }
      if (st2 != null) {
        results.push(st2);
        if (justOne) break;
      }
    }
    return results;
  }
  /**
   * A list of all the URIs by which this thing is known
   * @param term
   */
  uris(term3) {
    var cterm = this.canon(term3);
    var terms = this.aliases[this.id(cterm)];
    if (!cterm.value) return [];
    var res = [cterm.value];
    if (terms) {
      for (var i = 0; i < terms.length; i++) {
        res.push(terms[i].uri);
      }
    }
    return res;
  }
  serialize(base2, contentType4, provenance2, options) {
    const namespaces = options?.namespaces ? {
      ...this.namespaces,
      ...options.namespaces
    } : {
      ...this.namespaces
    };
    options = {
      ...options || {},
      namespaces
    };
    return serialize(provenance2, this, base2, contentType4, void 0, options);
  }
};
_defineProperty(IndexedFormula, "handleRDFType", void 0);
IndexedFormula.handleRDFType = handleRDFType;

// node_modules/rdflib/esm/lists.js
var RDF = Namespace("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
function substituteInDoc(store, x, y, doc) {
  for (const quad3 of store.statementsMatching(y, null, null, doc)) {
    const newStatement = new Statement(x, quad3.predicate, quad3.object, doc);
    store.remove(quad3);
    store.add(newStatement);
  }
  for (const quad3 of store.statementsMatching(null, y, null, doc)) {
    store.remove(quad3);
    store.add(new Statement(quad3.subject, x, quad3.object, doc));
  }
  for (const quad3 of store.statementsMatching(null, null, y, doc)) {
    store.remove(quad3);
    store.add(new Statement(quad3.subject, quad3.predicate, x, doc));
  }
}
function substituteNillsInDoc(store, doc) {
  const x = RDF("nil");
  for (const quad3 of store.statementsMatching(x, null, null, doc)) {
    store.remove(quad3);
    const y = new Collection();
    store.add(new Statement(y, quad3.predicate, quad3.object, doc));
  }
  for (const quad3 of store.statementsMatching(null, null, x, doc)) {
    if (!quad3.predicate.sameTerm(RDF("rest"))) {
      store.remove(quad3);
      const y = new Collection();
      store.add(new Statement(quad3.subject, quad3.predicate, y, doc));
    }
  }
}
function convertFirstRestNil(store, doc) {
  function preceding(ele, listSoFar, trash) {
    const rests = store.statementsMatching(ele, RDF("rest"), null, doc);
    if (rests.length !== 1) throw new Error(`Bad list structure: no rest at ${ele}`);
    const firsts = store.statementsMatching(ele, RDF("first"), null, doc);
    if (firsts.length !== 1) throw new Error(`Bad list structure: rest but ${firsts.length} firsts at ${ele}`);
    const value8 = firsts[0].object;
    const total2 = [value8].concat(listSoFar);
    const totalTrash = trash.concat(rests).concat(firsts);
    const pres = store.statementsMatching(null, RDF("rest"), ele, doc);
    if (pres.length === 0) {
      const newList = new Collection(total2);
      store.remove(totalTrash);
      substituteInDoc(store, newList, ele, doc);
      return;
    }
    if (pres.length !== 1) throw new Error(`Bad list structure: ${pres.length} pres at ${ele}`);
    const pre = pres[0].subject;
    if (pre.termType !== "BlankNode") throw new Error(`Bad list element node ${pre} type: ${pre.termType} `);
    preceding(pre, total2, totalTrash);
    return;
  }
  substituteNillsInDoc(store, doc);
  const tails = store.statementsMatching(null, RDF("rest"), RDF("nil"), doc);
  tails.forEach((tail) => {
    if (tail.subject.termType !== "BlankNode") throw new Error(`Bad list element node ${tail.subject} type: ${tail.subject.termType} `);
    preceding(tail.subject, [], []);
  });
}

// node_modules/rdflib/esm/n3parser.js
function hexify2(str) {
  return encodeURI(str);
}
var Utf8 = {
  // public method for url encoding
  encode: function(string3) {
    string3 = string3.replace(/\r\n/g, "\n");
    var utftext = "";
    for (var n3 = 0; n3 < string3.length; n3++) {
      var c = string3.charCodeAt(n3);
      if (c < 128) {
        utftext += String.fromCharCode(c);
      } else if (c > 127 && c < 2048) {
        utftext += String.fromCharCode(c >> 6 | 192);
        utftext += String.fromCharCode(c & 63 | 128);
      } else {
        utftext += String.fromCharCode(c >> 12 | 224);
        utftext += String.fromCharCode(c >> 6 & 63 | 128);
        utftext += String.fromCharCode(c & 63 | 128);
      }
    }
    return utftext;
  },
  // public method for url decoding
  decode: function(utftext) {
    var string3 = "";
    var i = 0;
    while (i < utftext.length) {
      var c = utftext.charCodeAt(i);
      if (c < 128) {
        string3 += String.fromCharCode(c);
        i++;
      } else if (c > 191 && c < 224) {
        string3 += String.fromCharCode((c & 31) << 6 | utftext.charCodeAt(i + 1) & 63);
        i += 2;
      } else {
        string3 += String.fromCharCode((c & 15) << 12 | (utftext.charCodeAt(i + 1) & 63) << 6 | utftext.charCodeAt(i + 2) & 63);
        i += 3;
      }
    }
    return string3;
  }
};
var Logic_NS = "http://www.w3.org/2000/10/swap/log#";
var pyjslib_Tuple = function(theList) {
  return theList;
};
var pyjslib_List = function(theList) {
  return theList;
};
var pyjslib_Dict = function(listOfPairs) {
  if (listOfPairs.length > 0) throw "missing.js: oops nnonempty dict not imp";
  return [];
};
var pyjslib_len = function(s) {
  return s.length;
};
var pyjslib_slice = function(str, i, j) {
  if (typeof str.slice == "undefined") throw "@@ mising.js: No .slice function for " + str + " of type " + typeof str;
  if (typeof j == "undefined" || j == null) return str.slice(i);
  return str.slice(i, j);
};
var StopIteration = Error("dummy error stop iteration");
var pyjslib_Iterator = function(theList) {
  this.last = 0;
  this.li = theList;
  this.next = function() {
    if (this.last == this.li.length) throw StopIteration;
    return this.li[this.last++];
  };
  return this;
};
var string_find = function(str, s) {
  return str.indexOf(s);
};
var assertFudge = function(condition3, desc) {
  if (condition3) return;
  if (desc) throw "python Assertion failed: " + desc;
  throw "(python) Assertion failed.";
};
var stringFromCharCode = function(uesc) {
  return String.fromCharCode(uesc);
};
String.prototype.encode = function(encoding3) {
  if (encoding3 != "utf-8") throw "UTF8_converter: can only do utf-8";
  return Utf8.encode(this);
};
String.prototype.decode = function(encoding3) {
  if (encoding3 != "utf-8") throw "UTF8_converter: can only do utf-8";
  return this;
};
var uripath_join = function(base2, given2) {
  return join(given2, base2);
};
var becauseSubexpression = null;
var diag_tracking = 0;
var diag_chatty_flag = 0;
var diag_progress = function(str) {
};
var RDF_type_URI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
var RDF_nil_URI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil";
var DAML_sameAs_URI = "http://www.w3.org/2002/07/owl#sameAs";
var ADDED_HASH = "#";
var INTEGER_DATATYPE = "http://www.w3.org/2001/XMLSchema#integer";
var FLOAT_DATATYPE = "http://www.w3.org/2001/XMLSchema#double";
var DECIMAL_DATATYPE = "http://www.w3.org/2001/XMLSchema#decimal";
var DATE_DATATYPE = "http://www.w3.org/2001/XMLSchema#date";
var DATETIME_DATATYPE = "http://www.w3.org/2001/XMLSchema#dateTime";
var _notQNameChars = "	\r\n !\"#$%&'()*.,+/;<=>?@[\\]^`{|}~";
var _notNameChars = _notQNameChars + ":";
var eol = new RegExp("^[ \\t]*(#[^\\n]*)?\\r?\\n", "g");
var eof = new RegExp("^[ \\t]*(#[^\\n]*)?$", "g");
var ws = new RegExp("^[ \\t]*", "g");
var signed_integer = new RegExp("^[-+]?[0-9]+", "g");
var number_syntax = new RegExp("^([-+]?[0-9]+)(\\.[0-9]+)?([eE][-+]?[0-9]+)?", "g");
var datetime_syntax = new RegExp("^[0-9][0-9][0-9][0-9]-[0-9][0-9]-[0-9][0-9](T[0-9][0-9]:[0-9][0-9](:[0-9][0-9](\\.[0-9]*)?)?)?Z?");
var wsOrHash = new RegExp("[\\s#]");
var digitstring = new RegExp("^[0-9]+", "g");
var interesting = new RegExp('[\\\\\\r\\n\\"]', "g");
var langcode = new RegExp("^[a-zA-Z0-9]+(-[a-zA-Z0-9]+)*", "g");
function dotTerminatesName(str, i) {
  var next4 = str.charAt(i + 1);
  return next4 === "" || wsOrHash.test(next4);
}
function createSinkParser(store, openFormula, thisDoc, baseURI, genPrefix, metaURI, flags3, why) {
  return new SinkParser(store, openFormula, thisDoc, baseURI, genPrefix, metaURI, flags3, why);
}
var n3parser_default = createSinkParser;
var SinkParser = class {
  constructor(store, openFormula, thisDoc, baseURI, genPrefix, metaURI, flags3, why) {
    if (typeof openFormula == "undefined") openFormula = null;
    if (typeof thisDoc == "undefined") thisDoc = "";
    if (typeof baseURI == "undefined") baseURI = null;
    if (typeof genPrefix == "undefined") genPrefix = "";
    if (typeof metaURI == "undefined") metaURI = null;
    if (typeof flags3 == "undefined") flags3 = "";
    if (typeof why == "undefined") why = null;
    this._bindings = new pyjslib_Dict([]);
    this._flags = flags3;
    if (thisDoc != "") {
      assertFudge(thisDoc.indexOf(":") >= 0, "Document URI not absolute: " + thisDoc);
      this._bindings[""] = thisDoc + "#";
    }
    this._store = store;
    if (genPrefix) {
      store.setGenPrefix(genPrefix);
    }
    this._thisDoc = thisDoc;
    this.source = store.sym(thisDoc);
    this.lines = 0;
    this.statementCount = 0;
    this.hasNil = false;
    this.startOfLine = 0;
    this.previousLine = 0;
    this._genPrefix = genPrefix;
    this.keywords = new pyjslib_List(["a", "this", "bind", "has", "is", "of", "true", "false"]);
    this.keywordsSet = 0;
    this._anonymousNodes = new pyjslib_Dict([]);
    this._variables = new pyjslib_Dict([]);
    this._parentVariables = new pyjslib_Dict([]);
    this._reason = why;
    this._reason2 = null;
    if (diag_tracking) {
      this._reason2 = why_BecauseOfData(store.sym(thisDoc), this._reason);
    }
    if (baseURI) {
      this._baseURI = baseURI;
    } else {
      if (thisDoc) {
        this._baseURI = thisDoc;
      } else {
        this._baseURI = null;
      }
    }
    assertFudge(!this._baseURI || this._baseURI.indexOf(":") >= 0);
    if (!this._genPrefix) {
      if (this._thisDoc) {
        this._genPrefix = this._thisDoc + "#_g";
      } else {
        this._genPrefix = RDFSink_uniqueURI();
      }
    }
    if (openFormula == null) {
      if (this._thisDoc) {
        this._formula = store.formula(thisDoc + "#_formula");
      } else {
        this._formula = store.formula();
      }
    } else {
      this._formula = openFormula;
    }
    this._context = this._formula;
    this._parentContext = null;
  }
  here(i) {
    return this._genPrefix + "_L" + this.lines + "C" + (i - this.startOfLine + 1);
  }
  formula() {
    return this._formula;
  }
  loadStream(stream) {
    return this.loadBuf(stream.read());
  }
  loadBuf(buf) {
    this.startDoc();
    this.feed(buf);
    return this.endDoc();
  }
  feed(octets) {
    var str = octets.decode("utf-8");
    var i = 0;
    while (i >= 0) {
      var j = this.skipSpace(str, i);
      if (j < 0) {
        return;
      }
      var i = this.directiveOrStatement(str, j);
      if (i < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, j, "expected directive or statement");
      }
    }
  }
  directiveOrStatement(str, h) {
    var i = this.skipSpace(str, h);
    if (i < 0) {
      return i;
    }
    var j = this.directive(str, i);
    if (j >= 0) {
      return this.checkDot(str, j);
    }
    var j = this.statement(str, i);
    if (j >= 0) {
      return this.checkDot(str, j);
    }
    return j;
  }
  tok(tok, str, i) {
    var whitespace = "	\n\v\f\r ";
    if (str.slice(i, i + 1) == "@") {
      var i = i + 1;
    } else {
      if (ArrayIndexOf(this.keywords, tok) < 0) {
        return -1;
      }
    }
    var k = i + pyjslib_len(tok);
    if (str.slice(i, k) == tok && _notQNameChars.indexOf(str.charAt(k)) >= 0) {
      return k;
    } else {
      return -1;
    }
  }
  directive(str, i) {
    var j = this.skipSpace(str, i);
    if (j < 0) {
      return j;
    }
    var res = new pyjslib_List([]);
    var j = this.tok("bind", str, i);
    if (j > 0) {
      throw BadSyntax(this._thisDoc, this.lines, str, i, "keyword bind is obsolete: use @prefix");
    }
    var j = this.tok("keywords", str, i);
    if (j > 0) {
      var i = this.commaSeparatedList(str, j, res, false);
      if (i < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, i, "'@keywords' needs comma separated list of words");
      }
      this.setKeywords(pyjslib_slice(res, null, null));
      if (diag_chatty_flag > 80) {
        diag_progress("Keywords ", this.keywords);
      }
      return i;
    }
    var j = this.tok("forAll", str, i);
    if (j > 0) {
      var i = this.commaSeparatedList(str, j, res, true);
      if (i < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, i, "Bad variable list after @forAll");
      }
      var __x = new pyjslib_Iterator(res);
      try {
        while (true) {
          var x = __x.next();
          if (ArrayIndexOf(this._variables, x) < 0 || ArrayIndexOf(this._parentVariables, x) >= 0) {
            this._variables[x] = this._context.newUniversal(x);
          }
        }
      } catch (e) {
        if (e != StopIteration) {
          throw e;
        }
      }
      return i;
    }
    var j = this.tok("forSome", str, i);
    if (j > 0) {
      var i = this.commaSeparatedList(str, j, res, this.uri_ref2);
      if (i < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, i, "Bad variable list after @forSome");
      }
      var __x = new pyjslib_Iterator(res);
      try {
        while (true) {
          var x = __x.next();
          this._context.declareExistential(x);
        }
      } catch (e) {
        if (e != StopIteration) {
          throw e;
        }
      }
      return i;
    }
    var j = this.tok("prefix", str, i);
    if (j >= 0) {
      var t = new pyjslib_List([]);
      var i = this.qname(str, j, t);
      if (i < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, j, "expected qname after @prefix");
      }
      var j = this.uri_ref2(str, i, t);
      if (j < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, i, "expected <uriref> after @prefix _qname_");
      }
      var ns3 = t[1].uri;
      if (this._baseURI) {
        var ns3 = uripath_join(this._baseURI, ns3);
      } else {
        assertFudge(ns3.indexOf(":") >= 0, "With no base URI, cannot handle relative URI for NS");
      }
      assertFudge(ns3.indexOf(":") >= 0);
      this._bindings[t[0][0]] = ns3;
      this.bind(t[0][0], hexify2(ns3));
      return j;
    }
    var j = this.tok("base", str, i);
    if (j >= 0) {
      var t = new pyjslib_List([]);
      var i = this.uri_ref2(str, j, t);
      if (i < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, j, "expected <uri> after @base ");
      }
      var ns3 = t[0].uri;
      if (this._baseURI) {
        var ns3 = uripath_join(this._baseURI, ns3);
      } else {
        throw BadSyntax(this._thisDoc, this.lines, str, j, "With no previous base URI, cannot use relative URI in @base  <" + ns3 + ">");
      }
      assertFudge(ns3.indexOf(":") >= 0);
      this._baseURI = ns3;
      return i;
    }
    return -1;
  }
  bind(qn, uri6) {
    if (qn == "") {
    } else {
      this._store.setPrefixForURI(qn, uri6);
    }
  }
  setKeywords(k) {
    if (k == null) {
      this.keywordsSet = 0;
    } else {
      this.keywords = k;
      this.keywordsSet = 1;
    }
  }
  startDoc() {
  }
  /* Signal end of document and stop parsing. returns formula */
  endDoc() {
    if (this.hasNil && this._store.rdfFactory.supports["COLLECTIONS"]) {
      convertFirstRestNil(this._store, this.source);
    }
    return this._formula;
  }
  makeStatement(quad3) {
    quad3[0].add(quad3[2], quad3[1], quad3[3], this.source);
    if (quad3[2].uri && quad3[2].uri === RDF_nil_URI || quad3[3].uri && quad3[3].uri === RDF_nil_URI) {
      this.hasNil = true;
    }
    this.statementCount += 1;
  }
  statement(str, i) {
    var r = new pyjslib_List([]);
    var i = this.object(str, i, r);
    if (i < 0) {
      return i;
    }
    var j = this.property_list(str, i, r[0]);
    if (j < 0) {
      throw BadSyntax(this._thisDoc, this.lines, str, i, "expected propertylist");
    }
    return j;
  }
  subject(str, i, res) {
    return this.item(str, i, res);
  }
  verb(str, i, res) {
    var j = this.skipSpace(str, i);
    if (j < 0) {
      return j;
    }
    var r = new pyjslib_List([]);
    var j = this.tok("has", str, i);
    if (j >= 0) {
      var i = this.prop(str, j, r);
      if (i < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, j, "expected property after 'has'");
      }
      res.push(new pyjslib_Tuple(["->", r[0]]));
      return i;
    }
    var j = this.tok("is", str, i);
    if (j >= 0) {
      var i = this.prop(str, j, r);
      if (i < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, j, "expected <property> after 'is'");
      }
      var j = this.skipSpace(str, i);
      if (j < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, i, "End of file found, expected property after 'is'");
        return j;
      }
      var i = j;
      var j = this.tok("of", str, i);
      if (j < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, i, "expected 'of' after 'is' <prop>");
      }
      res.push(new pyjslib_Tuple(["<-", r[0]]));
      return j;
    }
    var j = this.tok("a", str, i);
    if (j >= 0) {
      res.push(new pyjslib_Tuple(["->", this._store.sym(RDF_type_URI)]));
      return j;
    }
    if (str.slice(i, i + 2) == "<=") {
      res.push(new pyjslib_Tuple(["<-", this._store.sym(Logic_NS + "implies")]));
      return i + 2;
    }
    if (str.slice(i, i + 1) == "=") {
      if (str.slice(i + 1, i + 2) == ">") {
        res.push(new pyjslib_Tuple(["->", this._store.sym(Logic_NS + "implies")]));
        return i + 2;
      }
      res.push(new pyjslib_Tuple(["->", this._store.sym(DAML_sameAs_URI)]));
      return i + 1;
    }
    if (str.slice(i, i + 2) == ":=") {
      res.push(new pyjslib_Tuple(["->", Logic_NS + "becomes"]));
      return i + 2;
    }
    var j = this.prop(str, i, r);
    if (j >= 0) {
      res.push(new pyjslib_Tuple(["->", r[0]]));
      return j;
    }
    if (str.slice(i, i + 2) == ">-" || str.slice(i, i + 2) == "<-") {
      throw BadSyntax(this._thisDoc, this.lines, str, j, ">- ... -> syntax is obsolete.");
    }
    return -1;
  }
  prop(str, i, res) {
    return this.item(str, i, res);
  }
  item(str, i, res) {
    return this.path(str, i, res);
  }
  blankNode(uri6) {
    return this._context.bnode(uri6, this._reason2);
  }
  path(str, i, res) {
    var j = this.nodeOrLiteral(str, i, res);
    if (j < 0) {
      return j;
    }
    while ("!^.".indexOf(str.slice(j, j + 1)) >= 0) {
      var ch = str.slice(j, j + 1);
      if (ch == ".") {
        if (dotTerminatesName(str, j)) {
          break;
        }
      }
      var subj = res.pop();
      var obj = this.blankNode(this.here(j));
      var j = this.node(str, j + 1, res);
      if (j < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, j, "EOF found in middle of path syntax");
      }
      var pred = res.pop();
      if (ch == "^") {
        this.makeStatement(new pyjslib_Tuple([this._context, pred, obj, subj]));
      } else {
        this.makeStatement(new pyjslib_Tuple([this._context, pred, subj, obj]));
      }
      res.push(obj);
    }
    return j;
  }
  anonymousNode(ln) {
    var term3 = this._anonymousNodes[ln];
    if (term3) {
      return term3;
    }
    var term3 = this._store.bnode(ln);
    this._anonymousNodes[ln] = term3;
    return term3;
  }
  node(str, i, res, subjectAlready) {
    if (typeof subjectAlready == "undefined") subjectAlready = null;
    var subj = subjectAlready;
    var j = this.skipSpace(str, i);
    if (j < 0) {
      return j;
    }
    var i = j;
    var ch = str.slice(i, i + 1);
    if (ch == "[") {
      var bnodeID = this.here(i);
      var j = this.skipSpace(str, i + 1);
      if (j < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, i, "EOF after '['");
      }
      if (str.slice(j, j + 1) == "=") {
        var i = j + 1;
        var objs = new pyjslib_List([]);
        var j = this.objectList(str, i, objs);
        if (j >= 0) {
          var subj = objs[0];
          if (pyjslib_len(objs) > 1) {
            var __obj = new pyjslib_Iterator(objs);
            try {
              while (true) {
                var obj = __obj.next();
                this.makeStatement(new pyjslib_Tuple([this._context, this._store.sym(DAML_sameAs_URI), subj, obj]));
              }
            } catch (e) {
              if (e != StopIteration) {
                throw e;
              }
            }
          }
          var j = this.skipSpace(str, j);
          if (j < 0) {
            throw BadSyntax(this._thisDoc, this.lines, str, i, "EOF when objectList expected after [ = ");
          }
          if (str.slice(j, j + 1) == ";") {
            var j = j + 1;
          }
        } else {
          throw BadSyntax(this._thisDoc, this.lines, str, i, "objectList expected after [= ");
        }
      }
      if (subj == null) {
        var subj = this.blankNode(bnodeID);
      }
      var i = this.property_list(str, j, subj);
      if (i < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, j, "property_list expected");
      }
      var j = this.skipSpace(str, i);
      if (j < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, i, "EOF when ']' expected after [ <propertyList>");
      }
      if (str.slice(j, j + 1) == ".") {
        res.push(subj);
        return j;
      }
      if (str.slice(j, j + 1) != "]") {
        throw BadSyntax(this._thisDoc, this.lines, str, j, "']' expected");
      }
      res.push(subj);
      return j + 1;
    }
    if (ch == "{") {
      var ch2 = str.slice(i + 1, i + 2);
      if (ch2 == "$") {
        i += 1;
        var j = i + 1;
        var mylist = new pyjslib_List([]);
        var first_run = true;
        while (1) {
          var i = this.skipSpace(str, j);
          if (i < 0) {
            throw BadSyntax(this._thisDoc, this.lines, str, i, "needed '$}', found end.");
          }
          if (str.slice(i, i + 2) == "$}") {
            var j = i + 2;
            break;
          }
          if (!first_run) {
            if (str.slice(i, i + 1) == ",") {
              i += 1;
            } else {
              throw BadSyntax(this._thisDoc, this.lines, str, i, "expected: ','");
            }
          } else {
            var first_run = false;
          }
          var item4 = new pyjslib_List([]);
          var j = this.item(str, i, item4);
          if (j < 0) {
            throw BadSyntax(this._thisDoc, this.lines, str, i, "expected item in set or '$}'");
          }
          mylist.push(item4[0]);
        }
        res.push(this._store.newSet(mylist, this._context));
        return j;
      } else {
        var j = i + 1;
        var oldParentContext = this._parentContext;
        this._parentContext = this._context;
        var parentAnonymousNodes = this._anonymousNodes;
        var grandParentVariables = this._parentVariables;
        this._parentVariables = this._variables;
        this._anonymousNodes = new pyjslib_Dict([]);
        this._variables = this._variables.slice();
        var reason2 = this._reason2;
        this._reason2 = becauseSubexpression;
        if (subj == null) {
          var subj = this._store.formula();
        }
        this._context = subj;
        while (1) {
          var i = this.skipSpace(str, j);
          if (i < 0) {
            throw BadSyntax(this._thisDoc, this.lines, str, i, "needed '}', found end.");
          }
          if (str.slice(i, i + 1) == "}") {
            var j = i + 1;
            break;
          }
          var j = this.directiveOrStatement(str, i);
          if (j < 0) {
            throw BadSyntax(this._thisDoc, this.lines, str, i, "expected statement or '}'");
          }
        }
        this._anonymousNodes = parentAnonymousNodes;
        this._variables = this._parentVariables;
        this._parentVariables = grandParentVariables;
        this._context = this._parentContext;
        this._reason2 = reason2;
        this._parentContext = oldParentContext;
        res.push(subj.close());
        return j;
      }
    }
    if (ch == "(") {
      var thing_type = this._store.list;
      var ch2 = str.slice(i + 1, i + 2);
      if (ch2 == "$") {
        var thing_type = this._store.newSet;
        i += 1;
      }
      var j = i + 1;
      var mylist = new pyjslib_List([]);
      while (1) {
        var i = this.skipSpace(str, j);
        if (i < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, i, "needed ')', found end.");
        }
        if (str.slice(i, i + 1) == ")") {
          var j = i + 1;
          break;
        }
        var item4 = new pyjslib_List([]);
        var j = this.item(str, i, item4);
        if (j < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, i, "expected item in list or ')'");
        }
        mylist.push(item4[0]);
      }
      res.push(thing_type(mylist, this._context));
      return j;
    }
    var j = this.tok("this", str, i);
    if (j >= 0) {
      throw BadSyntax(this._thisDoc, this.lines, str, i, "Keyword 'this' was ancient N3. Now use @forSome and @forAll keywords.");
      res.push(this._context);
      return j;
    }
    var j = this.tok("true", str, i);
    if (j >= 0) {
      res.push(true);
      return j;
    }
    var j = this.tok("false", str, i);
    if (j >= 0) {
      res.push(false);
      return j;
    }
    if (subj == null) {
      var j = this.uri_ref2(str, i, res);
      if (j >= 0) {
        return j;
      }
    }
    return -1;
  }
  property_list(str, i, subj) {
    while (1) {
      var j = this.skipSpace(str, i);
      if (j < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, i, "EOF found when expected verb in property list");
        return j;
      }
      if (str.slice(j, j + 2) == ":-") {
        var i = j + 2;
        var res = new pyjslib_List([]);
        var j = this.node(str, i, res, subj);
        if (j < 0) {
          throw BadSyntax(this._thisDoc, this.lines, str, i, "bad {} or () or [] node after :- ");
        }
        var i = j;
        continue;
      }
      var i = j;
      var v2 = new pyjslib_List([]);
      var j = this.verb(str, i, v2);
      if (j <= 0) {
        return i;
      }
      var objs = new pyjslib_List([]);
      var i = this.objectList(str, j, objs);
      if (i < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, j, "objectList expected");
      }
      var __obj = new pyjslib_Iterator(objs);
      try {
        while (true) {
          var obj = __obj.next();
          var pairFudge = v2[0];
          var dir = pairFudge[0];
          var sym = pairFudge[1];
          if (dir == "->") {
            this.makeStatement(new pyjslib_Tuple([this._context, sym, subj, obj]));
          } else {
            this.makeStatement(new pyjslib_Tuple([this._context, sym, obj, subj]));
          }
        }
      } catch (e) {
        if (e != StopIteration) {
          throw e;
        }
      }
      var j = this.skipSpace(str, i);
      if (j < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, j, "EOF found in list of objects");
        return j;
      }
      if (str.slice(i, i + 1) != ";") {
        return i;
      }
      var i = i + 1;
    }
  }
  commaSeparatedList(str, j, res, ofUris) {
    var i = this.skipSpace(str, j);
    if (i < 0) {
      throw BadSyntax(this._thisDoc, this.lines, str, i, "EOF found expecting comma sep list");
      return i;
    }
    if (str.charAt(i) == ".") {
      return j;
    }
    if (ofUris) {
      var i = this.uri_ref2(str, i, res);
    } else {
      var i = this.bareWord(str, i, res);
    }
    if (i < 0) {
      return -1;
    }
    while (1) {
      var j = this.skipSpace(str, i);
      if (j < 0) {
        return j;
      }
      var ch = str.slice(j, j + 1);
      if (ch != ",") {
        if (ch != ".") {
          return -1;
        }
        return j;
      }
      if (ofUris) {
        var i = this.uri_ref2(str, j + 1, res);
      } else {
        var i = this.bareWord(str, j + 1, res);
      }
      if (i < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, i, "bad list content");
        return i;
      }
    }
  }
  objectList(str, i, res) {
    var i = this.object(str, i, res);
    if (i < 0) {
      return -1;
    }
    while (1) {
      var j = this.skipSpace(str, i);
      if (j < 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, j, "EOF found after object");
        return j;
      }
      if (str.slice(j, j + 1) != ",") {
        return j;
      }
      var i = this.object(str, j + 1, res);
      if (i < 0) {
        return i;
      }
    }
  }
  checkDot(str, i) {
    var j = this.skipSpace(str, i);
    if (j < 0) {
      return j;
    }
    if (str.slice(j, j + 1) == ".") {
      return j + 1;
    }
    if (str.slice(j, j + 1) == "}") {
      return j;
    }
    if (str.slice(j, j + 1) == "]") {
      return j;
    }
    throw BadSyntax(this._thisDoc, this.lines, str, j, "expected '.' or '}' or ']' at end of statement");
    return i;
  }
  uri_ref2(str, i, res) {
    var qn = new pyjslib_List([]);
    var j = this.qname(str, i, qn);
    if (j >= 0) {
      var pairFudge = qn[0];
      var pfx = pairFudge[0];
      var ln = pairFudge[1];
      if (pfx == null) {
        assertFudge(0, "not used?");
        var ns3 = this._baseURI + ADDED_HASH;
      } else {
        var ns3 = this._bindings[pfx];
        if (!ns3) {
          if (pfx == "_") {
            res.push(this.anonymousNode(ln));
            return j;
          }
          throw BadSyntax(this._thisDoc, this.lines, str, i, "Prefix " + pfx + " not bound.");
        }
      }
      var symb = this._store.sym(ns3 + ln);
      if (ArrayIndexOf(this._variables, symb) >= 0) {
        res.push(this._variables[symb]);
      } else {
        res.push(symb);
      }
      return j;
    }
    var i = this.skipSpace(str, i);
    if (i < 0) {
      return -1;
    }
    if (str.charAt(i) == "?") {
      var v2 = new pyjslib_List([]);
      var j = this.variable(str, i, v2);
      if (j > 0) {
        res.push(v2[0]);
        return j;
      }
      return -1;
    } else if (str.charAt(i) == "<") {
      var i = i + 1;
      var st2 = i;
      while (i < pyjslib_len(str)) {
        if (str.charAt(i) == ">") {
          var uref = str.slice(st2, i);
          if (this._baseURI) {
            var uref = uripath_join(this._baseURI, uref);
          } else {
            assertFudge(uref.indexOf(":") >= 0, "With no base URI, cannot deal with relative URIs");
          }
          if (str.slice(i - 1, i) == "#" && !(pyjslib_slice(uref, -1, null) == "#")) {
            var uref = uref + "#";
          }
          var symb = this._store.sym(uref);
          if (ArrayIndexOf(this._variables, symb) >= 0) {
            res.push(this._variables[symb]);
          } else {
            res.push(symb);
          }
          return i + 1;
        }
        var i = i + 1;
      }
      throw BadSyntax(this._thisDoc, this.lines, str, j, "unterminated URI reference");
    } else if (this.keywordsSet) {
      var v2 = new pyjslib_List([]);
      var j = this.bareWord(str, i, v2);
      if (j < 0) {
        return -1;
      }
      if (ArrayIndexOf(this.keywords, v2[0]) >= 0) {
        throw BadSyntax(this._thisDoc, this.lines, str, i, 'Keyword "' + v2[0] + '" not allowed here.');
      }
      res.push(this._store.sym(this._bindings[""] + v2[0]));
      return j;
    } else {
      return -1;
    }
  }
  skipSpace(str, i) {
    var whitespace = " \n\r	\f\v\xA0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u200B\u2028\u2029\u3000";
    for (var j = i ? i : 0; j < str.length; j++) {
      var ch = str.charAt(j);
      if (whitespace.indexOf(ch) < 0) {
        if (str.charAt(j) === "#") {
          for (; ; j++) {
            if (j === str.length) {
              return -1;
            }
            if (str.charAt(j) === "\n") {
              this.lines = this.lines + 1;
              break;
            }
          }
          ;
        } else {
          return j;
        }
      } else {
        if (str.charAt(j) === "\n") {
          this.lines = this.lines + 1;
        }
      }
    }
    return -1;
  }
  variable(str, i, res) {
    var j = this.skipSpace(str, i);
    if (j < 0) {
      return -1;
    }
    if (str.slice(j, j + 1) != "?") {
      return -1;
    }
    var j = j + 1;
    var i = j;
    if ("0123456789-".indexOf(str.charAt(j)) >= 0) {
      throw BadSyntax(this._thisDoc, this.lines, str, j, "Varible name can't start with '" + str.charAt(j) + "s'");
      return -1;
    }
    while (i < pyjslib_len(str) && _notNameChars.indexOf(str.charAt(i)) < 0) {
      var i = i + 1;
    }
    if (this._parentContext == null) {
      throw BadSyntax(this._thisDoc, this.lines, str, j, "Can't use ?xxx syntax for variable in outermost level: " + str.slice(j - 1, i));
    }
    res.push(this._store.variable(str.slice(j, i)));
    return i;
  }
  bareWord(str, i, res) {
    var j = this.skipSpace(str, i);
    if (j < 0) {
      return -1;
    }
    var ch = str.charAt(j);
    if ("0123456789-".indexOf(ch) >= 0) {
      return -1;
    }
    if (_notNameChars.indexOf(ch) >= 0) {
      return -1;
    }
    var i = j;
    while (i < pyjslib_len(str)) {
      var c = str.charAt(i);
      if (c === ".") {
        if (dotTerminatesName(str, i)) {
          break;
        }
      } else if (_notNameChars.indexOf(c) >= 0) {
        break;
      }
      var i = i + 1;
    }
    res.push(str.slice(j, i));
    return i;
  }
  qname(str, i, res) {
    var i = this.skipSpace(str, i);
    if (i < 0) {
      return -1;
    }
    var c = str.charAt(i);
    if ("0123456789-+".indexOf(c) >= 0) {
      return -1;
    }
    if (_notNameChars.indexOf(c) < 0) {
      var ln = c;
      var i = i + 1;
      while (i < pyjslib_len(str)) {
        var c = str.charAt(i);
        if (c === ".") {
          if (dotTerminatesName(str, i)) {
            break;
          }
        } else if (_notNameChars.indexOf(c) >= 0) {
          break;
        }
        var ln = ln + c;
        var i = i + 1;
      }
    } else {
      var ln = "";
    }
    if (i < pyjslib_len(str) && str.charAt(i) == ":") {
      var pfx = ln;
      var i = i + 1;
      var ln = "";
      while (i < pyjslib_len(str)) {
        var c = str.charAt(i);
        if (c === ".") {
          if (dotTerminatesName(str, i)) {
            break;
          }
        } else if (_notNameChars.indexOf(c) >= 0) {
          break;
        }
        var ln = ln + c;
        var i = i + 1;
      }
      res.push(new pyjslib_Tuple([pfx, ln]));
      return i;
    } else {
      if (ln && this.keywordsSet && ArrayIndexOf(this.keywords, ln) < 0) {
        res.push(new pyjslib_Tuple(["", ln]));
        return i;
      }
      return -1;
    }
  }
  object(str, i, res) {
    var j = this.subject(str, i, res);
    if (j >= 0) {
      return j;
    } else {
      var j = this.skipSpace(str, i);
      if (j < 0) {
        return -1;
      } else {
        var i = j;
      }
      var delim = null;
      let ch = str.charAt(i);
      if (ch == '"' || ch == "'") {
        if (str.slice(i, i + 3 == ch + ch)) {
          delim = ch + ch + ch;
        } else {
          delim = ch;
        }
        var i = i + pyjslib_len(delim);
        var pairFudge = this.strconst(str, i, delim);
        var j = pairFudge[0];
        var s = pairFudge[1];
        res.push(this._store.literal(s));
        diag_progress("New string const ", s, j);
        return j;
      } else {
        return -1;
      }
    }
  }
  nodeOrLiteral(str, i, res) {
    var j = this.node(str, i, res);
    if (j >= 0) {
      return j;
    } else {
      var j = this.skipSpace(str, i);
      if (j < 0) {
        return -1;
      } else {
        var i = j;
      }
      var ch = str.charAt(i);
      if ("-+0987654321".indexOf(ch) >= 0) {
        datetime_syntax.lastIndex = 0;
        var m = datetime_syntax.exec(str.slice(i));
        if (m != null) {
          var val = m[0];
          j = i + val.length;
          if (val.indexOf("T") >= 0) {
            res.push(this._store.literal(val, this._store.sym(DATETIME_DATATYPE)));
          } else {
            res.push(this._store.literal(val, this._store.sym(DATE_DATATYPE)));
          }
        } else {
          number_syntax.lastIndex = 0;
          var m = number_syntax.exec(str.slice(i));
          if (m == null) {
            throw BadSyntax(this._thisDoc, this.lines, str, i, "Bad number or date syntax");
          }
          j = i + number_syntax.lastIndex;
          var val = str.slice(i, j);
          if (val.indexOf("e") >= 0) {
            res.push(this._store.literal(parseFloat(val), this._store.sym(FLOAT_DATATYPE)));
          } else if (str.slice(i, j).indexOf(".") >= 0) {
            res.push(this._store.literal(parseFloat(val), this._store.sym(DECIMAL_DATATYPE)));
          } else {
            res.push(this._store.literal(parseInt(val), this._store.sym(INTEGER_DATATYPE)));
          }
        }
        ;
        return j;
      }
      if (str.charAt(i) == '"') {
        if (str.slice(i, i + 3) == '"""') {
          var delim = '"""';
        } else {
          var delim = '"';
        }
        var i = i + pyjslib_len(delim);
        var dt = null;
        var pairFudge = this.strconst(str, i, delim);
        var j = pairFudge[0];
        var s = pairFudge[1];
        var lang = null;
        if (str.slice(j, j + 1) == "@") {
          langcode.lastIndex = 0;
          var m = langcode.exec(str.slice(j + 1));
          if (m == null) {
            throw BadSyntax(this._thisDoc, startline, str, i, "Bad language code syntax on string literal, after @");
          }
          var i = langcode.lastIndex + j + 1;
          var lang = str.slice(j + 1, i);
          var j = i;
        }
        if (str.slice(j, j + 2) == "^^") {
          var res2 = new pyjslib_List([]);
          var j = this.uri_ref2(str, j + 2, res2);
          var dt = res2[0];
        }
        res.push(this._store.literal(s, lang || dt));
        return j;
      } else {
        return -1;
      }
    }
  }
  strconst(str, i, delim) {
    var j = i;
    var ustr = "";
    var startline2 = this.lines;
    while (j < pyjslib_len(str)) {
      var i = j + pyjslib_len(delim);
      if (str.slice(j, i) == delim) {
        return new pyjslib_Tuple([i, ustr]);
      }
      if (str.charAt(j) == '"') {
        var ustr = ustr + '"';
        var j = j + 1;
        continue;
      }
      interesting.lastIndex = 0;
      var m = interesting.exec(str.slice(j));
      if (!m) {
        throw BadSyntax(this._thisDoc, startline2, str, j, "Closing quote missing in string at ^ in " + str.slice(j - 20, j) + "^" + str.slice(j, j + 20));
      }
      var i = j + interesting.lastIndex - 1;
      var ustr = ustr + str.slice(j, i);
      var ch = str.charAt(i);
      if (ch == '"') {
        var j = i;
        continue;
      } else if (ch == "\r") {
        var j = i + 1;
        continue;
      } else if (ch == "\n") {
        if (delim == '"') {
          throw BadSyntax(this._thisDoc, startline2, str, i, "newline found in string literal");
        }
        this.lines = this.lines + 1;
        var ustr = ustr + ch;
        var j = i + 1;
        this.previousLine = this.startOfLine;
        this.startOfLine = j;
      } else if (ch == "\\") {
        var j = i + 1;
        var ch = str.slice(j, j + 1);
        if (!ch) {
          throw BadSyntax(this._thisDoc, startline2, str, i, "unterminated string literal (2)");
        }
        var k = string_find('abfrtvn\\"', ch);
        if (k >= 0) {
          var uch = 'a\b\f\r	\v\n\\"'.charAt(k);
          var ustr = ustr + uch;
          var j = j + 1;
        } else if (ch == "u") {
          var pairFudge = this.uEscape(str, j + 1, startline2);
          var j = pairFudge[0];
          var ch = pairFudge[1];
          var ustr = ustr + ch;
        } else if (ch == "U") {
          var pairFudge = this.UEscape(str, j + 1, startline2);
          var j = pairFudge[0];
          var ch = pairFudge[1];
          var ustr = ustr + ch;
        } else {
          throw BadSyntax(this._thisDoc, this.lines, str, i, "bad escape");
        }
      }
    }
    throw BadSyntax(this._thisDoc, this.lines, str, i, "unterminated string literal");
  }
  uEscape(str, i, startline2) {
    var j = i;
    var count2 = 0;
    var value8 = 0;
    while (count2 < 4) {
      var chFudge = str.slice(j, j + 1);
      var ch = chFudge.toLowerCase();
      var j = j + 1;
      if (ch == "") {
        throw BadSyntax(this._thisDoc, startline2, str, i, "unterminated string literal(3)");
      }
      var k = string_find("0123456789abcdef", ch);
      if (k < 0) {
        throw BadSyntax(this._thisDoc, startline2, str, i, "bad string literal hex escape");
      }
      var value8 = value8 * 16 + k;
      var count2 = count2 + 1;
    }
    var uch = String.fromCharCode(value8);
    return new pyjslib_Tuple([j, uch]);
  }
  UEscape(str, i, startline2) {
    var j = i;
    var count2 = 0;
    var value8 = "\\U";
    while (count2 < 8) {
      var chFudge = str.slice(j, j + 1);
      var ch = chFudge.toLowerCase();
      var j = j + 1;
      if (ch == "") {
        throw BadSyntax(this._thisDoc, startline2, str, i, "unterminated string literal(3)");
      }
      var k = string_find("0123456789abcdef", ch);
      if (k < 0) {
        throw BadSyntax(this._thisDoc, startline2, str, i, "bad string literal hex escape");
      }
      var value8 = value8 + ch;
      var count2 = count2 + 1;
    }
    var uch = stringFromCharCode("0x" + pyjslib_slice(value8, 2, 10) - 0);
    return new pyjslib_Tuple([j, uch]);
  }
};
function __OLD_BadSyntax(uri6, lines, str, i, why) {
  this._str = str.encode("utf-8");
  this._str = str;
  this._i = i;
  this._why = why;
  this.lines = lines;
  this._uri = uri6;
}
__OLD_BadSyntax.prototype.toString = function() {
  var str = this._str;
  var i = this._i;
  var st2 = 0;
  if (i > 60) {
    var pre = "...";
    var st2 = i - 60;
  } else {
    var pre = "";
  }
  if (pyjslib_len(str) - i > 60) {
    var post = "...";
  } else {
    var post = "";
  }
  return 'Line %i of <%s>: Bad syntax (%s) at ^ in:\n"%s%s^%s%s"' % new pyjslib_Tuple([this.lines + 1, this._uri, this._why, pre, str.slice(st2, i), str.slice(i, i + 60), post]);
};
function BadSyntax(uri6, lines, str, i, why) {
  let lineNo = lines + 1;
  let msg = "Line " + lineNo + " of <" + uri6 + ">: Bad syntax: " + why + '\nat: "' + str.slice(i, i + 30) + '"';
  let e = new SyntaxError(msg, uri6, lineNo);
  e.lineNo = lineNo;
  e.characterInFile = i;
  e.syntaxProblem = why;
  return e;
}

// node_modules/rdflib/esm/factories/extended-term-factory.js
var ExtendedTermFactory = {
  ...canonical_data_factory_default,
  supports: {
    [Feature.collections]: true,
    [Feature.defaultGraphType]: false,
    [Feature.equalsMethod]: true,
    [Feature.identity]: false,
    [Feature.id]: true,
    [Feature.reversibleId]: false,
    [Feature.variableType]: true
  },
  /**
   * Creates a new collection
   * @param elements - The initial element
   */
  collection(elements) {
    return new Collection(elements);
  },
  id(term3) {
    if (isCollection(term3)) {
      return Collection.toNT(term3);
    }
    if (isVariable(term3)) {
      return Variable.toString(term3);
    }
    return canonical_data_factory_default.id(term3);
  },
  termToNQ(term3) {
    if (term3.termType === CollectionTermType) {
      return Collection.toNT(term3);
    }
    return canonical_data_factory_default.termToNQ(term3);
  }
};
var extended_term_factory_default = ExtendedTermFactory;

// node_modules/rdflib/esm/jsonldparser.js
function jsonldObjectToTerm(kb, obj) {
  if (typeof obj === "string") {
    return kb.rdfFactory.literal(obj);
  }
  if (Object.prototype.hasOwnProperty.call(obj, "@list")) {
    if (kb.rdfFactory.supports["COLLECTIONS"] === true) {
      return listToCollection(kb, obj["@list"]);
    }
    return listToStatements(kb, obj);
  }
  if (Object.prototype.hasOwnProperty.call(obj, "@id")) {
    return nodeType(kb, obj);
  }
  if (Object.prototype.hasOwnProperty.call(obj, "@language")) {
    return kb.rdfFactory.literal(obj["@value"], obj["@language"]);
  }
  if (Object.prototype.hasOwnProperty.call(obj, "@type")) {
    return kb.rdfFactory.literal(obj["@value"], kb.rdfFactory.namedNode(obj["@type"]));
  }
  if (Object.prototype.hasOwnProperty.call(obj, "@value")) {
    return kb.rdfFactory.literal(obj["@value"]);
  }
  return kb.rdfFactory.literal(obj);
}
function listToStatements(kb, obj) {
  const listId = obj["@id"] ? nodeType(kb, obj) : kb.rdfFactory.blankNode();
  const items2 = obj["@list"].map((listItem) => jsonldObjectToTerm(kb, listItem));
  const statements = arrayToStatements(kb.rdfFactory, listId, items2);
  kb.addAll(statements);
  return listId;
}
function listToCollection(kb, obj) {
  if (!Array.isArray(obj)) {
    throw new TypeError("Object must be an array");
  }
  return kb.rdfFactory.collection(obj.map((o) => jsonldObjectToTerm(kb, o)));
}
async function jsonldParser(str, kb, base2) {
  const baseString = base2 && Object.prototype.hasOwnProperty.call(base2, "termType") ? base2.value : base2;
  const jsonld = await import("./jsonld-V2RB47OZ.js");
  const jsonldLib = jsonld.default || jsonld;
  const flattened = await jsonldLib.flatten(JSON.parse(str), null, {
    base: baseString
  });
  return flattened.reduce((store, flatResource) => processResource(store, base2, flatResource), kb);
}
function nodeType(kb, obj) {
  if (obj["@id"].startsWith("_:")) {
    return kb.rdfFactory.blankNode(obj["@id"].substring(2));
  } else {
    return kb.rdfFactory.namedNode(obj["@id"]);
  }
}
function processResource(kb, base2, flatResource) {
  const id4 = flatResource["@id"] ? nodeType(kb, flatResource) : kb.rdfFactory.blankNode();
  for (const property4 of Object.keys(flatResource)) {
    if (property4 === "@id") {
      continue;
    } else if (property4 == "@graph") {
      const graphId = id4;
      const nestedFlatResources = flatResource[property4];
      for (let i = 0; i < nestedFlatResources.length; i++) {
        kb = processResource(kb, graphId, nestedFlatResources[i]);
      }
    }
    const value8 = flatResource[property4];
    if (Array.isArray(value8)) {
      for (let i = 0; i < value8.length; i++) {
        kb.addStatement(createStatement(kb, id4, property4, value8[i], base2));
      }
    } else {
      kb.addStatement(createStatement(kb, id4, property4, value8, base2));
    }
  }
  return kb;
}
function createStatement(kb, id4, property4, value8, base2) {
  let predicate4, object8;
  if (property4 === "@type") {
    predicate4 = kb.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type");
    object8 = kb.rdfFactory.namedNode(value8);
  } else {
    predicate4 = kb.rdfFactory.namedNode(property4);
    object8 = jsonldObjectToTerm(kb, value8);
  }
  return kb.rdfFactory.quad(id4, predicate4, object8, kb.rdfFactory.namedNode(base2));
}

// node_modules/n3/src/N3Lexer.js
var import_buffer = __toESM(require_buffer());

// node_modules/n3/src/IRIs.js
var RDF2 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#";
var XSD = "http://www.w3.org/2001/XMLSchema#";
var SWAP = "http://www.w3.org/2000/10/swap/";
var IRIs_default = {
  xsd: {
    decimal: `${XSD}decimal`,
    boolean: `${XSD}boolean`,
    double: `${XSD}double`,
    integer: `${XSD}integer`,
    string: `${XSD}string`
  },
  rdf: {
    type: `${RDF2}type`,
    nil: `${RDF2}nil`,
    first: `${RDF2}first`,
    rest: `${RDF2}rest`,
    langString: `${RDF2}langString`,
    dirLangString: `${RDF2}dirLangString`,
    reifies: `${RDF2}reifies`
  },
  owl: {
    sameAs: "http://www.w3.org/2002/07/owl#sameAs"
  },
  r: {
    forSome: `${SWAP}reify#forSome`,
    forAll: `${SWAP}reify#forAll`
  },
  log: {
    implies: `${SWAP}log#implies`,
    isImpliedBy: `${SWAP}log#isImpliedBy`
  }
};

// node_modules/n3/src/N3Lexer.js
var { xsd } = IRIs_default;
var escapeSequence = /\\u([a-fA-F0-9]{4})|\\U([a-fA-F0-9]{8})|\\([^])/g;
var escapeReplacements = {
  "\\": "\\",
  "'": "'",
  '"': '"',
  "n": "\n",
  "r": "\r",
  "t": "	",
  "f": "\f",
  "b": "\b",
  "_": "_",
  "~": "~",
  ".": ".",
  "-": "-",
  "!": "!",
  "$": "$",
  "&": "&",
  "(": "(",
  ")": ")",
  "*": "*",
  "+": "+",
  ",": ",",
  ";": ";",
  "=": "=",
  "/": "/",
  "?": "?",
  "#": "#",
  "@": "@",
  "%": "%"
};
var illegalIriChars = /[\x00-\x20<>\\"\{\}\|\^\`]/;
var lineModeRegExps = {
  _iri: true,
  _unescapedIri: true,
  _simpleQuotedString: true,
  _langcode: true,
  _dircode: true,
  _blank: true,
  _newline: true,
  _comment: true,
  _whitespace: true,
  _endOfFile: true
};
var invalidRegExp = /$0^/;
var N3Lexer = class {
  constructor(options) {
    this._iri = /^<((?:[^ <>{}\\]|\\[uU])+)>[ \t]*/;
    this._unescapedIri = /^<([^\x00-\x20<>\\"\{\}\|\^\`]*)>[ \t]*/;
    this._simpleQuotedString = /^"([^"\\\r\n]*)"(?=[^"])/;
    this._simpleApostropheString = /^'([^'\\\r\n]*)'(?=[^'])/;
    this._langcode = /^@([a-z]+(?:-[a-z0-9]+)*)(?=[^a-z0-9])/i;
    this._dircode = /^--(ltr)|(rtl)/;
    this._prefix = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:(?=[#\s<])/;
    this._prefixed = /^((?:[A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)?:((?:(?:[0-:A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])(?:(?:[\.\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~])*(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff]|%[0-9a-fA-F]{2}|\\[!#-\/;=?\-@_~]))?)?)(?:[ \t]+|(?=\.?[,;!\^\s#()\[\]\{\}"'<>]))/;
    this._variable = /^\?(?:(?:[A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:[\-0-:A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?=[.,;!\^\s#()\[\]\{\}"'<>])/;
    this._blank = /^_:((?:[0-9A-Z_a-z\xc0-\xd6\xd8-\xf6\xf8-\u02ff\u0370-\u037d\u037f-\u1fff\u200c\u200d\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])(?:\.?[\-0-9A-Z_a-z\xb7\xc0-\xd6\xd8-\xf6\xf8-\u037d\u037f-\u1fff\u200c\u200d\u203f\u2040\u2070-\u218f\u2c00-\u2fef\u3001-\ud7ff\uf900-\ufdcf\ufdf0-\ufffd]|[\ud800-\udb7f][\udc00-\udfff])*)(?:[ \t]+|(?=\.?[,;:\s#()\[\]\{\}"'<>]))/;
    this._number = /^[\-+]?(?:(\d+\.\d*|\.?\d+)[eE][\-+]?|\d*(\.)?)\d+(?=\.?[,;:\s#()\[\]\{\}"'<>])/;
    this._boolean = /^(?:true|false)(?=[.,;\s#()\[\]\{\}"'<>])/;
    this._atKeyword = /^@[a-z]+(?=[\s#<:])/i;
    this._keyword = /^(?:PREFIX|BASE|VERSION|GRAPH)(?=[\s#<])/i;
    this._shortPredicates = /^a(?=[\s#()\[\]\{\}"'<>])/;
    this._newline = /^[ \t]*(?:#[^\n\r]*)?(?:\r\n|\n|\r)[ \t]*/;
    this._comment = /#([^\n\r]*)/;
    this._whitespace = /^[ \t]+/;
    this._endOfFile = /^(?:#[^\n\r]*)?$/;
    options = options || {};
    this._isImpliedBy = options.isImpliedBy;
    if (this._lineMode = !!options.lineMode) {
      this._n3Mode = false;
      for (const key3 in this) {
        if (!(key3 in lineModeRegExps) && this[key3] instanceof RegExp)
          this[key3] = invalidRegExp;
      }
    } else {
      this._n3Mode = options.n3 !== false;
    }
    this.comments = !!options.comments;
    this._literalClosingPos = 0;
  }
  // ## Private methods
  // ### `_tokenizeToEnd` tokenizes as for as possible, emitting tokens through the callback
  _tokenizeToEnd(callback, inputFinished) {
    let input2 = this._input;
    let currentLineLength = input2.length;
    while (true) {
      let whiteSpaceMatch, comment6;
      while (whiteSpaceMatch = this._newline.exec(input2)) {
        if (this.comments && (comment6 = this._comment.exec(whiteSpaceMatch[0])))
          emitToken("comment", comment6[1], "", this._line, whiteSpaceMatch[0].length);
        input2 = input2.substr(whiteSpaceMatch[0].length, input2.length);
        currentLineLength = input2.length;
        this._line++;
      }
      if (!whiteSpaceMatch && (whiteSpaceMatch = this._whitespace.exec(input2)))
        input2 = input2.substr(whiteSpaceMatch[0].length, input2.length);
      if (this._endOfFile.test(input2)) {
        if (inputFinished) {
          if (this.comments && (comment6 = this._comment.exec(input2)))
            emitToken("comment", comment6[1], "", this._line, input2.length);
          input2 = null;
          emitToken("eof", "", "", this._line, 0);
        }
        return this._input = input2;
      }
      const line4 = this._line, firstChar = input2[0];
      let type5 = "", value8 = "", prefix3 = "", match = null, matchLength = 0, inconclusive = false;
      switch (firstChar) {
        case "^":
          if (input2.length < 3)
            break;
          else if (input2[1] === "^") {
            this._previousMarker = "^^";
            input2 = input2.substr(2);
            if (input2[0] !== "<") {
              inconclusive = true;
              break;
            }
          } else {
            if (this._n3Mode) {
              matchLength = 1;
              type5 = "^";
            }
            break;
          }
        // Fall through in case the type is an IRI
        case "<":
          if (match = this._unescapedIri.exec(input2))
            type5 = "IRI", value8 = match[1];
          else if (match = this._iri.exec(input2)) {
            value8 = this._unescape(match[1]);
            if (value8 === null || illegalIriChars.test(value8))
              return reportSyntaxError(this);
            type5 = "IRI";
          } else if (input2.length > 2 && input2[1] === "<" && input2[2] === "(")
            type5 = "<<(", matchLength = 3;
          else if (!this._lineMode && input2.length > (inputFinished ? 1 : 2) && input2[1] === "<")
            type5 = "<<", matchLength = 2;
          else if (this._n3Mode && input2.length > 1 && input2[1] === "=") {
            matchLength = 2;
            if (this._isImpliedBy) type5 = "abbreviation", value8 = "<";
            else type5 = "inverse", value8 = ">";
          }
          break;
        case ">":
          if (input2.length > 1 && input2[1] === ">")
            type5 = ">>", matchLength = 2;
          break;
        case "_":
          if ((match = this._blank.exec(input2)) || inputFinished && (match = this._blank.exec(`${input2} `)))
            type5 = "blank", prefix3 = "_", value8 = match[1];
          break;
        case '"':
          if (match = this._simpleQuotedString.exec(input2))
            value8 = match[1];
          else {
            ({ value: value8, matchLength } = this._parseLiteral(input2));
            if (value8 === null)
              return reportSyntaxError(this);
          }
          if (match !== null || matchLength !== 0) {
            type5 = "literal";
            this._literalClosingPos = 0;
          }
          break;
        case "'":
          if (!this._lineMode) {
            if (match = this._simpleApostropheString.exec(input2))
              value8 = match[1];
            else {
              ({ value: value8, matchLength } = this._parseLiteral(input2));
              if (value8 === null)
                return reportSyntaxError(this);
            }
            if (match !== null || matchLength !== 0) {
              type5 = "literal";
              this._literalClosingPos = 0;
            }
          }
          break;
        case "?":
          if (this._n3Mode && (match = this._variable.exec(input2)))
            type5 = "var", value8 = match[0];
          break;
        case "@":
          if (this._previousMarker === "literal" && (match = this._langcode.exec(input2)) && match[1] !== "version")
            type5 = "langcode", value8 = match[1];
          else if (match = this._atKeyword.exec(input2))
            type5 = match[0];
          break;
        case ".":
          if (input2.length === 1 ? inputFinished : input2[1] < "0" || input2[1] > "9") {
            type5 = ".";
            matchLength = 1;
            break;
          }
        // Fall through to numerical case (could be a decimal dot)
        case "0":
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
        case "7":
        case "8":
        case "9":
        case "+":
        case "-":
          if (input2[1] === "-") {
            if (this._previousMarker === "langcode" && (match = this._dircode.exec(input2)))
              type5 = "dircode", matchLength = 2, value8 = match[1] || match[2], matchLength = value8.length + 2;
            break;
          }
          if (match = this._number.exec(input2) || inputFinished && (match = this._number.exec(`${input2} `))) {
            type5 = "literal", value8 = match[0];
            prefix3 = typeof match[1] === "string" ? xsd.double : typeof match[2] === "string" ? xsd.decimal : xsd.integer;
          }
          break;
        case "B":
        case "b":
        case "p":
        case "P":
        case "G":
        case "g":
        case "V":
        case "v":
          if (match = this._keyword.exec(input2))
            type5 = match[0].toUpperCase();
          else
            inconclusive = true;
          break;
        case "f":
        case "t":
          if (match = this._boolean.exec(input2))
            type5 = "literal", value8 = match[0], prefix3 = xsd.boolean;
          else
            inconclusive = true;
          break;
        case "a":
          if (match = this._shortPredicates.exec(input2))
            type5 = "abbreviation", value8 = "a";
          else
            inconclusive = true;
          break;
        case "=":
          if (this._n3Mode && input2.length > 1) {
            type5 = "abbreviation";
            if (input2[1] !== ">")
              matchLength = 1, value8 = "=";
            else
              matchLength = 2, value8 = ">";
          }
          break;
        case "!":
          if (!this._n3Mode)
            break;
        case ")":
          if (!inputFinished && (input2.length === 1 || input2.length === 2 && input2[1] === ">")) {
            break;
          }
          if (input2.length > 2 && input2[1] === ">" && input2[2] === ">") {
            type5 = ")>>", matchLength = 3;
            break;
          }
        case ",":
        case ";":
        case "[":
        case "]":
        case "(":
        case "}":
        case "~":
          if (!this._lineMode) {
            matchLength = 1;
            type5 = firstChar;
          }
          break;
        case "{":
          if (!this._lineMode && input2.length >= 2) {
            if (input2[1] === "|")
              type5 = "{|", matchLength = 2;
            else
              type5 = firstChar, matchLength = 1;
          }
          break;
        case "|":
          if (input2.length >= 2 && input2[1] === "}")
            type5 = "|}", matchLength = 2;
          break;
        default:
          inconclusive = true;
      }
      if (inconclusive) {
        if ((this._previousMarker === "@prefix" || this._previousMarker === "PREFIX") && (match = this._prefix.exec(input2)))
          type5 = "prefix", value8 = match[1] || "";
        else if ((match = this._prefixed.exec(input2)) || inputFinished && (match = this._prefixed.exec(`${input2} `)))
          type5 = "prefixed", prefix3 = match[1] || "", value8 = this._unescape(match[2]);
      }
      if (this._previousMarker === "^^") {
        switch (type5) {
          case "prefixed":
            type5 = "type";
            break;
          case "IRI":
            type5 = "typeIRI";
            break;
          default:
            type5 = "";
        }
      }
      if (!type5) {
        if (inputFinished || !/^'''|^"""/.test(input2) && /\n|\r/.test(input2))
          return reportSyntaxError(this);
        else
          return this._input = input2;
      }
      const length3 = matchLength || match[0].length;
      const token2 = emitToken(type5, value8, prefix3, line4, length3);
      this.previousToken = token2;
      this._previousMarker = type5;
      input2 = input2.substr(length3, input2.length);
    }
    function emitToken(type5, value8, prefix3, line4, length3) {
      const start3 = input2 ? currentLineLength - input2.length : currentLineLength;
      const end2 = start3 + length3;
      const token2 = { type: type5, value: value8, prefix: prefix3, line: line4, start: start3, end: end2 };
      callback(null, token2);
      return token2;
    }
    function reportSyntaxError(self2) {
      callback(self2._syntaxError(/^\S*/.exec(input2)[0]));
    }
  }
  // ### `_unescape` replaces N3 escape codes by their corresponding characters
  _unescape(item4) {
    let invalid = false;
    const replaced = item4.replace(escapeSequence, (sequence3, unicode4, unicode8, escapedChar) => {
      if (typeof unicode4 === "string")
        return String.fromCharCode(Number.parseInt(unicode4, 16));
      if (typeof unicode8 === "string") {
        let charCode = Number.parseInt(unicode8, 16);
        return charCode <= 65535 ? String.fromCharCode(Number.parseInt(unicode8, 16)) : String.fromCharCode(55296 + ((charCode -= 65536) >> 10), 56320 + (charCode & 1023));
      }
      if (escapedChar in escapeReplacements)
        return escapeReplacements[escapedChar];
      invalid = true;
      return "";
    });
    return invalid ? null : replaced;
  }
  // ### `_parseLiteral` parses a literal into an unescaped value
  _parseLiteral(input2) {
    if (input2.length >= 3) {
      const opening = input2.match(/^(?:"""|"|'''|'|)/)[0];
      const openingLength = opening.length;
      let closingPos = Math.max(this._literalClosingPos, openingLength);
      while ((closingPos = input2.indexOf(opening, closingPos)) > 0) {
        let backslashCount = 0;
        while (input2[closingPos - backslashCount - 1] === "\\")
          backslashCount++;
        if (backslashCount % 2 === 0) {
          const raw = input2.substring(openingLength, closingPos);
          const lines = raw.split(/\r\n|\r|\n/).length - 1;
          const matchLength = closingPos + openingLength;
          if (openingLength === 1 && lines !== 0 || openingLength === 3 && this._lineMode)
            break;
          this._line += lines;
          return { value: this._unescape(raw), matchLength };
        }
        closingPos++;
      }
      this._literalClosingPos = input2.length - openingLength + 1;
    }
    return { value: "", matchLength: 0 };
  }
  // ### `_syntaxError` creates a syntax error for the given issue
  _syntaxError(issue3) {
    this._input = null;
    const err2 = new Error(`Unexpected "${issue3}" on line ${this._line}.`);
    err2.context = {
      token: void 0,
      line: this._line,
      previousToken: this.previousToken
    };
    return err2;
  }
  // ### Strips off any starting UTF BOM mark.
  _readStartingBom(input2) {
    return input2.startsWith("\uFEFF") ? input2.substr(1) : input2;
  }
  // ## Public methods
  // ### `tokenize` starts the transformation of an N3 document into an array of tokens.
  // The input can be a string or a stream.
  tokenize(input2, callback) {
    this._line = 1;
    if (typeof input2 === "string") {
      this._input = this._readStartingBom(input2);
      if (typeof callback === "function")
        queueMicrotask(() => this._tokenizeToEnd(callback, true));
      else {
        const tokens = [];
        let error4;
        this._tokenizeToEnd((e, t) => e ? error4 = e : tokens.push(t), true);
        if (error4) throw error4;
        return tokens;
      }
    } else {
      this._pendingBuffer = null;
      if (typeof input2.setEncoding === "function")
        input2.setEncoding("utf8");
      input2.on("data", (data4) => {
        if (this._input !== null && data4.length !== 0) {
          if (this._pendingBuffer) {
            data4 = import_buffer.Buffer.concat([this._pendingBuffer, data4]);
            this._pendingBuffer = null;
          }
          if (data4[data4.length - 1] & 128) {
            this._pendingBuffer = data4;
          } else {
            if (typeof this._input === "undefined")
              this._input = this._readStartingBom(typeof data4 === "string" ? data4 : data4.toString());
            else
              this._input += data4;
            this._tokenizeToEnd(callback, false);
          }
        }
      });
      input2.on("end", () => {
        if (typeof this._input === "string")
          this._tokenizeToEnd(callback, true);
      });
      input2.on("error", callback);
    }
  }
};

// node_modules/n3/src/N3DataFactory.js
var { rdf: rdf2, xsd: xsd2 } = IRIs_default;
var DEFAULTGRAPH;
var _blankNodeCounter = 0;
var DataFactory = {
  namedNode,
  blankNode,
  variable,
  literal,
  defaultGraph: defaultGraph3,
  quad,
  triple: quad,
  fromTerm,
  fromQuad
};
var N3DataFactory_default = DataFactory;
var Term = class _Term {
  constructor(id4) {
    this.id = id4;
  }
  // ### The value of this term
  get value() {
    return this.id;
  }
  // ### Returns whether this object represents the same term as the other
  equals(other2) {
    if (other2 instanceof _Term)
      return this.id === other2.id;
    return !!other2 && this.termType === other2.termType && this.value === other2.value;
  }
  // ### Implement hashCode for Immutable.js, since we implement `equals`
  // https://immutable-js.com/docs/v4.0.0/ValueObject/#hashCode()
  hashCode() {
    return 0;
  }
  // ### Returns a plain object representation of this term
  toJSON() {
    return {
      termType: this.termType,
      value: this.value
    };
  }
};
var NamedNode2 = class extends Term {
  // ### The term type of this term
  get termType() {
    return "NamedNode";
  }
};
var Literal2 = class _Literal extends Term {
  // ### The term type of this term
  get termType() {
    return "Literal";
  }
  // ### The text value of this literal
  get value() {
    return this.id.substring(1, this.id.lastIndexOf('"'));
  }
  // ### The language of this literal
  get language() {
    const id4 = this.id;
    let atPos = id4.lastIndexOf('"') + 1;
    const dirPos = id4.lastIndexOf("--");
    return atPos < id4.length && id4[atPos++] === "@" ? (dirPos > atPos ? id4.substr(0, dirPos) : id4).substr(atPos).toLowerCase() : "";
  }
  // ### The direction of this literal
  get direction() {
    const id4 = this.id;
    const endPos = id4.lastIndexOf('"');
    const dirPos = id4.lastIndexOf("--");
    return dirPos > endPos && dirPos + 2 < id4.length ? id4.substr(dirPos + 2).toLowerCase() : "";
  }
  // ### The datatype IRI of this literal
  get datatype() {
    return new NamedNode2(this.datatypeString);
  }
  // ### The datatype string of this literal
  get datatypeString() {
    const id4 = this.id, dtPos = id4.lastIndexOf('"') + 1;
    const char = dtPos < id4.length ? id4[dtPos] : "";
    return char === "^" ? id4.substr(dtPos + 2) : (
      // If "@" follows, return rdf:langString or rdf:dirLangString; xsd:string otherwise
      char !== "@" ? xsd2.string : id4.indexOf("--", dtPos) > 0 ? rdf2.dirLangString : rdf2.langString
    );
  }
  // ### Returns whether this object represents the same term as the other
  equals(other2) {
    if (other2 instanceof _Literal)
      return this.id === other2.id;
    return !!other2 && !!other2.datatype && this.termType === other2.termType && this.value === other2.value && this.language === other2.language && (this.direction === other2.direction || this.direction === "" && !other2.direction) && this.datatype.value === other2.datatype.value;
  }
  toJSON() {
    return {
      termType: this.termType,
      value: this.value,
      language: this.language,
      direction: this.direction,
      datatype: { termType: "NamedNode", value: this.datatypeString }
    };
  }
};
var BlankNode2 = class extends Term {
  constructor(name9) {
    super(`_:${name9}`);
  }
  // ### The term type of this term
  get termType() {
    return "BlankNode";
  }
  // ### The name of this blank node
  get value() {
    return this.id.substr(2);
  }
};
var Variable2 = class extends Term {
  constructor(name9) {
    super(`?${name9}`);
  }
  // ### The term type of this term
  get termType() {
    return "Variable";
  }
  // ### The name of this variable
  get value() {
    return this.id.substr(1);
  }
};
var DefaultGraph2 = class extends Term {
  constructor() {
    super("");
    return DEFAULTGRAPH || this;
  }
  // ### The term type of this term
  get termType() {
    return "DefaultGraph";
  }
  // ### Returns whether this object represents the same term as the other
  equals(other2) {
    return this === other2 || !!other2 && this.termType === other2.termType;
  }
};
DEFAULTGRAPH = new DefaultGraph2();
var Quad = class extends Term {
  constructor(subject8, predicate4, object8, graph3) {
    super("");
    this._subject = subject8;
    this._predicate = predicate4;
    this._object = object8;
    this._graph = graph3 || DEFAULTGRAPH;
  }
  // ### The term type of this term
  get termType() {
    return "Quad";
  }
  get subject() {
    return this._subject;
  }
  get predicate() {
    return this._predicate;
  }
  get object() {
    return this._object;
  }
  get graph() {
    return this._graph;
  }
  // ### Returns a plain object representation of this quad
  toJSON() {
    return {
      termType: this.termType,
      subject: this._subject.toJSON(),
      predicate: this._predicate.toJSON(),
      object: this._object.toJSON(),
      graph: this._graph.toJSON()
    };
  }
  // ### Returns whether this object represents the same quad as the other
  equals(other2) {
    return !!other2 && this._subject.equals(other2.subject) && this._predicate.equals(other2.predicate) && this._object.equals(other2.object) && this._graph.equals(other2.graph);
  }
};
function namedNode(iri) {
  return new NamedNode2(iri);
}
function blankNode(name9) {
  return new BlankNode2(name9 || `n3-${_blankNodeCounter++}`);
}
function literal(value8, languageOrDataType) {
  if (typeof languageOrDataType === "string")
    return new Literal2(`"${value8}"@${languageOrDataType.toLowerCase()}`);
  if (languageOrDataType !== void 0 && !("termType" in languageOrDataType)) {
    return new Literal2(`"${value8}"@${languageOrDataType.language.toLowerCase()}${languageOrDataType.direction ? `--${languageOrDataType.direction.toLowerCase()}` : ""}`);
  }
  let datatype3 = languageOrDataType ? languageOrDataType.value : "";
  if (datatype3 === "") {
    if (typeof value8 === "boolean")
      datatype3 = xsd2.boolean;
    else if (typeof value8 === "number") {
      if (Number.isFinite(value8))
        datatype3 = Number.isInteger(value8) ? xsd2.integer : xsd2.double;
      else {
        datatype3 = xsd2.double;
        if (!Number.isNaN(value8))
          value8 = value8 > 0 ? "INF" : "-INF";
      }
    }
  }
  return datatype3 === "" || datatype3 === xsd2.string ? new Literal2(`"${value8}"`) : new Literal2(`"${value8}"^^${datatype3}`);
}
function variable(name9) {
  return new Variable2(name9);
}
function defaultGraph3() {
  return DEFAULTGRAPH;
}
function quad(subject8, predicate4, object8, graph3) {
  return new Quad(subject8, predicate4, object8, graph3);
}
function fromTerm(term3) {
  if (term3 instanceof Term)
    return term3;
  switch (term3.termType) {
    case "NamedNode":
      return namedNode(term3.value);
    case "BlankNode":
      return blankNode(term3.value);
    case "Variable":
      return variable(term3.value);
    case "DefaultGraph":
      return DEFAULTGRAPH;
    case "Literal":
      return literal(term3.value, term3.language || term3.datatype);
    case "Quad":
      return fromQuad(term3);
    default:
      throw new Error(`Unexpected termType: ${term3.termType}`);
  }
}
function fromQuad(inQuad) {
  if (inQuad instanceof Quad)
    return inQuad;
  if (inQuad.termType !== "Quad")
    throw new Error(`Unexpected termType: ${inQuad.termType}`);
  return quad(fromTerm(inQuad.subject), fromTerm(inQuad.predicate), fromTerm(inQuad.object), fromTerm(inQuad.graph));
}

// node_modules/n3/src/N3Parser.js
var blankNodePrefix = 0;
var N3Parser = class _N3Parser {
  constructor(options) {
    this._contextStack = [];
    this._graph = null;
    options = options || {};
    this._setBase(options.baseIRI);
    options.factory && initDataFactory(this, options.factory);
    const format4 = typeof options.format === "string" ? options.format.match(/\w*$/)[0].toLowerCase() : "", isTurtle = /turtle/.test(format4), isTriG = /trig/.test(format4), isNTriples = /triple/.test(format4), isNQuads = /quad/.test(format4), isN3 = this._n3Mode = /n3/.test(format4), isLineMode = isNTriples || isNQuads;
    if (!(this._supportsNamedGraphs = !(isTurtle || isN3)))
      this._readPredicateOrNamedGraph = this._readPredicate;
    this._supportsQuads = !(isTurtle || isTriG || isNTriples || isN3);
    this._isImpliedBy = options.isImpliedBy;
    if (isLineMode)
      this._resolveRelativeIRI = (iri) => {
        return null;
      };
    this._blankNodePrefix = typeof options.blankNodePrefix !== "string" ? "" : options.blankNodePrefix.replace(/^(?!_:)/, "_:");
    this._lexer = options.lexer || new N3Lexer({ lineMode: isLineMode, n3: isN3, isImpliedBy: this._isImpliedBy });
    this._explicitQuantifiers = !!options.explicitQuantifiers;
    this._parseUnsupportedVersions = !!options.parseUnsupportedVersions;
    this._version = options.version;
  }
  // ## Static class methods
  // ### `_resetBlankNodePrefix` restarts blank node prefix identification
  static _resetBlankNodePrefix() {
    blankNodePrefix = 0;
  }
  // ## Private methods
  // ### `_setBase` sets the base IRI to resolve relative IRIs
  _setBase(baseIRI) {
    if (!baseIRI) {
      this._base = "";
      this._basePath = "";
    } else {
      const fragmentPos = baseIRI.indexOf("#");
      if (fragmentPos >= 0)
        baseIRI = baseIRI.substr(0, fragmentPos);
      this._base = baseIRI;
      this._basePath = baseIRI.indexOf("/") < 0 ? baseIRI : baseIRI.replace(/[^\/?]*(?:\?.*)?$/, "");
      baseIRI = baseIRI.match(/^(?:([a-z][a-z0-9+.-]*:))?(?:\/\/[^\/]*)?/i);
      this._baseRoot = baseIRI[0];
      this._baseScheme = baseIRI[1];
    }
  }
  // ### `_saveContext` stores the current parsing context
  // when entering a new scope (list, blank node, formula)
  _saveContext(type5, graph3, subject8, predicate4, object8) {
    const n3Mode = this._n3Mode;
    this._contextStack.push({
      type: type5,
      subject: subject8,
      predicate: predicate4,
      object: object8,
      graph: graph3,
      inverse: n3Mode ? this._inversePredicate : false,
      blankPrefix: n3Mode ? this._prefixes._ : "",
      quantified: n3Mode ? this._quantified : null
    });
    if (n3Mode) {
      this._inversePredicate = false;
      this._prefixes._ = this._graph ? `${this._graph.value}.` : ".";
      this._quantified = Object.create(this._quantified);
    }
  }
  // ### `_restoreContext` restores the parent context
  // when leaving a scope (list, blank node, formula)
  _restoreContext(type5, token2) {
    const context4 = this._contextStack.pop();
    if (!context4 || context4.type !== type5)
      return this._error(`Unexpected ${token2.type}`, token2);
    this._subject = context4.subject;
    this._predicate = context4.predicate;
    this._object = context4.object;
    this._graph = context4.graph;
    if (this._n3Mode) {
      this._inversePredicate = context4.inverse;
      this._prefixes._ = context4.blankPrefix;
      this._quantified = context4.quantified;
    }
  }
  // ### `_readBeforeTopContext` is called once only at the start of parsing.
  _readBeforeTopContext(token2) {
    if (this._version && !this._isValidVersion(this._version))
      return this._error(`Detected unsupported version as media type parameter: "${this._version}"`, token2);
    return this._readInTopContext(token2);
  }
  // ### `_readInTopContext` reads a token when in the top context
  _readInTopContext(token2) {
    switch (token2.type) {
      // If an EOF token arrives in the top context, signal that we're done
      case "eof":
        if (this._graph !== null)
          return this._error("Unclosed graph", token2);
        delete this._prefixes._;
        return this._callback(null, null, this._prefixes);
      // It could be a prefix declaration
      case "PREFIX":
        this._sparqlStyle = true;
      case "@prefix":
        return this._readPrefix;
      // It could be a base declaration
      case "BASE":
        this._sparqlStyle = true;
      case "@base":
        return this._readBaseIRI;
      // It could be a version declaration
      case "VERSION":
        this._sparqlStyle = true;
      case "@version":
        return this._readVersion;
      // It could be a graph
      case "{":
        if (this._supportsNamedGraphs) {
          this._graph = "";
          this._subject = null;
          return this._readSubject;
        }
      case "GRAPH":
        if (this._supportsNamedGraphs)
          return this._readNamedGraphLabel;
      // Otherwise, the next token must be a subject
      default:
        return this._readSubject(token2);
    }
  }
  // ### `_readEntity` reads an IRI, prefixed name, blank node, or variable
  _readEntity(token2, quantifier) {
    let value8;
    switch (token2.type) {
      // Read a relative or absolute IRI
      case "IRI":
      case "typeIRI":
        const iri = this._resolveIRI(token2.value);
        if (iri === null)
          return this._error("Invalid IRI", token2);
        value8 = this._factory.namedNode(iri);
        break;
      // Read a prefixed name
      case "type":
      case "prefixed":
        const prefix3 = this._prefixes[token2.prefix];
        if (prefix3 === void 0)
          return this._error(`Undefined prefix "${token2.prefix}:"`, token2);
        value8 = this._factory.namedNode(prefix3 + token2.value);
        break;
      // Read a blank node
      case "blank":
        value8 = this._factory.blankNode(this._prefixes[token2.prefix] + token2.value);
        break;
      // Read a variable
      case "var":
        value8 = this._factory.variable(token2.value.substr(1));
        break;
      // Everything else is not an entity
      default:
        return this._error(`Expected entity but got ${token2.type}`, token2);
    }
    if (!quantifier && this._n3Mode && value8.id in this._quantified)
      value8 = this._quantified[value8.id];
    return value8;
  }
  // ### `_readSubject` reads a quad's subject
  _readSubject(token2) {
    this._predicate = null;
    switch (token2.type) {
      case "[":
        this._saveContext(
          "blank",
          this._graph,
          this._subject = this._factory.blankNode(),
          null,
          null
        );
        return this._readBlankNodeHead;
      case "(":
        const stack = this._contextStack, parent4 = stack.length && stack[stack.length - 1];
        if (parent4.type === "<<") {
          return this._error("Unexpected list in reified triple", token2);
        }
        this._saveContext("list", this._graph, this.RDF_NIL, null, null);
        this._subject = null;
        return this._readListItem;
      case "{":
        if (!this._n3Mode)
          return this._error("Unexpected graph", token2);
        this._saveContext(
          "formula",
          this._graph,
          this._graph = this._factory.blankNode(),
          null,
          null
        );
        return this._readSubject;
      case "}":
        return this._readPunctuation(token2);
      case "@forSome":
        if (!this._n3Mode)
          return this._error('Unexpected "@forSome"', token2);
        this._subject = null;
        this._predicate = this.N3_FORSOME;
        this._quantifier = "blankNode";
        return this._readQuantifierList;
      case "@forAll":
        if (!this._n3Mode)
          return this._error('Unexpected "@forAll"', token2);
        this._subject = null;
        this._predicate = this.N3_FORALL;
        this._quantifier = "variable";
        return this._readQuantifierList;
      case "literal":
        if (!this._n3Mode)
          return this._error("Unexpected literal", token2);
        if (token2.prefix.length === 0) {
          this._literalValue = token2.value;
          return this._completeSubjectLiteral;
        } else
          this._subject = this._factory.literal(token2.value, this._factory.namedNode(token2.prefix));
        break;
      case "<<(":
        if (!this._n3Mode)
          return this._error("Disallowed triple term as subject", token2);
        this._saveContext("<<(", this._graph, null, null, null);
        this._graph = null;
        return this._readSubject;
      case "<<":
        this._saveContext("<<", this._graph, null, null, null);
        this._graph = null;
        return this._readSubject;
      default:
        if ((this._subject = this._readEntity(token2)) === void 0)
          return;
        if (this._n3Mode)
          return this._getPathReader(this._readPredicateOrNamedGraph);
    }
    return this._readPredicateOrNamedGraph;
  }
  // ### `_readPredicate` reads a quad's predicate
  _readPredicate(token2) {
    const type5 = token2.type;
    switch (type5) {
      case "inverse":
        this._inversePredicate = true;
      case "abbreviation":
        this._predicate = this.ABBREVIATIONS[token2.value];
        break;
      case ".":
      case "]":
      case "}":
      case "|}":
        if (this._predicate === null)
          return this._error(`Unexpected ${type5}`, token2);
        this._subject = null;
        return type5 === "]" ? this._readBlankNodeTail(token2) : this._readPunctuation(token2);
      case ";":
        return this._predicate !== null ? this._readPredicate : this._error("Expected predicate but got ;", token2);
      case "[":
        if (this._n3Mode) {
          this._saveContext(
            "blank",
            this._graph,
            this._subject,
            this._subject = this._factory.blankNode(),
            null
          );
          return this._readBlankNodeHead;
        }
      case "blank":
        if (!this._n3Mode)
          return this._error("Disallowed blank node as predicate", token2);
      default:
        if ((this._predicate = this._readEntity(token2)) === void 0)
          return;
    }
    this._validAnnotation = true;
    return this._readObject;
  }
  // ### `_readObject` reads a quad's object
  _readObject(token2) {
    switch (token2.type) {
      case "literal":
        if (token2.prefix.length === 0) {
          this._literalValue = token2.value;
          return this._readDataTypeOrLang;
        } else
          this._object = this._factory.literal(token2.value, this._factory.namedNode(token2.prefix));
        break;
      case "[":
        this._saveContext(
          "blank",
          this._graph,
          this._subject,
          this._predicate,
          this._subject = this._factory.blankNode()
        );
        return this._readBlankNodeHead;
      case "(":
        const stack = this._contextStack, parent4 = stack.length && stack[stack.length - 1];
        if (parent4.type === "<<") {
          return this._error("Unexpected list in reified triple", token2);
        }
        this._saveContext("list", this._graph, this._subject, this._predicate, this.RDF_NIL);
        this._subject = null;
        return this._readListItem;
      case "{":
        if (!this._n3Mode)
          return this._error("Unexpected graph", token2);
        this._saveContext(
          "formula",
          this._graph,
          this._subject,
          this._predicate,
          this._graph = this._factory.blankNode()
        );
        return this._readSubject;
      case "<<(":
        this._saveContext("<<(", this._graph, this._subject, this._predicate, null);
        this._graph = null;
        return this._readSubject;
      case "<<":
        this._saveContext("<<", this._graph, this._subject, this._predicate, null);
        this._graph = null;
        return this._readSubject;
      default:
        if ((this._object = this._readEntity(token2)) === void 0)
          return;
        if (this._n3Mode)
          return this._getPathReader(this._getContextEndReader());
    }
    return this._getContextEndReader();
  }
  // ### `_readPredicateOrNamedGraph` reads a quad's predicate, or a named graph
  _readPredicateOrNamedGraph(token2) {
    return token2.type === "{" ? this._readGraph(token2) : this._readPredicate(token2);
  }
  // ### `_readGraph` reads a graph
  _readGraph(token2) {
    if (token2.type !== "{")
      return this._error(`Expected graph but got ${token2.type}`, token2);
    this._graph = this._subject, this._subject = null;
    return this._readSubject;
  }
  // ### `_readBlankNodeHead` reads the head of a blank node
  _readBlankNodeHead(token2) {
    if (token2.type === "]") {
      this._subject = null;
      return this._readBlankNodeTail(token2);
    } else {
      const stack = this._contextStack, parentParent = stack.length > 1 && stack[stack.length - 2];
      if (parentParent.type === "<<") {
        return this._error("Unexpected compound blank node expression in reified triple", token2);
      }
      this._predicate = null;
      return this._readPredicate(token2);
    }
  }
  // ### `_readBlankNodeTail` reads the end of a blank node
  _readBlankNodeTail(token2) {
    if (token2.type !== "]")
      return this._readBlankNodePunctuation(token2);
    if (this._subject !== null)
      this._emit(this._subject, this._predicate, this._object, this._graph);
    const empty = this._predicate === null;
    this._restoreContext("blank", token2);
    if (this._object !== null)
      return this._getContextEndReader();
    else if (this._predicate !== null)
      return this._readObject;
    else
      return empty ? this._readPredicateOrNamedGraph : this._readPredicateAfterBlank;
  }
  // ### `_readPredicateAfterBlank` reads a predicate after an anonymous blank node
  _readPredicateAfterBlank(token2) {
    switch (token2.type) {
      case ".":
      case "}":
        this._subject = null;
        return this._readPunctuation(token2);
      default:
        return this._readPredicate(token2);
    }
  }
  // ### `_readListItem` reads items from a list
  _readListItem(token2) {
    let item4 = null, list = null, next4 = this._readListItem;
    const previousList = this._subject, stack = this._contextStack, parent4 = stack[stack.length - 1];
    switch (token2.type) {
      case "[":
        this._saveContext(
          "blank",
          this._graph,
          list = this._factory.blankNode(),
          this.RDF_FIRST,
          this._subject = item4 = this._factory.blankNode()
        );
        next4 = this._readBlankNodeHead;
        break;
      case "(":
        this._saveContext(
          "list",
          this._graph,
          list = this._factory.blankNode(),
          this.RDF_FIRST,
          this.RDF_NIL
        );
        this._subject = null;
        break;
      case ")":
        this._restoreContext("list", token2);
        if (stack.length !== 0 && stack[stack.length - 1].type === "list")
          this._emit(this._subject, this._predicate, this._object, this._graph);
        if (this._predicate === null) {
          next4 = this._readPredicate;
          if (this._subject === this.RDF_NIL)
            return next4;
        } else {
          next4 = this._getContextEndReader();
          if (this._object === this.RDF_NIL)
            return next4;
        }
        list = this.RDF_NIL;
        break;
      case "literal":
        if (token2.prefix.length === 0) {
          this._literalValue = token2.value;
          next4 = this._readListItemDataTypeOrLang;
        } else {
          item4 = this._factory.literal(token2.value, this._factory.namedNode(token2.prefix));
          next4 = this._getContextEndReader();
        }
        break;
      case "{":
        if (!this._n3Mode)
          return this._error("Unexpected graph", token2);
        this._saveContext(
          "formula",
          this._graph,
          this._subject,
          this._predicate,
          this._graph = this._factory.blankNode()
        );
        return this._readSubject;
      case "<<":
        this._saveContext("<<", this._graph, null, null, null);
        this._graph = null;
        next4 = this._readSubject;
        break;
      default:
        if ((item4 = this._readEntity(token2)) === void 0)
          return;
    }
    if (list === null)
      this._subject = list = this._factory.blankNode();
    if (token2.type === "<<")
      stack[stack.length - 1].subject = this._subject;
    if (previousList === null) {
      if (parent4.predicate === null)
        parent4.subject = list;
      else
        parent4.object = list;
    } else {
      this._emit(previousList, this.RDF_REST, list, this._graph);
    }
    if (item4 !== null) {
      if (this._n3Mode && (token2.type === "IRI" || token2.type === "prefixed")) {
        this._saveContext("item", this._graph, list, this.RDF_FIRST, item4);
        this._subject = item4, this._predicate = null;
        return this._getPathReader(this._readListItem);
      }
      this._emit(list, this.RDF_FIRST, item4, this._graph);
    }
    return next4;
  }
  // ### `_readDataTypeOrLang` reads an _optional_ datatype or language
  _readDataTypeOrLang(token2) {
    return this._completeObjectLiteral(token2, false);
  }
  // ### `_readListItemDataTypeOrLang` reads an _optional_ datatype or language in a list
  _readListItemDataTypeOrLang(token2) {
    return this._completeObjectLiteral(token2, true);
  }
  // ### `_completeLiteral` completes a literal with an optional datatype or language
  _completeLiteral(token2, component3) {
    let literal4 = this._factory.literal(this._literalValue);
    let readCb;
    switch (token2.type) {
      // Create a datatyped literal
      case "type":
      case "typeIRI":
        const datatype3 = this._readEntity(token2);
        if (datatype3 === void 0) return;
        if (datatype3.value === IRIs_default.rdf.langString || datatype3.value === IRIs_default.rdf.dirLangString) {
          return this._error("Detected illegal (directional) languaged-tagged string with explicit datatype", token2);
        }
        literal4 = this._factory.literal(this._literalValue, datatype3);
        token2 = null;
        break;
      // Create a language-tagged string
      case "langcode":
        if (token2.value.split("-").some((t) => t.length > 8))
          return this._error("Detected language tag with subtag longer than 8 characters", token2);
        literal4 = this._factory.literal(this._literalValue, token2.value);
        this._literalLanguage = token2.value;
        token2 = null;
        readCb = this._readDirCode.bind(this, component3);
        break;
    }
    return { token: token2, literal: literal4, readCb };
  }
  _readDirCode(component3, listItem, token2) {
    if (token2.type === "dircode") {
      const term3 = this._factory.literal(this._literalValue, { language: this._literalLanguage, direction: token2.value });
      if (component3 === "subject")
        this._subject = term3;
      else
        this._object = term3;
      this._literalLanguage = void 0;
      token2 = null;
    }
    if (component3 === "subject")
      return token2 === null ? this._readPredicateOrNamedGraph : this._readPredicateOrNamedGraph(token2);
    return this._completeObjectLiteralPost(token2, listItem);
  }
  // Completes a literal in subject position
  _completeSubjectLiteral(token2) {
    const completed2 = this._completeLiteral(token2, "subject");
    this._subject = completed2.literal;
    if (completed2.readCb)
      return completed2.readCb.bind(this, false);
    return this._readPredicateOrNamedGraph;
  }
  // Completes a literal in object position
  _completeObjectLiteral(token2, listItem) {
    const completed2 = this._completeLiteral(token2, "object");
    if (!completed2)
      return;
    this._object = completed2.literal;
    if (completed2.readCb)
      return completed2.readCb.bind(this, listItem);
    return this._completeObjectLiteralPost(completed2.token, listItem);
  }
  _completeObjectLiteralPost(token2, listItem) {
    if (listItem)
      this._emit(this._subject, this.RDF_FIRST, this._object, this._graph);
    if (token2 === null)
      return this._getContextEndReader();
    else {
      this._readCallback = this._getContextEndReader();
      return this._readCallback(token2);
    }
  }
  // ### `_readFormulaTail` reads the end of a formula
  _readFormulaTail(token2) {
    if (token2.type !== "}")
      return this._readPunctuation(token2);
    if (this._subject !== null)
      this._emit(this._subject, this._predicate, this._object, this._graph);
    this._restoreContext("formula", token2);
    return this._object === null ? this._readPredicate : this._getContextEndReader();
  }
  // ### `_readPunctuation` reads punctuation between quads or quad parts
  _readPunctuation(token2) {
    let next4, graph3 = this._graph, startingAnnotation = false;
    const subject8 = this._subject, inversePredicate = this._inversePredicate;
    switch (token2.type) {
      // A closing brace ends a graph
      case "}":
        if (this._graph === null)
          return this._error("Unexpected graph closing", token2);
        if (this._n3Mode)
          return this._readFormulaTail(token2);
        this._graph = null;
      // A dot just ends the statement, without sharing anything with the next
      case ".":
        this._subject = null;
        this._tripleTerm = null;
        next4 = this._contextStack.length ? this._readSubject : this._readInTopContext;
        if (inversePredicate) this._inversePredicate = false;
        break;
      // Semicolon means the subject is shared; predicate and object are different
      case ";":
        next4 = this._readPredicate;
        break;
      // Comma means both the subject and predicate are shared; the object is different
      case ",":
        next4 = this._readObject;
        break;
      // ~ is allowed in the annotation syntax
      case "~":
        next4 = this._readReifierInAnnotation;
        startingAnnotation = true;
        break;
      // {| means that the current triple is annotated with predicate-object pairs.
      case "{|":
        this._subject = this._readTripleTerm();
        this._validAnnotation = false;
        startingAnnotation = true;
        next4 = this._readPredicate;
        break;
      // |} means that the current reified triple in annotation syntax is finalized.
      case "|}":
        if (!this._annotation)
          return this._error("Unexpected annotation syntax closing", token2);
        if (!this._validAnnotation)
          return this._error("Annotation block can not be empty", token2);
        this._subject = null;
        this._annotation = false;
        next4 = this._readPunctuation;
        break;
      default:
        if (this._supportsQuads && this._graph === null && (graph3 = this._readEntity(token2)) !== void 0) {
          next4 = this._readQuadPunctuation;
          break;
        }
        return this._error(`Expected punctuation to follow "${this._object.id}"`, token2);
    }
    if (subject8 !== null && (!startingAnnotation || startingAnnotation && !this._annotation)) {
      const predicate4 = this._predicate, object8 = this._object;
      if (!inversePredicate)
        this._emit(subject8, predicate4, object8, graph3);
      else
        this._emit(object8, predicate4, subject8, graph3);
    }
    if (startingAnnotation) {
      this._annotation = true;
    }
    return next4;
  }
  // ### `_readBlankNodePunctuation` reads punctuation in a blank node
  _readBlankNodePunctuation(token2) {
    let next4;
    switch (token2.type) {
      // Semicolon means the subject is shared; predicate and object are different
      case ";":
        next4 = this._readPredicate;
        break;
      // Comma means both the subject and predicate are shared; the object is different
      case ",":
        next4 = this._readObject;
        break;
      default:
        return this._error(`Expected punctuation to follow "${this._object.id}"`, token2);
    }
    this._emit(this._subject, this._predicate, this._object, this._graph);
    return next4;
  }
  // ### `_readQuadPunctuation` reads punctuation after a quad
  _readQuadPunctuation(token2) {
    if (token2.type !== ".")
      return this._error("Expected dot to follow quad", token2);
    return this._readInTopContext;
  }
  // ### `_readPrefix` reads the prefix of a prefix declaration
  _readPrefix(token2) {
    if (token2.type !== "prefix")
      return this._error("Expected prefix to follow @prefix", token2);
    this._prefix = token2.value;
    return this._readPrefixIRI;
  }
  // ### `_readPrefixIRI` reads the IRI of a prefix declaration
  _readPrefixIRI(token2) {
    if (token2.type !== "IRI")
      return this._error(`Expected IRI to follow prefix "${this._prefix}:"`, token2);
    const prefixNode = this._readEntity(token2);
    this._prefixes[this._prefix] = prefixNode.value;
    this._prefixCallback(this._prefix, prefixNode);
    return this._readDeclarationPunctuation;
  }
  // ### `_readBaseIRI` reads the IRI of a base declaration
  _readBaseIRI(token2) {
    const iri = token2.type === "IRI" && this._resolveIRI(token2.value);
    if (!iri)
      return this._error("Expected valid IRI to follow base declaration", token2);
    this._setBase(iri);
    return this._readDeclarationPunctuation;
  }
  // ### `_isValidVersion` checks if the given version is valid for this parser to handle.
  _isValidVersion(version6) {
    return this._parseUnsupportedVersions || _N3Parser.SUPPORTED_VERSIONS.includes(version6);
  }
  // ### `_readVersion` reads version string declaration
  _readVersion(token2) {
    if (token2.type !== "literal")
      return this._error("Expected literal to follow version declaration", token2);
    if (token2.end - token2.start !== token2.value.length + 2)
      return this._error("Version declarations must use single quotes", token2);
    this._versionCallback(token2.value);
    if (!this._isValidVersion(token2.value))
      return this._error(`Detected unsupported version: "${token2.value}"`, token2);
    return this._readDeclarationPunctuation;
  }
  // ### `_readNamedGraphLabel` reads the label of a named graph
  _readNamedGraphLabel(token2) {
    switch (token2.type) {
      case "IRI":
      case "blank":
      case "prefixed":
        return this._readSubject(token2), this._readGraph;
      case "[":
        return this._readNamedGraphBlankLabel;
      default:
        return this._error("Invalid graph label", token2);
    }
  }
  // ### `_readNamedGraphLabel` reads a blank node label of a named graph
  _readNamedGraphBlankLabel(token2) {
    if (token2.type !== "]")
      return this._error("Invalid graph label", token2);
    this._subject = this._factory.blankNode();
    return this._readGraph;
  }
  // ### `_readDeclarationPunctuation` reads the punctuation of a declaration
  _readDeclarationPunctuation(token2) {
    if (this._sparqlStyle) {
      this._sparqlStyle = false;
      return this._readInTopContext(token2);
    }
    if (token2.type !== ".")
      return this._error("Expected declaration to end with a dot", token2);
    return this._readInTopContext;
  }
  // Reads a list of quantified symbols from a @forSome or @forAll statement
  _readQuantifierList(token2) {
    let entity3;
    switch (token2.type) {
      case "IRI":
      case "prefixed":
        if ((entity3 = this._readEntity(token2, true)) !== void 0)
          break;
      default:
        return this._error(`Unexpected ${token2.type}`, token2);
    }
    if (!this._explicitQuantifiers)
      this._quantified[entity3.id] = this._factory[this._quantifier](this._factory.blankNode().value);
    else {
      if (this._subject === null)
        this._emit(
          this._graph || this.DEFAULTGRAPH,
          this._predicate,
          this._subject = this._factory.blankNode(),
          this.QUANTIFIERS_GRAPH
        );
      else
        this._emit(
          this._subject,
          this.RDF_REST,
          this._subject = this._factory.blankNode(),
          this.QUANTIFIERS_GRAPH
        );
      this._emit(this._subject, this.RDF_FIRST, entity3, this.QUANTIFIERS_GRAPH);
    }
    return this._readQuantifierPunctuation;
  }
  // Reads punctuation from a @forSome or @forAll statement
  _readQuantifierPunctuation(token2) {
    if (token2.type === ",")
      return this._readQuantifierList;
    else {
      if (this._explicitQuantifiers) {
        this._emit(this._subject, this.RDF_REST, this.RDF_NIL, this.QUANTIFIERS_GRAPH);
        this._subject = null;
      }
      this._readCallback = this._getContextEndReader();
      return this._readCallback(token2);
    }
  }
  // ### `_getPathReader` reads a potential path and then resumes with the given function
  _getPathReader(afterPath) {
    this._afterPath = afterPath;
    return this._readPath;
  }
  // ### `_readPath` reads a potential path
  _readPath(token2) {
    switch (token2.type) {
      // Forward path
      case "!":
        return this._readForwardPath;
      // Backward path
      case "^":
        return this._readBackwardPath;
      // Not a path; resume reading where we left off
      default:
        const stack = this._contextStack, parent4 = stack.length && stack[stack.length - 1];
        if (parent4 && parent4.type === "item") {
          const item4 = this._subject;
          this._restoreContext("item", token2);
          this._emit(this._subject, this.RDF_FIRST, item4, this._graph);
        }
        return this._afterPath(token2);
    }
  }
  // ### `_readForwardPath` reads a '!' path
  _readForwardPath(token2) {
    let subject8, predicate4;
    const object8 = this._factory.blankNode();
    if ((predicate4 = this._readEntity(token2)) === void 0)
      return;
    if (this._predicate === null)
      subject8 = this._subject, this._subject = object8;
    else
      subject8 = this._object, this._object = object8;
    this._emit(subject8, predicate4, object8, this._graph);
    return this._readPath;
  }
  // ### `_readBackwardPath` reads a '^' path
  _readBackwardPath(token2) {
    const subject8 = this._factory.blankNode();
    let predicate4, object8;
    if ((predicate4 = this._readEntity(token2)) === void 0)
      return;
    if (this._predicate === null)
      object8 = this._subject, this._subject = subject8;
    else
      object8 = this._object, this._object = subject8;
    this._emit(subject8, predicate4, object8, this._graph);
    return this._readPath;
  }
  // ### `_readTripleTermTail` reads the end of a triple term
  _readTripleTermTail(token2) {
    if (token2.type !== ")>>")
      return this._error(`Expected )>> but got ${token2.type}`, token2);
    const quad3 = this._factory.quad(
      this._subject,
      this._predicate,
      this._object,
      this._graph || this.DEFAULTGRAPH
    );
    this._restoreContext("<<(", token2);
    if (this._subject === null) {
      this._subject = quad3;
      return this._readPredicate;
    } else {
      this._object = quad3;
      return this._getContextEndReader();
    }
  }
  // ### `_readReifiedTripleTailOrReifier` reads a reifier or the end of a nested reified triple
  _readReifiedTripleTailOrReifier(token2) {
    if (token2.type === "~") {
      return this._readReifier;
    }
    return this._readReifiedTripleTail(token2);
  }
  // ### `_readReifiedTripleTail` reads the end of a nested reified triple
  _readReifiedTripleTail(token2) {
    if (token2.type !== ">>")
      return this._error(`Expected >> but got ${token2.type}`, token2);
    this._tripleTerm = null;
    const reifier = this._readTripleTerm();
    this._restoreContext("<<", token2);
    const stack = this._contextStack, parent4 = stack.length && stack[stack.length - 1];
    if (parent4 && parent4.type === "list") {
      this._emit(this._subject, this.RDF_FIRST, reifier, this._graph);
      return this._getContextEndReader();
    } else if (this._subject === null) {
      this._subject = reifier;
      return this._readPredicateOrReifierTripleEnd;
    } else {
      this._object = reifier;
      return this._getContextEndReader();
    }
  }
  _readPredicateOrReifierTripleEnd(token2) {
    if (token2.type === ".") {
      this._subject = null;
      return this._readPunctuation(token2);
    }
    return this._readPredicate(token2);
  }
  // ### `_readReifier` reads the triple term identifier after a tilde when in a reifying triple.
  _readReifier(token2) {
    this._reifier = this._readEntity(token2);
    return this._readReifiedTripleTail;
  }
  // ### `_readReifier` reads the optional triple term identifier after a tilde when in annotation syntax.
  _readReifierInAnnotation(token2) {
    if (token2.type === "IRI" || token2.type === "typeIRI" || token2.type === "type" || token2.type === "prefixed" || token2.type === "blank" || token2.type === "var") {
      this._reifier = this._readEntity(token2);
      return this._readPunctuation;
    }
    this._readTripleTerm();
    this._subject = null;
    return this._readPunctuation(token2);
  }
  _readTripleTerm() {
    const stack = this._contextStack, parent4 = stack.length && stack[stack.length - 1];
    const parentGraph = parent4 ? parent4.graph : void 0;
    const reifier = this._reifier || this._factory.blankNode();
    this._reifier = null;
    this._tripleTerm = this._tripleTerm || this._factory.quad(this._subject, this._predicate, this._object);
    this._emit(reifier, this.RDF_REIFIES, this._tripleTerm, parentGraph || this.DEFAULTGRAPH);
    return reifier;
  }
  // ### `_getContextEndReader` gets the next reader function at the end of a context
  _getContextEndReader() {
    const contextStack = this._contextStack;
    if (!contextStack.length)
      return this._readPunctuation;
    switch (contextStack[contextStack.length - 1].type) {
      case "blank":
        return this._readBlankNodeTail;
      case "list":
        return this._readListItem;
      case "formula":
        return this._readFormulaTail;
      case "<<(":
        return this._readTripleTermTail;
      case "<<":
        return this._readReifiedTripleTailOrReifier;
    }
  }
  // ### `_emit` sends a quad through the callback
  _emit(subject8, predicate4, object8, graph3) {
    this._callback(null, this._factory.quad(subject8, predicate4, object8, graph3 || this.DEFAULTGRAPH));
  }
  // ### `_error` emits an error message through the callback
  _error(message4, token2) {
    const err2 = new Error(`${message4} on line ${token2.line}.`);
    err2.context = {
      token: token2,
      line: token2.line,
      previousToken: this._lexer.previousToken
    };
    this._callback(err2);
    this._callback = noop2;
  }
  // ### `_resolveIRI` resolves an IRI against the base path
  _resolveIRI(iri) {
    return /^[a-z][a-z0-9+.-]*:/i.test(iri) ? iri : this._resolveRelativeIRI(iri);
  }
  // ### `_resolveRelativeIRI` resolves an IRI against the base path,
  // assuming that a base path has been set and that the IRI is indeed relative
  _resolveRelativeIRI(iri) {
    if (!iri.length)
      return this._base;
    switch (iri[0]) {
      // Resolve relative fragment IRIs against the base IRI
      case "#":
        return this._base + iri;
      // Resolve relative query string IRIs by replacing the query string
      case "?":
        return this._base.replace(/(?:\?.*)?$/, iri);
      // Resolve root-relative IRIs at the root of the base IRI
      case "/":
        return (iri[1] === "/" ? this._baseScheme : this._baseRoot) + this._removeDotSegments(iri);
      // Resolve all other IRIs at the base IRI's path
      default:
        return /^[^/:]*:/.test(iri) ? null : this._removeDotSegments(this._basePath + iri);
    }
  }
  // ### `_removeDotSegments` resolves './' and '../' path segments in an IRI as per RFC3986
  _removeDotSegments(iri) {
    if (!/(^|\/)\.\.?($|[/#?])/.test(iri))
      return iri;
    const length3 = iri.length;
    let result6 = "", i = -1, pathStart = -1, segmentStart = 0, next4 = "/";
    while (i < length3) {
      switch (next4) {
        // The path starts with the first slash after the authority
        case ":":
          if (pathStart < 0) {
            if (iri[++i] === "/" && iri[++i] === "/")
              while ((pathStart = i + 1) < length3 && iri[pathStart] !== "/")
                i = pathStart;
          }
          break;
        // Don't modify a query string or fragment
        case "?":
        case "#":
          i = length3;
          break;
        // Handle '/.' or '/..' path segments
        case "/":
          if (iri[i + 1] === ".") {
            next4 = iri[++i + 1];
            switch (next4) {
              // Remove a '/.' segment
              case "/":
                result6 += iri.substring(segmentStart, i - 1);
                segmentStart = i + 1;
                break;
              // Remove a trailing '/.' segment
              case void 0:
              case "?":
              case "#":
                return result6 + iri.substring(segmentStart, i) + iri.substr(i + 1);
              // Remove a '/..' segment
              case ".":
                next4 = iri[++i + 1];
                if (next4 === void 0 || next4 === "/" || next4 === "?" || next4 === "#") {
                  result6 += iri.substring(segmentStart, i - 2);
                  if ((segmentStart = result6.lastIndexOf("/")) >= pathStart)
                    result6 = result6.substr(0, segmentStart);
                  if (next4 !== "/")
                    return `${result6}/${iri.substr(i + 1)}`;
                  segmentStart = i + 1;
                }
            }
          }
      }
      next4 = iri[++i];
    }
    return result6 + iri.substring(segmentStart);
  }
  // ## Public methods
  // ### `parse` parses the N3 input and emits each parsed quad through the onQuad callback.
  parse(input2, quadCallback, prefixCallback, versionCallback) {
    let onQuad, onPrefix, onComment, onVersion;
    if (quadCallback && (quadCallback.onQuad || quadCallback.onPrefix || quadCallback.onComment || quadCallback.onVersion)) {
      onQuad = quadCallback.onQuad;
      onPrefix = quadCallback.onPrefix;
      onComment = quadCallback.onComment;
      onVersion = quadCallback.onVersion;
    } else {
      onQuad = quadCallback;
      onPrefix = prefixCallback;
      onVersion = versionCallback;
    }
    this._readCallback = this._readBeforeTopContext;
    this._sparqlStyle = false;
    this._prefixes = /* @__PURE__ */ Object.create(null);
    this._prefixes._ = this._blankNodePrefix ? this._blankNodePrefix.substr(2) : `b${blankNodePrefix++}_`;
    this._prefixCallback = onPrefix || noop2;
    this._versionCallback = onVersion || noop2;
    this._inversePredicate = false;
    this._quantified = /* @__PURE__ */ Object.create(null);
    if (!onQuad) {
      const quads = [];
      let error4;
      this._callback = (e, t) => {
        e ? error4 = e : t && quads.push(t);
      };
      this._lexer.tokenize(input2).every((token2) => {
        return this._readCallback = this._readCallback(token2);
      });
      if (error4) throw error4;
      return quads;
    }
    let processNextToken = (error4, token2) => {
      if (error4 !== null)
        this._callback(error4), this._callback = noop2;
      else if (this._readCallback)
        this._readCallback = this._readCallback(token2);
    };
    if (onComment) {
      this._lexer.comments = true;
      processNextToken = (error4, token2) => {
        if (error4 !== null)
          this._callback(error4), this._callback = noop2;
        else if (this._readCallback) {
          if (token2.type === "comment")
            onComment(token2.value);
          else
            this._readCallback = this._readCallback(token2);
        }
      };
    }
    this._callback = onQuad;
    this._lexer.tokenize(input2, processNextToken);
  }
};
function noop2() {
}
function initDataFactory(parser, factory) {
  parser._factory = factory;
  parser.DEFAULTGRAPH = factory.defaultGraph();
  parser.RDF_FIRST = factory.namedNode(IRIs_default.rdf.first);
  parser.RDF_REST = factory.namedNode(IRIs_default.rdf.rest);
  parser.RDF_NIL = factory.namedNode(IRIs_default.rdf.nil);
  parser.RDF_REIFIES = factory.namedNode(IRIs_default.rdf.reifies);
  parser.N3_FORALL = factory.namedNode(IRIs_default.r.forAll);
  parser.N3_FORSOME = factory.namedNode(IRIs_default.r.forSome);
  parser.ABBREVIATIONS = {
    "a": factory.namedNode(IRIs_default.rdf.type),
    "=": factory.namedNode(IRIs_default.owl.sameAs),
    ">": factory.namedNode(IRIs_default.log.implies),
    "<": factory.namedNode(IRIs_default.log.isImpliedBy)
  };
  parser.QUANTIFIERS_GRAPH = factory.namedNode("urn:n3:quantifiers");
}
N3Parser.SUPPORTED_VERSIONS = [
  "1.2",
  "1.2-basic",
  "1.1"
];
initDataFactory(N3Parser.prototype, N3DataFactory_default);

// node_modules/rdflib/esm/rdfaparser.js
if (typeof Node3 === "undefined") {
  Node3 = {
    ELEMENT_NODE: 1,
    ATTRIBUTE_NODE: 2,
    TEXT_NODE: 3,
    CDATA_SECTION_NODE: 4,
    ENTITY_REFERENCE_NODE: 5,
    ENTITY_NODE: 6,
    PROCESSING_INSTRUCTION_NODE: 7,
    COMMENT_NODE: 8,
    DOCUMENT_NODE: 9,
    DOCUMENT_TYPE_NODE: 10,
    DOCUMENT_FRAGMENT_NODE: 11,
    NOTATION_NODE: 12
  };
}
var Node3;
var RDFaProcessor = class _RDFaProcessor {
  constructor(kb, options) {
    this.options = options || {};
    this.kb = kb;
    this.target = options.target || {
      graph: {
        subjects: {},
        prefixes: {},
        terms: {}
      }
    };
    this.blankNodes = [];
    this.htmlOptions = {
      "selfClosing": "br img input area base basefont col colgroup source wbr isindex link meta param hr"
    };
    this.theOne = "_:" + (/* @__PURE__ */ new Date()).getTime();
    this.language = null;
    this.vocabulary = null;
    this.blankCounter = 0;
    this.langAttributes = [{
      namespaceURI: "http://www.w3.org/XML/1998/namespace",
      localName: "lang"
    }];
    this.inXHTMLMode = false;
    this.absURIRE = /[\w\_\-]+:\S+/;
    this.finishedHandlers = [];
    this.init();
  }
  addTriple(origin4, subject8, predicate4, object8) {
    var su, ob, pr, or2;
    if (typeof subject8 === "undefined") {
      su = canonical_data_factory_default.namedNode(this.options.base);
    } else {
      su = this.toRDFNodeObject(subject8);
    }
    pr = this.toRDFNodeObject(predicate4);
    ob = this.toRDFNodeObject(object8);
    or2 = canonical_data_factory_default.namedNode(this.options.base);
    this.kb.add(su, pr, ob, or2);
  }
  ancestorPath(node3) {
    var path3 = "";
    while (node3 && node3.nodeType !== Node3.DOCUMENT_NODE) {
      path3 = "/" + node3.localName + path3;
      node3 = node3.parentNode;
    }
    return path3;
  }
  copyMappings(mappings) {
    var newMappings = {};
    for (var k in mappings) {
      newMappings[k] = mappings[k];
    }
    return newMappings;
  }
  copyProperties() {
  }
  deriveDateTimeType(value8) {
    for (var i = 0; i < _RDFaProcessor.dateTimeTypes.length; i++) {
      var matched = _RDFaProcessor.dateTimeTypes[i].pattern.exec(value8);
      if (matched && matched[0].length === value8.length) {
        return _RDFaProcessor.dateTimeTypes[i].type;
      }
    }
    return null;
  }
  init() {
  }
  newBlankNode() {
    this.blankCounter++;
    return "_:" + this.blankCounter;
  }
  newSubjectOrigin(origin4, subject8) {
  }
  parseCURIE(value8, prefixes2, base2) {
    var colon = value8.indexOf(":");
    var uri6;
    if (colon >= 0) {
      var prefix3 = value8.substring(0, colon);
      if (prefix3 === "") {
        uri6 = prefixes2[""];
        return uri6 ? uri6 + value8.substring(colon + 1) : null;
      } else if (prefix3 === "_") {
        return "_:" + value8.substring(colon + 1);
      } else if (_RDFaProcessor.NCNAME.test(prefix3)) {
        uri6 = prefixes2[prefix3];
        if (uri6) {
          return uri6 + value8.substring(colon + 1);
        }
      }
    }
    return null;
  }
  parseCURIEOrURI(value8, prefixes2, base2) {
    var curie = this.parseCURIE(value8, prefixes2, base2);
    if (curie) {
      return curie;
    }
    return this.resolveAndNormalize(base2, value8);
  }
  parsePredicate(value8, defaultVocabulary, terms, prefixes2, base2, ignoreTerms) {
    if (value8 === "") {
      return null;
    }
    var predicate4 = this.parseTermOrCURIEOrAbsURI(value8, defaultVocabulary, ignoreTerms ? null : terms, prefixes2, base2);
    if (predicate4 && predicate4.indexOf("_:") === 0) {
      return null;
    }
    return predicate4;
  }
  parsePrefixMappings(str, target6) {
    var values2 = this.tokenize(str);
    var prefix3 = null;
    for (var i = 0; i < values2.length; i++) {
      if (values2[i][values2[i].length - 1] === ":") {
        prefix3 = values2[i].substring(0, values2[i].length - 1);
      } else if (prefix3) {
        target6[prefix3] = this.options.base ? join(values2[i], this.options.base) : values2[i];
        prefix3 = null;
      }
    }
  }
  static parseRDFaDOM(dom, kb, base2) {
    var p = new _RDFaProcessor(kb, {
      "base": base2
    });
    if (!dom.baseURI) {
      dom.baseURI = base2;
    }
    p.process(dom, {
      baseURI: base2
    });
  }
  parseSafeCURIEOrCURIEOrURI(value8, prefixes2, base2) {
    value8 = this.trim(value8);
    if (value8.charAt(0) === "[" && value8.charAt(value8.length - 1) === "]") {
      value8 = value8.substring(1, value8.length - 1);
      value8 = value8.trim(value8);
      if (value8.length === 0) {
        return null;
      }
      if (value8 === "_:") {
        return this.theOne;
      }
      return this.parseCURIE(value8, prefixes2, base2);
    } else {
      return this.parseCURIEOrURI(value8, prefixes2, base2);
    }
  }
  parseTermOrCURIEOrAbsURI(value8, defaultVocabulary, terms, prefixes2, base2) {
    value8 = this.trim(value8);
    var curie = this.parseCURIE(value8, prefixes2, base2);
    if (curie) {
      return curie;
    } else if (terms) {
      if (defaultVocabulary && !this.absURIRE.exec(value8)) {
        return defaultVocabulary + value8;
      }
      var term3 = terms[value8];
      if (term3) {
        return term3;
      }
      var lcvalue = value8.toLowerCase();
      term3 = terms[lcvalue];
      if (term3) {
        return term3;
      }
    }
    if (this.absURIRE.exec(value8)) {
      return this.resolveAndNormalize(base2, value8);
    }
    return null;
  }
  parseTermOrCURIEOrURI(value8, defaultVocabulary, terms, prefixes2, base2) {
    value8 = this.trim(value8);
    var curie = this.parseCURIE(value8, prefixes2, base2);
    if (curie) {
      return curie;
    } else {
      var term3 = terms[value8];
      if (term3) {
        return term3;
      }
      var lcvalue = value8.toLowerCase();
      term3 = terms[lcvalue];
      if (term3) {
        return term3;
      }
      if (defaultVocabulary && !this.absURIRE.exec(value8)) {
        return defaultVocabulary + value8;
      }
    }
    return this.resolveAndNormalize(base2, value8);
  }
  parseURI(uri6) {
    return uri6;
  }
  process(node3, options) {
    options = options || {};
    var base2;
    if (node3.nodeType === Node3.DOCUMENT_NODE) {
      if (node3.baseURI && !options.baseURI) {
        options.baseURI = node3.baseURI;
      }
      base2 = node3.baseURI;
      node3 = node3.documentElement;
      if (!node3.baseURI) {
        node3.baseURI = base2;
      }
      this.setContext(node3);
    } else if (node3.parentNode.nodeType === Node3.DOCUMENT_NODE) {
      this.setContext(node3);
    }
    var queue = [];
    var removeHash = function(baseURI) {
      if ((!baseURI || baseURI === "about:blank") && options && options.baseURI) {
        return options.baseURI;
      }
      var hash2 = baseURI.indexOf("#");
      if (hash2 >= 0) {
        baseURI = baseURI.substring(0, hash2);
      }
      if (options && options.baseURIMap) {
        baseURI = options.baseURIMap(baseURI);
      }
      return baseURI;
    };
    queue.push({
      current: node3,
      context: this.push(null, removeHash(node3.baseURI))
    });
    while (queue.length > 0) {
      var item4 = queue.shift();
      if (item4.parent) {
        if (item4.context.parent && item4.context.parent.listMapping === item4.listMapping) {
          continue;
        }
        for (let predicate5 in item4.listMapping) {
          var list = item4.listMapping[predicate5];
          if (list.length === 0) {
            this.addTriple(item4.parent, item4.subject, predicate5, {
              type: _RDFaProcessor.objectURI,
              value: "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
            });
            continue;
          }
          var bnodes = [];
          for (let i2 = 0; i2 < list.length; i2++) {
            bnodes.push(this.newBlankNode());
          }
          for (let i2 = 0; i2 < bnodes.length; i2++) {
            this.addTriple(item4.parent, bnodes[i2], "http://www.w3.org/1999/02/22-rdf-syntax-ns#first", list[i2]);
            this.addTriple(item4.parent, bnodes[i2], "http://www.w3.org/1999/02/22-rdf-syntax-ns#rest", {
              type: _RDFaProcessor.objectURI,
              value: i2 + 1 < bnodes.length ? bnodes[i2 + 1] : "http://www.w3.org/1999/02/22-rdf-syntax-ns#nil"
            });
          }
          this.addTriple(item4.parent, item4.subject, predicate5, {
            type: _RDFaProcessor.objectURI,
            value: bnodes[0]
          });
        }
        continue;
      }
      var current3 = item4.current;
      var context4 = item4.context;
      var skip = false;
      var newSubject = null;
      var currentObjectResource = null;
      var typedResource = null;
      var prefixes2 = context4.prefixes;
      var prefixesCopied = false;
      var incomplete2 = [];
      var listMapping = context4.listMapping;
      var listMappingDifferent = !context4.parent;
      var language9 = context4.language;
      var vocabulary = context4.vocabulary;
      base2 = this.parseURI(removeHash(current3.baseURI));
      current3.item = null;
      var vocabAtt = current3.getAttributeNode("vocab");
      if (vocabAtt) {
        let value8 = this.trim(vocabAtt.value);
        if (value8.length > 0) {
          vocabulary = value8;
          var baseSubject = base2.spec;
          this.addTriple(current3, baseSubject, "http://www.w3.org/ns/rdfa#usesVocabulary", {
            type: _RDFaProcessor.objectURI,
            value: vocabulary
          });
        } else {
          vocabulary = this.vocabulary;
        }
      }
      for (var i = 0; i < current3.attributes.length; i++) {
        var att = current3.attributes[i];
        if (att.nodeName.charAt(0) === "x" && att.nodeName.indexOf("xmlns:") === 0) {
          if (!prefixesCopied) {
            prefixes2 = this.copyMappings(prefixes2);
            prefixesCopied = true;
          }
          var prefix3 = att.nodeName.substring(6);
          var ref = _RDFaProcessor.trim(att.value);
          prefixes2[prefix3] = this.options.base ? join(ref, this.options.base) : ref;
        }
      }
      var prefixAtt = current3.getAttributeNode("prefix");
      if (prefixAtt) {
        if (!prefixesCopied) {
          prefixes2 = this.copyMappings(prefixes2);
          prefixesCopied = true;
        }
        this.parsePrefixMappings(prefixAtt.value, prefixes2);
      }
      var xmlLangAtt = null;
      for (let i2 = 0; !xmlLangAtt && i2 < this.langAttributes.length; i2++) {
        xmlLangAtt = current3.getAttributeNodeNS(this.langAttributes[i2].namespaceURI, this.langAttributes[i2].localName);
      }
      if (xmlLangAtt) {
        let value8 = _RDFaProcessor.trim(xmlLangAtt.value);
        if (value8.length > 0) {
          language9 = value8;
        } else {
          language9 = null;
        }
      }
      var relAtt = current3.getAttributeNode("rel");
      var revAtt = current3.getAttributeNode("rev");
      var typeofAtt = current3.getAttributeNode("typeof");
      var propertyAtt = current3.getAttributeNode("property");
      var datatypeAtt = current3.getAttributeNode("datatype");
      var datetimeAtt = this.inHTMLMode ? current3.getAttributeNode("datetime") : null;
      var contentAtt = current3.getAttributeNode("content");
      var aboutAtt = current3.getAttributeNode("about");
      var srcAtt = current3.getAttributeNode("src");
      var resourceAtt = current3.getAttributeNode("resource");
      var hrefAtt = current3.getAttributeNode("href");
      var inlistAtt = current3.getAttributeNode("inlist");
      var relAttPredicates = [];
      var predicate4, values2;
      if (relAtt) {
        values2 = this.tokenize(relAtt.value);
        for (let i2 = 0; i2 < values2.length; i2++) {
          predicate4 = this.parsePredicate(values2[i2], vocabulary, context4.terms, prefixes2, base2, this.inHTMLMode && propertyAtt !== null);
          if (predicate4) {
            relAttPredicates.push(predicate4);
          }
        }
      }
      var revAttPredicates = [];
      if (revAtt) {
        values2 = this.tokenize(revAtt.value);
        for (let i2 = 0; i2 < values2.length; i2++) {
          predicate4 = this.parsePredicate(values2[i2], vocabulary, context4.terms, prefixes2, base2, this.inHTMLMode && propertyAtt);
          if (predicate4) {
            revAttPredicates.push(predicate4);
          }
        }
      }
      if (this.inHTMLMode && (relAtt || revAtt) && propertyAtt) {
        if (relAttPredicates.length === 0) {
          relAtt = null;
        }
        if (revAttPredicates.length === 0) {
          revAtt = null;
        }
      }
      if (relAtt || revAtt) {
        if (aboutAtt) {
          newSubject = this.parseSafeCURIEOrCURIEOrURI(aboutAtt.value, prefixes2, base2);
        }
        if (typeofAtt) {
          typedResource = newSubject;
        }
        if (!newSubject) {
          if (current3.parentNode.nodeType === Node3.DOCUMENT_NODE) {
            newSubject = removeHash(current3.baseURI);
          } else if (context4.parentObject) {
            newSubject = removeHash(current3.parentNode.baseURI) === context4.parentObject ? removeHash(current3.baseURI) : context4.parentObject;
          }
        }
        if (resourceAtt) {
          currentObjectResource = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes2, base2);
        }
        if (!currentObjectResource) {
          if (hrefAtt) {
            currentObjectResource = this.resolveAndNormalize(base2, encodeURI(hrefAtt.value));
          } else if (srcAtt) {
            currentObjectResource = this.resolveAndNormalize(base2, encodeURI(srcAtt.value));
          } else if (typeofAtt && !aboutAtt && !(this.inXHTMLMode && (current3.localName === "head" || current3.localName === "body"))) {
            currentObjectResource = this.newBlankNode();
          }
        }
        if (typeofAtt && !aboutAtt && this.inXHTMLMode && (current3.localName === "head" || current3.localName === "body")) {
          typedResource = newSubject;
        } else if (typeofAtt && !aboutAtt) {
          typedResource = currentObjectResource;
        }
      } else if (propertyAtt && !contentAtt && !datatypeAtt) {
        if (aboutAtt) {
          newSubject = this.parseSafeCURIEOrCURIEOrURI(aboutAtt.value, prefixes2, base2);
          if (typeofAtt) {
            typedResource = newSubject;
          }
        }
        if (!newSubject && current3.parentNode.nodeType === Node3.DOCUMENT_NODE) {
          newSubject = removeHash(current3.baseURI);
          if (typeofAtt) {
            typedResource = newSubject;
          }
        } else if (!newSubject && context4.parentObject) {
          newSubject = removeHash(current3.parentNode.baseURI) === context4.parentObject ? removeHash(current3.baseURI) : context4.parentObject;
        }
        if (typeofAtt && !typedResource) {
          if (resourceAtt) {
            typedResource = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes2, base2);
          }
          if (!typedResource && hrefAtt) {
            typedResource = this.resolveAndNormalize(base2, encodeURI(hrefAtt.value));
          }
          if (!typedResource && srcAtt) {
            typedResource = this.resolveAndNormalize(base2, encodeURI(srcAtt.value));
          }
          if (!typedResource && (this.inXHTMLMode || this.inHTMLMode) && (current3.localName === "head" || current3.localName === "body")) {
            typedResource = newSubject;
          }
          if (!typedResource) {
            typedResource = this.newBlankNode();
          }
          currentObjectResource = typedResource;
        }
      } else {
        if (aboutAtt) {
          newSubject = this.parseSafeCURIEOrCURIEOrURI(aboutAtt.value, prefixes2, base2);
        }
        if (!newSubject && resourceAtt) {
          newSubject = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes2, base2);
        }
        if (!newSubject && hrefAtt) {
          newSubject = this.resolveAndNormalize(base2, encodeURI(hrefAtt.value));
        }
        if (!newSubject && srcAtt) {
          newSubject = this.resolveAndNormalize(base2, encodeURI(srcAtt.value));
        }
        if (!newSubject) {
          if (current3.parentNode.nodeType === Node3.DOCUMENT_NODE) {
            newSubject = removeHash(current3.baseURI);
          } else if ((this.inXHTMLMode || this.inHTMLMode) && (current3.localName === "head" || current3.localName === "body")) {
            newSubject = removeHash(current3.parentNode.baseURI) === context4.parentObject ? removeHash(current3.baseURI) : context4.parentObject;
          } else if (typeofAtt) {
            newSubject = this.newBlankNode();
          } else if (context4.parentObject) {
            newSubject = removeHash(current3.parentNode.baseURI) === context4.parentObject ? removeHash(current3.baseURI) : context4.parentObject;
            if (!propertyAtt) {
              skip = true;
            }
          }
        }
        if (typeofAtt) {
          typedResource = newSubject;
        }
      }
      if (newSubject) {
        if (aboutAtt || resourceAtt || typedResource) {
          var id4 = newSubject;
          if (typeofAtt && !aboutAtt && !resourceAtt && currentObjectResource) {
            id4 = currentObjectResource;
          }
          this.newSubjectOrigin(current3, id4);
        }
      }
      if (typedResource) {
        values2 = this.tokenize(typeofAtt.value);
        for (let i2 = 0; i2 < values2.length; i2++) {
          var object8 = this.parseTermOrCURIEOrAbsURI(values2[i2], vocabulary, context4.terms, prefixes2, base2);
          if (object8) {
            this.addTriple(current3, typedResource, _RDFaProcessor.typeURI, {
              type: _RDFaProcessor.objectURI,
              value: object8
            });
          }
        }
      }
      if (newSubject && newSubject !== context4.parentObject) {
        listMapping = {};
        listMappingDifferent = true;
      }
      if (currentObjectResource) {
        if (relAtt && inlistAtt) {
          for (let i2 = 0; i2 < relAttPredicates.length; i2++) {
            let list2 = listMapping[relAttPredicates[i2]];
            if (!list2) {
              list2 = [];
              listMapping[relAttPredicates[i2]] = list2;
            }
            list2.push({
              type: _RDFaProcessor.objectURI,
              value: currentObjectResource
            });
          }
        } else if (relAtt) {
          for (let i2 = 0; i2 < relAttPredicates.length; i2++) {
            this.addTriple(current3, newSubject, relAttPredicates[i2], {
              type: _RDFaProcessor.objectURI,
              value: currentObjectResource
            });
          }
        }
        if (revAtt) {
          for (let i2 = 0; i2 < revAttPredicates.length; i2++) {
            this.addTriple(current3, currentObjectResource, revAttPredicates[i2], {
              type: _RDFaProcessor.objectURI,
              value: newSubject
            });
          }
        }
      } else {
        if (newSubject && !currentObjectResource && (relAtt || revAtt)) {
          currentObjectResource = this.newBlankNode();
        }
        if (relAtt && inlistAtt) {
          for (let i2 = 0; i2 < relAttPredicates.length; i2++) {
            let list2 = listMapping[relAttPredicates[i2]];
            if (!list2) {
              list2 = [];
              listMapping[predicate4] = list2;
            }
            incomplete2.push({
              predicate: relAttPredicates[i2],
              list: list2
            });
          }
        } else if (relAtt) {
          for (let i2 = 0; i2 < relAttPredicates.length; i2++) {
            incomplete2.push({
              predicate: relAttPredicates[i2],
              forward: true
            });
          }
        }
        if (revAtt) {
          for (let i2 = 0; i2 < revAttPredicates.length; i2++) {
            incomplete2.push({
              predicate: revAttPredicates[i2],
              forward: false
            });
          }
        }
      }
      if (propertyAtt) {
        var datatype3 = null;
        var content5 = null;
        if (datatypeAtt) {
          datatype3 = datatypeAtt.value === "" ? _RDFaProcessor.PlainLiteralURI : this.parseTermOrCURIEOrAbsURI(datatypeAtt.value, vocabulary, context4.terms, prefixes2, base2);
          if (datetimeAtt && !contentAtt) {
            content5 = datetimeAtt.value;
          } else {
            content5 = datatype3 === _RDFaProcessor.XMLLiteralURI || datatype3 === _RDFaProcessor.HTMLLiteralURI ? null : contentAtt ? contentAtt.value : current3.textContent;
          }
        } else if (contentAtt) {
          datatype3 = _RDFaProcessor.PlainLiteralURI;
          content5 = contentAtt.value;
        } else if (datetimeAtt) {
          content5 = datetimeAtt.value;
          datatype3 = _RDFaProcessor.deriveDateTimeType(content5);
          if (!datatype3) {
            datatype3 = _RDFaProcessor.PlainLiteralURI;
          }
        } else if (!relAtt && !revAtt) {
          if (resourceAtt) {
            content5 = this.parseSafeCURIEOrCURIEOrURI(resourceAtt.value, prefixes2, base2);
          }
          if (!content5 && hrefAtt) {
            content5 = this.resolveAndNormalize(base2, encodeURI(hrefAtt.value));
          } else if (!content5 && srcAtt) {
            content5 = this.resolveAndNormalize(base2, encodeURI(srcAtt.value));
          }
          if (content5) {
            datatype3 = _RDFaProcessor.objectURI;
          }
        }
        if (!datatype3) {
          if (typeofAtt && !aboutAtt) {
            datatype3 = _RDFaProcessor.objectURI;
            content5 = typedResource;
          } else {
            content5 = current3.textContent;
            if (this.inHTMLMode && current3.localName === "time") {
              datatype3 = _RDFaProcessor.deriveDateTimeType(content5);
            }
            if (!datatype3) {
              datatype3 = _RDFaProcessor.PlainLiteralURI;
            }
          }
        }
        values2 = this.tokenize(propertyAtt.value);
        for (let i2 = 0; i2 < values2.length; i2++) {
          let predicate5 = this.parsePredicate(values2[i2], vocabulary, context4.terms, prefixes2, base2);
          if (predicate5) {
            if (inlistAtt) {
              let list2 = listMapping[predicate5];
              if (!list2) {
                list2 = [];
                listMapping[predicate5] = list2;
              }
              list2.push(datatype3 === _RDFaProcessor.XMLLiteralURI || datatype3 === _RDFaProcessor.HTMLLiteralURI ? {
                type: datatype3,
                value: current3.childNodes
              } : {
                type: datatype3 || _RDFaProcessor.PlainLiteralURI,
                value: content5,
                language: language9
              });
            } else {
              if (datatype3 === _RDFaProcessor.XMLLiteralURI || datatype3 === _RDFaProcessor.HTMLLiteralURI) {
                this.addTriple(current3, newSubject, predicate5, {
                  type: datatype3,
                  value: current3.childNodes
                });
              } else {
                this.addTriple(current3, newSubject, predicate5, {
                  type: datatype3 || _RDFaProcessor.PlainLiteralURI,
                  value: content5,
                  language: language9
                });
              }
            }
          }
        }
      }
      if (newSubject && !skip) {
        for (let i2 = 0; i2 < context4.incomplete.length; i2++) {
          if (context4.incomplete[i2].list) {
            context4.incomplete[i2].list.push({
              type: _RDFaProcessor.objectURI,
              value: newSubject
            });
          } else if (context4.incomplete[i2].forward) {
            this.addTriple(current3, context4.subject, context4.incomplete[i2].predicate, {
              type: _RDFaProcessor.objectURI,
              value: newSubject
            });
          } else {
            this.addTriple(current3, newSubject, context4.incomplete[i2].predicate, {
              type: _RDFaProcessor.objectURI,
              value: context4.subject
            });
          }
        }
      }
      var childContext = null;
      var listSubject = newSubject;
      if (skip) {
        childContext = this.push(context4, context4.subject);
        childContext.parentObject = removeHash(current3.parentNode.baseURI) === context4.parentObject ? removeHash(current3.baseURI) : context4.parentObject;
        childContext.incomplete = context4.incomplete;
        childContext.language = language9;
        childContext.prefixes = prefixes2;
        childContext.vocabulary = vocabulary;
      } else {
        childContext = this.push(context4, newSubject);
        childContext.parentObject = currentObjectResource || newSubject || context4.subject;
        childContext.prefixes = prefixes2;
        childContext.incomplete = incomplete2;
        if (currentObjectResource) {
          listSubject = currentObjectResource;
          listMapping = {};
          listMappingDifferent = true;
        }
        childContext.listMapping = listMapping;
        childContext.language = language9;
        childContext.vocabulary = vocabulary;
      }
      if (listMappingDifferent) {
        queue.unshift({
          parent: current3,
          context: context4,
          subject: listSubject,
          listMapping
        });
      }
      for (var child2 = current3.lastChild; child2; child2 = child2.previousSibling) {
        if (child2.nodeType === Node3.ELEMENT_NODE) {
          queue.unshift({
            current: child2,
            context: childContext
          });
        }
      }
    }
    if (this.inHTMLMode) {
      this.copyProperties();
    }
    for (let i2 = 0; i2 < this.finishedHandlers.length; i2++) {
      this.finishedHandlers[i2](node3);
    }
  }
  push(parent4, subject8) {
    return {
      parent: parent4,
      subject: subject8 || (parent4 ? parent4.subject : null),
      parentObject: null,
      incomplete: [],
      listMapping: parent4 ? parent4.listMapping : {},
      language: parent4 ? parent4.language : this.language,
      prefixes: parent4 ? parent4.prefixes : this.target.graph.prefixes,
      terms: parent4 ? parent4.terms : this.target.graph.terms,
      vocabulary: parent4 ? parent4.vocabulary : this.vocabulary
    };
  }
  resolveAndNormalize(base2, uri6) {
    return join(uri6, base2);
  }
  setContext(node3) {
    if (node3.localName === "html" && node3.getAttribute("version") === "XHTML+RDFa 1.1") {
      this.setXHTMLContext();
    } else if (node3.localName === "html" || node3.namespaceURI === "http://www.w3.org/1999/xhtml") {
      if (typeof document !== "undefined" && document.doctype) {
        if (document.doctype.publicId === "-//W3C//DTD XHTML+RDFa 1.0//EN" && document.doctype.systemId === "http://www.w3.org/MarkUp/DTD/xhtml-rdfa-1.dtd") {
          console.log("WARNING: RDF 1.0 is not supported.  Defaulting to HTML5 mode.");
          this.setHTMLContext();
        } else if (document.doctype.publicId === "-//W3C//DTD XHTML+RDFa 1.1//EN" && document.doctype.systemId === "http://www.w3.org/MarkUp/DTD/xhtml-rdfa-2.dtd") {
          this.setXHTMLContext();
        } else {
          this.setHTMLContext();
        }
      } else {
        this.setHTMLContext();
      }
    } else {
      this.setXMLContext();
    }
  }
  setHTMLContext() {
    this.setInitialContext();
    this.langAttributes = [{
      namespaceURI: "http://www.w3.org/XML/1998/namespace",
      localName: "lang"
    }, {
      namespaceURI: null,
      localName: "lang"
    }];
    this.inXHTMLMode = false;
    this.inHTMLMode = true;
  }
  setInitialContext() {
    this.vocabulary = null;
    this.langAttributes = [{
      namespaceURI: "http://www.w3.org/XML/1998/namespace",
      localName: "lang"
    }];
  }
  setXHTMLContext() {
    this.setInitialContext();
    this.inXHTMLMode = true;
    this.inHTMLMode = false;
    this.langAttributes = [{
      namespaceURI: "http://www.w3.org/XML/1998/namespace",
      localName: "lang"
    }, {
      namespaceURI: null,
      localName: "lang"
    }];
    this.target.graph.terms["alternate"] = "http://www.w3.org/1999/xhtml/vocab#alternate";
    this.target.graph.terms["appendix"] = "http://www.w3.org/1999/xhtml/vocab#appendix";
    this.target.graph.terms["bookmark"] = "http://www.w3.org/1999/xhtml/vocab#bookmark";
    this.target.graph.terms["cite"] = "http://www.w3.org/1999/xhtml/vocab#cite";
    this.target.graph.terms["chapter"] = "http://www.w3.org/1999/xhtml/vocab#chapter";
    this.target.graph.terms["contents"] = "http://www.w3.org/1999/xhtml/vocab#contents";
    this.target.graph.terms["copyright"] = "http://www.w3.org/1999/xhtml/vocab#copyright";
    this.target.graph.terms["first"] = "http://www.w3.org/1999/xhtml/vocab#first";
    this.target.graph.terms["glossary"] = "http://www.w3.org/1999/xhtml/vocab#glossary";
    this.target.graph.terms["help"] = "http://www.w3.org/1999/xhtml/vocab#help";
    this.target.graph.terms["icon"] = "http://www.w3.org/1999/xhtml/vocab#icon";
    this.target.graph.terms["index"] = "http://www.w3.org/1999/xhtml/vocab#index";
    this.target.graph.terms["last"] = "http://www.w3.org/1999/xhtml/vocab#last";
    this.target.graph.terms["license"] = "http://www.w3.org/1999/xhtml/vocab#license";
    this.target.graph.terms["meta"] = "http://www.w3.org/1999/xhtml/vocab#meta";
    this.target.graph.terms["next"] = "http://www.w3.org/1999/xhtml/vocab#next";
    this.target.graph.terms["prev"] = "http://www.w3.org/1999/xhtml/vocab#prev";
    this.target.graph.terms["previous"] = "http://www.w3.org/1999/xhtml/vocab#previous";
    this.target.graph.terms["section"] = "http://www.w3.org/1999/xhtml/vocab#section";
    this.target.graph.terms["stylesheet"] = "http://www.w3.org/1999/xhtml/vocab#stylesheet";
    this.target.graph.terms["subsection"] = "http://www.w3.org/1999/xhtml/vocab#subsection";
    this.target.graph.terms["start"] = "http://www.w3.org/1999/xhtml/vocab#start";
    this.target.graph.terms["top"] = "http://www.w3.org/1999/xhtml/vocab#top";
    this.target.graph.terms["up"] = "http://www.w3.org/1999/xhtml/vocab#up";
    this.target.graph.terms["p3pv1"] = "http://www.w3.org/1999/xhtml/vocab#p3pv1";
    this.target.graph.terms["related"] = "http://www.w3.org/1999/xhtml/vocab#related";
    this.target.graph.terms["role"] = "http://www.w3.org/1999/xhtml/vocab#role";
    this.target.graph.terms["transformation"] = "http://www.w3.org/1999/xhtml/vocab#transformation";
  }
  setXMLContext() {
    this.setInitialContext();
    this.inXHTMLMode = false;
    this.inHTMLMode = false;
  }
  tokenize(str) {
    return this.trim(str).split(/\s+/);
  }
  static tokenize(str) {
    return this.trim(str).split(/\s+/);
  }
  toRDFNodeObject(x) {
    if (typeof x === "undefined") return void 0;
    if (typeof x === "string") {
      if (x.substring(0, 2) === "_:") {
        if (typeof this.blankNodes[x.substring(2)] === "undefined") {
          this.blankNodes[x.substring(2)] = new BlankNode(x.substring(2));
        }
        return this.blankNodes[x.substring(2)];
      }
      return canonical_data_factory_default.namedNode(x);
    }
    switch (x.type) {
      case _RDFaProcessor.objectURI:
        if (x.value.substring(0, 2) === "_:") {
          if (typeof this.blankNodes[x.value.substring(2)] === "undefined") {
            this.blankNodes[x.value.substring(2)] = new BlankNode(x.value.substring(2));
          }
          return this.blankNodes[x.value.substring(2)];
        }
        return canonical_data_factory_default.namedNode(x.value);
      case _RDFaProcessor.PlainLiteralURI:
        return new Literal(x.value, x.language || "");
      case _RDFaProcessor.XMLLiteralURI:
      case _RDFaProcessor.HTMLLiteralURI:
        var string3 = "";
        Object.keys(x.value).forEach((i) => {
          string3 += domToString(x.value[i], this.htmlOptions);
        });
        return new Literal(string3, "", new NamedNode(x.type));
      default:
        return new Literal(x.value, "", new NamedNode(x.type));
    }
  }
  trim(str) {
    return str.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
  }
  static trim(str) {
    return str.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
  }
};
RDFaProcessor.XMLLiteralURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#XMLLiteral";
RDFaProcessor.HTMLLiteralURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#HTML";
RDFaProcessor.PlainLiteralURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#PlainLiteral";
RDFaProcessor.objectURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#object";
RDFaProcessor.typeURI = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
RDFaProcessor.nameChar = "[-A-Z_a-z\xC0-\xD6\xD8-\xF6\xF8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\u10000-\uEFFFF.0-9\xB7\u0300-\u036F\u203F-\u2040]";
RDFaProcessor.nameStartChar = "[A-Za-z\xC0-\xD6\xD8-\xF6\xF8-\xFF\u0100-\u0131\u0134-\u013E\u0141-\u0148\u014A-\u017E\u0180-\u01C3\u01CD-\u01F0\u01F4-\u01F5\u01FA-\u0217\u0250-\u02A8\u02BB-\u02C1\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03CE\u03D0-\u03D6\u03DA\u03DC\u03DE\u03E0\u03E2-\u03F3\u0401-\u040C\u040E-\u044F\u0451-\u045C\u045E-\u0481\u0490-\u04C4\u04C7-\u04C8\u04CB-\u04CC\u04D0-\u04EB\u04EE-\u04F5\u04F8-\u04F9\u0531-\u0556\u0559\u0561-\u0586\u05D0-\u05EA\u05F0-\u05F2\u0621-\u063A\u0641-\u064A\u0671-\u06B7\u06BA-\u06BE\u06C0-\u06CE\u06D0-\u06D3\u06D5\u06E5-\u06E6\u0905-\u0939\u093D\u0958-\u0961\u0985-\u098C\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09DC-\u09DD\u09DF-\u09E1\u09F0-\u09F1\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33\u0A35-\u0A36\u0A38-\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8B\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0AE0\u0B05-\u0B0C\u0B0F-\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B36-\u0B39\u0B3D\u0B5C-\u0B5D\u0B5F-\u0B61\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB5\u0BB7-\u0BB9\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C60-\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CDE\u0CE0-\u0CE1\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D28\u0D2A-\u0D39\u0D60-\u0D61\u0E01-\u0E2E\u0E30\u0E32-\u0E33\u0E40-\u0E45\u0E81-\u0E82\u0E84\u0E87-\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA-\u0EAB\u0EAD-\u0EAE\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0F40-\u0F47\u0F49-\u0F69\u10A0-\u10C5\u10D0-\u10F6\u1100\u1102-\u1103\u1105-\u1107\u1109\u110B-\u110C\u110E-\u1112\u113C\u113E\u1140\u114C\u114E\u1150\u1154-\u1155\u1159\u115F-\u1161\u1163\u1165\u1167\u1169\u116D-\u116E\u1172-\u1173\u1175\u119E\u11A8\u11AB\u11AE-\u11AF\u11B7-\u11B8\u11BA\u11BC-\u11C2\u11EB\u11F0\u11F9\u1E00-\u1E9B\u1EA0-\u1EF9\u1F00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2126\u212A-\u212B\u212E\u2180-\u2182\u3041-\u3094\u30A1-\u30FA\u3105-\u312C\uAC00-\uD7A3\u4E00-\u9FA5\u3007\u3021-\u3029_]";
RDFaProcessor.NCNAME = new RegExp("^" + RDFaProcessor.nameStartChar + RDFaProcessor.nameChar + "*$");
RDFaProcessor.dateTimeTypes = [{
  pattern: /-?P(?:[0-9]+Y)?(?:[0-9]+M)?(?:[0-9]+D)?(?:T(?:[0-9]+H)?(?:[0-9]+M)?(?:[0-9]+(?:\.[0-9]+)?S)?)?/,
  type: "http://www.w3.org/2001/XMLSchema#duration"
}, {
  pattern: /-?(?:[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9])-[0-9][0-9]-[0-9][0-9]T(?:[0-1][0-9]|2[0-4]):[0-5][0-9]:[0-5][0-9](?:\.[0-9]+)?(?:Z|[+\-][0-9][0-9]:[0-9][0-9])?/,
  type: "http://www.w3.org/2001/XMLSchema#dateTime"
}, {
  pattern: /-?(?:[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9])-[0-9][0-9]-[0-9][0-9](?:Z|[+\-][0-9][0-9]:[0-9][0-9])?/,
  type: "http://www.w3.org/2001/XMLSchema#date"
}, {
  pattern: /(?:[0-1][0-9]|2[0-4]):[0-5][0-9]:[0-5][0-9](?:\.[0-9]+)?(?:Z|[+\-][0-9][0-9]:[0-9][0-9])?/,
  type: "http://www.w3.org/2001/XMLSchema#time"
}, {
  pattern: /-?(?:[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9])-[0-9][0-9]/,
  type: "http://www.w3.org/2001/XMLSchema#gYearMonth"
}, {
  pattern: /-?[1-9][0-9][0-9][0-9]|0[1-9][0-9][0-9]|00[1-9][0-9]|000[1-9]/,
  type: "http://www.w3.org/2001/XMLSchema#gYear"
}];
var parseRDFaDOM = RDFaProcessor.parseRDFaDOM;

// node_modules/rdflib/esm/rdfxmlparser.js
var RDFParser = class _RDFParser {
  /*
   * @constructor
   * @param {RDFStore} store An RDFStore object
   */
  constructor(store) {
    this.store = store;
    this.bnodes = {};
    this.why = null;
    this.reify = false;
  }
  /** Standard namespaces that we know how to handle @final
   *  @member RDFParser
   */
  /**
   * Frame class for namespace and base URI lookups
   * Base lookups will always resolve because the parser knows
   * the default base.
   *
   * @private
   */
  frameFactory(parser, parent4, element2) {
    return {
      "NODE": 1,
      "ARC": 2,
      "parent": parent4,
      "parser": parser,
      "store": parser.store,
      "element": element2,
      "lastChild": 0,
      "base": null,
      "lang": null,
      "node": null,
      "nodeType": null,
      "listIndex": 1,
      "rdfid": null,
      "datatype": null,
      "collection": false,
      /** Terminate the frame and notify the store that we're done */
      "terminateFrame": function() {
        if (this.collection) {
          this.node.close();
        }
      },
      /** Add a symbol of a certain type to the this frame */
      "addSymbol": function(type5, uri6) {
        uri6 = join(uri6, this.base);
        this.node = this.store.sym(uri6);
        this.nodeType = type5;
      },
      /** Load any constructed triples into the store */
      "loadTriple": function() {
        if (this.parent.parent.collection) {
          this.parent.parent.node.append(this.node);
        } else {
          this.store.add(this.parent.parent.node, this.parent.node, this.node, this.parser.why);
        }
        if (this.parent.rdfid != null) {
          var triple2 = this.store.sym(join("#" + this.parent.rdfid, this.base));
          this.store.add(triple2, this.store.sym(_RDFParser.ns.RDF + "type"), this.store.sym(_RDFParser.ns.RDF + "Statement"), this.parser.why);
          this.store.add(triple2, this.store.sym(_RDFParser.ns.RDF + "subject"), this.parent.parent.node, this.parser.why);
          this.store.add(triple2, this.store.sym(_RDFParser.ns.RDF + "predicate"), this.parent.node, this.parser.why);
          this.store.add(triple2, this.store.sym(_RDFParser.ns.RDF + "object"), this.node, this.parser.why);
        }
      },
      /** Check if it's OK to load a triple */
      "isTripleToLoad": function() {
        return this.parent != null && this.parent.parent != null && this.nodeType === this.NODE && this.parent.nodeType === this.ARC && this.parent.parent.nodeType === this.NODE;
      },
      /** Add a symbolic node to this frame */
      "addNode": function(uri6) {
        this.addSymbol(this.NODE, uri6);
        if (this.isTripleToLoad()) {
          this.loadTriple();
        }
      },
      /** Add a collection node to this frame */
      "addCollection": function() {
        this.nodeType = this.NODE;
        this.node = this.store.collection();
        this.collection = true;
        if (this.isTripleToLoad()) {
          this.loadTriple();
        }
      },
      /** Add a collection arc to this frame */
      "addCollectionArc": function() {
        this.nodeType = this.ARC;
      },
      /** Add a bnode to this frame */
      "addBNode": function(id4) {
        if (id4 != null) {
          if (this.parser.bnodes[id4] != null) {
            this.node = this.parser.bnodes[id4];
          } else {
            this.node = this.parser.bnodes[id4] = this.store.bnode();
          }
        } else {
          this.node = this.store.bnode();
        }
        this.nodeType = this.NODE;
        if (this.isTripleToLoad()) {
          this.loadTriple();
        }
      },
      /** Add an arc or property to this frame */
      "addArc": function(uri6) {
        if (uri6 === _RDFParser.ns.RDF + "li") {
          uri6 = _RDFParser.ns.RDF + "_" + this.parent.listIndex;
          this.parent.listIndex++;
        }
        this.addSymbol(this.ARC, uri6);
      },
      /** Add a literal to this frame */
      "addLiteral": function(value8) {
        if (this.parent.datatype && this.parent.datatype !== _RDFParser.ns.RDF + "langString") {
          this.node = this.store.literal(value8, this.store.sym(this.parent.datatype));
        } else {
          this.node = this.store.literal(value8, this.lang);
        }
        this.nodeType = this.NODE;
        if (this.isTripleToLoad()) {
          this.loadTriple();
        }
      }
    };
  }
  // from the OpenLayers source .. needed to get around IE problems.
  getAttributeNodeNS(node3, uri6, name9) {
    var attributeNode = null;
    if (node3.getAttributeNodeNS) {
      attributeNode = node3.getAttributeNodeNS(uri6, name9);
    } else {
      var attributes = node3.attributes;
      var potentialNode, fullName2;
      for (var i = 0; i < attributes.length; ++i) {
        potentialNode = attributes[i];
        if (potentialNode.namespaceURI === uri6) {
          fullName2 = potentialNode.prefix ? potentialNode.prefix + ":" + name9 : name9;
          if (fullName2 === potentialNode.nodeName) {
            attributeNode = potentialNode;
            break;
          }
        }
      }
    }
    return attributeNode;
  }
  /**
   * Build our initial scope frame and parse the DOM into triples
    * @param {import('@xmldom/xmldom').Document} document The DOM to parse
   * @param {String} base The base URL to use
   * @param {Object} why The context to which this resource belongs
   */
  parse(document4, base2, why) {
    var children3 = document4.childNodes;
    this.cleanParser();
    var root;
    if (document4.nodeType === _RDFParser.nodeType.DOCUMENT) {
      for (var c = 0; c < children3.length; c++) {
        if (children3[c].nodeType === _RDFParser.nodeType.ELEMENT) {
          root = children3[c];
          break;
        }
      }
    } else if (document4.nodeType === _RDFParser.nodeType.ELEMENT) {
      root = document4;
    } else {
      throw new Error("RDFParser: can't find root in " + base2 + ". Halting. ");
    }
    this.why = why;
    var f = this.frameFactory(this);
    this.base = base2;
    f.base = base2;
    f.lang = null;
    this.parseDOM(this.buildFrame(f, root));
    return true;
  }
  parseDOM(frame) {
    var rdfid;
    var elementURI = function(el) {
      var result6 = "";
      if (el.namespaceURI == null) {
        throw new Error("RDF/XML syntax error: No namespace for " + el.localName + " in " + this.base);
      }
      if (el.namespaceURI) {
        result6 = result6 + el.namespaceURI;
      }
      if (el.localName) {
        result6 = result6 + el.localName;
      } else if (el.nodeName) {
        if (el.nodeName.indexOf(":") >= 0) result6 = result6 + el.nodeName.split(":")[1];
        else result6 = result6 + el.nodeName;
      }
      return result6;
    }.bind(this);
    var dig = true;
    while (frame.parent) {
      var dom = frame.element;
      var attrs = dom.attributes;
      if (dom.nodeType === _RDFParser.nodeType.TEXT || dom.nodeType === _RDFParser.nodeType.CDATA_SECTION) {
        if (frame.parent.nodeType === frame.NODE) {
          frame.addArc(_RDFParser.ns.RDF + "value");
          frame = this.buildFrame(frame);
        }
        frame.addLiteral(dom.nodeValue);
      } else if (elementURI(dom) !== _RDFParser.ns.RDF + "RDF") {
        if (frame.parent && frame.parent.collection) {
          frame.addCollectionArc();
          frame = this.buildFrame(frame, frame.element);
          frame.parent.element = null;
        }
        if (!frame.parent || !frame.parent.nodeType || frame.parent.nodeType === frame.ARC) {
          var about5 = this.getAttributeNodeNS(dom, _RDFParser.ns.RDF, "about");
          rdfid = this.getAttributeNodeNS(dom, _RDFParser.ns.RDF, "ID");
          if (about5 && rdfid) {
            throw new Error("RDFParser: " + dom.nodeName + " has both rdf:id and rdf:about. Halting. Only one of these properties may be specified on a node.");
          }
          if (!about5 && rdfid) {
            frame.addNode("#" + rdfid.nodeValue);
            dom.removeAttributeNode(rdfid);
          } else if (about5 == null && rdfid == null) {
            var bnid = this.getAttributeNodeNS(dom, _RDFParser.ns.RDF, "nodeID");
            if (bnid) {
              frame.addBNode(bnid.nodeValue);
              dom.removeAttributeNode(bnid);
            } else {
              frame.addBNode();
            }
          } else {
            frame.addNode(about5.nodeValue);
            dom.removeAttributeNode(about5);
          }
          var rdftype = this.getAttributeNodeNS(dom, _RDFParser.ns.RDF, "type");
          if (_RDFParser.ns.RDF + "Description" !== elementURI(dom)) {
            rdftype = {
              "nodeValue": elementURI(dom)
            };
          }
          if (rdftype != null) {
            this.store.add(frame.node, this.store.sym(_RDFParser.ns.RDF + "type"), this.store.sym(join(rdftype.nodeValue, frame.base)), this.why);
            if (rdftype.nodeName) {
              dom.removeAttributeNode(rdftype);
            }
          }
          for (var x = attrs.length - 1; x >= 0; x--) {
            this.store.add(frame.node, this.store.sym(elementURI(attrs[x])), this.store.literal(attrs[x].nodeValue, frame.lang), this.why);
          }
        } else {
          frame.addArc(elementURI(dom));
          if (this.reify) {
            rdfid = this.getAttributeNodeNS(dom, _RDFParser.ns.RDF, "ID");
            if (rdfid) {
              frame.rdfid = rdfid.nodeValue;
              dom.removeAttributeNode(rdfid);
            }
          }
          var parsetype = this.getAttributeNodeNS(dom, _RDFParser.ns.RDF, "parseType");
          var datatype3 = this.getAttributeNodeNS(dom, _RDFParser.ns.RDF, "datatype");
          if (datatype3) {
            frame.datatype = datatype3.nodeValue;
            dom.removeAttributeNode(datatype3);
          }
          if (parsetype) {
            var nv = parsetype.nodeValue;
            if (nv === "Literal") {
              frame.datatype = _RDFParser.ns.RDF + "XMLLiteral";
              frame = this.buildFrame(frame);
              frame.addLiteral(dom.innerHTML || dom.childNodes);
              dig = false;
            } else if (nv === "Resource") {
              frame = this.buildFrame(frame, frame.element);
              frame.parent.element = null;
              frame.addBNode();
            } else if (nv === "Collection") {
              frame = this.buildFrame(frame, frame.element);
              frame.parent.element = null;
              frame.addCollection();
            }
            dom.removeAttributeNode(parsetype);
          }
          if (attrs.length !== 0) {
            var resource2 = this.getAttributeNodeNS(dom, _RDFParser.ns.RDF, "resource");
            var bnid2 = this.getAttributeNodeNS(dom, _RDFParser.ns.RDF, "nodeID");
            frame = this.buildFrame(frame);
            if (resource2) {
              frame.addNode(resource2.nodeValue);
              dom.removeAttributeNode(resource2);
            } else {
              if (bnid2) {
                frame.addBNode(bnid2.nodeValue);
                dom.removeAttributeNode(bnid2);
              } else {
                frame.addBNode();
              }
            }
            for (var x1 = attrs.length - 1; x1 >= 0; x1--) {
              var f = this.buildFrame(frame);
              f.addArc(elementURI(attrs[x1]));
              if (elementURI(attrs[x1]) === _RDFParser.ns.RDF + "type") {
                this.buildFrame(f).addNode(attrs[x1].nodeValue);
              } else {
                this.buildFrame(f).addLiteral(attrs[x1].nodeValue);
              }
            }
          } else if (dom.childNodes.length === 0) {
            this.buildFrame(frame).addLiteral("");
          }
        }
      }
      dom = frame.element;
      while (frame.parent) {
        var pframe = frame;
        while (dom == null) {
          frame = frame.parent;
          dom = frame.element;
        }
        var candidate4 = dom.childNodes && dom.childNodes[frame.lastChild];
        if (!candidate4 || !dig) {
          frame.terminateFrame();
          if (!(frame = frame.parent)) {
            break;
          }
          dom = frame.element;
          dig = true;
        } else if (candidate4.nodeType !== _RDFParser.nodeType.ELEMENT && candidate4.nodeType !== _RDFParser.nodeType.TEXT && candidate4.nodeType !== _RDFParser.nodeType.CDATA_SECTION || (candidate4.nodeType === _RDFParser.nodeType.TEXT || candidate4.nodeType === _RDFParser.nodeType.CDATA_SECTION) && dom.childNodes.length !== 1) {
          frame.lastChild++;
        } else {
          frame.lastChild++;
          frame = this.buildFrame(pframe, dom.childNodes[frame.lastChild - 1]);
          break;
        }
      }
    }
  }
  /**
   * Cleans out state from a previous parse run
   * @private
   */
  cleanParser() {
    this.bnodes = {};
    this.why = null;
  }
  /**
   * Builds scope frame
   * @private
   */
  buildFrame(parent4, element2) {
    var frame = this.frameFactory(this, parent4, element2);
    if (parent4) {
      frame.base = parent4.base;
      frame.lang = parent4.lang;
    }
    if (!element2 || element2.nodeType === _RDFParser.nodeType.TEXT || element2.nodeType === _RDFParser.nodeType.CDATA_SECTION) {
      return frame;
    }
    var attrs = element2.attributes;
    var base2 = element2.getAttributeNode("xml:base");
    if (base2 != null) {
      frame.base = base2.nodeValue;
      element2.removeAttribute("xml:base");
    }
    var lang = element2.getAttributeNode("xml:lang");
    if (lang != null) {
      frame.lang = lang.nodeValue;
      element2.removeAttribute("xml:lang");
    }
    for (var x = attrs.length - 1; x >= 0; x--) {
      if (attrs[x].nodeName.substr(0, 3) === "xml") {
        if (attrs[x].name.slice(0, 6) === "xmlns:") {
          var uri6 = attrs[x].nodeValue;
          if (this.base) uri6 = join(uri6, this.base);
          this.store.setPrefixForURI(attrs[x].name.slice(6), uri6);
        }
        element2.removeAttributeNode(attrs[x]);
      }
    }
    return frame;
  }
};
_defineProperty(RDFParser, "ns", {
  "RDF": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
  "RDFS": "http://www.w3.org/2000/01/rdf-schema#"
});
_defineProperty(RDFParser, "nodeType", {
  "ELEMENT": 1,
  "ATTRIBUTE": 2,
  "TEXT": 3,
  "CDATA_SECTION": 4,
  "ENTITY_REFERENCE": 5,
  "ENTITY": 6,
  "PROCESSING_INSTRUCTION": 7,
  "COMMENT": 8,
  "DOCUMENT": 9,
  "DOCUMENT_TYPE": 10,
  "DOCUMENT_FRAGMENT": 11,
  "NOTATION": 12
});

// node_modules/rdflib/esm/patch-parser.js
function sparqlUpdateParser(str, kb, base2) {
  var i, j, k;
  var keywords3 = ["INSERT", "DELETE", "WHERE"];
  var SQNS = Namespace("http://www.w3.org/ns/pim/patch#");
  var p = n3parser_default(kb, kb, base2, base2, null, null, "", null);
  var clauses = {};
  var badSyntax = function(uri6, lines, str2, i2, why) {
    return "Line " + (lines + 1) + " of <" + uri6 + ">: Bad syntax:\n   " + why + '\n   at: "' + str2.slice(i2, i2 + 30) + '"';
  };
  i = 0;
  var query4 = kb.sym(base2 + "#query");
  clauses["query"] = query4;
  while (true) {
    j = p.skipSpace(str, i);
    if (j < 0) {
      return clauses;
    }
    if (str[j] === ";") {
      i = p.skipSpace(str, j + 1);
      if (i < 0) {
        return clauses;
      }
      j = i;
    }
    var found = false;
    for (k = 0; k < keywords3.length; k++) {
      var key3 = keywords3[k];
      if (str.slice(j, j + key3.length) === key3) {
        i = p.skipSpace(str, j + key3.length);
        if (i < 0) {
          throw badSyntax(p._thisDoc, p.lines, str, j + key3.length, "found EOF, needed {...} after " + key3);
        }
        if ((key3 === "INSERT" || key3 === "DELETE") && str.slice(i, i + 4) === "DATA") {
          j = p.skipSpace(str, i + 4);
          if (j < 0) {
            throw badSyntax(p._thisDoc, p.lines, str, i + 4, "needed {...} after INSERT DATA " + key3);
          }
          i = j;
        }
        var res2 = [];
        j = p.node(str, i, res2);
        if (j < 0) {
          throw badSyntax(p._thisDoc, p.lines, str, i, "bad syntax or EOF in {...} after " + key3);
        }
        clauses[key3.toLowerCase()] = res2[0];
        kb.add(query4, SQNS(key3.toLowerCase()), res2[0]);
        found = true;
        i = j;
      }
    }
    if (!found && str.slice(j, j + 7) === "@prefix") {
      i = p.directive(str, j);
      if (i < 0) {
        throw badSyntax(p._thisDoc, p.lines, str, i, "bad syntax or EOF after @prefix ");
      }
      i = p.checkDot(str, i);
      found = true;
    }
    if (!found) {
      throw badSyntax(p._thisDoc, p.lines, str, j, "Unknown syntax at start of statememt: '" + str.slice(j).slice(0, 20) + "'");
    }
  }
}

// node_modules/rdflib/esm/parse.js
function parse2(str, kb, base2, contentType4 = "text/turtle", callback) {
  contentType4 = contentType4 || TurtleContentType;
  contentType4 = contentType4.split(";")[0];
  try {
    if (contentType4 === N3ContentType || contentType4 === TurtleContentType) {
      var p = n3parser_default(kb, kb, base2, base2, null, null, "", null);
      p.loadBuf(str);
      executeCallback();
    } else if (contentType4 === RDFXMLContentType) {
      var parser = new RDFParser(kb);
      parser.parse(parseXML(str), base2, kb.sym(base2));
      executeCallback();
    } else if (contentType4 === XHTMLContentType) {
      parseRDFaDOM(parseXML(str, {
        contentType: XHTMLContentType
      }), kb, base2);
      executeCallback();
    } else if (contentType4 === HTMLContentType) {
      parseRDFaDOM(parseXML(str, {
        contentType: HTMLContentType
      }), kb, base2);
      executeCallback();
    } else if (contentType4 === SPARQLUpdateContentType || contentType4 === SPARQLUpdateSingleMatchContentType) {
      sparqlUpdateParser(str, kb, base2);
      executeCallback();
    } else if (contentType4 === JSONLDContentType) {
      jsonldParser(str, kb, base2).then(executeCallback).catch(executeErrorCallback);
    } else if (contentType4 === NQuadsContentType || contentType4 === NQuadsAltContentType) {
      var n3Parser = new N3Parser({
        factory: extended_term_factory_default
      });
      nquadCallback(null, str);
    } else if (contentType4 === void 0) {
      throw new Error("contentType is undefined");
    } else {
      throw new Error("Don't know how to parse " + contentType4 + " yet");
    }
  } catch (e) {
    executeErrorCallback(e);
  }
  parse2.handled = {
    "text/n3": true,
    "text/turtle": true,
    "application/rdf+xml": true,
    "application/xhtml+xml": true,
    "text/html": true,
    "application/sparql-update": true,
    "application/sparql-update-single-match": true,
    "application/ld+json": true,
    "application/nquads": true,
    "application/n-quads": true
  };
  function executeCallback() {
    if (callback) {
      callback(null, kb);
    } else {
      return;
    }
  }
  function executeErrorCallback(e) {
    if (
      // TODO: Always true, what is the right behavior
      contentType4 !== JSONLDContentType || // @ts-ignore always true?
      contentType4 !== NQuadsContentType || // @ts-ignore always true?
      contentType4 !== NQuadsAltContentType
    ) {
      if (callback) {
        callback(e, kb);
      } else {
        let e2 = new Error("" + e + " while trying to parse <" + base2 + "> as " + contentType4);
        e2.cause = e;
        throw e2;
      }
    }
  }
  function nquadCallback(err2, nquads) {
    if (err2) {
      callback(err2, kb);
    }
    try {
      n3Parser.parse(nquads, tripleCallback);
    } catch (err3) {
      callback(err3, kb);
    }
  }
  function tripleCallback(err2, triple2) {
    if (triple2) {
      kb.add(triple2.subject, triple2.predicate, triple2.object, triple2.graph);
    } else {
      callback(err2, kb);
    }
  }
}

// node_modules/rdflib/esm/fetcher.js
var import_cross_fetch = __toESM(require_browser_ponyfill());
var Parsable = {
  "text/n3": true,
  "text/turtle": true,
  "application/rdf+xml": true,
  "application/xhtml+xml": true,
  "text/html": true,
  "application/ld+json": true
};
var CONTENT_TYPE_BY_EXT = {
  "rdf": RDFXMLContentType,
  "owl": RDFXMLContentType,
  "n3": "text/n3",
  "ttl": "text/turtle",
  "nt": "text/n3",
  "acl": "text/n3",
  "html": "text/html",
  "xml": "text/xml"
};
var getNS = (factory) => {
  return {
    link: Namespace("http://www.w3.org/2007/ont/link#", factory),
    http: Namespace("http://www.w3.org/2007/ont/http#", factory),
    httph: Namespace("http://www.w3.org/2007/ont/httph#", factory),
    // headers
    rdf: Namespace("http://www.w3.org/1999/02/22-rdf-syntax-ns#", factory),
    rdfs: Namespace("http://www.w3.org/2000/01/rdf-schema#", factory),
    dc: Namespace("http://purl.org/dc/elements/1.1/", factory),
    ldp: Namespace("http://www.w3.org/ns/ldp#", factory)
  };
};
var ns2 = getNS();
var Handler = class {
  constructor(response6, dom) {
    _defineProperty(this, "response", void 0);
    _defineProperty(this, "dom", void 0);
    this.response = response6;
    this.dom = dom;
  }
};
_defineProperty(Handler, "pattern", void 0);
var RDFXMLHandler = class extends Handler {
  static toString() {
    return "RDFXMLHandler";
  }
  static register(fetcher2) {
    fetcher2.mediatypes[RDFXMLContentType] = {
      "q": 0.9
    };
  }
  parse(fetcher2, responseText, options) {
    let kb = fetcher2.store;
    if (!this.dom) {
      this.dom = parseXML(responseText);
    }
    let root = this.dom.documentElement;
    if (root && root.nodeName === "parsererror") {
      return fetcher2.failFetch(options, "Badly formed XML in " + options.resource.value, "parse_error");
    }
    let parser = new RDFParser(kb);
    try {
      parser.parse(this.dom, options.original.value, options.original);
    } catch (err2) {
      return fetcher2.failFetch(options, "Syntax error parsing RDF/XML! " + err2, "parse_error");
    }
    if (!options.noMeta) {
      kb.add(options.original, ns2.rdf("type"), ns2.link("RDFDocument"), fetcher2.appNode);
    }
    return fetcher2.doneFetch(options, this.response);
  }
};
RDFXMLHandler.pattern = new RegExp("application/rdf\\+xml");
var XHTMLHandler = class extends Handler {
  static toString() {
    return "XHTMLHandler";
  }
  static register(fetcher2) {
    fetcher2.mediatypes[XHTMLContentType] = {
      "q": 0.8
    };
  }
  parse(fetcher2, responseText, options) {
    let relation4, reverse;
    if (!this.dom) {
      this.dom = parseXML(responseText);
    }
    let kb = fetcher2.store;
    let title10 = this.dom.getElementsByTagName("title");
    if (title10.length > 0) {
      kb.add(options.resource, ns2.dc("title"), kb.rdfFactory.literal(title10[0].textContent), options.resource);
    }
    let links = this.dom.getElementsByTagName("link");
    for (let x = links.length - 1; x >= 0; x--) {
      relation4 = links[x].getAttribute("rel");
      reverse = false;
      if (!relation4) {
        relation4 = links[x].getAttribute("rev");
        reverse = true;
      }
      if (relation4) {
        fetcher2.linkData(options.original, relation4, links[x].getAttribute("href"), options.resource, reverse);
      }
    }
    let scripts = this.dom.getElementsByTagName("script");
    for (let i = 0; i < scripts.length; i++) {
      let contentType4 = scripts[i].getAttribute("type");
      if (Parsable[contentType4]) {
        parse2(scripts[i].textContent, kb, options.original.value, contentType4);
        parse2(scripts[i].textContent, kb, options.original.value, contentType4);
      }
    }
    if (!options.noMeta) {
      kb.add(options.resource, ns2.rdf("type"), ns2.link("WebPage"), fetcher2.appNode);
    }
    if (!options.noRDFa && parseRDFaDOM) {
      try {
        parseRDFaDOM(this.dom, kb, options.original.value);
      } catch (err2) {
        let msg = "Error trying to parse " + options.resource + " as RDFa:\n" + err2 + ":\n" + err2.stack;
        return fetcher2.failFetch(options, msg, "parse_error");
      }
    }
    return fetcher2.doneFetch(options, this.response);
  }
};
XHTMLHandler.pattern = new RegExp("application/xhtml");
var XMLHandler = class _XMLHandler extends Handler {
  static toString() {
    return "XMLHandler";
  }
  static register(fetcher2) {
    fetcher2.mediatypes["text/xml"] = {
      "q": 0.5
    };
    fetcher2.mediatypes["application/xml"] = {
      "q": 0.5
    };
  }
  static isElement(node3) {
    return node3.nodeType === Node.ELEMENT_NODE;
  }
  parse(fetcher2, responseText, options) {
    let dom = parseXML(responseText);
    for (let c = 0; c < dom.childNodes.length; c++) {
      const node3 = dom.childNodes[c];
      if (_XMLHandler.isElement(node3)) {
        let ns3 = node3.namespaceURI;
        if (ns3 && ns3 === ns3["rdf"]) {
          fetcher2.addStatus(options.req, "Has XML root element in the RDF namespace, so assume RDF/XML.");
          let rdfHandler = new RDFXMLHandler(this.response, dom);
          return rdfHandler.parse(fetcher2, responseText, options);
        }
        break;
      }
    }
    if (dom.doctype) {
      if (dom.doctype.name === "html" && dom.doctype.publicId.match(/^-\/\/W3C\/\/DTD XHTML/) && dom.doctype.systemId.match(/http:\/\/www.w3.org\/TR\/xhtml/)) {
        fetcher2.addStatus(options.req, "Has XHTML DOCTYPE. Switching to XHTML Handler.\n");
        let xhtmlHandler = new XHTMLHandler(this.response, dom);
        return xhtmlHandler.parse(fetcher2, responseText, options);
      }
    }
    let html = dom.getElementsByTagName("html")[0];
    if (html) {
      let xmlns = html.getAttribute("xmlns");
      if (xmlns && xmlns.match(/^http:\/\/www.w3.org\/1999\/xhtml/)) {
        fetcher2.addStatus(options.req, "Has a default namespace for XHTML. Switching to XHTMLHandler.\n");
        let xhtmlHandler = new XHTMLHandler(this.response, dom);
        return xhtmlHandler.parse(fetcher2, responseText, options);
      }
    }
    return fetcher2.failFetch(options, "Unsupported dialect of XML: not RDF or XHTML namespace, etc.\n" + responseText.slice(0, 80), 901);
  }
};
XMLHandler.pattern = new RegExp("(text|application)/(.*)xml");
var HTMLHandler = class extends Handler {
  static toString() {
    return "HTMLHandler";
  }
  static register(fetcher2) {
    fetcher2.mediatypes["text/html"] = {
      "q": 0.8
    };
  }
  parse(fetcher2, responseText, options) {
    let kb = fetcher2.store;
    if (isXML(responseText)) {
      fetcher2.addStatus(options.req, "Has an XML declaration. We'll assume it's XHTML as the content-type was text/html.\n");
      let xhtmlHandler = new XHTMLHandler(this.response);
      return xhtmlHandler.parse(fetcher2, responseText, options);
    }
    if (isXHTML(responseText)) {
      fetcher2.addStatus(options.req, "Has XHTML DOCTYPE. Switching to XHTMLHandler.\n");
      let xhtmlHandler = new XHTMLHandler(this.response);
      return xhtmlHandler.parse(fetcher2, responseText, options);
    }
    if (isXMLNS(responseText)) {
      fetcher2.addStatus(options.req, "Has default namespace for XHTML, so switching to XHTMLHandler.\n");
      let xhtmlHandler = new XHTMLHandler(this.response);
      return xhtmlHandler.parse(fetcher2, responseText, options);
    }
    let titleMatch = new RegExp("<title>([\\s\\S]+?)</title>", "im").exec(responseText);
    if (titleMatch) {
      kb.add(options.resource, ns2.dc("title"), kb.rdfFactory.literal(titleMatch[1]), options.resource);
    }
    kb.add(options.resource, ns2.rdf("type"), ns2.link("WebPage"), fetcher2.appNode);
    fetcher2.addStatus(options.req, "non-XML HTML document, not parsed for data.");
    return fetcher2.doneFetch(options, this.response);
  }
};
HTMLHandler.pattern = new RegExp("text/html");
var JsonLdHandler = class extends Handler {
  static toString() {
    return "JsonLdHandler";
  }
  static register(fetcher2) {
    fetcher2.mediatypes["application/ld+json"] = {
      "q": 0.9
    };
  }
  async parse(fetcher2, responseText, options, response6) {
    const kb = fetcher2.store;
    try {
      await jsonldParser(responseText, kb, options.original.value);
      fetcher2.store.add(options.original, ns2.rdf("type"), ns2.link("RDFDocument"), fetcher2.appNode);
      return fetcher2.doneFetch(options, response6);
    } catch (err2) {
      const msg = "Error trying to parse " + options.resource + " as JSON-LD:\n" + err2;
      return fetcher2.failFetch(options, msg, "parse_error", response6);
    }
  }
};
JsonLdHandler.pattern = /application\/(ld\+json|activity\+json)/;
var TextHandler = class extends Handler {
  static toString() {
    return "TextHandler";
  }
  static register(fetcher2) {
    fetcher2.mediatypes["text/plain"] = {
      "q": 0.5
    };
  }
  parse(fetcher2, responseText, options) {
    if (isXML(responseText)) {
      fetcher2.addStatus(options.req, "Warning: " + options.resource + " has an XML declaration. We'll assume it's XML but its content-type wasn't XML.\n");
      let xmlHandler = new XMLHandler(this.response);
      return xmlHandler.parse(fetcher2, responseText, options);
    }
    if (responseText.slice(0, 500).match(/xmlns:/)) {
      fetcher2.addStatus(options.req, "May have an XML namespace. We'll assume it's XML but its content-type wasn't XML.\n");
      let xmlHandler = new XMLHandler(this.response);
      return xmlHandler.parse(fetcher2, responseText, options);
    }
    fetcher2.addStatus(options.req, "Plain text document, no known RDF semantics.");
    return fetcher2.doneFetch(options, this.response);
  }
};
TextHandler.pattern = new RegExp("text/plain");
var N3Handler = class extends Handler {
  static toString() {
    return "N3Handler";
  }
  static register(fetcher2) {
    fetcher2.mediatypes["text/n3"] = {};
    fetcher2.mediatypes["text/turtle"] = {};
  }
  parse(fetcher2, responseText, options, response6) {
    let kb = fetcher2.store;
    let p = n3parser_default(kb, kb, options.original.value, options.original.value, null, null, "", null);
    try {
      p.loadBuf(responseText);
    } catch (err2) {
      let msg = "Error trying to parse " + options.resource + " as Notation3:\n" + err2;
      return fetcher2.failFetch(options, msg, "parse_error", response6);
    }
    fetcher2.addStatus(options.req, "N3 parsed: " + p.statementCount + " triples in " + p.lines + " lines.");
    fetcher2.store.add(options.original, ns2.rdf("type"), ns2.link("RDFDocument"), fetcher2.appNode);
    return fetcher2.doneFetch(options, this.response);
  }
};
N3Handler.pattern = new RegExp("(application|text)/(x-)?(rdf\\+)?(n3|turtle)");
var defaultHandlers = {
  RDFXMLHandler,
  XHTMLHandler,
  XMLHandler,
  HTMLHandler,
  TextHandler,
  N3Handler,
  JsonLdHandler
};
function isXHTML(responseText) {
  const docTypeStart = responseText.indexOf("<!DOCTYPE html");
  const docTypeEnd = responseText.indexOf(">");
  if (docTypeStart === -1 || docTypeEnd === -1 || docTypeStart > docTypeEnd) {
    return false;
  }
  return responseText.substr(docTypeStart, docTypeEnd - docTypeStart).indexOf("XHTML") !== -1;
}
function isXML(responseText) {
  const match = responseText.match(/\s*<\?xml\s+version\s*=[^<>]+\?>/);
  return !!match;
}
function isXMLNS(responseText) {
  const match = responseText.match(/[^(<html)]*<html\s+[^<]*xmlns=['"]http:\/\/www.w3.org\/1999\/xhtml["'][^<]*>/);
  return !!match;
}
var Fetcher = class _Fetcher {
  constructor(store, options = {}) {
    _defineProperty(this, "store", void 0);
    _defineProperty(this, "timeout", void 0);
    _defineProperty(this, "_fetch", void 0);
    _defineProperty(this, "mediatypes", void 0);
    _defineProperty(this, "appNode", void 0);
    _defineProperty(this, "requested", void 0);
    _defineProperty(this, "timeouts", void 0);
    _defineProperty(this, "redirectedTo", void 0);
    _defineProperty(this, "fetchQueue", void 0);
    _defineProperty(this, "fetchCallbacks", void 0);
    _defineProperty(this, "nonexistent", void 0);
    _defineProperty(this, "lookedUp", void 0);
    _defineProperty(this, "handlers", void 0);
    _defineProperty(this, "ns", void 0);
    _defineProperty(this, "fireCallbacks", void 0);
    this.store = store || new IndexedFormula();
    this.ns = getNS(this.store.rdfFactory);
    this.timeout = options.timeout || 3e4;
    let fetchFunc = options.fetch || typeof global !== "undefined" && (global.solidFetcher || global.solidFetch) || typeof window !== "undefined" && (window.solidFetcher || window.solidFetch) || import_cross_fetch.default;
    if (!fetchFunc) {
      throw new Error("No _fetch function available for Fetcher");
    }
    if (typeof window !== "undefined" && fetchFunc === window.fetch) {
      this._fetch = fetchFunc.bind(window);
    } else if (typeof global !== "undefined" && fetchFunc === global.fetch) {
      this._fetch = fetchFunc.bind(global);
    } else {
      this._fetch = fetchFunc;
    }
    this.appNode = this.store.sym("chrome://TheCurrentSession");
    this.store.fetcher = this;
    this.requested = {};
    this.timeouts = {};
    this.redirectedTo = {};
    this.fetchQueue = {};
    this.fetchCallbacks = {};
    this.nonexistent = {};
    this.lookedUp = {};
    this.handlers = [];
    this.mediatypes = {
      "image/*": {
        "q": 0.9
      },
      "*/*": {
        "q": 0.1
      }
      // Must allow access to random content
    };
    callbackify(this, ["request", "fail", "refresh", "retract", "done"]);
    Object.keys(options.handlers || defaultHandlers).map((key3) => this.addHandler(defaultHandlers[key3]));
  }
  static crossSiteProxy(uri6) {
    if (_Fetcher.crossSiteProxyTemplate) {
      return _Fetcher.crossSiteProxyTemplate.replace("{uri}", encodeURIComponent(uri6));
    } else {
      return void 0;
    }
  }
  static offlineOverride(uri6) {
    let requestedURI4 = uri6;
    var UI;
    if (typeof window !== "undefined" && window.panes && (UI = window.panes.UI) && UI.preferences && UI.preferences.get("offlineModeUsingLocalhost")) {
      if (requestedURI4.slice(0, 7) === "http://" && requestedURI4.slice(7, 17) !== "localhost/") {
        requestedURI4 = "http://localhost/" + requestedURI4.slice(7);
        log_default.warn("Localhost kludge for offline use: actually getting <" + requestedURI4 + ">");
      } else {
      }
    } else {
    }
    return requestedURI4;
  }
  static proxyIfNecessary(uri6) {
    var UI;
    if (typeof window !== "undefined" && window.panes && (UI = window.panes.UI) && UI.isExtension) {
      return uri6;
    }
    if (typeof $SolidTestEnvironment !== "undefined" && $SolidTestEnvironment.localSiteMap) {
      let hostpath = uri6.split("/").slice(2);
      const lookup = (parts, index2) => {
        let z = index2[parts.shift()];
        if (!z) {
          return null;
        }
        if (typeof z === "string") {
          return z + parts.join("/");
        }
        if (!parts) {
          return null;
        }
        return lookup(parts, z);
      };
      const y = lookup(hostpath, $SolidTestEnvironment.localSiteMap);
      if (y) {
        return y;
      }
    }
    if (_Fetcher.crossSiteProxyTemplate && typeof document !== "undefined" && document.location && ("" + document.location).slice(0, 6) === "https:" && // origin is secure
    uri6.slice(0, 5) === "http:") {
      return _Fetcher.crossSiteProxyTemplate.replace("{uri}", encodeURIComponent(uri6));
    }
    return uri6;
  }
  /**
   * Tests whether the uri's protocol is supported by the Fetcher.
   * @param uri
   */
  static unsupportedProtocol(uri6) {
    let pcol = protocol(uri6);
    return pcol === "tel" || pcol === "mailto" || pcol === "urn";
  }
  /** Decide on credentials using old XXHR api or new fetch()  one
   * @param requestedURI
   * @param options
   */
  static setCredentials(requestedURI4, options = {}) {
    if (options.credentials === void 0) {
      if (options.withCredentials !== void 0) {
        options.credentials = options.withCredentials ? "include" : "omit";
      } else {
        options.credentials = "include";
      }
    }
  }
  /**
   * Promise-based load function
   *
   * Loads a web resource or resources into the store.
   *
   * A resource may be given as NamedNode object, or as a plain URI.
   * an array of resources will be given, in which they will be fetched in parallel.
   * By default, the HTTP headers are recorded also, in the same store, in a separate graph.
   * This allows code like editable() for example to test things about the resource.
   *
   * @param uri {Array<RDFlibNamedNode>|Array<string>|RDFlibNamedNode|string}
   *
   * @param [options={}] {Object}
   *
   * @param [options.fetch] {Function}
   *
   * @param [options.referringTerm] {RDFlibNamedNode} Referring term, the resource which
   *   referred to this (for tracking bad links)
   *
   * @param [options.contentType] {string} Provided content type (for writes)
   *
   * @param [options.forceContentType] {string} Override the incoming header to
   *   force the data to be treated as this content-type (for reads)
   *
   * @param [options.force] {boolean} Load the data even if loaded before.
   *   Also sets the `Cache-Control:` header to `no-cache`
   *
   * @param [options.baseURI=docuri] {Node|string} Original uri to preserve
   *   through proxying etc (`xhr.original`).
   *
   * @param [options.proxyUsed] {boolean} Whether this request is a retry via
   *   a proxy (generally done from an error handler)
   *
   * @param [options.withCredentials] {boolean} flag for XHR/CORS etc
   *
   * @param [options.clearPreviousData] {boolean} Before we parse new data,
   *   clear old, but only on status 200 responses
   *
   * @param [options.noMeta] {boolean} Prevents the addition of various metadata
   *   triples (about the fetch request) to the store
   *
   * @param [options.noRDFa] {boolean}
   *
   * @returns {Promise<Result>}
   */
  load(uri6, options = {}) {
    options = Object.assign({}, options);
    if (uri6 instanceof Array) {
      return Promise.all(uri6.map((x) => {
        return this.load(x, Object.assign({}, options));
      }));
    }
    const uriIn = uri6;
    let docuri = termValue(uriIn);
    docuri = docuri.split("#")[0];
    options = this.initFetchOptions(docuri, options);
    const meta2 = this.appNode;
    const kb = this.store;
    const requests = kb.statementsMatching(void 0, this.ns.link("requestedURI"), kb.sym(docuri), meta2).map((st2) => st2.subject);
    for (const request2 of requests) {
      const response6 = kb.any(request2, this.ns.link("response"), null, meta2);
      if (response6 != void 0) {
        const quad3 = kb.statementsMatching(response6, this.ns.link("outOfDate"), true, meta2);
        kb.remove(quad3);
        options.force = true;
        options.clearPreviousData = true;
      }
    }
    const initialisedOptions = this.initFetchOptions(docuri, options);
    return this.pendingFetchPromise(docuri, initialisedOptions.baseURI, initialisedOptions);
  }
  async pendingFetchPromise(uri6, originalUri, options) {
    let pendingPromise;
    if (!options.force && await this.fetchQueue[originalUri]) {
      pendingPromise = this.fetchQueue[originalUri];
    } else {
      pendingPromise = Promise.race([this.setRequestTimeout(uri6, options), this.fetchUri(uri6, options)]);
      this.fetchQueue[originalUri] = pendingPromise;
      this.cleanupFetchRequest(originalUri, void 0, this.timeout);
    }
    return pendingPromise.then((x) => {
      if (uri6 in this.timeouts) {
        this.timeouts[uri6].forEach(clearTimeout);
        delete this.timeouts[uri6];
      }
      return x;
    });
  }
  /**
   * @param _options - DEPRECATED
   */
  cleanupFetchRequest(originalUri, _options, timeout2) {
    if (_options !== void 0) {
      console.warn("_options is deprecated");
    }
    this.timeouts[originalUri] = (this.timeouts[originalUri] || []).concat(setTimeout(() => {
      if (!this.isPending(originalUri)) {
        delete this.fetchQueue[originalUri];
      }
    }, timeout2));
  }
  initFetchOptions(uri6, options) {
    let kb = this.store;
    let isGet = !options.method || options.method.toUpperCase() === "GET";
    if (!isGet) {
      options.force = true;
    }
    options.resource = kb.rdfFactory.namedNode(uri6);
    options.baseURI = options.baseURI || uri6;
    options.original = kb.rdfFactory.namedNode(options.baseURI);
    options.req = kb.bnode();
    options.headers = options.headers || {};
    if (options.contentType) {
      options.headers["content-type"] = options.contentType;
    }
    if (options.force) {
      options.cache = "no-cache";
    }
    let acceptString = this.acceptString();
    options.headers["accept"] = acceptString;
    let requestedURI4 = _Fetcher.offlineOverride(uri6);
    options.requestedURI = requestedURI4;
    _Fetcher.setCredentials(requestedURI4, options);
    let actualProxyURI = _Fetcher.proxyIfNecessary(requestedURI4);
    if (requestedURI4 !== actualProxyURI) {
      options.proxyUsed = true;
    }
    options.actualProxyURI = actualProxyURI;
    return options;
  }
  /**
   * (The promise chain ends in either a `failFetch()` or a `doneFetch()`)
   *
   * @param docuri {string}
   * @param options {Object}
   *
   * @returns {Promise<Object>} fetch() result or an { error, status } object
   */
  fetchUri(docuri, options) {
    if (!docuri) {
      return Promise.reject(new Error("Cannot fetch an empty uri"));
    }
    if (_Fetcher.unsupportedProtocol(docuri)) {
      return this.failFetch(options, "fetcher: Unsupported protocol", "unsupported_protocol");
    }
    let state2 = this.getState(docuri);
    if (!options.force) {
      if (state2 === "fetched") {
        return Promise.resolve(
          // @ts-ignore This is not a valid response object
          this.doneFetch(options, {
            status: 200,
            ok: true,
            statusText: "Already loaded into quadstore."
          })
        );
      }
      if (state2 === "failed" && this.requested[docuri] === 404) {
        let message4 = "Previously failed: " + this.requested[docuri];
        let dummyResponse = {
          url: docuri,
          // This does not comply to Fetch spec, it can be a string value in rdflib
          status: this.requested[docuri],
          statusText: message4,
          responseText: message4,
          headers: new import_cross_fetch.Headers(),
          // Headers() ???
          ok: false,
          body: null,
          bodyUsed: false,
          size: 0,
          timeout: 0
        };
        return this.failFetch(options, message4, this.requested[docuri], dummyResponse);
      }
    } else {
      delete this.nonexistent[docuri];
    }
    this.fireCallbacks("request", [docuri]);
    this.requested[docuri] = true;
    if (!options.noMeta) {
      this.saveRequestMetadata(docuri, options);
    }
    let {
      actualProxyURI
    } = options;
    return this._fetch(actualProxyURI, options).then((response6) => this.handleResponse(response6, docuri, options), (error4) => {
      let dummyResponse = {
        url: actualProxyURI,
        status: 999,
        // @@ what number/string should fetch failures report?
        statusText: (error4.name || "network failure") + ": " + (error4.errno || error4.code || error4.type),
        responseText: error4.message,
        headers: new import_cross_fetch.Headers(),
        // Headers() ???
        ok: false,
        body: null,
        bodyUsed: false,
        size: 0,
        timeout: 0
      };
      return this.handleError(dummyResponse, docuri, options);
    });
  }
  /**
   * Asks for a doc to be loaded if necessary then calls back
   *
   * Calling methods:
   *   nowOrWhenFetched (uri, userCallback)
   *   nowOrWhenFetched (uri, options, userCallback)
   *   nowOrWhenFetched (uri, referringTerm, userCallback, options)  <-- old
   *   nowOrWhenFetched (uri, referringTerm, userCallback) <-- old
   *
   *  Options include:
   *   referringTerm    The document in which this link was found.
   *                    this is valuable when finding the source of bad URIs
   *   force            boolean.  Never mind whether you have tried before,
   *                    load this from scratch.
   *   forceContentType Override the incoming header to force the data to be
   *                    treated as this content-type.
   *
   *  Callback function takes:
   *
   *    ok               True if the fetch worked, and got a 200 response.
   *                     False if any error happened
   *
   *    errmessage       Text error message if not OK.
   *
   *    response         The fetch Response object (was: XHR) if there was was one
   *                     includes response.status as the HTTP status if any.
   */
  nowOrWhenFetched(uriIn, p2, userCallback, options = {}) {
    const uri6 = termValue(uriIn);
    if (typeof p2 === "function") {
      userCallback = p2;
    } else if (typeof p2 === "undefined") {
    } else if (isNamedNode(p2)) {
      options.referringTerm = p2;
    } else {
      options = p2;
    }
    this.load(uri6, options).then((fetchResponse) => {
      if (userCallback) {
        if (fetchResponse) {
          if (fetchResponse.ok) {
            userCallback(true, "OK", fetchResponse);
          } else {
            let oops = "HTTP error: Status " + fetchResponse.status + " (" + fetchResponse.statusText + ")";
            if (fetchResponse.responseText) {
              oops += " " + fetchResponse.responseText;
            }
            userCallback(false, oops, fetchResponse);
          }
        } else {
          let oops = "@@ nowOrWhenFetched:  no response object!";
          userCallback(false, oops);
        }
      }
    }, function(err2) {
      var message4 = err2.message || err2.statusText;
      message4 = "Failed to load  <" + uri6 + "> " + message4;
      if (err2.response && err2.response.status) {
        message4 += " status: " + err2.response.status;
      }
      userCallback(false, message4, err2.response);
    });
  }
  /**
   * Records a status message (as a literal node) by appending it to the
   * request's metadata status collection.
   *
   */
  addStatus(req, statusMessage) {
    let now = /* @__PURE__ */ new Date();
    statusMessage = "[" + now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds() + "." + now.getMilliseconds() + "] " + statusMessage;
    let kb = this.store;
    const statusNode = kb.the(req, this.ns.link("status"));
    if (isCollection(statusNode)) {
      statusNode.append(kb.rdfFactory.literal(statusMessage));
    } else {
      log_default.warn("web.js: No list to add to: " + statusNode + "," + statusMessage);
    }
  }
  /**
   * Records errors in the system on failure:
   *
   *  - Adds an entry to the request status collection
   *  - Adds an error triple with the fail message to the metadata
   *  - Fires the 'fail' callback
   *  - Rejects with an error result object, which has a response object if any
   */
  failFetch(options, errorMessage, statusCode2, response6) {
    this.addStatus(options.req, errorMessage);
    if (!options.noMeta) {
      this.store.add(options.original, this.ns.link("error"), this.store.rdfFactory.literal(errorMessage));
    }
    let meth = (options.method || "GET").toUpperCase();
    let isGet = meth === "GET" || meth === "HEAD";
    if (isGet) {
      if (!options.resource.equals(options.original)) {
      } else {
      }
      this.requested[docpart(options.original.value)] = statusCode2;
      this.fireCallbacks("fail", [options.original.value, errorMessage]);
    }
    var err2 = new Error("Fetcher: " + errorMessage);
    err2.status = statusCode2;
    err2.statusText = errorMessage;
    err2.response = response6;
    return Promise.reject(err2);
  }
  // in the why part of the quad distinguish between HTML and HTTP header
  // Reverse is set iif the link was rev= as opposed to rel=
  linkData(originalUri, rel2, uri6, why, reverse) {
    if (!uri6) return;
    let kb = this.store;
    let obj = kb.rdfFactory.namedNode(join(uri6, originalUri.value));
    let predicates;
    if (rel2 === "alternate" || rel2 === "seeAlso" || rel2 === "meta" || rel2 === "describedby") {
      if (obj.value === originalUri.value) {
        return;
      }
      predicates = [kb.rdfFactory.namedNode(this.ianaLinkRelation(rel2)), this.ns.rdfs("seeAlso")];
    } else if (rel2 === "type") {
      predicates = [kb.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type")];
    } else {
      predicates = [kb.rdfFactory.namedNode(this.ianaLinkRelation(rel2))];
    }
    kb.addAll(predicates.map((predicate4) => reverse ? kb.rdfFactory.quad(obj, predicate4, originalUri, why) : kb.rdfFactory.quad(originalUri, predicate4, obj, why)));
  }
  ianaLinkRelation(rel2) {
    return join(encodeURIComponent(rel2), "http://www.iana.org/assignments/link-relations/");
  }
  parseLinkHeader(linkHeader, originalUri, reqNode) {
    if (!linkHeader) {
      return;
    }
    const linkexp = /<[^>]*>\s*(\s*;\s*[^()<>@,;:"/[\]?={} \t]+=(([^\(\)<>@,;:"\/\[\]\?={} \t]+)|("[^"]*")))*(,|$)/g;
    const paramexp = /[^\(\)<>@,;:"\/\[\]\?={} \t]+=(([^\(\)<>@,;:"\/\[\]\?={} \t]+)|("[^"]*"))/g;
    const matches = linkHeader.match(linkexp);
    if (matches == null) return;
    for (let i = 0; i < matches.length; i++) {
      let split = matches[i].split(">");
      let href2 = split[0].substring(1);
      let ps = split[1];
      let s = ps.match(paramexp);
      if (s == null) return;
      for (let j = 0; j < s.length; j++) {
        let p = s[j];
        let paramsplit = p.split("=");
        let rel2 = paramsplit[1].replace(/["']/g, "");
        this.linkData(originalUri, rel2, href2, reqNode);
      }
    }
  }
  doneFetch(options, response6) {
    this.addStatus(options.req, "Done.");
    this.requested[options.original.value] = "done";
    this.fireCallbacks("done", [options.original.value]);
    response6.req = options.req;
    return response6;
  }
  /**
   * Note two nodes are now smushed
   * If only one was flagged as looked up, then the new node is looked up again,
   * which will make sure all the URIs are dereferenced
   */
  nowKnownAs(was, now) {
    if (this.lookedUp[was.value]) {
      if (!this.lookedUp[now.value]) {
        this.lookUpThing(now, was);
      }
    } else if (this.lookedUp[now.value]) {
      if (!this.lookedUp[was.value]) {
        this.lookUpThing(was, now);
      }
    }
  }
  /**
   * Writes back to the web what we have in the store for this uri
   */
  putBack(uri6, options = {}) {
    const uriSting = termValue(uri6);
    let doc = new NamedNode(uriSting).doc();
    options.contentType = options["content-type"] || options["Content-Type"] || options.contentType || TurtleContentType;
    if (options.contentType === "application/ld+json") {
      return new Promise((resolve, reject) => {
        serialize(doc, this.store, doc.uri, options.contentType, (err2, jsonString) => {
          if (err2) {
            reject(err2);
          } else {
            options.data = jsonString;
            this.webOperation("PUT", uri6, options).then((res) => resolve(res)).catch((error4) => reject(error4));
          }
        });
      });
    }
    options.data = serialize(doc, this.store, doc.value, options.contentType);
    return this.webOperation("PUT", uriSting, options);
  }
  webCopy(here, there, contentType4) {
    return this.webOperation("GET", here).then((result6) => {
      return this.webOperation(
        "PUT",
        // change to binary from text
        there,
        {
          data: result6.responseText,
          contentType: contentType4
        }
      );
    });
  }
  delete(uri6, options) {
    return this.webOperation("DELETE", uri6, options).then((response6) => {
      this.requested[uri6] = 404;
      this.nonexistent[uri6] = true;
      this.unload(this.store.rdfFactory.namedNode(uri6));
      return response6;
    });
  }
  /** Create an empty resource if it really does not exist
   *  Be absolutely sure something does not exist before creating a new empty file
   * as otherwise existing could  be deleted.
   * @param doc - The resource
  */
  async createIfNotExists(doc, contentType4 = TurtleContentType, data4 = "") {
    const fetcher2 = this;
    try {
      var response6 = await fetcher2.load(doc);
    } catch (err2) {
      if (err2.response.status === 404) {
        try {
          response6 = await fetcher2.webOperation("PUT", doc.value, {
            data: data4,
            contentType: contentType4
          });
        } catch (err3) {
          throw err3;
        }
        delete fetcher2.requested[doc.value];
        return response6;
      } else {
        throw err2;
      }
    }
    return response6;
  }
  /**
   * @param parentURI URI of parent container
   * @param folderName - Optional folder name (slug)
   * @param data - Optional folder metadata
   */
  createContainer(parentURI, folderName, data4) {
    let headers = {
      // Force the right mime type for containers
      "content-type": TurtleContentType,
      "link": this.ns.ldp("BasicContainer") + '; rel="type"'
    };
    if (folderName) {
      headers["slug"] = folderName;
    }
    let options = {
      headers
    };
    if (data4) {
      options.body = data4;
    }
    return this.webOperation("POST", parentURI, options);
  }
  invalidateCache(iri) {
    const uri6 = termValue(iri);
    const fetcher2 = this;
    if (fetcher2.fetchQueue && fetcher2.fetchQueue[uri6]) {
      var promise = fetcher2.fetchQueue[uri6];
      if (promise["PromiseStatus"] === "resolved") {
        delete fetcher2.fetchQueue[uri6];
      } else {
        delete fetcher2.fetchQueue[uri6];
      }
    }
    if (fetcher2.requested[uri6] && fetcher2.requested[uri6] !== "done" && fetcher2.requested[uri6] !== "failed" && fetcher2.requested[uri6] !== 404) {
      let msg = `Rdflib: fetcher: Destructive operation on <${fetcher2.requested[uri6]}> file being fetched! ` + uri6;
      console.error(msg);
    } else {
      delete fetcher2.requested[uri6];
      delete fetcher2.nonexistent[uri6];
    }
  }
  /**
   * A generic web operation, at the fetch() level.
   * does not involve the quad store.
   *
   *  Returns promise of Response
   *  If data is returned, copies it to response.responseText before returning
   */
  webOperation(method5, uriIn, options = {}) {
    const uri6 = termValue(uriIn);
    options.method = method5;
    options.body = options.data || options.body;
    options.force = true;
    const fetcher2 = this;
    if (options.body && !options.contentType) {
      throw new Error("Web operation sending data must have a defined contentType.");
    }
    if (options.contentType) {
      options.headers = options.headers || {};
      options.headers["content-type"] = options.contentType;
    }
    _Fetcher.setCredentials(uri6, options);
    return new Promise(function(resolve, reject) {
      fetcher2._fetch(uri6, options).then((response6) => {
        if (response6.ok) {
          if (method5 === "PUT" || method5 === "PATCH" || method5 === "POST" || method5 === "DELETE") {
            fetcher2.invalidateCache(uri6);
          }
          if (response6.text) {
            response6.text().then((data4) => {
              response6.responseText = data4;
              resolve(response6);
            });
          } else {
            resolve(response6);
          }
        } else {
          let msg = "Web error: " + response6.status;
          if (response6.statusText) msg += " (" + response6.statusText + ")";
          msg += " on " + method5 + " of <" + uri6 + ">";
          if (response6.responseText) msg += ": " + response6.responseText;
          let e2 = new Error(msg);
          e2.response = response6;
          reject(e2);
        }
      }, (err2) => {
        let msg = "Fetch error for " + method5 + " of <" + uri6 + ">:" + err2;
        reject(new Error(msg));
      });
    });
  }
  /**
   * Looks up something.
   * Looks up all the URIs a things has.
   *
   * @param term - canonical term for the thing whose URI is
   *   to be dereferenced
   * @param rterm - the resource which referred to this
   *   (for tracking bad links)
   */
  lookUpThing(term3, rterm) {
    let uris = this.store.uris(term3);
    uris = uris.map((u) => docpart(u));
    uris.forEach((u) => {
      this.lookedUp[u] = true;
    });
    return this.load(uris, {
      referringTerm: rterm
    });
  }
  /**
   * Looks up response header.
   *
   * @returns {Array|undefined} a list of header values found in a stored HTTP
   *   response, or [] if response was found but no header found,
   *   or undefined if no response is available.
   * Looks for { [] link:requestedURI ?uri; link:response [ httph:header-name  ?value ] }
   */
  getHeader(doc, header2) {
    const kb = this.store;
    const docuri = doc.value;
    const requests = kb.each(void 0, this.ns.link("requestedURI"), kb.rdfFactory.literal(docuri));
    for (let r = 0; r < requests.length; r++) {
      let request2 = requests[r];
      if (request2 !== void 0) {
        let response6 = kb.any(request2, this.ns.link("response"));
        if (response6 !== void 0 && kb.anyValue(response6, this.ns.http("status")) && kb.anyValue(response6, this.ns.http("status")).startsWith("2")) {
          let results = kb.each(response6, this.ns.httph(header2.toLowerCase()));
          if (results.length) {
            return results.map((v2) => {
              return v2.value;
            });
          }
          return [];
        }
      }
    }
    return void 0;
  }
  saveRequestMetadata(docuri, options) {
    let req = options.req;
    let kb = this.store;
    let rterm = options.referringTerm;
    this.addStatus(options.req, "Accept: " + options.headers["accept"]);
    if (isNamedNode(rterm)) {
      kb.add(kb.rdfFactory.namedNode(docuri), this.ns.link("requestedBy"), rterm, this.appNode);
    }
    if (options.original && options.original.value !== docuri) {
      kb.add(req, this.ns.link("orginalURI"), kb.rdfFactory.literal(options.original.value), this.appNode);
    }
    const now = /* @__PURE__ */ new Date();
    const timeNow = "[" + now.getHours() + ":" + now.getMinutes() + ":" + now.getSeconds() + "] ";
    kb.add(req, this.ns.rdfs("label"), kb.rdfFactory.literal(timeNow + " Request for " + docuri), this.appNode);
    kb.add(req, this.ns.link("requestedURI"), kb.rdfFactory.literal(docuri), this.appNode);
    kb.add(req, this.ns.link("status"), kb.collection(), this.appNode);
  }
  saveResponseMetadata(response6, options) {
    const kb = this.store;
    let responseNode = kb.bnode();
    kb.add(options.req, this.ns.link("response"), responseNode, this.appNode);
    kb.add(responseNode, this.ns.http("status"), kb.rdfFactory.literal(response6.status), this.appNode);
    kb.add(responseNode, this.ns.http("statusText"), kb.rdfFactory.literal(response6.statusText), this.appNode);
    response6.headers.forEach((value8, header2) => {
      kb.add(responseNode, this.ns.httph(header2), this.store.rdfFactory.literal(value8), this.appNode);
      if (header2 === "content-type") {
        kb.add(
          options.resource,
          this.ns.rdf("type"),
          kb.rdfFactory.namedNode(mediaTypeClass(value8).value),
          this.appNode
          // responseNode
        );
      }
    });
    return responseNode;
  }
  objectRefresh(term3) {
    let uris = this.store.uris(term3);
    if (typeof uris !== "undefined") {
      for (let i = 0; i < uris.length; i++) {
        this.refresh(this.store.rdfFactory.namedNode(docpart(uris[i])));
      }
    }
  }
  /* refresh  Reload data from a given document
  **
  ** @param term - An RDF Named Node for the eodcument in question
  ** @param userCallback - A function userCallback(ok, message, response)
  */
  refresh(term3, userCallback) {
    this.fireCallbacks("refresh", arguments);
    this.nowOrWhenFetched(term3, {
      force: true,
      clearPreviousData: true
    }, userCallback);
  }
  /* refreshIfExpired   Conditional refresh if Expired
  **
  ** @param term - An RDF Named Node for the eodcument in question
  ** @param userCallback - A function userCallback(ok, message, response)
  */
  refreshIfExpired(term3, userCallback) {
    let exp = this.getHeader(term3, "Expires");
    if (!exp || new Date(exp[0]).getTime() <= (/* @__PURE__ */ new Date()).getTime()) {
      this.refresh(term3, userCallback);
    } else {
      userCallback(true, "Not expired", {});
    }
  }
  retract(term3) {
    this.store.removeMany(void 0, void 0, void 0, term3);
    if (term3.value) {
      delete this.requested[docpart(term3.value)];
    }
    this.fireCallbacks("retract", arguments);
  }
  getState(docuri) {
    if (typeof this.requested[docuri] === "undefined") {
      return "unrequested";
    } else if (this.requested[docuri] === true) {
      return "requested";
    } else if (this.requested[docuri] === "done") {
      return "fetched";
    } else if (this.requested[docuri] === "redirected") {
      return this.getState(this.redirectedTo[docuri]);
    } else {
      return "failed";
    }
  }
  isPending(docuri) {
    return this.requested[docuri] === true;
  }
  unload(term3) {
    this.store.removeDocument(term3);
    delete this.requested[term3.value];
  }
  addHandler(handler) {
    this.handlers.push(handler);
    handler.register(this);
  }
  retryNoCredentials(docuri, options) {
    options.retriedWithNoCredentials = true;
    delete this.requested[docuri];
    delete this.fetchQueue[docuri];
    let newOptions = Object.assign({}, options, {
      credentials: "omit"
    });
    this.addStatus(options.req, "Abort: Will retry with credentials SUPPRESSED to see if that helps");
    return this.load(docuri, newOptions);
  }
  /**
   * Tests whether a request is being made to a cross-site URI (for purposes
   * of retrying with a proxy)
   */
  isCrossSite(uri6) {
    if (typeof document === "undefined" || !document.location) {
      return false;
    }
    const hostpart2 = hostpart;
    const here = "" + document.location;
    return (hostpart2(here) && hostpart2(uri6) && hostpart2(here)) !== hostpart2(uri6);
  }
  /**
   * Called when there's a network error in fetch(), or a response
   * with status of 0.
   */
  handleError(response6, docuri, options) {
    if (this.isCrossSite(docuri)) {
      if (options.credentials && options.credentials === "include" && !options.retriedWithNoCredentials) {
        return this.retryNoCredentials(docuri, options);
      }
      let proxyUri = _Fetcher.crossSiteProxy(docuri);
      if (proxyUri && !options.proxyUsed) {
        return this.redirectToProxy(proxyUri, options);
      }
    }
    var message4;
    if (response6 instanceof Error) {
      message4 = "Fetch error: " + response6.message;
    } else {
      message4 = response6.statusText;
      if (response6.responseText) {
        message4 += ` ${response6.responseText}`;
      }
    }
    return this.failFetch(options, message4, response6.status || 998, response6);
  }
  // deduce some things from the HTTP transaction
  addType(rdfType, req, kb, locURI) {
    let prev2 = req;
    if (locURI) {
      var reqURI = kb.any(prev2, this.ns.link("requestedURI"));
      if (reqURI && reqURI.value !== locURI) {
        kb.add(kb.rdfFactory.namedNode(locURI), this.ns.rdf("type"), rdfType, this.appNode);
      }
    }
    for (; ; ) {
      const doc = kb.any(prev2, this.ns.link("requestedURI"));
      if (doc && doc.value) {
        kb.add(kb.rdfFactory.namedNode(doc.value), this.ns.rdf("type"), rdfType, this.appNode);
      }
      prev2 = kb.any(void 0, kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/link#redirectedRequest"), prev2);
      if (!prev2) {
        break;
      }
      var response6 = kb.any(prev2, kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/link#response"));
      if (!response6) {
        break;
      }
      var redirection = kb.any(response6, kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/http#status"));
      if (!redirection) {
        break;
      }
      if (redirection !== "301" && redirection !== "302") {
        break;
      }
    }
  }
  /**
   * Handle fetch() response
   */
  handleResponse(response6, docuri, options) {
    const kb = this.store;
    const headers = response6.headers;
    const reqNode = options.req;
    const responseNode = this.saveResponseMetadata(response6, options);
    const contentType4 = this.normalizedContentType(options, headers) || "";
    let contentLocation3 = headers.get("content-location");
    if (response6.status === 0) {
      return this.handleError(response6, docuri, options);
    }
    if (response6.status >= 400) {
      if (response6.status === 404) {
        this.nonexistent[options.original.value] = true;
        this.nonexistent[docuri] = true;
      }
      return this.saveErrorResponse(response6, responseNode).then(() => {
        let errorMessage = options.resource + " " + response6.statusText;
        return this.failFetch(options, errorMessage, response6.status, response6);
      });
    }
    var diffLocation = null;
    var absContentLocation = null;
    if (contentLocation3) {
      absContentLocation = join(contentLocation3, docuri);
      if (absContentLocation !== docuri) {
        diffLocation = absContentLocation;
      }
    }
    if (response6.status === 200) {
      this.addType(this.ns.link("Document"), reqNode, kb, docuri);
      if (diffLocation) {
        this.addType(this.ns.link("Document"), reqNode, kb, diffLocation);
      }
      if (options.clearPreviousData) {
        const sts = kb.statementsMatching(void 0, void 0, void 0, options.resource).slice();
        for (let i = 0; i < sts.length; i++) {
          kb.removeStatement(sts[i]);
        }
      }
      let isImage = contentType4.includes("image/") || contentType4.includes("application/pdf");
      if (contentType4 && isImage) {
        this.addType(kb.rdfFactory.namedNode("http://purl.org/dc/terms/Image"), reqNode, kb, docuri);
        if (diffLocation) {
          this.addType(kb.rdfFactory.namedNode("http://purl.org/dc/terms/Image"), reqNode, kb, diffLocation);
        }
      }
    }
    if (contentLocation3) {
      if (!options.force && diffLocation && this.requested[absContentLocation] === "done") {
        return this.doneFetch(options, response6);
      }
      this.requested[absContentLocation] = true;
    }
    this.parseLinkHeader(headers.get("link"), options.original, reqNode);
    let handler = this.handlerForContentType(contentType4, response6);
    if (!handler) {
      this.addStatus(reqNode, "Fetch over. No data handled.");
      return this.doneFetch(options, response6);
    }
    return response6.text().then((responseText) => {
      response6.responseText = responseText;
      return handler.parse(this, responseText, options, response6);
    });
  }
  saveErrorResponse(response6, responseNode) {
    let kb = this.store;
    return response6.text().then((content5) => {
      if (content5.length > 10) {
        kb.add(responseNode, this.ns.http("content"), kb.rdfFactory.literal(content5), responseNode);
      }
    });
  }
  handlerForContentType(contentType4, response6) {
    if (!contentType4) {
      return null;
    }
    let Handler2 = this.handlers.find((handler) => {
      return contentType4.match(handler.pattern);
    });
    return Handler2 ? new Handler2(response6) : null;
  }
  guessContentType(uri6) {
    return CONTENT_TYPE_BY_EXT[uri6.split(".").pop()];
  }
  normalizedContentType(options, headers) {
    if (options.forceContentType) {
      return options.forceContentType;
    }
    let contentType4 = headers.get("content-type");
    if (!contentType4 || contentType4.includes("application/octet-stream")) {
      let guess = this.guessContentType(options.resource.value);
      if (guess) {
        return guess;
      }
    }
    let protocol6 = protocol(options.resource.value);
    if (!contentType4 && ["file", "chrome"].includes(protocol6)) {
      return "text/xml";
    }
    return contentType4;
  }
  /**
   * Sends a new request to the specified uri. (Extracted from `onerrorFactory()`)
   */
  redirectToProxy(newURI, options) {
    this.addStatus(options.req, "BLOCKED -> Cross-site Proxy to <" + newURI + ">");
    options.proxyUsed = true;
    const kb = this.store;
    const oldReq = options.req;
    if (!options.noMeta) {
      kb.add(oldReq, this.ns.link("redirectedTo"), kb.rdfFactory.namedNode(newURI), oldReq);
      this.addStatus(oldReq, "redirected to new request");
    }
    this.requested[options.resource.value] = "redirected";
    this.redirectedTo[options.resource.value] = newURI;
    let newOptions = Object.assign({}, options);
    newOptions.baseURI = options.resource.value;
    return this.fetchUri(newURI, newOptions).then((response6) => {
      if (!newOptions.noMeta) {
        kb.add(oldReq, this.ns.link("redirectedRequest"), newOptions.req, this.appNode);
      }
      return response6;
    });
  }
  setRequestTimeout(uri6, options) {
    return new Promise((resolve) => {
      this.timeouts[uri6] = (this.timeouts[uri6] || []).concat(setTimeout(() => {
        if (this.isPending(uri6) && !options.retriedWithNoCredentials && !options.proxyUsed) {
          resolve(this.failFetch(options, `Request to ${uri6} timed out`, "timeout"));
        }
      }, this.timeout));
    });
  }
  addFetchCallback(uri6, callback) {
    if (!this.fetchCallbacks[uri6]) {
      this.fetchCallbacks[uri6] = [callback];
    } else {
      this.fetchCallbacks[uri6].push(callback);
    }
  }
  acceptString() {
    let acceptstring = "";
    for (let mediaType2 in this.mediatypes) {
      if (acceptstring !== "") {
        acceptstring += ", ";
      }
      acceptstring += mediaType2;
      for (let property4 in this.mediatypes[mediaType2]) {
        acceptstring += ";" + property4 + "=" + this.mediatypes[mediaType2][property4];
      }
    }
    return acceptstring;
  }
  // var updatesVia = new $rdf.UpdatesVia(this) // Subscribe to headers
  // @@@@@@@@ This is turned off because it causes a websocket to be set up for ANY fetch
  // whether we want to track it ot not. including ontologies loaed though the XSSproxy
};
_defineProperty(Fetcher, "HANDLERS", void 0);
_defineProperty(Fetcher, "CONTENT_TYPE_BY_EXT", void 0);
_defineProperty(Fetcher, "crossSiteProxyTemplate", void 0);
Fetcher.HANDLERS = defaultHandlers;
Fetcher.CONTENT_TYPE_BY_EXT = CONTENT_TYPE_BY_EXT;

// node_modules/rdflib/esm/update-manager.js
var UpdateManager = class {
  /**
   * @param  store - The quadstore to store data and metadata. Created if not passed.
  */
  constructor(store) {
    _defineProperty(this, "store", void 0);
    _defineProperty(this, "ifps", void 0);
    _defineProperty(this, "fps", void 0);
    _defineProperty(this, "patchControl", void 0);
    _defineProperty(this, "ns", void 0);
    store = store || new IndexedFormula();
    if (store.updater) {
      throw new Error("You can't have two UpdateManagers for the same store");
    }
    if (!store.fetcher) {
      store.fetcher = new Fetcher(store);
    }
    this.store = store;
    store.updater = this;
    this.ifps = {};
    this.fps = {};
    this.ns = {};
    this.ns.link = Namespace("http://www.w3.org/2007/ont/link#");
    this.ns.http = Namespace("http://www.w3.org/2007/ont/http#");
    this.ns.httph = Namespace("http://www.w3.org/2007/ont/httph#");
    this.ns.ldp = Namespace("http://www.w3.org/ns/ldp#");
    this.ns.rdf = Namespace("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
    this.ns.rdfs = Namespace("http://www.w3.org/2000/01/rdf-schema#");
    this.ns.rdf = Namespace("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
    this.ns.owl = Namespace("http://www.w3.org/2002/07/owl#");
    this.patchControl = [];
  }
  patchControlFor(doc) {
    if (!this.patchControl[doc.value]) {
      this.patchControl[doc.value] = [];
    }
    return this.patchControl[doc.value];
  }
  isHttpUri(uri6) {
    return uri6.slice(0, 4) === "http";
  }
  /** Remove from the store HTTP authorization metadata
  * The editable function below relies on copies we have in the store
  * of the results of previous HTTP transactions. However, when
  * the user logs in, then that data misrepresents what would happen
  * if the user tried again.
  */
  flagAuthorizationMetadata(kb) {
    if (!kb) {
      kb = this.store;
    }
    const meta2 = kb.fetcher?.appNode;
    const requests = kb.statementsMatching(void 0, this.ns.link("requestedURI"), void 0, meta2).map((st2) => st2.subject);
    for (const request2 of requests) {
      const response6 = kb.any(request2, this.ns.link("response"), null, meta2);
      if (response6 != void 0) {
        kb.add(response6, this.ns.link("outOfDate"), true, meta2);
      }
    }
  }
  /**
   * Tests whether a file is editable.
   * If the file has a specific annotation that it is machine written,
   * for safety, it is editable (this doesn't actually check for write access)
   * If the file has wac-allow and accept patch headers, those are respected.
   * and local write access is determined by those headers.
   * This async version not only looks at past HTTP requests, it also makes new ones if necessary.
   *
   * @returns The method string N3PATCH or SPARQL or DAV or
   *   LOCALFILE or false if known, undefined if not known.
   */
  async checkEditable(uri6, kb) {
    if (!uri6) {
      return false;
    }
    if (!kb) {
      kb = this.store;
    }
    const initial2 = this.editable(uri6, kb);
    if (initial2 !== void 0) {
      return initial2;
    }
    await kb.fetcher?.load(uri6);
    const final2 = this.editable(uri6, kb);
    return final2;
  }
  /**
   * Tests whether a file is editable.
   * If the file has a specific annotation that it is machine written,
   * for safety, it is editable (this doesn't actually check for write access)
   * If the file has wac-allow and accept patch headers, those are respected.
   * and local write access is determined by those headers.
   * This synchronous version only looks at past HTTP requests, does not make new ones.
   *
   * @returns The method string SPARQL or DAV or
   *   LOCALFILE or false if known, undefined if not known.
   */
  editable(uri6, kb) {
    if (!uri6) {
      return false;
    }
    if (!kb) {
      kb = this.store;
    }
    uri6 = termValue(uri6);
    if (!this.isHttpUri(uri6)) {
      if (kb.holds(kb.rdfFactory.namedNode(uri6), kb.rdfFactory.namedNode("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"), kb.rdfFactory.namedNode("http://www.w3.org/2007/ont/link#MachineEditableDocument"))) {
        return "LOCALFILE";
      }
    }
    var request2;
    var definitive = false;
    const meta2 = kb.fetcher?.appNode;
    var requests = kb.each(void 0, this.ns.link("requestedURI"), docpart(uri6), meta2);
    var method5;
    for (var r = 0; r < requests.length; r++) {
      request2 = requests[r];
      if (request2 !== void 0) {
        const response6 = kb.any(request2, this.ns.link("response"), null, meta2);
        if (response6 !== void 0) {
          const outOfDate = kb.anyJS(response6, this.ns.link("outOfDate"), null, meta2);
          if (outOfDate) continue;
          var wacAllow = kb.anyValue(response6, this.ns.httph("wac-allow"));
          if (wacAllow) {
            for (var bit of wacAllow.split(",")) {
              var lr = bit.split("=");
              if (lr[0].includes("user") && !lr[1].includes("write") && !lr[1].includes("append")) {
                return false;
              }
            }
          }
          var acceptPatch = kb.each(response6, this.ns.httph("accept-patch"));
          if (acceptPatch.length) {
            for (let i = 0; i < acceptPatch.length; i++) {
              method5 = acceptPatch[i].value.trim();
              if (method5.indexOf("application/sparql-update") >= 0) return "SPARQL";
              if (method5.indexOf("application/sparql-update-single-match") >= 0) return "SPARQL";
              if (method5.indexOf("text/n3") >= 0) return "N3PATCH";
            }
          }
          var authorVia = kb.each(response6, this.ns.httph("ms-author-via"));
          if (authorVia.length) {
            for (let i = 0; i < authorVia.length; i++) {
              method5 = authorVia[i].value.trim();
              if (method5.indexOf("SPARQL") >= 0) {
                return "SPARQL";
              }
              if (method5.indexOf("DAV") >= 0) {
                return "DAV";
              }
            }
          }
          if (!this.isHttpUri(uri6)) {
            if (!wacAllow) return false;
            else return "LOCALFILE";
          }
          var status10 = kb.each(response6, this.ns.http("status"));
          if (status10.length) {
            for (let i = 0; i < status10.length; i++) {
              if (status10[i] === 200 || status10[i] === 404) {
                definitive = true;
              }
            }
          }
        } else {
        }
      }
    }
    if (requests.length === 0) {
    } else {
      if (definitive) {
        return false;
      }
    }
    return void 0;
  }
  anonymize(obj) {
    let anonymized = obj.toNT().substr(0, 2) === "_:" && this.mentioned(obj) ? "?" + obj.toNT().substr(2) : obj.toNT();
    return anonymized;
  }
  anonymizeNT(stmt) {
    return this.anonymize(stmt.subject) + " " + this.anonymize(stmt.predicate) + " " + this.anonymize(stmt.object) + " .";
  }
  nTriples(stmt) {
    return `${stmt.subject.toNT()} ${stmt.predicate.toNT()} ${stmt.object.toNT()} .`;
  }
  /**
   * Returns a list of all bnodes occurring in a statement
   * @private
   */
  statementBnodes(st2) {
    return [st2.subject, st2.predicate, st2.object].filter(function(x) {
      return isBlankNode(x);
    });
  }
  /**
   * Returns a list of all bnodes occurring in a list of statements
   * @private
   */
  statementArrayBnodes(sts) {
    var bnodes = [];
    for (let i = 0; i < sts.length; i++) {
      bnodes = bnodes.concat(this.statementBnodes(sts[i]));
    }
    bnodes.sort();
    var bnodes2 = [];
    for (let j = 0; j < bnodes.length; j++) {
      if (j === 0 || !bnodes[j].equals(bnodes[j - 1])) {
        bnodes2.push(bnodes[j]);
      }
    }
    return bnodes2;
  }
  /**
   * Makes a cached list of [Inverse-]Functional properties
   * @private
   */
  cacheIfps() {
    this.ifps = {};
    var a = this.store.each(void 0, this.ns.rdf("type"), this.ns.owl("InverseFunctionalProperty"));
    for (let i = 0; i < a.length; i++) {
      this.ifps[a[i].value] = true;
    }
    this.fps = {};
    a = this.store.each(void 0, this.ns.rdf("type"), this.ns.owl("FunctionalProperty"));
    for (let i = 0; i < a.length; i++) {
      this.fps[a[i].value] = true;
    }
  }
  /**
   * Returns a context to bind a given node, up to a given depth
   * @private
   */
  bnodeContext2(x, source10, depth3) {
    var sts = this.store.statementsMatching(void 0, void 0, x, source10);
    var y;
    var res;
    for (let i = 0; i < sts.length; i++) {
      if (this.fps[sts[i].predicate.value]) {
        y = sts[i].subject;
        if (!y.isBlank) {
          return [sts[i]];
        }
        if (depth3) {
          res = this.bnodeContext2(y, source10, depth3 - 1);
          if (res) {
            return res.concat([sts[i]]);
          }
        }
      }
    }
    sts = this.store.statementsMatching(x, void 0, void 0, source10);
    for (let i = 0; i < sts.length; i++) {
      if (this.ifps[sts[i].predicate.value]) {
        y = sts[i].object;
        if (!y.isBlank) {
          return [sts[i]];
        }
        if (depth3) {
          res = this.bnodeContext2(y, source10, depth3 - 1);
          if (res) {
            return res.concat([sts[i]]);
          }
        }
      }
    }
    return null;
  }
  /**
   * Returns the smallest context to bind a given single bnode
   * @private
   */
  bnodeContext1(x, source10) {
    for (var depth3 = 0; depth3 < 3; depth3++) {
      var con = this.bnodeContext2(x, source10, depth3);
      if (con !== null) return con;
    }
    return this.store.connectedStatements(x, source10);
  }
  /**
   * @private
   */
  mentioned(x) {
    return this.store.statementsMatching(x, null, null, null).length !== 0 || // Don't pin fresh bnodes
    this.store.statementsMatching(null, x).length !== 0 || this.store.statementsMatching(null, null, x).length !== 0;
  }
  /**
   * @private
   */
  bnodeContext(bnodes, doc) {
    var context4 = [];
    if (bnodes.length) {
      this.cacheIfps();
      for (let i = 0; i < bnodes.length; i++) {
        var bnode = bnodes[i];
        if (!this.mentioned(bnode)) continue;
        context4 = context4.concat(this.bnodeContext1(bnode, doc));
      }
    }
    return context4;
  }
  /**
   * Returns the best context for a single statement
   * @private
   */
  statementContext(st2) {
    var bnodes = this.statementBnodes(st2);
    return this.bnodeContext(bnodes, st2.graph);
  }
  /**
   * @private
   */
  contextWhere(context4) {
    var updater = this;
    return !context4 || context4.length === 0 ? "" : "WHERE { " + context4.map(function(x) {
      return updater.anonymizeNT(x);
    }).join("\n") + " }\n";
  }
  /**
   * @private
   */
  fire(uri6, query4, callbackFunction, options = {}) {
    return Promise.resolve().then(() => {
      if (!uri6) {
        throw new Error("No URI given for remote editing operation: " + query4);
      }
      options.noMeta = true;
      options.contentType = options.contentType || "application/sparql-update";
      options.body = query4;
      return this.store.fetcher.webOperation("PATCH", uri6, options);
    }).then((response6) => {
      if (!response6.ok) {
        let message4 = "UpdateManager: update failed for <" + uri6 + "> status=" + response6.status + ", " + response6.statusText + "\n   for query: " + query4;
        throw new Error(message4);
      }
      callbackFunction(uri6, response6.ok, response6.responseText, response6);
    }).catch((err2) => {
      callbackFunction(uri6, false, err2.message, err2);
    });
  }
  // ARE THESE THREE FUNCTIONS USED? DEPRECATE?
  /** return a statemnet updating function
   *
   * This does NOT update the statement.
   * It returns an object which includes
   *  function which can be used to change the object of the statement.
   */
  update_statement(statement2) {
    if (statement2 && !statement2.graph) {
      return;
    }
    var updater = this;
    var context4 = this.statementContext(statement2);
    return {
      statement: statement2 ? [statement2.subject, statement2.predicate, statement2.object, statement2.graph] : void 0,
      statementNT: statement2 ? this.anonymizeNT(statement2) : void 0,
      where: updater.contextWhere(context4),
      set_object: function(obj, callbackFunction) {
        var query4 = this.where;
        query4 += "DELETE DATA { " + this.statementNT + " } ;\n";
        query4 += "INSERT DATA { " + // @ts-ignore `this` might refer to the wrong scope. Does this work?
        this.anonymize(this.statement[0]) + " " + // @ts-ignore
        this.anonymize(this.statement[1]) + " " + // @ts-ignore
        this.anonymize(obj) + "  . }\n";
        updater.fire(this.statement[3].value, query4, callbackFunction);
      }
    };
  }
  insert_statement(st2, callbackFunction) {
    var st0 = st2 instanceof Array ? st2[0] : st2;
    var query4 = this.contextWhere(this.statementContext(st0));
    if (st2 instanceof Array) {
      var stText = "";
      for (let i = 0; i < st2.length; i++) stText += st2[i] + "\n";
      query4 += "INSERT DATA { " + stText + " }\n";
    } else {
      query4 += "INSERT DATA { " + this.anonymize(st2.subject) + " " + this.anonymize(st2.predicate) + " " + this.anonymize(st2.object) + "  . }\n";
    }
    this.fire(st0.graph.value, query4, callbackFunction);
  }
  delete_statement(st2, callbackFunction) {
    var st0 = st2 instanceof Array ? st2[0] : st2;
    var query4 = this.contextWhere(this.statementContext(st0));
    if (st2 instanceof Array) {
      var stText = "";
      for (let i = 0; i < st2.length; i++) stText += st2[i] + "\n";
      query4 += "DELETE DATA { " + stText + " }\n";
    } else {
      query4 += "DELETE DATA { " + this.anonymize(st2.subject) + " " + this.anonymize(st2.predicate) + " " + this.anonymize(st2.object) + "  . }\n";
    }
    this.fire(st0.graph.value, query4, callbackFunction);
  }
  /// //////////////////////
  /**
   * Requests a now or future action to refresh changes coming downstream
   * This is designed to allow the system to re-request the server version,
   * when a websocket has pinged to say there are changes.
   * If the websocket, by contrast, has sent a patch, then this may not be necessary.
   *
   * @param doc
   * @param action
   */
  requestDownstreamAction(doc, action3) {
    var control2 = this.patchControlFor(doc);
    if (!control2.pendingUpstream) {
      action3(doc);
    } else {
      if (control2.downstreamAction) {
        if ("" + control2.downstreamAction !== "" + action3) {
          throw new Error("Can't wait for > 1 different downstream actions");
        }
      } else {
        control2.downstreamAction = action3;
      }
    }
  }
  /**
   * We want to start counting websocket notifications
   * to distinguish the ones from others from our own.
   */
  clearUpstreamCount(doc) {
    var control2 = this.patchControlFor(doc);
    control2.upstreamCount = 0;
  }
  getUpdatesVia(doc) {
    var linkHeaders = this.store.fetcher.getHeader(doc, "updates-via");
    if (!linkHeaders || !linkHeaders.length) return null;
    return linkHeaders[0].trim();
  }
  addDownstreamChangeListener(doc, listener) {
    var control2 = this.patchControlFor(doc);
    if (!control2.downstreamChangeListeners) {
      control2.downstreamChangeListeners = [];
    }
    control2.downstreamChangeListeners.push(listener);
    this.setRefreshHandler(doc, (doc2) => {
      this.reloadAndSync(doc2);
    });
  }
  reloadAndSync(doc) {
    var control2 = this.patchControlFor(doc);
    var updater = this;
    if (control2.reloading) {
      control2.outOfDate = true;
      return;
    }
    control2.reloading = true;
    var retryTimeout = 1e3;
    var tryReload = function() {
      updater.reload(updater.store, doc, function(ok2, message4, response6) {
        if (ok2) {
          if (control2.downstreamChangeListeners) {
            for (let i = 0; i < control2.downstreamChangeListeners.length; i++) {
              control2.downstreamChangeListeners[i]();
            }
          }
          control2.reloading = false;
          if (control2.outOfDate) {
            control2.outOfDate = false;
            tryReload();
          }
        } else {
          control2.reloading = false;
          if (response6 && response6.status === 0) {
            control2.reloading = true;
            retryTimeout = retryTimeout * 2;
            setTimeout(tryReload, retryTimeout);
          } else {
          }
        }
      });
    };
    tryReload();
  }
  /**
   * Sets up websocket to listen on
   *
   * There is coordination between upstream changes and downstream ones
   * so that a reload is not done in the middle of an upstream patch.
   * If you use this API then you get called when a change happens, and you
   * have to reload the file yourself, and then refresh the UI.
   * Alternative is addDownstreamChangeListener(), where you do not
   * have to do the reload yourself. Do mot mix them.
   *
   * kb contains the HTTP  metadata from previous operations
   *
   * @param doc
   * @param handler
   *
   * @returns {boolean}
   */
  setRefreshHandler(doc, handler) {
    let wssURI = this.getUpdatesVia(doc);
    var theHandler = handler;
    var self2 = this;
    var updater = this;
    var retryTimeout = 1500;
    var retries = 0;
    if (!wssURI) {
      return false;
    }
    wssURI = join(wssURI, doc.value);
    const validWssURI = wssURI.replace(/^http:/, "ws:").replace(/^https:/, "wss:");
    var openWebsocket = function() {
      var socket;
      if (typeof WebSocket !== "undefined") {
        socket = new WebSocket(validWssURI);
      } else if (typeof window !== "undefined" && window.WebSocket) {
        socket = window.WebSocket(validWssURI);
      } else {
        return;
      }
      socket.onopen = function() {
        retryTimeout = 1500;
        this.send("sub " + doc.value);
        if (retries) {
          updater.requestDownstreamAction(doc, theHandler);
        }
      };
      var control2 = self2.patchControlFor(doc);
      control2.upstreamCount = 0;
      socket.onerror = function onerror(err2) {
      };
      socket.onclose = function(event4) {
        retryTimeout *= 2;
        retries += 1;
        setTimeout(function() {
          openWebsocket();
        }, retryTimeout);
      };
      socket.onmessage = function(msg) {
        if (msg.data && msg.data.slice(0, 3) === "pub") {
          if ("upstreamCount" in control2) {
            control2.upstreamCount -= 1;
            if (control2.upstreamCount >= 0) {
              return;
            }
          }
          control2.upstreamCount = 0;
          self2.requestDownstreamAction(doc, theHandler);
        }
      };
    };
    openWebsocket();
    return true;
  }
  /**
   * This high-level function updates the local store iff the web is changed successfully.
   * Deletions, insertions may be undefined or single statements or lists or formulae (may contain bnodes which can be indirectly identified by a where clause).
   * The `why` property of each statement must be the give the web document to be updated.
   * The statements to be deleted and inserted may span more than one web document.
   * @param deletions - Statement or statements to be deleted.
   * @param insertions - Statement or statements to be inserted.
   * @returns a promise
   */
  updateMany(deletions, insertions = []) {
    const docs = deletions.concat(insertions).map((st2) => st2.why);
    const thisUpdater = this;
    const uniqueDocs = [];
    docs.forEach((doc) => {
      if (!uniqueDocs.find((uniqueDoc) => uniqueDoc.equals(doc))) uniqueDocs.push(doc);
    });
    const updates = uniqueDocs.map((doc) => thisUpdater.update(deletions.filter((st2) => st2.why.equals(doc)), insertions.filter((st2) => st2.why.equals(doc))));
    if (updates.length > 1) {
    }
    return Promise.all(updates);
  }
  /**
   * @private
   * 
   * This helper function constructs SPARQL Update query from resolved arguments.
   * 
   * @param ds: deletions array.
   * @param is: insertions array.
   * @param bnodes_context: Additional context to uniquely identify any blank nodes.
   */
  constructSparqlUpdateQuery(ds, is, bnodes_context) {
    var whereClause = this.contextWhere(bnodes_context);
    var query4 = "";
    if (whereClause.length) {
      if (ds.length) {
        query4 += "DELETE { ";
        for (let i = 0; i < ds.length; i++) {
          query4 += this.anonymizeNT(ds[i]) + "\n";
        }
        query4 += " }\n";
      }
      if (is.length) {
        query4 += "INSERT { ";
        for (let i = 0; i < is.length; i++) {
          query4 += this.anonymizeNT(is[i]) + "\n";
        }
        query4 += " }\n";
      }
      query4 += whereClause;
    } else {
      if (ds.length) {
        query4 += "DELETE DATA { ";
        for (let i = 0; i < ds.length; i++) {
          query4 += this.anonymizeNT(ds[i]) + "\n";
        }
        query4 += " } \n";
      }
      if (is.length) {
        if (ds.length) query4 += " ; ";
        query4 += "INSERT DATA { ";
        for (let i = 0; i < is.length; i++) {
          query4 += this.nTriples(is[i]) + "\n";
        }
        query4 += " }\n";
      }
    }
    return query4;
  }
  /**
   * @private
   * 
   * This helper function constructs n3-patch query from resolved arguments.
   * 
   * @param ds: deletions array.
   * @param is: insertions array.
   * @param bnodes_context: Additional context to uniquely identify any blanknodes.
   */
  constructN3PatchQuery(ds, is, bnodes_context) {
    var query4 = `
@prefix solid: <http://www.w3.org/ns/solid/terms#>.
@prefix ex: <http://www.example.org/terms#>.

_:patch
`;
    if (bnodes_context && bnodes_context.length > 0) {
      query4 += `
      solid:where {
        ${bnodes_context.map((x) => this.anonymizeNT(x)).join("\n        ")}
      };`;
    }
    if (ds.length > 0) {
      query4 += `
      solid:deletes {
        ${ds.map((x) => this.anonymizeNT(x)).join("\n        ")}
      };`;
    }
    if (is.length > 0) {
      query4 += `
      solid:inserts {
        ${is.map((x) => this.anonymizeNT(x)).join("\n        ")}
      };`;
    }
    query4 += "   a solid:InsertDeletePatch .\n";
    return query4;
  }
  /**
   * This high-level function updates the local store if the web is changed successfully.
   * Deletions, insertions may be undefined or single statements or lists or formulae (may contain bnodes which can be indirectly identified by a where clause).
   * The `why` property of each statement must be the same and give the web document to be updated.
   * @param deletions - Statement or statements to be deleted.
   * @param insertions - Statement or statements to be inserted.
   * @param callback - called as callbackFunction(uri, success, errorbody)
   *           OR returns a promise
   * @param options - Options for the fetch call
   */
  update(deletions, insertions, callback, secondTry, options = {}) {
    if (!callback) {
      var thisUpdater = this;
      return new Promise(function(resolve, reject) {
        thisUpdater.update(deletions, insertions, function(uri6, ok2, errorBody) {
          if (!ok2) {
            reject(new Error(errorBody));
          } else {
            resolve();
          }
        }, secondTry, options);
      });
    }
    try {
      var kb = this.store;
      var ds = !deletions ? [] : isStore(deletions) ? deletions.statements : deletions instanceof Array ? deletions : [deletions];
      var is = !insertions ? [] : isStore(insertions) ? insertions.statements : insertions instanceof Array ? insertions : [insertions];
      if (!(ds instanceof Array)) {
        throw new Error("Type Error " + typeof ds + ": " + ds);
      }
      if (!(is instanceof Array)) {
        throw new Error("Type Error " + typeof is + ": " + is);
      }
      if (ds.length === 0 && is.length === 0) {
        return callback(null, true);
      }
      var doc = ds.length ? ds[0].graph : is[0].graph;
      if (!doc) {
        let message4 = "Error patching: statement does not specify which document to patch:" + ds[0] + ", " + is[0];
        throw new Error(message4);
      }
      if (doc.termType !== "NamedNode") {
        let message4 = "Error patching: document not a NamedNode:" + ds[0] + ", " + is[0];
        throw new Error(message4);
      }
      var control2 = this.patchControlFor(doc);
      var startTime4 = Date.now();
      var props = ["subject", "predicate", "object", "why"];
      var verbs = ["insert", "delete"];
      var clauses = {
        "delete": ds,
        "insert": is
      };
      verbs.map(function(verb2) {
        clauses[verb2].map(function(st2) {
          if (!doc.equals(st2.graph)) {
            throw new Error("update: destination " + doc + " inconsistent with delete quad " + st2.graph);
          }
          props.map(function(prop) {
            if (typeof st2[prop] === "undefined") {
              throw new Error("update: undefined " + prop + " of statement.");
            }
          });
        });
      });
      var protocol6 = this.editable(doc.value, kb);
      if (protocol6 === false) {
        throw new Error("Update: Can't make changes in uneditable " + doc);
      }
      if (protocol6 === void 0) {
        if (secondTry) {
          throw new Error("Update: Loaded " + doc + "but still can't figure out what editing protocol it supports.");
        }
        this.store.fetcher.load(doc).then((response6) => {
          this.update(deletions, insertions, callback, true, options);
        }, (err2) => {
          if (err2.response.status === 404) {
            this.update(deletions, insertions, callback, true, options);
          } else {
            throw new Error(`Update: Can't get updatability status ${doc} before patching: ${err2}`);
          }
        });
        return;
      } else if (protocol6.indexOf("SPARQL") >= 0 || protocol6.indexOf("N3PATCH") >= 0) {
        var isSparql = protocol6.indexOf("SPARQL") >= 0;
        var bnodes = [];
        if (ds.length) bnodes = this.statementArrayBnodes(ds);
        if (is.length) bnodes = bnodes.concat(this.statementArrayBnodes(is));
        var context4 = this.bnodeContext(bnodes, doc);
        var query4 = isSparql ? this.constructSparqlUpdateQuery(ds, is, context4) : this.constructN3PatchQuery(ds, is, context4);
        options.contentType = isSparql ? "application/sparql-update" : "text/n3";
        control2.pendingUpstream = control2.pendingUpstream ? control2.pendingUpstream + 1 : 1;
        if ("upstreamCount" in control2) {
          control2.upstreamCount += 1;
        }
        this.fire(doc.value, query4, (uri6, success, body, response6) => {
          response6.elapsedTimeMs = Date.now() - startTime4;
          if (success) {
            try {
              kb.remove(ds);
            } catch (e) {
              success = false;
              body = "Remote Ok BUT error deleting " + ds.length + " from store!!! " + e;
            }
            for (let i = 0; i < is.length; i++) {
              kb.add(is[i].subject, is[i].predicate, is[i].object, doc);
            }
          }
          callback(uri6, success, body, response6);
          control2.pendingUpstream -= 1;
          if (control2.pendingUpstream === 0 && control2.downstreamAction) {
            var downstreamAction = control2.downstreamAction;
            delete control2.downstreamAction;
            downstreamAction(doc);
          }
        }, options);
      } else if (protocol6.indexOf("DAV") >= 0) {
        this.updateDav(doc, ds, is, callback, options);
      } else {
        if (protocol6.indexOf("LOCALFILE") >= 0) {
          try {
            this.updateLocalFile(doc, ds, is, callback, options);
          } catch (e) {
            callback(
              doc.value,
              false,
              "Exception trying to write back file <" + doc.value + ">\n"
              // + tabulator.Util.stackString(e))
            );
          }
        } else {
          throw new Error("Unhandled edit method: '" + protocol6 + "' for " + doc);
        }
      }
    } catch (e) {
      callback(void 0, false, "Exception in update: " + e + "\n" + stackString(e));
    }
  }
  updateDav(doc, ds, is, callbackFunction, options = {}) {
    let kb = this.store;
    var request2 = kb.any(doc, this.ns.link("request"));
    if (!request2) {
      throw new Error("No record of our HTTP GET request for document: " + doc);
    }
    var response6 = kb.any(request2, this.ns.link("response"));
    if (!response6) {
      return null;
    }
    var contentType4 = kb.the(response6, this.ns.httph("content-type")).value;
    let newSts = kb.statementsMatching(void 0, void 0, void 0, doc).slice();
    for (let i = 0; i < ds.length; i++) {
      RDFArrayRemove(newSts, ds[i]);
    }
    for (let i = 0; i < is.length; i++) {
      newSts.push(is[i]);
    }
    const documentString = this.serialize(doc.value, newSts, contentType4);
    var candidateTarget = kb.the(response6, this.ns.httph("content-location"));
    var targetURI;
    if (candidateTarget) {
      targetURI = join(candidateTarget.value, targetURI);
    }
    options.contentType = contentType4;
    options.noMeta = true;
    options.body = documentString;
    return kb.fetcher.webOperation("PUT", targetURI, options).then((response7) => {
      if (!response7.ok) {
        throw new Error(response7.error);
      }
      for (let i = 0; i < ds.length; i++) {
        kb.remove(ds[i]);
      }
      for (let i = 0; i < is.length; i++) {
        kb.add(is[i].subject, is[i].predicate, is[i].object, doc);
      }
      callbackFunction(doc.value, response7.ok, response7.responseText, response7);
    }).catch((err2) => {
      callbackFunction(doc.value, false, err2.message, err2);
    });
  }
  /**
   * Likely deprecated, since this lib no longer deals with browser extension
   *
   * @param doc
   * @param ds
   * @param is
   * @param callbackFunction
   * @param options
   */
  updateLocalFile(doc, ds, is, callbackFunction, options = {}) {
    const kb = this.store;
    let newSts = kb.statementsMatching(void 0, void 0, void 0, doc).slice();
    for (let i = 0; i < ds.length; i++) {
      RDFArrayRemove(newSts, ds[i]);
    }
    for (let i = 0; i < is.length; i++) {
      newSts.push(is[i]);
    }
    var dot = doc.value.lastIndexOf(".");
    if (dot < 1) {
      throw new Error("Rewriting file: No filename extension: " + doc.value);
    }
    var ext = doc.value.slice(dot + 1);
    let contentType4 = Fetcher.CONTENT_TYPE_BY_EXT[ext];
    if (!contentType4) {
      throw new Error("File extension ." + ext + " not supported for data write");
    }
    options.body = this.serialize(doc.value, newSts, contentType4);
    options.contentType = contentType4;
    kb.fetcher.webOperation("PUT", doc.value, options).then((response6) => {
      if (!response6.ok) return callbackFunction(doc.value, false, response6.error);
      for (let i = 0; i < ds.length; i++) {
        kb.remove(ds[i]);
      }
      for (let i = 0; i < is.length; i++) {
        kb.add(is[i].subject, is[i].predicate, is[i].object, doc);
      }
      callbackFunction(doc.value, true, "");
    });
  }
  /**
   * @throws {Error} On unsupported content type
   *
   * @returns {string}
   */
  serialize(uri6, data4, contentType4) {
    const kb = this.store;
    let documentString;
    if (typeof data4 === "string") {
      return data4;
    }
    var sz = createSerializer(kb);
    sz.suggestNamespaces(kb.namespaces);
    sz.setBase(uri6);
    switch (contentType4) {
      case "text/xml":
      case "application/rdf+xml":
        documentString = sz.statementsToXML(data4);
        break;
      case "text/n3":
      case "text/turtle":
      case "application/x-turtle":
      // Legacy
      case "application/n3":
        documentString = sz.statementsToN3(data4);
        break;
      default:
        throw new Error("Content-type " + contentType4 + " not supported for data serialization");
    }
    return documentString;
  }
  /**
   * This is suitable for an initial creation of a document.
   */
  put(doc, data4, contentType4, callback) {
    const kb = this.store;
    let documentString;
    return Promise.resolve().then(() => {
      documentString = this.serialize(doc.value, data4, contentType4);
      return kb.fetcher.webOperation("PUT", doc.value, {
        contentType: contentType4,
        body: documentString
      });
    }).then((response6) => {
      if (!response6.ok) {
        return callback(doc.value, response6.ok, response6.error, response6);
      }
      delete kb.fetcher.nonexistent[doc.value];
      delete kb.fetcher.requested[doc.value];
      if (typeof data4 !== "string") {
        data4.map((st2) => {
          kb.addStatement(st2);
        });
      }
      callback(doc.value, response6.ok, "", response6);
    }).catch((err2) => {
      callback(doc.value, false, err2.message);
    });
  }
  /**
   * Reloads a document.
   *
   * Fast and cheap, no metadata. Measure times for the document.
   * Load it provisionally.
   * Don't delete the statements before the load, or it will leave a broken
   * document in the meantime.
   *
   * @param kb
   * @param doc {RDFlibNamedNode}
   * @param callbackFunction
   */
  reload(kb, doc, callbackFunction) {
    var startTime4 = Date.now();
    const options = {
      force: true,
      noMeta: true,
      clearPreviousData: true
    };
    kb.fetcher.nowOrWhenFetched(doc.value, options, function(ok2, body, response6) {
      if (!ok2) {
        callbackFunction(false, "Error reloading data: " + body, response6);
      } else if (response6.onErrorWasCalled || response6.status !== 200) {
        callbackFunction(false, "Non-HTTP error reloading data: " + body, response6);
      } else {
        var elapsedTimeMs = Date.now() - startTime4;
        if (!doc.reloadTimeTotal) doc.reloadTimeTotal = 0;
        if (!doc.reloadTimeCount) doc.reloadTimeCount = 0;
        doc.reloadTimeTotal += elapsedTimeMs;
        doc.reloadTimeCount += 1;
        callbackFunction(true);
      }
    });
  }
};

// node_modules/rdflib/esm/factories/rdflib-data-factory.js
var RDFlibDataFactory = {
  ...extended_term_factory_default,
  /**
   * Creates a new fetcher
   * @param store - The store to use
   * @param options - The options
   */
  fetcher(store, options) {
    return new Fetcher(store, options);
  },
  /**
   * Creates a new graph (store)
   */
  graph(features = void 0, opts = void 0) {
    return new IndexedFormula(features, opts || {
      rdfFactory: extended_term_factory_default
    });
  },
  /**
   * Creates a new literal node
   * @param val The lexical value
   * @param lang The language
   * @param dt The datatype
   */
  lit(val, lang, dt) {
    return this.literal("" + val, lang || dt);
  },
  /**
   * Creates a new statement
   * @param subject The subject
   * @param predicate The predicate
   * @param object The object
   * @param graph The containing graph
   */
  st(subject8, predicate4, object8, graph3) {
    return this.quad(subject8, predicate4, object8, graph3);
  }
};
var rdflib_data_factory_default = RDFlibDataFactory;

// node_modules/rdflib/esm/index.js
var boundDataFactory = {};
for (const name9 in rdflib_data_factory_default) {
  if (typeof rdflib_data_factory_default[name9] === "function") boundDataFactory[name9] = rdflib_data_factory_default[name9].bind(rdflib_data_factory_default);
}
var {
  fetcher,
  graph,
  lit,
  st,
  namedNode: namedNode2,
  variable: variable2,
  blankNode: blankNode2,
  defaultGraph: defaultGraph4,
  literal: literal2,
  quad: quad2,
  triple
} = boundDataFactory;
var formula = new Formula();
var term = node_default.fromValue;
var NextId = BlankNode.nextId;

// src/namespaces/index.ts
var rdfs = Namespace("http://www.w3.org/2000/01/rdf-schema#");
var pim = Namespace("http://www.w3.org/ns/pim/space#");
var schema = Namespace("https://schema.org/");
var flow = Namespace("http://www.w3.org/2005/01/wf/flow#");
var iana = Namespace(
  "http://www.iana.org/assignments/link-relations/"
);
var link = Namespace("http://www.w3.org/2007/ont/link#");
var internal = Namespace("urn:pod-os:internal");

// src/thing/accumulateSubjects.ts
var accumulateSubjects = (accumulator, current3) => {
  const existing = accumulator[current3.predicate.uri];
  if (existing && existing.includes(current3.subject.value)) return accumulator;
  return {
    ...accumulator,
    [current3.predicate.uri]: existing ? [...existing, current3.subject.value] : [current3.subject.value]
  };
};

// src/thing/accumulateValues.ts
var accumulateValues = (accumulator, current3) => {
  const existing = accumulator[current3.predicate.uri];
  if (existing && existing.includes(current3.object.value)) return accumulator;
  return {
    ...accumulator,
    [current3.predicate.uri]: existing ? [...existing, current3.object.value] : [current3.object.value]
  };
};

// src/thing/isRdfType.ts
function isRdfType(predicate4) {
  return predicate4.sameTerm(
    namedNode2("http://www.w3.org/1999/02/22-rdf-syntax-ns#type")
  );
}

// src/thing/labelForType.ts
function labelForType(typeUri) {
  if (typeUri.includes("#")) {
    return typeUri.substring(typeUri.lastIndexOf("#") + 1);
  } else {
    return typeUri.substring(typeUri.lastIndexOf("/") + 1);
  }
}

// src/thing/labelFromUri.ts
function labelFromUri(uri6) {
  const url7 = new URL(uri6);
  if (isTooGeneric(url7.hash)) {
    return (getFilename(url7) || url7.host + url7.pathname) + url7.hash;
  }
  const name9 = labelFromFragment(url7.hash) || getFilename(url7) || url7.host;
  return name9.endsWith("/") ? name9.slice(0, -1) : name9;
}
function labelFromFragment(fragment) {
  return fragment ? fragment.split("#")[1] : null;
}
function isTooGeneric(fragment) {
  const genericFragments = ["#it", "#this", "#me", "#i"];
  return genericFragments.includes(fragment);
}
function getFilename(url7) {
  if (url7.pathname.endsWith("/")) {
    const containerName = url7.pathname.split("/").at(-2);
    return containerName ? decodeURIComponent(containerName) + "/" : null;
  } else {
    const name9 = url7.pathname.split("/").pop();
    return name9 ? decodeURIComponent(name9) : null;
  }
}

// src/thing/Thing.ts
var LABEL_PREDICATES = [
  "http://www.w3.org/2006/vcard/ns#fn",
  "http://xmlns.com/foaf/0.1/name",
  "http://xmlns.com/foaf/0.1/nick",
  "https://schema.org/name",
  "http://schema.org/name",
  "http://purl.org/dc/terms/title",
  "http://purl.org/dc/elements/1.1/title",
  "http://www.w3.org/2000/01/rdf-schema#label",
  "https://www.w3.org/ns/activitystreams#name",
  "http://schema.org/caption",
  "https://schema.org/caption"
];
var DESCRIPTION_PREDICATES = [
  "http://purl.org/dc/terms/description",
  "http://purl.org/dc/elements/1.1/description",
  "http://schema.org/description",
  "https://schema.org/description",
  "https://schema.org/text",
  "http://www.w3.org/2000/01/rdf-schema#comment",
  "https://www.w3.org/ns/activitystreams#summary",
  "https://www.w3.org/ns/activitystreams#content",
  "http://www.w3.org/2006/vcard/ns#note"
];
var Thing = class {
  constructor(uri6, store, editable = false) {
    this.uri = uri6;
    this.store = store;
    this.editable = editable;
  }
  /**
   * Returns a human-readable label for this thing. Tries to match common RDF terms
   * used for labels, such as `rdfs:label`, `schema:name` and others.
   *
   * If no such term is present, it will derive a label from the URI.
   */
  label() {
    const value8 = this.anyValue(...LABEL_PREDICATES);
    if (value8) {
      return value8;
    }
    return labelFromUri(this.uri);
  }
  /**
   * Observe changes in human-readable label for this thing. See `label`.
   */
  observeLabel() {
    return this.observeAnyValue(...LABEL_PREDICATES).pipe(
      map((value8) => value8 ?? labelFromUri(this.uri))
    );
  }
  /**
   * Returns all the literal values that are linked to this thing
   */
  literals() {
    const statements = this.store.statementsMatching(namedNode2(this.uri));
    const values2 = statements.filter((it) => isLiteral(it.object)).reduce(accumulateValues, {});
    return Object.keys(values2).map((predicate4) => ({
      predicate: predicate4,
      label: labelFromUri(predicate4),
      values: values2[predicate4]
    }));
  }
  /**
   * Observe changes in literal values linked to this thing
   */
  observeLiterals() {
    return this.observeSubjectChanges({
      observes: () => this.literals(),
      compare: (prev2, curr) => prev2.length === curr.length && prev2.every(
        (rel2, i) => rel2.predicate === curr[i].predicate && rel2.values.length === curr[i].values.length && rel2.values.every((val, j) => val === curr[i].values[j])
      )
    });
  }
  /**
   * Returns all the unique links from this thing to other resources. This only includes named nodes and excludes rdf:type relations.
   */
  relations(predicate4) {
    const statements = this.store.statementsMatching(
      namedNode2(this.uri),
      predicate4 ? namedNode2(predicate4) : null
    );
    const values2 = statements.filter((it) => isNamedNode(it.object) && !isRdfType(it.predicate)).reduce(accumulateValues, {});
    return Object.keys(values2).map((predicate5) => ({
      predicate: predicate5,
      label: labelFromUri(predicate5),
      uris: values2[predicate5]
    }));
  }
  /**
   * Observe changes in links from this thing to other resources
   */
  observeRelations(predicate4) {
    return this.observeSubjectChanges({
      observes: () => this.relations(predicate4),
      compare: (prev2, curr) => prev2.length === curr.length && prev2.every(
        (rel2, i) => rel2.predicate === curr[i].predicate && rel2.uris.length === curr[i].uris.length
      )
    });
  }
  /**
   * Generic observable creator that watches the store for changes
   * that have this thing as a subject
   * @param args.observedValue Function that returns the current value to observe
   * @param args.compare Function that compares previous and current values for distinctUntilChanged
   */
  observeSubjectChanges(args) {
    const { observes, compare } = args;
    return this.observeChanges({
      filterFn: (quad3) => quad3.subject.value === this.uri,
      observes,
      compare
    });
  }
  /**
   * Generic observable creator that watches the store for changes
   * that have this thing as an object
   * @param args.observedValue Function that returns the current value to observe
   * @param args.compare Function that compares previous and current values for distinctUntilChanged
   */
  observeObjectChanges(args) {
    const { observes, compare } = args;
    return this.observeChanges({
      filterFn: (quad3) => quad3.object.value === this.uri,
      observes,
      compare
    });
  }
  /**
   * Generic observable creator that watches the store for changes
   * that match the given filter function before comparing values of this thing for possible changes.
   * The observable only emits a new value if relevant quads are added or removed, and in consequence
   * the observed value changes according to the compare function
   *
   * @param args.filterFn Filter for relevant quads
   * @param args.observedValue Function that returns the value to observe
   * @param args.compare Function that compares previous and current values
   */
  observeChanges(args) {
    const { observes, compare, filterFn } = args;
    return merge(this.store.additions$, this.store.removals$).pipe(
      filter(filterFn),
      debounceTime(250),
      map(observes),
      startWith(observes()),
      distinctUntilChanged(compare)
    );
  }
  /**
   * Returns all the unique links from other resources to this thing
   */
  reverseRelations(predicate4) {
    const statements = this.store.statementsMatching(
      void 0,
      predicate4 ? namedNode2(predicate4) : null,
      namedNode2(this.uri)
    );
    const values2 = statements.reduce(accumulateSubjects, {});
    return Object.keys(values2).map((predicate5) => ({
      predicate: predicate5,
      label: labelFromUri(predicate5),
      uris: values2[predicate5]
    }));
  }
  /**
   * Observe changes in links from other resources to this thing
   */
  observeReverseRelations(predicate4) {
    return this.observeObjectChanges({
      observes: () => this.reverseRelations(predicate4),
      compare: (prev2, curr) => prev2.length === curr.length && prev2.every(
        (rel2, i) => rel2.predicate === curr[i].predicate && rel2.uris.length === curr[i].uris.length
      )
    });
  }
  /**
   * Returns any value linked from this thing via one of the given predicates
   * @param predicateUris
   */
  anyValue(...predicateUris) {
    let value8;
    predicateUris.some((it) => {
      value8 = this.store.anyValue(namedNode2(this.uri), namedNode2(it));
      return Boolean(value8);
    });
    return value8;
  }
  /**
   * Observe changes in a value linked from this thing via one of the given predicates
   *
   * Note that return value may differ from that from `anyValue` when more than one value is present.
   *
   * @param predicateUris
   */
  observeAnyValue(...predicateUris) {
    const currentValue = this.anyValue(...predicateUris);
    const relevantChanges$ = (observable2) => observable2.pipe(
      filter(
        (quad3) => quad3.subject.value === this.uri && predicateUris.includes(quad3.predicate.value)
      )
    );
    const removalOrInitial$ = relevantChanges$(this.store.removals$).pipe(
      map(() => ({ type: "removal" })),
      currentValue === void 0 ? startWith({ type: "removal" }) : identity
    );
    const addition$ = removalOrInitial$.pipe(
      switchMap(
        () => relevantChanges$(this.store.additions$).pipe(
          take(1),
          map((quad3) => ({
            type: "addition",
            value: quad3.object.value
          }))
        )
      )
    );
    return merge(removalOrInitial$, addition$).pipe(
      debounceTime(250),
      map(
        (event4) => event4.type === "addition" ? event4.value : this.anyValue(...predicateUris)
        // determine a new value after a removal
      ),
      startWith(currentValue)
    );
  }
  /**
   * Returns a literal value that describes this thing. Tries to match common RDF terms
   * used for descriptions, like `dct:description`, `schema:description` or `rdfs:comment`
   */
  description() {
    return this.anyValue(...DESCRIPTION_PREDICATES);
  }
  /**
   * Observe changes in literal values that describe this thing. See `description`
   */
  observeDescription() {
    return this.observeAnyValue(...DESCRIPTION_PREDICATES);
  }
  /**
   * Returns the url of a picture or logo associated with this thing
   * Tries to match common RDF terms used for pictures like `schema:image`,
   * `vcard:photo` or `foaf:img`
   *
   * @return {Object} An object containing the `url` of the picture
   */
  picture() {
    const directUrl = this.anyValue(
      "http://schema.org/image",
      "https://schema.org/image",
      "http://schema.org/logo",
      "https://schema.org/logo",
      "http://www.w3.org/2006/vcard/ns#hasPhoto",
      "http://www.w3.org/2006/vcard/ns#photo",
      "http://www.w3.org/2006/vcard/ns#hasLogo",
      "http://www.w3.org/2006/vcard/ns#logo",
      "http://xmlns.com/foaf/0.1/img",
      "http://xmlns.com/foaf/0.1/depiction",
      "http://xmlns.com/foaf/0.1/thumbnail"
    );
    if (directUrl) {
      return {
        url: directUrl
      };
    } else {
      return this.findActivityStreamsPicture();
    }
  }
  findActivityStreamsPicture() {
    const activityStreamsImage = this.store.any(
      namedNode2(this.uri),
      namedNode2("https://www.w3.org/ns/activitystreams#image")
    ) || this.store.any(
      namedNode2(this.uri),
      namedNode2("https://www.w3.org/ns/activitystreams#icon")
    );
    if (!activityStreamsImage || !(isBlankNode(activityStreamsImage) || isNamedNode(activityStreamsImage))) {
      return null;
    }
    const url7 = this.store.anyValue(
      activityStreamsImage,
      namedNode2("https://www.w3.org/ns/activitystreams#url")
    );
    return url7 ? {
      url: url7
    } : null;
  }
  /**
   * Retrieves a list of RDF types for this thing.
   */
  types() {
    const uris = this.store.findTypes(this.uri);
    return uris.map((uri6) => ({
      uri: uri6,
      label: labelForType(uri6)
    }));
  }
  /**
   * Observe changes to the list of RDF types for this thing
   */
  observeTypes() {
    return merge(this.store.additions$, this.store.removals$).pipe(
      filter(
        (quad3) => quad3.subject.value === this.uri && quad3.predicate.value === "http://www.w3.org/1999/02/22-rdf-syntax-ns#type" || quad3.predicate.value === "http://www.w3.org/2000/01/rdf-schema#subClassOf"
      ),
      map(() => this.types()),
      startWith(this.types()),
      distinctUntilChanged((prev2, curr) => prev2.length === curr.length)
    );
  }
  /**
   * Returns all attachments linked to this thing
   */
  attachments() {
    const statements = this.store.statementsMatching(
      namedNode2(this.uri),
      flow("attachment")
    );
    return statements.filter((it) => isNamedNode(it.object)).map((statement2) => ({
      uri: statement2.object.value,
      label: labelFromUri(statement2.object.value)
    }));
  }
  /**
   * Call this method to switch to a more specific subclass of Thing.
   *
   * @param SpecificThing - a subclass of Thing to assume
   */
  assume(SpecificThing) {
    return new SpecificThing(this.uri, this.store, this.editable);
  }
  /**
   * Returns the container that contains this thing's document
   * The container URI is derived from the thing's URI.
   */
  container() {
    const doc = namedNode2(this.uri).doc();
    const baseUri = doc.value.endsWith("/") ? doc.value.slice(0, -1) : doc.value;
    const uri6 = new URL(".", baseUri).toString();
    return { uri: uri6 };
  }
  rdfDocument() {
    const doc = namedNode2(this.uri).doc();
    const isRdf = this.store.get(doc.uri).hasType(link("RDFDocument").value);
    if (isRdf) {
      return doc.value;
    }
    return this.store.anyValue(doc, iana("describedby"), null, internal());
  }
  hasType(typeUri) {
    return this.types().map((it) => it.uri).includes(typeUri);
  }
};

// src/ldp-container/LdpContainer.ts
var LdpContainer = class extends Thing {
  constructor(uri6, store, editable = false) {
    super(uri6, store, editable);
  }
  /**
   * Resources that the LDP Container contains
   *
   * @returns Array of objects with uri and name
   */
  contains() {
    const contains3 = this.store.statementsMatching(
      namedNode2(this.uri),
      namedNode2("http://www.w3.org/ns/ldp#contains"),
      null,
      namedNode2(this.uri)
    );
    return contains3.map((content5) => ({
      uri: content5.object.value,
      name: labelFromUri(content5.object.value)
    }));
  }
  /**
   * Observe changes to the resources that the LDP Container contains
   *
   * @returns RxJS Observable that pushes a new contains() array when it changes
   */
  observeContains() {
    return merge(this.store.additions$, this.store.removals$).pipe(
      filter(
        (quad3) => quad3.graph.value === this.uri && quad3.predicate.value === "http://www.w3.org/ns/ldp#contains"
      ),
      debounceTime(250),
      map(() => this.contains()),
      startWith(this.contains())
    );
  }
};

// src/files/createFileLinkOperation.ts
function createFileLinkOperation(thing, predicateUri, file2) {
  return {
    deletions: [],
    filesToCreate: [],
    insertions: [
      st(
        namedNode2(thing.uri),
        namedNode2(predicateUri),
        namedNode2(file2.url),
        namedNode2(thing.uri).doc()
      )
    ]
  };
}

// src/files/FileGateway.ts
var FileGateway = class {
  constructor(store, fileFetcher) {
    this.store = store;
    this.fileFetcher = fileFetcher;
  }
  /**
   * Uploads a file and associates it with a thing.
   * The container is automatically derived from the thing's URI.
   * Uses schema:image as the predicate.
   *
   * @param thing - The thing to add the file to
   * @param predicateUri - The URI of the predicate to use
   * @param fileToUpload - The file to upload
   * @returns Result with the uploaded metadata (url, name, contentType) or error
   */
  uploadAndLinkFile(thing, predicateUri, fileToUpload) {
    const container2 = this.getContainerFromThing(thing);
    return this.fileFetcher.createNewFile(container2, fileToUpload).andThen((file2) => this.linkFileToThing(thing, predicateUri, file2));
  }
  linkFileToThing(thing, predicateUri, file2) {
    const operation3 = createFileLinkOperation(thing, predicateUri, file2);
    return ResultAsync.fromPromise(
      this.store.executeUpdate(operation3).then(() => file2),
      () => ({
        type: "network",
        title: "Failed to link file to thing"
      })
    );
  }
  getContainerFromThing(thing) {
    return this.store.get(thing.container().uri).assume(LdpContainer);
  }
};

// src/attachments/AttachmentGateway.ts
var AttachmentGateway = class {
  constructor(fileGateway) {
    this.fileGateway = fileGateway;
  }
  /**
   * Uploads an attachment file and associates it with a thing.
   * The container is automatically derived from the thing's URI.
   * Uses flow:attachment as the predicate.
   *
   * @param thing - The thing to add the attachment to
   * @param attachmentFile - The attachment file to upload
   * @returns Result with the uploaded attachment metadata (url, name, contentType) or error
   */
  uploadAndAddAttachment(thing, attachmentFile) {
    return this.fileGateway.uploadAndLinkFile(
      thing,
      "http://www.w3.org/2005/01/wf/flow#attachment",
      attachmentFile
    );
  }
};

// src/picture/PictureGateway.ts
var PictureGateway = class {
  constructor(attachmentGateway) {
    this.attachmentGateway = attachmentGateway;
  }
  /**
   * Uploads a picture file and associates it with a thing.
   * The container is automatically derived from the thing's URI.
   * Uses schema:image as the predicate.
   *
   * @param thing - The thing to add the picture to
   * @param pictureFile - The picture file to upload
   * @returns Result with the uploaded picture metadata (url, name, contentType) or error
   */
  uploadAndAddPicture(thing, pictureFile) {
    return this.attachmentGateway.uploadAndLinkFile(
      thing,
      "http://schema.org/image",
      pictureFile
    );
  }
};

// src/profile/WebIdProfile.ts
var WebIdProfile = class extends Thing {
  constructor(webId, store, editable = false) {
    super(webId, store, editable);
    this.webId = webId;
    this.profileQuery = this.store.profileQuery(this.webId);
  }
  /**
   * Returns the URI of the preferences document
   */
  getPreferencesFile() {
    return this.profileQuery.queryPreferencesFile()?.value;
  }
  /**
   * Returns the URI of the public type index document
   * @since 0.24.0
   */
  getPublicTypeIndex() {
    return this.profileQuery.queryPublicTypeIndex()?.value;
  }
  /**
   * Returns the URI of the private type index document
   * @since 0.24.0
   */
  getPrivateTypeIndex() {
    const preferences = this.profileQuery.queryPreferencesFile();
    if (!preferences) return void 0;
    const query4 = this.store.preferencesQuery(this.webId, preferences);
    return query4.queryPrivateTypeIndex()?.value;
  }
  /**
   * Returns the URIs of the private label indexes
   */
  getPrivateLabelIndexes() {
    const profileNodes = this.store.each(
      namedNode2(this.webId),
      namedNode2("http://www.w3.org/ns/solid/terms#privateLabelIndex"),
      void 0,
      namedNode2(this.webId).doc()
    );
    const preferences = this.getPreferencesFile();
    if (preferences) {
      const preferencesNodes = this.store.each(
        namedNode2(this.webId),
        namedNode2("http://www.w3.org/ns/solid/terms#privateLabelIndex"),
        void 0,
        namedNode2(preferences)
      );
      return [...profileNodes, ...preferencesNodes].map((it) => it.value);
    } else {
      return profileNodes.map((it) => it.value);
    }
  }
};

// src/profile/ProfileGateway.ts
var ProfileGateway = class {
  constructor(store) {
    this.store = store;
  }
  /**
   * Fetches the profile for the given WebID and all linked documents
   * @since 0.24.0
   * @param webId The WebID to fetch the profile for
   * @returns {Promise<WebIdProfile>} The fetched profile
   */
  async fetchProfile(webId) {
    await this.store.fetch(webId);
    const profile2 = this.store.get(webId).assume(WebIdProfile);
    const preferences = profile2.getPreferencesFile();
    if (preferences) {
      try {
        await this.store.fetch(preferences);
      } catch (error4) {
        console.warn(`Failed to fetch preferences file ${preferences}:`, error4);
      }
    }
    const publicTypeIndex2 = profile2.getPublicTypeIndex();
    const privateTypeIndex2 = profile2.getPrivateTypeIndex();
    await this.store.fetchAll(
      [privateTypeIndex2, publicTypeIndex2].filter((it) => it !== void 0)
    );
    return profile2;
  }
};

// src/search/SearchIndex.ts
var import_lunr = __toESM(require_lunr(), 1);
var SearchIndex = class {
  constructor(labelIndexes) {
    this.labelIndexes = labelIndexes;
    this.index = this.rebuild().index;
  }
  /**
   * Recreates the search index with the current data from all label indexes
   */
  rebuild() {
    const labelIndexes = this.labelIndexes;
    this.index = (0, import_lunr.default)(function() {
      this.ref("uri");
      this.field("uri");
      this.field("label");
      this.metadataWhitelist = ["position"];
      const items2 = labelIndexes.flatMap((it) => it.getIndexedItems());
      items2.forEach((item4) => {
        this.add({
          uri: item4.uri,
          label: item4.label
        });
      });
    });
    return this;
  }
  /**
   * Search the index for a given term. It finds partial matches, but will rank exact matches higher.
   *
   * The rank order is:
   *
   *  1. exact matches
   *  2. prefix matches
   *  3. suffix matches
   *  4. any matches inside a literal
   *
   * @param term The (partial) term to search for
   * @param maxResults The maximum number of results to return (defaults to 10)
   */
  search(term3, maxResults = 10) {
    const escapedTerm = term3.replace(/[~^+:]/g, (x) => `\\${x}`);
    return this.index.search(
      `${escapedTerm}^100 ${escapedTerm}*^20 *${escapedTerm}^10 *${escapedTerm}*^5`
    ).slice(0, maxResults);
  }
  /**
   * Remove all data from the search index.
   */
  clear() {
    this.index = (0, import_lunr.default)(() => {
    });
  }
};

// src/rdf-document/RdfDocument.ts
var RdfDocument = class extends Thing {
  constructor(uri6, store, editable = false) {
    super(uri6, store, editable);
  }
  subjects() {
    const matches = this.store.statementsMatching(
      null,
      null,
      null,
      namedNode2(this.uri)
    );
    const uris = matches.filter((match) => isNamedNode(match.subject)).map((match) => match.subject.value);
    const uniqueUris = new Set(uris);
    uniqueUris.delete(this.uri);
    return [...uniqueUris].map((uri6) => ({
      uri: uri6
    }));
  }
};

// src/search/LabelIndex.ts
var LabelIndex = class extends RdfDocument {
  constructor(uri6, store, editable = false) {
    super(uri6, store, editable);
  }
  /**
   * Returns the URIs and labels for all the things listed in the document.
   */
  getIndexedItems() {
    const matches = this.store.statementsMatching(
      null,
      rdfs("label"),
      null,
      namedNode2(this.uri)
    );
    return matches.map((it) => {
      return {
        uri: it.subject.value,
        label: it.object.value
      };
    });
  }
  contains(uri6) {
    return this.store.holds(namedNode2(uri6), rdfs("label"), null, namedNode2(this.uri));
  }
};

// node_modules/@solid-data-modules/rdflib-utils/dist/web-operations/executeUpdate.js
async function executeUpdate(fetcher2, updater, operation3) {
  await updater.updateMany(operation3.deletions, operation3.insertions);
  operation3.filesToCreate.map((file2) => {
    createEmptyTurtleFile(fetcher2, file2.url);
  });
}
function createEmptyTurtleFile(fetcher2, url7) {
  return fetcher2.webOperation("PUT", url7, {
    contentType: "text/turtle"
  });
}

// node_modules/@solid-data-modules/rdflib-utils/dist/namespaces/index.js
var rdf3 = Namespace("http://www.w3.org/1999/02/22-rdf-syntax-ns#");
var solid = Namespace("http://www.w3.org/ns/solid/terms#");
var pim2 = Namespace("http://www.w3.org/ns/pim/space#");
var ldp = Namespace("http://www.w3.org/ns/ldp#");

// node_modules/@solid-data-modules/rdflib-utils/dist/queries/PreferencesQuery.js
var PreferencesQuery = class {
  constructor(store, webIdNode, preferencesDoc) {
    this.store = store;
    this.webIdNode = webIdNode;
    this.preferencesDoc = preferencesDoc;
  }
  /**
   * Look up the private type index. Returns null if none is found or if the predicated does not link to a proper named node
   */
  queryPrivateTypeIndex() {
    const node3 = this.store.any(this.webIdNode, solid("privateTypeIndex"), null, this.preferencesDoc);
    if (isNamedNode(node3)) {
      return node3;
    }
    return null;
  }
};

// node_modules/@solid-data-modules/rdflib-utils/dist/queries/ProfileQuery.js
var ProfileQuery = class {
  constructor(webIdNode, store) {
    this.webIdNode = webIdNode;
    this.store = store;
  }
  /**
   * Look up the public type index. Returns null if none is found or if the predicated does not link to a proper named node
   */
  queryPublicTypeIndex() {
    const predicate4 = solid("publicTypeIndex");
    return this.queryNamedNode(predicate4);
  }
  /**
   * Look up the preferences file. Returns null if none is found or if the predicated does not link to a proper named node
   */
  queryPreferencesFile() {
    const predicate4 = pim2("preferencesFile");
    return this.queryNamedNode(predicate4);
  }
  queryNamedNode(predicate4) {
    const node3 = this.store.any(this.webIdNode, predicate4, null, this.webIdNode.doc());
    if (isNamedNode(node3)) {
      return node3;
    }
    return null;
  }
};

// node_modules/@solid-data-modules/rdflib-utils/dist/identifier/generate-id.js
var import_short_unique_id = __toESM(require_short_unique_id(), 1);
var uid = new import_short_unique_id.default({ length: 10 });

// src/search/createDefaultLabelIndex.ts
function createDefaultLabelIndex(profile2) {
  const webId = namedNode2(profile2.webId);
  const preferencesFile2 = profile2.getPreferencesFile();
  const defaultFileName = "privateLabelIndex.ttl";
  const indexUrl = preferencesFile2 ? new URL(defaultFileName, preferencesFile2).href : new URL(defaultFileName, webId.uri).href;
  const preferencesOrProfileDoc = preferencesFile2 ? namedNode2(preferencesFile2) : webId.doc();
  const indexDocument = namedNode2(indexUrl);
  return {
    uri: indexDocument.uri,
    insertions: [
      st(
        webId,
        solid("privateLabelIndex"),
        indexDocument,
        preferencesOrProfileDoc
      ),
      st(indexDocument, rdfs("label"), lit("Default Index"), indexDocument)
    ],
    deletions: [],
    filesToCreate: []
  };
}

// src/search/addToLabelIndex.ts
var addToLabelIndex = (thing, labelIndex) => {
  return {
    deletions: [],
    filesToCreate: [],
    insertions: [
      st(
        namedNode2(thing.uri),
        rdfs("label"),
        lit(thing.label()),
        namedNode2(labelIndex.uri)
      )
    ]
  };
};

// src/search/SearchGateway.ts
var SearchGateway = class {
  constructor(store) {
    this.store = store;
  }
  /**
   * Fetch the private label index for the given profile and build a search index from it
   * @param profile
   */
  async buildSearchIndex(profile2) {
    const labelIndexUris = profile2.getPrivateLabelIndexes();
    if (labelIndexUris.length > 0) {
      await this.store.fetchAll(labelIndexUris);
      const labelIndex = labelIndexUris.map(
        (uri6) => this.store.get(uri6).assume(LabelIndex)
      );
      return new SearchIndex(labelIndex);
    }
    return new SearchIndex([]);
  }
  async addToLabelIndex(thing, labelIndex) {
    await this.store.executeUpdate(addToLabelIndex(thing, labelIndex));
  }
  async createDefaultLabelIndex(profile2) {
    const operation3 = createDefaultLabelIndex(profile2);
    await this.store.executeUpdate(operation3);
    return this.store.get(operation3.uri).assume(LabelIndex);
  }
};

// src/offline-cache/OfflineCapableFetcher.ts
var OfflineCapableFetcher = class extends Fetcher {
  constructor(store, options) {
    const { offlineCache, isOnline, ...rest3 } = options;
    super(store, rest3);
    this.store = store;
    this.offlineCache = offlineCache;
    this.isOnline = isOnline;
  }
  async load(oneOrMoreUris, options) {
    if (Array.isArray(oneOrMoreUris)) {
      return await super.load(
        oneOrMoreUris,
        options
      );
    }
    const node3 = namedNode2(termValue(oneOrMoreUris));
    const doc = node3.doc();
    if (this.isOnline()) {
      try {
        const response6 = await super.load(node3, options);
        const etag2 = response6.headers.get("etag");
        this.putToCache(doc, etag2);
        return response6;
      } catch (e) {
        const error4 = e;
        if (error4.status === 999) {
          return await this.retrieveFromCache(doc, error4);
        } else {
          throw error4;
        }
      }
    } else {
      return await this.retrieveFromCache(
        doc,
        new Error(
          `You are offline and no data was found in the offline cache for ${doc.uri}`
        )
      );
    }
  }
  putToCache(doc, etag2) {
    const triples = serialize(doc, this.store, null, "application/n-triples");
    this.offlineCache.put({
      url: doc.uri,
      revision: etag2 ?? `timestamp-${(/* @__PURE__ */ new Date()).getTime()}`,
      statements: triples?.trim() ?? ""
    });
  }
  async retrieveFromCache(doc, errorOnCacheMiss) {
    const cache = await this.offlineCache.get(doc.uri);
    if (!cache) {
      throw errorOnCacheMiss;
    }
    parse2(cache.statements, this.store, doc.uri, "text/turtle");
    return new Response(cache.statements, {
      status: 200,
      headers: {
        "Content-Type": "text/turtle",
        etag: cache.revision
      }
    });
  }
};

// src/offline-cache/OfflineCache.ts
var NoOfflineCache = class {
  put() {
  }
  async get() {
    return void 0;
  }
  clear() {
  }
};

// src/offline-cache/OnlineStatus.ts
var AssumeAlwaysOnline = class {
  isOnline() {
    return true;
  }
};

// src/Store.ts
var import_tf_types = __toESM(require_tf_types(), 1);
var Store = class {
  constructor(session4, offlineCache = new NoOfflineCache(), onlineStatus = new AssumeAlwaysOnline(), internalStore = graph()) {
    this.DESCRIBEDBY = iana("describedby");
    this.internalStore = internalStore;
    this.fetcher = new OfflineCapableFetcher(this.internalStore, {
      fetch: session4.authenticatedFetch,
      offlineCache,
      isOnline: onlineStatus.isOnline
    });
    this.updater = new UpdateManager(this.internalStore);
    this.additions$ = new Subject();
    this.removals$ = new Subject();
    this.internalStore.addDataCallback((quad3) => this.additions$.next(quad3));
    this.internalStore.addDataRemovalCallback(
      (quad3) => this.removals$.next(quad3)
    );
  }
  /**
   * Fetch data for the given URI to the internalStore.
   * If the response includes a Link header with rel="describedby",
   * the metadata document will also be fetched automatically.
   * @param uri
   */
  async fetch(uri6) {
    const response6 = await this.fetcher.load(namedNode2(uri6), {
      // force fetching due to
      // https://github.com/linkeddata/rdflib.js/issues/247
      // and
      // https://github.com/linkeddata/rdflib.js/issues/441
      force: true,
      // explicitly omit credentials due to
      // https://github.com/pod-os/PodOS/issues/17
      credentials: "omit"
    });
    const descriptionResourceUri = this.internalStore.any(
      namedNode2(uri6),
      this.DESCRIBEDBY,
      null,
      response6.req
    );
    if (descriptionResourceUri) {
      try {
        await this.fetcher.load(namedNode2(descriptionResourceUri.value), {
          force: true,
          credentials: "omit"
        });
      } catch {
      } finally {
        this.internalStore.add(
          namedNode2(uri6),
          this.DESCRIBEDBY,
          namedNode2(descriptionResourceUri.value),
          internal()
        );
      }
    }
  }
  /**
   * Fetch all the given URIs in parallel and put the data to the internalStore
   * @param uris
   */
  fetchAll(uris) {
    const responses = uris.map((uri6) => this.fetch(uri6));
    return Promise.allSettled(responses);
  }
  /**
   * Retrieve the thing identified by the given URI from the internalStore
   * @param uri
   */
  get(uri6) {
    const editable = !!this.updater.editable(uri6);
    return new Thing(uri6, this, editable);
  }
  /**
   * Adds a new value to the property of the given thing
   * @param thing
   * @param property
   * @param value
   */
  async addPropertyValue(thing, property4, value8) {
    const docUrl = this.determineDocumentToUpdate(thing);
    return this.insert(
      st(namedNode2(thing.uri), namedNode2(property4), lit(value8), namedNode2(docUrl))
    );
  }
  insert(statement2) {
    return this.updater.update([], [statement2], void 0, false, {
      // explicitly omit credentials due to
      // https://github.com/pod-os/PodOS/issues/17
      credentials: "omit"
    });
  }
  /**
   * Adds a new relation (link) from the thing to the given uri using the property
   * @param thing
   * @param property
   * @param uri
   */
  async addRelation(thing, property4, uri6) {
    const docUrl = this.determineDocumentToUpdate(thing);
    return this.insert(
      st(namedNode2(thing.uri), namedNode2(property4), namedNode2(uri6), namedNode2(docUrl))
    );
  }
  determineDocumentToUpdate(thing) {
    const docUrl = thing.rdfDocument();
    if (!docUrl) {
      throw new Error("Could not determine document to update");
    }
    return docUrl;
  }
  async addNewThing(uri6, name9, type5) {
    await this.updater.update(
      [],
      [
        st(
          namedNode2(uri6),
          namedNode2("http://www.w3.org/1999/02/22-rdf-syntax-ns#type"),
          namedNode2(type5),
          namedNode2(uri6).doc()
        ),
        st(
          namedNode2(uri6),
          namedNode2("http://www.w3.org/2000/01/rdf-schema#label"),
          lit(name9),
          namedNode2(uri6).doc()
        )
      ],
      void 0,
      false,
      {
        // explicitly omit credentials due to
        // https://github.com/pod-os/PodOS/issues/17
        credentials: "omit"
      }
    );
  }
  async executeUpdate(operation3) {
    await executeUpdate(this.fetcher, this.updater, operation3);
  }
  flagAuthorizationMetadata() {
    this.updater.flagAuthorizationMetadata();
  }
  loadModule(module3) {
    return new module3.default({
      store: this.internalStore,
      fetcher: this.fetcher,
      updater: this.updater
    });
  }
  /**
   * Finds instances of the given class or its sub-classes
   * @param {string} classUri
   * @returns {string[]} An array of URIs
   */
  findMembers(classUri) {
    return Object.keys(this.internalStore.findMemberURIs(namedNode2(classUri)));
  }
  /**
   * Get an Observable that will push new results from {@link findMembers} when it changes
   * @param {string} classUri
   * @returns {Observable<string[]>} Observable that pushes an array of URIs of instances of the given class or its sub-classes
   */
  observeFindMembers(classUri) {
    return merge(this.additions$, this.removals$).pipe(
      filter(
        (quad3) => quad3.predicate.value == "http://www.w3.org/1999/02/22-rdf-syntax-ns#type" || quad3.predicate.value == "http://www.w3.org/2000/01/rdf-schema#subClassOf"
      ),
      map(() => this.findMembers(classUri)),
      startWith(this.findMembers(classUri)),
      distinctUntilChanged((prev2, curr) => prev2.length === curr.length)
    );
  }
  /**
   * Finds types of the given resource
   *
   * @param {string|NamedNode|BlankNode} uri String or RDF/JS object
   * @returns {string[]} An array of URIs of types
   */
  findTypes(uri6) {
    if (typeof uri6 === "string") uri6 = namedNode2(uri6);
    return Object.keys(this.internalStore.findTypeURIs(uri6));
  }
  /**
   * Determines whether the store includes a certain quad pattern, returning true or false as appropriate.
   *
   * @param {Quad_Subject|null|undefined} subject
   * @param {Quad_Predicate|null|undefined} predicate
   * @param {Quad_Object|null|undefined} object
   * @param {Quad_Graph|null|undefined} graph
   * @returns {boolean} Whether the store includes the quad pattern
   */
  holds(subject8, predicate4, object8, graph3) {
    return this.internalStore.holds(subject8, predicate4, object8, graph3);
  }
  /**
   * Statements matching the provided quad pattern
   *
   * @param {Quad_Subject|null|undefined} subject
   * @param {Quad_Predicate|null|undefined} predicate
   * @param {Quad_Object|null|undefined} object
   * @param {Quad_Graph|null|undefined} graph
   * @returns {Quad[]} Array of statements
   */
  statementsMatching(subject8, predicate4, object8, graph3) {
    return this.internalStore.statementsMatching(
      subject8,
      predicate4,
      object8,
      graph3
    );
  }
  /**
   * RDF/JS terms matching the first wildcard in the provided quad pattern
   *
   * @param {Quad_Subject|null|undefined} subject
   * @param {Quad_Predicate|null|undefined} predicate
   * @param {Quad_Object|null|undefined} object
   * @param {Quad_Graph|null|undefined} graph
   * @returns {Term[]} Array of terms
   */
  each(subject8, predicate4, object8, graph3) {
    const statements = this.statementsMatching(
      subject8,
      predicate4,
      object8,
      graph3
    );
    if (!subject8) {
      return statements.map((statement2) => statement2.subject);
    } else if (!predicate4) {
      return statements.map((statement2) => statement2.predicate);
    } else if (!object8) {
      return statements.map((statement2) => statement2.object);
    } else if (!graph3) {
      return statements.map((statement2) => statement2.graph);
    }
    throw new Error("No wildcard specified");
  }
  /**
   * Any one RDF/JS term matching the first wildcard in the provided quad pattern
   *
   * @param {Quad_Subject|null|undefined} subject
   * @param {Quad_Predicate|null|undefined} predicate
   * @param {Quad_Object|null|undefined} object
   * @param {Quad_Graph|null|undefined} graph
   * @returns {Term | null} RDF/JS term
   */
  any(subject8, predicate4, object8, graph3) {
    const justOne = true;
    const statements = this.internalStore.statementsMatching(
      subject8,
      predicate4,
      object8,
      graph3,
      justOne
    );
    if (statements.length === 0) return null;
    if (!subject8) {
      return statements[0].subject;
    } else if (!predicate4) {
      return statements[0].predicate;
    } else if (!object8) {
      return statements[0].object;
    } else if (!graph3) {
      return statements[0].graph;
    }
    throw new Error("No wildcard specified");
  }
  /**
   * Value of any one RDF/JS term matching the first wildcard in the provided quad pattern
   *
   * @param {Quad_Subject|null|undefined} subject
   * @param {Quad_Predicate|null|undefined} predicate
   * @param {Quad_Object|null|undefined} object
   * @param {Quad_Graph|null|undefined} graph
   * @returns {string | undefined} value of RDF/JS term
   */
  anyValue(subject8, predicate4, object8, graph3) {
    return this.any(subject8, predicate4, object8, graph3)?.value;
  }
  /**
     * Create a query to fetch information from a user's preferences file
     * 
     * @param webId 
     * @param preferencesDoc 
     * @returns {PreferencesQuery} PreferencesQuery instance. See [@solid-data-modules/rdflib-utils
  ](https://solid-contrib.github.io/data-modules/rdflib-utils/classes/index.PreferencesQuery.html)
     */
  preferencesQuery(webId, preferencesDoc) {
    if (typeof webId === "string") webId = namedNode2(webId);
    if (typeof preferencesDoc === "string")
      preferencesDoc = namedNode2(preferencesDoc);
    return new PreferencesQuery(this.internalStore, webId, preferencesDoc);
  }
  /**
     * Create a query to fetch information from a user's profile document
     * 
     * @param webId 
     * @returns {ProfileQuery} ProfileQuery instance. See [@solid-data-modules/rdflib-utils
  ](https://solid-contrib.github.io/data-modules/rdflib-utils/classes/index.ProfileQuery.html)
     */
  profileQuery(webId) {
    if (typeof webId === "string") webId = namedNode2(webId);
    return new ProfileQuery(webId, this.internalStore);
  }
};

// ../node_modules/rdf-namespaces/dist/index.es.js
var index_es_exports = {};
__export(index_es_exports, {
  acl: () => acl,
  arg: () => arg,
  as: () => as,
  bookmark: () => bookmark,
  cal: () => cal,
  contact: () => contact3,
  dc: () => dc,
  dct: () => dct,
  fhir: () => fhir,
  foaf: () => foaf,
  http: () => http,
  hydra: () => hydra,
  ldp: () => ldp2,
  link: () => link4,
  log: () => log2,
  meeting: () => meeting,
  owl: () => owl,
  prov: () => prov,
  qu: () => qu,
  rdf: () => rdf4,
  rdfs: () => rdfs2,
  sched: () => sched,
  schema: () => schema2,
  schema_https: () => schema_https,
  sec: () => sec,
  shacl: () => shacl,
  shex: () => shex,
  sioc: () => sioc,
  skos: () => skos,
  solid: () => solid2,
  space: () => space,
  tab: () => tab,
  tabont: () => tabont,
  trip: () => trip3,
  vcard: () => vcard,
  wf: () => wf,
  xsd: () => xsd3
});

// ../node_modules/rdf-namespaces/dist/acl-6c2719b4.js
var Access = "http://www.w3.org/ns/auth/acl#Access";
var Append = "http://www.w3.org/ns/auth/acl#Append";
var AuthenticatedAgent = "http://www.w3.org/ns/auth/acl#AuthenticatedAgent";
var Authorization = "http://www.w3.org/ns/auth/acl#Authorization";
var Control = "http://www.w3.org/ns/auth/acl#Control";
var Origin = "http://www.w3.org/ns/auth/acl#Origin";
var Read = "http://www.w3.org/ns/auth/acl#Read";
var Write = "http://www.w3.org/ns/auth/acl#Write";
var accessControl = "http://www.w3.org/ns/auth/acl#accessControl";
var accessTo = "http://www.w3.org/ns/auth/acl#accessTo";
var accessToClass = "http://www.w3.org/ns/auth/acl#accessToClass";
var agent = "http://www.w3.org/ns/auth/acl#agent";
var agentClass = "http://www.w3.org/ns/auth/acl#agentClass";
var agentGroup = "http://www.w3.org/ns/auth/acl#agentGroup";
var default__workaround = "http://www.w3.org/ns/auth/acl#default";
var defaultForNew = "http://www.w3.org/ns/auth/acl#defaultForNew";
var delegates = "http://www.w3.org/ns/auth/acl#delegates";
var mode = "http://www.w3.org/ns/auth/acl#mode";
var origin = "http://www.w3.org/ns/auth/acl#origin";
var owner = "http://www.w3.org/ns/auth/acl#owner";
var aclImport = /* @__PURE__ */ Object.freeze({
  Access,
  Append,
  AuthenticatedAgent,
  Authorization,
  Control,
  Origin,
  Read,
  Write,
  accessControl,
  accessTo,
  accessToClass,
  agent,
  agentClass,
  agentGroup,
  default__workaround,
  defaultForNew,
  delegates,
  mode,
  origin,
  owner
});

// ../node_modules/rdf-namespaces/dist/arg-7c8fcdfd.js
var Conjunction = "http://www.w3.org/ns/pim/arg#Conjunction";
var Position = "http://www.w3.org/ns/pim/arg#Position";
var Resolution = "http://www.w3.org/ns/pim/arg#Resolution";
var opposition = "http://www.w3.org/ns/pim/arg#opposition";
var requires = "http://www.w3.org/ns/pim/arg#requires";
var support = "http://www.w3.org/ns/pim/arg#support";
var argImport = /* @__PURE__ */ Object.freeze({
  Conjunction,
  Position,
  Resolution,
  opposition,
  requires,
  support
});

// ../node_modules/rdf-namespaces/dist/as-48207dab.js
var actor = "https://www.w3.org/ns/activitystreams#actor";
var attributedTo = "https://www.w3.org/ns/activitystreams#attributedTo";
var attachment = "https://www.w3.org/ns/activitystreams#attachment";
var attachments = "https://www.w3.org/ns/activitystreams#attachments";
var author = "https://www.w3.org/ns/activitystreams#author";
var bcc = "https://www.w3.org/ns/activitystreams#bcc";
var bto = "https://www.w3.org/ns/activitystreams#bto";
var cc = "https://www.w3.org/ns/activitystreams#cc";
var context2 = "https://www.w3.org/ns/activitystreams#context";
var current = "https://www.w3.org/ns/activitystreams#current";
var first = "https://www.w3.org/ns/activitystreams#first";
var generator = "https://www.w3.org/ns/activitystreams#generator";
var icon = "https://www.w3.org/ns/activitystreams#icon";
var image = "https://www.w3.org/ns/activitystreams#image";
var inReplyTo = "https://www.w3.org/ns/activitystreams#inReplyTo";
var items = "https://www.w3.org/ns/activitystreams#items";
var last2 = "https://www.w3.org/ns/activitystreams#last";
var location = "https://www.w3.org/ns/activitystreams#location";
var next = "https://www.w3.org/ns/activitystreams#next";
var object = "https://www.w3.org/ns/activitystreams#object";
var oneOf = "https://www.w3.org/ns/activitystreams#oneOf";
var anyOf = "https://www.w3.org/ns/activitystreams#anyOf";
var prev = "https://www.w3.org/ns/activitystreams#prev";
var preview = "https://www.w3.org/ns/activitystreams#preview";
var provider = "https://www.w3.org/ns/activitystreams#provider";
var replies = "https://www.w3.org/ns/activitystreams#replies";
var result = "https://www.w3.org/ns/activitystreams#result";
var audience = "https://www.w3.org/ns/activitystreams#audience";
var partOf = "https://www.w3.org/ns/activitystreams#partOf";
var tag = "https://www.w3.org/ns/activitystreams#tag";
var tags = "https://www.w3.org/ns/activitystreams#tags";
var target = "https://www.w3.org/ns/activitystreams#target";
var origin2 = "https://www.w3.org/ns/activitystreams#origin";
var instrument = "https://www.w3.org/ns/activitystreams#instrument";
var to = "https://www.w3.org/ns/activitystreams#to";
var url = "https://www.w3.org/ns/activitystreams#url";
var subject = "https://www.w3.org/ns/activitystreams#subject";
var relationship = "https://www.w3.org/ns/activitystreams#relationship";
var describes = "https://www.w3.org/ns/activitystreams#describes";
var formerType = "https://www.w3.org/ns/activitystreams#formerType";
var accuracy = "https://www.w3.org/ns/activitystreams#accuracy";
var altitude = "https://www.w3.org/ns/activitystreams#altitude";
var content = "https://www.w3.org/ns/activitystreams#content";
var name = "https://www.w3.org/ns/activitystreams#name";
var downstreamDuplicates = "https://www.w3.org/ns/activitystreams#downstreamDuplicates";
var duration = "https://www.w3.org/ns/activitystreams#duration";
var endTime = "https://www.w3.org/ns/activitystreams#endTime";
var height = "https://www.w3.org/ns/activitystreams#height";
var href = "https://www.w3.org/ns/activitystreams#href";
var hreflang = "https://www.w3.org/ns/activitystreams#hreflang";
var id = "https://www.w3.org/ns/activitystreams#id";
var latitude = "https://www.w3.org/ns/activitystreams#latitude";
var longitude = "https://www.w3.org/ns/activitystreams#longitude";
var mediaType = "https://www.w3.org/ns/activitystreams#mediaType";
var objectType = "https://www.w3.org/ns/activitystreams#objectType";
var published = "https://www.w3.org/ns/activitystreams#published";
var radius = "https://www.w3.org/ns/activitystreams#radius";
var rating = "https://www.w3.org/ns/activitystreams#rating";
var rel = "https://www.w3.org/ns/activitystreams#rel";
var startIndex = "https://www.w3.org/ns/activitystreams#startIndex";
var startTime = "https://www.w3.org/ns/activitystreams#startTime";
var summary = "https://www.w3.org/ns/activitystreams#summary";
var totalItems = "https://www.w3.org/ns/activitystreams#totalItems";
var units = "https://www.w3.org/ns/activitystreams#units";
var updated = "https://www.w3.org/ns/activitystreams#updated";
var upstreamDuplicates = "https://www.w3.org/ns/activitystreams#upstreamDuplicates";
var verb = "https://www.w3.org/ns/activitystreams#verb";
var width = "https://www.w3.org/ns/activitystreams#width";
var deleted = "https://www.w3.org/ns/activitystreams#deleted";
var Accept = "https://www.w3.org/ns/activitystreams#Accept";
var Activity = "https://www.w3.org/ns/activitystreams#Activity";
var Block = "https://www.w3.org/ns/activitystreams#Block";
var IntransitiveActivity = "https://www.w3.org/ns/activitystreams#IntransitiveActivity";
var Add = "https://www.w3.org/ns/activitystreams#Add";
var Announce = "https://www.w3.org/ns/activitystreams#Announce";
var Application = "https://www.w3.org/ns/activitystreams#Application";
var Arrive = "https://www.w3.org/ns/activitystreams#Arrive";
var Article = "https://www.w3.org/ns/activitystreams#Article";
var Audio = "https://www.w3.org/ns/activitystreams#Audio";
var Collection2 = "https://www.w3.org/ns/activitystreams#Collection";
var CollectionPage = "https://www.w3.org/ns/activitystreams#CollectionPage";
var OrderedCollectionPage = "https://www.w3.org/ns/activitystreams#OrderedCollectionPage";
var Relationship = "https://www.w3.org/ns/activitystreams#Relationship";
var Create = "https://www.w3.org/ns/activitystreams#Create";
var Delete = "https://www.w3.org/ns/activitystreams#Delete";
var Dislike = "https://www.w3.org/ns/activitystreams#Dislike";
var Document = "https://www.w3.org/ns/activitystreams#Document";
var Event = "https://www.w3.org/ns/activitystreams#Event";
var Flag = "https://www.w3.org/ns/activitystreams#Flag";
var Follow = "https://www.w3.org/ns/activitystreams#Follow";
var Group = "https://www.w3.org/ns/activitystreams#Group";
var Ignore = "https://www.w3.org/ns/activitystreams#Ignore";
var Image = "https://www.w3.org/ns/activitystreams#Image";
var Invite = "https://www.w3.org/ns/activitystreams#Invite";
var Join = "https://www.w3.org/ns/activitystreams#Join";
var Leave = "https://www.w3.org/ns/activitystreams#Leave";
var Like = "https://www.w3.org/ns/activitystreams#Like";
var View = "https://www.w3.org/ns/activitystreams#View";
var Listen = "https://www.w3.org/ns/activitystreams#Listen";
var Read2 = "https://www.w3.org/ns/activitystreams#Read";
var Move = "https://www.w3.org/ns/activitystreams#Move";
var Travel = "https://www.w3.org/ns/activitystreams#Travel";
var Link = "https://www.w3.org/ns/activitystreams#Link";
var Mention = "https://www.w3.org/ns/activitystreams#Mention";
var Note = "https://www.w3.org/ns/activitystreams#Note";
var Object__workaround = "https://www.w3.org/ns/activitystreams#Object";
var Offer = "https://www.w3.org/ns/activitystreams#Offer";
var OrderedCollection = "https://www.w3.org/ns/activitystreams#OrderedCollection";
var OrderedItems = "https://www.w3.org/ns/activitystreams#OrderedItems";
var Page = "https://www.w3.org/ns/activitystreams#Page";
var Person = "https://www.w3.org/ns/activitystreams#Person";
var Organization = "https://www.w3.org/ns/activitystreams#Organization";
var Profile = "https://www.w3.org/ns/activitystreams#Profile";
var Place = "https://www.w3.org/ns/activitystreams#Place";
var Question = "https://www.w3.org/ns/activitystreams#Question";
var Reject = "https://www.w3.org/ns/activitystreams#Reject";
var Remove = "https://www.w3.org/ns/activitystreams#Remove";
var Service = "https://www.w3.org/ns/activitystreams#Service";
var TentativeAccept = "https://www.w3.org/ns/activitystreams#TentativeAccept";
var TentativeReject = "https://www.w3.org/ns/activitystreams#TentativeReject";
var Tombstone = "https://www.w3.org/ns/activitystreams#Tombstone";
var Undo = "https://www.w3.org/ns/activitystreams#Undo";
var Update = "https://www.w3.org/ns/activitystreams#Update";
var Video = "https://www.w3.org/ns/activitystreams#Video";
var asImport = /* @__PURE__ */ Object.freeze({
  actor,
  attributedTo,
  attachment,
  attachments,
  author,
  bcc,
  bto,
  cc,
  context: context2,
  current,
  first,
  generator,
  icon,
  image,
  inReplyTo,
  items,
  last: last2,
  location,
  next,
  object,
  oneOf,
  anyOf,
  prev,
  preview,
  provider,
  replies,
  result,
  audience,
  partOf,
  tag,
  tags,
  target,
  origin: origin2,
  instrument,
  to,
  url,
  subject,
  relationship,
  describes,
  formerType,
  accuracy,
  altitude,
  content,
  name,
  downstreamDuplicates,
  duration,
  endTime,
  height,
  href,
  hreflang,
  id,
  latitude,
  longitude,
  mediaType,
  objectType,
  published,
  radius,
  rating,
  rel,
  startIndex,
  startTime,
  summary,
  totalItems,
  units,
  updated,
  upstreamDuplicates,
  verb,
  width,
  deleted,
  Accept,
  Activity,
  Block,
  IntransitiveActivity,
  Add,
  Announce,
  Application,
  Arrive,
  Article,
  Audio,
  Collection: Collection2,
  CollectionPage,
  OrderedCollectionPage,
  Relationship,
  Create,
  Delete,
  Dislike,
  Document,
  Event,
  Flag,
  Follow,
  Group,
  Ignore,
  Image,
  Invite,
  Join,
  Leave,
  Like,
  View,
  Listen,
  Read: Read2,
  Move,
  Travel,
  Link,
  Mention,
  Note,
  Object__workaround,
  Offer,
  OrderedCollection,
  OrderedItems,
  Page,
  Person,
  Organization,
  Profile,
  Place,
  Question,
  Reject,
  Remove,
  Service,
  TentativeAccept,
  TentativeReject,
  Tombstone,
  Undo,
  Update,
  Video
});

// ../node_modules/rdf-namespaces/dist/bookmark-7c2b6a42.js
var hasTopic = "http://www.w3.org/2002/01/bookmark#hasTopic";
var leadsTo = "http://www.w3.org/2002/01/bookmark#leadsTo";
var Topic = "http://www.w3.org/2002/01/bookmark#Topic";
var Shortcut = "http://www.w3.org/2002/01/bookmark#Shortcut";
var bookmarks = "http://www.w3.org/2002/01/bookmark#bookmarks";
var recalls = "http://www.w3.org/2002/01/bookmark#recalls";
var subTopicOf = "http://www.w3.org/2002/01/bookmark#subTopicOf";
var Bookmark = "http://www.w3.org/2002/01/bookmark#Bookmark";
var bookmarkImport = /* @__PURE__ */ Object.freeze({
  hasTopic,
  leadsTo,
  Topic,
  Shortcut,
  bookmarks,
  recalls,
  subTopicOf,
  Bookmark
});

// ../node_modules/rdf-namespaces/dist/cal-a0992050.js
var Vevent = "http://www.w3.org/2002/12/cal/ical#Vevent";
var Vtodo = "http://www.w3.org/2002/12/cal/ical#Vtodo";
var Vjournal = "http://www.w3.org/2002/12/cal/ical#Vjournal";
var Vfreebusy = "http://www.w3.org/2002/12/cal/ical#Vfreebusy";
var Vtimezone = "http://www.w3.org/2002/12/cal/ical#Vtimezone";
var Valarm = "http://www.w3.org/2002/12/cal/ical#Valarm";
var calscale = "http://www.w3.org/2002/12/cal/ical#calscale";
var method = "http://www.w3.org/2002/12/cal/ical#method";
var prodid = "http://www.w3.org/2002/12/cal/ical#prodid";
var version = "http://www.w3.org/2002/12/cal/ical#version";
var attach = "http://www.w3.org/2002/12/cal/ical#attach";
var categories = "http://www.w3.org/2002/12/cal/ical#categories";
var class__workaround = "http://www.w3.org/2002/12/cal/ical#class";
var comment = "http://www.w3.org/2002/12/cal/ical#comment";
var description = "http://www.w3.org/2002/12/cal/ical#description";
var geo = "http://www.w3.org/2002/12/cal/ical#geo";
var List_of_Float = "http://www.w3.org/2002/12/cal/ical#List_of_Float";
var location2 = "http://www.w3.org/2002/12/cal/ical#location";
var percentComplete = "http://www.w3.org/2002/12/cal/ical#percentComplete";
var priority = "http://www.w3.org/2002/12/cal/ical#priority";
var resources = "http://www.w3.org/2002/12/cal/ical#resources";
var status = "http://www.w3.org/2002/12/cal/ical#status";
var summary2 = "http://www.w3.org/2002/12/cal/ical#summary";
var completed = "http://www.w3.org/2002/12/cal/ical#completed";
var dtend = "http://www.w3.org/2002/12/cal/ical#dtend";
var Value_DATE = "http://www.w3.org/2002/12/cal/ical#Value_DATE";
var due = "http://www.w3.org/2002/12/cal/ical#due";
var dtstart = "http://www.w3.org/2002/12/cal/ical#dtstart";
var duration2 = "http://www.w3.org/2002/12/cal/ical#duration";
var Value_DURATION = "http://www.w3.org/2002/12/cal/ical#Value_DURATION";
var freebusy = "http://www.w3.org/2002/12/cal/ical#freebusy";
var Value_PERIOD = "http://www.w3.org/2002/12/cal/ical#Value_PERIOD";
var transp = "http://www.w3.org/2002/12/cal/ical#transp";
var tzid = "http://www.w3.org/2002/12/cal/ical#tzid";
var tzname = "http://www.w3.org/2002/12/cal/ical#tzname";
var tzoffsetfrom = "http://www.w3.org/2002/12/cal/ical#tzoffsetfrom";
var tzoffsetto = "http://www.w3.org/2002/12/cal/ical#tzoffsetto";
var tzurl = "http://www.w3.org/2002/12/cal/ical#tzurl";
var attendee = "http://www.w3.org/2002/12/cal/ical#attendee";
var contact = "http://www.w3.org/2002/12/cal/ical#contact";
var organizer = "http://www.w3.org/2002/12/cal/ical#organizer";
var recurrenceId = "http://www.w3.org/2002/12/cal/ical#recurrenceId";
var DomainOf_rrule = "http://www.w3.org/2002/12/cal/ical#DomainOf_rrule";
var relatedTo = "http://www.w3.org/2002/12/cal/ical#relatedTo";
var url2 = "http://www.w3.org/2002/12/cal/ical#url";
var uid2 = "http://www.w3.org/2002/12/cal/ical#uid";
var exdate = "http://www.w3.org/2002/12/cal/ical#exdate";
var exrule = "http://www.w3.org/2002/12/cal/ical#exrule";
var Value_RECUR = "http://www.w3.org/2002/12/cal/ical#Value_RECUR";
var rdate = "http://www.w3.org/2002/12/cal/ical#rdate";
var rrule = "http://www.w3.org/2002/12/cal/ical#rrule";
var action = "http://www.w3.org/2002/12/cal/ical#action";
var repeat = "http://www.w3.org/2002/12/cal/ical#repeat";
var trigger = "http://www.w3.org/2002/12/cal/ical#trigger";
var created = "http://www.w3.org/2002/12/cal/ical#created";
var dtstamp = "http://www.w3.org/2002/12/cal/ical#dtstamp";
var lastModified = "http://www.w3.org/2002/12/cal/ical#lastModified";
var sequence = "http://www.w3.org/2002/12/cal/ical#sequence";
var requestStatus = "http://www.w3.org/2002/12/cal/ical#requestStatus";
var calImport = /* @__PURE__ */ Object.freeze({
  Vevent,
  Vtodo,
  Vjournal,
  Vfreebusy,
  Vtimezone,
  Valarm,
  calscale,
  method,
  prodid,
  version,
  attach,
  categories,
  class__workaround,
  comment,
  description,
  geo,
  List_of_Float,
  location: location2,
  percentComplete,
  priority,
  resources,
  status,
  summary: summary2,
  completed,
  dtend,
  Value_DATE,
  due,
  dtstart,
  duration: duration2,
  Value_DURATION,
  freebusy,
  Value_PERIOD,
  transp,
  tzid,
  tzname,
  tzoffsetfrom,
  tzoffsetto,
  tzurl,
  attendee,
  contact,
  organizer,
  recurrenceId,
  DomainOf_rrule,
  relatedTo,
  url: url2,
  uid: uid2,
  exdate,
  exrule,
  Value_RECUR,
  rdate,
  rrule,
  action,
  repeat,
  trigger,
  created,
  dtstamp,
  lastModified,
  sequence,
  requestStatus
});

// ../node_modules/rdf-namespaces/dist/contact-aea98523.js
var Address = "http://www.w3.org/2000/10/swap/pim/contact#Address";
var ContactLocation = "http://www.w3.org/2000/10/swap/pim/contact#ContactLocation";
var Female = "http://www.w3.org/2000/10/swap/pim/contact#Female";
var LanguageCode = "http://www.w3.org/2000/10/swap/pim/contact#LanguageCode";
var Male = "http://www.w3.org/2000/10/swap/pim/contact#Male";
var Phone = "http://www.w3.org/2000/10/swap/pim/contact#Phone";
var SocialEntity = "http://www.w3.org/2000/10/swap/pim/contact#SocialEntity";
var _addressProperty = "http://www.w3.org/2000/10/swap/pim/contact#_addressProperty";
var address = "http://www.w3.org/2000/10/swap/pim/contact#address";
var assistant = "http://www.w3.org/2000/10/swap/pim/contact#assistant";
var birthday = "http://www.w3.org/2000/10/swap/pim/contact#birthday";
var child = "http://www.w3.org/2000/10/swap/pim/contact#child";
var description2 = "http://www.w3.org/2000/10/swap/pim/contact#description";
var emergency = "http://www.w3.org/2000/10/swap/pim/contact#emergency";
var fax = "http://www.w3.org/2000/10/swap/pim/contact#fax";
var fullName = "http://www.w3.org/2000/10/swap/pim/contact#fullName";
var home = "http://www.w3.org/2000/10/swap/pim/contact#home";
var knownAs = "http://www.w3.org/2000/10/swap/pim/contact#knownAs";
var mobile = "http://www.w3.org/2000/10/swap/pim/contact#mobile";
var motherTongue = "http://www.w3.org/2000/10/swap/pim/contact#motherTongue";
var nearestAirport = "http://www.w3.org/2000/10/swap/pim/contact#nearestAirport";
var office = "http://www.w3.org/2000/10/swap/pim/contact#office";
var participant = "http://www.w3.org/2000/10/swap/pim/contact#participant";
var partner = "http://www.w3.org/2000/10/swap/pim/contact#partner";
var phone = "http://www.w3.org/2000/10/swap/pim/contact#phone";
var preferredURI = "http://www.w3.org/2000/10/swap/pim/contact#preferredURI";
var region = "http://www.w3.org/2000/10/swap/pim/contact#region";
var sortName = "http://www.w3.org/2000/10/swap/pim/contact#sortName";
var vacationHome = "http://www.w3.org/2000/10/swap/pim/contact#vacationHome";
var webPage = "http://www.w3.org/2000/10/swap/pim/contact#webPage";
var contactImport = /* @__PURE__ */ Object.freeze({
  Address,
  ContactLocation,
  Female,
  LanguageCode,
  Male,
  Phone,
  SocialEntity,
  _addressProperty,
  address,
  assistant,
  birthday,
  child,
  description: description2,
  emergency,
  fax,
  fullName,
  home,
  knownAs,
  mobile,
  motherTongue,
  nearestAirport,
  office,
  participant,
  partner,
  phone,
  preferredURI,
  region,
  sortName,
  vacationHome,
  webPage
});

// ../node_modules/rdf-namespaces/dist/dc-36376a75.js
var contributor = "http://purl.org/dc/elements/1.1/contributor";
var coverage = "http://purl.org/dc/elements/1.1/coverage";
var creator = "http://purl.org/dc/elements/1.1/creator";
var date = "http://purl.org/dc/elements/1.1/date";
var description3 = "http://purl.org/dc/elements/1.1/description";
var format = "http://purl.org/dc/elements/1.1/format";
var identifier = "http://purl.org/dc/elements/1.1/identifier";
var language = "http://purl.org/dc/elements/1.1/language";
var publisher = "http://purl.org/dc/elements/1.1/publisher";
var relation = "http://purl.org/dc/elements/1.1/relation";
var rights = "http://purl.org/dc/elements/1.1/rights";
var source = "http://purl.org/dc/elements/1.1/source";
var subject2 = "http://purl.org/dc/elements/1.1/subject";
var title = "http://purl.org/dc/elements/1.1/title";
var type = "http://purl.org/dc/elements/1.1/type";
var dcImport = /* @__PURE__ */ Object.freeze({
  contributor,
  coverage,
  creator,
  date,
  description: description3,
  format,
  identifier,
  language,
  publisher,
  relation,
  rights,
  source,
  subject: subject2,
  title,
  type
});

// ../node_modules/rdf-namespaces/dist/dct-00f7660b.js
var Agent = "http://purl.org/dc/terms/Agent";
var AgentClass = "http://purl.org/dc/terms/AgentClass";
var BibliographicResource = "http://purl.org/dc/terms/BibliographicResource";
var Box = "http://purl.org/dc/terms/Box";
var FileFormat = "http://purl.org/dc/terms/FileFormat";
var Frequency = "http://purl.org/dc/terms/Frequency";
var ISO3166 = "http://purl.org/dc/terms/ISO3166";
var Jurisdiction = "http://purl.org/dc/terms/Jurisdiction";
var LicenseDocument = "http://purl.org/dc/terms/LicenseDocument";
var LinguisticSystem = "http://purl.org/dc/terms/LinguisticSystem";
var Location = "http://purl.org/dc/terms/Location";
var LocationPeriodOrJurisdiction = "http://purl.org/dc/terms/LocationPeriodOrJurisdiction";
var MediaType = "http://purl.org/dc/terms/MediaType";
var MediaTypeOrExtent = "http://purl.org/dc/terms/MediaTypeOrExtent";
var MethodOfAccrual = "http://purl.org/dc/terms/MethodOfAccrual";
var MethodOfInstruction = "http://purl.org/dc/terms/MethodOfInstruction";
var Period = "http://purl.org/dc/terms/Period";
var PeriodOfTime = "http://purl.org/dc/terms/PeriodOfTime";
var PhysicalMedium = "http://purl.org/dc/terms/PhysicalMedium";
var PhysicalResource = "http://purl.org/dc/terms/PhysicalResource";
var Point = "http://purl.org/dc/terms/Point";
var Policy = "http://purl.org/dc/terms/Policy";
var ProvenanceStatement = "http://purl.org/dc/terms/ProvenanceStatement";
var RFC1766 = "http://purl.org/dc/terms/RFC1766";
var RFC3066 = "http://purl.org/dc/terms/RFC3066";
var RFC4646 = "http://purl.org/dc/terms/RFC4646";
var RFC5646 = "http://purl.org/dc/terms/RFC5646";
var RightsStatement = "http://purl.org/dc/terms/RightsStatement";
var SizeOrDuration = "http://purl.org/dc/terms/SizeOrDuration";
var Standard = "http://purl.org/dc/terms/Standard";
var URI = "http://purl.org/dc/terms/URI";
var W3CDTF = "http://purl.org/dc/terms/W3CDTF";
var abstract = "http://purl.org/dc/terms/abstract";
var accessRights = "http://purl.org/dc/terms/accessRights";
var accrualMethod = "http://purl.org/dc/terms/accrualMethod";
var accrualPeriodicity = "http://purl.org/dc/terms/accrualPeriodicity";
var accrualPolicy = "http://purl.org/dc/terms/accrualPolicy";
var alternative = "http://purl.org/dc/terms/alternative";
var audience2 = "http://purl.org/dc/terms/audience";
var available = "http://purl.org/dc/terms/available";
var bibliographicCitation = "http://purl.org/dc/terms/bibliographicCitation";
var conformsTo = "http://purl.org/dc/terms/conformsTo";
var contributor2 = "http://purl.org/dc/terms/contributor";
var coverage2 = "http://purl.org/dc/terms/coverage";
var created2 = "http://purl.org/dc/terms/created";
var creator2 = "http://purl.org/dc/terms/creator";
var date2 = "http://purl.org/dc/terms/date";
var dateAccepted = "http://purl.org/dc/terms/dateAccepted";
var dateCopyrighted = "http://purl.org/dc/terms/dateCopyrighted";
var dateSubmitted = "http://purl.org/dc/terms/dateSubmitted";
var description4 = "http://purl.org/dc/terms/description";
var educationLevel = "http://purl.org/dc/terms/educationLevel";
var extent = "http://purl.org/dc/terms/extent";
var format2 = "http://purl.org/dc/terms/format";
var hasFormat = "http://purl.org/dc/terms/hasFormat";
var hasPart = "http://purl.org/dc/terms/hasPart";
var hasVersion = "http://purl.org/dc/terms/hasVersion";
var identifier2 = "http://purl.org/dc/terms/identifier";
var instructionalMethod = "http://purl.org/dc/terms/instructionalMethod";
var isFormatOf = "http://purl.org/dc/terms/isFormatOf";
var isPartOf = "http://purl.org/dc/terms/isPartOf";
var isReferencedBy = "http://purl.org/dc/terms/isReferencedBy";
var isReplacedBy = "http://purl.org/dc/terms/isReplacedBy";
var isRequiredBy = "http://purl.org/dc/terms/isRequiredBy";
var isVersionOf = "http://purl.org/dc/terms/isVersionOf";
var issued = "http://purl.org/dc/terms/issued";
var language2 = "http://purl.org/dc/terms/language";
var license = "http://purl.org/dc/terms/license";
var mediator = "http://purl.org/dc/terms/mediator";
var medium = "http://purl.org/dc/terms/medium";
var modified = "http://purl.org/dc/terms/modified";
var provenance = "http://purl.org/dc/terms/provenance";
var publisher2 = "http://purl.org/dc/terms/publisher";
var references = "http://purl.org/dc/terms/references";
var relation2 = "http://purl.org/dc/terms/relation";
var replaces = "http://purl.org/dc/terms/replaces";
var requires2 = "http://purl.org/dc/terms/requires";
var rights2 = "http://purl.org/dc/terms/rights";
var rightsHolder = "http://purl.org/dc/terms/rightsHolder";
var source2 = "http://purl.org/dc/terms/source";
var spatial = "http://purl.org/dc/terms/spatial";
var subject3 = "http://purl.org/dc/terms/subject";
var tableOfContents = "http://purl.org/dc/terms/tableOfContents";
var temporal = "http://purl.org/dc/terms/temporal";
var title2 = "http://purl.org/dc/terms/title";
var type2 = "http://purl.org/dc/terms/type";
var valid = "http://purl.org/dc/terms/valid";
var dctImport = /* @__PURE__ */ Object.freeze({
  Agent,
  AgentClass,
  BibliographicResource,
  Box,
  FileFormat,
  Frequency,
  ISO3166,
  Jurisdiction,
  LicenseDocument,
  LinguisticSystem,
  Location,
  LocationPeriodOrJurisdiction,
  MediaType,
  MediaTypeOrExtent,
  MethodOfAccrual,
  MethodOfInstruction,
  Period,
  PeriodOfTime,
  PhysicalMedium,
  PhysicalResource,
  Point,
  Policy,
  ProvenanceStatement,
  RFC1766,
  RFC3066,
  RFC4646,
  RFC5646,
  RightsStatement,
  SizeOrDuration,
  Standard,
  URI,
  W3CDTF,
  abstract,
  accessRights,
  accrualMethod,
  accrualPeriodicity,
  accrualPolicy,
  alternative,
  audience: audience2,
  available,
  bibliographicCitation,
  conformsTo,
  contributor: contributor2,
  coverage: coverage2,
  created: created2,
  creator: creator2,
  date: date2,
  dateAccepted,
  dateCopyrighted,
  dateSubmitted,
  description: description4,
  educationLevel,
  extent,
  format: format2,
  hasFormat,
  hasPart,
  hasVersion,
  identifier: identifier2,
  instructionalMethod,
  isFormatOf,
  isPartOf,
  isReferencedBy,
  isReplacedBy,
  isRequiredBy,
  isVersionOf,
  issued,
  language: language2,
  license,
  mediator,
  medium,
  modified,
  provenance,
  publisher: publisher2,
  references,
  relation: relation2,
  replaces,
  requires: requires2,
  rights: rights2,
  rightsHolder,
  source: source2,
  spatial,
  subject: subject3,
  tableOfContents,
  temporal,
  title: title2,
  type: type2,
  valid
});

// ../node_modules/rdf-namespaces/dist/fhir-09bb1d53.js
var constituent = "http://hl7.org/fhir/constituent";
var _careTeam = "http://hl7.org/fhir/_careTeam";
var ClinicalUseDefinitionWarningComponent = "http://hl7.org/fhir/ClinicalUseDefinitionWarningComponent";
var PlanDefinitionActionParticipantComponent = "http://hl7.org/fhir/PlanDefinitionActionParticipantComponent";
var VisionPrescriptionLensSpecificationComponent = "http://hl7.org/fhir/VisionPrescriptionLensSpecificationComponent";
var _answerOption = "http://hl7.org/fhir/_answerOption";
var decimal = "http://hl7.org/fhir/decimal";
var _applies = "http://hl7.org/fhir/_applies";
var serviceProvider = "http://hl7.org/fhir/serviceProvider";
var NutritionProductIngredientComponent = "http://hl7.org/fhir/NutritionProductIngredientComponent";
var Error__workaround = "http://hl7.org/fhir/Error";
var productStatus = "http://hl7.org/fhir/productStatus";
var ImagingStudySeriesPerformerComponent = "http://hl7.org/fhir/ImagingStudySeriesPerformerComponent";
var _lowerLimit = "http://hl7.org/fhir/_lowerLimit";
var Medication = "http://hl7.org/fhir/Medication";
var header = "http://hl7.org/fhir/header";
var StructureMapGroupRuleComponent = "http://hl7.org/fhir/StructureMapGroupRuleComponent";
var _productType = "http://hl7.org/fhir/_productType";
var _relatedItem = "http://hl7.org/fhir/_relatedItem";
var author2 = "http://hl7.org/fhir/author";
var _direction = "http://hl7.org/fhir/_direction";
var _frequencyOfOccurrence = "http://hl7.org/fhir/_frequencyOfOccurrence";
var RequestOrchestration = "http://hl7.org/fhir/RequestOrchestration";
var Detail = "http://hl7.org/fhir/Detail";
var numberOfRepeatsAllowed = "http://hl7.org/fhir/numberOfRepeatsAllowed";
var _communicationRequest = "http://hl7.org/fhir/_communicationRequest";
var DocumentReferenceContentProfileComponent = "http://hl7.org/fhir/DocumentReferenceContentProfileComponent";
var _masterFile = "http://hl7.org/fhir/_masterFile";
var comment2 = "http://hl7.org/fhir/comment";
var availableTime = "http://hl7.org/fhir/availableTime";
var _assert = "http://hl7.org/fhir/_assert";
var listRuleId = "http://hl7.org/fhir/listRuleId";
var preAdmissionIdentifier = "http://hl7.org/fhir/preAdmissionIdentifier";
var participantType = "http://hl7.org/fhir/participantType";
var _related = "http://hl7.org/fhir/_related";
var SupplementSchedule = "http://hl7.org/fhir/SupplementSchedule";
var reAdmission = "http://hl7.org/fhir/reAdmission";
var _requestURL = "http://hl7.org/fhir/_requestURL";
var _caseSensitive = "http://hl7.org/fhir/_caseSensitive";
var _chargeItem = "http://hl7.org/fhir/_chargeItem";
var _withdrawalPeriod = "http://hl7.org/fhir/_withdrawalPeriod";
var CapabilityStatementImplementationComponent = "http://hl7.org/fhir/CapabilityStatementImplementationComponent";
var analysis = "http://hl7.org/fhir/analysis";
var monitoringProgram = "http://hl7.org/fhir/monitoringProgram";
var _date = "http://hl7.org/fhir/_date";
var satisfiedBy = "http://hl7.org/fhir/satisfiedBy";
var artifact = "http://hl7.org/fhir/artifact";
var timing = "http://hl7.org/fhir/timing";
var appliesToAll = "http://hl7.org/fhir/appliesToAll";
var _appointmentRequired = "http://hl7.org/fhir/_appointmentRequired";
var _canFilterBy = "http://hl7.org/fhir/_canFilterBy";
var filter2 = "http://hl7.org/fhir/filter";
var _targetNumber = "http://hl7.org/fhir/_targetNumber";
var _additive = "http://hl7.org/fhir/_additive";
var _management = "http://hl7.org/fhir/_management";
var _phylum = "http://hl7.org/fhir/_phylum";
var _distributor = "http://hl7.org/fhir/_distributor";
var _clinicalRecommendationStatement = "http://hl7.org/fhir/_clinicalRecommendationStatement";
var _manifest = "http://hl7.org/fhir/_manifest";
var cancellationDate = "http://hl7.org/fhir/cancellationDate";
var _doseQuantity = "http://hl7.org/fhir/_doseQuantity";
var DeviceDefinitionPackagingComponentUdiDeviceIdentifier = "http://hl7.org/fhir/DeviceDefinitionPackagingComponentUdiDeviceIdentifier";
var VerificationResult = "http://hl7.org/fhir/VerificationResult";
var preference = "http://hl7.org/fhir/preference";
var _asserter = "http://hl7.org/fhir/_asserter";
var _regulatoryIdentifier = "http://hl7.org/fhir/_regulatoryIdentifier";
var molecularFormula = "http://hl7.org/fhir/molecularFormula";
var isActive = "http://hl7.org/fhir/isActive";
var dispenserInstruction = "http://hl7.org/fhir/dispenserInstruction";
var MedicationKnowledgeRelatedMedicationKnowledgeComponent = "http://hl7.org/fhir/MedicationKnowledgeRelatedMedicationKnowledgeComponent";
var CapabilityStatementRestSecurityComponent = "http://hl7.org/fhir/CapabilityStatementRestSecurityComponent";
var initialSelected = "http://hl7.org/fhir/initialSelected";
var _preventiveAction = "http://hl7.org/fhir/_preventiveAction";
var DeviceDefinitionConformsToComponent = "http://hl7.org/fhir/DeviceDefinitionConformsToComponent";
var _MedicationStatement = "http://hl7.org/fhir/_MedicationStatement";
var _availableStartTime = "http://hl7.org/fhir/_availableStartTime";
var validationType = "http://hl7.org/fhir/validationType";
var _axis = "http://hl7.org/fhir/_axis";
var _serialNumber = "http://hl7.org/fhir/_serialNumber";
var Narrative = "http://hl7.org/fhir/Narrative";
var _dependency = "http://hl7.org/fhir/_dependency";
var endDate = "http://hl7.org/fhir/endDate";
var _prognosisReference = "http://hl7.org/fhir/_prognosisReference";
var _recruitment = "http://hl7.org/fhir/_recruitment";
var searchParam = "http://hl7.org/fhir/searchParam";
var _usageInstruction = "http://hl7.org/fhir/_usageInstruction";
var _generation = "http://hl7.org/fhir/_generation";
var artifactAssessment = "http://hl7.org/fhir/artifactAssessment";
var complete = "http://hl7.org/fhir/complete";
var _dependent = "http://hl7.org/fhir/_dependent";
var _due = "http://hl7.org/fhir/_due";
var _replaces = "http://hl7.org/fhir/_replaces";
var EvidenceStatisticModelCharacteristicComponent = "http://hl7.org/fhir/EvidenceStatisticModelCharacteristicComponent";
var _friday = "http://hl7.org/fhir/_friday";
var orderedBy = "http://hl7.org/fhir/orderedBy";
var _modality = "http://hl7.org/fhir/_modality";
var expirationType = "http://hl7.org/fhir/expirationType";
var party = "http://hl7.org/fhir/party";
var _objective = "http://hl7.org/fhir/_objective";
var _totalNet = "http://hl7.org/fhir/_totalNet";
var _adherence = "http://hl7.org/fhir/_adherence";
var _cardinalityBehavior = "http://hl7.org/fhir/_cardinalityBehavior";
var startDate = "http://hl7.org/fhir/startDate";
var basis = "http://hl7.org/fhir/basis";
var _minutesDuration = "http://hl7.org/fhir/_minutesDuration";
var instruction = "http://hl7.org/fhir/instruction";
var _targetDisease = "http://hl7.org/fhir/_targetDisease";
var eventTrigger = "http://hl7.org/fhir/eventTrigger";
var closure = "http://hl7.org/fhir/closure";
var numberOfParticipants = "http://hl7.org/fhir/numberOfParticipants";
var businessArrangement = "http://hl7.org/fhir/businessArrangement";
var requesterLinkId = "http://hl7.org/fhir/requesterLinkId";
var _programEligibility = "http://hl7.org/fhir/_programEligibility";
var _average = "http://hl7.org/fhir/_average";
var proxySignature = "http://hl7.org/fhir/proxySignature";
var _assessmentMethod = "http://hl7.org/fhir/_assessmentMethod";
var _series = "http://hl7.org/fhir/_series";
var _performingOrganization = "http://hl7.org/fhir/_performingOrganization";
var frames = "http://hl7.org/fhir/frames";
var _paternalOrganismName = "http://hl7.org/fhir/_paternalOrganismName";
var inputProfile = "http://hl7.org/fhir/inputProfile";
var _guarantor = "http://hl7.org/fhir/_guarantor";
var _human = "http://hl7.org/fhir/_human";
var NutritionProductCharacteristicComponent = "http://hl7.org/fhir/NutritionProductCharacteristicComponent";
var _orderDetail = "http://hl7.org/fhir/_orderDetail";
var maxParticipants = "http://hl7.org/fhir/maxParticipants";
var ClinicalUseDefinitionUndesirableEffectComponent = "http://hl7.org/fhir/ClinicalUseDefinitionUndesirableEffectComponent";
var _observed = "http://hl7.org/fhir/_observed";
var validityPeriod = "http://hl7.org/fhir/validityPeriod";
var ComputableLanguage = "http://hl7.org/fhir/ComputableLanguage";
var surfaceOrientation = "http://hl7.org/fhir/surfaceOrientation";
var _Provenance = "http://hl7.org/fhir/_Provenance";
var testRun = "http://hl7.org/fhir/testRun";
var SubstanceProtein = "http://hl7.org/fhir/SubstanceProtein";
var _focalDevice = "http://hl7.org/fhir/_focalDevice";
var _operationType = "http://hl7.org/fhir/_operationType";
var context3 = "http://hl7.org/fhir/context";
var occurrenceDateTime = "http://hl7.org/fhir/occurrenceDateTime";
var DetectedIssueEvidenceComponent = "http://hl7.org/fhir/DetectedIssueEvidenceComponent";
var _ExplanationOfBenefit = "http://hl7.org/fhir/_ExplanationOfBenefit";
var validated = "http://hl7.org/fhir/validated";
var _subunit = "http://hl7.org/fhir/_subunit";
var EvidenceStatisticAttributeEstimateComponent = "http://hl7.org/fhir/EvidenceStatisticAttributeEstimateComponent";
var replacedSequence = "http://hl7.org/fhir/replacedSequence";
var specimen = "http://hl7.org/fhir/specimen";
var rater = "http://hl7.org/fhir/rater";
var relatedMedicationKnowledge = "http://hl7.org/fhir/relatedMedicationKnowledge";
var lastModified2 = "http://hl7.org/fhir/lastModified";
var RequestOrchestrationActionParticipantComponent = "http://hl7.org/fhir/RequestOrchestrationActionParticipantComponent";
var _informationType = "http://hl7.org/fhir/_informationType";
var citation = "http://hl7.org/fhir/citation";
var paymentStatus = "http://hl7.org/fhir/paymentStatus";
var treatment = "http://hl7.org/fhir/treatment";
var _initial = "http://hl7.org/fhir/_initial";
var priceComponent = "http://hl7.org/fhir/priceComponent";
var _Linkage = "http://hl7.org/fhir/_Linkage";
var _indicationGuideline = "http://hl7.org/fhir/_indicationGuideline";
var SubstanceSourceMaterial = "http://hl7.org/fhir/SubstanceSourceMaterial";
var _conditionalRead = "http://hl7.org/fhir/_conditionalRead";
var managingEntity = "http://hl7.org/fhir/managingEntity";
var EvidenceVariableCharacteristicDefinitionByTypeAndValueComponent = "http://hl7.org/fhir/EvidenceVariableCharacteristicDefinitionByTypeAndValueComponent";
var operationalStatus = "http://hl7.org/fhir/operationalStatus";
var _module = "http://hl7.org/fhir/_module";
var MedicationAdministration = "http://hl7.org/fhir/MedicationAdministration";
var UdiDeviceIdentifierMarketDistribution = "http://hl7.org/fhir/UdiDeviceIdentifierMarketDistribution";
var _probability = "http://hl7.org/fhir/_probability";
var clinicalRecommendationStatement = "http://hl7.org/fhir/clinicalRecommendationStatement";
var _image = "http://hl7.org/fhir/_image";
var SubscriptionTopicNotificationShapeComponent = "http://hl7.org/fhir/SubscriptionTopicNotificationShapeComponent";
var _componentPart = "http://hl7.org/fhir/_componentPart";
var op = "http://hl7.org/fhir/op";
var _processingFacility = "http://hl7.org/fhir/_processingFacility";
var unit = "http://hl7.org/fhir/unit";
var _problem = "http://hl7.org/fhir/_problem";
var SubstanceDefinitionPropertyComponent = "http://hl7.org/fhir/SubstanceDefinitionPropertyComponent";
var _fluidConsistencyType = "http://hl7.org/fhir/_fluidConsistencyType";
var _SubstancePolymer = "http://hl7.org/fhir/_SubstancePolymer";
var ValueSetComposeIncludeConceptDesignationComponent = "http://hl7.org/fhir/ValueSetComposeIncludeConceptDesignationComponent";
var versionReference = "http://hl7.org/fhir/versionReference";
var _maxSingleDose = "http://hl7.org/fhir/_maxSingleDose";
var meaning = "http://hl7.org/fhir/meaning";
var measurementPoint = "http://hl7.org/fhir/measurementPoint";
var diagnosisRelatedGroup = "http://hl7.org/fhir/diagnosisRelatedGroup";
var _relative = "http://hl7.org/fhir/_relative";
var _publicationForm = "http://hl7.org/fhir/_publicationForm";
var _Patient = "http://hl7.org/fhir/_Patient";
var GuidanceResponse = "http://hl7.org/fhir/GuidanceResponse";
var entity = "http://hl7.org/fhir/entity";
var sourceReference = "http://hl7.org/fhir/sourceReference";
var valueFilter = "http://hl7.org/fhir/valueFilter";
var _useBy = "http://hl7.org/fhir/_useBy";
var bodyLandmarkOrientation = "http://hl7.org/fhir/bodyLandmarkOrientation";
var SubstanceDefinitionNameComponentName = "http://hl7.org/fhir/SubstanceDefinitionNameComponentName";
var _policyText = "http://hl7.org/fhir/_policyText";
var _changePattern = "http://hl7.org/fhir/_changePattern";
var subDetail = "http://hl7.org/fhir/subDetail";
var allDay = "http://hl7.org/fhir/allDay";
var _modification = "http://hl7.org/fhir/_modification";
var _nodeId = "http://hl7.org/fhir/_nodeId";
var AdverseEventContributingFactorComponent = "http://hl7.org/fhir/AdverseEventContributingFactorComponent";
var TestPlanTestCaseComponent = "http://hl7.org/fhir/TestPlanTestCaseComponent";
var sunday = "http://hl7.org/fhir/sunday";
var cancellationReason = "http://hl7.org/fhir/cancellationReason";
var _title = "http://hl7.org/fhir/_title";
var _sourceId = "http://hl7.org/fhir/_sourceId";
var _entityRelatedness = "http://hl7.org/fhir/_entityRelatedness";
var line = "http://hl7.org/fhir/line";
var _effectivePeriod = "http://hl7.org/fhir/_effectivePeriod";
var preAuthRef = "http://hl7.org/fhir/preAuthRef";
var requestId = "http://hl7.org/fhir/requestId";
var _autodelete = "http://hl7.org/fhir/_autodelete";
var _fundsReserve = "http://hl7.org/fhir/_fundsReserve";
var BundleEntryComponentLink = "http://hl7.org/fhir/BundleEntryComponentLink";
var DocumentReferenceContentComponent = "http://hl7.org/fhir/DocumentReferenceContentComponent";
var _holder = "http://hl7.org/fhir/_holder";
var _qualifiers = "http://hl7.org/fhir/_qualifiers";
var _Specimen = "http://hl7.org/fhir/_Specimen";
var CodeSystemFilterComponent = "http://hl7.org/fhir/CodeSystemFilterComponent";
var _replacementSequence = "http://hl7.org/fhir/_replacementSequence";
var serviceCategory = "http://hl7.org/fhir/serviceCategory";
var _next = "http://hl7.org/fhir/_next";
var paymentTerms = "http://hl7.org/fhir/paymentTerms";
var _started = "http://hl7.org/fhir/_started";
var offer = "http://hl7.org/fhir/offer";
var coordinateSystem = "http://hl7.org/fhir/coordinateSystem";
var DeviceDefinition = "http://hl7.org/fhir/DeviceDefinition";
var _intent = "http://hl7.org/fhir/_intent";
var _text = "http://hl7.org/fhir/_text";
var _level = "http://hl7.org/fhir/_level";
var facility = "http://hl7.org/fhir/facility";
var qualifiedValue = "http://hl7.org/fhir/qualifiedValue";
var ManifestResource = "http://hl7.org/fhir/ManifestResource";
var prism = "http://hl7.org/fhir/prism";
var MedicationBatchComponent = "http://hl7.org/fhir/MedicationBatchComponent";
var resultForDelete = "http://hl7.org/fhir/resultForDelete";
var _accept = "http://hl7.org/fhir/_accept";
var overbooked = "http://hl7.org/fhir/overbooked";
var _plan = "http://hl7.org/fhir/_plan";
var ReviewOutcome = "http://hl7.org/fhir/ReviewOutcome";
var CitationCitedArtifactContributorshipEntryComponent = "http://hl7.org/fhir/CitationCitedArtifactContributorshipEntryComponent";
var discriminator = "http://hl7.org/fhir/discriminator";
var ordered = "http://hl7.org/fhir/ordered";
var LegalLanguage = "http://hl7.org/fhir/LegalLanguage";
var frequencyOfOccurrence = "http://hl7.org/fhir/frequencyOfOccurrence";
var _validationType = "http://hl7.org/fhir/_validationType";
var PermissionRuleDataComponent = "http://hl7.org/fhir/PermissionRuleDataComponent";
var _versionNeeded = "http://hl7.org/fhir/_versionNeeded";
var PackagedProductDefinitionPackagingContainedItemComponent = "http://hl7.org/fhir/PackagedProductDefinitionPackagingContainedItemComponent";
var predecessor = "http://hl7.org/fhir/predecessor";
var ArtifactAssessment = "http://hl7.org/fhir/ArtifactAssessment";
var _dependsOn = "http://hl7.org/fhir/_dependsOn";
var evidence = "http://hl7.org/fhir/evidence";
var MeasureGroupPopulationComponent = "http://hl7.org/fhir/MeasureGroupPopulationComponent";
var opticalActivity = "http://hl7.org/fhir/opticalActivity";
var nutritionProduct = "http://hl7.org/fhir/nutritionProduct";
var specialMeasures = "http://hl7.org/fhir/specialMeasures";
var packageId = "http://hl7.org/fhir/packageId";
var TerminologyCapabilitiesCodeSystemVersionFilterComponent = "http://hl7.org/fhir/TerminologyCapabilitiesCodeSystemVersionFilterComponent";
var SubDetail = "http://hl7.org/fhir/SubDetail";
var _received = "http://hl7.org/fhir/_received";
var CapabilityStatementDocumentComponent = "http://hl7.org/fhir/CapabilityStatementDocumentComponent";
var observationResultRequirement = "http://hl7.org/fhir/observationResultRequirement";
var FriendlyLanguage = "http://hl7.org/fhir/FriendlyLanguage";
var _observedGroup = "http://hl7.org/fhir/_observedGroup";
var cancelledReason = "http://hl7.org/fhir/cancelledReason";
var _expirationType = "http://hl7.org/fhir/_expirationType";
var _actualNumber = "http://hl7.org/fhir/_actualNumber";
var derivation = "http://hl7.org/fhir/derivation";
var AdverseEventSuspectEntityComponent = "http://hl7.org/fhir/AdverseEventSuspectEntityComponent";
var ImmunizationRecommendation = "http://hl7.org/fhir/ImmunizationRecommendation";
var _BiologicallyDerivedProductDispense = "http://hl7.org/fhir/_BiologicallyDerivedProductDispense";
var _definitionId = "http://hl7.org/fhir/_definitionId";
var _authoredOn = "http://hl7.org/fhir/_authoredOn";
var keyword = "http://hl7.org/fhir/keyword";
var characteristic = "http://hl7.org/fhir/characteristic";
var _note = "http://hl7.org/fhir/_note";
var ImagingStudySeriesInstanceComponent = "http://hl7.org/fhir/ImagingStudySeriesInstanceComponent";
var _signature = "http://hl7.org/fhir/_signature";
var slicing = "http://hl7.org/fhir/slicing";
var _population = "http://hl7.org/fhir/_population";
var cap = "http://hl7.org/fhir/cap";
var given = "http://hl7.org/fhir/given";
var account = "http://hl7.org/fhir/account";
var _organism = "http://hl7.org/fhir/_organism";
var _need = "http://hl7.org/fhir/_need";
var environmentalSetting = "http://hl7.org/fhir/environmentalSetting";
var volume = "http://hl7.org/fhir/volume";
var weeklyTemplate = "http://hl7.org/fhir/weeklyTemplate";
var lowerLimit = "http://hl7.org/fhir/lowerLimit";
var _justification = "http://hl7.org/fhir/_justification";
var _fixture = "http://hl7.org/fhir/_fixture";
var unitPriceComponent = "http://hl7.org/fhir/unitPriceComponent";
var availabilityStatus = "http://hl7.org/fhir/availabilityStatus";
var _proxySignature = "http://hl7.org/fhir/_proxySignature";
var statusChanged = "http://hl7.org/fhir/statusChanged";
var _about = "http://hl7.org/fhir/_about";
var occurence = "http://hl7.org/fhir/occurence";
var actualPeriod = "http://hl7.org/fhir/actualPeriod";
var _originalPrescription = "http://hl7.org/fhir/_originalPrescription";
var _dosage = "http://hl7.org/fhir/_dosage";
var returnedAmount = "http://hl7.org/fhir/returnedAmount";
var _cTerminalModification = "http://hl7.org/fhir/_cTerminalModification";
var name2 = "http://hl7.org/fhir/name";
var masterFile = "http://hl7.org/fhir/masterFile";
var baseFormulaType = "http://hl7.org/fhir/baseFormulaType";
var threshold = "http://hl7.org/fhir/threshold";
var active = "http://hl7.org/fhir/active";
var IngredientSubstanceComponent = "http://hl7.org/fhir/IngredientSubstanceComponent";
var size = "http://hl7.org/fhir/size";
var _validityPeriod = "http://hl7.org/fhir/_validityPeriod";
var who = "http://hl7.org/fhir/who";
var ExampleScenarioProcessStepAlternativeComponent = "http://hl7.org/fhir/ExampleScenarioProcessStepAlternativeComponent";
var InsurancePlanPlanSpecificCostComponent = "http://hl7.org/fhir/InsurancePlanPlanSpecificCostComponent";
var interaction = "http://hl7.org/fhir/interaction";
var _beneficiary = "http://hl7.org/fhir/_beneficiary";
var requestURL = "http://hl7.org/fhir/requestURL";
var transform = "http://hl7.org/fhir/transform";
var sugar = "http://hl7.org/fhir/sugar";
var _subscriptionTopic = "http://hl7.org/fhir/_subscriptionTopic";
var _usageStatus = "http://hl7.org/fhir/_usageStatus";
var _recurring = "http://hl7.org/fhir/_recurring";
var chargeItem = "http://hl7.org/fhir/chargeItem";
var DiagnosticReportMediaComponent = "http://hl7.org/fhir/DiagnosticReportMediaComponent";
var validationProcess = "http://hl7.org/fhir/validationProcess";
var _DiagnosticReport = "http://hl7.org/fhir/_DiagnosticReport";
var moiety = "http://hl7.org/fhir/moiety";
var _marketingStatus = "http://hl7.org/fhir/_marketingStatus";
var _citedArtifact = "http://hl7.org/fhir/_citedArtifact";
var CitationCitedArtifactPartComponent = "http://hl7.org/fhir/CitationCitedArtifactPartComponent";
var TerminologyCapabilitiesImplementationComponent = "http://hl7.org/fhir/TerminologyCapabilitiesImplementationComponent";
var _immutable = "http://hl7.org/fhir/_immutable";
var _requester = "http://hl7.org/fhir/_requester";
var regionsStudied = "http://hl7.org/fhir/regionsStudied";
var _code = "http://hl7.org/fhir/_code";
var sourceMaterial = "http://hl7.org/fhir/sourceMaterial";
var subrogation = "http://hl7.org/fhir/subrogation";
var _structureVersion = "http://hl7.org/fhir/_structureVersion";
var _priceComponent = "http://hl7.org/fhir/_priceComponent";
var management = "http://hl7.org/fhir/management";
var _additionalInstruction = "http://hl7.org/fhir/_additionalInstruction";
var _managingEntity = "http://hl7.org/fhir/_managingEntity";
var patchFormat = "http://hl7.org/fhir/patchFormat";
var proxyIdentityCertificate = "http://hl7.org/fhir/proxyIdentityCertificate";
var DeviceVersionComponent = "http://hl7.org/fhir/DeviceVersionComponent";
var TaskRestrictionComponent = "http://hl7.org/fhir/TaskRestrictionComponent";
var _frameOfReferenceUid = "http://hl7.org/fhir/_frameOfReferenceUid";
var MedicinalProductDefinition = "http://hl7.org/fhir/MedicinalProductDefinition";
var paternalOrganismId = "http://hl7.org/fhir/paternalOrganismId";
var averageMolecularFormula = "http://hl7.org/fhir/averageMolecularFormula";
var EvidenceStatisticSampleSizeComponent = "http://hl7.org/fhir/EvidenceStatisticSampleSizeComponent";
var _occurred = "http://hl7.org/fhir/_occurred";
var definitionByCombination = "http://hl7.org/fhir/definitionByCombination";
var _compositional = "http://hl7.org/fhir/_compositional";
var financial = "http://hl7.org/fhir/financial";
var _bodysite = "http://hl7.org/fhir/_bodysite";
var sourceScope = "http://hl7.org/fhir/sourceScope";
var modifierExtensionClass = "http://hl7.org/fhir/modifierExtensionClass";
var parameter = "http://hl7.org/fhir/parameter";
var lineItem = "http://hl7.org/fhir/lineItem";
var _businessArrangement = "http://hl7.org/fhir/_businessArrangement";
var _ordinalPosition = "http://hl7.org/fhir/_ordinalPosition";
var dependency = "http://hl7.org/fhir/dependency";
var DeviceUsage = "http://hl7.org/fhir/DeviceUsage";
var sent = "http://hl7.org/fhir/sent";
var _associatedMedication = "http://hl7.org/fhir/_associatedMedication";
var ParametersParameterComponentParameter = "http://hl7.org/fhir/ParametersParameterComponentParameter";
var executionPeriod = "http://hl7.org/fhir/executionPeriod";
var _custodian = "http://hl7.org/fhir/_custodian";
var specification = "http://hl7.org/fhir/specification";
var HumanName = "http://hl7.org/fhir/HumanName";
var ObservationDefinitionComponentComponentQualifiedValue = "http://hl7.org/fhir/ObservationDefinitionComponentComponentQualifiedValue";
var _searchInclude = "http://hl7.org/fhir/_searchInclude";
var _technique = "http://hl7.org/fhir/_technique";
var legalStatusOfSupply = "http://hl7.org/fhir/legalStatusOfSupply";
var short = "http://hl7.org/fhir/short";
var generation = "http://hl7.org/fhir/generation";
var doseAndRate = "http://hl7.org/fhir/doseAndRate";
var _condition = "http://hl7.org/fhir/_condition";
var _followUp = "http://hl7.org/fhir/_followUp";
var manufacturer = "http://hl7.org/fhir/manufacturer";
var BiologicallyDerivedProductDispense = "http://hl7.org/fhir/BiologicallyDerivedProductDispense";
var _seriesUid = "http://hl7.org/fhir/_seriesUid";
var relatesTo = "http://hl7.org/fhir/relatesTo";
var temperatureQualifier = "http://hl7.org/fhir/temperatureQualifier";
var _PackagedProductDefinition = "http://hl7.org/fhir/_PackagedProductDefinition";
var _correspondingContact = "http://hl7.org/fhir/_correspondingContact";
var citeAs = "http://hl7.org/fhir/citeAs";
var _DeviceAssociation = "http://hl7.org/fhir/_DeviceAssociation";
var requireBoth = "http://hl7.org/fhir/requireBoth";
var provisionData = "http://hl7.org/fhir/provisionData";
var _characterization = "http://hl7.org/fhir/_characterization";
var criticality = "http://hl7.org/fhir/criticality";
var ConditionDefinitionPlanComponent = "http://hl7.org/fhir/ConditionDefinitionPlanComponent";
var canPushUpdates = "http://hl7.org/fhir/canPushUpdates";
var _nTerminalModificationId = "http://hl7.org/fhir/_nTerminalModificationId";
var _regionsCalled = "http://hl7.org/fhir/_regionsCalled";
var TestPlanTestCaseTestRunComponent = "http://hl7.org/fhir/TestPlanTestCaseTestRunComponent";
var _productOrService = "http://hl7.org/fhir/_productOrService";
var reviewOutcome = "http://hl7.org/fhir/reviewOutcome";
var maxDispense = "http://hl7.org/fhir/maxDispense";
var modifierExtensionProperty = "http://hl7.org/fhir/modifierExtensionProperty";
var filterDefinition = "http://hl7.org/fhir/filterDefinition";
var sourceAttachment = "http://hl7.org/fhir/sourceAttachment";
var provisionActor = "http://hl7.org/fhir/provisionActor";
var NamingSystem = "http://hl7.org/fhir/NamingSystem";
var dateOfService = "http://hl7.org/fhir/dateOfService";
var VisionPrescription = "http://hl7.org/fhir/VisionPrescription";
var _unitPrice = "http://hl7.org/fhir/_unitPrice";
var resource = "http://hl7.org/fhir/resource";
var _response = "http://hl7.org/fhir/_response";
var _agent = "http://hl7.org/fhir/_agent";
var contraindicatedVaccineCode = "http://hl7.org/fhir/contraindicatedVaccineCode";
var collector = "http://hl7.org/fhir/collector";
var enterer = "http://hl7.org/fhir/enterer";
var _supportedInteraction = "http://hl7.org/fhir/_supportedInteraction";
var _differential = "http://hl7.org/fhir/_differential";
var _qualifiedValue = "http://hl7.org/fhir/_qualifiedValue";
var ManufacturedItemDefinitionComponentConstituentComponent = "http://hl7.org/fhir/ManufacturedItemDefinitionComponentConstituentComponent";
var _additionalMonitoringIndicator = "http://hl7.org/fhir/_additionalMonitoringIndicator";
var _position = "http://hl7.org/fhir/_position";
var limit = "http://hl7.org/fhir/limit";
var _reason = "http://hl7.org/fhir/_reason";
var _planningHorizon = "http://hl7.org/fhir/_planningHorizon";
var _safety = "http://hl7.org/fhir/_safety";
var Identifier = "http://hl7.org/fhir/Identifier";
var _mitigation = "http://hl7.org/fhir/_mitigation";
var _specialCourtesy = "http://hl7.org/fhir/_specialCourtesy";
var ExampleScenarioInstanceContainedInstanceComponent = "http://hl7.org/fhir/ExampleScenarioInstanceContainedInstanceComponent";
var edit = "http://hl7.org/fhir/edit";
var qualitativeRisk = "http://hl7.org/fhir/qualitativeRisk";
var immunizationEvent = "http://hl7.org/fhir/immunizationEvent";
var reference = "http://hl7.org/fhir/reference";
var reporter = "http://hl7.org/fhir/reporter";
var BackboneElement = "http://hl7.org/fhir/BackboneElement";
var _hasMember = "http://hl7.org/fhir/_hasMember";
var Provenance = "http://hl7.org/fhir/Provenance";
var reasonLinkId = "http://hl7.org/fhir/reasonLinkId";
var owner2 = "http://hl7.org/fhir/owner";
var _assignedComparisonGroup = "http://hl7.org/fhir/_assignedComparisonGroup";
var _Condition = "http://hl7.org/fhir/_Condition";
var ConsentPolicyBasisComponent = "http://hl7.org/fhir/ConsentPolicyBasisComponent";
var communicationMethod = "http://hl7.org/fhir/communicationMethod";
var _param = "http://hl7.org/fhir/_param";
var _power = "http://hl7.org/fhir/_power";
var _issue = "http://hl7.org/fhir/_issue";
var concept = "http://hl7.org/fhir/concept";
var decisionMode = "http://hl7.org/fhir/decisionMode";
var instantiatesUri = "http://hl7.org/fhir/instantiatesUri";
var _ifMatch = "http://hl7.org/fhir/_ifMatch";
var sequenceType = "http://hl7.org/fhir/sequenceType";
var _fastingStatus = "http://hl7.org/fhir/_fastingStatus";
var preferredReportName = "http://hl7.org/fhir/preferredReportName";
var _numberOfSeries = "http://hl7.org/fhir/_numberOfSeries";
var rankingOrder = "http://hl7.org/fhir/rankingOrder";
var _currency = "http://hl7.org/fhir/_currency";
var testTools = "http://hl7.org/fhir/testTools";
var _warning = "http://hl7.org/fhir/_warning";
var CoverageEligibilityResponseEventComponent = "http://hl7.org/fhir/CoverageEligibilityResponseEventComponent";
var _characteristic = "http://hl7.org/fhir/_characteristic";
var dataRequirement = "http://hl7.org/fhir/dataRequirement";
var _domain = "http://hl7.org/fhir/_domain";
var InventoryReport = "http://hl7.org/fhir/InventoryReport";
var _parameterName = "http://hl7.org/fhir/_parameterName";
var progressStatus = "http://hl7.org/fhir/progressStatus";
var _narrative = "http://hl7.org/fhir/_narrative";
var Endpoint = "http://hl7.org/fhir/Endpoint";
var subjectState = "http://hl7.org/fhir/subjectState";
var entry = "http://hl7.org/fhir/entry";
var _weeklyTemplate = "http://hl7.org/fhir/_weeklyTemplate";
var what = "http://hl7.org/fhir/what";
var whenPrepared = "http://hl7.org/fhir/whenPrepared";
var Action2 = "http://hl7.org/fhir/Action";
var _observationRequirement = "http://hl7.org/fhir/_observationRequirement";
var focal = "http://hl7.org/fhir/focal";
var verification = "http://hl7.org/fhir/verification";
var _availability = "http://hl7.org/fhir/_availability";
var resultingEffect = "http://hl7.org/fhir/resultingEffect";
var timeout = "http://hl7.org/fhir/timeout";
var CapabilityStatementMessagingSupportedMessageComponent = "http://hl7.org/fhir/CapabilityStatementMessagingSupportedMessageComponent";
var _revenue = "http://hl7.org/fhir/_revenue";
var _returnedAmount = "http://hl7.org/fhir/_returnedAmount";
var MedicationKnowledgeDefinitionalIngredientComponent = "http://hl7.org/fhir/MedicationKnowledgeDefinitionalIngredientComponent";
var candidate = "http://hl7.org/fhir/candidate";
var Subscription2 = "http://hl7.org/fhir/Subscription";
var relatedAction = "http://hl7.org/fhir/relatedAction";
var textPresentation = "http://hl7.org/fhir/textPresentation";
var _supplements = "http://hl7.org/fhir/_supplements";
var result2 = "http://hl7.org/fhir/result";
var policyText = "http://hl7.org/fhir/policyText";
var _regionType = "http://hl7.org/fhir/_regionType";
var StratifierGroup = "http://hl7.org/fhir/StratifierGroup";
var _contract = "http://hl7.org/fhir/_contract";
var _timeFromEvent = "http://hl7.org/fhir/_timeFromEvent";
var notificationEvent = "http://hl7.org/fhir/notificationEvent";
var _inclusionCriteria = "http://hl7.org/fhir/_inclusionCriteria";
var _orderMeaning = "http://hl7.org/fhir/_orderMeaning";
var autodelete = "http://hl7.org/fhir/autodelete";
var qualifiers = "http://hl7.org/fhir/qualifiers";
var _regionsStudied = "http://hl7.org/fhir/_regionsStudied";
var _application = "http://hl7.org/fhir/_application";
var frequency = "http://hl7.org/fhir/frequency";
var _sourceMaterial = "http://hl7.org/fhir/_sourceMaterial";
var regulatoryBasis = "http://hl7.org/fhir/regulatoryBasis";
var associationType = "http://hl7.org/fhir/associationType";
var _software = "http://hl7.org/fhir/_software";
var _copolymerConnectivity = "http://hl7.org/fhir/_copolymerConnectivity";
var _approvalDate = "http://hl7.org/fhir/_approvalDate";
var totalVolume = "http://hl7.org/fhir/totalVolume";
var AppointmentRecurrenceTemplateWeeklyTemplateComponent = "http://hl7.org/fhir/AppointmentRecurrenceTemplateWeeklyTemplateComponent";
var _requestedPerformer = "http://hl7.org/fhir/_requestedPerformer";
var packagedProduct = "http://hl7.org/fhir/packagedProduct";
var tissue = "http://hl7.org/fhir/tissue";
var isSubpotent = "http://hl7.org/fhir/isSubpotent";
var _supportingInfoSequence = "http://hl7.org/fhir/_supportingInfoSequence";
var _rating = "http://hl7.org/fhir/_rating";
var maternalOrganismName = "http://hl7.org/fhir/maternalOrganismName";
var CommunicationRequest = "http://hl7.org/fhir/CommunicationRequest";
var polymer = "http://hl7.org/fhir/polymer";
var initiatorActive = "http://hl7.org/fhir/initiatorActive";
var _productStatus = "http://hl7.org/fhir/_productStatus";
var strand = "http://hl7.org/fhir/strand";
var _outputParameters = "http://hl7.org/fhir/_outputParameters";
var participantStatus = "http://hl7.org/fhir/participantStatus";
var label = "http://hl7.org/fhir/label";
var manipulated = "http://hl7.org/fhir/manipulated";
var _geometry = "http://hl7.org/fhir/_geometry";
var Coding = "http://hl7.org/fhir/Coding";
var requisition = "http://hl7.org/fhir/requisition";
var InventoryReportInventoryListingComponent = "http://hl7.org/fhir/InventoryReportInventoryListingComponent";
var _parent = "http://hl7.org/fhir/_parent";
var _net = "http://hl7.org/fhir/_net";
var presentation = "http://hl7.org/fhir/presentation";
var flag = "http://hl7.org/fhir/flag";
var hoursOfOperation = "http://hl7.org/fhir/hoursOfOperation";
var encounter = "http://hl7.org/fhir/encounter";
var applicability = "http://hl7.org/fhir/applicability";
var releaseDate = "http://hl7.org/fhir/releaseDate";
var _relationshipType = "http://hl7.org/fhir/_relationshipType";
var _managingOrganization = "http://hl7.org/fhir/_managingOrganization";
var derivedFromCanonical = "http://hl7.org/fhir/derivedFromCanonical";
var _hasSeverity = "http://hl7.org/fhir/_hasSeverity";
var cTerminalModification = "http://hl7.org/fhir/cTerminalModification";
var ContentDefinition = "http://hl7.org/fhir/ContentDefinition";
var _bodyLandmarkOrientation = "http://hl7.org/fhir/_bodyLandmarkOrientation";
var relationship2 = "http://hl7.org/fhir/relationship";
var goal = "http://hl7.org/fhir/goal";
var _connectivity = "http://hl7.org/fhir/_connectivity";
var _listMode = "http://hl7.org/fhir/_listMode";
var _availableTime = "http://hl7.org/fhir/_availableTime";
var property = "http://hl7.org/fhir/property";
var _calibration = "http://hl7.org/fhir/_calibration";
var TerminologyCapabilitiesExpansionParameterComponent = "http://hl7.org/fhir/TerminologyCapabilitiesExpansionParameterComponent";
var adjustmentReason = "http://hl7.org/fhir/adjustmentReason";
var AdministrableProductDefinitionRouteOfAdministrationTargetSpeciesComponent = "http://hl7.org/fhir/AdministrableProductDefinitionRouteOfAdministrationTargetSpeciesComponent";
var Basic = "http://hl7.org/fhir/Basic";
var _isDerived = "http://hl7.org/fhir/_isDerived";
var hierarchical = "http://hl7.org/fhir/hierarchical";
var _resultForCreate = "http://hl7.org/fhir/_resultForCreate";
var _deviceName = "http://hl7.org/fhir/_deviceName";
var _startDate = "http://hl7.org/fhir/_startDate";
var Attachment = "http://hl7.org/fhir/Attachment";
var _patientPreparation = "http://hl7.org/fhir/_patientPreparation";
var CitationCitedArtifactPublicationFormComponent = "http://hl7.org/fhir/CitationCitedArtifactPublicationFormComponent";
var windowStart = "http://hl7.org/fhir/windowStart";
var _propertyGroup = "http://hl7.org/fhir/_propertyGroup";
var languageCode = "http://hl7.org/fhir/languageCode";
var _canPushUpdates = "http://hl7.org/fhir/_canPushUpdates";
var groupingBehavior = "http://hl7.org/fhir/groupingBehavior";
var for__workaround = "http://hl7.org/fhir/for";
var _studyUid = "http://hl7.org/fhir/_studyUid";
var _event = "http://hl7.org/fhir/_event";
var informationProvider = "http://hl7.org/fhir/informationProvider";
var network = "http://hl7.org/fhir/network";
var _manufacturedDoseForm = "http://hl7.org/fhir/_manufacturedDoseForm";
var assert = "http://hl7.org/fhir/assert";
var _warningOnly = "http://hl7.org/fhir/_warningOnly";
var isSummary = "http://hl7.org/fhir/isSummary";
var attachedDocument = "http://hl7.org/fhir/attachedDocument";
var _unit = "http://hl7.org/fhir/_unit";
var _endDate = "http://hl7.org/fhir/_endDate";
var authoredOn = "http://hl7.org/fhir/authoredOn";
var _geographicalLocation = "http://hl7.org/fhir/_geographicalLocation";
var CitationCitedArtifactClassificationComponent = "http://hl7.org/fhir/CitationCitedArtifactClassificationComponent";
var userSelected = "http://hl7.org/fhir/userSelected";
var _prognosisCodeableConcept = "http://hl7.org/fhir/_prognosisCodeableConcept";
var dateCriterion = "http://hl7.org/fhir/dateCriterion";
var additionalInstruction = "http://hl7.org/fhir/additionalInstruction";
var specialPrecautionsForStorage = "http://hl7.org/fhir/specialPrecautionsForStorage";
var population = "http://hl7.org/fhir/population";
var _member = "http://hl7.org/fhir/_member";
var securityLabel = "http://hl7.org/fhir/securityLabel";
var _renderedDosageInstruction = "http://hl7.org/fhir/_renderedDosageInstruction";
var Notes = "http://hl7.org/fhir/Notes";
var _dynamicValue = "http://hl7.org/fhir/_dynamicValue";
var _confidentialityIndicator = "http://hl7.org/fhir/_confidentialityIndicator";
var _intendedUse = "http://hl7.org/fhir/_intendedUse";
var lastUpdated = "http://hl7.org/fhir/lastUpdated";
var deceased = "http://hl7.org/fhir/deceased";
var NutritionOrderEnteralFormulaAdditiveComponent = "http://hl7.org/fhir/NutritionOrderEnteralFormulaAdditiveComponent";
var designation = "http://hl7.org/fhir/designation";
var reportedDateTime = "http://hl7.org/fhir/reportedDateTime";
var productOrServiceEnd = "http://hl7.org/fhir/productOrServiceEnd";
var teardown = "http://hl7.org/fhir/teardown";
var securityLabelNumber = "http://hl7.org/fhir/securityLabelNumber";
var _manufactureDate = "http://hl7.org/fhir/_manufactureDate";
var _textFilter = "http://hl7.org/fhir/_textFilter";
var _route = "http://hl7.org/fhir/_route";
var parentSubstanceName = "http://hl7.org/fhir/parentSubstanceName";
var _docStatus = "http://hl7.org/fhir/_docStatus";
var ArtifactAssessmentContentComponentContentContent = "http://hl7.org/fhir/ArtifactAssessmentContentComponentContentContent";
var _subscriber = "http://hl7.org/fhir/_subscriber";
var workflowStatus = "http://hl7.org/fhir/workflowStatus";
var phylum = "http://hl7.org/fhir/phylum";
var _mustSupport = "http://hl7.org/fhir/_mustSupport";
var forecastStatus = "http://hl7.org/fhir/forecastStatus";
var _closure = "http://hl7.org/fhir/_closure";
var _abstract = "http://hl7.org/fhir/_abstract";
var relatedClinicalInformation = "http://hl7.org/fhir/relatedClinicalInformation";
var PersonCommunicationComponent = "http://hl7.org/fhir/PersonCommunicationComponent";
var _relativePath = "http://hl7.org/fhir/_relativePath";
var CitationCitedArtifactVersionComponent = "http://hl7.org/fhir/CitationCitedArtifactVersionComponent";
var _paging = "http://hl7.org/fhir/_paging";
var _uniqueId = "http://hl7.org/fhir/_uniqueId";
var _readOnly = "http://hl7.org/fhir/_readOnly";
var _jurisdiction = "http://hl7.org/fhir/_jurisdiction";
var _treatment = "http://hl7.org/fhir/_treatment";
var _responsibleParty = "http://hl7.org/fhir/_responsibleParty";
var RequestOrchestrationActionComponentActionAction = "http://hl7.org/fhir/RequestOrchestrationActionComponentActionAction";
var _role = "http://hl7.org/fhir/_role";
var TestPlanDependencyComponent = "http://hl7.org/fhir/TestPlanDependencyComponent";
var Binary = "http://hl7.org/fhir/Binary";
var contentDerivative = "http://hl7.org/fhir/contentDerivative";
var inforce = "http://hl7.org/fhir/inforce";
var RiskAssessmentPredictionComponent = "http://hl7.org/fhir/RiskAssessmentPredictionComponent";
var _enteredDate = "http://hl7.org/fhir/_enteredDate";
var _legalStatusOfSupply = "http://hl7.org/fhir/_legalStatusOfSupply";
var valueAlternatives = "http://hl7.org/fhir/valueAlternatives";
var subject4 = "http://hl7.org/fhir/subject";
var _publicationDate = "http://hl7.org/fhir/_publicationDate";
var occurrenceChanged = "http://hl7.org/fhir/occurrenceChanged";
var _referralRequest = "http://hl7.org/fhir/_referralRequest";
var friday = "http://hl7.org/fhir/friday";
var productType = "http://hl7.org/fhir/productType";
var _payeeType = "http://hl7.org/fhir/_payeeType";
var _fixed = "http://hl7.org/fhir/_fixed";
var _nTerminalModification = "http://hl7.org/fhir/_nTerminalModification";
var _progressStatus = "http://hl7.org/fhir/_progressStatus";
var _age = "http://hl7.org/fhir/_age";
var _verificationDate = "http://hl7.org/fhir/_verificationDate";
var CompartmentDefinitionResourceComponent = "http://hl7.org/fhir/CompartmentDefinitionResourceComponent";
var _questionnaire = "http://hl7.org/fhir/_questionnaire";
var TestScript = "http://hl7.org/fhir/TestScript";
var billingStatus = "http://hl7.org/fhir/billingStatus";
var _resourceTrigger = "http://hl7.org/fhir/_resourceTrigger";
var compose = "http://hl7.org/fhir/compose";
var _submitter = "http://hl7.org/fhir/_submitter";
var _productReference = "http://hl7.org/fhir/_productReference";
var payment = "http://hl7.org/fhir/payment";
var rateAggregation = "http://hl7.org/fhir/rateAggregation";
var OrganizationQualificationComponent = "http://hl7.org/fhir/OrganizationQualificationComponent";
var identityCertificate = "http://hl7.org/fhir/identityCertificate";
var _subDetail = "http://hl7.org/fhir/_subDetail";
var contextInvariant = "http://hl7.org/fhir/contextInvariant";
var _suffix = "http://hl7.org/fhir/_suffix";
var _recurrenceId = "http://hl7.org/fhir/_recurrenceId";
var dispenseInterval = "http://hl7.org/fhir/dispenseInterval";
var _map = "http://hl7.org/fhir/_map";
var _lensSpecification = "http://hl7.org/fhir/_lensSpecification";
var allergyIntolerance = "http://hl7.org/fhir/allergyIntolerance";
var asset = "http://hl7.org/fhir/asset";
var CoverageEligibilityResponse = "http://hl7.org/fhir/CoverageEligibilityResponse";
var OperationDefinitionParameterComponentParameter = "http://hl7.org/fhir/OperationDefinitionParameterComponentParameter";
var packagedMedicinalProduct = "http://hl7.org/fhir/packagedMedicinalProduct";
var _count = "http://hl7.org/fhir/_count";
var SubstancePolymerRepeatRepeatUnitDegreeOfPolymerisationComponent = "http://hl7.org/fhir/SubstancePolymerRepeatRepeatUnitDegreeOfPolymerisationComponent";
var adjudication = "http://hl7.org/fhir/adjudication";
var RequestOrchestrationActionConditionComponent = "http://hl7.org/fhir/RequestOrchestrationActionConditionComponent";
var validator = "http://hl7.org/fhir/validator";
var _gene = "http://hl7.org/fhir/_gene";
var _length = "http://hl7.org/fhir/_length";
var series = "http://hl7.org/fhir/series";
var maxDosePerAdministration = "http://hl7.org/fhir/maxDosePerAdministration";
var _performerRole = "http://hl7.org/fhir/_performerRole";
var _balance = "http://hl7.org/fhir/_balance";
var _correctiveAction = "http://hl7.org/fhir/_correctiveAction";
var dispenser = "http://hl7.org/fhir/dispenser";
var NutritionOrderOralDietComponent = "http://hl7.org/fhir/NutritionOrderOralDietComponent";
var _meaning = "http://hl7.org/fhir/_meaning";
var endParam = "http://hl7.org/fhir/endParam";
var _provider = "http://hl7.org/fhir/_provider";
var inResponseTo = "http://hl7.org/fhir/inResponseTo";
var authorDescription = "http://hl7.org/fhir/authorDescription";
var _intendedExposure = "http://hl7.org/fhir/_intendedExposure";
var _cycle = "http://hl7.org/fhir/_cycle";
var ProvenanceEntityComponentAgent = "http://hl7.org/fhir/ProvenanceEntityComponentAgent";
var high = "http://hl7.org/fhir/high";
var _paymentStatus = "http://hl7.org/fhir/_paymentStatus";
var TestScriptVariableComponent = "http://hl7.org/fhir/TestScriptVariableComponent";
var _comparator = "http://hl7.org/fhir/_comparator";
var _instantiatesCanonical = "http://hl7.org/fhir/_instantiatesCanonical";
var class__workaround2 = "http://hl7.org/fhir/class";
var _countryOfOrigin = "http://hl7.org/fhir/_countryOfOrigin";
var structuralRepresentation = "http://hl7.org/fhir/structuralRepresentation";
var _communicationMethod = "http://hl7.org/fhir/_communicationMethod";
var _size = "http://hl7.org/fhir/_size";
var _averageMolecularFormula = "http://hl7.org/fhir/_averageMolecularFormula";
var _ingredientLabel = "http://hl7.org/fhir/_ingredientLabel";
var _landmarkDescription = "http://hl7.org/fhir/_landmarkDescription";
var _criticalCodedValueSet = "http://hl7.org/fhir/_criticalCodedValueSet";
var unmapped = "http://hl7.org/fhir/unmapped";
var _productCategory = "http://hl7.org/fhir/_productCategory";
var SubstanceReferenceInformationTargetComponent = "http://hl7.org/fhir/SubstanceReferenceInformationTargetComponent";
var _preferredReportName = "http://hl7.org/fhir/_preferredReportName";
var _maternalOrganismId = "http://hl7.org/fhir/_maternalOrganismId";
var _order = "http://hl7.org/fhir/_order";
var qualifier = "http://hl7.org/fhir/qualifier";
var recruitment = "http://hl7.org/fhir/recruitment";
var mitigation = "http://hl7.org/fhir/mitigation";
var Procedure = "http://hl7.org/fhir/Procedure";
var material = "http://hl7.org/fhir/material";
var _packageId = "http://hl7.org/fhir/_packageId";
var address2 = "http://hl7.org/fhir/address";
var module2 = "http://hl7.org/fhir/module";
var SubstanceNucleicAcidSubunitComponent = "http://hl7.org/fhir/SubstanceNucleicAcidSubunitComponent";
var _healthcareService = "http://hl7.org/fhir/_healthcareService";
var check = "http://hl7.org/fhir/check";
var _serviceProvisionCode = "http://hl7.org/fhir/_serviceProvisionCode";
var DeviceDefinitionHasPartComponent = "http://hl7.org/fhir/DeviceDefinitionHasPartComponent";
var hybrid = "http://hl7.org/fhir/hybrid";
var DeviceDefinitionPackagingComponentPackaging = "http://hl7.org/fhir/DeviceDefinitionPackagingComponentPackaging";
var extends__workaround = "http://hl7.org/fhir/extends";
var AdverseEventSupportingInfoComponent = "http://hl7.org/fhir/AdverseEventSupportingInfoComponent";
var _MedicationRequest = "http://hl7.org/fhir/_MedicationRequest";
var startingSequence = "http://hl7.org/fhir/startingSequence";
var MedicationKnowledgeMonographComponent = "http://hl7.org/fhir/MedicationKnowledgeMonographComponent";
var DetectedIssue = "http://hl7.org/fhir/DetectedIssue";
var targetLocation = "http://hl7.org/fhir/targetLocation";
var MedicinalProductDefinitionCrossReferenceComponent = "http://hl7.org/fhir/MedicinalProductDefinitionCrossReferenceComponent";
var _alternateMaterial = "http://hl7.org/fhir/_alternateMaterial";
var _ordered = "http://hl7.org/fhir/_ordered";
var _List = "http://hl7.org/fhir/_List";
var _gateway = "http://hl7.org/fhir/_gateway";
var _effect = "http://hl7.org/fhir/_effect";
var _coordinate = "http://hl7.org/fhir/_coordinate";
var case__workaround = "http://hl7.org/fhir/case";
var QuestionnaireItemComponentItem = "http://hl7.org/fhir/QuestionnaireItemComponentItem";
var DeviceConformsToComponent = "http://hl7.org/fhir/DeviceConformsToComponent";
var PatientLinkComponent = "http://hl7.org/fhir/PatientLinkComponent";
var testData = "http://hl7.org/fhir/testData";
var ProcedureFocalDeviceComponent = "http://hl7.org/fhir/ProcedureFocalDeviceComponent";
var _typeCanonical = "http://hl7.org/fhir/_typeCanonical";
var nodeId = "http://hl7.org/fhir/nodeId";
var CapabilityStatementSoftwareComponent = "http://hl7.org/fhir/CapabilityStatementSoftwareComponent";
var _preparation = "http://hl7.org/fhir/_preparation";
var _subType = "http://hl7.org/fhir/_subType";
var _definitionCodeableConcept = "http://hl7.org/fhir/_definitionCodeableConcept";
var benefitBalance = "http://hl7.org/fhir/benefitBalance";
var exclusionCriteria = "http://hl7.org/fhir/exclusionCriteria";
var numberOfStudies = "http://hl7.org/fhir/numberOfStudies";
var start = "http://hl7.org/fhir/start";
var AccountRelatedAccountComponent = "http://hl7.org/fhir/AccountRelatedAccountComponent";
var _OperationOutcome = "http://hl7.org/fhir/_OperationOutcome";
var orientation = "http://hl7.org/fhir/orientation";
var holder = "http://hl7.org/fhir/holder";
var _mitigatingAction = "http://hl7.org/fhir/_mitigatingAction";
var include = "http://hl7.org/fhir/include";
var _conditionalPatch = "http://hl7.org/fhir/_conditionalPatch";
var NamingSystemUniqueIdComponent = "http://hl7.org/fhir/NamingSystemUniqueIdComponent";
var _threshold = "http://hl7.org/fhir/_threshold";
var Count = "http://hl7.org/fhir/Count";
var _instantiates = "http://hl7.org/fhir/_instantiates";
var media = "http://hl7.org/fhir/media";
var appliesTo = "http://hl7.org/fhir/appliesTo";
var _implementationGuide = "http://hl7.org/fhir/_implementationGuide";
var RequestOrchestrationActionInputComponent = "http://hl7.org/fhir/RequestOrchestrationActionInputComponent";
var _discriminator = "http://hl7.org/fhir/_discriminator";
var ClaimResponse = "http://hl7.org/fhir/ClaimResponse";
var section = "http://hl7.org/fhir/section";
var _workflowStatus = "http://hl7.org/fhir/_workflowStatus";
var _DeviceMetric = "http://hl7.org/fhir/_DeviceMetric";
var diseaseSymptomProcedure = "http://hl7.org/fhir/diseaseSymptomProcedure";
var _keyword = "http://hl7.org/fhir/_keyword";
var _forecastStatus = "http://hl7.org/fhir/_forecastStatus";
var Bundle = "http://hl7.org/fhir/Bundle";
var _excluded = "http://hl7.org/fhir/_excluded";
var _transform = "http://hl7.org/fhir/_transform";
var intent = "http://hl7.org/fhir/intent";
var _slicing = "http://hl7.org/fhir/_slicing";
var generalPractitioner = "http://hl7.org/fhir/generalPractitioner";
var gestationalAge = "http://hl7.org/fhir/gestationalAge";
var _account = "http://hl7.org/fhir/_account";
var _administeredProduct = "http://hl7.org/fhir/_administeredProduct";
var answerOption = "http://hl7.org/fhir/answerOption";
var regionType = "http://hl7.org/fhir/regionType";
var _association = "http://hl7.org/fhir/_association";
var _messaging = "http://hl7.org/fhir/_messaging";
var organismType = "http://hl7.org/fhir/organismType";
var accept = "http://hl7.org/fhir/accept";
var _methodType = "http://hl7.org/fhir/_methodType";
var _authorizationRequired = "http://hl7.org/fhir/_authorizationRequired";
var includedStructure = "http://hl7.org/fhir/includedStructure";
var sourceIdentityCertificate = "http://hl7.org/fhir/sourceIdentityCertificate";
var foodType = "http://hl7.org/fhir/foodType";
var temperatureRange = "http://hl7.org/fhir/temperatureRange";
var ManifestPage = "http://hl7.org/fhir/ManifestPage";
var DeviceRequest = "http://hl7.org/fhir/DeviceRequest";
var _contextLinkId = "http://hl7.org/fhir/_contextLinkId";
var ExampleScenarioProcessStepOperationComponent = "http://hl7.org/fhir/ExampleScenarioProcessStepOperationComponent";
var SubstanceDefinitionStructureComponent = "http://hl7.org/fhir/SubstanceDefinitionStructureComponent";
var calculatedAt = "http://hl7.org/fhir/calculatedAt";
var MarketingStatus = "http://hl7.org/fhir/MarketingStatus";
var _emptyReason = "http://hl7.org/fhir/_emptyReason";
var _offsets = "http://hl7.org/fhir/_offsets";
var _financial = "http://hl7.org/fhir/_financial";
var _exposureRoute = "http://hl7.org/fhir/_exposureRoute";
var _policyHolder = "http://hl7.org/fhir/_policyHolder";
var SupplyDeliverySuppliedItemComponent = "http://hl7.org/fhir/SupplyDeliverySuppliedItemComponent";
var intendedRoute = "http://hl7.org/fhir/intendedRoute";
var _paymentDate = "http://hl7.org/fhir/_paymentDate";
var GenomicStudyAnalysisDeviceComponent = "http://hl7.org/fhir/GenomicStudyAnalysisDeviceComponent";
var _informationProvider = "http://hl7.org/fhir/_informationProvider";
var _outsideFoodAllowed = "http://hl7.org/fhir/_outsideFoodAllowed";
var feature = "http://hl7.org/fhir/feature";
var needsMap = "http://hl7.org/fhir/needsMap";
var _dataAbsentReason = "http://hl7.org/fhir/_dataAbsentReason";
var _definition = "http://hl7.org/fhir/_definition";
var creation = "http://hl7.org/fhir/creation";
var _minValue = "http://hl7.org/fhir/_minValue";
var width2 = "http://hl7.org/fhir/width";
var _Permission = "http://hl7.org/fhir/_Permission";
var AllergyIntolerance = "http://hl7.org/fhir/AllergyIntolerance";
var _Encounter = "http://hl7.org/fhir/_Encounter";
var targetNumber = "http://hl7.org/fhir/targetNumber";
var severity = "http://hl7.org/fhir/severity";
var ObservationDefinitionQualifiedValueComponent = "http://hl7.org/fhir/ObservationDefinitionQualifiedValueComponent";
var filterBy = "http://hl7.org/fhir/filterBy";
var packaging = "http://hl7.org/fhir/packaging";
var endorser = "http://hl7.org/fhir/endorser";
var _relatesTo = "http://hl7.org/fhir/_relatesTo";
var _sourceSignature = "http://hl7.org/fhir/_sourceSignature";
var abnormalCodedValueSet = "http://hl7.org/fhir/abnormalCodedValueSet";
var lastOccurrenceDate = "http://hl7.org/fhir/lastOccurrenceDate";
var _securityLabelNumber = "http://hl7.org/fhir/_securityLabelNumber";
var _queryCriteria = "http://hl7.org/fhir/_queryCriteria";
var _multipleResultsAllowed = "http://hl7.org/fhir/_multipleResultsAllowed";
var _allowed = "http://hl7.org/fhir/_allowed";
var _TestReport = "http://hl7.org/fhir/_TestReport";
var _Location = "http://hl7.org/fhir/_Location";
var deviceName = "http://hl7.org/fhir/deviceName";
var ImmunizationReactionComponent = "http://hl7.org/fhir/ImmunizationReactionComponent";
var ConceptMap = "http://hl7.org/fhir/ConceptMap";
var _daysOfWeek = "http://hl7.org/fhir/_daysOfWeek";
var ParameterDefinition = "http://hl7.org/fhir/ParameterDefinition";
var _packageCode = "http://hl7.org/fhir/_packageCode";
var Insurance = "http://hl7.org/fhir/Insurance";
var lastPerformed = "http://hl7.org/fhir/lastPerformed";
var IngredientManufacturerComponent = "http://hl7.org/fhir/IngredientManufacturerComponent";
var nthWeekOfMonth = "http://hl7.org/fhir/nthWeekOfMonth";
var targetSpecies = "http://hl7.org/fhir/targetSpecies";
var authorization = "http://hl7.org/fhir/authorization";
var _RequestOrchestration = "http://hl7.org/fhir/_RequestOrchestration";
var _endpoint = "http://hl7.org/fhir/_endpoint";
var triggeredBy = "http://hl7.org/fhir/triggeredBy";
var _Dosage = "http://hl7.org/fhir/_Dosage";
var _doNotPerform = "http://hl7.org/fhir/_doNotPerform";
var careTeam = "http://hl7.org/fhir/careTeam";
var _meta = "http://hl7.org/fhir/_meta";
var TerminologyCapabilitiesCodeSystemVersionComponent = "http://hl7.org/fhir/TerminologyCapabilitiesCodeSystemVersionComponent";
var entryQuantity = "http://hl7.org/fhir/entryQuantity";
var CapabilityStatementMessagingEndpointComponent = "http://hl7.org/fhir/CapabilityStatementMessagingEndpointComponent";
var nTerminalModification = "http://hl7.org/fhir/nTerminalModification";
var _asNeededFor = "http://hl7.org/fhir/_asNeededFor";
var _link = "http://hl7.org/fhir/_link";
var attribute = "http://hl7.org/fhir/attribute";
var Note2 = "http://hl7.org/fhir/Note";
var textFilter = "http://hl7.org/fhir/textFilter";
var disposition = "http://hl7.org/fhir/disposition";
var PackagedProductDefinition = "http://hl7.org/fhir/PackagedProductDefinition";
var Accident = "http://hl7.org/fhir/Accident";
var _reference = "http://hl7.org/fhir/_reference";
var StructureMapGroupRuleTargetParameterComponent = "http://hl7.org/fhir/StructureMapGroupRuleTargetParameterComponent";
var subscriber = "http://hl7.org/fhir/subscriber";
var structureType = "http://hl7.org/fhir/structureType";
var _detail = "http://hl7.org/fhir/_detail";
var meaningWhenMissing = "http://hl7.org/fhir/meaningWhenMissing";
var modelCharacteristic = "http://hl7.org/fhir/modelCharacteristic";
var mapping = "http://hl7.org/fhir/mapping";
var _Person = "http://hl7.org/fhir/_Person";
var _eligibility = "http://hl7.org/fhir/_eligibility";
var SubstanceSourceMaterialFractionDescriptionComponent = "http://hl7.org/fhir/SubstanceSourceMaterialFractionDescriptionComponent";
var typeCollected = "http://hl7.org/fhir/typeCollected";
var timestamp = "http://hl7.org/fhir/timestamp";
var _subpotentReason = "http://hl7.org/fhir/_subpotentReason";
var _relatedMedicationKnowledge = "http://hl7.org/fhir/_relatedMedicationKnowledge";
var _inventoryStatus = "http://hl7.org/fhir/_inventoryStatus";
var synonym = "http://hl7.org/fhir/synonym";
var _category = "http://hl7.org/fhir/_category";
var _regulatory = "http://hl7.org/fhir/_regulatory";
var birthDate = "http://hl7.org/fhir/birthDate";
var _priorPrescription = "http://hl7.org/fhir/_priorPrescription";
var Base = "http://hl7.org/fhir/Base";
var _testTools = "http://hl7.org/fhir/_testTools";
var _targetLocation = "http://hl7.org/fhir/_targetLocation";
var substanceDefinition = "http://hl7.org/fhir/substanceDefinition";
var _medication = "http://hl7.org/fhir/_medication";
var _vaccineCode = "http://hl7.org/fhir/_vaccineCode";
var _dateAsserted = "http://hl7.org/fhir/_dateAsserted";
var DeviceDefinitionMaterialComponent = "http://hl7.org/fhir/DeviceDefinitionMaterialComponent";
var _codeSearch = "http://hl7.org/fhir/_codeSearch";
var range = "http://hl7.org/fhir/range";
var NutritionOrder = "http://hl7.org/fhir/NutritionOrder";
var _dispenserInstruction = "http://hl7.org/fhir/_dispenserInstruction";
var _summary = "http://hl7.org/fhir/_summary";
var _synthesisType = "http://hl7.org/fhir/_synthesisType";
var productName = "http://hl7.org/fhir/productName";
var _reviewOutcome = "http://hl7.org/fhir/_reviewOutcome";
var claimResponse = "http://hl7.org/fhir/claimResponse";
var path = "http://hl7.org/fhir/path";
var additive = "http://hl7.org/fhir/additive";
var ElementDefinition = "http://hl7.org/fhir/ElementDefinition";
var fundingSource = "http://hl7.org/fhir/fundingSource";
var instantiatesCanonical = "http://hl7.org/fhir/instantiatesCanonical";
var family = "http://hl7.org/fhir/family";
var NutritionIntake = "http://hl7.org/fhir/NutritionIntake";
var EvidenceReport = "http://hl7.org/fhir/EvidenceReport";
var billablePeriod = "http://hl7.org/fhir/billablePeriod";
var _otherTherapy = "http://hl7.org/fhir/_otherTherapy";
var _dateOfService = "http://hl7.org/fhir/_dateOfService";
var _benefitBalance = "http://hl7.org/fhir/_benefitBalance";
var _information = "http://hl7.org/fhir/_information";
var _CareTeam = "http://hl7.org/fhir/_CareTeam";
var _aggregateMethod = "http://hl7.org/fhir/_aggregateMethod";
var generatedBy = "http://hl7.org/fhir/generatedBy";
var _tag = "http://hl7.org/fhir/_tag";
var asserter = "http://hl7.org/fhir/asserter";
var _revInclude = "http://hl7.org/fhir/_revInclude";
var onset = "http://hl7.org/fhir/onset";
var criticalCodedValueSet = "http://hl7.org/fhir/criticalCodedValueSet";
var _mode = "http://hl7.org/fhir/_mode";
var anchor = "http://hl7.org/fhir/anchor";
var _substitution = "http://hl7.org/fhir/_substitution";
var _consent = "http://hl7.org/fhir/_consent";
var _candidate = "http://hl7.org/fhir/_candidate";
var _concept = "http://hl7.org/fhir/_concept";
var MeasureReportGroupStratifierStratumComponentComponent = "http://hl7.org/fhir/MeasureReportGroupStratifierStratumComponentComponent";
var ifNoneExist = "http://hl7.org/fhir/ifNoneExist";
var GraphDefinitionNodeComponent = "http://hl7.org/fhir/GraphDefinitionNodeComponent";
var _answer = "http://hl7.org/fhir/_answer";
var _schedule = "http://hl7.org/fhir/_schedule";
var administrationTreatment = "http://hl7.org/fhir/administrationTreatment";
var _baseFormulaProductName = "http://hl7.org/fhir/_baseFormulaProductName";
var PermissionRuleDataResourceComponent = "http://hl7.org/fhir/PermissionRuleDataResourceComponent";
var _gestationalAge = "http://hl7.org/fhir/_gestationalAge";
var carrierAIDC = "http://hl7.org/fhir/carrierAIDC";
var _capability = "http://hl7.org/fhir/_capability";
var usageStatus = "http://hl7.org/fhir/usageStatus";
var _knownAllergen = "http://hl7.org/fhir/_knownAllergen";
var storageTempRequirements = "http://hl7.org/fhir/storageTempRequirements";
var definitionReference = "http://hl7.org/fhir/definitionReference";
var experimental = "http://hl7.org/fhir/experimental";
var _numberOfParticipants = "http://hl7.org/fhir/_numberOfParticipants";
var _repeat = "http://hl7.org/fhir/_repeat";
var displayName = "http://hl7.org/fhir/displayName";
var replaces2 = "http://hl7.org/fhir/replaces";
var _distanceFromLandmark = "http://hl7.org/fhir/_distanceFromLandmark";
var _frequency = "http://hl7.org/fhir/_frequency";
var shortDoco = "http://hl7.org/fhir/shortDoco";
var ImagingSelection = "http://hl7.org/fhir/ImagingSelection";
var modality = "http://hl7.org/fhir/modality";
var _targetId = "http://hl7.org/fhir/_targetId";
var _amount = "http://hl7.org/fhir/_amount";
var species = "http://hl7.org/fhir/species";
var totalNet = "http://hl7.org/fhir/totalNet";
var observationRequirement = "http://hl7.org/fhir/observationRequirement";
var InsurancePlanPlanGeneralCostComponent = "http://hl7.org/fhir/InsurancePlanPlanGeneralCostComponent";
var InvoiceLineItemComponent = "http://hl7.org/fhir/InvoiceLineItemComponent";
var requestor = "http://hl7.org/fhir/requestor";
var dietPreference = "http://hl7.org/fhir/dietPreference";
var comparator = "http://hl7.org/fhir/comparator";
var _combinedPharmaceuticalDoseForm = "http://hl7.org/fhir/_combinedPharmaceuticalDoseForm";
var servicePeriod = "http://hl7.org/fhir/servicePeriod";
var _rater = "http://hl7.org/fhir/_rater";
var receiverActive = "http://hl7.org/fhir/receiverActive";
var modification = "http://hl7.org/fhir/modification";
var practitioner = "http://hl7.org/fhir/practitioner";
var _normalCodedValueSet = "http://hl7.org/fhir/_normalCodedValueSet";
var TestCaseDependency = "http://hl7.org/fhir/TestCaseDependency";
var _costToBeneficiary = "http://hl7.org/fhir/_costToBeneficiary";
var MessageHeader = "http://hl7.org/fhir/MessageHeader";
var ResearchStudyRecruitmentComponent = "http://hl7.org/fhir/ResearchStudyRecruitmentComponent";
var _forenameInitials = "http://hl7.org/fhir/_forenameInitials";
var plannedStartDate = "http://hl7.org/fhir/plannedStartDate";
var study = "http://hl7.org/fhir/study";
var groupIdentifier = "http://hl7.org/fhir/groupIdentifier";
var _participatingOrganization = "http://hl7.org/fhir/_participatingOrganization";
var MeasureGroupStratifierComponent = "http://hl7.org/fhir/MeasureGroupStratifierComponent";
var wednesday = "http://hl7.org/fhir/wednesday";
var _diameter = "http://hl7.org/fhir/_diameter";
var enteralFormula = "http://hl7.org/fhir/enteralFormula";
var _stabilityDuration = "http://hl7.org/fhir/_stabilityDuration";
var integer = "http://hl7.org/fhir/integer";
var domain = "http://hl7.org/fhir/domain";
var _periodType = "http://hl7.org/fhir/_periodType";
var _ImagingStudy = "http://hl7.org/fhir/_ImagingStudy";
var searchRevInclude = "http://hl7.org/fhir/searchRevInclude";
var _relatedAction = "http://hl7.org/fhir/_relatedAction";
var observed = "http://hl7.org/fhir/observed";
var born = "http://hl7.org/fhir/born";
var _ImmunizationRecommendation = "http://hl7.org/fhir/_ImmunizationRecommendation";
var service = "http://hl7.org/fhir/service";
var _requestIdentifier = "http://hl7.org/fhir/_requestIdentifier";
var maxDosePerLifetime = "http://hl7.org/fhir/maxDosePerLifetime";
var format3 = "http://hl7.org/fhir/format";
var _isSummary = "http://hl7.org/fhir/_isSummary";
var supportingInfoSequence = "http://hl7.org/fhir/supportingInfoSequence";
var EvidenceStatisticModelCharacteristicVariableComponent = "http://hl7.org/fhir/EvidenceStatisticModelCharacteristicVariableComponent";
var ManufacturedItemDefinitionPropertyComponent = "http://hl7.org/fhir/ManufacturedItemDefinitionPropertyComponent";
var _concentration = "http://hl7.org/fhir/_concentration";
var coordinate = "http://hl7.org/fhir/coordinate";
var AddedItemDetailSubDetail = "http://hl7.org/fhir/AddedItemDetailSubDetail";
var TerminologyCapabilitiesTranslationComponent = "http://hl7.org/fhir/TerminologyCapabilitiesTranslationComponent";
var _generalPractitioner = "http://hl7.org/fhir/_generalPractitioner";
var _protocol = "http://hl7.org/fhir/_protocol";
var _exception = "http://hl7.org/fhir/_exception";
var _complication = "http://hl7.org/fhir/_complication";
var value = "http://hl7.org/fhir/value";
var _nthWeekOfMonth = "http://hl7.org/fhir/_nthWeekOfMonth";
var _url = "http://hl7.org/fhir/_url";
var SubstanceSourceMaterialOrganismHybridComponent = "http://hl7.org/fhir/SubstanceSourceMaterialOrganismHybridComponent";
var SubscriptionTopicEventTriggerComponent = "http://hl7.org/fhir/SubscriptionTopicEventTriggerComponent";
var MedicinalProductDefinitionNameComponent = "http://hl7.org/fhir/MedicinalProductDefinitionNameComponent";
var SubstanceSourceMaterialOrganismComponent = "http://hl7.org/fhir/SubstanceSourceMaterialOrganismComponent";
var overrideReason = "http://hl7.org/fhir/overrideReason";
var pages = "http://hl7.org/fhir/pages";
var _conclusion = "http://hl7.org/fhir/_conclusion";
var _combined = "http://hl7.org/fhir/_combined";
var _contains = "http://hl7.org/fhir/_contains";
var _documentType = "http://hl7.org/fhir/_documentType";
var MeasureGroupStratifierComponentComponent = "http://hl7.org/fhir/MeasureGroupStratifierComponentComponent";
var _numberOfInstances = "http://hl7.org/fhir/_numberOfInstances";
var PlanDefinitionActionComponent = "http://hl7.org/fhir/PlanDefinitionActionComponent";
var _processor = "http://hl7.org/fhir/_processor";
var actualNumber = "http://hl7.org/fhir/actualNumber";
var _network = "http://hl7.org/fhir/_network";
var effective = "http://hl7.org/fhir/effective";
var textEquivalent = "http://hl7.org/fhir/textEquivalent";
var preferred = "http://hl7.org/fhir/preferred";
var ImplementationGuide = "http://hl7.org/fhir/ImplementationGuide";
var EvidenceReportRelatesToTargetComponent = "http://hl7.org/fhir/EvidenceReportRelatesToTargetComponent";
var _applicability = "http://hl7.org/fhir/_applicability";
var min = "http://hl7.org/fhir/min";
var DeviceNameComponent = "http://hl7.org/fhir/DeviceNameComponent";
var Payment = "http://hl7.org/fhir/Payment";
var organismName = "http://hl7.org/fhir/organismName";
var relative = "http://hl7.org/fhir/relative";
var Ratio = "http://hl7.org/fhir/Ratio";
var item = "http://hl7.org/fhir/item";
var rating2 = "http://hl7.org/fhir/rating";
var _numerator = "http://hl7.org/fhir/_numerator";
var TestScriptScopeComponent = "http://hl7.org/fhir/TestScriptScopeComponent";
var _aggregation = "http://hl7.org/fhir/_aggregation";
var minutesDuration = "http://hl7.org/fhir/minutesDuration";
var AuditEventEntityComponent = "http://hl7.org/fhir/AuditEventEntityComponent";
var rate = "http://hl7.org/fhir/rate";
var CompartmentDefinition = "http://hl7.org/fhir/CompartmentDefinition";
var renderedDosageInstruction = "http://hl7.org/fhir/renderedDosageInstruction";
var methodType = "http://hl7.org/fhir/methodType";
var parent = "http://hl7.org/fhir/parent";
var sourceId = "http://hl7.org/fhir/sourceId";
var _requestedPeriod = "http://hl7.org/fhir/_requestedPeriod";
var _chromosome = "http://hl7.org/fhir/_chromosome";
var isSubPotent = "http://hl7.org/fhir/isSubPotent";
var presentedForm = "http://hl7.org/fhir/presentedForm";
var repetitions = "http://hl7.org/fhir/repetitions";
var aggregate = "http://hl7.org/fhir/aggregate";
var EvidenceStatisticComponent = "http://hl7.org/fhir/EvidenceStatisticComponent";
var ImplementationGuideDefinitionParameterComponent = "http://hl7.org/fhir/ImplementationGuideDefinitionParameterComponent";
var CompositionEventComponent = "http://hl7.org/fhir/CompositionEventComponent";
var _NutritionOrder = "http://hl7.org/fhir/_NutritionOrder";
var TaskInputComponent = "http://hl7.org/fhir/TaskInputComponent";
var rule = "http://hl7.org/fhir/rule";
var Specimen = "http://hl7.org/fhir/Specimen";
var _MedicinalProductDefinition = "http://hl7.org/fhir/_MedicinalProductDefinition";
var OperationDefinition = "http://hl7.org/fhir/OperationDefinition";
var process2 = "http://hl7.org/fhir/process";
var CitationCitedArtifactContributorshipEntryContributionInstanceComponent = "http://hl7.org/fhir/CitationCitedArtifactContributorshipEntryContributionInstanceComponent";
var EncounterAdmissionComponent = "http://hl7.org/fhir/EncounterAdmissionComponent";
var _MedicationDispense = "http://hl7.org/fhir/_MedicationDispense";
var translation = "http://hl7.org/fhir/translation";
var ObservationTriggeredByComponent = "http://hl7.org/fhir/ObservationTriggeredByComponent";
var _etag = "http://hl7.org/fhir/_etag";
var _dateCriterion = "http://hl7.org/fhir/_dateCriterion";
var _administrationInstruction = "http://hl7.org/fhir/_administrationInstruction";
var part = "http://hl7.org/fhir/part";
var _billablePeriod = "http://hl7.org/fhir/_billablePeriod";
var requestHeader = "http://hl7.org/fhir/requestHeader";
var _shortTitle = "http://hl7.org/fhir/_shortTitle";
var _securityLabel = "http://hl7.org/fhir/_securityLabel";
var _procedure = "http://hl7.org/fhir/_procedure";
var periodMax = "http://hl7.org/fhir/periodMax";
var monograph = "http://hl7.org/fhir/monograph";
var _eventsSinceSubscriptionStart = "http://hl7.org/fhir/_eventsSinceSubscriptionStart";
var QuestionnaireResponseItemAnswerComponent = "http://hl7.org/fhir/QuestionnaireResponseItemAnswerComponent";
var formatted = "http://hl7.org/fhir/formatted";
var restoreDate = "http://hl7.org/fhir/restoreDate";
var _grouping = "http://hl7.org/fhir/_grouping";
var definition = "http://hl7.org/fhir/definition";
var BodyStructureIncludedStructureBodyLandmarkOrientationDistanceFromLandmarkComponent = "http://hl7.org/fhir/BodyStructureIncludedStructureBodyLandmarkOrientationDistanceFromLandmarkComponent";
var dayOfWeek = "http://hl7.org/fhir/dayOfWeek";
var _variableDefinition = "http://hl7.org/fhir/_variableDefinition";
var nodeRole = "http://hl7.org/fhir/nodeRole";
var Permission = "http://hl7.org/fhir/Permission";
var dateWritten = "http://hl7.org/fhir/dateWritten";
var ratioHighLimitAmount = "http://hl7.org/fhir/ratioHighLimitAmount";
var _relatedData = "http://hl7.org/fhir/_relatedData";
var _inforce = "http://hl7.org/fhir/_inforce";
var _reportingVendor = "http://hl7.org/fhir/_reportingVendor";
var _sequenceRange = "http://hl7.org/fhir/_sequenceRange";
var member = "http://hl7.org/fhir/member";
var _versionAlgorithm = "http://hl7.org/fhir/_versionAlgorithm";
var _subject = "http://hl7.org/fhir/_subject";
var _case = "http://hl7.org/fhir/_case";
var _ClinicalUseDefinition = "http://hl7.org/fhir/_ClinicalUseDefinition";
var _cylinder = "http://hl7.org/fhir/_cylinder";
var _saturday = "http://hl7.org/fhir/_saturday";
var ConceptMapGroupUnmappedComponent = "http://hl7.org/fhir/ConceptMapGroupUnmappedComponent";
var Address2 = "http://hl7.org/fhir/Address";
var _validateCode = "http://hl7.org/fhir/_validateCode";
var _dispenser = "http://hl7.org/fhir/_dispenser";
var _issued = "http://hl7.org/fhir/_issued";
var TestReport = "http://hl7.org/fhir/TestReport";
var conditionalRead = "http://hl7.org/fhir/conditionalRead";
var fullUrl = "http://hl7.org/fhir/fullUrl";
var parameterFocus = "http://hl7.org/fhir/parameterFocus";
var _currentState = "http://hl7.org/fhir/_currentState";
var ActivityDefinition = "http://hl7.org/fhir/ActivityDefinition";
var daysOfWeek = "http://hl7.org/fhir/daysOfWeek";
var containedInstance = "http://hl7.org/fhir/containedInstance";
var StructureMapGroupRuleSourceComponent = "http://hl7.org/fhir/StructureMapGroupRuleSourceComponent";
var application = "http://hl7.org/fhir/application";
var received = "http://hl7.org/fhir/received";
var AuditEventEntityComponentAgent = "http://hl7.org/fhir/AuditEventEntityComponentAgent";
var element = "http://hl7.org/fhir/element";
var _compose = "http://hl7.org/fhir/_compose";
var _environmentalSetting = "http://hl7.org/fhir/_environmentalSetting";
var _payment = "http://hl7.org/fhir/_payment";
var _preparedDate = "http://hl7.org/fhir/_preparedDate";
var ImagingSelectionInstanceComponent = "http://hl7.org/fhir/ImagingSelectionInstanceComponent";
var _responseRequired = "http://hl7.org/fhir/_responseRequired";
var _contraindication = "http://hl7.org/fhir/_contraindication";
var _operator = "http://hl7.org/fhir/_operator";
var ActivityDefinitionParticipantComponent = "http://hl7.org/fhir/ActivityDefinitionParticipantComponent";
var _contraindicatedVaccineCode = "http://hl7.org/fhir/_contraindicatedVaccineCode";
var _membership = "http://hl7.org/fhir/_membership";
var _recordedDate = "http://hl7.org/fhir/_recordedDate";
var _provision = "http://hl7.org/fhir/_provision";
var _dietPreference = "http://hl7.org/fhir/_dietPreference";
var _laterality = "http://hl7.org/fhir/_laterality";
var _parentSubstanceId = "http://hl7.org/fhir/_parentSubstanceId";
var _report = "http://hl7.org/fhir/_report";
var MedicationDispensePerformerComponent = "http://hl7.org/fhir/MedicationDispensePerformerComponent";
var FamilyMemberHistoryConditionComponent = "http://hl7.org/fhir/FamilyMemberHistoryConditionComponent";
var _editor = "http://hl7.org/fhir/_editor";
var instant = "http://hl7.org/fhir/instant";
var paging = "http://hl7.org/fhir/paging";
var _receiverActive = "http://hl7.org/fhir/_receiverActive";
var publicationForm = "http://hl7.org/fhir/publicationForm";
var operation = "http://hl7.org/fhir/operation";
var organism = "http://hl7.org/fhir/organism";
var focus = "http://hl7.org/fhir/focus";
var _reviewer = "http://hl7.org/fhir/_reviewer";
var validCodedValueSet = "http://hl7.org/fhir/validCodedValueSet";
var Signatory = "http://hl7.org/fhir/Signatory";
var clockFacePosition = "http://hl7.org/fhir/clockFacePosition";
var _instanceReference = "http://hl7.org/fhir/_instanceReference";
var withdrawalPeriod = "http://hl7.org/fhir/withdrawalPeriod";
var conformance = "http://hl7.org/fhir/conformance";
var effectivePeriod = "http://hl7.org/fhir/effectivePeriod";
var _matchStatus = "http://hl7.org/fhir/_matchStatus";
var virtualService = "http://hl7.org/fhir/virtualService";
var Communication = "http://hl7.org/fhir/Communication";
var _enteralFormula = "http://hl7.org/fhir/_enteralFormula";
var whenHandedOver = "http://hl7.org/fhir/whenHandedOver";
var EvidenceReportSubjectComponent = "http://hl7.org/fhir/EvidenceReportSubjectComponent";
var substance = "http://hl7.org/fhir/substance";
var Section = "http://hl7.org/fhir/Section";
var _valueRange = "http://hl7.org/fhir/_valueRange";
var regulatoryIdentifier = "http://hl7.org/fhir/regulatoryIdentifier";
var kind = "http://hl7.org/fhir/kind";
var hasIngredient = "http://hl7.org/fhir/hasIngredient";
var detailSequence = "http://hl7.org/fhir/detailSequence";
var NutritionProductNutrientComponent = "http://hl7.org/fhir/NutritionProductNutrientComponent";
var _fractionDescription = "http://hl7.org/fhir/_fractionDescription";
var _degreeOfPolymerisation = "http://hl7.org/fhir/_degreeOfPolymerisation";
var _Account = "http://hl7.org/fhir/_Account";
var rangeCategory = "http://hl7.org/fhir/rangeCategory";
var _index = "http://hl7.org/fhir/_index";
var ValueSetComposeComponentInclude = "http://hl7.org/fhir/ValueSetComposeComponentInclude";
var regulatory = "http://hl7.org/fhir/regulatory";
var _modifier = "http://hl7.org/fhir/_modifier";
var _short = "http://hl7.org/fhir/_short";
var medication = "http://hl7.org/fhir/medication";
var codeSearch = "http://hl7.org/fhir/codeSearch";
var suffix = "http://hl7.org/fhir/suffix";
var MedicationDispenseSubstitutionComponent = "http://hl7.org/fhir/MedicationDispenseSubstitutionComponent";
var foodPreferenceModifier = "http://hl7.org/fhir/foodPreferenceModifier";
var Immunization = "http://hl7.org/fhir/Immunization";
var AppointmentRecurrenceTemplateMonthlyTemplateComponent = "http://hl7.org/fhir/AppointmentRecurrenceTemplateMonthlyTemplateComponent";
var preventiveAction = "http://hl7.org/fhir/preventiveAction";
var _AdministrableProductDefinition = "http://hl7.org/fhir/_AdministrableProductDefinition";
var _deliverFrom = "http://hl7.org/fhir/_deliverFrom";
var _address = "http://hl7.org/fhir/_address";
var intendedUse = "http://hl7.org/fhir/intendedUse";
var ElementDefinitionSlicingDiscriminatorComponent = "http://hl7.org/fhir/ElementDefinitionSlicingDiscriminatorComponent";
var SubscriptionTopic = "http://hl7.org/fhir/SubscriptionTopic";
var GenomicStudy = "http://hl7.org/fhir/GenomicStudy";
var _partLocation = "http://hl7.org/fhir/_partLocation";
var _subsumption = "http://hl7.org/fhir/_subsumption";
var BenefitBalance = "http://hl7.org/fhir/BenefitBalance";
var script = "http://hl7.org/fhir/script";
var _resourceReference = "http://hl7.org/fhir/_resourceReference";
var lastReviewDate = "http://hl7.org/fhir/lastReviewDate";
var SubstanceDefinitionNameComponentNameName = "http://hl7.org/fhir/SubstanceDefinitionNameComponentNameName";
var length = "http://hl7.org/fhir/length";
var _overrideReason = "http://hl7.org/fhir/_overrideReason";
var _period = "http://hl7.org/fhir/_period";
var TerminologyCapabilities = "http://hl7.org/fhir/TerminologyCapabilities";
var _supportingPatientInformation = "http://hl7.org/fhir/_supportingPatientInformation";
var OperationDefinitionParameterBindingComponent = "http://hl7.org/fhir/OperationDefinitionParameterBindingComponent";
var Task = "http://hl7.org/fhir/Task";
var MeasureReportGroupPopulationComponent = "http://hl7.org/fhir/MeasureReportGroupPopulationComponent";
var revInclude = "http://hl7.org/fhir/revInclude";
var _appliesTo = "http://hl7.org/fhir/_appliesTo";
var MedicationKnowledgeDefinitionalComponent = "http://hl7.org/fhir/MedicationKnowledgeDefinitionalComponent";
var usageInstruction = "http://hl7.org/fhir/usageInstruction";
var trigger2 = "http://hl7.org/fhir/trigger";
var mustSupport = "http://hl7.org/fhir/mustSupport";
var TimingRepeatComponent = "http://hl7.org/fhir/TimingRepeatComponent";
var effectiveDosePeriod = "http://hl7.org/fhir/effectiveDosePeriod";
var _textEquivalent = "http://hl7.org/fhir/_textEquivalent";
var bodysite = "http://hl7.org/fhir/bodysite";
var _appliesToAll = "http://hl7.org/fhir/_appliesToAll";
var comorbidity = "http://hl7.org/fhir/comorbidity";
var TestScriptFixtureComponent = "http://hl7.org/fhir/TestScriptFixtureComponent";
var oligoNucleotideType = "http://hl7.org/fhir/oligoNucleotideType";
var intendedEffect = "http://hl7.org/fhir/intendedEffect";
var _conformsTo = "http://hl7.org/fhir/_conformsTo";
var copyright = "http://hl7.org/fhir/copyright";
var _insurance = "http://hl7.org/fhir/_insurance";
var _partDescription = "http://hl7.org/fhir/_partDescription";
var _genomeBuild = "http://hl7.org/fhir/_genomeBuild";
var Slot = "http://hl7.org/fhir/Slot";
var _medium = "http://hl7.org/fhir/_medium";
var followUp = "http://hl7.org/fhir/followUp";
var maxDuration = "http://hl7.org/fhir/maxDuration";
var lotNumber = "http://hl7.org/fhir/lotNumber";
var EncounterHistoryLocationComponent = "http://hl7.org/fhir/EncounterHistoryLocationComponent";
var _owner = "http://hl7.org/fhir/_owner";
var InventoryItem = "http://hl7.org/fhir/InventoryItem";
var content2 = "http://hl7.org/fhir/content";
var DeviceDefinitionPropertyComponent = "http://hl7.org/fhir/DeviceDefinitionPropertyComponent";
var enteredDate = "http://hl7.org/fhir/enteredDate";
var _district = "http://hl7.org/fhir/_district";
var QuestionnaireItemComponentItemItem = "http://hl7.org/fhir/QuestionnaireItemComponentItemItem";
var eye = "http://hl7.org/fhir/eye";
var facilityType = "http://hl7.org/fhir/facilityType";
var markdown = "http://hl7.org/fhir/markdown";
var _friendly = "http://hl7.org/fhir/_friendly";
var ManufacturedItemDefinitionComponentComponentComponent = "http://hl7.org/fhir/ManufacturedItemDefinitionComponentComponentComponent";
var basedOn = "http://hl7.org/fhir/basedOn";
var assessmentMethod = "http://hl7.org/fhir/assessmentMethod";
var _sourceMaterialClass = "http://hl7.org/fhir/_sourceMaterialClass";
var CarePlanActivityComponent = "http://hl7.org/fhir/CarePlanActivityComponent";
var response = "http://hl7.org/fhir/response";
var _singleUse = "http://hl7.org/fhir/_singleUse";
var ProvenanceAgentComponent = "http://hl7.org/fhir/ProvenanceAgentComponent";
var _kingdom = "http://hl7.org/fhir/_kingdom";
var error = "http://hl7.org/fhir/error";
var effect = "http://hl7.org/fhir/effect";
var verifiedWith = "http://hl7.org/fhir/verifiedWith";
var _packaging = "http://hl7.org/fhir/_packaging";
var position = "http://hl7.org/fhir/position";
var EvidenceCertaintyComponentCertainty = "http://hl7.org/fhir/EvidenceCertaintyComponentCertainty";
var low = "http://hl7.org/fhir/low";
var _Device = "http://hl7.org/fhir/_Device";
var AddedItemSubDetail = "http://hl7.org/fhir/AddedItemSubDetail";
var _responsible = "http://hl7.org/fhir/_responsible";
var excludingDate = "http://hl7.org/fhir/excludingDate";
var _verified = "http://hl7.org/fhir/_verified";
var TestScriptMetadataCapabilityComponent = "http://hl7.org/fhir/TestScriptMetadataCapabilityComponent";
var marketingStatus = "http://hl7.org/fhir/marketingStatus";
var _ClaimResponse = "http://hl7.org/fhir/_ClaimResponse";
var request = "http://hl7.org/fhir/request";
var MolecularSequenceRelativeEditComponent = "http://hl7.org/fhir/MolecularSequenceRelativeEditComponent";
var periodType = "http://hl7.org/fhir/periodType";
var approvalDate = "http://hl7.org/fhir/approvalDate";
var _monomerSet = "http://hl7.org/fhir/_monomerSet";
var _eventTrigger = "http://hl7.org/fhir/_eventTrigger";
var _ingredient = "http://hl7.org/fhir/_ingredient";
var _biologicalSourceEvent = "http://hl7.org/fhir/_biologicalSourceEvent";
var durationMax = "http://hl7.org/fhir/durationMax";
var _MolecularSequence = "http://hl7.org/fhir/_MolecularSequence";
var _permittedDataType = "http://hl7.org/fhir/_permittedDataType";
var subtitle = "http://hl7.org/fhir/subtitle";
var _SubscriptionStatus = "http://hl7.org/fhir/_SubscriptionStatus";
var maxTreatmentPeriod = "http://hl7.org/fhir/maxTreatmentPeriod";
var _relatedIdentifier = "http://hl7.org/fhir/_relatedIdentifier";
var _feature = "http://hl7.org/fhir/_feature";
var ValueSetExpansionComponent = "http://hl7.org/fhir/ValueSetExpansionComponent";
var _parameterFocus = "http://hl7.org/fhir/_parameterFocus";
var _maxDosePerDay = "http://hl7.org/fhir/_maxDosePerDay";
var CapabilityStatementMessagingComponent = "http://hl7.org/fhir/CapabilityStatementMessagingComponent";
var ResearchStudyObjectiveComponent = "http://hl7.org/fhir/ResearchStudyObjectiveComponent";
var MedicationIngredientComponent = "http://hl7.org/fhir/MedicationIngredientComponent";
var SourceElement = "http://hl7.org/fhir/SourceElement";
var _sequence = "http://hl7.org/fhir/_sequence";
var _validateProfileId = "http://hl7.org/fhir/_validateProfileId";
var responsibility = "http://hl7.org/fhir/responsibility";
var containedItem = "http://hl7.org/fhir/containedItem";
var completionTime = "http://hl7.org/fhir/completionTime";
var _identifier = "http://hl7.org/fhir/_identifier";
var _scope = "http://hl7.org/fhir/_scope";
var currency = "http://hl7.org/fhir/currency";
var _inputProfile = "http://hl7.org/fhir/_inputProfile";
var TestAction = "http://hl7.org/fhir/TestAction";
var _performer = "http://hl7.org/fhir/_performer";
var QuestionnaireResponseItemComponentItemItem = "http://hl7.org/fhir/QuestionnaireResponseItemComponentItemItem";
var _pushTypeAvailable = "http://hl7.org/fhir/_pushTypeAvailable";
var communication = "http://hl7.org/fhir/communication";
var interpretation = "http://hl7.org/fhir/interpretation";
var _capacity = "http://hl7.org/fhir/_capacity";
var topic = "http://hl7.org/fhir/topic";
var _undesirableEffect = "http://hl7.org/fhir/_undesirableEffect";
var _noteNumber = "http://hl7.org/fhir/_noteNumber";
var _DeviceRequest = "http://hl7.org/fhir/_DeviceRequest";
var courseOfTherapyType = "http://hl7.org/fhir/courseOfTherapyType";
var ordinalPosition = "http://hl7.org/fhir/ordinalPosition";
var ObservationComponentComponentReferenceRange = "http://hl7.org/fhir/ObservationComponentComponentReferenceRange";
var _actorId = "http://hl7.org/fhir/_actorId";
var conclusion = "http://hl7.org/fhir/conclusion";
var Resource = "http://hl7.org/fhir/Resource";
var accountNumber = "http://hl7.org/fhir/accountNumber";
var deliverTo = "http://hl7.org/fhir/deliverTo";
var multipleResultsAllowed = "http://hl7.org/fhir/multipleResultsAllowed";
var _asNeeded = "http://hl7.org/fhir/_asNeeded";
var _onHold = "http://hl7.org/fhir/_onHold";
var genomeAssembly = "http://hl7.org/fhir/genomeAssembly";
var _preAuthRefPeriod = "http://hl7.org/fhir/_preAuthRefPeriod";
var itemSequence = "http://hl7.org/fhir/itemSequence";
var _relatedClinicalInformation = "http://hl7.org/fhir/_relatedClinicalInformation";
var ResearchStudy = "http://hl7.org/fhir/ResearchStudy";
var _action = "http://hl7.org/fhir/_action";
var _DocumentReference = "http://hl7.org/fhir/_DocumentReference";
var _coverageArea = "http://hl7.org/fhir/_coverageArea";
var DataType = "http://hl7.org/fhir/DataType";
var Duration = "http://hl7.org/fhir/Duration";
var _Consent = "http://hl7.org/fhir/_Consent";
var _referencePolicy = "http://hl7.org/fhir/_referencePolicy";
var _virtualService = "http://hl7.org/fhir/_virtualService";
var _lastModified = "http://hl7.org/fhir/_lastModified";
var destination = "http://hl7.org/fhir/destination";
var _whenHandedOver = "http://hl7.org/fhir/_whenHandedOver";
var _typeTested = "http://hl7.org/fhir/_typeTested";
var product = "http://hl7.org/fhir/product";
var _referrer = "http://hl7.org/fhir/_referrer";
var plannedEndDate = "http://hl7.org/fhir/plannedEndDate";
var _birthDate = "http://hl7.org/fhir/_birthDate";
var _mustHaveValue = "http://hl7.org/fhir/_mustHaveValue";
var ClinicalUseDefinition = "http://hl7.org/fhir/ClinicalUseDefinition";
var dynamicValue = "http://hl7.org/fhir/dynamicValue";
var _detailSequence = "http://hl7.org/fhir/_detailSequence";
var SupportingInformation = "http://hl7.org/fhir/SupportingInformation";
var CitationStatusDateComponent = "http://hl7.org/fhir/CitationStatusDateComponent";
var subscriberId = "http://hl7.org/fhir/subscriberId";
var node = "http://hl7.org/fhir/node";
var details = "http://hl7.org/fhir/details";
var GenomicStudyAnalysisInputComponent = "http://hl7.org/fhir/GenomicStudyAnalysisInputComponent";
var contract = "http://hl7.org/fhir/contract";
var _paymentIssuer = "http://hl7.org/fhir/_paymentIssuer";
var _clinicalTrial = "http://hl7.org/fhir/_clinicalTrial";
var Adjudication = "http://hl7.org/fhir/Adjudication";
var AdverseEventMitigatingActionComponent = "http://hl7.org/fhir/AdverseEventMitigatingActionComponent";
var ratioType = "http://hl7.org/fhir/ratioType";
var authoritative = "http://hl7.org/fhir/authoritative";
var chromosome = "http://hl7.org/fhir/chromosome";
var referralMethod = "http://hl7.org/fhir/referralMethod";
var MedicationKnowledgeDefinitionalDrugCharacteristicComponent = "http://hl7.org/fhir/MedicationKnowledgeDefinitionalDrugCharacteristicComponent";
var _filterParameter = "http://hl7.org/fhir/_filterParameter";
var _costCenter = "http://hl7.org/fhir/_costCenter";
var _maternalOrganismName = "http://hl7.org/fhir/_maternalOrganismName";
var _CommunicationRequest = "http://hl7.org/fhir/_CommunicationRequest";
var _mapping = "http://hl7.org/fhir/_mapping";
var _spatialReference = "http://hl7.org/fhir/_spatialReference";
var _AppointmentResponse = "http://hl7.org/fhir/_AppointmentResponse";
var preparation = "http://hl7.org/fhir/preparation";
var _outcome = "http://hl7.org/fhir/_outcome";
var _policy = "http://hl7.org/fhir/_policy";
var planningHorizon = "http://hl7.org/fhir/planningHorizon";
var _targetSpecies = "http://hl7.org/fhir/_targetSpecies";
var EvidenceVariableCharacteristicComponent = "http://hl7.org/fhir/EvidenceVariableCharacteristicComponent";
var _authorization = "http://hl7.org/fhir/_authorization";
var software = "http://hl7.org/fhir/software";
var _lastReviewDate = "http://hl7.org/fhir/_lastReviewDate";
var _derivedFromCanonical = "http://hl7.org/fhir/_derivedFromCanonical";
var specialCourtesy = "http://hl7.org/fhir/specialCourtesy";
var intraspecificType = "http://hl7.org/fhir/intraspecificType";
var shortTitle = "http://hl7.org/fhir/shortTitle";
var channelType = "http://hl7.org/fhir/channelType";
var _subSite = "http://hl7.org/fhir/_subSite";
var use = "http://hl7.org/fhir/use";
var webLocation = "http://hl7.org/fhir/webLocation";
var PlanDefinitionGoalTargetComponent = "http://hl7.org/fhir/PlanDefinitionGoalTargetComponent";
var _entryQuantity = "http://hl7.org/fhir/_entryQuantity";
var _seriousness = "http://hl7.org/fhir/_seriousness";
var _born = "http://hl7.org/fhir/_born";
var initiator = "http://hl7.org/fhir/initiator";
var geometry = "http://hl7.org/fhir/geometry";
var _organismGeneral = "http://hl7.org/fhir/_organismGeneral";
var TestReportSetupComponent = "http://hl7.org/fhir/TestReportSetupComponent";
var message = "http://hl7.org/fhir/message";
var PlanDefinitionActionInputComponent = "http://hl7.org/fhir/PlanDefinitionActionInputComponent";
var Dosage = "http://hl7.org/fhir/Dosage";
var _structureType = "http://hl7.org/fhir/_structureType";
var onAdmission = "http://hl7.org/fhir/onAdmission";
var EncounterLocationComponent = "http://hl7.org/fhir/EncounterLocationComponent";
var statusHistory = "http://hl7.org/fhir/statusHistory";
var CitationCitedArtifactComponent = "http://hl7.org/fhir/CitationCitedArtifactComponent";
var _paymentTerms = "http://hl7.org/fhir/_paymentTerms";
var _intendedEffect = "http://hl7.org/fhir/_intendedEffect";
var SubstanceSourceMaterialOrganismAuthorComponent = "http://hl7.org/fhir/SubstanceSourceMaterialOrganismAuthorComponent";
var listMode = "http://hl7.org/fhir/listMode";
var _typeCollected = "http://hl7.org/fhir/_typeCollected";
var definitional = "http://hl7.org/fhir/definitional";
var improvementNotation = "http://hl7.org/fhir/improvementNotation";
var ValuedItem = "http://hl7.org/fhir/ValuedItem";
var ElementDefinitionBaseComponent = "http://hl7.org/fhir/ElementDefinitionBaseComponent";
var Errors = "http://hl7.org/fhir/Errors";
var pattern = "http://hl7.org/fhir/pattern";
var TestScriptDestinationComponent = "http://hl7.org/fhir/TestScriptDestinationComponent";
var CoveragePaymentByComponent = "http://hl7.org/fhir/CoveragePaymentByComponent";
var _AuditEvent = "http://hl7.org/fhir/_AuditEvent";
var requirements = "http://hl7.org/fhir/requirements";
var authority = "http://hl7.org/fhir/authority";
var _compareToSourceId = "http://hl7.org/fhir/_compareToSourceId";
var _Contract = "http://hl7.org/fhir/_Contract";
var _occurrenceChanged = "http://hl7.org/fhir/_occurrenceChanged";
var typeReference = "http://hl7.org/fhir/typeReference";
var detail = "http://hl7.org/fhir/detail";
var _alternative = "http://hl7.org/fhir/_alternative";
var ClaimResponseAdjudication = "http://hl7.org/fhir/ClaimResponseAdjudication";
var Person2 = "http://hl7.org/fhir/Person";
var readHistory = "http://hl7.org/fhir/readHistory";
var _subjects = "http://hl7.org/fhir/_subjects";
var membership = "http://hl7.org/fhir/membership";
var studyUid = "http://hl7.org/fhir/studyUid";
var GraphDefinitionLinkCompartmentComponent = "http://hl7.org/fhir/GraphDefinitionLinkCompartmentComponent";
var _occurrence = "http://hl7.org/fhir/_occurrence";
var _dayOfMonth = "http://hl7.org/fhir/_dayOfMonth";
var Extension = "http://hl7.org/fhir/Extension";
var _proxyIdentityCertificate = "http://hl7.org/fhir/_proxyIdentityCertificate";
var emptyReason = "http://hl7.org/fhir/emptyReason";
var ConceptMapGroupComponent = "http://hl7.org/fhir/ConceptMapGroupComponent";
var laterality = "http://hl7.org/fhir/laterality";
var _previous = "http://hl7.org/fhir/_previous";
var _claimResponse = "http://hl7.org/fhir/_claimResponse";
var dataUpdateType = "http://hl7.org/fhir/dataUpdateType";
var paymentDate = "http://hl7.org/fhir/paymentDate";
var baseFormulaProductName = "http://hl7.org/fhir/baseFormulaProductName";
var performed = "http://hl7.org/fhir/performed";
var ServiceRequestOrderDetailComponent = "http://hl7.org/fhir/ServiceRequestOrderDetailComponent";
var _informationSequence = "http://hl7.org/fhir/_informationSequence";
var _wednesday = "http://hl7.org/fhir/_wednesday";
var _id = "http://hl7.org/fhir/_id";
var nucleicAcid = "http://hl7.org/fhir/nucleicAcid";
var implementation = "http://hl7.org/fhir/implementation";
var _species = "http://hl7.org/fhir/_species";
var _goalId = "http://hl7.org/fhir/_goalId";
var manager = "http://hl7.org/fhir/manager";
var Meta = "http://hl7.org/fhir/Meta";
var interpreter = "http://hl7.org/fhir/interpreter";
var situation = "http://hl7.org/fhir/situation";
var _recorded = "http://hl7.org/fhir/_recorded";
var DiagnosticReport = "http://hl7.org/fhir/DiagnosticReport";
var drugCharacteristic = "http://hl7.org/fhir/drugCharacteristic";
var SubstanceDefinitionStructureRepresentationComponent = "http://hl7.org/fhir/SubstanceDefinitionStructureRepresentationComponent";
var RequestOrchestrationActionRelatedActionComponent = "http://hl7.org/fhir/RequestOrchestrationActionRelatedActionComponent";
var variableRole = "http://hl7.org/fhir/variableRole";
var failureAction = "http://hl7.org/fhir/failureAction";
var suppliedItem = "http://hl7.org/fhir/suppliedItem";
var abstract2 = "http://hl7.org/fhir/abstract";
var valueRange = "http://hl7.org/fhir/valueRange";
var _query = "http://hl7.org/fhir/_query";
var sigFormat = "http://hl7.org/fhir/sigFormat";
var VirtualServiceDetail = "http://hl7.org/fhir/VirtualServiceDetail";
var _rest = "http://hl7.org/fhir/_rest";
var packageCode = "http://hl7.org/fhir/packageCode";
var _reaction = "http://hl7.org/fhir/_reaction";
var _contributor = "http://hl7.org/fhir/_contributor";
var _normalValue = "http://hl7.org/fhir/_normalValue";
var _resultsInterpreter = "http://hl7.org/fhir/_resultsInterpreter";
var _tester = "http://hl7.org/fhir/_tester";
var denominator = "http://hl7.org/fhir/denominator";
var uniqueId = "http://hl7.org/fhir/uniqueId";
var readOnly = "http://hl7.org/fhir/readOnly";
var _effectiveDosePeriod = "http://hl7.org/fhir/_effectiveDosePeriod";
var _patientInstruction = "http://hl7.org/fhir/_patientInstruction";
var focusReference = "http://hl7.org/fhir/focusReference";
var _sopClass = "http://hl7.org/fhir/_sopClass";
var _brand = "http://hl7.org/fhir/_brand";
var SubscriptionStatusNotificationEventComponent = "http://hl7.org/fhir/SubscriptionStatusNotificationEventComponent";
var specialArrangement = "http://hl7.org/fhir/specialArrangement";
var _autocreate = "http://hl7.org/fhir/_autocreate";
var _responsibility = "http://hl7.org/fhir/_responsibility";
var any = "http://hl7.org/fhir/any";
var protocolApplied = "http://hl7.org/fhir/protocolApplied";
var PaymentNotice = "http://hl7.org/fhir/PaymentNotice";
var _completionTime = "http://hl7.org/fhir/_completionTime";
var _preAdmissionIdentifier = "http://hl7.org/fhir/_preAdmissionIdentifier";
var _interpretation = "http://hl7.org/fhir/_interpretation";
var testingDestination = "http://hl7.org/fhir/testingDestination";
var ExtendedContactDetail = "http://hl7.org/fhir/ExtendedContactDetail";
var administrableDoseForm = "http://hl7.org/fhir/administrableDoseForm";
var repeat2 = "http://hl7.org/fhir/repeat";
var CapabilityStatementRestResourceSearchParamComponent = "http://hl7.org/fhir/CapabilityStatementRestResourceSearchParamComponent";
var interactant = "http://hl7.org/fhir/interactant";
var _groupDefinition = "http://hl7.org/fhir/_groupDefinition";
var _effective = "http://hl7.org/fhir/_effective";
var _service = "http://hl7.org/fhir/_service";
var admitSource = "http://hl7.org/fhir/admitSource";
var _cap = "http://hl7.org/fhir/_cap";
var _structure = "http://hl7.org/fhir/_structure";
var _preferred = "http://hl7.org/fhir/_preferred";
var human = "http://hl7.org/fhir/human";
var _genomeAssembly = "http://hl7.org/fhir/_genomeAssembly";
var _dimensions = "http://hl7.org/fhir/_dimensions";
var Reason = "http://hl7.org/fhir/Reason";
var eligibility = "http://hl7.org/fhir/eligibility";
var resultForCreate = "http://hl7.org/fhir/resultForCreate";
var PersonLinkComponent = "http://hl7.org/fhir/PersonLinkComponent";
var EvidenceCertaintyComponent = "http://hl7.org/fhir/EvidenceCertaintyComponent";
var texture = "http://hl7.org/fhir/texture";
var characterization = "http://hl7.org/fhir/characterization";
var TerminologyCapabilitiesExpansionComponent = "http://hl7.org/fhir/TerminologyCapabilitiesExpansionComponent";
var DataRequirementCodeFilterComponent = "http://hl7.org/fhir/DataRequirementCodeFilterComponent";
var _derivedFrom = "http://hl7.org/fhir/_derivedFrom";
var _doseAdministrationAid = "http://hl7.org/fhir/_doseAdministrationAid";
var productOrService = "http://hl7.org/fhir/productOrService";
var _plannedEndDate = "http://hl7.org/fhir/_plannedEndDate";
var conformsTo2 = "http://hl7.org/fhir/conformsTo";
var _detected = "http://hl7.org/fhir/_detected";
var _threePrime = "http://hl7.org/fhir/_threePrime";
var referencedFrom = "http://hl7.org/fhir/referencedFrom";
var targetFormat = "http://hl7.org/fhir/targetFormat";
var _characteristicType = "http://hl7.org/fhir/_characteristicType";
var StructureDefinitionMappingComponent = "http://hl7.org/fhir/StructureDefinitionMappingComponent";
var _initiatorActive = "http://hl7.org/fhir/_initiatorActive";
var supportedInteraction = "http://hl7.org/fhir/supportedInteraction";
var vaccineCode = "http://hl7.org/fhir/vaccineCode";
var seriesNumber = "http://hl7.org/fhir/seriesNumber";
var pageCount = "http://hl7.org/fhir/pageCount";
var _who = "http://hl7.org/fhir/_who";
var PermissionRuleActivityComponent = "http://hl7.org/fhir/PermissionRuleActivityComponent";
var careManager = "http://hl7.org/fhir/careManager";
var CodeSystem = "http://hl7.org/fhir/CodeSystem";
var MedicinalProductDefinitionNamePartComponent = "http://hl7.org/fhir/MedicinalProductDefinitionNamePartComponent";
var _requestingOrganization = "http://hl7.org/fhir/_requestingOrganization";
var _referralMethod = "http://hl7.org/fhir/_referralMethod";
var _suspectEntity = "http://hl7.org/fhir/_suspectEntity";
var _exclusionCriteria = "http://hl7.org/fhir/_exclusionCriteria";
var ObservationComponentComponent = "http://hl7.org/fhir/ObservationComponentComponent";
var _testScript = "http://hl7.org/fhir/_testScript";
var manufactureDate = "http://hl7.org/fhir/manufactureDate";
var _textPresentation = "http://hl7.org/fhir/_textPresentation";
var TestReportSetupActionOperationComponent = "http://hl7.org/fhir/TestReportSetupActionOperationComponent";
var legal = "http://hl7.org/fhir/legal";
var provider2 = "http://hl7.org/fhir/provider";
var exitCriteria = "http://hl7.org/fhir/exitCriteria";
var image2 = "http://hl7.org/fhir/image";
var SupplyRequest = "http://hl7.org/fhir/SupplyRequest";
var _periodMax = "http://hl7.org/fhir/_periodMax";
var _monograph = "http://hl7.org/fhir/_monograph";
var _decision = "http://hl7.org/fhir/_decision";
var _diagnostics = "http://hl7.org/fhir/_diagnostics";
var _origin = "http://hl7.org/fhir/_origin";
var _durationUnit = "http://hl7.org/fhir/_durationUnit";
var contact2 = "http://hl7.org/fhir/contact";
var _disabledDisplay = "http://hl7.org/fhir/_disabledDisplay";
var _attestation = "http://hl7.org/fhir/_attestation";
var PackagedProductDefinitionPackagingComponentPackaging = "http://hl7.org/fhir/PackagedProductDefinitionPackagingComponentPackaging";
var OperationOutcomeIssueComponent = "http://hl7.org/fhir/OperationOutcomeIssueComponent";
var _hash = "http://hl7.org/fhir/_hash";
var _pageString = "http://hl7.org/fhir/_pageString";
var _constituent = "http://hl7.org/fhir/_constituent";
var DeviceAssociation = "http://hl7.org/fhir/DeviceAssociation";
var _dayOfWeek = "http://hl7.org/fhir/_dayOfWeek";
var _inventoryListing = "http://hl7.org/fhir/_inventoryListing";
var _hierarchyMeaning = "http://hl7.org/fhir/_hierarchyMeaning";
var _dispenseRequest = "http://hl7.org/fhir/_dispenseRequest";
var legallyBinding = "http://hl7.org/fhir/legallyBinding";
var _manufacturer = "http://hl7.org/fhir/_manufacturer";
var _answerConstraint = "http://hl7.org/fhir/_answerConstraint";
var _when = "http://hl7.org/fhir/_when";
var _form = "http://hl7.org/fhir/_form";
var businessStatus = "http://hl7.org/fhir/businessStatus";
var comparisonGroup = "http://hl7.org/fhir/comparisonGroup";
var _instance = "http://hl7.org/fhir/_instance";
var _itemStatus = "http://hl7.org/fhir/_itemStatus";
var _conditionalDelete = "http://hl7.org/fhir/_conditionalDelete";
var _grade = "http://hl7.org/fhir/_grade";
var _process = "http://hl7.org/fhir/_process";
var _articleDate = "http://hl7.org/fhir/_articleDate";
var additionalMonitoringIndicator = "http://hl7.org/fhir/additionalMonitoringIndicator";
var title3 = "http://hl7.org/fhir/title";
var _courseOfTherapyType = "http://hl7.org/fhir/_courseOfTherapyType";
var _identity = "http://hl7.org/fhir/_identity";
var CapabilityStatementRestComponent = "http://hl7.org/fhir/CapabilityStatementRestComponent";
var additionalAttribute = "http://hl7.org/fhir/additionalAttribute";
var monomerSet = "http://hl7.org/fhir/monomerSet";
var ingredient = "http://hl7.org/fhir/ingredient";
var _subPotentReason = "http://hl7.org/fhir/_subPotentReason";
var _supportedMessage = "http://hl7.org/fhir/_supportedMessage";
var DataRequirementDateFilterComponent = "http://hl7.org/fhir/DataRequirementDateFilterComponent";
var _performedActivity = "http://hl7.org/fhir/_performedActivity";
var _specialty = "http://hl7.org/fhir/_specialty";
var _weekInterval = "http://hl7.org/fhir/_weekInterval";
var publicationDate = "http://hl7.org/fhir/publicationDate";
var administrationInstruction = "http://hl7.org/fhir/administrationInstruction";
var fivePrime = "http://hl7.org/fhir/fivePrime";
var _points = "http://hl7.org/fhir/_points";
var TestScriptSetupActionAssertComponent = "http://hl7.org/fhir/TestScriptSetupActionAssertComponent";
var referralRequest = "http://hl7.org/fhir/referralRequest";
var _timeAspect = "http://hl7.org/fhir/_timeAspect";
var _presentedForm = "http://hl7.org/fhir/_presentedForm";
var _seriesDoses = "http://hl7.org/fhir/_seriesDoses";
var milestone = "http://hl7.org/fhir/milestone";
var MedicationAdministrationPerformerComponent = "http://hl7.org/fhir/MedicationAdministrationPerformerComponent";
var Invoice = "http://hl7.org/fhir/Invoice";
var additionalContext = "http://hl7.org/fhir/additionalContext";
var _satisfiedBy = "http://hl7.org/fhir/_satisfiedBy";
var identifier3 = "http://hl7.org/fhir/identifier";
var SubstanceNucleicAcid = "http://hl7.org/fhir/SubstanceNucleicAcid";
var resourceTrigger = "http://hl7.org/fhir/resourceTrigger";
var _overload = "http://hl7.org/fhir/_overload";
var organization = "http://hl7.org/fhir/organization";
var PlanDefinitionActionConditionComponent = "http://hl7.org/fhir/PlanDefinitionActionConditionComponent";
var RegulatedAuthorizationCaseComponentCaseCase = "http://hl7.org/fhir/RegulatedAuthorizationCaseComponentCaseCase";
var sliceIsConstraining = "http://hl7.org/fhir/sliceIsConstraining";
var _dataUpdateType = "http://hl7.org/fhir/_dataUpdateType";
var noteNumber = "http://hl7.org/fhir/noteNumber";
var installDate = "http://hl7.org/fhir/installDate";
var cardBrand = "http://hl7.org/fhir/cardBrand";
var _fullUrl = "http://hl7.org/fhir/_fullUrl";
var codeMap = "http://hl7.org/fhir/codeMap";
var ConditionDefinitionObservationComponent = "http://hl7.org/fhir/ConditionDefinitionObservationComponent";
var FamilyMemberHistory = "http://hl7.org/fhir/FamilyMemberHistory";
var operationTypeReason = "http://hl7.org/fhir/operationTypeReason";
var SpecimenDefinitionTypeTestedContainerAdditiveComponent = "http://hl7.org/fhir/SpecimenDefinitionTypeTestedContainerAdditiveComponent";
var _element = "http://hl7.org/fhir/_element";
var _attachedDocument = "http://hl7.org/fhir/_attachedDocument";
var _implementation = "http://hl7.org/fhir/_implementation";
var sourceMaterialType = "http://hl7.org/fhir/sourceMaterialType";
var _substance = "http://hl7.org/fhir/_substance";
var _qualification = "http://hl7.org/fhir/_qualification";
var _countType = "http://hl7.org/fhir/_countType";
var sourceMaterialState = "http://hl7.org/fhir/sourceMaterialState";
var _observationResultRequirement = "http://hl7.org/fhir/_observationResultRequirement";
var attestationSignature = "http://hl7.org/fhir/attestationSignature";
var PackagedProductDefinitionPackagingComponentPackagingPackaging = "http://hl7.org/fhir/PackagedProductDefinitionPackagingComponentPackagingPackaging";
var _marketingAuthorizationHolder = "http://hl7.org/fhir/_marketingAuthorizationHolder";
var _decisionMode = "http://hl7.org/fhir/_decisionMode";
var repeats = "http://hl7.org/fhir/repeats";
var typeTested = "http://hl7.org/fhir/typeTested";
var _rankingOrder = "http://hl7.org/fhir/_rankingOrder";
var end = "http://hl7.org/fhir/end";
var GenomicStudyAnalysisComponent = "http://hl7.org/fhir/GenomicStudyAnalysisComponent";
var excluded = "http://hl7.org/fhir/excluded";
var BundleEntryRequestComponent = "http://hl7.org/fhir/BundleEntryRequestComponent";
var DeviceDefinitionDeviceNameComponent = "http://hl7.org/fhir/DeviceDefinitionDeviceNameComponent";
var _eventNumber = "http://hl7.org/fhir/_eventNumber";
var FormularyItem = "http://hl7.org/fhir/FormularyItem";
var _marketDistribution = "http://hl7.org/fhir/_marketDistribution";
var _searchParam = "http://hl7.org/fhir/_searchParam";
var countryOfOrigin = "http://hl7.org/fhir/countryOfOrigin";
var AuditEventAgentComponent = "http://hl7.org/fhir/AuditEventAgentComponent";
var _regulatoryAuthority = "http://hl7.org/fhir/_regulatoryAuthority";
var _subjectState = "http://hl7.org/fhir/_subjectState";
var actualComparisonGroup = "http://hl7.org/fhir/actualComparisonGroup";
var _focusReference = "http://hl7.org/fhir/_focusReference";
var _statusReason = "http://hl7.org/fhir/_statusReason";
var ingredientLabel = "http://hl7.org/fhir/ingredientLabel";
var _whenPrepared = "http://hl7.org/fhir/_whenPrepared";
var costCenter = "http://hl7.org/fhir/costCenter";
var outputParameters = "http://hl7.org/fhir/outputParameters";
var DevicePropertyComponent = "http://hl7.org/fhir/DevicePropertyComponent";
var productCategory = "http://hl7.org/fhir/productCategory";
var serviceType = "http://hl7.org/fhir/serviceType";
var _verification = "http://hl7.org/fhir/_verification";
var reliableCache = "http://hl7.org/fhir/reliableCache";
var _Flag = "http://hl7.org/fhir/_Flag";
var numberAffected = "http://hl7.org/fhir/numberAffected";
var StructureMapGroupRuleDependentComponent = "http://hl7.org/fhir/StructureMapGroupRuleDependentComponent";
var relationshipType = "http://hl7.org/fhir/relationshipType";
var _statement = "http://hl7.org/fhir/_statement";
var _Goal = "http://hl7.org/fhir/_Goal";
var issued2 = "http://hl7.org/fhir/issued";
var _instruction = "http://hl7.org/fhir/_instruction";
var inclusionCriteria = "http://hl7.org/fhir/inclusionCriteria";
var about = "http://hl7.org/fhir/about";
var Practitioner = "http://hl7.org/fhir/Practitioner";
var prognosisCodeableConcept = "http://hl7.org/fhir/prognosisCodeableConcept";
var AdverseEventParticipantComponent = "http://hl7.org/fhir/AdverseEventParticipantComponent";
var _maxValue = "http://hl7.org/fhir/_maxValue";
var ItemDetail = "http://hl7.org/fhir/ItemDetail";
var _hasBodySite = "http://hl7.org/fhir/_hasBodySite";
var _metadata = "http://hl7.org/fhir/_metadata";
var rejectionCriterion = "http://hl7.org/fhir/rejectionCriterion";
var cors = "http://hl7.org/fhir/cors";
var _option = "http://hl7.org/fhir/_option";
var TypeRefComponent = "http://hl7.org/fhir/TypeRefComponent";
var minValue = "http://hl7.org/fhir/minValue";
var _tuesday = "http://hl7.org/fhir/_tuesday";
var _offset = "http://hl7.org/fhir/_offset";
var report = "http://hl7.org/fhir/report";
var _fhirPathCriteria = "http://hl7.org/fhir/_fhirPathCriteria";
var editor = "http://hl7.org/fhir/editor";
var _firstDose = "http://hl7.org/fhir/_firstDose";
var procedureSequence = "http://hl7.org/fhir/procedureSequence";
var MedicinalProductDefinitionContactComponent = "http://hl7.org/fhir/MedicinalProductDefinitionContactComponent";
var _Communication = "http://hl7.org/fhir/_Communication";
var _controller = "http://hl7.org/fhir/_controller";
var TestScriptSetupActionAssertRequirementComponent = "http://hl7.org/fhir/TestScriptSetupActionAssertRequirementComponent";
var _allocation = "http://hl7.org/fhir/_allocation";
var otherTherapy = "http://hl7.org/fhir/otherTherapy";
var _requestedLocation = "http://hl7.org/fhir/_requestedLocation";
var _referencedFrom = "http://hl7.org/fhir/_referencedFrom";
var eventsSinceSubscriptionStart = "http://hl7.org/fhir/eventsSinceSubscriptionStart";
var _question = "http://hl7.org/fhir/_question";
var _drugCharacteristic = "http://hl7.org/fhir/_drugCharacteristic";
var _total = "http://hl7.org/fhir/_total";
var AuditEvent = "http://hl7.org/fhir/AuditEvent";
var _environmentType = "http://hl7.org/fhir/_environmentType";
var AssetContext = "http://hl7.org/fhir/AssetContext";
var _rangeCategory = "http://hl7.org/fhir/_rangeCategory";
var Location2 = "http://hl7.org/fhir/Location";
var rank = "http://hl7.org/fhir/rank";
var PlanDefinitionActionComponentActionAction = "http://hl7.org/fhir/PlanDefinitionActionComponentActionAction";
var _occurrenceCount = "http://hl7.org/fhir/_occurrenceCount";
var entryType = "http://hl7.org/fhir/entryType";
var _trigger = "http://hl7.org/fhir/_trigger";
var _contextInvariant = "http://hl7.org/fhir/_contextInvariant";
var id2 = "http://hl7.org/fhir/id";
var _productionIdentifierInUDI = "http://hl7.org/fhir/_productionIdentifierInUDI";
var _variable = "http://hl7.org/fhir/_variable";
var occurrence = "http://hl7.org/fhir/occurrence";
var dayOfMonth = "http://hl7.org/fhir/dayOfMonth";
var _maxDosePerPeriod = "http://hl7.org/fhir/_maxDosePerPeriod";
var _MeasureReport = "http://hl7.org/fhir/_MeasureReport";
var MedicationKnowledgeCostComponent = "http://hl7.org/fhir/MedicationKnowledgeCostComponent";
var uuid = "http://hl7.org/fhir/uuid";
var _range = "http://hl7.org/fhir/_range";
var related = "http://hl7.org/fhir/related";
var endpoint = "http://hl7.org/fhir/endpoint";
var ValueSetExpansionParameterComponent = "http://hl7.org/fhir/ValueSetExpansionParameterComponent";
var _logMessage = "http://hl7.org/fhir/_logMessage";
var SubscriptionTopicResourceTriggerQueryCriteriaComponent = "http://hl7.org/fhir/SubscriptionTopicResourceTriggerQueryCriteriaComponent";
var _supportingImmunization = "http://hl7.org/fhir/_supportingImmunization";
var StructureMapConstComponent = "http://hl7.org/fhir/StructureMapConstComponent";
var NutritionIntakeConsumedItemComponent = "http://hl7.org/fhir/NutritionIntakeConsumedItemComponent";
var PlanDefinitionGoalComponent = "http://hl7.org/fhir/PlanDefinitionGoalComponent";
var precondition = "http://hl7.org/fhir/precondition";
var _CoverageEligibilityResponse = "http://hl7.org/fhir/_CoverageEligibilityResponse";
var _duration = "http://hl7.org/fhir/_duration";
var _routeOfAdministration = "http://hl7.org/fhir/_routeOfAdministration";
var _legallyBinding = "http://hl7.org/fhir/_legallyBinding";
var rendering = "http://hl7.org/fhir/rendering";
var _hierarchical = "http://hl7.org/fhir/_hierarchical";
var _nameType = "http://hl7.org/fhir/_nameType";
var _businessStatus = "http://hl7.org/fhir/_businessStatus";
var _maxLength = "http://hl7.org/fhir/_maxLength";
var SubstancePolymerRepeatComponent = "http://hl7.org/fhir/SubstancePolymerRepeatComponent";
var responsibleParty = "http://hl7.org/fhir/responsibleParty";
var BundleEntryComponent = "http://hl7.org/fhir/BundleEntryComponent";
var _input = "http://hl7.org/fhir/_input";
var _languageCode = "http://hl7.org/fhir/_languageCode";
var _patient = "http://hl7.org/fhir/_patient";
var direction = "http://hl7.org/fhir/direction";
var _publicationDateSeason = "http://hl7.org/fhir/_publicationDateSeason";
var maritalStatus = "http://hl7.org/fhir/maritalStatus";
var AllergyIntoleranceReactionComponent = "http://hl7.org/fhir/AllergyIntoleranceReactionComponent";
var _observer = "http://hl7.org/fhir/_observer";
var SubscriptionParameterComponent = "http://hl7.org/fhir/SubscriptionParameterComponent";
var doseAdministrationAid = "http://hl7.org/fhir/doseAdministrationAid";
var DeviceDefinitionClassificationComponent = "http://hl7.org/fhir/DeviceDefinitionClassificationComponent";
var _measure = "http://hl7.org/fhir/_measure";
var _maxDosePerAdministration = "http://hl7.org/fhir/_maxDosePerAdministration";
var CompositionAttesterComponent = "http://hl7.org/fhir/CompositionAttesterComponent";
var _valueFilter = "http://hl7.org/fhir/_valueFilter";
var studyDesign = "http://hl7.org/fhir/studyDesign";
var _relation = "http://hl7.org/fhir/_relation";
var _priority = "http://hl7.org/fhir/_priority";
var MessageDefinition = "http://hl7.org/fhir/MessageDefinition";
var _description = "http://hl7.org/fhir/_description";
var TestPlanTestCaseTestDataComponent = "http://hl7.org/fhir/TestPlanTestCaseTestDataComponent";
var HealthcareServiceEligibilityComponent = "http://hl7.org/fhir/HealthcareServiceEligibilityComponent";
var category = "http://hl7.org/fhir/category";
var Details = "http://hl7.org/fhir/Details";
var verificationDate = "http://hl7.org/fhir/verificationDate";
var ExampleScenarioActorComponent = "http://hl7.org/fhir/ExampleScenarioActorComponent";
var _specimenQuantity = "http://hl7.org/fhir/_specimenQuantity";
var DeviceDefinitionPackagingComponent = "http://hl7.org/fhir/DeviceDefinitionPackagingComponent";
var autocreate = "http://hl7.org/fhir/autocreate";
var _structuralRepresentation = "http://hl7.org/fhir/_structuralRepresentation";
var agent2 = "http://hl7.org/fhir/agent";
var _request = "http://hl7.org/fhir/_request";
var _deliverTo = "http://hl7.org/fhir/_deliverTo";
var _textConcentration = "http://hl7.org/fhir/_textConcentration";
var benefitPeriod = "http://hl7.org/fhir/benefitPeriod";
var SpecimenDefinitionTypeTestedContainerComponent = "http://hl7.org/fhir/SpecimenDefinitionTypeTestedContainerComponent";
var ServiceRequestPatientInstructionComponent = "http://hl7.org/fhir/ServiceRequestPatientInstructionComponent";
var _adjustment = "http://hl7.org/fhir/_adjustment";
var _guidance = "http://hl7.org/fhir/_guidance";
var productReference = "http://hl7.org/fhir/productReference";
var _for = "http://hl7.org/fhir/_for";
var _intended = "http://hl7.org/fhir/_intended";
var _additionalUse = "http://hl7.org/fhir/_additionalUse";
var MetadataResource = "http://hl7.org/fhir/MetadataResource";
var _startingSequence = "http://hl7.org/fhir/_startingSequence";
var MedicationStatement = "http://hl7.org/fhir/MedicationStatement";
var medium2 = "http://hl7.org/fhir/medium";
var _baseUnit = "http://hl7.org/fhir/_baseUnit";
var _doseStatusReason = "http://hl7.org/fhir/_doseStatusReason";
var unitOfPresentation = "http://hl7.org/fhir/unitOfPresentation";
var CareTeam = "http://hl7.org/fhir/CareTeam";
var sourceSignature = "http://hl7.org/fhir/sourceSignature";
var availableStartTime = "http://hl7.org/fhir/availableStartTime";
var _effectiveDate = "http://hl7.org/fhir/_effectiveDate";
var _relevantHistory = "http://hl7.org/fhir/_relevantHistory";
var ParametersParameterComponent = "http://hl7.org/fhir/ParametersParameterComponent";
var MessageDefinitionFocusComponent = "http://hl7.org/fhir/MessageDefinitionFocusComponent";
var EnrollmentResponse = "http://hl7.org/fhir/EnrollmentResponse";
var ListEntryComponent = "http://hl7.org/fhir/ListEntryComponent";
var _subset = "http://hl7.org/fhir/_subset";
var dimensions = "http://hl7.org/fhir/dimensions";
var _function = "http://hl7.org/fhir/_function";
var recommendation = "http://hl7.org/fhir/recommendation";
var _prescription = "http://hl7.org/fhir/_prescription";
var prognosisReference = "http://hl7.org/fhir/prognosisReference";
var _hint = "http://hl7.org/fhir/_hint";
var _ownedBy = "http://hl7.org/fhir/_ownedBy";
var measurementFrequency = "http://hl7.org/fhir/measurementFrequency";
var _traceNumber = "http://hl7.org/fhir/_traceNumber";
var _excludingDate = "http://hl7.org/fhir/_excludingDate";
var _required = "http://hl7.org/fhir/_required";
var correctiveAction = "http://hl7.org/fhir/correctiveAction";
var schedule = "http://hl7.org/fhir/schedule";
var _referral = "http://hl7.org/fhir/_referral";
var alternate = "http://hl7.org/fhir/alternate";
var intendedExposure = "http://hl7.org/fhir/intendedExposure";
var threePrime = "http://hl7.org/fhir/threePrime";
var param = "http://hl7.org/fhir/param";
var _proposedNewTime = "http://hl7.org/fhir/_proposedNewTime";
var power = "http://hl7.org/fhir/power";
var cardinalityBehavior = "http://hl7.org/fhir/cardinalityBehavior";
var supportingPatientInformation = "http://hl7.org/fhir/supportingPatientInformation";
var _predecessor = "http://hl7.org/fhir/_predecessor";
var allergenicIndicator = "http://hl7.org/fhir/allergenicIndicator";
var _regulator = "http://hl7.org/fhir/_regulator";
var issue = "http://hl7.org/fhir/issue";
var _admission = "http://hl7.org/fhir/_admission";
var _extension = "http://hl7.org/fhir/_extension";
var _notificationShape = "http://hl7.org/fhir/_notificationShape";
var Device = "http://hl7.org/fhir/Device";
var Range = "http://hl7.org/fhir/Range";
var ItemBodySite = "http://hl7.org/fhir/ItemBodySite";
var average = "http://hl7.org/fhir/average";
var SubstanceNucleicAcidSubunitSugarComponent = "http://hl7.org/fhir/SubstanceNucleicAcidSubunitSugarComponent";
var Composition = "http://hl7.org/fhir/Composition";
var _otherMap = "http://hl7.org/fhir/_otherMap";
var Rule = "http://hl7.org/fhir/Rule";
var testScript = "http://hl7.org/fhir/testScript";
var targetId = "http://hl7.org/fhir/targetId";
var _additionalAttribute = "http://hl7.org/fhir/_additionalAttribute";
var _validity = "http://hl7.org/fhir/_validity";
var _product = "http://hl7.org/fhir/_product";
var objective = "http://hl7.org/fhir/objective";
var _containedItem = "http://hl7.org/fhir/_containedItem";
var MedicationKnowledgePackagingComponentCost = "http://hl7.org/fhir/MedicationKnowledgePackagingComponentCost";
var relatedDevice = "http://hl7.org/fhir/relatedDevice";
var QuestionnaireItemEnableWhenComponent = "http://hl7.org/fhir/QuestionnaireItemEnableWhenComponent";
var _numberAffected = "http://hl7.org/fhir/_numberAffected";
var _batch = "http://hl7.org/fhir/_batch";
var preparationInstruction = "http://hl7.org/fhir/preparationInstruction";
var EpisodeOfCare = "http://hl7.org/fhir/EpisodeOfCare";
var _entity = "http://hl7.org/fhir/_entity";
var _initiator = "http://hl7.org/fhir/_initiator";
var _communication = "http://hl7.org/fhir/_communication";
var programEligibility = "http://hl7.org/fhir/programEligibility";
var addItem = "http://hl7.org/fhir/addItem";
var _details = "http://hl7.org/fhir/_details";
var pageString = "http://hl7.org/fhir/pageString";
var expansion = "http://hl7.org/fhir/expansion";
var MedicationKnowledgeRegulatoryComponent = "http://hl7.org/fhir/MedicationKnowledgeRegulatoryComponent";
var _affiliation = "http://hl7.org/fhir/_affiliation";
var _contentDefinition = "http://hl7.org/fhir/_contentDefinition";
var marketPeriod = "http://hl7.org/fhir/marketPeriod";
var _reportingPeriod = "http://hl7.org/fhir/_reportingPeriod";
var _accountNumber = "http://hl7.org/fhir/_accountNumber";
var _geneSequenceOrigin = "http://hl7.org/fhir/_geneSequenceOrigin";
var subpotentReason = "http://hl7.org/fhir/subpotentReason";
var inventoryStatus = "http://hl7.org/fhir/inventoryStatus";
var subunit = "http://hl7.org/fhir/subunit";
var orderer = "http://hl7.org/fhir/orderer";
var ExampleScenarioInstanceVersionComponent = "http://hl7.org/fhir/ExampleScenarioInstanceVersionComponent";
var itemStatus = "http://hl7.org/fhir/itemStatus";
var _ResearchStudy = "http://hl7.org/fhir/_ResearchStudy";
var resourceType = "http://hl7.org/fhir/resourceType";
var Quantity = "http://hl7.org/fhir/Quantity";
var contained = "http://hl7.org/fhir/contained";
var _appointmentType = "http://hl7.org/fhir/_appointmentType";
var SpecimenDefinitionTypeTestedComponent = "http://hl7.org/fhir/SpecimenDefinitionTypeTestedComponent";
var _actual = "http://hl7.org/fhir/_actual";
var CostToBeneficiary = "http://hl7.org/fhir/CostToBeneficiary";
var _Schedule = "http://hl7.org/fhir/_Schedule";
var programCode = "http://hl7.org/fhir/programCode";
var _PractitionerRole = "http://hl7.org/fhir/_PractitionerRole";
var guarantor = "http://hl7.org/fhir/guarantor";
var _FamilyMemberHistory = "http://hl7.org/fhir/_FamilyMemberHistory";
var _operationTypeReason = "http://hl7.org/fhir/_operationTypeReason";
var _programStatus = "http://hl7.org/fhir/_programStatus";
var _performerLinkId = "http://hl7.org/fhir/_performerLinkId";
var onHold = "http://hl7.org/fhir/onHold";
var _copackagedIndicator = "http://hl7.org/fhir/_copackagedIndicator";
var storageGuideline = "http://hl7.org/fhir/storageGuideline";
var _receiver = "http://hl7.org/fhir/_receiver";
var _whyStopped = "http://hl7.org/fhir/_whyStopped";
var _packageFor = "http://hl7.org/fhir/_packageFor";
var action2 = "http://hl7.org/fhir/action";
var _sourceMaterialState = "http://hl7.org/fhir/_sourceMaterialState";
var indicationGuideline = "http://hl7.org/fhir/indicationGuideline";
var _interaction = "http://hl7.org/fhir/_interaction";
var aggregateMethod = "http://hl7.org/fhir/aggregateMethod";
var _authorizingPrescription = "http://hl7.org/fhir/_authorizingPrescription";
var _authoritative = "http://hl7.org/fhir/_authoritative";
var timeAspect = "http://hl7.org/fhir/timeAspect";
var _valueSet = "http://hl7.org/fhir/_valueSet";
var OperationOutcome = "http://hl7.org/fhir/OperationOutcome";
var Contributor = "http://hl7.org/fhir/Contributor";
var _message = "http://hl7.org/fhir/_message";
var import__workaround = "http://hl7.org/fhir/import";
var definitionByTypeAndValue = "http://hl7.org/fhir/definitionByTypeAndValue";
var TestScriptSetupActionOperationComponent = "http://hl7.org/fhir/TestScriptSetupActionOperationComponent";
var mitigatingAction = "http://hl7.org/fhir/mitigatingAction";
var validationDate = "http://hl7.org/fhir/validationDate";
var healthcareService = "http://hl7.org/fhir/healthcareService";
var conditionalPatch = "http://hl7.org/fhir/conditionalPatch";
var minimumVolume = "http://hl7.org/fhir/minimumVolume";
var _practiceSetting = "http://hl7.org/fhir/_practiceSetting";
var protocol2 = "http://hl7.org/fhir/protocol";
var _structureProfile = "http://hl7.org/fhir/_structureProfile";
var _Coverage = "http://hl7.org/fhir/_Coverage";
var _issuerType = "http://hl7.org/fhir/_issuerType";
var MedicationRequest = "http://hl7.org/fhir/MedicationRequest";
var _pattern = "http://hl7.org/fhir/_pattern";
var processingFacility = "http://hl7.org/fhir/processingFacility";
var _situation = "http://hl7.org/fhir/_situation";
var _patchFormat = "http://hl7.org/fhir/_patchFormat";
var alternateMaterial = "http://hl7.org/fhir/alternateMaterial";
var responsible = "http://hl7.org/fhir/responsible";
var PlanDefinitionActionRelatedActionComponent = "http://hl7.org/fhir/PlanDefinitionActionRelatedActionComponent";
var _security = "http://hl7.org/fhir/_security";
var combined = "http://hl7.org/fhir/combined";
var contains = "http://hl7.org/fhir/contains";
var _addresses = "http://hl7.org/fhir/_addresses";
var expirationDate = "http://hl7.org/fhir/expirationDate";
var compartment = "http://hl7.org/fhir/compartment";
var _scoring = "http://hl7.org/fhir/_scoring";
var policy = "http://hl7.org/fhir/policy";
var recordedDate = "http://hl7.org/fhir/recordedDate";
var _sourceScope = "http://hl7.org/fhir/_sourceScope";
var _chain = "http://hl7.org/fhir/_chain";
var ImplementationGuideManifestComponent = "http://hl7.org/fhir/ImplementationGuideManifestComponent";
var _contributedToDeath = "http://hl7.org/fhir/_contributedToDeath";
var _diagnosisRelatedGroup = "http://hl7.org/fhir/_diagnosisRelatedGroup";
var _referenceNumber = "http://hl7.org/fhir/_referenceNumber";
var _template = "http://hl7.org/fhir/_template";
var _preConditions = "http://hl7.org/fhir/_preConditions";
var _score = "http://hl7.org/fhir/_score";
var SubstancePolymerMonomerSetComponent = "http://hl7.org/fhir/SubstancePolymerMonomerSetComponent";
var _requiredBehavior = "http://hl7.org/fhir/_requiredBehavior";
var _statusHistory = "http://hl7.org/fhir/_statusHistory";
var replacementSequence = "http://hl7.org/fhir/replacementSequence";
var _file = "http://hl7.org/fhir/_file";
var _height = "http://hl7.org/fhir/_height";
var _groupSize = "http://hl7.org/fhir/_groupSize";
var observedGroup = "http://hl7.org/fhir/observedGroup";
var receivedTime = "http://hl7.org/fhir/receivedTime";
var _doseAndRate = "http://hl7.org/fhir/_doseAndRate";
var definitionCanonical = "http://hl7.org/fhir/definitionCanonical";
var QuestionnaireResponseItemComponent = "http://hl7.org/fhir/QuestionnaireResponseItemComponent";
var _typeReference = "http://hl7.org/fhir/_typeReference";
var PractitionerQualificationComponent = "http://hl7.org/fhir/PractitionerQualificationComponent";
var cTerminalModificationId = "http://hl7.org/fhir/cTerminalModificationId";
var _requireBoth = "http://hl7.org/fhir/_requireBoth";
var dataAbsentReason = "http://hl7.org/fhir/dataAbsentReason";
var _criticality = "http://hl7.org/fhir/_criticality";
var _subjectStatus = "http://hl7.org/fhir/_subjectStatus";
var _expiry = "http://hl7.org/fhir/_expiry";
var usage = "http://hl7.org/fhir/usage";
var city = "http://hl7.org/fhir/city";
var _instances = "http://hl7.org/fhir/_instances";
var stratum = "http://hl7.org/fhir/stratum";
var MeasureReportGroupStratifierComponent = "http://hl7.org/fhir/MeasureReportGroupStratifierComponent";
var _ratioHighLimitAmount = "http://hl7.org/fhir/_ratioHighLimitAmount";
var route = "http://hl7.org/fhir/route";
var TestScriptMetadataLinkComponent = "http://hl7.org/fhir/TestScriptMetadataLinkComponent";
var DeviceDispensePerformerComponent = "http://hl7.org/fhir/DeviceDispensePerformerComponent";
var frequencyMax = "http://hl7.org/fhir/frequencyMax";
var _number = "http://hl7.org/fhir/_number";
var QuestionnaireResponse = "http://hl7.org/fhir/QuestionnaireResponse";
var MappingProperty = "http://hl7.org/fhir/MappingProperty";
var _securityContext = "http://hl7.org/fhir/_securityContext";
var display = "http://hl7.org/fhir/display";
var yearlyTemplate = "http://hl7.org/fhir/yearlyTemplate";
var ChargeItemPerformerComponent = "http://hl7.org/fhir/ChargeItemPerformerComponent";
var Contact = "http://hl7.org/fhir/Contact";
var EndpointPayloadComponent = "http://hl7.org/fhir/EndpointPayloadComponent";
var _relatedArtifact = "http://hl7.org/fhir/_relatedArtifact";
var updateCreate = "http://hl7.org/fhir/updateCreate";
var _subtype = "http://hl7.org/fhir/_subtype";
var _stereochemistry = "http://hl7.org/fhir/_stereochemistry";
var _upperLimit = "http://hl7.org/fhir/_upperLimit";
var routeOfAdministration = "http://hl7.org/fhir/routeOfAdministration";
var _amountType = "http://hl7.org/fhir/_amountType";
var _organismType = "http://hl7.org/fhir/_organismType";
var bodySite = "http://hl7.org/fhir/bodySite";
var _moiety = "http://hl7.org/fhir/_moiety";
var _recommendation = "http://hl7.org/fhir/_recommendation";
var grouping = "http://hl7.org/fhir/grouping";
var _pause = "http://hl7.org/fhir/_pause";
var _primaryPurposeType = "http://hl7.org/fhir/_primaryPurposeType";
var ConceptSubProperty = "http://hl7.org/fhir/ConceptSubProperty";
var subscription = "http://hl7.org/fhir/subscription";
var _lastPage = "http://hl7.org/fhir/_lastPage";
var partLocation = "http://hl7.org/fhir/partLocation";
var controller = "http://hl7.org/fhir/controller";
var publicationDateSeason = "http://hl7.org/fhir/publicationDateSeason";
var imports = "http://hl7.org/fhir/imports";
var allocation = "http://hl7.org/fhir/allocation";
var _pageCount = "http://hl7.org/fhir/_pageCount";
var _failureAction = "http://hl7.org/fhir/_failureAction";
var profile = "http://hl7.org/fhir/profile";
var cylinder = "http://hl7.org/fhir/cylinder";
var deleted2 = "http://hl7.org/fhir/deleted";
var episodeOfCare = "http://hl7.org/fhir/episodeOfCare";
var saturday = "http://hl7.org/fhir/saturday";
var _expectedInResearchStudy = "http://hl7.org/fhir/_expectedInResearchStudy";
var CommunicationRequestPayloadComponent = "http://hl7.org/fhir/CommunicationRequestPayloadComponent";
var _calculatedAt = "http://hl7.org/fhir/_calculatedAt";
var _impurity = "http://hl7.org/fhir/_impurity";
var type3 = "http://hl7.org/fhir/type";
var goalId = "http://hl7.org/fhir/goalId";
var ObservationDefinitionComponentComponent = "http://hl7.org/fhir/ObservationDefinitionComponentComponent";
var TestScriptSetupComponent = "http://hl7.org/fhir/TestScriptSetupComponent";
var Appointment = "http://hl7.org/fhir/Appointment";
var _groupIdentifier = "http://hl7.org/fhir/_groupIdentifier";
var _countMax = "http://hl7.org/fhir/_countMax";
var patientCharacteristic = "http://hl7.org/fhir/patientCharacteristic";
var lowNumerator = "http://hl7.org/fhir/lowNumerator";
var _texture = "http://hl7.org/fhir/_texture";
var _causality = "http://hl7.org/fhir/_causality";
var operator = "http://hl7.org/fhir/operator";
var fixed = "http://hl7.org/fhir/fixed";
var nTerminalModificationId = "http://hl7.org/fhir/nTerminalModificationId";
var InventoryItemNameComponent = "http://hl7.org/fhir/InventoryItemNameComponent";
var _minimumId = "http://hl7.org/fhir/_minimumId";
var verificationStatus = "http://hl7.org/fhir/verificationStatus";
var _PaymentNotice = "http://hl7.org/fhir/_PaymentNotice";
var _dateAccessed = "http://hl7.org/fhir/_dateAccessed";
var logMessage = "http://hl7.org/fhir/logMessage";
var ResearchStudyProgressStatusComponent = "http://hl7.org/fhir/ResearchStudyProgressStatusComponent";
var _residueSite = "http://hl7.org/fhir/_residueSite";
var MonetaryComponent = "http://hl7.org/fhir/MonetaryComponent";
var TeardownAction = "http://hl7.org/fhir/TeardownAction";
var clinicalUseIssue = "http://hl7.org/fhir/clinicalUseIssue";
var classification = "http://hl7.org/fhir/classification";
var _lifecycleStatus = "http://hl7.org/fhir/_lifecycleStatus";
var signature = "http://hl7.org/fhir/signature";
var reviewer = "http://hl7.org/fhir/reviewer";
var _usePeriod = "http://hl7.org/fhir/_usePeriod";
var BodyStructureIncludedStructureComponent = "http://hl7.org/fhir/BodyStructureIncludedStructureComponent";
var next2 = "http://hl7.org/fhir/next";
var _changeType = "http://hl7.org/fhir/_changeType";
var _ImmunizationEvaluation = "http://hl7.org/fhir/_ImmunizationEvaluation";
var requestingOrganization = "http://hl7.org/fhir/requestingOrganization";
var _unitOfPresentation = "http://hl7.org/fhir/_unitOfPresentation";
var requestedPeriod = "http://hl7.org/fhir/requestedPeriod";
var Answer = "http://hl7.org/fhir/Answer";
var count = "http://hl7.org/fhir/count";
var ContractOffer = "http://hl7.org/fhir/ContractOffer";
var composition = "http://hl7.org/fhir/composition";
var _EnrollmentResponse = "http://hl7.org/fhir/_EnrollmentResponse";
var ConditionStageComponent = "http://hl7.org/fhir/ConditionStageComponent";
var ResearchSubjectProgressComponent = "http://hl7.org/fhir/ResearchSubjectProgressComponent";
var key = "http://hl7.org/fhir/key";
var assertion = "http://hl7.org/fhir/assertion";
var MedicationKnowledgeIndicationGuidelineDosingGuidelinePatientCharacteristicComponent = "http://hl7.org/fhir/MedicationKnowledgeIndicationGuidelineDosingGuidelinePatientCharacteristicComponent";
var alternative2 = "http://hl7.org/fhir/alternative";
var plan = "http://hl7.org/fhir/plan";
var _criteria = "http://hl7.org/fhir/_criteria";
var cycle = "http://hl7.org/fhir/cycle";
var _latitude = "http://hl7.org/fhir/_latitude";
var modifier = "http://hl7.org/fhir/modifier";
var _scoringUnit = "http://hl7.org/fhir/_scoringUnit";
var subJurisdiction = "http://hl7.org/fhir/subJurisdiction";
var _search = "http://hl7.org/fhir/_search";
var assignedComparisonGroup = "http://hl7.org/fhir/assignedComparisonGroup";
var _alias = "http://hl7.org/fhir/_alias";
var _status = "http://hl7.org/fhir/_status";
var recurring = "http://hl7.org/fhir/recurring";
var InventoryItemInstanceComponent = "http://hl7.org/fhir/InventoryItemInstanceComponent";
var frameOfReferenceUid = "http://hl7.org/fhir/frameOfReferenceUid";
var _validationDate = "http://hl7.org/fhir/_validationDate";
var NutritionOrderEnteralFormulaComponent = "http://hl7.org/fhir/NutritionOrderEnteralFormulaComponent";
var deliveryDevice = "http://hl7.org/fhir/deliveryDevice";
var _cardBrand = "http://hl7.org/fhir/_cardBrand";
var adjustment = "http://hl7.org/fhir/adjustment";
var _cors = "http://hl7.org/fhir/_cors";
var _allergenicIndicator = "http://hl7.org/fhir/_allergenicIndicator";
var _timezone = "http://hl7.org/fhir/_timezone";
var _actor = "http://hl7.org/fhir/_actor";
var valueQuantity = "http://hl7.org/fhir/valueQuantity";
var _versionId = "http://hl7.org/fhir/_versionId";
var requester = "http://hl7.org/fhir/requester";
var _SupplyRequest = "http://hl7.org/fhir/_SupplyRequest";
var MeasureTermComponent = "http://hl7.org/fhir/MeasureTermComponent";
var _containedItemQuantity = "http://hl7.org/fhir/_containedItemQuantity";
var _daysSupply = "http://hl7.org/fhir/_daysSupply";
var reportingVendor = "http://hl7.org/fhir/reportingVendor";
var current2 = "http://hl7.org/fhir/current";
var uid3 = "http://hl7.org/fhir/uid";
var order = "http://hl7.org/fhir/order";
var priorPrescription = "http://hl7.org/fhir/priorPrescription";
var distanceFromLandmark = "http://hl7.org/fhir/distanceFromLandmark";
var VerificationResultValidatorComponent = "http://hl7.org/fhir/VerificationResultValidatorComponent";
var _recurrenceTemplate = "http://hl7.org/fhir/_recurrenceTemplate";
var tenderedAmount = "http://hl7.org/fhir/tenderedAmount";
var _diseaseStatus = "http://hl7.org/fhir/_diseaseStatus";
var _expirationDate = "http://hl7.org/fhir/_expirationDate";
var _dataPeriod = "http://hl7.org/fhir/_dataPeriod";
var note = "http://hl7.org/fhir/note";
var _manipulated = "http://hl7.org/fhir/_manipulated";
var _Invoice = "http://hl7.org/fhir/_Invoice";
var RatioRange = "http://hl7.org/fhir/RatioRange";
var _requisition = "http://hl7.org/fhir/_requisition";
var ClinicalImpression = "http://hl7.org/fhir/ClinicalImpression";
var _claim = "http://hl7.org/fhir/_claim";
var need = "http://hl7.org/fhir/need";
var contributor3 = "http://hl7.org/fhir/contributor";
var ConceptProperty = "http://hl7.org/fhir/ConceptProperty";
var ConsentVerificationComponent = "http://hl7.org/fhir/ConsentVerificationComponent";
var TestReportTeardownComponent = "http://hl7.org/fhir/TestReportTeardownComponent";
var _genus = "http://hl7.org/fhir/_genus";
var extraDetails = "http://hl7.org/fhir/extraDetails";
var _location = "http://hl7.org/fhir/_location";
var _reported = "http://hl7.org/fhir/_reported";
var _codeMap = "http://hl7.org/fhir/_codeMap";
var firstPage = "http://hl7.org/fhir/firstPage";
var _setup = "http://hl7.org/fhir/_setup";
var _paymentBy = "http://hl7.org/fhir/_paymentBy";
var custodian = "http://hl7.org/fhir/custodian";
var estimatedAge = "http://hl7.org/fhir/estimatedAge";
var _observation = "http://hl7.org/fhir/_observation";
var technique = "http://hl7.org/fhir/technique";
var Requirements = "http://hl7.org/fhir/Requirements";
var supplementalData = "http://hl7.org/fhir/supplementalData";
var SimpleQuantity = "http://hl7.org/fhir/SimpleQuantity";
var ProvenanceEntityComponent = "http://hl7.org/fhir/ProvenanceEntityComponent";
var condition = "http://hl7.org/fhir/condition";
var excludeFoodModifier = "http://hl7.org/fhir/excludeFoodModifier";
var coverageArea = "http://hl7.org/fhir/coverageArea";
var contributionInstance = "http://hl7.org/fhir/contributionInstance";
var _productCode = "http://hl7.org/fhir/_productCode";
var _language = "http://hl7.org/fhir/_language";
var base = "http://hl7.org/fhir/base";
var _windowStart = "http://hl7.org/fhir/_windowStart";
var district = "http://hl7.org/fhir/district";
var forenameInitials = "http://hl7.org/fhir/forenameInitials";
var _state = "http://hl7.org/fhir/_state";
var friendly = "http://hl7.org/fhir/friendly";
var AdditionalAttribute = "http://hl7.org/fhir/AdditionalAttribute";
var _Transport = "http://hl7.org/fhir/_Transport";
var xhtml = "http://hl7.org/fhir/xhtml";
var _official = "http://hl7.org/fhir/_official";
var CodeSystemConceptDesignationComponent = "http://hl7.org/fhir/CodeSystemConceptDesignationComponent";
var _precedence = "http://hl7.org/fhir/_precedence";
var _result = "http://hl7.org/fhir/_result";
var _sliceName = "http://hl7.org/fhir/_sliceName";
var points = "http://hl7.org/fhir/points";
var finding = "http://hl7.org/fhir/finding";
var _yearlyTemplate = "http://hl7.org/fhir/_yearlyTemplate";
var _isModifierReason = "http://hl7.org/fhir/_isModifierReason";
var _experimental = "http://hl7.org/fhir/_experimental";
var _overbooked = "http://hl7.org/fhir/_overbooked";
var ExampleScenario = "http://hl7.org/fhir/ExampleScenario";
var AvailabilityNotAvailableTimeComponent = "http://hl7.org/fhir/AvailabilityNotAvailableTimeComponent";
var derivedFrom = "http://hl7.org/fhir/derivedFrom";
var _postalCode = "http://hl7.org/fhir/_postalCode";
var _endorser = "http://hl7.org/fhir/_endorser";
var modifierExtension = "http://hl7.org/fhir/modifierExtension";
var verified = "http://hl7.org/fhir/verified";
var warning = "http://hl7.org/fhir/warning";
var _color = "http://hl7.org/fhir/_color";
var _global = "http://hl7.org/fhir/_global";
var _policyBasis = "http://hl7.org/fhir/_policyBasis";
var timeFromEvent = "http://hl7.org/fhir/timeFromEvent";
var costToBeneficiary = "http://hl7.org/fhir/costToBeneficiary";
var Questionnaire = "http://hl7.org/fhir/Questionnaire";
var _FormularyItem = "http://hl7.org/fhir/_FormularyItem";
var _permittedUnit = "http://hl7.org/fhir/_permittedUnit";
var data = "http://hl7.org/fhir/data";
var _targetItem = "http://hl7.org/fhir/_targetItem";
var whyStopped = "http://hl7.org/fhir/whyStopped";
var _practitioner = "http://hl7.org/fhir/_practitioner";
var packageFor = "http://hl7.org/fhir/packageFor";
var _informationSource = "http://hl7.org/fhir/_informationSource";
var hasMember = "http://hl7.org/fhir/hasMember";
var _paymentIdentifier = "http://hl7.org/fhir/_paymentIdentifier";
var allowedType = "http://hl7.org/fhir/allowedType";
var _intraspecificType = "http://hl7.org/fhir/_intraspecificType";
var _isDefault = "http://hl7.org/fhir/_isDefault";
var _supportedProfile = "http://hl7.org/fhir/_supportedProfile";
var _authored = "http://hl7.org/fhir/_authored";
var stabilityDuration = "http://hl7.org/fhir/stabilityDuration";
var InsurancePlanCoverageBenefitLimitComponent = "http://hl7.org/fhir/InsurancePlanCoverageBenefitLimitComponent";
var compareToSourcePath = "http://hl7.org/fhir/compareToSourcePath";
var _dosageInstruction = "http://hl7.org/fhir/_dosageInstruction";
var sequence2 = "http://hl7.org/fhir/sequence";
var revenue = "http://hl7.org/fhir/revenue";
var SystemInteraction = "http://hl7.org/fhir/SystemInteraction";
var SubscriptionFilterByComponent = "http://hl7.org/fhir/SubscriptionFilterByComponent";
var _requirement = "http://hl7.org/fhir/_requirement";
var _reliableCache = "http://hl7.org/fhir/_reliableCache";
var nextScheduled = "http://hl7.org/fhir/nextScheduled";
var MeasureGroupComponent = "http://hl7.org/fhir/MeasureGroupComponent";
var processNote = "http://hl7.org/fhir/processNote";
var StratifierGroupPopulation = "http://hl7.org/fhir/StratifierGroupPopulation";
var issuerType = "http://hl7.org/fhir/issuerType";
var capacity = "http://hl7.org/fhir/capacity";
var _rendering = "http://hl7.org/fhir/_rendering";
var TestScriptTeardownComponent = "http://hl7.org/fhir/TestScriptTeardownComponent";
var requestIdentifier = "http://hl7.org/fhir/requestIdentifier";
var _definitionCanonical = "http://hl7.org/fhir/_definitionCanonical";
var v = "http://hl7.org/fhir/v";
var _classification = "http://hl7.org/fhir/_classification";
var Claim = "http://hl7.org/fhir/Claim";
var asNeeded = "http://hl7.org/fhir/asNeeded";
var defaultManualCompletion = "http://hl7.org/fhir/defaultManualCompletion";
var partDescription = "http://hl7.org/fhir/partDescription";
var articleDate = "http://hl7.org/fhir/articleDate";
var narrative = "http://hl7.org/fhir/narrative";
var participant2 = "http://hl7.org/fhir/participant";
var incidence = "http://hl7.org/fhir/incidence";
var div = "http://hl7.org/fhir/div";
var _versioning = "http://hl7.org/fhir/_versioning";
var RelatedClaim = "http://hl7.org/fhir/RelatedClaim";
var _page = "http://hl7.org/fhir/_page";
var appointment = "http://hl7.org/fhir/appointment";
var AuditEventEntityDetailComponent = "http://hl7.org/fhir/AuditEventEntityDetailComponent";
var productionIdentifierInUDI = "http://hl7.org/fhir/productionIdentifierInUDI";
var _photo = "http://hl7.org/fhir/_photo";
var formOf = "http://hl7.org/fhir/formOf";
var referrer = "http://hl7.org/fhir/referrer";
var _subdetailSequence = "http://hl7.org/fhir/_subdetailSequence";
var CareTeamParticipantComponent = "http://hl7.org/fhir/CareTeamParticipantComponent";
var SpecimenDefinition = "http://hl7.org/fhir/SpecimenDefinition";
var _affectsState = "http://hl7.org/fhir/_affectsState";
var _inputPopulationId = "http://hl7.org/fhir/_inputPopulationId";
var outputProfile = "http://hl7.org/fhir/outputProfile";
var MessageDefinitionAllowedResponseComponent = "http://hl7.org/fhir/MessageDefinitionAllowedResponseComponent";
var numberOfInstances = "http://hl7.org/fhir/numberOfInstances";
var Term2 = "http://hl7.org/fhir/Term";
var supportingImmunization = "http://hl7.org/fhir/supportingImmunization";
var previousAppointment = "http://hl7.org/fhir/previousAppointment";
var seriesDoses = "http://hl7.org/fhir/seriesDoses";
var propertyGroup = "http://hl7.org/fhir/propertyGroup";
var option = "http://hl7.org/fhir/option";
var component = "http://hl7.org/fhir/component";
var offset = "http://hl7.org/fhir/offset";
var materialType = "http://hl7.org/fhir/materialType";
var marketingAuthorizationHolder = "http://hl7.org/fhir/marketingAuthorizationHolder";
var requestedPerformer = "http://hl7.org/fhir/requestedPerformer";
var developmentStage = "http://hl7.org/fhir/developmentStage";
var _deliveryDevice = "http://hl7.org/fhir/_deliveryDevice";
var _Timing = "http://hl7.org/fhir/_Timing";
var AdverseEventSuspectEntityCausalityComponent = "http://hl7.org/fhir/AdverseEventSuspectEntityCausalityComponent";
var add = "http://hl7.org/fhir/add";
var ImmunizationPerformerComponent = "http://hl7.org/fhir/ImmunizationPerformerComponent";
var _BodyStructure = "http://hl7.org/fhir/_BodyStructure";
var _organismName = "http://hl7.org/fhir/_organismName";
var _monthlyTemplate = "http://hl7.org/fhir/_monthlyTemplate";
var versionAlgorithm = "http://hl7.org/fhir/versionAlgorithm";
var _deliverFor = "http://hl7.org/fhir/_deliverFor";
var ElementDefinitionSlicingComponent = "http://hl7.org/fhir/ElementDefinitionSlicingComponent";
var _responseId = "http://hl7.org/fhir/_responseId";
var _tenderedAmount = "http://hl7.org/fhir/_tenderedAmount";
var upperLimit = "http://hl7.org/fhir/upperLimit";
var _verificationStatus = "http://hl7.org/fhir/_verificationStatus";
var amountType = "http://hl7.org/fhir/amountType";
var _patientPaid = "http://hl7.org/fhir/_patientPaid";
var RequestOrchestrationActionOutputComponent = "http://hl7.org/fhir/RequestOrchestrationActionOutputComponent";
var _quantity = "http://hl7.org/fhir/_quantity";
var InsurancePlanPlanSpecificCostBenefitCostComponent = "http://hl7.org/fhir/InsurancePlanPlanSpecificCostBenefitCostComponent";
var _alternate = "http://hl7.org/fhir/_alternate";
var _contributingFactor = "http://hl7.org/fhir/_contributingFactor";
var _sourceIdentityCertificate = "http://hl7.org/fhir/_sourceIdentityCertificate";
var eventNumber = "http://hl7.org/fhir/eventNumber";
var AdministrableProductDefinitionPropertyComponent = "http://hl7.org/fhir/AdministrableProductDefinitionPropertyComponent";
var responseRequired = "http://hl7.org/fhir/responseRequired";
var _verifiedBy = "http://hl7.org/fhir/_verifiedBy";
var _maritalStatus = "http://hl7.org/fhir/_maritalStatus";
var _timeOfDay = "http://hl7.org/fhir/_timeOfDay";
var contraindication = "http://hl7.org/fhir/contraindication";
var patientPreparation = "http://hl7.org/fhir/patientPreparation";
var _expression = "http://hl7.org/fhir/_expression";
var _min = "http://hl7.org/fhir/_min";
var _attester = "http://hl7.org/fhir/_attester";
var _progress = "http://hl7.org/fhir/_progress";
var _collection = "http://hl7.org/fhir/_collection";
var base64Binary = "http://hl7.org/fhir/base64Binary";
var ExampleScenarioProcessStepComponent = "http://hl7.org/fhir/ExampleScenarioProcessStepComponent";
var _comprisedOf = "http://hl7.org/fhir/_comprisedOf";
var _factor = "http://hl7.org/fhir/_factor";
var _endRelationship = "http://hl7.org/fhir/_endRelationship";
var _startingMaterial = "http://hl7.org/fhir/_startingMaterial";
var expectedSupplyDuration = "http://hl7.org/fhir/expectedSupplyDuration";
var totalPriceComponent = "http://hl7.org/fhir/totalPriceComponent";
var _signer = "http://hl7.org/fhir/_signer";
var enableBehavior = "http://hl7.org/fhir/enableBehavior";
var Contract = "http://hl7.org/fhir/Contract";
var _cTerminalModificationId = "http://hl7.org/fhir/_cTerminalModificationId";
var ObservationReferenceRangeComponent = "http://hl7.org/fhir/ObservationReferenceRangeComponent";
var maxVolumeToDeliver = "http://hl7.org/fhir/maxVolumeToDeliver";
var CapabilityStatementRestResourceOperationComponent = "http://hl7.org/fhir/CapabilityStatementRestResourceOperationComponent";
var isDerived = "http://hl7.org/fhir/isDerived";
var conditionalUpdate = "http://hl7.org/fhir/conditionalUpdate";
var repeatUnitAmountType = "http://hl7.org/fhir/repeatUnitAmountType";
var subjects = "http://hl7.org/fhir/subjects";
var EvidenceVariableCharacteristicTimeFromEventComponent = "http://hl7.org/fhir/EvidenceVariableCharacteristicTimeFromEventComponent";
var _expansion = "http://hl7.org/fhir/_expansion";
var _Ingredient = "http://hl7.org/fhir/_Ingredient";
var _phase = "http://hl7.org/fhir/_phase";
var _benefitPeriod = "http://hl7.org/fhir/_benefitPeriod";
var Organization2 = "http://hl7.org/fhir/Organization";
var _referenceStrength = "http://hl7.org/fhir/_referenceStrength";
var StructureMapGroupComponent = "http://hl7.org/fhir/StructureMapGroupComponent";
var referencePolicy = "http://hl7.org/fhir/referencePolicy";
var previous = "http://hl7.org/fhir/previous";
var _stage = "http://hl7.org/fhir/_stage";
var PlanDefinitionActionOutputComponent = "http://hl7.org/fhir/PlanDefinitionActionOutputComponent";
var _publisherLocation = "http://hl7.org/fhir/_publisherLocation";
var MedicationKnowledgeIndicationGuidelineDosingGuidelineDosageComponent = "http://hl7.org/fhir/MedicationKnowledgeIndicationGuidelineDosingGuidelineDosageComponent";
var containedItemQuantity = "http://hl7.org/fhir/containedItemQuantity";
var copyrightLabel = "http://hl7.org/fhir/copyrightLabel";
var BodyStructureIncludedStructureBodyLandmarkOrientationComponent = "http://hl7.org/fhir/BodyStructureIncludedStructureBodyLandmarkOrientationComponent";
var hasBodySite = "http://hl7.org/fhir/hasBodySite";
var _valuedItem = "http://hl7.org/fhir/_valuedItem";
var Period2 = "http://hl7.org/fhir/Period";
var questionnaire = "http://hl7.org/fhir/questionnaire";
var specificCost = "http://hl7.org/fhir/specificCost";
var _collected = "http://hl7.org/fhir/_collected";
var _notAvailableTime = "http://hl7.org/fhir/_notAvailableTime";
var AllergyIntoleranceParticipantComponent = "http://hl7.org/fhir/AllergyIntoleranceParticipantComponent";
var headerField = "http://hl7.org/fhir/headerField";
var _contained = "http://hl7.org/fhir/_contained";
var _assigner = "http://hl7.org/fhir/_assigner";
var _ifNoneMatch = "http://hl7.org/fhir/_ifNoneMatch";
var DeviceAssociationOperationComponent = "http://hl7.org/fhir/DeviceAssociationOperationComponent";
var _graph = "http://hl7.org/fhir/_graph";
var changeType = "http://hl7.org/fhir/changeType";
var _orientation = "http://hl7.org/fhir/_orientation";
var parentSubstanceId = "http://hl7.org/fhir/parentSubstanceId";
var recorded = "http://hl7.org/fhir/recorded";
var _contributionType = "http://hl7.org/fhir/_contributionType";
var filterParameter = "http://hl7.org/fhir/filterParameter";
var positiveInt = "http://hl7.org/fhir/positiveInt";
var docStatus = "http://hl7.org/fhir/docStatus";
var CoverageBenefit = "http://hl7.org/fhir/CoverageBenefit";
var durationUnit = "http://hl7.org/fhir/durationUnit";
var contentType = "http://hl7.org/fhir/contentType";
var _addItem = "http://hl7.org/fhir/_addItem";
var MedicationKnowledgeIndicationGuidelineDosingGuidelineComponent = "http://hl7.org/fhir/MedicationKnowledgeIndicationGuidelineDosingGuidelineComponent";
var dateRange = "http://hl7.org/fhir/dateRange";
var used = "http://hl7.org/fhir/used";
var _city = "http://hl7.org/fhir/_city";
var reaction = "http://hl7.org/fhir/reaction";
var subset = "http://hl7.org/fhir/subset";
var performerRole = "http://hl7.org/fhir/performerRole";
var retentionTime = "http://hl7.org/fhir/retentionTime";
var _ClinicalImpression = "http://hl7.org/fhir/_ClinicalImpression";
var _generalCost = "http://hl7.org/fhir/_generalCost";
var instanceReference = "http://hl7.org/fhir/instanceReference";
var _history = "http://hl7.org/fhir/_history";
var molecularFormulaByMoiety = "http://hl7.org/fhir/molecularFormulaByMoiety";
var _orderer = "http://hl7.org/fhir/_orderer";
var _payee = "http://hl7.org/fhir/_payee";
var _windowEnd = "http://hl7.org/fhir/_windowEnd";
var _maxDosePerTreatmentPeriod = "http://hl7.org/fhir/_maxDosePerTreatmentPeriod";
var sopClass = "http://hl7.org/fhir/sopClass";
var PlanDefinitionActorOptionComponent = "http://hl7.org/fhir/PlanDefinitionActorOptionComponent";
var ExampleScenarioInstanceComponent = "http://hl7.org/fhir/ExampleScenarioInstanceComponent";
var organismGeneral = "http://hl7.org/fhir/organismGeneral";
var abatement = "http://hl7.org/fhir/abatement";
var _relatedDevice = "http://hl7.org/fhir/_relatedDevice";
var daysSupply = "http://hl7.org/fhir/daysSupply";
var _legal = "http://hl7.org/fhir/_legal";
var _EpisodeOfCare = "http://hl7.org/fhir/_EpisodeOfCare";
var _excludeFoodModifier = "http://hl7.org/fhir/_excludeFoodModifier";
var weekInterval = "http://hl7.org/fhir/weekInterval";
var _measureScore = "http://hl7.org/fhir/_measureScore";
var _const = "http://hl7.org/fhir/_const";
var _hybrid = "http://hl7.org/fhir/_hybrid";
var PackagedProductDefinitionPackagingComponent = "http://hl7.org/fhir/PackagedProductDefinitionPackagingComponent";
var _prefix = "http://hl7.org/fhir/_prefix";
var _publicationDateText = "http://hl7.org/fhir/_publicationDateText";
var ConceptSet = "http://hl7.org/fhir/ConceptSet";
var payeeType = "http://hl7.org/fhir/payeeType";
var _shelfLifeStorage = "http://hl7.org/fhir/_shelfLifeStorage";
var balance = "http://hl7.org/fhir/balance";
var _type = "http://hl7.org/fhir/_type";
var dataPeriod = "http://hl7.org/fhir/dataPeriod";
var _Immunization = "http://hl7.org/fhir/_Immunization";
var resourceReference = "http://hl7.org/fhir/resourceReference";
var _providedBy = "http://hl7.org/fhir/_providedBy";
var _fhirVersion = "http://hl7.org/fhir/_fhirVersion";
var _HealthcareService = "http://hl7.org/fhir/_HealthcareService";
var submitter = "http://hl7.org/fhir/submitter";
var description5 = "http://hl7.org/fhir/description";
var combinedPharmaceuticalDoseForm = "http://hl7.org/fhir/combinedPharmaceuticalDoseForm";
var _targetScope = "http://hl7.org/fhir/_targetScope";
var Parameter = "http://hl7.org/fhir/Parameter";
var BiologicallyDerivedProduct = "http://hl7.org/fhir/BiologicallyDerivedProduct";
var _GenomicStudy = "http://hl7.org/fhir/_GenomicStudy";
var _NutritionProduct = "http://hl7.org/fhir/_NutritionProduct";
var _additionalContext = "http://hl7.org/fhir/_additionalContext";
var version2 = "http://hl7.org/fhir/version";
var detected = "http://hl7.org/fhir/detected";
var _statistic = "http://hl7.org/fhir/_statistic";
var _bodyStructure = "http://hl7.org/fhir/_bodyStructure";
var _definitionExpression = "http://hl7.org/fhir/_definitionExpression";
var translations = "http://hl7.org/fhir/translations";
var _targetProfile = "http://hl7.org/fhir/_targetProfile";
var _notPerformedReason = "http://hl7.org/fhir/_notPerformedReason";
var ArtifactAssessmentContentComponent = "http://hl7.org/fhir/ArtifactAssessmentContentComponent";
var cost = "http://hl7.org/fhir/cost";
var CanonicalResource = "http://hl7.org/fhir/CanonicalResource";
var _authorizationSupporting = "http://hl7.org/fhir/_authorizationSupporting";
var team = "http://hl7.org/fhir/team";
var actual = "http://hl7.org/fhir/actual";
var landmarkDescription = "http://hl7.org/fhir/landmarkDescription";
var typeCanonical = "http://hl7.org/fhir/typeCanonical";
var ArtifactAssessmentContentComponentContent = "http://hl7.org/fhir/ArtifactAssessmentContentComponentContent";
var _organizationReference = "http://hl7.org/fhir/_organizationReference";
var _minimumVolume = "http://hl7.org/fhir/_minimumVolume";
var precedence = "http://hl7.org/fhir/precedence";
var CitationSummaryComponent = "http://hl7.org/fhir/CitationSummaryComponent";
var decision = "http://hl7.org/fhir/decision";
var role = "http://hl7.org/fhir/role";
var maternalOrganismId = "http://hl7.org/fhir/maternalOrganismId";
var _triggeredBy = "http://hl7.org/fhir/_triggeredBy";
var MedicationKnowledgeStorageGuidelineComponent = "http://hl7.org/fhir/MedicationKnowledgeStorageGuidelineComponent";
var dischargeDisposition = "http://hl7.org/fhir/dischargeDisposition";
var _output = "http://hl7.org/fhir/_output";
var QuestionnaireItemComponent = "http://hl7.org/fhir/QuestionnaireItemComponent";
var _compareToSourcePath = "http://hl7.org/fhir/_compareToSourcePath";
var traceNumber = "http://hl7.org/fhir/traceNumber";
var InsurancePlanPlanComponent = "http://hl7.org/fhir/InsurancePlanPlanComponent";
var object2 = "http://hl7.org/fhir/object";
var statusReason = "http://hl7.org/fhir/statusReason";
var recall = "http://hl7.org/fhir/recall";
var _codeSystem = "http://hl7.org/fhir/_codeSystem";
var _processing = "http://hl7.org/fhir/_processing";
var gateway = "http://hl7.org/fhir/gateway";
var _performerType = "http://hl7.org/fhir/_performerType";
var _subcomponent = "http://hl7.org/fhir/_subcomponent";
var postalCode = "http://hl7.org/fhir/postalCode";
var AddedItemDetail = "http://hl7.org/fhir/AddedItemDetail";
var instance = "http://hl7.org/fhir/instance";
var _disposition = "http://hl7.org/fhir/_disposition";
var _statusDate = "http://hl7.org/fhir/_statusDate";
var _facilityType = "http://hl7.org/fhir/_facilityType";
var _stratum = "http://hl7.org/fhir/_stratum";
var Payee = "http://hl7.org/fhir/Payee";
var _measurementType = "http://hl7.org/fhir/_measurementType";
var RelatedArtifact = "http://hl7.org/fhir/RelatedArtifact";
var RequestOrchestrationActionDynamicValueComponent = "http://hl7.org/fhir/RequestOrchestrationActionDynamicValueComponent";
var identity2 = "http://hl7.org/fhir/identity";
var subType = "http://hl7.org/fhir/subType";
var ValueSetExpansionContainsComponent = "http://hl7.org/fhir/ValueSetExpansionContainsComponent";
var MedicationKnowledgePackagingComponent = "http://hl7.org/fhir/MedicationKnowledgePackagingComponent";
var _display = "http://hl7.org/fhir/_display";
var ImplementationGuideGlobalComponent = "http://hl7.org/fhir/ImplementationGuideGlobalComponent";
var _SubstanceNucleicAcid = "http://hl7.org/fhir/_SubstanceNucleicAcid";
var TestScriptSetupActionOperationRequestHeaderComponent = "http://hl7.org/fhir/TestScriptSetupActionOperationRequestHeaderComponent";
var targetItem = "http://hl7.org/fhir/targetItem";
var _dosingGuideline = "http://hl7.org/fhir/_dosingGuideline";
var _totalGross = "http://hl7.org/fhir/_totalGross";
var Reference = "http://hl7.org/fhir/Reference";
var _precheckBehavior = "http://hl7.org/fhir/_precheckBehavior";
var _enableBehavior = "http://hl7.org/fhir/_enableBehavior";
var slot = "http://hl7.org/fhir/slot";
var groupDefinition = "http://hl7.org/fhir/groupDefinition";
var _verifiedWith = "http://hl7.org/fhir/_verifiedWith";
var ResourceInteraction = "http://hl7.org/fhir/ResourceInteraction";
var _numberOfSubunits = "http://hl7.org/fhir/_numberOfSubunits";
var numberOfSeries = "http://hl7.org/fhir/numberOfSeries";
var preAuthRefPeriod = "http://hl7.org/fhir/preAuthRefPeriod";
var _excludingRecurrenceId = "http://hl7.org/fhir/_excludingRecurrenceId";
var _baseCitation = "http://hl7.org/fhir/_baseCitation";
var ContractAsset = "http://hl7.org/fhir/ContractAsset";
var ClinicalImpressionFindingComponent = "http://hl7.org/fhir/ClinicalImpressionFindingComponent";
var stopTestOnFail = "http://hl7.org/fhir/stopTestOnFail";
var _selectionBehavior = "http://hl7.org/fhir/_selectionBehavior";
var _imports = "http://hl7.org/fhir/_imports";
var contextLinkId = "http://hl7.org/fhir/contextLinkId";
var _eye = "http://hl7.org/fhir/_eye";
var affiliation = "http://hl7.org/fhir/affiliation";
var defaultValue = "http://hl7.org/fhir/defaultValue";
var MolecularSequence = "http://hl7.org/fhir/MolecularSequence";
var overload = "http://hl7.org/fhir/overload";
var _productName = "http://hl7.org/fhir/_productName";
var _comment = "http://hl7.org/fhir/_comment";
var _profile = "http://hl7.org/fhir/_profile";
var _deleted = "http://hl7.org/fhir/_deleted";
var _workflow = "http://hl7.org/fhir/_workflow";
var _attestationSignature = "http://hl7.org/fhir/_attestationSignature";
var permittedDataType = "http://hl7.org/fhir/permittedDataType";
var gene = "http://hl7.org/fhir/gene";
var _prediction = "http://hl7.org/fhir/_prediction";
var exposureRoute = "http://hl7.org/fhir/exposureRoute";
var height2 = "http://hl7.org/fhir/height";
var _entryClassifier = "http://hl7.org/fhir/_entryClassifier";
var test = "http://hl7.org/fhir/test";
var _previousAppointment = "http://hl7.org/fhir/_previousAppointment";
var implementationGuide = "http://hl7.org/fhir/implementationGuide";
var UsageContext = "http://hl7.org/fhir/UsageContext";
var EventDefinition = "http://hl7.org/fhir/EventDefinition";
var relatedIdentifier = "http://hl7.org/fhir/relatedIdentifier";
var ImplementationGuideDependsOnComponent = "http://hl7.org/fhir/ImplementationGuideDependsOnComponent";
var _procedureSequence = "http://hl7.org/fhir/_procedureSequence";
var _copyrightLabel = "http://hl7.org/fhir/_copyrightLabel";
var _navigationLinks = "http://hl7.org/fhir/_navigationLinks";
var _generatedBy = "http://hl7.org/fhir/_generatedBy";
var administeredProduct = "http://hl7.org/fhir/administeredProduct";
var validateProfileId = "http://hl7.org/fhir/validateProfileId";
var MedicationKnowledgeIndicationGuidelineComponent = "http://hl7.org/fhir/MedicationKnowledgeIndicationGuidelineComponent";
var intraspecificDescription = "http://hl7.org/fhir/intraspecificDescription";
var _protocolApplied = "http://hl7.org/fhir/_protocolApplied";
var _VerificationResult = "http://hl7.org/fhir/_VerificationResult";
var monthInterval = "http://hl7.org/fhir/monthInterval";
var expiry = "http://hl7.org/fhir/expiry";
var versioning = "http://hl7.org/fhir/versioning";
var pushTypeAvailable = "http://hl7.org/fhir/pushTypeAvailable";
var CitationCitedArtifactStatusDateComponent = "http://hl7.org/fhir/CitationCitedArtifactStatusDateComponent";
var _assertion = "http://hl7.org/fhir/_assertion";
var diagnosis = "http://hl7.org/fhir/diagnosis";
var _ifNoneExist = "http://hl7.org/fhir/_ifNoneExist";
var _low = "http://hl7.org/fhir/_low";
var undesirableEffect = "http://hl7.org/fhir/undesirableEffect";
var _base = "http://hl7.org/fhir/_base";
var queryCriteria = "http://hl7.org/fhir/queryCriteria";
var _availableEndTime = "http://hl7.org/fhir/_availableEndTime";
var number = "http://hl7.org/fhir/number";
var spatialReference = "http://hl7.org/fhir/spatialReference";
var conditionality = "http://hl7.org/fhir/conditionality";
var _codeFilter = "http://hl7.org/fhir/_codeFilter";
var SubstanceDefinitionCharacterizationComponent = "http://hl7.org/fhir/SubstanceDefinitionCharacterizationComponent";
var offsets = "http://hl7.org/fhir/offsets";
var _orderedBy = "http://hl7.org/fhir/_orderedBy";
var _authorizationUrl = "http://hl7.org/fhir/_authorizationUrl";
var _carrierAIDC = "http://hl7.org/fhir/_carrierAIDC";
var _episodeOfCare = "http://hl7.org/fhir/_episodeOfCare";
var disabledDisplay = "http://hl7.org/fhir/disabledDisplay";
var DocumentReference = "http://hl7.org/fhir/DocumentReference";
var compositeScoring = "http://hl7.org/fhir/compositeScoring";
var _yearInterval = "http://hl7.org/fhir/_yearInterval";
var RelatedPersonCommunicationComponent = "http://hl7.org/fhir/RelatedPersonCommunicationComponent";
var _displayName = "http://hl7.org/fhir/_displayName";
var _monday = "http://hl7.org/fhir/_monday";
var messaging = "http://hl7.org/fhir/messaging";
var geneElement = "http://hl7.org/fhir/geneElement";
var exclude = "http://hl7.org/fhir/exclude";
var _itemSequence = "http://hl7.org/fhir/_itemSequence";
var _artifactAssessment = "http://hl7.org/fhir/_artifactAssessment";
var dispenseRequest = "http://hl7.org/fhir/dispenseRequest";
var intendedJurisdiction = "http://hl7.org/fhir/intendedJurisdiction";
var _restriction = "http://hl7.org/fhir/_restriction";
var ImmunizationEvaluation = "http://hl7.org/fhir/ImmunizationEvaluation";
var Observation = "http://hl7.org/fhir/Observation";
var _supplier = "http://hl7.org/fhir/_supplier";
var NutritionIntakePerformerComponent = "http://hl7.org/fhir/NutritionIntakePerformerComponent";
var CapabilityStatementRestComponentSearchParam = "http://hl7.org/fhir/CapabilityStatementRestComponentSearchParam";
var _SubstanceReferenceInformation = "http://hl7.org/fhir/_SubstanceReferenceInformation";
var _CarePlan = "http://hl7.org/fhir/_CarePlan";
var AdverseEventPreventiveActionComponent = "http://hl7.org/fhir/AdverseEventPreventiveActionComponent";
var outsideFoodAllowed = "http://hl7.org/fhir/outsideFoodAllowed";
var _maxVolumeToDeliver = "http://hl7.org/fhir/_maxVolumeToDeliver";
var InventoryItemAssociationComponent = "http://hl7.org/fhir/InventoryItemAssociationComponent";
var deliverFor = "http://hl7.org/fhir/deliverFor";
var ElementDefinitionExampleComponent = "http://hl7.org/fhir/ElementDefinitionExampleComponent";
var _totalPriceComponent = "http://hl7.org/fhir/_totalPriceComponent";
var _carrierHRF = "http://hl7.org/fhir/_carrierHRF";
var _subProperty = "http://hl7.org/fhir/_subProperty";
var allowed = "http://hl7.org/fhir/allowed";
var _searchType = "http://hl7.org/fhir/_searchType";
var List = "http://hl7.org/fhir/List";
var responseId = "http://hl7.org/fhir/responseId";
var _defaultManualCompletion = "http://hl7.org/fhir/_defaultManualCompletion";
var _subscriberId = "http://hl7.org/fhir/_subscriberId";
var _groupingId = "http://hl7.org/fhir/_groupingId";
var _protocolPerformed = "http://hl7.org/fhir/_protocolPerformed";
var subPotentReason = "http://hl7.org/fhir/subPotentReason";
var maxValue = "http://hl7.org/fhir/maxValue";
var _data = "http://hl7.org/fhir/_data";
var _disulfideLinkage = "http://hl7.org/fhir/_disulfideLinkage";
var metadata = "http://hl7.org/fhir/metadata";
var ConditionParticipantComponent = "http://hl7.org/fhir/ConditionParticipantComponent";
var rationale = "http://hl7.org/fhir/rationale";
var tax = "http://hl7.org/fhir/tax";
var _line = "http://hl7.org/fhir/_line";
var index = "http://hl7.org/fhir/index";
var _firstPage = "http://hl7.org/fhir/_firstPage";
var verifiedBy = "http://hl7.org/fhir/verifiedBy";
var _requestProvider = "http://hl7.org/fhir/_requestProvider";
var Diagnosis = "http://hl7.org/fhir/Diagnosis";
var _hybridType = "http://hl7.org/fhir/_hybridType";
var _abnormalCodedValueSet = "http://hl7.org/fhir/_abnormalCodedValueSet";
var Encounter = "http://hl7.org/fhir/Encounter";
var expression = "http://hl7.org/fhir/expression";
var _current = "http://hl7.org/fhir/_current";
var BackboneType = "http://hl7.org/fhir/BackboneType";
var collection = "http://hl7.org/fhir/collection";
var _family = "http://hl7.org/fhir/_family";
var _validated = "http://hl7.org/fhir/_validated";
var question = "http://hl7.org/fhir/question";
var _noMap = "http://hl7.org/fhir/_noMap";
var _comparisonGroup = "http://hl7.org/fhir/_comparisonGroup";
var EnrollmentRequest = "http://hl7.org/fhir/EnrollmentRequest";
var _surfaceOrientation = "http://hl7.org/fhir/_surfaceOrientation";
var prescription = "http://hl7.org/fhir/prescription";
var _contributorship = "http://hl7.org/fhir/_contributorship";
var synthesisType = "http://hl7.org/fhir/synthesisType";
var _anchor = "http://hl7.org/fhir/_anchor";
var _suppress = "http://hl7.org/fhir/_suppress";
var _other = "http://hl7.org/fhir/_other";
var variable3 = "http://hl7.org/fhir/variable";
var MolecularSequenceRelativeComponent = "http://hl7.org/fhir/MolecularSequenceRelativeComponent";
var Ingredient = "http://hl7.org/fhir/Ingredient";
var _occurrenceDateTime = "http://hl7.org/fhir/_occurrenceDateTime";
var Annotation = "http://hl7.org/fhir/Annotation";
var SubstanceReferenceInformationGeneComponent = "http://hl7.org/fhir/SubstanceReferenceInformationGeneComponent";
var _valueQuantity = "http://hl7.org/fhir/_valueQuantity";
var DeviceDefinitionCorrectiveActionComponent = "http://hl7.org/fhir/DeviceDefinitionCorrectiveActionComponent";
var OperationDefinitionParameterComponent = "http://hl7.org/fhir/OperationDefinitionParameterComponent";
var EvidenceVariableCharacteristicDefinitionByCombinationComponent = "http://hl7.org/fhir/EvidenceVariableCharacteristicDefinitionByCombinationComponent";
var SpecimenDefinitionTypeTestedHandlingComponent = "http://hl7.org/fhir/SpecimenDefinitionTypeTestedHandlingComponent";
var _testRun = "http://hl7.org/fhir/_testRun";
var compareToSourceId = "http://hl7.org/fhir/compareToSourceId";
var _definitional = "http://hl7.org/fhir/_definitional";
var _testCase = "http://hl7.org/fhir/_testCase";
var _PaymentReconciliation = "http://hl7.org/fhir/_PaymentReconciliation";
var valuedItem = "http://hl7.org/fhir/valuedItem";
var relatedItem = "http://hl7.org/fhir/relatedItem";
var consumedItem = "http://hl7.org/fhir/consumedItem";
var search = "http://hl7.org/fhir/search";
var duration3 = "http://hl7.org/fhir/duration";
var status2 = "http://hl7.org/fhir/status";
var _context = "http://hl7.org/fhir/_context";
var _requirements = "http://hl7.org/fhir/_requirements";
var _subjectType = "http://hl7.org/fhir/_subjectType";
var _use = "http://hl7.org/fhir/_use";
var udi = "http://hl7.org/fhir/udi";
var nameType = "http://hl7.org/fhir/nameType";
var _producedFrom = "http://hl7.org/fhir/_producedFrom";
var _interval = "http://hl7.org/fhir/_interval";
var summary3 = "http://hl7.org/fhir/summary";
var MedicinalProductDefinitionCharacteristicComponent = "http://hl7.org/fhir/MedicinalProductDefinitionCharacteristicComponent";
var sex = "http://hl7.org/fhir/sex";
var AdministrableProductDefinition = "http://hl7.org/fhir/AdministrableProductDefinition";
var SecurityLabel = "http://hl7.org/fhir/SecurityLabel";
var SubstanceDefinitionRelationshipComponent = "http://hl7.org/fhir/SubstanceDefinitionRelationshipComponent";
var knownAllergen = "http://hl7.org/fhir/knownAllergen";
var knownDataCount = "http://hl7.org/fhir/knownDataCount";
var observer = "http://hl7.org/fhir/observer";
var _subtitle = "http://hl7.org/fhir/_subtitle";
var accessionNumber = "http://hl7.org/fhir/accessionNumber";
var _finding = "http://hl7.org/fhir/_finding";
var _style = "http://hl7.org/fhir/_style";
var relation3 = "http://hl7.org/fhir/relation";
var priority2 = "http://hl7.org/fhir/priority";
var _requestId = "http://hl7.org/fhir/_requestId";
var ElementDefinitionBindingComponent = "http://hl7.org/fhir/ElementDefinitionBindingComponent";
var sequenceAttachment = "http://hl7.org/fhir/sequenceAttachment";
var AddedItemBodySite = "http://hl7.org/fhir/AddedItemBodySite";
var _group = "http://hl7.org/fhir/_group";
var publisher3 = "http://hl7.org/fhir/publisher";
var consent = "http://hl7.org/fhir/consent";
var site = "http://hl7.org/fhir/site";
var canFilterBy = "http://hl7.org/fhir/canFilterBy";
var TerminologyCapabilitiesValidateCodeComponent = "http://hl7.org/fhir/TerminologyCapabilitiesValidateCodeComponent";
var _isSubPotent = "http://hl7.org/fhir/_isSubPotent";
var EncounterParticipantComponent = "http://hl7.org/fhir/EncounterParticipantComponent";
var _cancellationReason = "http://hl7.org/fhir/_cancellationReason";
var _repetitions = "http://hl7.org/fhir/_repetitions";
var TestPlanTestCaseTestRunScriptComponent = "http://hl7.org/fhir/TestPlanTestCaseTestRunScriptComponent";
var distributor = "http://hl7.org/fhir/distributor";
var _stopTestOnFail = "http://hl7.org/fhir/_stopTestOnFail";
var organizationReference = "http://hl7.org/fhir/organizationReference";
var residueSite = "http://hl7.org/fhir/residueSite";
var guidance = "http://hl7.org/fhir/guidance";
var _originatingAppointment = "http://hl7.org/fhir/_originatingAppointment";
var intended = "http://hl7.org/fhir/intended";
var _measurementFrequency = "http://hl7.org/fhir/_measurementFrequency";
var _variableRole = "http://hl7.org/fhir/_variableRole";
var assurance = "http://hl7.org/fhir/assurance";
var literal3 = "http://hl7.org/fhir/literal";
var _suppliedItem = "http://hl7.org/fhir/_suppliedItem";
var ProcedurePerformerComponent = "http://hl7.org/fhir/ProcedurePerformerComponent";
var baseUnit = "http://hl7.org/fhir/baseUnit";
var _translation = "http://hl7.org/fhir/_translation";
var StructureDefinitionSnapshotComponent = "http://hl7.org/fhir/StructureDefinitionSnapshotComponent";
var _name = "http://hl7.org/fhir/_name";
var MedicationRequestDispenseRequestInitialFillComponent = "http://hl7.org/fhir/MedicationRequestDispenseRequestInitialFillComponent";
var _incidence = "http://hl7.org/fhir/_incidence";
var _during = "http://hl7.org/fhir/_during";
var _snapshot = "http://hl7.org/fhir/_snapshot";
var SubstancePolymerRepeatRepeatUnitComponent = "http://hl7.org/fhir/SubstancePolymerRepeatRepeatUnitComponent";
var _format = "http://hl7.org/fhir/_format";
var PlanBenefit = "http://hl7.org/fhir/PlanBenefit";
var _foodPreferenceModifier = "http://hl7.org/fhir/_foodPreferenceModifier";
var function__workaround = "http://hl7.org/fhir/function";
var environmentType = "http://hl7.org/fhir/environmentType";
var SubscriptionTopicCanFilterByComponent = "http://hl7.org/fhir/SubscriptionTopicCanFilterByComponent";
var occurrenceCount = "http://hl7.org/fhir/occurrenceCount";
var careTeamSequence = "http://hl7.org/fhir/careTeamSequence";
var _notConsumedReason = "http://hl7.org/fhir/_notConsumedReason";
var _restoreDate = "http://hl7.org/fhir/_restoreDate";
var providedBy = "http://hl7.org/fhir/providedBy";
var meta = "http://hl7.org/fhir/meta";
var _subDetailSequence = "http://hl7.org/fhir/_subDetailSequence";
var required = "http://hl7.org/fhir/required";
var _dateWritten = "http://hl7.org/fhir/_dateWritten";
var _deviceIdentifier = "http://hl7.org/fhir/_deviceIdentifier";
var referral = "http://hl7.org/fhir/referral";
var _conditionality = "http://hl7.org/fhir/_conditionality";
var AuditEventSourceComponent = "http://hl7.org/fhir/AuditEventSourceComponent";
var _component = "http://hl7.org/fhir/_component";
var link2 = "http://hl7.org/fhir/link";
var _hasStage = "http://hl7.org/fhir/_hasStage";
var _contentReference = "http://hl7.org/fhir/_contentReference";
var program = "http://hl7.org/fhir/program";
var OtherElement = "http://hl7.org/fhir/OtherElement";
var scoringUnit = "http://hl7.org/fhir/scoringUnit";
var _maxCount = "http://hl7.org/fhir/_maxCount";
var ExplanationOfBenefitEventComponent = "http://hl7.org/fhir/ExplanationOfBenefitEventComponent";
var _ArtifactAssessment = "http://hl7.org/fhir/_ArtifactAssessment";
var scope = "http://hl7.org/fhir/scope";
var inventoryListing = "http://hl7.org/fhir/inventoryListing";
var concentration = "http://hl7.org/fhir/concentration";
var _device = "http://hl7.org/fhir/_device";
var hierarchyMeaning = "http://hl7.org/fhir/hierarchyMeaning";
var CapabilityStatementRestComponentOperation = "http://hl7.org/fhir/CapabilityStatementRestComponentOperation";
var otherMap = "http://hl7.org/fhir/otherMap";
var answerConstraint = "http://hl7.org/fhir/answerConstraint";
var normalCodedValueSet = "http://hl7.org/fhir/normalCodedValueSet";
var global2 = "http://hl7.org/fhir/global";
var excludingRecurrenceId = "http://hl7.org/fhir/excludingRecurrenceId";
var _SubstanceSourceMaterial = "http://hl7.org/fhir/_SubstanceSourceMaterial";
var validity = "http://hl7.org/fhir/validity";
var subjectReport = "http://hl7.org/fhir/subjectReport";
var _any = "http://hl7.org/fhir/_any";
var _nextScheduled = "http://hl7.org/fhir/_nextScheduled";
var administration = "http://hl7.org/fhir/administration";
var sort = "http://hl7.org/fhir/sort";
var ManufacturedItemDefinitionComponentComponentProperty = "http://hl7.org/fhir/ManufacturedItemDefinitionComponentComponentProperty";
var _sent = "http://hl7.org/fhir/_sent";
var _directnessMatch = "http://hl7.org/fhir/_directnessMatch";
var _targetFormat = "http://hl7.org/fhir/_targetFormat";
var _used = "http://hl7.org/fhir/_used";
var _occurence = "http://hl7.org/fhir/_occurence";
var _partOf = "http://hl7.org/fhir/_partOf";
var relativeRisk = "http://hl7.org/fhir/relativeRisk";
var supportedMessage = "http://hl7.org/fhir/supportedMessage";
var _dateOfDiagnosis = "http://hl7.org/fhir/_dateOfDiagnosis";
var _seriesNumber = "http://hl7.org/fhir/_seriesNumber";
var DataRequirementSortComponent = "http://hl7.org/fhir/DataRequirementSortComponent";
var ChargeItemDefinitionPropertyGroupComponentApplicability = "http://hl7.org/fhir/ChargeItemDefinitionPropertyGroupComponentApplicability";
var codeSystem = "http://hl7.org/fhir/codeSystem";
var processing = "http://hl7.org/fhir/processing";
var _ResearchSubject = "http://hl7.org/fhir/_ResearchSubject";
var _heartbeatPeriod = "http://hl7.org/fhir/_heartbeatPeriod";
var ValueSetExpansionPropertyComponent = "http://hl7.org/fhir/ValueSetExpansionPropertyComponent";
var orderDetail = "http://hl7.org/fhir/orderDetail";
var Group2 = "http://hl7.org/fhir/Group";
var statusDate = "http://hl7.org/fhir/statusDate";
var uri = "http://hl7.org/fhir/uri";
var max = "http://hl7.org/fhir/max";
var _conformance = "http://hl7.org/fhir/_conformance";
var _unitPriceComponent = "http://hl7.org/fhir/_unitPriceComponent";
var _availabilityStatus = "http://hl7.org/fhir/_availabilityStatus";
var _exitCriteria = "http://hl7.org/fhir/_exitCriteria";
var Schedule = "http://hl7.org/fhir/Schedule";
var BiologicallyDerivedProductCollectionComponent = "http://hl7.org/fhir/BiologicallyDerivedProductCollectionComponent";
var DomainResource = "http://hl7.org/fhir/DomainResource";
var _AdverseEvent = "http://hl7.org/fhir/_AdverseEvent";
var focalDevice = "http://hl7.org/fhir/focalDevice";
var _authorType = "http://hl7.org/fhir/_authorType";
var mode2 = "http://hl7.org/fhir/mode";
var observation = "http://hl7.org/fhir/observation";
var _issuer = "http://hl7.org/fhir/_issuer";
var ClaimEventComponent = "http://hl7.org/fhir/ClaimEventComponent";
var FamilyMemberHistoryParticipantComponent = "http://hl7.org/fhir/FamilyMemberHistoryParticipantComponent";
var _validationStatus = "http://hl7.org/fhir/_validationStatus";
var string = "http://hl7.org/fhir/string";
var productCode = "http://hl7.org/fhir/productCode";
var receiver = "http://hl7.org/fhir/receiver";
var CitationCitedArtifactTitleComponent = "http://hl7.org/fhir/CitationCitedArtifactTitleComponent";
var totalGross = "http://hl7.org/fhir/totalGross";
var _outputProfile = "http://hl7.org/fhir/_outputProfile";
var conditionalDelete = "http://hl7.org/fhir/conditionalDelete";
var baseDefinition = "http://hl7.org/fhir/baseDefinition";
var NutritionProductInstanceComponent = "http://hl7.org/fhir/NutritionProductInstanceComponent";
var ClinicalUseDefinitionIndicationComponent = "http://hl7.org/fhir/ClinicalUseDefinitionIndicationComponent";
var relevantHistory = "http://hl7.org/fhir/relevantHistory";
var referenceInformation = "http://hl7.org/fhir/referenceInformation";
var valueSet = "http://hl7.org/fhir/valueSet";
var library = "http://hl7.org/fhir/library";
var InventoryReportInventoryListingItemComponent = "http://hl7.org/fhir/InventoryReportInventoryListingItemComponent";
var performedActivity = "http://hl7.org/fhir/performedActivity";
var Coverage = "http://hl7.org/fhir/Coverage";
var probability = "http://hl7.org/fhir/probability";
var TerminologyCapabilitiesSoftwareComponent = "http://hl7.org/fhir/TerminologyCapabilitiesSoftwareComponent";
var _activity = "http://hl7.org/fhir/_activity";
var prediction = "http://hl7.org/fhir/prediction";
var _mimeType = "http://hl7.org/fhir/_mimeType";
var exception = "http://hl7.org/fhir/exception";
var ImplementationGuideDefinitionTemplateComponent = "http://hl7.org/fhir/ImplementationGuideDefinitionTemplateComponent";
var _edit = "http://hl7.org/fhir/_edit";
var _usage = "http://hl7.org/fhir/_usage";
var proposedNewTime = "http://hl7.org/fhir/proposedNewTime";
var security = "http://hl7.org/fhir/security";
var _parameter = "http://hl7.org/fhir/_parameter";
var InventoryItemDescriptionComponent = "http://hl7.org/fhir/InventoryItemDescriptionComponent";
var ConditionDefinitionPreconditionComponent = "http://hl7.org/fhir/ConditionDefinitionPreconditionComponent";
var LocationPositionComponent = "http://hl7.org/fhir/LocationPositionComponent";
var sequenceRange = "http://hl7.org/fhir/sequenceRange";
var policyBasis = "http://hl7.org/fhir/policyBasis";
var _inputParameters = "http://hl7.org/fhir/_inputParameters";
var _dateRange = "http://hl7.org/fhir/_dateRange";
var _cost = "http://hl7.org/fhir/_cost";
var Timing = "http://hl7.org/fhir/Timing";
var _team = "http://hl7.org/fhir/_team";
var _paternalOrganismId = "http://hl7.org/fhir/_paternalOrganismId";
var _statusChanged = "http://hl7.org/fhir/_statusChanged";
var ActivityDefinitionDynamicValueComponent = "http://hl7.org/fhir/ActivityDefinitionDynamicValueComponent";
var processor = "http://hl7.org/fhir/processor";
var _constraint = "http://hl7.org/fhir/_constraint";
var _sampleSize = "http://hl7.org/fhir/_sampleSize";
var ClinicalUseDefinitionContraindicationComponent = "http://hl7.org/fhir/ClinicalUseDefinitionContraindicationComponent";
var _comorbidity = "http://hl7.org/fhir/_comorbidity";
var _knownDataCount = "http://hl7.org/fhir/_knownDataCount";
var template = "http://hl7.org/fhir/template";
var codeFilter = "http://hl7.org/fhir/codeFilter";
var dateAccessed = "http://hl7.org/fhir/dateAccessed";
var _organization = "http://hl7.org/fhir/_organization";
var _ifModifiedSince = "http://hl7.org/fhir/_ifModifiedSince";
var _lastRevisionDate = "http://hl7.org/fhir/_lastRevisionDate";
var _strength = "http://hl7.org/fhir/_strength";
var numerator = "http://hl7.org/fhir/numerator";
var _altitude = "http://hl7.org/fhir/_altitude";
var _countingDateTime = "http://hl7.org/fhir/_countingDateTime";
var MedicationDispense = "http://hl7.org/fhir/MedicationDispense";
var _maxDuration = "http://hl7.org/fhir/_maxDuration";
var requirement = "http://hl7.org/fhir/requirement";
var SubstanceProteinSubunitComponent = "http://hl7.org/fhir/SubstanceProteinSubunitComponent";
var _abatement = "http://hl7.org/fhir/_abatement";
var reportingPeriod = "http://hl7.org/fhir/reportingPeriod";
var dosage = "http://hl7.org/fhir/dosage";
var _supplement = "http://hl7.org/fhir/_supplement";
var _treatmentIntent = "http://hl7.org/fhir/_treatmentIntent";
var performingOrganization = "http://hl7.org/fhir/performingOrganization";
var _what = "http://hl7.org/fhir/_what";
var intervalUnit = "http://hl7.org/fhir/intervalUnit";
var preAuthPeriod = "http://hl7.org/fhir/preAuthPeriod";
var fhirPathCriteria = "http://hl7.org/fhir/fhirPathCriteria";
var administeredBy = "http://hl7.org/fhir/administeredBy";
var factor = "http://hl7.org/fhir/factor";
var ContactPoint = "http://hl7.org/fhir/ContactPoint";
var appointmentType = "http://hl7.org/fhir/appointmentType";
var _collector = "http://hl7.org/fhir/_collector";
var answerValueSet = "http://hl7.org/fhir/answerValueSet";
var _achievementStatus = "http://hl7.org/fhir/_achievementStatus";
var carrierHRF = "http://hl7.org/fhir/carrierHRF";
var _evaluatedResource = "http://hl7.org/fhir/_evaluatedResource";
var signer = "http://hl7.org/fhir/signer";
var _usageReason = "http://hl7.org/fhir/_usageReason";
var variableDefinition = "http://hl7.org/fhir/variableDefinition";
var manifestation = "http://hl7.org/fhir/manifestation";
var searchType = "http://hl7.org/fhir/searchType";
var PaymentReconciliation = "http://hl7.org/fhir/PaymentReconciliation";
var _modelNumber = "http://hl7.org/fhir/_modelNumber";
var groupingId = "http://hl7.org/fhir/groupingId";
var _VisionPrescription = "http://hl7.org/fhir/_VisionPrescription";
var performerLinkId = "http://hl7.org/fhir/performerLinkId";
var procedure = "http://hl7.org/fhir/procedure";
var implicitRules = "http://hl7.org/fhir/implicitRules";
var query = "http://hl7.org/fhir/query";
var Items = "http://hl7.org/fhir/Items";
var _slot = "http://hl7.org/fhir/_slot";
var _conditionalCreate = "http://hl7.org/fhir/_conditionalCreate";
var PatientCommunicationComponent = "http://hl7.org/fhir/PatientCommunicationComponent";
var ConditionDefinitionMedicationComponent = "http://hl7.org/fhir/ConditionDefinitionMedicationComponent";
var documentation = "http://hl7.org/fhir/documentation";
var maxDosePerTreatmentPeriod = "http://hl7.org/fhir/maxDosePerTreatmentPeriod";
var example = "http://hl7.org/fhir/example";
var _sessionKey = "http://hl7.org/fhir/_sessionKey";
var lastPage = "http://hl7.org/fhir/lastPage";
var hybridType = "http://hl7.org/fhir/hybridType";
var field = "http://hl7.org/fhir/field";
var maxDosePerPeriod = "http://hl7.org/fhir/maxDosePerPeriod";
var _excludedStructure = "http://hl7.org/fhir/_excludedStructure";
var _script = "http://hl7.org/fhir/_script";
var acceptLanguage = "http://hl7.org/fhir/acceptLanguage";
var practiceSetting = "http://hl7.org/fhir/practiceSetting";
var brand = "http://hl7.org/fhir/brand";
var _attributeEstimate = "http://hl7.org/fhir/_attributeEstimate";
var _end = "http://hl7.org/fhir/_end";
var diagnosisSequence = "http://hl7.org/fhir/diagnosisSequence";
var _specification = "http://hl7.org/fhir/_specification";
var _test = "http://hl7.org/fhir/_test";
var _durationMax = "http://hl7.org/fhir/_durationMax";
var impurity = "http://hl7.org/fhir/impurity";
var _Practitioner = "http://hl7.org/fhir/_Practitioner";
var SubstanceIngredientComponent = "http://hl7.org/fhir/SubstanceIngredientComponent";
var control = "http://hl7.org/fhir/control";
var _enterer = "http://hl7.org/fhir/_enterer";
var TransportOutputComponent = "http://hl7.org/fhir/TransportOutputComponent";
var _retentionTime = "http://hl7.org/fhir/_retentionTime";
var _encodeRequestUrl = "http://hl7.org/fhir/_encodeRequestUrl";
var countMax = "http://hl7.org/fhir/countMax";
var _netContent = "http://hl7.org/fhir/_netContent";
var AccountBalanceComponent = "http://hl7.org/fhir/AccountBalanceComponent";
var _sequenceAttachment = "http://hl7.org/fhir/_sequenceAttachment";
var requestedLocation = "http://hl7.org/fhir/requestedLocation";
var DeviceDefinitionRegulatoryIdentifierComponent = "http://hl7.org/fhir/DeviceDefinitionRegulatoryIdentifierComponent";
var _target = "http://hl7.org/fhir/_target";
var _implicated = "http://hl7.org/fhir/_implicated";
var _administration = "http://hl7.org/fhir/_administration";
var _flag = "http://hl7.org/fhir/_flag";
var _party = "http://hl7.org/fhir/_party";
var _version = "http://hl7.org/fhir/_version";
var provision = "http://hl7.org/fhir/provision";
var patientPaid = "http://hl7.org/fhir/patientPaid";
var referenceNumber = "http://hl7.org/fhir/referenceNumber";
var manifest = "http://hl7.org/fhir/manifest";
var Account = "http://hl7.org/fhir/Account";
var _goal = "http://hl7.org/fhir/_goal";
var _basis = "http://hl7.org/fhir/_basis";
var MessageSource = "http://hl7.org/fhir/MessageSource";
var _formCode = "http://hl7.org/fhir/_formCode";
var _disclaimer = "http://hl7.org/fhir/_disclaimer";
var _definitionByCombination = "http://hl7.org/fhir/_definitionByCombination";
var step = "http://hl7.org/fhir/step";
var fractionDescription = "http://hl7.org/fhir/fractionDescription";
var valueCategory = "http://hl7.org/fhir/valueCategory";
var requestMethod = "http://hl7.org/fhir/requestMethod";
var BodySite = "http://hl7.org/fhir/BodySite";
var etag = "http://hl7.org/fhir/etag";
var specimenQuantity = "http://hl7.org/fhir/specimenQuantity";
var comprisedOf = "http://hl7.org/fhir/comprisedOf";
var _pediatricUseIndicator = "http://hl7.org/fhir/_pediatricUseIndicator";
var _destination = "http://hl7.org/fhir/_destination";
var _evaluationMessage = "http://hl7.org/fhir/_evaluationMessage";
var ResearchStudyComparisonGroupComponent = "http://hl7.org/fhir/ResearchStudyComparisonGroupComponent";
var _DomainResource = "http://hl7.org/fhir/_DomainResource";
var CitationCitedArtifactWebLocationComponent = "http://hl7.org/fhir/CitationCitedArtifactWebLocationComponent";
var beneficiary = "http://hl7.org/fhir/beneficiary";
var prefix = "http://hl7.org/fhir/prefix";
var effectiveTime = "http://hl7.org/fhir/effectiveTime";
var RegulatedAuthorizationCaseComponent = "http://hl7.org/fhir/RegulatedAuthorizationCaseComponent";
var AccountProcedureComponent = "http://hl7.org/fhir/AccountProcedureComponent";
var doseStatusReason = "http://hl7.org/fhir/doseStatusReason";
var ResearchStudyAssociatedPartyComponent = "http://hl7.org/fhir/ResearchStudyAssociatedPartyComponent";
var reason = "http://hl7.org/fhir/reason";
var _precondition = "http://hl7.org/fhir/_precondition";
var criteria = "http://hl7.org/fhir/criteria";
var MedicationAdministrationDosageComponent = "http://hl7.org/fhir/MedicationAdministrationDosageComponent";
var latitude2 = "http://hl7.org/fhir/latitude";
var IngredientSubstanceStrengthReferenceStrengthComponent = "http://hl7.org/fhir/IngredientSubstanceStrengthReferenceStrengthComponent";
var _thursday = "http://hl7.org/fhir/_thursday";
var securityContext = "http://hl7.org/fhir/securityContext";
var _baseDefinition = "http://hl7.org/fhir/_baseDefinition";
var _publicationStatus = "http://hl7.org/fhir/_publicationStatus";
var relatedArtifact = "http://hl7.org/fhir/relatedArtifact";
var safety = "http://hl7.org/fhir/safety";
var stereochemistry = "http://hl7.org/fhir/stereochemistry";
var _timeout = "http://hl7.org/fhir/_timeout";
var primarySource = "http://hl7.org/fhir/primarySource";
var NutritionOrderOralDietNutrientComponent = "http://hl7.org/fhir/NutritionOrderOralDietNutrientComponent";
var responseCode = "http://hl7.org/fhir/responseCode";
var eventHistory = "http://hl7.org/fhir/eventHistory";
var _doseForm = "http://hl7.org/fhir/_doseForm";
var _allowedResponse = "http://hl7.org/fhir/_allowedResponse";
var _storageGuideline = "http://hl7.org/fhir/_storageGuideline";
var timezone = "http://hl7.org/fhir/timezone";
var copolymerConnectivity = "http://hl7.org/fhir/copolymerConnectivity";
var GenomicStudyAnalysisOutputComponent = "http://hl7.org/fhir/GenomicStudyAnalysisOutputComponent";
var _molecularWeight = "http://hl7.org/fhir/_molecularWeight";
var ObservationDefinition = "http://hl7.org/fhir/ObservationDefinition";
var ifNoneMatch = "http://hl7.org/fhir/ifNoneMatch";
var _notConsumed = "http://hl7.org/fhir/_notConsumed";
var grade = "http://hl7.org/fhir/grade";
var OralDietSchedule = "http://hl7.org/fhir/OralDietSchedule";
var _diagnosis = "http://hl7.org/fhir/_diagnosis";
var _channelType = "http://hl7.org/fhir/_channelType";
var _encounter = "http://hl7.org/fhir/_encounter";
var SubstancePolymerMonomerSetStartingMaterialComponent = "http://hl7.org/fhir/SubstancePolymerMonomerSetStartingMaterialComponent";
var statisticType = "http://hl7.org/fhir/statisticType";
var _webLocation = "http://hl7.org/fhir/_webLocation";
var SubstanceSourceMaterialOrganismOrganismGeneralComponent = "http://hl7.org/fhir/SubstanceSourceMaterialOrganismOrganismGeneralComponent";
var textConcentration = "http://hl7.org/fhir/textConcentration";
var _multipleAnd = "http://hl7.org/fhir/_multipleAnd";
var _freeToShare = "http://hl7.org/fhir/_freeToShare";
var _contributionInstance = "http://hl7.org/fhir/_contributionInstance";
var MedicationStatementAdherenceComponent = "http://hl7.org/fhir/MedicationStatementAdherenceComponent";
var _onAdmission = "http://hl7.org/fhir/_onAdmission";
var output = "http://hl7.org/fhir/output";
var _indication = "http://hl7.org/fhir/_indication";
var DeviceDefinitionChargeItemComponent = "http://hl7.org/fhir/DeviceDefinitionChargeItemComponent";
var location3 = "http://hl7.org/fhir/location";
var generalCost = "http://hl7.org/fhir/generalCost";
var _plannedActivityReference = "http://hl7.org/fhir/_plannedActivityReference";
var rules = "http://hl7.org/fhir/rules";
var reported = "http://hl7.org/fhir/reported";
var maxDosePerDay = "http://hl7.org/fhir/maxDosePerDay";
var NutritionOrderOralDietTextureComponent = "http://hl7.org/fhir/NutritionOrderOralDietTextureComponent";
var _definitionByTypeAndValue = "http://hl7.org/fhir/_definitionByTypeAndValue";
var GroupMemberComponent = "http://hl7.org/fhir/GroupMemberComponent";
var _verificationType = "http://hl7.org/fhir/_verificationType";
var _supportingInformation = "http://hl7.org/fhir/_supportingInformation";
var kingdom = "http://hl7.org/fhir/kingdom";
var sourceMaterialClass = "http://hl7.org/fhir/sourceMaterialClass";
var _polymer = "http://hl7.org/fhir/_polymer";
var insurance = "http://hl7.org/fhir/insurance";
var _handling = "http://hl7.org/fhir/_handling";
var supportingInfo = "http://hl7.org/fhir/supportingInfo";
var lifecycleStatus = "http://hl7.org/fhir/lifecycleStatus";
var _symptomConditionEffect = "http://hl7.org/fhir/_symptomConditionEffect";
var _fraction = "http://hl7.org/fhir/_fraction";
var language3 = "http://hl7.org/fhir/language";
var combining = "http://hl7.org/fhir/combining";
var country = "http://hl7.org/fhir/country";
var isExample = "http://hl7.org/fhir/isExample";
var _readHistory = "http://hl7.org/fhir/_readHistory";
var BundleLinkComponent = "http://hl7.org/fhir/BundleLinkComponent";
var currentLocation = "http://hl7.org/fhir/currentLocation";
var official = "http://hl7.org/fhir/official";
var _EncounterHistory = "http://hl7.org/fhir/_EncounterHistory";
var EvidenceVariableCategoryComponent = "http://hl7.org/fhir/EvidenceVariableCategoryComponent";
var _administeredBy = "http://hl7.org/fhir/_administeredBy";
var _ProductShelfLife = "http://hl7.org/fhir/_ProductShelfLife";
var SubstanceDefinitionMolecularWeightComponent = "http://hl7.org/fhir/SubstanceDefinitionMolecularWeightComponent";
var affectsState = "http://hl7.org/fhir/affectsState";
var notificationShape = "http://hl7.org/fhir/notificationShape";
var descriptionSummary = "http://hl7.org/fhir/descriptionSummary";
var _answerValueSet = "http://hl7.org/fhir/_answerValueSet";
var PractitionerRole = "http://hl7.org/fhir/PractitionerRole";
var _rationale = "http://hl7.org/fhir/_rationale";
var _ChargeItem = "http://hl7.org/fhir/_ChargeItem";
var _offer = "http://hl7.org/fhir/_offer";
var OperationDefinitionParameterReferencedFromComponent = "http://hl7.org/fhir/OperationDefinitionParameterReferencedFromComponent";
var singleUse = "http://hl7.org/fhir/singleUse";
var _exclude = "http://hl7.org/fhir/_exclude";
var fhirVersion = "http://hl7.org/fhir/fhirVersion";
var _nucleicAcid = "http://hl7.org/fhir/_nucleicAcid";
var CodeableConcept = "http://hl7.org/fhir/CodeableConcept";
var _Claim = "http://hl7.org/fhir/_Claim";
var _site = "http://hl7.org/fhir/_site";
var targetScope = "http://hl7.org/fhir/targetScope";
var _monthInterval = "http://hl7.org/fhir/_monthInterval";
var _monitoringProgram = "http://hl7.org/fhir/_monitoringProgram";
var mustHaveValue = "http://hl7.org/fhir/mustHaveValue";
var _interpreter = "http://hl7.org/fhir/_interpreter";
var SubscriptionStatus = "http://hl7.org/fhir/SubscriptionStatus";
var _productOrServiceEnd = "http://hl7.org/fhir/_productOrServiceEnd";
var doseQuantity = "http://hl7.org/fhir/doseQuantity";
var _prism = "http://hl7.org/fhir/_prism";
var highNumerator = "http://hl7.org/fhir/highNumerator";
var contentDefinition = "http://hl7.org/fhir/contentDefinition";
var due2 = "http://hl7.org/fhir/due";
var structureProfile = "http://hl7.org/fhir/structureProfile";
var _acceptLanguage = "http://hl7.org/fhir/_acceptLanguage";
var _RegulatedAuthorization = "http://hl7.org/fhir/_RegulatedAuthorization";
var authorType = "http://hl7.org/fhir/authorType";
var paymentIssuer = "http://hl7.org/fhir/paymentIssuer";
var clinicalTrial = "http://hl7.org/fhir/clinicalTrial";
var _parentSubstanceName = "http://hl7.org/fhir/_parentSubstanceName";
var _high = "http://hl7.org/fhir/_high";
var actorId = "http://hl7.org/fhir/actorId";
var _document = "http://hl7.org/fhir/_document";
var _marketPeriod = "http://hl7.org/fhir/_marketPeriod";
var _denominator = "http://hl7.org/fhir/_denominator";
var accessionIdentifier = "http://hl7.org/fhir/accessionIdentifier";
var VerificationResultPrimarySourceComponent = "http://hl7.org/fhir/VerificationResultPrimarySourceComponent";
var authored = "http://hl7.org/fhir/authored";
var serialNumber = "http://hl7.org/fhir/serialNumber";
var Consent = "http://hl7.org/fhir/Consent";
var _resourceType = "http://hl7.org/fhir/_resourceType";
var outcomeMeasure = "http://hl7.org/fhir/outcomeMeasure";
var purpose = "http://hl7.org/fhir/purpose";
var DiagnosticReportSupportingInfoComponent = "http://hl7.org/fhir/DiagnosticReportSupportingInfoComponent";
var Citation = "http://hl7.org/fhir/Citation";
var _serviced = "http://hl7.org/fhir/_serviced";
var performer = "http://hl7.org/fhir/performer";
var _stratifier = "http://hl7.org/fhir/_stratifier";
var InvoiceParticipantComponent = "http://hl7.org/fhir/InvoiceParticipantComponent";
var requiredBehavior = "http://hl7.org/fhir/requiredBehavior";
var _oralDiet = "http://hl7.org/fhir/_oralDiet";
var monday = "http://hl7.org/fhir/monday";
var MedicationRequestDispenseRequestComponent = "http://hl7.org/fhir/MedicationRequestDispenseRequestComponent";
var _subJurisdiction = "http://hl7.org/fhir/_subJurisdiction";
var _interactant = "http://hl7.org/fhir/_interactant";
var _admitSource = "http://hl7.org/fhir/_admitSource";
var TargetElement = "http://hl7.org/fhir/TargetElement";
var _given = "http://hl7.org/fhir/_given";
var _recorder = "http://hl7.org/fhir/_recorder";
var hasPart2 = "http://hl7.org/fhir/hasPart";
var _cancellationDate = "http://hl7.org/fhir/_cancellationDate";
var supplements = "http://hl7.org/fhir/supplements";
var constraint = "http://hl7.org/fhir/constraint";
var total = "http://hl7.org/fhir/total";
var outcome = "http://hl7.org/fhir/outcome";
var sampleSize = "http://hl7.org/fhir/sampleSize";
var ContributorshipSummary = "http://hl7.org/fhir/ContributorshipSummary";
var PrimitiveType = "http://hl7.org/fhir/PrimitiveType";
var caloricDensity = "http://hl7.org/fhir/caloricDensity";
var MedicationKnowledgeStorageGuidelineEnvironmentalSettingComponent = "http://hl7.org/fhir/MedicationKnowledgeStorageGuidelineEnvironmentalSettingComponent";
var _clinicalUseIssue = "http://hl7.org/fhir/_clinicalUseIssue";
var LinkageItemComponent = "http://hl7.org/fhir/LinkageItemComponent";
var AdministrableProductDefinitionRouteOfAdministrationComponent = "http://hl7.org/fhir/AdministrableProductDefinitionRouteOfAdministrationComponent";
var _conditionalUpdate = "http://hl7.org/fhir/_conditionalUpdate";
var _publisher = "http://hl7.org/fhir/_publisher";
var MolecularSequenceRelativeStartingSequenceComponent = "http://hl7.org/fhir/MolecularSequenceRelativeStartingSequenceComponent";
var _validator = "http://hl7.org/fhir/_validator";
var _inactive = "http://hl7.org/fhir/_inactive";
var AppointmentResponse = "http://hl7.org/fhir/AppointmentResponse";
var _molecularFormula = "http://hl7.org/fhir/_molecularFormula";
var payload = "http://hl7.org/fhir/payload";
var subSite = "http://hl7.org/fhir/subSite";
var _sort = "http://hl7.org/fhir/_sort";
var TestScriptOriginComponent = "http://hl7.org/fhir/TestScriptOriginComponent";
var _allergyIntolerance = "http://hl7.org/fhir/_allergyIntolerance";
var _identityCertificate = "http://hl7.org/fhir/_identityCertificate";
var _additional = "http://hl7.org/fhir/_additional";
var _assurance = "http://hl7.org/fhir/_assurance";
var _careManager = "http://hl7.org/fhir/_careManager";
var ImageRegion2D = "http://hl7.org/fhir/ImageRegion2D";
var forecastReason = "http://hl7.org/fhir/forecastReason";
var supplement = "http://hl7.org/fhir/supplement";
var _nutrient = "http://hl7.org/fhir/_nutrient";
var _sugar = "http://hl7.org/fhir/_sugar";
var entryReference = "http://hl7.org/fhir/entryReference";
var _citedMedium = "http://hl7.org/fhir/_citedMedium";
var MeasureSupplementalDataComponent = "http://hl7.org/fhir/MeasureSupplementalDataComponent";
var input = "http://hl7.org/fhir/input";
var ManufacturedItemDefinition = "http://hl7.org/fhir/ManufacturedItemDefinition";
var Prism = "http://hl7.org/fhir/Prism";
var GroupCharacteristicComponent = "http://hl7.org/fhir/GroupCharacteristicComponent";
var _qualifier = "http://hl7.org/fhir/_qualifier";
var GraphDefinition = "http://hl7.org/fhir/GraphDefinition";
var _BiologicallyDerivedProduct = "http://hl7.org/fhir/_BiologicallyDerivedProduct";
var _Procedure = "http://hl7.org/fhir/_Procedure";
var _receivedTime = "http://hl7.org/fhir/_receivedTime";
var quantity = "http://hl7.org/fhir/quantity";
var _linkId = "http://hl7.org/fhir/_linkId";
var ManufacturedItemDefinitionComponentComponentComponentComponent = "http://hl7.org/fhir/ManufacturedItemDefinitionComponentComponentComponentComponent";
var _prescriber = "http://hl7.org/fhir/_prescriber";
var EvidenceReportSubjectCharacteristicComponent = "http://hl7.org/fhir/EvidenceReportSubjectCharacteristicComponent";
var hasSeverity = "http://hl7.org/fhir/hasSeverity";
var _estimate = "http://hl7.org/fhir/_estimate";
var certainty = "http://hl7.org/fhir/certainty";
var _billingStatus = "http://hl7.org/fhir/_billingStatus";
var ContactDetail = "http://hl7.org/fhir/ContactDetail";
var sessionKey = "http://hl7.org/fhir/sessionKey";
var calibration = "http://hl7.org/fhir/calibration";
var _literal = "http://hl7.org/fhir/_literal";
var ConditionDefinitionQuestionnaireComponent = "http://hl7.org/fhir/ConditionDefinitionQuestionnaireComponent";
var _dateTime = "http://hl7.org/fhir/_dateTime";
var CoverageEligibilityRequest = "http://hl7.org/fhir/CoverageEligibilityRequest";
var _repeatUnitAmountType = "http://hl7.org/fhir/_repeatUnitAmountType";
var pediatricUseIndicator = "http://hl7.org/fhir/pediatricUseIndicator";
var SampledData = "http://hl7.org/fhir/SampledData";
var attester = "http://hl7.org/fhir/attester";
var originatingAppointment = "http://hl7.org/fhir/originatingAppointment";
var progress = "http://hl7.org/fhir/progress";
var _frequencyMax = "http://hl7.org/fhir/_frequencyMax";
var measureScore = "http://hl7.org/fhir/measureScore";
var InsurancePlanCoverageComponent = "http://hl7.org/fhir/InsurancePlanCoverageComponent";
var Evidence = "http://hl7.org/fhir/Evidence";
var _operationalStatus = "http://hl7.org/fhir/_operationalStatus";
var ImagingSelectionPerformerComponent = "http://hl7.org/fhir/ImagingSelectionPerformerComponent";
var restriction = "http://hl7.org/fhir/restriction";
var _issues = "http://hl7.org/fhir/_issues";
var dose = "http://hl7.org/fhir/dose";
var _updateCreate = "http://hl7.org/fhir/_updateCreate";
var _supportingInfo = "http://hl7.org/fhir/_supportingInfo";
var warningOnly = "http://hl7.org/fhir/warningOnly";
var _coverage = "http://hl7.org/fhir/_coverage";
var informationSequence = "http://hl7.org/fhir/informationSequence";
var netContent = "http://hl7.org/fhir/netContent";
var representation = "http://hl7.org/fhir/representation";
var _typeMode = "http://hl7.org/fhir/_typeMode";
var subProperty = "http://hl7.org/fhir/subProperty";
var _subscription = "http://hl7.org/fhir/_subscription";
var Library = "http://hl7.org/fhir/Library";
var DeviceMetricCalibrationComponent = "http://hl7.org/fhir/DeviceMetricCalibrationComponent";
var implicated = "http://hl7.org/fhir/implicated";
var _actualGroup = "http://hl7.org/fhir/_actualGroup";
var _SubstanceProtein = "http://hl7.org/fhir/_SubstanceProtein";
var _capabilities = "http://hl7.org/fhir/_capabilities";
var _associatedParty = "http://hl7.org/fhir/_associatedParty";
var _supplementalData = "http://hl7.org/fhir/_supplementalData";
var _program = "http://hl7.org/fhir/_program";
var offeredIn = "http://hl7.org/fhir/offeredIn";
var TerminologyCapabilitiesCodeSystemComponent = "http://hl7.org/fhir/TerminologyCapabilitiesCodeSystemComponent";
var multipleBirth = "http://hl7.org/fhir/multipleBirth";
var _replacedSequence = "http://hl7.org/fhir/_replacedSequence";
var disclaimer = "http://hl7.org/fhir/disclaimer";
var InsurancePlan = "http://hl7.org/fhir/InsurancePlan";
var _installDate = "http://hl7.org/fhir/_installDate";
var _extends = "http://hl7.org/fhir/_extends";
var fundsReserve = "http://hl7.org/fhir/fundsReserve";
var assigner = "http://hl7.org/fhir/assigner";
var SpecimenProcessingComponent = "http://hl7.org/fhir/SpecimenProcessingComponent";
var occurred = "http://hl7.org/fhir/occurred";
var _lockedDate = "http://hl7.org/fhir/_lockedDate";
var GenomicStudyAnalysisPerformerComponent = "http://hl7.org/fhir/GenomicStudyAnalysisPerformerComponent";
var _lowNumerator = "http://hl7.org/fhir/_lowNumerator";
var _classifier = "http://hl7.org/fhir/_classifier";
var resultsInterpreter = "http://hl7.org/fhir/resultsInterpreter";
var _limit = "http://hl7.org/fhir/_limit";
var _serviceProvider = "http://hl7.org/fhir/_serviceProvider";
var patientInstruction = "http://hl7.org/fhir/patientInstruction";
var binding = "http://hl7.org/fhir/binding";
var recurrenceType = "http://hl7.org/fhir/recurrenceType";
var during = "http://hl7.org/fhir/during";
var capability = "http://hl7.org/fhir/capability";
var Substance = "http://hl7.org/fhir/Substance";
var suspectEntity = "http://hl7.org/fhir/suspectEntity";
var QuestionnaireItemInitialComponent = "http://hl7.org/fhir/QuestionnaireItemInitialComponent";
var occurrenceDate = "http://hl7.org/fhir/occurrenceDate";
var monthlyTemplate = "http://hl7.org/fhir/monthlyTemplate";
var supportingInformation = "http://hl7.org/fhir/supportingInformation";
var authorizationRequired = "http://hl7.org/fhir/authorizationRequired";
var _versionReference = "http://hl7.org/fhir/_versionReference";
var ImmunizationRecommendationRecommendationComponent = "http://hl7.org/fhir/ImmunizationRecommendationRecommendationComponent";
var _measurementPoint = "http://hl7.org/fhir/_measurementPoint";
var batch = "http://hl7.org/fhir/batch";
var _include = "http://hl7.org/fhir/_include";
var ValueSetComposeIncludeFilterComponent = "http://hl7.org/fhir/ValueSetComposeIncludeFilterComponent";
var subcomponent = "http://hl7.org/fhir/subcomponent";
var _DetectedIssue = "http://hl7.org/fhir/_DetectedIssue";
var _GuidanceResponse = "http://hl7.org/fhir/_GuidanceResponse";
var _participantType = "http://hl7.org/fhir/_participantType";
var _division = "http://hl7.org/fhir/_division";
var _section = "http://hl7.org/fhir/_section";
var _MedicationAdministration = "http://hl7.org/fhir/_MedicationAdministration";
var _outcomeMeasure = "http://hl7.org/fhir/_outcomeMeasure";
var PackagingDistributor = "http://hl7.org/fhir/PackagingDistributor";
var _serviceType = "http://hl7.org/fhir/_serviceType";
var _subjectReport = "http://hl7.org/fhir/_subjectReport";
var _initialFill = "http://hl7.org/fhir/_initialFill";
var _administrableDoseForm = "http://hl7.org/fhir/_administrableDoseForm";
var areaOfHybridisation = "http://hl7.org/fhir/areaOfHybridisation";
var subjectType = "http://hl7.org/fhir/subjectType";
var device = "http://hl7.org/fhir/device";
var AddedItem = "http://hl7.org/fhir/AddedItem";
var _region = "http://hl7.org/fhir/_region";
var MedicationKnowledgeRegulatorySubstitutionComponent = "http://hl7.org/fhir/MedicationKnowledgeRegulatorySubstitutionComponent";
var MeasureReportGroupComponent = "http://hl7.org/fhir/MeasureReportGroupComponent";
var _accident = "http://hl7.org/fhir/_accident";
var endRelationship = "http://hl7.org/fhir/endRelationship";
var structure = "http://hl7.org/fhir/structure";
var _library = "http://hl7.org/fhir/_library";
var _descriptionSummary = "http://hl7.org/fhir/_descriptionSummary";
var baseCitation = "http://hl7.org/fhir/baseCitation";
var definitionId = "http://hl7.org/fhir/definitionId";
var _coordinateSystem = "http://hl7.org/fhir/_coordinateSystem";
var characteristicType = "http://hl7.org/fhir/characteristicType";
var _entry = "http://hl7.org/fhir/_entry";
var imageRegion2D = "http://hl7.org/fhir/imageRegion2D";
var _DeviceDefinition = "http://hl7.org/fhir/_DeviceDefinition";
var conclusionCode = "http://hl7.org/fhir/conclusionCode";
var BiologicallyDerivedProductDispensePerformerComponent = "http://hl7.org/fhir/BiologicallyDerivedProductDispensePerformerComponent";
var _caloricDensity = "http://hl7.org/fhir/_caloricDensity";
var ManufacturedItemDefinitionComponentComponent = "http://hl7.org/fhir/ManufacturedItemDefinitionComponentComponent";
var _focal = "http://hl7.org/fhir/_focal";
var indication = "http://hl7.org/fhir/indication";
var _AllergyIntolerance = "http://hl7.org/fhir/_AllergyIntolerance";
var _publishedIn = "http://hl7.org/fhir/_publishedIn";
var partOf2 = "http://hl7.org/fhir/partOf";
var _initialSelected = "http://hl7.org/fhir/_initialSelected";
var _key = "http://hl7.org/fhir/_key";
var backCurve = "http://hl7.org/fhir/backCurve";
var _path = "http://hl7.org/fhir/_path";
var definitionUri = "http://hl7.org/fhir/definitionUri";
var ExplanationOfBenefitItemReviewOutcomeComponent = "http://hl7.org/fhir/ExplanationOfBenefitItemReviewOutcomeComponent";
var DetectedIssueMitigationComponent = "http://hl7.org/fhir/DetectedIssueMitigationComponent";
var _lastOccurrenceDate = "http://hl7.org/fhir/_lastOccurrenceDate";
var _enableWhen = "http://hl7.org/fhir/_enableWhen";
var time = "http://hl7.org/fhir/time";
var MedicinalProductDefinitionNameUsageComponent = "http://hl7.org/fhir/MedicinalProductDefinitionNameUsageComponent";
var ChargeItemDefinitionApplicabilityComponent = "http://hl7.org/fhir/ChargeItemDefinitionApplicabilityComponent";
var InventoryItemCharacteristicComponent = "http://hl7.org/fhir/InventoryItemCharacteristicComponent";
var _dischargeDisposition = "http://hl7.org/fhir/_dischargeDisposition";
var isModifierReason = "http://hl7.org/fhir/isModifierReason";
var StructureDefinitionContextComponent = "http://hl7.org/fhir/StructureDefinitionContextComponent";
var _forecastReason = "http://hl7.org/fhir/_forecastReason";
var SubstanceDefinitionMoietyComponent = "http://hl7.org/fhir/SubstanceDefinitionMoietyComponent";
var _step = "http://hl7.org/fhir/_step";
var rest = "http://hl7.org/fhir/rest";
var issuer = "http://hl7.org/fhir/issuer";
var _nutritionProduct = "http://hl7.org/fhir/_nutritionProduct";
var SubstancePolymer = "http://hl7.org/fhir/SubstancePolymer";
var ValueSetComposeComponent = "http://hl7.org/fhir/ValueSetComposeComponent";
var _doseNumber = "http://hl7.org/fhir/_doseNumber";
var SubstanceDefinitionNameComponent = "http://hl7.org/fhir/SubstanceDefinitionNameComponent";
var derivedFromUri = "http://hl7.org/fhir/derivedFromUri";
var _startParam = "http://hl7.org/fhir/_startParam";
var _attribute = "http://hl7.org/fhir/_attribute";
var _extraDetails = "http://hl7.org/fhir/_extraDetails";
var _accessionIdentifier = "http://hl7.org/fhir/_accessionIdentifier";
var _entryReference = "http://hl7.org/fhir/_entryReference";
var Parameters = "http://hl7.org/fhir/Parameters";
var ChargeItem = "http://hl7.org/fhir/ChargeItem";
var _uid = "http://hl7.org/fhir/_uid";
var chain = "http://hl7.org/fhir/chain";
var _bodySite = "http://hl7.org/fhir/_bodySite";
var qualification = "http://hl7.org/fhir/qualification";
var yearInterval = "http://hl7.org/fhir/yearInterval";
var _developmentStage = "http://hl7.org/fhir/_developmentStage";
var riskAdjustment = "http://hl7.org/fhir/riskAdjustment";
var _estimatedAge = "http://hl7.org/fhir/_estimatedAge";
var RequirementsStatementComponent = "http://hl7.org/fhir/RequirementsStatementComponent";
var _intendedRoute = "http://hl7.org/fhir/_intendedRoute";
var score = "http://hl7.org/fhir/score";
var DeviceRequestParameterComponent = "http://hl7.org/fhir/DeviceRequestParameterComponent";
var _diseaseSymptomProcedure = "http://hl7.org/fhir/_diseaseSymptomProcedure";
var _validationProcess = "http://hl7.org/fhir/_validationProcess";
var ExampleScenarioProcessComponent = "http://hl7.org/fhir/ExampleScenarioProcessComponent";
var _timestamp = "http://hl7.org/fhir/_timestamp";
var supportedProfile = "http://hl7.org/fhir/supportedProfile";
var TestReportSetupActionAssertComponent = "http://hl7.org/fhir/TestReportSetupActionAssertComponent";
var _label = "http://hl7.org/fhir/_label";
var _preparationInstruction = "http://hl7.org/fhir/_preparationInstruction";
var InventoryItemResponsibleOrganizationComponent = "http://hl7.org/fhir/InventoryItemResponsibleOrganizationComponent";
var informationType = "http://hl7.org/fhir/informationType";
var BodyStructureIncludedStructure = "http://hl7.org/fhir/BodyStructureIncludedStructure";
var _requesterLinkId = "http://hl7.org/fhir/_requesterLinkId";
var PlanDefinition = "http://hl7.org/fhir/PlanDefinition";
var postConditions = "http://hl7.org/fhir/postConditions";
var EvidenceVariableDefinitionComponent = "http://hl7.org/fhir/EvidenceVariableDefinitionComponent";
var _meaningWhenMissing = "http://hl7.org/fhir/_meaningWhenMissing";
var DeviceDispense = "http://hl7.org/fhir/DeviceDispense";
var _modelCharacteristic = "http://hl7.org/fhir/_modelCharacteristic";
var SetupAction = "http://hl7.org/fhir/SetupAction";
var _studyDesign = "http://hl7.org/fhir/_studyDesign";
var _analysis = "http://hl7.org/fhir/_analysis";
var insurancePlan = "http://hl7.org/fhir/insurancePlan";
var communicationRequest = "http://hl7.org/fhir/communicationRequest";
var specialty = "http://hl7.org/fhir/specialty";
var _artifact = "http://hl7.org/fhir/_artifact";
var chargeItemCode = "http://hl7.org/fhir/chargeItemCode";
var actuality = "http://hl7.org/fhir/actuality";
var _maxParticipants = "http://hl7.org/fhir/_maxParticipants";
var _Basic = "http://hl7.org/fhir/_Basic";
var _example = "http://hl7.org/fhir/_example";
var _representation = "http://hl7.org/fhir/_representation";
var telecom = "http://hl7.org/fhir/telecom";
var EvidenceCertaintyComponentCertaintyCertainty = "http://hl7.org/fhir/EvidenceCertaintyComponentCertaintyCertainty";
var _lastPerformed = "http://hl7.org/fhir/_lastPerformed";
var _legalState = "http://hl7.org/fhir/_legalState";
var _preAuthPeriod = "http://hl7.org/fhir/_preAuthPeriod";
var GraphDefinitionLinkComponent = "http://hl7.org/fhir/GraphDefinitionLinkComponent";
var workflow = "http://hl7.org/fhir/workflow";
var _incomplete = "http://hl7.org/fhir/_incomplete";
var _sphere = "http://hl7.org/fhir/_sphere";
var _substanceDefinition = "http://hl7.org/fhir/_substanceDefinition";
var informationSource = "http://hl7.org/fhir/informationSource";
var _periodUnit = "http://hl7.org/fhir/_periodUnit";
var paymentIdentifier = "http://hl7.org/fhir/paymentIdentifier";
var stratifier = "http://hl7.org/fhir/stratifier";
var pause = "http://hl7.org/fhir/pause";
var _isActive = "http://hl7.org/fhir/_isActive";
var _synonym = "http://hl7.org/fhir/_synonym";
var _manifestation = "http://hl7.org/fhir/_manifestation";
var _control = "http://hl7.org/fhir/_control";
var RegulatedAuthorizationCaseComponentCase = "http://hl7.org/fhir/RegulatedAuthorizationCaseComponentCase";
var dosageInstruction = "http://hl7.org/fhir/dosageInstruction";
var _implicitRules = "http://hl7.org/fhir/_implicitRules";
var AvailabilityAvailableTimeComponent = "http://hl7.org/fhir/AvailabilityAvailableTimeComponent";
var SpecimenCollectionComponent = "http://hl7.org/fhir/SpecimenCollectionComponent";
var regulatoryAuthority = "http://hl7.org/fhir/regulatoryAuthority";
var _EnrollmentRequest = "http://hl7.org/fhir/_EnrollmentRequest";
var hash = "http://hl7.org/fhir/hash";
var marketDistribution = "http://hl7.org/fhir/marketDistribution";
var countType = "http://hl7.org/fhir/countType";
var _documentation = "http://hl7.org/fhir/_documentation";
var association = "http://hl7.org/fhir/association";
var _intendedJurisdiction = "http://hl7.org/fhir/_intendedJurisdiction";
var _recurrenceType = "http://hl7.org/fhir/_recurrenceType";
var when = "http://hl7.org/fhir/when";
var form = "http://hl7.org/fhir/form";
var _complete = "http://hl7.org/fhir/_complete";
var _shortDoco = "http://hl7.org/fhir/_shortDoco";
var differential = "http://hl7.org/fhir/differential";
var _occurrenceDate = "http://hl7.org/fhir/_occurrenceDate";
var additional = "http://hl7.org/fhir/additional";
var canonical = "http://hl7.org/fhir/canonical";
var _actualComparisonGroup = "http://hl7.org/fhir/_actualComparisonGroup";
var _requestor = "http://hl7.org/fhir/_requestor";
var CommunicationPayloadComponent = "http://hl7.org/fhir/CommunicationPayloadComponent";
var AccountDiagnosisComponent = "http://hl7.org/fhir/AccountDiagnosisComponent";
var _doseStatus = "http://hl7.org/fhir/_doseStatus";
var TestScriptTestComponent = "http://hl7.org/fhir/TestScriptTestComponent";
var TaskOutputComponent = "http://hl7.org/fhir/TaskOutputComponent";
var MeasureReport = "http://hl7.org/fhir/MeasureReport";
var producedFrom = "http://hl7.org/fhir/producedFrom";
var tuesday = "http://hl7.org/fhir/tuesday";
var _sourceReference = "http://hl7.org/fhir/_sourceReference";
var crossReference = "http://hl7.org/fhir/crossReference";
var _Composition = "http://hl7.org/fhir/_Composition";
var subdetailSequence = "http://hl7.org/fhir/subdetailSequence";
var _definitionReference = "http://hl7.org/fhir/_definitionReference";
var supplier = "http://hl7.org/fhir/supplier";
var inputPopulationId = "http://hl7.org/fhir/inputPopulationId";
var CarePlan = "http://hl7.org/fhir/CarePlan";
var clinicalStatus = "http://hl7.org/fhir/clinicalStatus";
var measurementType = "http://hl7.org/fhir/measurementType";
var ImplementationGuideDefinitionGroupingComponent = "http://hl7.org/fhir/ImplementationGuideDefinitionGroupingComponent";
var _fundingSource = "http://hl7.org/fhir/_fundingSource";
var _immunizationEvent = "http://hl7.org/fhir/_immunizationEvent";
var ClaimResponseEventComponent = "http://hl7.org/fhir/ClaimResponseEventComponent";
var statement = "http://hl7.org/fhir/statement";
var ImageRegion3D = "http://hl7.org/fhir/ImageRegion3D";
var _item = "http://hl7.org/fhir/_item";
var _repeatUnit = "http://hl7.org/fhir/_repeatUnit";
var startingMaterial = "http://hl7.org/fhir/startingMaterial";
var _temperatureQualifier = "http://hl7.org/fhir/_temperatureQualifier";
var dosingGuideline = "http://hl7.org/fhir/dosingGuideline";
var _serviceCategory = "http://hl7.org/fhir/_serviceCategory";
var _rate = "http://hl7.org/fhir/_rate";
var _filterDefinition = "http://hl7.org/fhir/_filterDefinition";
var prescriber = "http://hl7.org/fhir/prescriber";
var oid = "http://hl7.org/fhir/oid";
var _attachment = "http://hl7.org/fhir/_attachment";
var _sourceAttachment = "http://hl7.org/fhir/_sourceAttachment";
var _materialType = "http://hl7.org/fhir/_materialType";
var target2 = "http://hl7.org/fhir/target";
var _valueCategory = "http://hl7.org/fhir/_valueCategory";
var _requestMethod = "http://hl7.org/fhir/_requestMethod";
var linkage = "http://hl7.org/fhir/linkage";
var DeviceUdiCarrierComponent = "http://hl7.org/fhir/DeviceUdiCarrierComponent";
var TerminologyCapabilitiesClosureComponent = "http://hl7.org/fhir/TerminologyCapabilitiesClosureComponent";
var _conclusionCode = "http://hl7.org/fhir/_conclusionCode";
var _div = "http://hl7.org/fhir/_div";
var processingMode = "http://hl7.org/fhir/processingMode";
var _rule = "http://hl7.org/fhir/_rule";
var StructureMap = "http://hl7.org/fhir/StructureMap";
var _molecularFormulaByMoiety = "http://hl7.org/fhir/_molecularFormulaByMoiety";
var firstDose = "http://hl7.org/fhir/firstDose";
var BundleEntryResponseComponent = "http://hl7.org/fhir/BundleEntryResponseComponent";
var structureVersion = "http://hl7.org/fhir/structureVersion";
var alias = "http://hl7.org/fhir/alias";
var _programCode = "http://hl7.org/fhir/_programCode";
var _resultForDelete = "http://hl7.org/fhir/_resultForDelete";
var grantee = "http://hl7.org/fhir/grantee";
var _effectiveTime = "http://hl7.org/fhir/_effectiveTime";
var definitionCodeableConcept = "http://hl7.org/fhir/definitionCodeableConcept";
var Property = "http://hl7.org/fhir/Property";
var entryClassifier = "http://hl7.org/fhir/entryClassifier";
var _combining = "http://hl7.org/fhir/_combining";
var paternalOrganismName = "http://hl7.org/fhir/paternalOrganismName";
var _asset = "http://hl7.org/fhir/_asset";
var PaymentReconciliationAllocationComponent = "http://hl7.org/fhir/PaymentReconciliationAllocationComponent";
var _part = "http://hl7.org/fhir/_part";
var actor2 = "http://hl7.org/fhir/actor";
var _isExample = "http://hl7.org/fhir/_isExample";
var navigationLinks = "http://hl7.org/fhir/navigationLinks";
var availability = "http://hl7.org/fhir/availability";
var _specimen = "http://hl7.org/fhir/_specimen";
var term2 = "http://hl7.org/fhir/term";
var notAvailableTime = "http://hl7.org/fhir/notAvailableTime";
var specimenRequirement = "http://hl7.org/fhir/specimenRequirement";
var answer = "http://hl7.org/fhir/answer";
var _citation = "http://hl7.org/fhir/_citation";
var patient = "http://hl7.org/fhir/patient";
var suppress = "http://hl7.org/fhir/suppress";
var additionalUse = "http://hl7.org/fhir/additionalUse";
var _maxDosePerLifetime = "http://hl7.org/fhir/_maxDosePerLifetime";
var Distance = "http://hl7.org/fhir/Distance";
var _primarySource = "http://hl7.org/fhir/_primarySource";
var _opticalActivity = "http://hl7.org/fhir/_opticalActivity";
var _multipleOr = "http://hl7.org/fhir/_multipleOr";
var _specialMeasures = "http://hl7.org/fhir/_specialMeasures";
var usageReason = "http://hl7.org/fhir/usageReason";
var GoalTargetComponent = "http://hl7.org/fhir/GoalTargetComponent";
var measure = "http://hl7.org/fhir/measure";
var contributionType = "http://hl7.org/fhir/contributionType";
var modelNumber = "http://hl7.org/fhir/modelNumber";
var _derivedFromUri = "http://hl7.org/fhir/_derivedFromUri";
var _method = "http://hl7.org/fhir/_method";
var effectiveDate = "http://hl7.org/fhir/effectiveDate";
var _servicePeriod = "http://hl7.org/fhir/_servicePeriod";
var asNeededFor = "http://hl7.org/fhir/asNeededFor";
var ExplanationOfBenefit = "http://hl7.org/fhir/ExplanationOfBenefit";
var _add = "http://hl7.org/fhir/_add";
var _cancelledReason = "http://hl7.org/fhir/_cancelledReason";
var orderMeaning = "http://hl7.org/fhir/orderMeaning";
var testCase = "http://hl7.org/fhir/testCase";
var net = "http://hl7.org/fhir/net";
var VerificationResultAttestationComponent = "http://hl7.org/fhir/VerificationResultAttestationComponent";
var _class = "http://hl7.org/fhir/_class";
var claim = "http://hl7.org/fhir/claim";
var Flag2 = "http://hl7.org/fhir/Flag";
var _riskAdjustment = "http://hl7.org/fhir/_riskAdjustment";
var _compareToSourceExpression = "http://hl7.org/fhir/_compareToSourceExpression";
var _notificationEvent = "http://hl7.org/fhir/_notificationEvent";
var guideline = "http://hl7.org/fhir/guideline";
var amount = "http://hl7.org/fhir/amount";
var _dateFilter = "http://hl7.org/fhir/_dateFilter";
var _statisticType = "http://hl7.org/fhir/_statisticType";
var genus = "http://hl7.org/fhir/genus";
var _MessageHeader = "http://hl7.org/fhir/_MessageHeader";
var _administrationTreatment = "http://hl7.org/fhir/_administrationTreatment";
var _country = "http://hl7.org/fhir/_country";
var insurer = "http://hl7.org/fhir/insurer";
var DeviceDefinitionLinkComponent = "http://hl7.org/fhir/DeviceDefinitionLinkComponent";
var container = "http://hl7.org/fhir/container";
var _params = "http://hl7.org/fhir/_params";
var Goal = "http://hl7.org/fhir/Goal";
var lockedDate = "http://hl7.org/fhir/lockedDate";
var symptomConditionEffect = "http://hl7.org/fhir/symptomConditionEffect";
var referenceStrength = "http://hl7.org/fhir/referenceStrength";
var interval = "http://hl7.org/fhir/interval";
var _compartment = "http://hl7.org/fhir/_compartment";
var classifier = "http://hl7.org/fhir/classifier";
var PackagedProductDefinitionPackagingPropertyComponent = "http://hl7.org/fhir/PackagedProductDefinitionPackagingPropertyComponent";
var setup = "http://hl7.org/fhir/setup";
var _areaOfHybridisation = "http://hl7.org/fhir/_areaOfHybridisation";
var maxLength = "http://hl7.org/fhir/maxLength";
var publisherLocation = "http://hl7.org/fhir/publisherLocation";
var RelatedPerson = "http://hl7.org/fhir/RelatedPerson";
var _storageTempRequirements = "http://hl7.org/fhir/_storageTempRequirements";
var _Organization = "http://hl7.org/fhir/_Organization";
var _postConditions = "http://hl7.org/fhir/_postConditions";
var _DeviceDispense = "http://hl7.org/fhir/_DeviceDispense";
var state = "http://hl7.org/fhir/state";
var SubstanceDefinitionSourceMaterialComponent = "http://hl7.org/fhir/SubstanceDefinitionSourceMaterialComponent";
var _aggregate = "http://hl7.org/fhir/_aggregate";
var fluidConsistencyType = "http://hl7.org/fhir/fluidConsistencyType";
var MoneyQuantity = "http://hl7.org/fhir/MoneyQuantity";
var _specificCost = "http://hl7.org/fhir/_specificCost";
var _organismId = "http://hl7.org/fhir/_organismId";
var StructureMapGroupInputComponent = "http://hl7.org/fhir/StructureMapGroupInputComponent";
var _check = "http://hl7.org/fhir/_check";
var _chargeItemCode = "http://hl7.org/fhir/_chargeItemCode";
var ownedBy = "http://hl7.org/fhir/ownedBy";
var _participantStatus = "http://hl7.org/fhir/_participantStatus";
var _baseFormulaType = "http://hl7.org/fhir/_baseFormulaType";
var shelfLifeStorage = "http://hl7.org/fhir/shelfLifeStorage";
var authorizingPrescription = "http://hl7.org/fhir/authorizingPrescription";
var protein = "http://hl7.org/fhir/protein";
var connectivity = "http://hl7.org/fhir/connectivity";
var information = "http://hl7.org/fhir/information";
var DeviceDefinitionVersionComponent = "http://hl7.org/fhir/DeviceDefinitionVersionComponent";
var AdverseEvent = "http://hl7.org/fhir/AdverseEvent";
var _originRelationshipType = "http://hl7.org/fhir/_originRelationshipType";
var definitionExpression = "http://hl7.org/fhir/definitionExpression";
var ServiceRequestOrderDetailParameterComponent = "http://hl7.org/fhir/ServiceRequestOrderDetailParameterComponent";
var TestPlan = "http://hl7.org/fhir/TestPlan";
var requestProvider = "http://hl7.org/fhir/requestProvider";
var _formatted = "http://hl7.org/fhir/_formatted";
var NutritionProduct = "http://hl7.org/fhir/NutritionProduct";
var ActorDefinition = "http://hl7.org/fhir/ActorDefinition";
var RegulatedAuthorization = "http://hl7.org/fhir/RegulatedAuthorization";
var _facility = "http://hl7.org/fhir/_facility";
var sourceDocument = "http://hl7.org/fhir/sourceDocument";
var _morphology = "http://hl7.org/fhir/_morphology";
var _kind = "http://hl7.org/fhir/_kind";
var color = "http://hl7.org/fhir/color";
var _bounds = "http://hl7.org/fhir/_bounds";
var snapshot = "http://hl7.org/fhir/snapshot";
var SpecimenContainerComponent = "http://hl7.org/fhir/SpecimenContainerComponent";
var unsignedInt = "http://hl7.org/fhir/unsignedInt";
var MedicationKnowledgeMedicineClassificationComponent = "http://hl7.org/fhir/MedicationKnowledgeMedicineClassificationComponent";
var ImmunizationProgramEligibilityComponent = "http://hl7.org/fhir/ImmunizationProgramEligibilityComponent";
var _dose = "http://hl7.org/fhir/_dose";
var useBy = "http://hl7.org/fhir/useBy";
var _start = "http://hl7.org/fhir/_start";
var _import = "http://hl7.org/fhir/_import";
var TaskPerformerComponent = "http://hl7.org/fhir/TaskPerformerComponent";
var grantor = "http://hl7.org/fhir/grantor";
var _purpose = "http://hl7.org/fhir/_purpose";
var benefit = "http://hl7.org/fhir/benefit";
var contributorship = "http://hl7.org/fhir/contributorship";
var PlanDefinitionActionDynamicValueComponent = "http://hl7.org/fhir/PlanDefinitionActionDynamicValueComponent";
var ImagingStudySeriesComponent = "http://hl7.org/fhir/ImagingStudySeriesComponent";
var programStatus = "http://hl7.org/fhir/programStatus";
var _evidence = "http://hl7.org/fhir/_evidence";
var ClinicalUseDefinitionInteractionInteractantComponent = "http://hl7.org/fhir/ClinicalUseDefinitionInteractionInteractantComponent";
var _highNumerator = "http://hl7.org/fhir/_highNumerator";
var ChargeItemDefinitionPropertyGroupComponent = "http://hl7.org/fhir/ChargeItemDefinitionPropertyGroupComponent";
var boolean = "http://hl7.org/fhir/boolean";
var PackagedProductDefinitionProperty = "http://hl7.org/fhir/PackagedProductDefinitionProperty";
var _Group = "http://hl7.org/fhir/_Group";
var _media = "http://hl7.org/fhir/_media";
var hasStage = "http://hl7.org/fhir/hasStage";
var TestReportSetupActionAssertRequirementComponent = "http://hl7.org/fhir/TestReportSetupActionAssertRequirementComponent";
var _onBehalfOf = "http://hl7.org/fhir/_onBehalfOf";
var SubstanceReferenceInformationGeneElementComponent = "http://hl7.org/fhir/SubstanceReferenceInformationGeneElementComponent";
var maxCount = "http://hl7.org/fhir/maxCount";
var enableWhen = "http://hl7.org/fhir/enableWhen";
var regulator = "http://hl7.org/fhir/regulator";
var _medicineClassification = "http://hl7.org/fhir/_medicineClassification";
var imageRegion3D = "http://hl7.org/fhir/imageRegion3D";
var _source = "http://hl7.org/fhir/_source";
var _hoursOfOperation = "http://hl7.org/fhir/_hoursOfOperation";
var admission = "http://hl7.org/fhir/admission";
var extension = "http://hl7.org/fhir/extension";
var _reAdmission = "http://hl7.org/fhir/_reAdmission";
var integer64 = "http://hl7.org/fhir/integer64";
var _Task = "http://hl7.org/fhir/_Task";
var HealthcareService = "http://hl7.org/fhir/HealthcareService";
var _Appointment = "http://hl7.org/fhir/_Appointment";
var _crossReference = "http://hl7.org/fhir/_crossReference";
var _hasPart = "http://hl7.org/fhir/_hasPart";
var _executionPeriod = "http://hl7.org/fhir/_executionPeriod";
var Expression = "http://hl7.org/fhir/Expression";
var Class = "http://hl7.org/fhir/Class";
var _operation = "http://hl7.org/fhir/_operation";
var _adjustmentReason = "http://hl7.org/fhir/_adjustmentReason";
var notConsumed = "http://hl7.org/fhir/notConsumed";
var relativePath = "http://hl7.org/fhir/relativePath";
var ImplementationGuideDefinitionComponent = "http://hl7.org/fhir/ImplementationGuideDefinitionComponent";
var geneSequenceOrigin = "http://hl7.org/fhir/geneSequenceOrigin";
var level = "http://hl7.org/fhir/level";
var TestReportTestComponent = "http://hl7.org/fhir/TestReportTestComponent";
var doseNumber = "http://hl7.org/fhir/doseNumber";
var ParametersParameterComponentParameterParameter = "http://hl7.org/fhir/ParametersParameterComponentParameterParameter";
var age = "http://hl7.org/fhir/age";
var _payload = "http://hl7.org/fhir/_payload";
var entityRelatedness = "http://hl7.org/fhir/entityRelatedness";
var startParam = "http://hl7.org/fhir/startParam";
var _intraspecificDescription = "http://hl7.org/fhir/_intraspecificDescription";
var _clinicalStatus = "http://hl7.org/fhir/_clinicalStatus";
var _compositeScoring = "http://hl7.org/fhir/_compositeScoring";
var jurisdiction = "http://hl7.org/fhir/jurisdiction";
var Exemption = "http://hl7.org/fhir/Exemption";
var _requestHeader = "http://hl7.org/fhir/_requestHeader";
var _certainty = "http://hl7.org/fhir/_certainty";
var connectionType = "http://hl7.org/fhir/connectionType";
var _groupingBehavior = "http://hl7.org/fhir/_groupingBehavior";
var _translations = "http://hl7.org/fhir/_translations";
var photo = "http://hl7.org/fhir/photo";
var multipleAnd = "http://hl7.org/fhir/multipleAnd";
var _gender = "http://hl7.org/fhir/_gender";
var _coding = "http://hl7.org/fhir/_coding";
var _system = "http://hl7.org/fhir/_system";
var _Slot = "http://hl7.org/fhir/_Slot";
var freeToShare = "http://hl7.org/fhir/freeToShare";
var ElementDefinitionMappingComponent = "http://hl7.org/fhir/ElementDefinitionMappingComponent";
var copackagedIndicator = "http://hl7.org/fhir/copackagedIndicator";
var precheckBehavior = "http://hl7.org/fhir/precheckBehavior";
var map2 = "http://hl7.org/fhir/map";
var additionalInfo = "http://hl7.org/fhir/additionalInfo";
var preConditions = "http://hl7.org/fhir/preConditions";
var numberOfSubunits = "http://hl7.org/fhir/numberOfSubunits";
var numberOfEvents = "http://hl7.org/fhir/numberOfEvents";
var _sender = "http://hl7.org/fhir/_sender";
var _validCodedValueSet = "http://hl7.org/fhir/_validCodedValueSet";
var _referenceInformation = "http://hl7.org/fhir/_referenceInformation";
var longitude2 = "http://hl7.org/fhir/longitude";
var _contentDerivative = "http://hl7.org/fhir/_contentDerivative";
var _reportedDateTime = "http://hl7.org/fhir/_reportedDateTime";
var Primitive = "http://hl7.org/fhir/Primitive";
var _processingMode = "http://hl7.org/fhir/_processingMode";
var _composition = "http://hl7.org/fhir/_composition";
var _width = "http://hl7.org/fhir/_width";
var _valueAlternatives = "http://hl7.org/fhir/_valueAlternatives";
var hint = "http://hl7.org/fhir/hint";
var license2 = "http://hl7.org/fhir/license";
var created3 = "http://hl7.org/fhir/created";
var expectedInResearchStudy = "http://hl7.org/fhir/expectedInResearchStudy";
var originalPrescription = "http://hl7.org/fhir/originalPrescription";
var scoring = "http://hl7.org/fhir/scoring";
var ClinicalUseDefinitionInteractionComponent = "http://hl7.org/fhir/ClinicalUseDefinitionInteractionComponent";
var PlanDefinitionActorComponent = "http://hl7.org/fhir/PlanDefinitionActorComponent";
var subjectStatus = "http://hl7.org/fhir/subjectStatus";
var _qualitativeRisk = "http://hl7.org/fhir/_qualitativeRisk";
var _header = "http://hl7.org/fhir/_header";
var recurrenceId2 = "http://hl7.org/fhir/recurrenceId";
var _author = "http://hl7.org/fhir/_author";
var responsibleOrganization = "http://hl7.org/fhir/responsibleOrganization";
var TriggerDefinition = "http://hl7.org/fhir/TriggerDefinition";
var _BackboneElement = "http://hl7.org/fhir/_BackboneElement";
var _offeredIn = "http://hl7.org/fhir/_offeredIn";
var _accessionNumber = "http://hl7.org/fhir/_accessionNumber";
var legalState = "http://hl7.org/fhir/legalState";
var incomplete = "http://hl7.org/fhir/incomplete";
var CodeableReference = "http://hl7.org/fhir/CodeableReference";
var activity = "http://hl7.org/fhir/activity";
var availableEndTime = "http://hl7.org/fhir/availableEndTime";
var mimeType = "http://hl7.org/fhir/mimeType";
var NutritionOrderEnteralFormulaAdministrationComponent = "http://hl7.org/fhir/NutritionOrderEnteralFormulaAdministrationComponent";
var periodUnit = "http://hl7.org/fhir/periodUnit";
var EvidenceReportRelatesToComponent = "http://hl7.org/fhir/EvidenceReportRelatesToComponent";
var SubstanceDefinition = "http://hl7.org/fhir/SubstanceDefinition";
var _useContext = "http://hl7.org/fhir/_useContext";
var _instantiatesUri = "http://hl7.org/fhir/_instantiatesUri";
var authorizationUrl = "http://hl7.org/fhir/authorizationUrl";
var contributedToDeath = "http://hl7.org/fhir/contributedToDeath";
var confidentialityIndicator = "http://hl7.org/fhir/confidentialityIndicator";
var _diagnosisSequence = "http://hl7.org/fhir/_diagnosisSequence";
var selectionBehavior = "http://hl7.org/fhir/selectionBehavior";
var _time = "http://hl7.org/fhir/_time";
var addresses = "http://hl7.org/fhir/addresses";
var _dataRequirement = "http://hl7.org/fhir/_dataRequirement";
var CapabilityStatementRestResourceComponent = "http://hl7.org/fhir/CapabilityStatementRestResourceComponent";
var _lineItem = "http://hl7.org/fhir/_lineItem";
var _InventoryReport = "http://hl7.org/fhir/_InventoryReport";
var _copyright = "http://hl7.org/fhir/_copyright";
var _Substance = "http://hl7.org/fhir/_Substance";
var _timing = "http://hl7.org/fhir/_timing";
var wasSubstituted = "http://hl7.org/fhir/wasSubstituted";
var aggregation = "http://hl7.org/fhir/aggregation";
var _authorDescription = "http://hl7.org/fhir/_authorDescription";
var _filter = "http://hl7.org/fhir/_filter";
var MedicinalProductDefinitionOperationComponent = "http://hl7.org/fhir/MedicinalProductDefinitionOperationComponent";
var _defaultValue = "http://hl7.org/fhir/_defaultValue";
var StructureMapStructureComponent = "http://hl7.org/fhir/StructureMapStructureComponent";
var recipient = "http://hl7.org/fhir/recipient";
var _lotNumber = "http://hl7.org/fhir/_lotNumber";
var QuestionnaireItemAnswerOptionComponent = "http://hl7.org/fhir/QuestionnaireItemAnswerOptionComponent";
var applies = "http://hl7.org/fhir/applies";
var caseSensitive = "http://hl7.org/fhir/caseSensitive";
var subtype = "http://hl7.org/fhir/subtype";
var _field = "http://hl7.org/fhir/_field";
var _hasIngredient = "http://hl7.org/fhir/_hasIngredient";
var strength = "http://hl7.org/fhir/strength";
var linkId = "http://hl7.org/fhir/linkId";
var StructureMapGroupRuleTargetComponent = "http://hl7.org/fhir/StructureMapGroupRuleTargetComponent";
var _resultingEffect = "http://hl7.org/fhir/_resultingEffect";
var altitude2 = "http://hl7.org/fhir/altitude";
var phase = "http://hl7.org/fhir/phase";
var _numberOfRepeatsAllowed = "http://hl7.org/fhir/_numberOfRepeatsAllowed";
var groupSize = "http://hl7.org/fhir/groupSize";
var _oligoNucleotideType = "http://hl7.org/fhir/_oligoNucleotideType";
var doseStatus = "http://hl7.org/fhir/doseStatus";
var directnessMatch = "http://hl7.org/fhir/directnessMatch";
var AppointmentParticipantComponent = "http://hl7.org/fhir/AppointmentParticipantComponent";
var _continuous = "http://hl7.org/fhir/_continuous";
var _dispenseInterval = "http://hl7.org/fhir/_dispenseInterval";
var stage = "http://hl7.org/fhir/stage";
var associatedMedication = "http://hl7.org/fhir/associatedMedication";
var dateOfDiagnosis = "http://hl7.org/fhir/dateOfDiagnosis";
var _actualPeriod = "http://hl7.org/fhir/_actualPeriod";
var ValueSet = "http://hl7.org/fhir/ValueSet";
var lastOccurrence = "http://hl7.org/fhir/lastOccurrence";
var disulfideLinkage = "http://hl7.org/fhir/disulfideLinkage";
var participatingOrganization = "http://hl7.org/fhir/participatingOrganization";
var ResearchSubject = "http://hl7.org/fhir/ResearchSubject";
var heartbeatPeriod = "http://hl7.org/fhir/heartbeatPeriod";
var OrganizationAffiliation = "http://hl7.org/fhir/OrganizationAffiliation";
var _binding = "http://hl7.org/fhir/_binding";
var SubstanceNucleicAcidSubunitLinkageComponent = "http://hl7.org/fhir/SubstanceNucleicAcidSubunitLinkageComponent";
var ImplementationGuideDefinitionPageComponent = "http://hl7.org/fhir/ImplementationGuideDefinitionPageComponent";
var FamilyMemberHistoryProcedureComponent = "http://hl7.org/fhir/FamilyMemberHistoryProcedureComponent";
var subscriptionTopic = "http://hl7.org/fhir/subscriptionTopic";
var _resource = "http://hl7.org/fhir/_resource";
var correspondingContact = "http://hl7.org/fhir/correspondingContact";
var graph2 = "http://hl7.org/fhir/graph";
var _QuestionnaireResponse = "http://hl7.org/fhir/_QuestionnaireResponse";
var RequestOrchestrationActionComponentAction = "http://hl7.org/fhir/RequestOrchestrationActionComponentAction";
var issues = "http://hl7.org/fhir/issues";
var instances = "http://hl7.org/fhir/instances";
var _isDefining = "http://hl7.org/fhir/_isDefining";
var primaryPurposeType = "http://hl7.org/fhir/primaryPurposeType";
var _specimenRequirement = "http://hl7.org/fhir/_specimenRequirement";
var _sourceDocument = "http://hl7.org/fhir/_sourceDocument";
var SubstanceReferenceInformation = "http://hl7.org/fhir/SubstanceReferenceInformation";
var _multipleBirth = "http://hl7.org/fhir/_multipleBirth";
var _InsurancePlan = "http://hl7.org/fhir/_InsurancePlan";
var repeatUnit = "http://hl7.org/fhir/repeatUnit";
var StructureDefinition = "http://hl7.org/fhir/StructureDefinition";
var _node = "http://hl7.org/fhir/_node";
var TestPlanTestCaseAssertionComponent = "http://hl7.org/fhir/TestPlanTestCaseAssertionComponent";
var relatedData = "http://hl7.org/fhir/relatedData";
var _content = "http://hl7.org/fhir/_content";
var _associationType = "http://hl7.org/fhir/_associationType";
var _regulatoryBasis = "http://hl7.org/fhir/_regulatoryBasis";
var attachment2 = "http://hl7.org/fhir/attachment";
var ActionSubject = "http://hl7.org/fhir/ActionSubject";
var _packagedMedicinalProduct = "http://hl7.org/fhir/_packagedMedicinalProduct";
var _packagedProduct = "http://hl7.org/fhir/_packagedProduct";
var _onset = "http://hl7.org/fhir/_onset";
var _basedOn = "http://hl7.org/fhir/_basedOn";
var CitationCitedArtifactRelatesToComponent = "http://hl7.org/fhir/CitationCitedArtifactRelatesToComponent";
var _backCurve = "http://hl7.org/fhir/_backCurve";
var AuditEventOutcomeComponent = "http://hl7.org/fhir/AuditEventOutcomeComponent";
var payee = "http://hl7.org/fhir/payee";
var _reporter = "http://hl7.org/fhir/_reporter";
var SubstanceDefinitionStructureComponentMolecularWeight = "http://hl7.org/fhir/SubstanceDefinitionStructureComponentMolecularWeight";
var biologicalSourceEvent = "http://hl7.org/fhir/biologicalSourceEvent";
var RequestOrchestrationActionComponent = "http://hl7.org/fhir/RequestOrchestrationActionComponent";
var period = "http://hl7.org/fhir/period";
var SearchParameterComponentComponent = "http://hl7.org/fhir/SearchParameterComponentComponent";
var protocolPerformed = "http://hl7.org/fhir/protocolPerformed";
var ResearchStudyLabelComponent = "http://hl7.org/fhir/ResearchStudyLabelComponent";
var _careTeamSequence = "http://hl7.org/fhir/_careTeamSequence";
var instantiates = "http://hl7.org/fhir/instantiates";
var _patientCharacteristic = "http://hl7.org/fhir/_patientCharacteristic";
var _allowedType = "http://hl7.org/fhir/_allowedType";
var Element = "http://hl7.org/fhir/Element";
var DeviceMetric = "http://hl7.org/fhir/DeviceMetric";
var _maxTreatmentPeriod = "http://hl7.org/fhir/_maxTreatmentPeriod";
var _InventoryItem = "http://hl7.org/fhir/_InventoryItem";
var AppointmentRecurrenceTemplateComponent = "http://hl7.org/fhir/AppointmentRecurrenceTemplateComponent";
var targetDisease = "http://hl7.org/fhir/targetDisease";
var PlanDefinitionActionComponentAction = "http://hl7.org/fhir/PlanDefinitionActionComponentAction";
var file = "http://hl7.org/fhir/file";
var const__workaround = "http://hl7.org/fhir/const";
var citedMedium = "http://hl7.org/fhir/citedMedium";
var _frames = "http://hl7.org/fhir/_frames";
var multipleOr = "http://hl7.org/fhir/multipleOr";
var inputParameters = "http://hl7.org/fhir/inputParameters";
var causality = "http://hl7.org/fhir/causality";
var SupplyDelivery = "http://hl7.org/fhir/SupplyDelivery";
var minimumId = "http://hl7.org/fhir/minimumId";
var _processNote = "http://hl7.org/fhir/_processNote";
var Money = "http://hl7.org/fhir/Money";
var _BackboneType = "http://hl7.org/fhir/_BackboneType";
var _Endpoint = "http://hl7.org/fhir/_Endpoint";
var udiDeviceIdentifier = "http://hl7.org/fhir/udiDeviceIdentifier";
var EnteralFormulaSchedule = "http://hl7.org/fhir/EnteralFormulaSchedule";
var diseaseStatus = "http://hl7.org/fhir/diseaseStatus";
var _expectedSupplyDuration = "http://hl7.org/fhir/_expectedSupplyDuration";
var ifModifiedSince = "http://hl7.org/fhir/ifModifiedSince";
var formCode = "http://hl7.org/fhir/formCode";
var _connectionType = "http://hl7.org/fhir/_connectionType";
var ImplementationGuideDefinitionResourceComponent = "http://hl7.org/fhir/ImplementationGuideDefinitionResourceComponent";
var _fundsReserveRequested = "http://hl7.org/fhir/_fundsReserveRequested";
var dateFilter = "http://hl7.org/fhir/dateFilter";
var matchStatus = "http://hl7.org/fhir/matchStatus";
var usePeriod = "http://hl7.org/fhir/usePeriod";
var _participant = "http://hl7.org/fhir/_participant";
var MessageDestination = "http://hl7.org/fhir/MessageDestination";
var _additionalInfo = "http://hl7.org/fhir/_additionalInfo";
var _numberOfEvents = "http://hl7.org/fhir/_numberOfEvents";
var _includedStructure = "http://hl7.org/fhir/_includedStructure";
var _imageRegion2D = "http://hl7.org/fhir/_imageRegion2D";
var _tax = "http://hl7.org/fhir/_tax";
var _appointment = "http://hl7.org/fhir/_appointment";
var treatmentIntent = "http://hl7.org/fhir/treatmentIntent";
var SubstanceDefinitionCodeComponent = "http://hl7.org/fhir/SubstanceDefinitionCodeComponent";
var _study = "http://hl7.org/fhir/_study";
var _ratioType = "http://hl7.org/fhir/_ratioType";
var policyHolder = "http://hl7.org/fhir/policyHolder";
var region2 = "http://hl7.org/fhir/region";
var operationType = "http://hl7.org/fhir/operationType";
var _actuality = "http://hl7.org/fhir/_actuality";
var _definitionUri = "http://hl7.org/fhir/_definitionUri";
var organismId = "http://hl7.org/fhir/organismId";
var ManufacturedItemDefinitionComponentComponentComponentProperty = "http://hl7.org/fhir/ManufacturedItemDefinitionComponentComponentComponentProperty";
var _consumedItem = "http://hl7.org/fhir/_consumedItem";
var thursday = "http://hl7.org/fhir/thursday";
var _rules = "http://hl7.org/fhir/_rules";
var dependent = "http://hl7.org/fhir/dependent";
var deliverFrom = "http://hl7.org/fhir/deliverFrom";
var ImmunizationProtocolAppliedComponent = "http://hl7.org/fhir/ImmunizationProtocolAppliedComponent";
var actualGroup = "http://hl7.org/fhir/actualGroup";
var Age = "http://hl7.org/fhir/Age";
var subsumption = "http://hl7.org/fhir/subsumption";
var ElementDefinitionConstraintComponent = "http://hl7.org/fhir/ElementDefinitionConstraintComponent";
var subjectResults = "http://hl7.org/fhir/subjectResults";
var OperationDefinitionOverloadComponent = "http://hl7.org/fhir/OperationDefinitionOverloadComponent";
var recurrenceTemplate = "http://hl7.org/fhir/recurrenceTemplate";
var doseForm = "http://hl7.org/fhir/doseForm";
var adherence = "http://hl7.org/fhir/adherence";
var ServiceRequest = "http://hl7.org/fhir/ServiceRequest";
var deviceIdentifier = "http://hl7.org/fhir/deviceIdentifier";
var _reasonLinkId = "http://hl7.org/fhir/_reasonLinkId";
var versionId = "http://hl7.org/fhir/versionId";
var componentPart = "http://hl7.org/fhir/componentPart";
var _value = "http://hl7.org/fhir/_value";
var TestReportParticipantComponent = "http://hl7.org/fhir/TestReportParticipantComponent";
var morphology = "http://hl7.org/fhir/morphology";
var date3 = "http://hl7.org/fhir/date";
var _isModifier = "http://hl7.org/fhir/_isModifier";
var _allDay = "http://hl7.org/fhir/_allDay";
var contentReference = "http://hl7.org/fhir/contentReference";
var _sunday = "http://hl7.org/fhir/_sunday";
var DeviceUsageAdherenceComponent = "http://hl7.org/fhir/DeviceUsageAdherenceComponent";
var maxSingleDose = "http://hl7.org/fhir/maxSingleDose";
var referenceRange = "http://hl7.org/fhir/referenceRange";
var _pages = "http://hl7.org/fhir/_pages";
var DeviceDefinitionGuidelineComponent = "http://hl7.org/fhir/DeviceDefinitionGuidelineComponent";
var _temperatureRange = "http://hl7.org/fhir/_temperatureRange";
var _sequenceType = "http://hl7.org/fhir/_sequenceType";
var _partNumber = "http://hl7.org/fhir/_partNumber";
var _term = "http://hl7.org/fhir/_term";
var StructureDefinitionDifferentialComponent = "http://hl7.org/fhir/StructureDefinitionDifferentialComponent";
var _udi = "http://hl7.org/fhir/_udi";
var _telecom = "http://hl7.org/fhir/_telecom";
var CitationCitedArtifactPublicationFormPublishedInComponent = "http://hl7.org/fhir/CitationCitedArtifactPublicationFormPublishedInComponent";
var _wasSubstituted = "http://hl7.org/fhir/_wasSubstituted";
var initial = "http://hl7.org/fhir/initial";
var doNotPerform = "http://hl7.org/fhir/doNotPerform";
var diameter = "http://hl7.org/fhir/diameter";
var _property = "http://hl7.org/fhir/_property";
var MessageHeaderResponseComponent = "http://hl7.org/fhir/MessageHeaderResponseComponent";
var Linkage = "http://hl7.org/fhir/Linkage";
var permittedUnit = "http://hl7.org/fhir/permittedUnit";
var _sex = "http://hl7.org/fhir/_sex";
var genomeBuild = "http://hl7.org/fhir/genomeBuild";
var changePattern = "http://hl7.org/fhir/changePattern";
var MedicationRequestSubstitutionComponent = "http://hl7.org/fhir/MedicationRequestSubstitutionComponent";
var _authority = "http://hl7.org/fhir/_authority";
var onBehalfOf = "http://hl7.org/fhir/onBehalfOf";
var _rateAggregation = "http://hl7.org/fhir/_rateAggregation";
var managingOrganization = "http://hl7.org/fhir/managingOrganization";
var handling = "http://hl7.org/fhir/handling";
var notConsumedReason = "http://hl7.org/fhir/notConsumedReason";
var axis = "http://hl7.org/fhir/axis";
var _udiCarrier = "http://hl7.org/fhir/_udiCarrier";
var paymentBy = "http://hl7.org/fhir/paymentBy";
var _insurancePlan = "http://hl7.org/fhir/_insurancePlan";
var subDetailSequence = "http://hl7.org/fhir/subDetailSequence";
var DataRequirementValueFilterComponent = "http://hl7.org/fhir/DataRequirementValueFilterComponent";
var problem = "http://hl7.org/fhir/problem";
var initialFill = "http://hl7.org/fhir/initialFill";
var _ManufacturedItemDefinition = "http://hl7.org/fhir/_ManufacturedItemDefinition";
var _improvementNotation = "http://hl7.org/fhir/_improvementNotation";
var ClinicalUseDefinitionIndicationComponentOtherTherapy = "http://hl7.org/fhir/ClinicalUseDefinitionIndicationComponentOtherTherapy";
var fraction = "http://hl7.org/fhir/fraction";
var _lastOccurrence = "http://hl7.org/fhir/_lastOccurrence";
var _assessment = "http://hl7.org/fhir/_assessment";
var Patient = "http://hl7.org/fhir/Patient";
var _identified = "http://hl7.org/fhir/_identified";
var ExplanationOfBenefitAdjudication = "http://hl7.org/fhir/ExplanationOfBenefitAdjudication";
var _Subscription = "http://hl7.org/fhir/_Subscription";
var tag2 = "http://hl7.org/fhir/tag";
var _performed = "http://hl7.org/fhir/_performed";
var _formOf = "http://hl7.org/fhir/_formOf";
var DeviceDefinitionPackagingComponentPackagingPackaging = "http://hl7.org/fhir/DeviceDefinitionPackagingComponentPackagingPackaging";
var _subrogation = "http://hl7.org/fhir/_subrogation";
var _deceased = "http://hl7.org/fhir/_deceased";
var relatedAccount = "http://hl7.org/fhir/relatedAccount";
var Transport = "http://hl7.org/fhir/Transport";
var Measure = "http://hl7.org/fhir/Measure";
var RiskAssessment = "http://hl7.org/fhir/RiskAssessment";
var _teardown = "http://hl7.org/fhir/_teardown";
var degreeOfPolymerisation = "http://hl7.org/fhir/degreeOfPolymerisation";
var _CoverageEligibilityRequest = "http://hl7.org/fhir/_CoverageEligibilityRequest";
var _Medication = "http://hl7.org/fhir/_Medication";
var manufacturedDoseForm = "http://hl7.org/fhir/manufacturedDoseForm";
var sliceName = "http://hl7.org/fhir/sliceName";
var dateAsserted = "http://hl7.org/fhir/dateAsserted";
var ContractParty = "http://hl7.org/fhir/ContractParty";
var validationStatus = "http://hl7.org/fhir/validationStatus";
var TestScriptMetadataComponent = "http://hl7.org/fhir/TestScriptMetadataComponent";
var _headerField = "http://hl7.org/fhir/_headerField";
var geographicalLocation = "http://hl7.org/fhir/geographicalLocation";
var versionNeeded = "http://hl7.org/fhir/versionNeeded";
var ConceptDefinition = "http://hl7.org/fhir/ConceptDefinition";
var _sigFormat = "http://hl7.org/fhir/_sigFormat";
var publishedIn = "http://hl7.org/fhir/publishedIn";
var sphere = "http://hl7.org/fhir/sphere";
var _SubstanceDefinition = "http://hl7.org/fhir/_SubstanceDefinition";
var SubstanceDefinitionNameOfficialComponent = "http://hl7.org/fhir/SubstanceDefinitionNameOfficialComponent";
var _listRuleId = "http://hl7.org/fhir/_listRuleId";
var started = "http://hl7.org/fhir/started";
var EvidenceVariable = "http://hl7.org/fhir/EvidenceVariable";
var ResearchStudyOutcomeMeasureComponent = "http://hl7.org/fhir/ResearchStudyOutcomeMeasureComponent";
var allowedResponse = "http://hl7.org/fhir/allowedResponse";
var _ElementDefinition = "http://hl7.org/fhir/_ElementDefinition";
var CitationCitedArtifactContributorshipComponent = "http://hl7.org/fhir/CitationCitedArtifactContributorshipComponent";
var _contentType = "http://hl7.org/fhir/_contentType";
var _DeviceUsage = "http://hl7.org/fhir/_DeviceUsage";
var DeviceDefinitionUdiDeviceIdentifierComponent = "http://hl7.org/fhir/DeviceDefinitionUdiDeviceIdentifierComponent";
var document3 = "http://hl7.org/fhir/document";
var event = "http://hl7.org/fhir/event";
var Guarantor = "http://hl7.org/fhir/Guarantor";
var molecularWeight = "http://hl7.org/fhir/molecularWeight";
var substitution = "http://hl7.org/fhir/substitution";
var NutritionOrderSupplementComponent = "http://hl7.org/fhir/NutritionOrderSupplementComponent";
var _relativeRisk = "http://hl7.org/fhir/_relativeRisk";
var _volume = "http://hl7.org/fhir/_volume";
var _manager = "http://hl7.org/fhir/_manager";
var _presentation = "http://hl7.org/fhir/_presentation";
var _linkage = "http://hl7.org/fhir/_linkage";
var isDefault = "http://hl7.org/fhir/isDefault";
var BodyStructure = "http://hl7.org/fhir/BodyStructure";
var _relationship = "http://hl7.org/fhir/_relationship";
var _maxDispense = "http://hl7.org/fhir/_maxDispense";
var ChargeItemDefinition = "http://hl7.org/fhir/ChargeItemDefinition";
var _SupplyDelivery = "http://hl7.org/fhir/_SupplyDelivery";
var _specialArrangement = "http://hl7.org/fhir/_specialArrangement";
var DosageDoseAndRateComponent = "http://hl7.org/fhir/DosageDoseAndRateComponent";
var _guideline = "http://hl7.org/fhir/_guideline";
var _grantee = "http://hl7.org/fhir/_grantee";
var serviced = "http://hl7.org/fhir/serviced";
var _active = "http://hl7.org/fhir/_active";
var _preference = "http://hl7.org/fhir/_preference";
var useContext = "http://hl7.org/fhir/useContext";
var _container = "http://hl7.org/fhir/_container";
var justification = "http://hl7.org/fhir/justification";
var oralDiet = "http://hl7.org/fhir/oralDiet";
var _testingDestination = "http://hl7.org/fhir/_testingDestination";
var lastRevisionDate = "http://hl7.org/fhir/lastRevisionDate";
var NutritionIntakeIngredientLabelComponent = "http://hl7.org/fhir/NutritionIntakeIngredientLabelComponent";
var QuestionnaireResponseItemComponentItem = "http://hl7.org/fhir/QuestionnaireResponseItemComponentItem";
var PermissionJustificationComponent = "http://hl7.org/fhir/PermissionJustificationComponent";
var recorder = "http://hl7.org/fhir/recorder";
var ImmunizationRecommendationRecommendationDateCriterionComponent = "http://hl7.org/fhir/ImmunizationRecommendationRecommendationDateCriterionComponent";
var _focus = "http://hl7.org/fhir/_focus";
var countingDateTime = "http://hl7.org/fhir/countingDateTime";
var MedicationKnowledge = "http://hl7.org/fhir/MedicationKnowledge";
var ConditionDefinition = "http://hl7.org/fhir/ConditionDefinition";
var noMap = "http://hl7.org/fhir/noMap";
var _userSelected = "http://hl7.org/fhir/_userSelected";
var appointmentRequired = "http://hl7.org/fhir/appointmentRequired";
var _numberOfStudies = "http://hl7.org/fhir/_numberOfStudies";
var capabilities = "http://hl7.org/fhir/capabilities";
var Benefit = "http://hl7.org/fhir/Benefit";
var _uri = "http://hl7.org/fhir/_uri";
var _max = "http://hl7.org/fhir/_max";
var inactive = "http://hl7.org/fhir/inactive";
var other = "http://hl7.org/fhir/other";
var dependsOn = "http://hl7.org/fhir/dependsOn";
var citedArtifact = "http://hl7.org/fhir/citedArtifact";
var fixture = "http://hl7.org/fhir/fixture";
var _insurer = "http://hl7.org/fhir/_insurer";
var _endParam = "http://hl7.org/fhir/_endParam";
var continuous = "http://hl7.org/fhir/continuous";
var SubstancePolymerRepeatRepeatUnitStructuralRepresentationComponent = "http://hl7.org/fhir/SubstancePolymerRepeatRepeatUnitStructuralRepresentationComponent";
var _responsibleOrganization = "http://hl7.org/fhir/_responsibleOrganization";
var url3 = "http://hl7.org/fhir/url";
var compareToSourceExpression = "http://hl7.org/fhir/compareToSourceExpression";
var nutrient = "http://hl7.org/fhir/nutrient";
var _subjectResults = "http://hl7.org/fhir/_subjectResults";
var DocumentReferenceRelatesToComponent = "http://hl7.org/fhir/DocumentReferenceRelatesToComponent";
var ImagingStudy = "http://hl7.org/fhir/ImagingStudy";
var AppointmentRecurrenceTemplateYearlyTemplateComponent = "http://hl7.org/fhir/AppointmentRecurrenceTemplateYearlyTemplateComponent";
var SpecimenFeatureComponent = "http://hl7.org/fhir/SpecimenFeatureComponent";
var _ServiceRequest = "http://hl7.org/fhir/_ServiceRequest";
var tester = "http://hl7.org/fhir/tester";
var seriousness = "http://hl7.org/fhir/seriousness";
var isDefining = "http://hl7.org/fhir/isDefining";
var contributingFactor = "http://hl7.org/fhir/contributingFactor";
var CapabilityStatement = "http://hl7.org/fhir/CapabilityStatement";
var _ImagingSelection = "http://hl7.org/fhir/_ImagingSelection";
var _unmapped = "http://hl7.org/fhir/_unmapped";
var compositional = "http://hl7.org/fhir/compositional";
var fundsReserveRequested = "http://hl7.org/fhir/fundsReserveRequested";
var Total = "http://hl7.org/fhir/Total";
var _citeAs = "http://hl7.org/fhir/_citeAs";
var _protein = "http://hl7.org/fhir/_protein";
var _referenceRange = "http://hl7.org/fhir/_referenceRange";
var complication = "http://hl7.org/fhir/complication";
var SubscriptionTopicResourceTriggerComponent = "http://hl7.org/fhir/SubscriptionTopicResourceTriggerComponent";
var estimate = "http://hl7.org/fhir/estimate";
var _material = "http://hl7.org/fhir/_material";
var Item = "http://hl7.org/fhir/Item";
var encodeRequestUrl = "http://hl7.org/fhir/encodeRequestUrl";
var _currentLocation = "http://hl7.org/fhir/_currentLocation";
var style = "http://hl7.org/fhir/style";
var method2 = "http://hl7.org/fhir/method";
var _MarketingStatus = "http://hl7.org/fhir/_MarketingStatus";
var group = "http://hl7.org/fhir/group";
var achievementStatus = "http://hl7.org/fhir/achievementStatus";
var evaluatedResource = "http://hl7.org/fhir/evaluatedResource";
var _udiDeviceIdentifier = "http://hl7.org/fhir/_udiDeviceIdentifier";
var _RelatedPerson = "http://hl7.org/fhir/_RelatedPerson";
var dateTime = "http://hl7.org/fhir/dateTime";
var _intervalUnit = "http://hl7.org/fhir/_intervalUnit";
var text = "http://hl7.org/fhir/text";
var _contact = "http://hl7.org/fhir/_contact";
var searchInclude = "http://hl7.org/fhir/searchInclude";
var _fivePrime = "http://hl7.org/fhir/_fivePrime";
var timeOfDay = "http://hl7.org/fhir/timeOfDay";
var originRelationshipType = "http://hl7.org/fhir/originRelationshipType";
var CitationClassificationComponent = "http://hl7.org/fhir/CitationClassificationComponent";
var _plannedStartDate = "http://hl7.org/fhir/_plannedStartDate";
var documentType = "http://hl7.org/fhir/documentType";
var CoverageEligibilityRequestEventComponent = "http://hl7.org/fhir/CoverageEligibilityRequestEventComponent";
var _milestone = "http://hl7.org/fhir/_milestone";
var page = "http://hl7.org/fhir/page";
var params = "http://hl7.org/fhir/params";
var regionsCalled = "http://hl7.org/fhir/regionsCalled";
var conditionalCreate = "http://hl7.org/fhir/conditionalCreate";
var lensSpecification = "http://hl7.org/fhir/lensSpecification";
var _grantor = "http://hl7.org/fhir/_grantor";
var coverage3 = "http://hl7.org/fhir/coverage";
var authorizationSupporting = "http://hl7.org/fhir/authorizationSupporting";
var ElementDefinitionBindingAdditionalComponent = "http://hl7.org/fhir/ElementDefinitionBindingAdditionalComponent";
var _benefit = "http://hl7.org/fhir/_benefit";
var _testData = "http://hl7.org/fhir/_testData";
var _OrganizationAffiliation = "http://hl7.org/fhir/_OrganizationAffiliation";
var excludedStructure = "http://hl7.org/fhir/excludedStructure";
var _searchRevInclude = "http://hl7.org/fhir/_searchRevInclude";
var serviceProvisionCode = "http://hl7.org/fhir/serviceProvisionCode";
var typeMode = "http://hl7.org/fhir/typeMode";
var ValueSetScopeComponent = "http://hl7.org/fhir/ValueSetScopeComponent";
var SupplyRequestParameterComponent = "http://hl7.org/fhir/SupplyRequestParameterComponent";
var attributeEstimate = "http://hl7.org/fhir/attributeEstimate";
var immutable = "http://hl7.org/fhir/immutable";
var _relatedAccount = "http://hl7.org/fhir/_relatedAccount";
var _RiskAssessment = "http://hl7.org/fhir/_RiskAssessment";
var BiologicallyDerivedProductPropertyComponent = "http://hl7.org/fhir/BiologicallyDerivedProductPropertyComponent";
var _totalVolume = "http://hl7.org/fhir/_totalVolume";
var _adjudication = "http://hl7.org/fhir/_adjudication";
var history = "http://hl7.org/fhir/history";
var _isSubpotent = "http://hl7.org/fhir/_isSubpotent";
var _longitude = "http://hl7.org/fhir/_longitude";
var _sliceIsConstraining = "http://hl7.org/fhir/_sliceIsConstraining";
var collected = "http://hl7.org/fhir/collected";
var medicineClassification = "http://hl7.org/fhir/medicineClassification";
var Signature = "http://hl7.org/fhir/Signature";
var ConceptReference = "http://hl7.org/fhir/ConceptReference";
var TransportRestrictionComponent = "http://hl7.org/fhir/TransportRestrictionComponent";
var _rank = "http://hl7.org/fhir/_rank";
var _inResponseTo = "http://hl7.org/fhir/_inResponseTo";
var CitationCitedArtifactAbstractComponent = "http://hl7.org/fhir/CitationCitedArtifactAbstractComponent";
var _error = "http://hl7.org/fhir/_error";
var origin3 = "http://hl7.org/fhir/origin";
var treeRoot = "http://hl7.org/fhir/treeRoot";
var _sourceMaterialType = "http://hl7.org/fhir/_sourceMaterialType";
var bodyStructure = "http://hl7.org/fhir/bodyStructure";
var _releaseDate = "http://hl7.org/fhir/_releaseDate";
var normalValue = "http://hl7.org/fhir/normalValue";
var PractitionerCommunicationComponent = "http://hl7.org/fhir/PractitionerCommunicationComponent";
var targetProfile = "http://hl7.org/fhir/targetProfile";
var bounds = "http://hl7.org/fhir/bounds";
var _op = "http://hl7.org/fhir/_op";
var OperationDefinitionParameterComponentParameterParameter = "http://hl7.org/fhir/OperationDefinitionParameterComponentParameterParameter";
var plannedActivityReference = "http://hl7.org/fhir/plannedActivityReference";
var _preAuthRef = "http://hl7.org/fhir/_preAuthRef";
var _imageRegion3D = "http://hl7.org/fhir/_imageRegion3D";
var _object = "http://hl7.org/fhir/_object";
var DocumentReferenceAttesterComponent = "http://hl7.org/fhir/DocumentReferenceAttesterComponent";
var _recall = "http://hl7.org/fhir/_recall";
var fastingStatus = "http://hl7.org/fhir/fastingStatus";
var seriesUid = "http://hl7.org/fhir/seriesUid";
var SubstanceSourceMaterialPartDescriptionComponent = "http://hl7.org/fhir/SubstanceSourceMaterialPartDescriptionComponent";
var _geneElement = "http://hl7.org/fhir/_geneElement";
var publicationDateText = "http://hl7.org/fhir/publicationDateText";
var EpisodeOfCareStatusHistoryComponent = "http://hl7.org/fhir/EpisodeOfCareStatusHistoryComponent";
var evaluationMessage = "http://hl7.org/fhir/evaluationMessage";
var division = "http://hl7.org/fhir/division";
var windowEnd = "http://hl7.org/fhir/windowEnd";
var _foodType = "http://hl7.org/fhir/_foodType";
var _repeats = "http://hl7.org/fhir/_repeats";
var _Observation = "http://hl7.org/fhir/_Observation";
var validateCode = "http://hl7.org/fhir/validateCode";
var parameterName = "http://hl7.org/fhir/parameterName";
var source3 = "http://hl7.org/fhir/source";
var currentState = "http://hl7.org/fhir/currentState";
var publicationStatus = "http://hl7.org/fhir/publicationStatus";
var _license = "http://hl7.org/fhir/_license";
var _created = "http://hl7.org/fhir/_created";
var ClinicalUseDefinitionContraindicationOtherTherapyComponent = "http://hl7.org/fhir/ClinicalUseDefinitionContraindicationOtherTherapyComponent";
var isModifier = "http://hl7.org/fhir/isModifier";
var _needsMap = "http://hl7.org/fhir/_needsMap";
var performerType = "http://hl7.org/fhir/performerType";
var unitPrice = "http://hl7.org/fhir/unitPrice";
var _topic = "http://hl7.org/fhir/_topic";
var _lastUpdated = "http://hl7.org/fhir/_lastUpdated";
var preparedDate = "http://hl7.org/fhir/preparedDate";
var accident = "http://hl7.org/fhir/accident";
var code = "http://hl7.org/fhir/code";
var _designation = "http://hl7.org/fhir/_designation";
var _creation = "http://hl7.org/fhir/_creation";
var verificationType = "http://hl7.org/fhir/verificationType";
var DeviceDefinitionPackagingComponentPackagingUdiDeviceIdentifier = "http://hl7.org/fhir/DeviceDefinitionPackagingComponentPackagingUdiDeviceIdentifier";
var _containedInstance = "http://hl7.org/fhir/_containedInstance";
var PackagedProductDefinitionLegalStatusOfSupplyComponent = "http://hl7.org/fhir/PackagedProductDefinitionLegalStatusOfSupplyComponent";
var _recipient = "http://hl7.org/fhir/_recipient";
var ifMatch = "http://hl7.org/fhir/ifMatch";
var partNumber = "http://hl7.org/fhir/partNumber";
var _severity = "http://hl7.org/fhir/_severity";
var _filterBy = "http://hl7.org/fhir/_filterBy";
var _NutritionIntake = "http://hl7.org/fhir/_NutritionIntake";
var BundleEntrySearchComponent = "http://hl7.org/fhir/BundleEntrySearchComponent";
var _responseCode = "http://hl7.org/fhir/_responseCode";
var _eventHistory = "http://hl7.org/fhir/_eventHistory";
var _rejectionCriterion = "http://hl7.org/fhir/_rejectionCriterion";
var notPerformedReason = "http://hl7.org/fhir/notPerformedReason";
var _entryType = "http://hl7.org/fhir/_entryType";
var EncounterHistory = "http://hl7.org/fhir/EncounterHistory";
var _specialPrecautionsForStorage = "http://hl7.org/fhir/_specialPrecautionsForStorage";
var SearchParameter = "http://hl7.org/fhir/SearchParameter";
var gender = "http://hl7.org/fhir/gender";
var coding = "http://hl7.org/fhir/coding";
var ProductShelfLife = "http://hl7.org/fhir/ProductShelfLife";
var system = "http://hl7.org/fhir/system";
var _tissue = "http://hl7.org/fhir/_tissue";
var associatedParty = "http://hl7.org/fhir/associatedParty";
var statistic = "http://hl7.org/fhir/statistic";
var DataRequirement = "http://hl7.org/fhir/DataRequirement";
var MedicationKnowledgeRegulatoryMaxDispenseComponent = "http://hl7.org/fhir/MedicationKnowledgeRegulatoryMaxDispenseComponent";
var udiCarrier = "http://hl7.org/fhir/udiCarrier";
var Availability = "http://hl7.org/fhir/Availability";
var sender = "http://hl7.org/fhir/sender";
var _strand = "http://hl7.org/fhir/_strand";
var IngredientSubstanceStrengthComponent = "http://hl7.org/fhir/IngredientSubstanceStrengthComponent";
var MedicationKnowledgeMonitoringProgramComponent = "http://hl7.org/fhir/MedicationKnowledgeMonitoringProgramComponent";
var _derivation = "http://hl7.org/fhir/_derivation";
var Condition = "http://hl7.org/fhir/Condition";
var AdministrableProductDefinitionRouteOfAdministrationTargetSpeciesWithdrawalPeriodComponent = "http://hl7.org/fhir/AdministrableProductDefinitionRouteOfAdministrationTargetSpeciesWithdrawalPeriodComponent";
var diagnostics = "http://hl7.org/fhir/diagnostics";
var assessment = "http://hl7.org/fhir/assessment";
var _clockFacePosition = "http://hl7.org/fhir/_clockFacePosition";
var attestation = "http://hl7.org/fhir/attestation";
var identified = "http://hl7.org/fhir/identified";
var fhirImport = /* @__PURE__ */ Object.freeze({
  constituent,
  _careTeam,
  ClinicalUseDefinitionWarningComponent,
  PlanDefinitionActionParticipantComponent,
  VisionPrescriptionLensSpecificationComponent,
  _answerOption,
  decimal,
  _applies,
  serviceProvider,
  NutritionProductIngredientComponent,
  Error__workaround,
  productStatus,
  ImagingStudySeriesPerformerComponent,
  _lowerLimit,
  Medication,
  header,
  StructureMapGroupRuleComponent,
  _productType,
  _relatedItem,
  author: author2,
  _direction,
  _frequencyOfOccurrence,
  RequestOrchestration,
  Detail,
  numberOfRepeatsAllowed,
  _communicationRequest,
  DocumentReferenceContentProfileComponent,
  _masterFile,
  comment: comment2,
  availableTime,
  _assert,
  listRuleId,
  preAdmissionIdentifier,
  participantType,
  _related,
  SupplementSchedule,
  reAdmission,
  _requestURL,
  _caseSensitive,
  _chargeItem,
  _withdrawalPeriod,
  CapabilityStatementImplementationComponent,
  analysis,
  monitoringProgram,
  _date,
  satisfiedBy,
  artifact,
  timing,
  appliesToAll,
  _appointmentRequired,
  _canFilterBy,
  filter: filter2,
  _targetNumber,
  _additive,
  _management,
  _phylum,
  _distributor,
  _clinicalRecommendationStatement,
  _manifest,
  cancellationDate,
  _doseQuantity,
  DeviceDefinitionPackagingComponentUdiDeviceIdentifier,
  VerificationResult,
  preference,
  _asserter,
  _regulatoryIdentifier,
  molecularFormula,
  isActive,
  dispenserInstruction,
  MedicationKnowledgeRelatedMedicationKnowledgeComponent,
  CapabilityStatementRestSecurityComponent,
  initialSelected,
  _preventiveAction,
  DeviceDefinitionConformsToComponent,
  _MedicationStatement,
  _availableStartTime,
  validationType,
  _axis,
  _serialNumber,
  Narrative,
  _dependency,
  endDate,
  _prognosisReference,
  _recruitment,
  searchParam,
  _usageInstruction,
  _generation,
  artifactAssessment,
  complete,
  _dependent,
  _due,
  _replaces,
  EvidenceStatisticModelCharacteristicComponent,
  _friday,
  orderedBy,
  _modality,
  expirationType,
  party,
  _objective,
  _totalNet,
  _adherence,
  _cardinalityBehavior,
  startDate,
  basis,
  _minutesDuration,
  instruction,
  _targetDisease,
  eventTrigger,
  closure,
  numberOfParticipants,
  businessArrangement,
  requesterLinkId,
  _programEligibility,
  _average,
  proxySignature,
  _assessmentMethod,
  _series,
  _performingOrganization,
  frames,
  _paternalOrganismName,
  inputProfile,
  _guarantor,
  _human,
  NutritionProductCharacteristicComponent,
  _orderDetail,
  maxParticipants,
  ClinicalUseDefinitionUndesirableEffectComponent,
  _observed,
  validityPeriod,
  ComputableLanguage,
  surfaceOrientation,
  _Provenance,
  testRun,
  SubstanceProtein,
  _focalDevice,
  _operationType,
  context: context3,
  occurrenceDateTime,
  DetectedIssueEvidenceComponent,
  _ExplanationOfBenefit,
  validated,
  _subunit,
  EvidenceStatisticAttributeEstimateComponent,
  replacedSequence,
  specimen,
  rater,
  relatedMedicationKnowledge,
  lastModified: lastModified2,
  RequestOrchestrationActionParticipantComponent,
  _informationType,
  citation,
  paymentStatus,
  treatment,
  _initial,
  priceComponent,
  _Linkage,
  _indicationGuideline,
  SubstanceSourceMaterial,
  _conditionalRead,
  managingEntity,
  EvidenceVariableCharacteristicDefinitionByTypeAndValueComponent,
  operationalStatus,
  _module,
  MedicationAdministration,
  UdiDeviceIdentifierMarketDistribution,
  _probability,
  clinicalRecommendationStatement,
  _image,
  SubscriptionTopicNotificationShapeComponent,
  _componentPart,
  op,
  _processingFacility,
  unit,
  _problem,
  SubstanceDefinitionPropertyComponent,
  _fluidConsistencyType,
  _SubstancePolymer,
  ValueSetComposeIncludeConceptDesignationComponent,
  versionReference,
  _maxSingleDose,
  meaning,
  measurementPoint,
  diagnosisRelatedGroup,
  _relative,
  _publicationForm,
  _Patient,
  GuidanceResponse,
  entity,
  sourceReference,
  valueFilter,
  _useBy,
  bodyLandmarkOrientation,
  SubstanceDefinitionNameComponentName,
  _policyText,
  _changePattern,
  subDetail,
  allDay,
  _modification,
  _nodeId,
  AdverseEventContributingFactorComponent,
  TestPlanTestCaseComponent,
  sunday,
  cancellationReason,
  _title,
  _sourceId,
  _entityRelatedness,
  line,
  _effectivePeriod,
  preAuthRef,
  requestId,
  _autodelete,
  _fundsReserve,
  BundleEntryComponentLink,
  DocumentReferenceContentComponent,
  _holder,
  _qualifiers,
  _Specimen,
  CodeSystemFilterComponent,
  _replacementSequence,
  serviceCategory,
  _next,
  paymentTerms,
  _started,
  offer,
  coordinateSystem,
  DeviceDefinition,
  _intent,
  _text,
  _level,
  facility,
  qualifiedValue,
  ManifestResource,
  prism,
  MedicationBatchComponent,
  resultForDelete,
  _accept,
  overbooked,
  _plan,
  ReviewOutcome,
  CitationCitedArtifactContributorshipEntryComponent,
  discriminator,
  ordered,
  LegalLanguage,
  frequencyOfOccurrence,
  _validationType,
  PermissionRuleDataComponent,
  _versionNeeded,
  PackagedProductDefinitionPackagingContainedItemComponent,
  predecessor,
  ArtifactAssessment,
  _dependsOn,
  evidence,
  MeasureGroupPopulationComponent,
  opticalActivity,
  nutritionProduct,
  specialMeasures,
  packageId,
  TerminologyCapabilitiesCodeSystemVersionFilterComponent,
  SubDetail,
  _received,
  CapabilityStatementDocumentComponent,
  observationResultRequirement,
  FriendlyLanguage,
  _observedGroup,
  cancelledReason,
  _expirationType,
  _actualNumber,
  derivation,
  AdverseEventSuspectEntityComponent,
  ImmunizationRecommendation,
  _BiologicallyDerivedProductDispense,
  _definitionId,
  _authoredOn,
  keyword,
  characteristic,
  _note,
  ImagingStudySeriesInstanceComponent,
  _signature,
  slicing,
  _population,
  cap,
  given,
  account,
  _organism,
  _need,
  environmentalSetting,
  volume,
  weeklyTemplate,
  lowerLimit,
  _justification,
  _fixture,
  unitPriceComponent,
  availabilityStatus,
  _proxySignature,
  statusChanged,
  _about,
  occurence,
  actualPeriod,
  _originalPrescription,
  _dosage,
  returnedAmount,
  _cTerminalModification,
  name: name2,
  masterFile,
  baseFormulaType,
  threshold,
  active,
  IngredientSubstanceComponent,
  size,
  _validityPeriod,
  who,
  ExampleScenarioProcessStepAlternativeComponent,
  InsurancePlanPlanSpecificCostComponent,
  interaction,
  _beneficiary,
  requestURL,
  transform,
  sugar,
  _subscriptionTopic,
  _usageStatus,
  _recurring,
  chargeItem,
  DiagnosticReportMediaComponent,
  validationProcess,
  _DiagnosticReport,
  moiety,
  _marketingStatus,
  _citedArtifact,
  CitationCitedArtifactPartComponent,
  TerminologyCapabilitiesImplementationComponent,
  _immutable,
  _requester,
  regionsStudied,
  _code,
  sourceMaterial,
  subrogation,
  _structureVersion,
  _priceComponent,
  management,
  _additionalInstruction,
  _managingEntity,
  patchFormat,
  proxyIdentityCertificate,
  DeviceVersionComponent,
  TaskRestrictionComponent,
  _frameOfReferenceUid,
  MedicinalProductDefinition,
  paternalOrganismId,
  averageMolecularFormula,
  EvidenceStatisticSampleSizeComponent,
  _occurred,
  definitionByCombination,
  _compositional,
  financial,
  _bodysite,
  sourceScope,
  modifierExtensionClass,
  parameter,
  lineItem,
  _businessArrangement,
  _ordinalPosition,
  dependency,
  DeviceUsage,
  sent,
  _associatedMedication,
  ParametersParameterComponentParameter,
  executionPeriod,
  _custodian,
  specification,
  HumanName,
  ObservationDefinitionComponentComponentQualifiedValue,
  _searchInclude,
  _technique,
  legalStatusOfSupply,
  short,
  generation,
  doseAndRate,
  _condition,
  _followUp,
  manufacturer,
  BiologicallyDerivedProductDispense,
  _seriesUid,
  relatesTo,
  temperatureQualifier,
  _PackagedProductDefinition,
  _correspondingContact,
  citeAs,
  _DeviceAssociation,
  requireBoth,
  provisionData,
  _characterization,
  criticality,
  ConditionDefinitionPlanComponent,
  canPushUpdates,
  _nTerminalModificationId,
  _regionsCalled,
  TestPlanTestCaseTestRunComponent,
  _productOrService,
  reviewOutcome,
  maxDispense,
  modifierExtensionProperty,
  filterDefinition,
  sourceAttachment,
  provisionActor,
  NamingSystem,
  dateOfService,
  VisionPrescription,
  _unitPrice,
  resource,
  _response,
  _agent,
  contraindicatedVaccineCode,
  collector,
  enterer,
  _supportedInteraction,
  _differential,
  _qualifiedValue,
  ManufacturedItemDefinitionComponentConstituentComponent,
  _additionalMonitoringIndicator,
  _position,
  limit,
  _reason,
  _planningHorizon,
  _safety,
  Identifier,
  _mitigation,
  _specialCourtesy,
  ExampleScenarioInstanceContainedInstanceComponent,
  edit,
  qualitativeRisk,
  immunizationEvent,
  reference,
  reporter,
  BackboneElement,
  _hasMember,
  Provenance,
  reasonLinkId,
  owner: owner2,
  _assignedComparisonGroup,
  _Condition,
  ConsentPolicyBasisComponent,
  communicationMethod,
  _param,
  _power,
  _issue,
  concept,
  decisionMode,
  instantiatesUri,
  _ifMatch,
  sequenceType,
  _fastingStatus,
  preferredReportName,
  _numberOfSeries,
  rankingOrder,
  _currency,
  testTools,
  _warning,
  CoverageEligibilityResponseEventComponent,
  _characteristic,
  dataRequirement,
  _domain,
  InventoryReport,
  _parameterName,
  progressStatus,
  _narrative,
  Endpoint,
  subjectState,
  entry,
  _weeklyTemplate,
  what,
  whenPrepared,
  Action: Action2,
  _observationRequirement,
  focal,
  verification,
  _availability,
  resultingEffect,
  timeout,
  CapabilityStatementMessagingSupportedMessageComponent,
  _revenue,
  _returnedAmount,
  MedicationKnowledgeDefinitionalIngredientComponent,
  candidate,
  Subscription: Subscription2,
  relatedAction,
  textPresentation,
  _supplements,
  result: result2,
  policyText,
  _regionType,
  StratifierGroup,
  _contract,
  _timeFromEvent,
  notificationEvent,
  _inclusionCriteria,
  _orderMeaning,
  autodelete,
  qualifiers,
  _regionsStudied,
  _application,
  frequency,
  _sourceMaterial,
  regulatoryBasis,
  associationType,
  _software,
  _copolymerConnectivity,
  _approvalDate,
  totalVolume,
  AppointmentRecurrenceTemplateWeeklyTemplateComponent,
  _requestedPerformer,
  packagedProduct,
  tissue,
  isSubpotent,
  _supportingInfoSequence,
  _rating,
  maternalOrganismName,
  CommunicationRequest,
  polymer,
  initiatorActive,
  _productStatus,
  strand,
  _outputParameters,
  participantStatus,
  label,
  manipulated,
  _geometry,
  Coding,
  requisition,
  InventoryReportInventoryListingComponent,
  _parent,
  _net,
  presentation,
  flag,
  hoursOfOperation,
  encounter,
  applicability,
  releaseDate,
  _relationshipType,
  _managingOrganization,
  derivedFromCanonical,
  _hasSeverity,
  cTerminalModification,
  ContentDefinition,
  _bodyLandmarkOrientation,
  relationship: relationship2,
  goal,
  _connectivity,
  _listMode,
  _availableTime,
  property,
  _calibration,
  TerminologyCapabilitiesExpansionParameterComponent,
  adjustmentReason,
  AdministrableProductDefinitionRouteOfAdministrationTargetSpeciesComponent,
  Basic,
  _isDerived,
  hierarchical,
  _resultForCreate,
  _deviceName,
  _startDate,
  Attachment,
  _patientPreparation,
  CitationCitedArtifactPublicationFormComponent,
  windowStart,
  _propertyGroup,
  languageCode,
  _canPushUpdates,
  groupingBehavior,
  for__workaround,
  _studyUid,
  _event,
  informationProvider,
  network,
  _manufacturedDoseForm,
  assert,
  _warningOnly,
  isSummary,
  attachedDocument,
  _unit,
  _endDate,
  authoredOn,
  _geographicalLocation,
  CitationCitedArtifactClassificationComponent,
  userSelected,
  _prognosisCodeableConcept,
  dateCriterion,
  additionalInstruction,
  specialPrecautionsForStorage,
  population,
  _member,
  securityLabel,
  _renderedDosageInstruction,
  Notes,
  _dynamicValue,
  _confidentialityIndicator,
  _intendedUse,
  lastUpdated,
  deceased,
  NutritionOrderEnteralFormulaAdditiveComponent,
  designation,
  reportedDateTime,
  productOrServiceEnd,
  teardown,
  securityLabelNumber,
  _manufactureDate,
  _textFilter,
  _route,
  parentSubstanceName,
  _docStatus,
  ArtifactAssessmentContentComponentContentContent,
  _subscriber,
  workflowStatus,
  phylum,
  _mustSupport,
  forecastStatus,
  _closure,
  _abstract,
  relatedClinicalInformation,
  PersonCommunicationComponent,
  _relativePath,
  CitationCitedArtifactVersionComponent,
  _paging,
  _uniqueId,
  _readOnly,
  _jurisdiction,
  _treatment,
  _responsibleParty,
  RequestOrchestrationActionComponentActionAction,
  _role,
  TestPlanDependencyComponent,
  Binary,
  contentDerivative,
  inforce,
  RiskAssessmentPredictionComponent,
  _enteredDate,
  _legalStatusOfSupply,
  valueAlternatives,
  subject: subject4,
  _publicationDate,
  occurrenceChanged,
  _referralRequest,
  friday,
  productType,
  _payeeType,
  _fixed,
  _nTerminalModification,
  _progressStatus,
  _age,
  _verificationDate,
  CompartmentDefinitionResourceComponent,
  _questionnaire,
  TestScript,
  billingStatus,
  _resourceTrigger,
  compose,
  _submitter,
  _productReference,
  payment,
  rateAggregation,
  OrganizationQualificationComponent,
  identityCertificate,
  _subDetail,
  contextInvariant,
  _suffix,
  _recurrenceId,
  dispenseInterval,
  _map,
  _lensSpecification,
  allergyIntolerance,
  asset,
  CoverageEligibilityResponse,
  OperationDefinitionParameterComponentParameter,
  packagedMedicinalProduct,
  _count,
  SubstancePolymerRepeatRepeatUnitDegreeOfPolymerisationComponent,
  adjudication,
  RequestOrchestrationActionConditionComponent,
  validator,
  _gene,
  _length,
  series,
  maxDosePerAdministration,
  _performerRole,
  _balance,
  _correctiveAction,
  dispenser,
  NutritionOrderOralDietComponent,
  _meaning,
  endParam,
  _provider,
  inResponseTo,
  authorDescription,
  _intendedExposure,
  _cycle,
  ProvenanceEntityComponentAgent,
  high,
  _paymentStatus,
  TestScriptVariableComponent,
  _comparator,
  _instantiatesCanonical,
  class__workaround: class__workaround2,
  _countryOfOrigin,
  structuralRepresentation,
  _communicationMethod,
  _size,
  _averageMolecularFormula,
  _ingredientLabel,
  _landmarkDescription,
  _criticalCodedValueSet,
  unmapped,
  _productCategory,
  SubstanceReferenceInformationTargetComponent,
  _preferredReportName,
  _maternalOrganismId,
  _order,
  qualifier,
  recruitment,
  mitigation,
  Procedure,
  material,
  _packageId,
  address: address2,
  module: module2,
  SubstanceNucleicAcidSubunitComponent,
  _healthcareService,
  check,
  _serviceProvisionCode,
  DeviceDefinitionHasPartComponent,
  hybrid,
  DeviceDefinitionPackagingComponentPackaging,
  extends__workaround,
  AdverseEventSupportingInfoComponent,
  _MedicationRequest,
  startingSequence,
  MedicationKnowledgeMonographComponent,
  DetectedIssue,
  targetLocation,
  MedicinalProductDefinitionCrossReferenceComponent,
  _alternateMaterial,
  _ordered,
  _List,
  _gateway,
  _effect,
  _coordinate,
  case__workaround,
  QuestionnaireItemComponentItem,
  DeviceConformsToComponent,
  PatientLinkComponent,
  testData,
  ProcedureFocalDeviceComponent,
  _typeCanonical,
  nodeId,
  CapabilityStatementSoftwareComponent,
  _preparation,
  _subType,
  _definitionCodeableConcept,
  benefitBalance,
  exclusionCriteria,
  numberOfStudies,
  start,
  AccountRelatedAccountComponent,
  _OperationOutcome,
  orientation,
  holder,
  _mitigatingAction,
  include,
  _conditionalPatch,
  NamingSystemUniqueIdComponent,
  _threshold,
  Count,
  _instantiates,
  media,
  appliesTo,
  _implementationGuide,
  RequestOrchestrationActionInputComponent,
  _discriminator,
  ClaimResponse,
  section,
  _workflowStatus,
  _DeviceMetric,
  diseaseSymptomProcedure,
  _keyword,
  _forecastStatus,
  Bundle,
  _excluded,
  _transform,
  intent,
  _slicing,
  generalPractitioner,
  gestationalAge,
  _account,
  _administeredProduct,
  answerOption,
  regionType,
  _association,
  _messaging,
  organismType,
  accept,
  _methodType,
  _authorizationRequired,
  includedStructure,
  sourceIdentityCertificate,
  foodType,
  temperatureRange,
  ManifestPage,
  DeviceRequest,
  _contextLinkId,
  ExampleScenarioProcessStepOperationComponent,
  SubstanceDefinitionStructureComponent,
  calculatedAt,
  MarketingStatus,
  _emptyReason,
  _offsets,
  _financial,
  _exposureRoute,
  _policyHolder,
  SupplyDeliverySuppliedItemComponent,
  intendedRoute,
  _paymentDate,
  GenomicStudyAnalysisDeviceComponent,
  _informationProvider,
  _outsideFoodAllowed,
  feature,
  needsMap,
  _dataAbsentReason,
  _definition,
  creation,
  _minValue,
  width: width2,
  _Permission,
  AllergyIntolerance,
  _Encounter,
  targetNumber,
  severity,
  ObservationDefinitionQualifiedValueComponent,
  filterBy,
  packaging,
  endorser,
  _relatesTo,
  _sourceSignature,
  abnormalCodedValueSet,
  lastOccurrenceDate,
  _securityLabelNumber,
  _queryCriteria,
  _multipleResultsAllowed,
  _allowed,
  _TestReport,
  _Location,
  deviceName,
  ImmunizationReactionComponent,
  ConceptMap,
  _daysOfWeek,
  ParameterDefinition,
  _packageCode,
  Insurance,
  lastPerformed,
  IngredientManufacturerComponent,
  nthWeekOfMonth,
  targetSpecies,
  authorization,
  _RequestOrchestration,
  _endpoint,
  triggeredBy,
  _Dosage,
  _doNotPerform,
  careTeam,
  _meta,
  TerminologyCapabilitiesCodeSystemVersionComponent,
  entryQuantity,
  CapabilityStatementMessagingEndpointComponent,
  nTerminalModification,
  _asNeededFor,
  _link,
  attribute,
  Note: Note2,
  textFilter,
  disposition,
  PackagedProductDefinition,
  Accident,
  _reference,
  StructureMapGroupRuleTargetParameterComponent,
  subscriber,
  structureType,
  _detail,
  meaningWhenMissing,
  modelCharacteristic,
  mapping,
  _Person,
  _eligibility,
  SubstanceSourceMaterialFractionDescriptionComponent,
  typeCollected,
  timestamp,
  _subpotentReason,
  _relatedMedicationKnowledge,
  _inventoryStatus,
  synonym,
  _category,
  _regulatory,
  birthDate,
  _priorPrescription,
  Base,
  _testTools,
  _targetLocation,
  substanceDefinition,
  _medication,
  _vaccineCode,
  _dateAsserted,
  DeviceDefinitionMaterialComponent,
  _codeSearch,
  range,
  NutritionOrder,
  _dispenserInstruction,
  _summary,
  _synthesisType,
  productName,
  _reviewOutcome,
  claimResponse,
  path,
  additive,
  ElementDefinition,
  fundingSource,
  instantiatesCanonical,
  family,
  NutritionIntake,
  EvidenceReport,
  billablePeriod,
  _otherTherapy,
  _dateOfService,
  _benefitBalance,
  _information,
  _CareTeam,
  _aggregateMethod,
  generatedBy,
  _tag,
  asserter,
  _revInclude,
  onset,
  criticalCodedValueSet,
  _mode,
  anchor,
  _substitution,
  _consent,
  _candidate,
  _concept,
  MeasureReportGroupStratifierStratumComponentComponent,
  ifNoneExist,
  GraphDefinitionNodeComponent,
  _answer,
  _schedule,
  administrationTreatment,
  _baseFormulaProductName,
  PermissionRuleDataResourceComponent,
  _gestationalAge,
  carrierAIDC,
  _capability,
  usageStatus,
  _knownAllergen,
  storageTempRequirements,
  definitionReference,
  experimental,
  _numberOfParticipants,
  _repeat,
  displayName,
  replaces: replaces2,
  _distanceFromLandmark,
  _frequency,
  shortDoco,
  ImagingSelection,
  modality,
  _targetId,
  _amount,
  species,
  totalNet,
  observationRequirement,
  InsurancePlanPlanGeneralCostComponent,
  InvoiceLineItemComponent,
  requestor,
  dietPreference,
  comparator,
  _combinedPharmaceuticalDoseForm,
  servicePeriod,
  _rater,
  receiverActive,
  modification,
  practitioner,
  _normalCodedValueSet,
  TestCaseDependency,
  _costToBeneficiary,
  MessageHeader,
  ResearchStudyRecruitmentComponent,
  _forenameInitials,
  plannedStartDate,
  study,
  groupIdentifier,
  _participatingOrganization,
  MeasureGroupStratifierComponent,
  wednesday,
  _diameter,
  enteralFormula,
  _stabilityDuration,
  integer,
  domain,
  _periodType,
  _ImagingStudy,
  searchRevInclude,
  _relatedAction,
  observed,
  born,
  _ImmunizationRecommendation,
  service,
  _requestIdentifier,
  maxDosePerLifetime,
  format: format3,
  _isSummary,
  supportingInfoSequence,
  EvidenceStatisticModelCharacteristicVariableComponent,
  ManufacturedItemDefinitionPropertyComponent,
  _concentration,
  coordinate,
  AddedItemDetailSubDetail,
  TerminologyCapabilitiesTranslationComponent,
  _generalPractitioner,
  _protocol,
  _exception,
  _complication,
  value,
  _nthWeekOfMonth,
  _url,
  SubstanceSourceMaterialOrganismHybridComponent,
  SubscriptionTopicEventTriggerComponent,
  MedicinalProductDefinitionNameComponent,
  SubstanceSourceMaterialOrganismComponent,
  overrideReason,
  pages,
  _conclusion,
  _combined,
  _contains,
  _documentType,
  MeasureGroupStratifierComponentComponent,
  _numberOfInstances,
  PlanDefinitionActionComponent,
  _processor,
  actualNumber,
  _network,
  effective,
  textEquivalent,
  preferred,
  ImplementationGuide,
  EvidenceReportRelatesToTargetComponent,
  _applicability,
  min,
  DeviceNameComponent,
  Payment,
  organismName,
  relative,
  Ratio,
  item,
  rating: rating2,
  _numerator,
  TestScriptScopeComponent,
  _aggregation,
  minutesDuration,
  AuditEventEntityComponent,
  rate,
  CompartmentDefinition,
  renderedDosageInstruction,
  methodType,
  parent,
  sourceId,
  _requestedPeriod,
  _chromosome,
  isSubPotent,
  presentedForm,
  repetitions,
  aggregate,
  EvidenceStatisticComponent,
  ImplementationGuideDefinitionParameterComponent,
  CompositionEventComponent,
  _NutritionOrder,
  TaskInputComponent,
  rule,
  Specimen,
  _MedicinalProductDefinition,
  OperationDefinition,
  process: process2,
  CitationCitedArtifactContributorshipEntryContributionInstanceComponent,
  EncounterAdmissionComponent,
  _MedicationDispense,
  translation,
  ObservationTriggeredByComponent,
  _etag,
  _dateCriterion,
  _administrationInstruction,
  part,
  _billablePeriod,
  requestHeader,
  _shortTitle,
  _securityLabel,
  _procedure,
  periodMax,
  monograph,
  _eventsSinceSubscriptionStart,
  QuestionnaireResponseItemAnswerComponent,
  formatted,
  restoreDate,
  _grouping,
  definition,
  BodyStructureIncludedStructureBodyLandmarkOrientationDistanceFromLandmarkComponent,
  dayOfWeek,
  _variableDefinition,
  nodeRole,
  Permission,
  dateWritten,
  ratioHighLimitAmount,
  _relatedData,
  _inforce,
  _reportingVendor,
  _sequenceRange,
  member,
  _versionAlgorithm,
  _subject,
  _case,
  _ClinicalUseDefinition,
  _cylinder,
  _saturday,
  ConceptMapGroupUnmappedComponent,
  Address: Address2,
  _validateCode,
  _dispenser,
  _issued,
  TestReport,
  conditionalRead,
  fullUrl,
  parameterFocus,
  _currentState,
  ActivityDefinition,
  daysOfWeek,
  containedInstance,
  StructureMapGroupRuleSourceComponent,
  application,
  received,
  AuditEventEntityComponentAgent,
  element,
  _compose,
  _environmentalSetting,
  _payment,
  _preparedDate,
  ImagingSelectionInstanceComponent,
  _responseRequired,
  _contraindication,
  _operator,
  ActivityDefinitionParticipantComponent,
  _contraindicatedVaccineCode,
  _membership,
  _recordedDate,
  _provision,
  _dietPreference,
  _laterality,
  _parentSubstanceId,
  _report,
  MedicationDispensePerformerComponent,
  FamilyMemberHistoryConditionComponent,
  _editor,
  instant,
  paging,
  _receiverActive,
  publicationForm,
  operation,
  organism,
  focus,
  _reviewer,
  validCodedValueSet,
  Signatory,
  clockFacePosition,
  _instanceReference,
  withdrawalPeriod,
  conformance,
  effectivePeriod,
  _matchStatus,
  virtualService,
  Communication,
  _enteralFormula,
  whenHandedOver,
  EvidenceReportSubjectComponent,
  substance,
  Section,
  _valueRange,
  regulatoryIdentifier,
  kind,
  hasIngredient,
  detailSequence,
  NutritionProductNutrientComponent,
  _fractionDescription,
  _degreeOfPolymerisation,
  _Account,
  rangeCategory,
  _index,
  ValueSetComposeComponentInclude,
  regulatory,
  _modifier,
  _short,
  medication,
  codeSearch,
  suffix,
  MedicationDispenseSubstitutionComponent,
  foodPreferenceModifier,
  Immunization,
  AppointmentRecurrenceTemplateMonthlyTemplateComponent,
  preventiveAction,
  _AdministrableProductDefinition,
  _deliverFrom,
  _address,
  intendedUse,
  ElementDefinitionSlicingDiscriminatorComponent,
  SubscriptionTopic,
  GenomicStudy,
  _partLocation,
  _subsumption,
  BenefitBalance,
  script,
  _resourceReference,
  lastReviewDate,
  SubstanceDefinitionNameComponentNameName,
  length,
  _overrideReason,
  _period,
  TerminologyCapabilities,
  _supportingPatientInformation,
  OperationDefinitionParameterBindingComponent,
  Task,
  MeasureReportGroupPopulationComponent,
  revInclude,
  _appliesTo,
  MedicationKnowledgeDefinitionalComponent,
  usageInstruction,
  trigger: trigger2,
  mustSupport,
  TimingRepeatComponent,
  effectiveDosePeriod,
  _textEquivalent,
  bodysite,
  _appliesToAll,
  comorbidity,
  TestScriptFixtureComponent,
  oligoNucleotideType,
  intendedEffect,
  _conformsTo,
  copyright,
  _insurance,
  _partDescription,
  _genomeBuild,
  Slot,
  _medium,
  followUp,
  maxDuration,
  lotNumber,
  EncounterHistoryLocationComponent,
  _owner,
  InventoryItem,
  content: content2,
  DeviceDefinitionPropertyComponent,
  enteredDate,
  _district,
  QuestionnaireItemComponentItemItem,
  eye,
  facilityType,
  markdown,
  _friendly,
  ManufacturedItemDefinitionComponentComponentComponent,
  basedOn,
  assessmentMethod,
  _sourceMaterialClass,
  CarePlanActivityComponent,
  response,
  _singleUse,
  ProvenanceAgentComponent,
  _kingdom,
  error,
  effect,
  verifiedWith,
  _packaging,
  position,
  EvidenceCertaintyComponentCertainty,
  low,
  _Device,
  AddedItemSubDetail,
  _responsible,
  excludingDate,
  _verified,
  TestScriptMetadataCapabilityComponent,
  marketingStatus,
  _ClaimResponse,
  request,
  MolecularSequenceRelativeEditComponent,
  periodType,
  approvalDate,
  _monomerSet,
  _eventTrigger,
  _ingredient,
  _biologicalSourceEvent,
  durationMax,
  _MolecularSequence,
  _permittedDataType,
  subtitle,
  _SubscriptionStatus,
  maxTreatmentPeriod,
  _relatedIdentifier,
  _feature,
  ValueSetExpansionComponent,
  _parameterFocus,
  _maxDosePerDay,
  CapabilityStatementMessagingComponent,
  ResearchStudyObjectiveComponent,
  MedicationIngredientComponent,
  SourceElement,
  _sequence,
  _validateProfileId,
  responsibility,
  containedItem,
  completionTime,
  _identifier,
  _scope,
  currency,
  _inputProfile,
  TestAction,
  _performer,
  QuestionnaireResponseItemComponentItemItem,
  _pushTypeAvailable,
  communication,
  interpretation,
  _capacity,
  topic,
  _undesirableEffect,
  _noteNumber,
  _DeviceRequest,
  courseOfTherapyType,
  ordinalPosition,
  ObservationComponentComponentReferenceRange,
  _actorId,
  conclusion,
  Resource,
  accountNumber,
  deliverTo,
  multipleResultsAllowed,
  _asNeeded,
  _onHold,
  genomeAssembly,
  _preAuthRefPeriod,
  itemSequence,
  _relatedClinicalInformation,
  ResearchStudy,
  _action,
  _DocumentReference,
  _coverageArea,
  DataType,
  Duration,
  _Consent,
  _referencePolicy,
  _virtualService,
  _lastModified,
  destination,
  _whenHandedOver,
  _typeTested,
  product,
  _referrer,
  plannedEndDate,
  _birthDate,
  _mustHaveValue,
  ClinicalUseDefinition,
  dynamicValue,
  _detailSequence,
  SupportingInformation,
  CitationStatusDateComponent,
  subscriberId,
  node,
  details,
  GenomicStudyAnalysisInputComponent,
  contract,
  _paymentIssuer,
  _clinicalTrial,
  Adjudication,
  AdverseEventMitigatingActionComponent,
  ratioType,
  authoritative,
  chromosome,
  referralMethod,
  MedicationKnowledgeDefinitionalDrugCharacteristicComponent,
  _filterParameter,
  _costCenter,
  _maternalOrganismName,
  _CommunicationRequest,
  _mapping,
  _spatialReference,
  _AppointmentResponse,
  preparation,
  _outcome,
  _policy,
  planningHorizon,
  _targetSpecies,
  EvidenceVariableCharacteristicComponent,
  _authorization,
  software,
  _lastReviewDate,
  _derivedFromCanonical,
  specialCourtesy,
  intraspecificType,
  shortTitle,
  channelType,
  _subSite,
  use,
  webLocation,
  PlanDefinitionGoalTargetComponent,
  _entryQuantity,
  _seriousness,
  _born,
  initiator,
  geometry,
  _organismGeneral,
  TestReportSetupComponent,
  message,
  PlanDefinitionActionInputComponent,
  Dosage,
  _structureType,
  onAdmission,
  EncounterLocationComponent,
  statusHistory,
  CitationCitedArtifactComponent,
  _paymentTerms,
  _intendedEffect,
  SubstanceSourceMaterialOrganismAuthorComponent,
  listMode,
  _typeCollected,
  definitional,
  improvementNotation,
  ValuedItem,
  ElementDefinitionBaseComponent,
  Errors,
  pattern,
  TestScriptDestinationComponent,
  CoveragePaymentByComponent,
  _AuditEvent,
  requirements,
  authority,
  _compareToSourceId,
  _Contract,
  _occurrenceChanged,
  typeReference,
  detail,
  _alternative,
  ClaimResponseAdjudication,
  Person: Person2,
  readHistory,
  _subjects,
  membership,
  studyUid,
  GraphDefinitionLinkCompartmentComponent,
  _occurrence,
  _dayOfMonth,
  Extension,
  _proxyIdentityCertificate,
  emptyReason,
  ConceptMapGroupComponent,
  laterality,
  _previous,
  _claimResponse,
  dataUpdateType,
  paymentDate,
  baseFormulaProductName,
  performed,
  ServiceRequestOrderDetailComponent,
  _informationSequence,
  _wednesday,
  _id,
  nucleicAcid,
  implementation,
  _species,
  _goalId,
  manager,
  Meta,
  interpreter,
  situation,
  _recorded,
  DiagnosticReport,
  drugCharacteristic,
  SubstanceDefinitionStructureRepresentationComponent,
  RequestOrchestrationActionRelatedActionComponent,
  variableRole,
  failureAction,
  suppliedItem,
  abstract: abstract2,
  valueRange,
  _query,
  sigFormat,
  VirtualServiceDetail,
  _rest,
  packageCode,
  _reaction,
  _contributor,
  _normalValue,
  _resultsInterpreter,
  _tester,
  denominator,
  uniqueId,
  readOnly,
  _effectiveDosePeriod,
  _patientInstruction,
  focusReference,
  _sopClass,
  _brand,
  SubscriptionStatusNotificationEventComponent,
  specialArrangement,
  _autocreate,
  _responsibility,
  any,
  protocolApplied,
  PaymentNotice,
  _completionTime,
  _preAdmissionIdentifier,
  _interpretation,
  testingDestination,
  ExtendedContactDetail,
  administrableDoseForm,
  repeat: repeat2,
  CapabilityStatementRestResourceSearchParamComponent,
  interactant,
  _groupDefinition,
  _effective,
  _service,
  admitSource,
  _cap,
  _structure,
  _preferred,
  human,
  _genomeAssembly,
  _dimensions,
  Reason,
  eligibility,
  resultForCreate,
  PersonLinkComponent,
  EvidenceCertaintyComponent,
  texture,
  characterization,
  TerminologyCapabilitiesExpansionComponent,
  DataRequirementCodeFilterComponent,
  _derivedFrom,
  _doseAdministrationAid,
  productOrService,
  _plannedEndDate,
  conformsTo: conformsTo2,
  _detected,
  _threePrime,
  referencedFrom,
  targetFormat,
  _characteristicType,
  StructureDefinitionMappingComponent,
  _initiatorActive,
  supportedInteraction,
  vaccineCode,
  seriesNumber,
  pageCount,
  _who,
  PermissionRuleActivityComponent,
  careManager,
  CodeSystem,
  MedicinalProductDefinitionNamePartComponent,
  _requestingOrganization,
  _referralMethod,
  _suspectEntity,
  _exclusionCriteria,
  ObservationComponentComponent,
  _testScript,
  manufactureDate,
  _textPresentation,
  TestReportSetupActionOperationComponent,
  legal,
  provider: provider2,
  exitCriteria,
  image: image2,
  SupplyRequest,
  _periodMax,
  _monograph,
  _decision,
  _diagnostics,
  _origin,
  _durationUnit,
  contact: contact2,
  _disabledDisplay,
  _attestation,
  PackagedProductDefinitionPackagingComponentPackaging,
  OperationOutcomeIssueComponent,
  _hash,
  _pageString,
  _constituent,
  DeviceAssociation,
  _dayOfWeek,
  _inventoryListing,
  _hierarchyMeaning,
  _dispenseRequest,
  legallyBinding,
  _manufacturer,
  _answerConstraint,
  _when,
  _form,
  businessStatus,
  comparisonGroup,
  _instance,
  _itemStatus,
  _conditionalDelete,
  _grade,
  _process,
  _articleDate,
  additionalMonitoringIndicator,
  title: title3,
  _courseOfTherapyType,
  _identity,
  CapabilityStatementRestComponent,
  additionalAttribute,
  monomerSet,
  ingredient,
  _subPotentReason,
  _supportedMessage,
  DataRequirementDateFilterComponent,
  _performedActivity,
  _specialty,
  _weekInterval,
  publicationDate,
  administrationInstruction,
  fivePrime,
  _points,
  TestScriptSetupActionAssertComponent,
  referralRequest,
  _timeAspect,
  _presentedForm,
  _seriesDoses,
  milestone,
  MedicationAdministrationPerformerComponent,
  Invoice,
  additionalContext,
  _satisfiedBy,
  identifier: identifier3,
  SubstanceNucleicAcid,
  resourceTrigger,
  _overload,
  organization,
  PlanDefinitionActionConditionComponent,
  RegulatedAuthorizationCaseComponentCaseCase,
  sliceIsConstraining,
  _dataUpdateType,
  noteNumber,
  installDate,
  cardBrand,
  _fullUrl,
  codeMap,
  ConditionDefinitionObservationComponent,
  FamilyMemberHistory,
  operationTypeReason,
  SpecimenDefinitionTypeTestedContainerAdditiveComponent,
  _element,
  _attachedDocument,
  _implementation,
  sourceMaterialType,
  _substance,
  _qualification,
  _countType,
  sourceMaterialState,
  _observationResultRequirement,
  attestationSignature,
  PackagedProductDefinitionPackagingComponentPackagingPackaging,
  _marketingAuthorizationHolder,
  _decisionMode,
  repeats,
  typeTested,
  _rankingOrder,
  end,
  GenomicStudyAnalysisComponent,
  excluded,
  BundleEntryRequestComponent,
  DeviceDefinitionDeviceNameComponent,
  _eventNumber,
  FormularyItem,
  _marketDistribution,
  _searchParam,
  countryOfOrigin,
  AuditEventAgentComponent,
  _regulatoryAuthority,
  _subjectState,
  actualComparisonGroup,
  _focusReference,
  _statusReason,
  ingredientLabel,
  _whenPrepared,
  costCenter,
  outputParameters,
  DevicePropertyComponent,
  productCategory,
  serviceType,
  _verification,
  reliableCache,
  _Flag,
  numberAffected,
  StructureMapGroupRuleDependentComponent,
  relationshipType,
  _statement,
  _Goal,
  issued: issued2,
  _instruction,
  inclusionCriteria,
  about,
  Practitioner,
  prognosisCodeableConcept,
  AdverseEventParticipantComponent,
  _maxValue,
  ItemDetail,
  _hasBodySite,
  _metadata,
  rejectionCriterion,
  cors,
  _option,
  TypeRefComponent,
  minValue,
  _tuesday,
  _offset,
  report,
  _fhirPathCriteria,
  editor,
  _firstDose,
  procedureSequence,
  MedicinalProductDefinitionContactComponent,
  _Communication,
  _controller,
  TestScriptSetupActionAssertRequirementComponent,
  _allocation,
  otherTherapy,
  _requestedLocation,
  _referencedFrom,
  eventsSinceSubscriptionStart,
  _question,
  _drugCharacteristic,
  _total,
  AuditEvent,
  _environmentType,
  AssetContext,
  _rangeCategory,
  Location: Location2,
  rank,
  PlanDefinitionActionComponentActionAction,
  _occurrenceCount,
  entryType,
  _trigger,
  _contextInvariant,
  id: id2,
  _productionIdentifierInUDI,
  _variable,
  occurrence,
  dayOfMonth,
  _maxDosePerPeriod,
  _MeasureReport,
  MedicationKnowledgeCostComponent,
  uuid,
  _range,
  related,
  endpoint,
  ValueSetExpansionParameterComponent,
  _logMessage,
  SubscriptionTopicResourceTriggerQueryCriteriaComponent,
  _supportingImmunization,
  StructureMapConstComponent,
  NutritionIntakeConsumedItemComponent,
  PlanDefinitionGoalComponent,
  precondition,
  _CoverageEligibilityResponse,
  _duration,
  _routeOfAdministration,
  _legallyBinding,
  rendering,
  _hierarchical,
  _nameType,
  _businessStatus,
  _maxLength,
  SubstancePolymerRepeatComponent,
  responsibleParty,
  BundleEntryComponent,
  _input,
  _languageCode,
  _patient,
  direction,
  _publicationDateSeason,
  maritalStatus,
  AllergyIntoleranceReactionComponent,
  _observer,
  SubscriptionParameterComponent,
  doseAdministrationAid,
  DeviceDefinitionClassificationComponent,
  _measure,
  _maxDosePerAdministration,
  CompositionAttesterComponent,
  _valueFilter,
  studyDesign,
  _relation,
  _priority,
  MessageDefinition,
  _description,
  TestPlanTestCaseTestDataComponent,
  HealthcareServiceEligibilityComponent,
  category,
  Details,
  verificationDate,
  ExampleScenarioActorComponent,
  _specimenQuantity,
  DeviceDefinitionPackagingComponent,
  autocreate,
  _structuralRepresentation,
  agent: agent2,
  _request,
  _deliverTo,
  _textConcentration,
  benefitPeriod,
  SpecimenDefinitionTypeTestedContainerComponent,
  ServiceRequestPatientInstructionComponent,
  _adjustment,
  _guidance,
  productReference,
  _for,
  _intended,
  _additionalUse,
  MetadataResource,
  _startingSequence,
  MedicationStatement,
  medium: medium2,
  _baseUnit,
  _doseStatusReason,
  unitOfPresentation,
  CareTeam,
  sourceSignature,
  availableStartTime,
  _effectiveDate,
  _relevantHistory,
  ParametersParameterComponent,
  MessageDefinitionFocusComponent,
  EnrollmentResponse,
  ListEntryComponent,
  _subset,
  dimensions,
  _function,
  recommendation,
  _prescription,
  prognosisReference,
  _hint,
  _ownedBy,
  measurementFrequency,
  _traceNumber,
  _excludingDate,
  _required,
  correctiveAction,
  schedule,
  _referral,
  alternate,
  intendedExposure,
  threePrime,
  param,
  _proposedNewTime,
  power,
  cardinalityBehavior,
  supportingPatientInformation,
  _predecessor,
  allergenicIndicator,
  _regulator,
  issue,
  _admission,
  _extension,
  _notificationShape,
  Device,
  Range,
  ItemBodySite,
  average,
  SubstanceNucleicAcidSubunitSugarComponent,
  Composition,
  _otherMap,
  Rule,
  testScript,
  targetId,
  _additionalAttribute,
  _validity,
  _product,
  objective,
  _containedItem,
  MedicationKnowledgePackagingComponentCost,
  relatedDevice,
  QuestionnaireItemEnableWhenComponent,
  _numberAffected,
  _batch,
  preparationInstruction,
  EpisodeOfCare,
  _entity,
  _initiator,
  _communication,
  programEligibility,
  addItem,
  _details,
  pageString,
  expansion,
  MedicationKnowledgeRegulatoryComponent,
  _affiliation,
  _contentDefinition,
  marketPeriod,
  _reportingPeriod,
  _accountNumber,
  _geneSequenceOrigin,
  subpotentReason,
  inventoryStatus,
  subunit,
  orderer,
  ExampleScenarioInstanceVersionComponent,
  itemStatus,
  _ResearchStudy,
  resourceType,
  Quantity,
  contained,
  _appointmentType,
  SpecimenDefinitionTypeTestedComponent,
  _actual,
  CostToBeneficiary,
  _Schedule,
  programCode,
  _PractitionerRole,
  guarantor,
  _FamilyMemberHistory,
  _operationTypeReason,
  _programStatus,
  _performerLinkId,
  onHold,
  _copackagedIndicator,
  storageGuideline,
  _receiver,
  _whyStopped,
  _packageFor,
  action: action2,
  _sourceMaterialState,
  indicationGuideline,
  _interaction,
  aggregateMethod,
  _authorizingPrescription,
  _authoritative,
  timeAspect,
  _valueSet,
  OperationOutcome,
  Contributor,
  _message,
  import__workaround,
  definitionByTypeAndValue,
  TestScriptSetupActionOperationComponent,
  mitigatingAction,
  validationDate,
  healthcareService,
  conditionalPatch,
  minimumVolume,
  _practiceSetting,
  protocol: protocol2,
  _structureProfile,
  _Coverage,
  _issuerType,
  MedicationRequest,
  _pattern,
  processingFacility,
  _situation,
  _patchFormat,
  alternateMaterial,
  responsible,
  PlanDefinitionActionRelatedActionComponent,
  _security,
  combined,
  contains,
  _addresses,
  expirationDate,
  compartment,
  _scoring,
  policy,
  recordedDate,
  _sourceScope,
  _chain,
  ImplementationGuideManifestComponent,
  _contributedToDeath,
  _diagnosisRelatedGroup,
  _referenceNumber,
  _template,
  _preConditions,
  _score,
  SubstancePolymerMonomerSetComponent,
  _requiredBehavior,
  _statusHistory,
  replacementSequence,
  _file,
  _height,
  _groupSize,
  observedGroup,
  receivedTime,
  _doseAndRate,
  definitionCanonical,
  QuestionnaireResponseItemComponent,
  _typeReference,
  PractitionerQualificationComponent,
  cTerminalModificationId,
  _requireBoth,
  dataAbsentReason,
  _criticality,
  _subjectStatus,
  _expiry,
  usage,
  city,
  _instances,
  stratum,
  MeasureReportGroupStratifierComponent,
  _ratioHighLimitAmount,
  route,
  TestScriptMetadataLinkComponent,
  DeviceDispensePerformerComponent,
  frequencyMax,
  _number,
  QuestionnaireResponse,
  MappingProperty,
  _securityContext,
  display,
  yearlyTemplate,
  ChargeItemPerformerComponent,
  Contact,
  EndpointPayloadComponent,
  _relatedArtifact,
  updateCreate,
  _subtype,
  _stereochemistry,
  _upperLimit,
  routeOfAdministration,
  _amountType,
  _organismType,
  bodySite,
  _moiety,
  _recommendation,
  grouping,
  _pause,
  _primaryPurposeType,
  ConceptSubProperty,
  subscription,
  _lastPage,
  partLocation,
  controller,
  publicationDateSeason,
  imports,
  allocation,
  _pageCount,
  _failureAction,
  profile,
  cylinder,
  deleted: deleted2,
  episodeOfCare,
  saturday,
  _expectedInResearchStudy,
  CommunicationRequestPayloadComponent,
  _calculatedAt,
  _impurity,
  type: type3,
  goalId,
  ObservationDefinitionComponentComponent,
  TestScriptSetupComponent,
  Appointment,
  _groupIdentifier,
  _countMax,
  patientCharacteristic,
  lowNumerator,
  _texture,
  _causality,
  operator,
  fixed,
  nTerminalModificationId,
  InventoryItemNameComponent,
  _minimumId,
  verificationStatus,
  _PaymentNotice,
  _dateAccessed,
  logMessage,
  ResearchStudyProgressStatusComponent,
  _residueSite,
  MonetaryComponent,
  TeardownAction,
  clinicalUseIssue,
  classification,
  _lifecycleStatus,
  signature,
  reviewer,
  _usePeriod,
  BodyStructureIncludedStructureComponent,
  next: next2,
  _changeType,
  _ImmunizationEvaluation,
  requestingOrganization,
  _unitOfPresentation,
  requestedPeriod,
  Answer,
  count,
  ContractOffer,
  composition,
  _EnrollmentResponse,
  ConditionStageComponent,
  ResearchSubjectProgressComponent,
  key,
  assertion,
  MedicationKnowledgeIndicationGuidelineDosingGuidelinePatientCharacteristicComponent,
  alternative: alternative2,
  plan,
  _criteria,
  cycle,
  _latitude,
  modifier,
  _scoringUnit,
  subJurisdiction,
  _search,
  assignedComparisonGroup,
  _alias,
  _status,
  recurring,
  InventoryItemInstanceComponent,
  frameOfReferenceUid,
  _validationDate,
  NutritionOrderEnteralFormulaComponent,
  deliveryDevice,
  _cardBrand,
  adjustment,
  _cors,
  _allergenicIndicator,
  _timezone,
  _actor,
  valueQuantity,
  _versionId,
  requester,
  _SupplyRequest,
  MeasureTermComponent,
  _containedItemQuantity,
  _daysSupply,
  reportingVendor,
  current: current2,
  uid: uid3,
  order,
  priorPrescription,
  distanceFromLandmark,
  VerificationResultValidatorComponent,
  _recurrenceTemplate,
  tenderedAmount,
  _diseaseStatus,
  _expirationDate,
  _dataPeriod,
  note,
  _manipulated,
  _Invoice,
  RatioRange,
  _requisition,
  ClinicalImpression,
  _claim,
  need,
  contributor: contributor3,
  ConceptProperty,
  ConsentVerificationComponent,
  TestReportTeardownComponent,
  _genus,
  extraDetails,
  _location,
  _reported,
  _codeMap,
  firstPage,
  _setup,
  _paymentBy,
  custodian,
  estimatedAge,
  _observation,
  technique,
  Requirements,
  supplementalData,
  SimpleQuantity,
  ProvenanceEntityComponent,
  condition,
  excludeFoodModifier,
  coverageArea,
  contributionInstance,
  _productCode,
  _language,
  base,
  _windowStart,
  district,
  forenameInitials,
  _state,
  friendly,
  AdditionalAttribute,
  _Transport,
  xhtml,
  _official,
  CodeSystemConceptDesignationComponent,
  _precedence,
  _result,
  _sliceName,
  points,
  finding,
  _yearlyTemplate,
  _isModifierReason,
  _experimental,
  _overbooked,
  ExampleScenario,
  AvailabilityNotAvailableTimeComponent,
  derivedFrom,
  _postalCode,
  _endorser,
  modifierExtension,
  verified,
  warning,
  _color,
  _global,
  _policyBasis,
  timeFromEvent,
  costToBeneficiary,
  Questionnaire,
  _FormularyItem,
  _permittedUnit,
  data,
  _targetItem,
  whyStopped,
  _practitioner,
  packageFor,
  _informationSource,
  hasMember,
  _paymentIdentifier,
  allowedType,
  _intraspecificType,
  _isDefault,
  _supportedProfile,
  _authored,
  stabilityDuration,
  InsurancePlanCoverageBenefitLimitComponent,
  compareToSourcePath,
  _dosageInstruction,
  sequence: sequence2,
  revenue,
  SystemInteraction,
  SubscriptionFilterByComponent,
  _requirement,
  _reliableCache,
  nextScheduled,
  MeasureGroupComponent,
  processNote,
  StratifierGroupPopulation,
  issuerType,
  capacity,
  _rendering,
  TestScriptTeardownComponent,
  requestIdentifier,
  _definitionCanonical,
  v,
  _classification,
  Claim,
  asNeeded,
  defaultManualCompletion,
  partDescription,
  articleDate,
  narrative,
  participant: participant2,
  incidence,
  div,
  _versioning,
  RelatedClaim,
  _page,
  appointment,
  AuditEventEntityDetailComponent,
  productionIdentifierInUDI,
  _photo,
  formOf,
  referrer,
  _subdetailSequence,
  CareTeamParticipantComponent,
  SpecimenDefinition,
  _affectsState,
  _inputPopulationId,
  outputProfile,
  MessageDefinitionAllowedResponseComponent,
  numberOfInstances,
  Term: Term2,
  supportingImmunization,
  previousAppointment,
  seriesDoses,
  propertyGroup,
  option,
  component,
  offset,
  materialType,
  marketingAuthorizationHolder,
  requestedPerformer,
  developmentStage,
  _deliveryDevice,
  _Timing,
  AdverseEventSuspectEntityCausalityComponent,
  add,
  ImmunizationPerformerComponent,
  _BodyStructure,
  _organismName,
  _monthlyTemplate,
  versionAlgorithm,
  _deliverFor,
  ElementDefinitionSlicingComponent,
  _responseId,
  _tenderedAmount,
  upperLimit,
  _verificationStatus,
  amountType,
  _patientPaid,
  RequestOrchestrationActionOutputComponent,
  _quantity,
  InsurancePlanPlanSpecificCostBenefitCostComponent,
  _alternate,
  _contributingFactor,
  _sourceIdentityCertificate,
  eventNumber,
  AdministrableProductDefinitionPropertyComponent,
  responseRequired,
  _verifiedBy,
  _maritalStatus,
  _timeOfDay,
  contraindication,
  patientPreparation,
  _expression,
  _min,
  _attester,
  _progress,
  _collection,
  base64Binary,
  ExampleScenarioProcessStepComponent,
  _comprisedOf,
  _factor,
  _endRelationship,
  _startingMaterial,
  expectedSupplyDuration,
  totalPriceComponent,
  _signer,
  enableBehavior,
  Contract,
  _cTerminalModificationId,
  ObservationReferenceRangeComponent,
  maxVolumeToDeliver,
  CapabilityStatementRestResourceOperationComponent,
  isDerived,
  conditionalUpdate,
  repeatUnitAmountType,
  subjects,
  EvidenceVariableCharacteristicTimeFromEventComponent,
  _expansion,
  _Ingredient,
  _phase,
  _benefitPeriod,
  Organization: Organization2,
  _referenceStrength,
  StructureMapGroupComponent,
  referencePolicy,
  previous,
  _stage,
  PlanDefinitionActionOutputComponent,
  _publisherLocation,
  MedicationKnowledgeIndicationGuidelineDosingGuidelineDosageComponent,
  containedItemQuantity,
  copyrightLabel,
  BodyStructureIncludedStructureBodyLandmarkOrientationComponent,
  hasBodySite,
  _valuedItem,
  Period: Period2,
  questionnaire,
  specificCost,
  _collected,
  _notAvailableTime,
  AllergyIntoleranceParticipantComponent,
  headerField,
  _contained,
  _assigner,
  _ifNoneMatch,
  DeviceAssociationOperationComponent,
  _graph,
  changeType,
  _orientation,
  parentSubstanceId,
  recorded,
  _contributionType,
  filterParameter,
  positiveInt,
  docStatus,
  CoverageBenefit,
  durationUnit,
  contentType,
  _addItem,
  MedicationKnowledgeIndicationGuidelineDosingGuidelineComponent,
  dateRange,
  used,
  _city,
  reaction,
  subset,
  performerRole,
  retentionTime,
  _ClinicalImpression,
  _generalCost,
  instanceReference,
  _history,
  molecularFormulaByMoiety,
  _orderer,
  _payee,
  _windowEnd,
  _maxDosePerTreatmentPeriod,
  sopClass,
  PlanDefinitionActorOptionComponent,
  ExampleScenarioInstanceComponent,
  organismGeneral,
  abatement,
  _relatedDevice,
  daysSupply,
  _legal,
  _EpisodeOfCare,
  _excludeFoodModifier,
  weekInterval,
  _measureScore,
  _const,
  _hybrid,
  PackagedProductDefinitionPackagingComponent,
  _prefix,
  _publicationDateText,
  ConceptSet,
  payeeType,
  _shelfLifeStorage,
  balance,
  _type,
  dataPeriod,
  _Immunization,
  resourceReference,
  _providedBy,
  _fhirVersion,
  _HealthcareService,
  submitter,
  description: description5,
  combinedPharmaceuticalDoseForm,
  _targetScope,
  Parameter,
  BiologicallyDerivedProduct,
  _GenomicStudy,
  _NutritionProduct,
  _additionalContext,
  version: version2,
  detected,
  _statistic,
  _bodyStructure,
  _definitionExpression,
  translations,
  _targetProfile,
  _notPerformedReason,
  ArtifactAssessmentContentComponent,
  cost,
  CanonicalResource,
  _authorizationSupporting,
  team,
  actual,
  landmarkDescription,
  typeCanonical,
  ArtifactAssessmentContentComponentContent,
  _organizationReference,
  _minimumVolume,
  precedence,
  CitationSummaryComponent,
  decision,
  role,
  maternalOrganismId,
  _triggeredBy,
  MedicationKnowledgeStorageGuidelineComponent,
  dischargeDisposition,
  _output,
  QuestionnaireItemComponent,
  _compareToSourcePath,
  traceNumber,
  InsurancePlanPlanComponent,
  object: object2,
  statusReason,
  recall,
  _codeSystem,
  _processing,
  gateway,
  _performerType,
  _subcomponent,
  postalCode,
  AddedItemDetail,
  instance,
  _disposition,
  _statusDate,
  _facilityType,
  _stratum,
  Payee,
  _measurementType,
  RelatedArtifact,
  RequestOrchestrationActionDynamicValueComponent,
  identity: identity2,
  subType,
  ValueSetExpansionContainsComponent,
  MedicationKnowledgePackagingComponent,
  _display,
  ImplementationGuideGlobalComponent,
  _SubstanceNucleicAcid,
  TestScriptSetupActionOperationRequestHeaderComponent,
  targetItem,
  _dosingGuideline,
  _totalGross,
  Reference,
  _precheckBehavior,
  _enableBehavior,
  slot,
  groupDefinition,
  _verifiedWith,
  ResourceInteraction,
  _numberOfSubunits,
  numberOfSeries,
  preAuthRefPeriod,
  _excludingRecurrenceId,
  _baseCitation,
  ContractAsset,
  ClinicalImpressionFindingComponent,
  stopTestOnFail,
  _selectionBehavior,
  _imports,
  contextLinkId,
  _eye,
  affiliation,
  defaultValue,
  MolecularSequence,
  overload,
  _productName,
  _comment,
  _profile,
  _deleted,
  _workflow,
  _attestationSignature,
  permittedDataType,
  gene,
  _prediction,
  exposureRoute,
  height: height2,
  _entryClassifier,
  test,
  _previousAppointment,
  implementationGuide,
  UsageContext,
  EventDefinition,
  relatedIdentifier,
  ImplementationGuideDependsOnComponent,
  _procedureSequence,
  _copyrightLabel,
  _navigationLinks,
  _generatedBy,
  administeredProduct,
  validateProfileId,
  MedicationKnowledgeIndicationGuidelineComponent,
  intraspecificDescription,
  _protocolApplied,
  _VerificationResult,
  monthInterval,
  expiry,
  versioning,
  pushTypeAvailable,
  CitationCitedArtifactStatusDateComponent,
  _assertion,
  diagnosis,
  _ifNoneExist,
  _low,
  undesirableEffect,
  _base,
  queryCriteria,
  _availableEndTime,
  number,
  spatialReference,
  conditionality,
  _codeFilter,
  SubstanceDefinitionCharacterizationComponent,
  offsets,
  _orderedBy,
  _authorizationUrl,
  _carrierAIDC,
  _episodeOfCare,
  disabledDisplay,
  DocumentReference,
  compositeScoring,
  _yearInterval,
  RelatedPersonCommunicationComponent,
  _displayName,
  _monday,
  messaging,
  geneElement,
  exclude,
  _itemSequence,
  _artifactAssessment,
  dispenseRequest,
  intendedJurisdiction,
  _restriction,
  ImmunizationEvaluation,
  Observation,
  _supplier,
  NutritionIntakePerformerComponent,
  CapabilityStatementRestComponentSearchParam,
  _SubstanceReferenceInformation,
  _CarePlan,
  AdverseEventPreventiveActionComponent,
  outsideFoodAllowed,
  _maxVolumeToDeliver,
  InventoryItemAssociationComponent,
  deliverFor,
  ElementDefinitionExampleComponent,
  _totalPriceComponent,
  _carrierHRF,
  _subProperty,
  allowed,
  _searchType,
  List,
  responseId,
  _defaultManualCompletion,
  _subscriberId,
  _groupingId,
  _protocolPerformed,
  subPotentReason,
  maxValue,
  _data,
  _disulfideLinkage,
  metadata,
  ConditionParticipantComponent,
  rationale,
  tax,
  _line,
  index,
  _firstPage,
  verifiedBy,
  _requestProvider,
  Diagnosis,
  _hybridType,
  _abnormalCodedValueSet,
  Encounter,
  expression,
  _current,
  BackboneType,
  collection,
  _family,
  _validated,
  question,
  _noMap,
  _comparisonGroup,
  EnrollmentRequest,
  _surfaceOrientation,
  prescription,
  _contributorship,
  synthesisType,
  _anchor,
  _suppress,
  _other,
  variable: variable3,
  MolecularSequenceRelativeComponent,
  Ingredient,
  _occurrenceDateTime,
  Annotation,
  SubstanceReferenceInformationGeneComponent,
  _valueQuantity,
  DeviceDefinitionCorrectiveActionComponent,
  OperationDefinitionParameterComponent,
  EvidenceVariableCharacteristicDefinitionByCombinationComponent,
  SpecimenDefinitionTypeTestedHandlingComponent,
  _testRun,
  compareToSourceId,
  _definitional,
  _testCase,
  _PaymentReconciliation,
  valuedItem,
  relatedItem,
  consumedItem,
  search,
  duration: duration3,
  status: status2,
  _context,
  _requirements,
  _subjectType,
  _use,
  udi,
  nameType,
  _producedFrom,
  _interval,
  summary: summary3,
  MedicinalProductDefinitionCharacteristicComponent,
  sex,
  AdministrableProductDefinition,
  SecurityLabel,
  SubstanceDefinitionRelationshipComponent,
  knownAllergen,
  knownDataCount,
  observer,
  _subtitle,
  accessionNumber,
  _finding,
  _style,
  relation: relation3,
  priority: priority2,
  _requestId,
  ElementDefinitionBindingComponent,
  sequenceAttachment,
  AddedItemBodySite,
  _group,
  publisher: publisher3,
  consent,
  site,
  canFilterBy,
  TerminologyCapabilitiesValidateCodeComponent,
  _isSubPotent,
  EncounterParticipantComponent,
  _cancellationReason,
  _repetitions,
  TestPlanTestCaseTestRunScriptComponent,
  distributor,
  _stopTestOnFail,
  organizationReference,
  residueSite,
  guidance,
  _originatingAppointment,
  intended,
  _measurementFrequency,
  _variableRole,
  assurance,
  literal: literal3,
  _suppliedItem,
  ProcedurePerformerComponent,
  baseUnit,
  _translation,
  StructureDefinitionSnapshotComponent,
  _name,
  MedicationRequestDispenseRequestInitialFillComponent,
  _incidence,
  _during,
  _snapshot,
  SubstancePolymerRepeatRepeatUnitComponent,
  _format,
  PlanBenefit,
  _foodPreferenceModifier,
  function__workaround,
  environmentType,
  SubscriptionTopicCanFilterByComponent,
  occurrenceCount,
  careTeamSequence,
  _notConsumedReason,
  _restoreDate,
  providedBy,
  meta,
  _subDetailSequence,
  required,
  _dateWritten,
  _deviceIdentifier,
  referral,
  _conditionality,
  AuditEventSourceComponent,
  _component,
  link: link2,
  _hasStage,
  _contentReference,
  program,
  OtherElement,
  scoringUnit,
  _maxCount,
  ExplanationOfBenefitEventComponent,
  _ArtifactAssessment,
  scope,
  inventoryListing,
  concentration,
  _device,
  hierarchyMeaning,
  CapabilityStatementRestComponentOperation,
  otherMap,
  answerConstraint,
  normalCodedValueSet,
  global: global2,
  excludingRecurrenceId,
  _SubstanceSourceMaterial,
  validity,
  subjectReport,
  _any,
  _nextScheduled,
  administration,
  sort,
  ManufacturedItemDefinitionComponentComponentProperty,
  _sent,
  _directnessMatch,
  _targetFormat,
  _used,
  _occurence,
  _partOf,
  relativeRisk,
  supportedMessage,
  _dateOfDiagnosis,
  _seriesNumber,
  DataRequirementSortComponent,
  ChargeItemDefinitionPropertyGroupComponentApplicability,
  codeSystem,
  processing,
  _ResearchSubject,
  _heartbeatPeriod,
  ValueSetExpansionPropertyComponent,
  orderDetail,
  Group: Group2,
  statusDate,
  uri,
  max,
  _conformance,
  _unitPriceComponent,
  _availabilityStatus,
  _exitCriteria,
  Schedule,
  BiologicallyDerivedProductCollectionComponent,
  DomainResource,
  _AdverseEvent,
  focalDevice,
  _authorType,
  mode: mode2,
  observation,
  _issuer,
  ClaimEventComponent,
  FamilyMemberHistoryParticipantComponent,
  _validationStatus,
  string,
  productCode,
  receiver,
  CitationCitedArtifactTitleComponent,
  totalGross,
  _outputProfile,
  conditionalDelete,
  baseDefinition,
  NutritionProductInstanceComponent,
  ClinicalUseDefinitionIndicationComponent,
  relevantHistory,
  referenceInformation,
  valueSet,
  library,
  InventoryReportInventoryListingItemComponent,
  performedActivity,
  Coverage,
  probability,
  TerminologyCapabilitiesSoftwareComponent,
  _activity,
  prediction,
  _mimeType,
  exception,
  ImplementationGuideDefinitionTemplateComponent,
  _edit,
  _usage,
  proposedNewTime,
  security,
  _parameter,
  InventoryItemDescriptionComponent,
  ConditionDefinitionPreconditionComponent,
  LocationPositionComponent,
  sequenceRange,
  policyBasis,
  _inputParameters,
  _dateRange,
  _cost,
  Timing,
  _team,
  _paternalOrganismId,
  _statusChanged,
  ActivityDefinitionDynamicValueComponent,
  processor,
  _constraint,
  _sampleSize,
  ClinicalUseDefinitionContraindicationComponent,
  _comorbidity,
  _knownDataCount,
  template,
  codeFilter,
  dateAccessed,
  _organization,
  _ifModifiedSince,
  _lastRevisionDate,
  _strength,
  numerator,
  _altitude,
  _countingDateTime,
  MedicationDispense,
  _maxDuration,
  requirement,
  SubstanceProteinSubunitComponent,
  _abatement,
  reportingPeriod,
  dosage,
  _supplement,
  _treatmentIntent,
  performingOrganization,
  _what,
  intervalUnit,
  preAuthPeriod,
  fhirPathCriteria,
  administeredBy,
  factor,
  ContactPoint,
  appointmentType,
  _collector,
  answerValueSet,
  _achievementStatus,
  carrierHRF,
  _evaluatedResource,
  signer,
  _usageReason,
  variableDefinition,
  manifestation,
  searchType,
  PaymentReconciliation,
  _modelNumber,
  groupingId,
  _VisionPrescription,
  performerLinkId,
  procedure,
  implicitRules,
  query,
  Items,
  _slot,
  _conditionalCreate,
  PatientCommunicationComponent,
  ConditionDefinitionMedicationComponent,
  documentation,
  maxDosePerTreatmentPeriod,
  example,
  _sessionKey,
  lastPage,
  hybridType,
  field,
  maxDosePerPeriod,
  _excludedStructure,
  _script,
  acceptLanguage,
  practiceSetting,
  brand,
  _attributeEstimate,
  _end,
  diagnosisSequence,
  _specification,
  _test,
  _durationMax,
  impurity,
  _Practitioner,
  SubstanceIngredientComponent,
  control,
  _enterer,
  TransportOutputComponent,
  _retentionTime,
  _encodeRequestUrl,
  countMax,
  _netContent,
  AccountBalanceComponent,
  _sequenceAttachment,
  requestedLocation,
  DeviceDefinitionRegulatoryIdentifierComponent,
  _target,
  _implicated,
  _administration,
  _flag,
  _party,
  _version,
  provision,
  patientPaid,
  referenceNumber,
  manifest,
  Account,
  _goal,
  _basis,
  MessageSource,
  _formCode,
  _disclaimer,
  _definitionByCombination,
  step,
  fractionDescription,
  valueCategory,
  requestMethod,
  BodySite,
  etag,
  specimenQuantity,
  comprisedOf,
  _pediatricUseIndicator,
  _destination,
  _evaluationMessage,
  ResearchStudyComparisonGroupComponent,
  _DomainResource,
  CitationCitedArtifactWebLocationComponent,
  beneficiary,
  prefix,
  effectiveTime,
  RegulatedAuthorizationCaseComponent,
  AccountProcedureComponent,
  doseStatusReason,
  ResearchStudyAssociatedPartyComponent,
  reason,
  _precondition,
  criteria,
  MedicationAdministrationDosageComponent,
  latitude: latitude2,
  IngredientSubstanceStrengthReferenceStrengthComponent,
  _thursday,
  securityContext,
  _baseDefinition,
  _publicationStatus,
  relatedArtifact,
  safety,
  stereochemistry,
  _timeout,
  primarySource,
  NutritionOrderOralDietNutrientComponent,
  responseCode,
  eventHistory,
  _doseForm,
  _allowedResponse,
  _storageGuideline,
  timezone,
  copolymerConnectivity,
  GenomicStudyAnalysisOutputComponent,
  _molecularWeight,
  ObservationDefinition,
  ifNoneMatch,
  _notConsumed,
  grade,
  OralDietSchedule,
  _diagnosis,
  _channelType,
  _encounter,
  SubstancePolymerMonomerSetStartingMaterialComponent,
  statisticType,
  _webLocation,
  SubstanceSourceMaterialOrganismOrganismGeneralComponent,
  textConcentration,
  _multipleAnd,
  _freeToShare,
  _contributionInstance,
  MedicationStatementAdherenceComponent,
  _onAdmission,
  output,
  _indication,
  DeviceDefinitionChargeItemComponent,
  location: location3,
  generalCost,
  _plannedActivityReference,
  rules,
  reported,
  maxDosePerDay,
  NutritionOrderOralDietTextureComponent,
  _definitionByTypeAndValue,
  GroupMemberComponent,
  _verificationType,
  _supportingInformation,
  kingdom,
  sourceMaterialClass,
  _polymer,
  insurance,
  _handling,
  supportingInfo,
  lifecycleStatus,
  _symptomConditionEffect,
  _fraction,
  language: language3,
  combining,
  country,
  isExample,
  _readHistory,
  BundleLinkComponent,
  currentLocation,
  official,
  _EncounterHistory,
  EvidenceVariableCategoryComponent,
  _administeredBy,
  _ProductShelfLife,
  SubstanceDefinitionMolecularWeightComponent,
  affectsState,
  notificationShape,
  descriptionSummary,
  _answerValueSet,
  PractitionerRole,
  _rationale,
  _ChargeItem,
  _offer,
  OperationDefinitionParameterReferencedFromComponent,
  singleUse,
  _exclude,
  fhirVersion,
  _nucleicAcid,
  CodeableConcept,
  _Claim,
  _site,
  targetScope,
  _monthInterval,
  _monitoringProgram,
  mustHaveValue,
  _interpreter,
  SubscriptionStatus,
  _productOrServiceEnd,
  doseQuantity,
  _prism,
  highNumerator,
  contentDefinition,
  due: due2,
  structureProfile,
  _acceptLanguage,
  _RegulatedAuthorization,
  authorType,
  paymentIssuer,
  clinicalTrial,
  _parentSubstanceName,
  _high,
  actorId,
  _document,
  _marketPeriod,
  _denominator,
  accessionIdentifier,
  VerificationResultPrimarySourceComponent,
  authored,
  serialNumber,
  Consent,
  _resourceType,
  outcomeMeasure,
  purpose,
  DiagnosticReportSupportingInfoComponent,
  Citation,
  _serviced,
  performer,
  _stratifier,
  InvoiceParticipantComponent,
  requiredBehavior,
  _oralDiet,
  monday,
  MedicationRequestDispenseRequestComponent,
  _subJurisdiction,
  _interactant,
  _admitSource,
  TargetElement,
  _given,
  _recorder,
  hasPart: hasPart2,
  _cancellationDate,
  supplements,
  constraint,
  total,
  outcome,
  sampleSize,
  ContributorshipSummary,
  PrimitiveType,
  caloricDensity,
  MedicationKnowledgeStorageGuidelineEnvironmentalSettingComponent,
  _clinicalUseIssue,
  LinkageItemComponent,
  AdministrableProductDefinitionRouteOfAdministrationComponent,
  _conditionalUpdate,
  _publisher,
  MolecularSequenceRelativeStartingSequenceComponent,
  _validator,
  _inactive,
  AppointmentResponse,
  _molecularFormula,
  payload,
  subSite,
  _sort,
  TestScriptOriginComponent,
  _allergyIntolerance,
  _identityCertificate,
  _additional,
  _assurance,
  _careManager,
  ImageRegion2D,
  forecastReason,
  supplement,
  _nutrient,
  _sugar,
  entryReference,
  _citedMedium,
  MeasureSupplementalDataComponent,
  input,
  ManufacturedItemDefinition,
  Prism,
  GroupCharacteristicComponent,
  _qualifier,
  GraphDefinition,
  _BiologicallyDerivedProduct,
  _Procedure,
  _receivedTime,
  quantity,
  _linkId,
  ManufacturedItemDefinitionComponentComponentComponentComponent,
  _prescriber,
  EvidenceReportSubjectCharacteristicComponent,
  hasSeverity,
  _estimate,
  certainty,
  _billingStatus,
  ContactDetail,
  sessionKey,
  calibration,
  _literal,
  ConditionDefinitionQuestionnaireComponent,
  _dateTime,
  CoverageEligibilityRequest,
  _repeatUnitAmountType,
  pediatricUseIndicator,
  SampledData,
  attester,
  originatingAppointment,
  progress,
  _frequencyMax,
  measureScore,
  InsurancePlanCoverageComponent,
  Evidence,
  _operationalStatus,
  ImagingSelectionPerformerComponent,
  restriction,
  _issues,
  dose,
  _updateCreate,
  _supportingInfo,
  warningOnly,
  _coverage,
  informationSequence,
  netContent,
  representation,
  _typeMode,
  subProperty,
  _subscription,
  Library,
  DeviceMetricCalibrationComponent,
  implicated,
  _actualGroup,
  _SubstanceProtein,
  _capabilities,
  _associatedParty,
  _supplementalData,
  _program,
  offeredIn,
  TerminologyCapabilitiesCodeSystemComponent,
  multipleBirth,
  _replacedSequence,
  disclaimer,
  InsurancePlan,
  _installDate,
  _extends,
  fundsReserve,
  assigner,
  SpecimenProcessingComponent,
  occurred,
  _lockedDate,
  GenomicStudyAnalysisPerformerComponent,
  _lowNumerator,
  _classifier,
  resultsInterpreter,
  _limit,
  _serviceProvider,
  patientInstruction,
  binding,
  recurrenceType,
  during,
  capability,
  Substance,
  suspectEntity,
  QuestionnaireItemInitialComponent,
  occurrenceDate,
  monthlyTemplate,
  supportingInformation,
  authorizationRequired,
  _versionReference,
  ImmunizationRecommendationRecommendationComponent,
  _measurementPoint,
  batch,
  _include,
  ValueSetComposeIncludeFilterComponent,
  subcomponent,
  _DetectedIssue,
  _GuidanceResponse,
  _participantType,
  _division,
  _section,
  _MedicationAdministration,
  _outcomeMeasure,
  PackagingDistributor,
  _serviceType,
  _subjectReport,
  _initialFill,
  _administrableDoseForm,
  areaOfHybridisation,
  subjectType,
  device,
  AddedItem,
  _region,
  MedicationKnowledgeRegulatorySubstitutionComponent,
  MeasureReportGroupComponent,
  _accident,
  endRelationship,
  structure,
  _library,
  _descriptionSummary,
  baseCitation,
  definitionId,
  _coordinateSystem,
  characteristicType,
  _entry,
  imageRegion2D,
  _DeviceDefinition,
  conclusionCode,
  BiologicallyDerivedProductDispensePerformerComponent,
  _caloricDensity,
  ManufacturedItemDefinitionComponentComponent,
  _focal,
  indication,
  _AllergyIntolerance,
  _publishedIn,
  partOf: partOf2,
  _initialSelected,
  _key,
  backCurve,
  _path,
  definitionUri,
  ExplanationOfBenefitItemReviewOutcomeComponent,
  DetectedIssueMitigationComponent,
  _lastOccurrenceDate,
  _enableWhen,
  time,
  MedicinalProductDefinitionNameUsageComponent,
  ChargeItemDefinitionApplicabilityComponent,
  InventoryItemCharacteristicComponent,
  _dischargeDisposition,
  isModifierReason,
  StructureDefinitionContextComponent,
  _forecastReason,
  SubstanceDefinitionMoietyComponent,
  _step,
  rest,
  issuer,
  _nutritionProduct,
  SubstancePolymer,
  ValueSetComposeComponent,
  _doseNumber,
  SubstanceDefinitionNameComponent,
  derivedFromUri,
  _startParam,
  _attribute,
  _extraDetails,
  _accessionIdentifier,
  _entryReference,
  Parameters,
  ChargeItem,
  _uid,
  chain,
  _bodySite,
  qualification,
  yearInterval,
  _developmentStage,
  riskAdjustment,
  _estimatedAge,
  RequirementsStatementComponent,
  _intendedRoute,
  score,
  DeviceRequestParameterComponent,
  _diseaseSymptomProcedure,
  _validationProcess,
  ExampleScenarioProcessComponent,
  _timestamp,
  supportedProfile,
  TestReportSetupActionAssertComponent,
  _label,
  _preparationInstruction,
  InventoryItemResponsibleOrganizationComponent,
  informationType,
  BodyStructureIncludedStructure,
  _requesterLinkId,
  PlanDefinition,
  postConditions,
  EvidenceVariableDefinitionComponent,
  _meaningWhenMissing,
  DeviceDispense,
  _modelCharacteristic,
  SetupAction,
  _studyDesign,
  _analysis,
  insurancePlan,
  communicationRequest,
  specialty,
  _artifact,
  chargeItemCode,
  actuality,
  _maxParticipants,
  _Basic,
  _example,
  _representation,
  telecom,
  EvidenceCertaintyComponentCertaintyCertainty,
  _lastPerformed,
  _legalState,
  _preAuthPeriod,
  GraphDefinitionLinkComponent,
  workflow,
  _incomplete,
  _sphere,
  _substanceDefinition,
  informationSource,
  _periodUnit,
  paymentIdentifier,
  stratifier,
  pause,
  _isActive,
  _synonym,
  _manifestation,
  _control,
  RegulatedAuthorizationCaseComponentCase,
  dosageInstruction,
  _implicitRules,
  AvailabilityAvailableTimeComponent,
  SpecimenCollectionComponent,
  regulatoryAuthority,
  _EnrollmentRequest,
  hash,
  marketDistribution,
  countType,
  _documentation,
  association,
  _intendedJurisdiction,
  _recurrenceType,
  when,
  form,
  _complete,
  _shortDoco,
  differential,
  _occurrenceDate,
  additional,
  canonical,
  _actualComparisonGroup,
  _requestor,
  CommunicationPayloadComponent,
  AccountDiagnosisComponent,
  _doseStatus,
  TestScriptTestComponent,
  TaskOutputComponent,
  MeasureReport,
  producedFrom,
  tuesday,
  _sourceReference,
  crossReference,
  _Composition,
  subdetailSequence,
  _definitionReference,
  supplier,
  inputPopulationId,
  CarePlan,
  clinicalStatus,
  measurementType,
  ImplementationGuideDefinitionGroupingComponent,
  _fundingSource,
  _immunizationEvent,
  ClaimResponseEventComponent,
  statement,
  ImageRegion3D,
  _item,
  _repeatUnit,
  startingMaterial,
  _temperatureQualifier,
  dosingGuideline,
  _serviceCategory,
  _rate,
  _filterDefinition,
  prescriber,
  oid,
  _attachment,
  _sourceAttachment,
  _materialType,
  target: target2,
  _valueCategory,
  _requestMethod,
  linkage,
  DeviceUdiCarrierComponent,
  TerminologyCapabilitiesClosureComponent,
  _conclusionCode,
  _div,
  processingMode,
  _rule,
  StructureMap,
  _molecularFormulaByMoiety,
  firstDose,
  BundleEntryResponseComponent,
  structureVersion,
  alias,
  _programCode,
  _resultForDelete,
  grantee,
  _effectiveTime,
  definitionCodeableConcept,
  Property,
  entryClassifier,
  _combining,
  paternalOrganismName,
  _asset,
  PaymentReconciliationAllocationComponent,
  _part,
  actor: actor2,
  _isExample,
  navigationLinks,
  availability,
  _specimen,
  term: term2,
  notAvailableTime,
  specimenRequirement,
  answer,
  _citation,
  patient,
  suppress,
  additionalUse,
  _maxDosePerLifetime,
  Distance,
  _primarySource,
  _opticalActivity,
  _multipleOr,
  _specialMeasures,
  usageReason,
  GoalTargetComponent,
  measure,
  contributionType,
  modelNumber,
  _derivedFromUri,
  _method,
  effectiveDate,
  _servicePeriod,
  asNeededFor,
  ExplanationOfBenefit,
  _add,
  _cancelledReason,
  orderMeaning,
  testCase,
  net,
  VerificationResultAttestationComponent,
  _class,
  claim,
  Flag: Flag2,
  _riskAdjustment,
  _compareToSourceExpression,
  _notificationEvent,
  guideline,
  amount,
  _dateFilter,
  _statisticType,
  genus,
  _MessageHeader,
  _administrationTreatment,
  _country,
  insurer,
  DeviceDefinitionLinkComponent,
  container,
  _params,
  Goal,
  lockedDate,
  symptomConditionEffect,
  referenceStrength,
  interval,
  _compartment,
  classifier,
  PackagedProductDefinitionPackagingPropertyComponent,
  setup,
  _areaOfHybridisation,
  maxLength,
  publisherLocation,
  RelatedPerson,
  _storageTempRequirements,
  _Organization,
  _postConditions,
  _DeviceDispense,
  state,
  SubstanceDefinitionSourceMaterialComponent,
  _aggregate,
  fluidConsistencyType,
  MoneyQuantity,
  _specificCost,
  _organismId,
  StructureMapGroupInputComponent,
  _check,
  _chargeItemCode,
  ownedBy,
  _participantStatus,
  _baseFormulaType,
  shelfLifeStorage,
  authorizingPrescription,
  protein,
  connectivity,
  information,
  DeviceDefinitionVersionComponent,
  AdverseEvent,
  _originRelationshipType,
  definitionExpression,
  ServiceRequestOrderDetailParameterComponent,
  TestPlan,
  requestProvider,
  _formatted,
  NutritionProduct,
  ActorDefinition,
  RegulatedAuthorization,
  _facility,
  sourceDocument,
  _morphology,
  _kind,
  color,
  _bounds,
  snapshot,
  SpecimenContainerComponent,
  unsignedInt,
  MedicationKnowledgeMedicineClassificationComponent,
  ImmunizationProgramEligibilityComponent,
  _dose,
  useBy,
  _start,
  _import,
  TaskPerformerComponent,
  grantor,
  _purpose,
  benefit,
  contributorship,
  PlanDefinitionActionDynamicValueComponent,
  ImagingStudySeriesComponent,
  programStatus,
  _evidence,
  ClinicalUseDefinitionInteractionInteractantComponent,
  _highNumerator,
  ChargeItemDefinitionPropertyGroupComponent,
  boolean,
  PackagedProductDefinitionProperty,
  _Group,
  _media,
  hasStage,
  TestReportSetupActionAssertRequirementComponent,
  _onBehalfOf,
  SubstanceReferenceInformationGeneElementComponent,
  maxCount,
  enableWhen,
  regulator,
  _medicineClassification,
  imageRegion3D,
  _source,
  _hoursOfOperation,
  admission,
  extension,
  _reAdmission,
  integer64,
  _Task,
  HealthcareService,
  _Appointment,
  _crossReference,
  _hasPart,
  _executionPeriod,
  Expression,
  Class,
  _operation,
  _adjustmentReason,
  notConsumed,
  relativePath,
  ImplementationGuideDefinitionComponent,
  geneSequenceOrigin,
  level,
  TestReportTestComponent,
  doseNumber,
  ParametersParameterComponentParameterParameter,
  age,
  _payload,
  entityRelatedness,
  startParam,
  _intraspecificDescription,
  _clinicalStatus,
  _compositeScoring,
  jurisdiction,
  Exemption,
  _requestHeader,
  _certainty,
  connectionType,
  _groupingBehavior,
  _translations,
  photo,
  multipleAnd,
  _gender,
  _coding,
  _system,
  _Slot,
  freeToShare,
  ElementDefinitionMappingComponent,
  copackagedIndicator,
  precheckBehavior,
  map: map2,
  additionalInfo,
  preConditions,
  numberOfSubunits,
  numberOfEvents,
  _sender,
  _validCodedValueSet,
  _referenceInformation,
  longitude: longitude2,
  _contentDerivative,
  _reportedDateTime,
  Primitive,
  _processingMode,
  _composition,
  _width,
  _valueAlternatives,
  hint,
  license: license2,
  created: created3,
  expectedInResearchStudy,
  originalPrescription,
  scoring,
  ClinicalUseDefinitionInteractionComponent,
  PlanDefinitionActorComponent,
  subjectStatus,
  _qualitativeRisk,
  _header,
  recurrenceId: recurrenceId2,
  _author,
  responsibleOrganization,
  TriggerDefinition,
  _BackboneElement,
  _offeredIn,
  _accessionNumber,
  legalState,
  incomplete,
  CodeableReference,
  activity,
  availableEndTime,
  mimeType,
  NutritionOrderEnteralFormulaAdministrationComponent,
  periodUnit,
  EvidenceReportRelatesToComponent,
  SubstanceDefinition,
  _useContext,
  _instantiatesUri,
  authorizationUrl,
  contributedToDeath,
  confidentialityIndicator,
  _diagnosisSequence,
  selectionBehavior,
  _time,
  addresses,
  _dataRequirement,
  CapabilityStatementRestResourceComponent,
  _lineItem,
  _InventoryReport,
  _copyright,
  _Substance,
  _timing,
  wasSubstituted,
  aggregation,
  _authorDescription,
  _filter,
  MedicinalProductDefinitionOperationComponent,
  _defaultValue,
  StructureMapStructureComponent,
  recipient,
  _lotNumber,
  QuestionnaireItemAnswerOptionComponent,
  applies,
  caseSensitive,
  subtype,
  _field,
  _hasIngredient,
  strength,
  linkId,
  StructureMapGroupRuleTargetComponent,
  _resultingEffect,
  altitude: altitude2,
  phase,
  _numberOfRepeatsAllowed,
  groupSize,
  _oligoNucleotideType,
  doseStatus,
  directnessMatch,
  AppointmentParticipantComponent,
  _continuous,
  _dispenseInterval,
  stage,
  associatedMedication,
  dateOfDiagnosis,
  _actualPeriod,
  ValueSet,
  lastOccurrence,
  disulfideLinkage,
  participatingOrganization,
  ResearchSubject,
  heartbeatPeriod,
  OrganizationAffiliation,
  _binding,
  SubstanceNucleicAcidSubunitLinkageComponent,
  ImplementationGuideDefinitionPageComponent,
  FamilyMemberHistoryProcedureComponent,
  subscriptionTopic,
  _resource,
  correspondingContact,
  graph: graph2,
  _QuestionnaireResponse,
  RequestOrchestrationActionComponentAction,
  issues,
  instances,
  _isDefining,
  primaryPurposeType,
  _specimenRequirement,
  _sourceDocument,
  SubstanceReferenceInformation,
  _multipleBirth,
  _InsurancePlan,
  repeatUnit,
  StructureDefinition,
  _node,
  TestPlanTestCaseAssertionComponent,
  relatedData,
  _content,
  _associationType,
  _regulatoryBasis,
  attachment: attachment2,
  ActionSubject,
  _packagedMedicinalProduct,
  _packagedProduct,
  _onset,
  _basedOn,
  CitationCitedArtifactRelatesToComponent,
  _backCurve,
  AuditEventOutcomeComponent,
  payee,
  _reporter,
  SubstanceDefinitionStructureComponentMolecularWeight,
  biologicalSourceEvent,
  RequestOrchestrationActionComponent,
  period,
  SearchParameterComponentComponent,
  protocolPerformed,
  ResearchStudyLabelComponent,
  _careTeamSequence,
  instantiates,
  _patientCharacteristic,
  _allowedType,
  Element,
  DeviceMetric,
  _maxTreatmentPeriod,
  _InventoryItem,
  AppointmentRecurrenceTemplateComponent,
  targetDisease,
  PlanDefinitionActionComponentAction,
  file,
  const__workaround,
  citedMedium,
  _frames,
  multipleOr,
  inputParameters,
  causality,
  SupplyDelivery,
  minimumId,
  _processNote,
  Money,
  _BackboneType,
  _Endpoint,
  udiDeviceIdentifier,
  EnteralFormulaSchedule,
  diseaseStatus,
  _expectedSupplyDuration,
  ifModifiedSince,
  formCode,
  _connectionType,
  ImplementationGuideDefinitionResourceComponent,
  _fundsReserveRequested,
  dateFilter,
  matchStatus,
  usePeriod,
  _participant,
  MessageDestination,
  _additionalInfo,
  _numberOfEvents,
  _includedStructure,
  _imageRegion2D,
  _tax,
  _appointment,
  treatmentIntent,
  SubstanceDefinitionCodeComponent,
  _study,
  _ratioType,
  policyHolder,
  region: region2,
  operationType,
  _actuality,
  _definitionUri,
  organismId,
  ManufacturedItemDefinitionComponentComponentComponentProperty,
  _consumedItem,
  thursday,
  _rules,
  dependent,
  deliverFrom,
  ImmunizationProtocolAppliedComponent,
  actualGroup,
  Age,
  subsumption,
  ElementDefinitionConstraintComponent,
  subjectResults,
  OperationDefinitionOverloadComponent,
  recurrenceTemplate,
  doseForm,
  adherence,
  ServiceRequest,
  deviceIdentifier,
  _reasonLinkId,
  versionId,
  componentPart,
  _value,
  TestReportParticipantComponent,
  morphology,
  date: date3,
  _isModifier,
  _allDay,
  contentReference,
  _sunday,
  DeviceUsageAdherenceComponent,
  maxSingleDose,
  referenceRange,
  _pages,
  DeviceDefinitionGuidelineComponent,
  _temperatureRange,
  _sequenceType,
  _partNumber,
  _term,
  StructureDefinitionDifferentialComponent,
  _udi,
  _telecom,
  CitationCitedArtifactPublicationFormPublishedInComponent,
  _wasSubstituted,
  initial,
  doNotPerform,
  diameter,
  _property,
  MessageHeaderResponseComponent,
  Linkage,
  permittedUnit,
  _sex,
  genomeBuild,
  changePattern,
  MedicationRequestSubstitutionComponent,
  _authority,
  onBehalfOf,
  _rateAggregation,
  managingOrganization,
  handling,
  notConsumedReason,
  axis,
  _udiCarrier,
  paymentBy,
  _insurancePlan,
  subDetailSequence,
  DataRequirementValueFilterComponent,
  problem,
  initialFill,
  _ManufacturedItemDefinition,
  _improvementNotation,
  ClinicalUseDefinitionIndicationComponentOtherTherapy,
  fraction,
  _lastOccurrence,
  _assessment,
  Patient,
  _identified,
  ExplanationOfBenefitAdjudication,
  _Subscription,
  tag: tag2,
  _performed,
  _formOf,
  DeviceDefinitionPackagingComponentPackagingPackaging,
  _subrogation,
  _deceased,
  relatedAccount,
  Transport,
  Measure,
  RiskAssessment,
  _teardown,
  degreeOfPolymerisation,
  _CoverageEligibilityRequest,
  _Medication,
  manufacturedDoseForm,
  sliceName,
  dateAsserted,
  ContractParty,
  validationStatus,
  TestScriptMetadataComponent,
  _headerField,
  geographicalLocation,
  versionNeeded,
  ConceptDefinition,
  _sigFormat,
  publishedIn,
  sphere,
  _SubstanceDefinition,
  SubstanceDefinitionNameOfficialComponent,
  _listRuleId,
  started,
  EvidenceVariable,
  ResearchStudyOutcomeMeasureComponent,
  allowedResponse,
  _ElementDefinition,
  CitationCitedArtifactContributorshipComponent,
  _contentType,
  _DeviceUsage,
  DeviceDefinitionUdiDeviceIdentifierComponent,
  document: document3,
  event,
  Guarantor,
  molecularWeight,
  substitution,
  NutritionOrderSupplementComponent,
  _relativeRisk,
  _volume,
  _manager,
  _presentation,
  _linkage,
  isDefault,
  BodyStructure,
  _relationship,
  _maxDispense,
  ChargeItemDefinition,
  _SupplyDelivery,
  _specialArrangement,
  DosageDoseAndRateComponent,
  _guideline,
  _grantee,
  serviced,
  _active,
  _preference,
  useContext,
  _container,
  justification,
  oralDiet,
  _testingDestination,
  lastRevisionDate,
  NutritionIntakeIngredientLabelComponent,
  QuestionnaireResponseItemComponentItem,
  PermissionJustificationComponent,
  recorder,
  ImmunizationRecommendationRecommendationDateCriterionComponent,
  _focus,
  countingDateTime,
  MedicationKnowledge,
  ConditionDefinition,
  noMap,
  _userSelected,
  appointmentRequired,
  _numberOfStudies,
  capabilities,
  Benefit,
  _uri,
  _max,
  inactive,
  other,
  dependsOn,
  citedArtifact,
  fixture,
  _insurer,
  _endParam,
  continuous,
  SubstancePolymerRepeatRepeatUnitStructuralRepresentationComponent,
  _responsibleOrganization,
  url: url3,
  compareToSourceExpression,
  nutrient,
  _subjectResults,
  DocumentReferenceRelatesToComponent,
  ImagingStudy,
  AppointmentRecurrenceTemplateYearlyTemplateComponent,
  SpecimenFeatureComponent,
  _ServiceRequest,
  tester,
  seriousness,
  isDefining,
  contributingFactor,
  CapabilityStatement,
  _ImagingSelection,
  _unmapped,
  compositional,
  fundsReserveRequested,
  Total,
  _citeAs,
  _protein,
  _referenceRange,
  complication,
  SubscriptionTopicResourceTriggerComponent,
  estimate,
  _material,
  Item,
  encodeRequestUrl,
  _currentLocation,
  style,
  method: method2,
  _MarketingStatus,
  group,
  achievementStatus,
  evaluatedResource,
  _udiDeviceIdentifier,
  _RelatedPerson,
  dateTime,
  _intervalUnit,
  text,
  _contact,
  searchInclude,
  _fivePrime,
  timeOfDay,
  originRelationshipType,
  CitationClassificationComponent,
  _plannedStartDate,
  documentType,
  CoverageEligibilityRequestEventComponent,
  _milestone,
  page,
  params,
  regionsCalled,
  conditionalCreate,
  lensSpecification,
  _grantor,
  coverage: coverage3,
  authorizationSupporting,
  ElementDefinitionBindingAdditionalComponent,
  _benefit,
  _testData,
  _OrganizationAffiliation,
  excludedStructure,
  _searchRevInclude,
  serviceProvisionCode,
  typeMode,
  ValueSetScopeComponent,
  SupplyRequestParameterComponent,
  attributeEstimate,
  immutable,
  _relatedAccount,
  _RiskAssessment,
  BiologicallyDerivedProductPropertyComponent,
  _totalVolume,
  _adjudication,
  history,
  _isSubpotent,
  _longitude,
  _sliceIsConstraining,
  collected,
  medicineClassification,
  Signature,
  ConceptReference,
  TransportRestrictionComponent,
  _rank,
  _inResponseTo,
  CitationCitedArtifactAbstractComponent,
  _error,
  origin: origin3,
  treeRoot,
  _sourceMaterialType,
  bodyStructure,
  _releaseDate,
  normalValue,
  PractitionerCommunicationComponent,
  targetProfile,
  bounds,
  _op,
  OperationDefinitionParameterComponentParameterParameter,
  plannedActivityReference,
  _preAuthRef,
  _imageRegion3D,
  _object,
  DocumentReferenceAttesterComponent,
  _recall,
  fastingStatus,
  seriesUid,
  SubstanceSourceMaterialPartDescriptionComponent,
  _geneElement,
  publicationDateText,
  EpisodeOfCareStatusHistoryComponent,
  evaluationMessage,
  division,
  windowEnd,
  _foodType,
  _repeats,
  _Observation,
  validateCode,
  parameterName,
  source: source3,
  currentState,
  publicationStatus,
  _license,
  _created,
  ClinicalUseDefinitionContraindicationOtherTherapyComponent,
  isModifier,
  _needsMap,
  performerType,
  unitPrice,
  _topic,
  _lastUpdated,
  preparedDate,
  accident,
  code,
  _designation,
  _creation,
  verificationType,
  DeviceDefinitionPackagingComponentPackagingUdiDeviceIdentifier,
  _containedInstance,
  PackagedProductDefinitionLegalStatusOfSupplyComponent,
  _recipient,
  ifMatch,
  partNumber,
  _severity,
  _filterBy,
  _NutritionIntake,
  BundleEntrySearchComponent,
  _responseCode,
  _eventHistory,
  _rejectionCriterion,
  notPerformedReason,
  _entryType,
  EncounterHistory,
  _specialPrecautionsForStorage,
  SearchParameter,
  gender,
  coding,
  ProductShelfLife,
  system,
  _tissue,
  associatedParty,
  statistic,
  DataRequirement,
  MedicationKnowledgeRegulatoryMaxDispenseComponent,
  udiCarrier,
  Availability,
  sender,
  _strand,
  IngredientSubstanceStrengthComponent,
  MedicationKnowledgeMonitoringProgramComponent,
  _derivation,
  Condition,
  AdministrableProductDefinitionRouteOfAdministrationTargetSpeciesWithdrawalPeriodComponent,
  diagnostics,
  assessment,
  _clockFacePosition,
  attestation,
  identified
});

// ../node_modules/rdf-namespaces/dist/foaf-85ab4e00.js
var Agent2 = "http://xmlns.com/foaf/0.1/Agent";
var Document2 = "http://xmlns.com/foaf/0.1/Document";
var Group3 = "http://xmlns.com/foaf/0.1/Group";
var Image2 = "http://xmlns.com/foaf/0.1/Image";
var LabelProperty = "http://xmlns.com/foaf/0.1/LabelProperty";
var OnlineAccount = "http://xmlns.com/foaf/0.1/OnlineAccount";
var OnlineChatAccount = "http://xmlns.com/foaf/0.1/OnlineChatAccount";
var OnlineEcommerceAccount = "http://xmlns.com/foaf/0.1/OnlineEcommerceAccount";
var OnlineGamingAccount = "http://xmlns.com/foaf/0.1/OnlineGamingAccount";
var Organization3 = "http://xmlns.com/foaf/0.1/Organization";
var Person3 = "http://xmlns.com/foaf/0.1/Person";
var PersonalProfileDocument = "http://xmlns.com/foaf/0.1/PersonalProfileDocument";
var Project = "http://xmlns.com/foaf/0.1/Project";
var account2 = "http://xmlns.com/foaf/0.1/account";
var accountName = "http://xmlns.com/foaf/0.1/accountName";
var accountServiceHomepage = "http://xmlns.com/foaf/0.1/accountServiceHomepage";
var age2 = "http://xmlns.com/foaf/0.1/age";
var aimChatID = "http://xmlns.com/foaf/0.1/aimChatID";
var based_near = "http://xmlns.com/foaf/0.1/based_near";
var birthday2 = "http://xmlns.com/foaf/0.1/birthday";
var currentProject = "http://xmlns.com/foaf/0.1/currentProject";
var depiction = "http://xmlns.com/foaf/0.1/depiction";
var depicts = "http://xmlns.com/foaf/0.1/depicts";
var dnaChecksum = "http://xmlns.com/foaf/0.1/dnaChecksum";
var familyName = "http://xmlns.com/foaf/0.1/familyName";
var family_name = "http://xmlns.com/foaf/0.1/family_name";
var firstName = "http://xmlns.com/foaf/0.1/firstName";
var focus2 = "http://xmlns.com/foaf/0.1/focus";
var fundedBy = "http://xmlns.com/foaf/0.1/fundedBy";
var geekcode = "http://xmlns.com/foaf/0.1/geekcode";
var gender2 = "http://xmlns.com/foaf/0.1/gender";
var givenName = "http://xmlns.com/foaf/0.1/givenName";
var givenname = "http://xmlns.com/foaf/0.1/givenname";
var holdsAccount = "http://xmlns.com/foaf/0.1/holdsAccount";
var homepage = "http://xmlns.com/foaf/0.1/homepage";
var icqChatID = "http://xmlns.com/foaf/0.1/icqChatID";
var img = "http://xmlns.com/foaf/0.1/img";
var interest = "http://xmlns.com/foaf/0.1/interest";
var isPrimaryTopicOf = "http://xmlns.com/foaf/0.1/isPrimaryTopicOf";
var jabberID = "http://xmlns.com/foaf/0.1/jabberID";
var knows = "http://xmlns.com/foaf/0.1/knows";
var lastName = "http://xmlns.com/foaf/0.1/lastName";
var logo = "http://xmlns.com/foaf/0.1/logo";
var made = "http://xmlns.com/foaf/0.1/made";
var maker = "http://xmlns.com/foaf/0.1/maker";
var mbox = "http://xmlns.com/foaf/0.1/mbox";
var mbox_sha1sum = "http://xmlns.com/foaf/0.1/mbox_sha1sum";
var member2 = "http://xmlns.com/foaf/0.1/member";
var membershipClass = "http://xmlns.com/foaf/0.1/membershipClass";
var msnChatID = "http://xmlns.com/foaf/0.1/msnChatID";
var myersBriggs = "http://xmlns.com/foaf/0.1/myersBriggs";
var name3 = "http://xmlns.com/foaf/0.1/name";
var nick = "http://xmlns.com/foaf/0.1/nick";
var openid = "http://xmlns.com/foaf/0.1/openid";
var page2 = "http://xmlns.com/foaf/0.1/page";
var pastProject = "http://xmlns.com/foaf/0.1/pastProject";
var phone2 = "http://xmlns.com/foaf/0.1/phone";
var plan2 = "http://xmlns.com/foaf/0.1/plan";
var primaryTopic = "http://xmlns.com/foaf/0.1/primaryTopic";
var publications = "http://xmlns.com/foaf/0.1/publications";
var schoolHomepage = "http://xmlns.com/foaf/0.1/schoolHomepage";
var sha1 = "http://xmlns.com/foaf/0.1/sha1";
var skypeID = "http://xmlns.com/foaf/0.1/skypeID";
var status3 = "http://xmlns.com/foaf/0.1/status";
var surname = "http://xmlns.com/foaf/0.1/surname";
var theme = "http://xmlns.com/foaf/0.1/theme";
var thumbnail = "http://xmlns.com/foaf/0.1/thumbnail";
var tipjar = "http://xmlns.com/foaf/0.1/tipjar";
var title4 = "http://xmlns.com/foaf/0.1/title";
var topic2 = "http://xmlns.com/foaf/0.1/topic";
var topic_interest = "http://xmlns.com/foaf/0.1/topic_interest";
var weblog = "http://xmlns.com/foaf/0.1/weblog";
var workInfoHomepage = "http://xmlns.com/foaf/0.1/workInfoHomepage";
var workplaceHomepage = "http://xmlns.com/foaf/0.1/workplaceHomepage";
var yahooChatID = "http://xmlns.com/foaf/0.1/yahooChatID";
var foafImport = /* @__PURE__ */ Object.freeze({
  Agent: Agent2,
  Document: Document2,
  Group: Group3,
  Image: Image2,
  LabelProperty,
  OnlineAccount,
  OnlineChatAccount,
  OnlineEcommerceAccount,
  OnlineGamingAccount,
  Organization: Organization3,
  Person: Person3,
  PersonalProfileDocument,
  Project,
  account: account2,
  accountName,
  accountServiceHomepage,
  age: age2,
  aimChatID,
  based_near,
  birthday: birthday2,
  currentProject,
  depiction,
  depicts,
  dnaChecksum,
  familyName,
  family_name,
  firstName,
  focus: focus2,
  fundedBy,
  geekcode,
  gender: gender2,
  givenName,
  givenname,
  holdsAccount,
  homepage,
  icqChatID,
  img,
  interest,
  isPrimaryTopicOf,
  jabberID,
  knows,
  lastName,
  logo,
  made,
  maker,
  mbox,
  mbox_sha1sum,
  member: member2,
  membershipClass,
  msnChatID,
  myersBriggs,
  name: name3,
  nick,
  openid,
  page: page2,
  pastProject,
  phone: phone2,
  plan: plan2,
  primaryTopic,
  publications,
  schoolHomepage,
  sha1,
  skypeID,
  status: status3,
  surname,
  theme,
  thumbnail,
  tipjar,
  title: title4,
  topic: topic2,
  topic_interest,
  weblog,
  workInfoHomepage,
  workplaceHomepage,
  yahooChatID
});

// ../node_modules/rdf-namespaces/dist/http-8179cb74.js
var Message = "http://www.w3.org/2007/ont/http#Message";
var RequestMessage = "http://www.w3.org/2007/ont/http#RequestMessage";
var ResponseMessage = "http://www.w3.org/2007/ont/http#ResponseMessage";
var method3 = "http://www.w3.org/2007/ont/http#method";
var requestURI = "http://www.w3.org/2007/ont/http#requestURI";
var version3 = "http://www.w3.org/2007/ont/http#version";
var status4 = "http://www.w3.org/2007/ont/http#status";
var httpImport = /* @__PURE__ */ Object.freeze({
  Message,
  RequestMessage,
  ResponseMessage,
  method: method3,
  requestURI,
  version: version3,
  status: status4
});

// ../node_modules/rdf-namespaces/dist/hydra-75d979cd.js
var ApiDocumentation = "http://www.w3.org/ns/hydra/core#ApiDocumentation";
var BaseUriSource = "http://www.w3.org/ns/hydra/core#BaseUriSource";
var BasicRepresentation = "http://www.w3.org/ns/hydra/core#BasicRepresentation";
var Class2 = "http://www.w3.org/ns/hydra/core#Class";
var Collection3 = "http://www.w3.org/ns/hydra/core#Collection";
var Error__workaround2 = "http://www.w3.org/ns/hydra/core#Error";
var ExplicitRepresentation = "http://www.w3.org/ns/hydra/core#ExplicitRepresentation";
var HeaderSpecification = "http://www.w3.org/ns/hydra/core#HeaderSpecification";
var IriTemplate = "http://www.w3.org/ns/hydra/core#IriTemplate";
var IriTemplateMapping = "http://www.w3.org/ns/hydra/core#IriTemplateMapping";
var Link2 = "http://www.w3.org/ns/hydra/core#Link";
var Operation = "http://www.w3.org/ns/hydra/core#Operation";
var PartialCollectionView = "http://www.w3.org/ns/hydra/core#PartialCollectionView";
var Resource2 = "http://www.w3.org/ns/hydra/core#Resource";
var Rfc6570Template = "http://www.w3.org/ns/hydra/core#Rfc6570Template";
var Status = "http://www.w3.org/ns/hydra/core#Status";
var SupportedProperty = "http://www.w3.org/ns/hydra/core#SupportedProperty";
var TemplatedLink = "http://www.w3.org/ns/hydra/core#TemplatedLink";
var VariableRepresentation = "http://www.w3.org/ns/hydra/core#VariableRepresentation";
var apiDocumentation = "http://www.w3.org/ns/hydra/core#apiDocumentation";
var closedSet = "http://www.w3.org/ns/hydra/core#closedSet";
var collection2 = "http://www.w3.org/ns/hydra/core#collection";
var description6 = "http://www.w3.org/ns/hydra/core#description";
var entrypoint = "http://www.w3.org/ns/hydra/core#entrypoint";
var expects = "http://www.w3.org/ns/hydra/core#expects";
var expectsHeader = "http://www.w3.org/ns/hydra/core#expectsHeader";
var extension2 = "http://www.w3.org/ns/hydra/core#extension";
var first2 = "http://www.w3.org/ns/hydra/core#first";
var freetextQuery = "http://www.w3.org/ns/hydra/core#freetextQuery";
var headerName = "http://www.w3.org/ns/hydra/core#headerName";
var last3 = "http://www.w3.org/ns/hydra/core#last";
var limit2 = "http://www.w3.org/ns/hydra/core#limit";
var mapping2 = "http://www.w3.org/ns/hydra/core#mapping";
var member3 = "http://www.w3.org/ns/hydra/core#member";
var method4 = "http://www.w3.org/ns/hydra/core#method";
var next3 = "http://www.w3.org/ns/hydra/core#next";
var offset2 = "http://www.w3.org/ns/hydra/core#offset";
var operation2 = "http://www.w3.org/ns/hydra/core#operation";
var pageIndex = "http://www.w3.org/ns/hydra/core#pageIndex";
var pageReference = "http://www.w3.org/ns/hydra/core#pageReference";
var possibleStatus = "http://www.w3.org/ns/hydra/core#possibleStatus";
var possibleValue = "http://www.w3.org/ns/hydra/core#possibleValue";
var previous2 = "http://www.w3.org/ns/hydra/core#previous";
var property2 = "http://www.w3.org/ns/hydra/core#property";
var readable = "http://www.w3.org/ns/hydra/core#readable";
var required2 = "http://www.w3.org/ns/hydra/core#required";
var resolveRelativeUsing = "http://www.w3.org/ns/hydra/core#resolveRelativeUsing";
var returns = "http://www.w3.org/ns/hydra/core#returns";
var returnsHeader = "http://www.w3.org/ns/hydra/core#returnsHeader";
var search2 = "http://www.w3.org/ns/hydra/core#search";
var statusCode = "http://www.w3.org/ns/hydra/core#statusCode";
var supportedClass = "http://www.w3.org/ns/hydra/core#supportedClass";
var supportedOperation = "http://www.w3.org/ns/hydra/core#supportedOperation";
var supportedProperty = "http://www.w3.org/ns/hydra/core#supportedProperty";
var template2 = "http://www.w3.org/ns/hydra/core#template";
var title5 = "http://www.w3.org/ns/hydra/core#title";
var totalItems2 = "http://www.w3.org/ns/hydra/core#totalItems";
var variable4 = "http://www.w3.org/ns/hydra/core#variable";
var variableRepresentation = "http://www.w3.org/ns/hydra/core#variableRepresentation";
var view = "http://www.w3.org/ns/hydra/core#view";
var writable = "http://www.w3.org/ns/hydra/core#writable";
var hydraImport = /* @__PURE__ */ Object.freeze({
  ApiDocumentation,
  BaseUriSource,
  BasicRepresentation,
  Class: Class2,
  Collection: Collection3,
  Error__workaround: Error__workaround2,
  ExplicitRepresentation,
  HeaderSpecification,
  IriTemplate,
  IriTemplateMapping,
  Link: Link2,
  Operation,
  PartialCollectionView,
  Resource: Resource2,
  Rfc6570Template,
  Status,
  SupportedProperty,
  TemplatedLink,
  VariableRepresentation,
  apiDocumentation,
  closedSet,
  collection: collection2,
  description: description6,
  entrypoint,
  expects,
  expectsHeader,
  extension: extension2,
  first: first2,
  freetextQuery,
  headerName,
  last: last3,
  limit: limit2,
  mapping: mapping2,
  member: member3,
  method: method4,
  next: next3,
  offset: offset2,
  operation: operation2,
  pageIndex,
  pageReference,
  possibleStatus,
  possibleValue,
  previous: previous2,
  property: property2,
  readable,
  required: required2,
  resolveRelativeUsing,
  returns,
  returnsHeader,
  search: search2,
  statusCode,
  supportedClass,
  supportedOperation,
  supportedProperty,
  template: template2,
  title: title5,
  totalItems: totalItems2,
  variable: variable4,
  variableRepresentation,
  view,
  writable
});

// ../node_modules/rdf-namespaces/dist/ldp-efa6e4d0.js
var Resource3 = "http://www.w3.org/ns/ldp#Resource";
var RDFSource = "http://www.w3.org/ns/ldp#RDFSource";
var NonRDFSource = "http://www.w3.org/ns/ldp#NonRDFSource";
var Container = "http://www.w3.org/ns/ldp#Container";
var BasicContainer = "http://www.w3.org/ns/ldp#BasicContainer";
var DirectContainer = "http://www.w3.org/ns/ldp#DirectContainer";
var IndirectContainer = "http://www.w3.org/ns/ldp#IndirectContainer";
var hasMemberRelation = "http://www.w3.org/ns/ldp#hasMemberRelation";
var isMemberOfRelation = "http://www.w3.org/ns/ldp#isMemberOfRelation";
var membershipResource = "http://www.w3.org/ns/ldp#membershipResource";
var insertedContentRelation = "http://www.w3.org/ns/ldp#insertedContentRelation";
var member4 = "http://www.w3.org/ns/ldp#member";
var contains2 = "http://www.w3.org/ns/ldp#contains";
var constrainedBy = "http://www.w3.org/ns/ldp#constrainedBy";
var pageSortCriteria = "http://www.w3.org/ns/ldp#pageSortCriteria";
var PageSortCriterion = "http://www.w3.org/ns/ldp#PageSortCriterion";
var pageSortPredicate = "http://www.w3.org/ns/ldp#pageSortPredicate";
var pageSortOrder = "http://www.w3.org/ns/ldp#pageSortOrder";
var pageSortCollation = "http://www.w3.org/ns/ldp#pageSortCollation";
var Page2 = "http://www.w3.org/ns/ldp#Page";
var pageSequence = "http://www.w3.org/ns/ldp#pageSequence";
var inbox = "http://www.w3.org/ns/ldp#inbox";
var ldpImport = /* @__PURE__ */ Object.freeze({
  Resource: Resource3,
  RDFSource,
  NonRDFSource,
  Container,
  BasicContainer,
  DirectContainer,
  IndirectContainer,
  hasMemberRelation,
  isMemberOfRelation,
  membershipResource,
  insertedContentRelation,
  member: member4,
  contains: contains2,
  constrainedBy,
  pageSortCriteria,
  PageSortCriterion,
  pageSortPredicate,
  pageSortOrder,
  pageSortCollation,
  Page: Page2,
  pageSequence,
  inbox
});

// ../node_modules/rdf-namespaces/dist/link-1a99e693.js
var Access2 = "http://www.w3.org/2007/ont/link#Access";
var Document3 = "http://www.w3.org/2007/ont/link#Document";
var Mailbox = "http://www.w3.org/2007/ont/link#Mailbox";
var ProtocolEvent = "http://www.w3.org/2007/ont/link#ProtocolEvent";
var RDFDocument = "http://www.w3.org/2007/ont/link#RDFDocument";
var Response2 = "http://www.w3.org/2007/ont/link#Response";
var Session = "http://www.w3.org/2007/ont/link#Session";
var isMentionedIn = "http://www.w3.org/2007/ont/link#isMentionedIn";
var mentionsClass = "http://www.w3.org/2007/ont/link#mentionsClass";
var protocol3 = "http://www.w3.org/2007/ont/link#protocol";
var redirectedRequest = "http://www.w3.org/2007/ont/link#redirectedRequest";
var requestedBy = "http://www.w3.org/2007/ont/link#requestedBy";
var requestedURI = "http://www.w3.org/2007/ont/link#requestedURI";
var response2 = "http://www.w3.org/2007/ont/link#response";
var session = "http://www.w3.org/2007/ont/link#session";
var source4 = "http://www.w3.org/2007/ont/link#source";
var status5 = "http://www.w3.org/2007/ont/link#status";
var testDataset = "http://www.w3.org/2007/ont/link#testDataset";
var uri2 = "http://www.w3.org/2007/ont/link#uri";
var linkImport = /* @__PURE__ */ Object.freeze({
  Access: Access2,
  Document: Document3,
  Mailbox,
  ProtocolEvent,
  RDFDocument,
  Response: Response2,
  Session,
  isMentionedIn,
  mentionsClass,
  protocol: protocol3,
  redirectedRequest,
  requestedBy,
  requestedURI,
  response: response2,
  session,
  source: source4,
  status: status5,
  testDataset,
  uri: uri2
});

// ../node_modules/rdf-namespaces/dist/log-1430a6f1.js
var Chaff = "http://www.w3.org/2000/10/swap/log#Chaff";
var Formula2 = "http://www.w3.org/2000/10/swap/log#Formula";
var List2 = "http://www.w3.org/2000/10/swap/log#List";
var N3Document = "http://www.w3.org/2000/10/swap/log#N3Document";
var Other = "http://www.w3.org/2000/10/swap/log#Other";
var String__workaround = "http://www.w3.org/2000/10/swap/log#String";
var Truth = "http://www.w3.org/2000/10/swap/log#Truth";
var conclusion2 = "http://www.w3.org/2000/10/swap/log#conclusion";
var conjunction = "http://www.w3.org/2000/10/swap/log#conjunction";
var content3 = "http://www.w3.org/2000/10/swap/log#content";
var definitiveDocument = "http://www.w3.org/2000/10/swap/log#definitiveDocument";
var definitiveService = "http://www.w3.org/2000/10/swap/log#definitiveService";
var dtlit = "http://www.w3.org/2000/10/swap/log#dtlit";
var equalTo = "http://www.w3.org/2000/10/swap/log#equalTo";
var implies = "http://www.w3.org/2000/10/swap/log#implies";
var includes = "http://www.w3.org/2000/10/swap/log#includes";
var n3String = "http://www.w3.org/2000/10/swap/log#n3String";
var notEqualTo = "http://www.w3.org/2000/10/swap/log#notEqualTo";
var notIncludes = "http://www.w3.org/2000/10/swap/log#notIncludes";
var outputString = "http://www.w3.org/2000/10/swap/log#outputString";
var parsedAsN3 = "http://www.w3.org/2000/10/swap/log#parsedAsN3";
var racine = "http://www.w3.org/2000/10/swap/log#racine";
var rawType = "http://www.w3.org/2000/10/swap/log#rawType";
var rawUri = "http://www.w3.org/2000/10/swap/log#rawUri";
var semantics = "http://www.w3.org/2000/10/swap/log#semantics";
var semanticsOrError = "http://www.w3.org/2000/10/swap/log#semanticsOrError";
var uri3 = "http://www.w3.org/2000/10/swap/log#uri";
var logImport = /* @__PURE__ */ Object.freeze({
  Chaff,
  Formula: Formula2,
  List: List2,
  N3Document,
  Other,
  String__workaround,
  Truth,
  conclusion: conclusion2,
  conjunction,
  content: content3,
  definitiveDocument,
  definitiveService,
  dtlit,
  equalTo,
  implies,
  includes,
  n3String,
  notEqualTo,
  notIncludes,
  outputString,
  parsedAsN3,
  racine,
  rawType,
  rawUri,
  semantics,
  semanticsOrError,
  uri: uri3
});

// ../node_modules/rdf-namespaces/dist/meeting-3b6d6467.js
var Meeting = "http://www.w3.org/ns/pim/meeting#Meeting";
var VideoCallPage = "http://www.w3.org/ns/pim/meeting#VideoCallPage";
var actionItems = "http://www.w3.org/ns/pim/meeting#actionItems";
var agenda = "http://www.w3.org/ns/pim/meeting#agenda";
var attendeeGroup = "http://www.w3.org/ns/pim/meeting#attendeeGroup";
var chat = "http://www.w3.org/ns/pim/meeting#chat";
var nextMeeting = "http://www.w3.org/ns/pim/meeting#nextMeeting";
var previousMeeting = "http://www.w3.org/ns/pim/meeting#previousMeeting";
var sharedNotes = "http://www.w3.org/ns/pim/meeting#sharedNotes";
var toolList = "http://www.w3.org/ns/pim/meeting#toolList";
var trip = "http://www.w3.org/ns/pim/meeting#trip";
var videoCallPage = "http://www.w3.org/ns/pim/meeting#videoCallPage";
var meetingImport = /* @__PURE__ */ Object.freeze({
  Meeting,
  VideoCallPage,
  actionItems,
  agenda,
  attendeeGroup,
  chat,
  nextMeeting,
  previousMeeting,
  sharedNotes,
  toolList,
  trip,
  videoCallPage
});

// ../node_modules/rdf-namespaces/dist/owl-cfadfdf5.js
var AllDifferent = "http://www.w3.org/2002/07/owl#AllDifferent";
var AllDisjointClasses = "http://www.w3.org/2002/07/owl#AllDisjointClasses";
var AllDisjointProperties = "http://www.w3.org/2002/07/owl#AllDisjointProperties";
var Annotation2 = "http://www.w3.org/2002/07/owl#Annotation";
var AnnotationProperty = "http://www.w3.org/2002/07/owl#AnnotationProperty";
var AsymmetricProperty = "http://www.w3.org/2002/07/owl#AsymmetricProperty";
var Axiom = "http://www.w3.org/2002/07/owl#Axiom";
var Class3 = "http://www.w3.org/2002/07/owl#Class";
var DataRange = "http://www.w3.org/2002/07/owl#DataRange";
var DatatypeProperty = "http://www.w3.org/2002/07/owl#DatatypeProperty";
var DeprecatedClass = "http://www.w3.org/2002/07/owl#DeprecatedClass";
var DeprecatedProperty = "http://www.w3.org/2002/07/owl#DeprecatedProperty";
var FunctionalProperty = "http://www.w3.org/2002/07/owl#FunctionalProperty";
var InverseFunctionalProperty = "http://www.w3.org/2002/07/owl#InverseFunctionalProperty";
var IrreflexiveProperty = "http://www.w3.org/2002/07/owl#IrreflexiveProperty";
var NamedIndividual = "http://www.w3.org/2002/07/owl#NamedIndividual";
var NegativePropertyAssertion = "http://www.w3.org/2002/07/owl#NegativePropertyAssertion";
var Nothing = "http://www.w3.org/2002/07/owl#Nothing";
var ObjectProperty = "http://www.w3.org/2002/07/owl#ObjectProperty";
var Ontology = "http://www.w3.org/2002/07/owl#Ontology";
var OntologyProperty = "http://www.w3.org/2002/07/owl#OntologyProperty";
var ReflexiveProperty = "http://www.w3.org/2002/07/owl#ReflexiveProperty";
var Restriction = "http://www.w3.org/2002/07/owl#Restriction";
var SymmetricProperty = "http://www.w3.org/2002/07/owl#SymmetricProperty";
var TransitiveProperty = "http://www.w3.org/2002/07/owl#TransitiveProperty";
var Thing2 = "http://www.w3.org/2002/07/owl#Thing";
var allValuesFrom = "http://www.w3.org/2002/07/owl#allValuesFrom";
var annotatedProperty = "http://www.w3.org/2002/07/owl#annotatedProperty";
var annotatedSource = "http://www.w3.org/2002/07/owl#annotatedSource";
var annotatedTarget = "http://www.w3.org/2002/07/owl#annotatedTarget";
var assertionProperty = "http://www.w3.org/2002/07/owl#assertionProperty";
var backwardCompatibleWith = "http://www.w3.org/2002/07/owl#backwardCompatibleWith";
var bottomDataProperty = "http://www.w3.org/2002/07/owl#bottomDataProperty";
var bottomObjectProperty = "http://www.w3.org/2002/07/owl#bottomObjectProperty";
var cardinality = "http://www.w3.org/2002/07/owl#cardinality";
var complementOf = "http://www.w3.org/2002/07/owl#complementOf";
var datatypeComplementOf = "http://www.w3.org/2002/07/owl#datatypeComplementOf";
var deprecated = "http://www.w3.org/2002/07/owl#deprecated";
var differentFrom = "http://www.w3.org/2002/07/owl#differentFrom";
var disjointUnionOf = "http://www.w3.org/2002/07/owl#disjointUnionOf";
var disjointWith = "http://www.w3.org/2002/07/owl#disjointWith";
var distinctMembers = "http://www.w3.org/2002/07/owl#distinctMembers";
var equivalentClass = "http://www.w3.org/2002/07/owl#equivalentClass";
var equivalentProperty = "http://www.w3.org/2002/07/owl#equivalentProperty";
var hasKey = "http://www.w3.org/2002/07/owl#hasKey";
var hasSelf = "http://www.w3.org/2002/07/owl#hasSelf";
var hasValue = "http://www.w3.org/2002/07/owl#hasValue";
var incompatibleWith = "http://www.w3.org/2002/07/owl#incompatibleWith";
var intersectionOf = "http://www.w3.org/2002/07/owl#intersectionOf";
var inverseOf = "http://www.w3.org/2002/07/owl#inverseOf";
var maxCardinality = "http://www.w3.org/2002/07/owl#maxCardinality";
var maxQualifiedCardinality = "http://www.w3.org/2002/07/owl#maxQualifiedCardinality";
var members = "http://www.w3.org/2002/07/owl#members";
var minCardinality = "http://www.w3.org/2002/07/owl#minCardinality";
var minQualifiedCardinality = "http://www.w3.org/2002/07/owl#minQualifiedCardinality";
var onClass = "http://www.w3.org/2002/07/owl#onClass";
var onDataRange = "http://www.w3.org/2002/07/owl#onDataRange";
var onDatatype = "http://www.w3.org/2002/07/owl#onDatatype";
var oneOf2 = "http://www.w3.org/2002/07/owl#oneOf";
var onProperties = "http://www.w3.org/2002/07/owl#onProperties";
var onProperty = "http://www.w3.org/2002/07/owl#onProperty";
var priorVersion = "http://www.w3.org/2002/07/owl#priorVersion";
var propertyChainAxiom = "http://www.w3.org/2002/07/owl#propertyChainAxiom";
var propertyDisjointWith = "http://www.w3.org/2002/07/owl#propertyDisjointWith";
var qualifiedCardinality = "http://www.w3.org/2002/07/owl#qualifiedCardinality";
var sameAs = "http://www.w3.org/2002/07/owl#sameAs";
var someValuesFrom = "http://www.w3.org/2002/07/owl#someValuesFrom";
var sourceIndividual = "http://www.w3.org/2002/07/owl#sourceIndividual";
var targetIndividual = "http://www.w3.org/2002/07/owl#targetIndividual";
var targetValue = "http://www.w3.org/2002/07/owl#targetValue";
var topDataProperty = "http://www.w3.org/2002/07/owl#topDataProperty";
var topObjectProperty = "http://www.w3.org/2002/07/owl#topObjectProperty";
var unionOf = "http://www.w3.org/2002/07/owl#unionOf";
var versionInfo = "http://www.w3.org/2002/07/owl#versionInfo";
var withRestrictions = "http://www.w3.org/2002/07/owl#withRestrictions";
var owlImport = /* @__PURE__ */ Object.freeze({
  AllDifferent,
  AllDisjointClasses,
  AllDisjointProperties,
  Annotation: Annotation2,
  AnnotationProperty,
  AsymmetricProperty,
  Axiom,
  Class: Class3,
  DataRange,
  DatatypeProperty,
  DeprecatedClass,
  DeprecatedProperty,
  FunctionalProperty,
  InverseFunctionalProperty,
  IrreflexiveProperty,
  NamedIndividual,
  NegativePropertyAssertion,
  Nothing,
  ObjectProperty,
  Ontology,
  OntologyProperty,
  ReflexiveProperty,
  Restriction,
  SymmetricProperty,
  TransitiveProperty,
  Thing: Thing2,
  allValuesFrom,
  annotatedProperty,
  annotatedSource,
  annotatedTarget,
  assertionProperty,
  backwardCompatibleWith,
  bottomDataProperty,
  bottomObjectProperty,
  cardinality,
  complementOf,
  datatypeComplementOf,
  deprecated,
  differentFrom,
  disjointUnionOf,
  disjointWith,
  distinctMembers,
  equivalentClass,
  equivalentProperty,
  hasKey,
  hasSelf,
  hasValue,
  incompatibleWith,
  intersectionOf,
  inverseOf,
  maxCardinality,
  maxQualifiedCardinality,
  members,
  minCardinality,
  minQualifiedCardinality,
  onClass,
  onDataRange,
  onDatatype,
  oneOf: oneOf2,
  onProperties,
  onProperty,
  priorVersion,
  propertyChainAxiom,
  propertyDisjointWith,
  qualifiedCardinality,
  sameAs,
  someValuesFrom,
  sourceIndividual,
  targetIndividual,
  targetValue,
  topDataProperty,
  topObjectProperty,
  unionOf,
  versionInfo,
  withRestrictions
});

// ../node_modules/rdf-namespaces/dist/prov-f41b5eb6.js
var Activity2 = "http://www.w3.org/ns/prov#Activity";
var ActivityInfluence = "http://www.w3.org/ns/prov#ActivityInfluence";
var Agent3 = "http://www.w3.org/ns/prov#Agent";
var AgentInfluence = "http://www.w3.org/ns/prov#AgentInfluence";
var Association = "http://www.w3.org/ns/prov#Association";
var Attribution = "http://www.w3.org/ns/prov#Attribution";
var Bundle2 = "http://www.w3.org/ns/prov#Bundle";
var Collection4 = "http://www.w3.org/ns/prov#Collection";
var Communication2 = "http://www.w3.org/ns/prov#Communication";
var Delegation = "http://www.w3.org/ns/prov#Delegation";
var Derivation = "http://www.w3.org/ns/prov#Derivation";
var EmptyCollection = "http://www.w3.org/ns/prov#EmptyCollection";
var End = "http://www.w3.org/ns/prov#End";
var Entity = "http://www.w3.org/ns/prov#Entity";
var EntityInfluence = "http://www.w3.org/ns/prov#EntityInfluence";
var Generation = "http://www.w3.org/ns/prov#Generation";
var Influence = "http://www.w3.org/ns/prov#Influence";
var InstantaneousEvent = "http://www.w3.org/ns/prov#InstantaneousEvent";
var Invalidation = "http://www.w3.org/ns/prov#Invalidation";
var Location3 = "http://www.w3.org/ns/prov#Location";
var Organization4 = "http://www.w3.org/ns/prov#Organization";
var Person4 = "http://www.w3.org/ns/prov#Person";
var Plan = "http://www.w3.org/ns/prov#Plan";
var PrimarySource = "http://www.w3.org/ns/prov#PrimarySource";
var Quotation = "http://www.w3.org/ns/prov#Quotation";
var Revision = "http://www.w3.org/ns/prov#Revision";
var Role = "http://www.w3.org/ns/prov#Role";
var SoftwareAgent = "http://www.w3.org/ns/prov#SoftwareAgent";
var Start = "http://www.w3.org/ns/prov#Start";
var Usage = "http://www.w3.org/ns/prov#Usage";
var actedOnBehalfOf = "http://www.w3.org/ns/prov#actedOnBehalfOf";
var activity2 = "http://www.w3.org/ns/prov#activity";
var agent3 = "http://www.w3.org/ns/prov#agent";
var alternateOf = "http://www.w3.org/ns/prov#alternateOf";
var aq = "http://www.w3.org/ns/prov#aq";
var atLocation = "http://www.w3.org/ns/prov#atLocation";
var atTime = "http://www.w3.org/ns/prov#atTime";
var category2 = "http://www.w3.org/ns/prov#category";
var component2 = "http://www.w3.org/ns/prov#component";
var constraints = "http://www.w3.org/ns/prov#constraints";
var definition2 = "http://www.w3.org/ns/prov#definition";
var dm = "http://www.w3.org/ns/prov#dm";
var editorialNote = "http://www.w3.org/ns/prov#editorialNote";
var editorsDefinition = "http://www.w3.org/ns/prov#editorsDefinition";
var endedAtTime = "http://www.w3.org/ns/prov#endedAtTime";
var entity2 = "http://www.w3.org/ns/prov#entity";
var generated = "http://www.w3.org/ns/prov#generated";
var generatedAtTime = "http://www.w3.org/ns/prov#generatedAtTime";
var hadActivity = "http://www.w3.org/ns/prov#hadActivity";
var hadGeneration = "http://www.w3.org/ns/prov#hadGeneration";
var hadMember = "http://www.w3.org/ns/prov#hadMember";
var hadPlan = "http://www.w3.org/ns/prov#hadPlan";
var hadPrimarySource = "http://www.w3.org/ns/prov#hadPrimarySource";
var hadRole = "http://www.w3.org/ns/prov#hadRole";
var hadUsage = "http://www.w3.org/ns/prov#hadUsage";
var influenced = "http://www.w3.org/ns/prov#influenced";
var influencer = "http://www.w3.org/ns/prov#influencer";
var invalidated = "http://www.w3.org/ns/prov#invalidated";
var invalidatedAtTime = "http://www.w3.org/ns/prov#invalidatedAtTime";
var inverse = "http://www.w3.org/ns/prov#inverse";
var n = "http://www.w3.org/ns/prov#n";
var order2 = "http://www.w3.org/ns/prov#order";
var qualifiedAssociation = "http://www.w3.org/ns/prov#qualifiedAssociation";
var qualifiedAttribution = "http://www.w3.org/ns/prov#qualifiedAttribution";
var qualifiedCommunication = "http://www.w3.org/ns/prov#qualifiedCommunication";
var qualifiedDelegation = "http://www.w3.org/ns/prov#qualifiedDelegation";
var qualifiedDerivation = "http://www.w3.org/ns/prov#qualifiedDerivation";
var qualifiedEnd = "http://www.w3.org/ns/prov#qualifiedEnd";
var qualifiedForm = "http://www.w3.org/ns/prov#qualifiedForm";
var qualifiedGeneration = "http://www.w3.org/ns/prov#qualifiedGeneration";
var qualifiedInfluence = "http://www.w3.org/ns/prov#qualifiedInfluence";
var qualifiedInvalidation = "http://www.w3.org/ns/prov#qualifiedInvalidation";
var qualifiedPrimarySource = "http://www.w3.org/ns/prov#qualifiedPrimarySource";
var qualifiedQuotation = "http://www.w3.org/ns/prov#qualifiedQuotation";
var qualifiedRevision = "http://www.w3.org/ns/prov#qualifiedRevision";
var qualifiedStart = "http://www.w3.org/ns/prov#qualifiedStart";
var qualifiedUsage = "http://www.w3.org/ns/prov#qualifiedUsage";
var sharesDefinitionWith = "http://www.w3.org/ns/prov#sharesDefinitionWith";
var specializationOf = "http://www.w3.org/ns/prov#specializationOf";
var startedAtTime = "http://www.w3.org/ns/prov#startedAtTime";
var todo = "http://www.w3.org/ns/prov#todo";
var unqualifiedForm = "http://www.w3.org/ns/prov#unqualifiedForm";
var used2 = "http://www.w3.org/ns/prov#used";
var value2 = "http://www.w3.org/ns/prov#value";
var wasAssociatedWith = "http://www.w3.org/ns/prov#wasAssociatedWith";
var wasAttributedTo = "http://www.w3.org/ns/prov#wasAttributedTo";
var wasDerivedFrom = "http://www.w3.org/ns/prov#wasDerivedFrom";
var wasEndedBy = "http://www.w3.org/ns/prov#wasEndedBy";
var wasGeneratedBy = "http://www.w3.org/ns/prov#wasGeneratedBy";
var wasInfluencedBy = "http://www.w3.org/ns/prov#wasInfluencedBy";
var wasInformedBy = "http://www.w3.org/ns/prov#wasInformedBy";
var wasInvalidatedBy = "http://www.w3.org/ns/prov#wasInvalidatedBy";
var wasQuotedFrom = "http://www.w3.org/ns/prov#wasQuotedFrom";
var wasRevisionOf = "http://www.w3.org/ns/prov#wasRevisionOf";
var wasStartedBy = "http://www.w3.org/ns/prov#wasStartedBy";
var ServiceDescription = "http://www.w3.org/ns/prov#ServiceDescription";
var DirectQueryService = "http://www.w3.org/ns/prov#DirectQueryService";
var has_anchor = "http://www.w3.org/ns/prov#has_anchor";
var has_provenance = "http://www.w3.org/ns/prov#has_provenance";
var has_query_service = "http://www.w3.org/ns/prov#has_query_service";
var describesService = "http://www.w3.org/ns/prov#describesService";
var provenanceUriTemplate = "http://www.w3.org/ns/prov#provenanceUriTemplate";
var pingback = "http://www.w3.org/ns/prov#pingback";
var Accept2 = "http://www.w3.org/ns/prov#Accept";
var Contribute = "http://www.w3.org/ns/prov#Contribute";
var Contributor2 = "http://www.w3.org/ns/prov#Contributor";
var Copyright = "http://www.w3.org/ns/prov#Copyright";
var Create2 = "http://www.w3.org/ns/prov#Create";
var Creator = "http://www.w3.org/ns/prov#Creator";
var Modify = "http://www.w3.org/ns/prov#Modify";
var Publish = "http://www.w3.org/ns/prov#Publish";
var Publisher = "http://www.w3.org/ns/prov#Publisher";
var Replace = "http://www.w3.org/ns/prov#Replace";
var RightsAssignment = "http://www.w3.org/ns/prov#RightsAssignment";
var RightsHolder = "http://www.w3.org/ns/prov#RightsHolder";
var Submit = "http://www.w3.org/ns/prov#Submit";
var Dictionary = "http://www.w3.org/ns/prov#Dictionary";
var EmptyDictionary = "http://www.w3.org/ns/prov#EmptyDictionary";
var KeyEntityPair = "http://www.w3.org/ns/prov#KeyEntityPair";
var Insertion = "http://www.w3.org/ns/prov#Insertion";
var Removal = "http://www.w3.org/ns/prov#Removal";
var dictionary = "http://www.w3.org/ns/prov#dictionary";
var derivedByInsertionFrom = "http://www.w3.org/ns/prov#derivedByInsertionFrom";
var derivedByRemovalFrom = "http://www.w3.org/ns/prov#derivedByRemovalFrom";
var insertedKeyEntityPair = "http://www.w3.org/ns/prov#insertedKeyEntityPair";
var hadDictionaryMember = "http://www.w3.org/ns/prov#hadDictionaryMember";
var pairKey = "http://www.w3.org/ns/prov#pairKey";
var pairEntity = "http://www.w3.org/ns/prov#pairEntity";
var qualifiedInsertion = "http://www.w3.org/ns/prov#qualifiedInsertion";
var qualifiedRemoval = "http://www.w3.org/ns/prov#qualifiedRemoval";
var removedKey = "http://www.w3.org/ns/prov#removedKey";
var asInBundle = "http://www.w3.org/ns/prov#asInBundle";
var mentionOf = "http://www.w3.org/ns/prov#mentionOf";
var provImport = /* @__PURE__ */ Object.freeze({
  Activity: Activity2,
  ActivityInfluence,
  Agent: Agent3,
  AgentInfluence,
  Association,
  Attribution,
  Bundle: Bundle2,
  Collection: Collection4,
  Communication: Communication2,
  Delegation,
  Derivation,
  EmptyCollection,
  End,
  Entity,
  EntityInfluence,
  Generation,
  Influence,
  InstantaneousEvent,
  Invalidation,
  Location: Location3,
  Organization: Organization4,
  Person: Person4,
  Plan,
  PrimarySource,
  Quotation,
  Revision,
  Role,
  SoftwareAgent,
  Start,
  Usage,
  actedOnBehalfOf,
  activity: activity2,
  agent: agent3,
  alternateOf,
  aq,
  atLocation,
  atTime,
  category: category2,
  component: component2,
  constraints,
  definition: definition2,
  dm,
  editorialNote,
  editorsDefinition,
  endedAtTime,
  entity: entity2,
  generated,
  generatedAtTime,
  hadActivity,
  hadGeneration,
  hadMember,
  hadPlan,
  hadPrimarySource,
  hadRole,
  hadUsage,
  influenced,
  influencer,
  invalidated,
  invalidatedAtTime,
  inverse,
  n,
  order: order2,
  qualifiedAssociation,
  qualifiedAttribution,
  qualifiedCommunication,
  qualifiedDelegation,
  qualifiedDerivation,
  qualifiedEnd,
  qualifiedForm,
  qualifiedGeneration,
  qualifiedInfluence,
  qualifiedInvalidation,
  qualifiedPrimarySource,
  qualifiedQuotation,
  qualifiedRevision,
  qualifiedStart,
  qualifiedUsage,
  sharesDefinitionWith,
  specializationOf,
  startedAtTime,
  todo,
  unqualifiedForm,
  used: used2,
  value: value2,
  wasAssociatedWith,
  wasAttributedTo,
  wasDerivedFrom,
  wasEndedBy,
  wasGeneratedBy,
  wasInfluencedBy,
  wasInformedBy,
  wasInvalidatedBy,
  wasQuotedFrom,
  wasRevisionOf,
  wasStartedBy,
  ServiceDescription,
  DirectQueryService,
  has_anchor,
  has_provenance,
  has_query_service,
  describesService,
  provenanceUriTemplate,
  pingback,
  Accept: Accept2,
  Contribute,
  Contributor: Contributor2,
  Copyright,
  Create: Create2,
  Creator,
  Modify,
  Publish,
  Publisher,
  Replace,
  RightsAssignment,
  RightsHolder,
  Submit,
  Dictionary,
  EmptyDictionary,
  KeyEntityPair,
  Insertion,
  Removal,
  dictionary,
  derivedByInsertionFrom,
  derivedByRemovalFrom,
  insertedKeyEntityPair,
  hadDictionaryMember,
  pairKey,
  pairEntity,
  qualifiedInsertion,
  qualifiedRemoval,
  removedKey,
  asInBundle,
  mentionOf
});

// ../node_modules/rdf-namespaces/dist/qu-b9bfeffa.js
var Account2 = "http://www.w3.org/2000/10/swap/pim/qif#Account";
var Bank = "http://www.w3.org/2000/10/swap/pim/qif#Bank";
var Cat = "http://www.w3.org/2000/10/swap/pim/qif#Cat";
var Classified = "http://www.w3.org/2000/10/swap/pim/qif#Classified";
var Receipt = "http://www.w3.org/2000/10/swap/pim/qif#Receipt";
var SplitTransaction = "http://www.w3.org/2000/10/swap/pim/qif#SplitTransaction";
var SupportingDocument = "http://www.w3.org/2000/10/swap/pim/qif#SupportingDocument";
var Transaction = "http://www.w3.org/2000/10/swap/pim/qif#Transaction";
var Unclassified = "http://www.w3.org/2000/10/swap/pim/qif#Unclassified";
var UnclassifiedIncome = "http://www.w3.org/2000/10/swap/pim/qif#UnclassifiedIncome";
var UnclassifiedOutgoing = "http://www.w3.org/2000/10/swap/pim/qif#UnclassifiedOutgoing";
var accordingTo = "http://www.w3.org/2000/10/swap/pim/qif#accordingTo";
var amount2 = "http://www.w3.org/2000/10/swap/pim/qif#amount";
var category3 = "http://www.w3.org/2000/10/swap/pim/qif#category";
var date4 = "http://www.w3.org/2000/10/swap/pim/qif#date";
var payee2 = "http://www.w3.org/2000/10/swap/pim/qif#payee";
var splitPart = "http://www.w3.org/2000/10/swap/pim/qif#splitPart";
var splitReverse = "http://www.w3.org/2000/10/swap/pim/qif#splitReverse";
var toAccount = "http://www.w3.org/2000/10/swap/pim/qif#toAccount";
var quImport = /* @__PURE__ */ Object.freeze({
  Account: Account2,
  Bank,
  Cat,
  Classified,
  Receipt,
  SplitTransaction,
  SupportingDocument,
  Transaction,
  Unclassified,
  UnclassifiedIncome,
  UnclassifiedOutgoing,
  accordingTo,
  amount: amount2,
  category: category3,
  date: date4,
  payee: payee2,
  splitPart,
  splitReverse,
  toAccount
});

// ../node_modules/rdf-namespaces/dist/rdf-2b18691f.js
var HTML = "http://www.w3.org/1999/02/22-rdf-syntax-ns#HTML";
var langString = "http://www.w3.org/1999/02/22-rdf-syntax-ns#langString";
var PlainLiteral = "http://www.w3.org/1999/02/22-rdf-syntax-ns#PlainLiteral";
var type4 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#type";
var Property2 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#Property";
var Statement3 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#Statement";
var subject5 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#subject";
var predicate = "http://www.w3.org/1999/02/22-rdf-syntax-ns#predicate";
var object3 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#object";
var Bag = "http://www.w3.org/1999/02/22-rdf-syntax-ns#Bag";
var Seq = "http://www.w3.org/1999/02/22-rdf-syntax-ns#Seq";
var Alt = "http://www.w3.org/1999/02/22-rdf-syntax-ns#Alt";
var value3 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#value";
var List3 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#List";
var first3 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#first";
var rest2 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#rest";
var XMLLiteral = "http://www.w3.org/1999/02/22-rdf-syntax-ns#XMLLiteral";
var JSON__workaround = "http://www.w3.org/1999/02/22-rdf-syntax-ns#JSON";
var CompoundLiteral = "http://www.w3.org/1999/02/22-rdf-syntax-ns#CompoundLiteral";
var language4 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#language";
var direction2 = "http://www.w3.org/1999/02/22-rdf-syntax-ns#direction";
var rdfImport = /* @__PURE__ */ Object.freeze({
  HTML,
  langString,
  PlainLiteral,
  type: type4,
  Property: Property2,
  Statement: Statement3,
  subject: subject5,
  predicate,
  object: object3,
  Bag,
  Seq,
  Alt,
  value: value3,
  List: List3,
  first: first3,
  rest: rest2,
  XMLLiteral,
  JSON__workaround,
  CompoundLiteral,
  language: language4,
  direction: direction2
});

// ../node_modules/rdf-namespaces/dist/rdfs-35cff9fd.js
var Resource4 = "http://www.w3.org/2000/01/rdf-schema#Resource";
var Class4 = "http://www.w3.org/2000/01/rdf-schema#Class";
var subClassOf = "http://www.w3.org/2000/01/rdf-schema#subClassOf";
var subPropertyOf = "http://www.w3.org/2000/01/rdf-schema#subPropertyOf";
var comment3 = "http://www.w3.org/2000/01/rdf-schema#comment";
var label2 = "http://www.w3.org/2000/01/rdf-schema#label";
var domain2 = "http://www.w3.org/2000/01/rdf-schema#domain";
var range2 = "http://www.w3.org/2000/01/rdf-schema#range";
var seeAlso = "http://www.w3.org/2000/01/rdf-schema#seeAlso";
var isDefinedBy = "http://www.w3.org/2000/01/rdf-schema#isDefinedBy";
var Literal3 = "http://www.w3.org/2000/01/rdf-schema#Literal";
var Container2 = "http://www.w3.org/2000/01/rdf-schema#Container";
var ContainerMembershipProperty = "http://www.w3.org/2000/01/rdf-schema#ContainerMembershipProperty";
var member5 = "http://www.w3.org/2000/01/rdf-schema#member";
var Datatype = "http://www.w3.org/2000/01/rdf-schema#Datatype";
var rdfsImport = /* @__PURE__ */ Object.freeze({
  Resource: Resource4,
  Class: Class4,
  subClassOf,
  subPropertyOf,
  comment: comment3,
  label: label2,
  domain: domain2,
  range: range2,
  seeAlso,
  isDefinedBy,
  Literal: Literal3,
  Container: Container2,
  ContainerMembershipProperty,
  member: member5,
  Datatype
});

// ../node_modules/rdf-namespaces/dist/sched-c441d2db.js
var DegreesOfDifficulty = "http://www.w3.org/ns/pim/schedule#DegreesOfDifficulty";
var Difficult = "http://www.w3.org/ns/pim/schedule#Difficult";
var Ideal = "http://www.w3.org/ns/pim/schedule#Ideal";
var Impossible = "http://www.w3.org/ns/pim/schedule#Impossible";
var Painful = "http://www.w3.org/ns/pim/schedule#Painful";
var Tolerable = "http://www.w3.org/ns/pim/schedule#Tolerable";
var YesNo = "http://www.w3.org/ns/pim/schedule#YesNo";
var YesNoMaybe = "http://www.w3.org/ns/pim/schedule#YesNoMaybe";
var availabilityOptions = "http://www.w3.org/ns/pim/schedule#availabilityOptions";
var availibility = "http://www.w3.org/ns/pim/schedule#availibility";
var option2 = "http://www.w3.org/ns/pim/schedule#option";
var response3 = "http://www.w3.org/ns/pim/schedule#response";
var schedImport = /* @__PURE__ */ Object.freeze({
  DegreesOfDifficulty,
  Difficult,
  Ideal,
  Impossible,
  Painful,
  Tolerable,
  YesNo,
  YesNoMaybe,
  availabilityOptions,
  availibility,
  option: option2,
  response: response3
});

// ../node_modules/rdf-namespaces/dist/schema-97ef74f0.js
var AMRadioChannel = "http://schema.org/AMRadioChannel";
var APIReference = "http://schema.org/APIReference";
var AboutPage = "http://schema.org/AboutPage";
var AcceptAction = "http://schema.org/AcceptAction";
var Accommodation = "http://schema.org/Accommodation";
var AccountingService = "http://schema.org/AccountingService";
var AchieveAction = "http://schema.org/AchieveAction";
var Action3 = "http://schema.org/Action";
var ActionAccessSpecification = "http://schema.org/ActionAccessSpecification";
var ActionStatusType = "http://schema.org/ActionStatusType";
var ActivateAction = "http://schema.org/ActivateAction";
var AddAction = "http://schema.org/AddAction";
var AdministrativeArea = "http://schema.org/AdministrativeArea";
var AdultEntertainment = "http://schema.org/AdultEntertainment";
var AdultOrientedEnumeration = "http://schema.org/AdultOrientedEnumeration";
var AdvertiserContentArticle = "http://schema.org/AdvertiserContentArticle";
var AggregateOffer = "http://schema.org/AggregateOffer";
var AggregateRating = "http://schema.org/AggregateRating";
var AgreeAction = "http://schema.org/AgreeAction";
var Airline = "http://schema.org/Airline";
var Airport = "http://schema.org/Airport";
var AlignmentObject = "http://schema.org/AlignmentObject";
var AllocateAction = "http://schema.org/AllocateAction";
var AmpStory = "http://schema.org/AmpStory";
var AmusementPark = "http://schema.org/AmusementPark";
var AnalysisNewsArticle = "http://schema.org/AnalysisNewsArticle";
var AnatomicalStructure = "http://schema.org/AnatomicalStructure";
var AnatomicalSystem = "http://schema.org/AnatomicalSystem";
var AnimalShelter = "http://schema.org/AnimalShelter";
var Answer2 = "http://schema.org/Answer";
var Apartment = "http://schema.org/Apartment";
var ApartmentComplex = "http://schema.org/ApartmentComplex";
var AppendAction = "http://schema.org/AppendAction";
var ApplyAction = "http://schema.org/ApplyAction";
var ApprovedIndication = "http://schema.org/ApprovedIndication";
var Aquarium = "http://schema.org/Aquarium";
var ArchiveComponent = "http://schema.org/ArchiveComponent";
var ArchiveOrganization = "http://schema.org/ArchiveOrganization";
var ArriveAction = "http://schema.org/ArriveAction";
var ArtGallery = "http://schema.org/ArtGallery";
var Artery = "http://schema.org/Artery";
var Article2 = "http://schema.org/Article";
var AskAction = "http://schema.org/AskAction";
var AskPublicNewsArticle = "http://schema.org/AskPublicNewsArticle";
var AssessAction = "http://schema.org/AssessAction";
var AssignAction = "http://schema.org/AssignAction";
var Atlas = "http://schema.org/Atlas";
var Attorney = "http://schema.org/Attorney";
var Audience = "http://schema.org/Audience";
var AudioObject = "http://schema.org/AudioObject";
var AudioObjectSnapshot = "http://schema.org/AudioObjectSnapshot";
var Audiobook = "http://schema.org/Audiobook";
var AuthenticateAction = "http://schema.org/AuthenticateAction";
var AuthorizeAction = "http://schema.org/AuthorizeAction";
var AutoBodyShop = "http://schema.org/AutoBodyShop";
var AutoDealer = "http://schema.org/AutoDealer";
var AutoPartsStore = "http://schema.org/AutoPartsStore";
var AutoRental = "http://schema.org/AutoRental";
var AutoRepair = "http://schema.org/AutoRepair";
var AutoWash = "http://schema.org/AutoWash";
var AutomatedTeller = "http://schema.org/AutomatedTeller";
var AutomotiveBusiness = "http://schema.org/AutomotiveBusiness";
var BackgroundNewsArticle = "http://schema.org/BackgroundNewsArticle";
var Bakery = "http://schema.org/Bakery";
var BankAccount = "http://schema.org/BankAccount";
var BankOrCreditUnion = "http://schema.org/BankOrCreditUnion";
var BarOrPub = "http://schema.org/BarOrPub";
var Barcode = "http://schema.org/Barcode";
var Beach = "http://schema.org/Beach";
var BeautySalon = "http://schema.org/BeautySalon";
var BedAndBreakfast = "http://schema.org/BedAndBreakfast";
var BedDetails = "http://schema.org/BedDetails";
var BedType = "http://schema.org/BedType";
var BefriendAction = "http://schema.org/BefriendAction";
var BikeStore = "http://schema.org/BikeStore";
var BioChemEntity = "http://schema.org/BioChemEntity";
var Blog = "http://schema.org/Blog";
var BlogPosting = "http://schema.org/BlogPosting";
var BloodTest = "http://schema.org/BloodTest";
var BoardingPolicyType = "http://schema.org/BoardingPolicyType";
var BoatReservation = "http://schema.org/BoatReservation";
var BoatTerminal = "http://schema.org/BoatTerminal";
var BoatTrip = "http://schema.org/BoatTrip";
var BodyMeasurementTypeEnumeration = "http://schema.org/BodyMeasurementTypeEnumeration";
var BodyOfWater = "http://schema.org/BodyOfWater";
var Bone = "http://schema.org/Bone";
var Book = "http://schema.org/Book";
var BookFormatType = "http://schema.org/BookFormatType";
var BookSeries = "http://schema.org/BookSeries";
var BookStore = "http://schema.org/BookStore";
var BookmarkAction = "http://schema.org/BookmarkAction";
var Boolean__workaround = "http://schema.org/Boolean";
var BorrowAction = "http://schema.org/BorrowAction";
var BowlingAlley = "http://schema.org/BowlingAlley";
var BrainStructure = "http://schema.org/BrainStructure";
var Brand = "http://schema.org/Brand";
var BreadcrumbList = "http://schema.org/BreadcrumbList";
var Brewery = "http://schema.org/Brewery";
var Bridge = "http://schema.org/Bridge";
var BroadcastChannel = "http://schema.org/BroadcastChannel";
var BroadcastEvent = "http://schema.org/BroadcastEvent";
var BroadcastFrequencySpecification = "http://schema.org/BroadcastFrequencySpecification";
var BroadcastService = "http://schema.org/BroadcastService";
var BrokerageAccount = "http://schema.org/BrokerageAccount";
var BuddhistTemple = "http://schema.org/BuddhistTemple";
var BusOrCoach = "http://schema.org/BusOrCoach";
var BusReservation = "http://schema.org/BusReservation";
var BusStation = "http://schema.org/BusStation";
var BusStop = "http://schema.org/BusStop";
var BusTrip = "http://schema.org/BusTrip";
var BusinessAudience = "http://schema.org/BusinessAudience";
var BusinessEntityType = "http://schema.org/BusinessEntityType";
var BusinessEvent = "http://schema.org/BusinessEvent";
var BusinessFunction = "http://schema.org/BusinessFunction";
var BuyAction = "http://schema.org/BuyAction";
var CDCPMDRecord = "http://schema.org/CDCPMDRecord";
var CableOrSatelliteService = "http://schema.org/CableOrSatelliteService";
var CafeOrCoffeeShop = "http://schema.org/CafeOrCoffeeShop";
var Campground = "http://schema.org/Campground";
var CampingPitch = "http://schema.org/CampingPitch";
var Canal = "http://schema.org/Canal";
var CancelAction = "http://schema.org/CancelAction";
var Car = "http://schema.org/Car";
var CarUsageType = "http://schema.org/CarUsageType";
var Casino = "http://schema.org/Casino";
var CategoryCode = "http://schema.org/CategoryCode";
var CategoryCodeSet = "http://schema.org/CategoryCodeSet";
var CatholicChurch = "http://schema.org/CatholicChurch";
var Cemetery = "http://schema.org/Cemetery";
var Certification = "http://schema.org/Certification";
var CertificationStatusEnumeration = "http://schema.org/CertificationStatusEnumeration";
var Chapter = "http://schema.org/Chapter";
var CheckAction = "http://schema.org/CheckAction";
var CheckInAction = "http://schema.org/CheckInAction";
var CheckOutAction = "http://schema.org/CheckOutAction";
var CheckoutPage = "http://schema.org/CheckoutPage";
var ChemicalSubstance = "http://schema.org/ChemicalSubstance";
var ChildCare = "http://schema.org/ChildCare";
var ChildrensEvent = "http://schema.org/ChildrensEvent";
var ChooseAction = "http://schema.org/ChooseAction";
var Church = "http://schema.org/Church";
var City = "http://schema.org/City";
var CityHall = "http://schema.org/CityHall";
var CivicStructure = "http://schema.org/CivicStructure";
var Claim2 = "http://schema.org/Claim";
var ClaimReview = "http://schema.org/ClaimReview";
var Class5 = "http://schema.org/Class";
var Clip = "http://schema.org/Clip";
var ClothingStore = "http://schema.org/ClothingStore";
var Code = "http://schema.org/Code";
var Collection5 = "http://schema.org/Collection";
var CollectionPage2 = "http://schema.org/CollectionPage";
var CollegeOrUniversity = "http://schema.org/CollegeOrUniversity";
var ComedyClub = "http://schema.org/ComedyClub";
var ComedyEvent = "http://schema.org/ComedyEvent";
var ComicCoverArt = "http://schema.org/ComicCoverArt";
var ComicIssue = "http://schema.org/ComicIssue";
var ComicSeries = "http://schema.org/ComicSeries";
var ComicStory = "http://schema.org/ComicStory";
var Comment = "http://schema.org/Comment";
var CommentAction = "http://schema.org/CommentAction";
var CommunicateAction = "http://schema.org/CommunicateAction";
var CompleteDataFeed = "http://schema.org/CompleteDataFeed";
var CompoundPriceSpecification = "http://schema.org/CompoundPriceSpecification";
var ComputerLanguage = "http://schema.org/ComputerLanguage";
var ComputerStore = "http://schema.org/ComputerStore";
var ConferenceEvent = "http://schema.org/ConferenceEvent";
var ConfirmAction = "http://schema.org/ConfirmAction";
var Consortium = "http://schema.org/Consortium";
var ConstraintNode = "http://schema.org/ConstraintNode";
var ConsumeAction = "http://schema.org/ConsumeAction";
var ContactPage = "http://schema.org/ContactPage";
var ContactPoint2 = "http://schema.org/ContactPoint";
var ContactPointOption = "http://schema.org/ContactPointOption";
var Continent = "http://schema.org/Continent";
var ControlAction = "http://schema.org/ControlAction";
var ConvenienceStore = "http://schema.org/ConvenienceStore";
var Conversation = "http://schema.org/Conversation";
var CookAction = "http://schema.org/CookAction";
var Cooperative = "http://schema.org/Cooperative";
var Corporation = "http://schema.org/Corporation";
var CorrectionComment = "http://schema.org/CorrectionComment";
var Country = "http://schema.org/Country";
var Course = "http://schema.org/Course";
var CourseInstance = "http://schema.org/CourseInstance";
var Courthouse = "http://schema.org/Courthouse";
var CoverArt = "http://schema.org/CoverArt";
var CovidTestingFacility = "http://schema.org/CovidTestingFacility";
var CreateAction = "http://schema.org/CreateAction";
var CreativeWork = "http://schema.org/CreativeWork";
var CreativeWorkSeason = "http://schema.org/CreativeWorkSeason";
var CreativeWorkSeries = "http://schema.org/CreativeWorkSeries";
var Credential = "http://schema.org/Credential";
var CreditCard = "http://schema.org/CreditCard";
var Crematorium = "http://schema.org/Crematorium";
var CriticReview = "http://schema.org/CriticReview";
var CssSelectorType = "http://schema.org/CssSelectorType";
var CurrencyConversionService = "http://schema.org/CurrencyConversionService";
var DDxElement = "http://schema.org/DDxElement";
var DENonprofitType = "http://schema.org/DENonprofitType";
var DanceEvent = "http://schema.org/DanceEvent";
var DanceGroup = "http://schema.org/DanceGroup";
var DataCatalog = "http://schema.org/DataCatalog";
var DataDownload = "http://schema.org/DataDownload";
var DataFeed = "http://schema.org/DataFeed";
var DataFeedItem = "http://schema.org/DataFeedItem";
var DataType2 = "http://schema.org/DataType";
var Dataset = "http://schema.org/Dataset";
var Date__workaround = "http://schema.org/Date";
var DateTime = "http://schema.org/DateTime";
var DatedMoneySpecification = "http://schema.org/DatedMoneySpecification";
var DayOfWeek = "http://schema.org/DayOfWeek";
var DaySpa = "http://schema.org/DaySpa";
var DeactivateAction = "http://schema.org/DeactivateAction";
var DefenceEstablishment = "http://schema.org/DefenceEstablishment";
var DefinedRegion = "http://schema.org/DefinedRegion";
var DefinedTerm = "http://schema.org/DefinedTerm";
var DefinedTermSet = "http://schema.org/DefinedTermSet";
var DeleteAction = "http://schema.org/DeleteAction";
var DeliveryChargeSpecification = "http://schema.org/DeliveryChargeSpecification";
var DeliveryEvent = "http://schema.org/DeliveryEvent";
var DeliveryMethod = "http://schema.org/DeliveryMethod";
var DeliveryTimeSettings = "http://schema.org/DeliveryTimeSettings";
var Demand = "http://schema.org/Demand";
var Dentist = "http://schema.org/Dentist";
var DepartAction = "http://schema.org/DepartAction";
var DepartmentStore = "http://schema.org/DepartmentStore";
var DepositAccount = "http://schema.org/DepositAccount";
var DiagnosticLab = "http://schema.org/DiagnosticLab";
var DiagnosticProcedure = "http://schema.org/DiagnosticProcedure";
var Diet = "http://schema.org/Diet";
var DietarySupplement = "http://schema.org/DietarySupplement";
var DigitalDocument = "http://schema.org/DigitalDocument";
var DigitalDocumentPermission = "http://schema.org/DigitalDocumentPermission";
var DigitalDocumentPermissionType = "http://schema.org/DigitalDocumentPermissionType";
var DigitalPlatformEnumeration = "http://schema.org/DigitalPlatformEnumeration";
var DisagreeAction = "http://schema.org/DisagreeAction";
var DiscoverAction = "http://schema.org/DiscoverAction";
var DiscussionForumPosting = "http://schema.org/DiscussionForumPosting";
var DislikeAction = "http://schema.org/DislikeAction";
var Distance2 = "http://schema.org/Distance";
var Distillery = "http://schema.org/Distillery";
var DonateAction = "http://schema.org/DonateAction";
var DoseSchedule = "http://schema.org/DoseSchedule";
var DownloadAction = "http://schema.org/DownloadAction";
var DrawAction = "http://schema.org/DrawAction";
var Drawing = "http://schema.org/Drawing";
var DrinkAction = "http://schema.org/DrinkAction";
var DriveWheelConfigurationValue = "http://schema.org/DriveWheelConfigurationValue";
var Drug = "http://schema.org/Drug";
var DrugClass = "http://schema.org/DrugClass";
var DrugCost = "http://schema.org/DrugCost";
var DrugCostCategory = "http://schema.org/DrugCostCategory";
var DrugLegalStatus = "http://schema.org/DrugLegalStatus";
var DrugPregnancyCategory = "http://schema.org/DrugPregnancyCategory";
var DrugPrescriptionStatus = "http://schema.org/DrugPrescriptionStatus";
var DrugStrength = "http://schema.org/DrugStrength";
var DryCleaningOrLaundry = "http://schema.org/DryCleaningOrLaundry";
var Duration2 = "http://schema.org/Duration";
var EUEnergyEfficiencyEnumeration = "http://schema.org/EUEnergyEfficiencyEnumeration";
var EatAction = "http://schema.org/EatAction";
var EducationEvent = "http://schema.org/EducationEvent";
var EducationalAudience = "http://schema.org/EducationalAudience";
var EducationalOccupationalCredential = "http://schema.org/EducationalOccupationalCredential";
var EducationalOccupationalProgram = "http://schema.org/EducationalOccupationalProgram";
var EducationalOrganization = "http://schema.org/EducationalOrganization";
var Electrician = "http://schema.org/Electrician";
var ElectronicsStore = "http://schema.org/ElectronicsStore";
var ElementarySchool = "http://schema.org/ElementarySchool";
var EmailMessage = "http://schema.org/EmailMessage";
var Embassy = "http://schema.org/Embassy";
var EmergencyService = "http://schema.org/EmergencyService";
var EmployeeRole = "http://schema.org/EmployeeRole";
var EmployerAggregateRating = "http://schema.org/EmployerAggregateRating";
var EmployerReview = "http://schema.org/EmployerReview";
var EmploymentAgency = "http://schema.org/EmploymentAgency";
var EndorseAction = "http://schema.org/EndorseAction";
var EndorsementRating = "http://schema.org/EndorsementRating";
var Energy = "http://schema.org/Energy";
var EnergyConsumptionDetails = "http://schema.org/EnergyConsumptionDetails";
var EnergyEfficiencyEnumeration = "http://schema.org/EnergyEfficiencyEnumeration";
var EnergyStarEnergyEfficiencyEnumeration = "http://schema.org/EnergyStarEnergyEfficiencyEnumeration";
var EngineSpecification = "http://schema.org/EngineSpecification";
var EntertainmentBusiness = "http://schema.org/EntertainmentBusiness";
var EntryPoint = "http://schema.org/EntryPoint";
var Enumeration = "http://schema.org/Enumeration";
var Episode = "http://schema.org/Episode";
var Error__workaround3 = "http://schema.org/Error";
var Event2 = "http://schema.org/Event";
var EventAttendanceModeEnumeration = "http://schema.org/EventAttendanceModeEnumeration";
var EventReservation = "http://schema.org/EventReservation";
var EventSeries = "http://schema.org/EventSeries";
var EventStatusType = "http://schema.org/EventStatusType";
var EventVenue = "http://schema.org/EventVenue";
var ExchangeRateSpecification = "http://schema.org/ExchangeRateSpecification";
var ExerciseAction = "http://schema.org/ExerciseAction";
var ExerciseGym = "http://schema.org/ExerciseGym";
var ExercisePlan = "http://schema.org/ExercisePlan";
var ExhibitionEvent = "http://schema.org/ExhibitionEvent";
var FAQPage = "http://schema.org/FAQPage";
var FMRadioChannel = "http://schema.org/FMRadioChannel";
var FastFoodRestaurant = "http://schema.org/FastFoodRestaurant";
var Festival = "http://schema.org/Festival";
var FilmAction = "http://schema.org/FilmAction";
var FinancialIncentive = "http://schema.org/FinancialIncentive";
var FinancialProduct = "http://schema.org/FinancialProduct";
var FinancialService = "http://schema.org/FinancialService";
var FindAction = "http://schema.org/FindAction";
var FireStation = "http://schema.org/FireStation";
var Flight = "http://schema.org/Flight";
var FlightReservation = "http://schema.org/FlightReservation";
var Float = "http://schema.org/Float";
var FloorPlan = "http://schema.org/FloorPlan";
var Florist = "http://schema.org/Florist";
var FollowAction = "http://schema.org/FollowAction";
var FoodEstablishment = "http://schema.org/FoodEstablishment";
var FoodEstablishmentReservation = "http://schema.org/FoodEstablishmentReservation";
var FoodEvent = "http://schema.org/FoodEvent";
var FoodService = "http://schema.org/FoodService";
var FulfillmentTypeEnumeration = "http://schema.org/FulfillmentTypeEnumeration";
var FundingAgency = "http://schema.org/FundingAgency";
var FundingScheme = "http://schema.org/FundingScheme";
var FurnitureStore = "http://schema.org/FurnitureStore";
var Game = "http://schema.org/Game";
var GameAvailabilityEnumeration = "http://schema.org/GameAvailabilityEnumeration";
var GamePlayMode = "http://schema.org/GamePlayMode";
var GameServer = "http://schema.org/GameServer";
var GameServerStatus = "http://schema.org/GameServerStatus";
var GardenStore = "http://schema.org/GardenStore";
var GasStation = "http://schema.org/GasStation";
var GatedResidenceCommunity = "http://schema.org/GatedResidenceCommunity";
var GenderType = "http://schema.org/GenderType";
var Gene = "http://schema.org/Gene";
var GeneralContractor = "http://schema.org/GeneralContractor";
var GeoCircle = "http://schema.org/GeoCircle";
var GeoCoordinates = "http://schema.org/GeoCoordinates";
var GeoShape = "http://schema.org/GeoShape";
var GeospatialGeometry = "http://schema.org/GeospatialGeometry";
var GiveAction = "http://schema.org/GiveAction";
var GolfCourse = "http://schema.org/GolfCourse";
var GovernmentBenefitsType = "http://schema.org/GovernmentBenefitsType";
var GovernmentBuilding = "http://schema.org/GovernmentBuilding";
var GovernmentOffice = "http://schema.org/GovernmentOffice";
var GovernmentOrganization = "http://schema.org/GovernmentOrganization";
var GovernmentPermit = "http://schema.org/GovernmentPermit";
var GovernmentService = "http://schema.org/GovernmentService";
var Grant = "http://schema.org/Grant";
var GroceryStore = "http://schema.org/GroceryStore";
var Guide = "http://schema.org/Guide";
var HVACBusiness = "http://schema.org/HVACBusiness";
var Hackathon = "http://schema.org/Hackathon";
var HairSalon = "http://schema.org/HairSalon";
var HardwareStore = "http://schema.org/HardwareStore";
var HealthAndBeautyBusiness = "http://schema.org/HealthAndBeautyBusiness";
var HealthAspectEnumeration = "http://schema.org/HealthAspectEnumeration";
var HealthClub = "http://schema.org/HealthClub";
var HealthInsurancePlan = "http://schema.org/HealthInsurancePlan";
var HealthPlanCostSharingSpecification = "http://schema.org/HealthPlanCostSharingSpecification";
var HealthPlanFormulary = "http://schema.org/HealthPlanFormulary";
var HealthPlanNetwork = "http://schema.org/HealthPlanNetwork";
var HealthTopicContent = "http://schema.org/HealthTopicContent";
var HighSchool = "http://schema.org/HighSchool";
var HinduTemple = "http://schema.org/HinduTemple";
var HobbyShop = "http://schema.org/HobbyShop";
var HomeAndConstructionBusiness = "http://schema.org/HomeAndConstructionBusiness";
var HomeGoodsStore = "http://schema.org/HomeGoodsStore";
var Hospital = "http://schema.org/Hospital";
var Hostel = "http://schema.org/Hostel";
var Hotel = "http://schema.org/Hotel";
var HotelRoom = "http://schema.org/HotelRoom";
var House = "http://schema.org/House";
var HousePainter = "http://schema.org/HousePainter";
var HowTo = "http://schema.org/HowTo";
var HowToDirection = "http://schema.org/HowToDirection";
var HowToItem = "http://schema.org/HowToItem";
var HowToSection = "http://schema.org/HowToSection";
var HowToStep = "http://schema.org/HowToStep";
var HowToSupply = "http://schema.org/HowToSupply";
var HowToTip = "http://schema.org/HowToTip";
var HowToTool = "http://schema.org/HowToTool";
var HyperToc = "http://schema.org/HyperToc";
var HyperTocEntry = "http://schema.org/HyperTocEntry";
var IPTCDigitalSourceEnumeration = "http://schema.org/IPTCDigitalSourceEnumeration";
var ITNonprofitType = "http://schema.org/ITNonprofitType";
var IceCreamShop = "http://schema.org/IceCreamShop";
var IgnoreAction = "http://schema.org/IgnoreAction";
var ImageGallery = "http://schema.org/ImageGallery";
var ImageObject = "http://schema.org/ImageObject";
var ImageObjectSnapshot = "http://schema.org/ImageObjectSnapshot";
var ImagingTest = "http://schema.org/ImagingTest";
var IncentiveQualifiedExpenseType = "http://schema.org/IncentiveQualifiedExpenseType";
var IncentiveStatus = "http://schema.org/IncentiveStatus";
var IncentiveType = "http://schema.org/IncentiveType";
var IndividualPhysician = "http://schema.org/IndividualPhysician";
var IndividualProduct = "http://schema.org/IndividualProduct";
var InfectiousAgentClass = "http://schema.org/InfectiousAgentClass";
var InfectiousDisease = "http://schema.org/InfectiousDisease";
var InformAction = "http://schema.org/InformAction";
var InsertAction = "http://schema.org/InsertAction";
var InstallAction = "http://schema.org/InstallAction";
var InstantaneousEvent2 = "http://schema.org/InstantaneousEvent";
var InsuranceAgency = "http://schema.org/InsuranceAgency";
var Intangible = "http://schema.org/Intangible";
var Integer = "http://schema.org/Integer";
var InteractAction = "http://schema.org/InteractAction";
var InteractionCounter = "http://schema.org/InteractionCounter";
var InternetCafe = "http://schema.org/InternetCafe";
var InvestmentFund = "http://schema.org/InvestmentFund";
var InvestmentOrDeposit = "http://schema.org/InvestmentOrDeposit";
var InviteAction = "http://schema.org/InviteAction";
var Invoice2 = "http://schema.org/Invoice";
var ItemAvailability = "http://schema.org/ItemAvailability";
var ItemList = "http://schema.org/ItemList";
var ItemListOrderType = "http://schema.org/ItemListOrderType";
var ItemPage = "http://schema.org/ItemPage";
var JewelryStore = "http://schema.org/JewelryStore";
var JobPosting = "http://schema.org/JobPosting";
var JoinAction = "http://schema.org/JoinAction";
var Joint = "http://schema.org/Joint";
var LakeBodyOfWater = "http://schema.org/LakeBodyOfWater";
var Landform = "http://schema.org/Landform";
var LandmarksOrHistoricalBuildings = "http://schema.org/LandmarksOrHistoricalBuildings";
var Language = "http://schema.org/Language";
var LearningResource = "http://schema.org/LearningResource";
var LeaveAction = "http://schema.org/LeaveAction";
var LegalForceStatus = "http://schema.org/LegalForceStatus";
var LegalService = "http://schema.org/LegalService";
var LegalValueLevel = "http://schema.org/LegalValueLevel";
var Legislation = "http://schema.org/Legislation";
var LegislationObject = "http://schema.org/LegislationObject";
var LegislativeBuilding = "http://schema.org/LegislativeBuilding";
var LendAction = "http://schema.org/LendAction";
var Library2 = "http://schema.org/Library";
var LibrarySystem = "http://schema.org/LibrarySystem";
var LifestyleModification = "http://schema.org/LifestyleModification";
var Ligament = "http://schema.org/Ligament";
var LikeAction = "http://schema.org/LikeAction";
var LinkRole = "http://schema.org/LinkRole";
var LiquorStore = "http://schema.org/LiquorStore";
var ListItem = "http://schema.org/ListItem";
var ListenAction = "http://schema.org/ListenAction";
var LiteraryEvent = "http://schema.org/LiteraryEvent";
var LiveBlogPosting = "http://schema.org/LiveBlogPosting";
var LoanOrCredit = "http://schema.org/LoanOrCredit";
var LocalBusiness = "http://schema.org/LocalBusiness";
var LocationFeatureSpecification = "http://schema.org/LocationFeatureSpecification";
var Locksmith = "http://schema.org/Locksmith";
var LodgingBusiness = "http://schema.org/LodgingBusiness";
var LodgingReservation = "http://schema.org/LodgingReservation";
var LoginAction = "http://schema.org/LoginAction";
var LoseAction = "http://schema.org/LoseAction";
var LymphaticVessel = "http://schema.org/LymphaticVessel";
var Manuscript = "http://schema.org/Manuscript";
var Map__workaround = "http://schema.org/Map";
var MapCategoryType = "http://schema.org/MapCategoryType";
var MarryAction = "http://schema.org/MarryAction";
var Mass = "http://schema.org/Mass";
var MathSolver = "http://schema.org/MathSolver";
var MaximumDoseSchedule = "http://schema.org/MaximumDoseSchedule";
var MeasurementMethodEnum = "http://schema.org/MeasurementMethodEnum";
var MeasurementTypeEnumeration = "http://schema.org/MeasurementTypeEnumeration";
var MediaEnumeration = "http://schema.org/MediaEnumeration";
var MediaGallery = "http://schema.org/MediaGallery";
var MediaManipulationRatingEnumeration = "http://schema.org/MediaManipulationRatingEnumeration";
var MediaObject = "http://schema.org/MediaObject";
var MediaReview = "http://schema.org/MediaReview";
var MediaReviewItem = "http://schema.org/MediaReviewItem";
var MediaSubscription = "http://schema.org/MediaSubscription";
var MedicalAudience = "http://schema.org/MedicalAudience";
var MedicalAudienceType = "http://schema.org/MedicalAudienceType";
var MedicalBusiness = "http://schema.org/MedicalBusiness";
var MedicalCause = "http://schema.org/MedicalCause";
var MedicalClinic = "http://schema.org/MedicalClinic";
var MedicalCode = "http://schema.org/MedicalCode";
var MedicalCondition = "http://schema.org/MedicalCondition";
var MedicalConditionStage = "http://schema.org/MedicalConditionStage";
var MedicalContraindication = "http://schema.org/MedicalContraindication";
var MedicalDevice = "http://schema.org/MedicalDevice";
var MedicalDevicePurpose = "http://schema.org/MedicalDevicePurpose";
var MedicalEntity = "http://schema.org/MedicalEntity";
var MedicalEnumeration = "http://schema.org/MedicalEnumeration";
var MedicalEvidenceLevel = "http://schema.org/MedicalEvidenceLevel";
var MedicalGuideline = "http://schema.org/MedicalGuideline";
var MedicalGuidelineContraindication = "http://schema.org/MedicalGuidelineContraindication";
var MedicalGuidelineRecommendation = "http://schema.org/MedicalGuidelineRecommendation";
var MedicalImagingTechnique = "http://schema.org/MedicalImagingTechnique";
var MedicalIndication = "http://schema.org/MedicalIndication";
var MedicalIntangible = "http://schema.org/MedicalIntangible";
var MedicalObservationalStudy = "http://schema.org/MedicalObservationalStudy";
var MedicalObservationalStudyDesign = "http://schema.org/MedicalObservationalStudyDesign";
var MedicalOrganization = "http://schema.org/MedicalOrganization";
var MedicalProcedure = "http://schema.org/MedicalProcedure";
var MedicalProcedureType = "http://schema.org/MedicalProcedureType";
var MedicalRiskCalculator = "http://schema.org/MedicalRiskCalculator";
var MedicalRiskEstimator = "http://schema.org/MedicalRiskEstimator";
var MedicalRiskFactor = "http://schema.org/MedicalRiskFactor";
var MedicalRiskScore = "http://schema.org/MedicalRiskScore";
var MedicalScholarlyArticle = "http://schema.org/MedicalScholarlyArticle";
var MedicalSign = "http://schema.org/MedicalSign";
var MedicalSignOrSymptom = "http://schema.org/MedicalSignOrSymptom";
var MedicalSpecialty = "http://schema.org/MedicalSpecialty";
var MedicalStudy = "http://schema.org/MedicalStudy";
var MedicalStudyStatus = "http://schema.org/MedicalStudyStatus";
var MedicalSymptom = "http://schema.org/MedicalSymptom";
var MedicalTest = "http://schema.org/MedicalTest";
var MedicalTestPanel = "http://schema.org/MedicalTestPanel";
var MedicalTherapy = "http://schema.org/MedicalTherapy";
var MedicalTrial = "http://schema.org/MedicalTrial";
var MedicalTrialDesign = "http://schema.org/MedicalTrialDesign";
var MedicalWebPage = "http://schema.org/MedicalWebPage";
var MedicineSystem = "http://schema.org/MedicineSystem";
var MeetingRoom = "http://schema.org/MeetingRoom";
var MemberProgram = "http://schema.org/MemberProgram";
var MemberProgramTier = "http://schema.org/MemberProgramTier";
var MensClothingStore = "http://schema.org/MensClothingStore";
var Menu = "http://schema.org/Menu";
var MenuItem = "http://schema.org/MenuItem";
var MenuSection = "http://schema.org/MenuSection";
var MerchantReturnEnumeration = "http://schema.org/MerchantReturnEnumeration";
var MerchantReturnPolicy = "http://schema.org/MerchantReturnPolicy";
var MerchantReturnPolicySeasonalOverride = "http://schema.org/MerchantReturnPolicySeasonalOverride";
var Message2 = "http://schema.org/Message";
var MiddleSchool = "http://schema.org/MiddleSchool";
var MobileApplication = "http://schema.org/MobileApplication";
var MobilePhoneStore = "http://schema.org/MobilePhoneStore";
var MolecularEntity = "http://schema.org/MolecularEntity";
var MonetaryAmount = "http://schema.org/MonetaryAmount";
var MonetaryAmountDistribution = "http://schema.org/MonetaryAmountDistribution";
var MonetaryGrant = "http://schema.org/MonetaryGrant";
var MoneyTransfer = "http://schema.org/MoneyTransfer";
var MortgageLoan = "http://schema.org/MortgageLoan";
var Mosque = "http://schema.org/Mosque";
var Motel = "http://schema.org/Motel";
var Motorcycle = "http://schema.org/Motorcycle";
var MotorcycleDealer = "http://schema.org/MotorcycleDealer";
var MotorcycleRepair = "http://schema.org/MotorcycleRepair";
var MotorizedBicycle = "http://schema.org/MotorizedBicycle";
var Mountain = "http://schema.org/Mountain";
var MoveAction = "http://schema.org/MoveAction";
var Movie = "http://schema.org/Movie";
var MovieClip = "http://schema.org/MovieClip";
var MovieRentalStore = "http://schema.org/MovieRentalStore";
var MovieSeries = "http://schema.org/MovieSeries";
var MovieTheater = "http://schema.org/MovieTheater";
var MovingCompany = "http://schema.org/MovingCompany";
var Muscle = "http://schema.org/Muscle";
var Museum = "http://schema.org/Museum";
var MusicAlbum = "http://schema.org/MusicAlbum";
var MusicAlbumProductionType = "http://schema.org/MusicAlbumProductionType";
var MusicAlbumReleaseType = "http://schema.org/MusicAlbumReleaseType";
var MusicComposition = "http://schema.org/MusicComposition";
var MusicEvent = "http://schema.org/MusicEvent";
var MusicGroup = "http://schema.org/MusicGroup";
var MusicPlaylist = "http://schema.org/MusicPlaylist";
var MusicRecording = "http://schema.org/MusicRecording";
var MusicRelease = "http://schema.org/MusicRelease";
var MusicReleaseFormatType = "http://schema.org/MusicReleaseFormatType";
var MusicStore = "http://schema.org/MusicStore";
var MusicVenue = "http://schema.org/MusicVenue";
var MusicVideoObject = "http://schema.org/MusicVideoObject";
var NGO = "http://schema.org/NGO";
var NLNonprofitType = "http://schema.org/NLNonprofitType";
var NailSalon = "http://schema.org/NailSalon";
var Nerve = "http://schema.org/Nerve";
var NewsArticle = "http://schema.org/NewsArticle";
var NewsMediaOrganization = "http://schema.org/NewsMediaOrganization";
var Newspaper = "http://schema.org/Newspaper";
var NightClub = "http://schema.org/NightClub";
var NonprofitType = "http://schema.org/NonprofitType";
var Notary = "http://schema.org/Notary";
var NoteDigitalDocument = "http://schema.org/NoteDigitalDocument";
var Number__workaround = "http://schema.org/Number";
var NutritionInformation = "http://schema.org/NutritionInformation";
var Observation2 = "http://schema.org/Observation";
var Occupation = "http://schema.org/Occupation";
var OccupationalExperienceRequirements = "http://schema.org/OccupationalExperienceRequirements";
var OccupationalTherapy = "http://schema.org/OccupationalTherapy";
var OceanBodyOfWater = "http://schema.org/OceanBodyOfWater";
var Offer2 = "http://schema.org/Offer";
var OfferCatalog = "http://schema.org/OfferCatalog";
var OfferForLease = "http://schema.org/OfferForLease";
var OfferForPurchase = "http://schema.org/OfferForPurchase";
var OfferItemCondition = "http://schema.org/OfferItemCondition";
var OfferShippingDetails = "http://schema.org/OfferShippingDetails";
var OfficeEquipmentStore = "http://schema.org/OfficeEquipmentStore";
var OnDemandEvent = "http://schema.org/OnDemandEvent";
var OnlineBusiness = "http://schema.org/OnlineBusiness";
var OnlineMarketplace = "http://schema.org/OnlineMarketplace";
var OnlineStore = "http://schema.org/OnlineStore";
var OpeningHoursSpecification = "http://schema.org/OpeningHoursSpecification";
var OperatingSystem = "http://schema.org/OperatingSystem";
var OpinionNewsArticle = "http://schema.org/OpinionNewsArticle";
var Optician = "http://schema.org/Optician";
var Order = "http://schema.org/Order";
var OrderAction = "http://schema.org/OrderAction";
var OrderItem = "http://schema.org/OrderItem";
var OrderStatus = "http://schema.org/OrderStatus";
var Organization5 = "http://schema.org/Organization";
var OrganizationRole = "http://schema.org/OrganizationRole";
var OrganizeAction = "http://schema.org/OrganizeAction";
var OutletStore = "http://schema.org/OutletStore";
var OwnershipInfo = "http://schema.org/OwnershipInfo";
var PaintAction = "http://schema.org/PaintAction";
var Painting = "http://schema.org/Painting";
var PalliativeProcedure = "http://schema.org/PalliativeProcedure";
var ParcelDelivery = "http://schema.org/ParcelDelivery";
var ParentAudience = "http://schema.org/ParentAudience";
var Park = "http://schema.org/Park";
var ParkingFacility = "http://schema.org/ParkingFacility";
var PathologyTest = "http://schema.org/PathologyTest";
var Patient2 = "http://schema.org/Patient";
var PawnShop = "http://schema.org/PawnShop";
var PayAction = "http://schema.org/PayAction";
var PaymentCard = "http://schema.org/PaymentCard";
var PaymentChargeSpecification = "http://schema.org/PaymentChargeSpecification";
var PaymentMethod = "http://schema.org/PaymentMethod";
var PaymentMethodType = "http://schema.org/PaymentMethodType";
var PaymentService = "http://schema.org/PaymentService";
var PaymentStatusType = "http://schema.org/PaymentStatusType";
var PeopleAudience = "http://schema.org/PeopleAudience";
var PerformAction = "http://schema.org/PerformAction";
var PerformanceRole = "http://schema.org/PerformanceRole";
var PerformingArtsEvent = "http://schema.org/PerformingArtsEvent";
var PerformingArtsTheater = "http://schema.org/PerformingArtsTheater";
var PerformingGroup = "http://schema.org/PerformingGroup";
var Periodical = "http://schema.org/Periodical";
var Permit = "http://schema.org/Permit";
var Person5 = "http://schema.org/Person";
var PetStore = "http://schema.org/PetStore";
var Pharmacy = "http://schema.org/Pharmacy";
var Photograph = "http://schema.org/Photograph";
var PhotographAction = "http://schema.org/PhotographAction";
var PhysicalActivity = "http://schema.org/PhysicalActivity";
var PhysicalActivityCategory = "http://schema.org/PhysicalActivityCategory";
var PhysicalExam = "http://schema.org/PhysicalExam";
var PhysicalTherapy = "http://schema.org/PhysicalTherapy";
var Physician = "http://schema.org/Physician";
var PhysiciansOffice = "http://schema.org/PhysiciansOffice";
var Place2 = "http://schema.org/Place";
var PlaceOfWorship = "http://schema.org/PlaceOfWorship";
var PlanAction = "http://schema.org/PlanAction";
var Play = "http://schema.org/Play";
var PlayAction = "http://schema.org/PlayAction";
var PlayGameAction = "http://schema.org/PlayGameAction";
var Playground = "http://schema.org/Playground";
var Plumber = "http://schema.org/Plumber";
var PodcastEpisode = "http://schema.org/PodcastEpisode";
var PodcastSeason = "http://schema.org/PodcastSeason";
var PodcastSeries = "http://schema.org/PodcastSeries";
var PoliceStation = "http://schema.org/PoliceStation";
var PoliticalParty = "http://schema.org/PoliticalParty";
var Pond = "http://schema.org/Pond";
var PostOffice = "http://schema.org/PostOffice";
var PostalAddress = "http://schema.org/PostalAddress";
var PostalCodeRangeSpecification = "http://schema.org/PostalCodeRangeSpecification";
var Poster = "http://schema.org/Poster";
var PreOrderAction = "http://schema.org/PreOrderAction";
var PrependAction = "http://schema.org/PrependAction";
var Preschool = "http://schema.org/Preschool";
var PresentationDigitalDocument = "http://schema.org/PresentationDigitalDocument";
var PreventionIndication = "http://schema.org/PreventionIndication";
var PriceComponentTypeEnumeration = "http://schema.org/PriceComponentTypeEnumeration";
var PriceSpecification = "http://schema.org/PriceSpecification";
var PriceTypeEnumeration = "http://schema.org/PriceTypeEnumeration";
var Product = "http://schema.org/Product";
var ProductCollection = "http://schema.org/ProductCollection";
var ProductGroup = "http://schema.org/ProductGroup";
var ProductModel = "http://schema.org/ProductModel";
var ProductReturnEnumeration = "http://schema.org/ProductReturnEnumeration";
var ProductReturnPolicy = "http://schema.org/ProductReturnPolicy";
var ProfessionalService = "http://schema.org/ProfessionalService";
var ProfilePage = "http://schema.org/ProfilePage";
var ProgramMembership = "http://schema.org/ProgramMembership";
var Project2 = "http://schema.org/Project";
var PronounceableText = "http://schema.org/PronounceableText";
var Property3 = "http://schema.org/Property";
var PropertyValue = "http://schema.org/PropertyValue";
var PropertyValueSpecification = "http://schema.org/PropertyValueSpecification";
var Protein = "http://schema.org/Protein";
var PsychologicalTreatment = "http://schema.org/PsychologicalTreatment";
var PublicSwimmingPool = "http://schema.org/PublicSwimmingPool";
var PublicToilet = "http://schema.org/PublicToilet";
var PublicationEvent = "http://schema.org/PublicationEvent";
var PublicationIssue = "http://schema.org/PublicationIssue";
var PublicationVolume = "http://schema.org/PublicationVolume";
var PurchaseType = "http://schema.org/PurchaseType";
var QAPage = "http://schema.org/QAPage";
var QualitativeValue = "http://schema.org/QualitativeValue";
var QuantitativeValue = "http://schema.org/QuantitativeValue";
var QuantitativeValueDistribution = "http://schema.org/QuantitativeValueDistribution";
var Quantity2 = "http://schema.org/Quantity";
var Question2 = "http://schema.org/Question";
var Quiz = "http://schema.org/Quiz";
var Quotation2 = "http://schema.org/Quotation";
var QuoteAction = "http://schema.org/QuoteAction";
var RVPark = "http://schema.org/RVPark";
var RadiationTherapy = "http://schema.org/RadiationTherapy";
var RadioBroadcastService = "http://schema.org/RadioBroadcastService";
var RadioChannel = "http://schema.org/RadioChannel";
var RadioClip = "http://schema.org/RadioClip";
var RadioEpisode = "http://schema.org/RadioEpisode";
var RadioSeason = "http://schema.org/RadioSeason";
var RadioSeries = "http://schema.org/RadioSeries";
var RadioStation = "http://schema.org/RadioStation";
var Rating = "http://schema.org/Rating";
var ReactAction = "http://schema.org/ReactAction";
var ReadAction = "http://schema.org/ReadAction";
var RealEstateAgent = "http://schema.org/RealEstateAgent";
var RealEstateListing = "http://schema.org/RealEstateListing";
var ReceiveAction = "http://schema.org/ReceiveAction";
var Recipe = "http://schema.org/Recipe";
var Recommendation = "http://schema.org/Recommendation";
var RecommendedDoseSchedule = "http://schema.org/RecommendedDoseSchedule";
var RecyclingCenter = "http://schema.org/RecyclingCenter";
var RefundTypeEnumeration = "http://schema.org/RefundTypeEnumeration";
var RegisterAction = "http://schema.org/RegisterAction";
var RejectAction = "http://schema.org/RejectAction";
var RentAction = "http://schema.org/RentAction";
var RentalCarReservation = "http://schema.org/RentalCarReservation";
var RepaymentSpecification = "http://schema.org/RepaymentSpecification";
var ReplaceAction = "http://schema.org/ReplaceAction";
var ReplyAction = "http://schema.org/ReplyAction";
var Report = "http://schema.org/Report";
var ReportageNewsArticle = "http://schema.org/ReportageNewsArticle";
var ReportedDoseSchedule = "http://schema.org/ReportedDoseSchedule";
var ResearchOrganization = "http://schema.org/ResearchOrganization";
var ResearchProject = "http://schema.org/ResearchProject";
var Researcher = "http://schema.org/Researcher";
var Reservation = "http://schema.org/Reservation";
var ReservationPackage = "http://schema.org/ReservationPackage";
var ReservationStatusType = "http://schema.org/ReservationStatusType";
var ReserveAction = "http://schema.org/ReserveAction";
var Reservoir = "http://schema.org/Reservoir";
var ResetPasswordAction = "http://schema.org/ResetPasswordAction";
var Residence = "http://schema.org/Residence";
var Resort = "http://schema.org/Resort";
var Restaurant = "http://schema.org/Restaurant";
var RestrictedDiet = "http://schema.org/RestrictedDiet";
var ResumeAction = "http://schema.org/ResumeAction";
var ReturnAction = "http://schema.org/ReturnAction";
var ReturnFeesEnumeration = "http://schema.org/ReturnFeesEnumeration";
var ReturnLabelSourceEnumeration = "http://schema.org/ReturnLabelSourceEnumeration";
var ReturnMethodEnumeration = "http://schema.org/ReturnMethodEnumeration";
var Review = "http://schema.org/Review";
var ReviewAction = "http://schema.org/ReviewAction";
var ReviewNewsArticle = "http://schema.org/ReviewNewsArticle";
var RiverBodyOfWater = "http://schema.org/RiverBodyOfWater";
var Role2 = "http://schema.org/Role";
var RoofingContractor = "http://schema.org/RoofingContractor";
var Room = "http://schema.org/Room";
var RsvpAction = "http://schema.org/RsvpAction";
var RsvpResponseType = "http://schema.org/RsvpResponseType";
var RuntimePlatform = "http://schema.org/RuntimePlatform";
var SaleEvent = "http://schema.org/SaleEvent";
var SatiricalArticle = "http://schema.org/SatiricalArticle";
var Schedule2 = "http://schema.org/Schedule";
var ScheduleAction = "http://schema.org/ScheduleAction";
var ScholarlyArticle = "http://schema.org/ScholarlyArticle";
var School = "http://schema.org/School";
var SchoolDistrict = "http://schema.org/SchoolDistrict";
var ScreeningEvent = "http://schema.org/ScreeningEvent";
var Sculpture = "http://schema.org/Sculpture";
var SeaBodyOfWater = "http://schema.org/SeaBodyOfWater";
var SearchAction = "http://schema.org/SearchAction";
var SearchRescueOrganization = "http://schema.org/SearchRescueOrganization";
var SearchResultsPage = "http://schema.org/SearchResultsPage";
var Season = "http://schema.org/Season";
var Seat = "http://schema.org/Seat";
var SeekToAction = "http://schema.org/SeekToAction";
var SelfStorage = "http://schema.org/SelfStorage";
var SellAction = "http://schema.org/SellAction";
var SendAction = "http://schema.org/SendAction";
var SequentialArt = "http://schema.org/SequentialArt";
var Series = "http://schema.org/Series";
var Service2 = "http://schema.org/Service";
var ServiceChannel = "http://schema.org/ServiceChannel";
var ServicePeriod = "http://schema.org/ServicePeriod";
var ShareAction = "http://schema.org/ShareAction";
var SheetMusic = "http://schema.org/SheetMusic";
var ShippingConditions = "http://schema.org/ShippingConditions";
var ShippingDeliveryTime = "http://schema.org/ShippingDeliveryTime";
var ShippingRateSettings = "http://schema.org/ShippingRateSettings";
var ShippingService = "http://schema.org/ShippingService";
var ShoeStore = "http://schema.org/ShoeStore";
var ShoppingCenter = "http://schema.org/ShoppingCenter";
var ShortStory = "http://schema.org/ShortStory";
var SingleFamilyResidence = "http://schema.org/SingleFamilyResidence";
var SiteNavigationElement = "http://schema.org/SiteNavigationElement";
var SizeGroupEnumeration = "http://schema.org/SizeGroupEnumeration";
var SizeSpecification = "http://schema.org/SizeSpecification";
var SizeSystemEnumeration = "http://schema.org/SizeSystemEnumeration";
var SkiResort = "http://schema.org/SkiResort";
var SocialEvent = "http://schema.org/SocialEvent";
var SocialMediaPosting = "http://schema.org/SocialMediaPosting";
var SoftwareApplication = "http://schema.org/SoftwareApplication";
var SoftwareSourceCode = "http://schema.org/SoftwareSourceCode";
var SolveMathAction = "http://schema.org/SolveMathAction";
var SomeProducts = "http://schema.org/SomeProducts";
var SpeakableSpecification = "http://schema.org/SpeakableSpecification";
var SpecialAnnouncement = "http://schema.org/SpecialAnnouncement";
var Specialty = "http://schema.org/Specialty";
var SportingGoodsStore = "http://schema.org/SportingGoodsStore";
var SportsActivityLocation = "http://schema.org/SportsActivityLocation";
var SportsClub = "http://schema.org/SportsClub";
var SportsEvent = "http://schema.org/SportsEvent";
var SportsOrganization = "http://schema.org/SportsOrganization";
var SportsTeam = "http://schema.org/SportsTeam";
var SpreadsheetDigitalDocument = "http://schema.org/SpreadsheetDigitalDocument";
var StadiumOrArena = "http://schema.org/StadiumOrArena";
var State = "http://schema.org/State";
var Statement4 = "http://schema.org/Statement";
var StatisticalPopulation = "http://schema.org/StatisticalPopulation";
var StatisticalVariable = "http://schema.org/StatisticalVariable";
var StatusEnumeration = "http://schema.org/StatusEnumeration";
var SteeringPositionValue = "http://schema.org/SteeringPositionValue";
var Store2 = "http://schema.org/Store";
var StructuredValue = "http://schema.org/StructuredValue";
var StupidType = "http://schema.org/StupidType";
var SubscribeAction = "http://schema.org/SubscribeAction";
var Substance2 = "http://schema.org/Substance";
var SubwayStation = "http://schema.org/SubwayStation";
var Suite = "http://schema.org/Suite";
var SuperficialAnatomy = "http://schema.org/SuperficialAnatomy";
var SurgicalProcedure = "http://schema.org/SurgicalProcedure";
var SuspendAction = "http://schema.org/SuspendAction";
var Syllabus = "http://schema.org/Syllabus";
var Synagogue = "http://schema.org/Synagogue";
var TVClip = "http://schema.org/TVClip";
var TVEpisode = "http://schema.org/TVEpisode";
var TVSeason = "http://schema.org/TVSeason";
var TVSeries = "http://schema.org/TVSeries";
var Table = "http://schema.org/Table";
var TakeAction = "http://schema.org/TakeAction";
var TattooParlor = "http://schema.org/TattooParlor";
var Taxi = "http://schema.org/Taxi";
var TaxiReservation = "http://schema.org/TaxiReservation";
var TaxiService = "http://schema.org/TaxiService";
var TaxiStand = "http://schema.org/TaxiStand";
var Taxon = "http://schema.org/Taxon";
var TechArticle = "http://schema.org/TechArticle";
var TelevisionChannel = "http://schema.org/TelevisionChannel";
var TelevisionStation = "http://schema.org/TelevisionStation";
var TennisComplex = "http://schema.org/TennisComplex";
var Text = "http://schema.org/Text";
var TextDigitalDocument = "http://schema.org/TextDigitalDocument";
var TextObject = "http://schema.org/TextObject";
var TheaterEvent = "http://schema.org/TheaterEvent";
var TheaterGroup = "http://schema.org/TheaterGroup";
var TherapeuticProcedure = "http://schema.org/TherapeuticProcedure";
var Thesis = "http://schema.org/Thesis";
var Thing3 = "http://schema.org/Thing";
var Ticket = "http://schema.org/Ticket";
var TieAction = "http://schema.org/TieAction";
var TierBenefitEnumeration = "http://schema.org/TierBenefitEnumeration";
var Time = "http://schema.org/Time";
var TipAction = "http://schema.org/TipAction";
var TireShop = "http://schema.org/TireShop";
var TouristAttraction = "http://schema.org/TouristAttraction";
var TouristDestination = "http://schema.org/TouristDestination";
var TouristInformationCenter = "http://schema.org/TouristInformationCenter";
var TouristTrip = "http://schema.org/TouristTrip";
var ToyStore = "http://schema.org/ToyStore";
var TrackAction = "http://schema.org/TrackAction";
var TradeAction = "http://schema.org/TradeAction";
var TrainReservation = "http://schema.org/TrainReservation";
var TrainStation = "http://schema.org/TrainStation";
var TrainTrip = "http://schema.org/TrainTrip";
var TransferAction = "http://schema.org/TransferAction";
var TravelAction = "http://schema.org/TravelAction";
var TravelAgency = "http://schema.org/TravelAgency";
var TreatmentIndication = "http://schema.org/TreatmentIndication";
var Trip = "http://schema.org/Trip";
var TypeAndQuantityNode = "http://schema.org/TypeAndQuantityNode";
var UKNonprofitType = "http://schema.org/UKNonprofitType";
var URL2 = "http://schema.org/URL";
var USNonprofitType = "http://schema.org/USNonprofitType";
var UnRegisterAction = "http://schema.org/UnRegisterAction";
var UnitPriceSpecification = "http://schema.org/UnitPriceSpecification";
var UpdateAction = "http://schema.org/UpdateAction";
var UseAction = "http://schema.org/UseAction";
var UserBlocks = "http://schema.org/UserBlocks";
var UserCheckins = "http://schema.org/UserCheckins";
var UserComments = "http://schema.org/UserComments";
var UserDownloads = "http://schema.org/UserDownloads";
var UserInteraction = "http://schema.org/UserInteraction";
var UserLikes = "http://schema.org/UserLikes";
var UserPageVisits = "http://schema.org/UserPageVisits";
var UserPlays = "http://schema.org/UserPlays";
var UserPlusOnes = "http://schema.org/UserPlusOnes";
var UserReview = "http://schema.org/UserReview";
var UserTweets = "http://schema.org/UserTweets";
var VacationRental = "http://schema.org/VacationRental";
var Vehicle = "http://schema.org/Vehicle";
var Vein = "http://schema.org/Vein";
var Vessel = "http://schema.org/Vessel";
var VeterinaryCare = "http://schema.org/VeterinaryCare";
var VideoGallery = "http://schema.org/VideoGallery";
var VideoGame = "http://schema.org/VideoGame";
var VideoGameClip = "http://schema.org/VideoGameClip";
var VideoGameSeries = "http://schema.org/VideoGameSeries";
var VideoObject = "http://schema.org/VideoObject";
var VideoObjectSnapshot = "http://schema.org/VideoObjectSnapshot";
var ViewAction = "http://schema.org/ViewAction";
var VirtualLocation = "http://schema.org/VirtualLocation";
var VisualArtsEvent = "http://schema.org/VisualArtsEvent";
var VisualArtwork = "http://schema.org/VisualArtwork";
var VitalSign = "http://schema.org/VitalSign";
var Volcano = "http://schema.org/Volcano";
var VoteAction = "http://schema.org/VoteAction";
var WPAdBlock = "http://schema.org/WPAdBlock";
var WPFooter = "http://schema.org/WPFooter";
var WPHeader = "http://schema.org/WPHeader";
var WPSideBar = "http://schema.org/WPSideBar";
var WantAction = "http://schema.org/WantAction";
var WarrantyPromise = "http://schema.org/WarrantyPromise";
var WarrantyScope = "http://schema.org/WarrantyScope";
var WatchAction = "http://schema.org/WatchAction";
var Waterfall = "http://schema.org/Waterfall";
var WearAction = "http://schema.org/WearAction";
var WearableMeasurementTypeEnumeration = "http://schema.org/WearableMeasurementTypeEnumeration";
var WearableSizeGroupEnumeration = "http://schema.org/WearableSizeGroupEnumeration";
var WearableSizeSystemEnumeration = "http://schema.org/WearableSizeSystemEnumeration";
var WebAPI = "http://schema.org/WebAPI";
var WebApplication = "http://schema.org/WebApplication";
var WebContent = "http://schema.org/WebContent";
var WebPage = "http://schema.org/WebPage";
var WebPageElement = "http://schema.org/WebPageElement";
var WebSite = "http://schema.org/WebSite";
var WholesaleStore = "http://schema.org/WholesaleStore";
var WinAction = "http://schema.org/WinAction";
var Winery = "http://schema.org/Winery";
var WorkBasedProgram = "http://schema.org/WorkBasedProgram";
var WorkersUnion = "http://schema.org/WorkersUnion";
var WriteAction = "http://schema.org/WriteAction";
var XPathType = "http://schema.org/XPathType";
var Zoo = "http://schema.org/Zoo";
var abridged = "http://schema.org/abridged";
var abstract3 = "http://schema.org/abstract";
var accelerationTime = "http://schema.org/accelerationTime";
var acceptedAnswer = "http://schema.org/acceptedAnswer";
var acceptedOffer = "http://schema.org/acceptedOffer";
var acceptedPaymentMethod = "http://schema.org/acceptedPaymentMethod";
var acceptsReservations = "http://schema.org/acceptsReservations";
var accessCode = "http://schema.org/accessCode";
var accessMode = "http://schema.org/accessMode";
var accessModeSufficient = "http://schema.org/accessModeSufficient";
var accessibilityAPI = "http://schema.org/accessibilityAPI";
var accessibilityControl = "http://schema.org/accessibilityControl";
var accessibilityFeature = "http://schema.org/accessibilityFeature";
var accessibilityHazard = "http://schema.org/accessibilityHazard";
var accessibilitySummary = "http://schema.org/accessibilitySummary";
var accommodationCategory = "http://schema.org/accommodationCategory";
var accommodationFloorPlan = "http://schema.org/accommodationFloorPlan";
var accountId = "http://schema.org/accountId";
var accountMinimumInflow = "http://schema.org/accountMinimumInflow";
var accountOverdraftLimit = "http://schema.org/accountOverdraftLimit";
var accountablePerson = "http://schema.org/accountablePerson";
var acquireLicensePage = "http://schema.org/acquireLicensePage";
var acquiredFrom = "http://schema.org/acquiredFrom";
var acrissCode = "http://schema.org/acrissCode";
var actionAccessibilityRequirement = "http://schema.org/actionAccessibilityRequirement";
var actionPlatform = "http://schema.org/actionPlatform";
var actionProcess = "http://schema.org/actionProcess";
var actionStatus = "http://schema.org/actionStatus";
var actionableFeedbackPolicy = "http://schema.org/actionableFeedbackPolicy";
var activeIngredient = "http://schema.org/activeIngredient";
var activityDuration = "http://schema.org/activityDuration";
var activityFrequency = "http://schema.org/activityFrequency";
var actors = "http://schema.org/actors";
var addOn = "http://schema.org/addOn";
var additionalName = "http://schema.org/additionalName";
var additionalNumberOfGuests = "http://schema.org/additionalNumberOfGuests";
var additionalProperty = "http://schema.org/additionalProperty";
var additionalType = "http://schema.org/additionalType";
var additionalVariable = "http://schema.org/additionalVariable";
var address3 = "http://schema.org/address";
var addressCountry = "http://schema.org/addressCountry";
var addressLocality = "http://schema.org/addressLocality";
var addressRegion = "http://schema.org/addressRegion";
var administrationRoute = "http://schema.org/administrationRoute";
var advanceBookingRequirement = "http://schema.org/advanceBookingRequirement";
var adverseOutcome = "http://schema.org/adverseOutcome";
var affectedBy = "http://schema.org/affectedBy";
var affiliation2 = "http://schema.org/affiliation";
var afterMedia = "http://schema.org/afterMedia";
var agent4 = "http://schema.org/agent";
var agentInteractionStatistic = "http://schema.org/agentInteractionStatistic";
var aggregateElement = "http://schema.org/aggregateElement";
var aggregateRating = "http://schema.org/aggregateRating";
var aircraft = "http://schema.org/aircraft";
var albumProductionType = "http://schema.org/albumProductionType";
var albumReleaseType = "http://schema.org/albumReleaseType";
var albums = "http://schema.org/albums";
var alcoholWarning = "http://schema.org/alcoholWarning";
var algorithm = "http://schema.org/algorithm";
var alignmentType = "http://schema.org/alignmentType";
var alternativeHeadline = "http://schema.org/alternativeHeadline";
var alternativeOf = "http://schema.org/alternativeOf";
var amenityFeature = "http://schema.org/amenityFeature";
var amount3 = "http://schema.org/amount";
var amountOfThisGood = "http://schema.org/amountOfThisGood";
var announcementLocation = "http://schema.org/announcementLocation";
var annualPercentageRate = "http://schema.org/annualPercentageRate";
var answerCount = "http://schema.org/answerCount";
var answerExplanation = "http://schema.org/answerExplanation";
var antagonist = "http://schema.org/antagonist";
var appearance = "http://schema.org/appearance";
var applicableCountry = "http://schema.org/applicableCountry";
var applicableLocation = "http://schema.org/applicableLocation";
var applicantLocationRequirements = "http://schema.org/applicantLocationRequirements";
var application2 = "http://schema.org/application";
var applicationCategory = "http://schema.org/applicationCategory";
var applicationContact = "http://schema.org/applicationContact";
var applicationDeadline = "http://schema.org/applicationDeadline";
var applicationStartDate = "http://schema.org/applicationStartDate";
var applicationSubCategory = "http://schema.org/applicationSubCategory";
var applicationSuite = "http://schema.org/applicationSuite";
var appliesToDeliveryMethod = "http://schema.org/appliesToDeliveryMethod";
var appliesToPaymentMethod = "http://schema.org/appliesToPaymentMethod";
var archivedAt = "http://schema.org/archivedAt";
var area = "http://schema.org/area";
var arrivalAirport = "http://schema.org/arrivalAirport";
var arrivalBoatTerminal = "http://schema.org/arrivalBoatTerminal";
var arrivalBusStop = "http://schema.org/arrivalBusStop";
var arrivalGate = "http://schema.org/arrivalGate";
var arrivalPlatform = "http://schema.org/arrivalPlatform";
var arrivalStation = "http://schema.org/arrivalStation";
var arrivalTerminal = "http://schema.org/arrivalTerminal";
var arrivalTime = "http://schema.org/arrivalTime";
var artEdition = "http://schema.org/artEdition";
var artMedium = "http://schema.org/artMedium";
var artform = "http://schema.org/artform";
var articleBody = "http://schema.org/articleBody";
var articleSection = "http://schema.org/articleSection";
var artist = "http://schema.org/artist";
var asin = "http://schema.org/asin";
var aspect = "http://schema.org/aspect";
var assembly = "http://schema.org/assembly";
var assemblyVersion = "http://schema.org/assemblyVersion";
var assesses = "http://schema.org/assesses";
var associatedAnatomy = "http://schema.org/associatedAnatomy";
var associatedArticle = "http://schema.org/associatedArticle";
var associatedClaimReview = "http://schema.org/associatedClaimReview";
var associatedDisease = "http://schema.org/associatedDisease";
var associatedMedia = "http://schema.org/associatedMedia";
var associatedMediaReview = "http://schema.org/associatedMediaReview";
var associatedPathophysiology = "http://schema.org/associatedPathophysiology";
var athlete = "http://schema.org/athlete";
var attendees = "http://schema.org/attendees";
var audienceType = "http://schema.org/audienceType";
var audio = "http://schema.org/audio";
var auditDate = "http://schema.org/auditDate";
var authenticator = "http://schema.org/authenticator";
var author3 = "http://schema.org/author";
var availability2 = "http://schema.org/availability";
var availabilityEnds = "http://schema.org/availabilityEnds";
var availabilityStarts = "http://schema.org/availabilityStarts";
var availableAtOrFrom = "http://schema.org/availableAtOrFrom";
var availableChannel = "http://schema.org/availableChannel";
var availableDeliveryMethod = "http://schema.org/availableDeliveryMethod";
var availableFrom = "http://schema.org/availableFrom";
var availableIn = "http://schema.org/availableIn";
var availableLanguage = "http://schema.org/availableLanguage";
var availableService = "http://schema.org/availableService";
var availableStrength = "http://schema.org/availableStrength";
var availableTest = "http://schema.org/availableTest";
var availableThrough = "http://schema.org/availableThrough";
var awards = "http://schema.org/awards";
var awayTeam = "http://schema.org/awayTeam";
var backstory = "http://schema.org/backstory";
var bankAccountType = "http://schema.org/bankAccountType";
var baseSalary = "http://schema.org/baseSalary";
var bccRecipient = "http://schema.org/bccRecipient";
var bed = "http://schema.org/bed";
var beforeMedia = "http://schema.org/beforeMedia";
var beneficiaryBank = "http://schema.org/beneficiaryBank";
var benefits = "http://schema.org/benefits";
var benefitsSummaryUrl = "http://schema.org/benefitsSummaryUrl";
var bestRating = "http://schema.org/bestRating";
var billingAddress = "http://schema.org/billingAddress";
var billingDuration = "http://schema.org/billingDuration";
var billingIncrement = "http://schema.org/billingIncrement";
var billingPeriod = "http://schema.org/billingPeriod";
var billingStart = "http://schema.org/billingStart";
var bioChemInteraction = "http://schema.org/bioChemInteraction";
var bioChemSimilarity = "http://schema.org/bioChemSimilarity";
var biologicalRole = "http://schema.org/biologicalRole";
var biomechnicalClass = "http://schema.org/biomechnicalClass";
var birthDate2 = "http://schema.org/birthDate";
var birthPlace = "http://schema.org/birthPlace";
var bitrate = "http://schema.org/bitrate";
var blogPosts = "http://schema.org/blogPosts";
var bloodSupply = "http://schema.org/bloodSupply";
var boardingGroup = "http://schema.org/boardingGroup";
var boardingPolicy = "http://schema.org/boardingPolicy";
var bodyLocation = "http://schema.org/bodyLocation";
var bodyType = "http://schema.org/bodyType";
var bookEdition = "http://schema.org/bookEdition";
var bookFormat = "http://schema.org/bookFormat";
var bookingAgent = "http://schema.org/bookingAgent";
var bookingTime = "http://schema.org/bookingTime";
var borrower = "http://schema.org/borrower";
var box = "http://schema.org/box";
var branch = "http://schema.org/branch";
var branchCode = "http://schema.org/branchCode";
var branchOf = "http://schema.org/branchOf";
var brand2 = "http://schema.org/brand";
var breadcrumb = "http://schema.org/breadcrumb";
var breastfeedingWarning = "http://schema.org/breastfeedingWarning";
var broadcastAffiliateOf = "http://schema.org/broadcastAffiliateOf";
var broadcastChannelId = "http://schema.org/broadcastChannelId";
var broadcastDisplayName = "http://schema.org/broadcastDisplayName";
var broadcastFrequency = "http://schema.org/broadcastFrequency";
var broadcastFrequencyValue = "http://schema.org/broadcastFrequencyValue";
var broadcastOfEvent = "http://schema.org/broadcastOfEvent";
var broadcastServiceTier = "http://schema.org/broadcastServiceTier";
var broadcastSignalModulation = "http://schema.org/broadcastSignalModulation";
var broadcastSubChannel = "http://schema.org/broadcastSubChannel";
var broadcastTimezone = "http://schema.org/broadcastTimezone";
var broadcaster = "http://schema.org/broadcaster";
var browserRequirements = "http://schema.org/browserRequirements";
var busName = "http://schema.org/busName";
var busNumber = "http://schema.org/busNumber";
var businessDays = "http://schema.org/businessDays";
var businessFunction = "http://schema.org/businessFunction";
var buyer = "http://schema.org/buyer";
var byArtist = "http://schema.org/byArtist";
var byDay = "http://schema.org/byDay";
var byMonth = "http://schema.org/byMonth";
var byMonthDay = "http://schema.org/byMonthDay";
var byMonthWeek = "http://schema.org/byMonthWeek";
var callSign = "http://schema.org/callSign";
var calories = "http://schema.org/calories";
var candidate2 = "http://schema.org/candidate";
var carbohydrateContent = "http://schema.org/carbohydrateContent";
var cargoVolume = "http://schema.org/cargoVolume";
var carrier = "http://schema.org/carrier";
var carrierRequirements = "http://schema.org/carrierRequirements";
var cashBack = "http://schema.org/cashBack";
var catalog = "http://schema.org/catalog";
var catalogNumber = "http://schema.org/catalogNumber";
var ccRecipient = "http://schema.org/ccRecipient";
var certificationIdentification = "http://schema.org/certificationIdentification";
var certificationRating = "http://schema.org/certificationRating";
var certificationStatus = "http://schema.org/certificationStatus";
var character = "http://schema.org/character";
var characterAttribute = "http://schema.org/characterAttribute";
var characterName = "http://schema.org/characterName";
var cheatCode = "http://schema.org/cheatCode";
var checkinTime = "http://schema.org/checkinTime";
var checkoutPageURLTemplate = "http://schema.org/checkoutPageURLTemplate";
var checkoutTime = "http://schema.org/checkoutTime";
var chemicalComposition = "http://schema.org/chemicalComposition";
var chemicalRole = "http://schema.org/chemicalRole";
var childMaxAge = "http://schema.org/childMaxAge";
var childMinAge = "http://schema.org/childMinAge";
var children = "http://schema.org/children";
var cholesterolContent = "http://schema.org/cholesterolContent";
var circle = "http://schema.org/circle";
var citation2 = "http://schema.org/citation";
var claimInterpreter = "http://schema.org/claimInterpreter";
var claimReviewed = "http://schema.org/claimReviewed";
var clincalPharmacology = "http://schema.org/clincalPharmacology";
var clipNumber = "http://schema.org/clipNumber";
var closes = "http://schema.org/closes";
var coach = "http://schema.org/coach";
var code2 = "http://schema.org/code";
var codeRepository = "http://schema.org/codeRepository";
var codeValue = "http://schema.org/codeValue";
var codingSystem = "http://schema.org/codingSystem";
var colleagues = "http://schema.org/colleagues";
var collection3 = "http://schema.org/collection";
var collectionSize = "http://schema.org/collectionSize";
var color2 = "http://schema.org/color";
var colorSwatch = "http://schema.org/colorSwatch";
var colorist = "http://schema.org/colorist";
var comment4 = "http://schema.org/comment";
var commentCount = "http://schema.org/commentCount";
var commentText = "http://schema.org/commentText";
var commentTime = "http://schema.org/commentTime";
var companyRegistration = "http://schema.org/companyRegistration";
var competencyRequired = "http://schema.org/competencyRequired";
var composer = "http://schema.org/composer";
var comprisedOf2 = "http://schema.org/comprisedOf";
var conditionsOfAccess = "http://schema.org/conditionsOfAccess";
var confirmationNumber = "http://schema.org/confirmationNumber";
var connectedTo = "http://schema.org/connectedTo";
var constraintProperty = "http://schema.org/constraintProperty";
var contactOption = "http://schema.org/contactOption";
var contactPoints = "http://schema.org/contactPoints";
var contactType = "http://schema.org/contactType";
var contactlessPayment = "http://schema.org/contactlessPayment";
var containedIn = "http://schema.org/containedIn";
var contentRating = "http://schema.org/contentRating";
var contentReferenceTime = "http://schema.org/contentReferenceTime";
var contentSize = "http://schema.org/contentSize";
var contentType2 = "http://schema.org/contentType";
var contentUrl = "http://schema.org/contentUrl";
var contraindication2 = "http://schema.org/contraindication";
var contributor4 = "http://schema.org/contributor";
var cookTime = "http://schema.org/cookTime";
var cookingMethod = "http://schema.org/cookingMethod";
var copyrightHolder = "http://schema.org/copyrightHolder";
var copyrightNotice = "http://schema.org/copyrightNotice";
var copyrightYear = "http://schema.org/copyrightYear";
var correction = "http://schema.org/correction";
var correctionsPolicy = "http://schema.org/correctionsPolicy";
var costCategory = "http://schema.org/costCategory";
var costCurrency = "http://schema.org/costCurrency";
var costOrigin = "http://schema.org/costOrigin";
var costPerUnit = "http://schema.org/costPerUnit";
var countriesNotSupported = "http://schema.org/countriesNotSupported";
var countriesSupported = "http://schema.org/countriesSupported";
var countryOfAssembly = "http://schema.org/countryOfAssembly";
var countryOfLastProcessing = "http://schema.org/countryOfLastProcessing";
var countryOfOrigin2 = "http://schema.org/countryOfOrigin";
var course = "http://schema.org/course";
var courseCode = "http://schema.org/courseCode";
var courseMode = "http://schema.org/courseMode";
var coursePrerequisites = "http://schema.org/coursePrerequisites";
var courseSchedule = "http://schema.org/courseSchedule";
var courseWorkload = "http://schema.org/courseWorkload";
var coverageEndTime = "http://schema.org/coverageEndTime";
var coverageStartTime = "http://schema.org/coverageStartTime";
var creativeWorkStatus = "http://schema.org/creativeWorkStatus";
var credentialCategory = "http://schema.org/credentialCategory";
var creditText = "http://schema.org/creditText";
var creditedTo = "http://schema.org/creditedTo";
var cssSelector = "http://schema.org/cssSelector";
var currenciesAccepted = "http://schema.org/currenciesAccepted";
var currency2 = "http://schema.org/currency";
var currentExchangeRate = "http://schema.org/currentExchangeRate";
var customer = "http://schema.org/customer";
var customerRemorseReturnFees = "http://schema.org/customerRemorseReturnFees";
var customerRemorseReturnLabelSource = "http://schema.org/customerRemorseReturnLabelSource";
var customerRemorseReturnShippingFeesAmount = "http://schema.org/customerRemorseReturnShippingFeesAmount";
var cutoffTime = "http://schema.org/cutoffTime";
var cvdCollectionDate = "http://schema.org/cvdCollectionDate";
var cvdFacilityCounty = "http://schema.org/cvdFacilityCounty";
var cvdFacilityId = "http://schema.org/cvdFacilityId";
var cvdNumBeds = "http://schema.org/cvdNumBeds";
var cvdNumBedsOcc = "http://schema.org/cvdNumBedsOcc";
var cvdNumC19Died = "http://schema.org/cvdNumC19Died";
var cvdNumC19HOPats = "http://schema.org/cvdNumC19HOPats";
var cvdNumC19HospPats = "http://schema.org/cvdNumC19HospPats";
var cvdNumC19MechVentPats = "http://schema.org/cvdNumC19MechVentPats";
var cvdNumC19OFMechVentPats = "http://schema.org/cvdNumC19OFMechVentPats";
var cvdNumC19OverflowPats = "http://schema.org/cvdNumC19OverflowPats";
var cvdNumICUBeds = "http://schema.org/cvdNumICUBeds";
var cvdNumICUBedsOcc = "http://schema.org/cvdNumICUBedsOcc";
var cvdNumTotBeds = "http://schema.org/cvdNumTotBeds";
var cvdNumVent = "http://schema.org/cvdNumVent";
var cvdNumVentUse = "http://schema.org/cvdNumVentUse";
var data2 = "http://schema.org/data";
var dataFeedElement = "http://schema.org/dataFeedElement";
var datasetTimeInterval = "http://schema.org/datasetTimeInterval";
var dateDeleted = "http://schema.org/dateDeleted";
var dateIssued = "http://schema.org/dateIssued";
var dateModified = "http://schema.org/dateModified";
var datePosted = "http://schema.org/datePosted";
var datePublished = "http://schema.org/datePublished";
var dateRead = "http://schema.org/dateRead";
var dateReceived = "http://schema.org/dateReceived";
var dateSent = "http://schema.org/dateSent";
var dateVehicleFirstRegistered = "http://schema.org/dateVehicleFirstRegistered";
var dateline = "http://schema.org/dateline";
var dayOfWeek2 = "http://schema.org/dayOfWeek";
var deathDate = "http://schema.org/deathDate";
var deathPlace = "http://schema.org/deathPlace";
var defaultValue2 = "http://schema.org/defaultValue";
var deliveryAddress = "http://schema.org/deliveryAddress";
var deliveryLeadTime = "http://schema.org/deliveryLeadTime";
var deliveryMethod = "http://schema.org/deliveryMethod";
var deliveryStatus = "http://schema.org/deliveryStatus";
var deliveryTime = "http://schema.org/deliveryTime";
var department = "http://schema.org/department";
var departureAirport = "http://schema.org/departureAirport";
var departureBoatTerminal = "http://schema.org/departureBoatTerminal";
var departureBusStop = "http://schema.org/departureBusStop";
var departureGate = "http://schema.org/departureGate";
var departurePlatform = "http://schema.org/departurePlatform";
var departureStation = "http://schema.org/departureStation";
var departureTerminal = "http://schema.org/departureTerminal";
var departureTime = "http://schema.org/departureTime";
var dependencies = "http://schema.org/dependencies";
var depth = "http://schema.org/depth";
var device2 = "http://schema.org/device";
var diagnosis2 = "http://schema.org/diagnosis";
var diagram = "http://schema.org/diagram";
var diet = "http://schema.org/diet";
var dietFeatures = "http://schema.org/dietFeatures";
var differentialDiagnosis = "http://schema.org/differentialDiagnosis";
var digitalSourceType = "http://schema.org/digitalSourceType";
var directApply = "http://schema.org/directApply";
var directors = "http://schema.org/directors";
var disambiguatingDescription = "http://schema.org/disambiguatingDescription";
var discount = "http://schema.org/discount";
var discountCode = "http://schema.org/discountCode";
var discountCurrency = "http://schema.org/discountCurrency";
var discusses = "http://schema.org/discusses";
var discussionUrl = "http://schema.org/discussionUrl";
var diseasePreventionInfo = "http://schema.org/diseasePreventionInfo";
var diseaseSpreadStatistics = "http://schema.org/diseaseSpreadStatistics";
var displayLocation = "http://schema.org/displayLocation";
var dissolutionDate = "http://schema.org/dissolutionDate";
var distance = "http://schema.org/distance";
var distinguishingSign = "http://schema.org/distinguishingSign";
var distribution = "http://schema.org/distribution";
var diversityPolicy = "http://schema.org/diversityPolicy";
var diversityStaffingReport = "http://schema.org/diversityStaffingReport";
var documentation2 = "http://schema.org/documentation";
var doesNotShip = "http://schema.org/doesNotShip";
var domainIncludes = "http://schema.org/domainIncludes";
var domiciledMortgage = "http://schema.org/domiciledMortgage";
var doorTime = "http://schema.org/doorTime";
var dosageForm = "http://schema.org/dosageForm";
var doseSchedule = "http://schema.org/doseSchedule";
var doseUnit = "http://schema.org/doseUnit";
var doseValue = "http://schema.org/doseValue";
var downPayment = "http://schema.org/downPayment";
var downloadUrl = "http://schema.org/downloadUrl";
var downvoteCount = "http://schema.org/downvoteCount";
var drainsTo = "http://schema.org/drainsTo";
var driveWheelConfiguration = "http://schema.org/driveWheelConfiguration";
var dropoffLocation = "http://schema.org/dropoffLocation";
var dropoffTime = "http://schema.org/dropoffTime";
var drug = "http://schema.org/drug";
var drugClass = "http://schema.org/drugClass";
var drugUnit = "http://schema.org/drugUnit";
var duns = "http://schema.org/duns";
var duplicateTherapy = "http://schema.org/duplicateTherapy";
var durationOfWarranty = "http://schema.org/durationOfWarranty";
var duringMedia = "http://schema.org/duringMedia";
var earlyPrepaymentPenalty = "http://schema.org/earlyPrepaymentPenalty";
var editEIDR = "http://schema.org/editEIDR";
var editor2 = "http://schema.org/editor";
var eduQuestionType = "http://schema.org/eduQuestionType";
var educationRequirements = "http://schema.org/educationRequirements";
var educationalAlignment = "http://schema.org/educationalAlignment";
var educationalCredentialAwarded = "http://schema.org/educationalCredentialAwarded";
var educationalFramework = "http://schema.org/educationalFramework";
var educationalLevel = "http://schema.org/educationalLevel";
var educationalProgramMode = "http://schema.org/educationalProgramMode";
var educationalRole = "http://schema.org/educationalRole";
var educationalUse = "http://schema.org/educationalUse";
var elevation = "http://schema.org/elevation";
var eligibilityToWorkRequirement = "http://schema.org/eligibilityToWorkRequirement";
var eligibleCustomerType = "http://schema.org/eligibleCustomerType";
var eligibleDuration = "http://schema.org/eligibleDuration";
var eligibleQuantity = "http://schema.org/eligibleQuantity";
var eligibleRegion = "http://schema.org/eligibleRegion";
var eligibleTransactionVolume = "http://schema.org/eligibleTransactionVolume";
var eligibleWithSupplier = "http://schema.org/eligibleWithSupplier";
var email = "http://schema.org/email";
var embedUrl = "http://schema.org/embedUrl";
var embeddedTextCaption = "http://schema.org/embeddedTextCaption";
var emissionsCO2 = "http://schema.org/emissionsCO2";
var employees = "http://schema.org/employees";
var employerOverview = "http://schema.org/employerOverview";
var employmentType = "http://schema.org/employmentType";
var employmentUnit = "http://schema.org/employmentUnit";
var encodingType = "http://schema.org/encodingType";
var encodings = "http://schema.org/encodings";
var endOffset = "http://schema.org/endOffset";
var endTime2 = "http://schema.org/endTime";
var endorsee = "http://schema.org/endorsee";
var endorsers = "http://schema.org/endorsers";
var energyEfficiencyScaleMax = "http://schema.org/energyEfficiencyScaleMax";
var energyEfficiencyScaleMin = "http://schema.org/energyEfficiencyScaleMin";
var engineDisplacement = "http://schema.org/engineDisplacement";
var enginePower = "http://schema.org/enginePower";
var engineType = "http://schema.org/engineType";
var entertainmentBusiness = "http://schema.org/entertainmentBusiness";
var epidemiology = "http://schema.org/epidemiology";
var episodeNumber = "http://schema.org/episodeNumber";
var episodes = "http://schema.org/episodes";
var equal = "http://schema.org/equal";
var error2 = "http://schema.org/error";
var errorCode = "http://schema.org/errorCode";
var estimatedCost = "http://schema.org/estimatedCost";
var estimatedFlightDuration = "http://schema.org/estimatedFlightDuration";
var estimatedSalary = "http://schema.org/estimatedSalary";
var estimatesRiskOf = "http://schema.org/estimatesRiskOf";
var ethicsPolicy = "http://schema.org/ethicsPolicy";
var eventAttendanceMode = "http://schema.org/eventAttendanceMode";
var eventSchedule = "http://schema.org/eventSchedule";
var eventStatus = "http://schema.org/eventStatus";
var events = "http://schema.org/events";
var evidenceLevel = "http://schema.org/evidenceLevel";
var evidenceOrigin = "http://schema.org/evidenceOrigin";
var exceptDate = "http://schema.org/exceptDate";
var exchangeRateSpread = "http://schema.org/exchangeRateSpread";
var exercisePlan = "http://schema.org/exercisePlan";
var exerciseRelatedDiet = "http://schema.org/exerciseRelatedDiet";
var exerciseType = "http://schema.org/exerciseType";
var exifData = "http://schema.org/exifData";
var expectedArrivalFrom = "http://schema.org/expectedArrivalFrom";
var expectedArrivalUntil = "http://schema.org/expectedArrivalUntil";
var expectedPrognosis = "http://schema.org/expectedPrognosis";
var expectsAcceptanceOf = "http://schema.org/expectsAcceptanceOf";
var experienceInPlaceOfEducation = "http://schema.org/experienceInPlaceOfEducation";
var experienceRequirements = "http://schema.org/experienceRequirements";
var expertConsiderations = "http://schema.org/expertConsiderations";
var expires = "http://schema.org/expires";
var expressedIn = "http://schema.org/expressedIn";
var extendedAddress = "http://schema.org/extendedAddress";
var familyName2 = "http://schema.org/familyName";
var fatContent = "http://schema.org/fatContent";
var faxNumber = "http://schema.org/faxNumber";
var featureList = "http://schema.org/featureList";
var feesAndCommissionsSpecification = "http://schema.org/feesAndCommissionsSpecification";
var fiberContent = "http://schema.org/fiberContent";
var fileFormat = "http://schema.org/fileFormat";
var fileSize = "http://schema.org/fileSize";
var financialAidEligible = "http://schema.org/financialAidEligible";
var firstAppearance = "http://schema.org/firstAppearance";
var firstPerformance = "http://schema.org/firstPerformance";
var flightDistance = "http://schema.org/flightDistance";
var flightNumber = "http://schema.org/flightNumber";
var floorLevel = "http://schema.org/floorLevel";
var floorLimit = "http://schema.org/floorLimit";
var floorSize = "http://schema.org/floorSize";
var followee = "http://schema.org/followee";
var follows = "http://schema.org/follows";
var followup = "http://schema.org/followup";
var foodEstablishment = "http://schema.org/foodEstablishment";
var foodEvent = "http://schema.org/foodEvent";
var foodWarning = "http://schema.org/foodWarning";
var founders = "http://schema.org/founders";
var foundingDate = "http://schema.org/foundingDate";
var foundingLocation = "http://schema.org/foundingLocation";
var free = "http://schema.org/free";
var freeShippingThreshold = "http://schema.org/freeShippingThreshold";
var fromLocation = "http://schema.org/fromLocation";
var fuelCapacity = "http://schema.org/fuelCapacity";
var fuelConsumption = "http://schema.org/fuelConsumption";
var fuelEfficiency = "http://schema.org/fuelEfficiency";
var fuelType = "http://schema.org/fuelType";
var fulfillmentType = "http://schema.org/fulfillmentType";
var functionalClass = "http://schema.org/functionalClass";
var funder = "http://schema.org/funder";
var gameAvailabilityType = "http://schema.org/gameAvailabilityType";
var gameEdition = "http://schema.org/gameEdition";
var gameItem = "http://schema.org/gameItem";
var gameLocation = "http://schema.org/gameLocation";
var gamePlatform = "http://schema.org/gamePlatform";
var gameTip = "http://schema.org/gameTip";
var gender3 = "http://schema.org/gender";
var geo2 = "http://schema.org/geo";
var geoContains = "http://schema.org/geoContains";
var geoCoveredBy = "http://schema.org/geoCoveredBy";
var geoCovers = "http://schema.org/geoCovers";
var geoCrosses = "http://schema.org/geoCrosses";
var geoDisjoint = "http://schema.org/geoDisjoint";
var geoEquals = "http://schema.org/geoEquals";
var geoIntersects = "http://schema.org/geoIntersects";
var geoMidpoint = "http://schema.org/geoMidpoint";
var geoOverlaps = "http://schema.org/geoOverlaps";
var geoRadius = "http://schema.org/geoRadius";
var geoTouches = "http://schema.org/geoTouches";
var geoWithin = "http://schema.org/geoWithin";
var geographicArea = "http://schema.org/geographicArea";
var gettingTestedInfo = "http://schema.org/gettingTestedInfo";
var givenName2 = "http://schema.org/givenName";
var globalLocationNumber = "http://schema.org/globalLocationNumber";
var governmentBenefitsInfo = "http://schema.org/governmentBenefitsInfo";
var gracePeriod = "http://schema.org/gracePeriod";
var grantee2 = "http://schema.org/grantee";
var greater = "http://schema.org/greater";
var greaterOrEqual = "http://schema.org/greaterOrEqual";
var gtin12 = "http://schema.org/gtin12";
var gtin13 = "http://schema.org/gtin13";
var gtin14 = "http://schema.org/gtin14";
var gtin8 = "http://schema.org/gtin8";
var guideline2 = "http://schema.org/guideline";
var guidelineDate = "http://schema.org/guidelineDate";
var guidelineSubject = "http://schema.org/guidelineSubject";
var handlingTime = "http://schema.org/handlingTime";
var hasAdultConsideration = "http://schema.org/hasAdultConsideration";
var hasBioPolymerSequence = "http://schema.org/hasBioPolymerSequence";
var hasCategoryCode = "http://schema.org/hasCategoryCode";
var hasCertification = "http://schema.org/hasCertification";
var hasCourse = "http://schema.org/hasCourse";
var hasCourseInstance = "http://schema.org/hasCourseInstance";
var hasCredential = "http://schema.org/hasCredential";
var hasDeliveryMethod = "http://schema.org/hasDeliveryMethod";
var hasDigitalDocumentPermission = "http://schema.org/hasDigitalDocumentPermission";
var hasDriveThroughService = "http://schema.org/hasDriveThroughService";
var hasEnergyConsumptionDetails = "http://schema.org/hasEnergyConsumptionDetails";
var hasEnergyEfficiencyCategory = "http://schema.org/hasEnergyEfficiencyCategory";
var hasGS1DigitalLink = "http://schema.org/hasGS1DigitalLink";
var hasHealthAspect = "http://schema.org/hasHealthAspect";
var hasMeasurement = "http://schema.org/hasMeasurement";
var hasMemberProgram = "http://schema.org/hasMemberProgram";
var hasMenuItem = "http://schema.org/hasMenuItem";
var hasMenuSection = "http://schema.org/hasMenuSection";
var hasMolecularFunction = "http://schema.org/hasMolecularFunction";
var hasOccupation = "http://schema.org/hasOccupation";
var hasOfferCatalog = "http://schema.org/hasOfferCatalog";
var hasPOS = "http://schema.org/hasPOS";
var hasParticipationOffer = "http://schema.org/hasParticipationOffer";
var hasProductReturnPolicy = "http://schema.org/hasProductReturnPolicy";
var hasShippingService = "http://schema.org/hasShippingService";
var hasSponsorshipOffer = "http://schema.org/hasSponsorshipOffer";
var hasStore = "http://schema.org/hasStore";
var hasTierBenefit = "http://schema.org/hasTierBenefit";
var hasTierRequirement = "http://schema.org/hasTierRequirement";
var headline = "http://schema.org/headline";
var healthCondition = "http://schema.org/healthCondition";
var healthPlanCoinsuranceOption = "http://schema.org/healthPlanCoinsuranceOption";
var healthPlanCoinsuranceRate = "http://schema.org/healthPlanCoinsuranceRate";
var healthPlanCopay = "http://schema.org/healthPlanCopay";
var healthPlanCopayOption = "http://schema.org/healthPlanCopayOption";
var healthPlanCostSharing = "http://schema.org/healthPlanCostSharing";
var healthPlanDrugOption = "http://schema.org/healthPlanDrugOption";
var healthPlanDrugTier = "http://schema.org/healthPlanDrugTier";
var healthPlanId = "http://schema.org/healthPlanId";
var healthPlanMarketingUrl = "http://schema.org/healthPlanMarketingUrl";
var healthPlanNetworkId = "http://schema.org/healthPlanNetworkId";
var healthPlanNetworkTier = "http://schema.org/healthPlanNetworkTier";
var healthPlanPharmacyCategory = "http://schema.org/healthPlanPharmacyCategory";
var healthcareReportingData = "http://schema.org/healthcareReportingData";
var height3 = "http://schema.org/height";
var highPrice = "http://schema.org/highPrice";
var hiringOrganization = "http://schema.org/hiringOrganization";
var homeLocation = "http://schema.org/homeLocation";
var homeTeam = "http://schema.org/homeTeam";
var honorificPrefix = "http://schema.org/honorificPrefix";
var honorificSuffix = "http://schema.org/honorificSuffix";
var hospitalAffiliation = "http://schema.org/hospitalAffiliation";
var hostingOrganization = "http://schema.org/hostingOrganization";
var hoursAvailable = "http://schema.org/hoursAvailable";
var howPerformed = "http://schema.org/howPerformed";
var httpMethod = "http://schema.org/httpMethod";
var iataCode = "http://schema.org/iataCode";
var icaoCode = "http://schema.org/icaoCode";
var identifyingExam = "http://schema.org/identifyingExam";
var identifyingTest = "http://schema.org/identifyingTest";
var illustrator = "http://schema.org/illustrator";
var imagingTechnique = "http://schema.org/imagingTechnique";
var inAlbum = "http://schema.org/inAlbum";
var inBroadcastLineup = "http://schema.org/inBroadcastLineup";
var inChI = "http://schema.org/inChI";
var inChIKey = "http://schema.org/inChIKey";
var inCodeSet = "http://schema.org/inCodeSet";
var inPlaylist = "http://schema.org/inPlaylist";
var inProductGroupWithID = "http://schema.org/inProductGroupWithID";
var inStoreReturnsOffered = "http://schema.org/inStoreReturnsOffered";
var inSupportOf = "http://schema.org/inSupportOf";
var incentiveAmount = "http://schema.org/incentiveAmount";
var incentiveStatus = "http://schema.org/incentiveStatus";
var incentiveType = "http://schema.org/incentiveType";
var incentives = "http://schema.org/incentives";
var incentivizedItem = "http://schema.org/incentivizedItem";
var includedComposition = "http://schema.org/includedComposition";
var includedDataCatalog = "http://schema.org/includedDataCatalog";
var includedInHealthInsurancePlan = "http://schema.org/includedInHealthInsurancePlan";
var includedRiskFactor = "http://schema.org/includedRiskFactor";
var includesAttraction = "http://schema.org/includesAttraction";
var includesHealthPlanFormulary = "http://schema.org/includesHealthPlanFormulary";
var includesHealthPlanNetwork = "http://schema.org/includesHealthPlanNetwork";
var includesObject = "http://schema.org/includesObject";
var incomeLimit = "http://schema.org/incomeLimit";
var increasesRiskOf = "http://schema.org/increasesRiskOf";
var industry = "http://schema.org/industry";
var ineligibleRegion = "http://schema.org/ineligibleRegion";
var infectiousAgent = "http://schema.org/infectiousAgent";
var infectiousAgentClass = "http://schema.org/infectiousAgentClass";
var ingredients = "http://schema.org/ingredients";
var inker = "http://schema.org/inker";
var insertion = "http://schema.org/insertion";
var installUrl = "http://schema.org/installUrl";
var instructor = "http://schema.org/instructor";
var intensity = "http://schema.org/intensity";
var interactingDrug = "http://schema.org/interactingDrug";
var interactionCount = "http://schema.org/interactionCount";
var interactionService = "http://schema.org/interactionService";
var interactionType = "http://schema.org/interactionType";
var interactivityType = "http://schema.org/interactivityType";
var interestRate = "http://schema.org/interestRate";
var interpretedAsClaim = "http://schema.org/interpretedAsClaim";
var inventoryLevel = "http://schema.org/inventoryLevel";
var inverseOf2 = "http://schema.org/inverseOf";
var isAcceptingNewPatients = "http://schema.org/isAcceptingNewPatients";
var isAccessoryOrSparePartFor = "http://schema.org/isAccessoryOrSparePartFor";
var isAvailableGenerically = "http://schema.org/isAvailableGenerically";
var isBasedOnUrl = "http://schema.org/isBasedOnUrl";
var isConsumableFor = "http://schema.org/isConsumableFor";
var isFamilyFriendly = "http://schema.org/isFamilyFriendly";
var isGift = "http://schema.org/isGift";
var isInvolvedInBiologicalProcess = "http://schema.org/isInvolvedInBiologicalProcess";
var isLiveBroadcast = "http://schema.org/isLiveBroadcast";
var isLocatedInSubcellularLocation = "http://schema.org/isLocatedInSubcellularLocation";
var isPlanForApartment = "http://schema.org/isPlanForApartment";
var isProprietary = "http://schema.org/isProprietary";
var isRelatedTo = "http://schema.org/isRelatedTo";
var isResizable = "http://schema.org/isResizable";
var isSimilarTo = "http://schema.org/isSimilarTo";
var isStoreOn = "http://schema.org/isStoreOn";
var isUnlabelledFallback = "http://schema.org/isUnlabelledFallback";
var isbn = "http://schema.org/isbn";
var isicV4 = "http://schema.org/isicV4";
var iso6523Code = "http://schema.org/iso6523Code";
var isrcCode = "http://schema.org/isrcCode";
var issn = "http://schema.org/issn";
var issueNumber = "http://schema.org/issueNumber";
var issuedBy = "http://schema.org/issuedBy";
var issuedThrough = "http://schema.org/issuedThrough";
var iswcCode = "http://schema.org/iswcCode";
var item2 = "http://schema.org/item";
var itemCondition = "http://schema.org/itemCondition";
var itemDefectReturnFees = "http://schema.org/itemDefectReturnFees";
var itemDefectReturnLabelSource = "http://schema.org/itemDefectReturnLabelSource";
var itemDefectReturnShippingFeesAmount = "http://schema.org/itemDefectReturnShippingFeesAmount";
var itemListElement = "http://schema.org/itemListElement";
var itemListOrder = "http://schema.org/itemListOrder";
var itemLocation = "http://schema.org/itemLocation";
var itemReviewed = "http://schema.org/itemReviewed";
var itemShipped = "http://schema.org/itemShipped";
var itinerary = "http://schema.org/itinerary";
var iupacName = "http://schema.org/iupacName";
var jobDuration = "http://schema.org/jobDuration";
var jobImmediateStart = "http://schema.org/jobImmediateStart";
var jobLocation = "http://schema.org/jobLocation";
var jobLocationType = "http://schema.org/jobLocationType";
var jobStartDate = "http://schema.org/jobStartDate";
var jobTitle = "http://schema.org/jobTitle";
var keywords = "http://schema.org/keywords";
var knownVehicleDamages = "http://schema.org/knownVehicleDamages";
var knows2 = "http://schema.org/knows";
var knowsAbout = "http://schema.org/knowsAbout";
var knowsLanguage = "http://schema.org/knowsLanguage";
var labelDetails = "http://schema.org/labelDetails";
var landlord = "http://schema.org/landlord";
var language5 = "http://schema.org/language";
var lastReviewed = "http://schema.org/lastReviewed";
var latitude3 = "http://schema.org/latitude";
var layoutImage = "http://schema.org/layoutImage";
var learningResourceType = "http://schema.org/learningResourceType";
var leaseLength = "http://schema.org/leaseLength";
var legalAddress = "http://schema.org/legalAddress";
var legalName = "http://schema.org/legalName";
var legalRepresentative = "http://schema.org/legalRepresentative";
var legalStatus = "http://schema.org/legalStatus";
var legislationAmends = "http://schema.org/legislationAmends";
var legislationCommences = "http://schema.org/legislationCommences";
var legislationConsolidates = "http://schema.org/legislationConsolidates";
var legislationCorrects = "http://schema.org/legislationCorrects";
var legislationCountersignedBy = "http://schema.org/legislationCountersignedBy";
var legislationDate = "http://schema.org/legislationDate";
var legislationDateOfApplicability = "http://schema.org/legislationDateOfApplicability";
var legislationDateVersion = "http://schema.org/legislationDateVersion";
var legislationEnsuresImplementationOf = "http://schema.org/legislationEnsuresImplementationOf";
var legislationIdentifier = "http://schema.org/legislationIdentifier";
var legislationJurisdiction = "http://schema.org/legislationJurisdiction";
var legislationLegalForce = "http://schema.org/legislationLegalForce";
var legislationLegalValue = "http://schema.org/legislationLegalValue";
var legislationPassedBy = "http://schema.org/legislationPassedBy";
var legislationRepeals = "http://schema.org/legislationRepeals";
var legislationResponsible = "http://schema.org/legislationResponsible";
var legislationTransposes = "http://schema.org/legislationTransposes";
var legislationType = "http://schema.org/legislationType";
var leiCode = "http://schema.org/leiCode";
var lender = "http://schema.org/lender";
var lesser = "http://schema.org/lesser";
var lesserOrEqual = "http://schema.org/lesserOrEqual";
var letterer = "http://schema.org/letterer";
var license3 = "http://schema.org/license";
var lifeEvent = "http://schema.org/lifeEvent";
var line2 = "http://schema.org/line";
var linkRelationship = "http://schema.org/linkRelationship";
var liveBlogUpdate = "http://schema.org/liveBlogUpdate";
var loanMortgageMandateAmount = "http://schema.org/loanMortgageMandateAmount";
var loanPaymentAmount = "http://schema.org/loanPaymentAmount";
var loanPaymentFrequency = "http://schema.org/loanPaymentFrequency";
var loanRepaymentForm = "http://schema.org/loanRepaymentForm";
var loanTerm = "http://schema.org/loanTerm";
var loanType = "http://schema.org/loanType";
var locationCreated = "http://schema.org/locationCreated";
var lodgingUnitDescription = "http://schema.org/lodgingUnitDescription";
var lodgingUnitType = "http://schema.org/lodgingUnitType";
var logo2 = "http://schema.org/logo";
var longitude3 = "http://schema.org/longitude";
var loser = "http://schema.org/loser";
var lowPrice = "http://schema.org/lowPrice";
var lyricist = "http://schema.org/lyricist";
var lyrics = "http://schema.org/lyrics";
var maintainer = "http://schema.org/maintainer";
var manufacturer2 = "http://schema.org/manufacturer";
var map3 = "http://schema.org/map";
var mapType = "http://schema.org/mapType";
var maps = "http://schema.org/maps";
var marginOfError = "http://schema.org/marginOfError";
var masthead = "http://schema.org/masthead";
var materialExtent = "http://schema.org/materialExtent";
var mathExpression = "http://schema.org/mathExpression";
var maxPrice = "http://schema.org/maxPrice";
var maxValue2 = "http://schema.org/maxValue";
var maximumAttendeeCapacity = "http://schema.org/maximumAttendeeCapacity";
var maximumEnrollment = "http://schema.org/maximumEnrollment";
var maximumIntake = "http://schema.org/maximumIntake";
var maximumPhysicalAttendeeCapacity = "http://schema.org/maximumPhysicalAttendeeCapacity";
var maximumVirtualAttendeeCapacity = "http://schema.org/maximumVirtualAttendeeCapacity";
var mealService = "http://schema.org/mealService";
var measuredProperty = "http://schema.org/measuredProperty";
var measurementDenominator = "http://schema.org/measurementDenominator";
var measurementMethod = "http://schema.org/measurementMethod";
var measurementQualifier = "http://schema.org/measurementQualifier";
var mechanismOfAction = "http://schema.org/mechanismOfAction";
var mediaAuthenticityCategory = "http://schema.org/mediaAuthenticityCategory";
var mediaItemAppearance = "http://schema.org/mediaItemAppearance";
var median = "http://schema.org/median";
var medicalAudience = "http://schema.org/medicalAudience";
var medicalSpecialty = "http://schema.org/medicalSpecialty";
var medicineSystem = "http://schema.org/medicineSystem";
var meetsEmissionStandard = "http://schema.org/meetsEmissionStandard";
var members2 = "http://schema.org/members";
var membershipNumber = "http://schema.org/membershipNumber";
var membershipPointsEarned = "http://schema.org/membershipPointsEarned";
var memoryRequirements = "http://schema.org/memoryRequirements";
var mentions = "http://schema.org/mentions";
var menu = "http://schema.org/menu";
var menuAddOn = "http://schema.org/menuAddOn";
var merchant = "http://schema.org/merchant";
var messageAttachment = "http://schema.org/messageAttachment";
var mileageFromOdometer = "http://schema.org/mileageFromOdometer";
var minPrice = "http://schema.org/minPrice";
var minValue2 = "http://schema.org/minValue";
var minimumPaymentDue = "http://schema.org/minimumPaymentDue";
var missionCoveragePrioritiesPolicy = "http://schema.org/missionCoveragePrioritiesPolicy";
var mobileUrl = "http://schema.org/mobileUrl";
var model = "http://schema.org/model";
var modelDate = "http://schema.org/modelDate";
var modifiedTime = "http://schema.org/modifiedTime";
var molecularFormula2 = "http://schema.org/molecularFormula";
var molecularWeight2 = "http://schema.org/molecularWeight";
var monoisotopicMolecularWeight = "http://schema.org/monoisotopicMolecularWeight";
var monthlyMinimumRepaymentAmount = "http://schema.org/monthlyMinimumRepaymentAmount";
var monthsOfExperience = "http://schema.org/monthsOfExperience";
var mpn = "http://schema.org/mpn";
var multipleValues = "http://schema.org/multipleValues";
var muscleAction = "http://schema.org/muscleAction";
var musicArrangement = "http://schema.org/musicArrangement";
var musicBy = "http://schema.org/musicBy";
var musicCompositionForm = "http://schema.org/musicCompositionForm";
var musicGroupMember = "http://schema.org/musicGroupMember";
var musicReleaseFormat = "http://schema.org/musicReleaseFormat";
var musicalKey = "http://schema.org/musicalKey";
var naics = "http://schema.org/naics";
var name4 = "http://schema.org/name";
var namedPosition = "http://schema.org/namedPosition";
var nationality = "http://schema.org/nationality";
var naturalProgression = "http://schema.org/naturalProgression";
var negativeNotes = "http://schema.org/negativeNotes";
var nerve = "http://schema.org/nerve";
var nerveMotor = "http://schema.org/nerveMotor";
var netWorth = "http://schema.org/netWorth";
var newsUpdatesAndGuidelines = "http://schema.org/newsUpdatesAndGuidelines";
var nextItem = "http://schema.org/nextItem";
var noBylinesPolicy = "http://schema.org/noBylinesPolicy";
var nonEqual = "http://schema.org/nonEqual";
var nonProprietaryName = "http://schema.org/nonProprietaryName";
var nonprofitStatus = "http://schema.org/nonprofitStatus";
var normalRange = "http://schema.org/normalRange";
var nsn = "http://schema.org/nsn";
var numAdults = "http://schema.org/numAdults";
var numChildren = "http://schema.org/numChildren";
var numConstraints = "http://schema.org/numConstraints";
var numItems = "http://schema.org/numItems";
var numTracks = "http://schema.org/numTracks";
var numberOfAccommodationUnits = "http://schema.org/numberOfAccommodationUnits";
var numberOfAirbags = "http://schema.org/numberOfAirbags";
var numberOfAvailableAccommodationUnits = "http://schema.org/numberOfAvailableAccommodationUnits";
var numberOfAxles = "http://schema.org/numberOfAxles";
var numberOfBathroomsTotal = "http://schema.org/numberOfBathroomsTotal";
var numberOfBedrooms = "http://schema.org/numberOfBedrooms";
var numberOfBeds = "http://schema.org/numberOfBeds";
var numberOfCredits = "http://schema.org/numberOfCredits";
var numberOfDoors = "http://schema.org/numberOfDoors";
var numberOfEmployees = "http://schema.org/numberOfEmployees";
var numberOfEpisodes = "http://schema.org/numberOfEpisodes";
var numberOfForwardGears = "http://schema.org/numberOfForwardGears";
var numberOfFullBathrooms = "http://schema.org/numberOfFullBathrooms";
var numberOfItems = "http://schema.org/numberOfItems";
var numberOfLoanPayments = "http://schema.org/numberOfLoanPayments";
var numberOfPages = "http://schema.org/numberOfPages";
var numberOfPartialBathrooms = "http://schema.org/numberOfPartialBathrooms";
var numberOfPlayers = "http://schema.org/numberOfPlayers";
var numberOfPreviousOwners = "http://schema.org/numberOfPreviousOwners";
var numberOfRooms = "http://schema.org/numberOfRooms";
var numberOfSeasons = "http://schema.org/numberOfSeasons";
var numberedPosition = "http://schema.org/numberedPosition";
var nutrition = "http://schema.org/nutrition";
var observationAbout = "http://schema.org/observationAbout";
var observationDate = "http://schema.org/observationDate";
var observationPeriod = "http://schema.org/observationPeriod";
var occupancy = "http://schema.org/occupancy";
var occupationLocation = "http://schema.org/occupationLocation";
var occupationalCategory = "http://schema.org/occupationalCategory";
var occupationalCredentialAwarded = "http://schema.org/occupationalCredentialAwarded";
var offerCount = "http://schema.org/offerCount";
var offersPrescriptionByMail = "http://schema.org/offersPrescriptionByMail";
var openingHours = "http://schema.org/openingHours";
var openingHoursSpecification = "http://schema.org/openingHoursSpecification";
var opens = "http://schema.org/opens";
var operatingSystem = "http://schema.org/operatingSystem";
var opponent = "http://schema.org/opponent";
var option3 = "http://schema.org/option";
var orderDate = "http://schema.org/orderDate";
var orderDelivery = "http://schema.org/orderDelivery";
var orderItemNumber = "http://schema.org/orderItemNumber";
var orderItemStatus = "http://schema.org/orderItemStatus";
var orderNumber = "http://schema.org/orderNumber";
var orderPercentage = "http://schema.org/orderPercentage";
var orderQuantity = "http://schema.org/orderQuantity";
var orderStatus = "http://schema.org/orderStatus";
var orderValue = "http://schema.org/orderValue";
var orderedItem = "http://schema.org/orderedItem";
var organizer2 = "http://schema.org/organizer";
var originAddress = "http://schema.org/originAddress";
var originalMediaContextDescription = "http://schema.org/originalMediaContextDescription";
var originalMediaLink = "http://schema.org/originalMediaLink";
var originatesFrom = "http://schema.org/originatesFrom";
var overdosage = "http://schema.org/overdosage";
var ownedFrom = "http://schema.org/ownedFrom";
var ownedThrough = "http://schema.org/ownedThrough";
var ownershipFundingInfo = "http://schema.org/ownershipFundingInfo";
var pageEnd = "http://schema.org/pageEnd";
var pageStart = "http://schema.org/pageStart";
var pagination = "http://schema.org/pagination";
var parentItem = "http://schema.org/parentItem";
var parentService = "http://schema.org/parentService";
var parents = "http://schema.org/parents";
var partOfEpisode = "http://schema.org/partOfEpisode";
var partOfInvoice = "http://schema.org/partOfInvoice";
var partOfOrder = "http://schema.org/partOfOrder";
var partOfSeason = "http://schema.org/partOfSeason";
var partOfSystem = "http://schema.org/partOfSystem";
var partOfTVSeries = "http://schema.org/partOfTVSeries";
var partySize = "http://schema.org/partySize";
var passengerPriorityStatus = "http://schema.org/passengerPriorityStatus";
var passengerSequenceNumber = "http://schema.org/passengerSequenceNumber";
var pathophysiology = "http://schema.org/pathophysiology";
var pattern2 = "http://schema.org/pattern";
var payload2 = "http://schema.org/payload";
var paymentAccepted = "http://schema.org/paymentAccepted";
var paymentDue = "http://schema.org/paymentDue";
var paymentMethod = "http://schema.org/paymentMethod";
var paymentMethodId = "http://schema.org/paymentMethodId";
var paymentMethodType = "http://schema.org/paymentMethodType";
var paymentStatus2 = "http://schema.org/paymentStatus";
var paymentUrl = "http://schema.org/paymentUrl";
var penciler = "http://schema.org/penciler";
var percentile10 = "http://schema.org/percentile10";
var percentile25 = "http://schema.org/percentile25";
var percentile75 = "http://schema.org/percentile75";
var percentile90 = "http://schema.org/percentile90";
var performerIn = "http://schema.org/performerIn";
var performers = "http://schema.org/performers";
var permissionType = "http://schema.org/permissionType";
var permissions = "http://schema.org/permissions";
var permitAudience = "http://schema.org/permitAudience";
var permittedUsage = "http://schema.org/permittedUsage";
var petsAllowed = "http://schema.org/petsAllowed";
var phoneticText = "http://schema.org/phoneticText";
var photos = "http://schema.org/photos";
var physicalRequirement = "http://schema.org/physicalRequirement";
var physiologicalBenefits = "http://schema.org/physiologicalBenefits";
var pickupLocation = "http://schema.org/pickupLocation";
var pickupTime = "http://schema.org/pickupTime";
var playMode = "http://schema.org/playMode";
var playerType = "http://schema.org/playerType";
var playersOnline = "http://schema.org/playersOnline";
var polygon = "http://schema.org/polygon";
var populationType = "http://schema.org/populationType";
var positiveNotes = "http://schema.org/positiveNotes";
var possibleComplication = "http://schema.org/possibleComplication";
var possibleTreatment = "http://schema.org/possibleTreatment";
var postOfficeBoxNumber = "http://schema.org/postOfficeBoxNumber";
var postOp = "http://schema.org/postOp";
var postalCode2 = "http://schema.org/postalCode";
var postalCodeBegin = "http://schema.org/postalCodeBegin";
var postalCodeEnd = "http://schema.org/postalCodeEnd";
var postalCodePrefix = "http://schema.org/postalCodePrefix";
var postalCodeRange = "http://schema.org/postalCodeRange";
var potentialAction = "http://schema.org/potentialAction";
var potentialUse = "http://schema.org/potentialUse";
var practicesAt = "http://schema.org/practicesAt";
var preOp = "http://schema.org/preOp";
var predecessorOf = "http://schema.org/predecessorOf";
var pregnancyCategory = "http://schema.org/pregnancyCategory";
var pregnancyWarning = "http://schema.org/pregnancyWarning";
var prepTime = "http://schema.org/prepTime";
var preparation2 = "http://schema.org/preparation";
var prescribingInfo = "http://schema.org/prescribingInfo";
var prescriptionStatus = "http://schema.org/prescriptionStatus";
var previousItem = "http://schema.org/previousItem";
var previousStartDate = "http://schema.org/previousStartDate";
var price = "http://schema.org/price";
var priceComponent2 = "http://schema.org/priceComponent";
var priceComponentType = "http://schema.org/priceComponentType";
var priceCurrency = "http://schema.org/priceCurrency";
var priceRange = "http://schema.org/priceRange";
var priceSpecification = "http://schema.org/priceSpecification";
var priceType = "http://schema.org/priceType";
var priceValidUntil = "http://schema.org/priceValidUntil";
var primaryImageOfPage = "http://schema.org/primaryImageOfPage";
var primaryPrevention = "http://schema.org/primaryPrevention";
var printColumn = "http://schema.org/printColumn";
var printEdition = "http://schema.org/printEdition";
var printPage = "http://schema.org/printPage";
var printSection = "http://schema.org/printSection";
var procedure2 = "http://schema.org/procedure";
var procedureType = "http://schema.org/procedureType";
var processingTime = "http://schema.org/processingTime";
var processorRequirements = "http://schema.org/processorRequirements";
var producer = "http://schema.org/producer";
var produces = "http://schema.org/produces";
var productGroupID = "http://schema.org/productGroupID";
var productID = "http://schema.org/productID";
var productReturnDays = "http://schema.org/productReturnDays";
var productReturnLink = "http://schema.org/productReturnLink";
var productSupported = "http://schema.org/productSupported";
var productionCompany = "http://schema.org/productionCompany";
var productionDate = "http://schema.org/productionDate";
var proficiencyLevel = "http://schema.org/proficiencyLevel";
var program2 = "http://schema.org/program";
var programMembershipUsed = "http://schema.org/programMembershipUsed";
var programName = "http://schema.org/programName";
var programPrerequisites = "http://schema.org/programPrerequisites";
var programType = "http://schema.org/programType";
var programmingLanguage = "http://schema.org/programmingLanguage";
var programmingModel = "http://schema.org/programmingModel";
var pronouns = "http://schema.org/pronouns";
var propertyID = "http://schema.org/propertyID";
var proprietaryName = "http://schema.org/proprietaryName";
var proteinContent = "http://schema.org/proteinContent";
var providerMobility = "http://schema.org/providerMobility";
var providesService = "http://schema.org/providesService";
var publicAccess = "http://schema.org/publicAccess";
var publicTransportClosuresInfo = "http://schema.org/publicTransportClosuresInfo";
var publication = "http://schema.org/publication";
var publicationType = "http://schema.org/publicationType";
var publishedBy = "http://schema.org/publishedBy";
var publishedOn = "http://schema.org/publishedOn";
var publisher4 = "http://schema.org/publisher";
var publisherImprint = "http://schema.org/publisherImprint";
var purchaseDate = "http://schema.org/purchaseDate";
var purchasePriceLimit = "http://schema.org/purchasePriceLimit";
var purchaseType = "http://schema.org/purchaseType";
var qualifications = "http://schema.org/qualifications";
var qualifiedExpense = "http://schema.org/qualifiedExpense";
var quarantineGuidelines = "http://schema.org/quarantineGuidelines";
var query2 = "http://schema.org/query";
var quest = "http://schema.org/quest";
var question2 = "http://schema.org/question";
var rangeIncludes = "http://schema.org/rangeIncludes";
var ratingCount = "http://schema.org/ratingCount";
var ratingExplanation = "http://schema.org/ratingExplanation";
var ratingValue = "http://schema.org/ratingValue";
var readBy = "http://schema.org/readBy";
var readonlyValue = "http://schema.org/readonlyValue";
var realEstateAgent = "http://schema.org/realEstateAgent";
var recipe = "http://schema.org/recipe";
var recipeCategory = "http://schema.org/recipeCategory";
var recipeCuisine = "http://schema.org/recipeCuisine";
var recipeInstructions = "http://schema.org/recipeInstructions";
var recipeYield = "http://schema.org/recipeYield";
var recognizedBy = "http://schema.org/recognizedBy";
var recognizingAuthority = "http://schema.org/recognizingAuthority";
var recommendationStrength = "http://schema.org/recommendationStrength";
var recommendedIntake = "http://schema.org/recommendedIntake";
var recordLabel = "http://schema.org/recordLabel";
var recourseLoan = "http://schema.org/recourseLoan";
var referee = "http://schema.org/referee";
var referenceQuantity = "http://schema.org/referenceQuantity";
var referencesOrder = "http://schema.org/referencesOrder";
var refundType = "http://schema.org/refundType";
var regionDrained = "http://schema.org/regionDrained";
var regionsAllowed = "http://schema.org/regionsAllowed";
var relatedAnatomy = "http://schema.org/relatedAnatomy";
var relatedCondition = "http://schema.org/relatedCondition";
var relatedDrug = "http://schema.org/relatedDrug";
var relatedLink = "http://schema.org/relatedLink";
var relatedStructure = "http://schema.org/relatedStructure";
var relatedTherapy = "http://schema.org/relatedTherapy";
var relatedTo2 = "http://schema.org/relatedTo";
var releaseDate2 = "http://schema.org/releaseDate";
var releaseNotes = "http://schema.org/releaseNotes";
var releasedEvent = "http://schema.org/releasedEvent";
var relevantOccupation = "http://schema.org/relevantOccupation";
var relevantSpecialty = "http://schema.org/relevantSpecialty";
var remainingAttendeeCapacity = "http://schema.org/remainingAttendeeCapacity";
var renegotiableLoan = "http://schema.org/renegotiableLoan";
var repeatCount = "http://schema.org/repeatCount";
var repeatFrequency = "http://schema.org/repeatFrequency";
var repetitions2 = "http://schema.org/repetitions";
var replacee = "http://schema.org/replacee";
var replacer = "http://schema.org/replacer";
var replyToUrl = "http://schema.org/replyToUrl";
var reportNumber = "http://schema.org/reportNumber";
var representativeOfPage = "http://schema.org/representativeOfPage";
var requiredCollateral = "http://schema.org/requiredCollateral";
var requiredGender = "http://schema.org/requiredGender";
var requiredMaxAge = "http://schema.org/requiredMaxAge";
var requiredMinAge = "http://schema.org/requiredMinAge";
var requiredQuantity = "http://schema.org/requiredQuantity";
var requirements2 = "http://schema.org/requirements";
var requiresSubscription = "http://schema.org/requiresSubscription";
var reservationFor = "http://schema.org/reservationFor";
var reservationId = "http://schema.org/reservationId";
var reservationStatus = "http://schema.org/reservationStatus";
var reservedTicket = "http://schema.org/reservedTicket";
var responsibilities = "http://schema.org/responsibilities";
var restPeriods = "http://schema.org/restPeriods";
var restockingFee = "http://schema.org/restockingFee";
var resultComment = "http://schema.org/resultComment";
var resultReview = "http://schema.org/resultReview";
var returnFees = "http://schema.org/returnFees";
var returnLabelSource = "http://schema.org/returnLabelSource";
var returnMethod = "http://schema.org/returnMethod";
var returnPolicyCategory = "http://schema.org/returnPolicyCategory";
var returnPolicyCountry = "http://schema.org/returnPolicyCountry";
var returnPolicySeasonalOverride = "http://schema.org/returnPolicySeasonalOverride";
var returnShippingFeesAmount = "http://schema.org/returnShippingFeesAmount";
var reviewAspect = "http://schema.org/reviewAspect";
var reviewBody = "http://schema.org/reviewBody";
var reviewCount = "http://schema.org/reviewCount";
var reviewRating = "http://schema.org/reviewRating";
var reviewedBy = "http://schema.org/reviewedBy";
var reviews = "http://schema.org/reviews";
var riskFactor = "http://schema.org/riskFactor";
var risks = "http://schema.org/risks";
var roofLoad = "http://schema.org/roofLoad";
var rsvpResponse = "http://schema.org/rsvpResponse";
var runsTo = "http://schema.org/runsTo";
var runtime = "http://schema.org/runtime";
var rxcui = "http://schema.org/rxcui";
var safetyConsideration = "http://schema.org/safetyConsideration";
var salaryCurrency = "http://schema.org/salaryCurrency";
var salaryUponCompletion = "http://schema.org/salaryUponCompletion";
var sameAs2 = "http://schema.org/sameAs";
var sampleType = "http://schema.org/sampleType";
var saturatedFatContent = "http://schema.org/saturatedFatContent";
var scheduleTimezone = "http://schema.org/scheduleTimezone";
var scheduledPaymentDate = "http://schema.org/scheduledPaymentDate";
var scheduledTime = "http://schema.org/scheduledTime";
var schemaVersion = "http://schema.org/schemaVersion";
var schoolClosuresInfo = "http://schema.org/schoolClosuresInfo";
var screenCount = "http://schema.org/screenCount";
var screenshot = "http://schema.org/screenshot";
var sdDatePublished = "http://schema.org/sdDatePublished";
var sdLicense = "http://schema.org/sdLicense";
var sdPublisher = "http://schema.org/sdPublisher";
var seasonNumber = "http://schema.org/seasonNumber";
var seasonalOverride = "http://schema.org/seasonalOverride";
var seasons = "http://schema.org/seasons";
var seatNumber = "http://schema.org/seatNumber";
var seatRow = "http://schema.org/seatRow";
var seatSection = "http://schema.org/seatSection";
var seatingCapacity = "http://schema.org/seatingCapacity";
var seatingType = "http://schema.org/seatingType";
var secondaryPrevention = "http://schema.org/secondaryPrevention";
var securityClearanceRequirement = "http://schema.org/securityClearanceRequirement";
var securityScreening = "http://schema.org/securityScreening";
var seeks = "http://schema.org/seeks";
var sender2 = "http://schema.org/sender";
var sensoryRequirement = "http://schema.org/sensoryRequirement";
var sensoryUnit = "http://schema.org/sensoryUnit";
var seriousAdverseOutcome = "http://schema.org/seriousAdverseOutcome";
var serverStatus = "http://schema.org/serverStatus";
var servesCuisine = "http://schema.org/servesCuisine";
var serviceAudience = "http://schema.org/serviceAudience";
var serviceLocation = "http://schema.org/serviceLocation";
var serviceOperator = "http://schema.org/serviceOperator";
var servicePhone = "http://schema.org/servicePhone";
var servicePostalAddress = "http://schema.org/servicePostalAddress";
var serviceSmsNumber = "http://schema.org/serviceSmsNumber";
var serviceType2 = "http://schema.org/serviceType";
var serviceUrl = "http://schema.org/serviceUrl";
var servingSize = "http://schema.org/servingSize";
var sha256 = "http://schema.org/sha256";
var sharedContent = "http://schema.org/sharedContent";
var shippingConditions = "http://schema.org/shippingConditions";
var shippingDestination = "http://schema.org/shippingDestination";
var shippingDetails = "http://schema.org/shippingDetails";
var shippingLabel = "http://schema.org/shippingLabel";
var shippingOrigin = "http://schema.org/shippingOrigin";
var shippingRate = "http://schema.org/shippingRate";
var shippingSettingsLink = "http://schema.org/shippingSettingsLink";
var siblings = "http://schema.org/siblings";
var signDetected = "http://schema.org/signDetected";
var signOrSymptom = "http://schema.org/signOrSymptom";
var significance = "http://schema.org/significance";
var significantLinks = "http://schema.org/significantLinks";
var size2 = "http://schema.org/size";
var sizeGroup = "http://schema.org/sizeGroup";
var sizeSystem = "http://schema.org/sizeSystem";
var skills = "http://schema.org/skills";
var sku = "http://schema.org/sku";
var slogan = "http://schema.org/slogan";
var smiles = "http://schema.org/smiles";
var smokingAllowed = "http://schema.org/smokingAllowed";
var sodiumContent = "http://schema.org/sodiumContent";
var softwareAddOn = "http://schema.org/softwareAddOn";
var softwareHelp = "http://schema.org/softwareHelp";
var softwareVersion = "http://schema.org/softwareVersion";
var source5 = "http://schema.org/source";
var sourceOrganization = "http://schema.org/sourceOrganization";
var sourcedFrom = "http://schema.org/sourcedFrom";
var spatial2 = "http://schema.org/spatial";
var speakable = "http://schema.org/speakable";
var specialCommitments = "http://schema.org/specialCommitments";
var specialOpeningHoursSpecification = "http://schema.org/specialOpeningHoursSpecification";
var specialty2 = "http://schema.org/specialty";
var speechToTextMarkup = "http://schema.org/speechToTextMarkup";
var speed = "http://schema.org/speed";
var spokenByCharacter = "http://schema.org/spokenByCharacter";
var sport = "http://schema.org/sport";
var sportsActivityLocation = "http://schema.org/sportsActivityLocation";
var sportsEvent = "http://schema.org/sportsEvent";
var sportsTeam = "http://schema.org/sportsTeam";
var spouse = "http://schema.org/spouse";
var stage2 = "http://schema.org/stage";
var stageAsNumber = "http://schema.org/stageAsNumber";
var starRating = "http://schema.org/starRating";
var startDate2 = "http://schema.org/startDate";
var startOffset = "http://schema.org/startOffset";
var startTime2 = "http://schema.org/startTime";
var statType = "http://schema.org/statType";
var status6 = "http://schema.org/status";
var steeringPosition = "http://schema.org/steeringPosition";
var stepValue = "http://schema.org/stepValue";
var steps = "http://schema.org/steps";
var storageRequirements = "http://schema.org/storageRequirements";
var streetAddress = "http://schema.org/streetAddress";
var strengthUnit = "http://schema.org/strengthUnit";
var strengthValue = "http://schema.org/strengthValue";
var structuralClass = "http://schema.org/structuralClass";
var study2 = "http://schema.org/study";
var studyDesign2 = "http://schema.org/studyDesign";
var studyLocation = "http://schema.org/studyLocation";
var studySubject = "http://schema.org/studySubject";
var stupidProperty = "http://schema.org/stupidProperty";
var subEvents = "http://schema.org/subEvents";
var subReservation = "http://schema.org/subReservation";
var subStageSuffix = "http://schema.org/subStageSuffix";
var subStructure = "http://schema.org/subStructure";
var subTest = "http://schema.org/subTest";
var subtitleLanguage = "http://schema.org/subtitleLanguage";
var successorOf = "http://schema.org/successorOf";
var sugarContent = "http://schema.org/sugarContent";
var suggestedAge = "http://schema.org/suggestedAge";
var suggestedGender = "http://schema.org/suggestedGender";
var suggestedMaxAge = "http://schema.org/suggestedMaxAge";
var suggestedMeasurement = "http://schema.org/suggestedMeasurement";
var suggestedMinAge = "http://schema.org/suggestedMinAge";
var suitableForDiet = "http://schema.org/suitableForDiet";
var supersededBy = "http://schema.org/supersededBy";
var supplyTo = "http://schema.org/supplyTo";
var supportingData = "http://schema.org/supportingData";
var surface = "http://schema.org/surface";
var syllabusSections = "http://schema.org/syllabusSections";
var target3 = "http://schema.org/target";
var targetDescription = "http://schema.org/targetDescription";
var targetName = "http://schema.org/targetName";
var targetPlatform = "http://schema.org/targetPlatform";
var targetPopulation = "http://schema.org/targetPopulation";
var targetProduct = "http://schema.org/targetProduct";
var targetUrl = "http://schema.org/targetUrl";
var taxID = "http://schema.org/taxID";
var taxonRank = "http://schema.org/taxonRank";
var taxonomicRange = "http://schema.org/taxonomicRange";
var teaches = "http://schema.org/teaches";
var telephone = "http://schema.org/telephone";
var temporal2 = "http://schema.org/temporal";
var termDuration = "http://schema.org/termDuration";
var termsOfService = "http://schema.org/termsOfService";
var termsPerYear = "http://schema.org/termsPerYear";
var text2 = "http://schema.org/text";
var textValue = "http://schema.org/textValue";
var thumbnail2 = "http://schema.org/thumbnail";
var thumbnailUrl = "http://schema.org/thumbnailUrl";
var tickerSymbol = "http://schema.org/tickerSymbol";
var ticketNumber = "http://schema.org/ticketNumber";
var ticketToken = "http://schema.org/ticketToken";
var ticketedSeat = "http://schema.org/ticketedSeat";
var timeOfDay2 = "http://schema.org/timeOfDay";
var timeRequired = "http://schema.org/timeRequired";
var timeToComplete = "http://schema.org/timeToComplete";
var timestamp2 = "http://schema.org/timestamp";
var tissueSample = "http://schema.org/tissueSample";
var title6 = "http://schema.org/title";
var titleEIDR = "http://schema.org/titleEIDR";
var toLocation = "http://schema.org/toLocation";
var toRecipient = "http://schema.org/toRecipient";
var tocContinuation = "http://schema.org/tocContinuation";
var tocEntry = "http://schema.org/tocEntry";
var tongueWeight = "http://schema.org/tongueWeight";
var tool = "http://schema.org/tool";
var torque = "http://schema.org/torque";
var totalHistoricalEnrollment = "http://schema.org/totalHistoricalEnrollment";
var totalJobOpenings = "http://schema.org/totalJobOpenings";
var totalPaymentDue = "http://schema.org/totalPaymentDue";
var totalPrice = "http://schema.org/totalPrice";
var totalTime = "http://schema.org/totalTime";
var tourBookingPage = "http://schema.org/tourBookingPage";
var touristType = "http://schema.org/touristType";
var trackingNumber = "http://schema.org/trackingNumber";
var trackingUrl = "http://schema.org/trackingUrl";
var tracks = "http://schema.org/tracks";
var trailer = "http://schema.org/trailer";
var trailerWeight = "http://schema.org/trailerWeight";
var trainName = "http://schema.org/trainName";
var trainNumber = "http://schema.org/trainNumber";
var trainingSalary = "http://schema.org/trainingSalary";
var transFatContent = "http://schema.org/transFatContent";
var transcript = "http://schema.org/transcript";
var transitTime = "http://schema.org/transitTime";
var transitTimeLabel = "http://schema.org/transitTimeLabel";
var translator = "http://schema.org/translator";
var transmissionMethod = "http://schema.org/transmissionMethod";
var travelBans = "http://schema.org/travelBans";
var trialDesign = "http://schema.org/trialDesign";
var tributary = "http://schema.org/tributary";
var tripOrigin = "http://schema.org/tripOrigin";
var typeOfBed = "http://schema.org/typeOfBed";
var typeOfGood = "http://schema.org/typeOfGood";
var typicalAgeRange = "http://schema.org/typicalAgeRange";
var typicalCreditsPerTerm = "http://schema.org/typicalCreditsPerTerm";
var typicalTest = "http://schema.org/typicalTest";
var underName = "http://schema.org/underName";
var unitCode = "http://schema.org/unitCode";
var unitText = "http://schema.org/unitText";
var unnamedSourcesPolicy = "http://schema.org/unnamedSourcesPolicy";
var unsaturatedFatContent = "http://schema.org/unsaturatedFatContent";
var uploadDate = "http://schema.org/uploadDate";
var upvoteCount = "http://schema.org/upvoteCount";
var url4 = "http://schema.org/url";
var urlTemplate = "http://schema.org/urlTemplate";
var usNPI = "http://schema.org/usNPI";
var usedToDiagnose = "http://schema.org/usedToDiagnose";
var userInteractionCount = "http://schema.org/userInteractionCount";
var usesDevice = "http://schema.org/usesDevice";
var usesHealthPlanIdStandard = "http://schema.org/usesHealthPlanIdStandard";
var utterances = "http://schema.org/utterances";
var validFor = "http://schema.org/validFor";
var validForMemberTier = "http://schema.org/validForMemberTier";
var validFrom = "http://schema.org/validFrom";
var validIn = "http://schema.org/validIn";
var validThrough = "http://schema.org/validThrough";
var validUntil = "http://schema.org/validUntil";
var value4 = "http://schema.org/value";
var valueAddedTaxIncluded = "http://schema.org/valueAddedTaxIncluded";
var valueMaxLength = "http://schema.org/valueMaxLength";
var valueMinLength = "http://schema.org/valueMinLength";
var valueName = "http://schema.org/valueName";
var valuePattern = "http://schema.org/valuePattern";
var valueReference = "http://schema.org/valueReference";
var valueRequired = "http://schema.org/valueRequired";
var variableMeasured = "http://schema.org/variableMeasured";
var variablesMeasured = "http://schema.org/variablesMeasured";
var variantCover = "http://schema.org/variantCover";
var variesBy = "http://schema.org/variesBy";
var vatID = "http://schema.org/vatID";
var vehicleConfiguration = "http://schema.org/vehicleConfiguration";
var vehicleEngine = "http://schema.org/vehicleEngine";
var vehicleIdentificationNumber = "http://schema.org/vehicleIdentificationNumber";
var vehicleInteriorColor = "http://schema.org/vehicleInteriorColor";
var vehicleInteriorType = "http://schema.org/vehicleInteriorType";
var vehicleModelDate = "http://schema.org/vehicleModelDate";
var vehicleSeatingCapacity = "http://schema.org/vehicleSeatingCapacity";
var vehicleSpecialUsage = "http://schema.org/vehicleSpecialUsage";
var vehicleTransmission = "http://schema.org/vehicleTransmission";
var vendor = "http://schema.org/vendor";
var verificationFactCheckingPolicy = "http://schema.org/verificationFactCheckingPolicy";
var version4 = "http://schema.org/version";
var video = "http://schema.org/video";
var videoFormat = "http://schema.org/videoFormat";
var videoFrameSize = "http://schema.org/videoFrameSize";
var videoQuality = "http://schema.org/videoQuality";
var volumeNumber = "http://schema.org/volumeNumber";
var warning2 = "http://schema.org/warning";
var warrantyPromise = "http://schema.org/warrantyPromise";
var warrantyScope = "http://schema.org/warrantyScope";
var webCheckinTime = "http://schema.org/webCheckinTime";
var webFeed = "http://schema.org/webFeed";
var weight = "http://schema.org/weight";
var weightPercentage = "http://schema.org/weightPercentage";
var weightTotal = "http://schema.org/weightTotal";
var wheelbase = "http://schema.org/wheelbase";
var width3 = "http://schema.org/width";
var winner = "http://schema.org/winner";
var wordCount = "http://schema.org/wordCount";
var workHours = "http://schema.org/workHours";
var workLocation = "http://schema.org/workLocation";
var workPerformed = "http://schema.org/workPerformed";
var workPresented = "http://schema.org/workPresented";
var workload = "http://schema.org/workload";
var worksFor = "http://schema.org/worksFor";
var worstRating = "http://schema.org/worstRating";
var xpath = "http://schema.org/xpath";
var yearBuilt = "http://schema.org/yearBuilt";
var yearlyRevenue = "http://schema.org/yearlyRevenue";
var yearsInOperation = "http://schema.org/yearsInOperation";
var actionApplication = "http://schema.org/actionApplication";
var actionOption = "http://schema.org/actionOption";
var album = "http://schema.org/album";
var albumRelease = "http://schema.org/albumRelease";
var alternateName = "http://schema.org/alternateName";
var alumni = "http://schema.org/alumni";
var alumniOf = "http://schema.org/alumniOf";
var archiveHeld = "http://schema.org/archiveHeld";
var arterialBranch = "http://schema.org/arterialBranch";
var artworkSurface = "http://schema.org/artworkSurface";
var attendee2 = "http://schema.org/attendee";
var audience3 = "http://schema.org/audience";
var availableOnDevice = "http://schema.org/availableOnDevice";
var award = "http://schema.org/award";
var blogPost = "http://schema.org/blogPost";
var broker = "http://schema.org/broker";
var caption = "http://schema.org/caption";
var category4 = "http://schema.org/category";
var cause = "http://schema.org/cause";
var causeOf = "http://schema.org/causeOf";
var childTaxon = "http://schema.org/childTaxon";
var clinicalPharmacology = "http://schema.org/clinicalPharmacology";
var codeSampleType = "http://schema.org/codeSampleType";
var colleague = "http://schema.org/colleague";
var contactPoint = "http://schema.org/contactPoint";
var containsPlace = "http://schema.org/containsPlace";
var containsSeason = "http://schema.org/containsSeason";
var contentLocation = "http://schema.org/contentLocation";
var creator3 = "http://schema.org/creator";
var dataset = "http://schema.org/dataset";
var dateCreated = "http://schema.org/dateCreated";
var director = "http://schema.org/director";
var employee = "http://schema.org/employee";
var encodesBioChemEntity = "http://schema.org/encodesBioChemEntity";
var encodesCreativeWork = "http://schema.org/encodesCreativeWork";
var encodingFormat = "http://schema.org/encodingFormat";
var endDate2 = "http://schema.org/endDate";
var episode = "http://schema.org/episode";
var event2 = "http://schema.org/event";
var exampleOfWork = "http://schema.org/exampleOfWork";
var executableLibraryName = "http://schema.org/executableLibraryName";
var exerciseCourse = "http://schema.org/exerciseCourse";
var founder = "http://schema.org/founder";
var frequency2 = "http://schema.org/frequency";
var fundedItem = "http://schema.org/fundedItem";
var funding = "http://schema.org/funding";
var game = "http://schema.org/game";
var gameServer = "http://schema.org/gameServer";
var genre = "http://schema.org/genre";
var hasBioChemEntityPart = "http://schema.org/hasBioChemEntityPart";
var hasBroadcastChannel = "http://schema.org/hasBroadcastChannel";
var hasDefinedTerm = "http://schema.org/hasDefinedTerm";
var hasMenu = "http://schema.org/hasMenu";
var hasMerchantReturnPolicy = "http://schema.org/hasMerchantReturnPolicy";
var hasTiers = "http://schema.org/hasTiers";
var hasVariant = "http://schema.org/hasVariant";
var holdingArchive = "http://schema.org/holdingArchive";
var inDefinedTermSet = "http://schema.org/inDefinedTermSet";
var inLanguage = "http://schema.org/inLanguage";
var incentiveCompensation = "http://schema.org/incentiveCompensation";
var interactionStatistic = "http://schema.org/interactionStatistic";
var isAccessibleForFree = "http://schema.org/isAccessibleForFree";
var isBasedOn = "http://schema.org/isBasedOn";
var isEncodedByBioChemEntity = "http://schema.org/isEncodedByBioChemEntity";
var isPartOfBioChemEntity = "http://schema.org/isPartOfBioChemEntity";
var isTierOf = "http://schema.org/isTierOf";
var isVariantOf = "http://schema.org/isVariantOf";
var itemOffered = "http://schema.org/itemOffered";
var jobBenefits = "http://schema.org/jobBenefits";
var jurisdiction2 = "http://schema.org/jurisdiction";
var mainContentOfPage = "http://schema.org/mainContentOfPage";
var mainEntity = "http://schema.org/mainEntity";
var mainEntityOfPage = "http://schema.org/mainEntityOfPage";
var makesOffer = "http://schema.org/makesOffer";
var measurementTechnique = "http://schema.org/measurementTechnique";
var merchantReturnDays = "http://schema.org/merchantReturnDays";
var merchantReturnLink = "http://schema.org/merchantReturnLink";
var offeredBy = "http://schema.org/offeredBy";
var offers = "http://schema.org/offers";
var owner3 = "http://schema.org/owner";
var owns = "http://schema.org/owns";
var parent2 = "http://schema.org/parent";
var parentTaxon = "http://schema.org/parentTaxon";
var partOfSeries = "http://schema.org/partOfSeries";
var partOfTrip = "http://schema.org/partOfTrip";
var paymentDueDate = "http://schema.org/paymentDueDate";
var performTime = "http://schema.org/performTime";
var performer2 = "http://schema.org/performer";
var photo2 = "http://schema.org/photo";
var provider3 = "http://schema.org/provider";
var providesBroadcastService = "http://schema.org/providesBroadcastService";
var recipeIngredient = "http://schema.org/recipeIngredient";
var recordedAs = "http://schema.org/recordedAs";
var recordedAt = "http://schema.org/recordedAt";
var recordedIn = "http://schema.org/recordedIn";
var recordingOf = "http://schema.org/recordingOf";
var releaseOf = "http://schema.org/releaseOf";
var review = "http://schema.org/review";
var roleName = "http://schema.org/roleName";
var runtimePlatform = "http://schema.org/runtimePlatform";
var season = "http://schema.org/season";
var serialNumber2 = "http://schema.org/serialNumber";
var serviceArea = "http://schema.org/serviceArea";
var serviceOutput = "http://schema.org/serviceOutput";
var sibling = "http://schema.org/sibling";
var significantLink = "http://schema.org/significantLink";
var softwareRequirements = "http://schema.org/softwareRequirements";
var sponsor = "http://schema.org/sponsor";
var subOrganization = "http://schema.org/subOrganization";
var subTrip = "http://schema.org/subTrip";
var subjectOf = "http://schema.org/subjectOf";
var suggestedAnswer = "http://schema.org/suggestedAnswer";
var superEvent = "http://schema.org/superEvent";
var targetCollection = "http://schema.org/targetCollection";
var temporalCoverage = "http://schema.org/temporalCoverage";
var termCode = "http://schema.org/termCode";
var track = "http://schema.org/track";
var translationOfWork = "http://schema.org/translationOfWork";
var usageInfo = "http://schema.org/usageInfo";
var warranty = "http://schema.org/warranty";
var workTranslation = "http://schema.org/workTranslation";
var yield__workaround = "http://schema.org/yield";
var about2 = "http://schema.org/about";
var actor3 = "http://schema.org/actor";
var associatedReview = "http://schema.org/associatedReview";
var competitor = "http://schema.org/competitor";
var containedInPlace = "http://schema.org/containedInPlace";
var encoding = "http://schema.org/encoding";
var hasMap = "http://schema.org/hasMap";
var legislationApplies = "http://schema.org/legislationApplies";
var material2 = "http://schema.org/material";
var memberOf = "http://schema.org/memberOf";
var parentOrganization = "http://schema.org/parentOrganization";
var result3 = "http://schema.org/result";
var seller = "http://schema.org/seller";
var spatialCoverage = "http://schema.org/spatialCoverage";
var step2 = "http://schema.org/step";
var subEvent = "http://schema.org/subEvent";
var supply = "http://schema.org/supply";
var workFeatured = "http://schema.org/workFeatured";
var areaServed = "http://schema.org/areaServed";
var duration4 = "http://schema.org/duration";
var includedInDataCatalog = "http://schema.org/includedInDataCatalog";
var legislationChanges = "http://schema.org/legislationChanges";
var member6 = "http://schema.org/member";
var recipient2 = "http://schema.org/recipient";
var workExample = "http://schema.org/workExample";
var description7 = "http://schema.org/description";
var gtin = "http://schema.org/gtin";
var hasRepresentation = "http://schema.org/hasRepresentation";
var image3 = "http://schema.org/image";
var hasPart3 = "http://schema.org/hasPart";
var position2 = "http://schema.org/position";
var isPartOf2 = "http://schema.org/isPartOf";
var instrument2 = "http://schema.org/instrument";
var object4 = "http://schema.org/object";
var publishingPrinciples = "http://schema.org/publishingPrinciples";
var location4 = "http://schema.org/location";
var participant3 = "http://schema.org/participant";
var identifier4 = "http://schema.org/identifier";
var schemaImport = /* @__PURE__ */ Object.freeze({
  AMRadioChannel,
  APIReference,
  AboutPage,
  AcceptAction,
  Accommodation,
  AccountingService,
  AchieveAction,
  Action: Action3,
  ActionAccessSpecification,
  ActionStatusType,
  ActivateAction,
  AddAction,
  AdministrativeArea,
  AdultEntertainment,
  AdultOrientedEnumeration,
  AdvertiserContentArticle,
  AggregateOffer,
  AggregateRating,
  AgreeAction,
  Airline,
  Airport,
  AlignmentObject,
  AllocateAction,
  AmpStory,
  AmusementPark,
  AnalysisNewsArticle,
  AnatomicalStructure,
  AnatomicalSystem,
  AnimalShelter,
  Answer: Answer2,
  Apartment,
  ApartmentComplex,
  AppendAction,
  ApplyAction,
  ApprovedIndication,
  Aquarium,
  ArchiveComponent,
  ArchiveOrganization,
  ArriveAction,
  ArtGallery,
  Artery,
  Article: Article2,
  AskAction,
  AskPublicNewsArticle,
  AssessAction,
  AssignAction,
  Atlas,
  Attorney,
  Audience,
  AudioObject,
  AudioObjectSnapshot,
  Audiobook,
  AuthenticateAction,
  AuthorizeAction,
  AutoBodyShop,
  AutoDealer,
  AutoPartsStore,
  AutoRental,
  AutoRepair,
  AutoWash,
  AutomatedTeller,
  AutomotiveBusiness,
  BackgroundNewsArticle,
  Bakery,
  BankAccount,
  BankOrCreditUnion,
  BarOrPub,
  Barcode,
  Beach,
  BeautySalon,
  BedAndBreakfast,
  BedDetails,
  BedType,
  BefriendAction,
  BikeStore,
  BioChemEntity,
  Blog,
  BlogPosting,
  BloodTest,
  BoardingPolicyType,
  BoatReservation,
  BoatTerminal,
  BoatTrip,
  BodyMeasurementTypeEnumeration,
  BodyOfWater,
  Bone,
  Book,
  BookFormatType,
  BookSeries,
  BookStore,
  BookmarkAction,
  Boolean__workaround,
  BorrowAction,
  BowlingAlley,
  BrainStructure,
  Brand,
  BreadcrumbList,
  Brewery,
  Bridge,
  BroadcastChannel,
  BroadcastEvent,
  BroadcastFrequencySpecification,
  BroadcastService,
  BrokerageAccount,
  BuddhistTemple,
  BusOrCoach,
  BusReservation,
  BusStation,
  BusStop,
  BusTrip,
  BusinessAudience,
  BusinessEntityType,
  BusinessEvent,
  BusinessFunction,
  BuyAction,
  CDCPMDRecord,
  CableOrSatelliteService,
  CafeOrCoffeeShop,
  Campground,
  CampingPitch,
  Canal,
  CancelAction,
  Car,
  CarUsageType,
  Casino,
  CategoryCode,
  CategoryCodeSet,
  CatholicChurch,
  Cemetery,
  Certification,
  CertificationStatusEnumeration,
  Chapter,
  CheckAction,
  CheckInAction,
  CheckOutAction,
  CheckoutPage,
  ChemicalSubstance,
  ChildCare,
  ChildrensEvent,
  ChooseAction,
  Church,
  City,
  CityHall,
  CivicStructure,
  Claim: Claim2,
  ClaimReview,
  Class: Class5,
  Clip,
  ClothingStore,
  Code,
  Collection: Collection5,
  CollectionPage: CollectionPage2,
  CollegeOrUniversity,
  ComedyClub,
  ComedyEvent,
  ComicCoverArt,
  ComicIssue,
  ComicSeries,
  ComicStory,
  Comment,
  CommentAction,
  CommunicateAction,
  CompleteDataFeed,
  CompoundPriceSpecification,
  ComputerLanguage,
  ComputerStore,
  ConferenceEvent,
  ConfirmAction,
  Consortium,
  ConstraintNode,
  ConsumeAction,
  ContactPage,
  ContactPoint: ContactPoint2,
  ContactPointOption,
  Continent,
  ControlAction,
  ConvenienceStore,
  Conversation,
  CookAction,
  Cooperative,
  Corporation,
  CorrectionComment,
  Country,
  Course,
  CourseInstance,
  Courthouse,
  CoverArt,
  CovidTestingFacility,
  CreateAction,
  CreativeWork,
  CreativeWorkSeason,
  CreativeWorkSeries,
  Credential,
  CreditCard,
  Crematorium,
  CriticReview,
  CssSelectorType,
  CurrencyConversionService,
  DDxElement,
  DENonprofitType,
  DanceEvent,
  DanceGroup,
  DataCatalog,
  DataDownload,
  DataFeed,
  DataFeedItem,
  DataType: DataType2,
  Dataset,
  Date__workaround,
  DateTime,
  DatedMoneySpecification,
  DayOfWeek,
  DaySpa,
  DeactivateAction,
  DefenceEstablishment,
  DefinedRegion,
  DefinedTerm,
  DefinedTermSet,
  DeleteAction,
  DeliveryChargeSpecification,
  DeliveryEvent,
  DeliveryMethod,
  DeliveryTimeSettings,
  Demand,
  Dentist,
  DepartAction,
  DepartmentStore,
  DepositAccount,
  DiagnosticLab,
  DiagnosticProcedure,
  Diet,
  DietarySupplement,
  DigitalDocument,
  DigitalDocumentPermission,
  DigitalDocumentPermissionType,
  DigitalPlatformEnumeration,
  DisagreeAction,
  DiscoverAction,
  DiscussionForumPosting,
  DislikeAction,
  Distance: Distance2,
  Distillery,
  DonateAction,
  DoseSchedule,
  DownloadAction,
  DrawAction,
  Drawing,
  DrinkAction,
  DriveWheelConfigurationValue,
  Drug,
  DrugClass,
  DrugCost,
  DrugCostCategory,
  DrugLegalStatus,
  DrugPregnancyCategory,
  DrugPrescriptionStatus,
  DrugStrength,
  DryCleaningOrLaundry,
  Duration: Duration2,
  EUEnergyEfficiencyEnumeration,
  EatAction,
  EducationEvent,
  EducationalAudience,
  EducationalOccupationalCredential,
  EducationalOccupationalProgram,
  EducationalOrganization,
  Electrician,
  ElectronicsStore,
  ElementarySchool,
  EmailMessage,
  Embassy,
  EmergencyService,
  EmployeeRole,
  EmployerAggregateRating,
  EmployerReview,
  EmploymentAgency,
  EndorseAction,
  EndorsementRating,
  Energy,
  EnergyConsumptionDetails,
  EnergyEfficiencyEnumeration,
  EnergyStarEnergyEfficiencyEnumeration,
  EngineSpecification,
  EntertainmentBusiness,
  EntryPoint,
  Enumeration,
  Episode,
  Error__workaround: Error__workaround3,
  Event: Event2,
  EventAttendanceModeEnumeration,
  EventReservation,
  EventSeries,
  EventStatusType,
  EventVenue,
  ExchangeRateSpecification,
  ExerciseAction,
  ExerciseGym,
  ExercisePlan,
  ExhibitionEvent,
  FAQPage,
  FMRadioChannel,
  FastFoodRestaurant,
  Festival,
  FilmAction,
  FinancialIncentive,
  FinancialProduct,
  FinancialService,
  FindAction,
  FireStation,
  Flight,
  FlightReservation,
  Float,
  FloorPlan,
  Florist,
  FollowAction,
  FoodEstablishment,
  FoodEstablishmentReservation,
  FoodEvent,
  FoodService,
  FulfillmentTypeEnumeration,
  FundingAgency,
  FundingScheme,
  FurnitureStore,
  Game,
  GameAvailabilityEnumeration,
  GamePlayMode,
  GameServer,
  GameServerStatus,
  GardenStore,
  GasStation,
  GatedResidenceCommunity,
  GenderType,
  Gene,
  GeneralContractor,
  GeoCircle,
  GeoCoordinates,
  GeoShape,
  GeospatialGeometry,
  GiveAction,
  GolfCourse,
  GovernmentBenefitsType,
  GovernmentBuilding,
  GovernmentOffice,
  GovernmentOrganization,
  GovernmentPermit,
  GovernmentService,
  Grant,
  GroceryStore,
  Guide,
  HVACBusiness,
  Hackathon,
  HairSalon,
  HardwareStore,
  HealthAndBeautyBusiness,
  HealthAspectEnumeration,
  HealthClub,
  HealthInsurancePlan,
  HealthPlanCostSharingSpecification,
  HealthPlanFormulary,
  HealthPlanNetwork,
  HealthTopicContent,
  HighSchool,
  HinduTemple,
  HobbyShop,
  HomeAndConstructionBusiness,
  HomeGoodsStore,
  Hospital,
  Hostel,
  Hotel,
  HotelRoom,
  House,
  HousePainter,
  HowTo,
  HowToDirection,
  HowToItem,
  HowToSection,
  HowToStep,
  HowToSupply,
  HowToTip,
  HowToTool,
  HyperToc,
  HyperTocEntry,
  IPTCDigitalSourceEnumeration,
  ITNonprofitType,
  IceCreamShop,
  IgnoreAction,
  ImageGallery,
  ImageObject,
  ImageObjectSnapshot,
  ImagingTest,
  IncentiveQualifiedExpenseType,
  IncentiveStatus,
  IncentiveType,
  IndividualPhysician,
  IndividualProduct,
  InfectiousAgentClass,
  InfectiousDisease,
  InformAction,
  InsertAction,
  InstallAction,
  InstantaneousEvent: InstantaneousEvent2,
  InsuranceAgency,
  Intangible,
  Integer,
  InteractAction,
  InteractionCounter,
  InternetCafe,
  InvestmentFund,
  InvestmentOrDeposit,
  InviteAction,
  Invoice: Invoice2,
  ItemAvailability,
  ItemList,
  ItemListOrderType,
  ItemPage,
  JewelryStore,
  JobPosting,
  JoinAction,
  Joint,
  LakeBodyOfWater,
  Landform,
  LandmarksOrHistoricalBuildings,
  Language,
  LearningResource,
  LeaveAction,
  LegalForceStatus,
  LegalService,
  LegalValueLevel,
  Legislation,
  LegislationObject,
  LegislativeBuilding,
  LendAction,
  Library: Library2,
  LibrarySystem,
  LifestyleModification,
  Ligament,
  LikeAction,
  LinkRole,
  LiquorStore,
  ListItem,
  ListenAction,
  LiteraryEvent,
  LiveBlogPosting,
  LoanOrCredit,
  LocalBusiness,
  LocationFeatureSpecification,
  Locksmith,
  LodgingBusiness,
  LodgingReservation,
  LoginAction,
  LoseAction,
  LymphaticVessel,
  Manuscript,
  Map__workaround,
  MapCategoryType,
  MarryAction,
  Mass,
  MathSolver,
  MaximumDoseSchedule,
  MeasurementMethodEnum,
  MeasurementTypeEnumeration,
  MediaEnumeration,
  MediaGallery,
  MediaManipulationRatingEnumeration,
  MediaObject,
  MediaReview,
  MediaReviewItem,
  MediaSubscription,
  MedicalAudience,
  MedicalAudienceType,
  MedicalBusiness,
  MedicalCause,
  MedicalClinic,
  MedicalCode,
  MedicalCondition,
  MedicalConditionStage,
  MedicalContraindication,
  MedicalDevice,
  MedicalDevicePurpose,
  MedicalEntity,
  MedicalEnumeration,
  MedicalEvidenceLevel,
  MedicalGuideline,
  MedicalGuidelineContraindication,
  MedicalGuidelineRecommendation,
  MedicalImagingTechnique,
  MedicalIndication,
  MedicalIntangible,
  MedicalObservationalStudy,
  MedicalObservationalStudyDesign,
  MedicalOrganization,
  MedicalProcedure,
  MedicalProcedureType,
  MedicalRiskCalculator,
  MedicalRiskEstimator,
  MedicalRiskFactor,
  MedicalRiskScore,
  MedicalScholarlyArticle,
  MedicalSign,
  MedicalSignOrSymptom,
  MedicalSpecialty,
  MedicalStudy,
  MedicalStudyStatus,
  MedicalSymptom,
  MedicalTest,
  MedicalTestPanel,
  MedicalTherapy,
  MedicalTrial,
  MedicalTrialDesign,
  MedicalWebPage,
  MedicineSystem,
  MeetingRoom,
  MemberProgram,
  MemberProgramTier,
  MensClothingStore,
  Menu,
  MenuItem,
  MenuSection,
  MerchantReturnEnumeration,
  MerchantReturnPolicy,
  MerchantReturnPolicySeasonalOverride,
  Message: Message2,
  MiddleSchool,
  MobileApplication,
  MobilePhoneStore,
  MolecularEntity,
  MonetaryAmount,
  MonetaryAmountDistribution,
  MonetaryGrant,
  MoneyTransfer,
  MortgageLoan,
  Mosque,
  Motel,
  Motorcycle,
  MotorcycleDealer,
  MotorcycleRepair,
  MotorizedBicycle,
  Mountain,
  MoveAction,
  Movie,
  MovieClip,
  MovieRentalStore,
  MovieSeries,
  MovieTheater,
  MovingCompany,
  Muscle,
  Museum,
  MusicAlbum,
  MusicAlbumProductionType,
  MusicAlbumReleaseType,
  MusicComposition,
  MusicEvent,
  MusicGroup,
  MusicPlaylist,
  MusicRecording,
  MusicRelease,
  MusicReleaseFormatType,
  MusicStore,
  MusicVenue,
  MusicVideoObject,
  NGO,
  NLNonprofitType,
  NailSalon,
  Nerve,
  NewsArticle,
  NewsMediaOrganization,
  Newspaper,
  NightClub,
  NonprofitType,
  Notary,
  NoteDigitalDocument,
  Number__workaround,
  NutritionInformation,
  Observation: Observation2,
  Occupation,
  OccupationalExperienceRequirements,
  OccupationalTherapy,
  OceanBodyOfWater,
  Offer: Offer2,
  OfferCatalog,
  OfferForLease,
  OfferForPurchase,
  OfferItemCondition,
  OfferShippingDetails,
  OfficeEquipmentStore,
  OnDemandEvent,
  OnlineBusiness,
  OnlineMarketplace,
  OnlineStore,
  OpeningHoursSpecification,
  OperatingSystem,
  OpinionNewsArticle,
  Optician,
  Order,
  OrderAction,
  OrderItem,
  OrderStatus,
  Organization: Organization5,
  OrganizationRole,
  OrganizeAction,
  OutletStore,
  OwnershipInfo,
  PaintAction,
  Painting,
  PalliativeProcedure,
  ParcelDelivery,
  ParentAudience,
  Park,
  ParkingFacility,
  PathologyTest,
  Patient: Patient2,
  PawnShop,
  PayAction,
  PaymentCard,
  PaymentChargeSpecification,
  PaymentMethod,
  PaymentMethodType,
  PaymentService,
  PaymentStatusType,
  PeopleAudience,
  PerformAction,
  PerformanceRole,
  PerformingArtsEvent,
  PerformingArtsTheater,
  PerformingGroup,
  Periodical,
  Permit,
  Person: Person5,
  PetStore,
  Pharmacy,
  Photograph,
  PhotographAction,
  PhysicalActivity,
  PhysicalActivityCategory,
  PhysicalExam,
  PhysicalTherapy,
  Physician,
  PhysiciansOffice,
  Place: Place2,
  PlaceOfWorship,
  PlanAction,
  Play,
  PlayAction,
  PlayGameAction,
  Playground,
  Plumber,
  PodcastEpisode,
  PodcastSeason,
  PodcastSeries,
  PoliceStation,
  PoliticalParty,
  Pond,
  PostOffice,
  PostalAddress,
  PostalCodeRangeSpecification,
  Poster,
  PreOrderAction,
  PrependAction,
  Preschool,
  PresentationDigitalDocument,
  PreventionIndication,
  PriceComponentTypeEnumeration,
  PriceSpecification,
  PriceTypeEnumeration,
  Product,
  ProductCollection,
  ProductGroup,
  ProductModel,
  ProductReturnEnumeration,
  ProductReturnPolicy,
  ProfessionalService,
  ProfilePage,
  ProgramMembership,
  Project: Project2,
  PronounceableText,
  Property: Property3,
  PropertyValue,
  PropertyValueSpecification,
  Protein,
  PsychologicalTreatment,
  PublicSwimmingPool,
  PublicToilet,
  PublicationEvent,
  PublicationIssue,
  PublicationVolume,
  PurchaseType,
  QAPage,
  QualitativeValue,
  QuantitativeValue,
  QuantitativeValueDistribution,
  Quantity: Quantity2,
  Question: Question2,
  Quiz,
  Quotation: Quotation2,
  QuoteAction,
  RVPark,
  RadiationTherapy,
  RadioBroadcastService,
  RadioChannel,
  RadioClip,
  RadioEpisode,
  RadioSeason,
  RadioSeries,
  RadioStation,
  Rating,
  ReactAction,
  ReadAction,
  RealEstateAgent,
  RealEstateListing,
  ReceiveAction,
  Recipe,
  Recommendation,
  RecommendedDoseSchedule,
  RecyclingCenter,
  RefundTypeEnumeration,
  RegisterAction,
  RejectAction,
  RentAction,
  RentalCarReservation,
  RepaymentSpecification,
  ReplaceAction,
  ReplyAction,
  Report,
  ReportageNewsArticle,
  ReportedDoseSchedule,
  ResearchOrganization,
  ResearchProject,
  Researcher,
  Reservation,
  ReservationPackage,
  ReservationStatusType,
  ReserveAction,
  Reservoir,
  ResetPasswordAction,
  Residence,
  Resort,
  Restaurant,
  RestrictedDiet,
  ResumeAction,
  ReturnAction,
  ReturnFeesEnumeration,
  ReturnLabelSourceEnumeration,
  ReturnMethodEnumeration,
  Review,
  ReviewAction,
  ReviewNewsArticle,
  RiverBodyOfWater,
  Role: Role2,
  RoofingContractor,
  Room,
  RsvpAction,
  RsvpResponseType,
  RuntimePlatform,
  SaleEvent,
  SatiricalArticle,
  Schedule: Schedule2,
  ScheduleAction,
  ScholarlyArticle,
  School,
  SchoolDistrict,
  ScreeningEvent,
  Sculpture,
  SeaBodyOfWater,
  SearchAction,
  SearchRescueOrganization,
  SearchResultsPage,
  Season,
  Seat,
  SeekToAction,
  SelfStorage,
  SellAction,
  SendAction,
  SequentialArt,
  Series,
  Service: Service2,
  ServiceChannel,
  ServicePeriod,
  ShareAction,
  SheetMusic,
  ShippingConditions,
  ShippingDeliveryTime,
  ShippingRateSettings,
  ShippingService,
  ShoeStore,
  ShoppingCenter,
  ShortStory,
  SingleFamilyResidence,
  SiteNavigationElement,
  SizeGroupEnumeration,
  SizeSpecification,
  SizeSystemEnumeration,
  SkiResort,
  SocialEvent,
  SocialMediaPosting,
  SoftwareApplication,
  SoftwareSourceCode,
  SolveMathAction,
  SomeProducts,
  SpeakableSpecification,
  SpecialAnnouncement,
  Specialty,
  SportingGoodsStore,
  SportsActivityLocation,
  SportsClub,
  SportsEvent,
  SportsOrganization,
  SportsTeam,
  SpreadsheetDigitalDocument,
  StadiumOrArena,
  State,
  Statement: Statement4,
  StatisticalPopulation,
  StatisticalVariable,
  StatusEnumeration,
  SteeringPositionValue,
  Store: Store2,
  StructuredValue,
  StupidType,
  SubscribeAction,
  Substance: Substance2,
  SubwayStation,
  Suite,
  SuperficialAnatomy,
  SurgicalProcedure,
  SuspendAction,
  Syllabus,
  Synagogue,
  TVClip,
  TVEpisode,
  TVSeason,
  TVSeries,
  Table,
  TakeAction,
  TattooParlor,
  Taxi,
  TaxiReservation,
  TaxiService,
  TaxiStand,
  Taxon,
  TechArticle,
  TelevisionChannel,
  TelevisionStation,
  TennisComplex,
  Text,
  TextDigitalDocument,
  TextObject,
  TheaterEvent,
  TheaterGroup,
  TherapeuticProcedure,
  Thesis,
  Thing: Thing3,
  Ticket,
  TieAction,
  TierBenefitEnumeration,
  Time,
  TipAction,
  TireShop,
  TouristAttraction,
  TouristDestination,
  TouristInformationCenter,
  TouristTrip,
  ToyStore,
  TrackAction,
  TradeAction,
  TrainReservation,
  TrainStation,
  TrainTrip,
  TransferAction,
  TravelAction,
  TravelAgency,
  TreatmentIndication,
  Trip,
  TypeAndQuantityNode,
  UKNonprofitType,
  URL: URL2,
  USNonprofitType,
  UnRegisterAction,
  UnitPriceSpecification,
  UpdateAction,
  UseAction,
  UserBlocks,
  UserCheckins,
  UserComments,
  UserDownloads,
  UserInteraction,
  UserLikes,
  UserPageVisits,
  UserPlays,
  UserPlusOnes,
  UserReview,
  UserTweets,
  VacationRental,
  Vehicle,
  Vein,
  Vessel,
  VeterinaryCare,
  VideoGallery,
  VideoGame,
  VideoGameClip,
  VideoGameSeries,
  VideoObject,
  VideoObjectSnapshot,
  ViewAction,
  VirtualLocation,
  VisualArtsEvent,
  VisualArtwork,
  VitalSign,
  Volcano,
  VoteAction,
  WPAdBlock,
  WPFooter,
  WPHeader,
  WPSideBar,
  WantAction,
  WarrantyPromise,
  WarrantyScope,
  WatchAction,
  Waterfall,
  WearAction,
  WearableMeasurementTypeEnumeration,
  WearableSizeGroupEnumeration,
  WearableSizeSystemEnumeration,
  WebAPI,
  WebApplication,
  WebContent,
  WebPage,
  WebPageElement,
  WebSite,
  WholesaleStore,
  WinAction,
  Winery,
  WorkBasedProgram,
  WorkersUnion,
  WriteAction,
  XPathType,
  Zoo,
  abridged,
  abstract: abstract3,
  accelerationTime,
  acceptedAnswer,
  acceptedOffer,
  acceptedPaymentMethod,
  acceptsReservations,
  accessCode,
  accessMode,
  accessModeSufficient,
  accessibilityAPI,
  accessibilityControl,
  accessibilityFeature,
  accessibilityHazard,
  accessibilitySummary,
  accommodationCategory,
  accommodationFloorPlan,
  accountId,
  accountMinimumInflow,
  accountOverdraftLimit,
  accountablePerson,
  acquireLicensePage,
  acquiredFrom,
  acrissCode,
  actionAccessibilityRequirement,
  actionPlatform,
  actionProcess,
  actionStatus,
  actionableFeedbackPolicy,
  activeIngredient,
  activityDuration,
  activityFrequency,
  actors,
  addOn,
  additionalName,
  additionalNumberOfGuests,
  additionalProperty,
  additionalType,
  additionalVariable,
  address: address3,
  addressCountry,
  addressLocality,
  addressRegion,
  administrationRoute,
  advanceBookingRequirement,
  adverseOutcome,
  affectedBy,
  affiliation: affiliation2,
  afterMedia,
  agent: agent4,
  agentInteractionStatistic,
  aggregateElement,
  aggregateRating,
  aircraft,
  albumProductionType,
  albumReleaseType,
  albums,
  alcoholWarning,
  algorithm,
  alignmentType,
  alternativeHeadline,
  alternativeOf,
  amenityFeature,
  amount: amount3,
  amountOfThisGood,
  announcementLocation,
  annualPercentageRate,
  answerCount,
  answerExplanation,
  antagonist,
  appearance,
  applicableCountry,
  applicableLocation,
  applicantLocationRequirements,
  application: application2,
  applicationCategory,
  applicationContact,
  applicationDeadline,
  applicationStartDate,
  applicationSubCategory,
  applicationSuite,
  appliesToDeliveryMethod,
  appliesToPaymentMethod,
  archivedAt,
  area,
  arrivalAirport,
  arrivalBoatTerminal,
  arrivalBusStop,
  arrivalGate,
  arrivalPlatform,
  arrivalStation,
  arrivalTerminal,
  arrivalTime,
  artEdition,
  artMedium,
  artform,
  articleBody,
  articleSection,
  artist,
  asin,
  aspect,
  assembly,
  assemblyVersion,
  assesses,
  associatedAnatomy,
  associatedArticle,
  associatedClaimReview,
  associatedDisease,
  associatedMedia,
  associatedMediaReview,
  associatedPathophysiology,
  athlete,
  attendees,
  audienceType,
  audio,
  auditDate,
  authenticator,
  author: author3,
  availability: availability2,
  availabilityEnds,
  availabilityStarts,
  availableAtOrFrom,
  availableChannel,
  availableDeliveryMethod,
  availableFrom,
  availableIn,
  availableLanguage,
  availableService,
  availableStrength,
  availableTest,
  availableThrough,
  awards,
  awayTeam,
  backstory,
  bankAccountType,
  baseSalary,
  bccRecipient,
  bed,
  beforeMedia,
  beneficiaryBank,
  benefits,
  benefitsSummaryUrl,
  bestRating,
  billingAddress,
  billingDuration,
  billingIncrement,
  billingPeriod,
  billingStart,
  bioChemInteraction,
  bioChemSimilarity,
  biologicalRole,
  biomechnicalClass,
  birthDate: birthDate2,
  birthPlace,
  bitrate,
  blogPosts,
  bloodSupply,
  boardingGroup,
  boardingPolicy,
  bodyLocation,
  bodyType,
  bookEdition,
  bookFormat,
  bookingAgent,
  bookingTime,
  borrower,
  box,
  branch,
  branchCode,
  branchOf,
  brand: brand2,
  breadcrumb,
  breastfeedingWarning,
  broadcastAffiliateOf,
  broadcastChannelId,
  broadcastDisplayName,
  broadcastFrequency,
  broadcastFrequencyValue,
  broadcastOfEvent,
  broadcastServiceTier,
  broadcastSignalModulation,
  broadcastSubChannel,
  broadcastTimezone,
  broadcaster,
  browserRequirements,
  busName,
  busNumber,
  businessDays,
  businessFunction,
  buyer,
  byArtist,
  byDay,
  byMonth,
  byMonthDay,
  byMonthWeek,
  callSign,
  calories,
  candidate: candidate2,
  carbohydrateContent,
  cargoVolume,
  carrier,
  carrierRequirements,
  cashBack,
  catalog,
  catalogNumber,
  ccRecipient,
  certificationIdentification,
  certificationRating,
  certificationStatus,
  character,
  characterAttribute,
  characterName,
  cheatCode,
  checkinTime,
  checkoutPageURLTemplate,
  checkoutTime,
  chemicalComposition,
  chemicalRole,
  childMaxAge,
  childMinAge,
  children,
  cholesterolContent,
  circle,
  citation: citation2,
  claimInterpreter,
  claimReviewed,
  clincalPharmacology,
  clipNumber,
  closes,
  coach,
  code: code2,
  codeRepository,
  codeValue,
  codingSystem,
  colleagues,
  collection: collection3,
  collectionSize,
  color: color2,
  colorSwatch,
  colorist,
  comment: comment4,
  commentCount,
  commentText,
  commentTime,
  companyRegistration,
  competencyRequired,
  composer,
  comprisedOf: comprisedOf2,
  conditionsOfAccess,
  confirmationNumber,
  connectedTo,
  constraintProperty,
  contactOption,
  contactPoints,
  contactType,
  contactlessPayment,
  containedIn,
  contentRating,
  contentReferenceTime,
  contentSize,
  contentType: contentType2,
  contentUrl,
  contraindication: contraindication2,
  contributor: contributor4,
  cookTime,
  cookingMethod,
  copyrightHolder,
  copyrightNotice,
  copyrightYear,
  correction,
  correctionsPolicy,
  costCategory,
  costCurrency,
  costOrigin,
  costPerUnit,
  countriesNotSupported,
  countriesSupported,
  countryOfAssembly,
  countryOfLastProcessing,
  countryOfOrigin: countryOfOrigin2,
  course,
  courseCode,
  courseMode,
  coursePrerequisites,
  courseSchedule,
  courseWorkload,
  coverageEndTime,
  coverageStartTime,
  creativeWorkStatus,
  credentialCategory,
  creditText,
  creditedTo,
  cssSelector,
  currenciesAccepted,
  currency: currency2,
  currentExchangeRate,
  customer,
  customerRemorseReturnFees,
  customerRemorseReturnLabelSource,
  customerRemorseReturnShippingFeesAmount,
  cutoffTime,
  cvdCollectionDate,
  cvdFacilityCounty,
  cvdFacilityId,
  cvdNumBeds,
  cvdNumBedsOcc,
  cvdNumC19Died,
  cvdNumC19HOPats,
  cvdNumC19HospPats,
  cvdNumC19MechVentPats,
  cvdNumC19OFMechVentPats,
  cvdNumC19OverflowPats,
  cvdNumICUBeds,
  cvdNumICUBedsOcc,
  cvdNumTotBeds,
  cvdNumVent,
  cvdNumVentUse,
  data: data2,
  dataFeedElement,
  datasetTimeInterval,
  dateDeleted,
  dateIssued,
  dateModified,
  datePosted,
  datePublished,
  dateRead,
  dateReceived,
  dateSent,
  dateVehicleFirstRegistered,
  dateline,
  dayOfWeek: dayOfWeek2,
  deathDate,
  deathPlace,
  defaultValue: defaultValue2,
  deliveryAddress,
  deliveryLeadTime,
  deliveryMethod,
  deliveryStatus,
  deliveryTime,
  department,
  departureAirport,
  departureBoatTerminal,
  departureBusStop,
  departureGate,
  departurePlatform,
  departureStation,
  departureTerminal,
  departureTime,
  dependencies,
  depth,
  device: device2,
  diagnosis: diagnosis2,
  diagram,
  diet,
  dietFeatures,
  differentialDiagnosis,
  digitalSourceType,
  directApply,
  directors,
  disambiguatingDescription,
  discount,
  discountCode,
  discountCurrency,
  discusses,
  discussionUrl,
  diseasePreventionInfo,
  diseaseSpreadStatistics,
  displayLocation,
  dissolutionDate,
  distance,
  distinguishingSign,
  distribution,
  diversityPolicy,
  diversityStaffingReport,
  documentation: documentation2,
  doesNotShip,
  domainIncludes,
  domiciledMortgage,
  doorTime,
  dosageForm,
  doseSchedule,
  doseUnit,
  doseValue,
  downPayment,
  downloadUrl,
  downvoteCount,
  drainsTo,
  driveWheelConfiguration,
  dropoffLocation,
  dropoffTime,
  drug,
  drugClass,
  drugUnit,
  duns,
  duplicateTherapy,
  durationOfWarranty,
  duringMedia,
  earlyPrepaymentPenalty,
  editEIDR,
  editor: editor2,
  eduQuestionType,
  educationRequirements,
  educationalAlignment,
  educationalCredentialAwarded,
  educationalFramework,
  educationalLevel,
  educationalProgramMode,
  educationalRole,
  educationalUse,
  elevation,
  eligibilityToWorkRequirement,
  eligibleCustomerType,
  eligibleDuration,
  eligibleQuantity,
  eligibleRegion,
  eligibleTransactionVolume,
  eligibleWithSupplier,
  email,
  embedUrl,
  embeddedTextCaption,
  emissionsCO2,
  employees,
  employerOverview,
  employmentType,
  employmentUnit,
  encodingType,
  encodings,
  endOffset,
  endTime: endTime2,
  endorsee,
  endorsers,
  energyEfficiencyScaleMax,
  energyEfficiencyScaleMin,
  engineDisplacement,
  enginePower,
  engineType,
  entertainmentBusiness,
  epidemiology,
  episodeNumber,
  episodes,
  equal,
  error: error2,
  errorCode,
  estimatedCost,
  estimatedFlightDuration,
  estimatedSalary,
  estimatesRiskOf,
  ethicsPolicy,
  eventAttendanceMode,
  eventSchedule,
  eventStatus,
  events,
  evidenceLevel,
  evidenceOrigin,
  exceptDate,
  exchangeRateSpread,
  exercisePlan,
  exerciseRelatedDiet,
  exerciseType,
  exifData,
  expectedArrivalFrom,
  expectedArrivalUntil,
  expectedPrognosis,
  expectsAcceptanceOf,
  experienceInPlaceOfEducation,
  experienceRequirements,
  expertConsiderations,
  expires,
  expressedIn,
  extendedAddress,
  familyName: familyName2,
  fatContent,
  faxNumber,
  featureList,
  feesAndCommissionsSpecification,
  fiberContent,
  fileFormat,
  fileSize,
  financialAidEligible,
  firstAppearance,
  firstPerformance,
  flightDistance,
  flightNumber,
  floorLevel,
  floorLimit,
  floorSize,
  followee,
  follows,
  followup,
  foodEstablishment,
  foodEvent,
  foodWarning,
  founders,
  foundingDate,
  foundingLocation,
  free,
  freeShippingThreshold,
  fromLocation,
  fuelCapacity,
  fuelConsumption,
  fuelEfficiency,
  fuelType,
  fulfillmentType,
  functionalClass,
  funder,
  gameAvailabilityType,
  gameEdition,
  gameItem,
  gameLocation,
  gamePlatform,
  gameTip,
  gender: gender3,
  geo: geo2,
  geoContains,
  geoCoveredBy,
  geoCovers,
  geoCrosses,
  geoDisjoint,
  geoEquals,
  geoIntersects,
  geoMidpoint,
  geoOverlaps,
  geoRadius,
  geoTouches,
  geoWithin,
  geographicArea,
  gettingTestedInfo,
  givenName: givenName2,
  globalLocationNumber,
  governmentBenefitsInfo,
  gracePeriod,
  grantee: grantee2,
  greater,
  greaterOrEqual,
  gtin12,
  gtin13,
  gtin14,
  gtin8,
  guideline: guideline2,
  guidelineDate,
  guidelineSubject,
  handlingTime,
  hasAdultConsideration,
  hasBioPolymerSequence,
  hasCategoryCode,
  hasCertification,
  hasCourse,
  hasCourseInstance,
  hasCredential,
  hasDeliveryMethod,
  hasDigitalDocumentPermission,
  hasDriveThroughService,
  hasEnergyConsumptionDetails,
  hasEnergyEfficiencyCategory,
  hasGS1DigitalLink,
  hasHealthAspect,
  hasMeasurement,
  hasMemberProgram,
  hasMenuItem,
  hasMenuSection,
  hasMolecularFunction,
  hasOccupation,
  hasOfferCatalog,
  hasPOS,
  hasParticipationOffer,
  hasProductReturnPolicy,
  hasShippingService,
  hasSponsorshipOffer,
  hasStore,
  hasTierBenefit,
  hasTierRequirement,
  headline,
  healthCondition,
  healthPlanCoinsuranceOption,
  healthPlanCoinsuranceRate,
  healthPlanCopay,
  healthPlanCopayOption,
  healthPlanCostSharing,
  healthPlanDrugOption,
  healthPlanDrugTier,
  healthPlanId,
  healthPlanMarketingUrl,
  healthPlanNetworkId,
  healthPlanNetworkTier,
  healthPlanPharmacyCategory,
  healthcareReportingData,
  height: height3,
  highPrice,
  hiringOrganization,
  homeLocation,
  homeTeam,
  honorificPrefix,
  honorificSuffix,
  hospitalAffiliation,
  hostingOrganization,
  hoursAvailable,
  howPerformed,
  httpMethod,
  iataCode,
  icaoCode,
  identifyingExam,
  identifyingTest,
  illustrator,
  imagingTechnique,
  inAlbum,
  inBroadcastLineup,
  inChI,
  inChIKey,
  inCodeSet,
  inPlaylist,
  inProductGroupWithID,
  inStoreReturnsOffered,
  inSupportOf,
  incentiveAmount,
  incentiveStatus,
  incentiveType,
  incentives,
  incentivizedItem,
  includedComposition,
  includedDataCatalog,
  includedInHealthInsurancePlan,
  includedRiskFactor,
  includesAttraction,
  includesHealthPlanFormulary,
  includesHealthPlanNetwork,
  includesObject,
  incomeLimit,
  increasesRiskOf,
  industry,
  ineligibleRegion,
  infectiousAgent,
  infectiousAgentClass,
  ingredients,
  inker,
  insertion,
  installUrl,
  instructor,
  intensity,
  interactingDrug,
  interactionCount,
  interactionService,
  interactionType,
  interactivityType,
  interestRate,
  interpretedAsClaim,
  inventoryLevel,
  inverseOf: inverseOf2,
  isAcceptingNewPatients,
  isAccessoryOrSparePartFor,
  isAvailableGenerically,
  isBasedOnUrl,
  isConsumableFor,
  isFamilyFriendly,
  isGift,
  isInvolvedInBiologicalProcess,
  isLiveBroadcast,
  isLocatedInSubcellularLocation,
  isPlanForApartment,
  isProprietary,
  isRelatedTo,
  isResizable,
  isSimilarTo,
  isStoreOn,
  isUnlabelledFallback,
  isbn,
  isicV4,
  iso6523Code,
  isrcCode,
  issn,
  issueNumber,
  issuedBy,
  issuedThrough,
  iswcCode,
  item: item2,
  itemCondition,
  itemDefectReturnFees,
  itemDefectReturnLabelSource,
  itemDefectReturnShippingFeesAmount,
  itemListElement,
  itemListOrder,
  itemLocation,
  itemReviewed,
  itemShipped,
  itinerary,
  iupacName,
  jobDuration,
  jobImmediateStart,
  jobLocation,
  jobLocationType,
  jobStartDate,
  jobTitle,
  keywords,
  knownVehicleDamages,
  knows: knows2,
  knowsAbout,
  knowsLanguage,
  labelDetails,
  landlord,
  language: language5,
  lastReviewed,
  latitude: latitude3,
  layoutImage,
  learningResourceType,
  leaseLength,
  legalAddress,
  legalName,
  legalRepresentative,
  legalStatus,
  legislationAmends,
  legislationCommences,
  legislationConsolidates,
  legislationCorrects,
  legislationCountersignedBy,
  legislationDate,
  legislationDateOfApplicability,
  legislationDateVersion,
  legislationEnsuresImplementationOf,
  legislationIdentifier,
  legislationJurisdiction,
  legislationLegalForce,
  legislationLegalValue,
  legislationPassedBy,
  legislationRepeals,
  legislationResponsible,
  legislationTransposes,
  legislationType,
  leiCode,
  lender,
  lesser,
  lesserOrEqual,
  letterer,
  license: license3,
  lifeEvent,
  line: line2,
  linkRelationship,
  liveBlogUpdate,
  loanMortgageMandateAmount,
  loanPaymentAmount,
  loanPaymentFrequency,
  loanRepaymentForm,
  loanTerm,
  loanType,
  locationCreated,
  lodgingUnitDescription,
  lodgingUnitType,
  logo: logo2,
  longitude: longitude3,
  loser,
  lowPrice,
  lyricist,
  lyrics,
  maintainer,
  manufacturer: manufacturer2,
  map: map3,
  mapType,
  maps,
  marginOfError,
  masthead,
  materialExtent,
  mathExpression,
  maxPrice,
  maxValue: maxValue2,
  maximumAttendeeCapacity,
  maximumEnrollment,
  maximumIntake,
  maximumPhysicalAttendeeCapacity,
  maximumVirtualAttendeeCapacity,
  mealService,
  measuredProperty,
  measurementDenominator,
  measurementMethod,
  measurementQualifier,
  mechanismOfAction,
  mediaAuthenticityCategory,
  mediaItemAppearance,
  median,
  medicalAudience,
  medicalSpecialty,
  medicineSystem,
  meetsEmissionStandard,
  members: members2,
  membershipNumber,
  membershipPointsEarned,
  memoryRequirements,
  mentions,
  menu,
  menuAddOn,
  merchant,
  messageAttachment,
  mileageFromOdometer,
  minPrice,
  minValue: minValue2,
  minimumPaymentDue,
  missionCoveragePrioritiesPolicy,
  mobileUrl,
  model,
  modelDate,
  modifiedTime,
  molecularFormula: molecularFormula2,
  molecularWeight: molecularWeight2,
  monoisotopicMolecularWeight,
  monthlyMinimumRepaymentAmount,
  monthsOfExperience,
  mpn,
  multipleValues,
  muscleAction,
  musicArrangement,
  musicBy,
  musicCompositionForm,
  musicGroupMember,
  musicReleaseFormat,
  musicalKey,
  naics,
  name: name4,
  namedPosition,
  nationality,
  naturalProgression,
  negativeNotes,
  nerve,
  nerveMotor,
  netWorth,
  newsUpdatesAndGuidelines,
  nextItem,
  noBylinesPolicy,
  nonEqual,
  nonProprietaryName,
  nonprofitStatus,
  normalRange,
  nsn,
  numAdults,
  numChildren,
  numConstraints,
  numItems,
  numTracks,
  numberOfAccommodationUnits,
  numberOfAirbags,
  numberOfAvailableAccommodationUnits,
  numberOfAxles,
  numberOfBathroomsTotal,
  numberOfBedrooms,
  numberOfBeds,
  numberOfCredits,
  numberOfDoors,
  numberOfEmployees,
  numberOfEpisodes,
  numberOfForwardGears,
  numberOfFullBathrooms,
  numberOfItems,
  numberOfLoanPayments,
  numberOfPages,
  numberOfPartialBathrooms,
  numberOfPlayers,
  numberOfPreviousOwners,
  numberOfRooms,
  numberOfSeasons,
  numberedPosition,
  nutrition,
  observationAbout,
  observationDate,
  observationPeriod,
  occupancy,
  occupationLocation,
  occupationalCategory,
  occupationalCredentialAwarded,
  offerCount,
  offersPrescriptionByMail,
  openingHours,
  openingHoursSpecification,
  opens,
  operatingSystem,
  opponent,
  option: option3,
  orderDate,
  orderDelivery,
  orderItemNumber,
  orderItemStatus,
  orderNumber,
  orderPercentage,
  orderQuantity,
  orderStatus,
  orderValue,
  orderedItem,
  organizer: organizer2,
  originAddress,
  originalMediaContextDescription,
  originalMediaLink,
  originatesFrom,
  overdosage,
  ownedFrom,
  ownedThrough,
  ownershipFundingInfo,
  pageEnd,
  pageStart,
  pagination,
  parentItem,
  parentService,
  parents,
  partOfEpisode,
  partOfInvoice,
  partOfOrder,
  partOfSeason,
  partOfSystem,
  partOfTVSeries,
  partySize,
  passengerPriorityStatus,
  passengerSequenceNumber,
  pathophysiology,
  pattern: pattern2,
  payload: payload2,
  paymentAccepted,
  paymentDue,
  paymentMethod,
  paymentMethodId,
  paymentMethodType,
  paymentStatus: paymentStatus2,
  paymentUrl,
  penciler,
  percentile10,
  percentile25,
  percentile75,
  percentile90,
  performerIn,
  performers,
  permissionType,
  permissions,
  permitAudience,
  permittedUsage,
  petsAllowed,
  phoneticText,
  photos,
  physicalRequirement,
  physiologicalBenefits,
  pickupLocation,
  pickupTime,
  playMode,
  playerType,
  playersOnline,
  polygon,
  populationType,
  positiveNotes,
  possibleComplication,
  possibleTreatment,
  postOfficeBoxNumber,
  postOp,
  postalCode: postalCode2,
  postalCodeBegin,
  postalCodeEnd,
  postalCodePrefix,
  postalCodeRange,
  potentialAction,
  potentialUse,
  practicesAt,
  preOp,
  predecessorOf,
  pregnancyCategory,
  pregnancyWarning,
  prepTime,
  preparation: preparation2,
  prescribingInfo,
  prescriptionStatus,
  previousItem,
  previousStartDate,
  price,
  priceComponent: priceComponent2,
  priceComponentType,
  priceCurrency,
  priceRange,
  priceSpecification,
  priceType,
  priceValidUntil,
  primaryImageOfPage,
  primaryPrevention,
  printColumn,
  printEdition,
  printPage,
  printSection,
  procedure: procedure2,
  procedureType,
  processingTime,
  processorRequirements,
  producer,
  produces,
  productGroupID,
  productID,
  productReturnDays,
  productReturnLink,
  productSupported,
  productionCompany,
  productionDate,
  proficiencyLevel,
  program: program2,
  programMembershipUsed,
  programName,
  programPrerequisites,
  programType,
  programmingLanguage,
  programmingModel,
  pronouns,
  propertyID,
  proprietaryName,
  proteinContent,
  providerMobility,
  providesService,
  publicAccess,
  publicTransportClosuresInfo,
  publication,
  publicationType,
  publishedBy,
  publishedOn,
  publisher: publisher4,
  publisherImprint,
  purchaseDate,
  purchasePriceLimit,
  purchaseType,
  qualifications,
  qualifiedExpense,
  quarantineGuidelines,
  query: query2,
  quest,
  question: question2,
  rangeIncludes,
  ratingCount,
  ratingExplanation,
  ratingValue,
  readBy,
  readonlyValue,
  realEstateAgent,
  recipe,
  recipeCategory,
  recipeCuisine,
  recipeInstructions,
  recipeYield,
  recognizedBy,
  recognizingAuthority,
  recommendationStrength,
  recommendedIntake,
  recordLabel,
  recourseLoan,
  referee,
  referenceQuantity,
  referencesOrder,
  refundType,
  regionDrained,
  regionsAllowed,
  relatedAnatomy,
  relatedCondition,
  relatedDrug,
  relatedLink,
  relatedStructure,
  relatedTherapy,
  relatedTo: relatedTo2,
  releaseDate: releaseDate2,
  releaseNotes,
  releasedEvent,
  relevantOccupation,
  relevantSpecialty,
  remainingAttendeeCapacity,
  renegotiableLoan,
  repeatCount,
  repeatFrequency,
  repetitions: repetitions2,
  replacee,
  replacer,
  replyToUrl,
  reportNumber,
  representativeOfPage,
  requiredCollateral,
  requiredGender,
  requiredMaxAge,
  requiredMinAge,
  requiredQuantity,
  requirements: requirements2,
  requiresSubscription,
  reservationFor,
  reservationId,
  reservationStatus,
  reservedTicket,
  responsibilities,
  restPeriods,
  restockingFee,
  resultComment,
  resultReview,
  returnFees,
  returnLabelSource,
  returnMethod,
  returnPolicyCategory,
  returnPolicyCountry,
  returnPolicySeasonalOverride,
  returnShippingFeesAmount,
  reviewAspect,
  reviewBody,
  reviewCount,
  reviewRating,
  reviewedBy,
  reviews,
  riskFactor,
  risks,
  roofLoad,
  rsvpResponse,
  runsTo,
  runtime,
  rxcui,
  safetyConsideration,
  salaryCurrency,
  salaryUponCompletion,
  sameAs: sameAs2,
  sampleType,
  saturatedFatContent,
  scheduleTimezone,
  scheduledPaymentDate,
  scheduledTime,
  schemaVersion,
  schoolClosuresInfo,
  screenCount,
  screenshot,
  sdDatePublished,
  sdLicense,
  sdPublisher,
  seasonNumber,
  seasonalOverride,
  seasons,
  seatNumber,
  seatRow,
  seatSection,
  seatingCapacity,
  seatingType,
  secondaryPrevention,
  securityClearanceRequirement,
  securityScreening,
  seeks,
  sender: sender2,
  sensoryRequirement,
  sensoryUnit,
  seriousAdverseOutcome,
  serverStatus,
  servesCuisine,
  serviceAudience,
  serviceLocation,
  serviceOperator,
  servicePhone,
  servicePostalAddress,
  serviceSmsNumber,
  serviceType: serviceType2,
  serviceUrl,
  servingSize,
  sha256,
  sharedContent,
  shippingConditions,
  shippingDestination,
  shippingDetails,
  shippingLabel,
  shippingOrigin,
  shippingRate,
  shippingSettingsLink,
  siblings,
  signDetected,
  signOrSymptom,
  significance,
  significantLinks,
  size: size2,
  sizeGroup,
  sizeSystem,
  skills,
  sku,
  slogan,
  smiles,
  smokingAllowed,
  sodiumContent,
  softwareAddOn,
  softwareHelp,
  softwareVersion,
  source: source5,
  sourceOrganization,
  sourcedFrom,
  spatial: spatial2,
  speakable,
  specialCommitments,
  specialOpeningHoursSpecification,
  specialty: specialty2,
  speechToTextMarkup,
  speed,
  spokenByCharacter,
  sport,
  sportsActivityLocation,
  sportsEvent,
  sportsTeam,
  spouse,
  stage: stage2,
  stageAsNumber,
  starRating,
  startDate: startDate2,
  startOffset,
  startTime: startTime2,
  statType,
  status: status6,
  steeringPosition,
  stepValue,
  steps,
  storageRequirements,
  streetAddress,
  strengthUnit,
  strengthValue,
  structuralClass,
  study: study2,
  studyDesign: studyDesign2,
  studyLocation,
  studySubject,
  stupidProperty,
  subEvents,
  subReservation,
  subStageSuffix,
  subStructure,
  subTest,
  subtitleLanguage,
  successorOf,
  sugarContent,
  suggestedAge,
  suggestedGender,
  suggestedMaxAge,
  suggestedMeasurement,
  suggestedMinAge,
  suitableForDiet,
  supersededBy,
  supplyTo,
  supportingData,
  surface,
  syllabusSections,
  target: target3,
  targetDescription,
  targetName,
  targetPlatform,
  targetPopulation,
  targetProduct,
  targetUrl,
  taxID,
  taxonRank,
  taxonomicRange,
  teaches,
  telephone,
  temporal: temporal2,
  termDuration,
  termsOfService,
  termsPerYear,
  text: text2,
  textValue,
  thumbnail: thumbnail2,
  thumbnailUrl,
  tickerSymbol,
  ticketNumber,
  ticketToken,
  ticketedSeat,
  timeOfDay: timeOfDay2,
  timeRequired,
  timeToComplete,
  timestamp: timestamp2,
  tissueSample,
  title: title6,
  titleEIDR,
  toLocation,
  toRecipient,
  tocContinuation,
  tocEntry,
  tongueWeight,
  tool,
  torque,
  totalHistoricalEnrollment,
  totalJobOpenings,
  totalPaymentDue,
  totalPrice,
  totalTime,
  tourBookingPage,
  touristType,
  trackingNumber,
  trackingUrl,
  tracks,
  trailer,
  trailerWeight,
  trainName,
  trainNumber,
  trainingSalary,
  transFatContent,
  transcript,
  transitTime,
  transitTimeLabel,
  translator,
  transmissionMethod,
  travelBans,
  trialDesign,
  tributary,
  tripOrigin,
  typeOfBed,
  typeOfGood,
  typicalAgeRange,
  typicalCreditsPerTerm,
  typicalTest,
  underName,
  unitCode,
  unitText,
  unnamedSourcesPolicy,
  unsaturatedFatContent,
  uploadDate,
  upvoteCount,
  url: url4,
  urlTemplate,
  usNPI,
  usedToDiagnose,
  userInteractionCount,
  usesDevice,
  usesHealthPlanIdStandard,
  utterances,
  validFor,
  validForMemberTier,
  validFrom,
  validIn,
  validThrough,
  validUntil,
  value: value4,
  valueAddedTaxIncluded,
  valueMaxLength,
  valueMinLength,
  valueName,
  valuePattern,
  valueReference,
  valueRequired,
  variableMeasured,
  variablesMeasured,
  variantCover,
  variesBy,
  vatID,
  vehicleConfiguration,
  vehicleEngine,
  vehicleIdentificationNumber,
  vehicleInteriorColor,
  vehicleInteriorType,
  vehicleModelDate,
  vehicleSeatingCapacity,
  vehicleSpecialUsage,
  vehicleTransmission,
  vendor,
  verificationFactCheckingPolicy,
  version: version4,
  video,
  videoFormat,
  videoFrameSize,
  videoQuality,
  volumeNumber,
  warning: warning2,
  warrantyPromise,
  warrantyScope,
  webCheckinTime,
  webFeed,
  weight,
  weightPercentage,
  weightTotal,
  wheelbase,
  width: width3,
  winner,
  wordCount,
  workHours,
  workLocation,
  workPerformed,
  workPresented,
  workload,
  worksFor,
  worstRating,
  xpath,
  yearBuilt,
  yearlyRevenue,
  yearsInOperation,
  actionApplication,
  actionOption,
  album,
  albumRelease,
  alternateName,
  alumni,
  alumniOf,
  archiveHeld,
  arterialBranch,
  artworkSurface,
  attendee: attendee2,
  audience: audience3,
  availableOnDevice,
  award,
  blogPost,
  broker,
  caption,
  category: category4,
  cause,
  causeOf,
  childTaxon,
  clinicalPharmacology,
  codeSampleType,
  colleague,
  contactPoint,
  containsPlace,
  containsSeason,
  contentLocation,
  creator: creator3,
  dataset,
  dateCreated,
  director,
  employee,
  encodesBioChemEntity,
  encodesCreativeWork,
  encodingFormat,
  endDate: endDate2,
  episode,
  event: event2,
  exampleOfWork,
  executableLibraryName,
  exerciseCourse,
  founder,
  frequency: frequency2,
  fundedItem,
  funding,
  game,
  gameServer,
  genre,
  hasBioChemEntityPart,
  hasBroadcastChannel,
  hasDefinedTerm,
  hasMenu,
  hasMerchantReturnPolicy,
  hasTiers,
  hasVariant,
  holdingArchive,
  inDefinedTermSet,
  inLanguage,
  incentiveCompensation,
  interactionStatistic,
  isAccessibleForFree,
  isBasedOn,
  isEncodedByBioChemEntity,
  isPartOfBioChemEntity,
  isTierOf,
  isVariantOf,
  itemOffered,
  jobBenefits,
  jurisdiction: jurisdiction2,
  mainContentOfPage,
  mainEntity,
  mainEntityOfPage,
  makesOffer,
  measurementTechnique,
  merchantReturnDays,
  merchantReturnLink,
  offeredBy,
  offers,
  owner: owner3,
  owns,
  parent: parent2,
  parentTaxon,
  partOfSeries,
  partOfTrip,
  paymentDueDate,
  performTime,
  performer: performer2,
  photo: photo2,
  provider: provider3,
  providesBroadcastService,
  recipeIngredient,
  recordedAs,
  recordedAt,
  recordedIn,
  recordingOf,
  releaseOf,
  review,
  roleName,
  runtimePlatform,
  season,
  serialNumber: serialNumber2,
  serviceArea,
  serviceOutput,
  sibling,
  significantLink,
  softwareRequirements,
  sponsor,
  subOrganization,
  subTrip,
  subjectOf,
  suggestedAnswer,
  superEvent,
  targetCollection,
  temporalCoverage,
  termCode,
  track,
  translationOfWork,
  usageInfo,
  warranty,
  workTranslation,
  yield__workaround,
  about: about2,
  actor: actor3,
  associatedReview,
  competitor,
  containedInPlace,
  encoding,
  hasMap,
  legislationApplies,
  material: material2,
  memberOf,
  parentOrganization,
  result: result3,
  seller,
  spatialCoverage,
  step: step2,
  subEvent,
  supply,
  workFeatured,
  areaServed,
  duration: duration4,
  includedInDataCatalog,
  legislationChanges,
  member: member6,
  recipient: recipient2,
  workExample,
  description: description7,
  gtin,
  hasRepresentation,
  image: image3,
  hasPart: hasPart3,
  position: position2,
  isPartOf: isPartOf2,
  instrument: instrument2,
  object: object4,
  publishingPrinciples,
  location: location4,
  participant: participant3,
  identifier: identifier4
});

// ../node_modules/rdf-namespaces/dist/schema_https-1bb566ef.js
var AMRadioChannel2 = "https://schema.org/AMRadioChannel";
var APIReference2 = "https://schema.org/APIReference";
var AboutPage2 = "https://schema.org/AboutPage";
var AcceptAction2 = "https://schema.org/AcceptAction";
var Accommodation2 = "https://schema.org/Accommodation";
var AccountingService2 = "https://schema.org/AccountingService";
var AchieveAction2 = "https://schema.org/AchieveAction";
var Action4 = "https://schema.org/Action";
var ActionAccessSpecification2 = "https://schema.org/ActionAccessSpecification";
var ActionStatusType2 = "https://schema.org/ActionStatusType";
var ActivateAction2 = "https://schema.org/ActivateAction";
var AddAction2 = "https://schema.org/AddAction";
var AdministrativeArea2 = "https://schema.org/AdministrativeArea";
var AdultEntertainment2 = "https://schema.org/AdultEntertainment";
var AdultOrientedEnumeration2 = "https://schema.org/AdultOrientedEnumeration";
var AdvertiserContentArticle2 = "https://schema.org/AdvertiserContentArticle";
var AggregateOffer2 = "https://schema.org/AggregateOffer";
var AggregateRating2 = "https://schema.org/AggregateRating";
var AgreeAction2 = "https://schema.org/AgreeAction";
var Airline2 = "https://schema.org/Airline";
var Airport2 = "https://schema.org/Airport";
var AlignmentObject2 = "https://schema.org/AlignmentObject";
var AllocateAction2 = "https://schema.org/AllocateAction";
var AmpStory2 = "https://schema.org/AmpStory";
var AmusementPark2 = "https://schema.org/AmusementPark";
var AnalysisNewsArticle2 = "https://schema.org/AnalysisNewsArticle";
var AnatomicalStructure2 = "https://schema.org/AnatomicalStructure";
var AnatomicalSystem2 = "https://schema.org/AnatomicalSystem";
var AnimalShelter2 = "https://schema.org/AnimalShelter";
var Answer3 = "https://schema.org/Answer";
var Apartment2 = "https://schema.org/Apartment";
var ApartmentComplex2 = "https://schema.org/ApartmentComplex";
var AppendAction2 = "https://schema.org/AppendAction";
var ApplyAction2 = "https://schema.org/ApplyAction";
var ApprovedIndication2 = "https://schema.org/ApprovedIndication";
var Aquarium2 = "https://schema.org/Aquarium";
var ArchiveComponent2 = "https://schema.org/ArchiveComponent";
var ArchiveOrganization2 = "https://schema.org/ArchiveOrganization";
var ArriveAction2 = "https://schema.org/ArriveAction";
var ArtGallery2 = "https://schema.org/ArtGallery";
var Artery2 = "https://schema.org/Artery";
var Article3 = "https://schema.org/Article";
var AskAction2 = "https://schema.org/AskAction";
var AskPublicNewsArticle2 = "https://schema.org/AskPublicNewsArticle";
var AssessAction2 = "https://schema.org/AssessAction";
var AssignAction2 = "https://schema.org/AssignAction";
var Atlas2 = "https://schema.org/Atlas";
var Attorney2 = "https://schema.org/Attorney";
var Audience2 = "https://schema.org/Audience";
var AudioObject2 = "https://schema.org/AudioObject";
var AudioObjectSnapshot2 = "https://schema.org/AudioObjectSnapshot";
var Audiobook2 = "https://schema.org/Audiobook";
var AuthenticateAction2 = "https://schema.org/AuthenticateAction";
var AuthorizeAction2 = "https://schema.org/AuthorizeAction";
var AutoBodyShop2 = "https://schema.org/AutoBodyShop";
var AutoDealer2 = "https://schema.org/AutoDealer";
var AutoPartsStore2 = "https://schema.org/AutoPartsStore";
var AutoRental2 = "https://schema.org/AutoRental";
var AutoRepair2 = "https://schema.org/AutoRepair";
var AutoWash2 = "https://schema.org/AutoWash";
var AutomatedTeller2 = "https://schema.org/AutomatedTeller";
var AutomotiveBusiness2 = "https://schema.org/AutomotiveBusiness";
var BackgroundNewsArticle2 = "https://schema.org/BackgroundNewsArticle";
var Bakery2 = "https://schema.org/Bakery";
var BankAccount2 = "https://schema.org/BankAccount";
var BankOrCreditUnion2 = "https://schema.org/BankOrCreditUnion";
var BarOrPub2 = "https://schema.org/BarOrPub";
var Barcode2 = "https://schema.org/Barcode";
var Beach2 = "https://schema.org/Beach";
var BeautySalon2 = "https://schema.org/BeautySalon";
var BedAndBreakfast2 = "https://schema.org/BedAndBreakfast";
var BedDetails2 = "https://schema.org/BedDetails";
var BedType2 = "https://schema.org/BedType";
var BefriendAction2 = "https://schema.org/BefriendAction";
var BikeStore2 = "https://schema.org/BikeStore";
var BioChemEntity2 = "https://schema.org/BioChemEntity";
var Blog2 = "https://schema.org/Blog";
var BlogPosting2 = "https://schema.org/BlogPosting";
var BloodTest2 = "https://schema.org/BloodTest";
var BoardingPolicyType2 = "https://schema.org/BoardingPolicyType";
var BoatReservation2 = "https://schema.org/BoatReservation";
var BoatTerminal2 = "https://schema.org/BoatTerminal";
var BoatTrip2 = "https://schema.org/BoatTrip";
var BodyMeasurementTypeEnumeration2 = "https://schema.org/BodyMeasurementTypeEnumeration";
var BodyOfWater2 = "https://schema.org/BodyOfWater";
var Bone2 = "https://schema.org/Bone";
var Book2 = "https://schema.org/Book";
var BookFormatType2 = "https://schema.org/BookFormatType";
var BookSeries2 = "https://schema.org/BookSeries";
var BookStore2 = "https://schema.org/BookStore";
var BookmarkAction2 = "https://schema.org/BookmarkAction";
var Boolean__workaround2 = "https://schema.org/Boolean";
var BorrowAction2 = "https://schema.org/BorrowAction";
var BowlingAlley2 = "https://schema.org/BowlingAlley";
var BrainStructure2 = "https://schema.org/BrainStructure";
var Brand2 = "https://schema.org/Brand";
var BreadcrumbList2 = "https://schema.org/BreadcrumbList";
var Brewery2 = "https://schema.org/Brewery";
var Bridge2 = "https://schema.org/Bridge";
var BroadcastChannel2 = "https://schema.org/BroadcastChannel";
var BroadcastEvent2 = "https://schema.org/BroadcastEvent";
var BroadcastFrequencySpecification2 = "https://schema.org/BroadcastFrequencySpecification";
var BroadcastService2 = "https://schema.org/BroadcastService";
var BrokerageAccount2 = "https://schema.org/BrokerageAccount";
var BuddhistTemple2 = "https://schema.org/BuddhistTemple";
var BusOrCoach2 = "https://schema.org/BusOrCoach";
var BusReservation2 = "https://schema.org/BusReservation";
var BusStation2 = "https://schema.org/BusStation";
var BusStop2 = "https://schema.org/BusStop";
var BusTrip2 = "https://schema.org/BusTrip";
var BusinessAudience2 = "https://schema.org/BusinessAudience";
var BusinessEntityType2 = "https://schema.org/BusinessEntityType";
var BusinessEvent2 = "https://schema.org/BusinessEvent";
var BusinessFunction2 = "https://schema.org/BusinessFunction";
var BuyAction2 = "https://schema.org/BuyAction";
var CDCPMDRecord2 = "https://schema.org/CDCPMDRecord";
var CableOrSatelliteService2 = "https://schema.org/CableOrSatelliteService";
var CafeOrCoffeeShop2 = "https://schema.org/CafeOrCoffeeShop";
var Campground2 = "https://schema.org/Campground";
var CampingPitch2 = "https://schema.org/CampingPitch";
var Canal2 = "https://schema.org/Canal";
var CancelAction2 = "https://schema.org/CancelAction";
var Car2 = "https://schema.org/Car";
var CarUsageType2 = "https://schema.org/CarUsageType";
var Casino2 = "https://schema.org/Casino";
var CategoryCode2 = "https://schema.org/CategoryCode";
var CategoryCodeSet2 = "https://schema.org/CategoryCodeSet";
var CatholicChurch2 = "https://schema.org/CatholicChurch";
var Cemetery2 = "https://schema.org/Cemetery";
var Certification2 = "https://schema.org/Certification";
var CertificationStatusEnumeration2 = "https://schema.org/CertificationStatusEnumeration";
var Chapter2 = "https://schema.org/Chapter";
var CheckAction2 = "https://schema.org/CheckAction";
var CheckInAction2 = "https://schema.org/CheckInAction";
var CheckOutAction2 = "https://schema.org/CheckOutAction";
var CheckoutPage2 = "https://schema.org/CheckoutPage";
var ChemicalSubstance2 = "https://schema.org/ChemicalSubstance";
var ChildCare2 = "https://schema.org/ChildCare";
var ChildrensEvent2 = "https://schema.org/ChildrensEvent";
var ChooseAction2 = "https://schema.org/ChooseAction";
var Church2 = "https://schema.org/Church";
var City2 = "https://schema.org/City";
var CityHall2 = "https://schema.org/CityHall";
var CivicStructure2 = "https://schema.org/CivicStructure";
var Claim3 = "https://schema.org/Claim";
var ClaimReview2 = "https://schema.org/ClaimReview";
var Class6 = "https://schema.org/Class";
var Clip2 = "https://schema.org/Clip";
var ClothingStore2 = "https://schema.org/ClothingStore";
var Code2 = "https://schema.org/Code";
var Collection6 = "https://schema.org/Collection";
var CollectionPage3 = "https://schema.org/CollectionPage";
var CollegeOrUniversity2 = "https://schema.org/CollegeOrUniversity";
var ComedyClub2 = "https://schema.org/ComedyClub";
var ComedyEvent2 = "https://schema.org/ComedyEvent";
var ComicCoverArt2 = "https://schema.org/ComicCoverArt";
var ComicIssue2 = "https://schema.org/ComicIssue";
var ComicSeries2 = "https://schema.org/ComicSeries";
var ComicStory2 = "https://schema.org/ComicStory";
var Comment2 = "https://schema.org/Comment";
var CommentAction2 = "https://schema.org/CommentAction";
var CommunicateAction2 = "https://schema.org/CommunicateAction";
var CompleteDataFeed2 = "https://schema.org/CompleteDataFeed";
var CompoundPriceSpecification2 = "https://schema.org/CompoundPriceSpecification";
var ComputerLanguage2 = "https://schema.org/ComputerLanguage";
var ComputerStore2 = "https://schema.org/ComputerStore";
var ConferenceEvent2 = "https://schema.org/ConferenceEvent";
var ConfirmAction2 = "https://schema.org/ConfirmAction";
var Consortium2 = "https://schema.org/Consortium";
var ConstraintNode2 = "https://schema.org/ConstraintNode";
var ConsumeAction2 = "https://schema.org/ConsumeAction";
var ContactPage2 = "https://schema.org/ContactPage";
var ContactPoint3 = "https://schema.org/ContactPoint";
var ContactPointOption2 = "https://schema.org/ContactPointOption";
var Continent2 = "https://schema.org/Continent";
var ControlAction2 = "https://schema.org/ControlAction";
var ConvenienceStore2 = "https://schema.org/ConvenienceStore";
var Conversation2 = "https://schema.org/Conversation";
var CookAction2 = "https://schema.org/CookAction";
var Cooperative2 = "https://schema.org/Cooperative";
var Corporation2 = "https://schema.org/Corporation";
var CorrectionComment2 = "https://schema.org/CorrectionComment";
var Country2 = "https://schema.org/Country";
var Course2 = "https://schema.org/Course";
var CourseInstance2 = "https://schema.org/CourseInstance";
var Courthouse2 = "https://schema.org/Courthouse";
var CoverArt2 = "https://schema.org/CoverArt";
var CovidTestingFacility2 = "https://schema.org/CovidTestingFacility";
var CreateAction2 = "https://schema.org/CreateAction";
var CreativeWork2 = "https://schema.org/CreativeWork";
var CreativeWorkSeason2 = "https://schema.org/CreativeWorkSeason";
var CreativeWorkSeries2 = "https://schema.org/CreativeWorkSeries";
var Credential2 = "https://schema.org/Credential";
var CreditCard2 = "https://schema.org/CreditCard";
var Crematorium2 = "https://schema.org/Crematorium";
var CriticReview2 = "https://schema.org/CriticReview";
var CssSelectorType2 = "https://schema.org/CssSelectorType";
var CurrencyConversionService2 = "https://schema.org/CurrencyConversionService";
var DDxElement2 = "https://schema.org/DDxElement";
var DENonprofitType2 = "https://schema.org/DENonprofitType";
var DanceEvent2 = "https://schema.org/DanceEvent";
var DanceGroup2 = "https://schema.org/DanceGroup";
var DataCatalog2 = "https://schema.org/DataCatalog";
var DataDownload2 = "https://schema.org/DataDownload";
var DataFeed2 = "https://schema.org/DataFeed";
var DataFeedItem2 = "https://schema.org/DataFeedItem";
var DataType3 = "https://schema.org/DataType";
var Dataset2 = "https://schema.org/Dataset";
var Date__workaround2 = "https://schema.org/Date";
var DateTime2 = "https://schema.org/DateTime";
var DatedMoneySpecification2 = "https://schema.org/DatedMoneySpecification";
var DayOfWeek2 = "https://schema.org/DayOfWeek";
var DaySpa2 = "https://schema.org/DaySpa";
var DeactivateAction2 = "https://schema.org/DeactivateAction";
var DefenceEstablishment2 = "https://schema.org/DefenceEstablishment";
var DefinedRegion2 = "https://schema.org/DefinedRegion";
var DefinedTerm2 = "https://schema.org/DefinedTerm";
var DefinedTermSet2 = "https://schema.org/DefinedTermSet";
var DeleteAction2 = "https://schema.org/DeleteAction";
var DeliveryChargeSpecification2 = "https://schema.org/DeliveryChargeSpecification";
var DeliveryEvent2 = "https://schema.org/DeliveryEvent";
var DeliveryMethod2 = "https://schema.org/DeliveryMethod";
var DeliveryTimeSettings2 = "https://schema.org/DeliveryTimeSettings";
var Demand2 = "https://schema.org/Demand";
var Dentist2 = "https://schema.org/Dentist";
var DepartAction2 = "https://schema.org/DepartAction";
var DepartmentStore2 = "https://schema.org/DepartmentStore";
var DepositAccount2 = "https://schema.org/DepositAccount";
var DiagnosticLab2 = "https://schema.org/DiagnosticLab";
var DiagnosticProcedure2 = "https://schema.org/DiagnosticProcedure";
var Diet2 = "https://schema.org/Diet";
var DietarySupplement2 = "https://schema.org/DietarySupplement";
var DigitalDocument2 = "https://schema.org/DigitalDocument";
var DigitalDocumentPermission2 = "https://schema.org/DigitalDocumentPermission";
var DigitalDocumentPermissionType2 = "https://schema.org/DigitalDocumentPermissionType";
var DigitalPlatformEnumeration2 = "https://schema.org/DigitalPlatformEnumeration";
var DisagreeAction2 = "https://schema.org/DisagreeAction";
var DiscoverAction2 = "https://schema.org/DiscoverAction";
var DiscussionForumPosting2 = "https://schema.org/DiscussionForumPosting";
var DislikeAction2 = "https://schema.org/DislikeAction";
var Distance3 = "https://schema.org/Distance";
var Distillery2 = "https://schema.org/Distillery";
var DonateAction2 = "https://schema.org/DonateAction";
var DoseSchedule2 = "https://schema.org/DoseSchedule";
var DownloadAction2 = "https://schema.org/DownloadAction";
var DrawAction2 = "https://schema.org/DrawAction";
var Drawing2 = "https://schema.org/Drawing";
var DrinkAction2 = "https://schema.org/DrinkAction";
var DriveWheelConfigurationValue2 = "https://schema.org/DriveWheelConfigurationValue";
var Drug2 = "https://schema.org/Drug";
var DrugClass2 = "https://schema.org/DrugClass";
var DrugCost2 = "https://schema.org/DrugCost";
var DrugCostCategory2 = "https://schema.org/DrugCostCategory";
var DrugLegalStatus2 = "https://schema.org/DrugLegalStatus";
var DrugPregnancyCategory2 = "https://schema.org/DrugPregnancyCategory";
var DrugPrescriptionStatus2 = "https://schema.org/DrugPrescriptionStatus";
var DrugStrength2 = "https://schema.org/DrugStrength";
var DryCleaningOrLaundry2 = "https://schema.org/DryCleaningOrLaundry";
var Duration3 = "https://schema.org/Duration";
var EUEnergyEfficiencyEnumeration2 = "https://schema.org/EUEnergyEfficiencyEnumeration";
var EatAction2 = "https://schema.org/EatAction";
var EducationEvent2 = "https://schema.org/EducationEvent";
var EducationalAudience2 = "https://schema.org/EducationalAudience";
var EducationalOccupationalCredential2 = "https://schema.org/EducationalOccupationalCredential";
var EducationalOccupationalProgram2 = "https://schema.org/EducationalOccupationalProgram";
var EducationalOrganization2 = "https://schema.org/EducationalOrganization";
var Electrician2 = "https://schema.org/Electrician";
var ElectronicsStore2 = "https://schema.org/ElectronicsStore";
var ElementarySchool2 = "https://schema.org/ElementarySchool";
var EmailMessage2 = "https://schema.org/EmailMessage";
var Embassy2 = "https://schema.org/Embassy";
var EmergencyService2 = "https://schema.org/EmergencyService";
var EmployeeRole2 = "https://schema.org/EmployeeRole";
var EmployerAggregateRating2 = "https://schema.org/EmployerAggregateRating";
var EmployerReview2 = "https://schema.org/EmployerReview";
var EmploymentAgency2 = "https://schema.org/EmploymentAgency";
var EndorseAction2 = "https://schema.org/EndorseAction";
var EndorsementRating2 = "https://schema.org/EndorsementRating";
var Energy2 = "https://schema.org/Energy";
var EnergyConsumptionDetails2 = "https://schema.org/EnergyConsumptionDetails";
var EnergyEfficiencyEnumeration2 = "https://schema.org/EnergyEfficiencyEnumeration";
var EnergyStarEnergyEfficiencyEnumeration2 = "https://schema.org/EnergyStarEnergyEfficiencyEnumeration";
var EngineSpecification2 = "https://schema.org/EngineSpecification";
var EntertainmentBusiness2 = "https://schema.org/EntertainmentBusiness";
var EntryPoint2 = "https://schema.org/EntryPoint";
var Enumeration2 = "https://schema.org/Enumeration";
var Episode2 = "https://schema.org/Episode";
var Error__workaround4 = "https://schema.org/Error";
var Event3 = "https://schema.org/Event";
var EventAttendanceModeEnumeration2 = "https://schema.org/EventAttendanceModeEnumeration";
var EventReservation2 = "https://schema.org/EventReservation";
var EventSeries2 = "https://schema.org/EventSeries";
var EventStatusType2 = "https://schema.org/EventStatusType";
var EventVenue2 = "https://schema.org/EventVenue";
var ExchangeRateSpecification2 = "https://schema.org/ExchangeRateSpecification";
var ExerciseAction2 = "https://schema.org/ExerciseAction";
var ExerciseGym2 = "https://schema.org/ExerciseGym";
var ExercisePlan2 = "https://schema.org/ExercisePlan";
var ExhibitionEvent2 = "https://schema.org/ExhibitionEvent";
var FAQPage2 = "https://schema.org/FAQPage";
var FMRadioChannel2 = "https://schema.org/FMRadioChannel";
var FastFoodRestaurant2 = "https://schema.org/FastFoodRestaurant";
var Festival2 = "https://schema.org/Festival";
var FilmAction2 = "https://schema.org/FilmAction";
var FinancialIncentive2 = "https://schema.org/FinancialIncentive";
var FinancialProduct2 = "https://schema.org/FinancialProduct";
var FinancialService2 = "https://schema.org/FinancialService";
var FindAction2 = "https://schema.org/FindAction";
var FireStation2 = "https://schema.org/FireStation";
var Flight2 = "https://schema.org/Flight";
var FlightReservation2 = "https://schema.org/FlightReservation";
var Float2 = "https://schema.org/Float";
var FloorPlan2 = "https://schema.org/FloorPlan";
var Florist2 = "https://schema.org/Florist";
var FollowAction2 = "https://schema.org/FollowAction";
var FoodEstablishment2 = "https://schema.org/FoodEstablishment";
var FoodEstablishmentReservation2 = "https://schema.org/FoodEstablishmentReservation";
var FoodEvent2 = "https://schema.org/FoodEvent";
var FoodService2 = "https://schema.org/FoodService";
var FulfillmentTypeEnumeration2 = "https://schema.org/FulfillmentTypeEnumeration";
var FundingAgency2 = "https://schema.org/FundingAgency";
var FundingScheme2 = "https://schema.org/FundingScheme";
var FurnitureStore2 = "https://schema.org/FurnitureStore";
var Game2 = "https://schema.org/Game";
var GameAvailabilityEnumeration2 = "https://schema.org/GameAvailabilityEnumeration";
var GamePlayMode2 = "https://schema.org/GamePlayMode";
var GameServer2 = "https://schema.org/GameServer";
var GameServerStatus2 = "https://schema.org/GameServerStatus";
var GardenStore2 = "https://schema.org/GardenStore";
var GasStation2 = "https://schema.org/GasStation";
var GatedResidenceCommunity2 = "https://schema.org/GatedResidenceCommunity";
var GenderType2 = "https://schema.org/GenderType";
var Gene2 = "https://schema.org/Gene";
var GeneralContractor2 = "https://schema.org/GeneralContractor";
var GeoCircle2 = "https://schema.org/GeoCircle";
var GeoCoordinates2 = "https://schema.org/GeoCoordinates";
var GeoShape2 = "https://schema.org/GeoShape";
var GeospatialGeometry2 = "https://schema.org/GeospatialGeometry";
var GiveAction2 = "https://schema.org/GiveAction";
var GolfCourse2 = "https://schema.org/GolfCourse";
var GovernmentBenefitsType2 = "https://schema.org/GovernmentBenefitsType";
var GovernmentBuilding2 = "https://schema.org/GovernmentBuilding";
var GovernmentOffice2 = "https://schema.org/GovernmentOffice";
var GovernmentOrganization2 = "https://schema.org/GovernmentOrganization";
var GovernmentPermit2 = "https://schema.org/GovernmentPermit";
var GovernmentService2 = "https://schema.org/GovernmentService";
var Grant2 = "https://schema.org/Grant";
var GroceryStore2 = "https://schema.org/GroceryStore";
var Guide2 = "https://schema.org/Guide";
var HVACBusiness2 = "https://schema.org/HVACBusiness";
var Hackathon2 = "https://schema.org/Hackathon";
var HairSalon2 = "https://schema.org/HairSalon";
var HardwareStore2 = "https://schema.org/HardwareStore";
var HealthAndBeautyBusiness2 = "https://schema.org/HealthAndBeautyBusiness";
var HealthAspectEnumeration2 = "https://schema.org/HealthAspectEnumeration";
var HealthClub2 = "https://schema.org/HealthClub";
var HealthInsurancePlan2 = "https://schema.org/HealthInsurancePlan";
var HealthPlanCostSharingSpecification2 = "https://schema.org/HealthPlanCostSharingSpecification";
var HealthPlanFormulary2 = "https://schema.org/HealthPlanFormulary";
var HealthPlanNetwork2 = "https://schema.org/HealthPlanNetwork";
var HealthTopicContent2 = "https://schema.org/HealthTopicContent";
var HighSchool2 = "https://schema.org/HighSchool";
var HinduTemple2 = "https://schema.org/HinduTemple";
var HobbyShop2 = "https://schema.org/HobbyShop";
var HomeAndConstructionBusiness2 = "https://schema.org/HomeAndConstructionBusiness";
var HomeGoodsStore2 = "https://schema.org/HomeGoodsStore";
var Hospital2 = "https://schema.org/Hospital";
var Hostel2 = "https://schema.org/Hostel";
var Hotel2 = "https://schema.org/Hotel";
var HotelRoom2 = "https://schema.org/HotelRoom";
var House2 = "https://schema.org/House";
var HousePainter2 = "https://schema.org/HousePainter";
var HowTo2 = "https://schema.org/HowTo";
var HowToDirection2 = "https://schema.org/HowToDirection";
var HowToItem2 = "https://schema.org/HowToItem";
var HowToSection2 = "https://schema.org/HowToSection";
var HowToStep2 = "https://schema.org/HowToStep";
var HowToSupply2 = "https://schema.org/HowToSupply";
var HowToTip2 = "https://schema.org/HowToTip";
var HowToTool2 = "https://schema.org/HowToTool";
var HyperToc2 = "https://schema.org/HyperToc";
var HyperTocEntry2 = "https://schema.org/HyperTocEntry";
var IPTCDigitalSourceEnumeration2 = "https://schema.org/IPTCDigitalSourceEnumeration";
var ITNonprofitType2 = "https://schema.org/ITNonprofitType";
var IceCreamShop2 = "https://schema.org/IceCreamShop";
var IgnoreAction2 = "https://schema.org/IgnoreAction";
var ImageGallery2 = "https://schema.org/ImageGallery";
var ImageObject2 = "https://schema.org/ImageObject";
var ImageObjectSnapshot2 = "https://schema.org/ImageObjectSnapshot";
var ImagingTest2 = "https://schema.org/ImagingTest";
var IncentiveQualifiedExpenseType2 = "https://schema.org/IncentiveQualifiedExpenseType";
var IncentiveStatus2 = "https://schema.org/IncentiveStatus";
var IncentiveType2 = "https://schema.org/IncentiveType";
var IndividualPhysician2 = "https://schema.org/IndividualPhysician";
var IndividualProduct2 = "https://schema.org/IndividualProduct";
var InfectiousAgentClass2 = "https://schema.org/InfectiousAgentClass";
var InfectiousDisease2 = "https://schema.org/InfectiousDisease";
var InformAction2 = "https://schema.org/InformAction";
var InsertAction2 = "https://schema.org/InsertAction";
var InstallAction2 = "https://schema.org/InstallAction";
var InstantaneousEvent3 = "https://schema.org/InstantaneousEvent";
var InsuranceAgency2 = "https://schema.org/InsuranceAgency";
var Intangible2 = "https://schema.org/Intangible";
var Integer2 = "https://schema.org/Integer";
var InteractAction2 = "https://schema.org/InteractAction";
var InteractionCounter2 = "https://schema.org/InteractionCounter";
var InternetCafe2 = "https://schema.org/InternetCafe";
var InvestmentFund2 = "https://schema.org/InvestmentFund";
var InvestmentOrDeposit2 = "https://schema.org/InvestmentOrDeposit";
var InviteAction2 = "https://schema.org/InviteAction";
var Invoice3 = "https://schema.org/Invoice";
var ItemAvailability2 = "https://schema.org/ItemAvailability";
var ItemList2 = "https://schema.org/ItemList";
var ItemListOrderType2 = "https://schema.org/ItemListOrderType";
var ItemPage2 = "https://schema.org/ItemPage";
var JewelryStore2 = "https://schema.org/JewelryStore";
var JobPosting2 = "https://schema.org/JobPosting";
var JoinAction2 = "https://schema.org/JoinAction";
var Joint2 = "https://schema.org/Joint";
var LakeBodyOfWater2 = "https://schema.org/LakeBodyOfWater";
var Landform2 = "https://schema.org/Landform";
var LandmarksOrHistoricalBuildings2 = "https://schema.org/LandmarksOrHistoricalBuildings";
var Language2 = "https://schema.org/Language";
var LearningResource2 = "https://schema.org/LearningResource";
var LeaveAction2 = "https://schema.org/LeaveAction";
var LegalForceStatus2 = "https://schema.org/LegalForceStatus";
var LegalService2 = "https://schema.org/LegalService";
var LegalValueLevel2 = "https://schema.org/LegalValueLevel";
var Legislation2 = "https://schema.org/Legislation";
var LegislationObject2 = "https://schema.org/LegislationObject";
var LegislativeBuilding2 = "https://schema.org/LegislativeBuilding";
var LendAction2 = "https://schema.org/LendAction";
var Library3 = "https://schema.org/Library";
var LibrarySystem2 = "https://schema.org/LibrarySystem";
var LifestyleModification2 = "https://schema.org/LifestyleModification";
var Ligament2 = "https://schema.org/Ligament";
var LikeAction2 = "https://schema.org/LikeAction";
var LinkRole2 = "https://schema.org/LinkRole";
var LiquorStore2 = "https://schema.org/LiquorStore";
var ListItem2 = "https://schema.org/ListItem";
var ListenAction2 = "https://schema.org/ListenAction";
var LiteraryEvent2 = "https://schema.org/LiteraryEvent";
var LiveBlogPosting2 = "https://schema.org/LiveBlogPosting";
var LoanOrCredit2 = "https://schema.org/LoanOrCredit";
var LocalBusiness2 = "https://schema.org/LocalBusiness";
var LocationFeatureSpecification2 = "https://schema.org/LocationFeatureSpecification";
var Locksmith2 = "https://schema.org/Locksmith";
var LodgingBusiness2 = "https://schema.org/LodgingBusiness";
var LodgingReservation2 = "https://schema.org/LodgingReservation";
var LoginAction2 = "https://schema.org/LoginAction";
var LoseAction2 = "https://schema.org/LoseAction";
var LymphaticVessel2 = "https://schema.org/LymphaticVessel";
var Manuscript2 = "https://schema.org/Manuscript";
var Map__workaround2 = "https://schema.org/Map";
var MapCategoryType2 = "https://schema.org/MapCategoryType";
var MarryAction2 = "https://schema.org/MarryAction";
var Mass2 = "https://schema.org/Mass";
var MathSolver2 = "https://schema.org/MathSolver";
var MaximumDoseSchedule2 = "https://schema.org/MaximumDoseSchedule";
var MeasurementMethodEnum2 = "https://schema.org/MeasurementMethodEnum";
var MeasurementTypeEnumeration2 = "https://schema.org/MeasurementTypeEnumeration";
var MediaEnumeration2 = "https://schema.org/MediaEnumeration";
var MediaGallery2 = "https://schema.org/MediaGallery";
var MediaManipulationRatingEnumeration2 = "https://schema.org/MediaManipulationRatingEnumeration";
var MediaObject2 = "https://schema.org/MediaObject";
var MediaReview2 = "https://schema.org/MediaReview";
var MediaReviewItem2 = "https://schema.org/MediaReviewItem";
var MediaSubscription2 = "https://schema.org/MediaSubscription";
var MedicalAudience2 = "https://schema.org/MedicalAudience";
var MedicalAudienceType2 = "https://schema.org/MedicalAudienceType";
var MedicalBusiness2 = "https://schema.org/MedicalBusiness";
var MedicalCause2 = "https://schema.org/MedicalCause";
var MedicalClinic2 = "https://schema.org/MedicalClinic";
var MedicalCode2 = "https://schema.org/MedicalCode";
var MedicalCondition2 = "https://schema.org/MedicalCondition";
var MedicalConditionStage2 = "https://schema.org/MedicalConditionStage";
var MedicalContraindication2 = "https://schema.org/MedicalContraindication";
var MedicalDevice2 = "https://schema.org/MedicalDevice";
var MedicalDevicePurpose2 = "https://schema.org/MedicalDevicePurpose";
var MedicalEntity2 = "https://schema.org/MedicalEntity";
var MedicalEnumeration2 = "https://schema.org/MedicalEnumeration";
var MedicalEvidenceLevel2 = "https://schema.org/MedicalEvidenceLevel";
var MedicalGuideline2 = "https://schema.org/MedicalGuideline";
var MedicalGuidelineContraindication2 = "https://schema.org/MedicalGuidelineContraindication";
var MedicalGuidelineRecommendation2 = "https://schema.org/MedicalGuidelineRecommendation";
var MedicalImagingTechnique2 = "https://schema.org/MedicalImagingTechnique";
var MedicalIndication2 = "https://schema.org/MedicalIndication";
var MedicalIntangible2 = "https://schema.org/MedicalIntangible";
var MedicalObservationalStudy2 = "https://schema.org/MedicalObservationalStudy";
var MedicalObservationalStudyDesign2 = "https://schema.org/MedicalObservationalStudyDesign";
var MedicalOrganization2 = "https://schema.org/MedicalOrganization";
var MedicalProcedure2 = "https://schema.org/MedicalProcedure";
var MedicalProcedureType2 = "https://schema.org/MedicalProcedureType";
var MedicalRiskCalculator2 = "https://schema.org/MedicalRiskCalculator";
var MedicalRiskEstimator2 = "https://schema.org/MedicalRiskEstimator";
var MedicalRiskFactor2 = "https://schema.org/MedicalRiskFactor";
var MedicalRiskScore2 = "https://schema.org/MedicalRiskScore";
var MedicalScholarlyArticle2 = "https://schema.org/MedicalScholarlyArticle";
var MedicalSign2 = "https://schema.org/MedicalSign";
var MedicalSignOrSymptom2 = "https://schema.org/MedicalSignOrSymptom";
var MedicalSpecialty2 = "https://schema.org/MedicalSpecialty";
var MedicalStudy2 = "https://schema.org/MedicalStudy";
var MedicalStudyStatus2 = "https://schema.org/MedicalStudyStatus";
var MedicalSymptom2 = "https://schema.org/MedicalSymptom";
var MedicalTest2 = "https://schema.org/MedicalTest";
var MedicalTestPanel2 = "https://schema.org/MedicalTestPanel";
var MedicalTherapy2 = "https://schema.org/MedicalTherapy";
var MedicalTrial2 = "https://schema.org/MedicalTrial";
var MedicalTrialDesign2 = "https://schema.org/MedicalTrialDesign";
var MedicalWebPage2 = "https://schema.org/MedicalWebPage";
var MedicineSystem2 = "https://schema.org/MedicineSystem";
var MeetingRoom2 = "https://schema.org/MeetingRoom";
var MemberProgram2 = "https://schema.org/MemberProgram";
var MemberProgramTier2 = "https://schema.org/MemberProgramTier";
var MensClothingStore2 = "https://schema.org/MensClothingStore";
var Menu2 = "https://schema.org/Menu";
var MenuItem2 = "https://schema.org/MenuItem";
var MenuSection2 = "https://schema.org/MenuSection";
var MerchantReturnEnumeration2 = "https://schema.org/MerchantReturnEnumeration";
var MerchantReturnPolicy2 = "https://schema.org/MerchantReturnPolicy";
var MerchantReturnPolicySeasonalOverride2 = "https://schema.org/MerchantReturnPolicySeasonalOverride";
var Message3 = "https://schema.org/Message";
var MiddleSchool2 = "https://schema.org/MiddleSchool";
var MobileApplication2 = "https://schema.org/MobileApplication";
var MobilePhoneStore2 = "https://schema.org/MobilePhoneStore";
var MolecularEntity2 = "https://schema.org/MolecularEntity";
var MonetaryAmount2 = "https://schema.org/MonetaryAmount";
var MonetaryAmountDistribution2 = "https://schema.org/MonetaryAmountDistribution";
var MonetaryGrant2 = "https://schema.org/MonetaryGrant";
var MoneyTransfer2 = "https://schema.org/MoneyTransfer";
var MortgageLoan2 = "https://schema.org/MortgageLoan";
var Mosque2 = "https://schema.org/Mosque";
var Motel2 = "https://schema.org/Motel";
var Motorcycle2 = "https://schema.org/Motorcycle";
var MotorcycleDealer2 = "https://schema.org/MotorcycleDealer";
var MotorcycleRepair2 = "https://schema.org/MotorcycleRepair";
var MotorizedBicycle2 = "https://schema.org/MotorizedBicycle";
var Mountain2 = "https://schema.org/Mountain";
var MoveAction2 = "https://schema.org/MoveAction";
var Movie2 = "https://schema.org/Movie";
var MovieClip2 = "https://schema.org/MovieClip";
var MovieRentalStore2 = "https://schema.org/MovieRentalStore";
var MovieSeries2 = "https://schema.org/MovieSeries";
var MovieTheater2 = "https://schema.org/MovieTheater";
var MovingCompany2 = "https://schema.org/MovingCompany";
var Muscle2 = "https://schema.org/Muscle";
var Museum2 = "https://schema.org/Museum";
var MusicAlbum2 = "https://schema.org/MusicAlbum";
var MusicAlbumProductionType2 = "https://schema.org/MusicAlbumProductionType";
var MusicAlbumReleaseType2 = "https://schema.org/MusicAlbumReleaseType";
var MusicComposition2 = "https://schema.org/MusicComposition";
var MusicEvent2 = "https://schema.org/MusicEvent";
var MusicGroup2 = "https://schema.org/MusicGroup";
var MusicPlaylist2 = "https://schema.org/MusicPlaylist";
var MusicRecording2 = "https://schema.org/MusicRecording";
var MusicRelease2 = "https://schema.org/MusicRelease";
var MusicReleaseFormatType2 = "https://schema.org/MusicReleaseFormatType";
var MusicStore2 = "https://schema.org/MusicStore";
var MusicVenue2 = "https://schema.org/MusicVenue";
var MusicVideoObject2 = "https://schema.org/MusicVideoObject";
var NGO2 = "https://schema.org/NGO";
var NLNonprofitType2 = "https://schema.org/NLNonprofitType";
var NailSalon2 = "https://schema.org/NailSalon";
var Nerve2 = "https://schema.org/Nerve";
var NewsArticle2 = "https://schema.org/NewsArticle";
var NewsMediaOrganization2 = "https://schema.org/NewsMediaOrganization";
var Newspaper2 = "https://schema.org/Newspaper";
var NightClub2 = "https://schema.org/NightClub";
var NonprofitType2 = "https://schema.org/NonprofitType";
var Notary2 = "https://schema.org/Notary";
var NoteDigitalDocument2 = "https://schema.org/NoteDigitalDocument";
var Number__workaround2 = "https://schema.org/Number";
var NutritionInformation2 = "https://schema.org/NutritionInformation";
var Observation3 = "https://schema.org/Observation";
var Occupation2 = "https://schema.org/Occupation";
var OccupationalExperienceRequirements2 = "https://schema.org/OccupationalExperienceRequirements";
var OccupationalTherapy2 = "https://schema.org/OccupationalTherapy";
var OceanBodyOfWater2 = "https://schema.org/OceanBodyOfWater";
var Offer3 = "https://schema.org/Offer";
var OfferCatalog2 = "https://schema.org/OfferCatalog";
var OfferForLease2 = "https://schema.org/OfferForLease";
var OfferForPurchase2 = "https://schema.org/OfferForPurchase";
var OfferItemCondition2 = "https://schema.org/OfferItemCondition";
var OfferShippingDetails2 = "https://schema.org/OfferShippingDetails";
var OfficeEquipmentStore2 = "https://schema.org/OfficeEquipmentStore";
var OnDemandEvent2 = "https://schema.org/OnDemandEvent";
var OnlineBusiness2 = "https://schema.org/OnlineBusiness";
var OnlineMarketplace2 = "https://schema.org/OnlineMarketplace";
var OnlineStore2 = "https://schema.org/OnlineStore";
var OpeningHoursSpecification2 = "https://schema.org/OpeningHoursSpecification";
var OperatingSystem2 = "https://schema.org/OperatingSystem";
var OpinionNewsArticle2 = "https://schema.org/OpinionNewsArticle";
var Optician2 = "https://schema.org/Optician";
var Order2 = "https://schema.org/Order";
var OrderAction2 = "https://schema.org/OrderAction";
var OrderItem2 = "https://schema.org/OrderItem";
var OrderStatus2 = "https://schema.org/OrderStatus";
var Organization6 = "https://schema.org/Organization";
var OrganizationRole2 = "https://schema.org/OrganizationRole";
var OrganizeAction2 = "https://schema.org/OrganizeAction";
var OutletStore2 = "https://schema.org/OutletStore";
var OwnershipInfo2 = "https://schema.org/OwnershipInfo";
var PaintAction2 = "https://schema.org/PaintAction";
var Painting2 = "https://schema.org/Painting";
var PalliativeProcedure2 = "https://schema.org/PalliativeProcedure";
var ParcelDelivery2 = "https://schema.org/ParcelDelivery";
var ParentAudience2 = "https://schema.org/ParentAudience";
var Park2 = "https://schema.org/Park";
var ParkingFacility2 = "https://schema.org/ParkingFacility";
var PathologyTest2 = "https://schema.org/PathologyTest";
var Patient3 = "https://schema.org/Patient";
var PawnShop2 = "https://schema.org/PawnShop";
var PayAction2 = "https://schema.org/PayAction";
var PaymentCard2 = "https://schema.org/PaymentCard";
var PaymentChargeSpecification2 = "https://schema.org/PaymentChargeSpecification";
var PaymentMethod2 = "https://schema.org/PaymentMethod";
var PaymentMethodType2 = "https://schema.org/PaymentMethodType";
var PaymentService2 = "https://schema.org/PaymentService";
var PaymentStatusType2 = "https://schema.org/PaymentStatusType";
var PeopleAudience2 = "https://schema.org/PeopleAudience";
var PerformAction2 = "https://schema.org/PerformAction";
var PerformanceRole2 = "https://schema.org/PerformanceRole";
var PerformingArtsEvent2 = "https://schema.org/PerformingArtsEvent";
var PerformingArtsTheater2 = "https://schema.org/PerformingArtsTheater";
var PerformingGroup2 = "https://schema.org/PerformingGroup";
var Periodical2 = "https://schema.org/Periodical";
var Permit2 = "https://schema.org/Permit";
var Person6 = "https://schema.org/Person";
var PetStore2 = "https://schema.org/PetStore";
var Pharmacy2 = "https://schema.org/Pharmacy";
var Photograph2 = "https://schema.org/Photograph";
var PhotographAction2 = "https://schema.org/PhotographAction";
var PhysicalActivity2 = "https://schema.org/PhysicalActivity";
var PhysicalActivityCategory2 = "https://schema.org/PhysicalActivityCategory";
var PhysicalExam2 = "https://schema.org/PhysicalExam";
var PhysicalTherapy2 = "https://schema.org/PhysicalTherapy";
var Physician2 = "https://schema.org/Physician";
var PhysiciansOffice2 = "https://schema.org/PhysiciansOffice";
var Place3 = "https://schema.org/Place";
var PlaceOfWorship2 = "https://schema.org/PlaceOfWorship";
var PlanAction2 = "https://schema.org/PlanAction";
var Play2 = "https://schema.org/Play";
var PlayAction2 = "https://schema.org/PlayAction";
var PlayGameAction2 = "https://schema.org/PlayGameAction";
var Playground2 = "https://schema.org/Playground";
var Plumber2 = "https://schema.org/Plumber";
var PodcastEpisode2 = "https://schema.org/PodcastEpisode";
var PodcastSeason2 = "https://schema.org/PodcastSeason";
var PodcastSeries2 = "https://schema.org/PodcastSeries";
var PoliceStation2 = "https://schema.org/PoliceStation";
var PoliticalParty2 = "https://schema.org/PoliticalParty";
var Pond2 = "https://schema.org/Pond";
var PostOffice2 = "https://schema.org/PostOffice";
var PostalAddress2 = "https://schema.org/PostalAddress";
var PostalCodeRangeSpecification2 = "https://schema.org/PostalCodeRangeSpecification";
var Poster2 = "https://schema.org/Poster";
var PreOrderAction2 = "https://schema.org/PreOrderAction";
var PrependAction2 = "https://schema.org/PrependAction";
var Preschool2 = "https://schema.org/Preschool";
var PresentationDigitalDocument2 = "https://schema.org/PresentationDigitalDocument";
var PreventionIndication2 = "https://schema.org/PreventionIndication";
var PriceComponentTypeEnumeration2 = "https://schema.org/PriceComponentTypeEnumeration";
var PriceSpecification2 = "https://schema.org/PriceSpecification";
var PriceTypeEnumeration2 = "https://schema.org/PriceTypeEnumeration";
var Product2 = "https://schema.org/Product";
var ProductCollection2 = "https://schema.org/ProductCollection";
var ProductGroup2 = "https://schema.org/ProductGroup";
var ProductModel2 = "https://schema.org/ProductModel";
var ProductReturnEnumeration2 = "https://schema.org/ProductReturnEnumeration";
var ProductReturnPolicy2 = "https://schema.org/ProductReturnPolicy";
var ProfessionalService2 = "https://schema.org/ProfessionalService";
var ProfilePage2 = "https://schema.org/ProfilePage";
var ProgramMembership2 = "https://schema.org/ProgramMembership";
var Project3 = "https://schema.org/Project";
var PronounceableText2 = "https://schema.org/PronounceableText";
var Property4 = "https://schema.org/Property";
var PropertyValue2 = "https://schema.org/PropertyValue";
var PropertyValueSpecification2 = "https://schema.org/PropertyValueSpecification";
var Protein2 = "https://schema.org/Protein";
var PsychologicalTreatment2 = "https://schema.org/PsychologicalTreatment";
var PublicSwimmingPool2 = "https://schema.org/PublicSwimmingPool";
var PublicToilet2 = "https://schema.org/PublicToilet";
var PublicationEvent2 = "https://schema.org/PublicationEvent";
var PublicationIssue2 = "https://schema.org/PublicationIssue";
var PublicationVolume2 = "https://schema.org/PublicationVolume";
var PurchaseType2 = "https://schema.org/PurchaseType";
var QAPage2 = "https://schema.org/QAPage";
var QualitativeValue2 = "https://schema.org/QualitativeValue";
var QuantitativeValue2 = "https://schema.org/QuantitativeValue";
var QuantitativeValueDistribution2 = "https://schema.org/QuantitativeValueDistribution";
var Quantity3 = "https://schema.org/Quantity";
var Question3 = "https://schema.org/Question";
var Quiz2 = "https://schema.org/Quiz";
var Quotation3 = "https://schema.org/Quotation";
var QuoteAction2 = "https://schema.org/QuoteAction";
var RVPark2 = "https://schema.org/RVPark";
var RadiationTherapy2 = "https://schema.org/RadiationTherapy";
var RadioBroadcastService2 = "https://schema.org/RadioBroadcastService";
var RadioChannel2 = "https://schema.org/RadioChannel";
var RadioClip2 = "https://schema.org/RadioClip";
var RadioEpisode2 = "https://schema.org/RadioEpisode";
var RadioSeason2 = "https://schema.org/RadioSeason";
var RadioSeries2 = "https://schema.org/RadioSeries";
var RadioStation2 = "https://schema.org/RadioStation";
var Rating2 = "https://schema.org/Rating";
var ReactAction2 = "https://schema.org/ReactAction";
var ReadAction2 = "https://schema.org/ReadAction";
var RealEstateAgent2 = "https://schema.org/RealEstateAgent";
var RealEstateListing2 = "https://schema.org/RealEstateListing";
var ReceiveAction2 = "https://schema.org/ReceiveAction";
var Recipe2 = "https://schema.org/Recipe";
var Recommendation2 = "https://schema.org/Recommendation";
var RecommendedDoseSchedule2 = "https://schema.org/RecommendedDoseSchedule";
var RecyclingCenter2 = "https://schema.org/RecyclingCenter";
var RefundTypeEnumeration2 = "https://schema.org/RefundTypeEnumeration";
var RegisterAction2 = "https://schema.org/RegisterAction";
var RejectAction2 = "https://schema.org/RejectAction";
var RentAction2 = "https://schema.org/RentAction";
var RentalCarReservation2 = "https://schema.org/RentalCarReservation";
var RepaymentSpecification2 = "https://schema.org/RepaymentSpecification";
var ReplaceAction2 = "https://schema.org/ReplaceAction";
var ReplyAction2 = "https://schema.org/ReplyAction";
var Report2 = "https://schema.org/Report";
var ReportageNewsArticle2 = "https://schema.org/ReportageNewsArticle";
var ReportedDoseSchedule2 = "https://schema.org/ReportedDoseSchedule";
var ResearchOrganization2 = "https://schema.org/ResearchOrganization";
var ResearchProject2 = "https://schema.org/ResearchProject";
var Researcher2 = "https://schema.org/Researcher";
var Reservation2 = "https://schema.org/Reservation";
var ReservationPackage2 = "https://schema.org/ReservationPackage";
var ReservationStatusType2 = "https://schema.org/ReservationStatusType";
var ReserveAction2 = "https://schema.org/ReserveAction";
var Reservoir2 = "https://schema.org/Reservoir";
var ResetPasswordAction2 = "https://schema.org/ResetPasswordAction";
var Residence2 = "https://schema.org/Residence";
var Resort2 = "https://schema.org/Resort";
var Restaurant2 = "https://schema.org/Restaurant";
var RestrictedDiet2 = "https://schema.org/RestrictedDiet";
var ResumeAction2 = "https://schema.org/ResumeAction";
var ReturnAction2 = "https://schema.org/ReturnAction";
var ReturnFeesEnumeration2 = "https://schema.org/ReturnFeesEnumeration";
var ReturnLabelSourceEnumeration2 = "https://schema.org/ReturnLabelSourceEnumeration";
var ReturnMethodEnumeration2 = "https://schema.org/ReturnMethodEnumeration";
var Review2 = "https://schema.org/Review";
var ReviewAction2 = "https://schema.org/ReviewAction";
var ReviewNewsArticle2 = "https://schema.org/ReviewNewsArticle";
var RiverBodyOfWater2 = "https://schema.org/RiverBodyOfWater";
var Role3 = "https://schema.org/Role";
var RoofingContractor2 = "https://schema.org/RoofingContractor";
var Room2 = "https://schema.org/Room";
var RsvpAction2 = "https://schema.org/RsvpAction";
var RsvpResponseType2 = "https://schema.org/RsvpResponseType";
var RuntimePlatform2 = "https://schema.org/RuntimePlatform";
var SaleEvent2 = "https://schema.org/SaleEvent";
var SatiricalArticle2 = "https://schema.org/SatiricalArticle";
var Schedule3 = "https://schema.org/Schedule";
var ScheduleAction2 = "https://schema.org/ScheduleAction";
var ScholarlyArticle2 = "https://schema.org/ScholarlyArticle";
var School2 = "https://schema.org/School";
var SchoolDistrict2 = "https://schema.org/SchoolDistrict";
var ScreeningEvent2 = "https://schema.org/ScreeningEvent";
var Sculpture2 = "https://schema.org/Sculpture";
var SeaBodyOfWater2 = "https://schema.org/SeaBodyOfWater";
var SearchAction2 = "https://schema.org/SearchAction";
var SearchRescueOrganization2 = "https://schema.org/SearchRescueOrganization";
var SearchResultsPage2 = "https://schema.org/SearchResultsPage";
var Season2 = "https://schema.org/Season";
var Seat2 = "https://schema.org/Seat";
var SeekToAction2 = "https://schema.org/SeekToAction";
var SelfStorage2 = "https://schema.org/SelfStorage";
var SellAction2 = "https://schema.org/SellAction";
var SendAction2 = "https://schema.org/SendAction";
var SequentialArt2 = "https://schema.org/SequentialArt";
var Series2 = "https://schema.org/Series";
var Service3 = "https://schema.org/Service";
var ServiceChannel2 = "https://schema.org/ServiceChannel";
var ServicePeriod2 = "https://schema.org/ServicePeriod";
var ShareAction2 = "https://schema.org/ShareAction";
var SheetMusic2 = "https://schema.org/SheetMusic";
var ShippingConditions2 = "https://schema.org/ShippingConditions";
var ShippingDeliveryTime2 = "https://schema.org/ShippingDeliveryTime";
var ShippingRateSettings2 = "https://schema.org/ShippingRateSettings";
var ShippingService2 = "https://schema.org/ShippingService";
var ShoeStore2 = "https://schema.org/ShoeStore";
var ShoppingCenter2 = "https://schema.org/ShoppingCenter";
var ShortStory2 = "https://schema.org/ShortStory";
var SingleFamilyResidence2 = "https://schema.org/SingleFamilyResidence";
var SiteNavigationElement2 = "https://schema.org/SiteNavigationElement";
var SizeGroupEnumeration2 = "https://schema.org/SizeGroupEnumeration";
var SizeSpecification2 = "https://schema.org/SizeSpecification";
var SizeSystemEnumeration2 = "https://schema.org/SizeSystemEnumeration";
var SkiResort2 = "https://schema.org/SkiResort";
var SocialEvent2 = "https://schema.org/SocialEvent";
var SocialMediaPosting2 = "https://schema.org/SocialMediaPosting";
var SoftwareApplication2 = "https://schema.org/SoftwareApplication";
var SoftwareSourceCode2 = "https://schema.org/SoftwareSourceCode";
var SolveMathAction2 = "https://schema.org/SolveMathAction";
var SomeProducts2 = "https://schema.org/SomeProducts";
var SpeakableSpecification2 = "https://schema.org/SpeakableSpecification";
var SpecialAnnouncement2 = "https://schema.org/SpecialAnnouncement";
var Specialty2 = "https://schema.org/Specialty";
var SportingGoodsStore2 = "https://schema.org/SportingGoodsStore";
var SportsActivityLocation2 = "https://schema.org/SportsActivityLocation";
var SportsClub2 = "https://schema.org/SportsClub";
var SportsEvent2 = "https://schema.org/SportsEvent";
var SportsOrganization2 = "https://schema.org/SportsOrganization";
var SportsTeam2 = "https://schema.org/SportsTeam";
var SpreadsheetDigitalDocument2 = "https://schema.org/SpreadsheetDigitalDocument";
var StadiumOrArena2 = "https://schema.org/StadiumOrArena";
var State2 = "https://schema.org/State";
var Statement5 = "https://schema.org/Statement";
var StatisticalPopulation2 = "https://schema.org/StatisticalPopulation";
var StatisticalVariable2 = "https://schema.org/StatisticalVariable";
var StatusEnumeration2 = "https://schema.org/StatusEnumeration";
var SteeringPositionValue2 = "https://schema.org/SteeringPositionValue";
var Store3 = "https://schema.org/Store";
var StructuredValue2 = "https://schema.org/StructuredValue";
var StupidType2 = "https://schema.org/StupidType";
var SubscribeAction2 = "https://schema.org/SubscribeAction";
var Substance3 = "https://schema.org/Substance";
var SubwayStation2 = "https://schema.org/SubwayStation";
var Suite2 = "https://schema.org/Suite";
var SuperficialAnatomy2 = "https://schema.org/SuperficialAnatomy";
var SurgicalProcedure2 = "https://schema.org/SurgicalProcedure";
var SuspendAction2 = "https://schema.org/SuspendAction";
var Syllabus2 = "https://schema.org/Syllabus";
var Synagogue2 = "https://schema.org/Synagogue";
var TVClip2 = "https://schema.org/TVClip";
var TVEpisode2 = "https://schema.org/TVEpisode";
var TVSeason2 = "https://schema.org/TVSeason";
var TVSeries2 = "https://schema.org/TVSeries";
var Table2 = "https://schema.org/Table";
var TakeAction2 = "https://schema.org/TakeAction";
var TattooParlor2 = "https://schema.org/TattooParlor";
var Taxi2 = "https://schema.org/Taxi";
var TaxiReservation2 = "https://schema.org/TaxiReservation";
var TaxiService2 = "https://schema.org/TaxiService";
var TaxiStand2 = "https://schema.org/TaxiStand";
var Taxon2 = "https://schema.org/Taxon";
var TechArticle2 = "https://schema.org/TechArticle";
var TelevisionChannel2 = "https://schema.org/TelevisionChannel";
var TelevisionStation2 = "https://schema.org/TelevisionStation";
var TennisComplex2 = "https://schema.org/TennisComplex";
var Text2 = "https://schema.org/Text";
var TextDigitalDocument2 = "https://schema.org/TextDigitalDocument";
var TextObject2 = "https://schema.org/TextObject";
var TheaterEvent2 = "https://schema.org/TheaterEvent";
var TheaterGroup2 = "https://schema.org/TheaterGroup";
var TherapeuticProcedure2 = "https://schema.org/TherapeuticProcedure";
var Thesis2 = "https://schema.org/Thesis";
var Thing4 = "https://schema.org/Thing";
var Ticket2 = "https://schema.org/Ticket";
var TieAction2 = "https://schema.org/TieAction";
var TierBenefitEnumeration2 = "https://schema.org/TierBenefitEnumeration";
var Time2 = "https://schema.org/Time";
var TipAction2 = "https://schema.org/TipAction";
var TireShop2 = "https://schema.org/TireShop";
var TouristAttraction2 = "https://schema.org/TouristAttraction";
var TouristDestination2 = "https://schema.org/TouristDestination";
var TouristInformationCenter2 = "https://schema.org/TouristInformationCenter";
var TouristTrip2 = "https://schema.org/TouristTrip";
var ToyStore2 = "https://schema.org/ToyStore";
var TrackAction2 = "https://schema.org/TrackAction";
var TradeAction2 = "https://schema.org/TradeAction";
var TrainReservation2 = "https://schema.org/TrainReservation";
var TrainStation2 = "https://schema.org/TrainStation";
var TrainTrip2 = "https://schema.org/TrainTrip";
var TransferAction2 = "https://schema.org/TransferAction";
var TravelAction2 = "https://schema.org/TravelAction";
var TravelAgency2 = "https://schema.org/TravelAgency";
var TreatmentIndication2 = "https://schema.org/TreatmentIndication";
var Trip2 = "https://schema.org/Trip";
var TypeAndQuantityNode2 = "https://schema.org/TypeAndQuantityNode";
var UKNonprofitType2 = "https://schema.org/UKNonprofitType";
var URL3 = "https://schema.org/URL";
var USNonprofitType2 = "https://schema.org/USNonprofitType";
var UnRegisterAction2 = "https://schema.org/UnRegisterAction";
var UnitPriceSpecification2 = "https://schema.org/UnitPriceSpecification";
var UpdateAction2 = "https://schema.org/UpdateAction";
var UseAction2 = "https://schema.org/UseAction";
var UserBlocks2 = "https://schema.org/UserBlocks";
var UserCheckins2 = "https://schema.org/UserCheckins";
var UserComments2 = "https://schema.org/UserComments";
var UserDownloads2 = "https://schema.org/UserDownloads";
var UserInteraction2 = "https://schema.org/UserInteraction";
var UserLikes2 = "https://schema.org/UserLikes";
var UserPageVisits2 = "https://schema.org/UserPageVisits";
var UserPlays2 = "https://schema.org/UserPlays";
var UserPlusOnes2 = "https://schema.org/UserPlusOnes";
var UserReview2 = "https://schema.org/UserReview";
var UserTweets2 = "https://schema.org/UserTweets";
var VacationRental2 = "https://schema.org/VacationRental";
var Vehicle2 = "https://schema.org/Vehicle";
var Vein2 = "https://schema.org/Vein";
var Vessel2 = "https://schema.org/Vessel";
var VeterinaryCare2 = "https://schema.org/VeterinaryCare";
var VideoGallery2 = "https://schema.org/VideoGallery";
var VideoGame2 = "https://schema.org/VideoGame";
var VideoGameClip2 = "https://schema.org/VideoGameClip";
var VideoGameSeries2 = "https://schema.org/VideoGameSeries";
var VideoObject2 = "https://schema.org/VideoObject";
var VideoObjectSnapshot2 = "https://schema.org/VideoObjectSnapshot";
var ViewAction2 = "https://schema.org/ViewAction";
var VirtualLocation2 = "https://schema.org/VirtualLocation";
var VisualArtsEvent2 = "https://schema.org/VisualArtsEvent";
var VisualArtwork2 = "https://schema.org/VisualArtwork";
var VitalSign2 = "https://schema.org/VitalSign";
var Volcano2 = "https://schema.org/Volcano";
var VoteAction2 = "https://schema.org/VoteAction";
var WPAdBlock2 = "https://schema.org/WPAdBlock";
var WPFooter2 = "https://schema.org/WPFooter";
var WPHeader2 = "https://schema.org/WPHeader";
var WPSideBar2 = "https://schema.org/WPSideBar";
var WantAction2 = "https://schema.org/WantAction";
var WarrantyPromise2 = "https://schema.org/WarrantyPromise";
var WarrantyScope2 = "https://schema.org/WarrantyScope";
var WatchAction2 = "https://schema.org/WatchAction";
var Waterfall2 = "https://schema.org/Waterfall";
var WearAction2 = "https://schema.org/WearAction";
var WearableMeasurementTypeEnumeration2 = "https://schema.org/WearableMeasurementTypeEnumeration";
var WearableSizeGroupEnumeration2 = "https://schema.org/WearableSizeGroupEnumeration";
var WearableSizeSystemEnumeration2 = "https://schema.org/WearableSizeSystemEnumeration";
var WebAPI2 = "https://schema.org/WebAPI";
var WebApplication2 = "https://schema.org/WebApplication";
var WebContent2 = "https://schema.org/WebContent";
var WebPage2 = "https://schema.org/WebPage";
var WebPageElement2 = "https://schema.org/WebPageElement";
var WebSite2 = "https://schema.org/WebSite";
var WholesaleStore2 = "https://schema.org/WholesaleStore";
var WinAction2 = "https://schema.org/WinAction";
var Winery2 = "https://schema.org/Winery";
var WorkBasedProgram2 = "https://schema.org/WorkBasedProgram";
var WorkersUnion2 = "https://schema.org/WorkersUnion";
var WriteAction2 = "https://schema.org/WriteAction";
var XPathType2 = "https://schema.org/XPathType";
var Zoo2 = "https://schema.org/Zoo";
var abridged2 = "https://schema.org/abridged";
var abstract4 = "https://schema.org/abstract";
var accelerationTime2 = "https://schema.org/accelerationTime";
var acceptedAnswer2 = "https://schema.org/acceptedAnswer";
var acceptedOffer2 = "https://schema.org/acceptedOffer";
var acceptedPaymentMethod2 = "https://schema.org/acceptedPaymentMethod";
var acceptsReservations2 = "https://schema.org/acceptsReservations";
var accessCode2 = "https://schema.org/accessCode";
var accessMode2 = "https://schema.org/accessMode";
var accessModeSufficient2 = "https://schema.org/accessModeSufficient";
var accessibilityAPI2 = "https://schema.org/accessibilityAPI";
var accessibilityControl2 = "https://schema.org/accessibilityControl";
var accessibilityFeature2 = "https://schema.org/accessibilityFeature";
var accessibilityHazard2 = "https://schema.org/accessibilityHazard";
var accessibilitySummary2 = "https://schema.org/accessibilitySummary";
var accommodationCategory2 = "https://schema.org/accommodationCategory";
var accommodationFloorPlan2 = "https://schema.org/accommodationFloorPlan";
var accountId2 = "https://schema.org/accountId";
var accountMinimumInflow2 = "https://schema.org/accountMinimumInflow";
var accountOverdraftLimit2 = "https://schema.org/accountOverdraftLimit";
var accountablePerson2 = "https://schema.org/accountablePerson";
var acquireLicensePage2 = "https://schema.org/acquireLicensePage";
var acquiredFrom2 = "https://schema.org/acquiredFrom";
var acrissCode2 = "https://schema.org/acrissCode";
var actionAccessibilityRequirement2 = "https://schema.org/actionAccessibilityRequirement";
var actionPlatform2 = "https://schema.org/actionPlatform";
var actionProcess2 = "https://schema.org/actionProcess";
var actionStatus2 = "https://schema.org/actionStatus";
var actionableFeedbackPolicy2 = "https://schema.org/actionableFeedbackPolicy";
var activeIngredient2 = "https://schema.org/activeIngredient";
var activityDuration2 = "https://schema.org/activityDuration";
var activityFrequency2 = "https://schema.org/activityFrequency";
var actors2 = "https://schema.org/actors";
var addOn2 = "https://schema.org/addOn";
var additionalName2 = "https://schema.org/additionalName";
var additionalNumberOfGuests2 = "https://schema.org/additionalNumberOfGuests";
var additionalProperty2 = "https://schema.org/additionalProperty";
var additionalType2 = "https://schema.org/additionalType";
var additionalVariable2 = "https://schema.org/additionalVariable";
var address4 = "https://schema.org/address";
var addressCountry2 = "https://schema.org/addressCountry";
var addressLocality2 = "https://schema.org/addressLocality";
var addressRegion2 = "https://schema.org/addressRegion";
var administrationRoute2 = "https://schema.org/administrationRoute";
var advanceBookingRequirement2 = "https://schema.org/advanceBookingRequirement";
var adverseOutcome2 = "https://schema.org/adverseOutcome";
var affectedBy2 = "https://schema.org/affectedBy";
var affiliation3 = "https://schema.org/affiliation";
var afterMedia2 = "https://schema.org/afterMedia";
var agent5 = "https://schema.org/agent";
var agentInteractionStatistic2 = "https://schema.org/agentInteractionStatistic";
var aggregateElement2 = "https://schema.org/aggregateElement";
var aggregateRating2 = "https://schema.org/aggregateRating";
var aircraft2 = "https://schema.org/aircraft";
var albumProductionType2 = "https://schema.org/albumProductionType";
var albumReleaseType2 = "https://schema.org/albumReleaseType";
var albums2 = "https://schema.org/albums";
var alcoholWarning2 = "https://schema.org/alcoholWarning";
var algorithm2 = "https://schema.org/algorithm";
var alignmentType2 = "https://schema.org/alignmentType";
var alternativeHeadline2 = "https://schema.org/alternativeHeadline";
var alternativeOf2 = "https://schema.org/alternativeOf";
var amenityFeature2 = "https://schema.org/amenityFeature";
var amount4 = "https://schema.org/amount";
var amountOfThisGood2 = "https://schema.org/amountOfThisGood";
var announcementLocation2 = "https://schema.org/announcementLocation";
var annualPercentageRate2 = "https://schema.org/annualPercentageRate";
var answerCount2 = "https://schema.org/answerCount";
var answerExplanation2 = "https://schema.org/answerExplanation";
var antagonist2 = "https://schema.org/antagonist";
var appearance2 = "https://schema.org/appearance";
var applicableCountry2 = "https://schema.org/applicableCountry";
var applicableLocation2 = "https://schema.org/applicableLocation";
var applicantLocationRequirements2 = "https://schema.org/applicantLocationRequirements";
var application3 = "https://schema.org/application";
var applicationCategory2 = "https://schema.org/applicationCategory";
var applicationContact2 = "https://schema.org/applicationContact";
var applicationDeadline2 = "https://schema.org/applicationDeadline";
var applicationStartDate2 = "https://schema.org/applicationStartDate";
var applicationSubCategory2 = "https://schema.org/applicationSubCategory";
var applicationSuite2 = "https://schema.org/applicationSuite";
var appliesToDeliveryMethod2 = "https://schema.org/appliesToDeliveryMethod";
var appliesToPaymentMethod2 = "https://schema.org/appliesToPaymentMethod";
var archivedAt2 = "https://schema.org/archivedAt";
var area2 = "https://schema.org/area";
var arrivalAirport2 = "https://schema.org/arrivalAirport";
var arrivalBoatTerminal2 = "https://schema.org/arrivalBoatTerminal";
var arrivalBusStop2 = "https://schema.org/arrivalBusStop";
var arrivalGate2 = "https://schema.org/arrivalGate";
var arrivalPlatform2 = "https://schema.org/arrivalPlatform";
var arrivalStation2 = "https://schema.org/arrivalStation";
var arrivalTerminal2 = "https://schema.org/arrivalTerminal";
var arrivalTime2 = "https://schema.org/arrivalTime";
var artEdition2 = "https://schema.org/artEdition";
var artMedium2 = "https://schema.org/artMedium";
var artform2 = "https://schema.org/artform";
var articleBody2 = "https://schema.org/articleBody";
var articleSection2 = "https://schema.org/articleSection";
var artist2 = "https://schema.org/artist";
var asin2 = "https://schema.org/asin";
var aspect2 = "https://schema.org/aspect";
var assembly2 = "https://schema.org/assembly";
var assemblyVersion2 = "https://schema.org/assemblyVersion";
var assesses2 = "https://schema.org/assesses";
var associatedAnatomy2 = "https://schema.org/associatedAnatomy";
var associatedArticle2 = "https://schema.org/associatedArticle";
var associatedClaimReview2 = "https://schema.org/associatedClaimReview";
var associatedDisease2 = "https://schema.org/associatedDisease";
var associatedMedia2 = "https://schema.org/associatedMedia";
var associatedMediaReview2 = "https://schema.org/associatedMediaReview";
var associatedPathophysiology2 = "https://schema.org/associatedPathophysiology";
var athlete2 = "https://schema.org/athlete";
var attendees2 = "https://schema.org/attendees";
var audienceType2 = "https://schema.org/audienceType";
var audio2 = "https://schema.org/audio";
var auditDate2 = "https://schema.org/auditDate";
var authenticator2 = "https://schema.org/authenticator";
var author4 = "https://schema.org/author";
var availability3 = "https://schema.org/availability";
var availabilityEnds2 = "https://schema.org/availabilityEnds";
var availabilityStarts2 = "https://schema.org/availabilityStarts";
var availableAtOrFrom2 = "https://schema.org/availableAtOrFrom";
var availableChannel2 = "https://schema.org/availableChannel";
var availableDeliveryMethod2 = "https://schema.org/availableDeliveryMethod";
var availableFrom2 = "https://schema.org/availableFrom";
var availableIn2 = "https://schema.org/availableIn";
var availableLanguage2 = "https://schema.org/availableLanguage";
var availableService2 = "https://schema.org/availableService";
var availableStrength2 = "https://schema.org/availableStrength";
var availableTest2 = "https://schema.org/availableTest";
var availableThrough2 = "https://schema.org/availableThrough";
var awards2 = "https://schema.org/awards";
var awayTeam2 = "https://schema.org/awayTeam";
var backstory2 = "https://schema.org/backstory";
var bankAccountType2 = "https://schema.org/bankAccountType";
var baseSalary2 = "https://schema.org/baseSalary";
var bccRecipient2 = "https://schema.org/bccRecipient";
var bed2 = "https://schema.org/bed";
var beforeMedia2 = "https://schema.org/beforeMedia";
var beneficiaryBank2 = "https://schema.org/beneficiaryBank";
var benefits2 = "https://schema.org/benefits";
var benefitsSummaryUrl2 = "https://schema.org/benefitsSummaryUrl";
var bestRating2 = "https://schema.org/bestRating";
var billingAddress2 = "https://schema.org/billingAddress";
var billingDuration2 = "https://schema.org/billingDuration";
var billingIncrement2 = "https://schema.org/billingIncrement";
var billingPeriod2 = "https://schema.org/billingPeriod";
var billingStart2 = "https://schema.org/billingStart";
var bioChemInteraction2 = "https://schema.org/bioChemInteraction";
var bioChemSimilarity2 = "https://schema.org/bioChemSimilarity";
var biologicalRole2 = "https://schema.org/biologicalRole";
var biomechnicalClass2 = "https://schema.org/biomechnicalClass";
var birthDate3 = "https://schema.org/birthDate";
var birthPlace2 = "https://schema.org/birthPlace";
var bitrate2 = "https://schema.org/bitrate";
var blogPosts2 = "https://schema.org/blogPosts";
var bloodSupply2 = "https://schema.org/bloodSupply";
var boardingGroup2 = "https://schema.org/boardingGroup";
var boardingPolicy2 = "https://schema.org/boardingPolicy";
var bodyLocation2 = "https://schema.org/bodyLocation";
var bodyType2 = "https://schema.org/bodyType";
var bookEdition2 = "https://schema.org/bookEdition";
var bookFormat2 = "https://schema.org/bookFormat";
var bookingAgent2 = "https://schema.org/bookingAgent";
var bookingTime2 = "https://schema.org/bookingTime";
var borrower2 = "https://schema.org/borrower";
var box2 = "https://schema.org/box";
var branch2 = "https://schema.org/branch";
var branchCode2 = "https://schema.org/branchCode";
var branchOf2 = "https://schema.org/branchOf";
var brand3 = "https://schema.org/brand";
var breadcrumb2 = "https://schema.org/breadcrumb";
var breastfeedingWarning2 = "https://schema.org/breastfeedingWarning";
var broadcastAffiliateOf2 = "https://schema.org/broadcastAffiliateOf";
var broadcastChannelId2 = "https://schema.org/broadcastChannelId";
var broadcastDisplayName2 = "https://schema.org/broadcastDisplayName";
var broadcastFrequency2 = "https://schema.org/broadcastFrequency";
var broadcastFrequencyValue2 = "https://schema.org/broadcastFrequencyValue";
var broadcastOfEvent2 = "https://schema.org/broadcastOfEvent";
var broadcastServiceTier2 = "https://schema.org/broadcastServiceTier";
var broadcastSignalModulation2 = "https://schema.org/broadcastSignalModulation";
var broadcastSubChannel2 = "https://schema.org/broadcastSubChannel";
var broadcastTimezone2 = "https://schema.org/broadcastTimezone";
var broadcaster2 = "https://schema.org/broadcaster";
var browserRequirements2 = "https://schema.org/browserRequirements";
var busName2 = "https://schema.org/busName";
var busNumber2 = "https://schema.org/busNumber";
var businessDays2 = "https://schema.org/businessDays";
var businessFunction2 = "https://schema.org/businessFunction";
var buyer2 = "https://schema.org/buyer";
var byArtist2 = "https://schema.org/byArtist";
var byDay2 = "https://schema.org/byDay";
var byMonth2 = "https://schema.org/byMonth";
var byMonthDay2 = "https://schema.org/byMonthDay";
var byMonthWeek2 = "https://schema.org/byMonthWeek";
var callSign2 = "https://schema.org/callSign";
var calories2 = "https://schema.org/calories";
var candidate3 = "https://schema.org/candidate";
var carbohydrateContent2 = "https://schema.org/carbohydrateContent";
var cargoVolume2 = "https://schema.org/cargoVolume";
var carrier2 = "https://schema.org/carrier";
var carrierRequirements2 = "https://schema.org/carrierRequirements";
var cashBack2 = "https://schema.org/cashBack";
var catalog2 = "https://schema.org/catalog";
var catalogNumber2 = "https://schema.org/catalogNumber";
var ccRecipient2 = "https://schema.org/ccRecipient";
var certificationIdentification2 = "https://schema.org/certificationIdentification";
var certificationRating2 = "https://schema.org/certificationRating";
var certificationStatus2 = "https://schema.org/certificationStatus";
var character2 = "https://schema.org/character";
var characterAttribute2 = "https://schema.org/characterAttribute";
var characterName2 = "https://schema.org/characterName";
var cheatCode2 = "https://schema.org/cheatCode";
var checkinTime2 = "https://schema.org/checkinTime";
var checkoutPageURLTemplate2 = "https://schema.org/checkoutPageURLTemplate";
var checkoutTime2 = "https://schema.org/checkoutTime";
var chemicalComposition2 = "https://schema.org/chemicalComposition";
var chemicalRole2 = "https://schema.org/chemicalRole";
var childMaxAge2 = "https://schema.org/childMaxAge";
var childMinAge2 = "https://schema.org/childMinAge";
var children2 = "https://schema.org/children";
var cholesterolContent2 = "https://schema.org/cholesterolContent";
var circle2 = "https://schema.org/circle";
var citation3 = "https://schema.org/citation";
var claimInterpreter2 = "https://schema.org/claimInterpreter";
var claimReviewed2 = "https://schema.org/claimReviewed";
var clincalPharmacology2 = "https://schema.org/clincalPharmacology";
var clipNumber2 = "https://schema.org/clipNumber";
var closes2 = "https://schema.org/closes";
var coach2 = "https://schema.org/coach";
var code3 = "https://schema.org/code";
var codeRepository2 = "https://schema.org/codeRepository";
var codeValue2 = "https://schema.org/codeValue";
var codingSystem2 = "https://schema.org/codingSystem";
var colleagues2 = "https://schema.org/colleagues";
var collection4 = "https://schema.org/collection";
var collectionSize2 = "https://schema.org/collectionSize";
var color3 = "https://schema.org/color";
var colorSwatch2 = "https://schema.org/colorSwatch";
var colorist2 = "https://schema.org/colorist";
var comment5 = "https://schema.org/comment";
var commentCount2 = "https://schema.org/commentCount";
var commentText2 = "https://schema.org/commentText";
var commentTime2 = "https://schema.org/commentTime";
var companyRegistration2 = "https://schema.org/companyRegistration";
var competencyRequired2 = "https://schema.org/competencyRequired";
var composer2 = "https://schema.org/composer";
var comprisedOf3 = "https://schema.org/comprisedOf";
var conditionsOfAccess2 = "https://schema.org/conditionsOfAccess";
var confirmationNumber2 = "https://schema.org/confirmationNumber";
var connectedTo2 = "https://schema.org/connectedTo";
var constraintProperty2 = "https://schema.org/constraintProperty";
var contactOption2 = "https://schema.org/contactOption";
var contactPoints2 = "https://schema.org/contactPoints";
var contactType2 = "https://schema.org/contactType";
var contactlessPayment2 = "https://schema.org/contactlessPayment";
var containedIn2 = "https://schema.org/containedIn";
var contentRating2 = "https://schema.org/contentRating";
var contentReferenceTime2 = "https://schema.org/contentReferenceTime";
var contentSize2 = "https://schema.org/contentSize";
var contentType3 = "https://schema.org/contentType";
var contentUrl2 = "https://schema.org/contentUrl";
var contraindication3 = "https://schema.org/contraindication";
var contributor5 = "https://schema.org/contributor";
var cookTime2 = "https://schema.org/cookTime";
var cookingMethod2 = "https://schema.org/cookingMethod";
var copyrightHolder2 = "https://schema.org/copyrightHolder";
var copyrightNotice2 = "https://schema.org/copyrightNotice";
var copyrightYear2 = "https://schema.org/copyrightYear";
var correction2 = "https://schema.org/correction";
var correctionsPolicy2 = "https://schema.org/correctionsPolicy";
var costCategory2 = "https://schema.org/costCategory";
var costCurrency2 = "https://schema.org/costCurrency";
var costOrigin2 = "https://schema.org/costOrigin";
var costPerUnit2 = "https://schema.org/costPerUnit";
var countriesNotSupported2 = "https://schema.org/countriesNotSupported";
var countriesSupported2 = "https://schema.org/countriesSupported";
var countryOfAssembly2 = "https://schema.org/countryOfAssembly";
var countryOfLastProcessing2 = "https://schema.org/countryOfLastProcessing";
var countryOfOrigin3 = "https://schema.org/countryOfOrigin";
var course2 = "https://schema.org/course";
var courseCode2 = "https://schema.org/courseCode";
var courseMode2 = "https://schema.org/courseMode";
var coursePrerequisites2 = "https://schema.org/coursePrerequisites";
var courseSchedule2 = "https://schema.org/courseSchedule";
var courseWorkload2 = "https://schema.org/courseWorkload";
var coverageEndTime2 = "https://schema.org/coverageEndTime";
var coverageStartTime2 = "https://schema.org/coverageStartTime";
var creativeWorkStatus2 = "https://schema.org/creativeWorkStatus";
var credentialCategory2 = "https://schema.org/credentialCategory";
var creditText2 = "https://schema.org/creditText";
var creditedTo2 = "https://schema.org/creditedTo";
var cssSelector2 = "https://schema.org/cssSelector";
var currenciesAccepted2 = "https://schema.org/currenciesAccepted";
var currency3 = "https://schema.org/currency";
var currentExchangeRate2 = "https://schema.org/currentExchangeRate";
var customer2 = "https://schema.org/customer";
var customerRemorseReturnFees2 = "https://schema.org/customerRemorseReturnFees";
var customerRemorseReturnLabelSource2 = "https://schema.org/customerRemorseReturnLabelSource";
var customerRemorseReturnShippingFeesAmount2 = "https://schema.org/customerRemorseReturnShippingFeesAmount";
var cutoffTime2 = "https://schema.org/cutoffTime";
var cvdCollectionDate2 = "https://schema.org/cvdCollectionDate";
var cvdFacilityCounty2 = "https://schema.org/cvdFacilityCounty";
var cvdFacilityId2 = "https://schema.org/cvdFacilityId";
var cvdNumBeds2 = "https://schema.org/cvdNumBeds";
var cvdNumBedsOcc2 = "https://schema.org/cvdNumBedsOcc";
var cvdNumC19Died2 = "https://schema.org/cvdNumC19Died";
var cvdNumC19HOPats2 = "https://schema.org/cvdNumC19HOPats";
var cvdNumC19HospPats2 = "https://schema.org/cvdNumC19HospPats";
var cvdNumC19MechVentPats2 = "https://schema.org/cvdNumC19MechVentPats";
var cvdNumC19OFMechVentPats2 = "https://schema.org/cvdNumC19OFMechVentPats";
var cvdNumC19OverflowPats2 = "https://schema.org/cvdNumC19OverflowPats";
var cvdNumICUBeds2 = "https://schema.org/cvdNumICUBeds";
var cvdNumICUBedsOcc2 = "https://schema.org/cvdNumICUBedsOcc";
var cvdNumTotBeds2 = "https://schema.org/cvdNumTotBeds";
var cvdNumVent2 = "https://schema.org/cvdNumVent";
var cvdNumVentUse2 = "https://schema.org/cvdNumVentUse";
var data3 = "https://schema.org/data";
var dataFeedElement2 = "https://schema.org/dataFeedElement";
var datasetTimeInterval2 = "https://schema.org/datasetTimeInterval";
var dateDeleted2 = "https://schema.org/dateDeleted";
var dateIssued2 = "https://schema.org/dateIssued";
var dateModified2 = "https://schema.org/dateModified";
var datePosted2 = "https://schema.org/datePosted";
var datePublished2 = "https://schema.org/datePublished";
var dateRead2 = "https://schema.org/dateRead";
var dateReceived2 = "https://schema.org/dateReceived";
var dateSent2 = "https://schema.org/dateSent";
var dateVehicleFirstRegistered2 = "https://schema.org/dateVehicleFirstRegistered";
var dateline2 = "https://schema.org/dateline";
var dayOfWeek3 = "https://schema.org/dayOfWeek";
var deathDate2 = "https://schema.org/deathDate";
var deathPlace2 = "https://schema.org/deathPlace";
var defaultValue3 = "https://schema.org/defaultValue";
var deliveryAddress2 = "https://schema.org/deliveryAddress";
var deliveryLeadTime2 = "https://schema.org/deliveryLeadTime";
var deliveryMethod2 = "https://schema.org/deliveryMethod";
var deliveryStatus2 = "https://schema.org/deliveryStatus";
var deliveryTime2 = "https://schema.org/deliveryTime";
var department2 = "https://schema.org/department";
var departureAirport2 = "https://schema.org/departureAirport";
var departureBoatTerminal2 = "https://schema.org/departureBoatTerminal";
var departureBusStop2 = "https://schema.org/departureBusStop";
var departureGate2 = "https://schema.org/departureGate";
var departurePlatform2 = "https://schema.org/departurePlatform";
var departureStation2 = "https://schema.org/departureStation";
var departureTerminal2 = "https://schema.org/departureTerminal";
var departureTime2 = "https://schema.org/departureTime";
var dependencies2 = "https://schema.org/dependencies";
var depth2 = "https://schema.org/depth";
var device3 = "https://schema.org/device";
var diagnosis3 = "https://schema.org/diagnosis";
var diagram2 = "https://schema.org/diagram";
var diet2 = "https://schema.org/diet";
var dietFeatures2 = "https://schema.org/dietFeatures";
var differentialDiagnosis2 = "https://schema.org/differentialDiagnosis";
var digitalSourceType2 = "https://schema.org/digitalSourceType";
var directApply2 = "https://schema.org/directApply";
var directors2 = "https://schema.org/directors";
var disambiguatingDescription2 = "https://schema.org/disambiguatingDescription";
var discount2 = "https://schema.org/discount";
var discountCode2 = "https://schema.org/discountCode";
var discountCurrency2 = "https://schema.org/discountCurrency";
var discusses2 = "https://schema.org/discusses";
var discussionUrl2 = "https://schema.org/discussionUrl";
var diseasePreventionInfo2 = "https://schema.org/diseasePreventionInfo";
var diseaseSpreadStatistics2 = "https://schema.org/diseaseSpreadStatistics";
var displayLocation2 = "https://schema.org/displayLocation";
var dissolutionDate2 = "https://schema.org/dissolutionDate";
var distance2 = "https://schema.org/distance";
var distinguishingSign2 = "https://schema.org/distinguishingSign";
var distribution2 = "https://schema.org/distribution";
var diversityPolicy2 = "https://schema.org/diversityPolicy";
var diversityStaffingReport2 = "https://schema.org/diversityStaffingReport";
var documentation3 = "https://schema.org/documentation";
var doesNotShip2 = "https://schema.org/doesNotShip";
var domainIncludes2 = "https://schema.org/domainIncludes";
var domiciledMortgage2 = "https://schema.org/domiciledMortgage";
var doorTime2 = "https://schema.org/doorTime";
var dosageForm2 = "https://schema.org/dosageForm";
var doseSchedule2 = "https://schema.org/doseSchedule";
var doseUnit2 = "https://schema.org/doseUnit";
var doseValue2 = "https://schema.org/doseValue";
var downPayment2 = "https://schema.org/downPayment";
var downloadUrl2 = "https://schema.org/downloadUrl";
var downvoteCount2 = "https://schema.org/downvoteCount";
var drainsTo2 = "https://schema.org/drainsTo";
var driveWheelConfiguration2 = "https://schema.org/driveWheelConfiguration";
var dropoffLocation2 = "https://schema.org/dropoffLocation";
var dropoffTime2 = "https://schema.org/dropoffTime";
var drug2 = "https://schema.org/drug";
var drugClass2 = "https://schema.org/drugClass";
var drugUnit2 = "https://schema.org/drugUnit";
var duns2 = "https://schema.org/duns";
var duplicateTherapy2 = "https://schema.org/duplicateTherapy";
var durationOfWarranty2 = "https://schema.org/durationOfWarranty";
var duringMedia2 = "https://schema.org/duringMedia";
var earlyPrepaymentPenalty2 = "https://schema.org/earlyPrepaymentPenalty";
var editEIDR2 = "https://schema.org/editEIDR";
var editor3 = "https://schema.org/editor";
var eduQuestionType2 = "https://schema.org/eduQuestionType";
var educationRequirements2 = "https://schema.org/educationRequirements";
var educationalAlignment2 = "https://schema.org/educationalAlignment";
var educationalCredentialAwarded2 = "https://schema.org/educationalCredentialAwarded";
var educationalFramework2 = "https://schema.org/educationalFramework";
var educationalLevel2 = "https://schema.org/educationalLevel";
var educationalProgramMode2 = "https://schema.org/educationalProgramMode";
var educationalRole2 = "https://schema.org/educationalRole";
var educationalUse2 = "https://schema.org/educationalUse";
var elevation2 = "https://schema.org/elevation";
var eligibilityToWorkRequirement2 = "https://schema.org/eligibilityToWorkRequirement";
var eligibleCustomerType2 = "https://schema.org/eligibleCustomerType";
var eligibleDuration2 = "https://schema.org/eligibleDuration";
var eligibleQuantity2 = "https://schema.org/eligibleQuantity";
var eligibleRegion2 = "https://schema.org/eligibleRegion";
var eligibleTransactionVolume2 = "https://schema.org/eligibleTransactionVolume";
var eligibleWithSupplier2 = "https://schema.org/eligibleWithSupplier";
var email2 = "https://schema.org/email";
var embedUrl2 = "https://schema.org/embedUrl";
var embeddedTextCaption2 = "https://schema.org/embeddedTextCaption";
var emissionsCO22 = "https://schema.org/emissionsCO2";
var employees2 = "https://schema.org/employees";
var employerOverview2 = "https://schema.org/employerOverview";
var employmentType2 = "https://schema.org/employmentType";
var employmentUnit2 = "https://schema.org/employmentUnit";
var encodingType2 = "https://schema.org/encodingType";
var encodings2 = "https://schema.org/encodings";
var endOffset2 = "https://schema.org/endOffset";
var endTime3 = "https://schema.org/endTime";
var endorsee2 = "https://schema.org/endorsee";
var endorsers2 = "https://schema.org/endorsers";
var energyEfficiencyScaleMax2 = "https://schema.org/energyEfficiencyScaleMax";
var energyEfficiencyScaleMin2 = "https://schema.org/energyEfficiencyScaleMin";
var engineDisplacement2 = "https://schema.org/engineDisplacement";
var enginePower2 = "https://schema.org/enginePower";
var engineType2 = "https://schema.org/engineType";
var entertainmentBusiness2 = "https://schema.org/entertainmentBusiness";
var epidemiology2 = "https://schema.org/epidemiology";
var episodeNumber2 = "https://schema.org/episodeNumber";
var episodes2 = "https://schema.org/episodes";
var equal2 = "https://schema.org/equal";
var error3 = "https://schema.org/error";
var errorCode2 = "https://schema.org/errorCode";
var estimatedCost2 = "https://schema.org/estimatedCost";
var estimatedFlightDuration2 = "https://schema.org/estimatedFlightDuration";
var estimatedSalary2 = "https://schema.org/estimatedSalary";
var estimatesRiskOf2 = "https://schema.org/estimatesRiskOf";
var ethicsPolicy2 = "https://schema.org/ethicsPolicy";
var eventAttendanceMode2 = "https://schema.org/eventAttendanceMode";
var eventSchedule2 = "https://schema.org/eventSchedule";
var eventStatus2 = "https://schema.org/eventStatus";
var events2 = "https://schema.org/events";
var evidenceLevel2 = "https://schema.org/evidenceLevel";
var evidenceOrigin2 = "https://schema.org/evidenceOrigin";
var exceptDate2 = "https://schema.org/exceptDate";
var exchangeRateSpread2 = "https://schema.org/exchangeRateSpread";
var exercisePlan2 = "https://schema.org/exercisePlan";
var exerciseRelatedDiet2 = "https://schema.org/exerciseRelatedDiet";
var exerciseType2 = "https://schema.org/exerciseType";
var exifData2 = "https://schema.org/exifData";
var expectedArrivalFrom2 = "https://schema.org/expectedArrivalFrom";
var expectedArrivalUntil2 = "https://schema.org/expectedArrivalUntil";
var expectedPrognosis2 = "https://schema.org/expectedPrognosis";
var expectsAcceptanceOf2 = "https://schema.org/expectsAcceptanceOf";
var experienceInPlaceOfEducation2 = "https://schema.org/experienceInPlaceOfEducation";
var experienceRequirements2 = "https://schema.org/experienceRequirements";
var expertConsiderations2 = "https://schema.org/expertConsiderations";
var expires2 = "https://schema.org/expires";
var expressedIn2 = "https://schema.org/expressedIn";
var extendedAddress2 = "https://schema.org/extendedAddress";
var familyName3 = "https://schema.org/familyName";
var fatContent2 = "https://schema.org/fatContent";
var faxNumber2 = "https://schema.org/faxNumber";
var featureList2 = "https://schema.org/featureList";
var feesAndCommissionsSpecification2 = "https://schema.org/feesAndCommissionsSpecification";
var fiberContent2 = "https://schema.org/fiberContent";
var fileFormat2 = "https://schema.org/fileFormat";
var fileSize2 = "https://schema.org/fileSize";
var financialAidEligible2 = "https://schema.org/financialAidEligible";
var firstAppearance2 = "https://schema.org/firstAppearance";
var firstPerformance2 = "https://schema.org/firstPerformance";
var flightDistance2 = "https://schema.org/flightDistance";
var flightNumber2 = "https://schema.org/flightNumber";
var floorLevel2 = "https://schema.org/floorLevel";
var floorLimit2 = "https://schema.org/floorLimit";
var floorSize2 = "https://schema.org/floorSize";
var followee2 = "https://schema.org/followee";
var follows2 = "https://schema.org/follows";
var followup2 = "https://schema.org/followup";
var foodEstablishment2 = "https://schema.org/foodEstablishment";
var foodEvent2 = "https://schema.org/foodEvent";
var foodWarning2 = "https://schema.org/foodWarning";
var founders2 = "https://schema.org/founders";
var foundingDate2 = "https://schema.org/foundingDate";
var foundingLocation2 = "https://schema.org/foundingLocation";
var free2 = "https://schema.org/free";
var freeShippingThreshold2 = "https://schema.org/freeShippingThreshold";
var fromLocation2 = "https://schema.org/fromLocation";
var fuelCapacity2 = "https://schema.org/fuelCapacity";
var fuelConsumption2 = "https://schema.org/fuelConsumption";
var fuelEfficiency2 = "https://schema.org/fuelEfficiency";
var fuelType2 = "https://schema.org/fuelType";
var fulfillmentType2 = "https://schema.org/fulfillmentType";
var functionalClass2 = "https://schema.org/functionalClass";
var funder2 = "https://schema.org/funder";
var gameAvailabilityType2 = "https://schema.org/gameAvailabilityType";
var gameEdition2 = "https://schema.org/gameEdition";
var gameItem2 = "https://schema.org/gameItem";
var gameLocation2 = "https://schema.org/gameLocation";
var gamePlatform2 = "https://schema.org/gamePlatform";
var gameTip2 = "https://schema.org/gameTip";
var gender4 = "https://schema.org/gender";
var geo3 = "https://schema.org/geo";
var geoContains2 = "https://schema.org/geoContains";
var geoCoveredBy2 = "https://schema.org/geoCoveredBy";
var geoCovers2 = "https://schema.org/geoCovers";
var geoCrosses2 = "https://schema.org/geoCrosses";
var geoDisjoint2 = "https://schema.org/geoDisjoint";
var geoEquals2 = "https://schema.org/geoEquals";
var geoIntersects2 = "https://schema.org/geoIntersects";
var geoMidpoint2 = "https://schema.org/geoMidpoint";
var geoOverlaps2 = "https://schema.org/geoOverlaps";
var geoRadius2 = "https://schema.org/geoRadius";
var geoTouches2 = "https://schema.org/geoTouches";
var geoWithin2 = "https://schema.org/geoWithin";
var geographicArea2 = "https://schema.org/geographicArea";
var gettingTestedInfo2 = "https://schema.org/gettingTestedInfo";
var givenName3 = "https://schema.org/givenName";
var globalLocationNumber2 = "https://schema.org/globalLocationNumber";
var governmentBenefitsInfo2 = "https://schema.org/governmentBenefitsInfo";
var gracePeriod2 = "https://schema.org/gracePeriod";
var grantee3 = "https://schema.org/grantee";
var greater2 = "https://schema.org/greater";
var greaterOrEqual2 = "https://schema.org/greaterOrEqual";
var gtin122 = "https://schema.org/gtin12";
var gtin132 = "https://schema.org/gtin13";
var gtin142 = "https://schema.org/gtin14";
var gtin82 = "https://schema.org/gtin8";
var guideline3 = "https://schema.org/guideline";
var guidelineDate2 = "https://schema.org/guidelineDate";
var guidelineSubject2 = "https://schema.org/guidelineSubject";
var handlingTime2 = "https://schema.org/handlingTime";
var hasAdultConsideration2 = "https://schema.org/hasAdultConsideration";
var hasBioPolymerSequence2 = "https://schema.org/hasBioPolymerSequence";
var hasCategoryCode2 = "https://schema.org/hasCategoryCode";
var hasCertification2 = "https://schema.org/hasCertification";
var hasCourse2 = "https://schema.org/hasCourse";
var hasCourseInstance2 = "https://schema.org/hasCourseInstance";
var hasCredential2 = "https://schema.org/hasCredential";
var hasDeliveryMethod2 = "https://schema.org/hasDeliveryMethod";
var hasDigitalDocumentPermission2 = "https://schema.org/hasDigitalDocumentPermission";
var hasDriveThroughService2 = "https://schema.org/hasDriveThroughService";
var hasEnergyConsumptionDetails2 = "https://schema.org/hasEnergyConsumptionDetails";
var hasEnergyEfficiencyCategory2 = "https://schema.org/hasEnergyEfficiencyCategory";
var hasGS1DigitalLink2 = "https://schema.org/hasGS1DigitalLink";
var hasHealthAspect2 = "https://schema.org/hasHealthAspect";
var hasMeasurement2 = "https://schema.org/hasMeasurement";
var hasMemberProgram2 = "https://schema.org/hasMemberProgram";
var hasMenuItem2 = "https://schema.org/hasMenuItem";
var hasMenuSection2 = "https://schema.org/hasMenuSection";
var hasMolecularFunction2 = "https://schema.org/hasMolecularFunction";
var hasOccupation2 = "https://schema.org/hasOccupation";
var hasOfferCatalog2 = "https://schema.org/hasOfferCatalog";
var hasPOS2 = "https://schema.org/hasPOS";
var hasParticipationOffer2 = "https://schema.org/hasParticipationOffer";
var hasProductReturnPolicy2 = "https://schema.org/hasProductReturnPolicy";
var hasShippingService2 = "https://schema.org/hasShippingService";
var hasSponsorshipOffer2 = "https://schema.org/hasSponsorshipOffer";
var hasStore2 = "https://schema.org/hasStore";
var hasTierBenefit2 = "https://schema.org/hasTierBenefit";
var hasTierRequirement2 = "https://schema.org/hasTierRequirement";
var headline2 = "https://schema.org/headline";
var healthCondition2 = "https://schema.org/healthCondition";
var healthPlanCoinsuranceOption2 = "https://schema.org/healthPlanCoinsuranceOption";
var healthPlanCoinsuranceRate2 = "https://schema.org/healthPlanCoinsuranceRate";
var healthPlanCopay2 = "https://schema.org/healthPlanCopay";
var healthPlanCopayOption2 = "https://schema.org/healthPlanCopayOption";
var healthPlanCostSharing2 = "https://schema.org/healthPlanCostSharing";
var healthPlanDrugOption2 = "https://schema.org/healthPlanDrugOption";
var healthPlanDrugTier2 = "https://schema.org/healthPlanDrugTier";
var healthPlanId2 = "https://schema.org/healthPlanId";
var healthPlanMarketingUrl2 = "https://schema.org/healthPlanMarketingUrl";
var healthPlanNetworkId2 = "https://schema.org/healthPlanNetworkId";
var healthPlanNetworkTier2 = "https://schema.org/healthPlanNetworkTier";
var healthPlanPharmacyCategory2 = "https://schema.org/healthPlanPharmacyCategory";
var healthcareReportingData2 = "https://schema.org/healthcareReportingData";
var height4 = "https://schema.org/height";
var highPrice2 = "https://schema.org/highPrice";
var hiringOrganization2 = "https://schema.org/hiringOrganization";
var homeLocation2 = "https://schema.org/homeLocation";
var homeTeam2 = "https://schema.org/homeTeam";
var honorificPrefix2 = "https://schema.org/honorificPrefix";
var honorificSuffix2 = "https://schema.org/honorificSuffix";
var hospitalAffiliation2 = "https://schema.org/hospitalAffiliation";
var hostingOrganization2 = "https://schema.org/hostingOrganization";
var hoursAvailable2 = "https://schema.org/hoursAvailable";
var howPerformed2 = "https://schema.org/howPerformed";
var httpMethod2 = "https://schema.org/httpMethod";
var iataCode2 = "https://schema.org/iataCode";
var icaoCode2 = "https://schema.org/icaoCode";
var identifyingExam2 = "https://schema.org/identifyingExam";
var identifyingTest2 = "https://schema.org/identifyingTest";
var illustrator2 = "https://schema.org/illustrator";
var imagingTechnique2 = "https://schema.org/imagingTechnique";
var inAlbum2 = "https://schema.org/inAlbum";
var inBroadcastLineup2 = "https://schema.org/inBroadcastLineup";
var inChI2 = "https://schema.org/inChI";
var inChIKey2 = "https://schema.org/inChIKey";
var inCodeSet2 = "https://schema.org/inCodeSet";
var inPlaylist2 = "https://schema.org/inPlaylist";
var inProductGroupWithID2 = "https://schema.org/inProductGroupWithID";
var inStoreReturnsOffered2 = "https://schema.org/inStoreReturnsOffered";
var inSupportOf2 = "https://schema.org/inSupportOf";
var incentiveAmount2 = "https://schema.org/incentiveAmount";
var incentiveStatus2 = "https://schema.org/incentiveStatus";
var incentiveType2 = "https://schema.org/incentiveType";
var incentives2 = "https://schema.org/incentives";
var incentivizedItem2 = "https://schema.org/incentivizedItem";
var includedComposition2 = "https://schema.org/includedComposition";
var includedDataCatalog2 = "https://schema.org/includedDataCatalog";
var includedInHealthInsurancePlan2 = "https://schema.org/includedInHealthInsurancePlan";
var includedRiskFactor2 = "https://schema.org/includedRiskFactor";
var includesAttraction2 = "https://schema.org/includesAttraction";
var includesHealthPlanFormulary2 = "https://schema.org/includesHealthPlanFormulary";
var includesHealthPlanNetwork2 = "https://schema.org/includesHealthPlanNetwork";
var includesObject2 = "https://schema.org/includesObject";
var incomeLimit2 = "https://schema.org/incomeLimit";
var increasesRiskOf2 = "https://schema.org/increasesRiskOf";
var industry2 = "https://schema.org/industry";
var ineligibleRegion2 = "https://schema.org/ineligibleRegion";
var infectiousAgent2 = "https://schema.org/infectiousAgent";
var infectiousAgentClass2 = "https://schema.org/infectiousAgentClass";
var ingredients2 = "https://schema.org/ingredients";
var inker2 = "https://schema.org/inker";
var insertion2 = "https://schema.org/insertion";
var installUrl2 = "https://schema.org/installUrl";
var instructor2 = "https://schema.org/instructor";
var intensity2 = "https://schema.org/intensity";
var interactingDrug2 = "https://schema.org/interactingDrug";
var interactionCount2 = "https://schema.org/interactionCount";
var interactionService2 = "https://schema.org/interactionService";
var interactionType2 = "https://schema.org/interactionType";
var interactivityType2 = "https://schema.org/interactivityType";
var interestRate2 = "https://schema.org/interestRate";
var interpretedAsClaim2 = "https://schema.org/interpretedAsClaim";
var inventoryLevel2 = "https://schema.org/inventoryLevel";
var inverseOf3 = "https://schema.org/inverseOf";
var isAcceptingNewPatients2 = "https://schema.org/isAcceptingNewPatients";
var isAccessoryOrSparePartFor2 = "https://schema.org/isAccessoryOrSparePartFor";
var isAvailableGenerically2 = "https://schema.org/isAvailableGenerically";
var isBasedOnUrl2 = "https://schema.org/isBasedOnUrl";
var isConsumableFor2 = "https://schema.org/isConsumableFor";
var isFamilyFriendly2 = "https://schema.org/isFamilyFriendly";
var isGift2 = "https://schema.org/isGift";
var isInvolvedInBiologicalProcess2 = "https://schema.org/isInvolvedInBiologicalProcess";
var isLiveBroadcast2 = "https://schema.org/isLiveBroadcast";
var isLocatedInSubcellularLocation2 = "https://schema.org/isLocatedInSubcellularLocation";
var isPlanForApartment2 = "https://schema.org/isPlanForApartment";
var isProprietary2 = "https://schema.org/isProprietary";
var isRelatedTo2 = "https://schema.org/isRelatedTo";
var isResizable2 = "https://schema.org/isResizable";
var isSimilarTo2 = "https://schema.org/isSimilarTo";
var isStoreOn2 = "https://schema.org/isStoreOn";
var isUnlabelledFallback2 = "https://schema.org/isUnlabelledFallback";
var isbn2 = "https://schema.org/isbn";
var isicV42 = "https://schema.org/isicV4";
var iso6523Code2 = "https://schema.org/iso6523Code";
var isrcCode2 = "https://schema.org/isrcCode";
var issn2 = "https://schema.org/issn";
var issueNumber2 = "https://schema.org/issueNumber";
var issuedBy2 = "https://schema.org/issuedBy";
var issuedThrough2 = "https://schema.org/issuedThrough";
var iswcCode2 = "https://schema.org/iswcCode";
var item3 = "https://schema.org/item";
var itemCondition2 = "https://schema.org/itemCondition";
var itemDefectReturnFees2 = "https://schema.org/itemDefectReturnFees";
var itemDefectReturnLabelSource2 = "https://schema.org/itemDefectReturnLabelSource";
var itemDefectReturnShippingFeesAmount2 = "https://schema.org/itemDefectReturnShippingFeesAmount";
var itemListElement2 = "https://schema.org/itemListElement";
var itemListOrder2 = "https://schema.org/itemListOrder";
var itemLocation2 = "https://schema.org/itemLocation";
var itemReviewed2 = "https://schema.org/itemReviewed";
var itemShipped2 = "https://schema.org/itemShipped";
var itinerary2 = "https://schema.org/itinerary";
var iupacName2 = "https://schema.org/iupacName";
var jobDuration2 = "https://schema.org/jobDuration";
var jobImmediateStart2 = "https://schema.org/jobImmediateStart";
var jobLocation2 = "https://schema.org/jobLocation";
var jobLocationType2 = "https://schema.org/jobLocationType";
var jobStartDate2 = "https://schema.org/jobStartDate";
var jobTitle2 = "https://schema.org/jobTitle";
var keywords2 = "https://schema.org/keywords";
var knownVehicleDamages2 = "https://schema.org/knownVehicleDamages";
var knows3 = "https://schema.org/knows";
var knowsAbout2 = "https://schema.org/knowsAbout";
var knowsLanguage2 = "https://schema.org/knowsLanguage";
var labelDetails2 = "https://schema.org/labelDetails";
var landlord2 = "https://schema.org/landlord";
var language6 = "https://schema.org/language";
var lastReviewed2 = "https://schema.org/lastReviewed";
var latitude4 = "https://schema.org/latitude";
var layoutImage2 = "https://schema.org/layoutImage";
var learningResourceType2 = "https://schema.org/learningResourceType";
var leaseLength2 = "https://schema.org/leaseLength";
var legalAddress2 = "https://schema.org/legalAddress";
var legalName2 = "https://schema.org/legalName";
var legalRepresentative2 = "https://schema.org/legalRepresentative";
var legalStatus2 = "https://schema.org/legalStatus";
var legislationAmends2 = "https://schema.org/legislationAmends";
var legislationCommences2 = "https://schema.org/legislationCommences";
var legislationConsolidates2 = "https://schema.org/legislationConsolidates";
var legislationCorrects2 = "https://schema.org/legislationCorrects";
var legislationCountersignedBy2 = "https://schema.org/legislationCountersignedBy";
var legislationDate2 = "https://schema.org/legislationDate";
var legislationDateOfApplicability2 = "https://schema.org/legislationDateOfApplicability";
var legislationDateVersion2 = "https://schema.org/legislationDateVersion";
var legislationEnsuresImplementationOf2 = "https://schema.org/legislationEnsuresImplementationOf";
var legislationIdentifier2 = "https://schema.org/legislationIdentifier";
var legislationJurisdiction2 = "https://schema.org/legislationJurisdiction";
var legislationLegalForce2 = "https://schema.org/legislationLegalForce";
var legislationLegalValue2 = "https://schema.org/legislationLegalValue";
var legislationPassedBy2 = "https://schema.org/legislationPassedBy";
var legislationRepeals2 = "https://schema.org/legislationRepeals";
var legislationResponsible2 = "https://schema.org/legislationResponsible";
var legislationTransposes2 = "https://schema.org/legislationTransposes";
var legislationType2 = "https://schema.org/legislationType";
var leiCode2 = "https://schema.org/leiCode";
var lender2 = "https://schema.org/lender";
var lesser2 = "https://schema.org/lesser";
var lesserOrEqual2 = "https://schema.org/lesserOrEqual";
var letterer2 = "https://schema.org/letterer";
var license4 = "https://schema.org/license";
var lifeEvent2 = "https://schema.org/lifeEvent";
var line3 = "https://schema.org/line";
var linkRelationship2 = "https://schema.org/linkRelationship";
var liveBlogUpdate2 = "https://schema.org/liveBlogUpdate";
var loanMortgageMandateAmount2 = "https://schema.org/loanMortgageMandateAmount";
var loanPaymentAmount2 = "https://schema.org/loanPaymentAmount";
var loanPaymentFrequency2 = "https://schema.org/loanPaymentFrequency";
var loanRepaymentForm2 = "https://schema.org/loanRepaymentForm";
var loanTerm2 = "https://schema.org/loanTerm";
var loanType2 = "https://schema.org/loanType";
var locationCreated2 = "https://schema.org/locationCreated";
var lodgingUnitDescription2 = "https://schema.org/lodgingUnitDescription";
var lodgingUnitType2 = "https://schema.org/lodgingUnitType";
var logo3 = "https://schema.org/logo";
var longitude4 = "https://schema.org/longitude";
var loser2 = "https://schema.org/loser";
var lowPrice2 = "https://schema.org/lowPrice";
var lyricist2 = "https://schema.org/lyricist";
var lyrics2 = "https://schema.org/lyrics";
var maintainer2 = "https://schema.org/maintainer";
var manufacturer3 = "https://schema.org/manufacturer";
var map4 = "https://schema.org/map";
var mapType2 = "https://schema.org/mapType";
var maps2 = "https://schema.org/maps";
var marginOfError2 = "https://schema.org/marginOfError";
var masthead2 = "https://schema.org/masthead";
var materialExtent2 = "https://schema.org/materialExtent";
var mathExpression2 = "https://schema.org/mathExpression";
var maxPrice2 = "https://schema.org/maxPrice";
var maxValue3 = "https://schema.org/maxValue";
var maximumAttendeeCapacity2 = "https://schema.org/maximumAttendeeCapacity";
var maximumEnrollment2 = "https://schema.org/maximumEnrollment";
var maximumIntake2 = "https://schema.org/maximumIntake";
var maximumPhysicalAttendeeCapacity2 = "https://schema.org/maximumPhysicalAttendeeCapacity";
var maximumVirtualAttendeeCapacity2 = "https://schema.org/maximumVirtualAttendeeCapacity";
var mealService2 = "https://schema.org/mealService";
var measuredProperty2 = "https://schema.org/measuredProperty";
var measurementDenominator2 = "https://schema.org/measurementDenominator";
var measurementMethod2 = "https://schema.org/measurementMethod";
var measurementQualifier2 = "https://schema.org/measurementQualifier";
var mechanismOfAction2 = "https://schema.org/mechanismOfAction";
var mediaAuthenticityCategory2 = "https://schema.org/mediaAuthenticityCategory";
var mediaItemAppearance2 = "https://schema.org/mediaItemAppearance";
var median2 = "https://schema.org/median";
var medicalAudience2 = "https://schema.org/medicalAudience";
var medicalSpecialty2 = "https://schema.org/medicalSpecialty";
var medicineSystem2 = "https://schema.org/medicineSystem";
var meetsEmissionStandard2 = "https://schema.org/meetsEmissionStandard";
var members3 = "https://schema.org/members";
var membershipNumber2 = "https://schema.org/membershipNumber";
var membershipPointsEarned2 = "https://schema.org/membershipPointsEarned";
var memoryRequirements2 = "https://schema.org/memoryRequirements";
var mentions2 = "https://schema.org/mentions";
var menu2 = "https://schema.org/menu";
var menuAddOn2 = "https://schema.org/menuAddOn";
var merchant2 = "https://schema.org/merchant";
var messageAttachment2 = "https://schema.org/messageAttachment";
var mileageFromOdometer2 = "https://schema.org/mileageFromOdometer";
var minPrice2 = "https://schema.org/minPrice";
var minValue3 = "https://schema.org/minValue";
var minimumPaymentDue2 = "https://schema.org/minimumPaymentDue";
var missionCoveragePrioritiesPolicy2 = "https://schema.org/missionCoveragePrioritiesPolicy";
var mobileUrl2 = "https://schema.org/mobileUrl";
var model2 = "https://schema.org/model";
var modelDate2 = "https://schema.org/modelDate";
var modifiedTime2 = "https://schema.org/modifiedTime";
var molecularFormula3 = "https://schema.org/molecularFormula";
var molecularWeight3 = "https://schema.org/molecularWeight";
var monoisotopicMolecularWeight2 = "https://schema.org/monoisotopicMolecularWeight";
var monthlyMinimumRepaymentAmount2 = "https://schema.org/monthlyMinimumRepaymentAmount";
var monthsOfExperience2 = "https://schema.org/monthsOfExperience";
var mpn2 = "https://schema.org/mpn";
var multipleValues2 = "https://schema.org/multipleValues";
var muscleAction2 = "https://schema.org/muscleAction";
var musicArrangement2 = "https://schema.org/musicArrangement";
var musicBy2 = "https://schema.org/musicBy";
var musicCompositionForm2 = "https://schema.org/musicCompositionForm";
var musicGroupMember2 = "https://schema.org/musicGroupMember";
var musicReleaseFormat2 = "https://schema.org/musicReleaseFormat";
var musicalKey2 = "https://schema.org/musicalKey";
var naics2 = "https://schema.org/naics";
var name5 = "https://schema.org/name";
var namedPosition2 = "https://schema.org/namedPosition";
var nationality2 = "https://schema.org/nationality";
var naturalProgression2 = "https://schema.org/naturalProgression";
var negativeNotes2 = "https://schema.org/negativeNotes";
var nerve2 = "https://schema.org/nerve";
var nerveMotor2 = "https://schema.org/nerveMotor";
var netWorth2 = "https://schema.org/netWorth";
var newsUpdatesAndGuidelines2 = "https://schema.org/newsUpdatesAndGuidelines";
var nextItem2 = "https://schema.org/nextItem";
var noBylinesPolicy2 = "https://schema.org/noBylinesPolicy";
var nonEqual2 = "https://schema.org/nonEqual";
var nonProprietaryName2 = "https://schema.org/nonProprietaryName";
var nonprofitStatus2 = "https://schema.org/nonprofitStatus";
var normalRange2 = "https://schema.org/normalRange";
var nsn2 = "https://schema.org/nsn";
var numAdults2 = "https://schema.org/numAdults";
var numChildren2 = "https://schema.org/numChildren";
var numConstraints2 = "https://schema.org/numConstraints";
var numItems2 = "https://schema.org/numItems";
var numTracks2 = "https://schema.org/numTracks";
var numberOfAccommodationUnits2 = "https://schema.org/numberOfAccommodationUnits";
var numberOfAirbags2 = "https://schema.org/numberOfAirbags";
var numberOfAvailableAccommodationUnits2 = "https://schema.org/numberOfAvailableAccommodationUnits";
var numberOfAxles2 = "https://schema.org/numberOfAxles";
var numberOfBathroomsTotal2 = "https://schema.org/numberOfBathroomsTotal";
var numberOfBedrooms2 = "https://schema.org/numberOfBedrooms";
var numberOfBeds2 = "https://schema.org/numberOfBeds";
var numberOfCredits2 = "https://schema.org/numberOfCredits";
var numberOfDoors2 = "https://schema.org/numberOfDoors";
var numberOfEmployees2 = "https://schema.org/numberOfEmployees";
var numberOfEpisodes2 = "https://schema.org/numberOfEpisodes";
var numberOfForwardGears2 = "https://schema.org/numberOfForwardGears";
var numberOfFullBathrooms2 = "https://schema.org/numberOfFullBathrooms";
var numberOfItems2 = "https://schema.org/numberOfItems";
var numberOfLoanPayments2 = "https://schema.org/numberOfLoanPayments";
var numberOfPages2 = "https://schema.org/numberOfPages";
var numberOfPartialBathrooms2 = "https://schema.org/numberOfPartialBathrooms";
var numberOfPlayers2 = "https://schema.org/numberOfPlayers";
var numberOfPreviousOwners2 = "https://schema.org/numberOfPreviousOwners";
var numberOfRooms2 = "https://schema.org/numberOfRooms";
var numberOfSeasons2 = "https://schema.org/numberOfSeasons";
var numberedPosition2 = "https://schema.org/numberedPosition";
var nutrition2 = "https://schema.org/nutrition";
var observationAbout2 = "https://schema.org/observationAbout";
var observationDate2 = "https://schema.org/observationDate";
var observationPeriod2 = "https://schema.org/observationPeriod";
var occupancy2 = "https://schema.org/occupancy";
var occupationLocation2 = "https://schema.org/occupationLocation";
var occupationalCategory2 = "https://schema.org/occupationalCategory";
var occupationalCredentialAwarded2 = "https://schema.org/occupationalCredentialAwarded";
var offerCount2 = "https://schema.org/offerCount";
var offersPrescriptionByMail2 = "https://schema.org/offersPrescriptionByMail";
var openingHours2 = "https://schema.org/openingHours";
var openingHoursSpecification2 = "https://schema.org/openingHoursSpecification";
var opens2 = "https://schema.org/opens";
var operatingSystem2 = "https://schema.org/operatingSystem";
var opponent2 = "https://schema.org/opponent";
var option4 = "https://schema.org/option";
var orderDate2 = "https://schema.org/orderDate";
var orderDelivery2 = "https://schema.org/orderDelivery";
var orderItemNumber2 = "https://schema.org/orderItemNumber";
var orderItemStatus2 = "https://schema.org/orderItemStatus";
var orderNumber2 = "https://schema.org/orderNumber";
var orderPercentage2 = "https://schema.org/orderPercentage";
var orderQuantity2 = "https://schema.org/orderQuantity";
var orderStatus2 = "https://schema.org/orderStatus";
var orderValue2 = "https://schema.org/orderValue";
var orderedItem2 = "https://schema.org/orderedItem";
var organizer3 = "https://schema.org/organizer";
var originAddress2 = "https://schema.org/originAddress";
var originalMediaContextDescription2 = "https://schema.org/originalMediaContextDescription";
var originalMediaLink2 = "https://schema.org/originalMediaLink";
var originatesFrom2 = "https://schema.org/originatesFrom";
var overdosage2 = "https://schema.org/overdosage";
var ownedFrom2 = "https://schema.org/ownedFrom";
var ownedThrough2 = "https://schema.org/ownedThrough";
var ownershipFundingInfo2 = "https://schema.org/ownershipFundingInfo";
var pageEnd2 = "https://schema.org/pageEnd";
var pageStart2 = "https://schema.org/pageStart";
var pagination2 = "https://schema.org/pagination";
var parentItem2 = "https://schema.org/parentItem";
var parentService2 = "https://schema.org/parentService";
var parents2 = "https://schema.org/parents";
var partOfEpisode2 = "https://schema.org/partOfEpisode";
var partOfInvoice2 = "https://schema.org/partOfInvoice";
var partOfOrder2 = "https://schema.org/partOfOrder";
var partOfSeason2 = "https://schema.org/partOfSeason";
var partOfSystem2 = "https://schema.org/partOfSystem";
var partOfTVSeries2 = "https://schema.org/partOfTVSeries";
var partySize2 = "https://schema.org/partySize";
var passengerPriorityStatus2 = "https://schema.org/passengerPriorityStatus";
var passengerSequenceNumber2 = "https://schema.org/passengerSequenceNumber";
var pathophysiology2 = "https://schema.org/pathophysiology";
var pattern3 = "https://schema.org/pattern";
var payload3 = "https://schema.org/payload";
var paymentAccepted2 = "https://schema.org/paymentAccepted";
var paymentDue2 = "https://schema.org/paymentDue";
var paymentMethod2 = "https://schema.org/paymentMethod";
var paymentMethodId2 = "https://schema.org/paymentMethodId";
var paymentMethodType2 = "https://schema.org/paymentMethodType";
var paymentStatus3 = "https://schema.org/paymentStatus";
var paymentUrl2 = "https://schema.org/paymentUrl";
var penciler2 = "https://schema.org/penciler";
var percentile102 = "https://schema.org/percentile10";
var percentile252 = "https://schema.org/percentile25";
var percentile752 = "https://schema.org/percentile75";
var percentile902 = "https://schema.org/percentile90";
var performerIn2 = "https://schema.org/performerIn";
var performers2 = "https://schema.org/performers";
var permissionType2 = "https://schema.org/permissionType";
var permissions2 = "https://schema.org/permissions";
var permitAudience2 = "https://schema.org/permitAudience";
var permittedUsage2 = "https://schema.org/permittedUsage";
var petsAllowed2 = "https://schema.org/petsAllowed";
var phoneticText2 = "https://schema.org/phoneticText";
var photos2 = "https://schema.org/photos";
var physicalRequirement2 = "https://schema.org/physicalRequirement";
var physiologicalBenefits2 = "https://schema.org/physiologicalBenefits";
var pickupLocation2 = "https://schema.org/pickupLocation";
var pickupTime2 = "https://schema.org/pickupTime";
var playMode2 = "https://schema.org/playMode";
var playerType2 = "https://schema.org/playerType";
var playersOnline2 = "https://schema.org/playersOnline";
var polygon2 = "https://schema.org/polygon";
var populationType2 = "https://schema.org/populationType";
var positiveNotes2 = "https://schema.org/positiveNotes";
var possibleComplication2 = "https://schema.org/possibleComplication";
var possibleTreatment2 = "https://schema.org/possibleTreatment";
var postOfficeBoxNumber2 = "https://schema.org/postOfficeBoxNumber";
var postOp2 = "https://schema.org/postOp";
var postalCode3 = "https://schema.org/postalCode";
var postalCodeBegin2 = "https://schema.org/postalCodeBegin";
var postalCodeEnd2 = "https://schema.org/postalCodeEnd";
var postalCodePrefix2 = "https://schema.org/postalCodePrefix";
var postalCodeRange2 = "https://schema.org/postalCodeRange";
var potentialAction2 = "https://schema.org/potentialAction";
var potentialUse2 = "https://schema.org/potentialUse";
var practicesAt2 = "https://schema.org/practicesAt";
var preOp2 = "https://schema.org/preOp";
var predecessorOf2 = "https://schema.org/predecessorOf";
var pregnancyCategory2 = "https://schema.org/pregnancyCategory";
var pregnancyWarning2 = "https://schema.org/pregnancyWarning";
var prepTime2 = "https://schema.org/prepTime";
var preparation3 = "https://schema.org/preparation";
var prescribingInfo2 = "https://schema.org/prescribingInfo";
var prescriptionStatus2 = "https://schema.org/prescriptionStatus";
var previousItem2 = "https://schema.org/previousItem";
var previousStartDate2 = "https://schema.org/previousStartDate";
var price2 = "https://schema.org/price";
var priceComponent3 = "https://schema.org/priceComponent";
var priceComponentType2 = "https://schema.org/priceComponentType";
var priceCurrency2 = "https://schema.org/priceCurrency";
var priceRange2 = "https://schema.org/priceRange";
var priceSpecification2 = "https://schema.org/priceSpecification";
var priceType2 = "https://schema.org/priceType";
var priceValidUntil2 = "https://schema.org/priceValidUntil";
var primaryImageOfPage2 = "https://schema.org/primaryImageOfPage";
var primaryPrevention2 = "https://schema.org/primaryPrevention";
var printColumn2 = "https://schema.org/printColumn";
var printEdition2 = "https://schema.org/printEdition";
var printPage2 = "https://schema.org/printPage";
var printSection2 = "https://schema.org/printSection";
var procedure3 = "https://schema.org/procedure";
var procedureType2 = "https://schema.org/procedureType";
var processingTime2 = "https://schema.org/processingTime";
var processorRequirements2 = "https://schema.org/processorRequirements";
var producer2 = "https://schema.org/producer";
var produces2 = "https://schema.org/produces";
var productGroupID2 = "https://schema.org/productGroupID";
var productID2 = "https://schema.org/productID";
var productReturnDays2 = "https://schema.org/productReturnDays";
var productReturnLink2 = "https://schema.org/productReturnLink";
var productSupported2 = "https://schema.org/productSupported";
var productionCompany2 = "https://schema.org/productionCompany";
var productionDate2 = "https://schema.org/productionDate";
var proficiencyLevel2 = "https://schema.org/proficiencyLevel";
var program3 = "https://schema.org/program";
var programMembershipUsed2 = "https://schema.org/programMembershipUsed";
var programName2 = "https://schema.org/programName";
var programPrerequisites2 = "https://schema.org/programPrerequisites";
var programType2 = "https://schema.org/programType";
var programmingLanguage2 = "https://schema.org/programmingLanguage";
var programmingModel2 = "https://schema.org/programmingModel";
var pronouns2 = "https://schema.org/pronouns";
var propertyID2 = "https://schema.org/propertyID";
var proprietaryName2 = "https://schema.org/proprietaryName";
var proteinContent2 = "https://schema.org/proteinContent";
var providerMobility2 = "https://schema.org/providerMobility";
var providesService2 = "https://schema.org/providesService";
var publicAccess2 = "https://schema.org/publicAccess";
var publicTransportClosuresInfo2 = "https://schema.org/publicTransportClosuresInfo";
var publication2 = "https://schema.org/publication";
var publicationType2 = "https://schema.org/publicationType";
var publishedBy2 = "https://schema.org/publishedBy";
var publishedOn2 = "https://schema.org/publishedOn";
var publisher5 = "https://schema.org/publisher";
var publisherImprint2 = "https://schema.org/publisherImprint";
var purchaseDate2 = "https://schema.org/purchaseDate";
var purchasePriceLimit2 = "https://schema.org/purchasePriceLimit";
var purchaseType2 = "https://schema.org/purchaseType";
var qualifications2 = "https://schema.org/qualifications";
var qualifiedExpense2 = "https://schema.org/qualifiedExpense";
var quarantineGuidelines2 = "https://schema.org/quarantineGuidelines";
var query3 = "https://schema.org/query";
var quest2 = "https://schema.org/quest";
var question3 = "https://schema.org/question";
var rangeIncludes2 = "https://schema.org/rangeIncludes";
var ratingCount2 = "https://schema.org/ratingCount";
var ratingExplanation2 = "https://schema.org/ratingExplanation";
var ratingValue2 = "https://schema.org/ratingValue";
var readBy2 = "https://schema.org/readBy";
var readonlyValue2 = "https://schema.org/readonlyValue";
var realEstateAgent2 = "https://schema.org/realEstateAgent";
var recipe2 = "https://schema.org/recipe";
var recipeCategory2 = "https://schema.org/recipeCategory";
var recipeCuisine2 = "https://schema.org/recipeCuisine";
var recipeInstructions2 = "https://schema.org/recipeInstructions";
var recipeYield2 = "https://schema.org/recipeYield";
var recognizedBy2 = "https://schema.org/recognizedBy";
var recognizingAuthority2 = "https://schema.org/recognizingAuthority";
var recommendationStrength2 = "https://schema.org/recommendationStrength";
var recommendedIntake2 = "https://schema.org/recommendedIntake";
var recordLabel2 = "https://schema.org/recordLabel";
var recourseLoan2 = "https://schema.org/recourseLoan";
var referee2 = "https://schema.org/referee";
var referenceQuantity2 = "https://schema.org/referenceQuantity";
var referencesOrder2 = "https://schema.org/referencesOrder";
var refundType2 = "https://schema.org/refundType";
var regionDrained2 = "https://schema.org/regionDrained";
var regionsAllowed2 = "https://schema.org/regionsAllowed";
var relatedAnatomy2 = "https://schema.org/relatedAnatomy";
var relatedCondition2 = "https://schema.org/relatedCondition";
var relatedDrug2 = "https://schema.org/relatedDrug";
var relatedLink2 = "https://schema.org/relatedLink";
var relatedStructure2 = "https://schema.org/relatedStructure";
var relatedTherapy2 = "https://schema.org/relatedTherapy";
var relatedTo3 = "https://schema.org/relatedTo";
var releaseDate3 = "https://schema.org/releaseDate";
var releaseNotes2 = "https://schema.org/releaseNotes";
var releasedEvent2 = "https://schema.org/releasedEvent";
var relevantOccupation2 = "https://schema.org/relevantOccupation";
var relevantSpecialty2 = "https://schema.org/relevantSpecialty";
var remainingAttendeeCapacity2 = "https://schema.org/remainingAttendeeCapacity";
var renegotiableLoan2 = "https://schema.org/renegotiableLoan";
var repeatCount2 = "https://schema.org/repeatCount";
var repeatFrequency2 = "https://schema.org/repeatFrequency";
var repetitions3 = "https://schema.org/repetitions";
var replacee2 = "https://schema.org/replacee";
var replacer2 = "https://schema.org/replacer";
var replyToUrl2 = "https://schema.org/replyToUrl";
var reportNumber2 = "https://schema.org/reportNumber";
var representativeOfPage2 = "https://schema.org/representativeOfPage";
var requiredCollateral2 = "https://schema.org/requiredCollateral";
var requiredGender2 = "https://schema.org/requiredGender";
var requiredMaxAge2 = "https://schema.org/requiredMaxAge";
var requiredMinAge2 = "https://schema.org/requiredMinAge";
var requiredQuantity2 = "https://schema.org/requiredQuantity";
var requirements3 = "https://schema.org/requirements";
var requiresSubscription2 = "https://schema.org/requiresSubscription";
var reservationFor2 = "https://schema.org/reservationFor";
var reservationId2 = "https://schema.org/reservationId";
var reservationStatus2 = "https://schema.org/reservationStatus";
var reservedTicket2 = "https://schema.org/reservedTicket";
var responsibilities2 = "https://schema.org/responsibilities";
var restPeriods2 = "https://schema.org/restPeriods";
var restockingFee2 = "https://schema.org/restockingFee";
var resultComment2 = "https://schema.org/resultComment";
var resultReview2 = "https://schema.org/resultReview";
var returnFees2 = "https://schema.org/returnFees";
var returnLabelSource2 = "https://schema.org/returnLabelSource";
var returnMethod2 = "https://schema.org/returnMethod";
var returnPolicyCategory2 = "https://schema.org/returnPolicyCategory";
var returnPolicyCountry2 = "https://schema.org/returnPolicyCountry";
var returnPolicySeasonalOverride2 = "https://schema.org/returnPolicySeasonalOverride";
var returnShippingFeesAmount2 = "https://schema.org/returnShippingFeesAmount";
var reviewAspect2 = "https://schema.org/reviewAspect";
var reviewBody2 = "https://schema.org/reviewBody";
var reviewCount2 = "https://schema.org/reviewCount";
var reviewRating2 = "https://schema.org/reviewRating";
var reviewedBy2 = "https://schema.org/reviewedBy";
var reviews2 = "https://schema.org/reviews";
var riskFactor2 = "https://schema.org/riskFactor";
var risks2 = "https://schema.org/risks";
var roofLoad2 = "https://schema.org/roofLoad";
var rsvpResponse2 = "https://schema.org/rsvpResponse";
var runsTo2 = "https://schema.org/runsTo";
var runtime2 = "https://schema.org/runtime";
var rxcui2 = "https://schema.org/rxcui";
var safetyConsideration2 = "https://schema.org/safetyConsideration";
var salaryCurrency2 = "https://schema.org/salaryCurrency";
var salaryUponCompletion2 = "https://schema.org/salaryUponCompletion";
var sameAs3 = "https://schema.org/sameAs";
var sampleType2 = "https://schema.org/sampleType";
var saturatedFatContent2 = "https://schema.org/saturatedFatContent";
var scheduleTimezone2 = "https://schema.org/scheduleTimezone";
var scheduledPaymentDate2 = "https://schema.org/scheduledPaymentDate";
var scheduledTime2 = "https://schema.org/scheduledTime";
var schemaVersion2 = "https://schema.org/schemaVersion";
var schoolClosuresInfo2 = "https://schema.org/schoolClosuresInfo";
var screenCount2 = "https://schema.org/screenCount";
var screenshot2 = "https://schema.org/screenshot";
var sdDatePublished2 = "https://schema.org/sdDatePublished";
var sdLicense2 = "https://schema.org/sdLicense";
var sdPublisher2 = "https://schema.org/sdPublisher";
var seasonNumber2 = "https://schema.org/seasonNumber";
var seasonalOverride2 = "https://schema.org/seasonalOverride";
var seasons2 = "https://schema.org/seasons";
var seatNumber2 = "https://schema.org/seatNumber";
var seatRow2 = "https://schema.org/seatRow";
var seatSection2 = "https://schema.org/seatSection";
var seatingCapacity2 = "https://schema.org/seatingCapacity";
var seatingType2 = "https://schema.org/seatingType";
var secondaryPrevention2 = "https://schema.org/secondaryPrevention";
var securityClearanceRequirement2 = "https://schema.org/securityClearanceRequirement";
var securityScreening2 = "https://schema.org/securityScreening";
var seeks2 = "https://schema.org/seeks";
var sender3 = "https://schema.org/sender";
var sensoryRequirement2 = "https://schema.org/sensoryRequirement";
var sensoryUnit2 = "https://schema.org/sensoryUnit";
var seriousAdverseOutcome2 = "https://schema.org/seriousAdverseOutcome";
var serverStatus2 = "https://schema.org/serverStatus";
var servesCuisine2 = "https://schema.org/servesCuisine";
var serviceAudience2 = "https://schema.org/serviceAudience";
var serviceLocation2 = "https://schema.org/serviceLocation";
var serviceOperator2 = "https://schema.org/serviceOperator";
var servicePhone2 = "https://schema.org/servicePhone";
var servicePostalAddress2 = "https://schema.org/servicePostalAddress";
var serviceSmsNumber2 = "https://schema.org/serviceSmsNumber";
var serviceType3 = "https://schema.org/serviceType";
var serviceUrl2 = "https://schema.org/serviceUrl";
var servingSize2 = "https://schema.org/servingSize";
var sha2562 = "https://schema.org/sha256";
var sharedContent2 = "https://schema.org/sharedContent";
var shippingConditions2 = "https://schema.org/shippingConditions";
var shippingDestination2 = "https://schema.org/shippingDestination";
var shippingDetails2 = "https://schema.org/shippingDetails";
var shippingLabel2 = "https://schema.org/shippingLabel";
var shippingOrigin2 = "https://schema.org/shippingOrigin";
var shippingRate2 = "https://schema.org/shippingRate";
var shippingSettingsLink2 = "https://schema.org/shippingSettingsLink";
var siblings2 = "https://schema.org/siblings";
var signDetected2 = "https://schema.org/signDetected";
var signOrSymptom2 = "https://schema.org/signOrSymptom";
var significance2 = "https://schema.org/significance";
var significantLinks2 = "https://schema.org/significantLinks";
var size3 = "https://schema.org/size";
var sizeGroup2 = "https://schema.org/sizeGroup";
var sizeSystem2 = "https://schema.org/sizeSystem";
var skills2 = "https://schema.org/skills";
var sku2 = "https://schema.org/sku";
var slogan2 = "https://schema.org/slogan";
var smiles2 = "https://schema.org/smiles";
var smokingAllowed2 = "https://schema.org/smokingAllowed";
var sodiumContent2 = "https://schema.org/sodiumContent";
var softwareAddOn2 = "https://schema.org/softwareAddOn";
var softwareHelp2 = "https://schema.org/softwareHelp";
var softwareVersion2 = "https://schema.org/softwareVersion";
var source6 = "https://schema.org/source";
var sourceOrganization2 = "https://schema.org/sourceOrganization";
var sourcedFrom2 = "https://schema.org/sourcedFrom";
var spatial3 = "https://schema.org/spatial";
var speakable2 = "https://schema.org/speakable";
var specialCommitments2 = "https://schema.org/specialCommitments";
var specialOpeningHoursSpecification2 = "https://schema.org/specialOpeningHoursSpecification";
var specialty3 = "https://schema.org/specialty";
var speechToTextMarkup2 = "https://schema.org/speechToTextMarkup";
var speed2 = "https://schema.org/speed";
var spokenByCharacter2 = "https://schema.org/spokenByCharacter";
var sport2 = "https://schema.org/sport";
var sportsActivityLocation2 = "https://schema.org/sportsActivityLocation";
var sportsEvent2 = "https://schema.org/sportsEvent";
var sportsTeam2 = "https://schema.org/sportsTeam";
var spouse2 = "https://schema.org/spouse";
var stage3 = "https://schema.org/stage";
var stageAsNumber2 = "https://schema.org/stageAsNumber";
var starRating2 = "https://schema.org/starRating";
var startDate3 = "https://schema.org/startDate";
var startOffset2 = "https://schema.org/startOffset";
var startTime3 = "https://schema.org/startTime";
var statType2 = "https://schema.org/statType";
var status7 = "https://schema.org/status";
var steeringPosition2 = "https://schema.org/steeringPosition";
var stepValue2 = "https://schema.org/stepValue";
var steps2 = "https://schema.org/steps";
var storageRequirements2 = "https://schema.org/storageRequirements";
var streetAddress2 = "https://schema.org/streetAddress";
var strengthUnit2 = "https://schema.org/strengthUnit";
var strengthValue2 = "https://schema.org/strengthValue";
var structuralClass2 = "https://schema.org/structuralClass";
var study3 = "https://schema.org/study";
var studyDesign3 = "https://schema.org/studyDesign";
var studyLocation2 = "https://schema.org/studyLocation";
var studySubject2 = "https://schema.org/studySubject";
var stupidProperty2 = "https://schema.org/stupidProperty";
var subEvents2 = "https://schema.org/subEvents";
var subReservation2 = "https://schema.org/subReservation";
var subStageSuffix2 = "https://schema.org/subStageSuffix";
var subStructure2 = "https://schema.org/subStructure";
var subTest2 = "https://schema.org/subTest";
var subtitleLanguage2 = "https://schema.org/subtitleLanguage";
var successorOf2 = "https://schema.org/successorOf";
var sugarContent2 = "https://schema.org/sugarContent";
var suggestedAge2 = "https://schema.org/suggestedAge";
var suggestedGender2 = "https://schema.org/suggestedGender";
var suggestedMaxAge2 = "https://schema.org/suggestedMaxAge";
var suggestedMeasurement2 = "https://schema.org/suggestedMeasurement";
var suggestedMinAge2 = "https://schema.org/suggestedMinAge";
var suitableForDiet2 = "https://schema.org/suitableForDiet";
var supersededBy2 = "https://schema.org/supersededBy";
var supplyTo2 = "https://schema.org/supplyTo";
var supportingData2 = "https://schema.org/supportingData";
var surface2 = "https://schema.org/surface";
var syllabusSections2 = "https://schema.org/syllabusSections";
var target4 = "https://schema.org/target";
var targetDescription2 = "https://schema.org/targetDescription";
var targetName2 = "https://schema.org/targetName";
var targetPlatform2 = "https://schema.org/targetPlatform";
var targetPopulation2 = "https://schema.org/targetPopulation";
var targetProduct2 = "https://schema.org/targetProduct";
var targetUrl2 = "https://schema.org/targetUrl";
var taxID2 = "https://schema.org/taxID";
var taxonRank2 = "https://schema.org/taxonRank";
var taxonomicRange2 = "https://schema.org/taxonomicRange";
var teaches2 = "https://schema.org/teaches";
var telephone2 = "https://schema.org/telephone";
var temporal3 = "https://schema.org/temporal";
var termDuration2 = "https://schema.org/termDuration";
var termsOfService2 = "https://schema.org/termsOfService";
var termsPerYear2 = "https://schema.org/termsPerYear";
var text3 = "https://schema.org/text";
var textValue2 = "https://schema.org/textValue";
var thumbnail3 = "https://schema.org/thumbnail";
var thumbnailUrl2 = "https://schema.org/thumbnailUrl";
var tickerSymbol2 = "https://schema.org/tickerSymbol";
var ticketNumber2 = "https://schema.org/ticketNumber";
var ticketToken2 = "https://schema.org/ticketToken";
var ticketedSeat2 = "https://schema.org/ticketedSeat";
var timeOfDay3 = "https://schema.org/timeOfDay";
var timeRequired2 = "https://schema.org/timeRequired";
var timeToComplete2 = "https://schema.org/timeToComplete";
var timestamp3 = "https://schema.org/timestamp";
var tissueSample2 = "https://schema.org/tissueSample";
var title7 = "https://schema.org/title";
var titleEIDR2 = "https://schema.org/titleEIDR";
var toLocation2 = "https://schema.org/toLocation";
var toRecipient2 = "https://schema.org/toRecipient";
var tocContinuation2 = "https://schema.org/tocContinuation";
var tocEntry2 = "https://schema.org/tocEntry";
var tongueWeight2 = "https://schema.org/tongueWeight";
var tool2 = "https://schema.org/tool";
var torque2 = "https://schema.org/torque";
var totalHistoricalEnrollment2 = "https://schema.org/totalHistoricalEnrollment";
var totalJobOpenings2 = "https://schema.org/totalJobOpenings";
var totalPaymentDue2 = "https://schema.org/totalPaymentDue";
var totalPrice2 = "https://schema.org/totalPrice";
var totalTime2 = "https://schema.org/totalTime";
var tourBookingPage2 = "https://schema.org/tourBookingPage";
var touristType2 = "https://schema.org/touristType";
var trackingNumber2 = "https://schema.org/trackingNumber";
var trackingUrl2 = "https://schema.org/trackingUrl";
var tracks2 = "https://schema.org/tracks";
var trailer2 = "https://schema.org/trailer";
var trailerWeight2 = "https://schema.org/trailerWeight";
var trainName2 = "https://schema.org/trainName";
var trainNumber2 = "https://schema.org/trainNumber";
var trainingSalary2 = "https://schema.org/trainingSalary";
var transFatContent2 = "https://schema.org/transFatContent";
var transcript2 = "https://schema.org/transcript";
var transitTime2 = "https://schema.org/transitTime";
var transitTimeLabel2 = "https://schema.org/transitTimeLabel";
var translator2 = "https://schema.org/translator";
var transmissionMethod2 = "https://schema.org/transmissionMethod";
var travelBans2 = "https://schema.org/travelBans";
var trialDesign2 = "https://schema.org/trialDesign";
var tributary2 = "https://schema.org/tributary";
var tripOrigin2 = "https://schema.org/tripOrigin";
var typeOfBed2 = "https://schema.org/typeOfBed";
var typeOfGood2 = "https://schema.org/typeOfGood";
var typicalAgeRange2 = "https://schema.org/typicalAgeRange";
var typicalCreditsPerTerm2 = "https://schema.org/typicalCreditsPerTerm";
var typicalTest2 = "https://schema.org/typicalTest";
var underName2 = "https://schema.org/underName";
var unitCode2 = "https://schema.org/unitCode";
var unitText2 = "https://schema.org/unitText";
var unnamedSourcesPolicy2 = "https://schema.org/unnamedSourcesPolicy";
var unsaturatedFatContent2 = "https://schema.org/unsaturatedFatContent";
var uploadDate2 = "https://schema.org/uploadDate";
var upvoteCount2 = "https://schema.org/upvoteCount";
var url5 = "https://schema.org/url";
var urlTemplate2 = "https://schema.org/urlTemplate";
var usNPI2 = "https://schema.org/usNPI";
var usedToDiagnose2 = "https://schema.org/usedToDiagnose";
var userInteractionCount2 = "https://schema.org/userInteractionCount";
var usesDevice2 = "https://schema.org/usesDevice";
var usesHealthPlanIdStandard2 = "https://schema.org/usesHealthPlanIdStandard";
var utterances2 = "https://schema.org/utterances";
var validFor2 = "https://schema.org/validFor";
var validForMemberTier2 = "https://schema.org/validForMemberTier";
var validFrom2 = "https://schema.org/validFrom";
var validIn2 = "https://schema.org/validIn";
var validThrough2 = "https://schema.org/validThrough";
var validUntil2 = "https://schema.org/validUntil";
var value5 = "https://schema.org/value";
var valueAddedTaxIncluded2 = "https://schema.org/valueAddedTaxIncluded";
var valueMaxLength2 = "https://schema.org/valueMaxLength";
var valueMinLength2 = "https://schema.org/valueMinLength";
var valueName2 = "https://schema.org/valueName";
var valuePattern2 = "https://schema.org/valuePattern";
var valueReference2 = "https://schema.org/valueReference";
var valueRequired2 = "https://schema.org/valueRequired";
var variableMeasured2 = "https://schema.org/variableMeasured";
var variablesMeasured2 = "https://schema.org/variablesMeasured";
var variantCover2 = "https://schema.org/variantCover";
var variesBy2 = "https://schema.org/variesBy";
var vatID2 = "https://schema.org/vatID";
var vehicleConfiguration2 = "https://schema.org/vehicleConfiguration";
var vehicleEngine2 = "https://schema.org/vehicleEngine";
var vehicleIdentificationNumber2 = "https://schema.org/vehicleIdentificationNumber";
var vehicleInteriorColor2 = "https://schema.org/vehicleInteriorColor";
var vehicleInteriorType2 = "https://schema.org/vehicleInteriorType";
var vehicleModelDate2 = "https://schema.org/vehicleModelDate";
var vehicleSeatingCapacity2 = "https://schema.org/vehicleSeatingCapacity";
var vehicleSpecialUsage2 = "https://schema.org/vehicleSpecialUsage";
var vehicleTransmission2 = "https://schema.org/vehicleTransmission";
var vendor2 = "https://schema.org/vendor";
var verificationFactCheckingPolicy2 = "https://schema.org/verificationFactCheckingPolicy";
var version5 = "https://schema.org/version";
var video2 = "https://schema.org/video";
var videoFormat2 = "https://schema.org/videoFormat";
var videoFrameSize2 = "https://schema.org/videoFrameSize";
var videoQuality2 = "https://schema.org/videoQuality";
var volumeNumber2 = "https://schema.org/volumeNumber";
var warning3 = "https://schema.org/warning";
var warrantyPromise2 = "https://schema.org/warrantyPromise";
var warrantyScope2 = "https://schema.org/warrantyScope";
var webCheckinTime2 = "https://schema.org/webCheckinTime";
var webFeed2 = "https://schema.org/webFeed";
var weight2 = "https://schema.org/weight";
var weightPercentage2 = "https://schema.org/weightPercentage";
var weightTotal2 = "https://schema.org/weightTotal";
var wheelbase2 = "https://schema.org/wheelbase";
var width4 = "https://schema.org/width";
var winner2 = "https://schema.org/winner";
var wordCount2 = "https://schema.org/wordCount";
var workHours2 = "https://schema.org/workHours";
var workLocation2 = "https://schema.org/workLocation";
var workPerformed2 = "https://schema.org/workPerformed";
var workPresented2 = "https://schema.org/workPresented";
var workload2 = "https://schema.org/workload";
var worksFor2 = "https://schema.org/worksFor";
var worstRating2 = "https://schema.org/worstRating";
var xpath2 = "https://schema.org/xpath";
var yearBuilt2 = "https://schema.org/yearBuilt";
var yearlyRevenue2 = "https://schema.org/yearlyRevenue";
var yearsInOperation2 = "https://schema.org/yearsInOperation";
var actionApplication2 = "https://schema.org/actionApplication";
var actionOption2 = "https://schema.org/actionOption";
var album2 = "https://schema.org/album";
var albumRelease2 = "https://schema.org/albumRelease";
var alternateName2 = "https://schema.org/alternateName";
var alumni2 = "https://schema.org/alumni";
var alumniOf2 = "https://schema.org/alumniOf";
var archiveHeld2 = "https://schema.org/archiveHeld";
var arterialBranch2 = "https://schema.org/arterialBranch";
var artworkSurface2 = "https://schema.org/artworkSurface";
var attendee3 = "https://schema.org/attendee";
var audience4 = "https://schema.org/audience";
var availableOnDevice2 = "https://schema.org/availableOnDevice";
var award2 = "https://schema.org/award";
var blogPost2 = "https://schema.org/blogPost";
var broker2 = "https://schema.org/broker";
var caption2 = "https://schema.org/caption";
var category5 = "https://schema.org/category";
var cause2 = "https://schema.org/cause";
var causeOf2 = "https://schema.org/causeOf";
var childTaxon2 = "https://schema.org/childTaxon";
var clinicalPharmacology2 = "https://schema.org/clinicalPharmacology";
var codeSampleType2 = "https://schema.org/codeSampleType";
var colleague2 = "https://schema.org/colleague";
var contactPoint2 = "https://schema.org/contactPoint";
var containsPlace2 = "https://schema.org/containsPlace";
var containsSeason2 = "https://schema.org/containsSeason";
var contentLocation2 = "https://schema.org/contentLocation";
var creator4 = "https://schema.org/creator";
var dataset2 = "https://schema.org/dataset";
var dateCreated2 = "https://schema.org/dateCreated";
var director2 = "https://schema.org/director";
var employee2 = "https://schema.org/employee";
var encodesBioChemEntity2 = "https://schema.org/encodesBioChemEntity";
var encodesCreativeWork2 = "https://schema.org/encodesCreativeWork";
var encodingFormat2 = "https://schema.org/encodingFormat";
var endDate3 = "https://schema.org/endDate";
var episode2 = "https://schema.org/episode";
var event3 = "https://schema.org/event";
var exampleOfWork2 = "https://schema.org/exampleOfWork";
var executableLibraryName2 = "https://schema.org/executableLibraryName";
var exerciseCourse2 = "https://schema.org/exerciseCourse";
var founder2 = "https://schema.org/founder";
var frequency3 = "https://schema.org/frequency";
var fundedItem2 = "https://schema.org/fundedItem";
var funding2 = "https://schema.org/funding";
var game2 = "https://schema.org/game";
var gameServer2 = "https://schema.org/gameServer";
var genre2 = "https://schema.org/genre";
var hasBioChemEntityPart2 = "https://schema.org/hasBioChemEntityPart";
var hasBroadcastChannel2 = "https://schema.org/hasBroadcastChannel";
var hasDefinedTerm2 = "https://schema.org/hasDefinedTerm";
var hasMenu2 = "https://schema.org/hasMenu";
var hasMerchantReturnPolicy2 = "https://schema.org/hasMerchantReturnPolicy";
var hasTiers2 = "https://schema.org/hasTiers";
var hasVariant2 = "https://schema.org/hasVariant";
var holdingArchive2 = "https://schema.org/holdingArchive";
var inDefinedTermSet2 = "https://schema.org/inDefinedTermSet";
var inLanguage2 = "https://schema.org/inLanguage";
var incentiveCompensation2 = "https://schema.org/incentiveCompensation";
var interactionStatistic2 = "https://schema.org/interactionStatistic";
var isAccessibleForFree2 = "https://schema.org/isAccessibleForFree";
var isBasedOn2 = "https://schema.org/isBasedOn";
var isEncodedByBioChemEntity2 = "https://schema.org/isEncodedByBioChemEntity";
var isPartOfBioChemEntity2 = "https://schema.org/isPartOfBioChemEntity";
var isTierOf2 = "https://schema.org/isTierOf";
var isVariantOf2 = "https://schema.org/isVariantOf";
var itemOffered2 = "https://schema.org/itemOffered";
var jobBenefits2 = "https://schema.org/jobBenefits";
var jurisdiction3 = "https://schema.org/jurisdiction";
var mainContentOfPage2 = "https://schema.org/mainContentOfPage";
var mainEntity2 = "https://schema.org/mainEntity";
var mainEntityOfPage2 = "https://schema.org/mainEntityOfPage";
var makesOffer2 = "https://schema.org/makesOffer";
var measurementTechnique2 = "https://schema.org/measurementTechnique";
var merchantReturnDays2 = "https://schema.org/merchantReturnDays";
var merchantReturnLink2 = "https://schema.org/merchantReturnLink";
var offeredBy2 = "https://schema.org/offeredBy";
var offers2 = "https://schema.org/offers";
var owner4 = "https://schema.org/owner";
var owns2 = "https://schema.org/owns";
var parent3 = "https://schema.org/parent";
var parentTaxon2 = "https://schema.org/parentTaxon";
var partOfSeries2 = "https://schema.org/partOfSeries";
var partOfTrip2 = "https://schema.org/partOfTrip";
var paymentDueDate2 = "https://schema.org/paymentDueDate";
var performTime2 = "https://schema.org/performTime";
var performer3 = "https://schema.org/performer";
var photo3 = "https://schema.org/photo";
var provider4 = "https://schema.org/provider";
var providesBroadcastService2 = "https://schema.org/providesBroadcastService";
var recipeIngredient2 = "https://schema.org/recipeIngredient";
var recordedAs2 = "https://schema.org/recordedAs";
var recordedAt2 = "https://schema.org/recordedAt";
var recordedIn2 = "https://schema.org/recordedIn";
var recordingOf2 = "https://schema.org/recordingOf";
var releaseOf2 = "https://schema.org/releaseOf";
var review2 = "https://schema.org/review";
var roleName2 = "https://schema.org/roleName";
var runtimePlatform2 = "https://schema.org/runtimePlatform";
var season2 = "https://schema.org/season";
var serialNumber3 = "https://schema.org/serialNumber";
var serviceArea2 = "https://schema.org/serviceArea";
var serviceOutput2 = "https://schema.org/serviceOutput";
var sibling2 = "https://schema.org/sibling";
var significantLink2 = "https://schema.org/significantLink";
var softwareRequirements2 = "https://schema.org/softwareRequirements";
var sponsor2 = "https://schema.org/sponsor";
var subOrganization2 = "https://schema.org/subOrganization";
var subTrip2 = "https://schema.org/subTrip";
var subjectOf2 = "https://schema.org/subjectOf";
var suggestedAnswer2 = "https://schema.org/suggestedAnswer";
var superEvent2 = "https://schema.org/superEvent";
var targetCollection2 = "https://schema.org/targetCollection";
var temporalCoverage2 = "https://schema.org/temporalCoverage";
var termCode2 = "https://schema.org/termCode";
var track2 = "https://schema.org/track";
var translationOfWork2 = "https://schema.org/translationOfWork";
var usageInfo2 = "https://schema.org/usageInfo";
var warranty2 = "https://schema.org/warranty";
var workTranslation2 = "https://schema.org/workTranslation";
var yield__workaround2 = "https://schema.org/yield";
var about3 = "https://schema.org/about";
var actor4 = "https://schema.org/actor";
var associatedReview2 = "https://schema.org/associatedReview";
var competitor2 = "https://schema.org/competitor";
var containedInPlace2 = "https://schema.org/containedInPlace";
var encoding2 = "https://schema.org/encoding";
var hasMap2 = "https://schema.org/hasMap";
var legislationApplies2 = "https://schema.org/legislationApplies";
var material3 = "https://schema.org/material";
var memberOf2 = "https://schema.org/memberOf";
var parentOrganization2 = "https://schema.org/parentOrganization";
var result4 = "https://schema.org/result";
var seller2 = "https://schema.org/seller";
var spatialCoverage2 = "https://schema.org/spatialCoverage";
var step3 = "https://schema.org/step";
var subEvent2 = "https://schema.org/subEvent";
var supply2 = "https://schema.org/supply";
var workFeatured2 = "https://schema.org/workFeatured";
var areaServed2 = "https://schema.org/areaServed";
var duration5 = "https://schema.org/duration";
var includedInDataCatalog2 = "https://schema.org/includedInDataCatalog";
var legislationChanges2 = "https://schema.org/legislationChanges";
var member7 = "https://schema.org/member";
var recipient3 = "https://schema.org/recipient";
var workExample2 = "https://schema.org/workExample";
var description8 = "https://schema.org/description";
var gtin2 = "https://schema.org/gtin";
var hasRepresentation2 = "https://schema.org/hasRepresentation";
var image4 = "https://schema.org/image";
var hasPart4 = "https://schema.org/hasPart";
var position3 = "https://schema.org/position";
var isPartOf3 = "https://schema.org/isPartOf";
var instrument3 = "https://schema.org/instrument";
var object5 = "https://schema.org/object";
var publishingPrinciples2 = "https://schema.org/publishingPrinciples";
var location5 = "https://schema.org/location";
var participant4 = "https://schema.org/participant";
var identifier5 = "https://schema.org/identifier";
var schema_httpsImport = /* @__PURE__ */ Object.freeze({
  AMRadioChannel: AMRadioChannel2,
  APIReference: APIReference2,
  AboutPage: AboutPage2,
  AcceptAction: AcceptAction2,
  Accommodation: Accommodation2,
  AccountingService: AccountingService2,
  AchieveAction: AchieveAction2,
  Action: Action4,
  ActionAccessSpecification: ActionAccessSpecification2,
  ActionStatusType: ActionStatusType2,
  ActivateAction: ActivateAction2,
  AddAction: AddAction2,
  AdministrativeArea: AdministrativeArea2,
  AdultEntertainment: AdultEntertainment2,
  AdultOrientedEnumeration: AdultOrientedEnumeration2,
  AdvertiserContentArticle: AdvertiserContentArticle2,
  AggregateOffer: AggregateOffer2,
  AggregateRating: AggregateRating2,
  AgreeAction: AgreeAction2,
  Airline: Airline2,
  Airport: Airport2,
  AlignmentObject: AlignmentObject2,
  AllocateAction: AllocateAction2,
  AmpStory: AmpStory2,
  AmusementPark: AmusementPark2,
  AnalysisNewsArticle: AnalysisNewsArticle2,
  AnatomicalStructure: AnatomicalStructure2,
  AnatomicalSystem: AnatomicalSystem2,
  AnimalShelter: AnimalShelter2,
  Answer: Answer3,
  Apartment: Apartment2,
  ApartmentComplex: ApartmentComplex2,
  AppendAction: AppendAction2,
  ApplyAction: ApplyAction2,
  ApprovedIndication: ApprovedIndication2,
  Aquarium: Aquarium2,
  ArchiveComponent: ArchiveComponent2,
  ArchiveOrganization: ArchiveOrganization2,
  ArriveAction: ArriveAction2,
  ArtGallery: ArtGallery2,
  Artery: Artery2,
  Article: Article3,
  AskAction: AskAction2,
  AskPublicNewsArticle: AskPublicNewsArticle2,
  AssessAction: AssessAction2,
  AssignAction: AssignAction2,
  Atlas: Atlas2,
  Attorney: Attorney2,
  Audience: Audience2,
  AudioObject: AudioObject2,
  AudioObjectSnapshot: AudioObjectSnapshot2,
  Audiobook: Audiobook2,
  AuthenticateAction: AuthenticateAction2,
  AuthorizeAction: AuthorizeAction2,
  AutoBodyShop: AutoBodyShop2,
  AutoDealer: AutoDealer2,
  AutoPartsStore: AutoPartsStore2,
  AutoRental: AutoRental2,
  AutoRepair: AutoRepair2,
  AutoWash: AutoWash2,
  AutomatedTeller: AutomatedTeller2,
  AutomotiveBusiness: AutomotiveBusiness2,
  BackgroundNewsArticle: BackgroundNewsArticle2,
  Bakery: Bakery2,
  BankAccount: BankAccount2,
  BankOrCreditUnion: BankOrCreditUnion2,
  BarOrPub: BarOrPub2,
  Barcode: Barcode2,
  Beach: Beach2,
  BeautySalon: BeautySalon2,
  BedAndBreakfast: BedAndBreakfast2,
  BedDetails: BedDetails2,
  BedType: BedType2,
  BefriendAction: BefriendAction2,
  BikeStore: BikeStore2,
  BioChemEntity: BioChemEntity2,
  Blog: Blog2,
  BlogPosting: BlogPosting2,
  BloodTest: BloodTest2,
  BoardingPolicyType: BoardingPolicyType2,
  BoatReservation: BoatReservation2,
  BoatTerminal: BoatTerminal2,
  BoatTrip: BoatTrip2,
  BodyMeasurementTypeEnumeration: BodyMeasurementTypeEnumeration2,
  BodyOfWater: BodyOfWater2,
  Bone: Bone2,
  Book: Book2,
  BookFormatType: BookFormatType2,
  BookSeries: BookSeries2,
  BookStore: BookStore2,
  BookmarkAction: BookmarkAction2,
  Boolean__workaround: Boolean__workaround2,
  BorrowAction: BorrowAction2,
  BowlingAlley: BowlingAlley2,
  BrainStructure: BrainStructure2,
  Brand: Brand2,
  BreadcrumbList: BreadcrumbList2,
  Brewery: Brewery2,
  Bridge: Bridge2,
  BroadcastChannel: BroadcastChannel2,
  BroadcastEvent: BroadcastEvent2,
  BroadcastFrequencySpecification: BroadcastFrequencySpecification2,
  BroadcastService: BroadcastService2,
  BrokerageAccount: BrokerageAccount2,
  BuddhistTemple: BuddhistTemple2,
  BusOrCoach: BusOrCoach2,
  BusReservation: BusReservation2,
  BusStation: BusStation2,
  BusStop: BusStop2,
  BusTrip: BusTrip2,
  BusinessAudience: BusinessAudience2,
  BusinessEntityType: BusinessEntityType2,
  BusinessEvent: BusinessEvent2,
  BusinessFunction: BusinessFunction2,
  BuyAction: BuyAction2,
  CDCPMDRecord: CDCPMDRecord2,
  CableOrSatelliteService: CableOrSatelliteService2,
  CafeOrCoffeeShop: CafeOrCoffeeShop2,
  Campground: Campground2,
  CampingPitch: CampingPitch2,
  Canal: Canal2,
  CancelAction: CancelAction2,
  Car: Car2,
  CarUsageType: CarUsageType2,
  Casino: Casino2,
  CategoryCode: CategoryCode2,
  CategoryCodeSet: CategoryCodeSet2,
  CatholicChurch: CatholicChurch2,
  Cemetery: Cemetery2,
  Certification: Certification2,
  CertificationStatusEnumeration: CertificationStatusEnumeration2,
  Chapter: Chapter2,
  CheckAction: CheckAction2,
  CheckInAction: CheckInAction2,
  CheckOutAction: CheckOutAction2,
  CheckoutPage: CheckoutPage2,
  ChemicalSubstance: ChemicalSubstance2,
  ChildCare: ChildCare2,
  ChildrensEvent: ChildrensEvent2,
  ChooseAction: ChooseAction2,
  Church: Church2,
  City: City2,
  CityHall: CityHall2,
  CivicStructure: CivicStructure2,
  Claim: Claim3,
  ClaimReview: ClaimReview2,
  Class: Class6,
  Clip: Clip2,
  ClothingStore: ClothingStore2,
  Code: Code2,
  Collection: Collection6,
  CollectionPage: CollectionPage3,
  CollegeOrUniversity: CollegeOrUniversity2,
  ComedyClub: ComedyClub2,
  ComedyEvent: ComedyEvent2,
  ComicCoverArt: ComicCoverArt2,
  ComicIssue: ComicIssue2,
  ComicSeries: ComicSeries2,
  ComicStory: ComicStory2,
  Comment: Comment2,
  CommentAction: CommentAction2,
  CommunicateAction: CommunicateAction2,
  CompleteDataFeed: CompleteDataFeed2,
  CompoundPriceSpecification: CompoundPriceSpecification2,
  ComputerLanguage: ComputerLanguage2,
  ComputerStore: ComputerStore2,
  ConferenceEvent: ConferenceEvent2,
  ConfirmAction: ConfirmAction2,
  Consortium: Consortium2,
  ConstraintNode: ConstraintNode2,
  ConsumeAction: ConsumeAction2,
  ContactPage: ContactPage2,
  ContactPoint: ContactPoint3,
  ContactPointOption: ContactPointOption2,
  Continent: Continent2,
  ControlAction: ControlAction2,
  ConvenienceStore: ConvenienceStore2,
  Conversation: Conversation2,
  CookAction: CookAction2,
  Cooperative: Cooperative2,
  Corporation: Corporation2,
  CorrectionComment: CorrectionComment2,
  Country: Country2,
  Course: Course2,
  CourseInstance: CourseInstance2,
  Courthouse: Courthouse2,
  CoverArt: CoverArt2,
  CovidTestingFacility: CovidTestingFacility2,
  CreateAction: CreateAction2,
  CreativeWork: CreativeWork2,
  CreativeWorkSeason: CreativeWorkSeason2,
  CreativeWorkSeries: CreativeWorkSeries2,
  Credential: Credential2,
  CreditCard: CreditCard2,
  Crematorium: Crematorium2,
  CriticReview: CriticReview2,
  CssSelectorType: CssSelectorType2,
  CurrencyConversionService: CurrencyConversionService2,
  DDxElement: DDxElement2,
  DENonprofitType: DENonprofitType2,
  DanceEvent: DanceEvent2,
  DanceGroup: DanceGroup2,
  DataCatalog: DataCatalog2,
  DataDownload: DataDownload2,
  DataFeed: DataFeed2,
  DataFeedItem: DataFeedItem2,
  DataType: DataType3,
  Dataset: Dataset2,
  Date__workaround: Date__workaround2,
  DateTime: DateTime2,
  DatedMoneySpecification: DatedMoneySpecification2,
  DayOfWeek: DayOfWeek2,
  DaySpa: DaySpa2,
  DeactivateAction: DeactivateAction2,
  DefenceEstablishment: DefenceEstablishment2,
  DefinedRegion: DefinedRegion2,
  DefinedTerm: DefinedTerm2,
  DefinedTermSet: DefinedTermSet2,
  DeleteAction: DeleteAction2,
  DeliveryChargeSpecification: DeliveryChargeSpecification2,
  DeliveryEvent: DeliveryEvent2,
  DeliveryMethod: DeliveryMethod2,
  DeliveryTimeSettings: DeliveryTimeSettings2,
  Demand: Demand2,
  Dentist: Dentist2,
  DepartAction: DepartAction2,
  DepartmentStore: DepartmentStore2,
  DepositAccount: DepositAccount2,
  DiagnosticLab: DiagnosticLab2,
  DiagnosticProcedure: DiagnosticProcedure2,
  Diet: Diet2,
  DietarySupplement: DietarySupplement2,
  DigitalDocument: DigitalDocument2,
  DigitalDocumentPermission: DigitalDocumentPermission2,
  DigitalDocumentPermissionType: DigitalDocumentPermissionType2,
  DigitalPlatformEnumeration: DigitalPlatformEnumeration2,
  DisagreeAction: DisagreeAction2,
  DiscoverAction: DiscoverAction2,
  DiscussionForumPosting: DiscussionForumPosting2,
  DislikeAction: DislikeAction2,
  Distance: Distance3,
  Distillery: Distillery2,
  DonateAction: DonateAction2,
  DoseSchedule: DoseSchedule2,
  DownloadAction: DownloadAction2,
  DrawAction: DrawAction2,
  Drawing: Drawing2,
  DrinkAction: DrinkAction2,
  DriveWheelConfigurationValue: DriveWheelConfigurationValue2,
  Drug: Drug2,
  DrugClass: DrugClass2,
  DrugCost: DrugCost2,
  DrugCostCategory: DrugCostCategory2,
  DrugLegalStatus: DrugLegalStatus2,
  DrugPregnancyCategory: DrugPregnancyCategory2,
  DrugPrescriptionStatus: DrugPrescriptionStatus2,
  DrugStrength: DrugStrength2,
  DryCleaningOrLaundry: DryCleaningOrLaundry2,
  Duration: Duration3,
  EUEnergyEfficiencyEnumeration: EUEnergyEfficiencyEnumeration2,
  EatAction: EatAction2,
  EducationEvent: EducationEvent2,
  EducationalAudience: EducationalAudience2,
  EducationalOccupationalCredential: EducationalOccupationalCredential2,
  EducationalOccupationalProgram: EducationalOccupationalProgram2,
  EducationalOrganization: EducationalOrganization2,
  Electrician: Electrician2,
  ElectronicsStore: ElectronicsStore2,
  ElementarySchool: ElementarySchool2,
  EmailMessage: EmailMessage2,
  Embassy: Embassy2,
  EmergencyService: EmergencyService2,
  EmployeeRole: EmployeeRole2,
  EmployerAggregateRating: EmployerAggregateRating2,
  EmployerReview: EmployerReview2,
  EmploymentAgency: EmploymentAgency2,
  EndorseAction: EndorseAction2,
  EndorsementRating: EndorsementRating2,
  Energy: Energy2,
  EnergyConsumptionDetails: EnergyConsumptionDetails2,
  EnergyEfficiencyEnumeration: EnergyEfficiencyEnumeration2,
  EnergyStarEnergyEfficiencyEnumeration: EnergyStarEnergyEfficiencyEnumeration2,
  EngineSpecification: EngineSpecification2,
  EntertainmentBusiness: EntertainmentBusiness2,
  EntryPoint: EntryPoint2,
  Enumeration: Enumeration2,
  Episode: Episode2,
  Error__workaround: Error__workaround4,
  Event: Event3,
  EventAttendanceModeEnumeration: EventAttendanceModeEnumeration2,
  EventReservation: EventReservation2,
  EventSeries: EventSeries2,
  EventStatusType: EventStatusType2,
  EventVenue: EventVenue2,
  ExchangeRateSpecification: ExchangeRateSpecification2,
  ExerciseAction: ExerciseAction2,
  ExerciseGym: ExerciseGym2,
  ExercisePlan: ExercisePlan2,
  ExhibitionEvent: ExhibitionEvent2,
  FAQPage: FAQPage2,
  FMRadioChannel: FMRadioChannel2,
  FastFoodRestaurant: FastFoodRestaurant2,
  Festival: Festival2,
  FilmAction: FilmAction2,
  FinancialIncentive: FinancialIncentive2,
  FinancialProduct: FinancialProduct2,
  FinancialService: FinancialService2,
  FindAction: FindAction2,
  FireStation: FireStation2,
  Flight: Flight2,
  FlightReservation: FlightReservation2,
  Float: Float2,
  FloorPlan: FloorPlan2,
  Florist: Florist2,
  FollowAction: FollowAction2,
  FoodEstablishment: FoodEstablishment2,
  FoodEstablishmentReservation: FoodEstablishmentReservation2,
  FoodEvent: FoodEvent2,
  FoodService: FoodService2,
  FulfillmentTypeEnumeration: FulfillmentTypeEnumeration2,
  FundingAgency: FundingAgency2,
  FundingScheme: FundingScheme2,
  FurnitureStore: FurnitureStore2,
  Game: Game2,
  GameAvailabilityEnumeration: GameAvailabilityEnumeration2,
  GamePlayMode: GamePlayMode2,
  GameServer: GameServer2,
  GameServerStatus: GameServerStatus2,
  GardenStore: GardenStore2,
  GasStation: GasStation2,
  GatedResidenceCommunity: GatedResidenceCommunity2,
  GenderType: GenderType2,
  Gene: Gene2,
  GeneralContractor: GeneralContractor2,
  GeoCircle: GeoCircle2,
  GeoCoordinates: GeoCoordinates2,
  GeoShape: GeoShape2,
  GeospatialGeometry: GeospatialGeometry2,
  GiveAction: GiveAction2,
  GolfCourse: GolfCourse2,
  GovernmentBenefitsType: GovernmentBenefitsType2,
  GovernmentBuilding: GovernmentBuilding2,
  GovernmentOffice: GovernmentOffice2,
  GovernmentOrganization: GovernmentOrganization2,
  GovernmentPermit: GovernmentPermit2,
  GovernmentService: GovernmentService2,
  Grant: Grant2,
  GroceryStore: GroceryStore2,
  Guide: Guide2,
  HVACBusiness: HVACBusiness2,
  Hackathon: Hackathon2,
  HairSalon: HairSalon2,
  HardwareStore: HardwareStore2,
  HealthAndBeautyBusiness: HealthAndBeautyBusiness2,
  HealthAspectEnumeration: HealthAspectEnumeration2,
  HealthClub: HealthClub2,
  HealthInsurancePlan: HealthInsurancePlan2,
  HealthPlanCostSharingSpecification: HealthPlanCostSharingSpecification2,
  HealthPlanFormulary: HealthPlanFormulary2,
  HealthPlanNetwork: HealthPlanNetwork2,
  HealthTopicContent: HealthTopicContent2,
  HighSchool: HighSchool2,
  HinduTemple: HinduTemple2,
  HobbyShop: HobbyShop2,
  HomeAndConstructionBusiness: HomeAndConstructionBusiness2,
  HomeGoodsStore: HomeGoodsStore2,
  Hospital: Hospital2,
  Hostel: Hostel2,
  Hotel: Hotel2,
  HotelRoom: HotelRoom2,
  House: House2,
  HousePainter: HousePainter2,
  HowTo: HowTo2,
  HowToDirection: HowToDirection2,
  HowToItem: HowToItem2,
  HowToSection: HowToSection2,
  HowToStep: HowToStep2,
  HowToSupply: HowToSupply2,
  HowToTip: HowToTip2,
  HowToTool: HowToTool2,
  HyperToc: HyperToc2,
  HyperTocEntry: HyperTocEntry2,
  IPTCDigitalSourceEnumeration: IPTCDigitalSourceEnumeration2,
  ITNonprofitType: ITNonprofitType2,
  IceCreamShop: IceCreamShop2,
  IgnoreAction: IgnoreAction2,
  ImageGallery: ImageGallery2,
  ImageObject: ImageObject2,
  ImageObjectSnapshot: ImageObjectSnapshot2,
  ImagingTest: ImagingTest2,
  IncentiveQualifiedExpenseType: IncentiveQualifiedExpenseType2,
  IncentiveStatus: IncentiveStatus2,
  IncentiveType: IncentiveType2,
  IndividualPhysician: IndividualPhysician2,
  IndividualProduct: IndividualProduct2,
  InfectiousAgentClass: InfectiousAgentClass2,
  InfectiousDisease: InfectiousDisease2,
  InformAction: InformAction2,
  InsertAction: InsertAction2,
  InstallAction: InstallAction2,
  InstantaneousEvent: InstantaneousEvent3,
  InsuranceAgency: InsuranceAgency2,
  Intangible: Intangible2,
  Integer: Integer2,
  InteractAction: InteractAction2,
  InteractionCounter: InteractionCounter2,
  InternetCafe: InternetCafe2,
  InvestmentFund: InvestmentFund2,
  InvestmentOrDeposit: InvestmentOrDeposit2,
  InviteAction: InviteAction2,
  Invoice: Invoice3,
  ItemAvailability: ItemAvailability2,
  ItemList: ItemList2,
  ItemListOrderType: ItemListOrderType2,
  ItemPage: ItemPage2,
  JewelryStore: JewelryStore2,
  JobPosting: JobPosting2,
  JoinAction: JoinAction2,
  Joint: Joint2,
  LakeBodyOfWater: LakeBodyOfWater2,
  Landform: Landform2,
  LandmarksOrHistoricalBuildings: LandmarksOrHistoricalBuildings2,
  Language: Language2,
  LearningResource: LearningResource2,
  LeaveAction: LeaveAction2,
  LegalForceStatus: LegalForceStatus2,
  LegalService: LegalService2,
  LegalValueLevel: LegalValueLevel2,
  Legislation: Legislation2,
  LegislationObject: LegislationObject2,
  LegislativeBuilding: LegislativeBuilding2,
  LendAction: LendAction2,
  Library: Library3,
  LibrarySystem: LibrarySystem2,
  LifestyleModification: LifestyleModification2,
  Ligament: Ligament2,
  LikeAction: LikeAction2,
  LinkRole: LinkRole2,
  LiquorStore: LiquorStore2,
  ListItem: ListItem2,
  ListenAction: ListenAction2,
  LiteraryEvent: LiteraryEvent2,
  LiveBlogPosting: LiveBlogPosting2,
  LoanOrCredit: LoanOrCredit2,
  LocalBusiness: LocalBusiness2,
  LocationFeatureSpecification: LocationFeatureSpecification2,
  Locksmith: Locksmith2,
  LodgingBusiness: LodgingBusiness2,
  LodgingReservation: LodgingReservation2,
  LoginAction: LoginAction2,
  LoseAction: LoseAction2,
  LymphaticVessel: LymphaticVessel2,
  Manuscript: Manuscript2,
  Map__workaround: Map__workaround2,
  MapCategoryType: MapCategoryType2,
  MarryAction: MarryAction2,
  Mass: Mass2,
  MathSolver: MathSolver2,
  MaximumDoseSchedule: MaximumDoseSchedule2,
  MeasurementMethodEnum: MeasurementMethodEnum2,
  MeasurementTypeEnumeration: MeasurementTypeEnumeration2,
  MediaEnumeration: MediaEnumeration2,
  MediaGallery: MediaGallery2,
  MediaManipulationRatingEnumeration: MediaManipulationRatingEnumeration2,
  MediaObject: MediaObject2,
  MediaReview: MediaReview2,
  MediaReviewItem: MediaReviewItem2,
  MediaSubscription: MediaSubscription2,
  MedicalAudience: MedicalAudience2,
  MedicalAudienceType: MedicalAudienceType2,
  MedicalBusiness: MedicalBusiness2,
  MedicalCause: MedicalCause2,
  MedicalClinic: MedicalClinic2,
  MedicalCode: MedicalCode2,
  MedicalCondition: MedicalCondition2,
  MedicalConditionStage: MedicalConditionStage2,
  MedicalContraindication: MedicalContraindication2,
  MedicalDevice: MedicalDevice2,
  MedicalDevicePurpose: MedicalDevicePurpose2,
  MedicalEntity: MedicalEntity2,
  MedicalEnumeration: MedicalEnumeration2,
  MedicalEvidenceLevel: MedicalEvidenceLevel2,
  MedicalGuideline: MedicalGuideline2,
  MedicalGuidelineContraindication: MedicalGuidelineContraindication2,
  MedicalGuidelineRecommendation: MedicalGuidelineRecommendation2,
  MedicalImagingTechnique: MedicalImagingTechnique2,
  MedicalIndication: MedicalIndication2,
  MedicalIntangible: MedicalIntangible2,
  MedicalObservationalStudy: MedicalObservationalStudy2,
  MedicalObservationalStudyDesign: MedicalObservationalStudyDesign2,
  MedicalOrganization: MedicalOrganization2,
  MedicalProcedure: MedicalProcedure2,
  MedicalProcedureType: MedicalProcedureType2,
  MedicalRiskCalculator: MedicalRiskCalculator2,
  MedicalRiskEstimator: MedicalRiskEstimator2,
  MedicalRiskFactor: MedicalRiskFactor2,
  MedicalRiskScore: MedicalRiskScore2,
  MedicalScholarlyArticle: MedicalScholarlyArticle2,
  MedicalSign: MedicalSign2,
  MedicalSignOrSymptom: MedicalSignOrSymptom2,
  MedicalSpecialty: MedicalSpecialty2,
  MedicalStudy: MedicalStudy2,
  MedicalStudyStatus: MedicalStudyStatus2,
  MedicalSymptom: MedicalSymptom2,
  MedicalTest: MedicalTest2,
  MedicalTestPanel: MedicalTestPanel2,
  MedicalTherapy: MedicalTherapy2,
  MedicalTrial: MedicalTrial2,
  MedicalTrialDesign: MedicalTrialDesign2,
  MedicalWebPage: MedicalWebPage2,
  MedicineSystem: MedicineSystem2,
  MeetingRoom: MeetingRoom2,
  MemberProgram: MemberProgram2,
  MemberProgramTier: MemberProgramTier2,
  MensClothingStore: MensClothingStore2,
  Menu: Menu2,
  MenuItem: MenuItem2,
  MenuSection: MenuSection2,
  MerchantReturnEnumeration: MerchantReturnEnumeration2,
  MerchantReturnPolicy: MerchantReturnPolicy2,
  MerchantReturnPolicySeasonalOverride: MerchantReturnPolicySeasonalOverride2,
  Message: Message3,
  MiddleSchool: MiddleSchool2,
  MobileApplication: MobileApplication2,
  MobilePhoneStore: MobilePhoneStore2,
  MolecularEntity: MolecularEntity2,
  MonetaryAmount: MonetaryAmount2,
  MonetaryAmountDistribution: MonetaryAmountDistribution2,
  MonetaryGrant: MonetaryGrant2,
  MoneyTransfer: MoneyTransfer2,
  MortgageLoan: MortgageLoan2,
  Mosque: Mosque2,
  Motel: Motel2,
  Motorcycle: Motorcycle2,
  MotorcycleDealer: MotorcycleDealer2,
  MotorcycleRepair: MotorcycleRepair2,
  MotorizedBicycle: MotorizedBicycle2,
  Mountain: Mountain2,
  MoveAction: MoveAction2,
  Movie: Movie2,
  MovieClip: MovieClip2,
  MovieRentalStore: MovieRentalStore2,
  MovieSeries: MovieSeries2,
  MovieTheater: MovieTheater2,
  MovingCompany: MovingCompany2,
  Muscle: Muscle2,
  Museum: Museum2,
  MusicAlbum: MusicAlbum2,
  MusicAlbumProductionType: MusicAlbumProductionType2,
  MusicAlbumReleaseType: MusicAlbumReleaseType2,
  MusicComposition: MusicComposition2,
  MusicEvent: MusicEvent2,
  MusicGroup: MusicGroup2,
  MusicPlaylist: MusicPlaylist2,
  MusicRecording: MusicRecording2,
  MusicRelease: MusicRelease2,
  MusicReleaseFormatType: MusicReleaseFormatType2,
  MusicStore: MusicStore2,
  MusicVenue: MusicVenue2,
  MusicVideoObject: MusicVideoObject2,
  NGO: NGO2,
  NLNonprofitType: NLNonprofitType2,
  NailSalon: NailSalon2,
  Nerve: Nerve2,
  NewsArticle: NewsArticle2,
  NewsMediaOrganization: NewsMediaOrganization2,
  Newspaper: Newspaper2,
  NightClub: NightClub2,
  NonprofitType: NonprofitType2,
  Notary: Notary2,
  NoteDigitalDocument: NoteDigitalDocument2,
  Number__workaround: Number__workaround2,
  NutritionInformation: NutritionInformation2,
  Observation: Observation3,
  Occupation: Occupation2,
  OccupationalExperienceRequirements: OccupationalExperienceRequirements2,
  OccupationalTherapy: OccupationalTherapy2,
  OceanBodyOfWater: OceanBodyOfWater2,
  Offer: Offer3,
  OfferCatalog: OfferCatalog2,
  OfferForLease: OfferForLease2,
  OfferForPurchase: OfferForPurchase2,
  OfferItemCondition: OfferItemCondition2,
  OfferShippingDetails: OfferShippingDetails2,
  OfficeEquipmentStore: OfficeEquipmentStore2,
  OnDemandEvent: OnDemandEvent2,
  OnlineBusiness: OnlineBusiness2,
  OnlineMarketplace: OnlineMarketplace2,
  OnlineStore: OnlineStore2,
  OpeningHoursSpecification: OpeningHoursSpecification2,
  OperatingSystem: OperatingSystem2,
  OpinionNewsArticle: OpinionNewsArticle2,
  Optician: Optician2,
  Order: Order2,
  OrderAction: OrderAction2,
  OrderItem: OrderItem2,
  OrderStatus: OrderStatus2,
  Organization: Organization6,
  OrganizationRole: OrganizationRole2,
  OrganizeAction: OrganizeAction2,
  OutletStore: OutletStore2,
  OwnershipInfo: OwnershipInfo2,
  PaintAction: PaintAction2,
  Painting: Painting2,
  PalliativeProcedure: PalliativeProcedure2,
  ParcelDelivery: ParcelDelivery2,
  ParentAudience: ParentAudience2,
  Park: Park2,
  ParkingFacility: ParkingFacility2,
  PathologyTest: PathologyTest2,
  Patient: Patient3,
  PawnShop: PawnShop2,
  PayAction: PayAction2,
  PaymentCard: PaymentCard2,
  PaymentChargeSpecification: PaymentChargeSpecification2,
  PaymentMethod: PaymentMethod2,
  PaymentMethodType: PaymentMethodType2,
  PaymentService: PaymentService2,
  PaymentStatusType: PaymentStatusType2,
  PeopleAudience: PeopleAudience2,
  PerformAction: PerformAction2,
  PerformanceRole: PerformanceRole2,
  PerformingArtsEvent: PerformingArtsEvent2,
  PerformingArtsTheater: PerformingArtsTheater2,
  PerformingGroup: PerformingGroup2,
  Periodical: Periodical2,
  Permit: Permit2,
  Person: Person6,
  PetStore: PetStore2,
  Pharmacy: Pharmacy2,
  Photograph: Photograph2,
  PhotographAction: PhotographAction2,
  PhysicalActivity: PhysicalActivity2,
  PhysicalActivityCategory: PhysicalActivityCategory2,
  PhysicalExam: PhysicalExam2,
  PhysicalTherapy: PhysicalTherapy2,
  Physician: Physician2,
  PhysiciansOffice: PhysiciansOffice2,
  Place: Place3,
  PlaceOfWorship: PlaceOfWorship2,
  PlanAction: PlanAction2,
  Play: Play2,
  PlayAction: PlayAction2,
  PlayGameAction: PlayGameAction2,
  Playground: Playground2,
  Plumber: Plumber2,
  PodcastEpisode: PodcastEpisode2,
  PodcastSeason: PodcastSeason2,
  PodcastSeries: PodcastSeries2,
  PoliceStation: PoliceStation2,
  PoliticalParty: PoliticalParty2,
  Pond: Pond2,
  PostOffice: PostOffice2,
  PostalAddress: PostalAddress2,
  PostalCodeRangeSpecification: PostalCodeRangeSpecification2,
  Poster: Poster2,
  PreOrderAction: PreOrderAction2,
  PrependAction: PrependAction2,
  Preschool: Preschool2,
  PresentationDigitalDocument: PresentationDigitalDocument2,
  PreventionIndication: PreventionIndication2,
  PriceComponentTypeEnumeration: PriceComponentTypeEnumeration2,
  PriceSpecification: PriceSpecification2,
  PriceTypeEnumeration: PriceTypeEnumeration2,
  Product: Product2,
  ProductCollection: ProductCollection2,
  ProductGroup: ProductGroup2,
  ProductModel: ProductModel2,
  ProductReturnEnumeration: ProductReturnEnumeration2,
  ProductReturnPolicy: ProductReturnPolicy2,
  ProfessionalService: ProfessionalService2,
  ProfilePage: ProfilePage2,
  ProgramMembership: ProgramMembership2,
  Project: Project3,
  PronounceableText: PronounceableText2,
  Property: Property4,
  PropertyValue: PropertyValue2,
  PropertyValueSpecification: PropertyValueSpecification2,
  Protein: Protein2,
  PsychologicalTreatment: PsychologicalTreatment2,
  PublicSwimmingPool: PublicSwimmingPool2,
  PublicToilet: PublicToilet2,
  PublicationEvent: PublicationEvent2,
  PublicationIssue: PublicationIssue2,
  PublicationVolume: PublicationVolume2,
  PurchaseType: PurchaseType2,
  QAPage: QAPage2,
  QualitativeValue: QualitativeValue2,
  QuantitativeValue: QuantitativeValue2,
  QuantitativeValueDistribution: QuantitativeValueDistribution2,
  Quantity: Quantity3,
  Question: Question3,
  Quiz: Quiz2,
  Quotation: Quotation3,
  QuoteAction: QuoteAction2,
  RVPark: RVPark2,
  RadiationTherapy: RadiationTherapy2,
  RadioBroadcastService: RadioBroadcastService2,
  RadioChannel: RadioChannel2,
  RadioClip: RadioClip2,
  RadioEpisode: RadioEpisode2,
  RadioSeason: RadioSeason2,
  RadioSeries: RadioSeries2,
  RadioStation: RadioStation2,
  Rating: Rating2,
  ReactAction: ReactAction2,
  ReadAction: ReadAction2,
  RealEstateAgent: RealEstateAgent2,
  RealEstateListing: RealEstateListing2,
  ReceiveAction: ReceiveAction2,
  Recipe: Recipe2,
  Recommendation: Recommendation2,
  RecommendedDoseSchedule: RecommendedDoseSchedule2,
  RecyclingCenter: RecyclingCenter2,
  RefundTypeEnumeration: RefundTypeEnumeration2,
  RegisterAction: RegisterAction2,
  RejectAction: RejectAction2,
  RentAction: RentAction2,
  RentalCarReservation: RentalCarReservation2,
  RepaymentSpecification: RepaymentSpecification2,
  ReplaceAction: ReplaceAction2,
  ReplyAction: ReplyAction2,
  Report: Report2,
  ReportageNewsArticle: ReportageNewsArticle2,
  ReportedDoseSchedule: ReportedDoseSchedule2,
  ResearchOrganization: ResearchOrganization2,
  ResearchProject: ResearchProject2,
  Researcher: Researcher2,
  Reservation: Reservation2,
  ReservationPackage: ReservationPackage2,
  ReservationStatusType: ReservationStatusType2,
  ReserveAction: ReserveAction2,
  Reservoir: Reservoir2,
  ResetPasswordAction: ResetPasswordAction2,
  Residence: Residence2,
  Resort: Resort2,
  Restaurant: Restaurant2,
  RestrictedDiet: RestrictedDiet2,
  ResumeAction: ResumeAction2,
  ReturnAction: ReturnAction2,
  ReturnFeesEnumeration: ReturnFeesEnumeration2,
  ReturnLabelSourceEnumeration: ReturnLabelSourceEnumeration2,
  ReturnMethodEnumeration: ReturnMethodEnumeration2,
  Review: Review2,
  ReviewAction: ReviewAction2,
  ReviewNewsArticle: ReviewNewsArticle2,
  RiverBodyOfWater: RiverBodyOfWater2,
  Role: Role3,
  RoofingContractor: RoofingContractor2,
  Room: Room2,
  RsvpAction: RsvpAction2,
  RsvpResponseType: RsvpResponseType2,
  RuntimePlatform: RuntimePlatform2,
  SaleEvent: SaleEvent2,
  SatiricalArticle: SatiricalArticle2,
  Schedule: Schedule3,
  ScheduleAction: ScheduleAction2,
  ScholarlyArticle: ScholarlyArticle2,
  School: School2,
  SchoolDistrict: SchoolDistrict2,
  ScreeningEvent: ScreeningEvent2,
  Sculpture: Sculpture2,
  SeaBodyOfWater: SeaBodyOfWater2,
  SearchAction: SearchAction2,
  SearchRescueOrganization: SearchRescueOrganization2,
  SearchResultsPage: SearchResultsPage2,
  Season: Season2,
  Seat: Seat2,
  SeekToAction: SeekToAction2,
  SelfStorage: SelfStorage2,
  SellAction: SellAction2,
  SendAction: SendAction2,
  SequentialArt: SequentialArt2,
  Series: Series2,
  Service: Service3,
  ServiceChannel: ServiceChannel2,
  ServicePeriod: ServicePeriod2,
  ShareAction: ShareAction2,
  SheetMusic: SheetMusic2,
  ShippingConditions: ShippingConditions2,
  ShippingDeliveryTime: ShippingDeliveryTime2,
  ShippingRateSettings: ShippingRateSettings2,
  ShippingService: ShippingService2,
  ShoeStore: ShoeStore2,
  ShoppingCenter: ShoppingCenter2,
  ShortStory: ShortStory2,
  SingleFamilyResidence: SingleFamilyResidence2,
  SiteNavigationElement: SiteNavigationElement2,
  SizeGroupEnumeration: SizeGroupEnumeration2,
  SizeSpecification: SizeSpecification2,
  SizeSystemEnumeration: SizeSystemEnumeration2,
  SkiResort: SkiResort2,
  SocialEvent: SocialEvent2,
  SocialMediaPosting: SocialMediaPosting2,
  SoftwareApplication: SoftwareApplication2,
  SoftwareSourceCode: SoftwareSourceCode2,
  SolveMathAction: SolveMathAction2,
  SomeProducts: SomeProducts2,
  SpeakableSpecification: SpeakableSpecification2,
  SpecialAnnouncement: SpecialAnnouncement2,
  Specialty: Specialty2,
  SportingGoodsStore: SportingGoodsStore2,
  SportsActivityLocation: SportsActivityLocation2,
  SportsClub: SportsClub2,
  SportsEvent: SportsEvent2,
  SportsOrganization: SportsOrganization2,
  SportsTeam: SportsTeam2,
  SpreadsheetDigitalDocument: SpreadsheetDigitalDocument2,
  StadiumOrArena: StadiumOrArena2,
  State: State2,
  Statement: Statement5,
  StatisticalPopulation: StatisticalPopulation2,
  StatisticalVariable: StatisticalVariable2,
  StatusEnumeration: StatusEnumeration2,
  SteeringPositionValue: SteeringPositionValue2,
  Store: Store3,
  StructuredValue: StructuredValue2,
  StupidType: StupidType2,
  SubscribeAction: SubscribeAction2,
  Substance: Substance3,
  SubwayStation: SubwayStation2,
  Suite: Suite2,
  SuperficialAnatomy: SuperficialAnatomy2,
  SurgicalProcedure: SurgicalProcedure2,
  SuspendAction: SuspendAction2,
  Syllabus: Syllabus2,
  Synagogue: Synagogue2,
  TVClip: TVClip2,
  TVEpisode: TVEpisode2,
  TVSeason: TVSeason2,
  TVSeries: TVSeries2,
  Table: Table2,
  TakeAction: TakeAction2,
  TattooParlor: TattooParlor2,
  Taxi: Taxi2,
  TaxiReservation: TaxiReservation2,
  TaxiService: TaxiService2,
  TaxiStand: TaxiStand2,
  Taxon: Taxon2,
  TechArticle: TechArticle2,
  TelevisionChannel: TelevisionChannel2,
  TelevisionStation: TelevisionStation2,
  TennisComplex: TennisComplex2,
  Text: Text2,
  TextDigitalDocument: TextDigitalDocument2,
  TextObject: TextObject2,
  TheaterEvent: TheaterEvent2,
  TheaterGroup: TheaterGroup2,
  TherapeuticProcedure: TherapeuticProcedure2,
  Thesis: Thesis2,
  Thing: Thing4,
  Ticket: Ticket2,
  TieAction: TieAction2,
  TierBenefitEnumeration: TierBenefitEnumeration2,
  Time: Time2,
  TipAction: TipAction2,
  TireShop: TireShop2,
  TouristAttraction: TouristAttraction2,
  TouristDestination: TouristDestination2,
  TouristInformationCenter: TouristInformationCenter2,
  TouristTrip: TouristTrip2,
  ToyStore: ToyStore2,
  TrackAction: TrackAction2,
  TradeAction: TradeAction2,
  TrainReservation: TrainReservation2,
  TrainStation: TrainStation2,
  TrainTrip: TrainTrip2,
  TransferAction: TransferAction2,
  TravelAction: TravelAction2,
  TravelAgency: TravelAgency2,
  TreatmentIndication: TreatmentIndication2,
  Trip: Trip2,
  TypeAndQuantityNode: TypeAndQuantityNode2,
  UKNonprofitType: UKNonprofitType2,
  URL: URL3,
  USNonprofitType: USNonprofitType2,
  UnRegisterAction: UnRegisterAction2,
  UnitPriceSpecification: UnitPriceSpecification2,
  UpdateAction: UpdateAction2,
  UseAction: UseAction2,
  UserBlocks: UserBlocks2,
  UserCheckins: UserCheckins2,
  UserComments: UserComments2,
  UserDownloads: UserDownloads2,
  UserInteraction: UserInteraction2,
  UserLikes: UserLikes2,
  UserPageVisits: UserPageVisits2,
  UserPlays: UserPlays2,
  UserPlusOnes: UserPlusOnes2,
  UserReview: UserReview2,
  UserTweets: UserTweets2,
  VacationRental: VacationRental2,
  Vehicle: Vehicle2,
  Vein: Vein2,
  Vessel: Vessel2,
  VeterinaryCare: VeterinaryCare2,
  VideoGallery: VideoGallery2,
  VideoGame: VideoGame2,
  VideoGameClip: VideoGameClip2,
  VideoGameSeries: VideoGameSeries2,
  VideoObject: VideoObject2,
  VideoObjectSnapshot: VideoObjectSnapshot2,
  ViewAction: ViewAction2,
  VirtualLocation: VirtualLocation2,
  VisualArtsEvent: VisualArtsEvent2,
  VisualArtwork: VisualArtwork2,
  VitalSign: VitalSign2,
  Volcano: Volcano2,
  VoteAction: VoteAction2,
  WPAdBlock: WPAdBlock2,
  WPFooter: WPFooter2,
  WPHeader: WPHeader2,
  WPSideBar: WPSideBar2,
  WantAction: WantAction2,
  WarrantyPromise: WarrantyPromise2,
  WarrantyScope: WarrantyScope2,
  WatchAction: WatchAction2,
  Waterfall: Waterfall2,
  WearAction: WearAction2,
  WearableMeasurementTypeEnumeration: WearableMeasurementTypeEnumeration2,
  WearableSizeGroupEnumeration: WearableSizeGroupEnumeration2,
  WearableSizeSystemEnumeration: WearableSizeSystemEnumeration2,
  WebAPI: WebAPI2,
  WebApplication: WebApplication2,
  WebContent: WebContent2,
  WebPage: WebPage2,
  WebPageElement: WebPageElement2,
  WebSite: WebSite2,
  WholesaleStore: WholesaleStore2,
  WinAction: WinAction2,
  Winery: Winery2,
  WorkBasedProgram: WorkBasedProgram2,
  WorkersUnion: WorkersUnion2,
  WriteAction: WriteAction2,
  XPathType: XPathType2,
  Zoo: Zoo2,
  abridged: abridged2,
  abstract: abstract4,
  accelerationTime: accelerationTime2,
  acceptedAnswer: acceptedAnswer2,
  acceptedOffer: acceptedOffer2,
  acceptedPaymentMethod: acceptedPaymentMethod2,
  acceptsReservations: acceptsReservations2,
  accessCode: accessCode2,
  accessMode: accessMode2,
  accessModeSufficient: accessModeSufficient2,
  accessibilityAPI: accessibilityAPI2,
  accessibilityControl: accessibilityControl2,
  accessibilityFeature: accessibilityFeature2,
  accessibilityHazard: accessibilityHazard2,
  accessibilitySummary: accessibilitySummary2,
  accommodationCategory: accommodationCategory2,
  accommodationFloorPlan: accommodationFloorPlan2,
  accountId: accountId2,
  accountMinimumInflow: accountMinimumInflow2,
  accountOverdraftLimit: accountOverdraftLimit2,
  accountablePerson: accountablePerson2,
  acquireLicensePage: acquireLicensePage2,
  acquiredFrom: acquiredFrom2,
  acrissCode: acrissCode2,
  actionAccessibilityRequirement: actionAccessibilityRequirement2,
  actionPlatform: actionPlatform2,
  actionProcess: actionProcess2,
  actionStatus: actionStatus2,
  actionableFeedbackPolicy: actionableFeedbackPolicy2,
  activeIngredient: activeIngredient2,
  activityDuration: activityDuration2,
  activityFrequency: activityFrequency2,
  actors: actors2,
  addOn: addOn2,
  additionalName: additionalName2,
  additionalNumberOfGuests: additionalNumberOfGuests2,
  additionalProperty: additionalProperty2,
  additionalType: additionalType2,
  additionalVariable: additionalVariable2,
  address: address4,
  addressCountry: addressCountry2,
  addressLocality: addressLocality2,
  addressRegion: addressRegion2,
  administrationRoute: administrationRoute2,
  advanceBookingRequirement: advanceBookingRequirement2,
  adverseOutcome: adverseOutcome2,
  affectedBy: affectedBy2,
  affiliation: affiliation3,
  afterMedia: afterMedia2,
  agent: agent5,
  agentInteractionStatistic: agentInteractionStatistic2,
  aggregateElement: aggregateElement2,
  aggregateRating: aggregateRating2,
  aircraft: aircraft2,
  albumProductionType: albumProductionType2,
  albumReleaseType: albumReleaseType2,
  albums: albums2,
  alcoholWarning: alcoholWarning2,
  algorithm: algorithm2,
  alignmentType: alignmentType2,
  alternativeHeadline: alternativeHeadline2,
  alternativeOf: alternativeOf2,
  amenityFeature: amenityFeature2,
  amount: amount4,
  amountOfThisGood: amountOfThisGood2,
  announcementLocation: announcementLocation2,
  annualPercentageRate: annualPercentageRate2,
  answerCount: answerCount2,
  answerExplanation: answerExplanation2,
  antagonist: antagonist2,
  appearance: appearance2,
  applicableCountry: applicableCountry2,
  applicableLocation: applicableLocation2,
  applicantLocationRequirements: applicantLocationRequirements2,
  application: application3,
  applicationCategory: applicationCategory2,
  applicationContact: applicationContact2,
  applicationDeadline: applicationDeadline2,
  applicationStartDate: applicationStartDate2,
  applicationSubCategory: applicationSubCategory2,
  applicationSuite: applicationSuite2,
  appliesToDeliveryMethod: appliesToDeliveryMethod2,
  appliesToPaymentMethod: appliesToPaymentMethod2,
  archivedAt: archivedAt2,
  area: area2,
  arrivalAirport: arrivalAirport2,
  arrivalBoatTerminal: arrivalBoatTerminal2,
  arrivalBusStop: arrivalBusStop2,
  arrivalGate: arrivalGate2,
  arrivalPlatform: arrivalPlatform2,
  arrivalStation: arrivalStation2,
  arrivalTerminal: arrivalTerminal2,
  arrivalTime: arrivalTime2,
  artEdition: artEdition2,
  artMedium: artMedium2,
  artform: artform2,
  articleBody: articleBody2,
  articleSection: articleSection2,
  artist: artist2,
  asin: asin2,
  aspect: aspect2,
  assembly: assembly2,
  assemblyVersion: assemblyVersion2,
  assesses: assesses2,
  associatedAnatomy: associatedAnatomy2,
  associatedArticle: associatedArticle2,
  associatedClaimReview: associatedClaimReview2,
  associatedDisease: associatedDisease2,
  associatedMedia: associatedMedia2,
  associatedMediaReview: associatedMediaReview2,
  associatedPathophysiology: associatedPathophysiology2,
  athlete: athlete2,
  attendees: attendees2,
  audienceType: audienceType2,
  audio: audio2,
  auditDate: auditDate2,
  authenticator: authenticator2,
  author: author4,
  availability: availability3,
  availabilityEnds: availabilityEnds2,
  availabilityStarts: availabilityStarts2,
  availableAtOrFrom: availableAtOrFrom2,
  availableChannel: availableChannel2,
  availableDeliveryMethod: availableDeliveryMethod2,
  availableFrom: availableFrom2,
  availableIn: availableIn2,
  availableLanguage: availableLanguage2,
  availableService: availableService2,
  availableStrength: availableStrength2,
  availableTest: availableTest2,
  availableThrough: availableThrough2,
  awards: awards2,
  awayTeam: awayTeam2,
  backstory: backstory2,
  bankAccountType: bankAccountType2,
  baseSalary: baseSalary2,
  bccRecipient: bccRecipient2,
  bed: bed2,
  beforeMedia: beforeMedia2,
  beneficiaryBank: beneficiaryBank2,
  benefits: benefits2,
  benefitsSummaryUrl: benefitsSummaryUrl2,
  bestRating: bestRating2,
  billingAddress: billingAddress2,
  billingDuration: billingDuration2,
  billingIncrement: billingIncrement2,
  billingPeriod: billingPeriod2,
  billingStart: billingStart2,
  bioChemInteraction: bioChemInteraction2,
  bioChemSimilarity: bioChemSimilarity2,
  biologicalRole: biologicalRole2,
  biomechnicalClass: biomechnicalClass2,
  birthDate: birthDate3,
  birthPlace: birthPlace2,
  bitrate: bitrate2,
  blogPosts: blogPosts2,
  bloodSupply: bloodSupply2,
  boardingGroup: boardingGroup2,
  boardingPolicy: boardingPolicy2,
  bodyLocation: bodyLocation2,
  bodyType: bodyType2,
  bookEdition: bookEdition2,
  bookFormat: bookFormat2,
  bookingAgent: bookingAgent2,
  bookingTime: bookingTime2,
  borrower: borrower2,
  box: box2,
  branch: branch2,
  branchCode: branchCode2,
  branchOf: branchOf2,
  brand: brand3,
  breadcrumb: breadcrumb2,
  breastfeedingWarning: breastfeedingWarning2,
  broadcastAffiliateOf: broadcastAffiliateOf2,
  broadcastChannelId: broadcastChannelId2,
  broadcastDisplayName: broadcastDisplayName2,
  broadcastFrequency: broadcastFrequency2,
  broadcastFrequencyValue: broadcastFrequencyValue2,
  broadcastOfEvent: broadcastOfEvent2,
  broadcastServiceTier: broadcastServiceTier2,
  broadcastSignalModulation: broadcastSignalModulation2,
  broadcastSubChannel: broadcastSubChannel2,
  broadcastTimezone: broadcastTimezone2,
  broadcaster: broadcaster2,
  browserRequirements: browserRequirements2,
  busName: busName2,
  busNumber: busNumber2,
  businessDays: businessDays2,
  businessFunction: businessFunction2,
  buyer: buyer2,
  byArtist: byArtist2,
  byDay: byDay2,
  byMonth: byMonth2,
  byMonthDay: byMonthDay2,
  byMonthWeek: byMonthWeek2,
  callSign: callSign2,
  calories: calories2,
  candidate: candidate3,
  carbohydrateContent: carbohydrateContent2,
  cargoVolume: cargoVolume2,
  carrier: carrier2,
  carrierRequirements: carrierRequirements2,
  cashBack: cashBack2,
  catalog: catalog2,
  catalogNumber: catalogNumber2,
  ccRecipient: ccRecipient2,
  certificationIdentification: certificationIdentification2,
  certificationRating: certificationRating2,
  certificationStatus: certificationStatus2,
  character: character2,
  characterAttribute: characterAttribute2,
  characterName: characterName2,
  cheatCode: cheatCode2,
  checkinTime: checkinTime2,
  checkoutPageURLTemplate: checkoutPageURLTemplate2,
  checkoutTime: checkoutTime2,
  chemicalComposition: chemicalComposition2,
  chemicalRole: chemicalRole2,
  childMaxAge: childMaxAge2,
  childMinAge: childMinAge2,
  children: children2,
  cholesterolContent: cholesterolContent2,
  circle: circle2,
  citation: citation3,
  claimInterpreter: claimInterpreter2,
  claimReviewed: claimReviewed2,
  clincalPharmacology: clincalPharmacology2,
  clipNumber: clipNumber2,
  closes: closes2,
  coach: coach2,
  code: code3,
  codeRepository: codeRepository2,
  codeValue: codeValue2,
  codingSystem: codingSystem2,
  colleagues: colleagues2,
  collection: collection4,
  collectionSize: collectionSize2,
  color: color3,
  colorSwatch: colorSwatch2,
  colorist: colorist2,
  comment: comment5,
  commentCount: commentCount2,
  commentText: commentText2,
  commentTime: commentTime2,
  companyRegistration: companyRegistration2,
  competencyRequired: competencyRequired2,
  composer: composer2,
  comprisedOf: comprisedOf3,
  conditionsOfAccess: conditionsOfAccess2,
  confirmationNumber: confirmationNumber2,
  connectedTo: connectedTo2,
  constraintProperty: constraintProperty2,
  contactOption: contactOption2,
  contactPoints: contactPoints2,
  contactType: contactType2,
  contactlessPayment: contactlessPayment2,
  containedIn: containedIn2,
  contentRating: contentRating2,
  contentReferenceTime: contentReferenceTime2,
  contentSize: contentSize2,
  contentType: contentType3,
  contentUrl: contentUrl2,
  contraindication: contraindication3,
  contributor: contributor5,
  cookTime: cookTime2,
  cookingMethod: cookingMethod2,
  copyrightHolder: copyrightHolder2,
  copyrightNotice: copyrightNotice2,
  copyrightYear: copyrightYear2,
  correction: correction2,
  correctionsPolicy: correctionsPolicy2,
  costCategory: costCategory2,
  costCurrency: costCurrency2,
  costOrigin: costOrigin2,
  costPerUnit: costPerUnit2,
  countriesNotSupported: countriesNotSupported2,
  countriesSupported: countriesSupported2,
  countryOfAssembly: countryOfAssembly2,
  countryOfLastProcessing: countryOfLastProcessing2,
  countryOfOrigin: countryOfOrigin3,
  course: course2,
  courseCode: courseCode2,
  courseMode: courseMode2,
  coursePrerequisites: coursePrerequisites2,
  courseSchedule: courseSchedule2,
  courseWorkload: courseWorkload2,
  coverageEndTime: coverageEndTime2,
  coverageStartTime: coverageStartTime2,
  creativeWorkStatus: creativeWorkStatus2,
  credentialCategory: credentialCategory2,
  creditText: creditText2,
  creditedTo: creditedTo2,
  cssSelector: cssSelector2,
  currenciesAccepted: currenciesAccepted2,
  currency: currency3,
  currentExchangeRate: currentExchangeRate2,
  customer: customer2,
  customerRemorseReturnFees: customerRemorseReturnFees2,
  customerRemorseReturnLabelSource: customerRemorseReturnLabelSource2,
  customerRemorseReturnShippingFeesAmount: customerRemorseReturnShippingFeesAmount2,
  cutoffTime: cutoffTime2,
  cvdCollectionDate: cvdCollectionDate2,
  cvdFacilityCounty: cvdFacilityCounty2,
  cvdFacilityId: cvdFacilityId2,
  cvdNumBeds: cvdNumBeds2,
  cvdNumBedsOcc: cvdNumBedsOcc2,
  cvdNumC19Died: cvdNumC19Died2,
  cvdNumC19HOPats: cvdNumC19HOPats2,
  cvdNumC19HospPats: cvdNumC19HospPats2,
  cvdNumC19MechVentPats: cvdNumC19MechVentPats2,
  cvdNumC19OFMechVentPats: cvdNumC19OFMechVentPats2,
  cvdNumC19OverflowPats: cvdNumC19OverflowPats2,
  cvdNumICUBeds: cvdNumICUBeds2,
  cvdNumICUBedsOcc: cvdNumICUBedsOcc2,
  cvdNumTotBeds: cvdNumTotBeds2,
  cvdNumVent: cvdNumVent2,
  cvdNumVentUse: cvdNumVentUse2,
  data: data3,
  dataFeedElement: dataFeedElement2,
  datasetTimeInterval: datasetTimeInterval2,
  dateDeleted: dateDeleted2,
  dateIssued: dateIssued2,
  dateModified: dateModified2,
  datePosted: datePosted2,
  datePublished: datePublished2,
  dateRead: dateRead2,
  dateReceived: dateReceived2,
  dateSent: dateSent2,
  dateVehicleFirstRegistered: dateVehicleFirstRegistered2,
  dateline: dateline2,
  dayOfWeek: dayOfWeek3,
  deathDate: deathDate2,
  deathPlace: deathPlace2,
  defaultValue: defaultValue3,
  deliveryAddress: deliveryAddress2,
  deliveryLeadTime: deliveryLeadTime2,
  deliveryMethod: deliveryMethod2,
  deliveryStatus: deliveryStatus2,
  deliveryTime: deliveryTime2,
  department: department2,
  departureAirport: departureAirport2,
  departureBoatTerminal: departureBoatTerminal2,
  departureBusStop: departureBusStop2,
  departureGate: departureGate2,
  departurePlatform: departurePlatform2,
  departureStation: departureStation2,
  departureTerminal: departureTerminal2,
  departureTime: departureTime2,
  dependencies: dependencies2,
  depth: depth2,
  device: device3,
  diagnosis: diagnosis3,
  diagram: diagram2,
  diet: diet2,
  dietFeatures: dietFeatures2,
  differentialDiagnosis: differentialDiagnosis2,
  digitalSourceType: digitalSourceType2,
  directApply: directApply2,
  directors: directors2,
  disambiguatingDescription: disambiguatingDescription2,
  discount: discount2,
  discountCode: discountCode2,
  discountCurrency: discountCurrency2,
  discusses: discusses2,
  discussionUrl: discussionUrl2,
  diseasePreventionInfo: diseasePreventionInfo2,
  diseaseSpreadStatistics: diseaseSpreadStatistics2,
  displayLocation: displayLocation2,
  dissolutionDate: dissolutionDate2,
  distance: distance2,
  distinguishingSign: distinguishingSign2,
  distribution: distribution2,
  diversityPolicy: diversityPolicy2,
  diversityStaffingReport: diversityStaffingReport2,
  documentation: documentation3,
  doesNotShip: doesNotShip2,
  domainIncludes: domainIncludes2,
  domiciledMortgage: domiciledMortgage2,
  doorTime: doorTime2,
  dosageForm: dosageForm2,
  doseSchedule: doseSchedule2,
  doseUnit: doseUnit2,
  doseValue: doseValue2,
  downPayment: downPayment2,
  downloadUrl: downloadUrl2,
  downvoteCount: downvoteCount2,
  drainsTo: drainsTo2,
  driveWheelConfiguration: driveWheelConfiguration2,
  dropoffLocation: dropoffLocation2,
  dropoffTime: dropoffTime2,
  drug: drug2,
  drugClass: drugClass2,
  drugUnit: drugUnit2,
  duns: duns2,
  duplicateTherapy: duplicateTherapy2,
  durationOfWarranty: durationOfWarranty2,
  duringMedia: duringMedia2,
  earlyPrepaymentPenalty: earlyPrepaymentPenalty2,
  editEIDR: editEIDR2,
  editor: editor3,
  eduQuestionType: eduQuestionType2,
  educationRequirements: educationRequirements2,
  educationalAlignment: educationalAlignment2,
  educationalCredentialAwarded: educationalCredentialAwarded2,
  educationalFramework: educationalFramework2,
  educationalLevel: educationalLevel2,
  educationalProgramMode: educationalProgramMode2,
  educationalRole: educationalRole2,
  educationalUse: educationalUse2,
  elevation: elevation2,
  eligibilityToWorkRequirement: eligibilityToWorkRequirement2,
  eligibleCustomerType: eligibleCustomerType2,
  eligibleDuration: eligibleDuration2,
  eligibleQuantity: eligibleQuantity2,
  eligibleRegion: eligibleRegion2,
  eligibleTransactionVolume: eligibleTransactionVolume2,
  eligibleWithSupplier: eligibleWithSupplier2,
  email: email2,
  embedUrl: embedUrl2,
  embeddedTextCaption: embeddedTextCaption2,
  emissionsCO2: emissionsCO22,
  employees: employees2,
  employerOverview: employerOverview2,
  employmentType: employmentType2,
  employmentUnit: employmentUnit2,
  encodingType: encodingType2,
  encodings: encodings2,
  endOffset: endOffset2,
  endTime: endTime3,
  endorsee: endorsee2,
  endorsers: endorsers2,
  energyEfficiencyScaleMax: energyEfficiencyScaleMax2,
  energyEfficiencyScaleMin: energyEfficiencyScaleMin2,
  engineDisplacement: engineDisplacement2,
  enginePower: enginePower2,
  engineType: engineType2,
  entertainmentBusiness: entertainmentBusiness2,
  epidemiology: epidemiology2,
  episodeNumber: episodeNumber2,
  episodes: episodes2,
  equal: equal2,
  error: error3,
  errorCode: errorCode2,
  estimatedCost: estimatedCost2,
  estimatedFlightDuration: estimatedFlightDuration2,
  estimatedSalary: estimatedSalary2,
  estimatesRiskOf: estimatesRiskOf2,
  ethicsPolicy: ethicsPolicy2,
  eventAttendanceMode: eventAttendanceMode2,
  eventSchedule: eventSchedule2,
  eventStatus: eventStatus2,
  events: events2,
  evidenceLevel: evidenceLevel2,
  evidenceOrigin: evidenceOrigin2,
  exceptDate: exceptDate2,
  exchangeRateSpread: exchangeRateSpread2,
  exercisePlan: exercisePlan2,
  exerciseRelatedDiet: exerciseRelatedDiet2,
  exerciseType: exerciseType2,
  exifData: exifData2,
  expectedArrivalFrom: expectedArrivalFrom2,
  expectedArrivalUntil: expectedArrivalUntil2,
  expectedPrognosis: expectedPrognosis2,
  expectsAcceptanceOf: expectsAcceptanceOf2,
  experienceInPlaceOfEducation: experienceInPlaceOfEducation2,
  experienceRequirements: experienceRequirements2,
  expertConsiderations: expertConsiderations2,
  expires: expires2,
  expressedIn: expressedIn2,
  extendedAddress: extendedAddress2,
  familyName: familyName3,
  fatContent: fatContent2,
  faxNumber: faxNumber2,
  featureList: featureList2,
  feesAndCommissionsSpecification: feesAndCommissionsSpecification2,
  fiberContent: fiberContent2,
  fileFormat: fileFormat2,
  fileSize: fileSize2,
  financialAidEligible: financialAidEligible2,
  firstAppearance: firstAppearance2,
  firstPerformance: firstPerformance2,
  flightDistance: flightDistance2,
  flightNumber: flightNumber2,
  floorLevel: floorLevel2,
  floorLimit: floorLimit2,
  floorSize: floorSize2,
  followee: followee2,
  follows: follows2,
  followup: followup2,
  foodEstablishment: foodEstablishment2,
  foodEvent: foodEvent2,
  foodWarning: foodWarning2,
  founders: founders2,
  foundingDate: foundingDate2,
  foundingLocation: foundingLocation2,
  free: free2,
  freeShippingThreshold: freeShippingThreshold2,
  fromLocation: fromLocation2,
  fuelCapacity: fuelCapacity2,
  fuelConsumption: fuelConsumption2,
  fuelEfficiency: fuelEfficiency2,
  fuelType: fuelType2,
  fulfillmentType: fulfillmentType2,
  functionalClass: functionalClass2,
  funder: funder2,
  gameAvailabilityType: gameAvailabilityType2,
  gameEdition: gameEdition2,
  gameItem: gameItem2,
  gameLocation: gameLocation2,
  gamePlatform: gamePlatform2,
  gameTip: gameTip2,
  gender: gender4,
  geo: geo3,
  geoContains: geoContains2,
  geoCoveredBy: geoCoveredBy2,
  geoCovers: geoCovers2,
  geoCrosses: geoCrosses2,
  geoDisjoint: geoDisjoint2,
  geoEquals: geoEquals2,
  geoIntersects: geoIntersects2,
  geoMidpoint: geoMidpoint2,
  geoOverlaps: geoOverlaps2,
  geoRadius: geoRadius2,
  geoTouches: geoTouches2,
  geoWithin: geoWithin2,
  geographicArea: geographicArea2,
  gettingTestedInfo: gettingTestedInfo2,
  givenName: givenName3,
  globalLocationNumber: globalLocationNumber2,
  governmentBenefitsInfo: governmentBenefitsInfo2,
  gracePeriod: gracePeriod2,
  grantee: grantee3,
  greater: greater2,
  greaterOrEqual: greaterOrEqual2,
  gtin12: gtin122,
  gtin13: gtin132,
  gtin14: gtin142,
  gtin8: gtin82,
  guideline: guideline3,
  guidelineDate: guidelineDate2,
  guidelineSubject: guidelineSubject2,
  handlingTime: handlingTime2,
  hasAdultConsideration: hasAdultConsideration2,
  hasBioPolymerSequence: hasBioPolymerSequence2,
  hasCategoryCode: hasCategoryCode2,
  hasCertification: hasCertification2,
  hasCourse: hasCourse2,
  hasCourseInstance: hasCourseInstance2,
  hasCredential: hasCredential2,
  hasDeliveryMethod: hasDeliveryMethod2,
  hasDigitalDocumentPermission: hasDigitalDocumentPermission2,
  hasDriveThroughService: hasDriveThroughService2,
  hasEnergyConsumptionDetails: hasEnergyConsumptionDetails2,
  hasEnergyEfficiencyCategory: hasEnergyEfficiencyCategory2,
  hasGS1DigitalLink: hasGS1DigitalLink2,
  hasHealthAspect: hasHealthAspect2,
  hasMeasurement: hasMeasurement2,
  hasMemberProgram: hasMemberProgram2,
  hasMenuItem: hasMenuItem2,
  hasMenuSection: hasMenuSection2,
  hasMolecularFunction: hasMolecularFunction2,
  hasOccupation: hasOccupation2,
  hasOfferCatalog: hasOfferCatalog2,
  hasPOS: hasPOS2,
  hasParticipationOffer: hasParticipationOffer2,
  hasProductReturnPolicy: hasProductReturnPolicy2,
  hasShippingService: hasShippingService2,
  hasSponsorshipOffer: hasSponsorshipOffer2,
  hasStore: hasStore2,
  hasTierBenefit: hasTierBenefit2,
  hasTierRequirement: hasTierRequirement2,
  headline: headline2,
  healthCondition: healthCondition2,
  healthPlanCoinsuranceOption: healthPlanCoinsuranceOption2,
  healthPlanCoinsuranceRate: healthPlanCoinsuranceRate2,
  healthPlanCopay: healthPlanCopay2,
  healthPlanCopayOption: healthPlanCopayOption2,
  healthPlanCostSharing: healthPlanCostSharing2,
  healthPlanDrugOption: healthPlanDrugOption2,
  healthPlanDrugTier: healthPlanDrugTier2,
  healthPlanId: healthPlanId2,
  healthPlanMarketingUrl: healthPlanMarketingUrl2,
  healthPlanNetworkId: healthPlanNetworkId2,
  healthPlanNetworkTier: healthPlanNetworkTier2,
  healthPlanPharmacyCategory: healthPlanPharmacyCategory2,
  healthcareReportingData: healthcareReportingData2,
  height: height4,
  highPrice: highPrice2,
  hiringOrganization: hiringOrganization2,
  homeLocation: homeLocation2,
  homeTeam: homeTeam2,
  honorificPrefix: honorificPrefix2,
  honorificSuffix: honorificSuffix2,
  hospitalAffiliation: hospitalAffiliation2,
  hostingOrganization: hostingOrganization2,
  hoursAvailable: hoursAvailable2,
  howPerformed: howPerformed2,
  httpMethod: httpMethod2,
  iataCode: iataCode2,
  icaoCode: icaoCode2,
  identifyingExam: identifyingExam2,
  identifyingTest: identifyingTest2,
  illustrator: illustrator2,
  imagingTechnique: imagingTechnique2,
  inAlbum: inAlbum2,
  inBroadcastLineup: inBroadcastLineup2,
  inChI: inChI2,
  inChIKey: inChIKey2,
  inCodeSet: inCodeSet2,
  inPlaylist: inPlaylist2,
  inProductGroupWithID: inProductGroupWithID2,
  inStoreReturnsOffered: inStoreReturnsOffered2,
  inSupportOf: inSupportOf2,
  incentiveAmount: incentiveAmount2,
  incentiveStatus: incentiveStatus2,
  incentiveType: incentiveType2,
  incentives: incentives2,
  incentivizedItem: incentivizedItem2,
  includedComposition: includedComposition2,
  includedDataCatalog: includedDataCatalog2,
  includedInHealthInsurancePlan: includedInHealthInsurancePlan2,
  includedRiskFactor: includedRiskFactor2,
  includesAttraction: includesAttraction2,
  includesHealthPlanFormulary: includesHealthPlanFormulary2,
  includesHealthPlanNetwork: includesHealthPlanNetwork2,
  includesObject: includesObject2,
  incomeLimit: incomeLimit2,
  increasesRiskOf: increasesRiskOf2,
  industry: industry2,
  ineligibleRegion: ineligibleRegion2,
  infectiousAgent: infectiousAgent2,
  infectiousAgentClass: infectiousAgentClass2,
  ingredients: ingredients2,
  inker: inker2,
  insertion: insertion2,
  installUrl: installUrl2,
  instructor: instructor2,
  intensity: intensity2,
  interactingDrug: interactingDrug2,
  interactionCount: interactionCount2,
  interactionService: interactionService2,
  interactionType: interactionType2,
  interactivityType: interactivityType2,
  interestRate: interestRate2,
  interpretedAsClaim: interpretedAsClaim2,
  inventoryLevel: inventoryLevel2,
  inverseOf: inverseOf3,
  isAcceptingNewPatients: isAcceptingNewPatients2,
  isAccessoryOrSparePartFor: isAccessoryOrSparePartFor2,
  isAvailableGenerically: isAvailableGenerically2,
  isBasedOnUrl: isBasedOnUrl2,
  isConsumableFor: isConsumableFor2,
  isFamilyFriendly: isFamilyFriendly2,
  isGift: isGift2,
  isInvolvedInBiologicalProcess: isInvolvedInBiologicalProcess2,
  isLiveBroadcast: isLiveBroadcast2,
  isLocatedInSubcellularLocation: isLocatedInSubcellularLocation2,
  isPlanForApartment: isPlanForApartment2,
  isProprietary: isProprietary2,
  isRelatedTo: isRelatedTo2,
  isResizable: isResizable2,
  isSimilarTo: isSimilarTo2,
  isStoreOn: isStoreOn2,
  isUnlabelledFallback: isUnlabelledFallback2,
  isbn: isbn2,
  isicV4: isicV42,
  iso6523Code: iso6523Code2,
  isrcCode: isrcCode2,
  issn: issn2,
  issueNumber: issueNumber2,
  issuedBy: issuedBy2,
  issuedThrough: issuedThrough2,
  iswcCode: iswcCode2,
  item: item3,
  itemCondition: itemCondition2,
  itemDefectReturnFees: itemDefectReturnFees2,
  itemDefectReturnLabelSource: itemDefectReturnLabelSource2,
  itemDefectReturnShippingFeesAmount: itemDefectReturnShippingFeesAmount2,
  itemListElement: itemListElement2,
  itemListOrder: itemListOrder2,
  itemLocation: itemLocation2,
  itemReviewed: itemReviewed2,
  itemShipped: itemShipped2,
  itinerary: itinerary2,
  iupacName: iupacName2,
  jobDuration: jobDuration2,
  jobImmediateStart: jobImmediateStart2,
  jobLocation: jobLocation2,
  jobLocationType: jobLocationType2,
  jobStartDate: jobStartDate2,
  jobTitle: jobTitle2,
  keywords: keywords2,
  knownVehicleDamages: knownVehicleDamages2,
  knows: knows3,
  knowsAbout: knowsAbout2,
  knowsLanguage: knowsLanguage2,
  labelDetails: labelDetails2,
  landlord: landlord2,
  language: language6,
  lastReviewed: lastReviewed2,
  latitude: latitude4,
  layoutImage: layoutImage2,
  learningResourceType: learningResourceType2,
  leaseLength: leaseLength2,
  legalAddress: legalAddress2,
  legalName: legalName2,
  legalRepresentative: legalRepresentative2,
  legalStatus: legalStatus2,
  legislationAmends: legislationAmends2,
  legislationCommences: legislationCommences2,
  legislationConsolidates: legislationConsolidates2,
  legislationCorrects: legislationCorrects2,
  legislationCountersignedBy: legislationCountersignedBy2,
  legislationDate: legislationDate2,
  legislationDateOfApplicability: legislationDateOfApplicability2,
  legislationDateVersion: legislationDateVersion2,
  legislationEnsuresImplementationOf: legislationEnsuresImplementationOf2,
  legislationIdentifier: legislationIdentifier2,
  legislationJurisdiction: legislationJurisdiction2,
  legislationLegalForce: legislationLegalForce2,
  legislationLegalValue: legislationLegalValue2,
  legislationPassedBy: legislationPassedBy2,
  legislationRepeals: legislationRepeals2,
  legislationResponsible: legislationResponsible2,
  legislationTransposes: legislationTransposes2,
  legislationType: legislationType2,
  leiCode: leiCode2,
  lender: lender2,
  lesser: lesser2,
  lesserOrEqual: lesserOrEqual2,
  letterer: letterer2,
  license: license4,
  lifeEvent: lifeEvent2,
  line: line3,
  linkRelationship: linkRelationship2,
  liveBlogUpdate: liveBlogUpdate2,
  loanMortgageMandateAmount: loanMortgageMandateAmount2,
  loanPaymentAmount: loanPaymentAmount2,
  loanPaymentFrequency: loanPaymentFrequency2,
  loanRepaymentForm: loanRepaymentForm2,
  loanTerm: loanTerm2,
  loanType: loanType2,
  locationCreated: locationCreated2,
  lodgingUnitDescription: lodgingUnitDescription2,
  lodgingUnitType: lodgingUnitType2,
  logo: logo3,
  longitude: longitude4,
  loser: loser2,
  lowPrice: lowPrice2,
  lyricist: lyricist2,
  lyrics: lyrics2,
  maintainer: maintainer2,
  manufacturer: manufacturer3,
  map: map4,
  mapType: mapType2,
  maps: maps2,
  marginOfError: marginOfError2,
  masthead: masthead2,
  materialExtent: materialExtent2,
  mathExpression: mathExpression2,
  maxPrice: maxPrice2,
  maxValue: maxValue3,
  maximumAttendeeCapacity: maximumAttendeeCapacity2,
  maximumEnrollment: maximumEnrollment2,
  maximumIntake: maximumIntake2,
  maximumPhysicalAttendeeCapacity: maximumPhysicalAttendeeCapacity2,
  maximumVirtualAttendeeCapacity: maximumVirtualAttendeeCapacity2,
  mealService: mealService2,
  measuredProperty: measuredProperty2,
  measurementDenominator: measurementDenominator2,
  measurementMethod: measurementMethod2,
  measurementQualifier: measurementQualifier2,
  mechanismOfAction: mechanismOfAction2,
  mediaAuthenticityCategory: mediaAuthenticityCategory2,
  mediaItemAppearance: mediaItemAppearance2,
  median: median2,
  medicalAudience: medicalAudience2,
  medicalSpecialty: medicalSpecialty2,
  medicineSystem: medicineSystem2,
  meetsEmissionStandard: meetsEmissionStandard2,
  members: members3,
  membershipNumber: membershipNumber2,
  membershipPointsEarned: membershipPointsEarned2,
  memoryRequirements: memoryRequirements2,
  mentions: mentions2,
  menu: menu2,
  menuAddOn: menuAddOn2,
  merchant: merchant2,
  messageAttachment: messageAttachment2,
  mileageFromOdometer: mileageFromOdometer2,
  minPrice: minPrice2,
  minValue: minValue3,
  minimumPaymentDue: minimumPaymentDue2,
  missionCoveragePrioritiesPolicy: missionCoveragePrioritiesPolicy2,
  mobileUrl: mobileUrl2,
  model: model2,
  modelDate: modelDate2,
  modifiedTime: modifiedTime2,
  molecularFormula: molecularFormula3,
  molecularWeight: molecularWeight3,
  monoisotopicMolecularWeight: monoisotopicMolecularWeight2,
  monthlyMinimumRepaymentAmount: monthlyMinimumRepaymentAmount2,
  monthsOfExperience: monthsOfExperience2,
  mpn: mpn2,
  multipleValues: multipleValues2,
  muscleAction: muscleAction2,
  musicArrangement: musicArrangement2,
  musicBy: musicBy2,
  musicCompositionForm: musicCompositionForm2,
  musicGroupMember: musicGroupMember2,
  musicReleaseFormat: musicReleaseFormat2,
  musicalKey: musicalKey2,
  naics: naics2,
  name: name5,
  namedPosition: namedPosition2,
  nationality: nationality2,
  naturalProgression: naturalProgression2,
  negativeNotes: negativeNotes2,
  nerve: nerve2,
  nerveMotor: nerveMotor2,
  netWorth: netWorth2,
  newsUpdatesAndGuidelines: newsUpdatesAndGuidelines2,
  nextItem: nextItem2,
  noBylinesPolicy: noBylinesPolicy2,
  nonEqual: nonEqual2,
  nonProprietaryName: nonProprietaryName2,
  nonprofitStatus: nonprofitStatus2,
  normalRange: normalRange2,
  nsn: nsn2,
  numAdults: numAdults2,
  numChildren: numChildren2,
  numConstraints: numConstraints2,
  numItems: numItems2,
  numTracks: numTracks2,
  numberOfAccommodationUnits: numberOfAccommodationUnits2,
  numberOfAirbags: numberOfAirbags2,
  numberOfAvailableAccommodationUnits: numberOfAvailableAccommodationUnits2,
  numberOfAxles: numberOfAxles2,
  numberOfBathroomsTotal: numberOfBathroomsTotal2,
  numberOfBedrooms: numberOfBedrooms2,
  numberOfBeds: numberOfBeds2,
  numberOfCredits: numberOfCredits2,
  numberOfDoors: numberOfDoors2,
  numberOfEmployees: numberOfEmployees2,
  numberOfEpisodes: numberOfEpisodes2,
  numberOfForwardGears: numberOfForwardGears2,
  numberOfFullBathrooms: numberOfFullBathrooms2,
  numberOfItems: numberOfItems2,
  numberOfLoanPayments: numberOfLoanPayments2,
  numberOfPages: numberOfPages2,
  numberOfPartialBathrooms: numberOfPartialBathrooms2,
  numberOfPlayers: numberOfPlayers2,
  numberOfPreviousOwners: numberOfPreviousOwners2,
  numberOfRooms: numberOfRooms2,
  numberOfSeasons: numberOfSeasons2,
  numberedPosition: numberedPosition2,
  nutrition: nutrition2,
  observationAbout: observationAbout2,
  observationDate: observationDate2,
  observationPeriod: observationPeriod2,
  occupancy: occupancy2,
  occupationLocation: occupationLocation2,
  occupationalCategory: occupationalCategory2,
  occupationalCredentialAwarded: occupationalCredentialAwarded2,
  offerCount: offerCount2,
  offersPrescriptionByMail: offersPrescriptionByMail2,
  openingHours: openingHours2,
  openingHoursSpecification: openingHoursSpecification2,
  opens: opens2,
  operatingSystem: operatingSystem2,
  opponent: opponent2,
  option: option4,
  orderDate: orderDate2,
  orderDelivery: orderDelivery2,
  orderItemNumber: orderItemNumber2,
  orderItemStatus: orderItemStatus2,
  orderNumber: orderNumber2,
  orderPercentage: orderPercentage2,
  orderQuantity: orderQuantity2,
  orderStatus: orderStatus2,
  orderValue: orderValue2,
  orderedItem: orderedItem2,
  organizer: organizer3,
  originAddress: originAddress2,
  originalMediaContextDescription: originalMediaContextDescription2,
  originalMediaLink: originalMediaLink2,
  originatesFrom: originatesFrom2,
  overdosage: overdosage2,
  ownedFrom: ownedFrom2,
  ownedThrough: ownedThrough2,
  ownershipFundingInfo: ownershipFundingInfo2,
  pageEnd: pageEnd2,
  pageStart: pageStart2,
  pagination: pagination2,
  parentItem: parentItem2,
  parentService: parentService2,
  parents: parents2,
  partOfEpisode: partOfEpisode2,
  partOfInvoice: partOfInvoice2,
  partOfOrder: partOfOrder2,
  partOfSeason: partOfSeason2,
  partOfSystem: partOfSystem2,
  partOfTVSeries: partOfTVSeries2,
  partySize: partySize2,
  passengerPriorityStatus: passengerPriorityStatus2,
  passengerSequenceNumber: passengerSequenceNumber2,
  pathophysiology: pathophysiology2,
  pattern: pattern3,
  payload: payload3,
  paymentAccepted: paymentAccepted2,
  paymentDue: paymentDue2,
  paymentMethod: paymentMethod2,
  paymentMethodId: paymentMethodId2,
  paymentMethodType: paymentMethodType2,
  paymentStatus: paymentStatus3,
  paymentUrl: paymentUrl2,
  penciler: penciler2,
  percentile10: percentile102,
  percentile25: percentile252,
  percentile75: percentile752,
  percentile90: percentile902,
  performerIn: performerIn2,
  performers: performers2,
  permissionType: permissionType2,
  permissions: permissions2,
  permitAudience: permitAudience2,
  permittedUsage: permittedUsage2,
  petsAllowed: petsAllowed2,
  phoneticText: phoneticText2,
  photos: photos2,
  physicalRequirement: physicalRequirement2,
  physiologicalBenefits: physiologicalBenefits2,
  pickupLocation: pickupLocation2,
  pickupTime: pickupTime2,
  playMode: playMode2,
  playerType: playerType2,
  playersOnline: playersOnline2,
  polygon: polygon2,
  populationType: populationType2,
  positiveNotes: positiveNotes2,
  possibleComplication: possibleComplication2,
  possibleTreatment: possibleTreatment2,
  postOfficeBoxNumber: postOfficeBoxNumber2,
  postOp: postOp2,
  postalCode: postalCode3,
  postalCodeBegin: postalCodeBegin2,
  postalCodeEnd: postalCodeEnd2,
  postalCodePrefix: postalCodePrefix2,
  postalCodeRange: postalCodeRange2,
  potentialAction: potentialAction2,
  potentialUse: potentialUse2,
  practicesAt: practicesAt2,
  preOp: preOp2,
  predecessorOf: predecessorOf2,
  pregnancyCategory: pregnancyCategory2,
  pregnancyWarning: pregnancyWarning2,
  prepTime: prepTime2,
  preparation: preparation3,
  prescribingInfo: prescribingInfo2,
  prescriptionStatus: prescriptionStatus2,
  previousItem: previousItem2,
  previousStartDate: previousStartDate2,
  price: price2,
  priceComponent: priceComponent3,
  priceComponentType: priceComponentType2,
  priceCurrency: priceCurrency2,
  priceRange: priceRange2,
  priceSpecification: priceSpecification2,
  priceType: priceType2,
  priceValidUntil: priceValidUntil2,
  primaryImageOfPage: primaryImageOfPage2,
  primaryPrevention: primaryPrevention2,
  printColumn: printColumn2,
  printEdition: printEdition2,
  printPage: printPage2,
  printSection: printSection2,
  procedure: procedure3,
  procedureType: procedureType2,
  processingTime: processingTime2,
  processorRequirements: processorRequirements2,
  producer: producer2,
  produces: produces2,
  productGroupID: productGroupID2,
  productID: productID2,
  productReturnDays: productReturnDays2,
  productReturnLink: productReturnLink2,
  productSupported: productSupported2,
  productionCompany: productionCompany2,
  productionDate: productionDate2,
  proficiencyLevel: proficiencyLevel2,
  program: program3,
  programMembershipUsed: programMembershipUsed2,
  programName: programName2,
  programPrerequisites: programPrerequisites2,
  programType: programType2,
  programmingLanguage: programmingLanguage2,
  programmingModel: programmingModel2,
  pronouns: pronouns2,
  propertyID: propertyID2,
  proprietaryName: proprietaryName2,
  proteinContent: proteinContent2,
  providerMobility: providerMobility2,
  providesService: providesService2,
  publicAccess: publicAccess2,
  publicTransportClosuresInfo: publicTransportClosuresInfo2,
  publication: publication2,
  publicationType: publicationType2,
  publishedBy: publishedBy2,
  publishedOn: publishedOn2,
  publisher: publisher5,
  publisherImprint: publisherImprint2,
  purchaseDate: purchaseDate2,
  purchasePriceLimit: purchasePriceLimit2,
  purchaseType: purchaseType2,
  qualifications: qualifications2,
  qualifiedExpense: qualifiedExpense2,
  quarantineGuidelines: quarantineGuidelines2,
  query: query3,
  quest: quest2,
  question: question3,
  rangeIncludes: rangeIncludes2,
  ratingCount: ratingCount2,
  ratingExplanation: ratingExplanation2,
  ratingValue: ratingValue2,
  readBy: readBy2,
  readonlyValue: readonlyValue2,
  realEstateAgent: realEstateAgent2,
  recipe: recipe2,
  recipeCategory: recipeCategory2,
  recipeCuisine: recipeCuisine2,
  recipeInstructions: recipeInstructions2,
  recipeYield: recipeYield2,
  recognizedBy: recognizedBy2,
  recognizingAuthority: recognizingAuthority2,
  recommendationStrength: recommendationStrength2,
  recommendedIntake: recommendedIntake2,
  recordLabel: recordLabel2,
  recourseLoan: recourseLoan2,
  referee: referee2,
  referenceQuantity: referenceQuantity2,
  referencesOrder: referencesOrder2,
  refundType: refundType2,
  regionDrained: regionDrained2,
  regionsAllowed: regionsAllowed2,
  relatedAnatomy: relatedAnatomy2,
  relatedCondition: relatedCondition2,
  relatedDrug: relatedDrug2,
  relatedLink: relatedLink2,
  relatedStructure: relatedStructure2,
  relatedTherapy: relatedTherapy2,
  relatedTo: relatedTo3,
  releaseDate: releaseDate3,
  releaseNotes: releaseNotes2,
  releasedEvent: releasedEvent2,
  relevantOccupation: relevantOccupation2,
  relevantSpecialty: relevantSpecialty2,
  remainingAttendeeCapacity: remainingAttendeeCapacity2,
  renegotiableLoan: renegotiableLoan2,
  repeatCount: repeatCount2,
  repeatFrequency: repeatFrequency2,
  repetitions: repetitions3,
  replacee: replacee2,
  replacer: replacer2,
  replyToUrl: replyToUrl2,
  reportNumber: reportNumber2,
  representativeOfPage: representativeOfPage2,
  requiredCollateral: requiredCollateral2,
  requiredGender: requiredGender2,
  requiredMaxAge: requiredMaxAge2,
  requiredMinAge: requiredMinAge2,
  requiredQuantity: requiredQuantity2,
  requirements: requirements3,
  requiresSubscription: requiresSubscription2,
  reservationFor: reservationFor2,
  reservationId: reservationId2,
  reservationStatus: reservationStatus2,
  reservedTicket: reservedTicket2,
  responsibilities: responsibilities2,
  restPeriods: restPeriods2,
  restockingFee: restockingFee2,
  resultComment: resultComment2,
  resultReview: resultReview2,
  returnFees: returnFees2,
  returnLabelSource: returnLabelSource2,
  returnMethod: returnMethod2,
  returnPolicyCategory: returnPolicyCategory2,
  returnPolicyCountry: returnPolicyCountry2,
  returnPolicySeasonalOverride: returnPolicySeasonalOverride2,
  returnShippingFeesAmount: returnShippingFeesAmount2,
  reviewAspect: reviewAspect2,
  reviewBody: reviewBody2,
  reviewCount: reviewCount2,
  reviewRating: reviewRating2,
  reviewedBy: reviewedBy2,
  reviews: reviews2,
  riskFactor: riskFactor2,
  risks: risks2,
  roofLoad: roofLoad2,
  rsvpResponse: rsvpResponse2,
  runsTo: runsTo2,
  runtime: runtime2,
  rxcui: rxcui2,
  safetyConsideration: safetyConsideration2,
  salaryCurrency: salaryCurrency2,
  salaryUponCompletion: salaryUponCompletion2,
  sameAs: sameAs3,
  sampleType: sampleType2,
  saturatedFatContent: saturatedFatContent2,
  scheduleTimezone: scheduleTimezone2,
  scheduledPaymentDate: scheduledPaymentDate2,
  scheduledTime: scheduledTime2,
  schemaVersion: schemaVersion2,
  schoolClosuresInfo: schoolClosuresInfo2,
  screenCount: screenCount2,
  screenshot: screenshot2,
  sdDatePublished: sdDatePublished2,
  sdLicense: sdLicense2,
  sdPublisher: sdPublisher2,
  seasonNumber: seasonNumber2,
  seasonalOverride: seasonalOverride2,
  seasons: seasons2,
  seatNumber: seatNumber2,
  seatRow: seatRow2,
  seatSection: seatSection2,
  seatingCapacity: seatingCapacity2,
  seatingType: seatingType2,
  secondaryPrevention: secondaryPrevention2,
  securityClearanceRequirement: securityClearanceRequirement2,
  securityScreening: securityScreening2,
  seeks: seeks2,
  sender: sender3,
  sensoryRequirement: sensoryRequirement2,
  sensoryUnit: sensoryUnit2,
  seriousAdverseOutcome: seriousAdverseOutcome2,
  serverStatus: serverStatus2,
  servesCuisine: servesCuisine2,
  serviceAudience: serviceAudience2,
  serviceLocation: serviceLocation2,
  serviceOperator: serviceOperator2,
  servicePhone: servicePhone2,
  servicePostalAddress: servicePostalAddress2,
  serviceSmsNumber: serviceSmsNumber2,
  serviceType: serviceType3,
  serviceUrl: serviceUrl2,
  servingSize: servingSize2,
  sha256: sha2562,
  sharedContent: sharedContent2,
  shippingConditions: shippingConditions2,
  shippingDestination: shippingDestination2,
  shippingDetails: shippingDetails2,
  shippingLabel: shippingLabel2,
  shippingOrigin: shippingOrigin2,
  shippingRate: shippingRate2,
  shippingSettingsLink: shippingSettingsLink2,
  siblings: siblings2,
  signDetected: signDetected2,
  signOrSymptom: signOrSymptom2,
  significance: significance2,
  significantLinks: significantLinks2,
  size: size3,
  sizeGroup: sizeGroup2,
  sizeSystem: sizeSystem2,
  skills: skills2,
  sku: sku2,
  slogan: slogan2,
  smiles: smiles2,
  smokingAllowed: smokingAllowed2,
  sodiumContent: sodiumContent2,
  softwareAddOn: softwareAddOn2,
  softwareHelp: softwareHelp2,
  softwareVersion: softwareVersion2,
  source: source6,
  sourceOrganization: sourceOrganization2,
  sourcedFrom: sourcedFrom2,
  spatial: spatial3,
  speakable: speakable2,
  specialCommitments: specialCommitments2,
  specialOpeningHoursSpecification: specialOpeningHoursSpecification2,
  specialty: specialty3,
  speechToTextMarkup: speechToTextMarkup2,
  speed: speed2,
  spokenByCharacter: spokenByCharacter2,
  sport: sport2,
  sportsActivityLocation: sportsActivityLocation2,
  sportsEvent: sportsEvent2,
  sportsTeam: sportsTeam2,
  spouse: spouse2,
  stage: stage3,
  stageAsNumber: stageAsNumber2,
  starRating: starRating2,
  startDate: startDate3,
  startOffset: startOffset2,
  startTime: startTime3,
  statType: statType2,
  status: status7,
  steeringPosition: steeringPosition2,
  stepValue: stepValue2,
  steps: steps2,
  storageRequirements: storageRequirements2,
  streetAddress: streetAddress2,
  strengthUnit: strengthUnit2,
  strengthValue: strengthValue2,
  structuralClass: structuralClass2,
  study: study3,
  studyDesign: studyDesign3,
  studyLocation: studyLocation2,
  studySubject: studySubject2,
  stupidProperty: stupidProperty2,
  subEvents: subEvents2,
  subReservation: subReservation2,
  subStageSuffix: subStageSuffix2,
  subStructure: subStructure2,
  subTest: subTest2,
  subtitleLanguage: subtitleLanguage2,
  successorOf: successorOf2,
  sugarContent: sugarContent2,
  suggestedAge: suggestedAge2,
  suggestedGender: suggestedGender2,
  suggestedMaxAge: suggestedMaxAge2,
  suggestedMeasurement: suggestedMeasurement2,
  suggestedMinAge: suggestedMinAge2,
  suitableForDiet: suitableForDiet2,
  supersededBy: supersededBy2,
  supplyTo: supplyTo2,
  supportingData: supportingData2,
  surface: surface2,
  syllabusSections: syllabusSections2,
  target: target4,
  targetDescription: targetDescription2,
  targetName: targetName2,
  targetPlatform: targetPlatform2,
  targetPopulation: targetPopulation2,
  targetProduct: targetProduct2,
  targetUrl: targetUrl2,
  taxID: taxID2,
  taxonRank: taxonRank2,
  taxonomicRange: taxonomicRange2,
  teaches: teaches2,
  telephone: telephone2,
  temporal: temporal3,
  termDuration: termDuration2,
  termsOfService: termsOfService2,
  termsPerYear: termsPerYear2,
  text: text3,
  textValue: textValue2,
  thumbnail: thumbnail3,
  thumbnailUrl: thumbnailUrl2,
  tickerSymbol: tickerSymbol2,
  ticketNumber: ticketNumber2,
  ticketToken: ticketToken2,
  ticketedSeat: ticketedSeat2,
  timeOfDay: timeOfDay3,
  timeRequired: timeRequired2,
  timeToComplete: timeToComplete2,
  timestamp: timestamp3,
  tissueSample: tissueSample2,
  title: title7,
  titleEIDR: titleEIDR2,
  toLocation: toLocation2,
  toRecipient: toRecipient2,
  tocContinuation: tocContinuation2,
  tocEntry: tocEntry2,
  tongueWeight: tongueWeight2,
  tool: tool2,
  torque: torque2,
  totalHistoricalEnrollment: totalHistoricalEnrollment2,
  totalJobOpenings: totalJobOpenings2,
  totalPaymentDue: totalPaymentDue2,
  totalPrice: totalPrice2,
  totalTime: totalTime2,
  tourBookingPage: tourBookingPage2,
  touristType: touristType2,
  trackingNumber: trackingNumber2,
  trackingUrl: trackingUrl2,
  tracks: tracks2,
  trailer: trailer2,
  trailerWeight: trailerWeight2,
  trainName: trainName2,
  trainNumber: trainNumber2,
  trainingSalary: trainingSalary2,
  transFatContent: transFatContent2,
  transcript: transcript2,
  transitTime: transitTime2,
  transitTimeLabel: transitTimeLabel2,
  translator: translator2,
  transmissionMethod: transmissionMethod2,
  travelBans: travelBans2,
  trialDesign: trialDesign2,
  tributary: tributary2,
  tripOrigin: tripOrigin2,
  typeOfBed: typeOfBed2,
  typeOfGood: typeOfGood2,
  typicalAgeRange: typicalAgeRange2,
  typicalCreditsPerTerm: typicalCreditsPerTerm2,
  typicalTest: typicalTest2,
  underName: underName2,
  unitCode: unitCode2,
  unitText: unitText2,
  unnamedSourcesPolicy: unnamedSourcesPolicy2,
  unsaturatedFatContent: unsaturatedFatContent2,
  uploadDate: uploadDate2,
  upvoteCount: upvoteCount2,
  url: url5,
  urlTemplate: urlTemplate2,
  usNPI: usNPI2,
  usedToDiagnose: usedToDiagnose2,
  userInteractionCount: userInteractionCount2,
  usesDevice: usesDevice2,
  usesHealthPlanIdStandard: usesHealthPlanIdStandard2,
  utterances: utterances2,
  validFor: validFor2,
  validForMemberTier: validForMemberTier2,
  validFrom: validFrom2,
  validIn: validIn2,
  validThrough: validThrough2,
  validUntil: validUntil2,
  value: value5,
  valueAddedTaxIncluded: valueAddedTaxIncluded2,
  valueMaxLength: valueMaxLength2,
  valueMinLength: valueMinLength2,
  valueName: valueName2,
  valuePattern: valuePattern2,
  valueReference: valueReference2,
  valueRequired: valueRequired2,
  variableMeasured: variableMeasured2,
  variablesMeasured: variablesMeasured2,
  variantCover: variantCover2,
  variesBy: variesBy2,
  vatID: vatID2,
  vehicleConfiguration: vehicleConfiguration2,
  vehicleEngine: vehicleEngine2,
  vehicleIdentificationNumber: vehicleIdentificationNumber2,
  vehicleInteriorColor: vehicleInteriorColor2,
  vehicleInteriorType: vehicleInteriorType2,
  vehicleModelDate: vehicleModelDate2,
  vehicleSeatingCapacity: vehicleSeatingCapacity2,
  vehicleSpecialUsage: vehicleSpecialUsage2,
  vehicleTransmission: vehicleTransmission2,
  vendor: vendor2,
  verificationFactCheckingPolicy: verificationFactCheckingPolicy2,
  version: version5,
  video: video2,
  videoFormat: videoFormat2,
  videoFrameSize: videoFrameSize2,
  videoQuality: videoQuality2,
  volumeNumber: volumeNumber2,
  warning: warning3,
  warrantyPromise: warrantyPromise2,
  warrantyScope: warrantyScope2,
  webCheckinTime: webCheckinTime2,
  webFeed: webFeed2,
  weight: weight2,
  weightPercentage: weightPercentage2,
  weightTotal: weightTotal2,
  wheelbase: wheelbase2,
  width: width4,
  winner: winner2,
  wordCount: wordCount2,
  workHours: workHours2,
  workLocation: workLocation2,
  workPerformed: workPerformed2,
  workPresented: workPresented2,
  workload: workload2,
  worksFor: worksFor2,
  worstRating: worstRating2,
  xpath: xpath2,
  yearBuilt: yearBuilt2,
  yearlyRevenue: yearlyRevenue2,
  yearsInOperation: yearsInOperation2,
  actionApplication: actionApplication2,
  actionOption: actionOption2,
  album: album2,
  albumRelease: albumRelease2,
  alternateName: alternateName2,
  alumni: alumni2,
  alumniOf: alumniOf2,
  archiveHeld: archiveHeld2,
  arterialBranch: arterialBranch2,
  artworkSurface: artworkSurface2,
  attendee: attendee3,
  audience: audience4,
  availableOnDevice: availableOnDevice2,
  award: award2,
  blogPost: blogPost2,
  broker: broker2,
  caption: caption2,
  category: category5,
  cause: cause2,
  causeOf: causeOf2,
  childTaxon: childTaxon2,
  clinicalPharmacology: clinicalPharmacology2,
  codeSampleType: codeSampleType2,
  colleague: colleague2,
  contactPoint: contactPoint2,
  containsPlace: containsPlace2,
  containsSeason: containsSeason2,
  contentLocation: contentLocation2,
  creator: creator4,
  dataset: dataset2,
  dateCreated: dateCreated2,
  director: director2,
  employee: employee2,
  encodesBioChemEntity: encodesBioChemEntity2,
  encodesCreativeWork: encodesCreativeWork2,
  encodingFormat: encodingFormat2,
  endDate: endDate3,
  episode: episode2,
  event: event3,
  exampleOfWork: exampleOfWork2,
  executableLibraryName: executableLibraryName2,
  exerciseCourse: exerciseCourse2,
  founder: founder2,
  frequency: frequency3,
  fundedItem: fundedItem2,
  funding: funding2,
  game: game2,
  gameServer: gameServer2,
  genre: genre2,
  hasBioChemEntityPart: hasBioChemEntityPart2,
  hasBroadcastChannel: hasBroadcastChannel2,
  hasDefinedTerm: hasDefinedTerm2,
  hasMenu: hasMenu2,
  hasMerchantReturnPolicy: hasMerchantReturnPolicy2,
  hasTiers: hasTiers2,
  hasVariant: hasVariant2,
  holdingArchive: holdingArchive2,
  inDefinedTermSet: inDefinedTermSet2,
  inLanguage: inLanguage2,
  incentiveCompensation: incentiveCompensation2,
  interactionStatistic: interactionStatistic2,
  isAccessibleForFree: isAccessibleForFree2,
  isBasedOn: isBasedOn2,
  isEncodedByBioChemEntity: isEncodedByBioChemEntity2,
  isPartOfBioChemEntity: isPartOfBioChemEntity2,
  isTierOf: isTierOf2,
  isVariantOf: isVariantOf2,
  itemOffered: itemOffered2,
  jobBenefits: jobBenefits2,
  jurisdiction: jurisdiction3,
  mainContentOfPage: mainContentOfPage2,
  mainEntity: mainEntity2,
  mainEntityOfPage: mainEntityOfPage2,
  makesOffer: makesOffer2,
  measurementTechnique: measurementTechnique2,
  merchantReturnDays: merchantReturnDays2,
  merchantReturnLink: merchantReturnLink2,
  offeredBy: offeredBy2,
  offers: offers2,
  owner: owner4,
  owns: owns2,
  parent: parent3,
  parentTaxon: parentTaxon2,
  partOfSeries: partOfSeries2,
  partOfTrip: partOfTrip2,
  paymentDueDate: paymentDueDate2,
  performTime: performTime2,
  performer: performer3,
  photo: photo3,
  provider: provider4,
  providesBroadcastService: providesBroadcastService2,
  recipeIngredient: recipeIngredient2,
  recordedAs: recordedAs2,
  recordedAt: recordedAt2,
  recordedIn: recordedIn2,
  recordingOf: recordingOf2,
  releaseOf: releaseOf2,
  review: review2,
  roleName: roleName2,
  runtimePlatform: runtimePlatform2,
  season: season2,
  serialNumber: serialNumber3,
  serviceArea: serviceArea2,
  serviceOutput: serviceOutput2,
  sibling: sibling2,
  significantLink: significantLink2,
  softwareRequirements: softwareRequirements2,
  sponsor: sponsor2,
  subOrganization: subOrganization2,
  subTrip: subTrip2,
  subjectOf: subjectOf2,
  suggestedAnswer: suggestedAnswer2,
  superEvent: superEvent2,
  targetCollection: targetCollection2,
  temporalCoverage: temporalCoverage2,
  termCode: termCode2,
  track: track2,
  translationOfWork: translationOfWork2,
  usageInfo: usageInfo2,
  warranty: warranty2,
  workTranslation: workTranslation2,
  yield__workaround: yield__workaround2,
  about: about3,
  actor: actor4,
  associatedReview: associatedReview2,
  competitor: competitor2,
  containedInPlace: containedInPlace2,
  encoding: encoding2,
  hasMap: hasMap2,
  legislationApplies: legislationApplies2,
  material: material3,
  memberOf: memberOf2,
  parentOrganization: parentOrganization2,
  result: result4,
  seller: seller2,
  spatialCoverage: spatialCoverage2,
  step: step3,
  subEvent: subEvent2,
  supply: supply2,
  workFeatured: workFeatured2,
  areaServed: areaServed2,
  duration: duration5,
  includedInDataCatalog: includedInDataCatalog2,
  legislationChanges: legislationChanges2,
  member: member7,
  recipient: recipient3,
  workExample: workExample2,
  description: description8,
  gtin: gtin2,
  hasRepresentation: hasRepresentation2,
  image: image4,
  hasPart: hasPart4,
  position: position3,
  isPartOf: isPartOf3,
  instrument: instrument3,
  object: object5,
  publishingPrinciples: publishingPrinciples2,
  location: location5,
  participant: participant4,
  identifier: identifier5
});

// ../node_modules/rdf-namespaces/dist/sec-b9ce70ee.js
var BbsBlsSignature2020 = "https://w3id.org/security#BbsBlsSignature2020";
var BbsBlsSignatureProof2020 = "https://w3id.org/security#BbsBlsSignatureProof2020";
var Bls12381G1Key2020 = "https://w3id.org/security#Bls12381G1Key2020";
var Bls12381G2Key2020 = "https://w3id.org/security#Bls12381G2Key2020";
var ControlledIdentifierDocument = "https://w3id.org/security#ControlledIdentifierDocument";
var DataIntegrityProof = "https://w3id.org/security#DataIntegrityProof";
var EcdsaSecp256k1RecoveryMethod2020 = "https://w3id.org/security#EcdsaSecp256k1RecoveryMethod2020";
var EcdsaSecp256k1RecoverySignature2020 = "https://w3id.org/security#EcdsaSecp256k1RecoverySignature2020";
var EcdsaSecp256k1Signature2019 = "https://w3id.org/security#EcdsaSecp256k1Signature2019";
var EcdsaSecp256k1Signature2020 = "https://w3id.org/security#EcdsaSecp256k1Signature2020";
var EcdsaSecp256k1VerificationKey2019 = "https://w3id.org/security#EcdsaSecp256k1VerificationKey2019";
var Ed25519Signature2020 = "https://w3id.org/security#Ed25519Signature2020";
var Ed25519VerificationKey2018 = "https://w3id.org/security#Ed25519VerificationKey2018";
var Ed25519VerificationKey2020 = "https://w3id.org/security#Ed25519VerificationKey2020";
var JsonWebKey = "https://w3id.org/security#JsonWebKey";
var JsonWebKey2020 = "https://w3id.org/security#JsonWebKey2020";
var JsonWebSignature2020 = "https://w3id.org/security#JsonWebSignature2020";
var Key = "https://w3id.org/security#Key";
var MerkleProof2019 = "https://w3id.org/security#MerkleProof2019";
var Multikey = "https://w3id.org/security#Multikey";
var ProcessingError = "https://w3id.org/security#ProcessingError";
var Proof = "https://w3id.org/security#Proof";
var ProofGraph = "https://w3id.org/security#ProofGraph";
var VerificationMethod = "https://w3id.org/security#VerificationMethod";
var VerificationRelationship = "https://w3id.org/security#VerificationRelationship";
var X25519KeyAgreementKey2019 = "https://w3id.org/security#X25519KeyAgreementKey2019";
var allowedAction = "https://w3id.org/security#allowedAction";
var assertionMethod = "https://w3id.org/security#assertionMethod";
var authentication = "https://w3id.org/security#authentication";
var blockchainAccountId = "https://w3id.org/security#blockchainAccountId";
var capabilityAction = "https://w3id.org/security#capabilityAction";
var capabilityChain = "https://w3id.org/security#capabilityChain";
var capabilityDelegationMethod = "https://w3id.org/security#capabilityDelegationMethod";
var capabilityInvocationMethod = "https://w3id.org/security#capabilityInvocationMethod";
var caveat = "https://w3id.org/security#caveat";
var challenge = "https://w3id.org/security#challenge";
var controller2 = "https://w3id.org/security#controller";
var created4 = "https://w3id.org/security#created";
var cryptosuite = "https://w3id.org/security#cryptosuite";
var cryptosuiteString = "https://w3id.org/security#cryptosuiteString";
var delegator = "https://w3id.org/security#delegator";
var digestMultibase = "https://w3id.org/security#digestMultibase";
var domain3 = "https://w3id.org/security#domain";
var ethereumAddress = "https://w3id.org/security#ethereumAddress";
var expiration = "https://w3id.org/security#expiration";
var invocationTarget = "https://w3id.org/security#invocationTarget";
var invoker = "https://w3id.org/security#invoker";
var jws = "https://w3id.org/security#jws";
var keyAgreementMethod = "https://w3id.org/security#keyAgreementMethod";
var multibase = "https://w3id.org/security#multibase";
var nonce = "https://w3id.org/security#nonce";
var previousProof = "https://w3id.org/security#previousProof";
var proof = "https://w3id.org/security#proof";
var proofPurpose = "https://w3id.org/security#proofPurpose";
var proofValue = "https://w3id.org/security#proofValue";
var publicKeyBase58 = "https://w3id.org/security#publicKeyBase58";
var publicKeyHex = "https://w3id.org/security#publicKeyHex";
var publicKeyJwk = "https://w3id.org/security#publicKeyJwk";
var publicKeyMultibase = "https://w3id.org/security#publicKeyMultibase";
var publicKeyPem = "https://w3id.org/security#publicKeyPem";
var revoked = "https://w3id.org/security#revoked";
var secretKeyJwk = "https://w3id.org/security#secretKeyJwk";
var secretKeyMultibase = "https://w3id.org/security#secretKeyMultibase";
var verificationMethod = "https://w3id.org/security#verificationMethod";
var secImport = /* @__PURE__ */ Object.freeze({
  BbsBlsSignature2020,
  BbsBlsSignatureProof2020,
  Bls12381G1Key2020,
  Bls12381G2Key2020,
  ControlledIdentifierDocument,
  DataIntegrityProof,
  EcdsaSecp256k1RecoveryMethod2020,
  EcdsaSecp256k1RecoverySignature2020,
  EcdsaSecp256k1Signature2019,
  EcdsaSecp256k1Signature2020,
  EcdsaSecp256k1VerificationKey2019,
  Ed25519Signature2020,
  Ed25519VerificationKey2018,
  Ed25519VerificationKey2020,
  JsonWebKey,
  JsonWebKey2020,
  JsonWebSignature2020,
  Key,
  MerkleProof2019,
  Multikey,
  ProcessingError,
  Proof,
  ProofGraph,
  VerificationMethod,
  VerificationRelationship,
  X25519KeyAgreementKey2019,
  allowedAction,
  assertionMethod,
  authentication,
  blockchainAccountId,
  capabilityAction,
  capabilityChain,
  capabilityDelegationMethod,
  capabilityInvocationMethod,
  caveat,
  challenge,
  controller: controller2,
  created: created4,
  cryptosuite,
  cryptosuiteString,
  delegator,
  digestMultibase,
  domain: domain3,
  ethereumAddress,
  expiration,
  invocationTarget,
  invoker,
  jws,
  keyAgreementMethod,
  multibase,
  nonce,
  previousProof,
  proof,
  proofPurpose,
  proofValue,
  publicKeyBase58,
  publicKeyHex,
  publicKeyJwk,
  publicKeyMultibase,
  publicKeyPem,
  revoked,
  secretKeyJwk,
  secretKeyMultibase,
  verificationMethod
});

// ../node_modules/rdf-namespaces/dist/shacl-36e24453.js
var Shape = "http://www.w3.org/ns/shacl#Shape";
var NodeShape = "http://www.w3.org/ns/shacl#NodeShape";
var PropertyShape = "http://www.w3.org/ns/shacl#PropertyShape";
var deactivated = "http://www.w3.org/ns/shacl#deactivated";
var targetClass = "http://www.w3.org/ns/shacl#targetClass";
var targetNode = "http://www.w3.org/ns/shacl#targetNode";
var targetObjectsOf = "http://www.w3.org/ns/shacl#targetObjectsOf";
var targetSubjectsOf = "http://www.w3.org/ns/shacl#targetSubjectsOf";
var message2 = "http://www.w3.org/ns/shacl#message";
var severity2 = "http://www.w3.org/ns/shacl#severity";
var NodeKind = "http://www.w3.org/ns/shacl#NodeKind";
var ValidationReport = "http://www.w3.org/ns/shacl#ValidationReport";
var conforms = "http://www.w3.org/ns/shacl#conforms";
var result5 = "http://www.w3.org/ns/shacl#result";
var shapesGraphWellFormed = "http://www.w3.org/ns/shacl#shapesGraphWellFormed";
var AbstractResult = "http://www.w3.org/ns/shacl#AbstractResult";
var ValidationResult = "http://www.w3.org/ns/shacl#ValidationResult";
var Severity = "http://www.w3.org/ns/shacl#Severity";
var detail2 = "http://www.w3.org/ns/shacl#detail";
var focusNode = "http://www.w3.org/ns/shacl#focusNode";
var resultMessage = "http://www.w3.org/ns/shacl#resultMessage";
var resultPath = "http://www.w3.org/ns/shacl#resultPath";
var resultSeverity = "http://www.w3.org/ns/shacl#resultSeverity";
var sourceConstraint = "http://www.w3.org/ns/shacl#sourceConstraint";
var sourceShape = "http://www.w3.org/ns/shacl#sourceShape";
var sourceConstraintComponent = "http://www.w3.org/ns/shacl#sourceConstraintComponent";
var value6 = "http://www.w3.org/ns/shacl#value";
var shapesGraph = "http://www.w3.org/ns/shacl#shapesGraph";
var suggestedShapesGraph = "http://www.w3.org/ns/shacl#suggestedShapesGraph";
var entailment = "http://www.w3.org/ns/shacl#entailment";
var path2 = "http://www.w3.org/ns/shacl#path";
var inversePath = "http://www.w3.org/ns/shacl#inversePath";
var alternativePath = "http://www.w3.org/ns/shacl#alternativePath";
var zeroOrMorePath = "http://www.w3.org/ns/shacl#zeroOrMorePath";
var oneOrMorePath = "http://www.w3.org/ns/shacl#oneOrMorePath";
var zeroOrOnePath = "http://www.w3.org/ns/shacl#zeroOrOnePath";
var Parameterizable = "http://www.w3.org/ns/shacl#Parameterizable";
var parameter2 = "http://www.w3.org/ns/shacl#parameter";
var labelTemplate = "http://www.w3.org/ns/shacl#labelTemplate";
var Parameter2 = "http://www.w3.org/ns/shacl#Parameter";
var optional = "http://www.w3.org/ns/shacl#optional";
var ConstraintComponent = "http://www.w3.org/ns/shacl#ConstraintComponent";
var validator2 = "http://www.w3.org/ns/shacl#validator";
var nodeValidator = "http://www.w3.org/ns/shacl#nodeValidator";
var propertyValidator = "http://www.w3.org/ns/shacl#propertyValidator";
var Validator = "http://www.w3.org/ns/shacl#Validator";
var SPARQLAskValidator = "http://www.w3.org/ns/shacl#SPARQLAskValidator";
var SPARQLSelectValidator = "http://www.w3.org/ns/shacl#SPARQLSelectValidator";
var and = "http://www.w3.org/ns/shacl#and";
var class__workaround3 = "http://www.w3.org/ns/shacl#class";
var closed = "http://www.w3.org/ns/shacl#closed";
var ignoredProperties = "http://www.w3.org/ns/shacl#ignoredProperties";
var datatype = "http://www.w3.org/ns/shacl#datatype";
var disjoint = "http://www.w3.org/ns/shacl#disjoint";
var equals = "http://www.w3.org/ns/shacl#equals";
var hasValue2 = "http://www.w3.org/ns/shacl#hasValue";
var in__workaround = "http://www.w3.org/ns/shacl#in";
var languageIn = "http://www.w3.org/ns/shacl#languageIn";
var lessThan = "http://www.w3.org/ns/shacl#lessThan";
var lessThanOrEquals = "http://www.w3.org/ns/shacl#lessThanOrEquals";
var maxCount2 = "http://www.w3.org/ns/shacl#maxCount";
var maxExclusive = "http://www.w3.org/ns/shacl#maxExclusive";
var maxInclusive = "http://www.w3.org/ns/shacl#maxInclusive";
var maxLength2 = "http://www.w3.org/ns/shacl#maxLength";
var minCount = "http://www.w3.org/ns/shacl#minCount";
var minExclusive = "http://www.w3.org/ns/shacl#minExclusive";
var minInclusive = "http://www.w3.org/ns/shacl#minInclusive";
var minLength = "http://www.w3.org/ns/shacl#minLength";
var node2 = "http://www.w3.org/ns/shacl#node";
var nodeKind = "http://www.w3.org/ns/shacl#nodeKind";
var not = "http://www.w3.org/ns/shacl#not";
var or = "http://www.w3.org/ns/shacl#or";
var flags = "http://www.w3.org/ns/shacl#flags";
var pattern4 = "http://www.w3.org/ns/shacl#pattern";
var property3 = "http://www.w3.org/ns/shacl#property";
var qualifiedMaxCount = "http://www.w3.org/ns/shacl#qualifiedMaxCount";
var qualifiedMinCount = "http://www.w3.org/ns/shacl#qualifiedMinCount";
var qualifiedValueShape = "http://www.w3.org/ns/shacl#qualifiedValueShape";
var qualifiedValueShapesDisjoint = "http://www.w3.org/ns/shacl#qualifiedValueShapesDisjoint";
var uniqueLang = "http://www.w3.org/ns/shacl#uniqueLang";
var xone = "http://www.w3.org/ns/shacl#xone";
var SPARQLExecutable = "http://www.w3.org/ns/shacl#SPARQLExecutable";
var SPARQLAskExecutable = "http://www.w3.org/ns/shacl#SPARQLAskExecutable";
var ask = "http://www.w3.org/ns/shacl#ask";
var SPARQLConstructExecutable = "http://www.w3.org/ns/shacl#SPARQLConstructExecutable";
var construct = "http://www.w3.org/ns/shacl#construct";
var SPARQLSelectExecutable = "http://www.w3.org/ns/shacl#SPARQLSelectExecutable";
var select = "http://www.w3.org/ns/shacl#select";
var SPARQLUpdateExecutable = "http://www.w3.org/ns/shacl#SPARQLUpdateExecutable";
var update = "http://www.w3.org/ns/shacl#update";
var prefixes = "http://www.w3.org/ns/shacl#prefixes";
var PrefixDeclaration = "http://www.w3.org/ns/shacl#PrefixDeclaration";
var declare = "http://www.w3.org/ns/shacl#declare";
var prefix2 = "http://www.w3.org/ns/shacl#prefix";
var namespace = "http://www.w3.org/ns/shacl#namespace";
var sparql = "http://www.w3.org/ns/shacl#sparql";
var SPARQLConstraint = "http://www.w3.org/ns/shacl#SPARQLConstraint";
var defaultValue4 = "http://www.w3.org/ns/shacl#defaultValue";
var description9 = "http://www.w3.org/ns/shacl#description";
var group2 = "http://www.w3.org/ns/shacl#group";
var name6 = "http://www.w3.org/ns/shacl#name";
var order3 = "http://www.w3.org/ns/shacl#order";
var PropertyGroup = "http://www.w3.org/ns/shacl#PropertyGroup";
var target5 = "http://www.w3.org/ns/shacl#target";
var Target = "http://www.w3.org/ns/shacl#Target";
var TargetType = "http://www.w3.org/ns/shacl#TargetType";
var SPARQLTarget = "http://www.w3.org/ns/shacl#SPARQLTarget";
var SPARQLTargetType = "http://www.w3.org/ns/shacl#SPARQLTargetType";
var Function__workaround = "http://www.w3.org/ns/shacl#Function";
var returnType = "http://www.w3.org/ns/shacl#returnType";
var SPARQLFunction = "http://www.w3.org/ns/shacl#SPARQLFunction";
var resultAnnotation = "http://www.w3.org/ns/shacl#resultAnnotation";
var ResultAnnotation = "http://www.w3.org/ns/shacl#ResultAnnotation";
var annotationProperty = "http://www.w3.org/ns/shacl#annotationProperty";
var annotationValue = "http://www.w3.org/ns/shacl#annotationValue";
var annotationVarName = "http://www.w3.org/ns/shacl#annotationVarName";
var filterShape = "http://www.w3.org/ns/shacl#filterShape";
var nodes = "http://www.w3.org/ns/shacl#nodes";
var intersection = "http://www.w3.org/ns/shacl#intersection";
var union = "http://www.w3.org/ns/shacl#union";
var expression2 = "http://www.w3.org/ns/shacl#expression";
var Rule2 = "http://www.w3.org/ns/shacl#Rule";
var rule2 = "http://www.w3.org/ns/shacl#rule";
var condition2 = "http://www.w3.org/ns/shacl#condition";
var TripleRule = "http://www.w3.org/ns/shacl#TripleRule";
var subject6 = "http://www.w3.org/ns/shacl#subject";
var predicate2 = "http://www.w3.org/ns/shacl#predicate";
var object6 = "http://www.w3.org/ns/shacl#object";
var SPARQLRule = "http://www.w3.org/ns/shacl#SPARQLRule";
var JSExecutable = "http://www.w3.org/ns/shacl#JSExecutable";
var JSTarget = "http://www.w3.org/ns/shacl#JSTarget";
var JSTargetType = "http://www.w3.org/ns/shacl#JSTargetType";
var JSConstraint = "http://www.w3.org/ns/shacl#JSConstraint";
var js = "http://www.w3.org/ns/shacl#js";
var jsFunctionName = "http://www.w3.org/ns/shacl#jsFunctionName";
var jsLibrary = "http://www.w3.org/ns/shacl#jsLibrary";
var jsLibraryURL = "http://www.w3.org/ns/shacl#jsLibraryURL";
var JSFunction = "http://www.w3.org/ns/shacl#JSFunction";
var JSLibrary = "http://www.w3.org/ns/shacl#JSLibrary";
var JSRule = "http://www.w3.org/ns/shacl#JSRule";
var JSValidator = "http://www.w3.org/ns/shacl#JSValidator";
var shaclImport = /* @__PURE__ */ Object.freeze({
  Shape,
  NodeShape,
  PropertyShape,
  deactivated,
  targetClass,
  targetNode,
  targetObjectsOf,
  targetSubjectsOf,
  message: message2,
  severity: severity2,
  NodeKind,
  ValidationReport,
  conforms,
  result: result5,
  shapesGraphWellFormed,
  AbstractResult,
  ValidationResult,
  Severity,
  detail: detail2,
  focusNode,
  resultMessage,
  resultPath,
  resultSeverity,
  sourceConstraint,
  sourceShape,
  sourceConstraintComponent,
  value: value6,
  shapesGraph,
  suggestedShapesGraph,
  entailment,
  path: path2,
  inversePath,
  alternativePath,
  zeroOrMorePath,
  oneOrMorePath,
  zeroOrOnePath,
  Parameterizable,
  parameter: parameter2,
  labelTemplate,
  Parameter: Parameter2,
  optional,
  ConstraintComponent,
  validator: validator2,
  nodeValidator,
  propertyValidator,
  Validator,
  SPARQLAskValidator,
  SPARQLSelectValidator,
  and,
  class__workaround: class__workaround3,
  closed,
  ignoredProperties,
  datatype,
  disjoint,
  equals,
  hasValue: hasValue2,
  in__workaround,
  languageIn,
  lessThan,
  lessThanOrEquals,
  maxCount: maxCount2,
  maxExclusive,
  maxInclusive,
  maxLength: maxLength2,
  minCount,
  minExclusive,
  minInclusive,
  minLength,
  node: node2,
  nodeKind,
  not,
  or,
  flags,
  pattern: pattern4,
  property: property3,
  qualifiedMaxCount,
  qualifiedMinCount,
  qualifiedValueShape,
  qualifiedValueShapesDisjoint,
  uniqueLang,
  xone,
  SPARQLExecutable,
  SPARQLAskExecutable,
  ask,
  SPARQLConstructExecutable,
  construct,
  SPARQLSelectExecutable,
  select,
  SPARQLUpdateExecutable,
  update,
  prefixes,
  PrefixDeclaration,
  declare,
  prefix: prefix2,
  namespace,
  sparql,
  SPARQLConstraint,
  defaultValue: defaultValue4,
  description: description9,
  group: group2,
  name: name6,
  order: order3,
  PropertyGroup,
  target: target5,
  Target,
  TargetType,
  SPARQLTarget,
  SPARQLTargetType,
  Function__workaround,
  returnType,
  SPARQLFunction,
  resultAnnotation,
  ResultAnnotation,
  annotationProperty,
  annotationValue,
  annotationVarName,
  filterShape,
  nodes,
  intersection,
  union,
  expression: expression2,
  Rule: Rule2,
  rule: rule2,
  condition: condition2,
  TripleRule,
  subject: subject6,
  predicate: predicate2,
  object: object6,
  SPARQLRule,
  JSExecutable,
  JSTarget,
  JSTargetType,
  JSConstraint,
  js,
  jsFunctionName,
  jsLibrary,
  jsLibraryURL,
  JSFunction,
  JSLibrary,
  JSRule,
  JSValidator
});

// ../node_modules/rdf-namespaces/dist/shex-b263635b.js
var Annotation3 = "http://www.w3.org/ns/shex#Annotation";
var EachOf = "http://www.w3.org/ns/shex#EachOf";
var IriStem = "http://www.w3.org/ns/shex#IriStem";
var IriStemRange = "http://www.w3.org/ns/shex#IriStemRange";
var Language3 = "http://www.w3.org/ns/shex#Language";
var LanguageStem = "http://www.w3.org/ns/shex#LanguageStem";
var LanguageStemRange = "http://www.w3.org/ns/shex#LanguageStemRange";
var LiteralStem = "http://www.w3.org/ns/shex#LiteralStem";
var LiteralStemRange = "http://www.w3.org/ns/shex#LiteralStemRange";
var NodeConstraint = "http://www.w3.org/ns/shex#NodeConstraint";
var NodeKind2 = "http://www.w3.org/ns/shex#NodeKind";
var OneOf = "http://www.w3.org/ns/shex#OneOf";
var Schema = "http://www.w3.org/ns/shex#Schema";
var SemAct = "http://www.w3.org/ns/shex#SemAct";
var Shape2 = "http://www.w3.org/ns/shex#Shape";
var ShapeAnd = "http://www.w3.org/ns/shex#ShapeAnd";
var ShapeExpression = "http://www.w3.org/ns/shex#ShapeExpression";
var ShapeExternal = "http://www.w3.org/ns/shex#ShapeExternal";
var ShapeNot = "http://www.w3.org/ns/shex#ShapeNot";
var ShapeOr = "http://www.w3.org/ns/shex#ShapeOr";
var Stem = "http://www.w3.org/ns/shex#Stem";
var StemRange = "http://www.w3.org/ns/shex#StemRange";
var TripleConstraint = "http://www.w3.org/ns/shex#TripleConstraint";
var TripleExpression = "http://www.w3.org/ns/shex#TripleExpression";
var Wildcard = "http://www.w3.org/ns/shex#Wildcard";
var annotation = "http://www.w3.org/ns/shex#annotation";
var closed2 = "http://www.w3.org/ns/shex#closed";
var code4 = "http://www.w3.org/ns/shex#code";
var datatype2 = "http://www.w3.org/ns/shex#datatype";
var exclusion = "http://www.w3.org/ns/shex#exclusion";
var expression3 = "http://www.w3.org/ns/shex#expression";
var expressions = "http://www.w3.org/ns/shex#expressions";
var extra = "http://www.w3.org/ns/shex#extra";
var extends__workaround2 = "http://www.w3.org/ns/shex#extends";
var flags2 = "http://www.w3.org/ns/shex#flags";
var fractiondigits = "http://www.w3.org/ns/shex#fractiondigits";
var inverse2 = "http://www.w3.org/ns/shex#inverse";
var languageTag = "http://www.w3.org/ns/shex#languageTag";
var length2 = "http://www.w3.org/ns/shex#length";
var max2 = "http://www.w3.org/ns/shex#max";
var maxexclusive = "http://www.w3.org/ns/shex#maxexclusive";
var maxinclusive = "http://www.w3.org/ns/shex#maxinclusive";
var maxlength = "http://www.w3.org/ns/shex#maxlength";
var min2 = "http://www.w3.org/ns/shex#min";
var minexclusive = "http://www.w3.org/ns/shex#minexclusive";
var mininclusive = "http://www.w3.org/ns/shex#mininclusive";
var minlength = "http://www.w3.org/ns/shex#minlength";
var name7 = "http://www.w3.org/ns/shex#name";
var nodeKind2 = "http://www.w3.org/ns/shex#nodeKind";
var numericFacet = "http://www.w3.org/ns/shex#numericFacet";
var object7 = "http://www.w3.org/ns/shex#object";
var pattern5 = "http://www.w3.org/ns/shex#pattern";
var predicate3 = "http://www.w3.org/ns/shex#predicate";
var semActs = "http://www.w3.org/ns/shex#semActs";
var shapeExpr = "http://www.w3.org/ns/shex#shapeExpr";
var shapeExprs = "http://www.w3.org/ns/shex#shapeExprs";
var shapes = "http://www.w3.org/ns/shex#shapes";
var start2 = "http://www.w3.org/ns/shex#start";
var startActs = "http://www.w3.org/ns/shex#startActs";
var stem = "http://www.w3.org/ns/shex#stem";
var stringFacet = "http://www.w3.org/ns/shex#stringFacet";
var totaldigits = "http://www.w3.org/ns/shex#totaldigits";
var valueExpr = "http://www.w3.org/ns/shex#valueExpr";
var values = "http://www.w3.org/ns/shex#values";
var xsFacet = "http://www.w3.org/ns/shex#xsFacet";
var shexImport = /* @__PURE__ */ Object.freeze({
  Annotation: Annotation3,
  EachOf,
  IriStem,
  IriStemRange,
  Language: Language3,
  LanguageStem,
  LanguageStemRange,
  LiteralStem,
  LiteralStemRange,
  NodeConstraint,
  NodeKind: NodeKind2,
  OneOf,
  Schema,
  SemAct,
  Shape: Shape2,
  ShapeAnd,
  ShapeExpression,
  ShapeExternal,
  ShapeNot,
  ShapeOr,
  Stem,
  StemRange,
  TripleConstraint,
  TripleExpression,
  Wildcard,
  annotation,
  closed: closed2,
  code: code4,
  datatype: datatype2,
  exclusion,
  expression: expression3,
  expressions,
  extra,
  extends__workaround: extends__workaround2,
  flags: flags2,
  fractiondigits,
  inverse: inverse2,
  languageTag,
  length: length2,
  max: max2,
  maxexclusive,
  maxinclusive,
  maxlength,
  min: min2,
  minexclusive,
  mininclusive,
  minlength,
  name: name7,
  nodeKind: nodeKind2,
  numericFacet,
  object: object7,
  pattern: pattern5,
  predicate: predicate3,
  semActs,
  shapeExpr,
  shapeExprs,
  shapes,
  start: start2,
  startActs,
  stem,
  stringFacet,
  totaldigits,
  valueExpr,
  values,
  xsFacet
});

// ../node_modules/rdf-namespaces/dist/sioc-0842c71e.js
var Community = "http://rdfs.org/sioc/ns#Community";
var Container3 = "http://rdfs.org/sioc/ns#Container";
var Forum = "http://rdfs.org/sioc/ns#Forum";
var Item2 = "http://rdfs.org/sioc/ns#Item";
var Post = "http://rdfs.org/sioc/ns#Post";
var Role4 = "http://rdfs.org/sioc/ns#Role";
var Space = "http://rdfs.org/sioc/ns#Space";
var Site = "http://rdfs.org/sioc/ns#Site";
var Thread = "http://rdfs.org/sioc/ns#Thread";
var UserAccount = "http://rdfs.org/sioc/ns#UserAccount";
var Usergroup = "http://rdfs.org/sioc/ns#Usergroup";
var about4 = "http://rdfs.org/sioc/ns#about";
var account_of = "http://rdfs.org/sioc/ns#account_of";
var addressed_to = "http://rdfs.org/sioc/ns#addressed_to";
var administrator_of = "http://rdfs.org/sioc/ns#administrator_of";
var attachment3 = "http://rdfs.org/sioc/ns#attachment";
var avatar = "http://rdfs.org/sioc/ns#avatar";
var container_of = "http://rdfs.org/sioc/ns#container_of";
var content4 = "http://rdfs.org/sioc/ns#content";
var creator_of = "http://rdfs.org/sioc/ns#creator_of";
var delivered_at = "http://rdfs.org/sioc/ns#delivered_at";
var discussion_of = "http://rdfs.org/sioc/ns#discussion_of";
var earlier_version = "http://rdfs.org/sioc/ns#earlier_version";
var email3 = "http://rdfs.org/sioc/ns#email";
var email_sha1 = "http://rdfs.org/sioc/ns#email_sha1";
var embeds_knowledge = "http://rdfs.org/sioc/ns#embeds_knowledge";
var feed = "http://rdfs.org/sioc/ns#feed";
var follows3 = "http://rdfs.org/sioc/ns#follows";
var function_of = "http://rdfs.org/sioc/ns#function_of";
var generator2 = "http://rdfs.org/sioc/ns#generator";
var has_administrator = "http://rdfs.org/sioc/ns#has_administrator";
var has_container = "http://rdfs.org/sioc/ns#has_container";
var has_creator = "http://rdfs.org/sioc/ns#has_creator";
var has_discussion = "http://rdfs.org/sioc/ns#has_discussion";
var has_function = "http://rdfs.org/sioc/ns#has_function";
var has_host = "http://rdfs.org/sioc/ns#has_host";
var has_member = "http://rdfs.org/sioc/ns#has_member";
var has_moderator = "http://rdfs.org/sioc/ns#has_moderator";
var has_modifier = "http://rdfs.org/sioc/ns#has_modifier";
var has_owner = "http://rdfs.org/sioc/ns#has_owner";
var has_parent = "http://rdfs.org/sioc/ns#has_parent";
var has_reply = "http://rdfs.org/sioc/ns#has_reply";
var has_scope = "http://rdfs.org/sioc/ns#has_scope";
var has_space = "http://rdfs.org/sioc/ns#has_space";
var has_subscriber = "http://rdfs.org/sioc/ns#has_subscriber";
var has_usergroup = "http://rdfs.org/sioc/ns#has_usergroup";
var host_of = "http://rdfs.org/sioc/ns#host_of";
var id3 = "http://rdfs.org/sioc/ns#id";
var ip_address = "http://rdfs.org/sioc/ns#ip_address";
var last_activity_date = "http://rdfs.org/sioc/ns#last_activity_date";
var last_item_date = "http://rdfs.org/sioc/ns#last_item_date";
var last_reply_date = "http://rdfs.org/sioc/ns#last_reply_date";
var later_version = "http://rdfs.org/sioc/ns#later_version";
var latest_version = "http://rdfs.org/sioc/ns#latest_version";
var likes = "http://rdfs.org/sioc/ns#likes";
var link3 = "http://rdfs.org/sioc/ns#link";
var links_to = "http://rdfs.org/sioc/ns#links_to";
var member_of = "http://rdfs.org/sioc/ns#member_of";
var mentions3 = "http://rdfs.org/sioc/ns#mentions";
var moderator_of = "http://rdfs.org/sioc/ns#moderator_of";
var modifier_of = "http://rdfs.org/sioc/ns#modifier_of";
var name8 = "http://rdfs.org/sioc/ns#name";
var next_by_date = "http://rdfs.org/sioc/ns#next_by_date";
var next_version = "http://rdfs.org/sioc/ns#next_version";
var note2 = "http://rdfs.org/sioc/ns#note";
var num_authors = "http://rdfs.org/sioc/ns#num_authors";
var num_items = "http://rdfs.org/sioc/ns#num_items";
var num_replies = "http://rdfs.org/sioc/ns#num_replies";
var num_threads = "http://rdfs.org/sioc/ns#num_threads";
var num_views = "http://rdfs.org/sioc/ns#num_views";
var owner_of = "http://rdfs.org/sioc/ns#owner_of";
var parent_of = "http://rdfs.org/sioc/ns#parent_of";
var previous_by_date = "http://rdfs.org/sioc/ns#previous_by_date";
var previous_version = "http://rdfs.org/sioc/ns#previous_version";
var read_at = "http://rdfs.org/sioc/ns#read_at";
var related_to = "http://rdfs.org/sioc/ns#related_to";
var reply_of = "http://rdfs.org/sioc/ns#reply_of";
var respond_to = "http://rdfs.org/sioc/ns#respond_to";
var scope_of = "http://rdfs.org/sioc/ns#scope_of";
var shared_by = "http://rdfs.org/sioc/ns#shared_by";
var sibling3 = "http://rdfs.org/sioc/ns#sibling";
var space_of = "http://rdfs.org/sioc/ns#space_of";
var subscriber_of = "http://rdfs.org/sioc/ns#subscriber_of";
var topic3 = "http://rdfs.org/sioc/ns#topic";
var usergroup_of = "http://rdfs.org/sioc/ns#usergroup_of";
var title8 = "http://rdfs.org/sioc/ns#title";
var content_encoded = "http://rdfs.org/sioc/ns#content_encoded";
var created_at = "http://rdfs.org/sioc/ns#created_at";
var description10 = "http://rdfs.org/sioc/ns#description";
var first_name = "http://rdfs.org/sioc/ns#first_name";
var group_of = "http://rdfs.org/sioc/ns#group_of";
var has_group = "http://rdfs.org/sioc/ns#has_group";
var has_part = "http://rdfs.org/sioc/ns#has_part";
var last_name = "http://rdfs.org/sioc/ns#last_name";
var modified_at = "http://rdfs.org/sioc/ns#modified_at";
var part_of = "http://rdfs.org/sioc/ns#part_of";
var reference2 = "http://rdfs.org/sioc/ns#reference";
var subject7 = "http://rdfs.org/sioc/ns#subject";
var siocImport = /* @__PURE__ */ Object.freeze({
  Community,
  Container: Container3,
  Forum,
  Item: Item2,
  Post,
  Role: Role4,
  Space,
  Site,
  Thread,
  UserAccount,
  Usergroup,
  about: about4,
  account_of,
  addressed_to,
  administrator_of,
  attachment: attachment3,
  avatar,
  container_of,
  content: content4,
  creator_of,
  delivered_at,
  discussion_of,
  earlier_version,
  email: email3,
  email_sha1,
  embeds_knowledge,
  feed,
  follows: follows3,
  function_of,
  generator: generator2,
  has_administrator,
  has_container,
  has_creator,
  has_discussion,
  has_function,
  has_host,
  has_member,
  has_moderator,
  has_modifier,
  has_owner,
  has_parent,
  has_reply,
  has_scope,
  has_space,
  has_subscriber,
  has_usergroup,
  host_of,
  id: id3,
  ip_address,
  last_activity_date,
  last_item_date,
  last_reply_date,
  later_version,
  latest_version,
  likes,
  link: link3,
  links_to,
  member_of,
  mentions: mentions3,
  moderator_of,
  modifier_of,
  name: name8,
  next_by_date,
  next_version,
  note: note2,
  num_authors,
  num_items,
  num_replies,
  num_threads,
  num_views,
  owner_of,
  parent_of,
  previous_by_date,
  previous_version,
  read_at,
  related_to,
  reply_of,
  respond_to,
  scope_of,
  shared_by,
  sibling: sibling3,
  space_of,
  subscriber_of,
  topic: topic3,
  usergroup_of,
  title: title8,
  content_encoded,
  created_at,
  description: description10,
  first_name,
  group_of,
  has_group,
  has_part,
  last_name,
  modified_at,
  part_of,
  reference: reference2,
  subject: subject7
});

// ../node_modules/rdf-namespaces/dist/skos-2b5965bf.js
var Concept = "http://www.w3.org/2004/02/skos/core#Concept";
var ConceptScheme = "http://www.w3.org/2004/02/skos/core#ConceptScheme";
var Collection7 = "http://www.w3.org/2004/02/skos/core#Collection";
var OrderedCollection2 = "http://www.w3.org/2004/02/skos/core#OrderedCollection";
var inScheme = "http://www.w3.org/2004/02/skos/core#inScheme";
var hasTopConcept = "http://www.w3.org/2004/02/skos/core#hasTopConcept";
var topConceptOf = "http://www.w3.org/2004/02/skos/core#topConceptOf";
var prefLabel = "http://www.w3.org/2004/02/skos/core#prefLabel";
var altLabel = "http://www.w3.org/2004/02/skos/core#altLabel";
var hiddenLabel = "http://www.w3.org/2004/02/skos/core#hiddenLabel";
var notation = "http://www.w3.org/2004/02/skos/core#notation";
var note3 = "http://www.w3.org/2004/02/skos/core#note";
var changeNote = "http://www.w3.org/2004/02/skos/core#changeNote";
var definition3 = "http://www.w3.org/2004/02/skos/core#definition";
var editorialNote2 = "http://www.w3.org/2004/02/skos/core#editorialNote";
var example2 = "http://www.w3.org/2004/02/skos/core#example";
var historyNote = "http://www.w3.org/2004/02/skos/core#historyNote";
var scopeNote = "http://www.w3.org/2004/02/skos/core#scopeNote";
var semanticRelation = "http://www.w3.org/2004/02/skos/core#semanticRelation";
var broader = "http://www.w3.org/2004/02/skos/core#broader";
var narrower = "http://www.w3.org/2004/02/skos/core#narrower";
var related2 = "http://www.w3.org/2004/02/skos/core#related";
var broaderTransitive = "http://www.w3.org/2004/02/skos/core#broaderTransitive";
var narrowerTransitive = "http://www.w3.org/2004/02/skos/core#narrowerTransitive";
var member8 = "http://www.w3.org/2004/02/skos/core#member";
var memberList = "http://www.w3.org/2004/02/skos/core#memberList";
var mappingRelation = "http://www.w3.org/2004/02/skos/core#mappingRelation";
var broadMatch = "http://www.w3.org/2004/02/skos/core#broadMatch";
var narrowMatch = "http://www.w3.org/2004/02/skos/core#narrowMatch";
var relatedMatch = "http://www.w3.org/2004/02/skos/core#relatedMatch";
var exactMatch = "http://www.w3.org/2004/02/skos/core#exactMatch";
var closeMatch = "http://www.w3.org/2004/02/skos/core#closeMatch";
var skosImport = /* @__PURE__ */ Object.freeze({
  Concept,
  ConceptScheme,
  Collection: Collection7,
  OrderedCollection: OrderedCollection2,
  inScheme,
  hasTopConcept,
  topConceptOf,
  prefLabel,
  altLabel,
  hiddenLabel,
  notation,
  note: note3,
  changeNote,
  definition: definition3,
  editorialNote: editorialNote2,
  example: example2,
  historyNote,
  scopeNote,
  semanticRelation,
  broader,
  narrower,
  related: related2,
  broaderTransitive,
  narrowerTransitive,
  member: member8,
  memberList,
  mappingRelation,
  broadMatch,
  narrowMatch,
  relatedMatch,
  exactMatch,
  closeMatch
});

// ../node_modules/rdf-namespaces/dist/solid-1bf48d40.js
var Account3 = "http://www.w3.org/ns/solid/terms#Account";
var Inbox = "http://www.w3.org/ns/solid/terms#Inbox";
var InsertDeletePatch = "http://www.w3.org/ns/solid/terms#InsertDeletePatch";
var ListedDocument = "http://www.w3.org/ns/solid/terms#ListedDocument";
var Notification = "http://www.w3.org/ns/solid/terms#Notification";
var Patch = "http://www.w3.org/ns/solid/terms#Patch";
var Timeline = "http://www.w3.org/ns/solid/terms#Timeline";
var TypeIndex = "http://www.w3.org/ns/solid/terms#TypeIndex";
var TypeRegistration = "http://www.w3.org/ns/solid/terms#TypeRegistration";
var UnlistedDocument = "http://www.w3.org/ns/solid/terms#UnlistedDocument";
var account3 = "http://www.w3.org/ns/solid/terms#account";
var deletes = "http://www.w3.org/ns/solid/terms#deletes";
var forClass = "http://www.w3.org/ns/solid/terms#forClass";
var inbox2 = "http://www.w3.org/ns/solid/terms#inbox";
var inserts = "http://www.w3.org/ns/solid/terms#inserts";
var instance2 = "http://www.w3.org/ns/solid/terms#instance";
var instanceContainer = "http://www.w3.org/ns/solid/terms#instanceContainer";
var loginEndpoint = "http://www.w3.org/ns/solid/terms#loginEndpoint";
var logoutEndpoint = "http://www.w3.org/ns/solid/terms#logoutEndpoint";
var notification = "http://www.w3.org/ns/solid/terms#notification";
var oidcIssuer = "http://www.w3.org/ns/solid/terms#oidcIssuer";
var owner5 = "http://www.w3.org/ns/solid/terms#owner";
var patches = "http://www.w3.org/ns/solid/terms#patches";
var privateTypeIndex = "http://www.w3.org/ns/solid/terms#privateTypeIndex";
var publicTypeIndex = "http://www.w3.org/ns/solid/terms#publicTypeIndex";
var privateLabelIndex = "http://www.w3.org/ns/solid/terms#privateLabelIndex";
var read = "http://www.w3.org/ns/solid/terms#read";
var storageDescription = "http://www.w3.org/ns/solid/terms#storageDescription";
var storageQuota = "http://www.w3.org/ns/solid/terms#storageQuota";
var storageUsage = "http://www.w3.org/ns/solid/terms#storageUsage";
var typeIndex = "http://www.w3.org/ns/solid/terms#typeIndex";
var timeline = "http://www.w3.org/ns/solid/terms#timeline";
var where = "http://www.w3.org/ns/solid/terms#where";
var solidImport = /* @__PURE__ */ Object.freeze({
  Account: Account3,
  Inbox,
  InsertDeletePatch,
  ListedDocument,
  Notification,
  Patch,
  Timeline,
  TypeIndex,
  TypeRegistration,
  UnlistedDocument,
  account: account3,
  deletes,
  forClass,
  inbox: inbox2,
  inserts,
  instance: instance2,
  instanceContainer,
  loginEndpoint,
  logoutEndpoint,
  notification,
  oidcIssuer,
  owner: owner5,
  patches,
  privateTypeIndex,
  publicTypeIndex,
  privateLabelIndex,
  read,
  storageDescription,
  storageQuota,
  storageUsage,
  typeIndex,
  timeline,
  where
});

// ../node_modules/rdf-namespaces/dist/space-3e307176.js
var ControlledStorage = "http://www.w3.org/ns/pim/space#ControlledStorage";
var PersonalStorage = "http://www.w3.org/ns/pim/space#PersonalStorage";
var PublicStorage = "http://www.w3.org/ns/pim/space#PublicStorage";
var Storage = "http://www.w3.org/ns/pim/space#Storage";
var Workspace = "http://www.w3.org/ns/pim/space#Workspace";
var masterWorkspace = "http://www.w3.org/ns/pim/space#masterWorkspace";
var preferencesFile = "http://www.w3.org/ns/pim/space#preferencesFile";
var storage = "http://www.w3.org/ns/pim/space#storage";
var uriPrefix = "http://www.w3.org/ns/pim/space#uriPrefix";
var workspace = "http://www.w3.org/ns/pim/space#workspace";
var spaceImport = /* @__PURE__ */ Object.freeze({
  ControlledStorage,
  PersonalStorage,
  PublicStorage,
  Storage,
  Workspace,
  masterWorkspace,
  preferencesFile,
  storage,
  uriPrefix,
  workspace
});

// ../node_modules/rdf-namespaces/dist/tab-12d8ebe8.js
var Access3 = "http://www.w3.org/2007/ont/link#Access";
var Document4 = "http://www.w3.org/2007/ont/link#Document";
var Mailbox2 = "http://www.w3.org/2007/ont/link#Mailbox";
var ProtocolEvent2 = "http://www.w3.org/2007/ont/link#ProtocolEvent";
var RDFDocument2 = "http://www.w3.org/2007/ont/link#RDFDocument";
var Response3 = "http://www.w3.org/2007/ont/link#Response";
var Session2 = "http://www.w3.org/2007/ont/link#Session";
var isMentionedIn2 = "http://www.w3.org/2007/ont/link#isMentionedIn";
var mentionsClass2 = "http://www.w3.org/2007/ont/link#mentionsClass";
var protocol4 = "http://www.w3.org/2007/ont/link#protocol";
var redirectedRequest2 = "http://www.w3.org/2007/ont/link#redirectedRequest";
var requestedBy2 = "http://www.w3.org/2007/ont/link#requestedBy";
var requestedURI2 = "http://www.w3.org/2007/ont/link#requestedURI";
var response4 = "http://www.w3.org/2007/ont/link#response";
var session2 = "http://www.w3.org/2007/ont/link#session";
var source7 = "http://www.w3.org/2007/ont/link#source";
var status8 = "http://www.w3.org/2007/ont/link#status";
var testDataset2 = "http://www.w3.org/2007/ont/link#testDataset";
var uri4 = "http://www.w3.org/2007/ont/link#uri";
var tabImport = /* @__PURE__ */ Object.freeze({
  Access: Access3,
  Document: Document4,
  Mailbox: Mailbox2,
  ProtocolEvent: ProtocolEvent2,
  RDFDocument: RDFDocument2,
  Response: Response3,
  Session: Session2,
  isMentionedIn: isMentionedIn2,
  mentionsClass: mentionsClass2,
  protocol: protocol4,
  redirectedRequest: redirectedRequest2,
  requestedBy: requestedBy2,
  requestedURI: requestedURI2,
  response: response4,
  session: session2,
  source: source7,
  status: status8,
  testDataset: testDataset2,
  uri: uri4
});

// ../node_modules/rdf-namespaces/dist/tabont-505264f7.js
var Access4 = "http://www.w3.org/2007/ont/link#Access";
var Document5 = "http://www.w3.org/2007/ont/link#Document";
var Mailbox3 = "http://www.w3.org/2007/ont/link#Mailbox";
var ProtocolEvent3 = "http://www.w3.org/2007/ont/link#ProtocolEvent";
var RDFDocument3 = "http://www.w3.org/2007/ont/link#RDFDocument";
var Response4 = "http://www.w3.org/2007/ont/link#Response";
var Session3 = "http://www.w3.org/2007/ont/link#Session";
var isMentionedIn3 = "http://www.w3.org/2007/ont/link#isMentionedIn";
var mentionsClass3 = "http://www.w3.org/2007/ont/link#mentionsClass";
var protocol5 = "http://www.w3.org/2007/ont/link#protocol";
var redirectedRequest3 = "http://www.w3.org/2007/ont/link#redirectedRequest";
var requestedBy3 = "http://www.w3.org/2007/ont/link#requestedBy";
var requestedURI3 = "http://www.w3.org/2007/ont/link#requestedURI";
var response5 = "http://www.w3.org/2007/ont/link#response";
var session3 = "http://www.w3.org/2007/ont/link#session";
var source8 = "http://www.w3.org/2007/ont/link#source";
var status9 = "http://www.w3.org/2007/ont/link#status";
var testDataset3 = "http://www.w3.org/2007/ont/link#testDataset";
var uri5 = "http://www.w3.org/2007/ont/link#uri";
var tabontImport = /* @__PURE__ */ Object.freeze({
  Access: Access4,
  Document: Document5,
  Mailbox: Mailbox3,
  ProtocolEvent: ProtocolEvent3,
  RDFDocument: RDFDocument3,
  Response: Response4,
  Session: Session3,
  isMentionedIn: isMentionedIn3,
  mentionsClass: mentionsClass3,
  protocol: protocol5,
  redirectedRequest: redirectedRequest3,
  requestedBy: requestedBy3,
  requestedURI: requestedURI3,
  response: response5,
  session: session3,
  source: source8,
  status: status9,
  testDataset: testDataset3,
  uri: uri5
});

// ../node_modules/rdf-namespaces/dist/trip-87e79363.js
var TaxiTransaction = "http://www.w3.org/ns/pim/trip#TaxiTransaction";
var Trip3 = "http://www.w3.org/ns/pim/trip#Trip";
var funder3 = "http://www.w3.org/ns/pim/trip#funder";
var location6 = "http://www.w3.org/ns/pim/trip#location";
var part2 = "http://www.w3.org/ns/pim/trip#part";
var travelDate = "http://www.w3.org/ns/pim/trip#travelDate";
var trip2 = "http://www.w3.org/ns/pim/trip#trip";
var tripImport = /* @__PURE__ */ Object.freeze({
  TaxiTransaction,
  Trip: Trip3,
  funder: funder3,
  location: location6,
  part: part2,
  travelDate,
  trip: trip2
});

// ../node_modules/rdf-namespaces/dist/vcard-16bbe2a9.js
var Acquaintance = "http://www.w3.org/2006/vcard/ns#Acquaintance";
var Address3 = "http://www.w3.org/2006/vcard/ns#Address";
var Agent4 = "http://www.w3.org/2006/vcard/ns#Agent";
var BBS = "http://www.w3.org/2006/vcard/ns#BBS";
var Car3 = "http://www.w3.org/2006/vcard/ns#Car";
var Cell = "http://www.w3.org/2006/vcard/ns#Cell";
var Child = "http://www.w3.org/2006/vcard/ns#Child";
var Colleague = "http://www.w3.org/2006/vcard/ns#Colleague";
var Contact2 = "http://www.w3.org/2006/vcard/ns#Contact";
var Coresident = "http://www.w3.org/2006/vcard/ns#Coresident";
var Coworker = "http://www.w3.org/2006/vcard/ns#Coworker";
var Crush = "http://www.w3.org/2006/vcard/ns#Crush";
var Date__workaround3 = "http://www.w3.org/2006/vcard/ns#Date";
var Dom = "http://www.w3.org/2006/vcard/ns#Dom";
var Email = "http://www.w3.org/2006/vcard/ns#Email";
var Emergency = "http://www.w3.org/2006/vcard/ns#Emergency";
var Fax = "http://www.w3.org/2006/vcard/ns#Fax";
var Female2 = "http://www.w3.org/2006/vcard/ns#Female";
var Friend = "http://www.w3.org/2006/vcard/ns#Friend";
var Gender = "http://www.w3.org/2006/vcard/ns#Gender";
var Group4 = "http://www.w3.org/2006/vcard/ns#Group";
var Home = "http://www.w3.org/2006/vcard/ns#Home";
var ISDN = "http://www.w3.org/2006/vcard/ns#ISDN";
var Individual = "http://www.w3.org/2006/vcard/ns#Individual";
var Internet = "http://www.w3.org/2006/vcard/ns#Internet";
var Intl__workaround = "http://www.w3.org/2006/vcard/ns#Intl";
var Kin = "http://www.w3.org/2006/vcard/ns#Kin";
var Kind = "http://www.w3.org/2006/vcard/ns#Kind";
var Label = "http://www.w3.org/2006/vcard/ns#Label";
var Location4 = "http://www.w3.org/2006/vcard/ns#Location";
var Male2 = "http://www.w3.org/2006/vcard/ns#Male";
var Me = "http://www.w3.org/2006/vcard/ns#Me";
var Met = "http://www.w3.org/2006/vcard/ns#Met";
var Modem = "http://www.w3.org/2006/vcard/ns#Modem";
var Msg = "http://www.w3.org/2006/vcard/ns#Msg";
var Muse = "http://www.w3.org/2006/vcard/ns#Muse";
var Name = "http://www.w3.org/2006/vcard/ns#Name";
var Neighbor = "http://www.w3.org/2006/vcard/ns#Neighbor";
var None = "http://www.w3.org/2006/vcard/ns#None";
var Organization7 = "http://www.w3.org/2006/vcard/ns#Organization";
var Other2 = "http://www.w3.org/2006/vcard/ns#Other";
var PCS = "http://www.w3.org/2006/vcard/ns#PCS";
var Pager = "http://www.w3.org/2006/vcard/ns#Pager";
var Parcel = "http://www.w3.org/2006/vcard/ns#Parcel";
var Parent = "http://www.w3.org/2006/vcard/ns#Parent";
var Postal = "http://www.w3.org/2006/vcard/ns#Postal";
var Pref = "http://www.w3.org/2006/vcard/ns#Pref";
var RelatedType = "http://www.w3.org/2006/vcard/ns#RelatedType";
var Sibling = "http://www.w3.org/2006/vcard/ns#Sibling";
var Spouse = "http://www.w3.org/2006/vcard/ns#Spouse";
var Sweetheart = "http://www.w3.org/2006/vcard/ns#Sweetheart";
var Tel = "http://www.w3.org/2006/vcard/ns#Tel";
var TelephoneType = "http://www.w3.org/2006/vcard/ns#TelephoneType";
var Text3 = "http://www.w3.org/2006/vcard/ns#Text";
var TextPhone = "http://www.w3.org/2006/vcard/ns#TextPhone";
var Type = "http://www.w3.org/2006/vcard/ns#Type";
var Unknown = "http://www.w3.org/2006/vcard/ns#Unknown";
var VCard = "http://www.w3.org/2006/vcard/ns#VCard";
var Video2 = "http://www.w3.org/2006/vcard/ns#Video";
var Voice = "http://www.w3.org/2006/vcard/ns#Voice";
var Work = "http://www.w3.org/2006/vcard/ns#Work";
var X400 = "http://www.w3.org/2006/vcard/ns#X400";
var adr = "http://www.w3.org/2006/vcard/ns#adr";
var agent6 = "http://www.w3.org/2006/vcard/ns#agent";
var anniversary = "http://www.w3.org/2006/vcard/ns#anniversary";
var bday = "http://www.w3.org/2006/vcard/ns#bday";
var category6 = "http://www.w3.org/2006/vcard/ns#category";
var class__workaround4 = "http://www.w3.org/2006/vcard/ns#class";
var email4 = "http://www.w3.org/2006/vcard/ns#email";
var fn = "http://www.w3.org/2006/vcard/ns#fn";
var geo4 = "http://www.w3.org/2006/vcard/ns#geo";
var hasAdditionalName = "http://www.w3.org/2006/vcard/ns#hasAdditionalName";
var hasAddress = "http://www.w3.org/2006/vcard/ns#hasAddress";
var hasCalendarBusy = "http://www.w3.org/2006/vcard/ns#hasCalendarBusy";
var hasCalendarLink = "http://www.w3.org/2006/vcard/ns#hasCalendarLink";
var hasCalendarRequest = "http://www.w3.org/2006/vcard/ns#hasCalendarRequest";
var hasCategory = "http://www.w3.org/2006/vcard/ns#hasCategory";
var hasCountryName = "http://www.w3.org/2006/vcard/ns#hasCountryName";
var hasEmail = "http://www.w3.org/2006/vcard/ns#hasEmail";
var hasFN = "http://www.w3.org/2006/vcard/ns#hasFN";
var hasFamilyName = "http://www.w3.org/2006/vcard/ns#hasFamilyName";
var hasGender = "http://www.w3.org/2006/vcard/ns#hasGender";
var hasGeo = "http://www.w3.org/2006/vcard/ns#hasGeo";
var hasGivenName = "http://www.w3.org/2006/vcard/ns#hasGivenName";
var hasHonorificPrefix = "http://www.w3.org/2006/vcard/ns#hasHonorificPrefix";
var hasHonorificSuffix = "http://www.w3.org/2006/vcard/ns#hasHonorificSuffix";
var hasInstantMessage = "http://www.w3.org/2006/vcard/ns#hasInstantMessage";
var hasKey2 = "http://www.w3.org/2006/vcard/ns#hasKey";
var hasLanguage = "http://www.w3.org/2006/vcard/ns#hasLanguage";
var hasLocality = "http://www.w3.org/2006/vcard/ns#hasLocality";
var hasLogo = "http://www.w3.org/2006/vcard/ns#hasLogo";
var hasMember2 = "http://www.w3.org/2006/vcard/ns#hasMember";
var hasName = "http://www.w3.org/2006/vcard/ns#hasName";
var hasNickname = "http://www.w3.org/2006/vcard/ns#hasNickname";
var hasNote = "http://www.w3.org/2006/vcard/ns#hasNote";
var hasOrganizationName = "http://www.w3.org/2006/vcard/ns#hasOrganizationName";
var hasOrganizationUnit = "http://www.w3.org/2006/vcard/ns#hasOrganizationUnit";
var hasPhoto = "http://www.w3.org/2006/vcard/ns#hasPhoto";
var hasPostalCode = "http://www.w3.org/2006/vcard/ns#hasPostalCode";
var hasRegion = "http://www.w3.org/2006/vcard/ns#hasRegion";
var hasRelated = "http://www.w3.org/2006/vcard/ns#hasRelated";
var hasRole = "http://www.w3.org/2006/vcard/ns#hasRole";
var hasSound = "http://www.w3.org/2006/vcard/ns#hasSound";
var hasSource = "http://www.w3.org/2006/vcard/ns#hasSource";
var hasStreetAddress = "http://www.w3.org/2006/vcard/ns#hasStreetAddress";
var hasTelephone = "http://www.w3.org/2006/vcard/ns#hasTelephone";
var hasTitle = "http://www.w3.org/2006/vcard/ns#hasTitle";
var hasUID = "http://www.w3.org/2006/vcard/ns#hasUID";
var hasURL = "http://www.w3.org/2006/vcard/ns#hasURL";
var hasValue3 = "http://www.w3.org/2006/vcard/ns#hasValue";
var key2 = "http://www.w3.org/2006/vcard/ns#key";
var label3 = "http://www.w3.org/2006/vcard/ns#label";
var language7 = "http://www.w3.org/2006/vcard/ns#language";
var latitude5 = "http://www.w3.org/2006/vcard/ns#latitude";
var locality = "http://www.w3.org/2006/vcard/ns#locality";
var logo4 = "http://www.w3.org/2006/vcard/ns#logo";
var longitude5 = "http://www.w3.org/2006/vcard/ns#longitude";
var mailer = "http://www.w3.org/2006/vcard/ns#mailer";
var n2 = "http://www.w3.org/2006/vcard/ns#n";
var nickname = "http://www.w3.org/2006/vcard/ns#nickname";
var note4 = "http://www.w3.org/2006/vcard/ns#note";
var org = "http://www.w3.org/2006/vcard/ns#org";
var photo4 = "http://www.w3.org/2006/vcard/ns#photo";
var prodid2 = "http://www.w3.org/2006/vcard/ns#prodid";
var region3 = "http://www.w3.org/2006/vcard/ns#region";
var rev = "http://www.w3.org/2006/vcard/ns#rev";
var role2 = "http://www.w3.org/2006/vcard/ns#role";
var sound = "http://www.w3.org/2006/vcard/ns#sound";
var tel = "http://www.w3.org/2006/vcard/ns#tel";
var title9 = "http://www.w3.org/2006/vcard/ns#title";
var tz = "http://www.w3.org/2006/vcard/ns#tz";
var url6 = "http://www.w3.org/2006/vcard/ns#url";
var value7 = "http://www.w3.org/2006/vcard/ns#value";
var vcardImport = /* @__PURE__ */ Object.freeze({
  Acquaintance,
  Address: Address3,
  Agent: Agent4,
  BBS,
  Car: Car3,
  Cell,
  Child,
  Colleague,
  Contact: Contact2,
  Coresident,
  Coworker,
  Crush,
  Date__workaround: Date__workaround3,
  Dom,
  Email,
  Emergency,
  Fax,
  Female: Female2,
  Friend,
  Gender,
  Group: Group4,
  Home,
  ISDN,
  Individual,
  Internet,
  Intl__workaround,
  Kin,
  Kind,
  Label,
  Location: Location4,
  Male: Male2,
  Me,
  Met,
  Modem,
  Msg,
  Muse,
  Name,
  Neighbor,
  None,
  Organization: Organization7,
  Other: Other2,
  PCS,
  Pager,
  Parcel,
  Parent,
  Postal,
  Pref,
  RelatedType,
  Sibling,
  Spouse,
  Sweetheart,
  Tel,
  TelephoneType,
  Text: Text3,
  TextPhone,
  Type,
  Unknown,
  VCard,
  Video: Video2,
  Voice,
  Work,
  X400,
  adr,
  agent: agent6,
  anniversary,
  bday,
  category: category6,
  class__workaround: class__workaround4,
  email: email4,
  fn,
  geo: geo4,
  hasAdditionalName,
  hasAddress,
  hasCalendarBusy,
  hasCalendarLink,
  hasCalendarRequest,
  hasCategory,
  hasCountryName,
  hasEmail,
  hasFN,
  hasFamilyName,
  hasGender,
  hasGeo,
  hasGivenName,
  hasHonorificPrefix,
  hasHonorificSuffix,
  hasInstantMessage,
  hasKey: hasKey2,
  hasLanguage,
  hasLocality,
  hasLogo,
  hasMember: hasMember2,
  hasName,
  hasNickname,
  hasNote,
  hasOrganizationName,
  hasOrganizationUnit,
  hasPhoto,
  hasPostalCode,
  hasRegion,
  hasRelated,
  hasRole,
  hasSound,
  hasSource,
  hasStreetAddress,
  hasTelephone,
  hasTitle,
  hasUID,
  hasURL,
  hasValue: hasValue3,
  key: key2,
  label: label3,
  language: language7,
  latitude: latitude5,
  locality,
  logo: logo4,
  longitude: longitude5,
  mailer,
  n: n2,
  nickname,
  note: note4,
  org,
  photo: photo4,
  prodid: prodid2,
  region: region3,
  rev,
  role: role2,
  sound,
  tel,
  title: title9,
  tz,
  url: url6,
  value: value7
});

// ../node_modules/rdf-namespaces/dist/wf-c80cf549.js
var ActionItem = "http://www.w3.org/2005/01/wf/flow#ActionItem";
var Change = "http://www.w3.org/2005/01/wf/flow#Change";
var Closed = "http://www.w3.org/2005/01/wf/flow#Closed";
var Creation = "http://www.w3.org/2005/01/wf/flow#Creation";
var Message4 = "http://www.w3.org/2005/01/wf/flow#Message";
var NonTerminalState = "http://www.w3.org/2005/01/wf/flow#NonTerminalState";
var Open = "http://www.w3.org/2005/01/wf/flow#Open";
var Product3 = "http://www.w3.org/2005/01/wf/flow#Product";
var Task2 = "http://www.w3.org/2005/01/wf/flow#Task";
var TerminalState = "http://www.w3.org/2005/01/wf/flow#TerminalState";
var Tracker = "http://www.w3.org/2005/01/wf/flow#Tracker";
var Transition = "http://www.w3.org/2005/01/wf/flow#Transition";
var affects = "http://www.w3.org/2005/01/wf/flow#affects";
var allowedTransitions = "http://www.w3.org/2005/01/wf/flow#allowedTransitions";
var asigneeClass = "http://www.w3.org/2005/01/wf/flow#asigneeClass";
var assignee = "http://www.w3.org/2005/01/wf/flow#assignee";
var attachment4 = "http://www.w3.org/2005/01/wf/flow#attachment";
var creates = "http://www.w3.org/2005/01/wf/flow#creates";
var dateDue = "http://www.w3.org/2005/01/wf/flow#dateDue";
var deliverable = "http://www.w3.org/2005/01/wf/flow#deliverable";
var dependent2 = "http://www.w3.org/2005/01/wf/flow#dependent";
var description11 = "http://www.w3.org/2005/01/wf/flow#description";
var final = "http://www.w3.org/2005/01/wf/flow#final";
var goalDescription = "http://www.w3.org/2005/01/wf/flow#goalDescription";
var initialState = "http://www.w3.org/2005/01/wf/flow#initialState";
var issue2 = "http://www.w3.org/2005/01/wf/flow#issue";
var issueCategory = "http://www.w3.org/2005/01/wf/flow#issueCategory";
var issueClass = "http://www.w3.org/2005/01/wf/flow#issueClass";
var message3 = "http://www.w3.org/2005/01/wf/flow#message";
var modifiedBy = "http://www.w3.org/2005/01/wf/flow#modifiedBy";
var recipent = "http://www.w3.org/2005/01/wf/flow#recipent";
var requires3 = "http://www.w3.org/2005/01/wf/flow#requires";
var screenShot = "http://www.w3.org/2005/01/wf/flow#screenShot";
var sender4 = "http://www.w3.org/2005/01/wf/flow#sender";
var source9 = "http://www.w3.org/2005/01/wf/flow#source";
var stateStore = "http://www.w3.org/2005/01/wf/flow#stateStore";
var subscriber2 = "http://www.w3.org/2005/01/wf/flow#subscriber";
var successCriteria = "http://www.w3.org/2005/01/wf/flow#successCriteria";
var task = "http://www.w3.org/2005/01/wf/flow#task";
var terminalOutput = "http://www.w3.org/2005/01/wf/flow#terminalOutput";
var testData2 = "http://www.w3.org/2005/01/wf/flow#testData";
var tracker = "http://www.w3.org/2005/01/wf/flow#tracker";
var transactionStore = "http://www.w3.org/2005/01/wf/flow#transactionStore";
var wfImport = /* @__PURE__ */ Object.freeze({
  ActionItem,
  Change,
  Closed,
  Creation,
  Message: Message4,
  NonTerminalState,
  Open,
  Product: Product3,
  Task: Task2,
  TerminalState,
  Tracker,
  Transition,
  affects,
  allowedTransitions,
  asigneeClass,
  assignee,
  attachment: attachment4,
  creates,
  dateDue,
  deliverable,
  dependent: dependent2,
  description: description11,
  final,
  goalDescription,
  initialState,
  issue: issue2,
  issueCategory,
  issueClass,
  message: message3,
  modifiedBy,
  recipent,
  requires: requires3,
  screenShot,
  sender: sender4,
  source: source9,
  stateStore,
  subscriber: subscriber2,
  successCriteria,
  task,
  terminalOutput,
  testData: testData2,
  tracker,
  transactionStore
});

// ../node_modules/rdf-namespaces/dist/xsd-7381cf16.js
var ID = "http://www.w3.org/2001/XMLSchema#ID";
var IDREF = "http://www.w3.org/2001/XMLSchema#IDREF";
var ENTITY = "http://www.w3.org/2001/XMLSchema#ENTITY";
var NCName = "http://www.w3.org/2001/XMLSchema#NCName";
var NMTOKEN = "http://www.w3.org/2001/XMLSchema#NMTOKEN";
var Name2 = "http://www.w3.org/2001/XMLSchema#Name";
var totalDigits = "http://www.w3.org/2001/XMLSchema#totalDigits";
var fractionDigits = "http://www.w3.org/2001/XMLSchema#fractionDigits";
var pattern6 = "http://www.w3.org/2001/XMLSchema#pattern";
var maxInclusive2 = "http://www.w3.org/2001/XMLSchema#maxInclusive";
var maxExclusive2 = "http://www.w3.org/2001/XMLSchema#maxExclusive";
var minInclusive2 = "http://www.w3.org/2001/XMLSchema#minInclusive";
var minExclusive2 = "http://www.w3.org/2001/XMLSchema#minExclusive";
var QName = "http://www.w3.org/2001/XMLSchema#QName";
var anyURI = "http://www.w3.org/2001/XMLSchema#anyURI";
var base64Binary2 = "http://www.w3.org/2001/XMLSchema#base64Binary";
var boolean2 = "http://www.w3.org/2001/XMLSchema#boolean";
var byte = "http://www.w3.org/2001/XMLSchema#byte";
var date5 = "http://www.w3.org/2001/XMLSchema#date";
var dateTime2 = "http://www.w3.org/2001/XMLSchema#dateTime";
var decimal2 = "http://www.w3.org/2001/XMLSchema#decimal";
var double = "http://www.w3.org/2001/XMLSchema#double";
var duration6 = "http://www.w3.org/2001/XMLSchema#duration";
var float = "http://www.w3.org/2001/XMLSchema#float";
var gDay = "http://www.w3.org/2001/XMLSchema#gDay";
var gMonth = "http://www.w3.org/2001/XMLSchema#gMonth";
var gMonthDay = "http://www.w3.org/2001/XMLSchema#gMonthDay";
var gYear = "http://www.w3.org/2001/XMLSchema#gYear";
var gYearMonth = "http://www.w3.org/2001/XMLSchema#gYearMonth";
var hexBinary = "http://www.w3.org/2001/XMLSchema#hexBinary";
var int = "http://www.w3.org/2001/XMLSchema#int";
var integer2 = "http://www.w3.org/2001/XMLSchema#integer";
var language8 = "http://www.w3.org/2001/XMLSchema#language";
var long = "http://www.w3.org/2001/XMLSchema#long";
var negativeInteger = "http://www.w3.org/2001/XMLSchema#negativeInteger";
var nonNegativeInteger = "http://www.w3.org/2001/XMLSchema#nonNegativeInteger";
var nonPositiveInteger = "http://www.w3.org/2001/XMLSchema#nonPositiveInteger";
var normalizedString = "http://www.w3.org/2001/XMLSchema#normalizedString";
var positiveInteger = "http://www.w3.org/2001/XMLSchema#positiveInteger";
var short2 = "http://www.w3.org/2001/XMLSchema#short";
var string2 = "http://www.w3.org/2001/XMLSchema#string";
var time2 = "http://www.w3.org/2001/XMLSchema#time";
var token = "http://www.w3.org/2001/XMLSchema#token";
var unsignedByte = "http://www.w3.org/2001/XMLSchema#unsignedByte";
var unsignedInt2 = "http://www.w3.org/2001/XMLSchema#unsignedInt";
var unsignedLong = "http://www.w3.org/2001/XMLSchema#unsignedLong";
var unsignedShort = "http://www.w3.org/2001/XMLSchema#unsignedShort";
var xsdImport = /* @__PURE__ */ Object.freeze({
  ID,
  IDREF,
  ENTITY,
  NCName,
  NMTOKEN,
  Name: Name2,
  totalDigits,
  fractionDigits,
  pattern: pattern6,
  maxInclusive: maxInclusive2,
  maxExclusive: maxExclusive2,
  minInclusive: minInclusive2,
  minExclusive: minExclusive2,
  QName,
  anyURI,
  base64Binary: base64Binary2,
  boolean: boolean2,
  byte,
  date: date5,
  dateTime: dateTime2,
  decimal: decimal2,
  double,
  duration: duration6,
  float,
  gDay,
  gMonth,
  gMonthDay,
  gYear,
  gYearMonth,
  hexBinary,
  int,
  integer: integer2,
  language: language8,
  long,
  negativeInteger,
  nonNegativeInteger,
  nonPositiveInteger,
  normalizedString,
  positiveInteger,
  short: short2,
  string: string2,
  time: time2,
  token,
  unsignedByte,
  unsignedInt: unsignedInt2,
  unsignedLong,
  unsignedShort
});

// ../node_modules/rdf-namespaces/dist/index.es.js
var acl = aclImport;
var arg = argImport;
var as = asImport;
var bookmark = bookmarkImport;
var cal = calImport;
var contact3 = contactImport;
var dc = dcImport;
var dct = dctImport;
var fhir = fhirImport;
var foaf = foafImport;
var http = httpImport;
var hydra = hydraImport;
var ldp2 = ldpImport;
var link4 = linkImport;
var log2 = logImport;
var meeting = meetingImport;
var owl = owlImport;
var prov = provImport;
var qu = quImport;
var rdf4 = rdfImport;
var rdfs2 = rdfsImport;
var sched = schedImport;
var schema2 = schemaImport;
var schema_https = schema_httpsImport;
var sec = secImport;
var shacl = shaclImport;
var shex = shexImport;
var sioc = siocImport;
var skos = skosImport;
var solid2 = solidImport;
var space = spaceImport;
var tab = tabImport;
var tabont = tabontImport;
var trip3 = tripImport;
var vcard = vcardImport;
var wf = wfImport;
var xsd3 = xsdImport;

// src/terms/createListOfTerms.ts
var createListOfTerms = (terms) => Object.keys(terms).flatMap((prefix3) => {
  return Object.keys(terms[prefix3]).map((name9) => ({
    uri: terms[prefix3][name9],
    shorthand: `${prefix3}:${name9}`
  }));
});

// src/terms/listKnownTerms.ts
function listKnownTerms() {
  return createListOfTerms(index_es_exports);
}

// src/uri/UriService.ts
var import_slugify = __toESM(require_slugify(), 1);
var UriService = class {
  constructor(store) {
    this.store = store;
  }
  /**
   * Proposes a URI for a new thing based on what the referenceUri identifies:
   * - if a container, the new URI is in this container
   * - if a file, the new URI is in the same container as said file
   * - if a non-information-resource, the new URI is in the same container as that resource
   * @param referenceUri
   * @param name (will be slugified)
   */
  proposeUriForNewThing(referenceUri, name9) {
    const filename = (0, import_slugify.default)(name9, { lower: true });
    return `${new URL(filename, referenceUri)}#it`;
  }
};

// src/modules/index.ts
async function loadModule(moduleName, store) {
  const module3 = await import(moduleName);
  return store.loadModule(module3);
}

// ../node_modules/url-template/lib/url-template.js
function encodeReserved(str) {
  return str.split(/(%[0-9A-Fa-f]{2})/g).map(function(part3) {
    if (!/%[0-9A-Fa-f]/.test(part3)) {
      part3 = encodeURI(part3).replace(/%5B/g, "[").replace(/%5D/g, "]");
    }
    return part3;
  }).join("");
}
function encodeUnreserved(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
    return "%" + c.charCodeAt(0).toString(16).toUpperCase();
  });
}
function encodeValue(operator2, value8, key3) {
  value8 = operator2 === "+" || operator2 === "#" ? encodeReserved(value8) : encodeUnreserved(value8);
  if (key3) {
    return encodeUnreserved(key3) + "=" + value8;
  } else {
    return value8;
  }
}
function isDefined(value8) {
  return value8 !== void 0 && value8 !== null;
}
function isKeyOperator(operator2) {
  return operator2 === ";" || operator2 === "&" || operator2 === "?";
}
function getValues(context4, operator2, key3, modifier2) {
  var value8 = context4[key3], result6 = [];
  if (isDefined(value8) && value8 !== "") {
    if (typeof value8 === "string" || typeof value8 === "number" || typeof value8 === "boolean") {
      value8 = value8.toString();
      if (modifier2 && modifier2 !== "*") {
        value8 = value8.substring(0, parseInt(modifier2, 10));
      }
      result6.push(encodeValue(operator2, value8, isKeyOperator(operator2) ? key3 : null));
    } else {
      if (modifier2 === "*") {
        if (Array.isArray(value8)) {
          value8.filter(isDefined).forEach(function(value9) {
            result6.push(encodeValue(operator2, value9, isKeyOperator(operator2) ? key3 : null));
          });
        } else {
          Object.keys(value8).forEach(function(k) {
            if (isDefined(value8[k])) {
              result6.push(encodeValue(operator2, value8[k], k));
            }
          });
        }
      } else {
        var tmp = [];
        if (Array.isArray(value8)) {
          value8.filter(isDefined).forEach(function(value9) {
            tmp.push(encodeValue(operator2, value9));
          });
        } else {
          Object.keys(value8).forEach(function(k) {
            if (isDefined(value8[k])) {
              tmp.push(encodeUnreserved(k));
              tmp.push(encodeValue(operator2, value8[k].toString()));
            }
          });
        }
        if (isKeyOperator(operator2)) {
          result6.push(encodeUnreserved(key3) + "=" + tmp.join(","));
        } else if (tmp.length !== 0) {
          result6.push(tmp.join(","));
        }
      }
    }
  } else {
    if (operator2 === ";") {
      if (isDefined(value8)) {
        result6.push(encodeUnreserved(key3));
      }
    } else if (value8 === "" && (operator2 === "&" || operator2 === "?")) {
      result6.push(encodeUnreserved(key3) + "=");
    } else if (value8 === "") {
      result6.push("");
    }
  }
  return result6;
}
function parseTemplate(template3) {
  var operators = ["+", "#", ".", "/", ";", "?", "&"];
  return {
    expand: function(context4) {
      return template3.replace(/\{([^\{\}]+)\}|([^\{\}]+)/g, function(_, expression4, literal4) {
        if (expression4) {
          var operator2 = null, values2 = [];
          if (operators.indexOf(expression4.charAt(0)) !== -1) {
            operator2 = expression4.charAt(0);
            expression4 = expression4.substr(1);
          }
          expression4.split(/,/g).forEach(function(variable5) {
            var tmp = /([^:\*]*)(?::(\d+)|(\*))?/.exec(variable5);
            values2.push.apply(values2, getValues(context4, operator2, tmp[1], tmp[2] || tmp[3]));
          });
          if (operator2 && operator2 !== "+") {
            var separator = ",";
            if (operator2 === "?") {
              separator = "&";
            } else if (operator2 !== "#") {
              separator = operator2;
            }
            return (values2.length !== 0 ? operator2 : "") + values2.join(separator);
          } else {
            return values2.join(",");
          }
        } else {
          return encodeReserved(literal4);
        }
      });
    }
  };
}

// src/open-with/apps.ts
var APPS = {
  DATA_BROWSER: {
    name: "Data Browser (SolidOS)",
    urlTemplate: parseTemplate(
      "https://solidos.github.io/mashlib/dist/browse.html{?uri}"
    )
  },
  PENNY: {
    name: "Penny",
    urlTemplate: parseTemplate(
      "https://penny.vincenttunru.com/explore/?url={uri}"
    )
  },
  SOLID_FILE_MANAGER: {
    name: "Solid File Manager",
    urlTemplate: parseTemplate(
      "https://otto-aa.github.io/solid-filemanager/?url={uri}"
    )
  },
  UMAI: {
    name: "Umai",
    urlTemplate: parseTemplate(
      "https://umai.noeldemartin.com/viewer?url={uri}"
    )
  },
  DOKIELI: {
    name: "dokieli",
    urlTemplate: parseTemplate("https://dokie.li/#open={uri}")
  },
  DOKIELI_GRAPH: {
    name: "dokieli Graph",
    urlTemplate: parseTemplate("https://dokie.li/#graph={uri}")
  },
  POD_OS_CONTACTS: {
    name: "PodOS Contacts",
    urlTemplate: parseTemplate(
      "https://contacts.pod-os.org/address-book{?uri}"
    )
  }
};

// src/open-with/proposeAppsFor.ts
var appRegistrations = {
  "http://www.w3.org/ns/ldp#Container": [APPS.SOLID_FILE_MANAGER],
  "http://schema.org/Recipe": [APPS.UMAI],
  "https://schema.org/Recipe": [APPS.UMAI],
  "http://www.w3.org/2007/ont/link#RDFDocument": [APPS.DOKIELI_GRAPH],
  "http://www.w3.org/ns/iana/media-types/text/html#Resource": [APPS.DOKIELI],
  "http://www.w3.org/2006/vcard/ns#AddressBook": [APPS.POD_OS_CONTACTS]
};
function proposeAppsFor(thing) {
  const apps = [APPS.DATA_BROWSER, APPS.PENNY];
  const appsForType = thing.types().flatMap((it) => appRegistrations[it.uri]).filter((it) => it !== void 0);
  return [...apps, ...appsForType];
}

// src/authentication/index.ts
var AnonymousSession = class {
  constructor() {
    this.sessionInfo$ = new BehaviorSubject({
      isLoggedIn: false,
      webId: void 0
    });
  }
  get authenticatedFetch() {
    return global.fetch;
  }
  observeSession() {
    return this.sessionInfo$;
  }
  login() {
    return Promise.resolve();
  }
  logout() {
    return Promise.resolve();
  }
};

// src/type-index/TypeIndex.ts
var TypeIndex2 = class extends Thing {
  constructor(uri6, store, editable = false) {
    super(uri6, store, editable);
  }
  listAll() {
    const forClassStatements = this.store.statementsMatching(
      null,
      solid("forClass"),
      null,
      namedNode2(this.uri)
    );
    return forClassStatements.map((statement2) => {
      const subject8 = statement2.subject;
      const instanceContainerStatements = this.store.statementsMatching(
        subject8,
        solid("instanceContainer"),
        null,
        namedNode2(this.uri)
      );
      const instanceStatements = this.store.statementsMatching(
        subject8,
        solid("instance"),
        null,
        namedNode2(this.uri)
      );
      const instances2 = instanceStatements.map((it) => ({
        type: "instance",
        uri: it.object.value
      }));
      const instanceContainers = instanceContainerStatements.map((it) => ({
        type: "container",
        uri: it.object.value
      }));
      return {
        targets: [...instanceContainers, ...instances2],
        forClass: statement2.object.value,
        label: labelForType(statement2.object.value)
      };
    });
  }
};

// src/index.ts
var PodOS = class {
  constructor({
    session: session4 = {},
    offlineCache = new NoOfflineCache(),
    onlineStatus = new AssumeAlwaysOnline(),
    internalStore = void 0
  } = {}) {
    this.session = session4;
    this.offlineCache = offlineCache;
    this.store = new Store(
      this.session,
      offlineCache,
      onlineStatus,
      internalStore
    );
    this.searchGateway = new SearchGateway(this.store);
    this.fileFetcher = new FileFetcher(this.session);
    this.fileGateway = new FileGateway(this.store, this.fileFetcher);
    this.attachmentGateway = new AttachmentGateway(this.fileGateway);
    this.pictureGateway = new PictureGateway(this.fileGateway);
    this.flagAuthorizationMetaDataOnSessionChange();
    this.uriService = new UriService(this.store);
    this.profileGateway = new ProfileGateway(this.store);
  }
  /*
       Flagging authorization metadata is necessary every time the user
       logs in or out, so that metadata from previous requests is outdated
       and not considered to determine whether a resource is editable anymore.
  
       See: https://github.com/linkeddata/rdflib.js/pull/512
    */
  flagAuthorizationMetaDataOnSessionChange() {
    this.session.observeSession().pipe(
      tap(() => {
        this.store.flagAuthorizationMetadata();
      })
    ).subscribe();
  }
  fetch(uri6) {
    return this.store.fetch(uri6);
  }
  fetchAll(uris) {
    return this.store.fetchAll(uris);
  }
  /**
   * @deprecated Use {@link FileFetcher.fetchFile} via {@link PodOS.files} instead
   * @param {string} url - URL identifying the file
   * @returns {Promise<SolidFile>} An object representing the fetched file
   */
  fetchFile(url7) {
    return this.files().fetchFile(url7);
  }
  /**
   * Provides access to file operations such as fetching and updating files in the pod
   * @returns {FileFetcher} An instance of FileFetcher that handles file operations
   */
  files() {
    return this.fileFetcher;
  }
  /**
   * Adds a new value to the property of the given thing
   * @param thing
   * @param property
   * @param value
   */
  addPropertyValue(thing, property4, value8) {
    return this.store.addPropertyValue(thing, property4, value8);
  }
  /**
   * Adds a new relation (link) from the thing to the given uri using the property
   * @param thing
   * @param property
   * @param uri
   */
  addRelation(thing, property4, value8) {
    return this.store.addRelation(thing, property4, value8);
  }
  listKnownTerms() {
    return listKnownTerms();
  }
  addNewThing(uri6, name9, type5) {
    return this.store.addNewThing(uri6, name9, type5);
  }
  proposeUriForNewThing(referenceUri, name9) {
    return this.uriService.proposeUriForNewThing(referenceUri, name9);
  }
  /**
   * returns a behavior subject that can be used to observe changes in the session state
   */
  observeSession() {
    return this.session.observeSession();
  }
  /**
   * Fetch the WebId profile and preferences file for the given WebID
   * @param webId
   */
  async fetchProfile(webId) {
    return this.profileGateway.fetchProfile(webId);
  }
  /**
   * Fetch the private label index for the given profile and build a search index from it
   * @param profile
   */
  async buildSearchIndex(profile2) {
    return this.searchGateway.buildSearchIndex(profile2);
  }
  logout() {
    this.offlineCache.clear();
    return this.session.logout();
  }
  login(oidcIssuer2 = "http://localhost:3000") {
    return this.session.login(oidcIssuer2);
  }
  /**
   * Dynamically loads a module by its name and returns an instance of the module
   * @param moduleName
   */
  loadModule(moduleName) {
    return loadModule(moduleName, this.store);
  }
  /**
   * Adds a label of the given thing to the label index, so that it can be found after the search index has been rebuilt
   * @param thing - The thing to index
   * @param labelIndex - The index to update
   */
  async addToLabelIndex(thing, labelIndex) {
    await this.searchGateway.addToLabelIndex(thing, labelIndex);
  }
  /**
   * Creates a new label index document at a default location and links it to the user's profile or preferences document
   *
   * @param profile - The profile for that to create the index
   * @returns the newly created label index
   */
  async createDefaultLabelIndex(profile2) {
    return await this.searchGateway.createDefaultLabelIndex(profile2);
  }
  /**
   * Uploads a picture file and associates it with a thing.
   * The container is automatically derived from the thing's URI.
   *
   * @param thing - The thing to add the picture to
   * @param pictureFile - The picture file to upload
   * @returns Result with the picture URL or error
   */
  uploadAndAddPicture(thing, pictureFile) {
    return this.pictureGateway.uploadAndAddPicture(thing, pictureFile);
  }
  /**
   * Provides access to attachment operations such as uploading and linking attachments to things
   * @since 0.24.0
   * @returns {AttachmentGateway} An instance of AttachmentGateway that handles attachment operations
   */
  attachments() {
    return this.attachmentGateway;
  }
  /**
   * Propose matching apps to open a thing
   * @param thing - The thing to open
   * @returns An array of apps that can open the thing. The array is empty if no apps are found.
   */
  proposeAppsFor(thing) {
    return proposeAppsFor(thing);
  }
};
var export_Quad = import_tf_types.Quad;
export {
  AnonymousSession,
  AssumeAlwaysOnline,
  AttachmentGateway,
  BinaryFile,
  BrokenFile,
  FileFetcher,
  FileGateway,
  HttpStatus,
  LabelIndex,
  LdpContainer,
  NoOfflineCache,
  OfflineCapableFetcher,
  PictureGateway,
  PodOS,
  ProfileGateway,
  export_Quad as Quad,
  RdfDocument,
  SearchGateway,
  SearchIndex,
  Store,
  Thing,
  TypeIndex2 as TypeIndex,
  UriService,
  WebIdProfile,
  httpProblem,
  labelFromUri,
  listKnownTerms,
  networkProblem,
  proposeAppsFor
};
/*! Bundled license information:

ieee754/index.js:
  (*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> *)

buffer/index.js:
  (*!
   * The buffer module from node.js, for the browser.
   *
   * @author   Feross Aboukhadijeh <https://feross.org>
   * @license  MIT
   *)

lunr/lunr.js:
  (**
   * lunr - http://lunrjs.com - A bit like Solr, but much smaller and not as bright - 2.3.9
   * Copyright (C) 2020 Oliver Nightingale
   * @license MIT
   *)
  (*!
   * lunr.utils
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.Set
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.tokenizer
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.Pipeline
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.Vector
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.stemmer
   * Copyright (C) 2020 Oliver Nightingale
   * Includes code from - http://tartarus.org/~martin/PorterStemmer/js.txt
   *)
  (*!
   * lunr.stopWordFilter
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.trimmer
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.TokenSet
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.Index
   * Copyright (C) 2020 Oliver Nightingale
   *)
  (*!
   * lunr.Builder
   * Copyright (C) 2020 Oliver Nightingale
   *)
*/
